(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 46565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34885);
var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgClose(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);

/***/ }),

/***/ 88739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(20613);
__webpack_require__(64707);
module.exports = __webpack_require__(24429).Array.from;


/***/ }),

/***/ 41193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(22622);
module.exports = __webpack_require__(24429).Array.isArray;


/***/ }),

/***/ 93829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(34164);
__webpack_require__(20613);
__webpack_require__(8191);
__webpack_require__(39681);
__webpack_require__(22126);
__webpack_require__(84155);
__webpack_require__(91363);
module.exports = __webpack_require__(24429).Map;


/***/ }),

/***/ 27079:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(2828);
module.exports = __webpack_require__(24429).Object.assign;


/***/ }),

/***/ 14763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(61146);
var $Object = (__webpack_require__(24429).Object);
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 71170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(54264);
var $Object = (__webpack_require__(24429).Object);
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),

/***/ 50694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(89079);
var $Object = (__webpack_require__(24429).Object);
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 68323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(13090);
module.exports = __webpack_require__(24429).Object.entries;


/***/ }),

/***/ 63273:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(88952);
module.exports = __webpack_require__(24429).Object.freeze;


/***/ }),

/***/ 27151:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(24757);
var $Object = (__webpack_require__(24429).Object);
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ 48939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(84397);
module.exports = __webpack_require__(24429).Object.getOwnPropertySymbols;


/***/ }),

/***/ 92984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(51570);
module.exports = __webpack_require__(24429).Object.getPrototypeOf;


/***/ }),

/***/ 23300:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(39547);
module.exports = __webpack_require__(24429).Object.keys;


/***/ }),

/***/ 94040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(80722);
module.exports = __webpack_require__(24429).Object.setPrototypeOf;


/***/ }),

/***/ 98816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(11861);
module.exports = __webpack_require__(24429).Object.values;


/***/ }),

/***/ 19502:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(68497);
module.exports = __webpack_require__(24429).parseFloat;


/***/ }),

/***/ 44562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(70930);
module.exports = __webpack_require__(24429).parseInt;


/***/ }),

/***/ 58507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(84397);
__webpack_require__(34164);
__webpack_require__(56991);
__webpack_require__(51049);
module.exports = __webpack_require__(24429).Symbol;


/***/ }),

/***/ 62568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(20613);
__webpack_require__(8191);
module.exports = (__webpack_require__(55856).f)('iterator');


/***/ }),

/***/ 4219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = (__webpack_require__(55856).f)('toPrimitive');


/***/ }),

/***/ 88363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(34164);
__webpack_require__(8191);
__webpack_require__(83024);
__webpack_require__(4863);
__webpack_require__(71015);
module.exports = __webpack_require__(24429).WeakMap;


/***/ }),

/***/ 19503:
/***/ (function(module) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 80535:
/***/ (function(module) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 11556:
/***/ (function(module) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ 49495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(63731);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 43876:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var forOf = __webpack_require__(99569);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 77017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(88462);
var toLength = __webpack_require__(81429);
var toAbsoluteIndex = __webpack_require__(57560);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 50482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(19478);
var IObject = __webpack_require__(73306);
var toObject = __webpack_require__(81022);
var toLength = __webpack_require__(81429);
var asc = __webpack_require__(72729);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 12424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(63731);
var isArray = __webpack_require__(48120);
var SPECIES = __webpack_require__(84593)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 72729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(12424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 42156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(67675);
var TAG = __webpack_require__(84593)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 67675:
/***/ (function(module) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 38269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var dP = (__webpack_require__(83207).f);
var create = __webpack_require__(82435);
var redefineAll = __webpack_require__(95828);
var ctx = __webpack_require__(19478);
var anInstance = __webpack_require__(11556);
var forOf = __webpack_require__(99569);
var $iterDefine = __webpack_require__(83912);
var step = __webpack_require__(34835);
var setSpecies = __webpack_require__(16736);
var DESCRIPTORS = __webpack_require__(45880);
var fastKey = (__webpack_require__(63268).fastKey);
var validate = __webpack_require__(2195);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 88941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(42156);
var from = __webpack_require__(43876);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 26190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(95828);
var getWeak = (__webpack_require__(63268).getWeak);
var anObject = __webpack_require__(49495);
var isObject = __webpack_require__(63731);
var anInstance = __webpack_require__(11556);
var forOf = __webpack_require__(99569);
var createArrayMethod = __webpack_require__(50482);
var $has = __webpack_require__(8346);
var validate = __webpack_require__(2195);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ 70952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19657);
var $export = __webpack_require__(57125);
var meta = __webpack_require__(63268);
var fails = __webpack_require__(91866);
var hide = __webpack_require__(51128);
var redefineAll = __webpack_require__(95828);
var forOf = __webpack_require__(99569);
var anInstance = __webpack_require__(11556);
var isObject = __webpack_require__(63731);
var setToStringTag = __webpack_require__(80411);
var dP = (__webpack_require__(83207).f);
var each = __webpack_require__(50482)(0);
var DESCRIPTORS = __webpack_require__(45880);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 24429:
/***/ (function(module) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 89641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(83207);
var createDesc = __webpack_require__(8991);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 19478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19503);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 47588:
/***/ (function(module) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 45880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(91866)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 76924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(63731);
var document = (__webpack_require__(19657).document);
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 73969:
/***/ (function(module) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 82261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(95169);
var gOPS = __webpack_require__(64392);
var pIE = __webpack_require__(79501);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 57125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(19657);
var core = __webpack_require__(24429);
var ctx = __webpack_require__(19478);
var hide = __webpack_require__(51128);
var has = __webpack_require__(8346);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 91866:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 99569:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ctx = __webpack_require__(19478);
var call = __webpack_require__(22722);
var isArrayIter = __webpack_require__(96155);
var anObject = __webpack_require__(49495);
var toLength = __webpack_require__(81429);
var getIterFn = __webpack_require__(95594);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ 19657:
/***/ (function(module) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 8346:
/***/ (function(module) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 51128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var dP = __webpack_require__(83207);
var createDesc = __webpack_require__(8991);
module.exports = __webpack_require__(45880) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 27491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var document = (__webpack_require__(19657).document);
module.exports = document && document.documentElement;


/***/ }),

/***/ 24620:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = !__webpack_require__(45880) && !__webpack_require__(91866)(function () {
  return Object.defineProperty(__webpack_require__(76924)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 73306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(67675);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 96155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(1998);
var ITERATOR = __webpack_require__(84593)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ 48120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(67675);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 63731:
/***/ (function(module) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 22722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(49495);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ 71932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(82435);
var descriptor = __webpack_require__(8991);
var setToStringTag = __webpack_require__(80411);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(51128)(IteratorPrototype, __webpack_require__(84593)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 83912:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(88596);
var $export = __webpack_require__(57125);
var redefine = __webpack_require__(23669);
var hide = __webpack_require__(51128);
var Iterators = __webpack_require__(1998);
var $iterCreate = __webpack_require__(71932);
var setToStringTag = __webpack_require__(80411);
var getPrototypeOf = __webpack_require__(63400);
var ITERATOR = __webpack_require__(84593)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 40968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ITERATOR = __webpack_require__(84593)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ 34835:
/***/ (function(module) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 1998:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 88596:
/***/ (function(module) {

module.exports = true;


/***/ }),

/***/ 63268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var META = __webpack_require__(83897)('meta');
var isObject = __webpack_require__(63731);
var has = __webpack_require__(8346);
var setDesc = (__webpack_require__(83207).f);
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(91866)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 38141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(45880);
var getKeys = __webpack_require__(95169);
var gOPS = __webpack_require__(64392);
var pIE = __webpack_require__(79501);
var toObject = __webpack_require__(81022);
var IObject = __webpack_require__(73306);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(91866)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 82435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(49495);
var dPs = __webpack_require__(42048);
var enumBugKeys = __webpack_require__(73969);
var IE_PROTO = __webpack_require__(37667)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(76924)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  (__webpack_require__(27491).appendChild)(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 83207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var anObject = __webpack_require__(49495);
var IE8_DOM_DEFINE = __webpack_require__(24620);
var toPrimitive = __webpack_require__(90648);
var dP = Object.defineProperty;

exports.f = __webpack_require__(45880) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 42048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var dP = __webpack_require__(83207);
var anObject = __webpack_require__(49495);
var getKeys = __webpack_require__(95169);

module.exports = __webpack_require__(45880) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var pIE = __webpack_require__(79501);
var createDesc = __webpack_require__(8991);
var toIObject = __webpack_require__(88462);
var toPrimitive = __webpack_require__(90648);
var has = __webpack_require__(8346);
var IE8_DOM_DEFINE = __webpack_require__(24620);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(45880) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 38883:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(88462);
var gOPN = (__webpack_require__(8689).f);
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 8689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(69550);
var hiddenKeys = (__webpack_require__(73969).concat)('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 64392:
/***/ (function(__unused_webpack_module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 63400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8346);
var toObject = __webpack_require__(81022);
var IE_PROTO = __webpack_require__(37667)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 69550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(8346);
var toIObject = __webpack_require__(88462);
var arrayIndexOf = __webpack_require__(77017)(false);
var IE_PROTO = __webpack_require__(37667)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 95169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(69550);
var enumBugKeys = __webpack_require__(73969);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 79501:
/***/ (function(__unused_webpack_module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 74494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(57125);
var core = __webpack_require__(24429);
var fails = __webpack_require__(91866);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 75070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(45880);
var getKeys = __webpack_require__(95169);
var toIObject = __webpack_require__(88462);
var isEnum = (__webpack_require__(79501).f);
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 76542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $parseFloat = (__webpack_require__(19657).parseFloat);
var $trim = (__webpack_require__(39895).trim);

module.exports = 1 / $parseFloat(__webpack_require__(57216) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),

/***/ 78595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $parseInt = (__webpack_require__(19657).parseInt);
var $trim = (__webpack_require__(39895).trim);
var ws = __webpack_require__(57216);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ 8991:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 95828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hide = __webpack_require__(51128);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ 23669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51128);


/***/ }),

/***/ 33461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(57125);
var aFunction = __webpack_require__(19503);
var ctx = __webpack_require__(19478);
var forOf = __webpack_require__(99569);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 31327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(57125);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 43614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(63731);
var anObject = __webpack_require__(49495);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(19478)(Function.call, (__webpack_require__(42060).f)(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 16736:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19657);
var core = __webpack_require__(24429);
var dP = __webpack_require__(83207);
var DESCRIPTORS = __webpack_require__(45880);
var SPECIES = __webpack_require__(84593)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ 80411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var def = (__webpack_require__(83207).f);
var has = __webpack_require__(8346);
var TAG = __webpack_require__(84593)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 37667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(60699)('keys');
var uid = __webpack_require__(83897);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 60699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var core = __webpack_require__(24429);
var global = __webpack_require__(19657);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(88596) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 29132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(30497);
var defined = __webpack_require__(47588);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 39895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(57125);
var defined = __webpack_require__(47588);
var fails = __webpack_require__(91866);
var spaces = __webpack_require__(57216);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ 57216:
/***/ (function(module) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 57560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(30497);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 30497:
/***/ (function(module) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 88462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(73306);
var defined = __webpack_require__(47588);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 81429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(30497);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 81022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(47588);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 90648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(63731);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 83897:
/***/ (function(module) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 2195:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(63731);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 49931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(19657);
var core = __webpack_require__(24429);
var LIBRARY = __webpack_require__(88596);
var wksExt = __webpack_require__(55856);
var defineProperty = (__webpack_require__(83207).f);
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 55856:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

exports.f = __webpack_require__(84593);


/***/ }),

/***/ 84593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var store = __webpack_require__(60699)('wks');
var uid = __webpack_require__(83897);
var Symbol = (__webpack_require__(19657).Symbol);
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 95594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(42156);
var ITERATOR = __webpack_require__(84593)('iterator');
var Iterators = __webpack_require__(1998);
module.exports = (__webpack_require__(24429).getIteratorMethod) = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 64707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(19478);
var $export = __webpack_require__(57125);
var toObject = __webpack_require__(81022);
var call = __webpack_require__(22722);
var isArrayIter = __webpack_require__(96155);
var toLength = __webpack_require__(81429);
var createProperty = __webpack_require__(89641);
var getIterFn = __webpack_require__(95594);

$export($export.S + $export.F * !__webpack_require__(40968)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 22622:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(57125);

$export($export.S, 'Array', { isArray: __webpack_require__(48120) });


/***/ }),

/***/ 98493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(80535);
var step = __webpack_require__(34835);
var Iterators = __webpack_require__(1998);
var toIObject = __webpack_require__(88462);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(83912)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 39681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(38269);
var validate = __webpack_require__(2195);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(70952)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ 2828:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(57125);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(38141) });


/***/ }),

/***/ 61146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(57125);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(82435) });


/***/ }),

/***/ 54264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(57125);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(45880), 'Object', { defineProperties: __webpack_require__(42048) });


/***/ }),

/***/ 89079:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(57125);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(45880), 'Object', { defineProperty: (__webpack_require__(83207).f) });


/***/ }),

/***/ 88952:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(63731);
var meta = (__webpack_require__(63268).onFreeze);

__webpack_require__(74494)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ 24757:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(88462);
var $getOwnPropertyDescriptor = (__webpack_require__(42060).f);

__webpack_require__(74494)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ 51570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(81022);
var $getPrototypeOf = __webpack_require__(63400);

__webpack_require__(74494)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 39547:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(81022);
var $keys = __webpack_require__(95169);

__webpack_require__(74494)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 80722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(57125);
$export($export.S, 'Object', { setPrototypeOf: (__webpack_require__(43614).set) });


/***/ }),

/***/ 34164:
/***/ (function() {



/***/ }),

/***/ 68497:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(57125);
var $parseFloat = __webpack_require__(76542);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),

/***/ 70930:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(57125);
var $parseInt = __webpack_require__(78595);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),

/***/ 20613:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(29132)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(83912)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 84397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(19657);
var has = __webpack_require__(8346);
var DESCRIPTORS = __webpack_require__(45880);
var $export = __webpack_require__(57125);
var redefine = __webpack_require__(23669);
var META = (__webpack_require__(63268).KEY);
var $fails = __webpack_require__(91866);
var shared = __webpack_require__(60699);
var setToStringTag = __webpack_require__(80411);
var uid = __webpack_require__(83897);
var wks = __webpack_require__(84593);
var wksExt = __webpack_require__(55856);
var wksDefine = __webpack_require__(49931);
var enumKeys = __webpack_require__(82261);
var isArray = __webpack_require__(48120);
var anObject = __webpack_require__(49495);
var isObject = __webpack_require__(63731);
var toObject = __webpack_require__(81022);
var toIObject = __webpack_require__(88462);
var toPrimitive = __webpack_require__(90648);
var createDesc = __webpack_require__(8991);
var _create = __webpack_require__(82435);
var gOPNExt = __webpack_require__(38883);
var $GOPD = __webpack_require__(42060);
var $GOPS = __webpack_require__(64392);
var $DP = __webpack_require__(83207);
var $keys = __webpack_require__(95169);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  (__webpack_require__(8689).f) = gOPNExt.f = $getOwnPropertyNames;
  (__webpack_require__(79501).f) = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(88596)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(51128)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 83024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19657);
var each = __webpack_require__(50482)(0);
var redefine = __webpack_require__(23669);
var meta = __webpack_require__(63268);
var assign = __webpack_require__(38141);
var weak = __webpack_require__(26190);
var isObject = __webpack_require__(63731);
var validate = __webpack_require__(2195);
var NATIVE_WEAK_MAP = __webpack_require__(2195);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(70952)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ 91363:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(33461)('Map');


/***/ }),

/***/ 84155:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(31327)('Map');


/***/ }),

/***/ 22126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(57125);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(88941)('Map') });


/***/ }),

/***/ 13090:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(57125);
var $entries = __webpack_require__(75070)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ 11861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(57125);
var $values = __webpack_require__(75070)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 56991:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(49931)('asyncIterator');


/***/ }),

/***/ 51049:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(49931)('observable');


/***/ }),

/***/ 71015:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(33461)('WeakMap');


/***/ }),

/***/ 4863:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(31327)('WeakMap');


/***/ }),

/***/ 8191:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(98493);
var global = __webpack_require__(19657);
var hide = __webpack_require__(51128);
var Iterators = __webpack_require__(1998);
var TO_STRING_TAG = __webpack_require__(84593)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 40300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.styledBox = styledBox;
exports["default"] = exports.styledProvider = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Theme = __webpack_require__(86522);

var _styled = _interopRequireDefault(__webpack_require__(6948));

var __jsx = _react["default"].createElement;
var boxStyles = {
  boxSizing: "border-box",
  minWidth: "0px",
  margin: 0,
  padding: 0,
  border: 0,
  listStyle: "none"
};
var focusReset = {
  ":focus": {
    outline: "none"
  }
};
var fitChildStyles = {
  position: "relative",
  "> *": {
    minWidth: "inherit !important",
    maxWidth: "inherit !important",
    width: "100% !important"
  }
};
var fitChildHeightStyles = {
  position: "relative",
  "> *": {
    minHeight: "inherit !important",
    maxHeight: "inherit !important",
    height: "100% !important"
  }
};

var styledProvider = function styledProvider(theme) {
  return function () {
    var as = "div";
    var obj = arguments.length <= 0 ? undefined : arguments[0];
    var extraProps = arguments.length <= 1 ? undefined : arguments[1];

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
      as = arguments.length <= 0 ? undefined : arguments[0];
      obj = arguments.length <= 1 ? undefined : arguments[1];
      extraProps = arguments.length <= 2 ? undefined : arguments[2];
    }

    return styledBox(as, obj, extraProps, theme);
  };
};

exports.styledProvider = styledProvider;

function styledBox(as, obj) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var theme = arguments.length > 3 ? arguments[3] : undefined;

  if (typeof obj !== "object") {
    throw new Error("Dupa, can't use function");
  }

  var fitW = extraProps.fitW,
      fitH = extraProps.fitH,
      noFocus = extraProps.noFocus,
      restProps = (0, _objectWithoutProperties2["default"])(extraProps, ["fitW", "fitH", "noFocus"]);
  var rootStyles = (0, _objectSpread2["default"])({}, boxStyles, fitW && fitChildStyles, fitH && fitChildHeightStyles, (theme.hideFocus || noFocus) && focusReset);
  var hasFunctions = false; // static styles calculated only once in styledBox function. dynamicStyles must be recalculated at runtime

  var staticStyles = {};

  for (var key in obj) {
    if (typeof obj[key] === "function") {
      hasFunctions = true;
    } else {
      staticStyles[key] = obj[key];
    }
  }

  staticStyles = (0, _.css)(staticStyles)(theme); // compile static styles

  var dynamicStyles;

  if (hasFunctions) {
    dynamicStyles = function dynamicStyles(props) {
      var dynamicStyles = {};

      for (var _key in obj) {
        if (typeof obj[_key] === "function") {
          dynamicStyles[_key] = obj[_key](props);
        } else {// newObj[key] = obj[key];
        }
      }

      dynamicStyles = (0, _.css)(dynamicStyles)(theme); // compile static styles

      return dynamicStyles;
    };
  }

  var result = [rootStyles, staticStyles];

  if (dynamicStyles) {
    result.push(dynamicStyles);
  }

  var RawDiv = (0, _styled["default"])(as).apply(void 0, result); // This below takes some performance hit, don't know why. Maybe it's just the issue of number of components and dev mode.

  var Component = _react["default"].forwardRef(function (props, ref) {
    if (props.__portals__) {
      return __jsx(_react["default"].Fragment, null, props.__portals__, __jsx(RawDiv, (0, _extends2["default"])({}, restProps, props, {
        ref: ref
      })));
    }

    return _react["default"].createElement(RawDiv, (0, _objectSpread2["default"])({}, props, {
      ref: ref
    }));
  });

  return Component;
}

function Box_(props) {
  var sx = props.sx,
      as = props.as,
      _ref = props._ref,
      _props$noFocus = props.noFocus,
      noFocus = _props$noFocus === void 0 ? false : _props$noFocus,
      _props$fitChild = props.fitChild,
      fitChild = _props$fitChild === void 0 ? false : _props$fitChild,
      _props$fitChildHeight = props.fitChildHeight,
      fitChildHeight = _props$fitChildHeight === void 0 ? false : _props$fitChildHeight,
      fitW = props.fitW,
      fitH = props.fitH,
      __portals__ = props.__portals__,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "as", "_ref", "noFocus", "fitChild", "fitChildHeight", "fitW", "fitH", "__portals__"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var t = (0, _Theme.useTheme)();

  if (fitW === true) {
    fitChild = true;
  }

  if (fitH === true) {
    fitChildHeight = true;
  }

  var ret = (0, _.jsx)(as, (0, _objectSpread2["default"])({
    sx: [boxStyles, (t.hideFocus || noFocus) && focusReset, fitChild && fitChildStyles, fitChildHeight && fitChildHeightStyles, css],
    ref: _ref
  }, restProps));

  if (__portals__) {
    return __jsx(_react["default"].Fragment, null, __portals__, ret);
  }

  return ret;
}

var Box = _react["default"].forwardRef(function (props, ref) {
  return __jsx(Box_, (0, _extends2["default"])({
    _ref: ref
  }, props));
});

Box.defaultProps = {
  as: "div"
};
var _default = Box;
/**
 What do we want?

 css={{
    color: "primary", // colors by simple string from theme,
    font: "heading1", // fonts that compile to a group of properties
    padding: rslin(10, 20), // linear spacings, responsive sizes,
    "media-query": {
        color: "blue" // media queries available directly
    }
 }}

 rslin(10, 20)
 {
    _: 0,
    md: rslin(10, 20)
 }

 We want easy access to:
 - h1, h2, h3, h4, etc.
 - p
 - ul, li, ol
 - section etc.
 - A
 - <Ul>
 - <Li>

 sx!!!

 <ul sx={} />

 <li sx={{}}

 They should have some nice default styles, but easily overrideable.

 If we want to use native HTML elements, we must remember that then can't have default styles defined in any other way than global styles.


 NATYWNE KOMPONENTY CZY NIE?
 - na razie natywne!!! z sx. Potem możemy rozszerzać. Możemy zostawić Box i Text na razie (w sumie to samo tylko inny default "as" na "p", lol)
 - czyli co, wgrywamy theme-ui?

 ZALETY NIENATYWNYCH
 - możemy mieć kontrolę nad propsami i wtedy np. wiedzieć, że żaden komponent w środku jakiegoś komponentu nie zrobi position: fixed czy coś. Można to realnie zablokować :O ZAJEBIŚCIE.
 - zacznijmy od Box i Text.


 THINGS TO DO:
 - One big css() function that takes "our form of css" (with theme styles, fonts, responsive sizes) and compiles to emotion form. It should be wrapper around css from styled-system.
 - W całej appce posługujemy sie naszymi obiektami, dopiero na SAM KONIEC kompilujemy style do styli emotion.
 - Rozkmiń kolejnośc media query etc.

 **/

exports["default"] = _default;

/***/ }),

/***/ 15112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _useHover = _interopRequireDefault(__webpack_require__(68854));

var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;
var commonResetStyles = {
  position: "relative",
  display: "inline-block",
  verticalAlign: "top"
};
var buttonResetStyles = {
  border: 0,
  margin: 0,
  padding: 0,
  width: "auto",
  overflow: "visible",
  background: "transparent",
  color: "inherit",
  font: "inherit",
  lineHeight: "normal",
  fontSmooth: "inherit",
  appearance: "none",
  ":not(:disabled)": {
    cursor: "pointer"
  },
  textAlign: "left"
};
var linkResetStyles = {
  color: "inherit",
  textDecoration: "none",
  boxSizing: "border-box"
};

var Button = _react["default"].forwardRef(function (props, _ref) {
  // look
  var disabled = props.disabled,
      children = props.children,
      label = props.label,
      selected = props.selected,
      buttonRef = props.buttonRef,
      isLoading = props.isLoading,
      href = props.href,
      _props$forceLink = props.forceLink,
      forceLink = _props$forceLink === void 0 ? false : _props$forceLink,
      sx = props.sx,
      _props$__minimalLinkS = props.__minimalLinkStyling,
      __minimalLinkStyling = _props$__minimalLinkS === void 0 ? false : _props$__minimalLinkS,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["disabled", "children", "label", "selected", "buttonRef", "isLoading", "href", "forceLink", "sx", "__minimalLinkStyling"]);

  _ref = buttonRef || _ref; // buttonRef is legacy, backward compatibility

  var hoverRef = (0, _react.useRef)(null);
  var isHovered = (0, _useHover["default"])(hoverRef);
  var state = {
    selected: selected,
    disabled: disabled,
    isHovered: isHovered,
    isLoading: isLoading,
    loading: isLoading,
    hovered: isHovered
  };
  sx = typeof sx === "function" ? sx(state) : sx;

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var mainProps = {
    ref: function ref(element) {
      hoverRef.current = element; // We must remember that ref that is passed here can be function or object! However, for internal use (useHover) we need object.

      if (typeof _ref === "function") {
        _ref(element);
      } else if (buttonRef) {
        _ref.current = element;
      }
    },
    disabled: disabled
  };

  if (href || forceLink) {
    mainProps.sx = (0, _objectSpread2["default"])({}, !__minimalLinkStyling && commonResetStyles, linkResetStyles, sx);
    mainProps.as = "a";
    mainProps.href = href;
  } else {
    mainProps.sx = [(0, _objectSpread2["default"])({}, commonResetStyles, buttonResetStyles), sx];
    mainProps.as = "button";
  }

  return __jsx(_Box["default"], (0, _extends2["default"])({}, restProps, mainProps), typeof children === "function" ? children(state) : children);
});

var _default = Button;
exports["default"] = _default;

/***/ }),

/***/ 96088:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Button = _interopRequireDefault(__webpack_require__(15112));

var _default = _Button["default"];
exports["default"] = _default;

/***/ }),

/***/ 54311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Button = _interopRequireDefault(__webpack_require__(96088));

var __jsx = _react["default"].createElement;
var defaults = {
  background: {
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  body: function body(_ref) {
    var children = _ref.children,
        isLoading = _ref.isLoading;
    return {
      boxSizing: "border-box",
      position: "relative",
      pointerEvents: "none",
      height: "100%",
      minHeight: "inherit",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      visibility: isLoading ? "hidden" : "visible",
      overflow: "hidden",
      textAlign: "center",
      // lineHeight: "1 !important",
      // whiteSpace: "nowrap",
      // textOverflow: "ellipsis", display: block must be on to make this work!!!
      __children: children
    };
  },
  loader: {
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    __children: "LOAD"
  }
};

var _default = function _default(props) {
  var _sx = props.sx,
      children = props.children,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "children"]);
  return (0, _.jsx)(_Button["default"], (0, _extends2["default"])({
    sx: function sx(state) {
      var _splitSx = (0, _.splitSx)(typeof _sx === "function" ? _sx(state) : _sx),
          _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
          css = _splitSx2[0],
          customSx = _splitSx2[1];

      return {
        $css: css
      };
    }
  }, restProps), function (state) {
    var newState = (0, _objectSpread2["default"])({}, state, {
      children: typeof children === "function" ? children(state) : children
    });

    var _splitSx3 = (0, _.splitSx)(typeof _sx === "function" ? _sx(newState) : _sx),
        _splitSx4 = (0, _slicedToArray2["default"])(_splitSx3, 2),
        css = _splitSx4[0],
        customSx = _splitSx4[1];

    var loaderSpec = (0, _.getElementSpec)(customSx.$loader, defaults.loader, newState);
    var backgroundSpec = (0, _.getElementSpec)(customSx.$background, defaults.background, newState);
    var bodySpec = (0, _.getElementSpec)(customSx.$body, defaults.body, newState);
    return (0, _.jsx)(_react["default"].Fragment, null, (0, _.createElement)(backgroundSpec), (0, _.createElement)(bodySpec), newState.isLoading && (0, _.createElement)(loaderSpec));
  });
};

exports["default"] = _default;

/***/ }),

/***/ 7859:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _ButtonBase = _interopRequireDefault(__webpack_require__(54311));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

var defaultBody = function defaultBody(_ref) {
  var children = _ref.children,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon;
  return {
    __children: [leftIcon, children, rightIcon]
  };
};

var _default = function _default(props) {
  var children = props.children,
      _sx = props.sx,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "sx"]);
  return (0, _.jsx)(_ButtonBase["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(state) {
      _sx = typeof _sx === "function" ? _sx(state) : _sx;

      var _splitSx = (0, _.splitSx)(_sx),
          _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
          css = _splitSx2[0],
          customSx = _splitSx2[1];

      var $icon = customSx.$icon,
          $body = customSx.$body,
          restSx = (0, _objectWithoutProperties2["default"])(customSx, ["$icon", "$body"]); // TODO: wrapper should not be there, styles should be applied directly to icon. We should have `size` parameter for Icons and we can have fixed amount of icon sizes!

      var iconWrapper = children && (0, _.jsx)(_Box["default"], {
        sx: (0, _objectSpread2["default"])({}, $icon)
      }, _react["default"].cloneElement(children, {
        style: {
          width: "100%",
          height: "100%"
        }
      }));
      var newState = (0, _objectSpread2["default"])({}, state, {
        icon: iconWrapper,
        children: children
      });
      var bodySpec = (0, _.getElementSpec)($body, defaultBody, newState);
      return (0, _objectSpread2["default"])({
        $css: css,
        $body: bodySpec
      }, restSx);
    }
  }));
};

exports["default"] = _default;

/***/ }),

/***/ 30650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

/**
 * Button Raw
 */
var buttonResetStyles = {
  border: "none",
  margin: 0,
  padding: 0,
  width: "auto",
  overflow: "visible",
  background: "transparent",
  color: "inherit",
  font: "inherit",
  lineHeight: "normal",
  fontSmooth: "inherit",
  appearance: "none",
  ":not(:disabled)": {
    cursor: "pointer"
  },
  textAlign: "left"
};

function ButtonRaw_(props) {
  var sx = props.sx,
      buttonRef = props.buttonRef,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "buttonRef"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    as: "button",
    sx: [buttonResetStyles, css]
  }, restProps, {
    ref: buttonRef
  }));
}

var ButtonRaw$ = _react["default"].forwardRef(function (props, ref) {
  return (0, _.jsx)(ButtonRaw_, (0, _extends2["default"])({
    buttonRef: ref
  }, props));
});

var _default = ButtonRaw$;
exports["default"] = _default;

/***/ }),

/***/ 27210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _ButtonBase = _interopRequireDefault(__webpack_require__(54311));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

var defaultBody = function defaultBody(_ref) {
  var children = _ref.children,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon;
  return {
    __children: (0, _.jsx)(_react["default"].Fragment, null, leftIcon, children, rightIcon)
  };
};

var _default = function _default(props) {
  var leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      children = props.children,
      _sx = props.sx,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["leftIcon", "rightIcon", "children", "sx"]);
  return (0, _.jsx)(_ButtonBase["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(state) {
      _sx = typeof _sx === "function" ? _sx(state) : _sx;

      var _splitSx = (0, _.splitSx)(_sx),
          _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
          css = _splitSx2[0],
          customSx = _splitSx2[1];

      var $leftIcon = customSx.$leftIcon,
          $rightIcon = customSx.$rightIcon,
          $body = customSx.$body,
          $gap = customSx.$gap,
          $iconSize = customSx.$iconSize,
          restSx = (0, _objectWithoutProperties2["default"])(customSx, ["$leftIcon", "$rightIcon", "$body", "$gap", "$iconSize"]);
      var gap = $gap || 0;
      var iconSize = $iconSize || "auto"; // TODO: wrapper should not be there, styles should be applied directly to icon. We should have `size` parameter for Icons and we can have fixed amount of icon sizes!

      var leftIconWrapper = leftIcon && (0, _.jsx)(_Box["default"], {
        sx: (0, _objectSpread2["default"])({
          mr: gap,
          flex: "0 0 auto",
          width: iconSize,
          height: iconSize
        }, $leftIcon)
      }, _react["default"].cloneElement(leftIcon, {
        style: {
          width: "100%",
          height: "100%"
        }
      }));
      var rightIconWrapper = rightIcon && (0, _.jsx)(_Box["default"], {
        sx: (0, _objectSpread2["default"])({
          ml: gap,
          flex: "0 0 auto",
          width: iconSize,
          height: iconSize
        }, $rightIcon)
      }, _react["default"].cloneElement(rightIcon, {
        style: {
          width: "100%",
          height: "100%"
        }
      }));
      var newState = (0, _objectSpread2["default"])({}, state, {
        leftIcon: leftIconWrapper,
        rightIcon: rightIconWrapper,
        children: children
      });
      var bodySpec = (0, _.getElementSpec)($body, defaultBody, newState);
      return (0, _objectSpread2["default"])({
        $css: css,
        $body: bodySpec
      }, restSx);
    }
  }));
};

exports["default"] = _default;

/***/ }),

/***/ 58709:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _Theme = __webpack_require__(86522);

var __jsx = _react["default"].createElement;

// import { responsiveValueTransformScales } from "../index";
var _default = function _default(_ref) {
  var _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "containerMargin" : _ref$margin,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["sx", "margin"]);
  var theme = (0, _Theme.useTheme)(); // margin =
  //   responsiveValueTransformScales(
  //     margin,
  //     theme,
  //     "containerMargins",
  //     "space"
  //   ) || "10vw";

  return __jsx(_Box["default"], (0, _extends2["default"])({
    sx: (0, _objectSpread2["default"])({}, sx, {
      position: "relative",
      pl: margin,
      pr: margin
    })
  }, restProps));
};

exports["default"] = _default;

/***/ }),

/***/ 21277:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Layer = _interopRequireDefault(__webpack_require__(24946));

var __jsx = _react["default"].createElement;

function Dialog$(props) {
  return __jsx(_Layer["default"], (0, _extends2["default"])({}, props, {
    focusLock: true
  }));
}

var _default = Dialog$;
exports["default"] = _default;

/***/ }),

/***/ 35572:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _interopRequireWildcard = __webpack_require__(72269);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _index = __webpack_require__(79329);

var _useWindowSize = _interopRequireDefault(__webpack_require__(47272));

var __jsx = _react["default"].createElement;

function Display(_ref) {
  var when = _ref.when,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  var size = (0, _useWindowSize["default"])();
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);
  var currentValue = (0, _index.responsiveValueCurrent)(when);
  var shouldBeDisplayed = !mounted || typeof window === "object" && currentValue;
  var sx = {};

  if (!mounted) {
    // on SSR and first render we use display: none to allow no blinking and good SEO
    sx = {
      display: when.map(function (t) {
        return t === null ? null : t === true ? "block" : "none";
      })
    };
  } // If mounted, then we can simply not render not displayed items to decrease rerenders overload performance


  if (!shouldBeDisplayed) {
    return null;
  }

  return __jsx(_Box["default"], {
    sx: sx
  }, children);
}

var _default = Display;
exports["default"] = _default;

/***/ }),

/***/ 98290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _Theme = __webpack_require__(86522);

var _index = __webpack_require__(79329);

var __jsx = _react["default"].createElement;

var _default = function _default(props) {
  var _props$sx = props.sx,
      sx = _props$sx === void 0 ? {} : _props$sx,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 12 : _props$cols,
      _props$gap = props.gap,
      gap = _props$gap === void 0 ? "gridGap" : _props$gap,
      rowGap = props.rowGap,
      minItemWidth = props.minItemWidth,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "cols", "gap", "rowGap", "minItemWidth"]);
  var theme = (0, _Theme.useTheme)();

  if (typeof rowGap === "undefined" || rowGap === null) {
    rowGap = gap;
  }

  var gridTemplateColumns = (0, _index.responsiveValueMap)(cols, function (x) {
    return typeof x === "number" ? "repeat(".concat(x, ", 1fr)") : x;
  });

  if (minItemWidth) {
    gridTemplateColumns = (0, _index.responsiveValueMap)(minItemWidth, function (x) {
      return "repeat(auto-fill, minmax(".concat(typeof x === "number" ? "".concat(x, "px") : x, ", 1fr))");
    });
  }

  return __jsx(_Box["default"], (0, _extends2["default"])({
    sx: (0, _objectSpread2["default"])({
      display: "grid",
      gridColumnGap: gap,
      gridRowGap: rowGap,
      gridTemplateColumns: gridTemplateColumns
    }, sx)
  }, restProps));
};

exports["default"] = _default;

/***/ }),

/***/ 74707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _parseInt2 = _interopRequireDefault(__webpack_require__(57919));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _Container = _interopRequireDefault(__webpack_require__(58709));

var _Grid = _interopRequireDefault(__webpack_require__(98290));

var __jsx = _react["default"].createElement;

function GridDebugger(props) {
  var _useState = (0, _react.useState)(null),
      cols = _useState[0],
      setCols = _useState[1];

  var onKeyPress = function onKeyPress(event) {
    if (event.keyCode === 71 && event.ctrlKey) {
      if (cols) {
        setCols(null);
      } else {
        var _cols = (0, _parseInt2["default"])(window.prompt("How many columns?", "12"));

        setCols(_cols);
      }
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("keydown", onKeyPress, false);
    return function () {
      document.removeEventListener("keydown", onKeyPress, false);
    };
  });

  if (!cols) {
    return null;
  }

  return __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      left: 0,
      top: 0,
      width: "100%",
      zIndex: "10000",
      overflow: "hidden",
      pointerEvents: "none"
    }
  }, __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: cols
  }, (0, _toConsumableArray2["default"])(Array(cols)).map(function (e, i) {
    return __jsx(_Box["default"], {
      sx: {
        position: "relative",
        height: "100vh",
        bg: "coral",
        opacity: 0.3
      },
      key: i
    });
  }))));
}

var _default = GridDebugger;
exports["default"] = _default;

/***/ }),

/***/ 46627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

/**
 * Helper component placing components next to each other with gutter.
 *
 * Gutter can be responsive but items layout can not. So it's usable ONLY if on all resolutions items will be next to each other and won't wrap.
 */
function HorizontalStack(_ref) {
  var sx = _ref.sx,
      gap = _ref.gap,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["sx", "gap"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var gutter = gap || customSx.$gutter || 0;
  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    sx: [{
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      " > *": {
        marginRight: gutter,
        ":last-child": {
          marginRight: 0
        }
      }
    }, css]
  }, restProps));
}

var _default = HorizontalStack;
exports["default"] = _default;

/***/ }),

/***/ 65760:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _InputRaw = _interopRequireDefault(__webpack_require__(38164));

var _InputContainer = _interopRequireDefault(__webpack_require__(53189));

var __jsx = _react["default"].createElement;

function isValueEmpty(val) {
  return val === undefined || val === null || val.toString() === "";
}

function Input$(props) {
  var onChange = props.onChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["onChange"]);

  var _useState = (0, _react.useState)(props.value),
      value = _useState[0],
      setValue = _useState[1];

  var isEmpty = isValueEmpty(value); // let [isEmpty, setEmpty] = useState(isValueEmpty(props.value));

  var onChangeEvent = function onChangeEvent(val, e) {
    setValue(val);

    if (onChange) {
      onChange(val, e);
    }
  };

  return __jsx(_InputContainer["default"], (0, _extends2["default"])({}, restProps, {
    empty: isEmpty,
    onClear: function onClear() {
      onChangeEvent("", null);
    },
    label: props.label || props.placeholder,
    cursor: "text"
  }), __jsx(_InputRaw["default"], {
    sx: {
      width: "100%",
      height: "100%"
    },
    onChange: onChangeEvent,
    value: value
  }));
}

var _default = Input$;
exports["default"] = _default;

/***/ }),

/***/ 53189:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(99228));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _objectDestructuringEmpty2 = _interopRequireDefault(__webpack_require__(89811));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _HorizontalStack = _interopRequireDefault(__webpack_require__(46627));

var _ = __webpack_require__(79329);

var _InputRaw = _interopRequireDefault(__webpack_require__(38164));

var __jsx = _react["default"].createElement;
var defaults = {
  rootCss: function rootCss(_ref2) {
    var focused = _ref2.focused;
    return {
      position: "relative",
      display: "flex",
      verticalAlign: "top",
      overflow: "hidden",
      flexDirection: "row",
      cursor: "text"
    };
  },
  $input: function $input(_ref3) {
    (0, _objectDestructuringEmpty2["default"])(_ref3);
    return {
      __type: _InputRaw["default"],
      height: "100%",
      width: "100%"
    };
  },
  $leftEnhancersContainer: function $leftEnhancersContainer(_ref4) {
    var leftEnhancer = _ref4.leftEnhancer;
    return {
      __type: _HorizontalStack["default"],
      height: "100%",
      flexGrow: 0,
      flexShrink: 0,
      pointerEvents: "none",
      __children: leftEnhancer
    };
  },
  $rightEnhancersContainer: function $rightEnhancersContainer(_ref5) {
    var rightEnhancer = _ref5.rightEnhancer;
    return {
      __type: _HorizontalStack["default"],
      height: "100%",
      flexGrow: 0,
      flexShrink: 0,
      pointerEvents: "none",
      __children: rightEnhancer
    };
  },
  $controlContainer: function $controlContainer(_ref6) {
    var control = _ref6.control,
        label = _ref6.label,
        arrow = _ref6.arrow,
        cursor = _ref6.cursor;
    return {
      position: "relative",
      boxSizing: "border-box",
      height: "100%",
      flexGrow: 1,
      flexShrink: 1,
      display: "flex",
      alignItems: "center",
      cursor: cursor,
      // pointerEvents: "none",
      __children: (0, _.jsx)(_react["default"].Fragment, null, label, control, arrow)
    };
  },
  $label: function $label(_ref7) {
    var label = _ref7.label,
        empty = _ref7.empty;
    return {
      __type: "span",
      position: "absolute",
      pointerEvents: "none",
      top: 0,
      left: 0,
      opacity: empty ? 0 : 1,
      __children: label
    };
  },
  $arrowContainer: function $arrowContainer(_ref8) {
    var arrow = _ref8.arrow;
    return {
      position: "absolute",
      top: 0,
      right: 0,
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none",
      __children: arrow,
      __props: {
        key: "arrow"
      }
    };
  },
  $arrow: {
    __children: (0, _.jsx)(_react["default"].Fragment, null, "\u2304")
  }
};

function InputContainer$(props) {
  var sx = props.sx,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      _onClick = props.onClick,
      autoFocus = props.autoFocus,
      controlRef = props.controlRef,
      invalid = props.invalid,
      disabled = props.disabled,
      placeholder = props.placeholder,
      leftEnhancer = props.leftEnhancer,
      rightEnhancer = props.rightEnhancer,
      label = props.label,
      children = props.children,
      _props$forceFocused = props.forceFocused,
      forceFocused = _props$forceFocused === void 0 ? false : _props$forceFocused,
      rootRef = props.rootRef,
      _ref = props._ref,
      _props$cursor = props.cursor,
      cursor = _props$cursor === void 0 ? "default" : _props$cursor,
      _props$empty = props.empty,
      empty = _props$empty === void 0 ? true : _props$empty,
      _props$showArrow = props.showArrow,
      showArrow = _props$showArrow === void 0 ? false : _props$showArrow,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      onClear = props.onClear,
      inputProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "onFocus", "onBlur", "onClick", "autoFocus", "controlRef", "invalid", "disabled", "placeholder", "leftEnhancer", "rightEnhancer", "label", "children", "forceFocused", "rootRef", "_ref", "cursor", "empty", "showArrow", "clearable", "onClear"]);

  var _useState = (0, _react.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  focused = focused || forceFocused; // let [empty, setEmpty] = useState(true);
  //
  // if (props.value) {
  //     empty = props.value === "";
  // }

  var internalControlRef = (0, _react.useRef)(null);
  controlRef = controlRef || internalControlRef;
  var state = {
    focused: focused,
    invalid: invalid,
    disabled: disabled,
    empty: empty,
    placeholder: placeholder
  };
  sx = typeof sx === "function" ? sx(state) : sx;

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  if (customSx.$labelInside) {
    state.label = label || placeholder || "Label";
  }

  var rootCss = typeof customSx.$root === "function" ? customSx.$root(state) : customSx.$root;

  var controlRaw = _react["default"].Children.only(children);

  var controlCss = typeof customSx.$control === "function" ? customSx.$control(state) : customSx.$control;
  (0, _react.useEffect)(function () {
    if (autoFocus && controlRef.current.focus) {
      controlRef.current.focus();
    }
  }, []);

  var control = _react["default"].cloneElement(controlRaw, (0, _objectSpread2["default"])({
    onFocus: function onFocus(e) {
      setFocused(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      setFocused(false);

      if (_onBlur) {
        _onBlur(e);
      }
    },
    disabled: disabled,
    placeholder: placeholder
  }, inputProps, {
    sx: (0, _objectSpread2["default"])({}, controlCss, controlRaw.props.sx),
    _ref: controlRef,
    noFocus: true
  }));

  var inputContainer;
  var inputContainerState = (0, _objectSpread2["default"])({}, state, {
    control: control
  });
  var arrowContainer;

  if (showArrow) {
    var arrow = (0, _.createElement)((0, _.getElementSpec)(customSx.$arrow, defaults.$arrow, state));
    arrowContainer = (0, _.createElement)((0, _.getElementSpec)(customSx.$arrowContainer, defaults.$arrowContainer, (0, _objectSpread2["default"])({}, state, {
      arrow: arrow
    })));
  }

  if (showArrow === "inline") {
    inputContainerState.arrow = arrowContainer;
    arrowContainer = null;
  }

  if (sx.$labelInside) {
    inputContainerState.label = (0, _.createElement)((0, _.getElementSpec)(customSx.$label, defaults.$label, state));
  }

  inputContainerState.cursor = cursor;
  inputContainer = (0, _.createElement)((0, _.getElementSpec)(customSx.$controlContainer, (0, _objectSpread2["default"])({}, defaults.$controlContainer(inputContainerState), {
    __type: sx.$labelInside ? "label" : "div"
  }), inputContainerState));
  leftEnhancer = typeof leftEnhancer === "function" ? leftEnhancer(state) : leftEnhancer;
  var leftEnhancersContainerSpec = (0, _.getElementSpec)(customSx.$leftEnhancersContainer, defaults.$leftEnhancersContainer, (0, _objectSpread2["default"])({}, state, {
    leftEnhancer: leftEnhancer
  }));
  var leftEnhancerContainer = leftEnhancer && (0, _.createElement)(leftEnhancersContainerSpec);
  rightEnhancer = typeof rightEnhancer === "function" ? rightEnhancer(state) : rightEnhancer;
  var rightEnhancer2 = (0, _isArray["default"])(rightEnhancer) ? rightEnhancer : rightEnhancer ? [rightEnhancer] : [];

  if (showArrow === "enhancer") {
    rightEnhancer2.unshift(arrowContainer);
  }

  if (clearable && !empty) {
    rightEnhancer2.unshift((0, _.jsx)(_Box["default"], {
      sx: {
        pointerEvents: "auto",
        cursor: "pointer"
      },
      onClick: function onClick(e) {
        onClear();
      }
    }, customSx.$clearElement || "X"));
  }

  var rightEnhancersContainerSpec = (0, _.getElementSpec)(customSx.$rightEnhancersContainer, defaults.$rightEnhancersContainer, (0, _objectSpread2["default"])({}, state, {
    rightEnhancer: rightEnhancer2
  }));
  var rightEnhancerContainer = rightEnhancer2.length > 0 && (0, _.createElement)(rightEnhancersContainerSpec);
  return (0, _.jsx)(_Box["default"], {
    sx: [defaults.rootCss(state), {
      cursor: cursor
    }, rootCss, css],
    _ref: _ref || rootRef // TODO: rootRef is legacy, can be removed later
    ,
    onClick: function onClick() {
      if (_onClick) {
        _onClick.apply(void 0, arguments);
      } // console.log('on open');


      controlRef.current.focus();
    }
  }, leftEnhancerContainer, inputContainer, rightEnhancerContainer);
}

var _default = InputContainer$;
exports["default"] = _default;

/***/ }),

/***/ 38164:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

/**
 * Input Raw
 */
var inputResetStyles = {
  border: 0,
  bg: "transparent",
  ":invalid": {
    boxShadow: "none",
    outline: "none"
  },
  "::-webkit-outer-spin-button, ::-webkit-inner-spin-button, ::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
    WebkitAppearance: "none"
  },
  WebkitAppearance: "none",
  MozAppearance: "textfield"
};

function InputRaw_(props) {
  var sx = props.sx,
      inputRef = props.inputRef,
      _onChange = props.onChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "inputRef", "onChange"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return __jsx(_Box["default"], (0, _extends2["default"])({
    as: "input",
    sx: [inputResetStyles, css],
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e.target.value, e);
      }
    }
  }, restProps, {
    ref: inputRef
  }));
}

var InputRaw = _react["default"].forwardRef(function (props, ref) {
  return __jsx(InputRaw_, (0, _extends2["default"])({
    inputRef: ref
  }, props));
});

var _default = InputRaw;
exports["default"] = _default;

/***/ }),

/***/ 24946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _isArray = _interopRequireDefault(__webpack_require__(99228));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _assign = _interopRequireDefault(__webpack_require__(53570));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _index = __webpack_require__(19658);

var _utils = __webpack_require__(19886);

var _index2 = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _uniqueId = _interopRequireDefault(__webpack_require__(68646));

var _reactFocusLock = _interopRequireDefault(__webpack_require__(69549));

var __jsx = _react["default"].createElement;

var mountNode = function mountNode() {
  if (typeof document !== "undefined") {
    return document.getElementById("__layers__");
  }
};

var scrollbarWidth;

function getScrollbarWidth() {
  if (typeof scrollbarWidth === "number") {
    return scrollbarWidth;
  } // Creating invisible container


  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100%"; // outer.style.overflow = "scroll"; // forcing scrollbar to appear
  // outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer); // Creating inner element and placing it in the container

  var inner = document.createElement("div");
  outer.appendChild(inner); // Calculating difference between container's full width and the child width

  scrollbarWidth = window.innerWidth - outer.clientWidth; // Removing temporary elements from the DOM

  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

var centered = function centered(_ref) {
  var width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      animationTime = _ref.animationTime,
      animationEase = _ref.animationEase,
      backgroundColor = _ref.backgroundColor,
      shouldShow = _ref.shouldShow;
  return {
    anchored: false,
    background: {
      backgroundColor: backgroundColor,
      transition: "opacity ".concat(animationTime, "s ").concat(animationEase),
      opacity: shouldShow ? 1 : 0
    },
    contentWrapper: {
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    },
    content: {
      transition: "all ".concat(animationTime, "s ").concat(animationEase),
      opacity: shouldShow ? 1 : 0
    }
  };
};

var slide = function slide(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      minWidth = _ref2.minWidth,
      minHeight = _ref2.minHeight,
      maxWidth = _ref2.maxWidth,
      maxHeight = _ref2.maxHeight,
      animationTime = _ref2.animationTime,
      animationEase = _ref2.animationEase,
      backgroundColor = _ref2.backgroundColor,
      axis = _ref2.axis,
      fromStart = _ref2.fromStart,
      shouldShow = _ref2.shouldShow;
  return {
    anchored: false,
    background: {
      backgroundColor: backgroundColor,
      transition: "opacity ".concat(animationTime, "s ").concat(animationEase),
      opacity: shouldShow ? 1 : 0
    },
    contentWrapper: {
      position: "absolute",
      top: axis === "Y" && fromStart || axis === "X" ? 0 : "auto",
      bottom: axis === "Y" && !fromStart ? 0 : "auto",
      left: axis === "X" && fromStart || axis === "Y" ? 0 : "auto",
      right: axis === "X" && !fromStart ? 0 : "auto",
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    },
    content: {
      transition: "all ".concat(animationTime, "s ").concat(animationEase),
      transform: shouldShow ? "none" : "translate".concat(axis, "(").concat(fromStart ? "-" : "", "100%)"),
      opacity: shouldShow ? 1 : 0
    }
  };
};

var popoverRootDefault = function popoverRootDefault(_ref3) {
  var children = _ref3.children,
      isOpen = _ref3.isOpen,
      isVisible = _ref3.isVisible,
      popoverOffset = _ref3.popoverOffset,
      showArrow = _ref3.showArrow,
      placement = _ref3.placement,
      width = _ref3.width,
      height = _ref3.height,
      minWidth = _ref3.minWidth,
      minHeight = _ref3.minHeight,
      maxWidth = _ref3.maxWidth,
      maxHeight = _ref3.maxHeight;
  return (0, _objectSpread2["default"])({
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    left: 0,
    transition: isVisible ? "all .1s ease-out" : "none",
    opacity: isVisible && isOpen ? 1 : 0,
    transform: isVisible && isOpen ? (0, _utils.getEndPosition)(popoverOffset) : (0, _utils.getStartPosition)(popoverOffset, placement, showArrow)
  }, (0, _utils.getPopoverMarginStyles)(showArrow, placement), {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    overflowY: "auto",
    __children: children
  });
};

function layerAdded(isAnchoredToWindow) {
  window.__cui_layerCounter = window.__cui_layerCounter || {
    window: 0,
    element: 0,
    all: 0
  };

  if (isAnchoredToWindow) {
    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(true);
    }

    window.__cui_layerCounter.window++;
  } else {
    window.__cui_layerCounter.element++;
  }

  window.__cui_layerCounter.all = window.__cui_layerCounter.window + window.__cui_layerCounter.element;
}

function layerRemoved(isAnchoredToWindow) {
  window.__cui_layerCounter = window.__cui_layerCounter || {
    window: 0,
    element: 0,
    all: 0
  };

  if (isAnchoredToWindow) {
    window.__cui_layerCounter.window = Math.max(0, window.__cui_layerCounter.window - 1);

    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(false);
    }
  } else {
    window.__cui_layerCounter.element = Math.max(0, window.__cui_layerCounter.element - 1);
  }

  window.__cui_layerCounter.all = window.__cui_layerCounter.window + window.__cui_layerCounter.element;
}

function layerChanged(isAnchoredToWindow) {
  window.__cui_layerCounter = window.__cui_layerCounter || {
    window: 0,
    element: 0,
    all: 0
  };

  if (isAnchoredToWindow) {
    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(true);
    }

    window.__cui_layerCounter.window++;
    window.__cui_layerCounter.element = Math.max(0, window.__cui_layerCounter.element - 1);
  } else {
    window.__cui_layerCounter.element++;
    window.__cui_layerCounter.window = Math.max(0, window.__cui_layerCounter.window - 1);

    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(false);
    }
  }

  window.__cui_layerCounter.all = window.__cui_layerCounter.window + window.__cui_layerCounter.element;
}

function Layer$(props) {
  var _useState = (0, _react.useState)(false),
      isMounted = _useState[0],
      setMounted = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isLayerMounted = _useState3[0],
      setLayerMounted = _useState3[1];

  var onClose = props.onClose,
      isOpen = props.isOpen,
      anchoredTo = props.anchoredTo,
      _props$sx = props.sx,
      sx = _props$sx === void 0 ? {} : _props$sx;

  var _Object$assign = (0, _assign["default"])((0, _objectSpread2["default"])({}, sx), props),
      width = _Object$assign.width,
      height = _Object$assign.height,
      minWidth = _Object$assign.minWidth,
      minHeight = _Object$assign.minHeight,
      maxWidth = _Object$assign.maxWidth,
      maxHeight = _Object$assign.maxHeight,
      animationTime = _Object$assign.animationTime,
      animationEase = _Object$assign.animationEase,
      backgroundColor = _Object$assign.backgroundColor,
      _Object$assign$root = _Object$assign.root,
      root = _Object$assign$root === void 0 ? {} : _Object$assign$root,
      _Object$assign$contai = _Object$assign.container,
      container = _Object$assign$contai === void 0 ? {} : _Object$assign$contai,
      placement = _Object$assign.placement; // backward compatibility. Now props are recommended.


  var closeTimeout = 0;
  var animateStartTimer = (0, _react.useRef)(null);
  var animateOutTimer = (0, _react.useRef)(null); // Popover

  var popperRef = (0, _react.useRef)(null);
  var arrowRef = (0, _react.useRef)(null);

  var _useState4 = (0, _react.useState)({
    left: 0,
    top: 0
  }),
      arrowOffset = _useState4[0],
      setArrowOffset = _useState4[1];

  var _useState5 = (0, _react.useState)("bottomLeft"),
      popoverPlacement = _useState5[0],
      setPopoverPlacement = _useState5[1];

  var _useState6 = (0, _react.useState)({
    left: 0,
    top: 0
  }),
      popoverOffset = _useState6[0],
      setPopoverOffset = _useState6[1]; // ID (to count number of open layers)


  var id = (0, _react.useRef)((0, _uniqueId["default"])());

  var clearTimers = function clearTimers() {
    clearTimeout(animateOutTimer.current);
    cancelAnimationFrame(animateStartTimer.current);
  };

  var show = function show() {
    clearTimers();
    animateStartTimer.current = requestAnimationFrame(function () {
      setVisible(true);
    });
  };

  var hide = function hide() {
    animateOutTimer.current = setTimeout(function () {
      setVisible(false);
    }, 500);
  };

  var shouldShow = isVisible && isOpen;
  anchoredTo = (0, _index2.responsiveValueCurrent)(anchoredTo) || "window";
  var isAnchored = anchoredTo && anchoredTo !== "window";
  var currentPlacement = (0, _index2.responsiveValueCurrent)(placement);
  var current = {
    isAnchored: isAnchored,
    anchoredTo: anchoredTo,
    placement: currentPlacement,
    width: typeof width === "function" ? width({
      anchorRect: anchoredTo.current && anchoredTo.current.getBoundingClientRect() || {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        right: 0,
        left: 0,
        top: 0,
        bottom: 0
      }
    }) : width || "auto",
    height: typeof height === "function" ? height({
      anchorRect: anchoredTo.current && anchoredTo.current.getBoundingClientRect() || {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        right: 0,
        left: 0,
        top: 0,
        bottom: 0
      }
    }) : height || "auto",
    minWidth: minWidth || 0,
    minHeight: minHeight || 0,
    maxWidth: maxWidth || "10000px",
    maxHeight: maxHeight || "10000px",
    animationTime: animationTime || 0.3,
    animationEase: animationEase || "cubic-bezier(0.19, 1, 0.22, 1)",
    backgroundColor: backgroundColor || "rgba(0,0,0,0.3)",
    shouldShow: shouldShow
  }; // Following 2 useEffects are responsible for counting open non-anchored layers

  (0, _react.useEffect)(function () {
    var body = document.querySelector("body");
    var scrollbarWidth = getScrollbarWidth();

    if (isOpen === true) {
      layerAdded(!current.isAnchored);
    } else {
      layerRemoved(!current.isAnchored);
    }

    if (isOpen && window.__cui_layerCounter.all === 1) {
      body.style["padding-right"] = scrollbarWidth + "px";
      body.style["overflow-y"] = "hidden";
    } else if (!isOpen && window.__cui_layerCounter.all == 0) {
      body.style.removeProperty("overflow-y");
      body.style.removeProperty("padding-right");
    }
  }, [isOpen]); // on route change!

  (0, _react.useEffect)(function () {
    var onRouteChange = function onRouteChange() {
      if (onClose) {
        onClose();
      }
    };

    if (!window.__cui_onRouteChange) {
      window.__cui_onRouteChange = [];
    }

    window.__cui_onRouteChange.push(onRouteChange);

    return function () {
      window.__cui_onRouteChange = window.__cui_onRouteChange.filter(function (x) {
        return x !== onRouteChange;
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!isOpen) {
      return;
    }

    layerChanged(!current.isAnchored);
  }, [current.isAnchored]);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      if (!current.isAnchored) {
        show();
      }
    } else {
      hide();
    }
  }, [isOpen]);
  useOnClickOutside([popperRef.current, arrowRef.current, anchoredTo.current], function () {
    if (!isOpen) {
      return;
    }

    if (current.isAnchored) {
      if (onClose) {
        onClose();
      }
    }
  });
  (0, _react.useEffect)(function () {
    setMounted(true);
  });

  if (!isMounted) {
    return null;
  }

  if (!current.isAnchored) {
    if (!isOpen && !isVisible) {
      return null;
    }

    var styles;

    switch (currentPlacement) {
      case "left":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          height: "100%",
          axis: "X",
          fromStart: true
        }));
        break;

      case "right":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          height: "100%",
          axis: "X",
          fromStart: false
        }));
        break;

      case "top":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          width: "100%",
          axis: "Y",
          fromStart: true
        }));
        break;

      case "bottom":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          width: "100%",
          axis: "Y",
          fromStart: false
        }));
        break;

      default:
        // "center"
        styles = centered(current);
    }

    return (0, _index2.jsx)(_index.Layer, {
      mountNode: mountNode()
    }, (0, _index2.jsx)(_Box["default"], {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      className: "__layer-window__"
    }, (0, _index2.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bg: "rgba(0,0,0,0.5)",
        zIndex: "-1"
      }, styles.background),
      onClick: onClose
    }), (0, _index2.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, styles.contentWrapper)
    }, (0, _index2.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: "inherit",
        minWidth: "inherit",
        maxHeight: "inherit",
        maxWidth: "inherit",
        overflowY: "auto"
      }, styles.content, root)
    }, typeof props.children === "function" ? props.children({
      anchored: current.isAnchored,
      close: function close() {
        if (onClose) {
          onClose();
        }
      }
    }) : props.children))));
  }

  if (!isOpen) {
    return null;
  }

  var onPopperUpdate = function onPopperUpdate(normalizedOffsets, data) {
    var placement = (0, _utils.fromPopperPlacement)(data.placement) || "top"; // this.setState({
    //     arrowOffset: normalizedOffsets.arrow,
    //     popoverOffset: normalizedOffsets.popper,
    //     placement
    // });

    setPopoverOffset(normalizedOffsets.popper);
    setPopoverPlacement(placement);
    setArrowOffset(normalizedOffsets.arrowOffset); // Now that element has been positioned, we can animate it in
    // this.animateInTimer = setTimeout(this.animateIn, ANIMATE_IN_TIME);

    show();
    return data;
  };

  var getSharedProps = function getSharedProps() {
    return {
      showArrow: false,
      arrowOffset: arrowOffset,
      popoverOffset: popoverOffset,
      placement: popoverPlacement,
      isVisible: isVisible,
      isOpen: isOpen,
      anchorWidth: anchoredTo.current && anchoredTo.current.clientWidth
    };
  };

  var renderPopover = function renderPopover() {
    // UPDATED CODE:
    var state = (0, _objectSpread2["default"])({}, getSharedProps(), {
      anchored: !!current.isAnchored,
      close: function close() {
        if (onClose) {
          onClose();
        }
      }
    }); // const children = <Box sx={{...container}}>{
    //     typeof props.children === "function"
    //         ? props.children(state)
    //         : props.children
    // }</Box>;

    var children = typeof props.children === "function" ? props.children(state) : props.children; // const bodyProps = this.getPopoverBodyProps();

    var popoverRootSpec = (0, _index2.getElementSpec)(root, popoverRootDefault, (0, _objectSpread2["default"])({}, state, {
      width: current.width,
      height: current.height,
      minWidth: current.minWidth,
      maxWidth: current.maxWidth,
      minHeight: current.minHeight,
      maxHeight: current.maxHeight,
      children: children
    }));
    var popoverRoot = (0, _index2.createElement)(popoverRootSpec, {
      ref: popperRef // ...bodyProps

    });
    return popoverRoot;
  }; // onMount and onUnmount are necessary to create rerender. Rerender makes popperRef to become not-null and TetherBehaviour depends on that


  return (0, _index2.jsx)(_index.Layer, {
    mountNode: mountNode(),
    onMount: function onMount() {
      return setLayerMounted(true);
    },
    onUnmount: function onUnmount() {
      return setLayerMounted(false);
    }
  }, (0, _index2.jsx)(_index.TetherBehavior, {
    anchorRef: anchoredTo.current,
    arrowRef: arrowRef.current,
    popperRef: popperRef.current // Remove the `ignoreBoundary` prop in the next major version
    // and have it replaced with the TetherBehavior props overrides
    ,
    popperOptions: {
      modifiers: {
        preventOverflow: {
          enabled: !props.ignoreBoundary
        }
      }
    },
    onPopperUpdate: onPopperUpdate,
    placement: currentPlacement || "bottomLeft"
  }, renderPopover()));
}

function useOnClickOutside(nodes, callback) {
  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(evt) {
      var target = evt.target;

      for (var i in nodes) {
        var node = nodes[i];

        if (!node) {
          continue;
        }

        if (node === target || node.contains(target)) {
          return;
        }
      }

      if (callback) {
        callback(evt);
      }
    };

    document.addEventListener("mousedown", onDocumentClick);
    return function () {
      document.removeEventListener("mousedown", onDocumentClick);
    };
  });
}

function getLayout(children, header, footer, onLinkClick) {
  var containerSx = {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
    maxWidth: "inherit",
    maxHeight: "inherit",
    minWidth: "inherit",
    minHeight: "inherit"
  };
  return (0, _index2.jsx)(_Box["default"], {
    sx: containerSx,
    onClick: function onClick(e) {
      if (e.target && e.target.tagName === "A") {
        onLinkClick();
      }
    }
  }, header && (0, _index2.jsx)(_Box["default"], {
    sx: {
      flex: "0 0 auto"
    }
  }, header), (0, _index2.jsx)(_Box["default"], {
    sx: {
      flex: "1 1 auto",
      overflow: "auto"
    }
  }, children), footer && (0, _index2.jsx)(_Box["default"], {
    sx: {
      flex: "0 0 auto"
    }
  }, footer));
} // Temporary wrapper around layer solving 2 tasks: header, footer and focus lock


function LayerWithHeaderAndFooter(props) {
  var children = props.children,
      header = props.header,
      footer = props.footer,
      container = props.container,
      _props$focusLock = props.focusLock,
      focusLock = _props$focusLock === void 0 ? false : _props$focusLock,
      _props$hideOnLinkClic = props.hideOnLinkClick,
      hideOnLinkClick = _props$hideOnLinkClic === void 0 ? false : _props$hideOnLinkClic,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "header", "footer", "container", "focusLock", "hideOnLinkClick"]);

  var _useState7 = (0, _react.useState)(true),
      focusLockDisabled = _useState7[0],
      setFocusLockDisabled = _useState7[1]; // We must enabled focus lock AFTER its mounted. For popups its mounted top: 0, left: 0 in the first place and then its position changes. Focus too early and you'll cause unwanted "scroll to top" effect.


  (0, _react.useEffect)(function () {
    if (props.isOpen) {
      setTimeout(function () {
        setFocusLockDisabled(false);
      }, 0);
    } else {
      setFocusLockDisabled(true);
    }
  }, [props.isOpen]);

  var content = function content(params) {
    return getLayout((0, _index2.jsx)(_Box["default"], {
      sx: container
    }, typeof children === "function" ? children(params) : children), typeof header === "function" ? header(params) : header, typeof footer === "function" ? footer(params) : footer, function () {
      if (hideOnLinkClick) {
        params.close();
      }
    });
  };

  var output;

  if (focusLock) {
    output = function output(params) {
      return (0, _index2.jsx)(_reactFocusLock["default"], {
        returnFocus: true,
        lockProps: {
          style: {
            width: "100%",
            height: "100%",
            maxWidth: "inherit",
            maxHeight: "inherit",
            minWidth: "inherit",
            minHeight: "inherit"
          },
          role: "dialog"
        },
        disabled: focusLockDisabled
      }, content(params));
    };
  } else {
    output = function output(params) {
      return content(params);
    };
  }

  return (0, _index2.jsx)(Layer$, restProps, output);
} // Layer with Button


function Layer$$(_ref4) {
  var button = _ref4.button,
      layerProps = (0, _objectWithoutProperties2["default"])(_ref4, ["button"]);
  var _layerProps$anchoredT = layerProps.anchoredTo,
      anchoredTo = _layerProps$anchoredT === void 0 ? "button" : _layerProps$anchoredT,
      _layerProps$closeOnEs = layerProps.closeOnEsc,
      closeOnEsc = _layerProps$closeOnEs === void 0 ? true : _layerProps$closeOnEs,
      _onClose = layerProps.onClose,
      restProps = (0, _objectWithoutProperties2["default"])(layerProps, ["anchoredTo", "closeOnEsc", "onClose"]);

  var _useState8 = (0, _react.useState)(false),
      isOpen = _useState8[0],
      setOpen = _useState8[1];

  var buttonRef = (0, _react.useRef)(null); // TODO: Make this not only array

  if ((0, _isArray["default"])(anchoredTo)) {
    anchoredTo = anchoredTo.map(function (x) {
      return x === "button" ? buttonRef : x;
    });
  } else {
    anchoredTo = anchoredTo === "button" ? buttonRef : anchoredTo;
  }

  (0, _react.useEffect)(function () {
    var onDocumentKeyPress = function onDocumentKeyPress(evt) {
      if (!closeOnEsc) {
        return;
      }

      if (evt.key !== "Escape") {
        return;
      } // Ignore events that have been `event.preventDefault()` marked.


      if (event.defaultPrevented) {
        return;
      }

      setOpen(false);

      if (_onClose) {
        _onClose({
          type: "esc"
        });
      }
    };

    document.addEventListener("keyup", onDocumentKeyPress);
    return function () {
      document.removeEventListener("keyup", onDocumentKeyPress);
    };
  });

  if (!button) {
    return (0, _index2.jsx)(LayerWithHeaderAndFooter, (0, _extends2["default"])({}, layerProps, {
      onClose: _onClose
    }));
  }

  return _react["default"].cloneElement(button, {
    onClick: function onClick() {
      setOpen(true);
    },
    buttonRef: buttonRef,
    selected: isOpen,
    __portals__: (0, _index2.jsx)(LayerWithHeaderAndFooter, (0, _extends2["default"])({}, restProps, {
      anchoredTo: anchoredTo,
      isOpen: isOpen,
      onClose: function onClose() {
        setOpen(false);

        if (_onClose) {
          _onClose();
        }
      }
    }))
  });
}

var _default = Layer$$;
exports["default"] = _default;

/***/ }),

/***/ 88244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;
var resetStyles = {
  color: "inherit",
  textDecoration: "none",
  boxSizing: "border-box"
};

function LinkRaw_(props) {
  var sx = props.sx,
      innerRef = props.innerRef,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "innerRef"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return __jsx(_Box["default"], (0, _extends2["default"])({}, restProps, {
    _ref: innerRef,
    as: "a",
    sx: [resetStyles, css]
  }));
}

var LinkRaw$ = _react["default"].forwardRef(function (props, ref) {
  return __jsx(LinkRaw_, (0, _extends2["default"])({}, props, {
    innerRef: ref
  }));
});

var _default = LinkRaw$;
exports["default"] = _default;

/***/ }),

/***/ 48413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _assign = _interopRequireDefault(__webpack_require__(53570));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(24677));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _entries = _interopRequireDefault(__webpack_require__(78541));

var _values = _interopRequireDefault(__webpack_require__(99850));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _reactDom = _interopRequireDefault(__webpack_require__(44661));

var _Theme = __webpack_require__(86522);

var _ShowHide = _interopRequireDefault(__webpack_require__(2500));

var _Grid = _interopRequireDefault(__webpack_require__(98290));

var _index = __webpack_require__(79329);

var __jsx = _react["default"].createElement;
var useLayoutEffect = typeof window === "object" ? _react.useLayoutEffect : _react.useEffect;

var MenuLayoutContext = _react["default"].createContext({});

var MenuBar = function MenuBar(_ref) {
  var open = _ref.open,
      takesSpace = _ref.takesSpace,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["open", "takesSpace"]);
  return __jsx(_Box["default"], props);
};

function MenuBarSticky(_ref2) {
  var _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? true : _ref2$open,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["open"]);

  var _useState = (0, _react.useState)("auto"),
      height = _useState[0],
      setHeight = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var ref = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(MenuLayoutContext);
  var container = document.getElementById("__sticky__");
  (0, _react.useEffect)(function () {
    var onScrollListener = function onScrollListener() {
      var rect = ref.current.getBoundingClientRect();
      var menuBottomY = document.getElementById("__menubottom__").getBoundingClientRect().top;
      var stickyBarY = document.getElementById("__sticky__").getBoundingClientRect().top;
      /**
       * IMPORTANT!
       *
       * There's assymetry here. Depending on open / not open state of bar, we differently pick the moment it becomes sticky. if not opened it becomes sticky "behind the curtains" (when totally covered by menu). If opened, then standard sticky.
       */

      if (!sticky) {
        if (open) {
          // if sticky and open
          if (rect.top < menuBottomY) {
            setHeight(rect.height);
            setSticky(true);
          }
        } else {
          // if sticky but NOT open, let it flow behind menu (like it's normally in body content) and THEN fix.
          if (rect.bottom < menuBottomY) {
            setHeight(rect.height);
            setSticky(true);
          }
        }
      } else {
        if (rect.top >= stickyBarY) {
          setHeight("auto");
          setSticky(false);
        }
      }
    };

    window.addEventListener("scroll", onScrollListener, {
      passive: true
    });
    return function () {
      window.removeEventListener("scroll", onScrollListener);
    };
  }, [sticky, open]);
  (0, _react.useEffect)(function () {
    context.setStickyOpen(open);
  }, [open]);
  var isDisplayedInPortal = sticky && container;
  var state = {
    stuck: isDisplayedInPortal
  };
  var children = typeof props.children === "function" ? props.children(state) : props.children;
  return __jsx(_Box["default"], {
    _ref: ref,
    sx: {
      height: height
    }
  }, isDisplayedInPortal && _reactDom["default"].createPortal(children, container), !isDisplayedInPortal && children);
}

function MenuLayout(props) {
  var _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      contentAbove = props.contentAbove;
  var children = [];
  var fixedBars = [];

  var _useState3 = (0, _react.useState)(true),
      stickyOpen = _useState3[0],
      _setStickyOpen = _useState3[1];

  _react["default"].Children.forEach(props.children, function (child) {
    if (child && child.type === MenuBar) {
      fixedBars.push(child);
    } else {
      children.push(child);
    }
  });

  fixedBars.push(__jsx(MenuBar, {
    id: "__sticky__",
    open: stickyOpen,
    takesSpace: false
  }));
  return __jsx(MenuLayoutContext.Provider, {
    value: {
      setStickyOpen: function setStickyOpen(open) {
        _setStickyOpen(open);
      }
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 200
    }
  }, contentAbove), __jsx(_Box["default"], {
    sx: {
      position: "sticky",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 100
    },
    id: "__menubarsticky__"
  }, __jsx(MenuBarsContainer, {
    bars: fixedBars
  })), __jsx(_Box["default"], {
    sx: {
      pt: offset,
      position: "relative",
      zIndex: 0
    }
  }, children)));
}

MenuLayout.MenuBar = MenuBar;
MenuLayout.MenuBarSticky = MenuBarSticky;
var _default = MenuLayout;
exports["default"] = _default;

var isBarOpen = function isBarOpen(bar) {
  var open = bar.props.open;

  if (typeof open === "undefined") {
    open = true;
  } else {
    open = !!open;
  }

  return open;
};
/**
 * Version with recursion and with ShowHide
 */


var MenuBarsContainer = function MenuBarsContainer(_ref3) {
  var bars = _ref3.bars,
      _ref3$previousBarTake = _ref3.previousBarTakesSpace,
      previousBarTakesSpace = _ref3$previousBarTake === void 0 ? true : _ref3$previousBarTake;
  var theme = (0, _Theme.useTheme)();

  if (!bars || bars.length === 0) {
    return __jsx(_Box["default"], {
      id: "__menubottom__",
      sx: {
        position: "relative"
      }
    }, __jsx(_Box["default"], {
      sx: {
        position: "absolute",
        top: "notificationSystemOffset",
        left: "notificationSystemOffset",
        width: theme.space.notificationSystemWidth,
        display: ["none", null, "block"]
      }
    }, __jsx(_Grid["default"], {
      cols: 1,
      gap: "notificationSystemSeparator",
      id: "__notifications-menu-topLeft__"
    })), __jsx(_Box["default"], {
      sx: {
        position: "absolute",
        top: "notificationSystemOffset",
        right: "notificationSystemOffset",
        width: theme.space.notificationSystemWidth,
        display: ["none", null, "block"]
      }
    }, __jsx(_Grid["default"], {
      cols: 1,
      gap: "notificationSystemSeparator",
      id: "__notifications-menu-topRight__"
    })), __jsx(_Box["default"], {
      sx: {
        position: "absolute",
        top: "notificationSystemOffset",
        right: "notificationSystemOffset",
        left: "notificationSystemOffset",
        display: ["block", null, "none"]
      }
    }, __jsx(_Grid["default"], {
      cols: 1,
      gap: "notificationSystemSeparator",
      id: "__notifications-menu-topMobile__"
    })));
  }

  var bar = bars[0];
  var open = isBarOpen(bar);
  var takesSpace = !!bar.props.takesSpace && previousBarTakesSpace;
  return __jsx(_Box["default"], {
    sx: {
      position: takesSpace ? "relative" : "absolute",
      top: takesSpace ? 0 : "100%",
      width: "100%",
      zIndex: -1
    }
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread3["default"])({
      position: "relative",
      zIndex: 0,
      width: "100%"
    }, takesSpace ? {} : {
      transform: !open ? "translateY(-100%)" : "none",
      transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"
    }),
    className: "__menubar__"
  }, __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: -1,
      width: "100%",
      height: "100%",
      // VERY IMPORTANT!!!! Makes entire container overflow: hidden so that flying content doesn't create horizontal scroll.
      pointerEvents: "none",
      // VERY IMPORTANT!!!!
      display: "flex",
      justifyContent: "center",
      opacity: 0
    },
    className: "__menubarshade__"
  }), __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 0,
      width: "100%",
      // height: "100vh", // VERY IMPORTANT!!!! Makes entire container overflow: hidden so that flying content doesn't create horizontal scroll.
      // overflow: "hidden",
      pointerEvents: "none",
      // VERY IMPORTANT!!!!
      display: "flex",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      pointerEvents: "auto"
    },
    className: "__menulayerstop__"
  })), __jsx(_Box["default"], {
    className: "__menubarcontent__",
    sx: {
      width: "100%"
    }
  }, takesSpace && __jsx(_ShowHide["default"], {
    isOpen: open,
    stickToBottom: true
  }, bar), !takesSpace && bar), __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 1,
      width: "100%",
      // height: "100vh", // VERY IMPORTANT!!!! Makes entire container overflow: hidden so that flying content doesn't create horizontal scroll.
      // overflow: "hidden",
      pointerEvents: "none",
      // VERY IMPORTANT!!!!
      display: "flex",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      pointerEvents: "auto",
      width: "100%"
    },
    className: "__menulayers__"
  })), __jsx(MenuBarsContainer, {
    bars: bars.slice(1),
    previousBarTakesSpace: takesSpace
  })));
};
/**
 * Version with recursion + margin-top
 */
// const MenuBarsContainer = ({ bars, isPreviousOpen = true }) => {
//   if (!bars || bars.length === 0) {
//     return <Box id={"__menubottom__"} />;
//   }
//
//   const bar = bars[0];
//   const open = isBarOpen(bar);
//
//   return (
//     <Box sx={{ position: "relative" }}>
//       <Box
//         sx={{
//           transform: !open ? "translateY(-100%)" : "none",
//           transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"
//         }}
//       >
//         {bar}
//         <Box
//           sx={{
//             position: "absolute",
//             top: "100%",
//             width: "100%",
//             zIndex: -1
//           }}
//         >
//           <MenuBarsContainer bars={bars.slice(1)} />
//         </Box>
//       </Box>
//     </Box>
//   );
// };

/**
 * Version without recursion with margin-top
 */
// const MenuBarsContainer = ({bars}) => {
//     return (
//         <Box sx={{position: "relative"}}>
//             {bars.map((bar, index) => {
//
//                 const open = isBarOpen(bar);
//                 console.log('open', open);
//
//                 return <Box sx={{
//                     position: "relative",
//                     zIndex: 100 - index,
//                 }}>
//                     <Box sx={{
//                         // transform: !open ? "translateY(-100%)" : 0,
//                         marginTop: !open ? "-100%" : 0,
//                         transition: "all .35s cubic-bezier(0.19, 1, 0.22, 1)"
//                     }}>
//                     {bar}
//                     </Box>
//                 </Box>
//             })}
//             <Box id={"__menubottom__"}/>
//         </Box>
//     );
// };

/**
 * Version without recursion and with ShowHide
 */
// const MenuBarsContainer = ({bars}) => {
//     return (
//         <Box sx={{position: "relative"}}>
//             {bars.map((bar, index) => {
//
//                 const open = isBarOpen(bar);
//
//                 return <Box sx={{
//                     position: "relative",
//                       transform: !open ? "translateY(-100%)" : "none",
//                       transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)",
//                     zIndex: 100 - index
//
//                 }}>
//                     <ShowHide isOpen={/*open*/true} sx={{zIndex: 100 - index}} stickToBottom={true}>
//                         {bar}
//                     </ShowHide>
//                 </Box>
//             })}
//             <Box id={"__menubottom__"}/>
//         </Box>
//     );
// };

/**
 * Version with recursion + translate only
 */
// const MenuBarsContainer = ({ bars, isPreviousOpen = true }) => {
//   if (!bars || bars.length === 0) {
//     return <Box id={"__menubottom__"} />;
//   }
//
//   const bar = bars[0];
//   const open = isBarOpen(bar);
//
//   return (
//     <Box sx={{ position: "relative" }}>
//       <Box
//         sx={{
//           transform: !open ? "translateY(-100%)" : "none",
//           transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"
//         }}
//       >
//         {bar}
//         <Box
//           sx={{
//             position: "absolute",
//             top: "100%",
//             width: "100%",
//             zIndex: -1
//           }}
//         >
//           <MenuBarsContainer bars={bars.slice(1)} />
//         </Box>
//       </Box>
//     </Box>
//   );
//
//   /**
//    * Below prototype is responsible for being able to hide 2 bars at the same time without harmonica effect.
//    *
//    * This has couple of problems:
//    * 1. Sometimes it's not animated (because of jumping from absolute to relative animation doest fire
//    * 2. If C is animating under B and then suddenly B becomes hidden too how do we do it without jank?
//    * 3. Also what happens during resizing of bars?
//    *
//    *
//    */
//   // const open = isBarOpen(bar);
//   // const nextBarOpen = bars.length > 1 && isBarOpen(bars[1]);
//   //
//   // return <Box sx={{position: "relative"}}>
//   //     <Box sx={{transform: !open && isPreviousOpen ? "translateY(-100%)" : "none", transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"}}>
//   //         { bar }
//   //         <Box sx={{
//   //             position: !open && !nextBarOpen ? "relative" : "absolute",
//   //             top: !open && !nextBarOpen ? 0 : "100%",
//   //             width: "100%",
//   //             zIndex: -1}}>
//   //             <MenuBarsContainer bars={bars.slice(1)} isPreviousOpen={open} />
//   //         </Box>
//   //     </Box>
//   // </Box>
// };
//
// function useLayer(props) {
//     let {
//         open,
//         anchoredTo = "window",
//         animationTime = 1000,
//         openOnHover = true,
//         onMount,
//         onMount2
//     } = props;
//
//     const [anchorRect, setAnchorRect] = useState(null);
//     const [isDisplayed, setDisplayed] = useState(false);
//     const [internalOpen, setInternalOpen] = useState(false);
//
//     const buttonRef = useRef(null);
//
//     // TODO: make it possible to steer Layer from hook AND from button. For now, with Layer+button we have only "uncontrolled state". Most frequently used!
//     if (button) {
//         button = React.cloneElement(button, {
//             onClick: () => {
//                 if (openOnHover) {
//                     setInternalOpen(true);
//                 } else {
//                     setInternalOpen(!internalOpen);
//                 }
//             },
//             onMouseEnter: () => {
//                 if (!openOnHover) {
//                     return;
//                 }
//
//                 setInternalOpen(true);
//             },
//             onMouseOut: () => {
//                 if (!openOnHover) {
//                     return;
//                 }
//
//                 setInternalOpen(false);
//             },
//             _ref: buttonRef
//         });
//
//         anchoredTo = buttonRef;
//
//         const [debouncedOpen] = useDebounce(internalOpen, 100);
//         open = debouncedOpen;
//     }
//
//     const ref = useRef(null);
//     const timeout = useRef(null);
//
//     useLayoutEffect(
//         () => {
//             clearTimeout(timeout.current);
//
//             if (open) {
//                 if (onMount) { onMount(ref.current.getBoundingClientRect())}
//
//                 window.getComputedStyle(ref.current).opacity; // recalculate styles
//
//                 if (onMount2) { onMount(ref.current.getBoundingClientRect())}
//
//                 setDisplayed(true);
//
//             } else {
//                 timeout.current = setTimeout(() => {
//                     setDisplayed(false);
//                 }, animationTime);
//             }
//         },
//         [open]
//     );
//
// }

/**
 * For now only uncontrolled (button + layer)
 */


var defaultBackgroundOverlay = {
  color: "black",
  opacity: 0.5,
  animationTime: 0.3,
  animationEase: "linear"
};

function useDialogs(_ref4) {
  var items = _ref4.items,
      _ref4$openOnHover = _ref4.openOnHover,
      openOnHover = _ref4$openOnHover === void 0 ? true : _ref4$openOnHover,
      _ref4$backgroundStyle = _ref4.backgroundStyles,
      backgroundStyles = _ref4$backgroundStyle === void 0 ? function (_ref5) {
    var isVisible = _ref5.isVisible;
    return {
      opacity: isVisible ? 1 : 0
    };
  } : _ref4$backgroundStyle,
      _ref4$animationTimeou = _ref4.animationTimeout,
      animationTimeout = _ref4$animationTimeou === void 0 ? 0 : _ref4$animationTimeou,
      onChange = _ref4.onChange,
      _ref4$positionedRelat = _ref4.positionedRelativeToTop,
      positionedRelativeToTop = _ref4$positionedRelat === void 0 ? false : _ref4$positionedRelat,
      _ref4$backgroundOverl = _ref4.backgroundOverlay,
      backgroundOverlay = _ref4$backgroundOverl === void 0 ? null : _ref4$backgroundOverl;
  var layers = items; // let buttons = [];
  // let buttonRefs = useRef(layers.map(_ => React.createRef()));

  var _useState4 = (0, _react.useState)(false),
      mounted = _useState4[0],
      setMounted = _useState4[1];

  var initState = {};
  layers.forEach(function (layer, index) {
    initState[(layer.key || index).toString()] = {
      active: false,
      visible: false,
      buttonRef: _react["default"].createRef(),
      layer: layer
    };
  });
  var anchorRects = (0, _react.useRef)({}); // we cache anchor rects for now, not to call getBoundingClientRect every render

  var containerRef = (0, _react.useRef)(null);
  var backgroundRef = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(initState),
      state = _useState5[0],
      setState = _useState5[1];

  var _useState6 = (0, _react.useState)(false),
      isSwitchingState = _useState6[0],
      setSwitchingState = _useState6[1];

  var timer = (0, _react.useRef)(null);
  var buttons = [];
  var contents = [];
  var hideTimers = (0, _react.useRef)({});
  var isAtInitState = !(0, _values["default"])(state).reduce(function (acc, val) {
    return acc || val.visible;
  }, false); // init state means that all layers are fully closed (not closing).

  var isAnyActive = (0, _values["default"])(state).reduce(function (acc, val) {
    return acc || val.active;
  }, false); // init state means that all layers are fully closed (not closing).

  var activeKey = null;
  (0, _entries["default"])(state).forEach(function (_ref6) {
    var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
        key = _ref7[0],
        val = _ref7[1];

    if (val.active) {
      activeKey = key;
    }
  });
  var cachedNodes = (0, _react.useRef)(null);

  if (mounted && !cachedNodes.current) {
    var menuBar = (0, _values["default"])(state)[0].buttonRef.current.closest(".__menubar__");
    cachedNodes.current = {
      content: menuBar.querySelector(".__menubarcontent__"),
      portal: menuBar.querySelector(positionedRelativeToTop ? ".__menulayerstop__" : ".__menulayers__"),
      // TODO: could be done better
      shade: menuBar.querySelector(".__menubarshade__")
    };
  }

  var getPosition = function getPosition(key) {
    if (key === null) {
      return;
    }

    var _state$key$layer = state[key].layer,
        _state$key$layer$offs = _state$key$layer.offsetX,
        offsetX = _state$key$layer$offs === void 0 ? 0 : _state$key$layer$offs,
        _state$key$layer$offs2 = _state$key$layer.offsetY,
        offsetY = _state$key$layer$offs2 === void 0 ? 0 : _state$key$layer$offs2,
        width = _state$key$layer.width,
        anchoredTo = _state$key$layer.anchoredTo,
        _state$key$layer$posX = _state$key$layer.posX,
        posX = _state$key$layer$posX === void 0 ? "left" : _state$key$layer$posX;

    if (!anchorRects.current[key]) {
      anchorRects.current[key] = state[key].buttonRef.current.getBoundingClientRect();
    }

    var anchorRect = anchorRects.current[key];
    var position = {};

    if (anchoredTo === "window") {
      switch (posX) {
        case "center":
          position.center = true;
          break;

        case "left":
          position.left = offsetX;
          position.right = "auto";
          break;

        case "right":
          position.left = "auto";
          position.right = offsetX;
          break;
      }
    } else {
      switch (posX) {
        case "center": // todo: center

        case "right":
          position.left = "auto";
          position.right = offsetX + (window.innerWidth - anchorRect.right);
          break;

        case "left-outside":
          position.left = "auto";
          position.right = offsetX + (window.innerWidth - anchorRect.left);
          break;

        case "right-outside":
          position.left = offsetX + anchorRect.right;
          position.right = "auto";
          break;

        case "left":
          position.left = offsetX + anchorRect.left;
          position.right = "auto";
      }
    }

    position.top = offsetY;
    position.width = width;
    position.anchoredTo = anchoredTo;
    return position;
  }; // 0 -> at init state
  // 1 -> invisible
  // 2 -> visible


  var applyBackgroundStyles = function applyBackgroundStyles(_ref8) {
    var isVisible = _ref8.isVisible,
        width = _ref8.width,
        height = _ref8.height,
        _ref8$noTransition = _ref8.noTransition,
        noTransition = _ref8$noTransition === void 0 ? false : _ref8$noTransition;
    var bs = backgroundStyles({
      isVisible: isVisible
    }); // Defaults

    backgroundRef.current.style.width = "100%";
    backgroundRef.current.style.height = "100%";
    backgroundRef.current.style.transition = "all .35s cubic-bezier(0.19, 1, 0.22, 1)";

    for (var x in bs) {
      backgroundRef.current.style[x] = bs[x];
    }

    if (width) {
      backgroundRef.current.style.width = width;
    }

    if (height) {
      backgroundRef.current.style.height = height;
    }

    if (noTransition) {
      backgroundRef.current.style.transition = "none";
    }
  };

  var switchLayer = function switchLayer(key) {
    if (key === activeKey) {
      return;
    }

    if (isAtInitState) {
      // if coming from empty, we set init state for animation
      // applyBackgroundStyles({
      //   isVisible: false,
      //   noTransition: true
      // });
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = "100%";
      //
      // const bs = backgroundStyles({ isVisible: true });
      // for (let x in bs) {
      //     backgroundRef.current.style[x] = bs[x];
      // }
      //
      // backgroundRef.current.style.transition = "none";
      var pos = getPosition(key); // containerRef.current.style.left = `${pos.left}px`;
      // containerRef.current.style.right = `${pos.right}px`;
      // containerRef.current.style.top = `${pos.top}px`;
      // containerRef.current.style.transition = "none";
    } else {} // const backgroundRect = backgroundRef.current.getBoundingClientRect();
      // applyBackgroundStyles({
      //             //     transition: "none",
      //             //     isVisible: true,
      //             //     width: backgroundRect.width + "px",
      //             //     height: backgroundRect.height + "px"
      //             // });
      // backgroundRef.current.style.width = backgroundRect.width + "px";
      // backgroundRef.current.style.height = backgroundRect.height + "px";
      // backgroundRef.current.style.transition = "none";

      /**
       * relative means that this menu TAKES SPACE (position: relative)
       */


    setState(function (prevState) {
      var newState = (0, _objectSpread3["default"])({}, prevState);

      for (var k in newState) {
        if (k === key) {
          clearTimeout(hideTimers.current[k]);
          newState[k].active = true;
          newState[k].visible = true; // visible might be not active (when hiding animation in progress).
        } else {
          if (k === activeKey && activeKey !== null) {
            // timeout for previous key
            hideTimers.current[activeKey] = setTimeout(function () {
              var count = 0;

              for (var _k in state) {
                if (state[_k].visible) {
                  count++;
                }
              }

              setState(function (currentState) {
                var newState = (0, _objectSpread3["default"])({}, currentState, (0, _defineProperty2["default"])({}, activeKey, (0, _objectSpread3["default"])({}, currentState[activeKey], {
                  visible: false
                })));
                return newState;
              });
            }, animationTimeout);
          }

          newState[k].active = false;
        }
      }

      return newState;
    });
    setSwitchingState(true);

    if (onChange) {
      onChange({
        oldKey: activeKey,
        newKey: key
      });
    }
  };

  useLayoutEffect(function () {
    if (!isSwitchingState) {
      return;
    }

    var _ = window.getComputedStyle(backgroundRef.current).height; // force recalculate styles

    if (isAnyActive) {
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = "100%";
      // backgroundRef.current.style.opacity = 1;
      // backgroundRef.current.style.transition =
      //     "all .35s cubic-bezier(0.19, 1, 0.22, 1)";
      var containerRect = containerRef.current.getBoundingClientRect(); // applyBackgroundStyles({
      //   isVisible: true,
      //   width: containerRect.width + "px", //"100%",
      //   height: containerRect.height + "px" //"100%"
      // });

      var pos = getPosition(activeKey); // containerRef.current.style.left = `${pos.left}px`;
      // containerRef.current.style.right = `${pos.right}px`;
      // containerRef.current.style.top = `${pos.top}px`;
      //
      // // containerRef.current.style.left = `${50 * index}px`;
      // containerRef.current.style.transition =
      //   "all .35s cubic-bezier(0.19, 1, 0.22, 1)";

      if (backgroundOverlay) {
        var config = (0, _assign["default"])(defaultBackgroundOverlay, backgroundOverlay);
        cachedNodes.current.shade.style.transition = "opacity ".concat(config.animationTime, "s ").concat(config.animationEase);
        cachedNodes.current.shade.style.backgroundColor = "black";
        cachedNodes.current.shade.style.opacity = config.opacity;
      }
    } else {
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = 0;
      // backgroundRef.current.style.opacity = 0;
      // backgroundRef.current.style.transition =
      //     "all .35s cubic-bezier(0.19, 1, 0.22, 1)";
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = "100%";
      // backgroundRef.current.style.transition = "all 2s linear";// cubic-bezier(0.19, 1, 0.22, 1)";
      // applyBackgroundStyles({
      //   isVisible: false
      // });
      cachedNodes.current.shade.style.opacity = 0; // const bs = backgroundStyles({ isVisible: false });
      // for (let x in bs) {
      //     backgroundRef.current.style[x] = bs[x];
      // }
      //
      //
      // timer.current = setTimeout(() => {
      //   // all relative flags must go down to false (which means that isAtInitState will light up).
      //
      //   let newState = {
      //     ...state
      //   };
      //
      //   for (let k in newState) {
      //     newState[k].relative = false;
      //   }
      //
      //   setState(newState);
      // }, 350);
    }

    setSwitchingState(false); // setContent(
    //     content.map(item =>
    //         item.active
    //             ? { ...item, isVisible: true }
    //             : { ...item, isVisible: false }
    //     )
    // );
    // setStatus(0);
  }, [isSwitchingState]);
  var hoverTimer = (0, _react.useRef)(null);

  var onHover = function onHover(key) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    clearTimeout(hoverTimer.current);

    if (timeout <= 0) {
      switchLayer(key);
    } else {
      hoverTimer.current = setTimeout(function () {
        switchLayer(key);
      }, timeout);
    }
  }; // on menu hover!!!


  (0, _react.useEffect)(function () {
    if (!mounted) {
      return;
    }

    if (!positionedRelativeToTop) {
      return;
    }

    var onMouseOver = function onMouseOver() {// onHover(activeKey);
    };

    var onMouseOut = function onMouseOut() {// onHover(null);
    };

    cachedNodes.current.content.addEventListener("mouseover", onMouseOver);
    cachedNodes.current.content.addEventListener("mouseout", onMouseOut);
    return function () {
      cachedNodes.current.content.removeEventListener("mouseover", onMouseOver);
      cachedNodes.current.content.removeEventListener("mouseover", onMouseOut);
    };
  }, [mounted, activeKey]); // on route change!

  (0, _react.useEffect)(function () {
    var onRouteChange = function onRouteChange() {
      onHover(null, 0);
    };

    if (!window.__cui_onRouteChange) {
      window.__cui_onRouteChange = [];
    }

    window.__cui_onRouteChange.push(onRouteChange);

    return function () {
      window.__cui_onRouteChange = window.__cui_onRouteChange.filter(function (x) {
        return x !== onRouteChange;
      });
    };
  }, [activeKey]);
  layers.forEach(function (layer, index) {
    var key = (layer.key || index).toString();
    var isActive = state[key].active;
    var visible = state[key].visible;

    var button = _react["default"].cloneElement(layer.button, {
      onClick: function onClick() {
        if (openOnHover) {
          onHover(key, 0);
        } else {
          onHover(activeKey === key ? null : key, 0);
        }
      },
      onMouseEnter: function onMouseEnter() {
        if (!openOnHover) {
          return;
        }

        onHover(key, 100);
      },
      onMouseLeave: function onMouseLeave() {
        if (!openOnHover) {
          return;
        }

        onHover(null, 100);
      },
      _ref: state[key].buttonRef,
      selected: isActive,
      key: "button-" + key
    });

    if (mounted) {
      var content = typeof layer.content === "function" ? layer.content({
        isVisible: isActive && !isSwitchingState
      }) : layer.content;
      var pos = getPosition(key) || {};
      contents.push(__jsx(_Box["default"], {
        sx: {
          position: "absolute",
          // isActive || (activeKey === null && visible)
          //   ? "relative"
          //   : "absolute",
          top: pos.top,
          left: pos.left,
          right: pos.right,
          width: pos.width,
          // left: 0,
          zIndex: isActive ? 1 : 0,
          pointerEvents: isActive ? "auto" : "none",
          opacity: visible ? 1 : 0 // left: position.left,
          // right: position.right,
          // top: offsetY,
          // width: "max-content"
          // width: "max-content",
          // width: "100%"
          // width

        },
        onMouseEnter: function onMouseEnter() {
          if (!openOnHover) {
            return;
          }

          onHover(key);
        },
        onMouseLeave: function onMouseLeave() {
          if (!openOnHover) {
            return;
          }

          onHover(null);
        },
        key: "portal-" + key
      }, content));
    }

    buttons.push(button);
  });
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);

  var portal = mounted && _reactDom["default"].createPortal(__jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      pointerEvents: isAnyActive ? "auto" : "none",
      width: "100%"
    },
    key: "portal",
    _ref: containerRef
  }, __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      transformOrigin: "0 0",
      zIndex: -1,
      width: "100%" // bg: "white",
      // boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)"

    },
    _ref: backgroundRef
  }), contents), cachedNodes.current.portal);

  buttons[0] = _react["default"].cloneElement(buttons[0], {
    __portals__: portal
  });
  return {
    buttons: buttons,
    hide: function hide() {
      switchLayer(null);
    },
    isOpen: isAnyActive
  };
}

function Dialog(props) {
  var button = props.button,
      children = props.children,
      openOnHover = props.openOnHover,
      backgroundStyles = props.backgroundStyles,
      animationTimeout = props.animationTimeout,
      hideOnLinkClick = props.hideOnLinkClick,
      positionedRelativeToTop = props.positionedRelativeToTop,
      onChange = props.onChange;

  var _useDialogs = useDialogs({
    items: [(0, _objectSpread3["default"])({
      button: button,
      content: children
    }, props)],
    openOnHover: openOnHover,
    backgroundStyles: backgroundStyles,
    animationTimeout: animationTimeout,
    positionedRelativeToTop: positionedRelativeToTop,
    onChange: onChange
  }),
      buttons = _useDialogs.buttons,
      layers = _useDialogs.layers;

  return buttons[0];
}

MenuLayout.Dialog = Dialog;
MenuLayout.useDialogs = useDialogs;

/***/ }),

/***/ 77603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getNotificationOffset = getNotificationOffset;
exports.NotificationSystemProvider = NotificationSystemProvider;
exports.useNotificationSystem = useNotificationSystem;

var _map = _interopRequireDefault(__webpack_require__(31764));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _reactDom = _interopRequireDefault(__webpack_require__(44661));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _index = __webpack_require__(79329);

var _useWindowSize = _interopRequireDefault(__webpack_require__(47272));

var _uniqueId = _interopRequireDefault(__webpack_require__(68646));

var __jsx = _react["default"].createElement;

var NotificationsContext = _react["default"].createContext({}); // TODO: make alerts visually-hidden instead of removing from DOM
// TODO: make it possible to show notification into ref
// notificationSystemOffset
// notificationSystemOffsetX notificationSystemOffsetY, notificationSystemMenuOffsetY notificationSystemMenuOffsetX


function getNotificationOffset(theme) {
  var s = theme.space;
  var top = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var bottom = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var topMenu = {
    x: s.notificationSystemOffsetMenuX || s.notificationSystemOffsetMenu || s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetMenuY || s.notificationSystemOffsetMenu || s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  return {
    top: top,
    bottom: bottom,
    topMenu: topMenu
  }; // if (placement === "topLeft") {
  //   topLeft.push(content);
  //   topMobile.push(content);
  // } else if (placement === "topRight") {
  //   topRight.push(content);
  //   topMobile.push(content);
  // } else if (placement === "bottomLeft") {
  //   bottomLeft.push(content);
  //   bottomMobile.push(content);
  // } else if (placement === "bottomRight") {
  //
  //
  // }
}

function NotificationSystemProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  var _useResponsiveHelpers = (0, _index.useResponsiveHelpers)(),
      currentValue = _useResponsiveHelpers.currentValue;

  var _useState2 = (0, _react.useState)([]),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isLayerOpen = _useState3[0],
      setLayerOpen = _useState3[1];

  var _close = function close(notification) {
    setNotifications(function (notifications) {
      return notifications.filter(function (x) {
        return x.id !== notification.id;
      });
    });
  };

  (0, _react.useEffect)(function () {
    window.window.__cui_notificationSystemSetLayerOpen = function (isOpen) {
      // We do it this way so that Layer doesn't have to import MenuLayout if not needed (code split!)
      setLayerOpen(isOpen);
    };
  }, []);

  var show = function show(config) {
    var id = config.id || (0, _uniqueId["default"])();
    var index = notifications.findIndex(function (x) {
      return x.id === id;
    });

    if (index > -1) {
      clearTimeout(notifications[index].timeout);
    }

    var newNotification = (0, _objectSpread2["default"])({}, config, {
      id: id
    });

    if (typeof config.timeout === "number" && config.timeout > 0) {
      newNotification.timeout = setTimeout(function () {
        _close(newNotification);
      }, config.timeout);
    }

    var newNotifications = (0, _toConsumableArray2["default"])(notifications);

    if (index > -1) {
      newNotifications[index] = newNotification;
    } else {
      newNotifications.push(newNotification);
    }

    setNotifications(newNotifications);
  };

  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);

  var _ = (0, _useWindowSize["default"])(); // unused but rerenders on resize


  var portals;

  if (mounted) {
    var topLeft = [];
    var topRight = [];
    var topMobile = [];
    var topLeftMenu = [];
    var topRightMenu = [];
    var topMobileMenu = [];
    var bottomLeft = [];
    var bottomRight = [];
    var bottomMobile = [];
    var refs = new _map["default"]();
    notifications.forEach(function (notification) {
      var placement = currentValue(notification.placement); // TODO: this function can't use hook!!!

      var content = typeof notification.content === "function" ? notification.content({
        close: function close() {
          _close(notification);
        }
      }) : notification.content; // TODO: accessibility!!

      content = __jsx(_Box["default"], {
        sx: {
          display: "contents"
        },
        role: "alert",
        key: notification.id
      }, content);

      if (typeof placement === "string") {
        // Menu placement is replaced by standard placement when dialogs are open
        if (placement === "topLeftMenu" && isLayerOpen) {
          placement = "topLeft";
        } else if (placement === "topRightMenu" && isLayerOpen) {
          placement = "topRight";
        }

        if (placement === "topLeft") {
          topLeft.push(content);
          topMobile.push(content);
        } else if (placement === "topRight") {
          topRight.push(content);
          topMobile.push(content);
        } else if (placement === "bottomLeft") {
          bottomLeft.push(content);
          bottomMobile.push(content);
        } else if (placement === "bottomRight") {
          bottomRight.push(content);
          bottomMobile.push(content);
        } else if (placement === "topLeftMenu") {
          topLeftMenu.push(content);
          topMobileMenu.push(content);
        } else if (placement === "topRightMenu") {
          topRightMenu.push(content);
          topMobileMenu.push(content);
        } else {
          throw new Error("unknown position " + placement + " for notification");
        }
      } else {
        if (!placement.current) {
          throw new Error("placement for notification can be either string with position (topLeft, topRight, etc...) or ref");
        }

        if (refs.has(placement.current)) {
          refs.set(placement.current, [].concat((0, _toConsumableArray2["default"])(refs.get(placement.current)), [content]));
        } else {
          refs.set(placement.current, [content]);
        }
      }
    });
    portals = [// ReactDOM.createPortal(
    //   topLeft,
    //   document.getElementById(
    //     isLayerOpen
    //       ? "__notifications-topLeft__"
    //       : "__notifications-menu-topLeft__"
    //   ) || document.getElementById("__notifications-topLeft__") // if there's no menu we must default
    // ),
    // ReactDOM.createPortal(
    //   topRight,
    //   document.getElementById(
    //     isLayerOpen
    //       ? "__notifications-topRight__"
    //       : "__notifications-menu-topRight__"
    //   ) || document.getElementById("__notifications-topRight__")
    // ),
    // ReactDOM.createPortal(
    //   topMobile,
    //   document.getElementById(
    //     isLayerOpen
    //       ? "__notifications-topMobile__"
    //       : "__notifications-menu-topMobile__"
    //   ) || document.getElementById("__notifications-topMobile__")
    // ),
    _reactDom["default"].createPortal(topLeftMenu, document.getElementById("__notifications-menu-topLeft__") || document.getElementById("__notifications-topLeft__")), _reactDom["default"].createPortal(topRightMenu, document.getElementById("__notifications-menu-topRight__") || document.getElementById("__notifications-topRight__")), _reactDom["default"].createPortal(topMobileMenu, document.getElementById("__notifications-menu-topMobile__") || document.getElementById("__notifications-topMobile__")), _reactDom["default"].createPortal(topLeft, document.getElementById("__notifications-topLeft__")), _reactDom["default"].createPortal(topRight, document.getElementById("__notifications-topRight__")), _reactDom["default"].createPortal(topMobile, document.getElementById("__notifications-topMobile__")), _reactDom["default"].createPortal(bottomLeft, document.getElementById("__notifications-bottomLeft__")), _reactDom["default"].createPortal(bottomRight, document.getElementById("__notifications-bottomRight__")), _reactDom["default"].createPortal(bottomMobile, document.getElementById("__notifications-bottomMobile__"))];
    refs.forEach(function (value, keyRef) {
      portals.push(_reactDom["default"].createPortal(value, keyRef));
    });
  }

  return __jsx(NotificationsContext.Provider, {
    value: {
      show: show
    }
  }, children, portals);
} // export function Notifications


function useNotificationSystem() {
  return (0, _react.useContext)(NotificationsContext);
}

/***/ }),

/***/ 34345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useQuantityPicker = useQuantityPicker;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _parseInt2 = _interopRequireDefault(__webpack_require__(57919));

var _objectDestructuringEmpty2 = _interopRequireDefault(__webpack_require__(89811));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));

var _InputRaw = _interopRequireDefault(__webpack_require__(38164));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _SelectNative = _interopRequireDefault(__webpack_require__(20912));

var __jsx = _react["default"].createElement;
var useLayoutEffect = typeof window === "object" ? _react.useLayoutEffect : _react.useEffect;
var defaults = {
  $buttonDecrease: {
    __type: _ButtonRaw["default"],
    __children: "-"
  },
  $buttonIncrease: {
    __type: _ButtonRaw["default"],
    __children: "+"
  },
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      position: "relative",
      display: "inline-flex",
      verticalAlign: "top",
      overflow: "hidden",
      flexDirection: "row"
    };
  },
  $input: function $input(_ref2) {
    (0, _objectDestructuringEmpty2["default"])(_ref2);
    return {
      __type: _InputRaw["default"],
      textAlign: "center"
    };
  },
  $select: function $select() {
    return {
      __type: _SelectNative["default"],
      __props: {
        allowEmpty: false
      }
    };
  }
};

function useQuantityPicker() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      defaultValue = props.defaultValue,
      _props$maxValue = props.maxValue,
      maxValue = _props$maxValue === void 0 ? 999 : _props$maxValue,
      _props$selectOptionsA = props.selectOptionsAmount,
      selectOptionsAmount = _props$selectOptionsA === void 0 ? 19 : _props$selectOptionsA,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(defaultValue || step),
      amount = _useState[0],
      setAmount = _useState[1];

  var _useState2 = (0, _react.useState)(defaultValue || step),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      inputFocusedAfterSelectingMore = _useState3[0],
      setInputFocusedAfterSelectingMore = _useState3[1];

  var inputRef = (0, _react.useRef)(null);

  var setValue = function setValue(number) {
    var newVal = number;

    if (isNaN(newVal)) {
      newVal = 0;
    }

    newVal = Math.max(newVal, step);
    newVal = Math.min(newVal, maxValue); // Check if multiple of step

    var rest = newVal % step;

    if (rest != 0) {
      newVal = newVal - rest;
    }

    setAmount(newVal);
    setInputValue(newVal);

    if (newVal !== amount && onChange) {
      onChange(newVal);
    }
  };

  var isMin = amount === step;
  var isMax = amount === maxValue - maxValue % step;
  var buttonIncrementProps = {
    onClick: function onClick() {
      setValue(amount + step);
    },
    disabled: isMax
  };
  var buttonDecrementProps = {
    onClick: function onClick() {
      setValue(amount - step);
    },
    disabled: isMin
  };
  var inputProps = {
    value: inputValue,
    onChange: function onChange(val) {
      setInputValue(val);
    },
    onBlur: function onBlur() {
      setValue((0, _parseInt2["default"])(inputValue));
      setInputFocusedAfterSelectingMore(false);
    },
    inputRef: inputRef
  };
  useLayoutEffect(function () {
    if (inputFocusedAfterSelectingMore) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }); // select

  var selectOptions = [];

  for (var i = 1; i <= selectOptionsAmount; i++) {
    selectOptions.push("".concat(i * step));
  }

  var maxSelectAmount = selectOptionsAmount * step;
  var moreOption = "".concat(maxSelectAmount + step, "+");
  selectOptions.push(moreOption);
  var exceedsSelectRange = amount > maxSelectAmount || inputFocusedAfterSelectingMore;
  var selectProps = {
    options: selectOptions,
    value: exceedsSelectRange ? moreOption : "".concat(amount),
    onChange: function onChange(val) {
      if (val === moreOption) {
        setInputValue("");
        setInputFocusedAfterSelectingMore(true); // inputRef.current.focus();
      } else {
        setValue((0, _parseInt2["default"])(val));
      }
    },
    label: "Quantity",
    placeholder: "Quantity"
  };
  var ret = {
    // inputFocusedAfterSelectingMore,
    exceedsSelectRange: exceedsSelectRange,
    buttonIncrementProps: buttonIncrementProps,
    buttonDecrementProps: buttonDecrementProps,
    inputProps: inputProps,
    selectProps: selectProps,
    amount: amount,
    isMax: isMax,
    isMin: isMin,
    setAmount: setValue,
    reset: function reset() {
      setValue(-1);
    }
  };
  return (0, _objectSpread2["default"])({}, ret, {
    counterProps: {
      controller: ret
    }
  });
}

function QuantityPicker$(props) {
  var _props$sx = props.sx,
      sx = _props$sx === void 0 ? {} : _props$sx;
  var controller;

  if (props.controller) {
    controller = props.controller;
  } else {
    controller = useQuantityPicker(props);
  }

  var _useState4 = (0, _react.useState)(false),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var state = {
    focused: focused
  };
  sx = typeof sx === "function" ? sx(state) : sx;

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var rootCss = typeof customSx.$root === "function" ? customSx.$root(state) : customSx.$root;

  var onFocus = function onFocus(e) {
    setFocused(true);
  };

  var onBlur = function onBlur(e) {
    setFocused(false);
  };

  var buttonDecrease;
  var buttonIncrease;

  if (customSx.$buttonDecrease !== null) {
    buttonDecrease = (0, _.createElement)((0, _.getElementSpec)(customSx.$buttonDecrease, defaults.$buttonDecrease, state, (0, _objectSpread2["default"])({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonDecrementProps), "-"));
  }

  if (customSx.$buttonIncrease !== null) {
    buttonIncrease = (0, _.createElement)((0, _.getElementSpec)(customSx.$buttonIncrease, defaults.$buttonIncrease, state, (0, _objectSpread2["default"])({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonIncrementProps), "+"));
  }

  var input = (0, _.createElement)((0, _.getElementSpec)(customSx.$input, defaults.$input, state), (0, _objectSpread2["default"])({
    type: "number",
    onFocus: onFocus,
    onBlur: onBlur
  }, controller.inputProps));
  var select = (0, _.createElement)((0, _.getElementSpec)(customSx.$select, defaults.$select, state), (0, _objectSpread2["default"])({
    onFocus: onFocus,
    onBlur: onBlur
  }, controller.selectProps));
  return (0, _.jsx)(_Box["default"], {
    sx: css
  }, (0, _.jsx)(_Box["default"], {
    sx: [{
      display: "flex",
      flexDirection: "row"
    }, defaults.$root(state), rootCss]
  }, buttonDecrease, controller.exceedsSelectRange && input, !controller.exceedsSelectRange && select, buttonIncrease));
}

var _default = QuantityPicker$;
exports["default"] = _default;

/***/ }),

/***/ 4644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var __jsx = _react["default"].createElement;

/**
 * Input Raw
 */
var resetStyles = {
  opacity: 0,
  width: 0,
  position: "absolute",
  overflow: "hidden",
  margin: 0,
  padding: 0
};

function RadioRaw_(props) {
  var sx = props.sx,
      inputRef = props.inputRef,
      type = props.type,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "inputRef", "type"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return (0, _.jsx)("input", (0, _extends2["default"])({
    sx: [resetStyles, css]
  }, restProps, {
    type: "radio",
    ref: inputRef
  }));
}

var _default = RadioRaw_;
exports["default"] = _default;

/***/ }),

/***/ 11790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(__webpack_require__(1266));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Theme = __webpack_require__(86522);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _Grid = _interopRequireDefault(__webpack_require__(98290));

var _core = __webpack_require__(98464);

var _GridDebugger = _interopRequireDefault(__webpack_require__(74707));

var _NotificationSystem = __webpack_require__(77603);

var __jsx = _react["default"].createElement;

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            position: absolute;\n            z-index: 10001;\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            position: absolute;\n            top: 0;\n            left: 0;\n            z-index: 10000;\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            position: relative;\n            z-index: 0;\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            body.ReactModal__Body--open {\n              overflow-y: hidden;\n            }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = function _default(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var offset = (0, _NotificationSystem.getNotificationOffset)(theme);
  return (0, _core.jsx)(_Theme.ThemeProvider, {
    theme: theme
  }, (0, _core.jsx)(_NotificationSystem.NotificationSystemProvider, null, (0, _core.jsx)(_GridDebugger["default"], null), (0, _core.jsx)(_core.Global, {
    styles: (0, _core.css)(_templateObject())
  }), (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject2()),
    id: "__app__"
  }, children), (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject3()),
    id: "__layers__"
  }), (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject4()),
    id: "__notifications__"
  }, (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      top: offset.top.y,
      left: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-topLeft__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      top: offset.top.y,
      right: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-topRight__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      top: offset.top.y,
      right: offset.top.x,
      left: offset.top.x,
      display: ["block", null, "none"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-topMobile__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: offset.top.y,
      left: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-bottomLeft__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: offset.top.y,
      right: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-bottomRight__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: offset.top.y,
      right: offset.top.x,
      left: offset.top.x,
      display: ["block", null, "none"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-bottomMobile__"
  })))));
};

exports["default"] = _default;

/***/ }),

/***/ 26282:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useSearch = useSearch;
exports.SearchInline = SearchInline;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

function useSearch(props) {
  var _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? "" : _props$defaultValue,
      onChange = props.onChange,
      _props$debounceTime = props.debounceTime,
      debounceTime = _props$debounceTime === void 0 ? 300 : _props$debounceTime,
      _props$closeOnSubmit = props.closeOnSubmit,
      closeOnSubmit = _props$closeOnSubmit === void 0 ? true : _props$closeOnSubmit,
      _props$blurOnSubmit = props.blurOnSubmit,
      blurOnSubmit = _props$blurOnSubmit === void 0 ? true : _props$blurOnSubmit,
      _onSubmit = props.onSubmit;

  var _useState = (0, _react.useState)(defaultValue),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var inputRef = (0, _react.useRef)(null);

  var _useState2 = (0, _react.useState)(false),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var debounceTimeout = (0, _react.useRef)(null);

  var changeValue = function changeValue(val) {
    clearTimeout(debounceTimeout.current);

    if (val === "") {
      // no debounce for empty
      if (onChange) {
        onChange(val);
      }
    } else {
      debounceTimeout.current = setTimeout(function () {
        if (onChange) {
          onChange(val);
        }
      }, debounceTime);
    }

    setOpen(true);
  };

  var inputProps = {
    value: inputValue,
    onChange: function onChange(val) {
      setInputValue(val);
      changeValue(val);
    },
    label: "Search",
    controlRef: inputRef,
    type: "search",
    onFocus: function onFocus() {
      setOpen(true);
    }
  };

  var close = function close() {
    setOpen(false);
  };

  var formProps = {
    as: "form",
    action: "",
    onSubmit: function onSubmit(e) {
      if (closeOnSubmit) {
        close();
      }

      if (blurOnSubmit) {
        inputRef.current.blur();
      }

      e.preventDefault();

      if (_onSubmit) {
        _onSubmit(inputValue);
      }
    }
  };
  var resultsProps = {
    "aria-hidden": true
  };
  var submitButtonProps = {
    type: "submit"
  };

  var clear = function clear() {
    setInputValue("");
  };

  return {
    inputProps: inputProps,
    close: close,
    clear: clear,
    formProps: formProps,
    resultsProps: resultsProps,
    submitButtonProps: submitButtonProps,
    isOpen: isOpen
  };
}

function Search(props) {
  var controller = props.controller;

  if (!controller) {
    controller = useSearch(props);
  }

  var input = props.input,
      layer = props.layer,
      children = props.children,
      _props$hideOnLinkClic = props.hideOnLinkClick,
      hideOnLinkClick = _props$hideOnLinkClic === void 0 ? true : _props$hideOnLinkClic;
  var _controller = controller,
      inputProps = _controller.inputProps,
      close = _controller.close,
      formProps = _controller.formProps,
      isOpen = _controller.isOpen;
  var anchorRef = (0, _react.useRef)(null);
  children = typeof children === "function" ? children({
    close: close
  }) : children;
  layer = _react["default"].cloneElement(layer, {
    isOpen: children && isOpen,
    anchoredTo: anchorRef,
    onClose: function onClose(params) {
      if (params && params.type === "esc") {// esc by default comes from "input type=search".
      } else {
        close();
      }
    },
    children: children
  });
  return __jsx(_Box["default"], {
    onClick: function onClick(e) {
      if (hideOnLinkClick && e.target && e.target.tagName === "A") {
        close();
      }
    }
  }, __jsx(_Box["default"], formProps, _react["default"].cloneElement(input, (0, _objectSpread2["default"])({}, inputProps, {
    _ref: anchorRef
  }))), layer);
} // function SearchDialog(props) {
//     let {
//         input,
//         layer,
//         children,
//         hideOnLinkClick = true
//     } = props;
//
//     const {inputProps, close, formProps, isOpen} = useSearch(props);
//
//     children = typeof children === "function" ? children({close}) : children;
//
//     layer = React.cloneElement(layer, {
//         isOpen: children && isOpen,
//         anchoredTo: inputProps.controlRef,
//         onClose: (params) => {
//             if (params && params.type === "esc") { // esc by default comes from "input type=search".
//
//             } else {
//                 close();
//             }
//         },
//         children
//     });
//
//     return (
//         <Box
//             onClick={e => {
//                 if (hideOnLinkClick && e.target && e.target.tagName === "A") {
//                     close();
//                 }
//             }}
//         >
//             <Box
//                 {...formProps}
//             >
//                 {React.cloneElement(input, inputProps)}
//             </Box>
//             {layer}
//         </Box>
//     );
// }


function SearchInline(props) {
  var input = props.input,
      inputContainer = props.inputContainer,
      searchForm = props.searchForm,
      children = props.children,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? "static" : _props$mode;

  var _useSearch = useSearch((0, _objectSpread2["default"])({}, props, {
    closeOnSubmit: false,
    blurOnSubmit: false
  })),
      inputProps = _useSearch.inputProps,
      submitButtonProps = _useSearch.submitButtonProps,
      resultsProps = _useSearch.resultsProps,
      close = _useSearch.close,
      formProps = _useSearch.formProps,
      isOpen = _useSearch.isOpen; // inline search doesn't have to blur because it's always fullscreen


  children = typeof children === "function" ? children({
    close: close
  }) : children;
  var inputContainerRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(0),
      offset = _useState3[0],
      setOffset = _useState3[1];

  (0, _react.useEffect)(function () {
    if (mode !== "static") {
      setOffset(inputContainerRef.current.getBoundingClientRect().height);
    }
  }, []);
  input = _react["default"].cloneElement(input, inputProps);
  var content;

  if (typeof inputContainer === "function") {
    content = inputContainer({
      input: input
    });
  } else {
    content = __jsx(_Box["default"], {
      sx: inputContainer
    }, input);
  } // searchForm overrides old mechanism


  if (searchForm) {
    content = searchForm({
      inputProps: inputProps,
      submitButtonProps: submitButtonProps
    });
  }

  return __jsx(_Box["default"], {
    sx: {
      position: "relative",
      height: "100%",
      width: "100%",
      minHeight: "inherit",
      maxHeight: "inherit",
      minWidth: "inherit",
      maxWidth: "inherit"
    }
  }, __jsx(_Box["default"], (0, _extends2["default"])({
    sx: {
      position: mode === "absolute" ? "absolute" : mode === "fixed" ? "fixed" : "relative",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 1
    }
  }, formProps, {
    ref: inputContainerRef
  }), content), children && isOpen && __jsx(_Box["default"], {
    sx: {
      position: "relative",
      height: "100%",
      width: "100%",
      minHeight: "inherit",
      maxHeight: "inherit",
      minWidth: "inherit",
      maxWidth: "inherit",
      paddingTop: offset,
      overflowY: "auto"
    }
  }, children));
}
/**8
 * TODO:
 * - tab sequence should go to the dialog and then to the input.
 * - SearchDialog (feature: automatic hiding of dialog when link inside is clicked -> actually this should be a feature of all dialogs).
 */


var _default = Search;
exports["default"] = _default;

/***/ }),

/***/ 71070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSelectableProps = getSelectableProps;
exports.getChildren = getChildren;
exports.useSelectInline = useSelectInline;
exports.SelectInline = SelectInline;
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _useSelectState = _interopRequireDefault(__webpack_require__(88829));

function getSelectableProps(controller, props) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var value = controller.value,
      options = controller.options,
      setValue = controller.setValue,
      multi = controller.multi,
      isSelected = controller.isSelected;
  var _config$allowUnselect = config.allowUnselect,
      allowUnselect = _config$allowUnselect === void 0 ? true : _config$allowUnselect; // this flag is important. In dropdown select even if we have allowEmpty=true, clicking on selected option doesn't unselect it. It does for SelectInline however.

  var selectableProps = options.map(function (option) {
    return {
      selected: isSelected(option),
      disabled: option.disabled,
      invalid: !!props.invalid,
      option: option,
      key: option.id,
      label: option.label,
      onClick: function onClick() {
        if (option.disabled) {
          return;
        }

        if (controller.isSelected(option)) {
          if (multi || props.allowEmpty !== false && allowUnselect) {
            controller.unselectValue(option);
          }
        } else {
          controller.selectValue(option);
        }
      }
    };
  });
  return selectableProps;
}

function getChildren(controller, props) {
  var children = props.children;

  try {
    var item;

    if (props.selectable) {
      item = props.selectable;
    } else {
      item = _react["default"].Children.only(children);
    }

    children = function children(_ref) {
      var selectableProps = _ref.selectableProps;
      return selectableProps.map(function (props) {
        return _react["default"].cloneElement(typeof item === "function" ? item({
          option: props.option
        }) : item, props);
      });
    };
  } catch (error) {}

  children = children(controller);
  return children;
}

function useSelectInline(props) {
  var controller = (0, _useSelectState["default"])(props);
  return (0, _objectSpread2["default"])({}, controller, {
    selectableProps: getSelectableProps(controller, props)
  });
}

function SelectInline(_ref2) {
  var controller = _ref2.controller,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["controller"]);

  if (!controller) {
    controller = useSelectInline(props);
  }

  return getChildren(controller, props);
} // TODO: accessibility


var _default = SelectInline;
exports["default"] = _default;

/***/ }),

/***/ 20912:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _InputContainer = _interopRequireDefault(__webpack_require__(53189));

var _SelectNativeRaw = _interopRequireDefault(__webpack_require__(94771));

var _useSelectState2 = _interopRequireDefault(__webpack_require__(88829));

var __jsx = _react["default"].createElement;

function SelectNative(props) {
  var _useSelectState = (0, _useSelectState2["default"])(props),
      setValue = _useSelectState.setValue,
      value = _useSelectState.value,
      valueObject = _useSelectState.valueObject,
      options = _useSelectState.options,
      empty = _useSelectState.empty;

  var _useSelectState$filte = _useSelectState2["default"].filterProps(props),
      _useSelectState$filte2 = _useSelectState$filte.placeholder,
      placeholder = _useSelectState$filte2 === void 0 ? "Select" : _useSelectState$filte2,
      _useSelectState$filte3 = _useSelectState$filte.allowEmpty,
      allowEmpty = _useSelectState$filte3 === void 0 ? true : _useSelectState$filte3,
      restProps = (0, _objectWithoutProperties2["default"])(_useSelectState$filte, ["placeholder", "allowEmpty"]);

  var optionElems = [];

  if (allowEmpty) {
    optionElems.push(__jsx("option", {
      disabled: true,
      value: "",
      key: "__default__"
    }, placeholder));
  }

  options.map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled;
    optionElems.push(__jsx("option", {
      value: id,
      key: id,
      disabled: disabled
    }, label));
  });
  var selectValue = valueObject ? valueObject.id : "";
  return __jsx(_InputContainer["default"], (0, _extends2["default"])({}, restProps, {
    empty: empty,
    label: props.label || props.placeholder,
    showArrow: "inline",
    cursor: "pointer"
  }), __jsx(_SelectNativeRaw["default"], {
    sx: {
      height: "100%",
      width: "100%",
      cursor: "pointer"
    },
    onChange: function onChange(e) {
      setValue(!e.target.value || e.target.value === "" ? null : e.target.value);
    },
    value: selectValue
  }, optionElems));
}

var _default = SelectNative;
exports["default"] = _default;

/***/ }),

/***/ 94771:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

/**
 * SelectNative Raw
 */
var inputResetStyles = {
  bg: "transparent",
  appearance: "none"
};

function SelectNativeRaw_(props) {
  var sx = props.sx,
      inputRef = props.inputRef,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "inputRef"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    as: "select",
    sx: [inputResetStyles, css]
  }, restProps, {
    ref: inputRef
  }));
}

var SelectNativeRaw = _react["default"].forwardRef(function (props, ref) {
  return (0, _.jsx)(SelectNativeRaw_, (0, _extends2["default"])({
    inputRef: ref
  }, props));
});

var _default = SelectNativeRaw;
exports["default"] = _default;

/***/ }),

/***/ 53910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));

var _RadioRaw = _interopRequireDefault(__webpack_require__(4644));

var __jsx = _react["default"].createElement;

function Selectable$(props) {
  var disabled = props.disabled,
      highlighted = props.highlighted,
      selected = props.selected,
      label = props.label,
      invalid = props.invalid,
      sx = props.sx,
      as = props.as,
      children = props.children,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      onSelect = props.onSelect,
      _props$ignoreLabel = props.ignoreLabel,
      ignoreLabel = _props$ignoreLabel === void 0 ? false : _props$ignoreLabel,
      id = props.id,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["disabled", "highlighted", "selected", "label", "invalid", "sx", "as", "children", "onFocus", "onBlur", "onSelect", "ignoreLabel", "id"]);

  var _useState = (0, _react.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  if (!label && ignoreLabel === false) {
    console.warn("You didn't pass label prop to the Selectable. This will affect accessibility negatively.");
  }

  var state = (0, _objectSpread2["default"])({}, props);
  var content = children(state);
  var radioRef = (0, _react.useRef)(null);

  if (as === "link") {
    return (0, _.jsx)(_LinkRaw["default"], (0, _extends2["default"])({
      title: label,
      sx: (0, _objectSpread2["default"])({
        $resetFocus: true,
        display: "block"
      }, css),
      onFocus: function onFocus(e) {
        setFocused(true);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);

        if (_onBlur) {
          _onBlur(e);
        }
      },
      id: id
    }, restProps), content);
  }

  if (as === "radio") {
    return (0, _.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        display: "block",
        position: "relative",
        cursor: "pointer"
      }, css),
      onClick: function onClick() {
        if (disabled) {
          return;
        }

        radioRef.current.focus();

        if (onSelect) {
          onSelect();
        }
      },
      className: focused ? "__commui_focus" : ""
    }, (0, _.jsx)("label", {
      htmlFor: id,
      sx: {
        visibility: "hidden",
        position: "absolute"
      }
    }, label), (0, _.jsx)(_RadioRaw["default"], (0, _extends2["default"])({}, restProps, {
      id: id,
      onFocus: function onFocus(e) {
        setFocused(true);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);

        if (_onBlur) {
          _onBlur(e);
        }
      },
      checked: selected,
      disabled: disabled,
      onChange: function onChange() {
        if (onSelect) {
          onSelect();
        }
      },
      inputRef: radioRef
    })), content);
  }

  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    sx: (0, _objectSpread2["default"])({
      display: "block",
      position: "relative",
      cursor: disabled ? "not-allowed" : "pointer"
    }, css)
  }, restProps), content);
}

var _default = Selectable$;
exports["default"] = _default;

/***/ }),

/***/ 2500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

var ShowHide = function ShowHide(props) {
  var isOpen = props.isOpen,
      _props$animated = props.animated,
      animated = _props$animated === void 0 ? true : _props$animated,
      _props$stickToBottom = props.stickToBottom,
      stickToBottom = _props$stickToBottom === void 0 ? false : _props$stickToBottom,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["isOpen", "animated", "stickToBottom"]);
  var containerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(isOpen === true ? null : 0),
      height = _useState[0],
      setHeight = _useState[1];

  (0, _react.useEffect)(function () {
    if (!animated) {
      return;
    }

    if (isOpen && height === 0) {
      setHeight(containerRef.current.clientHeight);
      setTimeout(function () {
        setHeight(null);
      }, 300);
    } else if (!props.isOpen && (height === null || height > 0)) {
      setHeight(containerRef.current.clientHeight);
      setTimeout(function () {
        setHeight(0);
      }, 50);
    }
  }, [isOpen]);

  if (!animated) {
    height = isOpen ? null : 0;
  }

  return __jsx(_Box["default"], restProps, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      transition: "height 0.35s cubic-bezier(0.19, 1, 0.22, 1)",
      overflow: "hidden",
      height: height === null ? "auto" : "".concat(height, "px"),
      width: "100%"
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: height === null ? "relative" : "absolute",
      width: "100%",
      bottom: stickToBottom ? 0 : "auto"
    },
    ref: containerRef
  }, props.children)));
};

var _default = ShowHide;
exports["default"] = _default;

/***/ }),

/***/ 25558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _core = __webpack_require__(98464);

var __jsx = _react["default"].createElement;
var animation = (0, _core.keyframes)({
  from: {
    transform: "rotate(360deg)"
  },
  to: {
    transform: "rotate(0deg)"
  }
});

var Spinner = function Spinner(_ref) {
  var _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      _ref$light = _ref.light,
      light = _ref$light === void 0 ? true : _ref$light;
  var color = sx.$color || "inherit";
  var color2 = sx.$color2 || "lightgrey";
  var width = sx.$width || 2;
  var styles = {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    textIndent: "-9999em",
    borderWidth: width,
    borderStyle: "solid",
    borderTopColor: color2,
    borderRightColor: color2,
    borderBottomColor: color2,
    borderLeftColor: color,
    transform: "translateZ(0)",
    animation: "".concat(animation, " 1s infinite linear"),
    overflow: "hidden"
  };
  return __jsx(_Box["default"], {
    sx: [{
      position: "relative",
      width: "24px"
    }, sx]
  }, __jsx(_Box["default"], {
    sx: {
      pb: "100%"
    }
  }, __jsx(_Box["default"], {
    sx: styles
  }, "Spin...")));
};

var _default = Spinner;
exports["default"] = _default;

/***/ }),

/***/ 86522:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _emotionTheming.useTheme;
  }
});

_Object$defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _emotionTheming.ThemeProvider;
  }
});

var _react = _interopRequireDefault(__webpack_require__(34885));

var _emotionTheming = __webpack_require__(96349);

/***/ }),

/***/ 56077:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TETHER_PLACEMENT = void 0;

/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var TETHER_PLACEMENT = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
};
exports.TETHER_PLACEMENT = TETHER_PLACEMENT;

/***/ }),

/***/ 19658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$keys = __webpack_require__(18396);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  LayersManager: true,
  Layer: true,
  TetherBehavior: true,
  TETHER_PLACEMENT: true
};

_Object$defineProperty(exports, "LayersManager", {
  enumerable: true,
  get: function get() {
    return _layersManager["default"];
  }
});

_Object$defineProperty(exports, "Layer", {
  enumerable: true,
  get: function get() {
    return _layer["default"];
  }
});

_Object$defineProperty(exports, "TetherBehavior", {
  enumerable: true,
  get: function get() {
    return _tether["default"];
  }
});

_Object$defineProperty(exports, "TETHER_PLACEMENT", {
  enumerable: true,
  get: function get() {
    return _constants.TETHER_PLACEMENT;
  }
});

var _layersManager = _interopRequireDefault(__webpack_require__(44635));

var _layer = _interopRequireDefault(__webpack_require__(27486));

var _tether = _interopRequireDefault(__webpack_require__(69317));

var _constants = __webpack_require__(56077);

var _types = __webpack_require__(51787);

_Object$keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

/***/ }),

/***/ 27486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Layer;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(79779));

var _createClass2 = _interopRequireDefault(__webpack_require__(8286));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80899));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(44034));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38099));

var _inherits2 = _interopRequireDefault(__webpack_require__(42071));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(24677));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _reactDom = _interopRequireDefault(__webpack_require__(44661));

var _layersManager = __webpack_require__(44635);

var __jsx = _react["default"].createElement;

var LayerComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LayerComponent, _React$Component);

  function LayerComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, LayerComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(LayerComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      container: null
    });
    return _this;
  }

  (0, _createClass2["default"])(LayerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          onMount = _this$props.onMount,
          mountNode = _this$props.mountNode;

      if (mountNode) {
        onMount && onMount();
        return;
      } // There was no LayersManager added if this.props.host === undefined.
      // Use document.body is the case no LayersManager is used.


      var host = this.props.host !== undefined ? this.props.host : document.body;

      if (host) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          host = _this$props2.host,
          mountNode = _this$props2.mountNode;

      if (mountNode) {
        return;
      }

      if (host && host !== prevProps.host && prevProps.host === null) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var container = this.state.container;
      var _this$props3 = this.props,
          host = _this$props3.host,
          onUnmount = _this$props3.onUnmount;
      onUnmount && onUnmount();
      host && container && host.contains(container) && host.removeChild(container);
    }
  }, {
    key: "addContainer",
    value: function addContainer(host) {
      var _this$props4 = this.props,
          index = _this$props4.index,
          mountNode = _this$props4.mountNode,
          onMount = _this$props4.onMount; // Do nothing if mountNode is provided

      if (mountNode) {
        return;
      }

      if (host) {
        var container = host.ownerDocument.createElement("div");
        var sibling = typeof index === "number" ? host.children[index] : null;
        sibling ? host.insertBefore(container, sibling) : host.appendChild(container);
        this.setState({
          container: container
        }, function () {
          onMount && onMount();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var container = this.state.container;
      var _this$props5 = this.props,
          children = _this$props5.children,
          mountNode = _this$props5.mountNode;

      if (__BROWSER__) {
        if (mountNode || container) {
          // $FlowFixMe
          return _reactDom["default"].createPortal(children, mountNode || container);
        }

        return null;
      }

      return null;
    }
  }]);
  return LayerComponent;
}(_react["default"].Component);

function Layer(props) {
  return __jsx(_layersManager.Consumer, null, function (_ref) {
    var host = _ref.host;
    return __jsx(LayerComponent, (0, _extends2["default"])({}, props, {
      host: host
    }));
  });
}

/***/ }),

/***/ 44635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Consumer = exports.Provider = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(79779));

var _createClass2 = _interopRequireDefault(__webpack_require__(8286));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80899));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(44034));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38099));

var _inherits2 = _interopRequireDefault(__webpack_require__(42071));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(24677));

var React = _interopRequireWildcard(__webpack_require__(34885));

var __jsx = React.createElement;

var _React$createContext = React.createContext({}),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

exports.Consumer = Consumer;
exports.Provider = Provider;

var LayersManager = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LayersManager, _React$Component);

  function LayersManager() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, LayersManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(LayersManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "host", React.createRef());
    return _this;
  }

  (0, _createClass2["default"])(LayersManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return __jsx(Provider, {
        value: {
          host: this.host.current
        }
      }, __jsx("div", null, this.props.children), __jsx("div", {
        ref: this.host
      }));
    }
  }]);
  return LayersManager;
}(React.Component);

exports["default"] = LayersManager;

/***/ }),

/***/ 69317:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(79779));

var _createClass2 = _interopRequireDefault(__webpack_require__(8286));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80899));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(44034));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38099));

var _inherits2 = _interopRequireDefault(__webpack_require__(42071));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(24677));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _popper = _interopRequireDefault(__webpack_require__(24842));

var _utils = __webpack_require__(75291);

var _constants = __webpack_require__(56077);

/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var Tether = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tether, _React$Component);

  function Tether() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Tether);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Tether)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "popperHeight", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      isMounted: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPopperUpdate", function (data) {
      var normalizedOffsets = {
        popper: (0, _utils.parsePopperOffset)(data.offsets.popper),
        arrow: data.offsets.arrow ? (0, _utils.parsePopperOffset)(data.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };

      _this.props.onPopperUpdate(normalizedOffsets, data);
    });
    return _this;
  }

  (0, _createClass2["default"])(Tether, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // console.log('TetherBehaviour: componentDidMount')
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Handles the case where popover content changes size and creates a gap between the anchor and
      // the popover. Popper.js only schedules updates on resize and scroll events. In the case of
      // the Select component, when options were filtered in the dropdown menu it creates a gap
      // between it and the input element.
      // console.log('TetherBehaviour: componentDidUpdate')
      //
      // console.log('has just mount?', this.state.isMounted !== prevState.isMounted, 'popper ref', this.props.popperRef);
      if (this.props.popperRef) {
        var _this$props$popperRef = this.props.popperRef.getBoundingClientRect(),
            height = _this$props$popperRef.height;

        if (this.popperHeight !== height) {
          this.popperHeight = height;
          this.popper && this.popper.scheduleUpdate();
        }

        if (this.state.isMounted !== prevState.isMounted) {
          if (!this.props.anchorRef) {
            if (__DEV__) {
              // eslint-disable-next-line no-console
              console.warn("[baseui][TetherBehavior] ref has not been passed to the Popper's anchor element.\n              See how to pass the ref to an anchor element in the Popover example\n              http://baseui.design/components/popover#anchor-ref-handling-example");
            }
          } else {
            this.initializePopper();
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function initializePopper() {
      var _this$props = this.props,
          placement = _this$props.placement,
          popperOptions = _this$props.popperOptions;
      var modifiers = popperOptions.modifiers,
          restOptions = (0, _objectWithoutProperties2["default"])(popperOptions, ["modifiers"]);
      this.popper = new _popper["default"](this.props.anchorRef, this.props.popperRef, (0, _objectSpread2["default"])({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: (0, _utils.toPopperPlacement)(placement),
        modifiers: (0, _objectSpread2["default"])({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: false
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: false
          },
          applyReactStyle: {
            enabled: true,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: true
          }
        }, modifiers)
      }, restOptions));
    }
  }, {
    key: "destroyPopover",
    value: function destroyPopover() {
      if (this.popper) {
        this.popper.destroy();
        delete this.popper;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // console.log('TetherBehaviour: render', this.props.children);
      return this.props.children || null;
    }
  }]);
  return Tether;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function onPopperUpdate() {
    return null;
  },
  placement: _constants.TETHER_PLACEMENT.auto,
  popperRef: null,
  popperOptions: {}
});
var _default = Tether;
exports["default"] = _default;

/***/ }),

/***/ 51787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var React = _interopRequireWildcard(__webpack_require__(34885));

var _constants = __webpack_require__(56077);

/***/ }),

/***/ 75291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.toPopperPlacement = toPopperPlacement;
exports.parsePopperOffset = parsePopperOffset;

/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function toPopperPlacement(placement) {
  return placement.replace(/(Top|Left)$/, "-start").replace(/(Right|Bottom)$/, "-end");
}
/**
 * Takes the offset passed from popper.js and normalizes it
 */


function parsePopperOffset(offset) {
  return {
    top: Math.floor(offset.top || 0),
    left: Math.floor(offset.left || 0)
  };
}

/***/ }),

/***/ 90714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ARROW_WIDTH = exports.ANIMATE_IN_TIME = exports.ANIMATE_OUT_TIME = exports.ARROW_SIZE = exports.POPOVER_MARGIN = exports.ACCESSIBILITY_TYPE = exports.STATE_CHANGE_TYPE = exports.TRIGGER_TYPE = exports.PLACEMENT = void 0;

/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var PLACEMENT = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
};
exports.PLACEMENT = PLACEMENT;
var TRIGGER_TYPE = {
  click: "click",
  hover: "hover"
};
exports.TRIGGER_TYPE = TRIGGER_TYPE;
var STATE_CHANGE_TYPE = {
  open: "open",
  close: "close"
};
exports.STATE_CHANGE_TYPE = STATE_CHANGE_TYPE;
var ACCESSIBILITY_TYPE = {
  none: "none",
  menu: "menu",
  tooltip: "tooltip"
};
exports.ACCESSIBILITY_TYPE = ACCESSIBILITY_TYPE;
var POPOVER_MARGIN = 8;
exports.POPOVER_MARGIN = POPOVER_MARGIN;
var ARROW_SIZE = 6;
exports.ARROW_SIZE = ARROW_SIZE;
var ANIMATE_OUT_TIME = 0;
exports.ANIMATE_OUT_TIME = ANIMATE_OUT_TIME;
var ANIMATE_IN_TIME = 20;
/**
 * Since we use a 45-degree rotated div to render the arrow, the
 * width/height of this div is different than the arrow size itself
 *
 * The arrow size is essentially half the diagonal of the rotated div,
 * using pythagorean theorem:
 *   width^2 + height^2 = (arrow_size * 2)^2
 * In this case width = height so:
 *   2 * width^2 = (arrow_size * 2)^2
 * Simplifies to:
 *   width = √((arrow_size * 2)^2 / 2)
 */

exports.ANIMATE_IN_TIME = ANIMATE_IN_TIME;
var ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));
exports.ARROW_WIDTH = ARROW_WIDTH;

/***/ }),

/***/ 19886:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getOppositePosition = getOppositePosition;
exports.isVerticalPosition = isVerticalPosition;
exports.capitalize = capitalize;
exports.fromPopperPlacement = fromPopperPlacement;
exports.splitPlacement = splitPlacement;
exports.getPopoverMarginStyles = getPopoverMarginStyles;
exports.getStartPosition = getStartPosition;
exports.getEndPosition = getEndPosition;
exports.getArrowPositionStyles = getArrowPositionStyles;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(24677));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _constants = __webpack_require__(90714);

/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */
var OPPOSITE_POSITIONS = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
/**
 * Returns the opposite of the specified position. Useful for tooltip
 * positioning logic.
 * Examples:
 * top -> bottom
 * left -> right
 */

function getOppositePosition(position) {
  return OPPOSITE_POSITIONS[position];
}
/**
 * Determines whether or not the specified position is a vertical one (top or bottom)
 */


function isVerticalPosition(position) {
  return position === "top" || position === "bottom";
}
/**
 * Simple utility function for capitalizing the first letter of a string
 */


function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Opposite of function above, converts from Popper.js placement
 * to our placement prop
 */


function fromPopperPlacement(placement) {
  var popoverPlacement = placement.replace(/(top|bottom)-start$/, "$1Left").replace(/(top|bottom)-end$/, "$1Right").replace(/(left|right)-start$/, "$1Top").replace(/(left|right)-end$/, "$1Bottom");
  return _constants.PLACEMENT[popoverPlacement] || null;
}
/**
 * Splits something like 'topLeft' to ['top', 'left'] for easier usage
 */


function splitPlacement(placement) {
  var matches = placement.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return matches.slice(1, 3).filter(Boolean).map(function (s) {
    return s.toLowerCase();
  });
}
/**
 * Returns margin styles to add spacing between the popover
 * and its anchor.
 *
 * We may eventually want to make margin a prop that can be overridden.
 */


function getPopoverMarginStyles(showArrow, placement) {
  var _splitPlacement = splitPlacement(placement),
      _splitPlacement2 = (0, _slicedToArray2["default"])(_splitPlacement, 1),
      position = _splitPlacement2[0];

  var opposite = getOppositePosition(position);

  if (!opposite) {
    return null;
  }

  var property = "margin".concat(capitalize(opposite));
  return (0, _defineProperty2["default"])({}, property, "".concat(showArrow ? _constants.ARROW_SIZE : _constants.POPOVER_MARGIN, "px"));
}
/**
 * Returns CSS rules for the popover animation start keyframe
 */


function getStartPosition(offset, placement, showArrow) {
  offset = (0, _objectSpread2["default"])({}, offset);

  var _splitPlacement3 = splitPlacement(placement),
      _splitPlacement4 = (0, _slicedToArray2["default"])(_splitPlacement3, 1),
      position = _splitPlacement4[0];

  var margin = (showArrow ? _constants.ARROW_SIZE : _constants.POPOVER_MARGIN) * 2;

  if (isVerticalPosition(position)) {
    offset.top += position === "top" ? margin : -margin;
  } else {
    offset.left += position === "left" ? margin : -margin;
  }

  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns CSS rules for the popover animation end keyframe
 */


function getEndPosition(offset) {
  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns top/left styles to position the popover arrow
 */


function getArrowPositionStyles(offsets, placement) {
  var _ref2;

  var _splitPlacement5 = splitPlacement(placement),
      _splitPlacement6 = (0, _slicedToArray2["default"])(_splitPlacement5, 1),
      position = _splitPlacement6[0];

  var oppositePosition = getOppositePosition(position);

  if (!oppositePosition) {
    return null;
  }

  var alignmentProperty = isVerticalPosition(position) ? "left" : "top";
  return _ref2 = {}, (0, _defineProperty2["default"])(_ref2, alignmentProperty, "".concat(offsets[alignmentProperty], "px")), (0, _defineProperty2["default"])(_ref2, oppositePosition, "-".concat(_constants.ARROW_SIZE - 2, "px")), _ref2;
}

/***/ }),

/***/ 40117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.css = exports.responsive = exports.get = void 0;

var _values = _interopRequireDefault(__webpack_require__(99850));

var _isArray = _interopRequireDefault(__webpack_require__(99228));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(24677));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(59415));

var _responsiveHelpers = __webpack_require__(96775);

/**
 * TODO: VERY IMPORTANT NOTES
 *
 * BEWARE!!! Fixing this file will take you longer than you think it will.
 *
 *
 * 1. This file is copied from styled-system which is not maintained and theme-ui has newest version
 * 2. Modifications in this file are:
 * a) font -> it's just custom variant actually, we could do PR for theme-ui for this.
 * b) linear spacings -> we should do them in array / object form with linearity done as "step functions". Arithmetic will be trivial to implement and we could add this as a PR to theme-ui.
 * c) make it possible to use [0, 0, "gridGap"] by using recursion. We could make it as a PR too.
 *
 * New version of theme-ui is constantly updated, for example it now has nested array styles, one thing that was missing here.
 *
 * Bugs in current version: there's only one level of recursion and no nested styles so:
 * mt: "gridGap"
 *
 * ... will work if this is on the top level:
 * 1. In first iteration it will be transformed into array.
 * 2. In second iteration array will be decoupled into values.
 *
 * Not sure if it work deeper.
 *
 * To sum up, we should sync with theme-ui and build PR for them.
 *
 */
// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split(".") : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};

exports.get = get;
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + "em";
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var scales = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== "number" || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === "string") return "-" + n;
  return n * -1;
};

var transforms = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function (acc, curr) {
  return (0, _objectSpread3["default"])({}, acc, (0, _defineProperty2["default"])({}, curr, positiveOrNegative));
}, {});

function isStylesObject(obj) {
  if (typeof obj !== "object") {
    return false;
  }

  if (obj.__isLinear) {
    return false;
  }

  if (typeof obj._ !== "undefined") {
    return false;
  }

  return true;
}

var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, "breakpoints", defaultBreakpoints);
    var mediaQueries = [null].concat((0, _toConsumableArray2["default"])(breakpoints.map(function (n) {
      return "@media screen and (min-width: ".concat(n, ")");
    }))); // MODIFICATION: let's add all media in a good order so that this order is kept later

    for (var k = 1; k < mediaQueries.length; k++) {
      next[mediaQueries[k]] = null;
    } // console.log('next', next);
    // mediaQueries.forEach(query => {
    //     if (query) {
    //         next[query] = {};
    //     }
    // });


    for (var key in styles) {
      var value = typeof styles[key] === "function" ? styles[key](theme) : styles[key]; // here we could get value from scales and transform it.

      if (value == null) continue;
      /** MODIFICATION 3, linear spacings **/

      if (typeof value === "object" && value.__isLinear) {
        var _css = (0, _responsiveHelpers.rslin)(theme.space[value.from] || value.from, theme.space[value.to] || value.to, value.isInf).cssObject(key);

        for (var media in _css) {
          next[media] = next[media] || {};
          next[media][key] = _css[media][key];
        }

        continue;
      }
      /** MODIFICATION 2, check if this is responsive object **/


      if (typeof value === "object" && typeof value._ !== "undefined") {
        for (var breakpoint in value) {
          if (breakpoint !== "_" && !breakpoints[breakpoint]) {
            throw new Error("Wrong breakpoint name in your rs styles: \"".concat(breakpoint, "\""));
          }

          var _media = "@media screen and (min-width: ".concat(breakpoints[breakpoint], ")");

          if (breakpoint === "_") {
            _media = undefined;
          }

          if (!_media) {
            next[key] = value[breakpoint];
            continue;
          }

          next[_media] = next[_media] || {};
          next[_media][key] = value[breakpoint];
        }

        continue;
      }

      if (!(0, _isArray["default"])(value)) {
        next[key] = value;
        /** MODIFICATION: it's required for cssSingle(cssSingle(...)) recursion to work. We don't want old media queries to override new ones. **/
        // if (isStylesObject(next[key])) {
        //     next[key] = {
        //         ...next[key],
        //         ...value
        //     };
        // } else {
        //     next[key] = value;
        // }

        continue;
      }
      /**
       * IF ARRAY
       */


      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var _media2 = mediaQueries[i];
        if (value[i] == null) continue;

        if (!_media2) {
          next[key] = value[i];
          continue;
        }

        next[_media2] = next[_media2] || {};
        next[_media2][key] = value[i];
      }
    } // MODIFICATION: let's clean up empty media queries


    for (var _key in next) {
      if (next[_key] === null) {
        delete next[_key];
      }
    }

    return next;
  };
};

exports.responsive = responsive;

function getValue(val, key, theme) {
  var prop = get(aliases, key, key);
  var scaleName = get(scales, prop);
  var scale = get(theme, scaleName, get(theme, prop, {}));
  var transform = get(transforms, prop, get);
  var value = transform(scale, val, val); // RESPONSIVE SIZE

  if (typeof value === "object" && value !== null && value.__isLinear) {
    var _css2 = (0, _responsiveHelpers.rslin)(theme.space[value.from] || value.from, theme.space[value.to] || value.to, value.isInf).cssObject("xxx");

    var css_ = (0, _values["default"])(_css2);
    var array = [];

    for (var i = 0; i < theme.breakpoints.length + 1; i++) {
      array[i] = null;

      if (i === 0) {
        array[i] = css_[0].xxx;
      } else if (i === theme.breakpoints.length) {
        array[i] = css_[2].xxx;
      } else {
        array[i] = css_[1].xxx;
      }
    }

    return array;
  }

  if (!(0, _isArray["default"])(value)) {
    // non-array values can easily pass
    return value;
  }

  var lastBreakpointArray; // null-padding of array shorter than num of breakpoints + 1 (this is required because [0, null, "containerMargin"] should actually affect 3th and 4th index

  for (var _i = value.length; _i < theme.breakpoints.length + 1; _i++) {
    value[_i] = null;
  }

  for (var _i2 = 0; _i2 < value.length; _i2++) {
    var breakpointVal = getValue(value[_i2], key, theme, _i2);

    if (breakpointVal === null || breakpointVal === undefined) {
      if (lastBreakpointArray) {
        value[_i2] = lastBreakpointArray[_i2];
      } else {
        value[_i2] = null;
      }
    } else if ((0, _isArray["default"])(breakpointVal)) {
      value[_i2] = breakpointVal[_i2];
      lastBreakpointArray = breakpointVal;
    } else {
      lastBreakpointArray = null;
      value[_i2] = breakpointVal;
    }
  }

  return value;
}

var css = function css(args) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = (0, _objectSpread3["default"])({}, defaultTheme, props.theme || props);
    var result = {};
    var obj = (0, _objectSpread3["default"])({}, typeof args === "function" ? args(theme) : args); // Pre-iteration flattening arrays with values from theme

    for (var key in obj) {
      obj[key] = getValue(obj[key], key, theme);
    }

    var styles = responsive(obj)(theme);

    for (var _key2 in styles) {
      var x = styles[_key2];
      var val = typeof x === "function" ? x(theme) : x;

      if (_key2 === "variant") {
        var variant = css(get(theme, val))(theme);
        result = (0, _objectSpread3["default"])({}, result, variant);
        continue;
      }
      /** MODIFICATION 1, special value font **/


      if (_key2 === "font") {
        var _variant = css(get(theme, "typography." + val))(theme);

        result = (0, _objectSpread3["default"])({}, result, _variant);
        continue;
      }

      if (val && typeof val === "object") {
        result[_key2] = css(val)(theme); // TODO: bug, second iteration overrides first one (or other way round), media queries are not merged in a smart way

        continue;
      }

      var prop = get(aliases, _key2, _key2);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

exports.css = css;
var _default = css;
exports["default"] = _default;

/***/ }),

/***/ 41387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.generateColorPalette = generateColorPalette;
exports.generateMonoPalette = generateMonoPalette;

var _parseFloat2 = _interopRequireDefault(__webpack_require__(95946));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _parseInt2 = _interopRequireDefault(__webpack_require__(57919));

function generateColorPalette(name, color) {
  // colorSets.forEach(colorSet => {
  //     levels.forEach(level => {
  //         const key = `${colorSet}${level}`;
  //         if (!primitives[key]) {
  //             primitives[key] = primitives[colorSet].changeBrightness(
  //                 (400 - level) / 500
  //             );
  //         }
  //     });
  // });
  var levels = [100, 200, 300, 400, 500, 600, 700, 800, 900];
  var colors = {};
  levels.forEach(function (level) {
    colors["".concat(name).concat(level)] = level === 500 ? color : pSBC((500 - level) / 500, color);
  });
  colors[name] = color;
  return colors;
}

function generateMonoPalette() {
  return {
    mono50: "#fafafa",
    mono100: "#f5f5f5",
    mono200: "#eeeeee",
    mono300: "#e0e0e0",
    mono400: "#bdbdbd",
    mono500: "#9e9e9e",
    mono600: "#757575",
    mono700: "#616161",
    mono800: "#424242",
    mono900: "#212121"
  };
}

var pSBCr = function pSBCr(d) {
  var i = _parseInt2["default"];
  var n = d.length,
      x = {};

  if (n > 9) {
    var _d, _d2;

    (_d = d = d.split(","), _d2 = (0, _slicedToArray2["default"])(_d, 4), r = _d2[0], g = _d2[1], b = _d2[2], a = _d2[3], _d), n = d.length;
    if (n < 3 || n > 4) return null;
    x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? (0, _parseFloat2["default"])(a) : -1;
  } else {
    if (n == 8 || n == 6 || n < 4) return null;
    if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
    d = i(d.slice(1), 16);
    if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
  }

  return x;
};

function pSBC(p, c0, c1, l) {
  var r,
      g,
      b,
      P,
      f,
      t,
      h,
      i = _parseInt2["default"],
      m = Math.round,
      a = typeof c1 == "string";
  if (typeof p != "number" || p < -1 || p > 1 || typeof c0 != "string" || c0[0] != "r" && c0[0] != "#" || c1 && !a) return null;
  h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBCr(c1) : P ? {
    r: 0,
    g: 0,
    b: 0,
    a: -1
  } : {
    r: 255,
    g: 255,
    b: 255,
    a: -1
  }, p = P ? p * -1 : p, P = 1 - p;
  if (!f || !t) return null;
  if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);else r = m(Math.pow(P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2), 0.5)), g = m(Math.pow(P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2), 0.5)), b = m(Math.pow(P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2), 0.5));
  a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
  if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
}

/***/ }),

/***/ 79329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.css = css;
exports.responsiveValueToRangeMap = responsiveValueToRangeMap;
exports.responsiveValueToResponsiveSize = responsiveValueToResponsiveSize;
exports.responsiveValueCurrent = responsiveValueCurrent;
exports.useResponsiveHelpers = useResponsiveHelpers;
exports.responsiveValueTransformScales = responsiveValueTransformScales;
exports.buildComponent = buildComponent;
exports.jsx = jsx;
exports.rs = rs;
exports.rslin = rslin;
exports.getElementSpec = getElementSpec;
exports.createElement = createElement;
exports.splitSx = splitSx;
exports.responsiveValueMap = responsiveValueMap;
exports.responsiveValueForEach = responsiveValueForEach;
exports.createComponent = exports.lin = exports.css2 = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _parseInt2 = _interopRequireDefault(__webpack_require__(57919));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _isArray = _interopRequireDefault(__webpack_require__(99228));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _core = __webpack_require__(98464);

var _css2 = _interopRequireWildcard(__webpack_require__(40117));

var _Theme = __webpack_require__(86522);

var _responsiveHelpers = __webpack_require__(96775);

var __jsx = _react["default"].createElement;

// import { R}
// import { rs as rs_, rslin as rslin_ } from "responsive-helpers";
function rs(config) {
  return config;
}

function rslin(from, to, isInf) {
  return {
    from: from,
    to: to,
    isInf: isInf,
    __isLinear: true
  };
}

var lin = rslin;
/**
 * Let's just add:
 * - responsive helpers to take theme breakpoints into account
 * - extension that allows to add
 */

exports.lin = lin;

function css(styles) {
  styles = (0, _isArray["default"])(styles) ? styles : [styles]; // we can have multiple styles
  // console.log('before css flattened styles', styles);

  styles = styles.flat([100]);
  styles = styles.filter(function (x) {
    return !!x;
  }); // console.log('after css flattened styles', styles);

  return function (theme) {
    return styles.map(function (stylesSet) {
      return (0, _css2["default"])(stylesSet)(theme);
    });
  };
}

var css2 = _css2["default"];
exports.css2 = css2;

function jsx(type, props) {
  var newProps = (0, _objectSpread2["default"])({}, props);
  var createElement = _react["default"].createElement;

  if (typeof type === "string" && props && props.sx) {
    // const [_css, _] = splitSx(props.sx); // for primitive components we ignore custom sx and just extract CSS to pass it through emotion "css" prop
    newProps.css = css(props.sx); //theme => { return css(props.sx, theme) }

    delete newProps.sx;
    createElement = _core.jsx;
  }

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return createElement.apply(void 0, [type, newProps].concat(children));
}

function mergeCss(a, b) {
  var ret = [];

  if ((0, _isArray["default"])(a)) {
    ret = (0, _toConsumableArray2["default"])(a);
  } else {
    ret = [a];
  }

  if ((0, _isArray["default"])(b)) {
    ret = [].concat((0, _toConsumableArray2["default"])(ret), (0, _toConsumableArray2["default"])(b));
  } else {
    ret = [].concat((0, _toConsumableArray2["default"])(ret), [b]);
  }

  return ret;
}

function getElementSpec() {
  var childSpec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parentSpec = arguments.length > 1 ? arguments[1] : undefined;
  var state = arguments.length > 2 ? arguments[2] : undefined;
  var forcedProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  childSpec = typeof childSpec === "function" ? childSpec(state) : childSpec;
  parentSpec = typeof parentSpec === "function" ? parentSpec(state) : parentSpec;
  forcedProps = typeof forcedProps === "function" ? forcedProps(state) : forcedProps;
  var parentSx = (0, _objectSpread2["default"])({}, parentSpec);
  delete parentSx.__children;
  delete parentSx.__type;
  delete parentSx.__props;
  var childSx = (0, _objectSpread2["default"])({}, childSpec);
  delete childSx.__children;
  delete childSx.__type;
  delete childSx.__props;

  var _splitSx = splitSx(parentSx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      parentCss = _splitSx2[0],
      parentCustomSx = _splitSx2[1];

  var _splitSx3 = splitSx(childSx),
      _splitSx4 = (0, _slicedToArray2["default"])(_splitSx3, 2),
      childCss = _splitSx4[0],
      childCustomSx = _splitSx4[1]; //
  // console.log('parent css', parentCss);
  // console.log('child css', childCss);
  //
  // console.log('---- ', [parentSx.$css, parentCss, childSx.$css, childCss]);


  return (0, _objectSpread2["default"])({}, parentCustomSx, childCustomSx, {
    $css: [parentSx.$css, parentCss, childSx.$css, childCss],
    __props: (0, _objectSpread2["default"])({}, parentSpec.__props, childSpec.__props, forcedProps),
    __children: childSpec.__children || parentSpec.__children,
    __type: childSpec.__type || parentSpec.__type
  });
}

function createElement(spec) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var __type = spec.__type,
      __children = spec.__children,
      __props = spec.__props,
      sx = (0, _objectWithoutProperties2["default"])(spec, ["__type", "__children", "__props"]);

  if (!__type || typeof __type === "string") {
    // If primitive element, then we should extract $css and sx should be an array.
    var _splitSx5 = splitSx(sx),
        _splitSx6 = (0, _slicedToArray2["default"])(_splitSx5, 2),
        _css = _splitSx6[0],
        $css = _splitSx6[1].$css;

    return jsx(__type || "div", (0, _objectSpread2["default"])({
      sx: [_css, $css]
    }, __props, props), __children);
  }

  return jsx(__type, (0, _objectSpread2["default"])({
    sx: sx
  }, __props, props), __children);
}

function splitSx(sx) {
  var css = {};
  var customSx = {};

  if ((0, _isArray["default"])(sx)) {
    customSx.$css = [];
    sx.forEach(function (subSx) {
      var _splitSx7 = splitSx(subSx),
          _splitSx8 = (0, _slicedToArray2["default"])(_splitSx7, 2),
          css_ = _splitSx8[0],
          sx_ = _splitSx8[1];

      customSx.$css.push(css_);
      customSx = (0, _objectSpread2["default"])({}, customSx, sx_);
    });
  } else {
    for (var prop in sx) {
      if (prop.startsWith("$")) {
        customSx[prop] = sx[prop];
      } else {
        css[prop] = sx[prop];
      }
    }
  }

  if (customSx.$css) {
    css = [customSx.$css, css];
    delete customSx.$css;
  }

  return [css, customSx];
} //
// function responsiveValueGetValueForBreakpoint(value, breakpoint) {
//   const theme = useTheme();
//
//   if (typeof value === 'string') {
//     const potentialValueFromTheme = get(theme.space || {}, value);
//     if (potentialValueFromTheme) {
//       value = potentialValueFromTheme;
//     }
//   }
// }


function responsiveValueForEach(resVal, callback, theme) {
  if (!theme) {
    theme = (0, _Theme.useTheme)();
  }

  var _theme = theme,
      breakpoints = _theme.breakpoints;

  if ((0, _isArray["default"])(resVal)) {
    resVal.forEach(function (val, index) {
      if (val === null) return;

      if (index === 0) {
        callback(val, null);
        return;
      }

      callback(val, breakpoints[index - 1]);
    });
    return;
  } else if (typeof resVal === "object" && typeof resVal._ !== "undefined") {
    for (var key in resVal) {
      if (key === "_") {
        callback(resVal[key], null);
        continue;
      }

      if (!breakpoints[key]) {
        throw new Error("Non-existent breakpoint");
      }

      callback(resVal[key], breakpoints[key]);
    }

    return;
  }

  callback(resVal, null);
}

function responsiveValueMap(resVal, mapper, theme) {
  if (!theme) {
    theme = (0, _Theme.useTheme)();
  }

  var _theme2 = theme,
      breakpoints = _theme2.breakpoints;

  if ((0, _isArray["default"])(resVal)) {
    var newResVal = [];

    for (var index in resVal) {
      if (resVal[index] === null) {
        newResVal.push(null);
        continue;
      }

      newResVal.push(mapper(resVal[index]));
    }

    return newResVal;
  } else if (typeof resVal === "object") {
    var _newResVal = {};

    for (var key in resVal) {
      _newResVal[key] = mapper(resVal[key]);
    }

    return _newResVal;
  }

  return mapper(resVal);
}
/**
 * ARITHMETICS ON RESPONSIVE ARRAYS
 */


function castResponsiveValue(resVal, Type, scale) {
  var theme = (0, _Theme.useTheme)(); // if (scale) {
  //   scale = theme[scale] || {};
  // }

  var config = {};
  responsiveValueForEach(resVal, function (val, breakpoint) {
    //
    // if (scale && typeof val === 'string') {
    //   const potentialValueFromTheme = get(scale, val);
    //
    //   console.log('potential value', potentialValueFromTheme, 'from', val);
    //   if (potentialValueFromTheme) {
    //     val = potentialValueFromTheme;
    //   }
    //   // console.log('before', val, 'after', val2)
    //
    // }
    if (breakpoint === null) {
      config[0] = val;
    } else {
      config[(0, _parseInt2["default"])(breakpoint)] = val;
    }
  });
  return new Type(config);
}

function responsiveValueToRangeMap(resVal) {
  return castResponsiveValue(resVal, _responsiveHelpers.RangeMap);
}

function responsiveValueToResponsiveSize(resVal) {
  return castResponsiveValue(resVal, _responsiveHelpers.ResponsiveSize, "space");
}

function responsiveValueCurrent(resVal, theme) {
  if (typeof window !== "object") {
    return;
  }

  var activeVal;
  responsiveValueForEach(resVal, function (val, breakpoint) {
    if (!breakpoint) {
      activeVal = val;
      return;
    }

    if (window.matchMedia("screen and (min-width: ".concat(breakpoint, ")")).matches) {
      activeVal = val;
    }
  }, theme);
  return activeVal;
}

function useResponsiveHelpers() {
  var theme = (0, _Theme.useTheme)();
  return {
    currentValue: function currentValue(resVal) {
      return responsiveValueCurrent(resVal, theme);
    }
  };
} // Helper for quick creating of components


var createComponent = function createComponent(Component, newSx) {
  return function (_ref) {
    var sx = _ref.sx,
        restProps = (0, _objectWithoutProperties2["default"])(_ref, ["sx"]);

    var _splitSx9 = splitSx(sx),
        _splitSx10 = (0, _slicedToArray2["default"])(_splitSx9, 2),
        css = _splitSx10[0],
        customSx = _splitSx10[1];

    var newSx2 = typeof newSx === "function" ? newSx(customSx) : newSx;
    var newSx3;

    if (typeof newSx2 === "function") {
      newSx3 = function newSx3() {
        return (0, _objectSpread2["default"])({}, newSx2.apply(void 0, arguments), sx, {
          $css: css
        });
      };
    } else {
      newSx3 = (0, _objectSpread2["default"])({}, newSx2, sx, {
        $css: css
      });
    }

    return __jsx(Component, (0, _extends2["default"])({}, restProps, {
      sx: newSx3
    }));
  };
};

exports.createComponent = createComponent;

function responsiveValueTransformScales(value, theme, scale, mainScale) {
  if ((0, _isArray["default"])(value)) {
    return value.map(function (v) {
      return responsiveValueTransformScales(v, theme, scale, mainScale);
    });
  } else if (typeof value === "object" && value !== null) {
    var newObj = {};

    for (var key in value) {
      newObj[key] = responsiveValueTransformScales(value[key], theme, scale, mainScale);
    }

    return newObj;
  } else if (typeof value === "string") {
    var _key2 = "".concat(scale, ".").concat(value);

    var transformedVal = (0, _css2.get)(theme, "".concat(mainScale, ".").concat(_key2));

    if (transformedVal) {
      return _key2;
    }

    return value;
  }

  return value;
}

function buildComponent(component, arg) {
  if (_react["default"].isValidElement(arg)) {
    return _react["default"].cloneElement(arg, (0, _objectSpread2["default"])({}, component.props, arg.props, {
      sx: (0, _objectSpread2["default"])({}, component.props.sx, arg.props.sx)
    }));
  } else if (typeof arg === "object") {
    return _react["default"].cloneElement(component, {
      sx: (0, _objectSpread2["default"])({}, component.props.sx, arg)
    });
  } else if (!arg) {
    return component;
  }

  throw new Error("Bad input for createBox");
} //
// function superResponsive(val, dict = {}) {
//   return responsiveValueMap(val, (x, breakpoint) => {
//     console.log(x, breakpoint);
//     return typeof dict[x] === 'undefined' ? x : dict[x];
//   })
// }

/***/ }),

/***/ 68646:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

function uniqueId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "_" + Math.random().toString(36).substr(2, 9);
}

var _default = uniqueId;
exports["default"] = _default;

/***/ }),

/***/ 68854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = __webpack_require__(34885);

// Hook
function useHover(ref) {
  var _useState = (0, _react.useState)(false),
      value = _useState[0],
      setValue = _useState[1];

  var handleMouseOver = function handleMouseOver() {
    return setValue(true);
  };

  var handleMouseOut = function handleMouseOut() {
    return setValue(false);
  };

  (0, _react.useEffect)(function () {
    var node = ref.current;

    if (node) {
      node.addEventListener("mouseover", handleMouseOver);
      node.addEventListener("mouseout", handleMouseOut);
      return function () {
        node.removeEventListener("mouseover", handleMouseOver);
        node.removeEventListener("mouseout", handleMouseOut);
      };
    }
  }, [ref.current] // Recall only if ref changes
  );

  if (typeof window === "object" && !window.matchMedia("screen and (pointer: fine)").matches) {
    return false;
  }

  return value;
}

var _default = useHover;
exports["default"] = _default;

/***/ }),

/***/ 90737:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = __webpack_require__(34885);

// takes overflow of Safari iOS into account
var getNormalizedScrollY = function getNormalizedScrollY() {
  var scrollY = window.scrollY;

  if (scrollY >= document.documentElement.scrollHeight - window.innerHeight || scrollY < 0) {
    return null;
  }

  return scrollY;
};

function useScrollDirection(options) {
  options = options || {};
  var _options = options,
      _options$timeDebounce = _options.timeDebounce,
      timeDebounce = _options$timeDebounce === void 0 ? 350 : _options$timeDebounce;

  var _useState = (0, _react.useState)(0),
      counter = _useState[0],
      setCounter = _useState[1];

  var blockedRef = (0, _react.useRef)(false);
  var directionRef = (0, _react.useRef)(undefined); // wrapper to have access to up-to-date values in updateScroll closure

  var previousScrollY = (0, _react.useRef)(null);
  var timeout = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var updateScroll = function updateScroll() {
      var direction = directionRef.current;
      var blocked = blockedRef.current;
      var scrollY = getNormalizedScrollY();

      if (scrollY === null) {
        return;
      }

      if (previousScrollY.current !== null) {
        var newDirection;

        if (scrollY > previousScrollY.current) {
          newDirection = true;
        } else {
          newDirection = false;
        }

        if (newDirection !== direction && !blocked) {
          directionRef.current = newDirection;
          blockedRef.current = true;
          clearTimeout(timeout.current);
          timeout.current = setTimeout(function () {
            blockedRef.current = false;
          }, timeDebounce);
          setCounter(function (counter) {
            return counter + 1;
          });
        }
      }

      previousScrollY.current = scrollY;
    };

    window.addEventListener("scroll", updateScroll);
    updateScroll();
    return function cleanup() {
      window.removeEventListener("scroll", updateScroll);
      clearTimeout(timeout.current);
    };
  }, [timeDebounce]);
  return directionRef.current;
}

var _default = useScrollDirection;
exports["default"] = _default;

/***/ }),

/***/ 23931:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _keys = _interopRequireDefault(__webpack_require__(18396));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = __webpack_require__(34885);

function getActiveOffset(offsets, scrollY) {
  var offsetsCopy = (0, _objectSpread2["default"])({}, offsets);

  if (!offsetsCopy[0]) {
    offsetsCopy[0] = "top";
  }

  var keys = (0, _keys["default"])(offsetsCopy);
  keys.sort();
  var result;

  for (var i = 0; i < keys.length; i++) {
    if (keys[i] <= scrollY) {
      result = offsetsCopy[keys[i]];
    }
  }

  return result;
}

function useScrollSegment() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isActive = (0, _react.useRef)(false); // ref instead of state prevents from extra re-renders.

  var _useState = (0, _react.useState)(0),
      counter = _useState[0],
      setCounter = _useState[1];

  var _config$from = config.from,
      from = _config$from === void 0 ? 0 : _config$from,
      to = config.to;
  (0, _react.useEffect)(function () {
    var updateScroll = function updateScroll() {
      if (window.scrollY >= from && !isActive.current) {
        isActive.current = true;
        setCounter(function (c) {
          return c + 1;
        });
      } else if (window.scrollY < from && isActive.current) {
        isActive.current = false;
        setCounter(function (c) {
          return c + 1;
        });
      }
    };

    window.addEventListener("scroll", updateScroll);
    updateScroll();
    return function cleanup() {
      window.removeEventListener("scroll", updateScroll);
    };
  }, [from, to]);
  return isActive.current;
}

var _default = useScrollSegment;
exports["default"] = _default;

/***/ }),

/***/ 88829:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useSelectState_controlled = useSelectState_controlled;
exports["default"] = exports.getValIndex = exports.normalizeSelectValue = exports.originalValue = exports.normalizeSelectOptions = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = __webpack_require__(34885);

function filterProps(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      allowEmpty = props.allowEmpty,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["options", "value", "defaultValue", "onChange", "allowEmpty"]);
  return restProps;
}

var normalizeSelectOptions = function normalizeSelectOptions(options) {
  return options.map(function (option) {
    if (typeof option === "object") {
      if (option.id === undefined || option.id === null) {
        throw new Error("[useSelectState] options must have id, this option doesn't: ".concat(option));
      }

      if (typeof option.__originalOption !== "undefined") {
        // you can't normalize already normalized value
        return option;
      }

      var label = option.label;
      var id = option.id.toString();

      if (!label) {
        label = option.id.toString();
      }

      return (0, _objectSpread2["default"])({}, option, {
        id: id,
        label: label,
        __originalOption: option
      });
    }

    if (option === null || option === undefined) {
      throw new Error("[useSelectState] options can't be null or undefined");
    } // throw new Error("options must be objects with ID!!!");


    return {
      id: option.toString(),
      label: option.toString(),
      __originalOption: option
    };
  });
};

exports.normalizeSelectOptions = normalizeSelectOptions;

var originalValue = function originalValue(val) {
  return val === null ? null : typeof val.__originalOption !== "undefined" ? val.__originalOption : val;
};

exports.originalValue = originalValue;

var normalizeSelectValue = function normalizeSelectValue(options, val, allowEmpty) {
  options = normalizeSelectOptions(options);
  var valueId = val === undefined || val === null ? val : typeof val === "object" ? val.id.toString() : val.toString();
  var valueObject = options.find(function (o) {
    return o.id === valueId;
  });
  val = valueObject || (allowEmpty ? null : options[0]);
  return val;
};

exports.normalizeSelectValue = normalizeSelectValue;

var getValIndex = function getValIndex(options, val) {
  if (val === null) {
    return null;
  }

  var index = options.findIndex(function (x) {
    return x.id === val.id;
  });

  if (index === -1) {
    return null;
  }

  return index;
};

exports.getValIndex = getValIndex;

function useSelectState(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange,
      _props$allowEmpty = props.allowEmpty,
      allowEmpty = _props$allowEmpty === void 0 ? true : _props$allowEmpty; // UNCONTROLLED ONLY IF: value === "undefined"

  var isControlled = typeof value !== "undefined";
  var normalizedValue = normalizeSelectValue(options, defaultValue, allowEmpty);

  var _useState = (0, _react.useState)(normalizedValue && normalizedValue.disabled ? null : normalizedValue),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var currentValue = isControlled ? value : internalValue;
  return useSelectState_controlled((0, _objectSpread2["default"])({}, props, {
    value: currentValue,
    onChange: function onChange(newVal, index) {
      if (!isControlled) {
        setInternalValue(newVal);
      }

      if (_onChange) {
        _onChange(newVal, index);
      }
    }
  }));
}

function useSelectState_controlled(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange,
      _props$allowEmpty2 = props.allowEmpty,
      allowEmpty = _props$allowEmpty2 === void 0 ? true : _props$allowEmpty2;
  options = normalizeSelectOptions(options); // Let's see if value or defaultValue is one from the options list or not

  var currentValue = normalizeSelectValue(options, value, allowEmpty);
  currentValue = currentValue && currentValue.disabled ? null : currentValue;

  var setValue = function setValue(newVal) {
    newVal = normalizeSelectValue(options, newVal, allowEmpty);

    if (newVal === null && currentValue === null) {
      return;
    }

    if (newVal && currentValue && newVal.id === currentValue.id) {
      return;
    }

    if (newVal && newVal.disabled) {
      return;
    }

    if (onChange) {
      onChange(originalValue(newVal), getValIndex(options, newVal));
    }
  };

  var isSelected = function isSelected(val) {
    return !!(val && currentValue && (currentValue.id === val || currentValue.id === val.id));
  };

  return {
    value: originalValue(currentValue),
    valueObject: currentValue,
    empty: currentValue === null,
    selectedIndex: getValIndex(options, currentValue),
    options: options,
    reset: function reset() {
      setValue(null);
    },
    setValue: setValue,
    isSelected: isSelected,
    selectValue: function selectValue(val) {
      setValue(val);
    },
    unselectValue: function unselectValue(val) {
      if (isSelected(val)) {
        setValue(null);
      }
    }
  };
}

useSelectState.filterProps = filterProps;
var _default = useSelectState;
exports["default"] = _default;

/***/ }),

/***/ 47272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(34885));

function useWindowSize() {
  var isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  var _useState = (0, _react.useState)(getSize),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  (0, _react.useEffect)(function () {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}

var _default = useWindowSize;
exports["default"] = _default;

/***/ }),

/***/ 98464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ CacheProvider; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ ThemeContext; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* reexport */ css_browser_esm; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withEmotionCache": function() { return /* reexport */ withEmotionCache; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(98911);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

// EXTERNAL MODULE: ../../node_modules/@emotion/utils/dist/utils.browser.esm.js
var utils_browser_esm = __webpack_require__(4193);
// EXTERNAL MODULE: ../../node_modules/@emotion/serialize/dist/serialize.browser.esm.js + 2 modules
var serialize_browser_esm = __webpack_require__(96471);
;// CONCATENATED MODULE: ../../node_modules/@emotion/core/dist/emotion-element-04d85134.browser.esm.js






var emotion_element_04d85134_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,utils_browser_esm/* getRegisteredStyles */.f)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,serialize_browser_esm/* serializeStyles */.O)(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = (0,utils_browser_esm/* insertStyles */.M)(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ../../node_modules/@emotion/css/dist/css.browser.esm.js


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,serialize_browser_esm/* serializeStyles */.O)(args);
}

/* harmony default export */ var css_browser_esm = (css);

;// CONCATENATED MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      var serialized = (0,serialize_browser_esm/* serializeStyles */.O)([styles(theme)]);
      return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = (0,serialize_browser_esm/* serializeStyles */.O)([styles]);
  return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      (0,utils_browser_esm/* insertStyles */.M)(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css_browser_esm.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,utils_browser_esm/* getRegisteredStyles */.f)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var core_browser_esm_Noop = function Noop() {
  return null;
};

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = (0,serialize_browser_esm/* serializeStyles */.O)(args, context.registered);

      {
        (0,utils_browser_esm/* insertStyles */.M)(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(core_browser_esm_Noop, null);


    return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
  });
});




/***/ }),

/***/ 87443:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 96471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(87443);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = (0,memoize_browser_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 6948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ styled_browser_esm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(4079);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(87443);
;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = (0,memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);

// EXTERNAL MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js + 5 modules
var core_browser_esm = __webpack_require__(98464);
// EXTERNAL MODULE: ../../node_modules/@emotion/utils/dist/utils.browser.esm.js
var utils_browser_esm = __webpack_require__(4193);
// EXTERNAL MODULE: ../../node_modules/@emotion/serialize/dist/serialize.browser.esm.js + 2 modules
var serialize_browser_esm = __webpack_require__(96471);
;// CONCATENATED MODULE: ../../node_modules/@emotion/styled-base/dist/styled-base.browser.esm.js







var testOmitPropsOnStringTag = is_prop_valid_browser_esm;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Noop = function Noop() {
  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,core_browser_esm.withEmotionCache)(function (props, context, ref) {
      return /*#__PURE__*/(0,react.createElement)(core_browser_esm.ThemeContext.Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = (0,utils_browser_esm/* getRegisteredStyles */.f)(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = (0,serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = (0,utils_browser_esm/* insertStyles */.M)(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (false) {}

        var ele = /*#__PURE__*/(0,react.createElement)(finalTag, newProps);
        var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


        return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/dist/styled.browser.esm.js


var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var styled_browser_esm = (newStyled);


/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "M": function() { return /* binding */ insertStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 33076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EnhancerArray": function() { return /* binding */ EnhancerArray; },
  "MiddlewareArray": function() { return /* binding */ MiddlewareArray; },
  "SHOULD_AUTOBATCH": function() { return /* binding */ SHOULD_AUTOBATCH; },
  "TaskAbortError": function() { return /* binding */ TaskAbortError; },
  "__DO_NOT_USE__ActionTypes": function() { return /* reexport */ ActionTypes; },
  "addListener": function() { return /* binding */ addListener; },
  "applyMiddleware": function() { return /* reexport */ applyMiddleware; },
  "autoBatchEnhancer": function() { return /* binding */ autoBatchEnhancer; },
  "bindActionCreators": function() { return /* reexport */ bindActionCreators; },
  "clearAllListeners": function() { return /* binding */ clearAllListeners; },
  "combineReducers": function() { return /* reexport */ combineReducers; },
  "compose": function() { return /* reexport */ compose; },
  "configureStore": function() { return /* binding */ configureStore; },
  "createAction": function() { return /* binding */ createAction; },
  "createActionCreatorInvariantMiddleware": function() { return /* binding */ createActionCreatorInvariantMiddleware; },
  "createAsyncThunk": function() { return /* binding */ createAsyncThunk; },
  "createDraftSafeSelector": function() { return /* binding */ createDraftSafeSelector; },
  "createEntityAdapter": function() { return /* binding */ createEntityAdapter; },
  "createImmutableStateInvariantMiddleware": function() { return /* binding */ createImmutableStateInvariantMiddleware; },
  "createListenerMiddleware": function() { return /* binding */ createListenerMiddleware; },
  "createNextState": function() { return /* reexport */ immer_esm; },
  "createReducer": function() { return /* binding */ createReducer; },
  "createSelector": function() { return /* reexport */ createSelector; },
  "createSerializableStateInvariantMiddleware": function() { return /* binding */ createSerializableStateInvariantMiddleware; },
  "createSlice": function() { return /* binding */ createSlice; },
  "createStore": function() { return /* reexport */ createStore; },
  "current": function() { return /* reexport */ R; },
  "findNonSerializableValue": function() { return /* binding */ findNonSerializableValue; },
  "freeze": function() { return /* reexport */ d; },
  "getDefaultMiddleware": function() { return /* binding */ getDefaultMiddleware; },
  "getType": function() { return /* binding */ getType; },
  "isAction": function() { return /* binding */ isAction; },
  "isActionCreator": function() { return /* binding */ isActionCreator; },
  "isAllOf": function() { return /* binding */ isAllOf; },
  "isAnyOf": function() { return /* binding */ isAnyOf; },
  "isAsyncThunkAction": function() { return /* binding */ isAsyncThunkAction; },
  "isDraft": function() { return /* reexport */ r; },
  "isFluxStandardAction": function() { return /* binding */ isFSA; },
  "isFulfilled": function() { return /* binding */ isFulfilled; },
  "isImmutableDefault": function() { return /* binding */ isImmutableDefault; },
  "isPending": function() { return /* binding */ isPending; },
  "isPlain": function() { return /* binding */ isPlain; },
  "isPlainObject": function() { return /* binding */ redux_toolkit_esm_isPlainObject; },
  "isRejected": function() { return /* binding */ isRejected; },
  "isRejectedWithValue": function() { return /* binding */ isRejectedWithValue; },
  "legacy_createStore": function() { return /* reexport */ legacy_createStore; },
  "miniSerializeError": function() { return /* binding */ miniSerializeError; },
  "nanoid": function() { return /* binding */ nanoid; },
  "original": function() { return /* reexport */ e; },
  "prepareAutoBatched": function() { return /* binding */ prepareAutoBatched; },
  "removeListener": function() { return /* binding */ removeListener; },
  "unwrapResult": function() { return /* binding */ unwrapResult; }
});

;// CONCATENATED MODULE: ../../node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(4079);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// CONCATENATED MODULE: ../../node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}



;// CONCATENATED MODULE: ../../node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ../../node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};
;// CONCATENATED MODULE: ../../node_modules/@reduxjs/toolkit/node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ../../node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
/* provided dependency */ var process = __webpack_require__(90907);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([r(value) ? R(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return compose;
    return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function redux_toolkit_esm_isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isAction(action) {
    return redux_toolkit_esm_isPlainObject(action) && "type" in action;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
function isFSA(action) {
    return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isActionCreator, isActionCreator2 = _c === void 0 ? isActionCreator : _c;
    return function () { return function (next) { return function (action) {
        if (isActionCreator2(action)) {
            console.warn(getMessage(action.type));
        }
        return next(action);
    }; }; };
}
// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
var EnhancerArray = /** @class */ (function (_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function () {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array));
function freezeDraftable(val) {
    return t(val) ? immer_esm(val, function () {
    }) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = "production" === "production";
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    if (checkedObjects === void 0) { checkedObjects = new Set(); }
    var tracked = { value: obj };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function (key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) {
            return { value: result };
        }
    };
    for (var key in keysToDetect) {
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || redux_toolkit_esm_isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    if (cache == null ? void 0 : cache.has(value))
        return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function (key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        if (!isSerializable(nestedValue)) {
            return { value: {
                    keyPath: nestedPath,
                    value: nestedValue
                } };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) {
                return { value: foundNestedSerializable };
            }
        }
    };
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object")
            return state_2.value;
    }
    if (cache && isNestedFrozen(value))
        cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value))
        return false;
    for (var _i = 0, _c = Object.values(value); _i < _c.length; _i++) {
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null)
            continue;
        if (!isNestedFrozen(nestedValue))
            return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j, _k = options.disableCache, disableCache = _k === void 0 ? false : _k;
    var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var actionCreatorOptions, serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (redux_toolkit_esm_isPlainObject(reducer)) {
        rootReducer = combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = compose;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(defaultEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) {
                throw new Error("`builder.addCase` cannot be called with an empty action type");
            }
            if (type in actionsMap) {
                throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    if (false) {}
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        if (false) {}
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (r(state)) {
            runMutator(state);
            return state;
        }
        else {
            return immer_esm(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = Object.keys(state.entities);
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for (var _i = 0, updates_1 = updates; _i < updates_1.length; _i++) {
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) {
                continue;
            }
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) {
            resortEntities(state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
var createAsyncThunk = (function () {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
            payload: payload,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        }); });
        var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
            payload: void 0,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        }); });
        var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
            payload: payload,
            error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        }); });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function () {
                    },
                    dispatchEvent: function () {
                        return false;
                    },
                    onabort: function () {
                    },
                    removeEventListener: function () {
                    },
                    reason: void 0,
                    throwIfAborted: function () {
                    }
                };
            }
            class_1.prototype.abort = function () {
                if (false) {}
            };
            return class_1;
        }());
        function actionCreator(arg) {
            return function (dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function () {
                    return __async(this, null, function () {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                    if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, conditionResult];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) {
                                        throw {
                                            name: "ConditionError",
                                            message: "Aborted due to condition callback returning false."
                                        };
                                    }
                                    started = true;
                                    abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({
                                        name: "AbortError",
                                        message: abortReason || "Aborted"
                                    }); }); });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                    return [4 /*yield*/, Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function (value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function (value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function (result) {
                                                if (result instanceof RejectWithValue) {
                                                    throw result;
                                                }
                                                if (result instanceof FulfillWithMeta) {
                                                    return fulfilled(result.payload, requestId, arg, result.meta);
                                                }
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])];
                                case 3:
                                    finalAction = _c.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [3 /*break*/, 5];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) {
                                        dispatch(finalAction);
                                    }
                                    return [2 /*return*/, finalAction];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function () {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function () { return createAsyncThunk2; };
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise2, onError) {
    if (onError === void 0) { onError = noop; }
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
    return function () { return abortSignal.removeEventListener("abort", callback); };
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
function raceWithSignal(signal, promise2) {
    var cleanup = noop;
    return new Promise(function (resolve, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function () { return cleanup(); }).then(resolve, reject);
    }).finally(function () {
        cleanup = noop;
    });
}
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise2) {
        return catchRejection(raceWithSignal(signal, promise2).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor, opts) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        if (opts == null ? void 0 : opts.autoJoin) {
            parentBlockingPromises.push(result);
        }
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve, reject) {
                        var stopListening = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                        unsubscribe = function () {
                            stopListening();
                            reject();
                        };
                    });
                    promises = [
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, raceWithSignal(signal, Promise.race(promises))];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, autoJoinPromises, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    autoJoinPromises = [];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 6]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal, autoJoinPromises),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, Promise.allSettled(autoJoinPromises)];
                case 5:
                    _c.sent();
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (!isAction(action)) {
            return next(action);
        }
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function () { return function (payload) {
    var _c;
    return ({
        payload: payload,
        meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
    });
}; };
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
var createQueueWithTimer = function (timeout) {
    return function (notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function (options) {
    if (options === void 0) { options = { type: "raf" }; }
    return function (next) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var store = next.apply(void 0, args);
        var notifying = true;
        var shouldNotifyAtEndOfTick = false;
        var notificationQueued = false;
        var listeners = new Set();
        var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
        var notifyListeners = function () {
            notificationQueued = false;
            if (shouldNotifyAtEndOfTick) {
                shouldNotifyAtEndOfTick = false;
                listeners.forEach(function (l) { return l(); });
            }
        };
        return Object.assign({}, store, {
            subscribe: function (listener2) {
                var wrappedListener = function () { return notifying && listener2(); };
                var unsubscribe = store.subscribe(wrappedListener);
                listeners.add(listener2);
                return function () {
                    unsubscribe();
                    listeners.delete(listener2);
                };
            },
            dispatch: function (action) {
                var _a;
                try {
                    notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                    shouldNotifyAtEndOfTick = !notifying;
                    if (shouldNotifyAtEndOfTick) {
                        if (!notificationQueued) {
                            notificationQueued = true;
                            queueCallback(notifyListeners);
                        }
                    }
                    return store.dispatch(action);
                }
                finally {
                    notifying = true;
                }
            }
        });
    }; };
};
// src/index.ts
F();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 89591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ registerBackgroundTabDetection; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77257);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4859);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58786);
/* harmony import */ var _common_debug_build_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20858);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28997);





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document) {
    _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.addEventListener */ .m.document.addEventListener('visibilitychange', () => {
      // eslint-disable-next-line deprecation/deprecation
      const activeTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getActiveTransaction */ .x1)() ;
      if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.hidden */ .m.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        const { op, status } = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .spanToJSON */ .XU)(activeTransaction);

        _common_debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!status) {
          activeTransaction.setStatus(statusType);
        }
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.end();
      }
    });
  } else {
    _common_debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.warn */ .kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map


/***/ }),

/***/ 46136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E8": function() { return /* binding */ browserTracingIntegration; },
/* harmony export */   "og": function() { return /* binding */ startBrowserTracingNavigationSpan; },
/* harmony export */   "Wo": function() { return /* binding */ startBrowserTracingPageLoadSpan; }
/* harmony export */ });
/* unused harmony exports BROWSER_TRACING_INTEGRATION_ID, getMetaContent */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83815);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91617);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10857);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4859);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46595);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28218);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77257);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75771);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24703);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16962);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71207);
/* harmony import */ var _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20858);
/* harmony import */ var _backgroundtab_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89591);
/* harmony import */ var _instrument_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(94423);
/* harmony import */ var _metrics_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29350);
/* harmony import */ var _request_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79727);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28997);









const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ..._sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .TRACING_DEFAULTS */ .AT,
  instrumentNavigation: true,
  instrumentPageLoad: true,
  markBackgroundSpan: true,
  enableLongTask: true,
  enableInp: false,
  interactionsSampleRate: 1,
  _experiments: {},
  ..._request_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultRequestInstrumentationOptions */ .k3,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */
const browserTracingIntegration = ((_options = {}) => {
  const _hasSetTracePropagationTargets = _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X
    ? !!(
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      )
    : false;

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .addTracingExtensions */ .T)();

  // TODO (v8): remove this block after tracingOrigins is removed
  // Set tracePropagationTargets to tracingOrigins if specified by the user
  // In case both are specified, tracePropagationTargets takes precedence
  // eslint-disable-next-line deprecation/deprecation
  if (!_options.tracePropagationTargets && _options.tracingOrigins) {
    // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
  }

  const options = {
    ...DEFAULT_BROWSER_TRACING_OPTIONS,
    ..._options,
  };

  const _collectWebVitals = (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_4__/* .startTrackingWebVitals */ .PR)();

  /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */
  const interactionIdToRouteNameMapping = {};
  if (options.enableInp) {
    (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_4__/* .startTrackingINP */ .NR)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
  }

  if (options.enableLongTask) {
    (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_4__/* .startTrackingLongTasks */ .Fv)();
  }
  if (options._experiments.enableInteractions) {
    (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_4__/* .startTrackingInteractions */ .sn)();
  }

  const latestRoute

 = {
    name: undefined,
    context: undefined,
  };

  /** Create routing idle transaction. */
  function _createRouteTransaction(context) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_5__/* .getCurrentHub */ .Gd)();

    const { beforeStartSpan, idleTimeout, finalTimeout, heartbeatInterval } = options;

    const isPageloadTransaction = context.op === 'pageload';

    let expandedContext;
    if (isPageloadTransaction) {
      const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
      const baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;
      const { traceId, dsc, parentSpanId, sampled } = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .propagationContextFromHeaders */ .pT)(sentryTrace, baggage);
      expandedContext = {
        traceId,
        parentSpanId,
        parentSampled: sampled,
        ...context,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...context.metadata,
          dynamicSamplingContext: dsc,
        },
        trimEnd: true,
      };
    } else {
      expandedContext = {
        trimEnd: true,
        ...context,
      };
    }

    const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;

    // If `beforeStartSpan` set a custom name, record that fact
    // eslint-disable-next-line deprecation/deprecation
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? // eslint-disable-next-line deprecation/deprecation
          { ...finalContext.metadata, source: 'custom' }
        : // eslint-disable-next-line deprecation/deprecation
          finalContext.metadata;

    latestRoute.name = finalContext.name;
    latestRoute.context = finalContext;

    if (finalContext.sampled === false) {
      _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW */ .m;

    const idleTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .startIdleTransaction */ .l)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
      isPageloadTransaction, // should wait for finish signal if it's a pageload transaction
    );

    if (isPageloadTransaction && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document */ .m.document) {
      _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.addEventListener */ .m.document.addEventListener('readystatechange', () => {
        if (['interactive', 'complete'].includes(_types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.readyState */ .m.document.readyState)) {
          idleTransaction.sendAutoFinishSignal();
        }
      });

      if (['interactive', 'complete'].includes(_types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.readyState */ .m.document.readyState)) {
        idleTransaction.sendAutoFinishSignal();
      }
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      _collectWebVitals();
      (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_4__/* .addPerformanceEntries */ .f7)(transaction);
    });

    return idleTransaction ;
  }

  return {
    name: BROWSER_TRACING_INTEGRATION_ID,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setupOnce: () => {},
    afterAllSetup(client) {
      const clientOptions = client.getOptions();

      const { markBackgroundSpan, traceFetch, traceXHR, shouldCreateSpanForRequest, enableHTTPTimings, _experiments } =
        options;

      const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
      // There are three ways to configure tracePropagationTargets:
      // 1. via top level client option `tracePropagationTargets`
      // 2. via BrowserTracing option `tracePropagationTargets`
      // 3. via BrowserTracing option `tracingOrigins` (deprecated)
      //
      // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
      // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
      // This is done as it minimizes bundle size (we don't have to have undefined checks).
      //
      // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
      // eslint-disable-next-line deprecation/deprecation
      const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
      if (_common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn(
          '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
        );
      }

      let activeSpan;
      let startingUrl = _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.href */ .m.location.href;

      if (client.on) {
        client.on('startNavigationSpan', (context) => {
          if (activeSpan) {
            _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(`[Tracing] Finishing current transaction with op: ${(0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(activeSpan).op}`);
            // If there's an open transaction on the scope, we need to finish it before creating an new one.
            activeSpan.end();
          }
          activeSpan = _createRouteTransaction({
            op: 'navigation',
            ...context,
          });
        });

        client.on('startPageLoadSpan', (context) => {
          if (activeSpan) {
            _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(`[Tracing] Finishing current transaction with op: ${(0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(activeSpan).op}`);
            // If there's an open transaction on the scope, we need to finish it before creating an new one.
            activeSpan.end();
          }
          activeSpan = _createRouteTransaction({
            op: 'pageload',
            ...context,
          });
        });
      }

      if (options.instrumentPageLoad && client.emit && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location) {
        const context = {
          name: _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.pathname */ .m.location.pathname,
          // pageload should always start at timeOrigin (and needs to be in s, not ms)
          startTimestamp: _sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .browserPerformanceTimeOrigin */ .Z1 ? _sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .browserPerformanceTimeOrigin */ .Z1 / 1000 : undefined,
          origin: 'auto.pageload.browser',
          attributes: {
            [_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj]: 'url',
          },
        };
        startBrowserTracingPageLoadSpan(client, context);
      }

      if (options.instrumentNavigation && client.emit && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .addHistoryInstrumentationHandler */ .a)(({ to, from }) => {
          /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */
          if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
          }

          if (from !== to) {
            startingUrl = undefined;
            const context = {
              name: _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.pathname */ .m.location.pathname,
              origin: 'auto.navigation.browser',
              attributes: {
                [_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj]: 'url',
              },
            };

            startBrowserTracingNavigationSpan(client, context);
          }
        });
      }

      if (markBackgroundSpan) {
        (0,_backgroundtab_js__WEBPACK_IMPORTED_MODULE_13__/* .registerBackgroundTabDetection */ .j)();
      }

      if (_experiments.enableInteractions) {
        registerInteractionListener(options, latestRoute);
      }

      if (options.enableInp) {
        registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
      }

      (0,_request_js__WEBPACK_IMPORTED_MODULE_1__/* .instrumentOutgoingRequests */ .L7)({
        traceFetch,
        traceXHR,
        tracePropagationTargets,
        shouldCreateSpanForRequest,
        enableHTTPTimings,
      });
    },
    // TODO v8: Remove this again
    // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
    options,
  };
}) ;

/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */
function startBrowserTracingPageLoadSpan(client, spanOptions) {
  if (!client.emit) {
    return;
  }

  client.emit('startPageLoadSpan', spanOptions);

  const span = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .getActiveSpan */ .HN)();
  const op = span && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).op;
  return op === 'pageload' ? span : undefined;
}

/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */
function startBrowserTracingNavigationSpan(client, spanOptions) {
  if (!client.emit) {
    return;
  }

  client.emit('startNavigationSpan', spanOptions);

  const span = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .getActiveSpan */ .HN)();
  const op = span && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).op;
  return op === 'navigation' ? span : undefined;
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_15__/* .getDomElement */ .qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

/** Start listener for interaction transactions */
function registerInteractionListener(
  options,
  latestRoute

,
) {
  let inflightInteractionTransaction;
  const registerInteractionTransaction = () => {
    const { idleTimeout, finalTimeout, heartbeatInterval } = options;
    const op = 'ui.action.click';

    // eslint-disable-next-line deprecation/deprecation
    const currentTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_16__/* .getActiveTransaction */ .x1)();
    if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
      _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn(
          `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
        );
      return undefined;
    }

    if (inflightInteractionTransaction) {
      inflightInteractionTransaction.setFinishReason('interactionInterrupted');
      inflightInteractionTransaction.end();
      inflightInteractionTransaction = undefined;
    }

    if (!latestRoute.name) {
      _common_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
      return undefined;
    }

    const { location } = _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW */ .m;

    const context = {
      name: latestRoute.name,
      op,
      trimEnd: true,
      data: {
        [_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj]: latestRoute.context ? getSource(latestRoute.context) : 'url',
      },
    };

    inflightInteractionTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .startIdleTransaction */ .l)(
      // eslint-disable-next-line deprecation/deprecation
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_5__/* .getCurrentHub */ .Gd)(),
      context,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
  };

  ['click'].forEach(type => {
    if (_types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document */ .m.document) {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    }
  });
}

function isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}

/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */
const MAX_INTERACTIONS = 10;

/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
function registerInpInteractionListener(
  interactionIdToRouteNameMapping,
  latestRoute

,
) {
  const handleEntries = ({ entries }) => {
    const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_17__/* .getClient */ .s3)();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay =
      client !== undefined && client.getIntegrationByName !== undefined
        ? (client.getIntegrationByName('Replay') )
        : undefined;
    const replayId = replay !== undefined ? replay.getReplayId() : undefined;
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_16__/* .getActiveTransaction */ .x1)();
    const currentScope = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_17__/* .getCurrentScope */ .nZ)();
    const user = currentScope !== undefined ? currentScope.getUser() : undefined;
    entries.forEach(entry => {
      if (isPerformanceEventTiming(entry)) {
        const interactionId = entry.interactionId;
        if (interactionId === undefined) {
          return;
        }
        const existingInteraction = interactionIdToRouteNameMapping[interactionId];
        const duration = entry.duration;
        const startTime = entry.startTime;
        const keys = Object.keys(interactionIdToRouteNameMapping);
        const minInteractionId =
          keys.length > 0
            ? keys.reduce((a, b) => {
                return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration
                  ? a
                  : b;
              })
            : undefined;
        // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
        // This is also checked in the web-vitals library.
        if (entry.entryType === 'first-input') {
          const matchingEntry = keys
            .map(key => interactionIdToRouteNameMapping[key])
            .some(interaction => {
              return interaction.duration === duration && interaction.startTime === startTime;
            });
          if (matchingEntry) {
            return;
          }
        }
        // Interactions with an id of 0 and are not first-input are not valid.
        if (!interactionId) {
          return;
        }
        // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
        if (existingInteraction) {
          existingInteraction.duration = Math.max(existingInteraction.duration, duration);
        } else if (
          keys.length < MAX_INTERACTIONS ||
          minInteractionId === undefined ||
          duration > interactionIdToRouteNameMapping[minInteractionId].duration
        ) {
          // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
          const routeName = latestRoute.name;
          const parentContext = latestRoute.context;
          if (routeName && parentContext) {
            if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
              // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
              delete interactionIdToRouteNameMapping[minInteractionId];
            }
            interactionIdToRouteNameMapping[interactionId] = {
              routeName,
              duration,
              parentContext,
              user,
              activeTransaction,
              replayId,
              startTime,
            };
          }
        }
      }
    });
  };
  (0,_instrument_js__WEBPACK_IMPORTED_MODULE_18__/* .addPerformanceInstrumentationHandler */ ._j)('event', handleEntries);
  (0,_instrument_js__WEBPACK_IMPORTED_MODULE_18__/* .addPerformanceInstrumentationHandler */ ._j)('first-input', handleEntries);
}

function getSource(context) {
  const sourceFromAttributes = context.attributes && context.attributes[_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromData = context.data && context.data[_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromMetadata = context.metadata && context.metadata.source;

  return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}


//# sourceMappingURL=browserTracingIntegration.js.map


/***/ }),

/***/ 94423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PR": function() { return /* binding */ addClsInstrumentationHandler; },
  "to": function() { return /* binding */ addFidInstrumentationHandler; },
  "YF": function() { return /* binding */ addInpInstrumentationHandler; },
  "$A": function() { return /* binding */ addLcpInstrumentationHandler; },
  "_j": function() { return /* binding */ addPerformanceInstrumentationHandler; },
  "_4": function() { return /* binding */ addTtfbInstrumentationHandler; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(16398);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/common/debug-build.js
var debug_build = __webpack_require__(20858);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(28997);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js
var getNavigationEntry = __webpack_require__(64953);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
  let navigationType = 'navigate';

  if (navEntry) {
    if ((types/* WINDOW.document */.m.document && types/* WINDOW.document.prerendering */.m.document.prerendering) || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js
var onHidden = __webpack_require__(57748);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (
  onReport,
  options = {},
) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric, options.reportAllChanges);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    (0,onHidden/* onHidden */.u)(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
var getVisibilityWatcher = __webpack_require__(54469);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.Y)();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    (0,onHidden/* onHidden */.u)(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/polyfills/interactionCountPolyfill.js


let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;

const updateEstimate = (entries) => {
  (entries ).forEach(e => {
    if (e.interactionId) {
      minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
      maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);

      interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
    }
  });
};

let po;

/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
const getInteractionCount = () => {
  return po ? interactionCountEstimate : performance.interactionCount || 0;
};

/**
 * Feature detects native support or initializes the polyfill if needed.
 */
const initInteractionCountPolyfill = () => {
  if ('interactionCount' in performance || po) return;

  po = observe('event', updateEstimate, {
    type: 'event',
    buffered: true,
    durationThreshold: 0,
  } );
};


//# sourceMappingURL=interactionCountPolyfill.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getINP.js






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */
const getInteractionCountForNavigation = () => {
  return getInteractionCount();
};

// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const MAX_INTERACTIONS_TO_CONSIDER = 10;

// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const longestInteractionList = [];

// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const longestInteractionMap = {};

/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */
const processEntry = (entry) => {
  // The least-long of the 10 longest interactions.
  const minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const existingInteraction = longestInteractionMap[entry.interactionId];

  // Only process the entry if it's possibly one of the ten longest,
  // or if it's part of an existing interaction.
  if (
    existingInteraction ||
    longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER ||
    entry.duration > minLongestInteraction.latency
  ) {
    // If the interaction already exists, update it. Otherwise create one.
    if (existingInteraction) {
      existingInteraction.entries.push(entry);
      existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
    } else {
      const interaction = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: entry.interactionId,
        latency: entry.duration,
        entries: [entry],
      };
      longestInteractionMap[interaction.id] = interaction;
      longestInteractionList.push(interaction);
    }

    // Sort the entries by latency (descending) and keep only the top ten.
    longestInteractionList.sort((a, b) => b.latency - a.latency);
    longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(i => {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete longestInteractionMap[i.id];
    });
  }
};

/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */
const estimateP98LongestInteraction = () => {
  const candidateInteractionIndex = Math.min(
    longestInteractionList.length - 1,
    Math.floor(getInteractionCountForNavigation() / 50),
  );

  return longestInteractionList[candidateInteractionIndex];
};

/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onINP = (onReport, opts) => {
  // Set defaults
  // eslint-disable-next-line no-param-reassign
  opts = opts || {};

  // https://web.dev/inp/#what's-a-%22good%22-inp-value
  // const thresholds = [200, 500];

  // TODO(philipwalton): remove once the polyfill is no longer needed.
  initInteractionCountPolyfill();

  const metric = initMetric('INP');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntries = (entries) => {
    entries.forEach(entry => {
      if (entry.interactionId) {
        processEntry(entry);
      }

      // Entries of type `first-input` don't currently have an `interactionId`,
      // so to consider them in INP we have to first check that an existing
      // entry doesn't match the `duration` and `startTime`.
      // Note that this logic assumes that `event` entries are dispatched
      // before `first-input` entries. This is true in Chrome but it is not
      // true in Firefox; however, Firefox doesn't support interactionId, so
      // it's not an issue at the moment.
      // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
      if (entry.entryType === 'first-input') {
        const noMatchingEntry = !longestInteractionList.some(interaction => {
          return interaction.entries.some(prevEntry => {
            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
          });
        });
        if (noMatchingEntry) {
          processEntry(entry);
        }
      }
    });

    const inp = estimateP98LongestInteraction();

    if (inp && inp.latency !== metric.value) {
      metric.value = inp.latency;
      metric.entries = inp.entries;
      report();
    }
  };

  const po = observe('event', handleEntries, {
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    durationThreshold: opts.durationThreshold || 40,
  } );

  report = bindReporter(onReport, metric, opts.reportAllChanges);

  if (po) {
    // Also observe entries of type `first-input`. This is useful in cases
    // where the first interaction is less than the `durationThreshold`.
    po.observe({ type: 'first-input', buffered: true });

    (0,onHidden/* onHidden */.u)(() => {
      handleEntries(po.takeRecords() );

      // If the interaction count shows that there were interactions but
      // none were captured by the PerformanceObserver, report a latency of 0.
      if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
        metric.value = 0;
        metric.entries = [];
      }

      report(true);
    });
  }
};


//# sourceMappingURL=getINP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.Y)();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      if (types/* WINDOW.document */.m.document) {
        addEventListener(type, stopListening, { once: true, capture: true });
      }
    });

    (0,onHidden/* onHidden */.u)(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/onTTFB.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */
const whenReady = (callback) => {
  if (!types/* WINDOW.document */.m.document) {
    return;
  }

  if (types/* WINDOW.document.prerendering */.m.document.prerendering) {
    addEventListener('prerenderingchange', () => whenReady(callback), true);
  } else if (types/* WINDOW.document.readyState */.m.document.readyState !== 'complete') {
    addEventListener('load', () => whenReady(callback), true);
  } else {
    // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
  }
};

/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */
const onTTFB = (onReport, opts) => {
  // Set defaults
  // eslint-disable-next-line no-param-reassign
  opts = opts || {};

  // https://web.dev/ttfb/#what-is-a-good-ttfb-score
  // const thresholds = [800, 1800];

  const metric = initMetric('TTFB');
  const report = bindReporter(onReport, metric, opts.reportAllChanges);

  whenReady(() => {
    const navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)() ;

    if (navEntry) {
      // The activationStart reference is used because TTFB should be
      // relative to page activation rather than navigation start if the
      // page was prerendered. But in cases where `activationStart` occurs
      // after the first byte is received, this time should be clamped at 0.
      metric.value = Math.max(navEntry.responseStart - getActivationStart(), 0);

      // In some cases the value reported is negative or is larger
      // than the current page time. Ignore these cases:
      // https://github.com/GoogleChrome/web-vitals/issues/137
      // https://github.com/GoogleChrome/web-vitals/issues/162
      if (metric.value < 0 || metric.value > performance.now()) return;

      metric.entries = [navEntry];

      report(true);
    }
  });
};


//# sourceMappingURL=onTTFB.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js









const handlers = {};
const instrumented = {};

let _previousCls;
let _previousFid;
let _previousLcp;
let _previousTtfb;
let _previousInp;

/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */
function addClsInstrumentationHandler(
  callback,
  stopOnCallback = false,
) {
  return addMetricObserver('cls', callback, instrumentCls, _previousCls, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */
function addLcpInstrumentationHandler(
  callback,
  stopOnCallback = false,
) {
  return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 */
function addTtfbInstrumentationHandler(callback) {
  return addMetricObserver('ttfb', callback, instrumentTtfb, _previousTtfb);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addFidInstrumentationHandler(callback) {
  return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}

/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addInpInstrumentationHandler(
  callback,
) {
  return addMetricObserver('inp', callback, instrumentInp, _previousInp);
}

/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addPerformanceInstrumentationHandler(
  type,
  callback,
) {
  addHandler(type, callback);

  if (!instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrumented[type] = true;
  }

  return getCleanupCallback(type, callback);
}

/** Trigger all handlers of a given type. */
function triggerHandlers(type, data) {
  const typeHandlers = handlers[type];

  if (!typeHandlers || !typeHandlers.length) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      debug_build/* DEBUG_BUILD */.X &&
        logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

function instrumentCls() {
  return onCLS(
    metric => {
      triggerHandlers('cls', {
        metric,
      });
      _previousCls = metric;
    },
    { reportAllChanges: true },
  );
}

function instrumentFid() {
  return onFID(metric => {
    triggerHandlers('fid', {
      metric,
    });
    _previousFid = metric;
  });
}

function instrumentLcp() {
  return onLCP(metric => {
    triggerHandlers('lcp', {
      metric,
    });
    _previousLcp = metric;
  });
}

function instrumentTtfb() {
  return onTTFB(metric => {
    triggerHandlers('ttfb', {
      metric,
    });
    _previousTtfb = metric;
  });
}

function instrumentInp() {
  return onINP(metric => {
    triggerHandlers('inp', {
      metric,
    });
    _previousInp = metric;
  });
}

function addMetricObserver(
  type,
  callback,
  instrumentFn,
  previousValue,
  stopOnCallback = false,
) {
  addHandler(type, callback);

  let stopListening;

  if (!instrumented[type]) {
    stopListening = instrumentFn();
    instrumented[type] = true;
  }

  if (previousValue) {
    callback({ metric: previousValue });
  }

  return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}

function instrumentPerformanceObserver(type) {
  const options = {};

  // Special per-type options we want to use
  if (type === 'event') {
    options.durationThreshold = 0;
  }

  observe(
    type,
    entries => {
      triggerHandlers(type, { entries });
    },
    options,
  );
}

function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(handler);
}

// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(
  type,
  callback,
  stopListening,
) {
  return () => {
    if (stopListening) {
      stopListening();
    }

    const typeHandlers = handlers[type];

    if (!typeHandlers) {
      return;
    }

    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 29350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f7": function() { return /* binding */ addPerformanceEntries; },
  "NR": function() { return /* binding */ startTrackingINP; },
  "sn": function() { return /* binding */ startTrackingInteractions; },
  "Fv": function() { return /* binding */ startTrackingLongTasks; },
  "PR": function() { return /* binding */ startTrackingWebVitals; }
});

// UNUSED EXPORTS: _addMeasureSpans, _addResourceSpans

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(10959);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(73506);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/span.js


/**
 * Create envelope from Span item.
 */
function createSpanEnvelope(spans, dsn) {
  const headers = {
    sent_at: new Date().toISOString(),
  };

  if (dsn) {
    headers.dsn = (0,esm_dsn/* dsnToString */.RA)(dsn);
  }

  const items = spans.map(createSpanItem);
  return (0,envelope/* createEnvelope */.Jd)(headers, items);
}

function createSpanItem(span) {
  const spanHeaders = {
    type: 'span',
  };
  return [spanHeaders, span];
}


//# sourceMappingURL=span.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(77257);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(13976);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/span.js
var tracing_span = __webpack_require__(60649);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(4859);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/measurement.js
var measurement = __webpack_require__(3578);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(7554);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/sampling.js
var sampling = __webpack_require__(3745);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(24703);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(71207);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(84808);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/common/debug-build.js
var debug_build = __webpack_require__(20858);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(94423);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(28997);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
var getVisibilityWatcher = __webpack_require__(54469);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  // eslint-disable-next-line deprecation/deprecation
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
  }

  // eslint-disable-next-line deprecation/deprecation
  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js
var getNavigationEntry = __webpack_require__(64953);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js









const MAX_INT_AS_BYTES = 2147483647;

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
  return types/* WINDOW */.m && types/* WINDOW.addEventListener */.m.addEventListener && types/* WINDOW.performance */.m.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      types/* WINDOW.performance.mark */.m.performance.mark('sentry-tracing-init');
    }
    const fidCallback = _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();
    const ttfbCallback = _trackTtfb();

    return () => {
      fidCallback();
      clsCallback();
      lcpCallback();
      ttfbCallback();
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  (0,instrument/* addPerformanceInstrumentationHandler */._j)('longtask', ({ entries }) => {
    for (const entry of entries) {
      // eslint-disable-next-line deprecation/deprecation
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      // eslint-disable-next-line deprecation/deprecation
      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  (0,instrument/* addPerformanceInstrumentationHandler */._j)('event', ({ entries }) => {
    for (const entry of entries) {
      // eslint-disable-next-line deprecation/deprecation
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        const span = {
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          origin: 'auto.ui.browser.metrics',
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        };

        const componentName = (0,browser/* getComponentName */.iY)(entry.target);
        if (componentName) {
          span.attributes = { 'ui.component_name': componentName };
        }

        // eslint-disable-next-line deprecation/deprecation
        transaction.startChild(span);
      }
    }
  });
}

/**
 * Start tracking INP webvital events.
 */
function startTrackingINP(
  interactionIdtoRouteNameMapping,
  interactionsSampleRate,
) {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    const inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);

    return () => {
      inpCallback();
    };
  }

  return () => undefined;
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  return (0,instrument/* addClsInstrumentationHandler */.PR)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  }, true);
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return (0,instrument/* addLcpInstrumentationHandler */.$A)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  }, true);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  return (0,instrument/* addFidInstrumentationHandler */.to)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

function _trackTtfb() {
  return (0,instrument/* addTtfbInstrumentationHandler */._4)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
    _measurements['ttfb'] = { value: metric.value, unit: 'millisecond' };
  });
}

const INP_ENTRY_MAP = {
  click: 'click',
  pointerdown: 'click',
  pointerup: 'click',
  mousedown: 'click',
  mouseup: 'click',
  touchstart: 'click',
  touchend: 'click',
  mouseover: 'hover',
  mouseout: 'hover',
  mouseenter: 'hover',
  mouseleave: 'hover',
  pointerover: 'hover',
  pointerout: 'hover',
  pointerenter: 'hover',
  pointerleave: 'hover',
  dragstart: 'drag',
  dragend: 'drag',
  drag: 'drag',
  dragenter: 'drag',
  dragleave: 'drag',
  dragover: 'drag',
  drop: 'drag',
  keydown: 'press',
  keyup: 'press',
  keypress: 'press',
  input: 'press',
};

/** Starts tracking the Interaction to Next Paint on the current page. */
function _trackINP(
  interactionIdToRouteNameMapping,
  interactionsSampleRate,
) {
  return (0,instrument/* addInpInstrumentationHandler */.YF)(({ metric }) => {
    if (metric.value === undefined) {
      return;
    }
    const entry = metric.entries.find(
      entry => entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined,
    );
    const client = (0,esm_exports/* getClient */.s3)();
    if (!entry || !client) {
      return;
    }
    const interactionType = INP_ENTRY_MAP[entry.name];
    const options = client.getOptions();
    /** Build the INP span, create an envelope from the span, and then send the envelope */
    const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
    const duration = msToSec(metric.value);
    const interaction =
      entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
    if (interaction === undefined) {
      return;
    }
    const { routeName, parentContext, activeTransaction, user, replayId } = interaction;
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    // eslint-disable-next-line deprecation/deprecation
    const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
    const span = new tracing_span/* Span */.D({
      startTimestamp: startTime,
      endTimestamp: startTime + duration,
      op: `ui.interaction.${interactionType}`,
      name: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
      attributes: {
        release: options.release,
        environment: options.environment,
        transaction: routeName,
        ...(userDisplay !== undefined && userDisplay !== '' ? { user: userDisplay } : {}),
        ...(profileId !== undefined ? { profile_id: profileId } : {}),
        ...(replayId !== undefined ? { replay_id: replayId } : {}),
      },
      exclusiveTime: metric.value,
      measurements: {
        inp: { value: metric.value, unit: 'millisecond' },
      },
    });

    /** Check to see if the span should be sampled */
    const sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);

    if (!sampleRate) {
      return;
    }

    if (Math.random() < (sampleRate )) {
      const envelope = span ? createSpanEnvelope([span], client.getDsn()) : undefined;
      const transport = client && client.getTransport();
      if (transport && envelope) {
        transport.send(envelope).then(null, reason => {
          debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Error while sending interaction:', reason);
        });
      }
      return;
    }
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types/* WINDOW.performance.getEntries */.m.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  const { op, start_timestamp: transactionStartTime } = (0,spanUtils/* spanToJSON */.XU)(transaction);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    // eslint-disable-next-line deprecation/deprecation
    if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = (0,getVisibilityWatcher/* getVisibilityWatcher */.Y)();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        _addResourceSpans(transaction, entry, entry.name , startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (op === 'pageload') {
    _addTtfbRequestTimeToMeasurements(_measurements);

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
      const delta = normalizedValue - oldValue;

      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      (0,measurement/* setMeasurement */.o)(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    origin: 'auto.resource.browser.metrics',
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  if (entry.responseEnd) {
    // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
    // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
    // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
    // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
    _startChild(transaction, {
      op: 'browser',
      origin: 'auto.browser.browser.metrics',
      description: 'request',
      startTimestamp: timeOrigin + msToSec(entry.requestStart ),
      endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
    });

    _startChild(transaction, {
      op: 'browser',
      origin: 'auto.browser.browser.metrics',
      description: 'response',
      startTimestamp: timeOrigin + msToSec(entry.responseStart ),
      endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
    });
  }
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceUrl,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  const parsedUrl = (0,url/* parseUrl */.en)(resourceUrl);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
  setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
  setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');

  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }
  if (parsedUrl.protocol) {
    data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
  }

  if (parsedUrl.host) {
    data['server.address'] = parsedUrl.host;
  }

  data['url.same_origin'] = resourceUrl.includes(types/* WINDOW.location.origin */.m.location.origin);

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceUrl.replace(types/* WINDOW.location.origin */.m.location.origin, ''),
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    origin: 'auto.resource.browser.metrics',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types/* WINDOW.navigator */.m.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}

function setResourceEntrySizeData(
  data,
  entry,
  key,
  dataKey,
) {
  const entryVal = entry[key];
  if (entryVal != null && entryVal < MAX_INT_AS_BYTES) {
    data[dataKey] = entryVal;
  }
}

/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */
function _addTtfbRequestTimeToMeasurements(_measurements) {
  const navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
  if (!navEntry) {
    return;
  }

  const { responseStart, requestStart } = navEntry;

  if (requestStart <= responseStart) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Measurements] Adding TTFB Request Time');
    _measurements['ttfb.requestTime'] = {
      value: responseStart - requestStart,
      unit: 'millisecond',
    };
  }
}

/** Taken from @sentry/core sampling.ts */
function getSampleRate(
  transactionContext,
  options,
  interactionsSampleRate,
) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    return false;
  }
  let sampleRate;
  if (transactionContext !== undefined && typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler({
      transactionContext,
      name: transactionContext.name,
      parentSampled: transactionContext.parentSampled,
      attributes: {
        // eslint-disable-next-line deprecation/deprecation
        ...transactionContext.data,
        ...transactionContext.attributes,
      },
      location: types/* WINDOW.location */.m.location,
    });
  } else if (transactionContext !== undefined && transactionContext.sampled !== undefined) {
    sampleRate = transactionContext.sampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
  } else {
    sampleRate = 1;
  }
  if (!(0,sampling/* isValidSampleRate */.X)(sampleRate)) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('[Tracing] Discarding interaction span because of invalid sample rate.');
    return false;
  }
  if (sampleRate === true) {
    return interactionsSampleRate;
  } else if (sampleRate === false) {
    return 0;
  }
  return sampleRate * interactionsSampleRate;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 79727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k3": function() { return /* binding */ defaultRequestInstrumentationOptions; },
  "L7": function() { return /* binding */ instrumentOutgoingRequests; }
});

// UNUSED EXPORTS: DEFAULT_TRACE_PROPAGATION_TARGETS, extractNetworkProtocol, shouldAttachHeaders, xhrCallback

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(4859);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(7554);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(35818);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(13976);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(10857);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(28218);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(46595);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(59278);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/fetch.js
var fetch = __webpack_require__(61245);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/url.js
var esm_url = __webpack_require__(84808);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(52868);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(24703);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(1466);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(75771);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(28308);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(48593);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/common/fetch.js



/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */
function instrumentFetchRequest(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
  spanOrigin = 'auto.http.browser',
) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !handlerData.fetchData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      endSpan(span, handlerData);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const client = (0,esm_exports/* getClient */.s3)();

  const { method, url } = handlerData.fetchData;

  const fullUrl = getFullURL(url);
  const host = fullUrl ? (0,esm_url/* parseUrl */.en)(fullUrl).host : undefined;

  const span = shouldCreateSpanResult
    ? (0,trace/* startInactiveSpan */.qp)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
          url,
          type: 'fetch',
          'http.method': method,
          'http.url': fullUrl,
          'server.address': host,
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: spanOrigin,
        },
        op: 'http.client',
      })
    : undefined;

  if (span) {
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
  }

  if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span);
  }

  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  client,
  scope,
  options

,
  requestSpan,
) {
  // eslint-disable-next-line deprecation/deprecation
  const span = requestSpan || scope.getSpan();

  const isolationScope = (0,hub/* getIsolationScope */.aF)();

  const { traceId, spanId, sampled, dsc } = {
    ...isolationScope.getPropagationContext(),
    ...scope.getPropagationContext(),
  };

  const sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);

  const sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(
    dsc ||
      (span ? (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)),
  );

  const headers =
    options.headers ||
    (typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : undefined);

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

function getFullURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}

function endSpan(span, handlerData) {
  if (handlerData.response) {
    (0,spanstatus/* setHttpStatus */.Q0)(span, handlerData.response.status);

    const contentLength =
      handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

    if (contentLength) {
      const contentLengthNum = parseInt(contentLength);
      if (contentLengthNum > 0) {
        span.setAttribute('http.response_content_length', contentLengthNum);
      }
    }
  } else if (handlerData.error) {
    span.setStatus('internal_error');
  }
  span.end();
}


//# sourceMappingURL=fetch.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(94423);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(28997);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/request.js






/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const {
    traceFetch,
    traceXHR,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,fetch/* addFetchInstrumentationHandler */.U)(handlerData => {
      const createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      // We cannot use `window.location` in the generic fetch instrumentation,
      // but we need it for reliable `server.address` attribute.
      // so we extend this in here
      if (createdSpan) {
        const fullUrl = request_getFullURL(handlerData.fetchData.url);
        const host = fullUrl ? (0,esm_url/* parseUrl */.en)(fullUrl).host : undefined;
        createdSpan.setAttributes({
          'http.url': fullUrl,
          'server.address': host,
        });
      }

      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    (0,instrument_xhr/* addXhrInstrumentationHandler */.UK)(handlerData => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

function isPerformanceResourceTiming(entry) {
  return (
    entry.entryType === 'resource' &&
    'initiatorType' in entry &&
    typeof (entry ).nextHopProtocol === 'string' &&
    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
  );
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const { url } = (0,spanUtils/* spanToJSON */.XU)(span).data || {};

  if (!url || typeof url !== 'string') {
    return;
  }

  const cleanup = (0,instrument/* addPerformanceInstrumentationHandler */._j)('resource', ({ entries }) => {
    entries.forEach(entry => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setAttribute(...data));
        // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done
        setTimeout(cleanup);
      }
    });
  });
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return { name, version };
}

function getAbsoluteTime(time = 0) {
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);

  const timingSpanData = [];

  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
    return timingSpanData;
  }
  return [
    ...timingSpanData,
    ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)],
    ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)],
    ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)],
    ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)],
    ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)],
    ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)],
    ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)],
    ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)],
    ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)],
    ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)],
  ];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];

  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span && sentryXhrData.status_code !== undefined) {
      (0,spanstatus/* setHttpStatus */.Q0)(span, sentryXhrData.status_code);
      span.end();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const isolationScope = (0,hub/* getIsolationScope */.aF)();

  const fullUrl = request_getFullURL(sentryXhrData.url);
  const host = fullUrl ? (0,esm_url/* parseUrl */.en)(fullUrl).host : undefined;

  const span = shouldCreateSpanResult
    ? (0,trace/* startInactiveSpan */.qp)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
          type: 'xhr',
          'http.method': sentryXhrData.method,
          'http.url': fullUrl,
          url: sentryXhrData.url,
          'server.address': host,
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.http.browser',
        },
        op: 'http.client',
      })
    : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  const client = (0,esm_exports/* getClient */.s3)();

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
    const { traceId, spanId, sampled, dsc } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext(),
    };

    const sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);

    const sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(
      dsc ||
        (span ? (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)),
    );

    setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
  }

  return span;
}

function setHeaderOnXhr(
  xhr,
  sentryTraceHeader,
  sentryBaggageHeader,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}

function request_getFullURL(url) {
  try {
    // By adding a base URL to new URL(), this will also work for relative urls
    // If `url` is a full URL, the base URL is ignored anyhow
    const parsed = new URL(url, types/* WINDOW.location.origin */.m.location.origin);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}


//# sourceMappingURL=request.js.map


/***/ }),

/***/ 28997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ WINDOW; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);


const WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2

;


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 64953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getNavigationEntry; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28997);


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance.timing */ .m.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance.navigation.type */ .m.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      // eslint-disable-next-line deprecation/deprecation
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.__WEB_VITALS_POLYFILL__ */ .m.__WEB_VITALS_POLYFILL__) {
    return (
      _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance */ .m.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance */ .m.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map


/***/ }),

/***/ 54469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getVisibilityWatcher; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28997);
/* harmony import */ var _onHidden_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57748);



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document && _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.visibilityState */ .m.document.visibilityState) {
    firstHiddenTime = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.visibilityState */ .m.document.visibilityState === 'hidden' && !_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.prerendering */ .m.document.prerendering ? 0 : Infinity;
  }
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  (0,_onHidden_js__WEBPACK_IMPORTED_MODULE_1__/* .onHidden */ .u)(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map


/***/ }),

/***/ 57748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ onHidden; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28997);


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.visibilityState */ .m.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };

  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document) {
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
  }
};


//# sourceMappingURL=onHidden.js.map


/***/ }),

/***/ 20858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 34101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ BrowserClient; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/baseclient.js + 1 modules
var baseclient = __webpack_require__(61335);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(61650);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(73506);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(24703);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return (0,envelope/* createEnvelope */.Jd)(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(3932);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(10959);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/debug-build.js
var debug_build = __webpack_require__(71673);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(2382);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(14828);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(54832);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends baseclient/* BaseClient */.W {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers/* WINDOW.SENTRY_SDK_SOURCE */.m9.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();
    (0,sdkMetadata/* applySdkMetadata */.V)(options, 'browser', ['browser'], sdkSource);

    super(options);

    if (options.sendClientReports && helpers/* WINDOW.document */.m9.document) {
      helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('visibilitychange', () => {
        if (helpers/* WINDOW.document.visibilityState */.m9.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return (0,eventbuilder/* eventFromException */.dr)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return (0,eventbuilder/* eventFromMessage */.aB)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = (0,userfeedback/* createUserFeedbackEnvelope */.r)(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    // This is really the only place where we want to check for a DSN and only send outcomes then
    if (!this._dsn) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,dsn/* dsnToString */.RA)(this._dsn));

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map


/***/ }),

/***/ 71673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 2382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dr": function() { return /* binding */ eventFromException; },
/* harmony export */   "aB": function() { return /* binding */ eventFromMessage; },
/* harmony export */   "ME": function() { return /* binding */ eventFromUnknownInput; },
/* harmony export */   "GJ": function() { return /* binding */ exceptionFromError; }
/* harmony export */ });
/* unused harmony exports eventFromError, eventFromPlainObject, eventFromString, parseStackFrames */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48593);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14600);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17954);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76721);



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }),
        },
      ],
    },
    extra: {
      __serialized__: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .normalizeToSize */ .Qy)(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .resolvedSyncPromise */ .WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .resolvedSyncPromise */ .WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMException */ .fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isError */ .VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, `${exception}`, undefined);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  message,
  syntheticException,
  attachStacktrace,
) {
  const event = {};

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: message, stacktrace: { frames } }],
      };
    }
  }

  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isParameterizedString */ .Le)(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;

    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__,
    };
    return event;
  }

  event.message = message;
  return event;
}

function getNonErrorObjectExceptionValue(
  exception,
  { isUnhandledRejection },
) {
  const keys = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .extractExceptionKeysForMessage */ .zf)(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }

  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }

  return `Object captured as ${captureType} with keys: ${keys}`;
}

function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}


//# sourceMappingURL=eventbuilder.js.map


/***/ }),

/***/ 14828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m9": function() { return /* binding */ WINDOW; },
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40901);




const WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      if (typeof wrapper === 'function') {
        return wrapper;
      } else {
        // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
        // that something messed with it. In that case we want to return the originally passed function.
        return fn;
      }
    }

    // We don't wanna wrap it twice
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(scope => {
        scope.addEventProcessor(event => {
          if (options.mechanism) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 34615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oo": function() { return /* reexport */ breadcrumbs/* Breadcrumbs */.O; },
  "RE": function() { return /* reexport */ client/* BrowserClient */.R; },
  "_p": function() { return /* reexport */ BrowserProfilingIntegration; },
  "Iq": function() { return /* reexport */ dedupe/* Dedupe */.I; },
  "x2": function() { return /* reexport */ Feedback; },
  "cq": function() { return /* reexport */ functiontostring/* FunctionToString */.c; },
  "dJ": function() { return /* reexport */ globalhandlers/* GlobalHandlers */.d; },
  "qT": function() { return /* reexport */ httpcontext/* HttpContext */.q; },
  "Xb": function() { return /* reexport */ hub/* Hub */.Xb; },
  "QD": function() { return /* reexport */ inboundfilters/* InboundFilters */.Q; },
  "jK": function() { return /* binding */ INTEGRATIONS; },
  "iP": function() { return /* reexport */ linkederrors/* LinkedErrors */.i; },
  "_e": function() { return /* reexport */ ModuleMetadata; },
  "UH": function() { return /* reexport */ Replay$1; },
  "$r": function() { return /* reexport */ ReplayCanvas; },
  "Jn": function() { return /* reexport */ version/* SDK_VERSION */.J; },
  "$J": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J; },
  "S3": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3; },
  "TE": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.TE; },
  "Zj": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj; },
  "sX": function() { return /* reexport */ scope/* Scope */.sX; },
  "pT": function() { return /* reexport */ trycatch/* TryCatch */.p; },
  "m9": function() { return /* reexport */ helpers/* WINDOW */.m9; },
  "n_": function() { return /* reexport */ esm_exports/* addBreadcrumb */.n_; },
  "Qy": function() { return /* reexport */ baseclient/* addEventProcessor */.Q; },
  "cc": function() { return /* reexport */ eventProcessors/* addGlobalEventProcessor */.cc; },
  "M5": function() { return /* reexport */ integration/* addIntegration */.M5; },
  "Ts": function() { return /* reexport */ hubextensions/* addTracingExtensions */.T; },
  "fQ": function() { return /* reexport */ breadcrumbs/* breadcrumbsIntegration */.f; },
  "tP": function() { return /* reexport */ trycatch/* browserApiErrorsIntegration */.t; },
  "xF": function() { return /* reexport */ browserProfilingIntegration; },
  "Xs": function() { return /* reexport */ captureConsoleIntegration; },
  "eN": function() { return /* reexport */ esm_exports/* captureEvent */.eN; },
  "Tb": function() { return /* reexport */ esm_exports/* captureException */.Tb; },
  "uT": function() { return /* reexport */ esm_exports/* captureMessage */.uT; },
  "cg": function() { return /* reexport */ esm_exports/* captureSession */.cg; },
  "Jd": function() { return /* reexport */ esm_sdk/* captureUserFeedback */.Jd; },
  "$3": function() { return /* reexport */ stack_parsers/* chromeStackLineParser */.$3; },
  "xv": function() { return /* reexport */ esm_exports/* close */.xv; },
  "e": function() { return /* reexport */ esm_exports/* configureScope */.e; },
  "SZ": function() { return /* reexport */ contextLinesIntegration; },
  "yn": function() { return /* reexport */ trace/* continueTrace */.yn; },
  "qv": function() { return /* reexport */ base/* createTransport */.q; },
  "rQ": function() { return /* reexport */ userfeedback/* createUserFeedbackEnvelope */.r; },
  "sC": function() { return /* reexport */ debugIntegration; },
  "RH": function() { return /* reexport */ dedupeIntegration; },
  "SS": function() { return /* reexport */ esm_sdk/* defaultIntegrations */.SS; },
  "k3": function() { return /* reexport */ request/* defaultRequestInstrumentationOptions */.k3; },
  "d8": function() { return /* reexport */ stack_parsers/* defaultStackLineParsers */.d8; },
  "Dt": function() { return /* reexport */ stack_parsers/* defaultStackParser */.Dt; },
  "TM": function() { return /* reexport */ esm_exports/* endSession */.TM; },
  "dr": function() { return /* reexport */ eventbuilder/* eventFromException */.dr; },
  "aB": function() { return /* reexport */ eventbuilder/* eventFromMessage */.aB; },
  "GJ": function() { return /* reexport */ eventbuilder/* exceptionFromError */.GJ; },
  "EY": function() { return /* reexport */ extraErrorDataIntegration; },
  "qG": function() { return /* reexport */ tracing_utils/* extractTraceparentData */.qG; },
  "Xc": function() { return /* reexport */ feedbackIntegration; },
  "yl": function() { return /* reexport */ esm_exports/* flush */.yl; },
  "Eg": function() { return /* reexport */ esm_sdk/* forceLoad */.Eg; },
  "CP": function() { return /* reexport */ functiontostring/* functionToStringIntegration */.C; },
  "$Q": function() { return /* reexport */ stack_parsers/* geckoStackLineParser */.$Q; },
  "HN": function() { return /* reexport */ trace/* getActiveSpan */.HN; },
  "x1": function() { return /* reexport */ tracing_utils/* getActiveTransaction */.x1; },
  "s3": function() { return /* reexport */ esm_exports/* getClient */.s3; },
  "Gd": function() { return /* reexport */ hub/* getCurrentHub */.Gd; },
  "nZ": function() { return /* reexport */ esm_exports/* getCurrentScope */.nZ; },
  "nV": function() { return /* reexport */ esm_sdk/* getDefaultIntegrations */.nV; },
  "vi": function() { return /* reexport */ hub/* getHubFromCarrier */.vi; },
  "TF": function() { return /* reexport */ getReplay$1; },
  "ix": function() { return /* reexport */ spanstatus/* getSpanStatusFromHttpCode */.ix; },
  "ks": function() { return /* reexport */ globalhandlers/* globalHandlersIntegration */.k; },
  "lQ": function() { return /* reexport */ httpClientIntegration; },
  "sA": function() { return /* reexport */ httpcontext/* httpContextIntegration */.s; },
  "SG": function() { return /* reexport */ inboundfilters/* inboundFiltersIntegration */.S; },
  "L7": function() { return /* reexport */ request/* instrumentOutgoingRequests */.L7; },
  "dk": function() { return /* reexport */ esm_exports/* isInitialized */.dk; },
  "eW": function() { return /* reexport */ esm_exports/* lastEventId */.eW; },
  "OB": function() { return /* reexport */ linkederrors/* linkedErrorsIntegration */.O; },
  "O1": function() { return /* reexport */ makeBrowserOfflineTransport; },
  "fD": function() { return /* reexport */ fetch/* makeFetchTransport */.f; },
  "pj": function() { return /* reexport */ hub/* makeMain */.pj; },
  "Wq": function() { return /* reexport */ makeMultiplexedTransport; },
  "KC": function() { return /* reexport */ xhr/* makeXHRTransport */.K; },
  "qI": function() { return /* reexport */ metrics; },
  "wo": function() { return /* reexport */ moduleMetadataIntegration; },
  "lA": function() { return /* reexport */ esm_sdk/* onLoad */.lA; },
  "Uv": function() { return /* reexport */ onProfilingStartRouteTransaction; },
  "NP": function() { return /* reexport */ stack_parsers/* opera10StackLineParser */.NP; },
  "HH": function() { return /* reexport */ stack_parsers/* opera11StackLineParser */.HH; },
  "XB": function() { return /* reexport */ parameterize; },
  "mz": function() { return /* reexport */ replayCanvasIntegration; },
  "Gs": function() { return /* reexport */ replayIntegration$1; },
  "yt": function() { return /* reexport */ reportingObserverIntegration; },
  "fA": function() { return /* reexport */ sendFeedback; },
  "rE": function() { return /* reexport */ sessionTimingIntegration; },
  "v": function() { return /* reexport */ esm_exports/* setContext */.v; },
  "KW": function() { return /* reexport */ sdk/* setCurrentClient */.K; },
  "sU": function() { return /* reexport */ esm_exports/* setExtra */.sU; },
  "rJ": function() { return /* reexport */ esm_exports/* setExtras */.rJ; },
  "Q0": function() { return /* reexport */ spanstatus/* setHttpStatus */.Q0; },
  "oi": function() { return /* reexport */ measurement/* setMeasurement */.o; },
  "YA": function() { return /* reexport */ esm_exports/* setTag */.YA; },
  "mG": function() { return /* reexport */ esm_exports/* setTags */.mG; },
  "av": function() { return /* reexport */ esm_exports/* setUser */.av; },
  "jp": function() { return /* reexport */ esm_sdk/* showReportDialog */.jp; },
  "Zd": function() { return /* reexport */ spanstatus/* spanStatusfromHttpCode */.Zd; },
  "og": function() { return /* reexport */ browserTracingIntegration/* startBrowserTracingNavigationSpan */.og; },
  "Wo": function() { return /* reexport */ browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo; },
  "qp": function() { return /* reexport */ trace/* startInactiveSpan */.qp; },
  "yj": function() { return /* reexport */ esm_exports/* startSession */.yj; },
  "GK": function() { return /* reexport */ trace/* startSpan */.GK; },
  "V0": function() { return /* reexport */ trace/* startSpanManual */.V0; },
  "Yr": function() { return /* reexport */ esm_exports/* startTransaction */.Yr; },
  "g4": function() { return /* reexport */ trace/* trace */.g4; },
  "R2": function() { return /* reexport */ stack_parsers/* winjsStackLineParser */.R2; },
  "_d": function() { return /* reexport */ esm_exports/* withActiveSpan */._d; },
  "wi": function() { return /* reexport */ esm_exports/* withIsolationScope */.wi; },
  "$e": function() { return /* reexport */ esm_exports/* withScope */.$e; },
  "re": function() { return /* reexport */ esm_sdk/* wrap */.re; }
});

// UNUSED EXPORTS: BrowserTracing, browserTracingIntegration, init, rewriteFramesIntegration

// NAMESPACE OBJECT: ../../node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return functiontostring/* FunctionToString */.c; },
  "InboundFilters": function() { return inboundfilters/* InboundFilters */.Q; },
  "LinkedErrors": function() { return LinkedErrors; }
});

// NAMESPACE OBJECT: ../../node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return breadcrumbs/* Breadcrumbs */.O; },
  "Dedupe": function() { return dedupe/* Dedupe */.I; },
  "GlobalHandlers": function() { return globalhandlers/* GlobalHandlers */.d; },
  "HttpContext": function() { return httpcontext/* HttpContext */.q; },
  "LinkedErrors": function() { return linkederrors/* LinkedErrors */.i; },
  "TryCatch": function() { return trycatch/* TryCatch */.p; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(17661);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(33931);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/aggregate-errors.js
var aggregate_errors = __webpack_require__(84596);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/eventbuilder.js





/**
 * Extracts stack frames from the error.stack string
 */
function parseStackFrames(stackParser, error) {
  return stackParser(error.stack || '', 1);
}

/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */
function exceptionFromError(stackParser, error) {
  const exception = {
    type: error.name || error.constructor.name,
    value: error.message,
  };

  const frames = parseStackFrames(stackParser, error);
  if (frames.length) {
    exception.stacktrace = { frames };
  }

  return exception;
}

function getMessageForObject(exception) {
  if ('name' in exception && typeof exception.name === 'string') {
    let message = `'${exception.name}' captured as exception`;

    if ('message' in exception && typeof exception.message === 'string') {
      message += ` with message '${exception.message}'`;
    }

    return message;
  } else if ('message' in exception && typeof exception.message === 'string') {
    return exception.message;
  } else {
    // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${extractExceptionKeysForMessage(
      exception ,
    )}`;
  }
}

/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */
function eventFromUnknownInput(
  // eslint-disable-next-line deprecation/deprecation
  getHubOrClient,
  stackParser,
  exception,
  hint,
) {
  const client =
    typeof getHubOrClient === 'function'
      ? // eslint-disable-next-line deprecation/deprecation
        getHubOrClient().getClient()
      : getHubOrClient;

  let ex = exception;
  const providedMechanism =
    hint && hint.data && (hint.data ).mechanism;
  const mechanism = providedMechanism || {
    handled: true,
    type: 'generic',
  };

  let extras;

  if (!isError(exception)) {
    if (isPlainObject(exception)) {
      const normalizeDepth = client && client.getOptions().normalizeDepth;
      extras = { ['__serialized__']: normalizeToSize(exception , normalizeDepth) };

      const message = getMessageForObject(exception);
      ex = (hint && hint.syntheticException) || new Error(message);
      (ex ).message = message;
    } else {
      // This handles when someone does: `throw "something awesome";`
      // We use synthesized Error here so we can extract a (rough) stack trace.
      ex = (hint && hint.syntheticException) || new Error(exception );
      (ex ).message = exception ;
    }
    mechanism.synthetic = true;
  }

  const event = {
    exception: {
      values: [exceptionFromError(stackParser, ex )],
    },
  };

  if (extras) {
    event.extra = extras;
  }

  addExceptionTypeValue(event, undefined, undefined);
  addExceptionMechanism(event, mechanism);

  return {
    ...event,
    event_id: hint && hint.event_id,
  };
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const event = {
    event_id: hint && hint.event_id,
    level,
  };

  if (attachStacktrace && hint && hint.syntheticException) {
    const frames = parseStackFrames(stackParser, hint.syntheticException);
    if (frames.length) {
      event.exception = {
        values: [
          {
            value: message,
            stacktrace: { frames },
          },
        ],
      };
    }
  }

  if (isParameterizedString(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;

    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__,
    };
    return event;
  }

  event.message = message;
  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(56102);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/linkederrors.js



const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

const INTEGRATION_NAME = 'LinkedErrors';

const _linkedErrorsIntegration = ((options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;

  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event, hint, client) {
      const options = client.getOptions();

      (0,aggregate_errors/* applyAggregateErrorsToEvent */.Z)(
        exceptionFromError,
        options.stackParser,
        options.maxValueLength,
        key,
        limit,
        event,
        hint,
      );
    },
  };
}) ;

const linkedErrorsIntegration = (0,integration/* defineIntegration */._I)(_linkedErrorsIntegration);

/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const LinkedErrors = (0,integration/* convertIntegrationFnToClass */.RN)(INTEGRATION_NAME, linkedErrorsIntegration)

;


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/index.js




/* eslint-disable deprecation/deprecation */
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/index.js















































/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */
const Integrations = integrations_namespaceObject;


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(73506);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(81539);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metadata.js


/** Keys are source filename/url, values are metadata objects. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */
const parsedStacks = new Set();

function ensureMetadataStacksAreParsed(parser) {
  if (!worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata) {
    return;
  }

  for (const stack of Object.keys(worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata)) {
    const metadata = worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata[stack];

    if (parsedStacks.has(stack)) {
      continue;
    }

    // Ensure this stack doesn't get parsed again
    parsedStacks.add(stack);

    const frames = parser(stack);

    // Go through the frames starting from the top of the stack and find the first one with a filename
    for (const frame of frames.reverse()) {
      if (frame.filename) {
        // Save the metadata for this filename
        filenameMetadataMap.set(frame.filename, metadata);
        break;
      }
    }
  }
}

/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
  ensureMetadataStacksAreParsed(parser);
  return filenameMetadataMap.get(filename);
}

/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */
function addMetadataToStackFrames(parser, event) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      if (!exception.stacktrace) {
        return;
      }

      for (const frame of exception.stacktrace.frames || []) {
        if (!frame.filename) {
          continue;
        }

        const metadata = getMetadataForUrl(parser, frame.filename);

        if (metadata) {
          frame.module_metadata = metadata;
        }
      }
    });
  } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Strips metadata from stack frames.
 */
function stripMetadataFromStackFrames(event) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      if (!exception.stacktrace) {
        return;
      }

      for (const frame of exception.stacktrace.frames || []) {
        delete frame.module_metadata;
      }
    });
  } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/metadata.js




const metadata_INTEGRATION_NAME = 'ModuleMetadata';

const _moduleMetadataIntegration = (() => {
  return {
    name: metadata_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      if (typeof client.on !== 'function') {
        return;
      }

      // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
      client.on('beforeEnvelope', envelope => {
        (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
          if (type === 'event') {
            const event = Array.isArray(item) ? (item )[1] : undefined;

            if (event) {
              stripMetadataFromStackFrames(event);
              item[1] = event;
            }
          }
        });
      });
    },

    processEvent(event, _hint, client) {
      const stackParser = client.getOptions().stackParser;
      addMetadataToStackFrames(stackParser, event);
      return event;
    },
  };
}) ;

const moduleMetadataIntegration = (0,integration/* defineIntegration */._I)(_moduleMetadataIntegration);

/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const ModuleMetadata = (0,integration/* convertIntegrationFnToClass */.RN)(
  metadata_INTEGRATION_NAME,
  moduleMetadataIntegration,
)

;


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(10959);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(74988);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/multiplexed.js



/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */
function eventFromEnvelope(env, types) {
  let event;

  (0,esm_envelope/* forEachEnvelopeItem */.gv)(env, (item, type) => {
    if (types.includes(type)) {
      event = Array.isArray(item) ? (item )[1] : undefined;
    }
    // bail out if we found an event
    return !!event;
  });

  return event;
}

/**
 * Creates a transport that overrides the release on all events.
 */
function makeOverrideReleaseTransport(
  createTransport,
  release,
) {
  return options => {
    const transport = createTransport(options);

    return {
      ...transport,
      send: async (envelope) => {
        const event = eventFromEnvelope(envelope, ['event', 'transaction', 'profile', 'replay_event']);

        if (event) {
          event.release = release;
        }
        return transport.send(envelope);
      },
    };
  };
}

/** Overrides the DSN in the envelope header  */
function overrideDsn(envelope, dsn) {
  return (0,esm_envelope/* createEnvelope */.Jd)(
    dsn
      ? {
          ...envelope[0],
          dsn,
        }
      : envelope[0],
    envelope[1],
  );
}

/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */
function makeMultiplexedTransport(
  createTransport,
  matcher,
) {
  return options => {
    const fallbackTransport = createTransport(options);
    const otherTransports = new Map();

    function getTransport(dsn, release) {
      // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
      // use at the same time
      const key = release ? `${dsn}:${release}` : dsn;

      let transport = otherTransports.get(key);

      if (!transport) {
        const validatedDsn = (0,esm_dsn/* dsnFromString */.U4)(dsn);
        if (!validatedDsn) {
          return undefined;
        }

        const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(validatedDsn, options.tunnel);

        transport = release
          ? makeOverrideReleaseTransport(createTransport, release)({ ...options, url })
          : createTransport({ ...options, url });

        otherTransports.set(key, transport);
      }

      return [dsn, transport];
    }

    async function send(envelope) {
      function getEvent(types) {
        const eventTypes = types && types.length ? types : ['event'];
        return eventFromEnvelope(envelope, eventTypes);
      }

      const transports = matcher({ envelope, getEvent })
        .map(result => {
          if (typeof result === 'string') {
            return getTransport(result, undefined);
          } else {
            return getTransport(result.dsn, result.release);
          }
        })
        .filter((t) => !!t);

      // If we have no transports to send to, use the fallback transport
      if (transports.length === 0) {
        // Don't override the DSN in the header for the fallback transport. '' is falsy
        transports.push(['', fallbackTransport]);
      }

      const results = await Promise.all(
        transports.map(([dsn, transport]) => transport.send(overrideDsn(envelope, dsn))),
      );

      return results[0];
    }

    async function flush(timeout) {
      const promises = [await fallbackTransport.flush(timeout)];
      for (const [, transport] of otherTransports) {
        promises.push(await transport.flush(timeout));
      }

      return promises.every(r => r);
    }

    return {
      send,
      flush,
    };
  };
}


//# sourceMappingURL=multiplexed.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(42598);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(13976);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(4859);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/constants.js
const COUNTER_METRIC_TYPE = 'c' ;
const GAUGE_METRIC_TYPE = 'g' ;
const SET_METRIC_TYPE = 's' ;
const DISTRIBUTION_METRIC_TYPE = 'd' ;

/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */
const DEFAULT_BROWSER_FLUSH_INTERVAL = 5000;

/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */
const DEFAULT_FLUSH_INTERVAL = 10000;

/**
 * The maximum number of metrics that should be stored in memory.
 */
const MAX_WEIGHT = 10000;


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(24703);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/metrics/utils.js
var utils = __webpack_require__(41666);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/instance.js



/**
 * A metric instance representing a counter.
 */
class CounterMetric  {
   constructor( _value) {this._value = _value;}

  /** @inheritDoc */
   get weight() {
    return 1;
  }

  /** @inheritdoc */
   add(value) {
    this._value += value;
  }

  /** @inheritdoc */
   toString() {
    return `${this._value}`;
  }
}

/**
 * A metric instance representing a gauge.
 */
class GaugeMetric  {

   constructor(value) {
    this._last = value;
    this._min = value;
    this._max = value;
    this._sum = value;
    this._count = 1;
  }

  /** @inheritDoc */
   get weight() {
    return 5;
  }

  /** @inheritdoc */
   add(value) {
    this._last = value;
    if (value < this._min) {
      this._min = value;
    }
    if (value > this._max) {
      this._max = value;
    }
    this._sum += value;
    this._count++;
  }

  /** @inheritdoc */
   toString() {
    return `${this._last}:${this._min}:${this._max}:${this._sum}:${this._count}`;
  }
}

/**
 * A metric instance representing a distribution.
 */
class DistributionMetric  {

   constructor(first) {
    this._value = [first];
  }

  /** @inheritDoc */
   get weight() {
    return this._value.length;
  }

  /** @inheritdoc */
   add(value) {
    this._value.push(value);
  }

  /** @inheritdoc */
   toString() {
    return this._value.join(':');
  }
}

/**
 * A metric instance representing a set.
 */
class SetMetric  {

   constructor( first) {this.first = first;
    this._value = new Set([first]);
  }

  /** @inheritDoc */
   get weight() {
    return this._value.size;
  }

  /** @inheritdoc */
   add(value) {
    this._value.add(value);
  }

  /** @inheritdoc */
   toString() {
    return Array.from(this._value)
      .map(val => (typeof val === 'string' ? (0,utils/* simpleHash */.M)(val) : val))
      .join(':');
  }
}

const METRIC_MAP = {
  [COUNTER_METRIC_TYPE]: CounterMetric,
  [GAUGE_METRIC_TYPE]: GaugeMetric,
  [DISTRIBUTION_METRIC_TYPE]: DistributionMetric,
  [SET_METRIC_TYPE]: SetMetric,
};


//# sourceMappingURL=instance.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/metrics/metric-summary.js
var metric_summary = __webpack_require__(40454);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/browser-aggregator.js






/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */
class BrowserMetricsAggregator  {
  // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
  // when the aggregator is garbage collected.
  // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry

   constructor(  _client) {this._client = _client;
    this._buckets = new Map();
    this._interval = setInterval(() => this.flush(), DEFAULT_BROWSER_FLUSH_INTERVAL);
  }

  /**
   * @inheritDoc
   */
   add(
    metricType,
    unsanitizedName,
    value,
    unsanitizedUnit = 'none',
    unsanitizedTags = {},
    maybeFloatTimestamp = (0,esm_time/* timestampInSeconds */.ph)(),
  ) {
    const timestamp = Math.floor(maybeFloatTimestamp);
    const name = (0,utils/* sanitizeMetricKey */.s3)(unsanitizedName);
    const tags = (0,utils/* sanitizeTags */.Bg)(unsanitizedTags);
    const unit = (0,utils/* sanitizeUnit */.OC)(unsanitizedUnit );

    const bucketKey = (0,utils/* getBucketKey */.Ic)(metricType, name, unit, tags);

    let bucketItem = this._buckets.get(bucketKey);
    // If this is a set metric, we need to calculate the delta from the previous weight.
    const previousWeight = bucketItem && metricType === SET_METRIC_TYPE ? bucketItem.metric.weight : 0;

    if (bucketItem) {
      bucketItem.metric.add(value);
      // TODO(abhi): Do we need this check?
      if (bucketItem.timestamp < timestamp) {
        bucketItem.timestamp = timestamp;
      }
    } else {
      bucketItem = {
        // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
        metric: new METRIC_MAP[metricType](value),
        timestamp,
        metricType,
        name,
        unit,
        tags,
      };
      this._buckets.set(bucketKey, bucketItem);
    }

    // If value is a string, it's a set metric so calculate the delta from the previous weight.
    const val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
    (0,metric_summary/* updateMetricSummaryOnActiveSpan */.v)(metricType, name, val, unit, unsanitizedTags, bucketKey);
  }

  /**
   * @inheritDoc
   */
   flush() {
    // short circuit if buckets are empty.
    if (this._buckets.size === 0) {
      return;
    }

    if (this._client.captureAggregateMetrics) {
      // TODO(@anonrig): Use Object.values() when we support ES6+
      const metricBuckets = Array.from(this._buckets).map(([, bucketItem]) => bucketItem);
      this._client.captureAggregateMetrics(metricBuckets);
    }

    this._buckets.clear();
  }

  /**
   * @inheritDoc
   */
   close() {
    clearInterval(this._interval);
    this.flush();
  }
}


//# sourceMappingURL=browser-aggregator.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/integration.js



const integration_INTEGRATION_NAME = 'MetricsAggregator';

const _metricsAggregatorIntegration = (() => {
  return {
    name: integration_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      client.metricsAggregator = new BrowserMetricsAggregator(client);
    },
  };
}) ;

const metricsAggregatorIntegration = (0,integration/* defineIntegration */._I)(_metricsAggregatorIntegration);

/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const MetricsAggregator = (0,integration/* convertIntegrationFnToClass */.RN)(
  integration_INTEGRATION_NAME,
  metricsAggregatorIntegration,
) ;


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/exports.js







function addToMetricsAggregator(
  metricType,
  name,
  value,
  data = {},
) {
  const client = (0,esm_exports/* getClient */.s3)();
  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  if (client) {
    if (!client.metricsAggregator) {
      debug_build/* DEBUG_BUILD */.X &&
        logger/* logger.warn */.kg.warn('No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs');
      return;
    }
    const { unit, tags, timestamp } = data;
    const { release, environment } = client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    const transaction = scope.getTransaction();
    const metricTags = {};
    if (release) {
      metricTags.release = release;
    }
    if (environment) {
      metricTags.environment = environment;
    }
    if (transaction) {
      metricTags.transaction = (0,spanUtils/* spanToJSON */.XU)(transaction).description || '';
    }

    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`Adding value of ${value} to ${metricType} metric ${name}`);
    client.metricsAggregator.add(metricType, name, value, unit, { ...metricTags, ...tags }, timestamp);
  }
}

/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */
function increment(name, value = 1, data) {
  addToMetricsAggregator(COUNTER_METRIC_TYPE, name, value, data);
}

/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */
function distribution(name, value, data) {
  addToMetricsAggregator(DISTRIBUTION_METRIC_TYPE, name, value, data);
}

/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */
function set(name, value, data) {
  addToMetricsAggregator(SET_METRIC_TYPE, name, value, data);
}

/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */
function gauge(name, value, data) {
  addToMetricsAggregator(GAUGE_METRIC_TYPE, name, value, data);
}

const metrics = {
  increment,
  distribution,
  set,
  gauge,
  /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */
  // eslint-disable-next-line deprecation/deprecation
  MetricsAggregator: MetricsAggregator,
  metricsAggregatorIntegration: metricsAggregatorIntegration,
};


//# sourceMappingURL=exports.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/utils/parameterize.js
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */
function parameterize(strings, ...values) {
  const formatted = new String(String.raw(strings, ...values)) ;
  formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
  formatted.__sentry_template_values__ = values;
  return formatted;
}


//# sourceMappingURL=parameterize.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(10857);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(91895);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(46595);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/scope.js
var scope = __webpack_require__(77172);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/baseclient.js + 1 modules
var baseclient = __webpack_require__(61335);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/eventProcessors.js
var eventProcessors = __webpack_require__(21712);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(91617);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(28218);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(12653);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/utils.js
var tracing_utils = __webpack_require__(77257);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(35818);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/sdk.js
var sdk = __webpack_require__(82536);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/measurement.js
var measurement = __webpack_require__(3578);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(14828);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/client.js + 1 modules
var client = __webpack_require__(34101);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/transports/fetch.js + 1 modules
var fetch = __webpack_require__(19338);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/transports/xhr.js
var xhr = __webpack_require__(19601);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/stack-parsers.js
var stack_parsers = __webpack_require__(60595);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(2382);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(54832);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/sdk.js
var esm_sdk = __webpack_require__(20113);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
var breadcrumbs = __webpack_require__(4297);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(43122);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(94073);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/integrations/httpcontext.js
var httpcontext = __webpack_require__(31912);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(12724);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(19086);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/index.js







/* eslint-disable deprecation/deprecation */
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(18746);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
var _optionalChain = __webpack_require__(57672);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/utils/isSentryRequestUrl.js
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */
// eslint-disable-next-line deprecation/deprecation
function isSentryRequestUrl(url, hubOrClient) {
  const client =
    hubOrClient && isHub(hubOrClient)
      ? // eslint-disable-next-line deprecation/deprecation
        hubOrClient.getClient()
      : hubOrClient;
  const dsn = client && client.getDsn();
  const tunnel = client && client.getOptions().tunnel;

  return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}

function checkTunnel(url, tunnel) {
  if (!tunnel) {
    return false;
  }

  return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}

function checkDsn(url, dsn) {
  return dsn ? url.includes(dsn.host) : false;
}

function removeTrailingSlash(str) {
  return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

// eslint-disable-next-line deprecation/deprecation
function isHub(hubOrClient) {
  // eslint-disable-next-line deprecation/deprecation
  return (hubOrClient ).getClient !== undefined;
}


//# sourceMappingURL=isSentryRequestUrl.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(4715);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(14600);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(76721);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(71207);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(40901);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(52868);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(1466);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/fetch.js
var instrument_fetch = __webpack_require__(61245);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/dom.js
var dom = __webpack_require__(9733);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/history.js + 1 modules
var instrument_history = __webpack_require__(16962);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(94050);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(26849);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/isBrowser.js



/**
 * Returns true if we are in the browser.
 */
function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && (!(0,node/* isNodeEnv */.KV)() || isElectronNodeRenderer());
}

// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    worldwide/* GLOBAL_OBJ.process */.n2.process !== undefined && worldwide/* GLOBAL_OBJ.process.type */.n2.process.type === 'renderer'
  );
}


//# sourceMappingURL=isBrowser.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(94423);
;// CONCATENATED MODULE: ../../node_modules/@sentry/replay/esm/index.js





// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const REPLAY_SESSION_KEY = 'sentryReplaySession';
const REPLAY_EVENT_NAME = 'replay_event';
const UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';

// The idle limit for a session after which recording is paused.
const SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms

// The idle limit for a session after which the session expires.
const SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms

/** Default flush delays */
const DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const DEFAULT_FLUSH_MAX_DELAY = 5500;

/* How long to wait for error checkouts */
const BUFFER_CHECKOUT_TIME = 60000;

const RETRY_BASE_INTERVAL = 5000;
const RETRY_MAX_COUNT = 3;

/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */
const NETWORK_BODY_MAX_SIZE = 150000;

/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */
const CONSOLE_ARG_MAX_SIZE = 5000;

/* Min. time to wait before we consider something a slow click. */
const SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */
const SLOW_CLICK_SCROLL_TIMEOUT = 300;

/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */
const REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB

/** Replays must be min. 5s long before we send them. */
const MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */
const MIN_REPLAY_DURATION_LIMIT = 15000;

/** The max. length of a replay. */
const MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;

function _nullishCoalesce$1(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }function _optionalChain$5(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var NodeType$1;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));

function isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
    const host = _optionalChain$5([n, 'optionalAccess', _ => _.host]);
    return Boolean(_optionalChain$5([host, 'optionalAccess', _2 => _2.shadowRoot]) === n);
}
function isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') &&
        !cssText.includes(' -webkit-background-clip: text;')) {
        cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    }
    return cssText;
}
function escapeImportStatement(rule) {
    const { cssText } = rule;
    if (cssText.split('"').length < 3)
        return cssText;
    const statement = ['@import', `url(${JSON.stringify(rule.href)})`];
    if (rule.layerName === '') {
        statement.push(`layer`);
    }
    else if (rule.layerName) {
        statement.push(`layer(${rule.layerName})`);
    }
    if (rule.supportsText) {
        statement.push(`supports(${rule.supportsText})`);
    }
    if (rule.media.length) {
        statement.push(rule.media.mediaText);
    }
    return statement.join(' ') + ';';
}
function stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules
            ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules, stringifyRule).join(''))
            : null;
    }
    catch (error) {
        return null;
    }
}
function stringifyRule(rule) {
    let importStringified;
    if (isCSSImportRule(rule)) {
        try {
            importStringified =
                stringifyStylesheet(rule.styleSheet) ||
                    escapeImportStatement(rule);
        }
        catch (error) {
        }
    }
    else if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        return fixSafariColons(rule.cssText);
    }
    return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class Mirror {
    constructor() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n)
            return -1;
        const id = _optionalChain$5([this, 'access', _3 => _3.getMeta, 'call', _4 => _4(n), 'optionalAccess', _5 => _5.id]);
        return _nullishCoalesce$1(id, () => ( -1));
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) {
            n.childNodes.forEach((childNode) => this.removeNodeFromMap(childNode));
        }
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta)
                this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function createMirror() {
    return new Mirror();
}
function shouldMaskInput({ maskInputOptions, tagName, type, }) {
    if (tagName === 'OPTION') {
        tagName = 'SELECT';
    }
    return Boolean(maskInputOptions[tagName.toLowerCase()] ||
        (type && maskInputOptions[type]) ||
        type === 'password' ||
        (tagName === 'INPUT' && !type && maskInputOptions['text']));
}
function maskInputValue({ isMasked, element, value, maskInputFn, }) {
    let text = value || '';
    if (!isMasked) {
        return text;
    }
    if (maskInputFn) {
        text = maskInputFn(text, element);
    }
    return '*'.repeat(text.length);
}
function toLowerCase(str) {
    return str.toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
const ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx)
        return true;
    const chunkSize = 50;
    for (let x = 0; x < canvas.width; x += chunkSize) {
        for (let y = 0; y < canvas.height; y += chunkSize) {
            const getImageData = ctx.getImageData;
            const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData
                ? getImageData[ORIGINAL_ATTRIBUTE_NAME]
                : getImageData;
            const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
            if (pixelBuffer.some((pixel) => pixel !== 0))
                return false;
        }
    }
    return true;
}
function getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password')
        ? 'password'
        : type
            ?
                toLowerCase(type)
            : null;
}
function getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) {
        return el.getAttribute('value') || '';
    }
    return el.value;
}

let _id = 1;
const tagNameRegex = new RegExp('[^a-z0-9-_:]');
const IGNORED_NODE = -2;
function genId() {
    return _id++;
}
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) {
        return 'form';
    }
    const processedTagName = toLowerCase(element.tagName);
    if (tagNameRegex.test(processedTagName)) {
        return 'div';
    }
    return processedTagName;
}
function extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) {
        origin = url.split('/').slice(0, 3).join('/');
    }
    else {
        origin = url.split('/')[0];
    }
    origin = origin.split('?')[0];
    return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const URL_WWW_MATCH = /^www\..*/i;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3) => {
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) {
            return origin;
        }
        if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (DATA_URI.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (filePath[0] === '/') {
            return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
        }
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts) {
            if (part === '.') {
                continue;
            }
            else if (part === '..') {
                stack.pop();
            }
            else {
                stack.push(part);
            }
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') {
        return attributeValue;
    }
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while (true) {
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) {
            break;
        }
        let url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        }
        else {
            let descriptorsStr = '';
            url = absoluteToDoc(doc, url);
            let inParens = false;
            while (true) {
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                }
                else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    }
                    else if (c === '(') {
                        inParens = true;
                    }
                }
                else {
                    if (c === ')') {
                        inParens = false;
                    }
                }
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') {
        return attributeValue;
    }
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) {
        return value;
    }
    if (name === 'src' ||
        (name === 'href' && !(tagName === 'use' && value[0] === '#'))) {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'xlink:href' && value[0] !== '#') {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'background' &&
        (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'srcset') {
        return getAbsoluteSrcsetString(doc, value);
    }
    else if (name === 'style') {
        return absoluteToStylesheet(value, getHref());
    }
    else if (tagName === 'object' && name === 'data') {
        return absoluteToDoc(doc, value);
    }
    if (typeof maskAttributeFn === 'function') {
        return maskAttributeFn(name, value, element);
    }
    return value;
}
function ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) {
            return false;
        }
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) {
                return true;
            }
        }
        else {
            for (let eIndex = element.classList.length; eIndex--;) {
                const className = element.classList[eIndex];
                if (blockClass.test(className)) {
                    return true;
                }
            }
        }
        if (blockSelector) {
            return element.matches(blockSelector);
        }
    }
    catch (e) {
    }
    return false;
}
function elementClassMatchesRegex(el, regex) {
    for (let eIndex = el.classList.length; eIndex--;) {
        const className = el.classList[eIndex];
        if (regex.test(className)) {
            return true;
        }
    }
    return false;
}
function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node)
        return -1;
    if (node.nodeType !== node.ELEMENT_NODE)
        return -1;
    if (distance > limit)
        return -1;
    if (matchPredicate(node))
        return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return (node) => {
        const el = node;
        if (el === null)
            return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`))
                        return true;
                }
                else if (elementClassMatchesRegex(el, className)) {
                    return true;
                }
            }
            if (selector && el.matches(selector))
                return true;
            return false;
        }
        catch (e2) {
            return false;
        }
    };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE
            ? node
            : node.parentElement;
        if (el === null)
            return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc',
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) {
                return true;
            }
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) {
                return true;
            }
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        }
        else {
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) {
                return false;
            }
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0
            ? unmaskDistance >= 0
                ? maskDistance <= unmaskDistance
                : true
            : unmaskDistance >= 0
                ? false
                : !!maskAllText;
    }
    catch (e) {
    }
    return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) {
        return;
    }
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    }
    catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(() => {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', () => {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl ||
        iframeEl.src === blankUrl ||
        iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    }
    catch (error) {
        return;
    }
    if (styleSheetLoaded)
        return;
    const timer = setTimeout(() => {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', () => {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function serializeNode(n, options) {
    const { doc, mirror, blockClass, blockSelector, unblockSelector, maskAllText, maskAttributeFn, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, inlineStylesheet, maskInputOptions = {}, maskTextFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false, } = options;
    const rootId = getRootId(doc, mirror);
    switch (n.nodeType) {
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') {
                return {
                    type: NodeType$1.Document,
                    childNodes: [],
                    compatMode: n.compatMode,
                };
            }
            else {
                return {
                    type: NodeType$1.Document,
                    childNodes: [],
                };
            }
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId,
            };
        case n.ELEMENT_NODE:
            return serializeElementNode(n, {
                doc,
                blockClass,
                blockSelector,
                unblockSelector,
                inlineStylesheet,
                maskAttributeFn,
                maskInputOptions,
                maskInputFn,
                dataURLOptions,
                inlineImages,
                recordCanvas,
                keepIframeSrcFn,
                newlyAddedElement,
                rootId,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
            });
        case n.TEXT_NODE:
            return serializeTextNode(n, {
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                maskTextFn,
                maskInputOptions,
                maskInputFn,
                rootId,
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: NodeType$1.CDATA,
                textContent: '',
                rootId,
            };
        case n.COMMENT_NODE:
            return {
                type: NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId,
            };
        default:
            return false;
    }
}
function getRootId(doc, mirror) {
    if (!mirror.hasNode(doc))
        return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function serializeTextNode(n, options) {
    const { maskAllText, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, maskTextFn, maskInputOptions, maskInputFn, rootId, } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) {
            }
            else if (_optionalChain$5([n, 'access', _6 => _6.parentNode, 'access', _7 => _7.sheet, 'optionalAccess', _8 => _8.cssRules])) {
                textContent = stringifyStylesheet(n.parentNode.sheet);
            }
        }
        catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = absoluteToStylesheet(textContent, getHref());
    }
    if (isScript) {
        textContent = 'SCRIPT_PLACEHOLDER';
    }
    const forceMask = needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) {
        textContent = maskTextFn
            ? maskTextFn(textContent, n.parentElement)
            : textContent.replace(/[\S]/g, '*');
    }
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) {
        textContent = maskInputFn
            ? maskInputFn(textContent, n.parentNode)
            : textContent.replace(/[\S]/g, '*');
    }
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions,
        });
        textContent = maskInputValue({
            isMasked: needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn,
        });
    }
    return {
        type: NodeType$1.Text,
        textContent: textContent || '',
        isStyle,
        rootId,
    };
}
function serializeElementNode(n, options) {
    const { doc, blockClass, blockSelector, unblockSelector, inlineStylesheet, maskInputOptions = {}, maskAttributeFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false, rootId, maskAllText, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, } = options;
    const needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for (let i = 0; i < len; i++) {
        const attr = n.attributes[i];
        if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) {
            attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value, n, maskAttributeFn);
        }
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s) => {
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) {
            cssText = stringifyStylesheet(stylesheet);
        }
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' &&
        n.sheet &&
        !(n.innerText || n.textContent || '').trim().length) {
        const cssText = stringifyStylesheet(n.sheet);
        if (cssText) {
            attributes._cssText = absoluteToStylesheet(cssText, getHref());
        }
    }
    if (tagName === 'input' ||
        tagName === 'textarea' ||
        tagName === 'select' ||
        tagName === 'option') {
        const el = n;
        const type = getInputType(el);
        const value = getInputValue(el, toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, shouldMaskInput({
                type,
                tagName: toUpperCase(tagName),
                maskInputOptions,
            }));
            attributes.value = maskInputValue({
                isMasked: forceMask,
                element: el,
                value,
                maskInputFn,
            });
        }
        if (checked) {
            attributes.checked = checked;
        }
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) {
            attributes.selected = true;
        }
        else {
            delete attributes.selected;
        }
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!is2DCanvasBlank(n)) {
                attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            }
        }
        else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) {
                attributes.rr_dataURL = canvasDataURL;
            }
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!canvasService) {
            canvasService = doc.createElement('canvas');
            canvasCtx = canvasService.getContext('2d');
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        const recordInlineImage = () => {
            image.removeEventListener('load', recordInlineImage);
            try {
                canvasService.width = image.naturalWidth;
                canvasService.height = image.naturalHeight;
                canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            }
            catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue
                ? (attributes.crossOrigin = oldValue)
                : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0)
            recordInlineImage();
        else
            image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused
            ? 'paused'
            : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) {
            attributes.rr_scrollLeft = n.scrollLeft;
        }
        if (n.scrollTop) {
            attributes.rr_scrollTop = n.scrollTop;
        }
    }
    if (needBlock) {
        const { width, height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`,
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) {
            attributes.rr_src = attributes.src;
        }
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName))
            isCustomElement = true;
    }
    catch (e) {
    }
    return {
        type: NodeType$1.Element,
        tagName,
        attributes,
        childNodes: [],
        isSVG: isSVGElement(n) || undefined,
        needBlock,
        rootId,
        isCustom: isCustomElement,
    };
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) {
        return '';
    }
    else {
        return maybeAttr.toLowerCase();
    }
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) {
        return true;
    }
    else if (sn.type === NodeType$1.Element) {
        if (slimDOMOptions.script &&
            (sn.tagName === 'script' ||
                (sn.tagName === 'link' &&
                    (sn.attributes.rel === 'preload' ||
                        sn.attributes.rel === 'modulepreload') &&
                    sn.attributes.as === 'script') ||
                (sn.tagName === 'link' &&
                    sn.attributes.rel === 'prefetch' &&
                    typeof sn.attributes.href === 'string' &&
                    sn.attributes.href.endsWith('.js')))) {
            return true;
        }
        else if (slimDOMOptions.headFavicon &&
            ((sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon') ||
                (sn.tagName === 'meta' &&
                    (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) ||
                        lowerIfExists(sn.attributes.name) === 'application-name' ||
                        lowerIfExists(sn.attributes.rel) === 'icon' ||
                        lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' ||
                        lowerIfExists(sn.attributes.rel) === 'shortcut icon')))) {
            return true;
        }
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords &&
                lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
                return true;
            }
            else if (slimDOMOptions.headMetaSocial &&
                (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) ||
                    lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) ||
                    lowerIfExists(sn.attributes.name) === 'pinterest')) {
                return true;
            }
            else if (slimDOMOptions.headMetaRobots &&
                (lowerIfExists(sn.attributes.name) === 'robots' ||
                    lowerIfExists(sn.attributes.name) === 'googlebot' ||
                    lowerIfExists(sn.attributes.name) === 'bingbot')) {
                return true;
            }
            else if (slimDOMOptions.headMetaHttpEquiv &&
                sn.attributes['http-equiv'] !== undefined) {
                return true;
            }
            else if (slimDOMOptions.headMetaAuthorship &&
                (lowerIfExists(sn.attributes.name) === 'author' ||
                    lowerIfExists(sn.attributes.name) === 'generator' ||
                    lowerIfExists(sn.attributes.name) === 'framework' ||
                    lowerIfExists(sn.attributes.name) === 'publisher' ||
                    lowerIfExists(sn.attributes.name) === 'progid' ||
                    lowerIfExists(sn.attributes.property).match(/^article:/) ||
                    lowerIfExists(sn.attributes.property).match(/^product:/))) {
                return true;
            }
            else if (slimDOMOptions.headMetaVerification &&
                (lowerIfExists(sn.attributes.name) === 'google-site-verification' ||
                    lowerIfExists(sn.attributes.name) === 'yandex-verification' ||
                    lowerIfExists(sn.attributes.name) === 'csrf-token' ||
                    lowerIfExists(sn.attributes.name) === 'p:domain_verify' ||
                    lowerIfExists(sn.attributes.name) === 'verify-v1' ||
                    lowerIfExists(sn.attributes.name) === 'verification' ||
                    lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
                return true;
            }
        }
    }
    return false;
}
function serializeNodeWithId(n, options) {
    const { doc, mirror, blockClass, blockSelector, unblockSelector, maskAllText, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, skipChild = false, inlineStylesheet = true, maskInputOptions = {}, maskAttributeFn, maskTextFn, maskInputFn, slimDOMOptions, dataURLOptions = {}, inlineImages = false, recordCanvas = false, onSerialize, onIframeLoad, iframeLoadTimeout = 5000, onStylesheetLoad, stylesheetLoadTimeout = 5000, keepIframeSrcFn = () => false, newlyAddedElement = false, } = options;
    let { preserveWhiteSpace = true } = options;
    const _serializedNode = serializeNode(n, {
        doc,
        mirror,
        blockClass,
        blockSelector,
        maskAllText,
        unblockSelector,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        inlineStylesheet,
        maskInputOptions,
        maskAttributeFn,
        maskTextFn,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement,
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) {
        id = mirror.getId(n);
    }
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) ||
        (!preserveWhiteSpace &&
            _serializedNode.type === NodeType$1.Text &&
            !_serializedNode.isStyle &&
            !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length)) {
        id = IGNORED_NODE;
    }
    else {
        id = genId();
    }
    const serializedNode = Object.assign(_serializedNode, { id });
    mirror.add(n, serializedNode);
    if (id === IGNORED_NODE) {
        return null;
    }
    if (onSerialize) {
        onSerialize(n);
    }
    let recordChild = !skipChild;
    if (serializedNode.type === NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && isNativeShadowDom(shadowRoot))
            serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType$1.Document ||
        serializedNode.type === NodeType$1.Element) &&
        recordChild) {
        if (slimDOMOptions.headWhitespace &&
            serializedNode.type === NodeType$1.Element &&
            serializedNode.tagName === 'head') {
            preserveWhiteSpace = false;
        }
        const bypassOptions = {
            doc,
            mirror,
            blockClass,
            blockSelector,
            maskAllText,
            unblockSelector,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild,
            inlineStylesheet,
            maskInputOptions,
            maskAttributeFn,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            onStylesheetLoad,
            stylesheetLoadTimeout,
            keepIframeSrcFn,
        };
        for (const childN of Array.from(n.childNodes)) {
            const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
        if (isElement$1(n) && n.shadowRoot) {
            for (const childN of Array.from(n.shadowRoot.childNodes)) {
                const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    isNativeShadowDom(n.shadowRoot) &&
                        (serializedChildNode.isShadow = true);
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
    }
    if (n.parentNode &&
        isShadowRoot(n.parentNode) &&
        isNativeShadowDom(n.parentNode)) {
        serializedNode.isShadow = true;
    }
    if (serializedNode.type === NodeType$1.Element &&
        serializedNode.tagName === 'iframe') {
        onceIframeLoaded(n, () => {
            const iframeDoc = n.contentDocument;
            if (iframeDoc && onIframeLoad) {
                const serializedIframeNode = serializeNodeWithId(iframeDoc, {
                    doc: iframeDoc,
                    mirror,
                    blockClass,
                    blockSelector,
                    unblockSelector,
                    maskAllText,
                    maskTextClass,
                    unmaskTextClass,
                    maskTextSelector,
                    unmaskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputOptions,
                    maskAttributeFn,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    onStylesheetLoad,
                    stylesheetLoadTimeout,
                    keepIframeSrcFn,
                });
                if (serializedIframeNode) {
                    onIframeLoad(n, serializedIframeNode);
                }
            }
        }, iframeLoadTimeout);
    }
    if (serializedNode.type === NodeType$1.Element &&
        serializedNode.tagName === 'link' &&
        serializedNode.attributes.rel === 'stylesheet') {
        onceStylesheetLoaded(n, () => {
            if (onStylesheetLoad) {
                const serializedLinkNode = serializeNodeWithId(n, {
                    doc,
                    mirror,
                    blockClass,
                    blockSelector,
                    unblockSelector,
                    maskAllText,
                    maskTextClass,
                    unmaskTextClass,
                    maskTextSelector,
                    unmaskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputOptions,
                    maskAttributeFn,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    onStylesheetLoad,
                    stylesheetLoadTimeout,
                    keepIframeSrcFn,
                });
                if (serializedLinkNode) {
                    onStylesheetLoad(n, serializedLinkNode);
                }
            }
        }, stylesheetLoadTimeout);
    }
    return serializedNode;
}
function snapshot(n, options) {
    const { mirror = new Mirror(), blockClass = 'rr-block', blockSelector = null, unblockSelector = null, maskAllText = false, maskTextClass = 'rr-mask', unmaskTextClass = null, maskTextSelector = null, unmaskTextSelector = null, inlineStylesheet = true, inlineImages = false, recordCanvas = false, maskAllInputs = false, maskAttributeFn, maskTextFn, maskInputFn, slimDOM = false, dataURLOptions, preserveWhiteSpace, onSerialize, onIframeLoad, iframeLoadTimeout, onStylesheetLoad, stylesheetLoadTimeout, keepIframeSrcFn = () => false, } = options || {};
    const maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
        }
        : maskAllInputs === false
            ? {}
            : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all'
        ?
            {
                script: true,
                comment: true,
                headFavicon: true,
                headWhitespace: true,
                headMetaDescKeywords: slimDOM === 'all',
                headMetaSocial: true,
                headMetaRobots: true,
                headMetaHttpEquiv: true,
                headMetaAuthorship: true,
                headMetaVerification: true,
            }
        : slimDOM === false
            ? {}
            : slimDOM;
    return serializeNodeWithId(n, {
        doc: n,
        mirror,
        blockClass,
        blockSelector,
        unblockSelector,
        maskAllText,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        skipChild: false,
        inlineStylesheet,
        maskInputOptions,
        maskAttributeFn,
        maskTextFn,
        maskInputFn,
        slimDOMOptions,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        preserveWhiteSpace,
        onSerialize,
        onIframeLoad,
        iframeLoadTimeout,
        onStylesheetLoad,
        stylesheetLoadTimeout,
        keepIframeSrcFn,
        newlyAddedElement: false,
    });
}

function _optionalChain$4(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
function on(type, fn, target = document) {
    const options = { capture: true, passive: true };
    target.addEventListener(type, fn, options);
    return () => target.removeEventListener(type, fn, options);
}
const DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' +
    '\r\n' +
    'now you can use replayer.getMirror() to access the mirror instance of a replayer,' +
    '\r\n' +
    'or you can use record.mirror to access the mirror instance during recording.';
let _mirror = {
    map: {},
    getId() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
    _mirror = new Proxy(_mirror, {
        get(target, prop, receiver) {
            if (prop === 'map') {
                console.error(DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        },
    });
}
function throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function (...args) {
        const now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout$1(() => {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };
}
function hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked
        ? d
        : {
            set(value) {
                setTimeout$1(() => {
                    d.set.call(this, value);
                }, 0);
                if (original && original.set) {
                    original.set.call(this, value);
                }
            },
        });
    return () => hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return () => {
            };
        }
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        source[name] = wrapped;
        return () => {
            source[name] = original;
        };
    }
    catch (e2) {
        return () => {
        };
    }
}
let nowTimestamp = Date.now;
if (!(/[1-9][0-9]{12}/.test(Date.now().toString()))) {
    nowTimestamp = () => new Date().getTime();
}
function getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement
            ? doc.scrollingElement.scrollLeft
            : win.pageXOffset !== undefined
                ? win.pageXOffset
                : _optionalChain$4([doc, 'optionalAccess', _ => _.documentElement, 'access', _2 => _2.scrollLeft]) ||
                    _optionalChain$4([doc, 'optionalAccess', _3 => _3.body, 'optionalAccess', _4 => _4.parentElement, 'optionalAccess', _5 => _5.scrollLeft]) ||
                    _optionalChain$4([doc, 'optionalAccess', _6 => _6.body, 'optionalAccess', _7 => _7.scrollLeft]) ||
                    0,
        top: doc.scrollingElement
            ? doc.scrollingElement.scrollTop
            : win.pageYOffset !== undefined
                ? win.pageYOffset
                : _optionalChain$4([doc, 'optionalAccess', _8 => _8.documentElement, 'access', _9 => _9.scrollTop]) ||
                    _optionalChain$4([doc, 'optionalAccess', _10 => _10.body, 'optionalAccess', _11 => _11.parentElement, 'optionalAccess', _12 => _12.scrollTop]) ||
                    _optionalChain$4([doc, 'optionalAccess', _13 => _13.body, 'optionalAccess', _14 => _14.scrollTop]) ||
                    0,
    };
}
function getWindowHeight() {
    return (window.innerHeight ||
        (document.documentElement && document.documentElement.clientHeight) ||
        (document.body && document.body.clientHeight));
}
function getWindowWidth() {
    return (window.innerWidth ||
        (document.documentElement && document.documentElement.clientWidth) ||
        (document.body && document.body.clientWidth));
}
function closestElementOfNode(node) {
    if (!node) {
        return null;
    }
    const el = node.nodeType === node.ELEMENT_NODE
        ? node
        : node.parentElement;
    return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) {
        return false;
    }
    const el = closestElementOfNode(node);
    if (!el) {
        return false;
    }
    const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) {
        return false;
    }
    if (unblockSelector) {
        unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    }
    if (blockDistance > -1 && unblockDistance < 0) {
        return true;
    }
    return blockDistance < unblockDistance;
}
function isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function isIgnored(n, mirror) {
    return mirror.getId(n) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror) {
    if (isShadowRoot(target)) {
        return false;
    }
    const id = mirror.getId(target);
    if (!mirror.has(id)) {
        return true;
    }
    if (target.parentNode &&
        target.parentNode.nodeType === target.DOCUMENT_NODE) {
        return false;
    }
    if (!target.parentNode) {
        return true;
    }
    return isAncestorRemoved(target.parentNode, mirror);
}
function legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) {
        win.NodeList.prototype.forEach = Array.prototype
            .forEach;
    }
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
        win.DOMTokenList.prototype.forEach = Array.prototype
            .forEach;
    }
    if (!Node.prototype.contains) {
        Node.prototype.contains = (...args) => {
            let node = args[0];
            if (!(0 in args)) {
                throw new TypeError('1 argument is required');
            }
            do {
                if (this === node) {
                    return true;
                }
            } while ((node = node && node.parentNode));
            return false;
        };
    }
}
function isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' &&
        n.nodeType === n.ELEMENT_NODE &&
        n.getAttribute &&
        n.getAttribute('rel') === 'stylesheet' &&
        mirror.getMeta(n));
}
function hasShadowRoot(n) {
    return Boolean(_optionalChain$4([n, 'optionalAccess', _18 => _18.shadowRoot]));
}
class StyleSheetMirror {
    constructor() {
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0,_nullishCoalesce/* _nullishCoalesce */.h)(this.styleIDMap.get(stylesheet), () => ( -1));
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet))
            return this.getId(stylesheet);
        let newId;
        if (id === undefined) {
            newId = this.id++;
        }
        else
            newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function getShadowHost(n) {
    let shadowHost = null;
    if (_optionalChain$4([n, 'access', _19 => _19.getRootNode, 'optionalCall', _20 => _20(), 'optionalAccess', _21 => _21.nodeType]) === Node.DOCUMENT_FRAGMENT_NODE &&
        n.getRootNode().host)
        shadowHost = n.getRootNode().host;
    return shadowHost;
}
function getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while ((shadowHost = getShadowHost(rootShadowHost)))
        rootShadowHost = shadowHost;
    return rootShadowHost;
}
function shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc)
        return false;
    const shadowHost = getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function inDom(n) {
    const doc = n.ownerDocument;
    if (!doc)
        return false;
    return doc.contains(n) || shadowHostInDom(n);
}
const cachedImplementations = {};
function getImplementation(name) {
    const cached = cachedImplementations[name];
    if (cached) {
        return cached;
    }
    const document = window.document;
    let impl = window[name];
    if (document && typeof document.createElement === 'function') {
        try {
            const sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            const contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow[name]) {
                impl =
                    contentWindow[name];
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
        }
    }
    return (cachedImplementations[name] = impl.bind(window));
}
function onRequestAnimationFrame(...rest) {
    return getImplementation('requestAnimationFrame')(...rest);
}
function setTimeout$1(...rest) {
    return getImplementation('setTimeout')(...rest);
}
function clearTimeout$1(...rest) {
    return getImplementation('clearTimeout')(...rest);
}

var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});
var IncrementalSource = /* @__PURE__ */ ((IncrementalSource2) => {
  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
  IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
  return IncrementalSource2;
})(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */ ((MouseInteractions2) => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */ ((PointerTypes2) => {
  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
  return PointerTypes2;
})(PointerTypes || {});

function _optionalChain$3(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
function isNodeInLinkedList(n) {
    return '__ln' in n;
}
class DoubleLinkedList {
    constructor() {
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) {
            throw new Error('Position outside of list range');
        }
        let current = this.head;
        for (let index = 0; index < position; index++) {
            current = _optionalChain$3([current, 'optionalAccess', _ => _.next]) || null;
        }
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null,
        };
        n.__ln = node;
        if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) {
                current.previous = node;
            }
        }
        else if (n.nextSibling &&
            isNodeInLinkedList(n.nextSibling) &&
            n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) {
                current.next = node;
            }
        }
        else {
            if (this.head) {
                this.head.previous = node;
            }
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) {
            this.tail = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) {
            return;
        }
        if (!current.previous) {
            this.head = current.next;
            if (this.head) {
                this.head.previous = null;
            }
            else {
                this.tail = null;
            }
        }
        else {
            current.previous.next = current.next;
            if (current.next) {
                current.next.previous = current.previous;
            }
            else {
                this.tail = current.previous;
            }
        }
        if (n.__ln) {
            delete n.__ln;
        }
        this.length--;
    }
}
const moveKey = (id, parentId) => `${id}@${parentId}`;
class MutationBuffer {
    constructor() {
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations) => {
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = () => {
            if (this.frozen || this.locked) {
                return;
            }
            const adds = [];
            const addedIds = new Set();
            const addList = new DoubleLinkedList();
            const getNextId = (n) => {
                let ns = n;
                let nextId = IGNORED_NODE;
                while (nextId === IGNORED_NODE) {
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n) => {
                if (!n.parentNode || !inDom(n)) {
                    return;
                }
                const parentId = isShadowRoot(n.parentNode)
                    ? this.mirror.getId(getShadowHost(n))
                    : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) {
                    return addList.addNode(n);
                }
                const sn = serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN) => {
                        if (isSerializedIframe(currentN, this.mirror)) {
                            this.iframeManager.addIframe(currentN);
                        }
                        if (isSerializedStylesheet(currentN, this.mirror)) {
                            this.stylesheetManager.trackLinkElement(currentN);
                        }
                        if (hasShadowRoot(n)) {
                            this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                        }
                    },
                    onIframeLoad: (iframe, childSn) => {
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn) => {
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                });
                if (sn) {
                    adds.push({
                        parentId,
                        nextId,
                        node: sn,
                    });
                    addedIds.add(sn.id);
                }
            };
            while (this.mapRemoves.length) {
                this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            }
            for (const n of this.movedSet) {
                if (isParentRemoved(this.removes, n, this.mirror) &&
                    !this.movedSet.has(n.parentNode)) {
                    continue;
                }
                pushAdd(n);
            }
            for (const n of this.addedSet) {
                if (!isAncestorInSet(this.droppedSet, n) &&
                    !isParentRemoved(this.removes, n, this.mirror)) {
                    pushAdd(n);
                }
                else if (isAncestorInSet(this.movedSet, n)) {
                    pushAdd(n);
                }
                else {
                    this.droppedSet.add(n);
                }
            }
            let candidate = null;
            while (addList.length) {
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) {
                        node = candidate;
                    }
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while (tailNode) {
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1)
                                continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            }
                            else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode &&
                                    unhandledNode.parentNode.nodeType ===
                                        Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode
                                        .host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while (addList.head) {
                        addList.removeNode(addList.head.value);
                    }
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts
                    .map((text) => ({
                    id: this.mirror.getId(text.node),
                    value: text.value,
                }))
                    .filter((text) => !addedIds.has(text.id))
                    .filter((text) => this.mirror.has(text.id)),
                attributes: this.attributes
                    .map((attribute) => {
                    const { attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length ===
                                attributes.style.split('var(').length) {
                                attributes.style = attribute.styleDiff;
                            }
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes,
                    };
                })
                    .filter((attribute) => !addedIds.has(attribute.id))
                    .filter((attribute) => this.mirror.has(attribute.id)),
                removes: this.removes,
                adds,
            };
            if (!payload.texts.length &&
                !payload.attributes.length &&
                !payload.removes.length &&
                !payload.adds.length) {
                return;
            }
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m) => {
            if (isIgnored(m.target, this.mirror)) {
                return;
            }
            switch (m.type) {
                case 'characterData': {
                    const value = m.target.textContent;
                    if (!isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) &&
                        value !== m.oldValue) {
                        this.texts.push({
                            value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value
                                ? this.maskTextFn
                                    ? this.maskTextFn(value, closestElementOfNode(m.target))
                                    : value.replace(/[\S]/g, '*')
                                : value,
                            node: m.target,
                        });
                    }
                    break;
                }
                case 'attributes': {
                    const target = m.target;
                    let attributeName = m.attributeName;
                    let value = m.target.getAttribute(attributeName);
                    if (attributeName === 'value') {
                        const type = getInputType(target);
                        const tagName = target.tagName;
                        value = getInputValue(target, tagName, type);
                        const isInputMasked = shouldMaskInput({
                            maskInputOptions: this.maskInputOptions,
                            tagName,
                            type,
                        });
                        const forceMask = needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                        value = maskInputValue({
                            isMasked: forceMask,
                            element: target,
                            value,
                            maskInputFn: this.maskInputFn,
                        });
                    }
                    if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) ||
                        value === m.oldValue) {
                        return;
                    }
                    let item = this.attributeMap.get(m.target);
                    if (target.tagName === 'IFRAME' &&
                        attributeName === 'src' &&
                        !this.keepIframeSrcFn(value)) {
                        if (!target.contentDocument) {
                            attributeName = 'rr_src';
                        }
                        else {
                            return;
                        }
                    }
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                            styleDiff: {},
                            _unchangedStyles: {},
                        };
                        this.attributes.push(item);
                        this.attributeMap.set(m.target, item);
                    }
                    if (attributeName === 'type' &&
                        target.tagName === 'INPUT' &&
                        (m.oldValue || '').toLowerCase() === 'password') {
                        target.setAttribute('data-rr-is-password', 'true');
                    }
                    if (!ignoreAttribute(target.tagName, attributeName)) {
                        item.attributes[attributeName] = transformAttribute(this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), value, target, this.maskAttributeFn);
                        if (attributeName === 'style') {
                            if (!this.unattachedDoc) {
                                try {
                                    this.unattachedDoc =
                                        document.implementation.createHTMLDocument();
                                }
                                catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                            }
                            const old = this.unattachedDoc.createElement('span');
                            if (m.oldValue) {
                                old.setAttribute('style', m.oldValue);
                            }
                            for (const pname of Array.from(target.style)) {
                                const newValue = target.style.getPropertyValue(pname);
                                const newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) ||
                                    newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === '') {
                                        item.styleDiff[pname] = newValue;
                                    }
                                    else {
                                        item.styleDiff[pname] = [newValue, newPriority];
                                    }
                                }
                                else {
                                    item._unchangedStyles[pname] = [newValue, newPriority];
                                }
                            }
                            for (const pname of Array.from(old.style)) {
                                if (target.style.getPropertyValue(pname) === '') {
                                    item.styleDiff[pname] = false;
                                }
                            }
                        }
                    }
                    break;
                }
                case 'childList': {
                    if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) {
                        return;
                    }
                    m.addedNodes.forEach((n) => this.genAdds(n, m.target));
                    m.removedNodes.forEach((n) => {
                        const nodeId = this.mirror.getId(n);
                        const parentId = isShadowRoot(m.target)
                            ? this.mirror.getId(m.target.host)
                            : this.mirror.getId(m.target);
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) ||
                            isIgnored(n, this.mirror) ||
                            !isSerialized(n, this.mirror)) {
                            return;
                        }
                        if (this.addedSet.has(n)) {
                            deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        }
                        else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) &&
                            this.movedMap[moveKey(nodeId, parentId)]) {
                            deepDelete(this.movedSet, n);
                        }
                        else {
                            this.removes.push({
                                parentId,
                                id: nodeId,
                                isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target)
                                    ? true
                                    : undefined,
                            });
                        }
                        this.mapRemoves.push(n);
                    });
                    break;
                }
            }
        };
        this.genAdds = (n, target) => {
            if (this.processedNodeManager.inOtherBuffer(n, this))
                return;
            if (this.addedSet.has(n) || this.movedSet.has(n))
                return;
            if (this.mirror.hasNode(n)) {
                if (isIgnored(n, this.mirror)) {
                    return;
                }
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) {
                    targetId = this.mirror.getId(target);
                }
                if (targetId && targetId !== -1) {
                    this.movedMap[moveKey(this.mirror.getId(n), targetId)] = true;
                }
            }
            else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN) => this.genAdds(childN));
                if (hasShadowRoot(n)) {
                    n.shadowRoot.childNodes.forEach((childN) => {
                        this.processedNodeManager.add(childN, this);
                        this.genAdds(childN, n);
                    });
                }
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager',
        ].forEach((key) => {
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN) => deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n, mirror) {
    if (removes.length === 0)
        return false;
    return _isParentRemoved(removes, n, mirror);
}
function _isParentRemoved(removes, n, mirror) {
    const { parentNode } = n;
    if (!parentNode) {
        return false;
    }
    const parentId = mirror.getId(parentNode);
    if (removes.some((r) => r.id === parentId)) {
        return true;
    }
    return _isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
    if (set.size === 0)
        return false;
    return _isAncestorInSet(set, n);
}
function _isAncestorInSet(set, n) {
    const { parentNode } = n;
    if (!parentNode) {
        return false;
    }
    if (set.has(parentNode)) {
        return true;
    }
    return _isAncestorInSet(set, parentNode);
}

let errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
function unregisterErrorHandler() {
    errorHandler = undefined;
}
const callbackWrapper = (cb) => {
    if (!errorHandler) {
        return cb;
    }
    const rrwebWrapped = ((...rest) => {
        try {
            return cb(...rest);
        }
        catch (error) {
            if (errorHandler && errorHandler(error) === true) {
                return () => {
                };
            }
            throw error;
        }
    });
    return rrwebWrapped;
};

function _optionalChain$2(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
const mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) {
                return path[0];
            }
        }
        else if ('path' in event && event.path.length) {
            return event.path[0];
        }
    }
    catch (e2) {
    }
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    const mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver ||
        window.__rrMutationObserver;
    const angularZoneSymbol = _optionalChain$2([window, 'optionalAccess', _ => _.Zone, 'optionalAccess', _2 => _2.__symbol__, 'optionalCall', _3 => _3('MutationObserver')]);
    if (angularZoneSymbol &&
        window[angularZoneSymbol]) {
        mutationObserverCtor = window[angularZoneSymbol];
    }
    const observer = new mutationObserverCtor(callbackWrapper((mutations) => {
        if (options.onMutation && options.onMutation(mutations) === false) {
            return;
        }
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return observer;
}
function initMoveObserver({ mousemoveCb, sampling, doc, mirror, }) {
    if (sampling.mousemove === false) {
        return () => {
        };
    }
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number'
        ? sampling.mousemoveCallback
        : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = throttle$1(callbackWrapper((source) => {
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p) => {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = callbackWrapper(throttle$1(callbackWrapper((evt) => {
        const target = getEventTarget(evt);
        const { clientX, clientY } = legacy_isTouchEvent(evt)
            ? evt.changedTouches[0]
            : evt;
        if (!timeBaseline) {
            timeBaseline = nowTimestamp();
        }
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: nowTimestamp() - timeBaseline,
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent
            ? IncrementalSource.Drag
            : evt instanceof MouseEvent
                ? IncrementalSource.MouseMove
                : IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false,
    }));
    const handlers = [
        on('mousemove', updatePosition, doc),
        on('touchmove', updatePosition, doc),
        on('drag', updatePosition, doc),
    ];
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initMouseInteractionObserver({ mouseInteractionCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling, }) {
    if (sampling.mouseInteraction === false) {
        return () => {
        };
    }
    const disableMap = sampling.mouseInteraction === true ||
        sampling.mouseInteraction === undefined
        ? {}
        : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey) => {
        return (event) => {
            const target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
                return;
            }
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch (event.pointerType) {
                    case 'mouse':
                        pointerType = PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = PointerTypes.Pen;
                        break;
                }
                if (pointerType === PointerTypes.Touch) {
                    if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
                        thisEventKey = 'TouchStart';
                    }
                    else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
                        thisEventKey = 'TouchEnd';
                    }
                }
                else if (pointerType === PointerTypes.Pen) ;
            }
            else if (legacy_isTouchEvent(event)) {
                pointerType = PointerTypes.Touch;
            }
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if ((thisEventKey.startsWith('Touch') &&
                    pointerType === PointerTypes.Touch) ||
                    (thisEventKey.startsWith('Mouse') &&
                        pointerType === PointerTypes.Mouse)) {
                    pointerType = null;
                }
            }
            else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) {
                return;
            }
            const id = mirror.getId(target);
            const { clientX, clientY } = e;
            callbackWrapper(mouseInteractionCb)({
                type: MouseInteractions[thisEventKey],
                id,
                x: clientX,
                y: clientY,
                ...(pointerType !== null && { pointerType }),
            });
        };
    };
    Object.keys(MouseInteractions)
        .filter((key) => Number.isNaN(Number(key)) &&
        !key.endsWith('_Departed') &&
        disableMap[key] !== false)
        .forEach((eventKey) => {
        let eventName = toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) {
            switch (MouseInteractions[eventKey]) {
                case MouseInteractions.MouseDown:
                case MouseInteractions.MouseUp:
                    eventName = eventName.replace('mouse', 'pointer');
                    break;
                case MouseInteractions.TouchStart:
                case MouseInteractions.TouchEnd:
                    return;
            }
        }
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initScrollObserver({ scrollCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling, }) {
    const updatePosition = callbackWrapper(throttle$1(callbackWrapper((evt) => {
        const target = getEventTarget(evt);
        if (!target ||
            isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
            return;
        }
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = getWindowScroll(doc.defaultView);
            scrollCb({
                id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top,
            });
        }
        else {
            scrollCb({
                id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }), sampling.scroll || 100));
    return on('scroll', updatePosition, doc);
}
function initViewportResizeObserver({ viewportResizeCb }, { win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = callbackWrapper(throttle$1(callbackWrapper(() => {
        const height = getWindowHeight();
        const width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height),
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return on('resize', updateDimension, win);
}
const INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
const lastInputValueMap = new WeakMap();
function initInputObserver({ inputCb, doc, mirror, blockClass, blockSelector, unblockSelector, ignoreClass, ignoreSelector, maskInputOptions, maskInputFn, sampling, userTriggeredOnInput, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, }) {
    function eventHandler(event) {
        let target = getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && toUpperCase(target.tagName);
        if (tagName === 'OPTION')
            target = target.parentElement;
        if (!target ||
            !tagName ||
            INPUT_TAGS.indexOf(tagName) < 0 ||
            isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
            return;
        }
        const el = target;
        if (el.classList.contains(ignoreClass) ||
            (ignoreSelector && el.matches(ignoreSelector))) {
            return;
        }
        const type = getInputType(target);
        let text = getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = shouldMaskInput({
            maskInputOptions,
            tagName,
            type,
        });
        const forceMask = needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') {
            isChecked = target.checked;
        }
        text = maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn,
        });
        cbWithDedup(target, userTriggeredOnInput
            ? { text, isChecked, userTriggered }
            : { text, isChecked });
        const name = target.name;
        if (type === 'radio' && name && isChecked) {
            doc
                .querySelectorAll(`input[type="radio"][name="${name}"]`)
                .forEach((el) => {
                if (el !== target) {
                    const text = maskInputValue({
                        isMasked: forceMask,
                        element: el,
                        value: getInputValue(el, tagName, type),
                        maskInputFn,
                    });
                    cbWithDedup(el, userTriggeredOnInput
                        ? { text, isChecked: !isChecked, userTriggered: false }
                        : { text, isChecked: !isChecked });
                }
            });
        }
    }
    function cbWithDedup(target, v) {
        const lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue ||
            lastInputValue.text !== v.text ||
            lastInputValue.isChecked !== v.isChecked) {
            lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            callbackWrapper(inputCb)({
                ...v,
                id,
            });
        }
    }
    const events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
    const handlers = events.map((eventName) => on(eventName, callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) {
        return () => {
            handlers.forEach((h) => h());
        };
    }
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [currentWindow.HTMLInputElement.prototype, 'value'],
        [currentWindow.HTMLInputElement.prototype, 'checked'],
        [currentWindow.HTMLSelectElement.prototype, 'value'],
        [currentWindow.HTMLTextAreaElement.prototype, 'value'],
        [currentWindow.HTMLSelectElement.prototype, 'selectedIndex'],
        [currentWindow.HTMLOptionElement.prototype, 'selected'],
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        handlers.push(...hookProperties.map((p) => hookSetter(p[0], p[1], {
            set() {
                callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false,
                });
            },
        }, false, currentWindow)));
    }
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ((hasNestedCSSRule('CSSGroupingRule') &&
            childRule.parentRule instanceof CSSGroupingRule) ||
            (hasNestedCSSRule('CSSMediaRule') &&
                childRule.parentRule instanceof CSSMediaRule) ||
            (hasNestedCSSRule('CSSSupportsRule') &&
                childRule.parentRule instanceof CSSSupportsRule) ||
            (hasNestedCSSRule('CSSConditionRule') &&
                childRule.parentRule instanceof CSSConditionRule)) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet)
        return {};
    if (sheet.ownerNode)
        id = mirror.getId(sheet.ownerNode);
    else
        styleId = styleMirror.getId(sheet);
    return {
        styleId,
        id,
    };
}
function initStyleSheetObserver({ styleSheetRuleCb, mirror, stylesheetManager }, { win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
        return () => {
        };
    }
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [rule, index] = argumentsList;
            const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if ((id && id !== -1) || (styleId && styleId !== -1)) {
                styleSheetRuleCb({
                    id,
                    styleId,
                    adds: [{ rule, index }],
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [index] = argumentsList;
            const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if ((id && id !== -1) || (styleId && styleId !== -1)) {
                styleSheetRuleCb({
                    id,
                    styleId,
                    removes: [{ index }],
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [text] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if ((id && id !== -1) || (styleId && styleId !== -1)) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        replace: text,
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [text] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if ((id && id !== -1) || (styleId && styleId !== -1)) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        replaceSync: text,
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
        supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    }
    else {
        if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
            supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        }
        if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
            supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        }
        if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
            supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
        }
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule,
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [rule, index] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if ((id && id !== -1) || (styleId && styleId !== -1)) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        adds: [
                            {
                                rule,
                                index: [
                                    ...getNestedCSSRulePositions(thisArg),
                                    index || 0,
                                ],
                            },
                        ],
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [index] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if ((id && id !== -1) || (styleId && styleId !== -1)) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        removes: [
                            { index: [...getNestedCSSRulePositions(thisArg), index] },
                        ],
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
    });
    return callbackWrapper(() => {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initAdoptedStyleSheetObserver({ mirror, stylesheetManager, }, host) {
    let hostId = null;
    if (host.nodeName === '#document')
        hostId = mirror.getId(host);
    else
        hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document'
        ? _optionalChain$2([host, 'access', _4 => _4.defaultView, 'optionalAccess', _5 => _5.Document])
        : _optionalChain$2([host, 'access', _6 => _6.ownerDocument, 'optionalAccess', _7 => _7.defaultView, 'optionalAccess', _8 => _8.ShadowRoot]);
    const originalPropertyDescriptor = _optionalChain$2([patchTarget, 'optionalAccess', _9 => _9.prototype])
        ? Object.getOwnPropertyDescriptor(_optionalChain$2([patchTarget, 'optionalAccess', _10 => _10.prototype]), 'adoptedStyleSheets')
        : undefined;
    if (hostId === null ||
        hostId === -1 ||
        !patchTarget ||
        !originalPropertyDescriptor)
        return () => {
        };
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get() {
            return _optionalChain$2([originalPropertyDescriptor, 'access', _11 => _11.get, 'optionalAccess', _12 => _12.call, 'call', _13 => _13(this)]);
        },
        set(sheets) {
            const result = _optionalChain$2([originalPropertyDescriptor, 'access', _14 => _14.set, 'optionalAccess', _15 => _15.call, 'call', _16 => _16(this, sheets)]);
            if (hostId !== null && hostId !== -1) {
                try {
                    stylesheetManager.adoptStyleSheets(sheets, hostId);
                }
                catch (e) {
                }
            }
            return result;
        },
    });
    return callbackWrapper(() => {
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set,
        });
    });
}
function initStyleDeclarationObserver({ styleDeclarationCb, mirror, ignoreCSSAttributes, stylesheetManager, }, { win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) {
                return setProperty.apply(thisArg, [property, value, priority]);
            }
            const { id, styleId } = getIdAndStyleId(_optionalChain$2([thisArg, 'access', _17 => _17.parentRule, 'optionalAccess', _18 => _18.parentStyleSheet]), mirror, stylesheetManager.styleMirror);
            if ((id && id !== -1) || (styleId && styleId !== -1)) {
                styleDeclarationCb({
                    id,
                    styleId,
                    set: {
                        property,
                        value,
                        priority,
                    },
                    index: getNestedCSSRulePositions(thisArg.parentRule),
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) {
                return removeProperty.apply(thisArg, [property]);
            }
            const { id, styleId } = getIdAndStyleId(_optionalChain$2([thisArg, 'access', _19 => _19.parentRule, 'optionalAccess', _20 => _20.parentStyleSheet]), mirror, stylesheetManager.styleMirror);
            if ((id && id !== -1) || (styleId && styleId !== -1)) {
                styleDeclarationCb({
                    id,
                    styleId,
                    remove: {
                        property,
                    },
                    index: getNestedCSSRulePositions(thisArg.parentRule),
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    return callbackWrapper(() => {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver({ mediaInteractionCb, blockClass, blockSelector, unblockSelector, mirror, sampling, doc, }) {
    const handler = callbackWrapper((type) => throttle$1(callbackWrapper((event) => {
        const target = getEventTarget(event);
        if (!target ||
            isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
            return;
        }
        const { currentTime, volume, muted, playbackRate } = target;
        mediaInteractionCb({
            type,
            id: mirror.getId(target),
            currentTime,
            volume,
            muted,
            playbackRate,
        });
    }), sampling.media || 500));
    const handlers = [
        on('play', handler(0), doc),
        on('pause', handler(1), doc),
        on('seeked', handler(2), doc),
        on('volumechange', handler(3), doc),
        on('ratechange', handler(4), doc),
    ];
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initFontObserver({ fontCb, doc }) {
    const win = doc.defaultView;
    if (!win) {
        return () => {
        };
    }
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family,
            buffer: typeof source !== 'string',
            descriptors,
            fontSource: typeof source === 'string'
                ? source
                : JSON.stringify(Array.from(new Uint8Array(source))),
        });
        return fontFace;
    };
    const restoreHandler = patch(doc.fonts, 'add', function (original) {
        return function (fontFace) {
            setTimeout$1(callbackWrapper(() => {
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [fontFace]);
        };
    });
    handlers.push(() => {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initSelectionObserver(param) {
    const { doc, mirror, blockClass, blockSelector, unblockSelector, selectionCb, } = param;
    let collapsed = true;
    const updateSelection = callbackWrapper(() => {
        const selection = doc.getSelection();
        if (!selection || (collapsed && _optionalChain$2([selection, 'optionalAccess', _21 => _21.isCollapsed])))
            return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for (let i = 0; i < count; i++) {
            const range = selection.getRangeAt(i);
            const { startContainer, startOffset, endContainer, endOffset } = range;
            const blocked = isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) ||
                isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked)
                continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset,
                end: mirror.getId(endContainer),
                endOffset,
            });
        }
        selectionCb({ ranges });
    });
    updateSelection();
    return on('selectionchange', updateSelection);
}
function initCustomElementObserver({ doc, customElementCb, }) {
    const win = doc.defaultView;
    if (!win || !win.customElements)
        return () => { };
    const restoreHandler = patch(win.customElements, 'define', function (original) {
        return function (name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name,
                    },
                });
            }
            catch (e) {
            }
            return original.apply(this, [name, constructor, options]);
        };
    });
    return restoreHandler;
}
function initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) {
        return () => {
        };
    }
    const mutationObserver = initMutationObserver(o, o.doc);
    const mousemoveHandler = initMoveObserver(o);
    const mouseInteractionHandler = initMouseInteractionObserver(o);
    const scrollHandler = initScrollObserver(o);
    const viewportResizeHandler = initViewportResizeObserver(o, {
        win: currentWindow,
    });
    const inputHandler = initInputObserver(o);
    const mediaInteractionHandler = initMediaInteractionObserver(o);
    const styleSheetObserver = initStyleSheetObserver(o, { win: currentWindow });
    const adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = initStyleDeclarationObserver(o, {
        win: currentWindow,
    });
    const fontObserver = o.collectFonts
        ? initFontObserver(o)
        : () => {
        };
    const selectionObserver = initSelectionObserver(o);
    const customElementObserver = initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins) {
        pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    }
    return callbackWrapper(() => {
        mutationBuffers.forEach((b) => b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h) => h());
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' &&
        window[prop].prototype &&
        'insertRule' in window[prop].prototype &&
        'deleteRule' in window[prop].prototype);
}

class CrossOriginIframeMirror {
    constructor(generateIdFn) {
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id) => this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number')
            return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId)
            return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id) => this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}

function _optionalChain$1(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
class IframeManagerNoop {
    constructor() {
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {
    }
    addLoadListener() {
    }
    attachIframe() {
    }
}
class IframeManager {
    constructor(options) {
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) {
            window.addEventListener('message', this.handleMessage.bind(this));
        }
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow)
            this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn,
                },
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true,
        });
        _optionalChain$1([this, 'access', _ => _.loadListener, 'optionalCall', _2 => _2(iframeEl)]);
        if (iframeEl.contentDocument &&
            iframeEl.contentDocument.adoptedStyleSheets &&
            iframeEl.contentDocument.adoptedStyleSheets.length > 0)
            this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' ||
            crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin)
            return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow)
            return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl)
            return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent)
            this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch (e.type) {
            case EventType.FullSnapshot: {
                this.crossOriginIframeMirror.reset(iframeEl);
                this.crossOriginIframeStyleMirror.reset(iframeEl);
                this.replaceIdOnNode(e.data.node, iframeEl);
                const rootId = e.data.node.id;
                this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                this.patchRootIdOnNode(e.data.node, rootId);
                return {
                    timestamp: e.timestamp,
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.Mutation,
                        adds: [
                            {
                                parentId: this.mirror.getId(iframeEl),
                                nextId: null,
                                node: e.data.node,
                            },
                        ],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: true,
                    },
                };
            }
            case EventType.Meta:
            case EventType.Load:
            case EventType.DomContentLoaded: {
                return false;
            }
            case EventType.Plugin: {
                return e;
            }
            case EventType.Custom: {
                this.replaceIds(e.data.payload, iframeEl, ['id', 'parentId', 'previousId', 'nextId']);
                return e;
            }
            case EventType.IncrementalSnapshot: {
                switch (e.data.source) {
                    case IncrementalSource.Mutation: {
                        e.data.adds.forEach((n) => {
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId',
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n) => {
                            this.replaceIds(n, iframeEl, ['parentId', 'id']);
                        });
                        e.data.attributes.forEach((n) => {
                            this.replaceIds(n, iframeEl, ['id']);
                        });
                        e.data.texts.forEach((n) => {
                            this.replaceIds(n, iframeEl, ['id']);
                        });
                        return e;
                    }
                    case IncrementalSource.Drag:
                    case IncrementalSource.TouchMove:
                    case IncrementalSource.MouseMove: {
                        e.data.positions.forEach((p) => {
                            this.replaceIds(p, iframeEl, ['id']);
                        });
                        return e;
                    }
                    case IncrementalSource.ViewportResize: {
                        return false;
                    }
                    case IncrementalSource.MediaInteraction:
                    case IncrementalSource.MouseInteraction:
                    case IncrementalSource.Scroll:
                    case IncrementalSource.CanvasMutation:
                    case IncrementalSource.Input: {
                        this.replaceIds(e.data, iframeEl, ['id']);
                        return e;
                    }
                    case IncrementalSource.StyleSheetRule:
                    case IncrementalSource.StyleDeclaration: {
                        this.replaceIds(e.data, iframeEl, ['id']);
                        this.replaceStyleIds(e.data, iframeEl, ['styleId']);
                        return e;
                    }
                    case IncrementalSource.Font: {
                        return e;
                    }
                    case IncrementalSource.Selection: {
                        e.data.ranges.forEach((range) => {
                            this.replaceIds(range, iframeEl, ['start', 'end']);
                        });
                        return e;
                    }
                    case IncrementalSource.AdoptedStyleSheet: {
                        this.replaceIds(e.data, iframeEl, ['id']);
                        this.replaceStyleIds(e.data, iframeEl, ['styleIds']);
                        _optionalChain$1([e, 'access', _3 => _3.data, 'access', _4 => _4.styles, 'optionalAccess', _5 => _5.forEach, 'call', _6 => _6((style) => {
                            this.replaceStyleIds(style, iframeEl, ['styleId']);
                        })]);
                        return e;
                    }
                }
            }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys) {
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number')
                continue;
            if (Array.isArray(obj[key])) {
                obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            }
            else {
                obj[key] = iframeMirror.getId(iframeEl, obj[key]);
            }
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, ['id', 'rootId']);
        if ('childNodes' in node) {
            node.childNodes.forEach((child) => {
                this.replaceIdOnNode(child, iframeEl);
            });
        }
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== NodeType$1.Document && !node.rootId)
            node.rootId = rootId;
        if ('childNodes' in node) {
            node.childNodes.forEach((child) => {
                this.patchRootIdOnNode(child, rootId);
            });
        }
    }
}

class ShadowDomManagerNoop {
    init() {
    }
    addShadowRoot() {
    }
    observeAttachShadow() {
    }
    reset() {
    }
}
class ShadowDomManager {
    constructor(options) {
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!isNativeShadowDom(shadowRoot))
            return;
        if (this.shadowDoms.has(shadowRoot))
            return;
        this.shadowDoms.add(shadowRoot);
        const observer = initMutationObserver({
            ...this.bypassOptions,
            doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this,
        }, shadowRoot);
        this.restoreHandlers.push(() => observer.disconnect());
        this.restoreHandlers.push(initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror,
        }));
        setTimeout$1(() => {
            if (shadowRoot.adoptedStyleSheets &&
                shadowRoot.adoptedStyleSheets.length > 0)
                this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push(initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager,
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument)
            return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function (original) {
            return function (option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && inDom(this))
                    manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler) => {
            try {
                handler();
            }
            catch (e) {
            }
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}

class CanvasManagerNoop {
    reset() {
    }
    freeze() {
    }
    unfreeze() {
    }
    lock() {
    }
    unlock() {
    }
    snapshot() {
    }
}

class StylesheetManager {
    constructor(options) {
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes)
            this.mutationCb({
                adds: [],
                removes: [],
                texts: [],
                attributes: [
                    {
                        id: childSn.id,
                        attributes: childSn
                            .attributes,
                    },
                ],
            });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl))
            return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0)
            return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: [],
        };
        const styles = [];
        for (const sheet of sheets) {
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index) => ({
                        rule: stringifyRule(r),
                        index,
                    })),
                });
            }
            else
                styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0)
            adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {
    }
}

class ProcessedNodeManager {
    constructor() {
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        onRequestAnimationFrame(() => {
            this.clear();
            if (this.loop)
                this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return (buffers && Array.from(buffers).some((buffer) => buffer !== thisBuffer));
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}

let wrappedEmit;
let _takeFullSnapshot;
const mirror = createMirror();
function record(options = {}) {
    const { emit, checkoutEveryNms, checkoutEveryNth, blockClass = 'rr-block', blockSelector = null, unblockSelector = null, ignoreClass = 'rr-ignore', ignoreSelector = null, maskAllText = false, maskTextClass = 'rr-mask', unmaskTextClass = null, maskTextSelector = null, unmaskTextSelector = null, inlineStylesheet = true, maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn, maskInputFn, maskTextFn, maxCanvasSize = null, packFn, sampling = {}, dataURLOptions = {}, mousemoveWait, recordCanvas = false, recordCrossOriginIframes = false, recordAfter = options.recordAfter === 'DOMContentLoaded'
        ? options.recordAfter
        : 'load', userTriggeredOnInput = false, collectFonts = false, inlineImages = false, plugins, keepIframeSrcFn = () => false, ignoreCSSAttributes = new Set([]), errorHandler, onMutation, getCanvasManager, } = options;
    registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes
        ? window.parent === window
        : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) {
        try {
            if (window.parent.document) {
                passEmitsToParent = false;
            }
        }
        catch (e) {
            passEmitsToParent = true;
        }
    }
    if (inEmittingFrame && !emit) {
        throw new Error('emit function is required');
    }
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
        sampling.mousemove = mousemoveWait;
    }
    mirror.reset();
    const maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
            radio: true,
            checkbox: true,
        }
        : _maskInputOptions !== undefined
            ? _maskInputOptions
            : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all'
        ? {
            script: true,
            comment: true,
            headFavicon: true,
            headWhitespace: true,
            headMetaSocial: true,
            headMetaRobots: true,
            headMetaHttpEquiv: true,
            headMetaVerification: true,
            headMetaAuthorship: _slimDOMOptions === 'all',
            headMetaDescKeywords: _slimDOMOptions === 'all',
        }
        : _slimDOMOptions
            ? _slimDOMOptions
            : {};
    polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e) => {
        for (const plugin of plugins || []) {
            if (plugin.eventProcessor) {
                e = plugin.eventProcessor(e);
            }
        }
        if (packFn &&
            !passEmitsToParent) {
            e = packFn(e);
        }
        return e;
    };
    wrappedEmit = (r, isCheckout) => {
        const e = r;
        e.timestamp = nowTimestamp();
        if ((0,_optionalChain/* _optionalChain */.x)([mutationBuffers, 'access', _ => _[0], 'optionalAccess', _2 => _2.isFrozen, 'call', _3 => _3()]) &&
            e.type !== EventType.FullSnapshot &&
            !(e.type === EventType.IncrementalSnapshot &&
                e.data.source === IncrementalSource.Mutation)) {
            mutationBuffers.forEach((buf) => buf.unfreeze());
        }
        if (inEmittingFrame) {
            (0,_optionalChain/* _optionalChain */.x)([emit, 'optionalCall', _4 => _4(eventProcessor(e), isCheckout)]);
        }
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout,
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        }
        else if (e.type === EventType.IncrementalSnapshot) {
            if (e.data.source === IncrementalSource.Mutation &&
                e.data.isAttachIframe) {
                return;
            }
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms &&
                lastFullSnapshotEvent &&
                e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) {
                takeFullSnapshot(true);
            }
        }
    };
    const wrappedMutationEmit = (m) => {
        wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
                source: IncrementalSource.Mutation,
                ...m,
            },
        });
    };
    const wrappedScrollEmit = (p) => wrappedEmit({
        type: EventType.IncrementalSnapshot,
        data: {
            source: IncrementalSource.Scroll,
            ...p,
        },
    });
    const wrappedCanvasMutationEmit = (p) => wrappedEmit({
        type: EventType.IncrementalSnapshot,
        data: {
            source: IncrementalSource.CanvasMutation,
            ...p,
        },
    });
    const wrappedAdoptedStyleSheetEmit = (a) => wrappedEmit({
        type: EventType.IncrementalSnapshot,
        data: {
            source: IncrementalSource.AdoptedStyleSheet,
            ...a,
        },
    });
    const stylesheetManager = new StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit,
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__
        ? new IframeManagerNoop()
        : new IframeManager({
            mirror,
            mutationCb: wrappedMutationEmit,
            stylesheetManager: stylesheetManager,
            recordCrossOriginIframes,
            wrappedEmit,
        });
    for (const plugin of plugins || []) {
        if (plugin.getMirror)
            plugin.getMirror({
                nodeMirror: mirror,
                crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
                crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror,
            });
    }
    const processedNodeManager = new ProcessedNodeManager();
    const canvasManager = _getCanvasManager(getCanvasManager, {
        mirror,
        win: window,
        mutationCb: (p) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
                source: IncrementalSource.CanvasMutation,
                ...p,
            },
        }),
        recordCanvas,
        blockClass,
        blockSelector,
        unblockSelector,
        maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions,
        errorHandler,
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' &&
        __RRWEB_EXCLUDE_SHADOW_DOM__
        ? new ShadowDomManagerNoop()
        : new ShadowDomManager({
            mutationCb: wrappedMutationEmit,
            scrollCb: wrappedScrollEmit,
            bypassOptions: {
                onMutation,
                blockClass,
                blockSelector,
                unblockSelector,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                inlineStylesheet,
                maskInputOptions,
                dataURLOptions,
                maskAttributeFn,
                maskTextFn,
                maskInputFn,
                recordCanvas,
                inlineImages,
                sampling,
                slimDOMOptions,
                iframeManager,
                stylesheetManager,
                canvasManager,
                keepIframeSrcFn,
                processedNodeManager,
            },
            mirror,
        });
    const takeFullSnapshot = (isCheckout = false) => {
        wrappedEmit({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight(),
            },
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        mutationBuffers.forEach((buf) => buf.lock());
        const node = snapshot(document, {
            mirror,
            blockClass,
            blockSelector,
            unblockSelector,
            maskAllText,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn,
            maskInputFn,
            maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions,
            recordCanvas,
            inlineImages,
            onSerialize: (n) => {
                if (isSerializedIframe(n, mirror)) {
                    iframeManager.addIframe(n);
                }
                if (isSerializedStylesheet(n, mirror)) {
                    stylesheetManager.trackLinkElement(n);
                }
                if (hasShadowRoot(n)) {
                    shadowDomManager.addShadowRoot(n.shadowRoot, document);
                }
            },
            onIframeLoad: (iframe, childSn) => {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn) => {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn,
        });
        if (!node) {
            return console.warn('Failed to snapshot the document');
        }
        wrappedEmit({
            type: EventType.FullSnapshot,
            data: {
                node,
                initialOffset: getWindowScroll(window),
            },
        });
        mutationBuffers.forEach((buf) => buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0)
            stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
    };
    _takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc) => {
            return callbackWrapper(initObservers)({
                onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source,
                        positions,
                    },
                }),
                mouseInteractionCb: (d) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.MouseInteraction,
                        ...d,
                    },
                }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.ViewportResize,
                        ...d,
                    },
                }),
                inputCb: (v) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.Input,
                        ...v,
                    },
                }),
                mediaInteractionCb: (p) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.MediaInteraction,
                        ...p,
                    },
                }),
                styleSheetRuleCb: (r) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.StyleSheetRule,
                        ...r,
                    },
                }),
                styleDeclarationCb: (r) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.StyleDeclaration,
                        ...r,
                    },
                }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p) => wrappedEmit({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source: IncrementalSource.Font,
                        ...p,
                    },
                }),
                selectionCb: (p) => {
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.Selection,
                            ...p,
                        },
                    });
                },
                customElementCb: (c) => {
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.CustomElement,
                            ...c,
                        },
                    });
                },
                blockClass,
                ignoreClass,
                ignoreSelector,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                maskInputOptions,
                inlineStylesheet,
                sampling,
                recordCanvas,
                inlineImages,
                userTriggeredOnInput,
                collectFonts,
                doc,
                maskAttributeFn,
                maskInputFn,
                maskTextFn,
                keepIframeSrcFn,
                blockSelector,
                unblockSelector,
                slimDOMOptions,
                dataURLOptions,
                mirror,
                iframeManager,
                stylesheetManager,
                shadowDomManager,
                processedNodeManager,
                canvasManager,
                ignoreCSSAttributes,
                plugins: (0,_optionalChain/* _optionalChain */.x)([plugins
, 'optionalAccess', _5 => _5.filter, 'call', _6 => _6((p) => p.observer)
, 'optionalAccess', _7 => _7.map, 'call', _8 => _8((p) => ({
                    observer: p.observer,
                    options: p.options,
                    callback: (payload) => wrappedEmit({
                        type: EventType.Plugin,
                        data: {
                            plugin: p.name,
                            payload,
                        },
                    }),
                }))]) || [],
            }, {});
        };
        iframeManager.addLoadListener((iframeEl) => {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            }
            catch (error) {
                console.warn(error);
            }
        });
        const init = () => {
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' ||
            document.readyState === 'complete') {
            init();
        }
        else {
            handlers.push(on('DOMContentLoaded', () => {
                wrappedEmit({
                    type: EventType.DomContentLoaded,
                    data: {},
                });
                if (recordAfter === 'DOMContentLoaded')
                    init();
            }));
            handlers.push(on('load', () => {
                wrappedEmit({
                    type: EventType.Load,
                    data: {},
                });
                if (recordAfter === 'load')
                    init();
            }, window));
        }
        return () => {
            handlers.forEach((h) => h());
            processedNodeManager.destroy();
            _takeFullSnapshot = undefined;
            unregisterErrorHandler();
        };
    }
    catch (error) {
        console.warn(error);
    }
}
function takeFullSnapshot(isCheckout) {
    if (!_takeFullSnapshot) {
        throw new Error('please take full snapshot after start recording');
    }
    _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn
            ? getCanvasManagerFn(options)
            : new CanvasManagerNoop();
    }
    catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new CanvasManagerNoop();
    }
}

const ReplayEventTypeIncrementalSnapshot = 3;
const ReplayEventTypeCustom = 5;

/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */
function timestampToMs(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp : timestamp * 1000;
}

/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */
function timestampToS(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Add a breadcrumb event to replay.
 */
function addBreadcrumbEvent(replay, breadcrumb) {
  if (breadcrumb.category === 'sentry.transaction') {
    return;
  }

  if (['ui.click', 'ui.input'].includes(breadcrumb.category )) {
    replay.triggerUserActivity();
  } else {
    replay.checkAndHandleExpiredSession();
  }

  replay.addUpdate(() => {
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.throttledAddEvent({
      type: EventType.Custom,
      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
      // but maybe we should just keep them as milliseconds
      timestamp: (breadcrumb.timestamp || 0) * 1000,
      data: {
        tag: 'breadcrumb',
        // normalize to max. 10 depth and 1_000 properties per object
        payload: (0,normalize/* normalize */.Fv)(breadcrumb, 10, 1000),
      },
    });

    // Do not flush after console log messages
    return breadcrumb.category === 'console';
  });
}

const INTERACTIVE_SELECTOR = 'button,a';

/** Get the closest interactive parent element, or else return the given element. */
function getClosestInteractive(element) {
  const closestInteractive = element.closest(INTERACTIVE_SELECTOR);
  return closestInteractive || element;
}

/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */
function getClickTargetNode(event) {
  const target = getTargetNode(event);

  if (!target || !(target instanceof Element)) {
    return target;
  }

  return getClosestInteractive(target);
}

/** Get the event target node. */
function getTargetNode(event) {
  if (isEventWithTarget(event)) {
    return event.target ;
  }

  return event;
}

function isEventWithTarget(event) {
  return typeof event === 'object' && !!event && 'target' in event;
}

let handlers;

/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */
function onWindowOpen(cb) {
  // Ensure to only register this once
  if (!handlers) {
    handlers = [];
    monkeyPatchWindowOpen();
  }

  handlers.push(cb);

  return () => {
    const pos = handlers ? handlers.indexOf(cb) : -1;
    if (pos > -1) {
      (handlers ).splice(pos, 1);
    }
  };
}

function monkeyPatchWindowOpen() {
  (0,object/* fill */.hl)(WINDOW, 'open', function (originalWindowOpen) {
    return function (...args) {
      if (handlers) {
        try {
          handlers.forEach(handler => handler());
        } catch (e) {
          // ignore errors in here
        }
      }

      return originalWindowOpen.apply(WINDOW, args);
    };
  });
}

/** Handle a click. */
function handleClick(clickDetector, clickBreadcrumb, node) {
  clickDetector.handleClick(clickBreadcrumb, node);
}

/** A click detector class that can be used to detect slow or rage clicks on elements. */
class ClickDetector  {
  // protected for testing

   constructor(
    replay,
    slowClickConfig,
    // Just for easier testing
    _addBreadcrumbEvent = addBreadcrumbEvent,
  ) {
    this._lastMutation = 0;
    this._lastScroll = 0;
    this._clicks = [];

    // We want everything in s, but options are in ms
    this._timeout = slowClickConfig.timeout / 1000;
    this._threshold = slowClickConfig.threshold / 1000;
    this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
    this._replay = replay;
    this._ignoreSelector = slowClickConfig.ignoreSelector;
    this._addBreadcrumbEvent = _addBreadcrumbEvent;
  }

  /** Register click detection handlers on mutation or scroll. */
   addListeners() {
    const cleanupWindowOpen = onWindowOpen(() => {
      // Treat window.open as mutation
      this._lastMutation = nowInSeconds();
    });

    this._teardown = () => {
      cleanupWindowOpen();

      this._clicks = [];
      this._lastMutation = 0;
      this._lastScroll = 0;
    };
  }

  /** Clean up listeners. */
   removeListeners() {
    if (this._teardown) {
      this._teardown();
    }

    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
  }

  /** @inheritDoc */
   handleClick(breadcrumb, node) {
    if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
      return;
    }

    const newClick = {
      timestamp: timestampToS(breadcrumb.timestamp),
      clickBreadcrumb: breadcrumb,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node,
    };

    // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
    if (
      this._clicks.some(click => click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)
    ) {
      return;
    }

    this._clicks.push(newClick);

    // If this is the first new click, set a timeout to check for multi clicks
    if (this._clicks.length === 1) {
      this._scheduleCheckClicks();
    }
  }

  /** @inheritDoc */
   registerMutation(timestamp = Date.now()) {
    this._lastMutation = timestampToS(timestamp);
  }

  /** @inheritDoc */
   registerScroll(timestamp = Date.now()) {
    this._lastScroll = timestampToS(timestamp);
  }

  /** @inheritDoc */
   registerClick(element) {
    const node = getClosestInteractive(element);
    this._handleMultiClick(node );
  }

  /** Count multiple clicks on elements. */
   _handleMultiClick(node) {
    this._getClicks(node).forEach(click => {
      click.clickCount++;
    });
  }

  /** Get all pending clicks for a given node. */
   _getClicks(node) {
    return this._clicks.filter(click => click.node === node);
  }

  /** Check the clicks that happened. */
   _checkClicks() {
    const timedOutClicks = [];

    const now = nowInSeconds();

    this._clicks.forEach(click => {
      if (!click.mutationAfter && this._lastMutation) {
        click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
      }
      if (!click.scrollAfter && this._lastScroll) {
        click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
      }

      // All of these are in seconds!
      if (click.timestamp + this._timeout <= now) {
        timedOutClicks.push(click);
      }
    });

    // Remove "old" clicks
    for (const click of timedOutClicks) {
      const pos = this._clicks.indexOf(click);

      if (pos > -1) {
        this._generateBreadcrumbs(click);
        this._clicks.splice(pos, 1);
      }
    }

    // Trigger new check, unless no clicks left
    if (this._clicks.length) {
      this._scheduleCheckClicks();
    }
  }

  /** Generate matching breadcrumb(s) for the click. */
   _generateBreadcrumbs(click) {
    const replay = this._replay;
    const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
    const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;

    const isSlowClick = !hadScroll && !hadMutation;
    const { clickCount, clickBreadcrumb } = click;

    // Slow click
    if (isSlowClick) {
      // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
      // If not, it means we just timed out without scroll & mutation
      const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
      const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';

      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.slowClickDetected',
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          timeAfterClickMs,
          endReason,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: clickCount || 1,
        },
      };

      this._addBreadcrumbEvent(replay, breadcrumb);
      return;
    }

    // Multi click
    if (clickCount > 1) {
      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.multiClick',
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          clickCount,
          metric: true,
        },
      };

      this._addBreadcrumbEvent(replay, breadcrumb);
    }
  }

  /** Schedule to check current clicks. */
   _scheduleCheckClicks() {
    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }

    this._checkClickTimeout = setTimeout(() => this._checkClicks(), 1000);
  }
}

const SLOW_CLICK_TAGS = ['A', 'BUTTON', 'INPUT'];

/** exported for tests only */
function ignoreElement(node, ignoreSelector) {
  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
    return true;
  }

  // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
  if (node.tagName === 'INPUT' && !['submit', 'button'].includes(node.getAttribute('type') || '')) {
    return true;
  }

  // If <a> tag, detect special variants that may not lead to an action
  // If target !== _self, we may open the link somewhere else, which would lead to no action
  // Also, when downloading a file, we may not leave the page, but still not trigger an action
  if (
    node.tagName === 'A' &&
    (node.hasAttribute('download') || (node.hasAttribute('target') && node.getAttribute('target') !== '_self'))
  ) {
    return true;
  }

  if (ignoreSelector && node.matches(ignoreSelector)) {
    return true;
  }

  return false;
}

function isClickBreadcrumb(breadcrumb) {
  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}

// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
  return Date.now() / 1000;
}

/** Update the click detector based on a recording event of rrweb. */
function updateClickDetectorForRecordingEvent(clickDetector, event) {
  try {
    // note: We only consider incremental snapshots here
    // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
    // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
    // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
    // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
    // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
    // But this should be more unlikely as we'd generally capture the incremental snapshot right away

    if (!isIncrementalEvent(event)) {
      return;
    }

    const { source } = event.data;
    if (source === IncrementalSource.Mutation) {
      clickDetector.registerMutation(event.timestamp);
    }

    if (source === IncrementalSource.Scroll) {
      clickDetector.registerScroll(event.timestamp);
    }

    if (isIncrementalMouseInteraction(event)) {
      const { type, id } = event.data;
      const node = record.mirror.getNode(id);

      if (node instanceof HTMLElement && type === MouseInteractions.Click) {
        clickDetector.registerClick(node);
      }
    }
  } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
  }
}

function isIncrementalEvent(event) {
  return event.type === ReplayEventTypeIncrementalSnapshot;
}

function isIncrementalMouseInteraction(
  event,
) {
  return event.data.source === IncrementalSource.MouseInteraction;
}

/**
 * Create a breadcrumb for a replay.
 */
function createBreadcrumb(
  breadcrumb,
) {
  return {
    timestamp: Date.now() / 1000,
    type: 'default',
    ...breadcrumb,
  };
}

var NodeType;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const ATTRIBUTES_TO_RECORD = new Set([
  'id',
  'class',
  'aria-label',
  'role',
  'name',
  'alt',
  'title',
  'data-test-id',
  'data-testid',
  'disabled',
  'aria-disabled',
  'data-sentry-component',
]);

/**
 * Inclusion list of attributes that we want to record from the DOM element
 */
function getAttributesToRecord(attributes) {
  const obj = {};
  for (const key in attributes) {
    if (ATTRIBUTES_TO_RECORD.has(key)) {
      let normalizedKey = key;

      if (key === 'data-testid' || key === 'data-test-id') {
        normalizedKey = 'testId';
      }

      obj[normalizedKey] = attributes[key];
    }
  }

  return obj;
}

const handleDomListener = (
  replay,
) => {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleDom(handlerData);

    if (!result) {
      return;
    }

    const isClick = handlerData.name === 'click';
    const event = isClick ? (handlerData.event ) : undefined;
    // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
    if (
      isClick &&
      replay.clickDetector &&
      event &&
      event.target &&
      !event.altKey &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey
    ) {
      handleClick(
        replay.clickDetector,
        result ,
        getClickTargetNode(handlerData.event ) ,
      );
    }

    addBreadcrumbEvent(replay, result);
  };
};

/** Get the base DOM breadcrumb. */
function getBaseDomBreadcrumb(target, message) {
  const nodeId = record.mirror.getId(target);
  const node = nodeId && record.mirror.getNode(nodeId);
  const meta = node && record.mirror.getMeta(node);
  const element = meta && isElement(meta) ? meta : null;

  return {
    message,
    data: element
      ? {
          nodeId,
          node: {
            id: nodeId,
            tagName: element.tagName,
            textContent: Array.from(element.childNodes)
              .map((node) => node.type === NodeType.Text && node.textContent)
              .filter(Boolean) // filter out empty values
              .map(text => (text ).trim())
              .join(''),
            attributes: getAttributesToRecord(element.attributes),
          },
        }
      : {},
  };
}

/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */
function handleDom(handlerData) {
  const { target, message } = getDomTarget(handlerData);

  return createBreadcrumb({
    category: `ui.${handlerData.name}`,
    ...getBaseDomBreadcrumb(target, message),
  });
}

function getDomTarget(handlerData) {
  const isClick = handlerData.name === 'click';

  let message;
  let target = null;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    target = isClick ? getClickTargetNode(handlerData.event ) : getTargetNode(handlerData.event );
    message = (0,browser/* htmlTreeAsString */.Rt)(target, { maxStringLength: 200 }) || '<unknown>';
  } catch (e) {
    message = '<unknown>';
  }

  return { target, message };
}

function isElement(node) {
  return node.type === NodeType.Element;
}

/** Handle keyboard events & create breadcrumbs. */
function handleKeyboardEvent(replay, event) {
  if (!replay.isEnabled()) {
    return;
  }

  // Update user activity, but do not restart recording as it can create
  // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
  // session with a single "keydown" breadcrumb is created)
  replay.updateUserActivity();

  const breadcrumb = getKeyboardBreadcrumb(event);

  if (!breadcrumb) {
    return;
  }

  addBreadcrumbEvent(replay, breadcrumb);
}

/** exported only for tests */
function getKeyboardBreadcrumb(event) {
  const { metaKey, shiftKey, ctrlKey, altKey, key, target } = event;

  // never capture for input fields
  if (!target || isInputElement(target ) || !key) {
    return null;
  }

  // Note: We do not consider shift here, as that means "uppercase"
  const hasModifierKey = metaKey || ctrlKey || altKey;
  const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length

  // Do not capture breadcrumb if only a word key is pressed
  // This could leak e.g. user input
  if (!hasModifierKey && isCharacterKey) {
    return null;
  }

  const message = (0,browser/* htmlTreeAsString */.Rt)(target, { maxStringLength: 200 }) || '<unknown>';
  const baseBreadcrumb = getBaseDomBreadcrumb(target , message);

  return createBreadcrumb({
    category: 'ui.keyDown',
    message,
    data: {
      ...baseBreadcrumb.data,
      metaKey,
      shiftKey,
      ctrlKey,
      altKey,
      key,
    },
  });
}

function isInputElement(target) {
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}

// Map entryType -> function to normalize data for event
const ENTRY_TYPES

 = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry,
};

/**
 * Create replay performance entries from the browser performance entries.
 */
function createPerformanceEntries(
  entries,
) {
  return entries.map(createPerformanceEntry).filter(Boolean) ;
}

function createPerformanceEntry(entry) {
  if (!ENTRY_TYPES[entry.entryType]) {
    return null;
  }

  return ENTRY_TYPES[entry.entryType](entry);
}

function getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || WINDOW.performance.timeOrigin) + time) / 1000;
}

function createPaintEntry(entry) {
  const { duration, entryType, name, startTime } = entry;

  const start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name,
    start,
    end: start + duration,
    data: undefined,
  };
}

function createNavigationEntry(entry) {
  const {
    entryType,
    name,
    decodedBodySize,
    duration,
    domComplete,
    encodedBodySize,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    domInteractive,
    loadEventStart,
    loadEventEnd,
    redirectCount,
    startTime,
    transferSize,
    type,
  } = entry;

  // Ignore entries with no duration, they do not seem to be useful and cause dupes
  if (duration === 0) {
    return null;
  }

  return {
    type: `${entryType}.${type}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name,
    data: {
      size: transferSize,
      decodedBodySize,
      encodedBodySize,
      duration,
      domInteractive,
      domContentLoadedEventStart,
      domContentLoadedEventEnd,
      loadEventStart,
      loadEventEnd,
      domComplete,
      redirectCount,
    },
  };
}

function createResourceEntry(
  entry,
) {
  const {
    entryType,
    initiatorType,
    name,
    responseEnd,
    startTime,
    decodedBodySize,
    encodedBodySize,
    responseStatus,
    transferSize,
  } = entry;

  // Core SDK handles these
  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }

  return {
    type: `${entryType}.${initiatorType}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name,
    data: {
      size: transferSize,
      statusCode: responseStatus,
      decodedBodySize,
      encodedBodySize,
    },
  };
}

/**
 * Add a LCP event to the replay based on an LCP metric.
 */
function getLargestContentfulPaint(metric

) {
  const entries = metric.entries;
  const lastEntry = entries[entries.length - 1] ;
  const element = lastEntry ? lastEntry.element : undefined;

  const value = metric.value;

  const end = getAbsoluteTime(value);

  const data = {
    type: 'largest-contentful-paint',
    name: 'largest-contentful-paint',
    start: end,
    end,
    data: {
      value,
      size: value,
      nodeId: element ? record.mirror.getId(element) : undefined,
    },
  };

  return data;
}

/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */
function setupPerformanceObserver(replay) {
  function addPerformanceEntry(entry) {
    // It is possible for entries to come up multiple times
    if (!replay.performanceEntries.includes(entry)) {
      replay.performanceEntries.push(entry);
    }
  }

  function onEntries({ entries }) {
    entries.forEach(addPerformanceEntry);
  }

  const clearCallbacks = [];

  (['navigation', 'paint', 'resource'] ).forEach(type => {
    clearCallbacks.push((0,instrument/* addPerformanceInstrumentationHandler */._j)(type, onEntries));
  });

  clearCallbacks.push(
    (0,instrument/* addLcpInstrumentationHandler */.$A)(({ metric }) => {
      replay.replayPerformanceEntries.push(getLargestContentfulPaint(metric));
    }),
  );

  // A callback to cleanup all handlers
  return () => {
    clearCallbacks.forEach(clearCallback => clearCallback());
  };
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

const r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;

function e(){const e=new Blob([r]);return URL.createObjectURL(e)}

/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */
function logInfo(message, shouldAddBreadcrumb) {
  if (!DEBUG_BUILD) {
    return;
  }

  logger/* logger.info */.kg.info(message);

  if (shouldAddBreadcrumb) {
    addLogBreadcrumb(message);
  }
}

/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */
function logInfoNextTick(message, shouldAddBreadcrumb) {
  if (!DEBUG_BUILD) {
    return;
  }

  logger/* logger.info */.kg.info(message);

  if (shouldAddBreadcrumb) {
    // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(() => {
      addLogBreadcrumb(message);
    }, 0);
  }
}

function addLogBreadcrumb(message) {
  (0,esm_exports/* addBreadcrumb */.n_)(
    {
      category: 'console',
      data: {
        logger: 'replay',
      },
      level: 'info',
      message,
    },
    { level: 'info' },
  );
}

/** This error indicates that the event buffer size exceeded the limit.. */
class EventBufferSizeExceededError extends Error {
   constructor() {
    super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
  }
}

/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */
class EventBufferArray  {
  /** All the events that are buffered to be sent. */

  /** @inheritdoc */

   constructor() {
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
  }

  /** @inheritdoc */
   get hasEvents() {
    return this.events.length > 0;
  }

  /** @inheritdoc */
   get type() {
    return 'sync';
  }

  /** @inheritdoc */
   destroy() {
    this.events = [];
  }

  /** @inheritdoc */
   async addEvent(event) {
    const eventSize = JSON.stringify(event).length;
    this._totalSize += eventSize;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      throw new EventBufferSizeExceededError();
    }

    this.events.push(event);
  }

  /** @inheritdoc */
   finish() {
    return new Promise(resolve => {
      // Make a copy of the events array reference and immediately clear the
      // events member so that we do not lose new events while uploading
      // attachment.
      const eventsRet = this.events;
      this.clear();
      resolve(JSON.stringify(eventsRet));
    });
  }

  /** @inheritdoc */
   clear() {
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    const timestamp = this.events.map(event => event.timestamp).sort()[0];

    if (!timestamp) {
      return null;
    }

    return timestampToMs(timestamp);
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class WorkerHandler {

   constructor(worker) {
    this._worker = worker;
    this._id = 0;
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    // Ensure we only check once
    if (this._ensureReadyPromise) {
      return this._ensureReadyPromise;
    }

    this._ensureReadyPromise = new Promise((resolve, reject) => {
      this._worker.addEventListener(
        'message',
        ({ data }) => {
          if ((data ).success) {
            resolve();
          } else {
            reject();
          }
        },
        { once: true },
      );

      this._worker.addEventListener(
        'error',
        error => {
          reject(error);
        },
        { once: true },
      );
    });

    return this._ensureReadyPromise;
  }

  /**
   * Destroy the worker.
   */
   destroy() {
    logInfo('[Replay] Destroying compression worker');
    this._worker.terminate();
  }

  /**
   * Post message to worker and wait for response before resolving promise.
   */
   postMessage(method, arg) {
    const id = this._getAndIncrementId();

    return new Promise((resolve, reject) => {
      const listener = ({ data }) => {
        const response = data ;
        if (response.method !== method) {
          return;
        }

        // There can be multiple listeners for a single method, the id ensures
        // that the response matches the caller.
        if (response.id !== id) {
          return;
        }

        // At this point, we'll always want to remove listener regardless of result status
        this._worker.removeEventListener('message', listener);

        if (!response.success) {
          // TODO: Do some error handling, not sure what
          DEBUG_BUILD && logger/* logger.error */.kg.error('[Replay]', response.response);

          reject(new Error('Error in compression worker'));
          return;
        }

        resolve(response.response );
      };

      // Note: we can't use `once` option because it's possible it needs to
      // listen to multiple messages
      this._worker.addEventListener('message', listener);
      this._worker.postMessage({ id, method, arg });
    });
  }

  /** Get the current ID and increment it for the next call. */
   _getAndIncrementId() {
    return this._id++;
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class EventBufferCompressionWorker  {
  /** @inheritdoc */

   constructor(worker) {
    this._worker = new WorkerHandler(worker);
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;
  }

  /** @inheritdoc */
   get hasEvents() {
    return !!this._earliestTimestamp;
  }

  /** @inheritdoc */
   get type() {
    return 'worker';
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    return this._worker.ensureReady();
  }

  /**
   * Destroy the event buffer.
   */
   destroy() {
    this._worker.destroy();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */
   addEvent(event) {
    const timestamp = timestampToMs(event.timestamp);
    if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
      this._earliestTimestamp = timestamp;
    }

    const data = JSON.stringify(event);
    this._totalSize += data.length;

    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      return Promise.reject(new EventBufferSizeExceededError());
    }

    return this._sendEventToWorker(data);
  }

  /**
   * Finish the event buffer and return the compressed data.
   */
   finish() {
    return this._finishRequest();
  }

  /** @inheritdoc */
   clear() {
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;

    // We do not wait on this, as we assume the order of messages is consistent for the worker
    this._worker.postMessage('clear').then(null, e => {
      DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Sending "clear" message to worker failed', e);
    });
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    return this._earliestTimestamp;
  }

  /**
   * Send the event to the worker.
   */
   _sendEventToWorker(data) {
    return this._worker.postMessage('addEvent', data);
  }

  /**
   * Finish the request and return the compressed data from the worker.
   */
   async _finishRequest() {
    const response = await this._worker.postMessage('finish');

    this._earliestTimestamp = null;
    this._totalSize = 0;

    return response;
  }
}

/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */
class EventBufferProxy  {

   constructor(worker) {
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;

    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }

  /** @inheritdoc */
   get type() {
    return this._used.type;
  }

  /** @inheritDoc */
   get hasEvents() {
    return this._used.hasEvents;
  }

  /** @inheritdoc */
   get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
   set hasCheckout(value) {
    this._used.hasCheckout = value;
  }

  /** @inheritDoc */
   destroy() {
    this._fallback.destroy();
    this._compression.destroy();
  }

  /** @inheritdoc */
   clear() {
    return this._used.clear();
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
   addEvent(event) {
    return this._used.addEvent(event);
  }

  /** @inheritDoc */
   async finish() {
    // Ensure the worker is loaded, so the sent event is compressed
    await this.ensureWorkerIsLoaded();

    return this._used.finish();
  }

  /** Ensure the worker has loaded. */
   ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }

  /** Actually check if the worker has been loaded. */
   async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (error) {
      // If the worker fails to load, we fall back to the simple buffer.
      // Nothing more to do from our side here
      logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
      return;
    }

    // Now we need to switch over the array buffer to the compression worker
    await this._switchToCompressionWorker();
  }

  /** Switch the used buffer to the compression worker. */
   async _switchToCompressionWorker() {
    const { events, hasCheckout } = this._fallback;

    const addEventPromises = [];
    for (const event of events) {
      addEventPromises.push(this._compression.addEvent(event));
    }

    this._compression.hasCheckout = hasCheckout;

    // We switch over to the new buffer immediately - any further events will be added
    // after the previously buffered ones
    this._used = this._compression;

    // Wait for original events to be re-added before resolving
    try {
      await Promise.all(addEventPromises);
    } catch (error) {
      DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to add events when switching buffers.', error);
    }
  }
}

/**
 * Create an event buffer for replays.
 */
function createEventBuffer({
  useCompression,
  workerUrl: customWorkerUrl,
}) {
  if (
    useCompression &&
    // eslint-disable-next-line no-restricted-globals
    window.Worker
  ) {
    const worker = _loadWorker(customWorkerUrl);

    if (worker) {
      return worker;
    }
  }

  logInfo('[Replay] Using simple buffer');
  return new EventBufferArray();
}

function _loadWorker(customWorkerUrl) {
  try {
    const workerUrl = customWorkerUrl || _getWorkerUrl();

    if (!workerUrl) {
      return;
    }

    logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
    const worker = new Worker(workerUrl);
    return new EventBufferProxy(worker);
  } catch (error) {
    logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
  }
}

function _getWorkerUrl() {
  if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) {
    return e();
  }

  return '';
}

/** If sessionStorage is available. */
function hasSessionStorage() {
  try {
    // This can throw, e.g. when being accessed in a sandboxed iframe
    return 'sessionStorage' in WINDOW && !!WINDOW.sessionStorage;
  } catch (e) {
    return false;
  }
}

/**
 * Removes the session from Session Storage and unsets session in replay instance
 */
function clearSession(replay) {
  deleteSession();
  replay.session = undefined;
}

/**
 * Deletes a session from storage
 */
function deleteSession() {
  if (!hasSessionStorage()) {
    return;
  }

  try {
    WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  }

  // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
  return Math.random() < sampleRate;
}

/**
 * Get a session with defaults & applied sampling.
 */
function makeSession(session) {
  const now = Date.now();
  const id = session.id || (0,misc/* uuid4 */.DM)();
  // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
  const started = session.started || now;
  const lastActivity = session.lastActivity || now;
  const segmentId = session.segmentId || 0;
  const sampled = session.sampled;
  const previousSessionId = session.previousSessionId;

  return {
    id,
    started,
    lastActivity,
    segmentId,
    sampled,
    previousSessionId,
  };
}

/**
 * Save a session to session storage.
 */
function saveSession(session) {
  if (!hasSessionStorage()) {
    return;
  }

  try {
    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */
function getSessionSampleType(sessionSampleRate, allowBuffering) {
  return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}

/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */
function createSession(
  { sessionSampleRate, allowBuffering, stickySession = false },
  { previousSessionId } = {},
) {
  const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
  const session = makeSession({
    sampled,
    previousSessionId,
  });

  if (stickySession) {
    saveSession(session);
  }

  return session;
}

/**
 * Fetches a session from storage
 */
function fetchSession(traceInternals) {
  if (!hasSessionStorage()) {
    return null;
  }

  try {
    // This can throw if cookies are disabled
    const sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);

    if (!sessionStringFromStorage) {
      return null;
    }

    const sessionObj = JSON.parse(sessionStringFromStorage) ;

    logInfoNextTick('[Replay] Loading existing session', traceInternals);

    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(
  initialTime,
  expiry,
  targetTime = +new Date(),
) {
  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  }

  // Never expires if == 0
  if (expiry === 0) {
    return false;
  }

  return initialTime + expiry <= targetTime;
}

/**
 * Checks to see if session is expired
 */
function isSessionExpired(
  session,
  {
    maxReplayDuration,
    sessionIdleExpire,
    targetTime = Date.now(),
  },
) {
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) ||
    // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime)
  );
}

/** If the session should be refreshed or not. */
function shouldRefreshSession(
  session,
  { sessionIdleExpire, maxReplayDuration },
) {
  // If not expired, all good, just keep the session
  if (!isSessionExpired(session, { sessionIdleExpire, maxReplayDuration })) {
    return false;
  }

  // If we are buffering & haven't ever flushed yet, always continue
  if (session.sampled === 'buffer' && session.segmentId === 0) {
    return false;
  }

  return true;
}

/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */
function loadOrCreateSession(
  {
    traceInternals,
    sessionIdleExpire,
    maxReplayDuration,
    previousSessionId,
  }

,
  sessionOptions,
) {
  const existingSession = sessionOptions.stickySession && fetchSession(traceInternals);

  // No session exists yet, just create a new one
  if (!existingSession) {
    logInfoNextTick('[Replay] Creating new session', traceInternals);
    return createSession(sessionOptions, { previousSessionId });
  }

  if (!shouldRefreshSession(existingSession, { sessionIdleExpire, maxReplayDuration })) {
    return existingSession;
  }

  logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');
  return createSession(sessionOptions, { previousSessionId: existingSession.id });
}

function isCustomEvent(event) {
  return event.type === EventType.Custom;
}

/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
function addEventSync(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return false;
  }

  // This should never reject
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  _addEvent(replay, event, isCheckout);

  return true;
}

/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
function addEvent(
  replay,
  event,
  isCheckout,
) {
  if (!shouldAddEvent(replay, event)) {
    return Promise.resolve(null);
  }

  return _addEvent(replay, event, isCheckout);
}

async function _addEvent(
  replay,
  event,
  isCheckout,
) {
  if (!replay.eventBuffer) {
    return null;
  }

  try {
    if (isCheckout && replay.recordingMode === 'buffer') {
      replay.eventBuffer.clear();
    }

    if (isCheckout) {
      replay.eventBuffer.hasCheckout = true;
    }

    const replayOptions = replay.getOptions();

    const eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);

    if (!eventAfterPossibleCallback) {
      return;
    }

    return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
  } catch (error) {
    const reason = error && error instanceof EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';

    DEBUG_BUILD && logger/* logger.error */.kg.error(error);
    await replay.stop({ reason });

    const client = (0,esm_exports/* getClient */.s3)();

    if (client) {
      client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
  }
}

/** Exported only for tests. */
function shouldAddEvent(replay, event) {
  if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) {
    return false;
  }

  const timestampInMs = timestampToMs(event.timestamp);

  // Throw out events that happen more than 5 minutes ago. This can happen if
  // page has been left open and idle for a long period of time and user
  // comes back to trigger a new session. The performance entries rely on
  // `performance.timeOrigin`, which is when the page first opened.
  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
    return false;
  }

  // Throw out events that are +60min from the initial timestamp
  if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
    logInfo(
      `[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`,
      replay.getOptions()._experiments.traceInternals,
    );
    return false;
  }

  return true;
}

function maybeApplyCallback(
  event,
  callback,
) {
  try {
    if (typeof callback === 'function' && isCustomEvent(event)) {
      return callback(event);
    }
  } catch (error) {
    DEBUG_BUILD &&
      logger/* logger.error */.kg.error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
    return null;
  }

  return event;
}

/** If the event is an error event */
function isErrorEvent(event) {
  return !event.type;
}

/** If the event is a transaction event */
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/** If the event is an replay event */
function isReplayEvent(event) {
  return event.type === 'replay_event';
}

/** If the event is a feedback event */
function isFeedbackEvent(event) {
  return event.type === 'feedback';
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleAfterSendEvent(replay) {
  // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
  // TODO (v8): remove this check as it will no longer be necessary
  const enforceStatusCode = isBaseTransportSend();

  return (event, sendResponse) => {
    if (!replay.isEnabled() || (!isErrorEvent(event) && !isTransactionEvent(event))) {
      return;
    }

    const statusCode = sendResponse && sendResponse.statusCode;

    // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
    // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
    // If we do use the base transport, we skip if we encountered an non-OK status code
    if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) {
      return;
    }

    if (isTransactionEvent(event)) {
      handleTransactionEvent(replay, event);
      return;
    }

    handleErrorEvent(replay, event);
  };
}

function handleTransactionEvent(replay, event) {
  const replayContext = replay.getContext();

  // Collect traceIds in _context regardless of `recordingMode`
  // In error mode, _context gets cleared on every checkout
  // We limit to max. 100 transactions linked
  if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) {
    replayContext.traceIds.add(event.contexts.trace.trace_id );
  }
}

function handleErrorEvent(replay, event) {
  const replayContext = replay.getContext();

  // Add error to list of errorIds of replay. This is ok to do even if not
  // sampled because context will get reset at next checkout.
  // XXX: There is also a race condition where it's possible to capture an
  // error to Sentry before Replay SDK has loaded, but response returns after
  // it was loaded, and this gets called.
  // We limit to max. 100 errors linked
  if (event.event_id && replayContext.errorIds.size < 100) {
    replayContext.errorIds.add(event.event_id);
  }

  // If error event is tagged with replay id it means it was sampled (when in buffer mode)
  // Need to be very careful that this does not cause an infinite loop
  if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) {
    return;
  }

  const { beforeErrorSampling } = replay.getOptions();
  if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) {
    return;
  }

  setTimeout(() => {
    // Capture current event buffer as new replay
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.sendBufferedReplayOrFlush();
  });
}

function isBaseTransportSend() {
  const client = (0,esm_exports/* getClient */.s3)();
  if (!client) {
    return false;
  }

  const transport = client.getTransport();
  if (!transport) {
    return false;
  }

  return (
    (transport.send ).__sentry__baseTransport__ || false
  );
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleBeforeSendEvent(replay) {
  return (event) => {
    if (!replay.isEnabled() || !isErrorEvent(event)) {
      return;
    }

    handleHydrationError(replay, event);
  };
}

function handleHydrationError(replay, event) {
  const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
  if (typeof exceptionValue !== 'string') {
    return;
  }

  if (
    // Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) ||
    // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)
  ) {
    const breadcrumb = createBreadcrumb({
      category: 'replay.hydrate-error',
    });
    addBreadcrumbEvent(replay, breadcrumb);
  }
}

/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */
function isRrwebError(event, hint) {
  if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) {
    return false;
  }

  // @ts-expect-error this may be set by rrweb when it finds errors
  if (hint.originalException && hint.originalException.__rrweb__) {
    return true;
  }

  return false;
}

/**
 * Add a feedback breadcrumb event to replay.
 */
function addFeedbackBreadcrumb(replay, event) {
  replay.triggerUserActivity();
  replay.addUpdate(() => {
    if (!event.timestamp) {
      // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
      // Return true here so that we don't flush
      return true;
    }

    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: event.timestamp * 1000,
      data: {
        tag: 'breadcrumb',
        payload: {
          timestamp: event.timestamp,
          type: 'default',
          category: 'sentry.feedback',
          data: {
            feedbackId: event.event_id,
          },
        },
      },
    } );

    return false;
  });
}

/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */
function shouldSampleForBufferEvent(replay, event) {
  if (replay.recordingMode !== 'buffer') {
    return false;
  }

  // ignore this error because otherwise we could loop indefinitely with
  // trying to capture replay and failing
  if (event.message === UNABLE_TO_SEND_REPLAY) {
    return false;
  }

  // Require the event to be an error event & to have an exception
  if (!event.exception || event.type) {
    return false;
  }

  return isSampled(replay.getOptions().errorSampleRate);
}

/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */
function handleGlobalEventListener(
  replay,
  includeAfterSendEventHandling = false,
) {
  const afterSendHandler = includeAfterSendEventHandling ? handleAfterSendEvent(replay) : undefined;

  return Object.assign(
    (event, hint) => {
      // Do nothing if replay has been disabled
      if (!replay.isEnabled()) {
        return event;
      }

      if (isReplayEvent(event)) {
        // Replays have separate set of breadcrumbs, do not include breadcrumbs
        // from core SDK
        delete event.breadcrumbs;
        return event;
      }

      // We only want to handle errors, transactions, and feedbacks, nothing else
      if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) {
        return event;
      }

      // Ensure we do not add replay_id if the session is expired
      const isSessionActive = replay.checkAndHandleExpiredSession();
      if (!isSessionActive) {
        return event;
      }

      if (isFeedbackEvent(event)) {
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.flush();
        event.contexts.feedback.replay_id = replay.getSessionId();
        // Add a replay breadcrumb for this piece of feedback
        addFeedbackBreadcrumb(replay, event);
        return event;
      }

      // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
      // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
      if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
        DEBUG_BUILD && logger/* logger.log */.kg.log('[Replay] Ignoring error from rrweb internals', event);
        return null;
      }

      // When in buffer mode, we decide to sample here.
      // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
      // And convert the buffer session to a full session
      const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);

      // Tag errors if it has been sampled in buffer mode, or if it is session mode
      // Only tag transactions if in session mode
      const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';

      if (shouldTagReplayId) {
        event.tags = { ...event.tags, replayId: replay.getSessionId() };
      }

      // In cases where a custom client is used that does not support the new hooks (yet),
      // we manually call this hook method here
      if (afterSendHandler) {
        // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, { statusCode: 200 });
      }

      return event;
    },
    { id: 'Replay' },
  );
}

/**
 * Create a "span" for each performance entry.
 */
function createPerformanceSpans(
  replay,
  entries,
) {
  return entries.map(({ type, start, end, name, data }) => {
    const response = replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: 'performanceSpan',
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data,
        },
      },
    });

    // If response is a string, it means its either THROTTLED or SKIPPED
    return typeof response === 'string' ? Promise.resolve(null) : response;
  });
}

function handleHistory(handlerData) {
  const { from, to } = handlerData;

  const now = Date.now() / 1000;

  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from,
    },
  };
}

/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */
function handleHistorySpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleHistory(handlerData);

    if (result === null) {
      return;
    }

    // Need to collect visited URLs
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();

    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning false to flush
      return false;
    });
  };
}

/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */
function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) {
    return false;
  }

  return isSentryRequestUrl(url, (0,esm_exports/* getClient */.s3)());
}

/** Add a performance entry breadcrumb */
function addNetworkBreadcrumb(
  replay,
  result,
) {
  if (!replay.isEnabled()) {
    return;
  }

  if (result === null) {
    return;
  }

  if (shouldFilterRequest(replay, result.name)) {
    return;
  }

  replay.addUpdate(() => {
    createPerformanceSpans(replay, [result]);
    // Returning true will cause `addUpdate` to not flush
    // We do not want network requests to cause a flush. This will prevent
    // recurring/polling requests from keeping the replay session alive.
    return true;
  });
}

/** only exported for tests */
function handleFetch(handlerData) {
  const { startTimestamp, endTimestamp, fetchData, response } = handlerData;

  if (!endTimestamp) {
    return null;
  }

  // This is only used as a fallback, so we know the body sizes are never set here
  const { method, url } = fetchData;

  return {
    type: 'resource.fetch',
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: {
      method,
      statusCode: response ? (response ).status : undefined,
    },
  };
}

/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */
function handleFetchSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleFetch(handlerData);

    addNetworkBreadcrumb(replay, result);
  };
}

/** only exported for tests */
function handleXhr(handlerData) {
  const { startTimestamp, endTimestamp, xhr } = handlerData;

  const sentryXhrData = xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];

  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return null;
  }

  // This is only used as a fallback, so we know the body sizes are never set here
  const { method, url, status_code: statusCode } = sentryXhrData;

  if (url === undefined) {
    return null;
  }

  return {
    type: 'resource.xhr',
    name: url,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    data: {
      method,
      statusCode,
    },
  };
}

/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */
function handleXhrSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleXhr(handlerData);

    addNetworkBreadcrumb(replay, result);
  };
}

/** Get the size of a body. */
function getBodySize(
  body,
  textEncoder,
) {
  if (!body) {
    return undefined;
  }

  try {
    if (typeof body === 'string') {
      return textEncoder.encode(body).length;
    }

    if (body instanceof URLSearchParams) {
      return textEncoder.encode(body.toString()).length;
    }

    if (body instanceof FormData) {
      const formDataStr = _serializeFormData(body);
      return textEncoder.encode(formDataStr).length;
    }

    if (body instanceof Blob) {
      return body.size;
    }

    if (body instanceof ArrayBuffer) {
      return body.byteLength;
    }

    // Currently unhandled types: ArrayBufferView, ReadableStream
  } catch (e) {
    // just return undefined
  }

  return undefined;
}

/** Convert a Content-Length header to number/undefined.  */
function parseContentLengthHeader(header) {
  if (!header) {
    return undefined;
  }

  const size = parseInt(header, 10);
  return isNaN(size) ? undefined : size;
}

/** Get the string representation of a body. */
function getBodyString(body) {
  try {
    if (typeof body === 'string') {
      return [body];
    }

    if (body instanceof URLSearchParams) {
      return [body.toString()];
    }

    if (body instanceof FormData) {
      return [_serializeFormData(body)];
    }

    if (!body) {
      return [undefined];
    }
  } catch (e2) {
    DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to serialize body', body);
    return [undefined, 'BODY_PARSE_ERROR'];
  }

  DEBUG_BUILD && logger/* logger.info */.kg.info('[Replay] Skipping network body because of body type', body);

  return [undefined, 'UNPARSEABLE_BODY_TYPE'];
}

/** Merge a warning into an existing network request/response. */
function mergeWarning(
  info,
  warning,
) {
  if (!info) {
    return {
      headers: {},
      size: undefined,
      _meta: {
        warnings: [warning],
      },
    };
  }

  const newMeta = { ...info._meta };
  const existingWarnings = newMeta.warnings || [];
  newMeta.warnings = [...existingWarnings, warning];

  info._meta = newMeta;
  return info;
}

/** Convert ReplayNetworkRequestData to a PerformanceEntry. */
function makeNetworkReplayBreadcrumb(
  type,
  data,
) {
  if (!data) {
    return null;
  }

  const { startTimestamp, endTimestamp, url, method, statusCode, request, response } = data;

  const result = {
    type,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: (0,object/* dropUndefinedKeys */.Jr)({
      method,
      statusCode,
      request,
      response,
    }),
  };

  return result;
}

/** Build the request or response part of a replay network breadcrumb that was skipped. */
function buildSkippedNetworkRequestOrResponse(bodySize) {
  return {
    headers: {},
    size: bodySize,
    _meta: {
      warnings: ['URL_SKIPPED'],
    },
  };
}

/** Build the request or response part of a replay network breadcrumb. */
function buildNetworkRequestOrResponse(
  headers,
  bodySize,
  body,
) {
  if (!bodySize && Object.keys(headers).length === 0) {
    return undefined;
  }

  if (!bodySize) {
    return {
      headers,
    };
  }

  if (!body) {
    return {
      headers,
      size: bodySize,
    };
  }

  const info = {
    headers,
    size: bodySize,
  };

  const { body: normalizedBody, warnings } = normalizeNetworkBody(body);
  info.body = normalizedBody;
  if (warnings && warnings.length > 0) {
    info._meta = {
      warnings,
    };
  }

  return info;
}

/** Filter a set of headers */
function getAllowedHeaders(headers, allowedHeaders) {
  return Object.keys(headers).reduce((filteredHeaders, key) => {
    const normalizedKey = key.toLowerCase();
    // Avoid putting empty strings into the headers
    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
      filteredHeaders[normalizedKey] = headers[key];
    }
    return filteredHeaders;
  }, {});
}

function _serializeFormData(formData) {
  // This is a bit simplified, but gives us a decent estimate
  // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
  // @ts-expect-error passing FormData to URLSearchParams actually works
  return new URLSearchParams(formData).toString();
}

function normalizeNetworkBody(body)

 {
  if (!body || typeof body !== 'string') {
    return {
      body,
    };
  }

  const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
  const isProbablyJson = _strIsProbablyJson(body);

  if (exceedsSizeLimit) {
    const truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);

    if (isProbablyJson) {
      return {
        body: truncatedBody,
        warnings: ['MAYBE_JSON_TRUNCATED'],
      };
    }

    return {
      body: `${truncatedBody}…`,
      warnings: ['TEXT_TRUNCATED'],
    };
  }

  if (isProbablyJson) {
    try {
      const jsonBody = JSON.parse(body);
      return {
        body: jsonBody,
      };
    } catch (e3) {
      // fall back to just send the body as string
    }
  }

  return {
    body,
  };
}

function _strIsProbablyJson(str) {
  const first = str[0];
  const last = str[str.length - 1];

  // Simple check: If this does not start & end with {} or [], it's not JSON
  return (first === '[' && last === ']') || (first === '{' && last === '}');
}

/** Match an URL against a list of strings/Regex. */
function urlMatches(url, urls) {
  const fullUrl = getFullUrl(url);

  return (0,string/* stringMatchesSomePattern */.U0)(fullUrl, urls);
}

/** exported for tests */
function getFullUrl(url, baseURI = WINDOW.document.baseURI) {
  // Short circuit for common cases:
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(WINDOW.location.origin)) {
    return url;
  }
  const fixedUrl = new URL(url, baseURI);

  // If these do not match, we are not dealing with a relative URL, so just return it
  if (fixedUrl.origin !== new URL(baseURI).origin) {
    return url;
  }

  const fullUrl = fixedUrl.href;

  // Remove trailing slashes, if they don't match the original URL
  if (!url.endsWith('/') && fullUrl.endsWith('/')) {
    return fullUrl.slice(0, -1);
  }

  return fullUrl;
}

/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */
async function captureFetchBreadcrumbToReplay(
  breadcrumb,
  hint,
  options

,
) {
  try {
    const data = await _prepareFetchData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.fetch', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    DEBUG_BUILD && logger/* logger.error */.kg.error('[Replay] Failed to capture fetch breadcrumb', error);
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichFetchBreadcrumb(
  breadcrumb,
  hint,
  options,
) {
  const { input, response } = hint;

  const body = input ? _getFetchRequestArgBody(input) : undefined;
  const reqSize = getBodySize(body, options.textEncoder);

  const resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;

  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}

async function _prepareFetchData(
  breadcrumb,
  hint,
  options

,
) {
  const now = Date.now();
  const { startTimestamp = now, endTimestamp = now } = hint;

  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize,
  } = breadcrumb.data;

  const captureDetails =
    urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);

  const request = captureDetails
    ? _getRequestInfo(options, hint.input, requestBodySize)
    : buildSkippedNetworkRequestOrResponse(requestBodySize);
  const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);

  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response,
  };
}

function _getRequestInfo(
  { networkCaptureBodies, networkRequestHeaders },
  input,
  requestBodySize,
) {
  const headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};

  if (!networkCaptureBodies) {
    return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
  }

  // We only want to transmit string or string-like bodies
  const requestBody = _getFetchRequestArgBody(input);
  const [bodyStr, warning] = getBodyString(requestBody);
  const data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);

  if (warning) {
    return mergeWarning(data, warning);
  }

  return data;
}

/** Exported only for tests. */
async function _getResponseInfo(
  captureDetails,
  {
    networkCaptureBodies,
    textEncoder,
    networkResponseHeaders,
  }

,
  response,
  responseBodySize,
) {
  if (!captureDetails && responseBodySize !== undefined) {
    return buildSkippedNetworkRequestOrResponse(responseBodySize);
  }

  const headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};

  if (!response || (!networkCaptureBodies && responseBodySize !== undefined)) {
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }

  const [bodyText, warning] = await _parseFetchResponseBody(response);
  const result = getResponseData(bodyText, {
    networkCaptureBodies,
    textEncoder,
    responseBodySize,
    captureDetails,
    headers,
  });

  if (warning) {
    return mergeWarning(result, warning);
  }

  return result;
}

function getResponseData(
  bodyText,
  {
    networkCaptureBodies,
    textEncoder,
    responseBodySize,
    captureDetails,
    headers,
  }

,
) {
  try {
    const size =
      bodyText && bodyText.length && responseBodySize === undefined
        ? getBodySize(bodyText, textEncoder)
        : responseBodySize;

    if (!captureDetails) {
      return buildSkippedNetworkRequestOrResponse(size);
    }

    if (networkCaptureBodies) {
      return buildNetworkRequestOrResponse(headers, size, bodyText);
    }

    return buildNetworkRequestOrResponse(headers, size, undefined);
  } catch (error) {
    DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to serialize response body', error);
    // fallback
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }
}

async function _parseFetchResponseBody(response) {
  const res = _tryCloneResponse(response);

  if (!res) {
    return [undefined, 'BODY_PARSE_ERROR'];
  }

  try {
    const text = await _tryGetResponseText(res);
    return [text];
  } catch (error) {
    DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to get text body from response', error);
    return [undefined, 'BODY_PARSE_ERROR'];
  }
}

function _getFetchRequestArgBody(fetchArgs = []) {
  // We only support getting the body from the fetch options
  if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') {
    return undefined;
  }

  return (fetchArgs[1] ).body;
}

function getAllHeaders(headers, allowedHeaders) {
  const allHeaders = {};

  allowedHeaders.forEach(header => {
    if (headers.get(header)) {
      allHeaders[header] = headers.get(header) ;
    }
  });

  return allHeaders;
}

function getRequestHeaders(fetchArgs, allowedHeaders) {
  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') {
    return getHeadersFromOptions(fetchArgs[0] , allowedHeaders);
  }

  if (fetchArgs.length === 2) {
    return getHeadersFromOptions(fetchArgs[1] , allowedHeaders);
  }

  return {};
}

function getHeadersFromOptions(
  input,
  allowedHeaders,
) {
  if (!input) {
    return {};
  }

  const headers = input.headers;

  if (!headers) {
    return {};
  }

  if (headers instanceof Headers) {
    return getAllHeaders(headers, allowedHeaders);
  }

  // We do not support this, as it is not really documented (anymore?)
  if (Array.isArray(headers)) {
    return {};
  }

  return getAllowedHeaders(headers, allowedHeaders);
}

function _tryCloneResponse(response) {
  try {
    // We have to clone this, as the body can only be read once
    return response.clone();
  } catch (error) {
    // this can throw if the response was already consumed before
    DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to clone response body', error);
  }
}

/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */
function _tryGetResponseText(response) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Timeout while trying to read response body')), 500);

    _getResponseText(response)
      .then(
        txt => resolve(txt),
        reason => reject(reason),
      )
      .finally(() => clearTimeout(timeout));
  });
}

async function _getResponseText(response) {
  // Force this to be a promise, just to be safe
  // eslint-disable-next-line no-return-await
  return await response.text();
}

/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */
async function captureXhrBreadcrumbToReplay(
  breadcrumb,
  hint,
  options,
) {
  try {
    const data = _prepareXhrData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.xhr', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    DEBUG_BUILD && logger/* logger.error */.kg.error('[Replay] Failed to capture xhr breadcrumb', error);
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichXhrBreadcrumb(
  breadcrumb,
  hint,
  options,
) {
  const { xhr, input } = hint;

  if (!xhr) {
    return;
  }

  const reqSize = getBodySize(input, options.textEncoder);
  const resSize = xhr.getResponseHeader('content-length')
    ? parseContentLengthHeader(xhr.getResponseHeader('content-length'))
    : _getBodySize(xhr.response, xhr.responseType, options.textEncoder);

  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}

function _prepareXhrData(
  breadcrumb,
  hint,
  options,
) {
  const now = Date.now();
  const { startTimestamp = now, endTimestamp = now, input, xhr } = hint;

  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize,
  } = breadcrumb.data;

  if (!url) {
    return null;
  }

  if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
    const request = buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = buildSkippedNetworkRequestOrResponse(responseBodySize);
    return {
      startTimestamp,
      endTimestamp,
      url,
      method,
      statusCode,
      request,
      response,
    };
  }

  const xhrInfo = xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];
  const networkRequestHeaders = xhrInfo
    ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders)
    : {};
  const networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);

  const [requestBody, requestWarning] = options.networkCaptureBodies ? getBodyString(input) : [undefined];
  const [responseBody, responseWarning] = options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [undefined];

  const request = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
  const response = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);

  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request: requestWarning ? mergeWarning(request, requestWarning) : request,
    response: responseWarning ? mergeWarning(response, responseWarning) : response,
  };
}

function getResponseHeaders(xhr) {
  const headers = xhr.getAllResponseHeaders();

  if (!headers) {
    return {};
  }

  return headers.split('\r\n').reduce((acc, line) => {
    const [key, value] = line.split(': ');
    acc[key.toLowerCase()] = value;
    return acc;
  }, {});
}

function _getXhrResponseBody(xhr) {
  // We collect errors that happen, but only log them if we can't get any response body
  const errors = [];

  try {
    return [xhr.responseText];
  } catch (e) {
    errors.push(e);
  }

  // Try to manually parse the response body, if responseText fails
  try {
    return _parseXhrResponse(xhr.response, xhr.responseType);
  } catch (e) {
    errors.push(e);
  }

  DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to get xhr response body', ...errors);

  return [undefined];
}

/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */
function _parseXhrResponse(
  body,
  responseType,
) {
  try {
    if (typeof body === 'string') {
      return [body];
    }

    if (body instanceof Document) {
      return [body.body.outerHTML];
    }

    if (responseType === 'json' && body && typeof body === 'object') {
      return [JSON.stringify(body)];
    }

    if (!body) {
      return [undefined];
    }
  } catch (e2) {
    DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Failed to serialize body', body);
    return [undefined, 'BODY_PARSE_ERROR'];
  }

  DEBUG_BUILD && logger/* logger.info */.kg.info('[Replay] Skipping network body because of body type', body);

  return [undefined, 'UNPARSEABLE_BODY_TYPE'];
}

function _getBodySize(
  body,
  responseType,
  textEncoder,
) {
  try {
    const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
    return getBodySize(bodyStr, textEncoder);
  } catch (e3) {
    return undefined;
  }
}

/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */
function handleNetworkBreadcrumbs(replay) {
  const client = (0,esm_exports/* getClient */.s3)();

  try {
    const textEncoder = new TextEncoder();

    const {
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders,
    } = replay.getOptions();

    const options = {
      replay,
      textEncoder,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders,
    };

    if (client && client.on) {
      client.on('beforeAddBreadcrumb', (breadcrumb, hint) => beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } else {
      // Fallback behavior
      (0,instrument_fetch/* addFetchInstrumentationHandler */.U)(handleFetchSpanListener(replay));
      (0,instrument_xhr/* addXhrInstrumentationHandler */.UK)(handleXhrSpanListener(replay));
    }
  } catch (e2) {
    // Do nothing
  }
}

/** just exported for tests */
function beforeAddNetworkBreadcrumb(
  options,
  breadcrumb,
  hint,
) {
  if (!breadcrumb.data) {
    return;
  }

  try {
    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichXhrBreadcrumb(breadcrumb, hint, options);

      // This call should not reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
    }

    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichFetchBreadcrumb(breadcrumb, hint, options);

      // This call should not reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
    }
  } catch (e) {
    DEBUG_BUILD && logger/* logger.warn */.kg.warn('Error when enriching network breadcrumb');
  }
}

function _isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'xhr';
}

function _isFetchBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'fetch';
}

function _isXhrHint(hint) {
  return hint && hint.xhr;
}

function _isFetchHint(hint) {
  return hint && hint.response;
}

let _LAST_BREADCRUMB = null;

function isBreadcrumbWithCategory(breadcrumb) {
  return !!breadcrumb.category;
}

const handleScopeListener =
  (replay) =>
  (scope) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleScope(scope);

    if (!result) {
      return;
    }

    addBreadcrumbEvent(replay, result);
  };

/**
 * An event handler to handle scope changes.
 */
function handleScope(scope) {
  // TODO (v8): Remove this guard. This was put in place because we introduced
  // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
  // For now, we'll just return null if the method doesn't exist but we should eventually
  // get rid of this guard.
  const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();

  // Listener can be called when breadcrumbs have not changed, so we store the
  // reference to the last crumb and only return a crumb if it has changed
  if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) {
    return null;
  }

  _LAST_BREADCRUMB = newBreadcrumb;

  if (
    !isBreadcrumbWithCategory(newBreadcrumb) ||
    ['fetch', 'xhr', 'sentry.event', 'sentry.transaction'].includes(newBreadcrumb.category) ||
    newBreadcrumb.category.startsWith('ui.')
  ) {
    return null;
  }

  if (newBreadcrumb.category === 'console') {
    return normalizeConsoleBreadcrumb(newBreadcrumb);
  }

  return createBreadcrumb(newBreadcrumb);
}

/** exported for tests only */
function normalizeConsoleBreadcrumb(
  breadcrumb,
) {
  const args = breadcrumb.data && breadcrumb.data.arguments;

  if (!Array.isArray(args) || args.length === 0) {
    return createBreadcrumb(breadcrumb);
  }

  let isTruncated = false;

  // Avoid giant args captures
  const normalizedArgs = args.map(arg => {
    if (!arg) {
      return arg;
    }
    if (typeof arg === 'string') {
      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
        isTruncated = true;
        return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}…`;
      }

      return arg;
    }
    if (typeof arg === 'object') {
      try {
        const normalizedArg = (0,normalize/* normalize */.Fv)(arg, 7);
        const stringified = JSON.stringify(normalizedArg);
        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
          isTruncated = true;
          // We use the pretty printed JSON string here as a base
          return `${JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE)}…`;
        }
        return normalizedArg;
      } catch (e) {
        // fall back to default
      }
    }

    return arg;
  });

  return createBreadcrumb({
    ...breadcrumb,
    data: {
      ...breadcrumb.data,
      arguments: normalizedArgs,
      ...(isTruncated ? { _meta: { warnings: ['CONSOLE_ARG_TRUNCATED'] } } : {}),
    },
  });
}

/**
 * Add global listeners that cannot be removed.
 */
function addGlobalListeners(replay) {
  // Listeners from core SDK //
  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const client = (0,esm_exports/* getClient */.s3)();

  scope.addScopeListener(handleScopeListener(replay));
  (0,dom/* addClickKeypressInstrumentationHandler */.O)(handleDomListener(replay));
  (0,instrument_history/* addHistoryInstrumentationHandler */.a)(handleHistorySpanListener(replay));
  handleNetworkBreadcrumbs(replay);

  // Tag all (non replay) events that get sent to Sentry with the current
  // replay ID so that we can reference them later in the UI
  const eventProcessor = handleGlobalEventListener(replay, !hasHooks(client));
  if (client && client.addEventProcessor) {
    client.addEventProcessor(eventProcessor);
  } else {
    (0,baseclient/* addEventProcessor */.Q)(eventProcessor);
  }

  // If a custom client has no hooks yet, we continue to use the "old" implementation
  if (hasHooks(client)) {
    client.on('beforeSendEvent', handleBeforeSendEvent(replay));
    client.on('afterSendEvent', handleAfterSendEvent(replay));
    client.on('createDsc', (dsc) => {
      const replayId = replay.getSessionId();
      // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
      if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
        // Ensure to check that the session is still active - it could have expired in the meanwhile
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (isSessionActive) {
          dsc.replay_id = replayId;
        }
      }
    });

    client.on('startTransaction', transaction => {
      replay.lastTransaction = transaction;
    });

    // We may be missing the initial startTransaction due to timing issues,
    // so we capture it on finish again.
    client.on('finishTransaction', transaction => {
      replay.lastTransaction = transaction;
    });

    // We want to flush replay
    client.on('beforeSendFeedback', (feedbackEvent, options) => {
      const replayId = replay.getSessionId();
      if (options && options.includeReplay && replay.isEnabled() && replayId) {
        // This should never reject
        if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) {
          feedbackEvent.contexts.feedback.replay_id = replayId;
        }
      }
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasHooks(client) {
  return !!(client && client.on);
}

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
async function addMemoryEntry(replay) {
  // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
  try {
    return Promise.all(
      createPerformanceSpans(replay, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        createMemoryEntry(WINDOW.performance.memory),
      ]),
    );
  } catch (error) {
    // Do nothing
    return [];
  }
}

function createMemoryEntry(memoryEntry) {
  const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  const time = Date.now() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize,
      },
    },
  };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */
function debounce(func, wait, options) {
  let callbackReturnValue;

  let timerId;
  let maxTimerId;

  const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;

  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }

  function cancelTimers() {
    timerId !== undefined && clearTimeout(timerId);
    maxTimerId !== undefined && clearTimeout(maxTimerId);
    timerId = maxTimerId = undefined;
  }

  function flush() {
    if (timerId !== undefined || maxTimerId !== undefined) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }

  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(invokeFunc, wait);

    if (maxWait && maxTimerId === undefined) {
      maxTimerId = setTimeout(invokeFunc, maxWait);
    }

    return callbackReturnValue;
  }

  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}

/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */
function getHandleRecordingEmit(replay) {
  let hadFirstEvent = false;

  return (event, _isCheckout) => {
    // If this is false, it means session is expired, create and a new session and wait for checkout
    if (!replay.checkAndHandleExpiredSession()) {
      DEBUG_BUILD && logger/* logger.warn */.kg.warn('[Replay] Received replay event after session expired.');

      return;
    }

    // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
    // We also want to treat the first event as a checkout, so we handle this specifically here
    const isCheckout = _isCheckout || !hadFirstEvent;
    hadFirstEvent = true;

    if (replay.clickDetector) {
      updateClickDetectorForRecordingEvent(replay.clickDetector, event);
    }

    // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
    replay.addUpdate(() => {
      // The session is always started immediately on pageload/init, but for
      // error-only replays, it should reflect the most recent checkout
      // when an error occurs. Clear any state that happens before this current
      // checkout. This needs to happen before `addEvent()` which updates state
      // dependent on this reset.
      if (replay.recordingMode === 'buffer' && isCheckout) {
        replay.setInitialState();
      }

      // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
      // Skip all further steps
      if (!addEventSync(replay, event, isCheckout)) {
        // Return true to skip scheduling a debounced flush
        return true;
      }

      // Different behavior for full snapshots (type=2), ignore other event types
      // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
      if (!isCheckout) {
        return false;
      }

      // Additionally, create a meta event that will capture certain SDK settings.
      // In order to handle buffer mode, this needs to either be done when we
      // receive checkout events or at flush time.
      //
      // `isCheckout` is always true, but want to be explicit that it should
      // only be added for checkouts
      addSettingsEvent(replay, isCheckout);

      // If there is a previousSessionId after a full snapshot occurs, then
      // the replay session was started due to session expiration. The new session
      // is started before triggering a new checkout and contains the id
      // of the previous session. Do not immediately flush in this case
      // to avoid capturing only the checkout and instead the replay will
      // be captured if they perform any follow-up actions.
      if (replay.session && replay.session.previousSessionId) {
        return true;
      }

      // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
      // this should usually be the timestamp of the checkout event, but to be safe...
      if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
        const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
        if (earliestEvent) {
          logInfo(
            `[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`,
            replay.getOptions()._experiments.traceInternals,
          );

          replay.session.started = earliestEvent;

          if (replay.getOptions().stickySession) {
            saveSession(replay.session);
          }
        }
      }

      if (replay.recordingMode === 'session') {
        // If the full snapshot is due to an initial load, we will not have
        // a previous session ID. In this case, we want to buffer events
        // for a set amount of time before flushing. This can help avoid
        // capturing replays of users that immediately close the window.

        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        void replay.flush();
      }

      return true;
    });
  };
}

/**
 * Exported for tests
 */
function createOptionsEvent(replay) {
  const options = replay.getOptions();
  return {
    type: EventType.Custom,
    timestamp: Date.now(),
    data: {
      tag: 'options',
      payload: {
        shouldRecordCanvas: replay.isRecordingCanvas(),
        sessionSampleRate: options.sessionSampleRate,
        errorSampleRate: options.errorSampleRate,
        useCompressionOption: options.useCompression,
        blockAllMedia: options.blockAllMedia,
        maskAllText: options.maskAllText,
        maskAllInputs: options.maskAllInputs,
        useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: options.networkCaptureBodies,
        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: options.networkResponseHeaders.length > 0,
      },
    },
  };
}

/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */
function addSettingsEvent(replay, isCheckout) {
  // Only need to add this event when sending the first segment
  if (!isCheckout || !replay.session || replay.session.segmentId !== 0) {
    return;
  }

  addEventSync(replay, createOptionsEvent(replay), false);
}

/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */
function createReplayEnvelope(
  replayEvent,
  recordingData,
  dsn,
  tunnel,
) {
  return (0,esm_envelope/* createEnvelope */.Jd)(
    (0,esm_envelope/* createEventEnvelopeHeaders */.Cd)(replayEvent, (0,esm_envelope/* getSdkMetadataForEnvelopeHeader */.HY)(replayEvent), tunnel, dsn),
    [
      [{ type: 'replay_event' }, replayEvent],
      [
        {
          type: 'replay_recording',
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length:
            typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length,
        },
        recordingData,
      ],
    ],
  );
}

/**
 * Prepare the recording data ready to be sent.
 */
function prepareRecordingData({
  recordingData,
  headers,
}

) {
  let payloadWithSequence;

  // XXX: newline is needed to separate sequence id from events
  const replayHeaders = `${JSON.stringify(headers)}
`;

  if (typeof recordingData === 'string') {
    payloadWithSequence = `${replayHeaders}${recordingData}`;
  } else {
    const enc = new TextEncoder();
    // XXX: newline is needed to separate sequence id from events
    const sequence = enc.encode(replayHeaders);
    // Merge the two Uint8Arrays
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }

  return payloadWithSequence;
}

/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */
async function prepareReplayEvent({
  client,
  scope,
  replayId: event_id,
  event,
}

) {
  const integrations =
    typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations)
      ? Object.keys(client._integrations)
      : undefined;

  const eventHint = { event_id, integrations };

  if (client.emit) {
    client.emit('preprocessEvent', event, eventHint);
  }

  const preparedEvent = (await (0,prepareEvent/* prepareEvent */.R)(
    client.getOptions(),
    event,
    eventHint,
    scope,
    client,
    (0,hub/* getIsolationScope */.aF)(),
  )) ;

  // If e.g. a global event processor returned null
  if (!preparedEvent) {
    return null;
  }

  // This normally happens in browser client "_prepareEvent"
  // but since we do not use this private method from the client, but rather the plain import
  // we need to do this manually.
  preparedEvent.platform = preparedEvent.platform || 'javascript';

  // extract the SDK name because `client._prepareEvent` doesn't add it to the event
  const metadata = client.getSdkMetadata && client.getSdkMetadata();
  const { name, version } = (metadata && metadata.sdk) || {};

  preparedEvent.sdk = {
    ...preparedEvent.sdk,
    name: name || 'sentry.javascript.unknown',
    version: version || '0.0.0',
  };

  return preparedEvent;
}

/**
 * Send replay attachment using `fetch()`
 */
async function sendReplayRequest({
  recordingData,
  replayId,
  segmentId: segment_id,
  eventContext,
  timestamp,
  session,
}) {
  const preparedRecordingData = prepareRecordingData({
    recordingData,
    headers: {
      segment_id,
    },
  });

  const { urls, errorIds, traceIds, initialTimestamp } = eventContext;

  const client = (0,esm_exports/* getClient */.s3)();
  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const transport = client && client.getTransport();
  const dsn = client && client.getDsn();

  if (!client || !transport || !dsn || !session.sampled) {
    return;
  }

  const baseEvent = {
    type: REPLAY_EVENT_NAME,
    replay_start_timestamp: initialTimestamp / 1000,
    timestamp: timestamp / 1000,
    error_ids: errorIds,
    trace_ids: traceIds,
    urls,
    replay_id: replayId,
    segment_id,
    replay_type: session.sampled,
  };

  const replayEvent = await prepareReplayEvent({ scope, client, replayId, event: baseEvent });

  if (!replayEvent) {
    // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
    client.recordDroppedEvent('event_processor', 'replay', baseEvent);
    logInfo('An event processor returned `null`, will not send event.');
    return;
  }

  /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete replayEvent.sdkProcessingMetadata;

  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);

  let response;

  try {
    response = await transport.send(envelope);
  } catch (err) {
    const error = new Error(UNABLE_TO_SEND_REPLAY);

    try {
      // In case browsers don't allow this property to be writable
      // @ts-expect-error This needs lib es2022 and newer
      error.cause = err;
    } catch (e) {
      // nothing to do
    }
    throw error;
  }

  // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
  if (!response) {
    return response;
  }

  // If the status code is invalid, we want to immediately stop & not retry
  if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) {
    throw new TransportStatusCodeError(response.statusCode);
  }

  const rateLimits = (0,ratelimit/* updateRateLimits */.WG)({}, response);
  if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, 'replay')) {
    throw new RateLimitError(rateLimits);
  }

  return response;
}

/**
 * This error indicates that the transport returned an invalid status code.
 */
class TransportStatusCodeError extends Error {
   constructor(statusCode) {
    super(`Transport returned status code ${statusCode}`);
  }
}

/**
 * This error indicates that we hit a rate limit API error.
 */
class RateLimitError extends Error {

   constructor(rateLimits) {
    super('Rate limit hit');
    this.rateLimits = rateLimits;
  }
}

/**
 * Finalize and send the current replay event to Sentry
 */
async function sendReplay(
  replayData,
  retryConfig = {
    count: 0,
    interval: RETRY_BASE_INTERVAL,
  },
) {
  const { recordingData, options } = replayData;

  // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
  if (!recordingData.length) {
    return;
  }

  try {
    await sendReplayRequest(replayData);
    return true;
  } catch (err) {
    if (err instanceof TransportStatusCodeError || err instanceof RateLimitError) {
      throw err;
    }

    // Capture error for every failed replay
    (0,esm_exports/* setContext */.v)('Replays', {
      _retryCount: retryConfig.count,
    });

    if (DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) {
      (0,esm_exports/* captureException */.Tb)(err);
    }

    // If an error happened here, it's likely that uploading the attachment
    // failed, we'll can retry with the same events payload
    if (retryConfig.count >= RETRY_MAX_COUNT) {
      const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);

      try {
        // In case browsers don't allow this property to be writable
        // @ts-expect-error This needs lib es2022 and newer
        error.cause = err;
      } catch (e) {
        // nothing to do
      }

      throw error;
    }

    // will retry in intervals of 5, 10, 30
    retryConfig.interval *= ++retryConfig.count;

    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          await sendReplay(replayData, retryConfig);
          resolve(true);
        } catch (err) {
          reject(err);
        }
      }, retryConfig.interval);
    });
  }
}

const THROTTLED = '__THROTTLED';
const SKIPPED = '__SKIPPED';

/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(
  fn,
  maxCount,
  durationSeconds,
) {
  const counter = new Map();

  const _cleanup = (now) => {
    const threshold = now - durationSeconds;
    counter.forEach((_value, key) => {
      if (key < threshold) {
        counter.delete(key);
      }
    });
  };

  const _getTotalCount = () => {
    return [...counter.values()].reduce((a, b) => a + b, 0);
  };

  let isThrottled = false;

  return (...rest) => {
    // Date in second-precision, which we use as basis for the throttling
    const now = Math.floor(Date.now() / 1000);

    // First, make sure to delete any old entries
    _cleanup(now);

    // If already over limit, do nothing
    if (_getTotalCount() >= maxCount) {
      const wasThrottled = isThrottled;
      isThrottled = true;
      return wasThrottled ? SKIPPED : THROTTLED;
    }

    isThrottled = false;
    const count = counter.get(now) || 0;
    counter.set(now, count + 1);

    return fn(...rest);
  };
}

/* eslint-disable max-lines */ // TODO: We might want to split this file up

/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */
class ReplayContainer  {

  /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */

  /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */

  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Timestamp of the last user activity. This lives across sessions.
   */

  /**
   * Is the integration currently active?
   */

  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */

  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */

  /**
   * Function to stop recording
   */

  /**
   * Internal use for canvas recording options
   */

   constructor({
    options,
    recordingOptions,
  }

) {ReplayContainer.prototype.__init.call(this);ReplayContainer.prototype.__init2.call(this);ReplayContainer.prototype.__init3.call(this);ReplayContainer.prototype.__init4.call(this);ReplayContainer.prototype.__init5.call(this);ReplayContainer.prototype.__init6.call(this);
    this.eventBuffer = null;
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];
    this.recordingMode = 'session';
    this.timeouts = {
      sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
      sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION,
    } ;
    this._lastActivity = Date.now();
    this._isEnabled = false;
    this._isPaused = false;
    this._hasInitializedCoreListeners = false;
    this._context = {
      errorIds: new Set(),
      traceIds: new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: '',
    };

    this._recordingOptions = recordingOptions;
    this._options = options;

    this._debouncedFlush = debounce(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay,
    });

    this._throttledAddEvent = throttle(
      (event, isCheckout) => addEvent(this, event, isCheckout),
      // Max 300 events...
      300,
      // ... per 5s
      5,
    );

    const { slowClickTimeout, slowClickIgnoreSelectors } = this.getOptions();

    const slowClickConfig = slowClickTimeout
      ? {
          threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
          timeout: slowClickTimeout,
          scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
          ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : '',
        }
      : undefined;

    if (slowClickConfig) {
      this.clickDetector = new ClickDetector(this, slowClickConfig);
    }
  }

  /** Get the event context. */
   getContext() {
    return this._context;
  }

  /** If recording is currently enabled. */
   isEnabled() {
    return this._isEnabled;
  }

  /** If recording is currently paused. */
   isPaused() {
    return this._isPaused;
  }

  /**
   * Determine if canvas recording is enabled
   */
   isRecordingCanvas() {
    return Boolean(this._canvas);
  }

  /** Get the replay integration options. */
   getOptions() {
    return this._options;
  }

  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
   initializeSampling(previousSessionId) {
    const { errorSampleRate, sessionSampleRate } = this._options;

    // If neither sample rate is > 0, then do nothing - user will need to call one of
    // `start()` or `startBuffering` themselves.
    if (errorSampleRate <= 0 && sessionSampleRate <= 0) {
      return;
    }

    // Otherwise if there is _any_ sample rate set, try to load an existing
    // session, or create a new one.
    this._initializeSessionForSampling(previousSessionId);

    if (!this.session) {
      // This should not happen, something wrong has occurred
      this._handleException(new Error('Unable to initialize and create session'));
      return;
    }

    if (this.session.sampled === false) {
      // This should only occur if `errorSampleRate` is 0 and was unsampled for
      // session-based replay. In this case there is nothing to do.
      return;
    }

    // If segmentId > 0, it means we've previously already captured this session
    // In this case, we still want to continue in `session` recording mode
    this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';

    logInfoNextTick(
      `[Replay] Starting replay in ${this.recordingMode} mode`,
      this._options._experiments.traceInternals,
    );

    this._initializeRecording();
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (this._isEnabled && this.recordingMode === 'session') {
      throw new Error('Replay recording is already in progress');
    }

    if (this._isEnabled && this.recordingMode === 'buffer') {
      throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
    }

    logInfoNextTick('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);

    // Required as user activity is initially set in
    // constructor, so if `start()` is called after
    // session idle expiration, a replay will not be
    // created due to an idle timeout.
    this._updateUserActivity();

    const session = loadOrCreateSession(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        traceInternals: this._options._experiments.traceInternals,
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: false,
      },
    );

    this.session = session;

    this._initializeRecording();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
   startBuffering() {
    if (this._isEnabled) {
      throw new Error('Replay recording is already in progress');
    }

    logInfoNextTick('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);

    const session = loadOrCreateSession(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        traceInternals: this._options._experiments.traceInternals,
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: true,
      },
    );

    this.session = session;

    this.recordingMode = 'buffer';
    this._initializeRecording();
  }

  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
   startRecording() {
    try {
      const canvasOptions = this._canvas;

      this._stopRecording = record({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...(this.recordingMode === 'buffer' && { checkoutEveryNms: BUFFER_CHECKOUT_TIME }),
        emit: getHandleRecordingEmit(this),
        onMutation: this._onMutationHandler,
        ...(canvasOptions
          ? {
              recordCanvas: canvasOptions.recordCanvas,
              getCanvasManager: canvasOptions.getCanvasManager,
              sampling: canvasOptions.sampling,
              dataURLOptions: canvasOptions.dataURLOptions,
            }
          : {}),
      });
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
   stopRecording() {
    try {
      if (this._stopRecording) {
        this._stopRecording();
        this._stopRecording = undefined;
      }

      return true;
    } catch (err) {
      this._handleException(err);
      return false;
    }
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   async stop({ forceFlush = false, reason } = {}) {
    if (!this._isEnabled) {
      return;
    }

    // We can't move `_isEnabled` after awaiting a flush, otherwise we can
    // enter into an infinite loop when `stop()` is called while flushing.
    this._isEnabled = false;

    try {
      logInfo(
        `[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`,
        this._options._experiments.traceInternals,
      );

      this._removeListeners();
      this.stopRecording();

      this._debouncedFlush.cancel();
      // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
      // `_isEnabled` state of the plugin since it was disabled above.
      if (forceFlush) {
        await this._flush({ force: true });
      }

      // After flush, destroy event buffer
      this.eventBuffer && this.eventBuffer.destroy();
      this.eventBuffer = null;

      // Clear session from session storage, note this means if a new session
      // is started after, it will not have `previousSessionId`
      clearSession(this);
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
   pause() {
    if (this._isPaused) {
      return;
    }

    this._isPaused = true;
    this.stopRecording();

    logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
  }

  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
   resume() {
    if (!this._isPaused || !this._checkSession()) {
      return;
    }

    this._isPaused = false;
    this.startRecording();

    logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
   async sendBufferedReplayOrFlush({ continueRecording = true } = {}) {
    if (this.recordingMode === 'session') {
      return this.flushImmediate();
    }

    const activityTime = Date.now();

    logInfo('[Replay] Converting buffer to session', this._options._experiments.traceInternals);

    // Allow flush to complete before resuming as a session recording, otherwise
    // the checkout from `startRecording` may be included in the payload.
    // Prefer to keep the error replay as a separate (and smaller) segment
    // than the session replay.
    await this.flushImmediate();

    const hasStoppedRecording = this.stopRecording();

    if (!continueRecording || !hasStoppedRecording) {
      return;
    }

    // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
    if ((this.recordingMode ) === 'session') {
      return;
    }

    // Re-start recording in session-mode
    this.recordingMode = 'session';

    // Once this session ends, we do not want to refresh it
    if (this.session) {
      this._updateUserActivity(activityTime);
      this._updateSessionActivity(activityTime);
      this._maybeSaveSession();
    }

    this.startRecording();
  }

  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
   addUpdate(cb) {
    // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
    const cbResult = cb();

    // If this option is turned on then we will only want to call `flush`
    // explicitly
    if (this.recordingMode === 'buffer') {
      return;
    }

    // If callback is true, we do not want to continue with flushing -- the
    // caller will need to handle it.
    if (cbResult === true) {
      return;
    }

    // addUpdate is called quite frequently - use _debouncedFlush so that it
    // respects the flush delays and does not flush immediately
    this._debouncedFlush();
  }

  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
   triggerUserActivity() {
    this._updateUserActivity();

    // This case means that recording was once stopped due to inactivity.
    // Ensure that recording is resumed.
    if (!this._stopRecording) {
      // Create a new session, otherwise when the user action is flushed, it
      // will get rejected due to an expired session.
      if (!this._checkSession()) {
        return;
      }

      // Note: This will cause a new DOM checkout
      this.resume();
      return;
    }

    // Otherwise... recording was never suspended, continue as normalish
    this.checkAndHandleExpiredSession();

    this._updateSessionActivity();
  }

  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
   updateUserActivity() {
    this._updateUserActivity();
    this._updateSessionActivity();
  }

  /**
   * Only flush if `this.recordingMode === 'session'`
   */
   conditionalFlush() {
    if (this.recordingMode === 'buffer') {
      return Promise.resolve();
    }

    return this.flushImmediate();
  }

  /**
   * Flush using debounce flush
   */
   flush() {
    return this._debouncedFlush() ;
  }

  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */
   flushImmediate() {
    this._debouncedFlush();
    // `.flush` is provided by the debounced function, analogously to lodash.debounce
    return this._debouncedFlush.flush() ;
  }

  /**
   * Cancels queued up flushes.
   */
   cancelFlush() {
    this._debouncedFlush.cancel();
  }

  /** Get the current sesion (=replay) ID */
   getSessionId() {
    return this.session && this.session.id;
  }

  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
   checkAndHandleExpiredSession() {
    // Prevent starting a new session if the last user activity is older than
    // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
    // session+recording. This creates noisy replays that do not have much
    // content in them.
    if (
      this._lastActivity &&
      isExpired(this._lastActivity, this.timeouts.sessionIdlePause) &&
      this.session &&
      this.session.sampled === 'session'
    ) {
      // Pause recording only for session-based replays. Otherwise, resuming
      // will create a new replay and will conflict with users who only choose
      // to record error-based replays only. (e.g. the resumed replay will not
      // contain a reference to an error)
      this.pause();
      return;
    }

    // --- There is recent user activity --- //
    // This will create a new session if expired, based on expiry length
    if (!this._checkSession()) {
      // Check session handles the refreshing itself
      return false;
    }

    return true;
  }

  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
   setInitialState() {
    const urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
    const url = `${WINDOW.location.origin}${urlPath}`;

    this.performanceEntries = [];
    this.replayPerformanceEntries = [];

    // Reset _context as well
    this._clearContext();

    this._context.initialUrl = url;
    this._context.initialTimestamp = Date.now();
    this._context.urls.push(url);
  }

  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
   throttledAddEvent(
    event,
    isCheckout,
  ) {
    const res = this._throttledAddEvent(event, isCheckout);

    // If this is THROTTLED, it means we have throttled the event for the first time
    // In this case, we want to add a breadcrumb indicating that something was skipped
    if (res === THROTTLED) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.throttled',
      });

      this.addUpdate(() => {
        // Return `false` if the event _was_ added, as that means we schedule a flush
        return !addEventSync(this, {
          type: ReplayEventTypeCustom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: 'breadcrumb',
            payload: breadcrumb,
            metric: true,
          },
        });
      });
    }

    return res;
  }

  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
   getCurrentRoute() {
    // eslint-disable-next-line deprecation/deprecation
    const lastTransaction = this.lastTransaction || (0,esm_exports/* getCurrentScope */.nZ)().getTransaction();

    const attributes = (lastTransaction && (0,spanUtils/* spanToJSON */.XU)(lastTransaction).data) || {};
    const source = attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
    if (!lastTransaction || !source || !['route', 'custom'].includes(source)) {
      return undefined;
    }

    return (0,spanUtils/* spanToJSON */.XU)(lastTransaction).description;
  }

  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
   _initializeRecording() {
    this.setInitialState();

    // this method is generally called on page load or manually - in both cases
    // we should treat it as an activity
    this._updateSessionActivity();

    this.eventBuffer = createEventBuffer({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl,
    });

    this._removeListeners();
    this._addListeners();

    // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
    this._isEnabled = true;
    this._isPaused = false;

    this.startRecording();
  }

  /** A wrapper to conditionally capture exceptions. */
   _handleException(error) {
    DEBUG_BUILD && logger/* logger.error */.kg.error('[Replay]', error);

    if (DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) {
      (0,esm_exports/* captureException */.Tb)(error);
    }
  }

  /**
   * Loads (or refreshes) the current session.
   */
   _initializeSessionForSampling(previousSessionId) {
    // Whenever there is _any_ error sample rate, we always allow buffering
    // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
    const allowBuffering = this._options.errorSampleRate > 0;

    const session = loadOrCreateSession(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        traceInternals: this._options._experiments.traceInternals,
        previousSessionId,
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering,
      },
    );

    this.session = session;
  }

  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
   _checkSession() {
    // If there is no session yet, we do not want to refresh anything
    // This should generally not happen, but to be safe....
    if (!this.session) {
      return false;
    }

    const currentSession = this.session;

    if (
      shouldRefreshSession(currentSession, {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
      })
    ) {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this._refreshSession(currentSession);
      return false;
    }

    return true;
  }

  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
   async _refreshSession(session) {
    if (!this._isEnabled) {
      return;
    }
    await this.stop({ reason: 'refresh session' });
    this.initializeSampling(session.id);
  }

  /**
   * Adds listeners to record events for the replay
   */
   _addListeners() {
    try {
      WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
      WINDOW.addEventListener('blur', this._handleWindowBlur);
      WINDOW.addEventListener('focus', this._handleWindowFocus);
      WINDOW.addEventListener('keydown', this._handleKeyboardEvent);

      if (this.clickDetector) {
        this.clickDetector.addListeners();
      }

      // There is no way to remove these listeners, so ensure they are only added once
      if (!this._hasInitializedCoreListeners) {
        addGlobalListeners(this);

        this._hasInitializedCoreListeners = true;
      }
    } catch (err) {
      this._handleException(err);
    }

    this._performanceCleanupCallback = setupPerformanceObserver(this);
  }

  /**
   * Cleans up listeners that were created in `_addListeners`
   */
   _removeListeners() {
    try {
      WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);

      WINDOW.removeEventListener('blur', this._handleWindowBlur);
      WINDOW.removeEventListener('focus', this._handleWindowFocus);
      WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);

      if (this.clickDetector) {
        this.clickDetector.removeListeners();
      }

      if (this._performanceCleanupCallback) {
        this._performanceCleanupCallback();
      }
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
   __init() {this._handleVisibilityChange = () => {
    if (WINDOW.document.visibilityState === 'visible') {
      this._doChangeToForegroundTasks();
    } else {
      this._doChangeToBackgroundTasks();
    }
  };}

  /**
   * Handle when page is blurred
   */
   __init2() {this._handleWindowBlur = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.blur',
    });

    // Do not count blur as a user action -- it's part of the process of them
    // leaving the page
    this._doChangeToBackgroundTasks(breadcrumb);
  };}

  /**
   * Handle when page is focused
   */
   __init3() {this._handleWindowFocus = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.focus',
    });

    // Do not count focus as a user action -- instead wait until they focus and
    // interactive with page
    this._doChangeToForegroundTasks(breadcrumb);
  };}

  /** Ensure page remains active when a key is pressed. */
   __init4() {this._handleKeyboardEvent = (event) => {
    handleKeyboardEvent(this, event);
  };}

  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
   _doChangeToBackgroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const expired = isSessionExpired(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
    });

    if (expired) {
      return;
    }

    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Send replay when the page/tab becomes hidden. There is no reason to send
    // replay if it becomes visible, since no actions we care about were done
    // while it was hidden
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    void this.conditionalFlush();
  }

  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
   _doChangeToForegroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const isSessionActive = this.checkAndHandleExpiredSession();

    if (!isSessionActive) {
      // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
      // ms, we will re-use the existing session, otherwise create a new
      // session
      logInfo('[Replay] Document has become active, but session has expired');
      return;
    }

    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
  }

  /**
   * Update user activity (across session lifespans)
   */
   _updateUserActivity(_lastActivity = Date.now()) {
    this._lastActivity = _lastActivity;
  }

  /**
   * Updates the session's last activity timestamp
   */
   _updateSessionActivity(_lastActivity = Date.now()) {
    if (this.session) {
      this.session.lastActivity = _lastActivity;
      this._maybeSaveSession();
    }
  }

  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
   _createCustomBreadcrumb(breadcrumb) {
    this.addUpdate(() => {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.throttledAddEvent({
        type: EventType.Custom,
        timestamp: breadcrumb.timestamp || 0,
        data: {
          tag: 'breadcrumb',
          payload: breadcrumb,
        },
      });
    });
  }

  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
   _addPerformanceEntries() {
    const performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);

    this.performanceEntries = [];
    this.replayPerformanceEntries = [];

    return Promise.all(createPerformanceSpans(this, performanceEntries));
  }

  /**
   * Clear _context
   */
   _clearContext() {
    // XXX: `initialTimestamp` and `initialUrl` do not get cleared
    this._context.errorIds.clear();
    this._context.traceIds.clear();
    this._context.urls = [];
  }

  /** Update the initial timestamp based on the buffer content. */
   _updateInitialTimestampFromEventBuffer() {
    const { session, eventBuffer } = this;
    if (!session || !eventBuffer) {
      return;
    }

    // we only ever update this on the initial segment
    if (session.segmentId) {
      return;
    }

    const earliestEvent = eventBuffer.getEarliestTimestamp();
    if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
      this._context.initialTimestamp = earliestEvent;
    }
  }

  /**
   * Return and clear _context
   */
   _popEventContext() {
    const _context = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls,
    };

    this._clearContext();

    return _context;
  }

  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
   async _runFlush() {
    const replayId = this.getSessionId();

    if (!this.session || !this.eventBuffer || !replayId) {
      DEBUG_BUILD && logger/* logger.error */.kg.error('[Replay] No session or eventBuffer found to flush.');
      return;
    }

    await this._addPerformanceEntries();

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer || !this.eventBuffer.hasEvents) {
      return;
    }

    // Only attach memory event if eventBuffer is not empty
    await addMemoryEntry(this);

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer) {
      return;
    }

    // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
    if (replayId !== this.getSessionId()) {
      return;
    }

    try {
      // This uses the data from the eventBuffer, so we need to call this before `finish()
      this._updateInitialTimestampFromEventBuffer();

      const timestamp = Date.now();

      // Check total duration again, to avoid sending outdated stuff
      // We leave 30s wiggle room to accomodate late flushing etc.
      // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
      if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) {
        throw new Error('Session is too long, not sending replay');
      }

      const eventContext = this._popEventContext();
      // Always increment segmentId regardless of outcome of sending replay
      const segmentId = this.session.segmentId++;
      this._maybeSaveSession();

      // Note this empties the event buffer regardless of outcome of sending replay
      const recordingData = await this.eventBuffer.finish();

      await sendReplay({
        replayId,
        recordingData,
        segmentId,
        eventContext,
        session: this.session,
        options: this.getOptions(),
        timestamp,
      });
    } catch (err) {
      this._handleException(err);

      // This means we retried 3 times and all of them failed,
      // or we ran into a problem we don't want to retry, like rate limiting.
      // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.stop({ reason: 'sendReplay' });

      const client = (0,esm_exports/* getClient */.s3)();

      if (client) {
        client.recordDroppedEvent('send_error', 'replay');
      }
    }
  }

  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
   __init5() {this._flush = async ({
    force = false,
  }

 = {}) => {
    if (!this._isEnabled && !force) {
      // This can happen if e.g. the replay was stopped because of exceeding the retry limit
      return;
    }

    if (!this.checkAndHandleExpiredSession()) {
      DEBUG_BUILD && logger/* logger.error */.kg.error('[Replay] Attempting to finish replay event after session expired.');
      return;
    }

    if (!this.session) {
      // should never happen, as we would have bailed out before
      return;
    }

    const start = this.session.started;
    const now = Date.now();
    const duration = now - start;

    // A flush is about to happen, cancel any queued flushes
    this._debouncedFlush.cancel();

    // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
    // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
    const tooShort = duration < this._options.minReplayDuration;
    const tooLong = duration > this._options.maxReplayDuration + 5000;
    if (tooShort || tooLong) {
      logInfo(
        `[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${
          tooShort ? 'short' : 'long'
        }, not sending replay.`,
        this._options._experiments.traceInternals,
      );

      if (tooShort) {
        this._debouncedFlush();
      }
      return;
    }

    const eventBuffer = this.eventBuffer;
    if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) {
      logInfo('[Replay] Flushing initial segment without checkout.', this._options._experiments.traceInternals);
      // TODO FN: Evaluate if we want to stop here, or remove this again?
    }

    // this._flushLock acts as a lock so that future calls to `_flush()`
    // will be blocked until this promise resolves
    if (!this._flushLock) {
      this._flushLock = this._runFlush();
      await this._flushLock;
      this._flushLock = undefined;
      return;
    }

    // Wait for previous flush to finish, then call the debounced `_flush()`.
    // It's possible there are other flush requests queued and waiting for it
    // to resolve. We want to reduce all outstanding requests (as well as any
    // new flush requests that occur within a second of the locked flush
    // completing) into a single flush.

    try {
      await this._flushLock;
    } catch (err) {
      DEBUG_BUILD && logger/* logger.error */.kg.error(err);
    } finally {
      this._debouncedFlush();
    }
  };}

  /** Save the session, if it is sticky */
   _maybeSaveSession() {
    if (this.session && this._options.stickySession) {
      saveSession(this.session);
    }
  }

  /** Handler for rrweb.record.onMutation */
   __init6() {this._onMutationHandler = (mutations) => {
    const count = mutations.length;

    const mutationLimit = this._options.mutationLimit;
    const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
    const overMutationLimit = mutationLimit && count > mutationLimit;

    // Create a breadcrumb if a lot of mutations happen at the same time
    // We can show this in the UI as an information with potential performance improvements
    if (count > mutationBreadcrumbLimit || overMutationLimit) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.mutations',
        data: {
          count,
          limit: overMutationLimit,
        },
      });
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Stop replay if over the mutation limit
    if (overMutationLimit) {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.stop({ reason: 'mutationLimit', forceFlush: this.recordingMode === 'session' });
      return false;
    }

    // `true` means we use the regular mutation handling by rrweb
    return true;
  };}
}

function getOption(
  selectors,
  defaultSelectors,
  deprecatedClassOption,
  deprecatedSelectorOption,
) {
  const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];

  const allSelectors = [
    ...selectors,
    // @deprecated
    ...deprecatedSelectors,

    // sentry defaults
    ...defaultSelectors,
  ];

  // @deprecated
  if (typeof deprecatedClassOption !== 'undefined') {
    // NOTE: No support for RegExp
    if (typeof deprecatedClassOption === 'string') {
      allSelectors.push(`.${deprecatedClassOption}`);
    }

    (0,logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.warn(
        '[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.',
      );
    });
  }

  return allSelectors.join(',');
}

/**
 * Returns privacy related configuration for use in rrweb
 */
function getPrivacyOptions({
  mask,
  unmask,
  block,
  unblock,
  ignore,

  // eslint-disable-next-line deprecation/deprecation
  blockClass,
  // eslint-disable-next-line deprecation/deprecation
  blockSelector,
  // eslint-disable-next-line deprecation/deprecation
  maskTextClass,
  // eslint-disable-next-line deprecation/deprecation
  maskTextSelector,
  // eslint-disable-next-line deprecation/deprecation
  ignoreClass,
}) {
  const defaultBlockedElements = ['base[href="/"]'];

  const maskSelector = getOption(mask, ['.sentry-mask', '[data-sentry-mask]'], maskTextClass, maskTextSelector);
  const unmaskSelector = getOption(unmask, ['.sentry-unmask', '[data-sentry-unmask]']);

  const options = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: maskSelector,
    unmaskTextSelector: unmaskSelector,

    blockSelector: getOption(
      block,
      ['.sentry-block', '[data-sentry-block]', ...defaultBlockedElements],
      blockClass,
      blockSelector,
    ),
    unblockSelector: getOption(unblock, ['.sentry-unblock', '[data-sentry-unblock]']),
    ignoreSelector: getOption(ignore, ['.sentry-ignore', '[data-sentry-ignore]', 'input[type="file"]'], ignoreClass),
  };

  if (blockClass instanceof RegExp) {
    options.blockClass = blockClass;
  }

  if (maskTextClass instanceof RegExp) {
    options.maskTextClass = maskTextClass;
  }

  return options;
}

/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */
function maskAttribute({
  el,
  key,
  maskAttributes,
  maskAllText,
  privacyOptions,
  value,
}) {
  // We only mask attributes if `maskAllText` is true
  if (!maskAllText) {
    return value;
  }

  // unmaskTextSelector takes precendence
  if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) {
    return value;
  }

  if (
    maskAttributes.includes(key) ||
    // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    (key === 'value' && el.tagName === 'INPUT' && ['submit', 'button'].includes(el.getAttribute('type') || ''))
  ) {
    return value.replace(/[\S]/g, '*');
  }

  return value;
}

const MEDIA_SELECTORS =
  'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';

const DEFAULT_NETWORK_HEADERS = ['content-length', 'content-type', 'accept'];

let _initialized = false;

const replayIntegration$1 = ((options) => {
  // eslint-disable-next-line deprecation/deprecation
  return new Replay$1(options);
}) ;

/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */
class Replay$1  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Replay';}

  /**
   * @inheritDoc
   */

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */

   constructor({
    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
    minReplayDuration = MIN_REPLAY_DURATION,
    maxReplayDuration = MAX_REPLAY_DURATION,
    stickySession = true,
    useCompression = true,
    workerUrl,
    _experiments = {},
    sessionSampleRate,
    errorSampleRate,
    maskAllText = true,
    maskAllInputs = true,
    blockAllMedia = true,

    mutationBreadcrumbLimit = 750,
    mutationLimit = 10000,

    slowClickTimeout = 7000,
    slowClickIgnoreSelectors = [],

    networkDetailAllowUrls = [],
    networkDetailDenyUrls = [],
    networkCaptureBodies = true,
    networkRequestHeaders = [],
    networkResponseHeaders = [],

    mask = [],
    maskAttributes = ['title', 'placeholder'],
    unmask = [],
    block = [],
    unblock = [],
    ignore = [],
    maskFn,

    beforeAddRecordingEvent,
    beforeErrorSampling,

    // eslint-disable-next-line deprecation/deprecation
    blockClass,
    // eslint-disable-next-line deprecation/deprecation
    blockSelector,
    // eslint-disable-next-line deprecation/deprecation
    maskInputOptions,
    // eslint-disable-next-line deprecation/deprecation
    maskTextClass,
    // eslint-disable-next-line deprecation/deprecation
    maskTextSelector,
    // eslint-disable-next-line deprecation/deprecation
    ignoreClass,
  } = {}) {
    // eslint-disable-next-line deprecation/deprecation
    this.name = Replay$1.id;

    const privacyOptions = getPrivacyOptions({
      mask,
      unmask,
      block,
      unblock,
      ignore,
      blockClass,
      blockSelector,
      maskTextClass,
      maskTextSelector,
      ignoreClass,
    });

    this._recordingOptions = {
      maskAllInputs,
      maskAllText,
      maskInputOptions: { ...(maskInputOptions || {}), password: true },
      maskTextFn: maskFn,
      maskInputFn: maskFn,
      maskAttributeFn: (key, value, el) =>
        maskAttribute({
          maskAttributes,
          maskAllText,
          privacyOptions,
          key,
          value,
          el,
        }),

      ...privacyOptions,

      // Our defaults
      slimDOMOptions: 'all',
      inlineStylesheet: true,
      // Disable inline images as it will increase segment/replay size
      inlineImages: false,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: true,
      errorHandler: (err) => {
        try {
          err.__rrweb__ = true;
        } catch (error) {
          // ignore errors here
          // this can happen if the error is frozen or does not allow mutation for other reasons
        }
      },
    };

    this._initialOptions = {
      flushMinDelay,
      flushMaxDelay,
      minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
      maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
      stickySession,
      sessionSampleRate,
      errorSampleRate,
      useCompression,
      workerUrl,
      blockAllMedia,
      maskAllInputs,
      maskAllText,
      mutationBreadcrumbLimit,
      mutationLimit,
      slowClickTimeout,
      slowClickIgnoreSelectors,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
      beforeAddRecordingEvent,
      beforeErrorSampling,

      _experiments,
    };

    if (typeof sessionSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`,
      );

      this._initialOptions.sessionSampleRate = sessionSampleRate;
    }

    if (typeof errorSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`,
      );

      this._initialOptions.errorSampleRate = errorSampleRate;
    }

    if (this._initialOptions.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector
        ? MEDIA_SELECTORS
        : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
    }

    if (this._isInitialized && isBrowser()) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }

    this._isInitialized = true;
  }

  /** If replay has already been initialized */
   get _isInitialized() {
    return _initialized;
  }

  /** Update _isInitialized */
   set _isInitialized(value) {
    _initialized = value;
  }

  /**
   * Setup and initialize replay container
   */
   setupOnce() {
    if (!isBrowser()) {
      return;
    }

    this._setup();

    // Once upon a time, we tried to create a transaction in `setupOnce` and it would
    // potentially create a transaction before some native SDK integrations have run
    // and applied their own global event processor. An example is:
    // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
    //
    // So we call `this._initialize()` in next event loop as a workaround to wait for other
    // global event processors to finish. This is no longer needed, but keeping it
    // here to avoid any future issues.
    setTimeout(() => this._initialize());
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (!this._replay) {
      return;
    }

    this._replay.start();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
   startBuffering() {
    if (!this._replay) {
      return;
    }

    this._replay.startBuffering();
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   stop() {
    if (!this._replay) {
      return Promise.resolve();
    }

    return this._replay.stop({ forceFlush: this._replay.recordingMode === 'session' });
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
   flush(options) {
    if (!this._replay || !this._replay.isEnabled()) {
      return Promise.resolve();
    }

    return this._replay.sendBufferedReplayOrFlush(options);
  }

  /**
   * Get the current session ID.
   */
   getReplayId() {
    if (!this._replay || !this._replay.isEnabled()) {
      return;
    }

    return this._replay.getSessionId();
  }

  /**
   * Initializes replay.
   */
   _initialize() {
    if (!this._replay) {
      return;
    }

    // We have to run this in _initialize, because this runs in setTimeout
    // So when this runs all integrations have been added
    // Before this, we cannot access integrations on the client,
    // so we need to mutate the options here
    this._maybeLoadFromReplayCanvasIntegration();

    this._replay.initializeSampling();
  }

  /** Setup the integration. */
   _setup() {
    // Client is not available in constructor, so we need to wait until setupOnce
    const finalOptions = loadReplayOptionsFromClient(this._initialOptions);

    this._replay = new ReplayContainer({
      options: finalOptions,
      recordingOptions: this._recordingOptions,
    });
  }

  /** Get canvas options from ReplayCanvas integration, if it is also added. */
   _maybeLoadFromReplayCanvasIntegration() {
    // To save bundle size, we skip checking for stuff here
    // and instead just try-catch everything - as generally this should all be defined
    /* eslint-disable @typescript-eslint/no-non-null-assertion */
    try {
      const client = (0,esm_exports/* getClient */.s3)();
      const canvasIntegration = client.getIntegrationByName('ReplayCanvas')

;
      if (!canvasIntegration) {
        return;
      }

      this._replay['_canvas'] = canvasIntegration.getOptions();
    } catch (e) {
      // ignore errors here
    }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */
  }
}Replay$1.__initStatic();

/** Parse Replay-related options from SDK options */
function loadReplayOptionsFromClient(initialOptions) {
  const client = (0,esm_exports/* getClient */.s3)();
  const opt = client && (client.getOptions() );

  const finalOptions = { sessionSampleRate: 0, errorSampleRate: 0, ...(0,object/* dropUndefinedKeys */.Jr)(initialOptions) };

  if (!opt) {
    (0,logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.warn('SDK client is not available.');
    });
    return finalOptions;
  }

  if (
    initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null &&
    opt.replaysOnErrorSampleRate == null
  ) {
    (0,logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.warn(
        'Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.',
      );
    });
  }

  if (typeof opt.replaysSessionSampleRate === 'number') {
    finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
  }

  if (typeof opt.replaysOnErrorSampleRate === 'number') {
    finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
  }

  return finalOptions;
}

function _getMergedNetworkHeaders(headers) {
  return [...DEFAULT_NETWORK_HEADERS, ...headers.map(header => header.toLowerCase())];
}

/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */
// eslint-disable-next-line deprecation/deprecation
function getReplay$1() {
  const client = (0,esm_exports/* getClient */.s3)();
  return (
    client && client.getIntegrationByName && client.getIntegrationByName('Replay')
  );
}

// eslint-disable-next-line deprecation/deprecation

/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */
const getReplay = (/* unused pure expression or super */ null && (getReplay$1));

/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */
const replayIntegration = (/* unused pure expression or super */ null && (replayIntegration$1));

/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */
// eslint-disable-next-line deprecation/deprecation
class Replay extends (/* unused pure expression or super */ null && (Replay$1)) {}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/replay-canvas/esm/index.js



var esm_NodeType;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(esm_NodeType || (esm_NodeType = {}));
function esm_elementClassMatchesRegex(el, regex) {
    for (let eIndex = el.classList.length; eIndex--;) {
        const className = el.classList[eIndex];
        if (regex.test(className)) {
            return true;
        }
    }
    return false;
}
function esm_distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node)
        return -1;
    if (node.nodeType !== node.ELEMENT_NODE)
        return -1;
    if (distance > limit)
        return -1;
    if (matchPredicate(node))
        return distance;
    return esm_distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function esm_createMatchPredicate(className, selector) {
    return (node) => {
        const el = node;
        if (el === null)
            return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`))
                        return true;
                }
                else if (esm_elementClassMatchesRegex(el, className)) {
                    return true;
                }
            }
            if (selector && el.matches(selector))
                return true;
            return false;
        }
        catch (e2) {
            return false;
        }
    };
}

const esm_DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' +
    '\r\n' +
    'now you can use replayer.getMirror() to access the mirror instance of a replayer,' +
    '\r\n' +
    'or you can use record.mirror to access the mirror instance during recording.';
let esm_mirror = {
    map: {},
    getId() {
        console.error(esm_DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode() {
        console.error(esm_DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap() {
        console.error(esm_DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has() {
        console.error(esm_DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset() {
        console.error(esm_DEPARTED_MIRROR_ACCESS_WARNING);
    },
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
    esm_mirror = new Proxy(esm_mirror, {
        get(target, prop, receiver) {
            if (prop === 'map') {
                console.error(esm_DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        },
    });
}
function esm_hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked
        ? d
        : {
            set(value) {
                esm_setTimeout(() => {
                    d.set.call(this, value);
                }, 0);
                if (original && original.set) {
                    original.set.call(this, value);
                }
            },
        });
    return () => esm_hookSetter(target, key, original || {}, true);
}
function esm_patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return () => {
            };
        }
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        source[name] = wrapped;
        return () => {
            source[name] = original;
        };
    }
    catch (e2) {
        return () => {
        };
    }
}
if (!(/[1-9][0-9]{12}/.test(Date.now().toString()))) ;
function esm_closestElementOfNode(node) {
    if (!node) {
        return null;
    }
    const el = node.nodeType === node.ELEMENT_NODE
        ? node
        : node.parentElement;
    return el;
}
function esm_isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) {
        return false;
    }
    const el = esm_closestElementOfNode(node);
    if (!el) {
        return false;
    }
    const blockedPredicate = esm_createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = esm_distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) {
        return false;
    }
    if (unblockSelector) {
        unblockDistance = esm_distanceToMatch(el, esm_createMatchPredicate(null, unblockSelector));
    }
    if (blockDistance > -1 && unblockDistance < 0) {
        return true;
    }
    return blockDistance < unblockDistance;
}
const esm_cachedImplementations = {};
function esm_getImplementation(name) {
    const cached = esm_cachedImplementations[name];
    if (cached) {
        return cached;
    }
    const document = window.document;
    let impl = window[name];
    if (document && typeof document.createElement === 'function') {
        try {
            const sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            const contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow[name]) {
                impl =
                    contentWindow[name];
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
        }
    }
    return (esm_cachedImplementations[name] = impl.bind(window));
}
function esm_onRequestAnimationFrame(...rest) {
    return esm_getImplementation('requestAnimationFrame')(...rest);
}
function esm_setTimeout(...rest) {
    return esm_getImplementation('setTimeout')(...rest);
}

var CanvasContext = /* @__PURE__ */ ((CanvasContext2) => {
  CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
  CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
  CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
  return CanvasContext2;
})(CanvasContext || {});

let esm_errorHandler;
function esm_registerErrorHandler(handler) {
    esm_errorHandler = handler;
}
const esm_callbackWrapper = (cb) => {
    if (!esm_errorHandler) {
        return cb;
    }
    const rrwebWrapped = ((...rest) => {
        try {
            return cb(...rest);
        }
        catch (error) {
            if (esm_errorHandler && esm_errorHandler(error) === true) {
                return () => {
                };
            }
            throw error;
        }
    });
    return rrwebWrapped;
};

/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
var encode = function (arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};

const canvasVarMap = new Map();
function variableListFor(ctx, ctor) {
    let contextMap = canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
const saveWebGLVar = (value, win, ctx) => {
    if (!value ||
        !(isInstanceOfWebGLObject(value, win) || typeof value === 'object'))
        return;
    const name = value.constructor.name;
    const list = variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) {
        return value.map((arg) => serializeArg(arg, win, ctx));
    }
    else if (value === null) {
        return value;
    }
    else if (value instanceof Float32Array ||
        value instanceof Float64Array ||
        value instanceof Int32Array ||
        value instanceof Uint32Array ||
        value instanceof Uint8Array ||
        value instanceof Uint16Array ||
        value instanceof Int16Array ||
        value instanceof Int8Array ||
        value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [Object.values(value)],
        };
    }
    else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = encode(value);
        return {
            rr_type: name,
            base64,
        };
    }
    else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength,
            ],
        };
    }
    else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src } = value;
        return {
            rr_type: name,
            src,
        };
    }
    else if (value instanceof HTMLCanvasElement) {
        const name = 'HTMLImageElement';
        const src = value.toDataURL();
        return {
            rr_type: name,
            src,
        };
    }
    else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [serializeArg(value.data, win, ctx), value.width, value.height],
        };
    }
    else if (isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index,
        };
    }
    return value;
}
const serializeArgs = (args, win, ctx) => {
    return args.map((arg) => serializeArg(arg, win, ctx));
};
const isInstanceOfWebGLObject = (value, win) => {
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES',
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name) => typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name) => value instanceof win[name]));
};

function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D) {
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
                continue;
            }
            const restoreHandler = esm_patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
                return function (...args) {
                    if (!esm_isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        esm_setTimeout(() => {
                            const recordArgs = serializeArgs(args, win, this);
                            cb(this.canvas, {
                                type: CanvasContext['2D'],
                                property: prop,
                                args: recordArgs,
                            });
                        }, 0);
                    }
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        }
        catch (e) {
            const hookHandler = esm_hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set(v) {
                    cb(this.canvas, {
                        type: CanvasContext['2D'],
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

function getNormalizedContextName(contextType) {
    return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = esm_patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
            return function (contextType, ...args) {
                if (!esm_isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = getNormalizedContextName(contextType);
                    if (!('__context' in this))
                        this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue &&
                        ['webgl', 'webgl2'].includes(ctxName)) {
                        if (args[0] && typeof args[0] === 'object') {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) {
                                contextAttributes.preserveDrawingBuffer = true;
                            }
                        }
                        else {
                            args.splice(0, 1, {
                                preserveDrawingBuffer: true,
                            });
                        }
                    }
                }
                return original.apply(this, [contextType, ...args]);
            };
        });
        handlers.push(restoreHandler);
    }
    catch (e) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props) {
        if ([
            'isContextLost',
            'canvas',
            'drawingBufferWidth',
            'drawingBufferHeight',
        ].includes(prop)) {
            continue;
        }
        try {
            if (typeof prototype[prop] !== 'function') {
                continue;
            }
            const restoreHandler = esm_patch(prototype, prop, function (original) {
                return function (...args) {
                    const result = original.apply(this, args);
                    saveWebGLVar(result, win, this);
                    if ('tagName' in this.canvas &&
                        !esm_isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        const recordArgs = serializeArgs(args, win, this);
                        const mutation = {
                            type,
                            property: prop,
                            args: recordArgs,
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        }
        catch (e) {
            const hookHandler = esm_hookSetter(prototype, prop, {
                set(v) {
                    cb(this.canvas, {
                        type,
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') {
        handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

var esm_r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;

function t(){const t=new Blob([esm_r]);return URL.createObjectURL(t)}

class CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options) {
        this.pendingCanvasMutations = new Map();
        this.rafStamps = { latestId: 0, invokeId: null };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation) => {
            const newFrame = this.rafStamps.invokeId &&
                this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId)
                this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) {
                this.pendingCanvasMutations.set(target, []);
            }
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling = 'all', win, blockClass, blockSelector, unblockSelector, maxCanvasSize, recordCanvas, dataURLOptions, errorHandler, } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) {
            esm_registerErrorHandler(errorHandler);
        }
        if (options.enableManualSnapshot) {
            return;
        }
        esm_callbackWrapper(() => {
            if (recordCanvas && sampling === 'all')
                this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === 'number')
                this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                    dataURLOptions,
                });
        })();
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
        const rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
        this.resetObservers = () => {
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = () => {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    snapshot(canvasElement) {
        const { options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === 'all' ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
        this.resetObservers = () => {
            cancelAnimationFrame(rafId);
        };
    }
    takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
        const snapshotInProgressMap = new Map();
        const worker = new Worker(t());
        worker.onmessage = (e) => {
            const data = e.data;
            const { id } = data;
            snapshotInProgressMap.set(id, false);
            if (!('base64' in data))
                return;
            const { base64, type, width, height } = data;
            this.mutationCb({
                id,
                type: CanvasContext['2D'],
                commands: [
                    {
                        property: 'clearRect',
                        args: [0, 0, width, height],
                    },
                    {
                        property: 'drawImage',
                        args: [
                            {
                                rr_type: 'ImageBitmap',
                                args: [
                                    {
                                        rr_type: 'Blob',
                                        data: [{ rr_type: 'ArrayBuffer', base64 }],
                                        type,
                                    },
                                ],
                            },
                            0,
                            0,
                            width,
                            height,
                        ],
                    },
                ],
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = (canvasElement) => {
            if (canvasElement) {
                return [canvasElement];
            }
            const matchedCanvas = [];
            win.document.querySelectorAll('canvas').forEach((canvas) => {
                if (!esm_isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) {
                    matchedCanvas.push(canvas);
                }
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp) => {
            if (lastSnapshotTime &&
                timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = esm_onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas) => {
                const id = this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id))
                    return;
                if (!canvas.width || !canvas.height)
                    return;
                snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot &&
                    ['webgl', 'webgl2'].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if ((0,_optionalChain/* _optionalChain */.x)([context, 'optionalAccess', _ => _.getContextAttributes, 'call', _2 => _2(), 'optionalAccess', _3 => _3.preserveDrawingBuffer]) === false) {
                        context.clear(context.COLOR_BUFFER_BIT);
                    }
                }
                createImageBitmap(canvas)
                    .then((bitmap) => {
                    worker.postMessage({
                        id,
                        bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions,
                        maxCanvasSize,
                    }, [bitmap]);
                })
                    .catch((error) => {
                    esm_callbackWrapper(() => {
                        throw error;
                    })();
                });
            });
            rafId = esm_onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = esm_onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        esm_onRequestAnimationFrame(() => this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp) => {
            this.rafStamps.latestId = timestamp;
            esm_onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        esm_onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas) => {
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        esm_onRequestAnimationFrame(() => this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) {
            return;
        }
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1)
            return;
        const values = valuesWithType.map((value) => {
            const { type, ...rest } = value;
            return rest;
        });
        const { type } = valuesWithType[0];
        this.mutationCb({ id, type, commands: values });
        this.pendingCanvasMutations.delete(canvas);
    }
}

const CANVAS_QUALITY = {
  low: {
    sampling: {
      canvas: 1,
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.25,
    },
  },
  medium: {
    sampling: {
      canvas: 2,
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.4,
    },
  },
  high: {
    sampling: {
      canvas: 4,
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.5,
    },
  },
};

const esm_INTEGRATION_NAME = 'ReplayCanvas';
const DEFAULT_MAX_CANVAS_SIZE = 1280;

/** Exported only for type safe tests. */
const _replayCanvasIntegration = ((options = {}) => {
  const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
  const _canvasOptions = {
    quality: options.quality || 'medium',
    enableManualSnapshot: options.enableManualSnapshot,
    maxCanvasSize: [
      maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
      maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
    ] ,
  };

  let canvasManagerResolve;
  const _canvasManager = new Promise(resolve => (canvasManagerResolve = resolve));

  return {
    name: esm_INTEGRATION_NAME,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setupOnce() {},
    getOptions() {
      const { quality, enableManualSnapshot, maxCanvasSize } = _canvasOptions;

      return {
        enableManualSnapshot,
        recordCanvas: true,
        getCanvasManager: (getCanvasManagerOptions) => {
          const manager = new CanvasManager({
            ...getCanvasManagerOptions,
            enableManualSnapshot,
            maxCanvasSize,
            errorHandler: (err) => {
              try {
                if (typeof err === 'object') {
                  (err ).__rrweb__ = true;
                }
              } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
              }
            },
          });
          canvasManagerResolve(manager);
          return manager;
        },
        ...(CANVAS_QUALITY[quality || 'medium'] || CANVAS_QUALITY.medium),
      };
    },
    async snapshot(canvasElement) {
      const canvasManager = await _canvasManager;
      canvasManager.snapshot(canvasElement);
    },
  };
}) ;

/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */
const replayCanvasIntegration = (0,integration/* defineIntegration */._I)(_replayCanvasIntegration);

/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */
// eslint-disable-next-line deprecation/deprecation
const ReplayCanvas = (0,integration/* convertIntegrationFnToClass */.RN)(esm_INTEGRATION_NAME, replayCanvasIntegration)

;


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/envelope.js
var core_esm_envelope = __webpack_require__(13114);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/feedback/esm/index.js



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
const esm_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const LIGHT_BACKGROUND = '#ffffff';
const INHERIT = 'inherit';
const SUBMIT_COLOR = 'rgba(108, 95, 199, 1)';
const LIGHT_THEME = {
  fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
  fontSize: '14px',

  background: LIGHT_BACKGROUND,
  backgroundHover: '#f6f6f7',
  foreground: '#2b2233',
  border: '1.5px solid rgba(41, 35, 47, 0.13)',
  borderRadius: '25px',
  boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',

  success: '#268d75',
  error: '#df3338',

  submitBackground: 'rgba(88, 74, 192, 1)',
  submitBackgroundHover: SUBMIT_COLOR,
  submitBorder: SUBMIT_COLOR,
  submitOutlineFocus: '#29232f',
  submitForeground: LIGHT_BACKGROUND,
  submitForegroundHover: LIGHT_BACKGROUND,

  cancelBackground: 'transparent',
  cancelBackgroundHover: 'var(--background-hover)',
  cancelBorder: 'var(--border)',
  cancelOutlineFocus: 'var(--input-outline-focus)',
  cancelForeground: 'var(--foreground)',
  cancelForegroundHover: 'var(--foreground)',

  inputBackground: INHERIT,
  inputForeground: INHERIT,
  inputBorder: 'var(--border)',
  inputOutlineFocus: SUBMIT_COLOR,

  formBorderRadius: '20px',
  formContentBorderRadius: '6px',
};

const DEFAULT_THEME = {
  light: LIGHT_THEME,
  dark: {
    ...LIGHT_THEME,

    background: '#29232f',
    backgroundHover: '#352f3b',
    foreground: '#ebe6ef',
    border: '1.5px solid rgba(235, 230, 239, 0.15)',

    success: '#2da98c',
    error: '#f55459',
  },
};

const ACTOR_LABEL = 'Report a Bug';
const CANCEL_BUTTON_LABEL = 'Cancel';
const SUBMIT_BUTTON_LABEL = 'Send Bug Report';
const FORM_TITLE = 'Report a Bug';
const EMAIL_PLACEHOLDER = 'your.email@example.org';
const EMAIL_LABEL = 'Email';
const MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const MESSAGE_LABEL = 'Description';
const NAME_PLACEHOLDER = 'Your Name';
const NAME_LABEL = 'Name';
const IS_REQUIRED_LABEL = '(required)';
const SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';

const FEEDBACK_WIDGET_SOURCE = 'widget';
const FEEDBACK_API_SOURCE = 'api';

/**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */
async function prepareFeedbackEvent({
  client,
  scope,
  event,
}) {
  const eventHint = {};
  if (client.emit) {
    client.emit('preprocessEvent', event, eventHint);
  }

  const preparedEvent = (await (0,prepareEvent/* prepareEvent */.R)(
    client.getOptions(),
    event,
    eventHint,
    scope,
    client,
    (0,hub/* getIsolationScope */.aF)(),
  )) ;

  if (preparedEvent === null) {
    // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
    client.recordDroppedEvent('event_processor', 'feedback', event);
    return null;
  }

  // This normally happens in browser client "_prepareEvent"
  // but since we do not use this private method from the client, but rather the plain import
  // we need to do this manually.
  preparedEvent.platform = preparedEvent.platform || 'javascript';

  return preparedEvent;
}

/**
 * Send feedback using transport
 */
async function sendFeedbackRequest(
  { feedback: { message, email, name, source, url } },
  { includeReplay = true } = {},
) {
  const client = (0,esm_exports/* getClient */.s3)();
  const transport = client && client.getTransport();
  const dsn = client && client.getDsn();

  if (!client || !transport || !dsn) {
    return;
  }

  const baseEvent = {
    contexts: {
      feedback: {
        contact_email: email,
        name,
        message,
        url,
        source,
      },
    },
    type: 'feedback',
  };

  return (0,esm_exports/* withScope */.$e)(async scope => {
    // No use for breadcrumbs in feedback
    scope.clearBreadcrumbs();

    if ([FEEDBACK_API_SOURCE, FEEDBACK_WIDGET_SOURCE].includes(String(source))) {
      scope.setLevel('info');
    }

    const feedbackEvent = await prepareFeedbackEvent({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      scope: scope ,
      client,
      event: baseEvent,
    });

    if (!feedbackEvent) {
      return;
    }

    if (client.emit) {
      client.emit('beforeSendFeedback', feedbackEvent, { includeReplay: Boolean(includeReplay) });
    }

    const envelope = (0,core_esm_envelope/* createEventEnvelope */.M)(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);

    let response;

    try {
      response = await transport.send(envelope);
    } catch (err) {
      const error = new Error('Unable to send Feedback');

      try {
        // In case browsers don't allow this property to be writable
        // @ts-expect-error This needs lib es2022 and newer
        error.cause = err;
      } catch (e) {
        // nothing to do
      }
      throw error;
    }

    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) {
      return;
    }

    // Require valid status codes, otherwise can assume feedback was not sent successfully
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) {
      throw new Error('Unable to send Feedback');
    }

    return response;
  });
}

/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */

/**
 * Public API to send a Feedback item to Sentry
 */
function sendFeedback(
  { name, email, message, source = FEEDBACK_API_SOURCE, url = (0,browser/* getLocationHref */.l4)() },
  options = {},
) {
  if (!message) {
    throw new Error('Unable to submit feedback with empty message');
  }

  return sendFeedbackRequest(
    {
      feedback: {
        name,
        email,
        message,
        url,
        source,
      },
    },
    options,
  );
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const esm_DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

/**
 * Quick and dirty deep merge for the Feedback integration options
 */
function mergeOptions(
  defaultOptions,
  optionOverrides,
) {
  return {
    ...defaultOptions,
    ...optionOverrides,
    themeDark: {
      ...defaultOptions.themeDark,
      ...optionOverrides.themeDark,
    },
    themeLight: {
      ...defaultOptions.themeLight,
      ...optionOverrides.themeLight,
    },
  };
}

/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */
function createActorStyles(d) {
  const style = d.createElement('style');
  style.textContent = `
.widget__actor {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  line-height: 16px;

  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: var(--border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 16px;
  text-decoration: none;
  z-index: 9000;

  color: var(--foreground);
  background-color: var(--background);
  border: var(--border);
  box-shadow: var(--box-shadow);
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
}

.widget__actor:hover {
  background-color: var(--background-hover);
}

.widget__actor svg {
  width: 16px;
  height: 16px;
}

.widget__actor--hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.widget__actor__text {
}

@media (max-width: 600px) {
  .widget__actor__text {
    display: none;
  }
}

.feedback-icon path {
  fill: var(--foreground);
}
`;

  return style;
}

/**
 * Creates <style> element for widget dialog
 */
function createDialogStyles(d) {
  const style = d.createElement('style');

  style.textContent = `
.dialog {
  line-height: 25px;
  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  position: fixed;
  inset: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);

  border: var(--border);
  border-radius: var(--form-border-radius);
  background-color: var(--background);
  color: var(--foreground);

  width: 320px;
  max-width: 100%;
  max-height: calc(100% - 2rem);
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  padding: 24px 24px 0 24px;
  margin: 0;
  margin-bottom: 16px;
}

.brand-link {
  display: inline-flex;
}

.error {
  color: var(--error);
  margin-bottom: 16px;
}

.form {
  display: grid;
  overflow: auto;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
}

.form__error-container {
  color: var(--error);
}

.form__error-container--hidden {
  display: none;
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: grid;
  gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  line-height: inherit;
  background-color: var(--input-background);
  box-sizing: border-box;
  border: var(--input-border);
  border-radius: var(--form-content-border-radius);
  color: var(--input-foreground);
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 500;
  padding: 6px 12px;
}

.form__input::placeholder {
  color: var(--input-foreground);
  opacity: 0.65;
}

.form__input:focus-visible {
  outline: 1px auto var(--input-outline-focus);
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.btn-group {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.btn {
  line-height: inherit;
  border: var(--cancel-border);
  border-radius: var(--form-content-border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 6px 16px;
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  background-color: var(--submit-background);
  border-color: var(--submit-border);
  color: var(--submit-foreground);
}
.btn--primary:hover {
  background-color: var(--submit-background-hover);
  color: var(--submit-foreground-hover);
}
.btn--primary:focus-visible {
  outline: 1px auto var(--submit-outline-focus);
}

.btn--default {
  background-color: var(--cancel-background);
  color: var(--cancel-foreground);
  font-weight: 500;
}
.btn--default:hover {
  background-color: var(--cancel-background-hover);
  color: var(--cancel-foreground-hover);
}
.btn--default:focus-visible {
  outline: 1px auto var(--cancel-outline-focus);
}

.success-message {
  background-color: var(--background);
  border: var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  font-weight: 600;
  color: var(--success);
  padding: 12px 24px;
  line-height: 25px;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success-icon path {
  fill: var(--success);
}
`;

  return style;
}

function getThemedCssVariables(theme) {
  return `
  --background: ${theme.background};
  --background-hover: ${theme.backgroundHover};
  --foreground: ${theme.foreground};
  --error: ${theme.error};
  --success: ${theme.success};
  --border: ${theme.border};
  --border-radius: ${theme.borderRadius};
  --box-shadow: ${theme.boxShadow};

  --submit-background: ${theme.submitBackground};
  --submit-background-hover: ${theme.submitBackgroundHover};
  --submit-border: ${theme.submitBorder};
  --submit-outline-focus: ${theme.submitOutlineFocus};
  --submit-foreground: ${theme.submitForeground};
  --submit-foreground-hover: ${theme.submitForegroundHover};

  --cancel-background: ${theme.cancelBackground};
  --cancel-background-hover: ${theme.cancelBackgroundHover};
  --cancel-border: ${theme.cancelBorder};
  --cancel-outline-focus: ${theme.cancelOutlineFocus};
  --cancel-foreground: ${theme.cancelForeground};
  --cancel-foreground-hover: ${theme.cancelForegroundHover};

  --input-background: ${theme.inputBackground};
  --input-foreground: ${theme.inputForeground};
  --input-border: ${theme.inputBorder};
  --input-outline-focus: ${theme.inputOutlineFocus};

  --form-border-radius: ${theme.formBorderRadius};
  --form-content-border-radius: ${theme.formContentBorderRadius};
  `;
}

/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */
function createMainStyles(
  d,
  colorScheme,
  themes,
) {
  const style = d.createElement('style');
  style.textContent = `
:host {
  --bottom: 1rem;
  --right: 1rem;
  --top: auto;
  --left: auto;
  --z-index: 100000;
  --font-family: ${themes.light.fontFamily};
  --font-size: ${themes.light.fontSize};

  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${getThemedCssVariables(colorScheme === 'dark' ? themes.dark : themes.light)}
}

${
  colorScheme === 'system'
    ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${getThemedCssVariables(themes.dark)}
  }
}`
    : ''
}
}`;

  return style;
}

/**
 * Creates shadow host
 */
function createShadowHost({ id, colorScheme, themeDark, themeLight })

 {
  try {
    const doc = esm_WINDOW.document;

    // Create the host
    const host = doc.createElement('div');
    host.id = id;

    // Create the shadow root
    const shadow = host.attachShadow({ mode: 'open' });

    shadow.appendChild(createMainStyles(doc, colorScheme, { dark: themeDark, light: themeLight }));
    shadow.appendChild(createDialogStyles(doc));

    return { shadow, host };
  } catch (e) {
    // Shadow DOM probably not supported
    logger/* logger.warn */.kg.warn('[Feedback] Browser does not support shadow DOM API');
    throw new Error('Browser does not support shadow DOM API.');
  }
}

/**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */
async function handleFeedbackSubmit(
  dialog,
  feedback,
  options,
) {
  if (!dialog) {
    // Not sure when this would happen
    return;
  }

  const showFetchError = () => {
    if (!dialog) {
      return;
    }
    dialog.showError('There was a problem submitting feedback, please wait and try again.');
  };

  dialog.hideError();

  try {
    const resp = await sendFeedback({ ...feedback, source: FEEDBACK_WIDGET_SOURCE }, options);

    // Success!
    return resp;
  } catch (err) {
    esm_DEBUG_BUILD && logger/* logger.error */.kg.error(err);
    showFetchError();
  }
}

/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */
function setAttributesNS(el, attributes) {
  Object.entries(attributes).forEach(([key, val]) => {
    el.setAttributeNS(null, key, val);
  });
  return el;
}

const SIZE = 20;
const XMLNS$2 = 'http://www.w3.org/2000/svg';

/**
 * Feedback Icon
 */
function Icon() {
  const createElementNS = (tagName) =>
    esm_WINDOW.document.createElementNS(XMLNS$2, tagName);
  const svg = setAttributesNS(createElementNS('svg'), {
    class: 'feedback-icon',
    width: `${SIZE}`,
    height: `${SIZE}`,
    viewBox: `0 0 ${SIZE} ${SIZE}`,
    fill: 'none',
  });

  const g = setAttributesNS(createElementNS('g'), {
    clipPath: 'url(#clip0_57_80)',
  });

  const path = setAttributesNS(createElementNS('path'), {
    ['fill-rule']: 'evenodd',
    ['clip-rule']: 'evenodd',
    d: 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z',
  });
  svg.appendChild(g).appendChild(path);

  const speakerDefs = createElementNS('defs');
  const speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
    id: 'clip0_57_80',
  });

  const speakerRect = setAttributesNS(createElementNS('rect'), {
    width: `${SIZE}`,
    height: `${SIZE}`,
    fill: 'white',
  });

  speakerClipPathDef.appendChild(speakerRect);
  speakerDefs.appendChild(speakerClipPathDef);

  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);

  return {
    get el() {
      return svg;
    },
  };
}

/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */
function createElement(
  tagName,
  attributes,
  ...children
) {
  const doc = esm_WINDOW.document;
  const element = doc.createElement(tagName);

  if (attributes) {
    Object.entries(attributes).forEach(([attribute, attributeValue]) => {
      if (attribute === 'className' && typeof attributeValue === 'string') {
        // JSX does not allow class as a valid name
        element.setAttribute('class', attributeValue);
      } else if (typeof attributeValue === 'boolean' && attributeValue) {
        element.setAttribute(attribute, '');
      } else if (typeof attributeValue === 'string') {
        element.setAttribute(attribute, attributeValue);
      } else if (attribute.startsWith('on') && typeof attributeValue === 'function') {
        element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
      }
    });
  }
  for (const child of children) {
    appendChild(element, child);
  }

  return element;
}

function appendChild(parent, child) {
  const doc = esm_WINDOW.document;
  if (typeof child === 'undefined' || child === null) {
    return;
  }

  if (Array.isArray(child)) {
    for (const value of child) {
      appendChild(parent, value);
    }
  } else if (child === false) ; else if (typeof child === 'string') {
    parent.appendChild(doc.createTextNode(child));
  } else if (child instanceof Node) {
    parent.appendChild(child);
  } else {
    parent.appendChild(doc.createTextNode(String(child)));
  }
}

/**
 *
 */
function Actor({ buttonLabel, onClick }) {
  function _handleClick(e) {
    onClick && onClick(e);
  }

  const el = createElement(
    'button',
    {
      type: 'button',
      className: 'widget__actor',
      ['aria-label']: buttonLabel,
      ['aria-hidden']: 'false',
    },
    Icon().el,
    buttonLabel
      ? createElement(
          'span',
          {
            className: 'widget__actor__text',
          },
          buttonLabel,
        )
      : null,
  );

  el.addEventListener('click', _handleClick);

  return {
    get el() {
      return el;
    },
    show: () => {
      el.classList.remove('widget__actor--hidden');
      el.setAttribute('aria-hidden', 'false');
    },
    hide: () => {
      el.classList.add('widget__actor--hidden');
      el.setAttribute('aria-hidden', 'true');
    },
  };
}

/**
 *
 */
function SubmitButton({ label }) {
  const el = createElement(
    'button',
    {
      type: 'submit',
      className: 'btn btn--primary',
      ['aria-label']: label,
    },
    label,
  );

  return {
    el,
  };
}

function retrieveStringValue(formData, key) {
  const value = formData.get(key);
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
}

/**
 * Creates the form element
 */
function Form({
  nameLabel,
  namePlaceholder,
  emailLabel,
  emailPlaceholder,
  messageLabel,
  messagePlaceholder,
  isRequiredLabel,
  cancelButtonLabel,
  submitButtonLabel,

  showName,
  showEmail,
  isNameRequired,
  isEmailRequired,

  defaultName,
  defaultEmail,
  onCancel,
  onSubmit,
}) {
  const { el: submitEl } = SubmitButton({
    label: submitButtonLabel,
  });

  function handleSubmit(e) {
    e.preventDefault();

    if (!(e.target instanceof HTMLFormElement)) {
      return;
    }

    try {
      if (onSubmit) {
        const formData = new FormData(e.target );
        const feedback = {
          name: retrieveStringValue(formData, 'name'),
          email: retrieveStringValue(formData, 'email'),
          message: retrieveStringValue(formData, 'message'),
        };

        onSubmit(feedback);
      }
    } catch (e2) {
      // pass
    }
  }

  const errorEl = createElement('div', {
    className: 'form__error-container form__error-container--hidden',
    ['aria-hidden']: 'true',
  });

  function showError(message) {
    errorEl.textContent = message;
    errorEl.classList.remove('form__error-container--hidden');
    errorEl.setAttribute('aria-hidden', 'false');
  }

  function hideError() {
    errorEl.textContent = '';
    errorEl.classList.add('form__error-container--hidden');
    errorEl.setAttribute('aria-hidden', 'true');
  }

  const nameEl = createElement('input', {
    id: 'name',
    type: showName ? 'text' : 'hidden',
    ['aria-hidden']: showName ? 'false' : 'true',
    name: 'name',
    required: isNameRequired,
    className: 'form__input',
    placeholder: namePlaceholder,
    value: defaultName,
  });

  const emailEl = createElement('input', {
    id: 'email',
    type: showEmail ? 'text' : 'hidden',
    ['aria-hidden']: showEmail ? 'false' : 'true',
    name: 'email',
    required: isEmailRequired,
    className: 'form__input',
    placeholder: emailPlaceholder,
    value: defaultEmail,
  });

  const messageEl = createElement('textarea', {
    id: 'message',
    autoFocus: 'true',
    rows: '5',
    name: 'message',
    required: true,
    className: 'form__input form__input--textarea',
    placeholder: messagePlaceholder,
  });

  const cancelEl = createElement(
    'button',
    {
      type: 'button',
      className: 'btn btn--default',
      ['aria-label']: cancelButtonLabel,
      onClick: (e) => {
        onCancel && onCancel(e);
      },
    },
    cancelButtonLabel,
  );

  const formEl = createElement(
    'form',
    {
      className: 'form',
      onSubmit: handleSubmit,
    },
    [
      errorEl,

      showName &&
        createElement(
          'label',
          {
            htmlFor: 'name',
            className: 'form__label',
          },
          [
            createElement(
              'span',
              { className: 'form__label__text' },
              nameLabel,
              isNameRequired &&
                createElement('span', { className: 'form__label__text--required' }, ` ${isRequiredLabel}`),
            ),
            nameEl,
          ],
        ),
      !showName && nameEl,

      showEmail &&
        createElement(
          'label',
          {
            htmlFor: 'email',
            className: 'form__label',
          },
          [
            createElement(
              'span',
              { className: 'form__label__text' },
              emailLabel,
              isEmailRequired &&
                createElement('span', { className: 'form__label__text--required' }, ` ${isRequiredLabel}`),
            ),
            emailEl,
          ],
        ),
      !showEmail && emailEl,

      createElement(
        'label',
        {
          htmlFor: 'message',
          className: 'form__label',
        },
        [
          createElement(
            'span',
            { className: 'form__label__text' },
            messageLabel,
            createElement('span', { className: 'form__label__text--required' }, ` ${isRequiredLabel}`),
          ),
          messageEl,
        ],
      ),

      createElement(
        'div',
        {
          className: 'btn-group',
        },
        [submitEl, cancelEl],
      ),
    ],
  );

  return {
    get el() {
      return formEl;
    },
    showError,
    hideError,
  };
}

const XMLNS$1 = 'http://www.w3.org/2000/svg';

/**
 * Sentry Logo
 */
function Logo({ colorScheme }) {
  const createElementNS = (tagName) =>
    esm_WINDOW.document.createElementNS(XMLNS$1, tagName);
  const svg = setAttributesNS(createElementNS('svg'), {
    class: 'sentry-logo',
    width: '32',
    height: '30',
    viewBox: '0 0 72 66',
    fill: 'none',
  });

  const path = setAttributesNS(createElementNS('path'), {
    transform: 'translate(11, 11)',
    d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z',
  });
  svg.append(path);

  const defs = createElementNS('defs');
  const style = createElementNS('style');

  style.textContent = `
    path {
      fill: ${colorScheme === 'dark' ? '#fff' : '#362d59'};
    }`;

  if (colorScheme === 'system') {
    style.textContent += `
    @media (prefers-color-scheme: dark) {
      path: {
        fill: '#fff';
      }
    }
    `;
  }

  defs.append(style);
  svg.append(defs);

  return {
    get el() {
      return svg;
    },
  };
}

/**
 * Feedback dialog component that has the form
 */
function Dialog({
  formTitle,
  showBranding,
  showName,
  showEmail,
  isNameRequired,
  isEmailRequired,
  colorScheme,
  defaultName,
  defaultEmail,
  onClosed,
  onCancel,
  onSubmit,
  ...textLabels
}) {
  let el = null;

  /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */
  function handleDialogClick() {
    close();

    // Only this should trigger `onClose`, we don't want the `close()` method to
    // trigger it, otherwise it can cause cycles.
    onClosed && onClosed();
  }

  /**
   * Close the dialog
   */
  function close() {
    if (el) {
      el.open = false;
    }
  }

  /**
   * Opens the dialog
   */
  function open() {
    if (el) {
      el.open = true;
    }
  }

  /**
   * Check if dialog is currently opened
   */
  function checkIsOpen() {
    return (el && el.open === true) || false;
  }

  const {
    el: formEl,
    showError,
    hideError,
  } = Form({
    showEmail,
    showName,
    isEmailRequired,
    isNameRequired,

    defaultName,
    defaultEmail,
    onSubmit,
    onCancel,
    ...textLabels,
  });

  el = createElement(
    'dialog',
    {
      className: 'dialog',
      open: true,
      onClick: handleDialogClick,
    },
    createElement(
      'div',
      {
        className: 'dialog__content',
        onClick: e => {
          // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
          e.stopPropagation();
        },
      },
      createElement(
        'h2',
        { className: 'dialog__header' },
        formTitle,
        showBranding &&
          createElement(
            'a',
            {
              className: 'brand-link',
              target: '_blank',
              href: 'https://sentry.io/welcome/',
              title: 'Powered by Sentry',
              rel: 'noopener noreferrer',
            },
            Logo({ colorScheme }).el,
          ),
      ),
      formEl,
    ),
  );

  return {
    get el() {
      return el;
    },
    showError,
    hideError,
    open,
    close,
    checkIsOpen,
  };
}

const WIDTH = 16;
const HEIGHT = 17;
const XMLNS = 'http://www.w3.org/2000/svg';

/**
 * Success Icon (checkmark)
 */
function SuccessIcon() {
  const createElementNS = (tagName) =>
    esm_WINDOW.document.createElementNS(XMLNS, tagName);
  const svg = setAttributesNS(createElementNS('svg'), {
    class: 'success-icon',
    width: `${WIDTH}`,
    height: `${HEIGHT}`,
    viewBox: `0 0 ${WIDTH} ${HEIGHT}`,
    fill: 'none',
  });

  const g = setAttributesNS(createElementNS('g'), {
    clipPath: 'url(#clip0_57_156)',
  });

  const path2 = setAttributesNS(createElementNS('path'), {
    ['fill-rule']: 'evenodd',
    ['clip-rule']: 'evenodd',
    d: 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z',
  });
  const path = setAttributesNS(createElementNS('path'), {
    d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z',
  });

  svg.appendChild(g).append(path, path2);

  const speakerDefs = createElementNS('defs');
  const speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
    id: 'clip0_57_156',
  });

  const speakerRect = setAttributesNS(createElementNS('rect'), {
    width: `${WIDTH}`,
    height: `${WIDTH}`,
    fill: 'white',
    transform: 'translate(0 0.5)',
  });

  speakerClipPathDef.appendChild(speakerRect);
  speakerDefs.appendChild(speakerClipPathDef);

  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);

  return {
    get el() {
      return svg;
    },
  };
}

/**
 * Feedback dialog component that has the form
 */
function SuccessMessage({ message, onRemove }) {
  function remove() {
    if (!el) {
      return;
    }

    el.remove();
    onRemove && onRemove();
  }

  const el = createElement(
    'div',
    {
      className: 'success-message',
      onClick: remove,
    },
    SuccessIcon().el,
    message,
  );

  return {
    el,
    remove,
  };
}

/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */
function createWidget({
  shadow,
  options: { shouldCreateActor = true, ...options },
  attachTo,
}) {
  let actor;
  let dialog;
  let isDialogOpen = false;

  /**
   * Show the success message for 5 seconds
   */
  function showSuccessMessage() {
    if (!shadow) {
      return;
    }

    try {
      const success = SuccessMessage({
        message: options.successMessageText,
        onRemove: () => {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          showActor();
        },
      });

      if (!success.el) {
        throw new Error('Unable to show success message');
      }

      shadow.appendChild(success.el);

      const timeoutId = setTimeout(() => {
        if (success) {
          success.remove();
        }
      }, 5000);
    } catch (err) {
      // TODO: error handling
      logger/* logger.error */.kg.error(err);
    }
  }

  /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */
  async function _handleFeedbackSubmit(feedback) {
    if (!dialog) {
      return;
    }

    // Simple validation for now, just check for non-empty required fields
    const emptyField = [];
    if (options.isNameRequired && !feedback.name) {
      emptyField.push(options.nameLabel);
    }
    if (options.isEmailRequired && !feedback.email) {
      emptyField.push(options.emailLabel);
    }
    if (!feedback.message) {
      emptyField.push(options.messageLabel);
    }
    if (emptyField.length > 0) {
      dialog.showError(`Please enter in the following required fields: ${emptyField.join(', ')}`);
      return;
    }

    const result = await handleFeedbackSubmit(dialog, feedback);

    // Error submitting feedback
    if (!result) {
      if (options.onSubmitError) {
        options.onSubmitError();
      }

      return;
    }

    // Success
    removeDialog();
    showSuccessMessage();

    if (options.onSubmitSuccess) {
      options.onSubmitSuccess();
    }
  }

  /**
   * Internal handler when dialog is opened
   */
  function handleOpenDialog() {
    // Flush replay if integration exists
    const client = (0,esm_exports/* getClient */.s3)();
    const replay =
      client &&
      client.getIntegrationByName &&
      client.getIntegrationByName('Replay');
    if (!replay) {
      return;
    }
    replay.flush().catch(err => {
      esm_DEBUG_BUILD && logger/* logger.error */.kg.error(err);
    });
  }

  /**
   * Displays the default actor
   */
  function showActor() {
    actor && actor.show();
  }

  /**
   * Hides the default actor
   */
  function hideActor() {
    actor && actor.hide();
  }

  /**
   * Removes the default actor element
   */
  function removeActor() {
    actor && actor.el && actor.el.remove();
  }

  /**
   *
   */
  function openDialog() {
    try {
      if (dialog) {
        dialog.open();
        isDialogOpen = true;
        if (options.onFormOpen) {
          options.onFormOpen();
        }
        handleOpenDialog();
        return;
      }

      const userKey = options.useSentryUser;
      const scope = (0,esm_exports/* getCurrentScope */.nZ)();
      const user = scope && scope.getUser();

      dialog = Dialog({
        colorScheme: options.colorScheme,
        showBranding: options.showBranding,
        showName: options.showName || options.isNameRequired,
        showEmail: options.showEmail || options.isEmailRequired,
        isNameRequired: options.isNameRequired,
        isEmailRequired: options.isEmailRequired,
        formTitle: options.formTitle,
        cancelButtonLabel: options.cancelButtonLabel,
        submitButtonLabel: options.submitButtonLabel,
        emailLabel: options.emailLabel,
        emailPlaceholder: options.emailPlaceholder,
        messageLabel: options.messageLabel,
        messagePlaceholder: options.messagePlaceholder,
        nameLabel: options.nameLabel,
        namePlaceholder: options.namePlaceholder,
        isRequiredLabel: options.isRequiredLabel,
        defaultName: (userKey && user && user[userKey.name]) || '',
        defaultEmail: (userKey && user && user[userKey.email]) || '',
        onClosed: () => {
          showActor();
          isDialogOpen = false;

          if (options.onFormClose) {
            options.onFormClose();
          }
        },
        onCancel: () => {
          closeDialog();
          showActor();
        },
        onSubmit: _handleFeedbackSubmit,
      });

      if (!dialog.el) {
        throw new Error('Unable to open Feedback dialog');
      }

      shadow.appendChild(dialog.el);

      // Hides the default actor whenever dialog is opened
      hideActor();

      if (options.onFormOpen) {
        options.onFormOpen();
      }
      handleOpenDialog();
    } catch (err) {
      // TODO: Error handling?
      logger/* logger.error */.kg.error(err);
    }
  }

  /**
   * Closes the dialog
   */
  function closeDialog() {
    if (dialog) {
      dialog.close();
      isDialogOpen = false;

      if (options.onFormClose) {
        options.onFormClose();
      }
    }
  }

  /**
   * Removes the dialog element from DOM
   */
  function removeDialog() {
    if (dialog) {
      closeDialog();
      const dialogEl = dialog.el;
      dialogEl && dialogEl.remove();
      dialog = undefined;
    }
  }

  /**
   *
   */
  function handleActorClick() {
    // Open dialog
    if (!isDialogOpen) {
      openDialog();
    }

    // Hide actor button
    hideActor();
  }

  if (attachTo) {
    attachTo.addEventListener('click', handleActorClick);
  } else if (shouldCreateActor) {
    actor = Actor({ buttonLabel: options.buttonLabel, onClick: handleActorClick });
    actor.el && shadow.appendChild(actor.el);
  }

  return {
    get actor() {
      return actor;
    },
    get dialog() {
      return dialog;
    },

    showActor,
    hideActor,
    removeActor,

    openDialog,
    closeDialog,
    removeDialog,
  };
}

const doc = esm_WINDOW.document;

const feedbackIntegration = ((options) => {
  // eslint-disable-next-line deprecation/deprecation
  return new Feedback(options);
}) ;

/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */
class Feedback  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Feedback';}

  /**
   * @inheritDoc
   */

  /**
   * Feedback configuration options
   */

  /**
   * Reference to widget element that is created when autoInject is true
   */

  /**
   * List of all widgets that are created from the integration
   */

  /**
   * Reference to the host element where widget is inserted
   */

  /**
   * Refernce to Shadow DOM root
   */

  /**
   * Tracks if actor styles have ever been inserted into shadow DOM
   */

   constructor({
    autoInject = true,
    id = 'sentry-feedback',
    isEmailRequired = false,
    isNameRequired = false,
    showBranding = true,
    showEmail = true,
    showName = true,
    useSentryUser = {
      email: 'email',
      name: 'username',
    },

    themeDark,
    themeLight,
    colorScheme = 'system',

    buttonLabel = ACTOR_LABEL,
    cancelButtonLabel = CANCEL_BUTTON_LABEL,
    submitButtonLabel = SUBMIT_BUTTON_LABEL,
    formTitle = FORM_TITLE,
    emailPlaceholder = EMAIL_PLACEHOLDER,
    emailLabel = EMAIL_LABEL,
    messagePlaceholder = MESSAGE_PLACEHOLDER,
    messageLabel = MESSAGE_LABEL,
    namePlaceholder = NAME_PLACEHOLDER,
    nameLabel = NAME_LABEL,
    isRequiredLabel = IS_REQUIRED_LABEL,
    successMessageText = SUCCESS_MESSAGE_TEXT,

    onFormClose,
    onFormOpen,
    onSubmitError,
    onSubmitSuccess,
  } = {}) {
    // eslint-disable-next-line deprecation/deprecation
    this.name = Feedback.id;

    // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
    this._host = null;
    this._shadow = null;
    this._widget = null;
    this._widgets = new Set();
    this._hasInsertedActorStyles = false;

    this.options = {
      autoInject,
      showBranding,
      id,
      isEmailRequired,
      isNameRequired,
      showEmail,
      showName,
      useSentryUser,

      colorScheme,
      themeDark: {
        ...DEFAULT_THEME.dark,
        ...themeDark,
      },
      themeLight: {
        ...DEFAULT_THEME.light,
        ...themeLight,
      },

      buttonLabel,
      cancelButtonLabel,
      submitButtonLabel,
      formTitle,
      emailLabel,
      emailPlaceholder,
      messageLabel,
      messagePlaceholder,
      nameLabel,
      namePlaceholder,
      isRequiredLabel,
      successMessageText,

      onFormClose,
      onFormOpen,
      onSubmitError,
      onSubmitSuccess,
    };
  }

  /**
   * Setup and initialize feedback container
   */
   setupOnce() {
    if (!isBrowser()) {
      return;
    }

    try {
      this._cleanupWidgetIfExists();

      const { autoInject } = this.options;

      if (!autoInject) {
        // Nothing to do here
        return;
      }

      this._createWidget(this.options);
    } catch (err) {
      esm_DEBUG_BUILD && logger/* logger.error */.kg.error(err);
    }
  }

  /**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */
   openDialog() {
    if (!this._widget) {
      this._createWidget({ ...this.options, shouldCreateActor: false });
    }

    if (!this._widget) {
      return;
    }

    this._widget.openDialog();
  }

  /**
   * Closes the dialog for the default widget, if it exists
   */
   closeDialog() {
    if (!this._widget) {
      // Nothing to do if widget does not exist
      return;
    }

    this._widget.closeDialog();
  }

  /**
   * Adds click listener to attached element to open a feedback dialog
   */
   attachTo(el, optionOverrides) {
    try {
      const options = mergeOptions(this.options, optionOverrides || {});

      return this._ensureShadowHost(options, ({ shadow }) => {
        const targetEl =
          typeof el === 'string' ? doc.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;

        if (!targetEl) {
          esm_DEBUG_BUILD && logger/* logger.error */.kg.error('[Feedback] Unable to attach to target element');
          return null;
        }

        const widget = createWidget({ shadow, options, attachTo: targetEl });
        this._widgets.add(widget);

        if (!this._widget) {
          this._widget = widget;
        }

        return widget;
      });
    } catch (err) {
      esm_DEBUG_BUILD && logger/* logger.error */.kg.error(err);
      return null;
    }
  }

  /**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */
   createWidget(
    optionOverrides,
  ) {
    try {
      return this._createWidget(mergeOptions(this.options, optionOverrides || {}));
    } catch (err) {
      esm_DEBUG_BUILD && logger/* logger.error */.kg.error(err);
      return null;
    }
  }

  /**
   * Removes a single widget
   */
   removeWidget(widget) {
    if (!widget) {
      return false;
    }

    try {
      if (this._widgets.has(widget)) {
        widget.removeActor();
        widget.removeDialog();
        this._widgets.delete(widget);

        if (this._widget === widget) {
          // TODO: is more clean-up needed? e.g. call remove()
          this._widget = null;
        }

        return true;
      }
    } catch (err) {
      esm_DEBUG_BUILD && logger/* logger.error */.kg.error(err);
    }

    return false;
  }

  /**
   * Returns the default (first-created) widget
   */
   getWidget() {
    return this._widget;
  }

  /**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */
   remove() {
    if (this._host) {
      this._host.remove();
    }
    this._initialize();
  }

  /**
   * Initializes values of protected properties
   */
   _initialize() {
    this._host = null;
    this._shadow = null;
    this._widget = null;
    this._widgets = new Set();
    this._hasInsertedActorStyles = false;
  }

  /**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */
   _cleanupWidgetIfExists() {
    if (this._host) {
      this.remove();
    }
    const existingFeedback = doc.querySelector(`#${this.options.id}`);
    if (existingFeedback) {
      existingFeedback.remove();
    }
  }

  /**
   * Creates a new widget, after ensuring shadow DOM exists
   */
   _createWidget(options) {
    return this._ensureShadowHost(options, ({ shadow }) => {
      const widget = createWidget({ shadow, options });

      if (!this._hasInsertedActorStyles && widget.actor) {
        shadow.appendChild(createActorStyles(doc));
        this._hasInsertedActorStyles = true;
      }

      this._widgets.add(widget);

      if (!this._widget) {
        this._widget = widget;
      }

      return widget;
    });
  }

  /**
   * Ensures that shadow DOM exists and is added to the DOM
   */
   _ensureShadowHost(
    options,
    cb,
  ) {
    let needsAppendHost = false;

    // Don't create if it already exists
    if (!this._shadow || !this._host) {
      const { id, colorScheme, themeLight, themeDark } = options;
      const { shadow, host } = createShadowHost({
        id,
        colorScheme,
        themeLight,
        themeDark,
      });
      this._shadow = shadow;
      this._host = host;
      needsAppendHost = true;
    }

    // set data attribute on host for different themes
    this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;

    const result = cb({ shadow: this._shadow, host: this._host });

    if (needsAppendHost) {
      doc.body.appendChild(this._host);
    }

    return result;
  }
} Feedback.__initStatic();


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/console.js
var instrument_console = __webpack_require__(17149);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/severity.js
var severity = __webpack_require__(32798);
;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/captureconsole.js



const captureconsole_INTEGRATION_NAME = 'CaptureConsole';

const _captureConsoleIntegration = ((options = {}) => {
  const levels = options.levels || logger/* CONSOLE_LEVELS */.RU;

  return {
    name: captureconsole_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      if (!('console' in worldwide/* GLOBAL_OBJ */.n2)) {
        return;
      }

      (0,instrument_console/* addConsoleInstrumentationHandler */.e)(({ args, level }) => {
        if ((0,esm_exports/* getClient */.s3)() !== client || !levels.includes(level)) {
          return;
        }

        consoleHandler(args, level);
      });
    },
  };
}) ;

const captureConsoleIntegration = (0,integration/* defineIntegration */._I)(_captureConsoleIntegration);

/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const CaptureConsole = (0,integration/* convertIntegrationFnToClass */.RN)(
  captureconsole_INTEGRATION_NAME,
  captureConsoleIntegration,
)

;

function consoleHandler(args, level) {
  const captureContext = {
    level: (0,severity/* severityLevelFromString */.VT)(level),
    extra: {
      arguments: args,
    },
  };

  (0,esm_exports/* withScope */.$e)(scope => {
    scope.addEventProcessor(event => {
      event.logger = 'console';

      (0,misc/* addExceptionMechanism */.EG)(event, {
        handled: false,
        type: 'console',
      });

      return event;
    });

    if (level === 'assert' && args[0] === false) {
      const message = `Assertion failed: ${(0,string/* safeJoin */.nK)(args.slice(1), ' ') || 'console.assert'}`;
      scope.setExtra('arguments', args.slice(1));
      (0,esm_exports/* captureMessage */.uT)(message, captureContext);
      return;
    }

    const error = args.find(arg => arg instanceof Error);
    if (level === 'error' && error) {
      (0,esm_exports/* captureException */.Tb)(error, captureContext);
      return;
    }

    const message = (0,string/* safeJoin */.nK)(args, ' ');
    (0,esm_exports/* captureMessage */.uT)(message, captureContext);
  });
}


//# sourceMappingURL=captureconsole.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(84808);
;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/contextlines.js



const contextlines_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const DEFAULT_LINES_OF_CONTEXT = 7;

const contextlines_INTEGRATION_NAME = 'ContextLines';

const _contextLinesIntegration = ((options = {}) => {
  const contextLines = options.frameContextLines != null ? options.frameContextLines : DEFAULT_LINES_OF_CONTEXT;

  return {
    name: contextlines_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event) {
      return addSourceContext(event, contextLines);
    },
  };
}) ;

const contextLinesIntegration = (0,integration/* defineIntegration */._I)(_contextLinesIntegration);

/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const ContextLines = (0,integration/* convertIntegrationFnToClass */.RN)(contextlines_INTEGRATION_NAME, contextLinesIntegration)

;

/**
 * Processes an event and adds context lines.
 */
function addSourceContext(event, contextLines) {
  const doc = contextlines_WINDOW.document;
  const htmlFilename = contextlines_WINDOW.location && (0,url/* stripUrlQueryAndFragment */.rt)(contextlines_WINDOW.location.href);
  if (!doc || !htmlFilename) {
    return event;
  }

  const exceptions = event.exception && event.exception.values;
  if (!exceptions || !exceptions.length) {
    return event;
  }

  const html = doc.documentElement.innerHTML;
  if (!html) {
    return event;
  }

  const htmlLines = ['<!DOCTYPE html>', '<html>', ...html.split('\n'), '</html>'];

  exceptions.forEach(exception => {
    const stacktrace = exception.stacktrace;
    if (stacktrace && stacktrace.frames) {
      stacktrace.frames = stacktrace.frames.map(frame =>
        applySourceContextToFrame(frame, htmlLines, htmlFilename, contextLines),
      );
    }
  });

  return event;
}

/**
 * Only exported for testing
 */
function applySourceContextToFrame(
  frame,
  htmlLines,
  htmlFilename,
  linesOfContext,
) {
  if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) {
    return frame;
  }

  (0,misc/* addContextToFrame */.go)(htmlLines, frame, linesOfContext);

  return frame;
}


//# sourceMappingURL=contextlines.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/debug.js



const debug_INTEGRATION_NAME = 'Debug';

const _debugIntegration = ((options = {}) => {
  const _options = {
    debugger: false,
    stringify: false,
    ...options,
  };

  return {
    name: debug_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      if (!client.on) {
        return;
      }

      client.on('beforeSendEvent', (event, hint) => {
        if (_options.debugger) {
          // eslint-disable-next-line no-debugger
          debugger;
        }

        /* eslint-disable no-console */
        (0,logger/* consoleSandbox */.Cf)(() => {
          if (_options.stringify) {
            console.log(JSON.stringify(event, null, 2));
            if (hint && Object.keys(hint).length) {
              console.log(JSON.stringify(hint, null, 2));
            }
          } else {
            console.log(event);
            if (hint && Object.keys(hint).length) {
              console.log(hint);
            }
          }
        });
        /* eslint-enable no-console */
      });
    },
  };
}) ;

const debugIntegration = (0,integration/* defineIntegration */._I)(_debugIntegration);

/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Debug = (0,integration/* convertIntegrationFnToClass */.RN)(debug_INTEGRATION_NAME, debugIntegration)

;


//# sourceMappingURL=debug.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const debug_build_DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/dedupe.js




const dedupe_INTEGRATION_NAME = 'Dedupe';

const _dedupeIntegration = (() => {
  let previousEvent;

  return {
    name: dedupe_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(currentEvent) {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      // Juuust in case something goes wrong
      try {
        if (_shouldDropEvent(currentEvent, previousEvent)) {
          debug_build_DEBUG_BUILD && logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
          return null;
        }
      } catch (_oO) {} // eslint-disable-line no-empty

      return (previousEvent = currentEvent);
    },
  };
}) ;

const dedupeIntegration = (0,integration/* defineIntegration */._I)(_dedupeIntegration);

/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Dedupe = (0,integration/* convertIntegrationFnToClass */.RN)(dedupe_INTEGRATION_NAME, dedupeIntegration)

;

/** only exported for tests. */
function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-expect-error Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(48593);
;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/extraerrordata.js




const extraerrordata_INTEGRATION_NAME = 'ExtraErrorData';

const _extraErrorDataIntegration = ((options = {}) => {
  const depth = options.depth || 3;

  // TODO(v8): Flip the default for this option to true
  const captureErrorCause = options.captureErrorCause || false;

  return {
    name: extraerrordata_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event, hint) {
      return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
    },
  };
}) ;

const extraErrorDataIntegration = (0,integration/* defineIntegration */._I)(_extraErrorDataIntegration);

/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const ExtraErrorData = (0,integration/* convertIntegrationFnToClass */.RN)(
  extraerrordata_INTEGRATION_NAME,
  extraErrorDataIntegration,
)

;

function _enhanceEventWithErrorData(
  event,
  hint = {},
  depth,
  captureErrorCause,
) {
  if (!hint.originalException || !(0,is/* isError */.VZ)(hint.originalException)) {
    return event;
  }
  const exceptionName = (hint.originalException ).name || hint.originalException.constructor.name;

  const errorData = _extractErrorData(hint.originalException , captureErrorCause);

  if (errorData) {
    const contexts = {
      ...event.contexts,
    };

    const normalizedErrorData = (0,normalize/* normalize */.Fv)(errorData, depth);

    if ((0,is/* isPlainObject */.PO)(normalizedErrorData)) {
      // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
      // potentially truncate the data we just already normalized, with a certain depth setting.
      (0,object/* addNonEnumerableProperty */.xp)(normalizedErrorData, '__sentry_skip_normalization__', true);
      contexts[exceptionName] = normalizedErrorData;
    }

    return {
      ...event,
      contexts,
    };
  }

  return event;
}

/**
 * Extract extra information from the Error object
 */
function _extractErrorData(error, captureErrorCause) {
  // We are trying to enhance already existing event, so no harm done if it won't succeed
  try {
    const nativeKeys = [
      'name',
      'message',
      'stack',
      'line',
      'column',
      'fileName',
      'lineNumber',
      'columnNumber',
      'toJSON',
    ];

    const extraErrorInfo = {};

    // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
    for (const key of Object.keys(error)) {
      if (nativeKeys.indexOf(key) !== -1) {
        continue;
      }
      const value = error[key];
      extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
    }

    // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
    if (captureErrorCause && error.cause !== undefined) {
      extraErrorInfo.cause = (0,is/* isError */.VZ)(error.cause) ? error.cause.toString() : error.cause;
    }

    // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
    if (typeof error.toJSON === 'function') {
      const serializedError = error.toJSON() ;

      for (const key of Object.keys(serializedError)) {
        const value = serializedError[key];
        extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
      }
    }

    return extraErrorInfo;
  } catch (oO) {
    debug_build_DEBUG_BUILD && logger/* logger.error */.kg.error('Unable to extract extra data from the Error object:', oO);
  }

  return null;
}


//# sourceMappingURL=extraerrordata.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(10264);
;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/httpclient.js




const httpclient_INTEGRATION_NAME = 'HttpClient';

const _httpClientIntegration = ((options = {}) => {
  const _options = {
    failedRequestStatusCodes: [[500, 599]],
    failedRequestTargets: [/.*/],
    ...options,
  };

  return {
    name: httpclient_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      _wrapFetch(client, _options);
      _wrapXHR(client, _options);
    },
  };
}) ;

const httpClientIntegration = (0,integration/* defineIntegration */._I)(_httpClientIntegration);

/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const HttpClient = (0,integration/* convertIntegrationFnToClass */.RN)(httpclient_INTEGRATION_NAME, httpClientIntegration)

;

/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */
function _fetchResponseHandler(
  options,
  requestInfo,
  response,
  requestInit,
) {
  if (_shouldCaptureResponse(options, response.status, response.url)) {
    const request = _getRequest(requestInfo, requestInit);

    let requestHeaders, responseHeaders, requestCookies, responseCookies;

    if (_shouldSendDefaultPii()) {
      [{ headers: requestHeaders, cookies: requestCookies }, { headers: responseHeaders, cookies: responseCookies }] = [
        { cookieHeader: 'Cookie', obj: request },
        { cookieHeader: 'Set-Cookie', obj: response },
      ].map(({ cookieHeader, obj }) => {
        const headers = _extractFetchHeaders(obj.headers);
        let cookies;

        try {
          const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;

          if (cookieString) {
            cookies = _parseCookieString(cookieString);
          }
        } catch (e) {
          debug_build_DEBUG_BUILD && logger/* logger.log */.kg.log(`Could not extract cookies from header ${cookieHeader}`);
        }

        return {
          headers,
          cookies,
        };
      });
    }

    const event = _createEvent({
      url: request.url,
      method: request.method,
      status: response.status,
      requestHeaders,
      responseHeaders,
      requestCookies,
      responseCookies,
    });

    (0,esm_exports/* captureEvent */.eN)(event);
  }
}

/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */
function _xhrResponseHandler(
  options,
  xhr,
  method,
  headers,
) {
  if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
    let requestHeaders, responseCookies, responseHeaders;

    if (_shouldSendDefaultPii()) {
      try {
        const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;

        if (cookieString) {
          responseCookies = _parseCookieString(cookieString);
        }
      } catch (e) {
        debug_build_DEBUG_BUILD && logger/* logger.log */.kg.log('Could not extract cookies from response headers');
      }

      try {
        responseHeaders = _getXHRResponseHeaders(xhr);
      } catch (e) {
        debug_build_DEBUG_BUILD && logger/* logger.log */.kg.log('Could not extract headers from response');
      }

      requestHeaders = headers;
    }

    const event = _createEvent({
      url: xhr.responseURL,
      method,
      status: xhr.status,
      requestHeaders,
      // Can't access request cookies from XHR
      responseHeaders,
      responseCookies,
    });

    (0,esm_exports/* captureEvent */.eN)(event);
  }
}

/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */
function _getResponseSizeFromHeaders(headers) {
  if (headers) {
    const contentLength = headers['Content-Length'] || headers['content-length'];

    if (contentLength) {
      return parseInt(contentLength, 10);
    }
  }

  return undefined;
}

/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */
function _parseCookieString(cookieString) {
  return cookieString.split('; ').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = value;
    return acc;
  }, {});
}

/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */
function _extractFetchHeaders(headers) {
  const result = {};

  headers.forEach((value, key) => {
    result[key] = value;
  });

  return result;
}

/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */
function _getXHRResponseHeaders(xhr) {
  const headers = xhr.getAllResponseHeaders();

  if (!headers) {
    return {};
  }

  return headers.split('\r\n').reduce((acc, line) => {
    const [key, value] = line.split(': ');
    acc[key] = value;
    return acc;
  }, {});
}

/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */
function _isInGivenRequestTargets(
  failedRequestTargets,
  target,
) {
  return failedRequestTargets.some((givenRequestTarget) => {
    if (typeof givenRequestTarget === 'string') {
      return target.includes(givenRequestTarget);
    }

    return givenRequestTarget.test(target);
  });
}

/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */
function _isInGivenStatusRanges(
  failedRequestStatusCodes,
  status,
) {
  return failedRequestStatusCodes.some((range) => {
    if (typeof range === 'number') {
      return range === status;
    }

    return status >= range[0] && status <= range[1];
  });
}

/**
 * Wraps `fetch` function to capture request and response data
 */
function _wrapFetch(client, options) {
  if (!(0,supports/* supportsNativeFetch */.t$)()) {
    return;
  }

  (0,instrument_fetch/* addFetchInstrumentationHandler */.U)(handlerData => {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const { response, args } = handlerData;
    const [requestInfo, requestInit] = args ;

    if (!response) {
      return;
    }

    _fetchResponseHandler(options, requestInfo, response , requestInit);
  });
}

/**
 * Wraps XMLHttpRequest to capture request and response data
 */
function _wrapXHR(client, options) {
  if (!('XMLHttpRequest' in worldwide/* GLOBAL_OBJ */.n2)) {
    return;
  }

  (0,instrument_xhr/* addXhrInstrumentationHandler */.UK)(handlerData => {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const xhr = handlerData.xhr ;

    const sentryXhrData = xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];

    if (!sentryXhrData) {
      return;
    }

    const { method, request_headers: headers } = sentryXhrData;

    try {
      _xhrResponseHandler(options, xhr, method, headers);
    } catch (e) {
      debug_build_DEBUG_BUILD && logger/* logger.warn */.kg.warn('Error while extracting response event form XHR response', e);
    }
  });
}

/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */
function _shouldCaptureResponse(options, status, url) {
  return (
    _isInGivenStatusRanges(options.failedRequestStatusCodes, status) &&
    _isInGivenRequestTargets(options.failedRequestTargets, url) &&
    !isSentryRequestUrl(url, (0,esm_exports/* getClient */.s3)())
  );
}

/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */
function _createEvent(data

) {
  const message = `HTTP Client Error with status code: ${data.status}`;

  const event = {
    message,
    exception: {
      values: [
        {
          type: 'Error',
          value: message,
        },
      ],
    },
    request: {
      url: data.url,
      method: data.method,
      headers: data.requestHeaders,
      cookies: data.requestCookies,
    },
    contexts: {
      response: {
        status_code: data.status,
        headers: data.responseHeaders,
        cookies: data.responseCookies,
        body_size: _getResponseSizeFromHeaders(data.responseHeaders),
      },
    },
  };

  (0,misc/* addExceptionMechanism */.EG)(event, {
    type: 'http.client',
    handled: false,
  });

  return event;
}

function _getRequest(requestInfo, requestInit) {
  if (!requestInit && requestInfo instanceof Request) {
    return requestInfo;
  }

  // If both are set, we try to construct a new Request with the given arguments
  // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
  // In this case, as a fallback, we just use the original request - using both is rather an edge case
  if (requestInfo instanceof Request && requestInfo.bodyUsed) {
    return requestInfo;
  }

  return new Request(requestInfo, requestInit);
}

function _shouldSendDefaultPii() {
  const client = (0,esm_exports/* getClient */.s3)();
  return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}


//# sourceMappingURL=httpclient.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/reportingobserver.js



const reportingobserver_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const reportingobserver_INTEGRATION_NAME = 'ReportingObserver';

const SETUP_CLIENTS = new WeakMap();

const _reportingObserverIntegration = ((options = {}) => {
  const types = options.types || ['crash', 'deprecation', 'intervention'];

  /** Handler for the reporting observer. */
  function handler(reports) {
    if (!SETUP_CLIENTS.has((0,esm_exports/* getClient */.s3)() )) {
      return;
    }

    for (const report of reports) {
      (0,esm_exports/* withScope */.$e)(scope => {
        scope.setExtra('url', report.url);

        const label = `ReportingObserver [${report.type}]`;
        let details = 'No details available';

        if (report.body) {
          // Object.keys doesn't work on ReportBody, as all properties are inheirted
          const plainBody

 = {};

          // eslint-disable-next-line guard-for-in
          for (const prop in report.body) {
            plainBody[prop] = report.body[prop];
          }

          scope.setExtra('body', plainBody);

          if (report.type === 'crash') {
            const body = report.body ;
            // A fancy way to create a message out of crashId OR reason OR both OR fallback
            details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
          } else {
            const body = report.body ;
            details = body.message || details;
          }
        }

        (0,esm_exports/* captureMessage */.uT)(`${label}: ${details}`);
      });
    }
  }

  return {
    name: reportingobserver_INTEGRATION_NAME,
    setupOnce() {
      if (!(0,supports/* supportsReportingObserver */.zb)()) {
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      const observer = new (reportingobserver_WINDOW ).ReportingObserver(handler, {
        buffered: true,
        types,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      observer.observe();
    },

    setup(client) {
      SETUP_CLIENTS.set(client, true);
    },
  };
}) ;

const reportingObserverIntegration = (0,integration/* defineIntegration */._I)(_reportingObserverIntegration);

/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const ReportingObserver = (0,integration/* convertIntegrationFnToClass */.RN)(
  reportingobserver_INTEGRATION_NAME,
  reportingObserverIntegration,
)

;


//# sourceMappingURL=reportingobserver.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/sessiontiming.js


const sessiontiming_INTEGRATION_NAME = 'SessionTiming';

const _sessionTimingIntegration = (() => {
  const startTime = Date.now();

  return {
    name: sessiontiming_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event) {
      const now = Date.now();

      return {
        ...event,
        extra: {
          ...event.extra,
          ['session:start']: startTime,
          ['session:duration']: now - startTime,
          ['session:end']: now,
        },
      };
    },
  };
}) ;

const sessionTimingIntegration = (0,integration/* defineIntegration */._I)(_sessionTimingIntegration);

/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const SessionTiming = (0,integration/* convertIntegrationFnToClass */.RN)(
  sessiontiming_INTEGRATION_NAME,
  sessionTimingIntegration,
) ;


//# sourceMappingURL=sessiontiming.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/request.js + 1 modules
var request = __webpack_require__(79727);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js
var browserTracingIntegration = __webpack_require__(46136);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/offline.js



const MIN_DELAY = 100; // 100 ms
const START_DELAY = 5000; // 5 seconds
const MAX_DELAY = 3.6e6; // 1 hour

function log(msg, error) {
  debug_build/* DEBUG_BUILD */.X && logger/* logger.info */.kg.info(`[Offline]: ${msg}`, error);
}

/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */
function makeOfflineTransport(
  createTransport,
) {
  return options => {
    const transport = createTransport(options);
    const store = options.createStore ? options.createStore(options) : undefined;

    let retryDelay = START_DELAY;
    let flushTimer;

    function shouldQueue(env, error, retryDelay) {
      // We don't queue Session Replay envelopes because they are:
      // - Ordered and Replay relies on the response status to know when they're successfully sent.
      // - Likely to fill the queue quickly and block other events from being sent.
      // We also want to drop client reports because they can be generated when we retry sending events while offline.
      if ((0,esm_envelope/* envelopeContainsItemType */.R)(env, ['replay_event', 'replay_recording', 'client_report'])) {
        return false;
      }

      if (options.shouldStore) {
        return options.shouldStore(env, error, retryDelay);
      }

      return true;
    }

    function flushIn(delay) {
      if (!store) {
        return;
      }

      if (flushTimer) {
        clearTimeout(flushTimer );
      }

      flushTimer = setTimeout(async () => {
        flushTimer = undefined;

        const found = await store.pop();
        if (found) {
          log('Attempting to send previously queued event');
          void send(found).catch(e => {
            log('Failed to retry sending', e);
          });
        }
      }, delay) ;

      // We need to unref the timer in node.js, otherwise the node process never exit.
      if (typeof flushTimer !== 'number' && flushTimer.unref) {
        flushTimer.unref();
      }
    }

    function flushWithBackOff() {
      if (flushTimer) {
        return;
      }

      flushIn(retryDelay);

      retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
    }

    async function send(envelope) {
      try {
        const result = await transport.send(envelope);

        let delay = MIN_DELAY;

        if (result) {
          // If there's a retry-after header, use that as the next delay.
          if (result.headers && result.headers['retry-after']) {
            delay = (0,ratelimit/* parseRetryAfterHeader */.JY)(result.headers['retry-after']);
          } // If we have a server error, return now so we don't flush the queue.
          else if ((result.statusCode || 0) >= 400) {
            return result;
          }
        }

        flushIn(delay);
        retryDelay = START_DELAY;
        return result;
      } catch (e) {
        if (store && (await shouldQueue(envelope, e , retryDelay))) {
          await store.insert(envelope);
          flushWithBackOff();
          log('Error sending. Event queued', e );
          return {};
        } else {
          throw e;
        }
      }
    }

    if (options.flushAtStartup) {
      flushWithBackOff();
    }

    return {
      send,
      flush: t => transport.flush(t),
    };
  };
}


//# sourceMappingURL=offline.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/offline.js



// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:

// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function promisifyRequest(request) {
  return new Promise((resolve, reject) => {
    // @ts-expect-error - file size hacks
    request.oncomplete = request.onsuccess = () => resolve(request.result);
    // @ts-expect-error - file size hacks
    request.onabort = request.onerror = () => reject(request.error);
  });
}

/** Create or open an IndexedDb store */
function createStore(dbName, storeName) {
  const request = indexedDB.open(dbName);
  request.onupgradeneeded = () => request.result.createObjectStore(storeName);
  const dbp = promisifyRequest(request);

  return callback => dbp.then(db => callback(db.transaction(storeName, 'readwrite').objectStore(storeName)));
}

function keys(store) {
  return promisifyRequest(store.getAllKeys() );
}

/** Insert into the store */
function insert(store, value, maxQueueSize) {
  return store(store => {
    return keys(store).then(keys => {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an incremented key so that the entries are popped in order
      store.put(value, Math.max(...keys, 0) + 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Pop the oldest value from the store */
function pop(store) {
  return store(store => {
    return keys(store).then(keys => {
      if (keys.length === 0) {
        return undefined;
      }

      return promisifyRequest(store.get(keys[0])).then(value => {
        store.delete(keys[0]);
        return promisifyRequest(store.transaction).then(() => value);
      });
    });
  });
}

function createIndexedDbStore(options) {
  let store;

  // Lazily create the store only when it's needed
  function getStore() {
    if (store == undefined) {
      store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
    }

    return store;
  }

  return {
    insert: async (env) => {
      try {
        const serialized = await (0,esm_envelope/* serializeEnvelope */.V$)(env, options.textEncoder);
        await insert(getStore(), serialized, options.maxQueueSize || 30);
      } catch (_) {
        //
      }
    },
    pop: async () => {
      try {
        const deserialized = await pop(getStore());
        if (deserialized) {
          return (0,esm_envelope/* parseEnvelope */.f4)(
            deserialized,
            options.textEncoder || new TextEncoder(),
            options.textDecoder || new TextDecoder(),
          );
        }
      } catch (_) {
        //
      }

      return undefined;
    },
  };
}

function makeIndexedDbOfflineTransport(
  createTransport,
) {
  return options => createTransport({ ...options, createStore: createIndexedDbStore });
}

/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */
function makeBrowserOfflineTransport(
  createTransport,
) {
  return makeIndexedDbOfflineTransport(makeOfflineTransport(createTransport));
}


//# sourceMappingURL=offline.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/debug-build.js
var esm_debug_build = __webpack_require__(71673);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(69356);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/profiling/utils.js





/* eslint-disable max-lines */

const MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const THREAD_ID_STRING = String(0);
const THREAD_NAME = 'main';

// Machine properties (eval only once)
let OS_PLATFORM = '';
let OS_PLATFORM_VERSION = '';
let OS_ARCH = '';
let OS_BROWSER = (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent) || '';
let OS_MODEL = '';
const OS_LOCALE =
  (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.language */.m9.navigator.language) ||
  (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.languages */.m9.navigator.languages && helpers/* WINDOW.navigator.languages.0 */.m9.navigator.languages[0]) ||
  '';

function isUserAgentData(data) {
  return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}

// @ts-expect-error userAgentData is not part of the navigator interface yet
const userAgentData = helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgentData */.m9.navigator.userAgentData;

if (isUserAgentData(userAgentData)) {
  userAgentData
    .getHighEntropyValues(['architecture', 'model', 'platform', 'platformVersion', 'fullVersionList'])
    .then((ua) => {
      OS_PLATFORM = ua.platform || '';
      OS_ARCH = ua.architecture || '';
      OS_MODEL = ua.model || '';
      OS_PLATFORM_VERSION = ua.platformVersion || '';

      if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
      }
    })
    .catch(e => void e);
}

function isProcessedJSSelfProfile(profile) {
  return !('thread_metadata' in profile);
}

// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */
function enrichWithThreadInformation(profile) {
  if (!isProcessedJSSelfProfile(profile)) {
    return profile;
  }

  return convertJSSelfProfileToSampledFormat(profile);
}

// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.

function getTraceId(event) {
  const traceId = event && event.contexts && event.contexts['trace'] && event.contexts['trace']['trace_id'];
  // Log a warning if the profile has an invalid traceId (should be uuidv4).
  // All profiles and transactions are rejected if this is the case and we want to
  // warn users that this is happening if they enable debug flag
  if (typeof traceId === 'string' && traceId.length !== 32) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
  }
  if (typeof traceId !== 'string') {
    return '';
  }

  return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */

/**
 * Creates a profiling event envelope from a Sentry event.
 */
function createProfilePayload(
  profile_id,
  start_timestamp,
  processed_profile,
  event,
) {
  if (event.type !== 'transaction') {
    // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
  }

  if (processed_profile === undefined || processed_profile === null) {
    throw new TypeError(
      `Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`,
    );
  }

  const traceId = getTraceId(event);
  const enrichedThreadProfile = enrichWithThreadInformation(processed_profile);
  const transactionStartMs = start_timestamp
    ? start_timestamp
    : typeof event.start_timestamp === 'number'
      ? event.start_timestamp * 1000
      : Date.now();
  const transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : Date.now();

  const profile = {
    event_id: profile_id,
    timestamp: new Date(transactionStartMs).toISOString(),
    platform: 'javascript',
    version: '1',
    release: event.release || '',
    environment: event.environment || constants/* DEFAULT_ENVIRONMENT */.J,
    runtime: {
      name: 'javascript',
      version: helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent,
    },
    os: {
      name: OS_PLATFORM,
      version: OS_PLATFORM_VERSION,
      build_number: OS_BROWSER,
    },
    device: {
      locale: OS_LOCALE,
      model: OS_MODEL,
      manufacturer: OS_BROWSER,
      architecture: OS_ARCH,
      is_emulator: false,
    },
    debug_meta: {
      images: applyDebugMetadata(processed_profile.resources),
    },
    profile: enrichedThreadProfile,
    transactions: [
      {
        name: event.transaction || '',
        id: event.event_id || (0,misc/* uuid4 */.DM)(),
        trace_id: traceId,
        active_thread_id: THREAD_ID_STRING,
        relative_start_ns: '0',
        relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0),
      },
    ],
  };

  return profile;
}

/*
  See packages/tracing-internal/src/browser/router.ts
*/
/**
 *
 */
function isAutomatedPageLoadTransaction(transaction) {
  return transaction.op === 'pageload';
}

/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */
function convertJSSelfProfileToSampledFormat(input) {
  let EMPTY_STACK_ID = undefined;
  let STACK_ID = 0;

  // Initialize the profile that we will fill with data
  const profile = {
    samples: [],
    stacks: [],
    frames: [],
    thread_metadata: {
      [THREAD_ID_STRING]: { name: THREAD_NAME },
    },
  };

  if (!input.samples.length) {
    return profile;
  }

  // We assert samples.length > 0 above and timestamp should always be present
  const start = input.samples[0].timestamp;
  // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
  // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
  // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
  // the drift between the SDK selected value and our profile time origin.
  const origin =
    typeof performance.timeOrigin === 'number' ? performance.timeOrigin : esm_time/* browserPerformanceTimeOrigin */.Z1 || 0;
  const adjustForOriginChange = origin - (esm_time/* browserPerformanceTimeOrigin */.Z1 || origin);

  for (let i = 0; i < input.samples.length; i++) {
    const jsSample = input.samples[i];

    // If sample has no stack, add an empty sample
    if (jsSample.stackId === undefined) {
      if (EMPTY_STACK_ID === undefined) {
        EMPTY_STACK_ID = STACK_ID;
        profile.stacks[EMPTY_STACK_ID] = [];
        STACK_ID++;
      }

      profile['samples'][i] = {
        // convert ms timestamp to ns
        elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
        stack_id: EMPTY_STACK_ID,
        thread_id: THREAD_ID_STRING,
      };
      continue;
    }

    let stackTop = input.stacks[jsSample.stackId];

    // Functions in top->down order (root is last)
    // We follow the stackTop.parentId trail and collect each visited frameId
    const stack = [];

    while (stackTop) {
      stack.push(stackTop.frameId);

      const frame = input.frames[stackTop.frameId];

      // If our frame has not been indexed yet, index it
      if (profile.frames[stackTop.frameId] === undefined) {
        profile.frames[stackTop.frameId] = {
          function: frame.name,
          abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
          lineno: frame.line,
          colno: frame.column,
        };
      }

      stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
    }

    const sample = {
      // convert ms timestamp to ns
      elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
      stack_id: STACK_ID,
      thread_id: THREAD_ID_STRING,
    };

    profile['stacks'][STACK_ID] = stack;
    profile['samples'][i] = sample;
    STACK_ID++;
  }

  return profile;
}

/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */
function addProfilesToEnvelope(envelope, profiles) {
  if (!profiles.length) {
    return envelope;
  }

  for (const profile of profiles) {
    envelope[1].push([{ type: 'profile' }, profile]);
  }
  return envelope;
}

/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */
function findProfiledTransactionsFromEnvelope(envelope) {
  const events = [];

  (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
    if (type !== 'transaction') {
      return;
    }

    for (let j = 1; j < item.length; j++) {
      const event = item[j] ;

      if (event && event.contexts && event.contexts['profile'] && event.contexts['profile']['profile_id']) {
        events.push(item[j] );
      }
    }
  });

  return events;
}

const debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */
function applyDebugMetadata(resource_paths) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return [];
  }

  const client = (0,esm_exports/* getClient */.s3)();
  const options = client && client.getOptions();
  const stackParser = options && options.stackParser;

  if (!stackParser) {
    return [];
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;

    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      const file = stackFrame && stackFrame.filename;

      if (stackFrame && file) {
        acc[file] = debugIdMap[debugIdStackTrace] ;
        break;
      }
    }
    return acc;
  }, {});

  const images = [];
  for (const path of resource_paths) {
    if (path && filenameDebugIdMap[path]) {
      images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path] ,
      });
    }
  }

  return images;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  if ((typeof rate !== 'number' && typeof rate !== 'boolean') || (typeof rate === 'number' && isNaN(rate))) {
    esm_debug_build/* DEBUG_BUILD */.X &&
      logger/* logger.warn */.kg.warn(
        `[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // Boolean sample rates are always valid
  if (rate === true || rate === false) {
    return true;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

function isValidProfile(profile) {
  if (profile.samples.length < 2) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      // Log a warning if the profile has less than 2 samples so users can know why
      // they are not seeing any profiling data and we cant avoid the back and forth
      // of asking them to provide us with a dump of the profile data.
      logger/* logger.log */.kg.log('[Profiling] Discarding profile because it contains less than 2 samples');
    }
    return false;
  }

  if (!profile.frames.length) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log('[Profiling] Discarding profile because it contains no frames');
    }
    return false;
  }

  return true;
}

// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let PROFILING_CONSTRUCTOR_FAILED = false;
const MAX_PROFILE_DURATION_MS = 30000;

/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */
function isJSProfilerSupported(maybeProfiler) {
  return typeof maybeProfiler === 'function';
}

/**
 * Starts the profiler and returns the profiler instance.
 */
function startJSSelfProfile() {
  // Feature support check first
  const JSProfilerConstructor = helpers/* WINDOW.Profiler */.m9.Profiler;

  if (!isJSProfilerSupported(JSProfilerConstructor)) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log(
        '[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.',
      );
    }
    return;
  }

  // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
  const samplingIntervalMS = 10;
  // Start the profiler
  const maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);

  // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
  // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
  // as we risk breaking the user's application, so just disable profiling and log an error.
  try {
    return new JSProfilerConstructor({ sampleInterval: samplingIntervalMS, maxBufferSize: maxSamples });
  } catch (e) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log(
        "[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.",
      );
      logger/* logger.log */.kg.log('[Profiling] Disabling profiling for current user session.');
    }
    PROFILING_CONSTRUCTOR_FAILED = true;
  }

  return;
}

/**
 * Determine if a profile should be profiled.
 */
function shouldProfileTransaction(transaction) {
  // If constructor failed once, it will always fail, so we can early return.
  if (PROFILING_CONSTRUCTOR_FAILED) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log('[Profiling] Profiling has been disabled for the duration of the current user session.');
    }
    return false;
  }

  if (!transaction.isRecording()) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log('[Profiling] Discarding profile because transaction was not sampled.');
    }
    return false;
  }

  const client = (0,esm_exports/* getClient */.s3)();
  const options = client && client.getOptions();
  if (!options) {
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Profiling] Profiling disabled, no options found.');
    return false;
  }

  // @ts-expect-error profilesSampleRate is not part of the browser options yet
  const profilesSampleRate = options.profilesSampleRate;

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(profilesSampleRate)) {
    esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('[Profiling] Discarding profile because of invalid sample rate.');
    return false;
  }

  // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
  if (!profilesSampleRate) {
    esm_debug_build/* DEBUG_BUILD */.X &&
      logger/* logger.log */.kg.log(
        '[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0',
      );
    return false;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
  // Check if we should sample this profile
  if (!sampled) {
    esm_debug_build/* DEBUG_BUILD */.X &&
      logger/* logger.log */.kg.log(
        `[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(
          profilesSampleRate,
        )})`,
      );
    return false;
  }

  return true;
}

/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */
function createProfilingEvent(
  profile_id,
  start_timestamp,
  profile,
  event,
) {
  if (!isValidProfile(profile)) {
    return null;
  }

  return createProfilePayload(profile_id, start_timestamp, profile, event);
}

// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
const PROFILE_MAP = new Map();
/**
 *
 */
function getActiveProfilesCount() {
  return PROFILE_MAP.size;
}

/**
 * Retrieves profile from global cache and removes it.
 */
function takeProfileFromGlobalCache(profile_id) {
  const profile = PROFILE_MAP.get(profile_id);
  if (profile) {
    PROFILE_MAP.delete(profile_id);
  }
  return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */
function addProfileToGlobalCache(profile_id, profile) {
  PROFILE_MAP.set(profile_id, profile);

  if (PROFILE_MAP.size > 30) {
    const last = PROFILE_MAP.keys().next().value;
    PROFILE_MAP.delete(last);
  }
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/profiling/hubextensions.js






/* eslint-disable complexity */

/**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */
function onProfilingStartRouteTransaction(transaction) {
  if (!transaction) {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log('[Profiling] Transaction is undefined, skipping profiling');
    }
    return transaction;
  }

  if (shouldProfileTransaction(transaction)) {
    return startProfileForTransaction(transaction);
  }

  return transaction;
}

/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */
function startProfileForTransaction(transaction) {
  // Start the profiler and get the profiler instance.
  let startTimestamp;
  if (isAutomatedPageLoadTransaction(transaction)) {
    startTimestamp = (0,esm_time/* timestampInSeconds */.ph)() * 1000;
  }

  const profiler = startJSSelfProfile();

  // We failed to construct the profiler, fallback to original transaction.
  // No need to log anything as this has already been logged in startProfile.
  if (!profiler) {
    return transaction;
  }

  if (esm_debug_build/* DEBUG_BUILD */.X) {
    logger/* logger.log */.kg.log(`[Profiling] started profiling transaction: ${(0,spanUtils/* spanToJSON */.XU)(transaction).description}`);
  }

  // We create "unique" transaction names to avoid concurrent transactions with same names
  // from being ignored by the profiler. From here on, only this transaction name should be used when
  // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
  const profileId = (0,misc/* uuid4 */.DM)();

  /**
   * Idempotent handler for profile stop
   */
  async function onProfileHandler() {
    // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
    if (!transaction) {
      return null;
    }
    // Satisfy the type checker, but profiler will always be defined here.
    if (!profiler) {
      return null;
    }

    return profiler
      .stop()
      .then((profile) => {
        if (maxDurationTimeoutID) {
          helpers/* WINDOW.clearTimeout */.m9.clearTimeout(maxDurationTimeoutID);
          maxDurationTimeoutID = undefined;
        }

        if (esm_debug_build/* DEBUG_BUILD */.X) {
          logger/* logger.log */.kg.log(`[Profiling] stopped profiling of transaction: ${(0,spanUtils/* spanToJSON */.XU)(transaction).description}`);
        }

        // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
        if (!profile) {
          if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log(
              `[Profiling] profiler returned null profile for: ${(0,spanUtils/* spanToJSON */.XU)(transaction).description}`,
              'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started',
            );
          }
          return null;
        }

        addProfileToGlobalCache(profileId, profile);
        return null;
      })
      .catch(error => {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
          logger/* logger.log */.kg.log('[Profiling] error while stopping profiler:', error);
        }
        return null;
      });
  }

  // Enqueue a timeout to prevent profiles from running over max duration.
  let maxDurationTimeoutID = helpers/* WINDOW.setTimeout */.m9.setTimeout(() => {
    if (esm_debug_build/* DEBUG_BUILD */.X) {
      logger/* logger.log */.kg.log(
        '[Profiling] max profile duration elapsed, stopping profiling for:',
        (0,spanUtils/* spanToJSON */.XU)(transaction).description,
      );
    }
    // If the timeout exceeds, we want to stop profiling, but not finish the transaction
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    onProfileHandler();
  }, MAX_PROFILE_DURATION_MS);

  // We need to reference the original end call to avoid creating an infinite loop
  const originalEnd = transaction.end.bind(transaction);

  /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */
  function profilingWrappedTransactionEnd() {
    if (!transaction) {
      return originalEnd();
    }
    // onProfileHandler should always return the same profile even if this is called multiple times.
    // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
    void onProfileHandler().then(
      () => {
        // TODO: Can we rewrite this to use attributes?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setContext('profile', { profile_id: profileId, start_timestamp: startTimestamp });
        originalEnd();
      },
      () => {
        // If onProfileHandler fails, we still want to call the original finish method.
        originalEnd();
      },
    );

    return transaction;
  }

  transaction.end = profilingWrappedTransactionEnd;
  return transaction;
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/profiling/integration.js






const profiling_integration_INTEGRATION_NAME = 'BrowserProfiling';

const _browserProfilingIntegration = (() => {
  return {
    name: profiling_integration_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      const scope = (0,esm_exports/* getCurrentScope */.nZ)();

      // eslint-disable-next-line deprecation/deprecation
      const transaction = scope.getTransaction();

      if (transaction && isAutomatedPageLoadTransaction(transaction)) {
        if (shouldProfileTransaction(transaction)) {
          startProfileForTransaction(transaction);
        }
      }

      if (typeof client.on !== 'function') {
        logger/* logger.warn */.kg.warn('[Profiling] Client does not support hooks, profiling will be disabled');
        return;
      }

      client.on('startTransaction', (transaction) => {
        if (shouldProfileTransaction(transaction)) {
          startProfileForTransaction(transaction);
        }
      });

      client.on('beforeEnvelope', (envelope) => {
        // if not profiles are in queue, there is nothing to add to the envelope.
        if (!getActiveProfilesCount()) {
          return;
        }

        const profiledTransactionEvents = findProfiledTransactionsFromEnvelope(envelope);
        if (!profiledTransactionEvents.length) {
          return;
        }

        const profilesToAddToEnvelope = [];

        for (const profiledTransaction of profiledTransactionEvents) {
          const context = profiledTransaction && profiledTransaction.contexts;
          const profile_id = context && context['profile'] && context['profile']['profile_id'];
          const start_timestamp = context && context['profile'] && context['profile']['start_timestamp'];

          if (typeof profile_id !== 'string') {
            esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Profiling] cannot find profile for a transaction without a profile context');
            continue;
          }

          if (!profile_id) {
            esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('[Profiling] cannot find profile for a transaction without a profile context');
            continue;
          }

          // Remove the profile from the transaction context before sending, relay will take care of the rest.
          if (context && context['profile']) {
            delete context.profile;
          }

          const profile = takeProfileFromGlobalCache(profile_id);
          if (!profile) {
            esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
            continue;
          }

          const profileEvent = createProfilingEvent(
            profile_id,
            start_timestamp ,
            profile,
            profiledTransaction ,
          );
          if (profileEvent) {
            profilesToAddToEnvelope.push(profileEvent);
          }
        }

        addProfilesToEnvelope(envelope , profilesToAddToEnvelope);
      });
    },
  };
}) ;

const browserProfilingIntegration = (0,integration/* defineIntegration */._I)(_browserProfilingIntegration);

/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const BrowserProfilingIntegration = (0,integration/* convertIntegrationFnToClass */.RN)(
  profiling_integration_INTEGRATION_NAME,
  browserProfilingIntegration,
) ;

// eslint-disable-next-line deprecation/deprecation


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/index.js



























let windowIntegrations = {};

// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers/* WINDOW.Sentry */.m9.Sentry && helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations) {
  windowIntegrations = helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations;
}

/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */
const INTEGRATIONS = {
  ...windowIntegrations,
  // eslint-disable-next-line deprecation/deprecation
  ...Integrations,
  ...esm_integrations_namespaceObject,
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 4297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; },
/* harmony export */   "f": function() { return /* binding */ breadcrumbsIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56102);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17149);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9733);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52868);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61245);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16962);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71207);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32798);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1466);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84808);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71673);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14828);





/* eslint-disable max-lines */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const INTEGRATION_NAME = 'Breadcrumbs';

const _breadcrumbsIntegration = ((options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options,
  };

  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      if (_options.console) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addConsoleInstrumentationHandler */ .e)(_getConsoleBreadcrumbHandler(client));
      }
      if (_options.dom) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addClickKeypressInstrumentationHandler */ .O)(_getDomBreadcrumbHandler(client, _options.dom));
      }
      if (_options.xhr) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addXhrInstrumentationHandler */ .UK)(_getXhrBreadcrumbHandler(client));
      }
      if (_options.fetch) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addFetchInstrumentationHandler */ .U)(_getFetchBreadcrumbHandler(client));
      }
      if (_options.history) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addHistoryInstrumentationHandler */ .a)(_getHistoryBreadcrumbHandler(client));
      }
      if (_options.sentry && client.on) {
        client.on('beforeSendEvent', _getSentryBreadcrumbHandler(client));
      }
    },
  };
}) ;

const breadcrumbsIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_5__/* .defineIntegration */ ._I)(_breadcrumbsIntegration);

/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Breadcrumbs = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_5__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, breadcrumbsIntegration)

;

/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */
function _getSentryBreadcrumbHandler(client) {
  return function addSentryBreadcrumb(event) {
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)() !== client) {
      return;
    }

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)(
      {
        category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
        event_id: event.event_id,
        level: event.level,
        message: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .getEventDescription */ .jH)(event),
      },
      {
        event,
      },
    );
  };
}

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _getDomBreadcrumbHandler(
  client,
  dom,
) {
  return function _innerDomBreadcrumb(handlerData) {
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)() !== client) {
      return;
    }

    let target;
    let componentName;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      const element = _isEvent(event) ? event.target : event;

      target = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .htmlTreeAsString */ .Rt)(element, { keyAttrs, maxStringLength });
      componentName = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .getComponentName */ .iY)(element);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target,
    };

    if (componentName) {
      breadcrumb.data = { 'ui.component_name': componentName };
    }

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global,
    });
  };
}

/**
 * Creates breadcrumbs from console API calls
 */
function _getConsoleBreadcrumbHandler(client) {
  return function _consoleBreadcrumb(handlerData) {
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)() !== client) {
      return;
    }

    const breadcrumb = {
      category: 'console',
      data: {
        arguments: handlerData.args,
        logger: 'console',
      },
      level: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .severityLevelFromString */ .VT)(handlerData.level),
      message: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .safeJoin */ .nK)(handlerData.args, ' '),
    };

    if (handlerData.level === 'assert') {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .safeJoin */ .nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        // Don't capture a breadcrumb for passed assertions
        return;
      }
    }

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level,
    });
  };
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _getXhrBreadcrumbHandler(client) {
  return function _xhrBreadcrumb(handlerData) {
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)() !== client) {
      return;
    }

    const { startTimestamp, endTimestamp } = handlerData;

    const sentryXhrData = handlerData.xhr[_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .SENTRY_XHR_DATA_KEY */ .xU];

    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }

    const { method, url, status_code, body } = sentryXhrData;

    const data = {
      method,
      url,
      status_code,
    };

    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp,
    };

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)(
      {
        category: 'xhr',
        data,
        type: 'http',
      },
      hint,
    );
  };
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _getFetchBreadcrumbHandler(client) {
  return function _fetchBreadcrumb(handlerData) {
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)() !== client) {
      return;
    }

    const { startTimestamp, endTimestamp } = handlerData;

    // We only capture complete fetch requests
    if (!endTimestamp) {
      return;
    }

    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
      // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
      return;
    }

    if (handlerData.error) {
      const data = handlerData.fetchData;
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp,
      };

      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)(
        {
          category: 'fetch',
          data,
          level: 'error',
          type: 'http',
        },
        hint,
      );
    } else {
      const response = handlerData.response ;
      const data = {
        ...handlerData.fetchData,
        status_code: response && response.status,
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp,
      };
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)(
        {
          category: 'fetch',
          data,
          type: 'http',
        },
        hint,
      );
    }
  };
}

/**
 * Creates breadcrumbs from history API calls
 */
function _getHistoryBreadcrumbHandler(client) {
  return function _historyBreadcrumb(handlerData) {
    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)() !== client) {
      return;
    }

    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .parseUrl */ .en)(_helpers_js__WEBPACK_IMPORTED_MODULE_14__/* .WINDOW.location.href */ .m9.location.href);
    let parsedFrom = from ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .parseUrl */ .en)(from) : undefined;
    const parsedTo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .parseUrl */ .en)(to);

    // Initial pushState doesn't provide `from` information
    if (!parsedFrom || !parsedFrom.path) {
      parsedFrom = parsedLoc;
    }

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .addBreadcrumb */ .n_)({
      category: 'navigation',
      data: {
        from,
        to,
      },
    });
  };
}

function _isEvent(event) {
  return !!event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map


/***/ }),

/***/ 43122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Dedupe; },
/* harmony export */   "R": function() { return /* binding */ dedupeIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56102);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58786);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71673);




const INTEGRATION_NAME = 'Dedupe';

const _dedupeIntegration = (() => {
  let previousEvent;

  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(currentEvent) {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      // Juuust in case something goes wrong
      try {
        if (_shouldDropEvent(currentEvent, previousEvent)) {
          _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Event dropped due to being a duplicate of previously captured event.');
          return null;
        }
      } catch (_oO) {} // eslint-disable-line no-empty

      return (previousEvent = currentEvent);
    },
  };
}) ;

const dedupeIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_dedupeIntegration);

/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Dedupe = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, dedupeIntegration)

;

function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-expect-error Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map


/***/ }),

/***/ 94073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GlobalHandlers; },
/* harmony export */   "k": function() { return /* binding */ globalHandlersIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56102);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80730);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48593);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(920);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71207);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58786);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71673);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2382);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14828);






/* eslint-disable @typescript-eslint/no-unsafe-member-access */

const INTEGRATION_NAME = 'GlobalHandlers';

const _globalHandlersIntegration = ((options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options,
  };

  return {
    name: INTEGRATION_NAME,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);
        globalHandlerLog('onerror');
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);
        globalHandlerLog('onunhandledrejection');
      }
    },
  };
}) ;

const globalHandlersIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .defineIntegration */ ._I)(_globalHandlersIntegration);

/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const GlobalHandlers = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .convertIntegrationFnToClass */ .RN)(
  INTEGRATION_NAME,
  globalHandlersIntegration,
)

;

function _installGlobalOnErrorHandler(client) {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalErrorInstrumentationHandler */ .V)(data => {
    const { stackParser, attachStacktrace } = getOptions();

    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)() !== client || (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .shouldIgnoreOnError */ .Wz)()) {
      return;
    }

    const { msg, url, line, column, error } = data;

    const event =
      error === undefined && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .HD)(msg)
        ? _eventFromIncompleteOnError(msg, url, line, column)
        : _enhanceEventWithInitialFrame(
            (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_5__/* .eventFromUnknownInput */ .ME)(stackParser, error || msg, undefined, attachStacktrace, false),
            url,
            line,
            column,
          );

    event.level = 'error';

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureEvent */ .eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onerror',
      },
    });
  });
}

function _installGlobalOnUnhandledRejectionHandler(client) {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .addGlobalUnhandledRejectionInstrumentationHandler */ .h)(e => {
    const { stackParser, attachStacktrace } = getOptions();

    if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)() !== client || (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .shouldIgnoreOnError */ .Wz)()) {
      return;
    }

    const error = _getUnhandledRejectionError(e );

    const event = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isPrimitive */ .pt)(error)
      ? _eventFromRejectionWithPrimitive(error)
      : (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_5__/* .eventFromUnknownInput */ .ME)(stackParser, error, undefined, attachStacktrace, true);

    event.level = 'error';

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureEvent */ .eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onunhandledrejection',
      },
    });
  });
}

function _getUnhandledRejectionError(error) {
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isPrimitive */ .pt)(error)) {
    return error;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const e = error ;

  // dig the object of the rejection out of known event types
  try {
    // PromiseRejectionEvents store the object of the rejection under 'reason'
    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
    if ('reason' in e) {
      return e.reason;
    }

    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
    // https://github.com/getsentry/sentry-javascript/issues/2380
    else if ('detail' in e && 'reason' in e.detail) {
      return e.detail.reason;
    }
  } catch (e2) {} // eslint-disable-line no-empty

  return error;
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isErrorEvent */ .VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .HD)(url) && url.length > 0 ? url : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .getLocationHref */ .l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log(`Global Handler attached: ${type}`);
}

function getOptions() {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return options;
}


//# sourceMappingURL=globalhandlers.js.map


/***/ }),

/***/ 31912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ HttpContext; },
/* harmony export */   "s": function() { return /* binding */ httpContextIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56102);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14828);



const INTEGRATION_NAME = 'HttpContext';

const _httpContextIntegration = (() => {
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.navigator */ .m9.navigator && !_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.location */ .m9.location && !_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m9.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      const url = (event.request && event.request.url) || (_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.location */ .m9.location && _helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.location.href */ .m9.location.href);
      const { referrer } = _helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m9.document || {};
      const { userAgent } = _helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.navigator */ .m9.navigator || {};

      const headers = {
        ...(event.request && event.request.headers),
        ...(referrer && { Referer: referrer }),
        ...(userAgent && { 'User-Agent': userAgent }),
      };
      const request = { ...event.request, ...(url && { url }), headers };

      event.request = request;
    },
  };
}) ;

const httpContextIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._I)(_httpContextIntegration);

/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const HttpContext = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, httpContextIntegration)

;


//# sourceMappingURL=httpcontext.js.map


/***/ }),

/***/ 12724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ LinkedErrors; },
/* harmony export */   "O": function() { return /* binding */ linkedErrorsIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56102);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84596);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2382);




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

const INTEGRATION_NAME = 'LinkedErrors';

const _linkedErrorsIntegration = ((options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;

  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event, hint, client) {
      const options = client.getOptions();

      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .applyAggregateErrorsToEvent */ .Z)(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        _eventbuilder_js__WEBPACK_IMPORTED_MODULE_1__/* .exceptionFromError */ .GJ,
        options.stackParser,
        options.maxValueLength,
        key,
        limit,
        event,
        hint,
      );
    },
  };
}) ;

const linkedErrorsIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_linkedErrorsIntegration);

/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const LinkedErrors = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, linkedErrorsIntegration)

;


//# sourceMappingURL=linkederrors.js.map


/***/ }),

/***/ 19086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TryCatch; },
/* harmony export */   "t": function() { return /* binding */ browserApiErrorsIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56102);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16398);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14828);




const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'BroadcastChannel',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'SharedWorker',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

const INTEGRATION_NAME = 'TryCatch';

const _browserApiErrorsIntegration = ((options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    ...options,
  };

  return {
    name: INTEGRATION_NAME,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'setTimeout', _wrapTimeFunction);
      }

      if (_options.setInterval) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'setInterval', _wrapTimeFunction);
      }

      if (_options.requestAnimationFrame) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'requestAnimationFrame', _wrapRAF);
      }

      if (_options.XMLHttpRequest && 'XMLHttpRequest' in _helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
      }

      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach(_wrapEventTarget);
      }
    },
  };
}) ;

const browserApiErrorsIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_browserApiErrorsIntegration);

/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const TryCatch = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(
  INTEGRATION_NAME,
  browserApiErrorsIntegration,
)

;

function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(originalCallback, {
      mechanism: {
        data: { function: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFunctionName */ .$P)(original) },
        handled: false,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFunctionName */ .$P)(original),
          },
          handled: false,
          type: 'instrument',
        },
      }),
    ]);
  };
}

function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFunctionName */ .$P)(original),
              },
              handled: false,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFunctionName */ .$P)(originalFunction);
          }

          // Otherwise wrap directly
          return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = _helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9 ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(proto, 'addEventListener', function (original,)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFunctionName */ .$P)(fn),
                target,
              },
              handled: false,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFunctionName */ .$P)(fn),
              target,
            },
            handled: false,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map


/***/ }),

/***/ 20113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ captureUserFeedback; },
/* harmony export */   "SS": function() { return /* binding */ defaultIntegrations; },
/* harmony export */   "Eg": function() { return /* binding */ forceLoad; },
/* harmony export */   "nV": function() { return /* binding */ getDefaultIntegrations; },
/* harmony export */   "S1": function() { return /* binding */ init; },
/* harmony export */   "lA": function() { return /* binding */ onLoad; },
/* harmony export */   "jp": function() { return /* binding */ showReportDialog; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33931);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17661);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56102);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82536);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10857);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(74988);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16398);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10264);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(16962);
/* harmony import */ var _client_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34101);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71673);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14828);
/* harmony import */ var _integrations_breadcrumbs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4297);
/* harmony import */ var _integrations_dedupe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43122);
/* harmony import */ var _integrations_globalhandlers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94073);
/* harmony import */ var _integrations_httpcontext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31912);
/* harmony import */ var _integrations_linkederrors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12724);
/* harmony import */ var _integrations_trycatch_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19086);
/* harmony import */ var _stack_parsers_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60595);
/* harmony import */ var _transports_fetch_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19338);
/* harmony import */ var _transports_xhr_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19601);















/** @deprecated Use `getDefaultIntegrations(options)` instead. */
const defaultIntegrations = [
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .inboundFiltersIntegration */ .S)(),
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .functionToStringIntegration */ .C)(),
  (0,_integrations_trycatch_js__WEBPACK_IMPORTED_MODULE_2__/* .browserApiErrorsIntegration */ .t)(),
  (0,_integrations_breadcrumbs_js__WEBPACK_IMPORTED_MODULE_3__/* .breadcrumbsIntegration */ .f)(),
  (0,_integrations_globalhandlers_js__WEBPACK_IMPORTED_MODULE_4__/* .globalHandlersIntegration */ .k)(),
  (0,_integrations_linkederrors_js__WEBPACK_IMPORTED_MODULE_5__/* .linkedErrorsIntegration */ .O)(),
  (0,_integrations_dedupe_js__WEBPACK_IMPORTED_MODULE_6__/* .dedupeIntegration */ .R)(),
  (0,_integrations_httpcontext_js__WEBPACK_IMPORTED_MODULE_7__/* .httpContextIntegration */ .s)(),
];

/** Get the default integrations for the browser SDK. */
function getDefaultIntegrations(_options) {
  // We return a copy of the defaultIntegrations here to avoid mutating this
  return [
    // eslint-disable-next-line deprecation/deprecation
    ...defaultIntegrations,
  ];
}

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = getDefaultIntegrations();
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (_helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.SENTRY_RELEASE */ .m9.SENTRY_RELEASE && _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.SENTRY_RELEASE.id */ .m9.SENTRY_RELEASE.id) {
      options.release = _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.SENTRY_RELEASE.id */ .m9.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .stackParserFromStackParserOptions */ .Sq)(options.stackParser || _stack_parsers_js__WEBPACK_IMPORTED_MODULE_10__/* .defaultStackParser */ .Dt),
    integrations: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .getIntegrationsToSetup */ .m8)(options),
    transport: options.transport || ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .supportsFetch */ .Ak)() ? _transports_fetch_js__WEBPACK_IMPORTED_MODULE_13__/* .makeFetchTransport */ .f : _transports_xhr_js__WEBPACK_IMPORTED_MODULE_14__/* .makeXHRTransport */ .K),
  };

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_15__/* .initAndBind */ .M)(_client_js__WEBPACK_IMPORTED_MODULE_16__/* .BrowserClient */ .R, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

const showReportDialog = (
  // eslint-disable-next-line deprecation/deprecation
  options = {},
  // eslint-disable-next-line deprecation/deprecation
  hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_17__/* .getCurrentHub */ .Gd)(),
) => {
  // doesn't work without a document (React Native)
  if (!_helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document */ .m9.document) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_18__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_19__/* .logger.error */ .kg.error('Global document not defined in showReportDialog call');
    return;
  }

  // eslint-disable-next-line deprecation/deprecation
  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_18__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_19__/* .logger.error */ .kg.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
  }

  const script = _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.createElement */ .m9.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_20__/* .getReportDialogEndpoint */ .h)(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const { onClose } = options;
  if (onClose) {
    const reportDialogClosedMessageHandler = (event) => {
      if (event.data === '__sentry_reportdialog_closed__') {
        try {
          onClose();
        } finally {
          _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.removeEventListener */ .m9.removeEventListener('message', reportDialogClosedMessageHandler);
        }
      }
    };
    _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.addEventListener */ .m9.addEventListener('message', reportDialogClosedMessageHandler);
  }

  const injectionPoint = _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.head */ .m9.document.head || _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.body */ .m9.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_18__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_19__/* .logger.error */ .kg.error('Not injecting report dialog. No injection point found in HTML');
  }
};

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
  return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .wrap */ .re)(fn)();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof _helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document */ .m9.document === 'undefined') {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_18__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_19__/* .logger.warn */ .kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_21__/* .startSession */ .yj)({ ignoreDuration: true });
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_21__/* .captureSession */ .cg)();

  // We want to create a session for every navigation as well
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_22__/* .addHistoryInstrumentationHandler */ .a)(({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (from !== undefined && from !== to) {
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_21__/* .startSession */ .yj)({ ignoreDuration: true });
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_21__/* .captureSession */ .cg)();
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_21__/* .getClient */ .s3)();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 60595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ chromeStackLineParser; },
/* harmony export */   "d8": function() { return /* binding */ defaultStackLineParsers; },
/* harmony export */   "Dt": function() { return /* binding */ defaultStackParser; },
/* harmony export */   "$Q": function() { return /* binding */ geckoStackLineParser; },
/* harmony export */   "NP": function() { return /* binding */ opera10StackLineParser; },
/* harmony export */   "HH": function() { return /* binding */ opera11StackLineParser; },
/* harmony export */   "R2": function() { return /* binding */ winjsStackLineParser; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16398);


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const chromeStackParserFn = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .createStackParser */ .pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map


/***/ }),

/***/ 19338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ makeFetchTransport; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(12653);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(17954);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(10264);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/debug-build.js
var debug_build = __webpack_require__(71673);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(14828);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/utils.js




let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers/* WINDOW.fetch */.m9.fetch)) {
    return (cachedFetchImpl = helpers/* WINDOW.fetch.bind */.m9.fetch.bind(helpers/* WINDOW */.m9));
  }

  const document = helpers/* WINDOW.document */.m9.document;
  let fetchImpl = helpers/* WINDOW.fetch */.m9.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers/* WINDOW */.m9));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return (0,base/* createTransport */.q)(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 19601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ makeXHRTransport; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12653);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17954);



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .SyncPromise */ .cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .createTransport */ .q)(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map


/***/ }),

/***/ 54832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ createUserFeedbackEnvelope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10959);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73506);


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dsnToString */ .RA)(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createEnvelope */ .Jd)(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map


/***/ }),

/***/ 74988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   "h": function() { return /* binding */ getReportDialogEndpoint; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10959);


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .urlEncode */ ._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .makeDsn */ .vK)(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'onClose') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map


/***/ }),

/***/ 61335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ BaseClient; },
  "Q": function() { return /* binding */ addEventProcessor; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(10959);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(40901);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(48593);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(17954);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(73506);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/error.js
var error = __webpack_require__(34026);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(74988);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(42598);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/envelope.js
var esm_envelope = __webpack_require__(13114);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(13976);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(10857);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/integration.js
var esm_integration = __webpack_require__(56102);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/metrics/utils.js
var utils = __webpack_require__(41666);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/envelope.js



/**
 * Create envelope from a metric aggregate.
 */
function createMetricEnvelope(
  metricBucketItems,
  dsn,
  metadata,
  tunnel,
) {
  const headers = {
    sent_at: new Date().toISOString(),
  };

  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version,
    };
  }

  if (!!tunnel && dsn) {
    headers.dsn = (0,esm_dsn/* dsnToString */.RA)(dsn);
  }

  const item = createMetricEnvelopeItem(metricBucketItems);
  return (0,envelope/* createEnvelope */.Jd)(headers, [item]);
}

function createMetricEnvelopeItem(metricBucketItems) {
  const payload = (0,utils/* serializeMetricBuckets */.uv)(metricBucketItems);
  const metricHeaders = {
    type: 'statsd',
    length: payload.length,
  };
  return [metricHeaders, payload];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(63965);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(59278);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(4715);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/baseclient.js












const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */

  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Indicates whether this client's integrations have been set up. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {
    this._options = options;
    this._integrations = {};
    this._integrationsInitialized = false;
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];

    if (options.dsn) {
      this._dsn = (0,esm_dsn/* makeDsn */.vK)(options.dsn);
    } else {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('No DSN provided, client will not send events.');
    }

    if (this._dsn) {
      const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(this._dsn, options);
      this._transport = options.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const eventMessage = (0,is/* isParameterizedString */.Le)(message) ? message : String(message);

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(eventMessage, level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;

    this._process(
      this._captureEvent(event, hint, capturedSpanScope || scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!(typeof session.release === 'string')) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      if (this.metricsAggregator) {
        this.metricsAggregator.flush();
      }
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      if (this.metricsAggregator) {
        this.metricsAggregator.close();
      }
      return result;
    });
  }

  /** Get all installed event processors. */
   getEventProcessors() {
    return this._eventProcessors;
  }

  /** @inheritDoc */
   addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }

  /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */
   setupIntegrations(forceInitialize) {
    if ((forceInitialize && !this._integrationsInitialized) || (this._isEnabled() && !this._integrationsInitialized)) {
      this._setupIntegrations();
    }
  }

  /** @inheritdoc */
   init() {
    if (this._isEnabled()) {
      this._setupIntegrations();
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */
   getIntegrationById(integrationId) {
    return this.getIntegrationByName(integrationId);
  }

  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
   getIntegrationByName(integrationName) {
    return this._integrations[integrationName] ;
  }

  /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    const isAlreadyInstalled = this._integrations[integration.name];

    // This hook takes care of only installing if not already installed
    (0,esm_integration/* setupIntegration */.m7)(this, integration, this._integrations);
    // Here we need to check manually to make sure to not run this multiple times
    if (!isAlreadyInstalled) {
      (0,esm_integration/* afterSetupIntegrations */.uf)(this, [integration]);
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    this.emit('beforeSendEvent', event, hint);

    let env = (0,esm_envelope/* createEventEnvelope */.M)(event, this._dsn, this._options._metadata, this._options.tunnel);

    for (const attachment of hint.attachments || []) {
      env = (0,envelope/* addItemToEnvelope */.BO)(
        env,
        (0,envelope/* createAttachmentEnvelopeItem */.zQ)(
          attachment,
          this._options.transportOptions && this._options.transportOptions.textEncoder,
        ),
      );
    }

    const promise = this._sendEnvelope(env);
    if (promise) {
      promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    const env = (0,esm_envelope/* createSessionEnvelope */.Q)(session, this._dsn, this._options._metadata, this._options.tunnel);

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(env);
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, eventOrCount) {
    if (this._options.sendClientReports) {
      // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
      // If event is passed as third argument, we assume this is a count of 1
      const count = typeof eventOrCount === 'number' ? eventOrCount : 1;

      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
      this._outcomes[key] = (this._outcomes[key] || 0) + count;
    }
  }

  /**
   * @inheritDoc
   */
   captureAggregateMetrics(metricBucketItems) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
    const metricsEnvelope = createMetricEnvelope(
      metricBucketItems,
      this._dsn,
      this._options._metadata,
      this._options.tunnel,
    );

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(metricsEnvelope);
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-expect-error We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /* eslint-enable @typescript-eslint/unified-signatures */

  /** Setup integrations for this client. */
   _setupIntegrations() {
    const { integrations } = this._options;
    this._integrations = (0,esm_integration/* setupIntegrations */.q4)(this, integrations);
    (0,esm_integration/* afterSetupIntegrations */.uf)(this, integrations);

    // TODO v8: We don't need this flag anymore
    this._integrationsInitialized = true;
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a transport is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(
    event,
    hint,
    scope,
    isolationScope = (0,hub/* getIsolationScope */.aF)(),
  ) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }

    this.emit('preprocessEvent', event, hint);

    return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope, this, isolationScope).then(evt => {
      if (evt === null) {
        return evt;
      }

      const propagationContext = {
        ...isolationScope.getPropagationContext(),
        ...(scope ? scope.getPropagationContext() : undefined),
      };

      const trace = evt.contexts && evt.contexts.trace;
      if (!trace && propagationContext) {
        const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext;
        evt.contexts = {
          trace: {
            trace_id,
            span_id: spanId,
            parent_span_id: parentSpanId,
          },
          ...evt.contexts,
        };

        const dynamicSamplingContext = dsc ? dsc : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(trace_id, this, scope);

        evt.sdkProcessingMetadata = {
          dynamicSamplingContext,
          ...evt.sdkProcessingMetadata,
        };
      }
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if (debug_build/* DEBUG_BUILD */.X) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            logger/* logger.log */.kg.log(sentryError.message);
          } else {
            logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new error/* SentryError */.b(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;

    return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new error/* SentryError */.b('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          if (isTransaction) {
            const spans = event.spans || [];
            // the transaction itself counts as one span, plus all the child spans that are added
            const spanCount = 1 + spans.length;
            this.recordDroppedEvent('before_send', 'span', spanCount);
          }
          throw new error/* SentryError */.b(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        if (isTransaction) {
          const spanCountBefore =
            (processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing) ||
            0;
          const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;

          const droppedSpanCount = spanCountBefore - spanCountAfter;
          if (droppedSpanCount > 0) {
            this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
          }
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof error/* SentryError */.b) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new error/* SentryError */.b(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    this.emit('beforeEnvelope', envelope);

    if (this._isEnabled() && this._transport) {
      return this._transport.send(envelope).then(null, reason => {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new error/* SentryError */.b(invalidValueError);
        }
        return event;
      },
      e => {
        throw new error/* SentryError */.b(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new error/* SentryError */.b(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    if (event.spans) {
      // We store the # of spans before processing in SDK metadata,
      // so we can compare it afterwards to determine how many spans were dropped
      const spanCountBefore = event.spans.length;
      event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        spanCountBeforeProcessing: spanCountBefore,
      };
    }
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */
function addEventProcessor(callback) {
  const client = (0,esm_exports/* getClient */.s3)();

  if (!client || !client.addEventProcessor) {
    return;
  }

  client.addEventProcessor(callback);
}


//# sourceMappingURL=baseclient.js.map


/***/ }),

/***/ 69356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 42598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ createEventEnvelope; },
/* harmony export */   "Q": function() { return /* binding */ createSessionEnvelope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73506);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10959);


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getSdkMetadataForEnvelopeHeader */ .HY)(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .createEnvelope */ .Jd)(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getSdkMetadataForEnvelopeHeader */ .HY)(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .createEventEnvelopeHeaders */ .Cd)(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .createEnvelope */ .Jd)(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map


/***/ }),

/***/ 21712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cc": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "fH": function() { return /* binding */ getGlobalEventProcessors; },
/* harmony export */   "RP": function() { return /* binding */ notifyEventProcessors; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17954);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48593);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42598);



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */
function addGlobalEventProcessor(callback) {
  // eslint-disable-next-line deprecation/deprecation
  getGlobalEventProcessors().push(callback);
}

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(
  processors,
  event,
  hint,
  index = 0,
) {
  return new _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .SyncPromise */ .cW((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({ ...event }, hint) ;

      _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && processor.id && result === null && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

      if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isThenable */ .J8)(result)) {
        void result
          .then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
          .then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1)
          .then(resolve)
          .then(null, reject);
      }
    }
  });
}


//# sourceMappingURL=eventProcessors.js.map


/***/ }),

/***/ 13976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "c": function() { return /* binding */ captureCheckIn; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; },
/* harmony export */   "cg": function() { return /* binding */ captureSession; },
/* harmony export */   "xv": function() { return /* binding */ close; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "TM": function() { return /* binding */ endSession; },
/* harmony export */   "yl": function() { return /* binding */ flush; },
/* harmony export */   "s3": function() { return /* binding */ getClient; },
/* harmony export */   "nZ": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "dk": function() { return /* binding */ isInitialized; },
/* harmony export */   "eW": function() { return /* binding */ lastEventId; },
/* harmony export */   "v": function() { return /* binding */ setContext; },
/* harmony export */   "sU": function() { return /* binding */ setExtra; },
/* harmony export */   "rJ": function() { return /* binding */ setExtras; },
/* harmony export */   "YA": function() { return /* binding */ setTag; },
/* harmony export */   "mG": function() { return /* binding */ setTags; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "yj": function() { return /* binding */ startSession; },
/* harmony export */   "Yr": function() { return /* binding */ startTransaction; },
/* harmony export */   "_d": function() { return /* binding */ withActiveSpan; },
/* harmony export */   "wi": function() { return /* binding */ withIsolationScope; },
/* harmony export */   "$e": function() { return /* binding */ withScope; }
/* harmony export */ });
/* unused harmony export withMonitor */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81539);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69356);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42598);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10857);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63965);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4715);







/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */
function captureException(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exception,
  hint,
) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__/* .parseEventHintOrCaptureContext */ .U0)(hint));
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */
function captureEvent(event, hint) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */
// eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
// eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb, hint);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
// eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
// eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
// eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
// eslint-disable-next-line deprecation/deprecation
function setUser(user) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */

/**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */
function withScope(
  ...rest
) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();

  // If a scope is defined, we want to make this the active scope instead of the default one
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      // eslint-disable-next-line deprecation/deprecation
      return hub.withScope(callback);
    }

    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(() => {
      // eslint-disable-next-line deprecation/deprecation
      hub.getStackTop().scope = scope ;
      return callback(scope );
    });
  }

  // eslint-disable-next-line deprecation/deprecation
  return hub.withScope(rest[0]);
}

/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */
function withIsolationScope(callback) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(() => {
    return callback((0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)());
  });
}

/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */
function withActiveSpan(span, callback) {
  return withScope(scope => {
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    return callback(scope);
  });
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */
function startTransaction(
  context,
  customSamplingContext,
  // eslint-disable-next-line deprecation/deprecation
) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const scope = getCurrentScope();
  const client = getClient();
  if (!client) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .uuid4 */ .DM)();
}

/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function withMonitor(
  monitorSlug,
  callback,
  upsertMonitorConfig,
) {
  const checkInId = captureCheckIn({ monitorSlug, status: 'in_progress' }, upsertMonitorConfig);
  const now = timestampInSeconds();

  function finishCheckIn(status) {
    captureCheckIn({ monitorSlug, status, checkInId, duration: timestampInSeconds() - now });
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback();
  } catch (e) {
    finishCheckIn('error');
    throw e;
  }

  if (isThenable(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishCheckIn('ok');
      },
      () => {
        finishCheckIn('error');
      },
    );
  } else {
    finishCheckIn('ok');
  }

  return maybePromiseResult;
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function flush(timeout) {
  const client = getClient();
  if (client) {
    return client.flush(timeout);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Cannot flush events. No client defined.');
  return Promise.resolve(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function close(timeout) {
  const client = getClient();
  if (client) {
    return client.close(timeout);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Cannot flush events and disable SDK. No client defined.');
  return Promise.resolve(false);
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().lastEventId();
}

/**
 * Get the currently active client.
 */
function getClient() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
}

/**
 * Returns true if Sentry has been properly initialized.
 */
function isInitialized() {
  return !!getClient();
}

/**
 * Get the currently active scope.
 */
function getCurrentScope() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getScope();
}

/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */
function startSession(context) {
  const client = getClient();
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();

  const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

  // Will fetch userAgent if called from browser sdk
  const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

  const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .makeSession */ .Hv)({
    release,
    environment,
    user: currentScope.getUser() || isolationScope.getUser(),
    ...(userAgent && { userAgent }),
    ...context,
  });

  // End existing session if there's one
  const currentSession = isolationScope.getSession();
  if (currentSession && currentSession.status === 'ok') {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
  }

  endSession();

  // Afterwards we set the new session on the scope
  isolationScope.setSession(session);

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession(session);

  return session;
}

/**
 * End the session on the current isolation scope.
 */
function endSession() {
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();

  const session = currentScope.getSession() || isolationScope.getSession();
  if (session) {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .closeSession */ .RJ)(session);
  }
  _sendSessionUpdate();

  // the session is over; take it off of the scope
  isolationScope.setSession();

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession();
}

/**
 * Sends the current Session on the scope
 */
function _sendSessionUpdate() {
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();
  const client = getClient();
  // TODO (v8): Remove currentScope and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session && client && client.captureSession) {
    client.captureSession(session);
  }
}

/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */
function captureSession(end = false) {
  // both send the update and pull the session from the scope
  if (end) {
    endSession();
    return;
  }

  // only send the update
  _sendSessionUpdate();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 10857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xb": function() { return /* binding */ Hub; },
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "vi": function() { return /* binding */ getHubFromCarrier; },
/* harmony export */   "aF": function() { return /* binding */ getIsolationScope; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; },
/* harmony export */   "pj": function() { return /* binding */ makeMain; },
/* harmony export */   "Ok": function() { return /* binding */ runWithAsyncContext; }
/* harmony export */ });
/* unused harmony exports API_VERSION, ensureHubOnCarrier, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48593);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24703);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81539);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69356);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42598);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77172);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63965);
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91895);







/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = parseFloat(_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J);

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */
// eslint-disable-next-line deprecation/deprecation
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
   constructor(
    client,
    scope,
    isolationScope,
      _version = API_VERSION,
  ) {this._version = _version;
    let assignedScope;
    if (!scope) {
      assignedScope = new _scope_js__WEBPACK_IMPORTED_MODULE_1__/* .Scope */ .sX();
      assignedScope.setClient(client);
    } else {
      assignedScope = scope;
    }

    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new _scope_js__WEBPACK_IMPORTED_MODULE_1__/* .Scope */ .sX();
      assignedIsolationScope.setClient(client);
    } else {
      assignedIsolationScope = isolationScope;
    }

    this._stack = [{ scope: assignedScope }];

    if (client) {
      // eslint-disable-next-line deprecation/deprecation
      this.bindClient(client);
    }

    this._isolationScope = assignedIsolationScope;
  }

  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
   bindClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    const top = this.getStackTop();
    top.client = client;
    top.scope.setClient(client);
    // eslint-disable-next-line deprecation/deprecation
    if (client && client.setupIntegrations) {
      // eslint-disable-next-line deprecation/deprecation
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
   pushScope() {
    // We want to clone the content of prev scope
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope().clone();
    // eslint-disable-next-line deprecation/deprecation
    this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
   popScope() {
    // eslint-disable-next-line deprecation/deprecation
    if (this.getStack().length <= 1) return false;
    // eslint-disable-next-line deprecation/deprecation
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
   withScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.pushScope();

    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      // eslint-disable-next-line deprecation/deprecation
      this.popScope();
      throw e;
    }

    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isThenable */ .J8)(maybePromiseResult)) {
      // @ts-expect-error - isThenable returns the wrong type
      return maybePromiseResult.then(
        res => {
          // eslint-disable-next-line deprecation/deprecation
          this.popScope();
          return res;
        },
        e => {
          // eslint-disable-next-line deprecation/deprecation
          this.popScope();
          throw e;
        },
      );
    }

    // eslint-disable-next-line deprecation/deprecation
    this.popScope();
    return maybePromiseResult;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
   getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return this.getStackTop().client ;
  }

  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
   getScope() {
    // eslint-disable-next-line deprecation/deprecation
    return this.getStackTop().scope;
  }

  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
   getIsolationScope() {
    return this._isolationScope;
  }

  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
   getStack() {
    return this._stack;
  }

  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureException(exception, {
      originalException: exception,
      syntheticException,
      ...hint,
      event_id: eventId,
    });

    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureMessage(message, level, {
      originalException: message,
      syntheticException,
      ...hint,
      event_id: eventId,
    });

    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureEvent(event, { ...hint, event_id: eventId });
    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
   addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
    // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
    // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
    // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
    // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
    // the event processing pipeline.
    // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
   setUser(user) {
    // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setUser(user);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setUser(user);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
   setTags(tags) {
    // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setTags(tags);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setTags(tags);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
   setExtras(extras) {
    // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setExtras(extras);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
   setTag(key, value) {
    // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setTag(key, value);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
   setExtra(key, extra) {
    // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setExtra(key, extra);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setContext(name, context);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
   configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
   run(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      // eslint-disable-next-line deprecation/deprecation
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
   getIntegration(integration) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    if (!client) return null;
    try {
      // eslint-disable-next-line deprecation/deprecation
      return client.getIntegration(integration);
    } catch (_oO) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && !result) {
      // eslint-disable-next-line deprecation/deprecation
      const client = this.getClient();
      if (!client) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'",
        );
      } else {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }

    return result;
  }

  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      // eslint-disable-next-line deprecation/deprecation
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
   endSession() {
    // eslint-disable-next-line deprecation/deprecation
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
   startSession(context) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_8__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    // eslint-disable-next-line deprecation/deprecation
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
   shouldSendDefaultPii() {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */
// eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */
function getIsolationScope() {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().getIsolationScope();
}

// eslint-disable-next-line deprecation/deprecation
function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one

  if (
    !hasHubOnCarrier(registry) ||
    // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)
  ) {
    // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
// eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (
    !hasHubOnCarrier(carrier) ||
    // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)
  ) {
    // eslint-disable-next-line deprecation/deprecation
    const client = parent.getClient();
    // eslint-disable-next-line deprecation/deprecation
    const scope = parent.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const isolationScope = parent.getIsolationScope();
    // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
// eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
// eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 56102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M5": function() { return /* binding */ addIntegration; },
/* harmony export */   "uf": function() { return /* binding */ afterSetupIntegrations; },
/* harmony export */   "RN": function() { return /* binding */ convertIntegrationFnToClass; },
/* harmony export */   "_I": function() { return /* binding */ defineIntegration; },
/* harmony export */   "m8": function() { return /* binding */ getIntegrationsToSetup; },
/* harmony export */   "m7": function() { return /* binding */ setupIntegration; },
/* harmony export */   "q4": function() { return /* binding */ setupIntegrations; }
/* harmony export */ });
/* unused harmony export installedIntegrations */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58786);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42598);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21712);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13976);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10857);






const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .arrayify */ .lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(client, integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */
function afterSetupIntegrations(client, integrations) {
  for (const integration of integrations) {
    // guard against empty provided integrations
    if (integration && integration.afterAllSetup) {
      integration.afterAllSetup(client);
    }
  }
}

/** Setup a single integration.  */
function setupIntegration(client, integration, integrationIndex) {
  if (integrationIndex[integration.name]) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`Integration skipped because it was already installed: ${integration.name}`);
    return;
  }
  integrationIndex[integration.name] = integration;

  // `setupOnce` is only called the first time
  if (installedIntegrations.indexOf(integration.name) === -1) {
    // eslint-disable-next-line deprecation/deprecation
    integration.setupOnce(_eventProcessors_js__WEBPACK_IMPORTED_MODULE_3__/* .addGlobalEventProcessor */ .cc, _hub_js__WEBPACK_IMPORTED_MODULE_4__/* .getCurrentHub */ .Gd);
    installedIntegrations.push(integration.name);
  }

  // `setup` is run for each client
  if (integration.setup && typeof integration.setup === 'function') {
    integration.setup(client);
  }

  if (client.on && typeof integration.preprocessEvent === 'function') {
    const callback = integration.preprocessEvent.bind(integration) ;
    client.on('preprocessEvent', (event, hint) => callback(event, hint, client));
  }

  if (client.addEventProcessor && typeof integration.processEvent === 'function') {
    const callback = integration.processEvent.bind(integration) ;

    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name,
    });

    client.addEventProcessor(processor);
  }

  _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`Integration installed: ${integration.name}`);
}

/** Add an integration to the current hub's client. */
function addIntegration(integration) {
  const client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_5__/* .getClient */ .s3)();

  if (!client || !client.addIntegration) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }

  client.addIntegration(integration);
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}

/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */
function convertIntegrationFnToClass(
  name,
  fn,
) {
  return Object.assign(
    function ConvertedIntegration(...args) {
      return fn(...args);
    },
    { id: name },
  ) ;
}

/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */
function defineIntegration(fn) {
  return fn;
}


//# sourceMappingURL=integration.js.map


/***/ }),

/***/ 17661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FunctionToString; },
/* harmony export */   "C": function() { return /* binding */ functionToStringIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13976);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56102);




let originalFunctionToString;

const INTEGRATION_NAME = 'FunctionToString';

const SETUP_CLIENTS = new WeakMap();

const _functionToStringIntegration = (() => {
  return {
    name: INTEGRATION_NAME,
    setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString;

      // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function ( ...args) {
          const originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(this);
          const context =
            SETUP_CLIENTS.has((0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getClient */ .s3)() ) && originalFunction !== undefined ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {
        // ignore errors here, just don't patch this
      }
    },
    setup(client) {
      SETUP_CLIENTS.set(client, true);
    },
  };
}) ;

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */
const functionToStringIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_functionToStringIntegration);

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const FunctionToString = (0,_integration_js__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(
  INTEGRATION_NAME,
  functionToStringIntegration,
) ;

// eslint-disable-next-line deprecation/deprecation


//# sourceMappingURL=functiontostring.js.map


/***/ }),

/***/ 33931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ InboundFilters; },
/* harmony export */   "S": function() { return /* binding */ inboundFiltersIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1466);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42598);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56102);




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/,
];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

const INTEGRATION_NAME = 'InboundFilters';
const _inboundFiltersIntegration = ((options = {}) => {
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event, _hint, client) {
      const clientOptions = client.getOptions();
      const mergedOptions = _mergeOptions(options, clientOptions);
      return _shouldDropEvent(event, mergedOptions) ? null : event;
    },
  };
}) ;

const inboundFiltersIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_0__/* .defineIntegration */ ._I)(_inboundFiltersIntegration);

/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const InboundFilters = (0,_integration_js__WEBPACK_IMPORTED_MODULE_0__/* .convertIntegrationFnToClass */ .RN)(
  INTEGRATION_NAME,
  inboundFiltersIntegration,
)

;

function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .stringMatchesSomePattern */ .U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .stringMatchesSomePattern */ .U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .stringMatchesSomePattern */ .U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .stringMatchesSomePattern */ .U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  const possibleMessages = [];

  if (event.message) {
    possibleMessages.push(event.message);
  }

  let lastException;
  try {
    // @ts-expect-error Try catching to save bundle size
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
    // try catching to save bundle size checking existence of variables
  }

  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }

  if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && possibleMessages.length === 0) {
    _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error(`Could not extract message for event ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event)}`);
  }

  return possibleMessages;
}

function _isSentryError(event) {
  try {
    // @ts-expect-error can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-expect-error we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error(`Cannot extract url for event ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map


/***/ }),

/***/ 40454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getMetricSummaryJsonForSpan; },
/* harmony export */   "v": function() { return /* binding */ updateMetricSummaryOnActiveSpan; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _tracing_trace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28218);






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */

let SPAN_METRIC_SUMMARY;

function getMetricStorageForSpan(span) {
  return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}

/**
 * Fetches the metric summary if it exists for the passed span
 */
function getMetricSummaryJsonForSpan(span) {
  const storage = getMetricStorageForSpan(span);

  if (!storage) {
    return undefined;
  }
  const output = {};

  for (const [, [exportKey, summary]] of storage) {
    if (!output[exportKey]) {
      output[exportKey] = [];
    }

    output[exportKey].push((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(summary));
  }

  return output;
}

/**
 * Updates the metric summary on the currently active span
 */
function updateMetricSummaryOnActiveSpan(
  metricType,
  sanitizedName,
  value,
  unit,
  tags,
  bucketKey,
) {
  const span = (0,_tracing_trace_js__WEBPACK_IMPORTED_MODULE_1__/* .getActiveSpan */ .HN)();
  if (span) {
    const storage = getMetricStorageForSpan(span) || new Map();

    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);

    if (bucketItem) {
      const [, summary] = bucketItem;
      storage.set(bucketKey, [
        exportKey,
        {
          min: Math.min(summary.min, value),
          max: Math.max(summary.max, value),
          count: (summary.count += 1),
          sum: (summary.sum += value),
          tags: summary.tags,
        },
      ]);
    } else {
      storage.set(bucketKey, [
        exportKey,
        {
          min: value,
          max: value,
          count: 1,
          sum: value,
          tags,
        },
      ]);
    }

    if (!SPAN_METRIC_SUMMARY) {
      SPAN_METRIC_SUMMARY = new WeakMap();
    }

    SPAN_METRIC_SUMMARY.set(span, storage);
  }
}


//# sourceMappingURL=metric-summary.js.map


/***/ }),

/***/ 41666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ic": function() { return /* binding */ getBucketKey; },
/* harmony export */   "s3": function() { return /* binding */ sanitizeMetricKey; },
/* harmony export */   "Bg": function() { return /* binding */ sanitizeTags; },
/* harmony export */   "OC": function() { return /* binding */ sanitizeUnit; },
/* harmony export */   "uv": function() { return /* binding */ serializeMetricBuckets; },
/* harmony export */   "M": function() { return /* binding */ simpleHash; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);


/**
 * Generate bucket key from metric properties.
 */
function getBucketKey(
  metricType,
  name,
  unit,
  tags,
) {
  const stringifiedTags = Object.entries((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(tags)).sort((a, b) => a[0].localeCompare(b[0]));
  return `${metricType}${name}${unit}${stringifiedTags}`;
}

/* eslint-disable no-bitwise */
/**
 * Simple hash function for strings.
 */
function simpleHash(s) {
  let rv = 0;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    rv = (rv << 5) - rv + c;
    rv &= rv;
  }
  return rv >>> 0;
}
/* eslint-enable no-bitwise */

/**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */
function serializeMetricBuckets(metricBucketItems) {
  let out = '';
  for (const item of metricBucketItems) {
    const tagEntries = Object.entries(item.tags);
    const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value]) => `${key}:${value}`).join(',')}` : '';
    out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
  }
  return out;
}

/** Sanitizes units */
function sanitizeUnit(unit) {
  return unit.replace(/[^\w]+/gi, '_');
}

/** Sanitizes metric keys */
function sanitizeMetricKey(key) {
  return key.replace(/[^\w\-.]+/gi, '_');
}

function sanitizeTagKey(key) {
  return key.replace(/[^\w\-./]+/gi, '');
}

const tagValueReplacements = [
  ['\n', '\\n'],
  ['\r', '\\r'],
  ['\t', '\\t'],
  ['\\', '\\\\'],
  ['|', '\\u{7c}'],
  [',', '\\u{2c}'],
];

function getCharOrReplacement(input) {
  for (const [search, replacement] of tagValueReplacements) {
    if (input === search) {
      return replacement;
    }
  }

  return input;
}

function sanitizeTagValue(value) {
  return [...value].reduce((acc, char) => acc + getCharOrReplacement(char), '');
}

/**
 * Sanitizes tags.
 */
function sanitizeTags(unsanitizedTags) {
  const tags = {};
  for (const key in unsanitizedTags) {
    if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
      const sanitizedKey = sanitizeTagKey(key);
      tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
    }
  }
  return tags;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 77172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sX": function() { return /* binding */ Scope; },
/* harmony export */   "lW": function() { return /* binding */ getGlobalScope; }
/* harmony export */ });
/* unused harmony export setGlobalScope */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48593);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24703);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58786);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21712);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63965);
/* harmony import */ var _utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43884);





/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */
let globalScope;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /**
   * Transaction Name
   */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  /** The client on this scope */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
   static clone(scope) {
    return scope ? scope.clone() : new Scope();
  }

  /**
   * Clone this scope instance.
   */
   clone() {
    const newScope = new Scope();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = { ...this._tags };
    newScope._extra = { ...this._extra };
    newScope._contexts = { ...this._contexts };
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._span = this._span;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._requestSession = this._requestSession;
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
    newScope._propagationContext = { ...this._propagationContext };
    newScope._client = this._client;

    return newScope;
  }

  /** Update the client on the scope. */
   setClient(client) {
    this._client = client;
  }

  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
   getClient() {
    return this._client;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    // If null is passed we want to unset everything, but still define keys,
    // so that later down in the pipeline any existing values are cleared.
    this._user = user || {
      email: undefined,
      id: undefined,
      ip_address: undefined,
      segment: undefined,
      username: undefined,
    };

    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the transaction name on the scope for future events.
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
   getSpan() {
    return this._span;
  }

  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this._span;
    // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
    // Also, this method will be removed anyway.
    // eslint-disable-next-line deprecation/deprecation
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;

    if (scopeToMerge instanceof Scope) {
      const scopeData = scopeToMerge.getScopeData();

      this._tags = { ...this._tags, ...scopeData.tags };
      this._extra = { ...this._extra, ...scopeData.extra };
      this._contexts = { ...this._contexts, ...scopeData.contexts };
      if (scopeData.user && Object.keys(scopeData.user).length) {
        this._user = scopeData.user;
      }
      if (scopeData.level) {
        this._level = scopeData.level;
      }
      if (scopeData.fingerprint.length) {
        this._fingerprint = scopeData.fingerprint;
      }
      if (scopeToMerge.getRequestSession()) {
        this._requestSession = scopeToMerge.getRequestSession();
      }
      if (scopeData.propagationContext) {
        this._propagationContext = scopeData.propagationContext;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(scopeToMerge)) {
      const scopeContext = captureContext ;
      this._tags = { ...this._tags, ...scopeContext.tags };
      this._extra = { ...this._extra, ...scopeContext.extra };
      this._contexts = { ...this._contexts, ...scopeContext.contexts };
      if (scopeContext.user) {
        this._user = scopeContext.user;
      }
      if (scopeContext.level) {
        this._level = scopeContext.level;
      }
      if (scopeContext.fingerprint) {
        this._fingerprint = scopeContext.fingerprint;
      }
      if (scopeContext.requestSession) {
        this._requestSession = scopeContext.requestSession;
      }
      if (scopeContext.propagationContext) {
        this._propagationContext = scopeContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };

    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
   getAttachments() {
    const data = this.getScopeData();

    return data.attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /** @inheritDoc */
   getScopeData() {
    const {
      _breadcrumbs,
      _attachments,
      _contexts,
      _tags,
      _extra,
      _user,
      _level,
      _fingerprint,
      _eventProcessors,
      _propagationContext,
      _sdkProcessingMetadata,
      _transactionName,
      _span,
    } = this;

    return {
      breadcrumbs: _breadcrumbs,
      attachments: _attachments,
      contexts: _contexts,
      tags: _tags,
      extra: _extra,
      user: _user,
      level: _level,
      fingerprint: _fingerprint || [],
      eventProcessors: _eventProcessors,
      propagationContext: _propagationContext,
      sdkProcessingMetadata: _sdkProcessingMetadata,
      transactionName: _transactionName,
      span: _span,
    };
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
   applyToEvent(
    event,
    hint = {},
    additionalEventProcessors = [],
  ) {
    (0,_utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .applyScopeDataToEvent */ .gi)(event, this.getScopeData());

    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
      ...additionalEventProcessors,
      // eslint-disable-next-line deprecation/deprecation
      ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalEventProcessors */ .fH)(),
      ...this._eventProcessors,
    ];

    return (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyEventProcessors */ .RP)(eventProcessors, event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
   captureException(exception, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture exception!');
      return eventId;
    }

    const syntheticException = new Error('Sentry syntheticException');

    this._client.captureException(
      exception,
      {
        originalException: exception,
        syntheticException,
        ...hint,
        event_id: eventId,
      },
      this,
    );

    return eventId;
  }

  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
   captureMessage(message, level, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture message!');
      return eventId;
    }

    const syntheticException = new Error(message);

    this._client.captureMessage(
      message,
      level,
      {
        originalException: message,
        syntheticException,
        ...hint,
        event_id: eventId,
      },
      this,
    );

    return eventId;
  }

  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture event!');
      return eventId;
    }

    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);

    return eventId;
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}

/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */
function getGlobalScope() {
  if (!globalScope) {
    globalScope = new Scope();
  }

  return globalScope;
}

/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */
function setGlobalScope(scope) {
  globalScope = scope;
}

function generatePropagationContext() {
  return {
    traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)(),
    spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)().substring(16),
  };
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 82536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ initAndBind; },
/* harmony export */   "K": function() { return /* binding */ setCurrentClient; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58786);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42598);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13976);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10857);





/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .logger.enable */ .kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .consoleSandbox */ .Cf)(() => {
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
      });
    }
  }
  const scope = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  setCurrentClient(client);
  initializeClient(client);
}

/**
 * Make the given client the current client.
 */
function setCurrentClient(client) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentHub */ .Gd)();
  // eslint-disable-next-line deprecation/deprecation
  const top = hub.getStackTop();
  top.client = client;
  top.scope.setClient(client);
}

/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */
function initializeClient(client) {
  if (client.init) {
    client.init();
    // TODO v8: Remove this fallback
    // eslint-disable-next-line deprecation/deprecation
  } else if (client.setupIntegrations) {
    // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
  }
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 46595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p6": function() { return /* binding */ SEMANTIC_ATTRIBUTE_PROFILE_ID; },
/* harmony export */   "$J": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_OP; },
/* harmony export */   "S3": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN; },
/* harmony export */   "TE": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE; },
/* harmony export */   "Zj": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SOURCE; }
/* harmony export */ });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';

/**
 * Use this attribute to represent the sample rate used for a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';

/**
 * Use this attribute to represent the operation of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';

/**
 * Use this attribute to represent the origin of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';

/**
 * The id of the profile that this span occured in.
 */
const SEMANTIC_ATTRIBUTE_PROFILE_ID = 'profile_id';


//# sourceMappingURL=semanticAttributes.js.map


/***/ }),

/***/ 63965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RJ": function() { return /* binding */ closeSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "CT": function() { return /* binding */ updateSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24703);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76721);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 59278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getDynamicSamplingContextFromClient; },
/* harmony export */   "j": function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69356);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13976);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43889);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4859);






/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(
  trace_id,
  client,
  scope,
) {
  const options = client.getOptions();

  const { publicKey: public_key } = client.getDsn() || {};
  // TODO(v8): Remove segment from User
  // eslint-disable-next-line deprecation/deprecation
  const { segment: user_segment } = (scope && scope.getUser()) || {};

  const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
    release: options.release,
    user_segment,
    public_key,
    trace_id,
  }) ;

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}

/**
 * A Span with a frozen dynamic sampling context.
 */

/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */
function getDynamicSamplingContextFromSpan(span) {
  const client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
  if (!client) {
    return {};
  }

  // passing emit=false here to only emit later once the DSC is actually populated
  const dsc = getDynamicSamplingContextFromClient((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).trace_id || '', client, (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)());

  // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
  const txn = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span) ;
  if (!txn) {
    return dsc;
  }

  // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
  // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
  // @see Transaction class constructor
  const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
  if (v7FrozenDsc) {
    return v7FrozenDsc;
  }

  // TODO (v8): Replace txn.metadata with txn.attributes[]
  // We can't do this yet because attributes aren't always set yet.
  // eslint-disable-next-line deprecation/deprecation
  const { sampleRate: maybeSampleRate, source } = txn.metadata;
  if (maybeSampleRate != null) {
    dsc.sample_rate = `${maybeSampleRate}`;
  }

  // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
  const jsonSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(txn);

  // after JSON conversion, txn.name becomes jsonSpan.description
  if (source && source !== 'url') {
    dsc.transaction = jsonSpan.description;
  }

  dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(txn));

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}


//# sourceMappingURL=dynamicSamplingContext.js.map


/***/ }),

/***/ 91617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ addTracingExtensions; },
  "l": function() { return /* binding */ startIdleTransaction; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(42598);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(10857);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(4859);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/globalError.js
var globalError = __webpack_require__(80730);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/globalUnhandledRejection.js
var globalUnhandledRejection = __webpack_require__(920);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(77257);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/errors.js




let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  (0,globalError/* addGlobalErrorInstrumentationHandler */.V)(errorCallback);
  (0,globalUnhandledRejection/* addGlobalUnhandledRejectionInstrumentationHandler */.h)(errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  // eslint-disable-next-line deprecation/deprecation
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(83815);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/sampling.js
var sampling = __webpack_require__(3745);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/transaction.js
var tracing_transaction = __webpack_require__(31069);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/hubextensions.js









/** Returns all trace headers that are currently on the top scope. */
// eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
  // eslint-disable-next-line deprecation/deprecation
  const scope = this.getScope();
  // eslint-disable-next-line deprecation/deprecation
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': (0,spanUtils/* spanToTraceHeader */.Hb)(span),
      }
    : {};
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(
  // eslint-disable-next-line deprecation/deprecation

  transactionContext,
  customSamplingContext,
) {
  // eslint-disable-next-line deprecation/deprecation
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    debug_build/* DEBUG_BUILD */.X &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    // eslint-disable-next-line deprecation/deprecation
    transactionContext.sampled = false;
  }

  // eslint-disable-next-line deprecation/deprecation
  let transaction = new tracing_transaction/* Transaction */.Y(transactionContext, this);
  transaction = (0,sampling/* sampleTransaction */.f)(transaction, options, {
    name: transactionContext.name,
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.data,
      ...transactionContext.attributes,
    },
    ...customSamplingContext,
  });
  if (transaction.isRecording()) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  // eslint-disable-next-line deprecation/deprecation
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
  delayAutoFinishUntilSignal = false,
) {
  // eslint-disable-next-line deprecation/deprecation
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  // eslint-disable-next-line deprecation/deprecation
  let transaction = new idletransaction/* IdleTransaction */.io(
    transactionContext,
    hub,
    idleTimeout,
    finalTimeout,
    heartbeatInterval,
    onScope,
    delayAutoFinishUntilSignal,
  );
  transaction = (0,sampling/* sampleTransaction */.f)(transaction, options, {
    name: transactionContext.name,
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.data,
      ...transactionContext.attributes,
    },
    ...customSamplingContext,
  });
  if (transaction.isRecording()) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 83815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "AT": function() { return /* binding */ TRACING_DEFAULTS; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24703);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42598);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4859);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60649);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31069);






const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .g {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanContext().spanId !== this.transactionSpanId) {
      // We patch span.end() to pop an activity after setting an endTimestamp.
      // eslint-disable-next-line @typescript-eslint/unbound-method
      const originalEnd = span.end;
      span.end = (...rest) => {
        this._popActivity(span.spanContext().spanId);
        return originalEnd.apply(span, rest);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if ((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToJSON */ .XU)(span).timestamp === undefined) {
        this._pushActivity(span.spanContext().spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  // We should not use heartbeat if we finished a transaction

  // Idle timeout was canceled and we should finish the transaction with the last span end.

  /**
   * Timer that tracks Transaction idleTimeout
   */

  /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
   constructor(
    transactionContext,
    // eslint-disable-next-line deprecation/deprecation
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
    /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */
    delayAutoFinishUntilSignal = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;
    this.activities = {};
    this._heartbeatCounter = 0;
    this._finished = false;
    this._idleTimeoutCanceledPermanently = false;
    this._beforeFinishCallbacks = [];
    this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
    this._autoFinishAllowed = !delayAutoFinishUntilSignal;

    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
      // eslint-disable-next-line deprecation/deprecation
      _idleHub.getScope().setSpan(this);
    }

    if (!delayAutoFinishUntilSignal) {
      this._restartIdleTimeout();
    }

    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.end();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   end(endTimestamp) {
    const endTimestampInS = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanTimeInputToSeconds */ .$k)(endTimestamp);

    this._finished = true;
    this.activities = {};

    // eslint-disable-next-line deprecation/deprecation
    if (this.op === 'ui.action.click') {
      this.setAttribute(FINISH_REASON_TAG, this._finishReason);
    }

    // eslint-disable-next-line deprecation/deprecation
    if (this.spanRecorder) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X &&
        // eslint-disable-next-line deprecation/deprecation
        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestampInS);
      }

      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanContext().spanId === this.spanContext().spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!(0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToJSON */ .XU)(span).timestamp) {
          span.setStatus('cancelled');
          span.end(endTimestampInS);
          _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const { start_timestamp: startTime, timestamp: endTime } = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToJSON */ .XU)(span);
        const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;

        // Add a delta with idle timeout so that we prevent false positives
        const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
        const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;

        if (_debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X) {
          const stringifiedSpan = JSON.stringify(span, undefined, 2);
          if (!spanStartedBeforeTransactionFinish) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
          } else if (!spanEndedBeforeFinalTimeout) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
          }
        }

        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
      });

      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      // eslint-disable-next-line deprecation/deprecation
      const scope = this._idleHub.getScope();
      // eslint-disable-next-line deprecation/deprecation
      if (scope.getTransaction() === this) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(undefined);
      }
    }

    return super.end(endTimestamp);
  }

  /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    // eslint-disable-next-line deprecation/deprecation
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    // eslint-disable-next-line deprecation/deprecation
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.end(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */
   sendAutoFinishSignal() {
    if (!this._autoFinishAllowed) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] Received finish signal for idle transaction.');
      this._restartIdleTimeout();
      this._autoFinishAllowed = true;
    }
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.end(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .timestampInSeconds */ .ph)();
      if (this._idleTimeoutCanceledPermanently) {
        if (this._autoFinishAllowed) {
          this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
          this.end(endTimestamp);
        }
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      if (this._autoFinishAllowed) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
        this.end();
      }
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 3578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ setMeasurement; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77257);


/**
 * Adds a measurement to the current active transaction.
 */
function setMeasurement(name, value, unit) {
  // eslint-disable-next-line deprecation/deprecation
  const transaction = (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .getActiveTransaction */ .x1)();
  if (transaction) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
  }
}


//# sourceMappingURL=measurement.js.map


/***/ }),

/***/ 3745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ isValidSampleRate; },
/* harmony export */   "f": function() { return /* binding */ sampleTransaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48593);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42598);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46595);
/* harmony import */ var _utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7554);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4859);






/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */
function sampleTransaction(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_0__/* .hasTracingEnabled */ .z)(options)) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  // eslint-disable-next-line deprecation/deprecation
  if (transaction.sampled !== undefined) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, Number(transaction.sampled));
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, Number(sampleRate));
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, Number(sampleRate));
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, sampleRate);
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  // eslint-disable-next-line deprecation/deprecation
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  // eslint-disable-next-line deprecation/deprecation
  if (!transaction.sampled) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X &&
    // eslint-disable-next-line deprecation/deprecation
    _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] starting ${transaction.op} transaction - ${(0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .spanToJSON */ .XU)(transaction).description}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isNaN */ .i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}


//# sourceMappingURL=sampling.js.map


/***/ }),

/***/ 60649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Span; },
/* harmony export */   "g": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24703);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76721);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42598);
/* harmony import */ var _metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40454);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46595);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43889);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4859);
/* harmony import */ var _spanstatus_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35818);








/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {

   constructor(maxlen = 1000) {
    this._maxlen = maxlen;
    this.spans = [];
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      // eslint-disable-next-line deprecation/deprecation
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */

  /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */

  /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */

  /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */

  /** Epoch timestamp in seconds when the span started. */

  /** Epoch timestamp in seconds when the span ended. */

  /** Internal keeper of the status */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();
    this._spanId = spanContext.spanId || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);
    this._startTime = spanContext.startTimestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .ph)();
    // eslint-disable-next-line deprecation/deprecation
    this.tags = spanContext.tags ? { ...spanContext.tags } : {};
    // eslint-disable-next-line deprecation/deprecation
    this.data = spanContext.data ? { ...spanContext.data } : {};
    // eslint-disable-next-line deprecation/deprecation
    this.instrumenter = spanContext.instrumenter || 'sentry';

    this._attributes = {};
    this.setAttributes({
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3]: spanContext.origin || 'manual',
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J]: spanContext.op,
      ...spanContext.attributes,
    });

    // eslint-disable-next-line deprecation/deprecation
    this._name = spanContext.name || spanContext.description;

    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.status) {
      this._status = spanContext.status;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    if (spanContext.exclusiveTime !== undefined) {
      this._exclusiveTime = spanContext.exclusiveTime;
    }
    this._measurements = spanContext.measurements ? { ...spanContext.measurements } : {};
  }

  // This rule conflicts with another eslint rule :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get name() {
    return this._name || '';
  }

  /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   set name(name) {
    this.updateName(name);
  }

  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get description() {
    return this._name;
  }

  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   set description(description) {
    this._name = description;
  }

  /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */
   get traceId() {
    return this._traceId;
  }

  /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */
   set traceId(traceId) {
    this._traceId = traceId;
  }

  /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */
   get spanId() {
    return this._spanId;
  }

  /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */
   set spanId(spanId) {
    this._spanId = spanId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */
   set parentSpanId(string) {
    this._parentSpanId = string;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */
   get parentSpanId() {
    return this._parentSpanId;
  }

  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */
   get sampled() {
    return this._sampled;
  }

  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */
   set sampled(sampled) {
    this._sampled = sampled;
  }

  /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
   get attributes() {
    return this._attributes;
  }

  /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */
   set attributes(attributes) {
    this._attributes = attributes;
  }

  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */
   get startTimestamp() {
    return this._startTime;
  }

  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */
   set startTimestamp(startTime) {
    this._startTime = startTime;
  }

  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */
   get endTimestamp() {
    return this._endTime;
  }

  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */
   set endTimestamp(endTime) {
    this._endTime = endTime;
  }

  /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */
   get status() {
    return this._status;
  }

  /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */
   set status(status) {
    this._status = status;
  }

  /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */
   get op() {
    return this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J] ;
  }

  /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */
   set op(op) {
    this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J, op);
  }

  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */
   get origin() {
    return this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3] ;
  }

  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */
   set origin(origin) {
    this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3, origin);
  }

  /* eslint-enable @typescript-eslint/member-ordering */

  /** @inheritdoc */
   spanContext() {
    const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
    return {
      spanId,
      traceId,
      traceFlags: sampled ? _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACE_FLAG_SAMPLED */ .i0 : _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACE_FLAG_NONE */ .ve,
    };
  }

  /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this._spanId,
      sampled: this._sampled,
      traceId: this._traceId,
    });

    // eslint-disable-next-line deprecation/deprecation
    childSpan.spanRecorder = this.spanRecorder;
    // eslint-disable-next-line deprecation/deprecation
    if (childSpan.spanRecorder) {
      // eslint-disable-next-line deprecation/deprecation
      childSpan.spanRecorder.add(childSpan);
    }

    const rootSpan = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(this);
    // TODO: still set span.transaction here until we have a more permanent solution
    // Probably similarly to the weakmap we hold in node-experimental
    // eslint-disable-next-line deprecation/deprecation
    childSpan.transaction = rootSpan ;

    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_5__/* .DEBUG_BUILD */ .X && rootSpan) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(childSpan).description || '< unknown name >';
      const idStr = rootSpan.spanContext().spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.log */ .kg.log(logMessage);
      this._logMessage = logMessage;
    }

    return childSpan;
  }

  /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */
   setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setData(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /** @inheritdoc */
   setAttribute(key, value) {
    if (value === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._attributes[key];
    } else {
      this._attributes[key] = value;
    }
  }

  /** @inheritdoc */
   setAttributes(attributes) {
    Object.keys(attributes).forEach(key => this.setAttribute(key, attributes[key]));
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this._status = value;
    return this;
  }

  /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */
   setHttpStatus(httpStatus) {
    (0,_spanstatus_js__WEBPACK_IMPORTED_MODULE_7__/* .setHttpStatus */ .Q0)(this, httpStatus);
    return this;
  }

  /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */
   setName(name) {
    this.updateName(name);
  }

  /**
   * @inheritDoc
   */
   updateName(name) {
    this._name = name;
    return this;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */
   isSuccess() {
    return this._status === 'ok';
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */
   finish(endTimestamp) {
    return this.end(endTimestamp);
  }

  /** @inheritdoc */
   end(endTimestamp) {
    // If already ended, skip
    if (this._endTime) {
      return;
    }
    const rootSpan = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(this);
    if (
      _debug_build_js__WEBPACK_IMPORTED_MODULE_5__/* .DEBUG_BUILD */ .X &&
      // Don't call this for transactions
      rootSpan &&
      rootSpan.spanContext().spanId !== this._spanId
    ) {
      const logMessage = this._logMessage;
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this._endTime = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanTimeInputToSeconds */ .$k)(endTimestamp);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */
   toTraceparent() {
    return (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToTraceHeader */ .Hb)(this);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .dropUndefinedKeys */ .Jr)({
      data: this._getData(),
      description: this._name,
      endTimestamp: this._endTime,
      // eslint-disable-next-line deprecation/deprecation
      op: this.op,
      parentSpanId: this._parentSpanId,
      sampled: this._sampled,
      spanId: this._spanId,
      startTimestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      traceId: this._traceId,
    });
  }

  /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */
   updateWithContext(spanContext) {
    // eslint-disable-next-line deprecation/deprecation
    this.data = spanContext.data || {};
    // eslint-disable-next-line deprecation/deprecation
    this._name = spanContext.name || spanContext.description;
    this._endTime = spanContext.endTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    this.op = spanContext.op;
    this._parentSpanId = spanContext.parentSpanId;
    this._sampled = spanContext.sampled;
    this._spanId = spanContext.spanId || this._spanId;
    this._startTime = spanContext.startTimestamp || this._startTime;
    this._status = spanContext.status;
    // eslint-disable-next-line deprecation/deprecation
    this.tags = spanContext.tags || {};
    this._traceId = spanContext.traceId || this._traceId;

    return this;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */
   getTraceContext() {
    return (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToTraceContext */ .wy)(this);
  }

  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
   getSpanJSON() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .dropUndefinedKeys */ .Jr)({
      data: this._getData(),
      description: this._name,
      op: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J] ,
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3] ,
      _metrics_summary: (0,_metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_9__/* .getMetricSummaryJsonForSpan */ .y)(this),
      profile_id: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_PROFILE_ID */ .p6] ,
      exclusive_time: this._exclusiveTime,
      measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined,
    });
  }

  /** @inheritdoc */
   isRecording() {
    return !this._endTime && !!this._sampled;
  }

  /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */
   toJSON() {
    return this.getSpanJSON();
  }

  /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */
   _getData()

 {
    // eslint-disable-next-line deprecation/deprecation
    const { data, _attributes: attributes } = this;

    const hasData = Object.keys(data).length > 0;
    const hasAttributes = Object.keys(attributes).length > 0;

    if (!hasData && !hasAttributes) {
      return undefined;
    }

    if (hasData && hasAttributes) {
      return {
        ...data,
        ...attributes,
      };
    }

    return hasData ? data : attributes;
  }
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 35818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ix": function() { return /* binding */ getSpanStatusFromHttpCode; },
/* harmony export */   "Q0": function() { return /* binding */ setHttpStatus; },
/* harmony export */   "Zd": function() { return /* binding */ spanStatusfromHttpCode; }
/* harmony export */ });
/* unused harmony export SpanStatus */
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */
var SpanStatus; (function (SpanStatus) {
  /** The operation completed successfully. */
  const Ok = 'ok'; SpanStatus["Ok"] = Ok;
  /** Deadline expired before operation could complete. */
  const DeadlineExceeded = 'deadline_exceeded'; SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
  /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
  const Unauthenticated = 'unauthenticated'; SpanStatus["Unauthenticated"] = Unauthenticated;
  /** 403 Forbidden */
  const PermissionDenied = 'permission_denied'; SpanStatus["PermissionDenied"] = PermissionDenied;
  /** 404 Not Found. Some requested entity (file or directory) was not found. */
  const NotFound = 'not_found'; SpanStatus["NotFound"] = NotFound;
  /** 429 Too Many Requests */
  const ResourceExhausted = 'resource_exhausted'; SpanStatus["ResourceExhausted"] = ResourceExhausted;
  /** Client specified an invalid argument. 4xx. */
  const InvalidArgument = 'invalid_argument'; SpanStatus["InvalidArgument"] = InvalidArgument;
  /** 501 Not Implemented */
  const Unimplemented = 'unimplemented'; SpanStatus["Unimplemented"] = Unimplemented;
  /** 503 Service Unavailable */
  const Unavailable = 'unavailable'; SpanStatus["Unavailable"] = Unavailable;
  /** Other/generic 5xx. */
  const InternalError = 'internal_error'; SpanStatus["InternalError"] = InternalError;
  /** Unknown. Any non-standard HTTP status code. */
  const UnknownError = 'unknown_error'; SpanStatus["UnknownError"] = UnknownError;
  /** The operation was cancelled (typically by the user). */
  const Cancelled = 'cancelled'; SpanStatus["Cancelled"] = Cancelled;
  /** Already exists (409) */
  const AlreadyExists = 'already_exists'; SpanStatus["AlreadyExists"] = AlreadyExists;
  /** Operation was rejected because the system is not in a state required for the operation's */
  const FailedPrecondition = 'failed_precondition'; SpanStatus["FailedPrecondition"] = FailedPrecondition;
  /** The operation was aborted, typically due to a concurrency issue. */
  const Aborted = 'aborted'; SpanStatus["Aborted"] = Aborted;
  /** Operation was attempted past the valid range. */
  const OutOfRange = 'out_of_range'; SpanStatus["OutOfRange"] = OutOfRange;
  /** Unrecoverable data loss or corruption */
  const DataLoss = 'data_loss'; SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function getSpanStatusFromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
const spanStatusfromHttpCode = getSpanStatusFromHttpCode;

/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */
function setHttpStatus(span, httpStatus) {
  // TODO (v8): Remove these calls
  // Relay does not require us to send the status code as a tag
  // For now, just because users might expect it to land as a tag we keep sending it.
  // Same with data.
  // In v8, we replace both, simply with
  // span.setAttribute('http.response.status_code', httpStatus);

  // eslint-disable-next-line deprecation/deprecation
  span.setTag('http.status_code', String(httpStatus));
  // eslint-disable-next-line deprecation/deprecation
  span.setData('http.response.status_code', httpStatus);

  const spanStatus = getSpanStatusFromHttpCode(httpStatus);
  if (spanStatus !== 'unknown_error') {
    span.setStatus(spanStatus);
  }
}


//# sourceMappingURL=spanstatus.js.map


/***/ }),

/***/ 28218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yn": function() { return /* binding */ continueTrace; },
/* harmony export */   "HN": function() { return /* binding */ getActiveSpan; },
/* harmony export */   "I1": function() { return /* binding */ getCapturedScopesOnSpan; },
/* harmony export */   "qp": function() { return /* binding */ startInactiveSpan; },
/* harmony export */   "GK": function() { return /* binding */ startSpan; },
/* harmony export */   "V0": function() { return /* binding */ startSpanManual; },
/* harmony export */   "g4": function() { return /* binding */ trace; }
/* harmony export */ });
/* unused harmony export startActiveSpan */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75771);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58786);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76721);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42598);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10857);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4859);
/* harmony import */ var _dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59278);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13976);
/* harmony import */ var _utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42885);
/* harmony import */ var _utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7554);











/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */
function trace(
  context,
  callback,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  afterFinish = () => {},
) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)();
  // eslint-disable-next-line deprecation/deprecation
  const parentSpan = scope.getSpan();

  const spanContext = normalizeContext(context);
  const activeSpan = createChildSpanOrTransaction(hub, {
    parentSpan,
    spanContext,
    forceTransaction: false,
    scope,
  });

  // eslint-disable-next-line deprecation/deprecation
  scope.setSpan(activeSpan);

  return (0,_utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__/* .handleCallbackErrors */ .i)(
    () => callback(activeSpan),
    error => {
      activeSpan && activeSpan.setStatus('internal_error');
      onError(error, activeSpan);
    },
    () => {
      activeSpan && activeSpan.end();
      // eslint-disable-next-line deprecation/deprecation
      scope.setSpan(parentSpan);
      afterFinish();
    },
  );
}

/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startSpan(context, callback) {
  const spanContext = normalizeContext(context);

  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(() => {
    return (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .$e)(context.scope, scope => {
      // eslint-disable-next-line deprecation/deprecation
      const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
      // eslint-disable-next-line deprecation/deprecation
      const parentSpan = scope.getSpan();

      const shouldSkipSpan = context.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan
        ? undefined
        : createChildSpanOrTransaction(hub, {
            parentSpan,
            spanContext,
            forceTransaction: context.forceTransaction,
            scope,
          });

      return (0,_utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__/* .handleCallbackErrors */ .i)(
        () => callback(activeSpan),
        () => {
          // Only update the span status if it hasn't been changed yet
          if (activeSpan) {
            const { status } = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(activeSpan);
            if (!status || status === 'ok') {
              activeSpan.setStatus('internal_error');
            }
          }
        },
        () => activeSpan && activeSpan.end(),
      );
    });
  });
}

/**
 * @deprecated Use {@link startSpan} instead.
 */
const startActiveSpan = (/* unused pure expression or super */ null && (startSpan));

/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startSpanManual(
  context,
  callback,
) {
  const spanContext = normalizeContext(context);

  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(() => {
    return (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .$e)(context.scope, scope => {
      // eslint-disable-next-line deprecation/deprecation
      const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
      // eslint-disable-next-line deprecation/deprecation
      const parentSpan = scope.getSpan();

      const shouldSkipSpan = context.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan
        ? undefined
        : createChildSpanOrTransaction(hub, {
            parentSpan,
            spanContext,
            forceTransaction: context.forceTransaction,
            scope,
          });

      function finishAndSetSpan() {
        activeSpan && activeSpan.end();
      }

      return (0,_utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__/* .handleCallbackErrors */ .i)(
        () => callback(activeSpan, finishAndSetSpan),
        () => {
          // Only update the span status if it hasn't been changed yet, and the span is not yet finished
          if (activeSpan && activeSpan.isRecording()) {
            const { status } = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(activeSpan);
            if (!status || status === 'ok') {
              activeSpan.setStatus('internal_error');
            }
          }
        },
      );
    });
  });
}

/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startInactiveSpan(context) {
  if (!(0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_4__/* .hasTracingEnabled */ .z)()) {
    return undefined;
  }

  const spanContext = normalizeContext(context);
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const parentSpan = context.scope
    ? // eslint-disable-next-line deprecation/deprecation
      context.scope.getSpan()
    : getActiveSpan();

  const shouldSkipSpan = context.onlyIfParent && !parentSpan;

  if (shouldSkipSpan) {
    return undefined;
  }

  const scope = context.scope || (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)();

  // Even though we don't actually want to make this span active on the current scope,
  // we need to make it active on a temporary scope that we use for event processing
  // as otherwise, it won't pick the correct span for the event when processing it
  const temporaryScope = (scope ).clone();

  return createChildSpanOrTransaction(hub, {
    parentSpan,
    spanContext,
    forceTransaction: context.forceTransaction,
    scope: temporaryScope,
  });
}

/**
 * Returns the currently active span.
 */
function getActiveSpan() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)().getSpan();
}

const continueTrace = (
  {
    sentryTrace,
    baggage,
  }

,
  callback,
) => {
  // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
  /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */

  const currentScope = (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)();

  // eslint-disable-next-line deprecation/deprecation
  const { traceparentData, dynamicSamplingContext, propagationContext } = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .tracingContextFromHeaders */ .KA)(
    sentryTrace,
    baggage,
  );

  currentScope.setPropagationContext(propagationContext);

  if (_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && traceparentData) {
    _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
  }

  const transactionContext = {
    ...traceparentData,
    metadata: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .dropUndefinedKeys */ .Jr)({
      dynamicSamplingContext,
    }),
  };

  if (!callback) {
    return transactionContext;
  }

  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(() => {
    return callback(transactionContext);
  });
};

function createChildSpanOrTransaction(
  // eslint-disable-next-line deprecation/deprecation
  hub,
  {
    parentSpan,
    spanContext,
    forceTransaction,
    scope,
  }

,
) {
  if (!(0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_4__/* .hasTracingEnabled */ .z)()) {
    return undefined;
  }

  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();

  let span;
  if (parentSpan && !forceTransaction) {
    // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
  } else if (parentSpan) {
    // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
    const dsc = (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_9__/* .getDynamicSamplingContextFromSpan */ .j)(parentSpan);
    const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
    const sampled = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(parentSpan);

    // eslint-disable-next-line deprecation/deprecation
    span = hub.startTransaction({
      traceId,
      parentSpanId,
      parentSampled: sampled,
      ...spanContext,
      metadata: {
        dynamicSamplingContext: dsc,
        // eslint-disable-next-line deprecation/deprecation
        ...spanContext.metadata,
      },
    });
  } else {
    const { traceId, dsc, parentSpanId, sampled } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext(),
    };

    // eslint-disable-next-line deprecation/deprecation
    span = hub.startTransaction({
      traceId,
      parentSpanId,
      parentSampled: sampled,
      ...spanContext,
      metadata: {
        dynamicSamplingContext: dsc,
        // eslint-disable-next-line deprecation/deprecation
        ...spanContext.metadata,
      },
    });
  }

  // We always set this as active span on the scope
  // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
  // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
  // eslint-disable-next-line deprecation/deprecation
  scope.setSpan(span);

  setCapturedScopesOnSpan(span, scope, isolationScope);

  return span;
}

/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */
function normalizeContext(context) {
  if (context.startTime) {
    const ctx = { ...context };
    ctx.startTimestamp = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanTimeInputToSeconds */ .$k)(context.startTime);
    delete ctx.startTime;
    return ctx;
  }

  return context;
}

const SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';

function setCapturedScopesOnSpan(span, scope, isolationScope) {
  if (span) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .addNonEnumerableProperty */ .xp)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .addNonEnumerableProperty */ .xp)(span, SCOPE_ON_START_SPAN_FIELD, scope);
  }
}

/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */
function getCapturedScopesOnSpan(span) {
  return {
    scope: (span )[SCOPE_ON_START_SPAN_FIELD],
    isolationScope: (span )[ISOLATION_SCOPE_ON_START_SPAN_FIELD],
  };
}


//# sourceMappingURL=trace.js.map


/***/ }),

/***/ 31069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58786);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42598);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10857);
/* harmony import */ var _metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40454);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46595);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4859);
/* harmony import */ var _dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59278);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60649);
/* harmony import */ var _trace_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28218);










/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .D  {
  /**
   * The reference to the current hub.
   */
  // eslint-disable-next-line deprecation/deprecation

  // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  // eslint-disable-next-line deprecation/deprecation
   constructor(transactionContext, hub) {
    super(transactionContext);
    this._contexts = {};

    // eslint-disable-next-line deprecation/deprecation
    this._hub = hub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this._metadata = {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.metadata,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    // TODO (v8): Replace this with another way to set the root span
    // eslint-disable-next-line deprecation/deprecation
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  // This sadly conflicts with the getter/setter ordering :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get name() {
    return this._name;
  }

  /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */
   set name(newName) {
    // eslint-disable-next-line deprecation/deprecation
    this.setName(newName);
  }

  /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
   get metadata() {
    // We merge attributes in for backwards compatibility
    return {
      // Defaults
      // eslint-disable-next-line deprecation/deprecation
      source: 'custom',
      spanMetadata: {},

      // Legacy metadata
      ...this._metadata,

      // From attributes
      ...(this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj] && {
        source: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj] ,
      }),
      ...(this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE] && {
        sampleRate: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE] ,
      }),
    };
  }

  /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
   set metadata(metadata) {
    this._metadata = metadata;
  }

  /* eslint-enable @typescript-eslint/member-ordering */

  /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj, source);
  }

  /** @inheritdoc */
   updateName(name) {
    this._name = name;
    return this;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    // eslint-disable-next-line deprecation/deprecation
    if (!this.spanRecorder) {
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .g(maxlen);
    }
    // eslint-disable-next-line deprecation/deprecation
    this.spanRecorder.add(this);
  }

  /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */
   setMetadata(newMetadata) {
    this._metadata = { ...this._metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   end(endTimestamp) {
    const timestampInS = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanTimeInputToSeconds */ .$k)(endTimestamp);
    const transaction = this._finishTransaction(timestampInS);
    if (!transaction) {
      return undefined;
    }
    // eslint-disable-next-line deprecation/deprecation
    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    // eslint-disable-next-line deprecation/deprecation
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this._name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    // eslint-disable-next-line deprecation/deprecation
    super.updateWithContext(transactionContext);

    this._name = transactionContext.name || '';
    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */
   getDynamicSamplingContext() {
    return (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__/* .getDynamicSamplingContextFromSpan */ .j)(this);
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  // eslint-disable-next-line deprecation/deprecation
   setHub(hub) {
    this._hub = hub;
  }

  /**
   * Get the profile id of the transaction.
   */
   getProfileId() {
    if (this._contexts !== undefined && this._contexts['profile'] !== undefined) {
      return this._contexts['profile'].profile_id ;
    }
    return undefined;
  }

  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
   _finishTransaction(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this._endTime !== undefined) {
      return undefined;
    }

    if (!this._name) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this._name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.end(endTimestamp);

    // eslint-disable-next-line deprecation/deprecation
    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this._sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    // eslint-disable-next-line deprecation/deprecation
    const finishedSpans = this.spanRecorder
      ? // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.spans.filter(span => span !== this && (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).timestamp)
      : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      const endTimes = finishedSpans.map(span => (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).timestamp).filter(Boolean) ;
      this._endTime = endTimes.reduce((prev, current) => {
        return prev > current ? prev : current;
      });
    }

    const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0,_trace_js__WEBPACK_IMPORTED_MODULE_8__/* .getCapturedScopesOnSpan */ .I1)(this);

    // eslint-disable-next-line deprecation/deprecation
    const { metadata } = this;
    // eslint-disable-next-line deprecation/deprecation
    const { source } = metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToTraceContext */ .wy)(this),
      },
      // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
      spans: finishedSpans,
      start_timestamp: this._startTime,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      timestamp: this._endTime,
      transaction: this._name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        capturedSpanScope,
        capturedSpanIsolationScope,
        ...(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
          dynamicSamplingContext: (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__/* .getDynamicSamplingContextFromSpan */ .j)(this),
        }),
      },
      _metrics_summary: (0,_metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_9__/* .getMetricSummaryJsonForSpan */ .y)(this),
      ...(source && {
        transaction_info: {
          source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    // eslint-disable-next-line deprecation/deprecation
    _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);

    return transaction;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 77257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75771);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10857);




/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = maybeHub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  // eslint-disable-next-line deprecation/deprecation
  const scope = hub.getScope();
  // eslint-disable-next-line deprecation/deprecation
  return scope.getTransaction() ;
}

/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */
const extractTraceparentData = _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .extractTraceparentData */ .qG;


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 12653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ createTransport; }
});

// UNUSED EXPORTS: DEFAULT_TRANSPORT_BUFFER_SIZE

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/error.js
var esm_error = __webpack_require__(34026);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(17954);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new esm_error/* SentryError */.b('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(73506);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(94050);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(42598);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/base.js



const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
      const dataCategory = (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type);
      if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, dataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = (0,esm_envelope/* createEnvelope */.Jd)(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      (0,esm_envelope/* forEachEnvelopeItem */.gv)(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: (0,esm_envelope/* serializeEnvelope */.V$)(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = (0,ratelimit/* updateRateLimits */.WG)(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof esm_error/* SentryError */.b) {
          debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map


/***/ }),

/***/ 43884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gi": function() { return /* binding */ applyScopeDataToEvent; },
/* harmony export */   "yo": function() { return /* binding */ mergeScopeData; }
/* harmony export */ });
/* unused harmony export mergeAndOverwriteScopeData */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40901);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59278);
/* harmony import */ var _getRootSpan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43889);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4859);





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */
function applyScopeDataToEvent(event, data) {
  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;

  // Apply general data
  applyDataToEvent(event, data);

  // We want to set the trace context for normal events only if there isn't already
  // a trace context on the event. There is a product feature in place where we link
  // errors with transaction and it relies on that.
  if (span) {
    applySpanToEvent(event, span);
  }

  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}

/** Merge data of two scopes together. */
function mergeScopeData(data, mergeData) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    sdkProcessingMetadata,
    breadcrumbs,
    fingerprint,
    eventProcessors,
    attachments,
    propagationContext,
    // eslint-disable-next-line deprecation/deprecation
    transactionName,
    span,
  } = mergeData;

  mergeAndOverwriteScopeData(data, 'extra', extra);
  mergeAndOverwriteScopeData(data, 'tags', tags);
  mergeAndOverwriteScopeData(data, 'user', user);
  mergeAndOverwriteScopeData(data, 'contexts', contexts);
  mergeAndOverwriteScopeData(data, 'sdkProcessingMetadata', sdkProcessingMetadata);

  if (level) {
    data.level = level;
  }

  if (transactionName) {
    // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
  }

  if (span) {
    data.span = span;
  }

  if (breadcrumbs.length) {
    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
  }

  if (fingerprint.length) {
    data.fingerprint = [...data.fingerprint, ...fingerprint];
  }

  if (eventProcessors.length) {
    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
  }

  if (attachments.length) {
    data.attachments = [...data.attachments, ...attachments];
  }

  data.propagationContext = { ...data.propagationContext, ...propagationContext };
}

/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */
function mergeAndOverwriteScopeData

(data, prop, mergeVal) {
  if (mergeVal && Object.keys(mergeVal).length) {
    // Clone object
    data[prop] = { ...data[prop] };
    for (const key in mergeVal) {
      if (Object.prototype.hasOwnProperty.call(mergeVal, key)) {
        data[prop][key] = mergeVal[key];
      }
    }
  }
}

function applyDataToEvent(event, data) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    // eslint-disable-next-line deprecation/deprecation
    transactionName,
  } = data;

  const cleanedExtra = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(extra);
  if (cleanedExtra && Object.keys(cleanedExtra).length) {
    event.extra = { ...cleanedExtra, ...event.extra };
  }

  const cleanedTags = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(tags);
  if (cleanedTags && Object.keys(cleanedTags).length) {
    event.tags = { ...cleanedTags, ...event.tags };
  }

  const cleanedUser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(user);
  if (cleanedUser && Object.keys(cleanedUser).length) {
    event.user = { ...cleanedUser, ...event.user };
  }

  const cleanedContexts = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(contexts);
  if (cleanedContexts && Object.keys(cleanedContexts).length) {
    event.contexts = { ...cleanedContexts, ...event.contexts };
  }

  if (level) {
    event.level = level;
  }

  if (transactionName) {
    event.transaction = transactionName;
  }
}

function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...(event.breadcrumbs || []), ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}

function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata,
  };
}

function applySpanToEvent(event, span) {
  event.contexts = { trace: (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToTraceContext */ .wy)(span), ...event.contexts };
  const rootSpan = (0,_getRootSpan_js__WEBPACK_IMPORTED_MODULE_2__/* .getRootSpan */ .G)(span);
  if (rootSpan) {
    event.sdkProcessingMetadata = {
      dynamicSamplingContext: (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_3__/* .getDynamicSamplingContextFromSpan */ .j)(span),
      ...event.sdkProcessingMetadata,
    };
    const transactionName = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToJSON */ .XU)(rootSpan).description;
    if (transactionName) {
      event.tags = { transaction: transactionName, ...event.tags };
    }
  }
}

/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */
function applyFingerprintToEvent(event, fingerprint) {
  // Make sure it's an array first and we actually have something in place
  event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .arrayify */ .lE)(event.fingerprint) : [];

  // If we have something on the scope, then merge it with event
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }

  // If we have no data at all, remove empty array default
  if (event.fingerprint && !event.fingerprint.length) {
    delete event.fingerprint;
  }
}


//# sourceMappingURL=applyScopeDataToEvent.js.map


/***/ }),

/***/ 43889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getRootSpan; }
/* harmony export */ });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */
function getRootSpan(span) {
  // TODO (v8): Remove this check and just return span
  // eslint-disable-next-line deprecation/deprecation
  return span.transaction;
}


//# sourceMappingURL=getRootSpan.js.map


/***/ }),

/***/ 42885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ handleCallbackErrors; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48593);


/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */
function handleCallbackErrors

(
  fn,
  onError,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFinally = () => {},
) {
  let maybePromiseResult;
  try {
    maybePromiseResult = fn();
  } catch (e) {
    onError(e);
    onFinally();
    throw e;
  }

  return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}

/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */
function maybeHandlePromiseRejection(
  value,
  onError,
  onFinally,
) {
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
    // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(
      res => {
        onFinally();
        return res;
      },
      e => {
        onError(e);
        onFinally();
        throw e;
      },
    );
  }

  onFinally();
  return value;
}


//# sourceMappingURL=handleCallbackErrors.js.map


/***/ }),

/***/ 7554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13976);


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map


/***/ }),

/***/ 4715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U0": function() { return /* binding */ parseEventHintOrCaptureContext; },
/* harmony export */   "R": function() { return /* binding */ prepareEvent; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40901);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24703);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1466);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81539);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14600);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69356);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21712);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77172);
/* harmony import */ var _applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43884);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4859);







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */

/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
  client,
  isolationScope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)(),
    timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  const finalScope = getFinalScope(scope, hint.captureContext);

  if (hint.mechanism) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addExceptionMechanism */ .EG)(prepared, hint.mechanism);
  }

  const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  // Merge scope data together
  const data = (0,_scope_js__WEBPACK_IMPORTED_MODULE_2__/* .getGlobalScope */ .lW)().getScopeData();

  if (isolationScope) {
    const isolationData = isolationScope.getScopeData();
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeScopeData */ .yo)(data, isolationData);
  }

  if (finalScope) {
    const finalScopeData = finalScope.getScopeData();
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeScopeData */ .yo)(data, finalScopeData);
  }

  const attachments = [...(hint.attachments || []), ...data.attachments];
  if (attachments.length) {
    hint.attachments = attachments;
  }

  (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .applyScopeDataToEvent */ .gi)(prepared, data);

  // TODO (v8): Update this order to be: Global > Client > Scope
  const eventProcessors = [
    ...clientEventProcessors,
    // eslint-disable-next-line deprecation/deprecation
    ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalEventProcessors */ .fH)(),
    // Run scope event processors _after_ all other processors
    ...data.eventProcessors,
  ];

  const result = (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyEventProcessors */ .RP)(eventProcessors, prepared, hint);

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      const data = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).data;

      if (data) {
        // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(data, depth, maxBreadth);
      }

      return span;
    });
  }

  return normalized;
}

function getFinalScope(scope, captureContext) {
  if (!captureContext) {
    return scope;
  }

  const finalScope = scope ? scope.clone() : new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
  finalScope.update(captureContext);
  return finalScope;
}

/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */
function parseEventHintOrCaptureContext(
  hint,
) {
  if (!hint) {
    return undefined;
  }

  // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
  if (hintIsScopeOrFunction(hint)) {
    return { captureContext: hint };
  }

  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint,
    };
  }

  return hint;
}

function hintIsScopeOrFunction(
  hint,
) {
  return hint instanceof _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX || typeof hint === 'function';
}

const captureContextKeys = [
  'user',
  'level',
  'extra',
  'contexts',
  'tags',
  'fingerprint',
  'requestSession',
  'propagationContext',
] ;

function hintIsScopeContext(hint) {
  return Object.keys(hint).some(key => captureContextKeys.includes(key ));
}


//# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 61650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ applySdkMetadata; }
/* harmony export */ });
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91895);


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */
function applySdkMetadata(options, name, names = [name], source = 'npm') {
  const metadata = options._metadata || {};

  if (!metadata.sdk) {
    metadata.sdk = {
      name: `sentry.javascript.${name}`,
      packages: names.map(name => ({
        name: `${source}:@sentry/${name}`,
        version: _version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J,
      })),
      version: _version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J,
    };
  }

  options._metadata = metadata;
}


//# sourceMappingURL=sdkMetadata.js.map


/***/ }),

/***/ 4859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ve": function() { return /* binding */ TRACE_FLAG_NONE; },
/* harmony export */   "i0": function() { return /* binding */ TRACE_FLAG_SAMPLED; },
/* harmony export */   "Tt": function() { return /* binding */ spanIsSampled; },
/* harmony export */   "$k": function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   "XU": function() { return /* binding */ spanToJSON; },
/* harmony export */   "wy": function() { return /* binding */ spanToTraceContext; },
/* harmony export */   "Hb": function() { return /* binding */ spanToTraceHeader; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75771);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24703);


// These are aligned with OpenTelemetry trace flags
const TRACE_FLAG_NONE = 0x0;
const TRACE_FLAG_SAMPLED = 0x1;

/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */
function spanToTraceContext(span) {
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  const { data, op, parent_span_id, status, tags, origin } = spanToJSON(span);

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    data,
    op,
    parent_span_id,
    span_id,
    status,
    tags,
    trace_id,
    origin,
  });
}

/**
 * Convert a Span to a Sentry trace header.
 */
function spanToTraceHeader(span) {
  const { traceId, spanId } = span.spanContext();
  const sampled = spanIsSampled(span);
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateSentryTraceHeader */ .$p)(traceId, spanId, sampled);
}

/**
 * Convert a span time input intp a timestamp in seconds.
 */
function spanTimeInputToSeconds(input) {
  if (typeof input === 'number') {
    return ensureTimestampInSeconds(input);
  }

  if (Array.isArray(input)) {
    // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
  }

  if (input instanceof Date) {
    return ensureTimestampInSeconds(input.getTime());
  }

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)();
}

/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */
function ensureTimestampInSeconds(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */
function spanToJSON(span) {
  if (spanIsSpanClass(span)) {
    return span.getSpanJSON();
  }

  // Fallback: We also check for `.toJSON()` here...
  // eslint-disable-next-line deprecation/deprecation
  if (typeof span.toJSON === 'function') {
    // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
  }

  return {};
}

/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */
function spanIsSpanClass(span) {
  return typeof (span ).getSpanJSON === 'function';
}

/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */
function spanIsSampled(span) {
  // We align our trace flags with the ones OpenTelemetry use
  // So we also check for sampled the same way they do.
  const { traceFlags } = span.spanContext();
  // eslint-disable-next-line no-bitwise
  return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}


//# sourceMappingURL=spanUtils.js.map


/***/ }),

/***/ 91895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
const SDK_VERSION = '7.120.3';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 51608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ captureUnderscoreErrorException; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13976);
/* harmony import */ var _utils_responseEnd_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74801);



/**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */
async function captureUnderscoreErrorException(contextOrProps) {
  const { req, res, err } = contextOrProps;

  // 404s (and other 400-y friends) can trigger `_error`, but we don't want to send them to Sentry
  const statusCode = (res && res.statusCode) || contextOrProps.statusCode;
  if (statusCode && statusCode < 500) {
    return Promise.resolve();
  }

  // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
  // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
  // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
  // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
  // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
  // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
  // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
  if (!contextOrProps.pathname) {
    return Promise.resolve();
  }

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .withScope */ .$e)(scope => {
    if (req) {
      scope.setSDKProcessingMetadata({ request: req });
    }

    // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
    // is what passing a string to `captureException` will wind up doing)
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb)(err || `_error.js called with falsy error (${err})`, {
      mechanism: {
        type: 'instrument',
        handled: false,
        data: {
          function: '_error.getInitialProps',
        },
      },
    });
  });

  // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
  // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
  await (0,_utils_responseEnd_js__WEBPACK_IMPORTED_MODULE_1__/* .flushQueue */ .DO)();
}


//# sourceMappingURL=_error.js.map


/***/ }),

/***/ 83687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 74801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RR": function() { return /* binding */ autoEndSpanOnResponseEnd; },
/* harmony export */   "DO": function() { return /* binding */ flushQueue; }
/* harmony export */ });
/* unused harmony export finishSpan */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35818);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76721);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58786);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83687);




/**
 * Wrap `res.end()` so that it ends the span and flushes events before letting the request finish.
 *
 * Note: This wraps a sync method with an async method. While in general that's not a great idea in terms of keeping
 * things in the right order, in this case it's safe, because the native `.end()` actually *is* (effectively) async, and
 * its run actually *is* (literally) awaited, just manually so (which reflects the fact that the core of the
 * request/response code in Node by far predates the introduction of `async`/`await`). When `.end()` is done, it emits
 * the `prefinish` event, and only once that fires does request processing continue. See
 * https://github.com/nodejs/node/commit/7c9b607048f13741173d397795bac37707405ba7.
 *
 * Also note: `res.end()` isn't called until *after* all response data and headers have been sent, so blocking inside of
 * `end` doesn't delay data getting to the end user. See
 * https://nodejs.org/api/http.html#responseenddata-encoding-callback.
 *
 * @param span The span tracking the request
 * @param res: The request's corresponding response
 */
function autoEndSpanOnResponseEnd(span, res) {
  const wrapEndMethod = (origEnd) => {
    return function sentryWrappedEnd( ...args) {
      finishSpan(span, this);
      return origEnd.call(this, ...args);
    };
  };

  // Prevent double-wrapping
  // res.end may be undefined during build when using `next export` to statically export a Next.js app
  if (res.end && !(res.end ).__sentry_original__) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(res, 'end', wrapEndMethod);
  }
}

/** Finish the given response's span and set HTTP status data */
function finishSpan(span, res) {
  if (span) {
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .setHttpStatus */ .Q0)(span, res.statusCode);
    span.end();
  }
}

/** Flush the event queue to ensure that events get sent to Sentry before the response is finished and the lambda ends */
async function flushQueue() {
  try {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Flushing events...');
    await (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .flush */ .yl)(2000);
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Done flushing events');
  } catch (e) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Error while flushing events:\n', e);
  }
}


//# sourceMappingURL=responseEnd.js.map


/***/ }),

/***/ 44159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Breadcrumbs": function() { return /* reexport */ react_esm/* Breadcrumbs */.Oo; },
  "BrowserClient": function() { return /* reexport */ react_esm/* BrowserClient */.RE; },
  "BrowserProfilingIntegration": function() { return /* reexport */ react_esm/* BrowserProfilingIntegration */._p; },
  "BrowserTracing": function() { return /* reexport */ BrowserTracing; },
  "Dedupe": function() { return /* reexport */ react_esm/* Dedupe */.Iq; },
  "ErrorBoundary": function() { return /* reexport */ react_esm/* ErrorBoundary */.SV; },
  "Feedback": function() { return /* reexport */ react_esm/* Feedback */.x2; },
  "FunctionToString": function() { return /* reexport */ react_esm/* FunctionToString */.cq; },
  "GlobalHandlers": function() { return /* reexport */ react_esm/* GlobalHandlers */.dJ; },
  "HttpContext": function() { return /* reexport */ react_esm/* HttpContext */.qT; },
  "Hub": function() { return /* reexport */ react_esm/* Hub */.Xb; },
  "InboundFilters": function() { return /* reexport */ react_esm/* InboundFilters */.QD; },
  "Integrations": function() { return /* reexport */ Integrations; },
  "LinkedErrors": function() { return /* reexport */ react_esm/* LinkedErrors */.iP; },
  "ModuleMetadata": function() { return /* reexport */ react_esm/* ModuleMetadata */._e; },
  "Profiler": function() { return /* reexport */ react_esm/* Profiler */.Q1; },
  "Replay": function() { return /* reexport */ react_esm/* Replay */.UH; },
  "ReplayCanvas": function() { return /* reexport */ react_esm/* ReplayCanvas */.$r; },
  "SDK_VERSION": function() { return /* reexport */ react_esm/* SDK_VERSION */.Jn; },
  "SEMANTIC_ATTRIBUTE_SENTRY_OP": function() { return /* reexport */ react_esm/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J; },
  "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN": function() { return /* reexport */ react_esm/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3; },
  "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE": function() { return /* reexport */ react_esm/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.TE; },
  "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE": function() { return /* reexport */ react_esm/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj; },
  "Scope": function() { return /* reexport */ react_esm/* Scope */.sX; },
  "TryCatch": function() { return /* reexport */ react_esm/* TryCatch */.pT; },
  "WINDOW": function() { return /* reexport */ react_esm/* WINDOW */.m9; },
  "addBreadcrumb": function() { return /* reexport */ react_esm/* addBreadcrumb */.n_; },
  "addEventProcessor": function() { return /* reexport */ react_esm/* addEventProcessor */.Qy; },
  "addGlobalEventProcessor": function() { return /* reexport */ react_esm/* addGlobalEventProcessor */.cc; },
  "addIntegration": function() { return /* reexport */ react_esm/* addIntegration */.M5; },
  "addTracingExtensions": function() { return /* reexport */ react_esm/* addTracingExtensions */.Ts; },
  "breadcrumbsIntegration": function() { return /* reexport */ react_esm/* breadcrumbsIntegration */.fQ; },
  "browserApiErrorsIntegration": function() { return /* reexport */ react_esm/* browserApiErrorsIntegration */.tP; },
  "browserProfilingIntegration": function() { return /* reexport */ react_esm/* browserProfilingIntegration */.xF; },
  "browserTracingIntegration": function() { return /* reexport */ browserTracingIntegration_browserTracingIntegration; },
  "captureConsoleIntegration": function() { return /* reexport */ react_esm/* captureConsoleIntegration */.Xs; },
  "captureEvent": function() { return /* reexport */ react_esm/* captureEvent */.eN; },
  "captureException": function() { return /* reexport */ react_esm/* captureException */.Tb; },
  "captureMessage": function() { return /* reexport */ react_esm/* captureMessage */.uT; },
  "captureSession": function() { return /* reexport */ react_esm/* captureSession */.cg; },
  "captureUnderscoreErrorException": function() { return /* reexport */ _error/* captureUnderscoreErrorException */.u; },
  "captureUserFeedback": function() { return /* reexport */ react_esm/* captureUserFeedback */.Jd; },
  "chromeStackLineParser": function() { return /* reexport */ react_esm/* chromeStackLineParser */.$3; },
  "close": function() { return /* reexport */ react_esm/* close */.xv; },
  "configureScope": function() { return /* reexport */ react_esm/* configureScope */.e; },
  "contextLinesIntegration": function() { return /* reexport */ react_esm/* contextLinesIntegration */.SZ; },
  "continueTrace": function() { return /* reexport */ react_esm/* continueTrace */.yn; },
  "createReduxEnhancer": function() { return /* reexport */ react_esm/* createReduxEnhancer */.wS; },
  "createTransport": function() { return /* reexport */ react_esm/* createTransport */.qv; },
  "createUserFeedbackEnvelope": function() { return /* reexport */ react_esm/* createUserFeedbackEnvelope */.rQ; },
  "debugIntegration": function() { return /* reexport */ react_esm/* debugIntegration */.sC; },
  "dedupeIntegration": function() { return /* reexport */ react_esm/* dedupeIntegration */.RH; },
  "defaultIntegrations": function() { return /* reexport */ react_esm/* defaultIntegrations */.SS; },
  "defaultRequestInstrumentationOptions": function() { return /* reexport */ react_esm/* defaultRequestInstrumentationOptions */.k3; },
  "defaultStackLineParsers": function() { return /* reexport */ react_esm/* defaultStackLineParsers */.d8; },
  "defaultStackParser": function() { return /* reexport */ react_esm/* defaultStackParser */.Dt; },
  "endSession": function() { return /* reexport */ react_esm/* endSession */.TM; },
  "eventFromException": function() { return /* reexport */ react_esm/* eventFromException */.dr; },
  "eventFromMessage": function() { return /* reexport */ react_esm/* eventFromMessage */.aB; },
  "exceptionFromError": function() { return /* reexport */ react_esm/* exceptionFromError */.GJ; },
  "extraErrorDataIntegration": function() { return /* reexport */ react_esm/* extraErrorDataIntegration */.EY; },
  "extractTraceparentData": function() { return /* reexport */ react_esm/* extractTraceparentData */.qG; },
  "feedbackIntegration": function() { return /* reexport */ react_esm/* feedbackIntegration */.Xc; },
  "flush": function() { return /* reexport */ react_esm/* flush */.yl; },
  "forceLoad": function() { return /* reexport */ react_esm/* forceLoad */.Eg; },
  "functionToStringIntegration": function() { return /* reexport */ react_esm/* functionToStringIntegration */.CP; },
  "geckoStackLineParser": function() { return /* reexport */ react_esm/* geckoStackLineParser */.$Q; },
  "getActiveSpan": function() { return /* reexport */ react_esm/* getActiveSpan */.HN; },
  "getActiveTransaction": function() { return /* reexport */ react_esm/* getActiveTransaction */.x1; },
  "getClient": function() { return /* reexport */ react_esm/* getClient */.s3; },
  "getCurrentHub": function() { return /* reexport */ react_esm/* getCurrentHub */.Gd; },
  "getCurrentScope": function() { return /* reexport */ react_esm/* getCurrentScope */.nZ; },
  "getDefaultIntegrations": function() { return /* reexport */ react_esm/* getDefaultIntegrations */.nV; },
  "getHubFromCarrier": function() { return /* reexport */ react_esm/* getHubFromCarrier */.vi; },
  "getReplay": function() { return /* reexport */ react_esm/* getReplay */.TF; },
  "getSpanStatusFromHttpCode": function() { return /* reexport */ react_esm/* getSpanStatusFromHttpCode */.ix; },
  "globalHandlersIntegration": function() { return /* reexport */ react_esm/* globalHandlersIntegration */.ks; },
  "httpClientIntegration": function() { return /* reexport */ react_esm/* httpClientIntegration */.lQ; },
  "httpContextIntegration": function() { return /* reexport */ react_esm/* httpContextIntegration */.sA; },
  "inboundFiltersIntegration": function() { return /* reexport */ react_esm/* inboundFiltersIntegration */.SG; },
  "init": function() { return /* reexport */ init; },
  "instrumentOutgoingRequests": function() { return /* reexport */ react_esm/* instrumentOutgoingRequests */.L7; },
  "isInitialized": function() { return /* reexport */ react_esm/* isInitialized */.dk; },
  "lastEventId": function() { return /* reexport */ react_esm/* lastEventId */.eW; },
  "linkedErrorsIntegration": function() { return /* reexport */ react_esm/* linkedErrorsIntegration */.OB; },
  "makeBrowserOfflineTransport": function() { return /* reexport */ react_esm/* makeBrowserOfflineTransport */.O1; },
  "makeFetchTransport": function() { return /* reexport */ react_esm/* makeFetchTransport */.fD; },
  "makeMain": function() { return /* reexport */ react_esm/* makeMain */.pj; },
  "makeMultiplexedTransport": function() { return /* reexport */ react_esm/* makeMultiplexedTransport */.Wq; },
  "makeXHRTransport": function() { return /* reexport */ react_esm/* makeXHRTransport */.KC; },
  "metrics": function() { return /* reexport */ react_esm/* metrics */.qI; },
  "moduleMetadataIntegration": function() { return /* reexport */ react_esm/* moduleMetadataIntegration */.wo; },
  "nextRouterInstrumentation": function() { return /* reexport */ nextRouterInstrumentation; },
  "onLoad": function() { return /* reexport */ react_esm/* onLoad */.lA; },
  "onProfilingStartRouteTransaction": function() { return /* reexport */ react_esm/* onProfilingStartRouteTransaction */.Uv; },
  "opera10StackLineParser": function() { return /* reexport */ react_esm/* opera10StackLineParser */.NP; },
  "opera11StackLineParser": function() { return /* reexport */ react_esm/* opera11StackLineParser */.HH; },
  "parameterize": function() { return /* reexport */ react_esm/* parameterize */.XB; },
  "reactRouterV3BrowserTracingIntegration": function() { return /* reexport */ react_esm/* reactRouterV3BrowserTracingIntegration */.h1; },
  "reactRouterV3Instrumentation": function() { return /* reexport */ react_esm/* reactRouterV3Instrumentation */.XQ; },
  "reactRouterV4BrowserTracingIntegration": function() { return /* reexport */ react_esm/* reactRouterV4BrowserTracingIntegration */.qi; },
  "reactRouterV4Instrumentation": function() { return /* reexport */ react_esm/* reactRouterV4Instrumentation */.qr; },
  "reactRouterV5BrowserTracingIntegration": function() { return /* reexport */ react_esm/* reactRouterV5BrowserTracingIntegration */.zL; },
  "reactRouterV5Instrumentation": function() { return /* reexport */ react_esm/* reactRouterV5Instrumentation */.qp; },
  "reactRouterV6BrowserTracingIntegration": function() { return /* reexport */ react_esm/* reactRouterV6BrowserTracingIntegration */.g3; },
  "reactRouterV6Instrumentation": function() { return /* reexport */ react_esm/* reactRouterV6Instrumentation */.KO; },
  "replayCanvasIntegration": function() { return /* reexport */ react_esm/* replayCanvasIntegration */.mz; },
  "replayIntegration": function() { return /* reexport */ react_esm/* replayIntegration */.Gs; },
  "reportingObserverIntegration": function() { return /* reexport */ react_esm/* reportingObserverIntegration */.yt; },
  "rewriteFramesIntegration": function() { return /* reexport */ rewriteFramesIntegration_rewriteFramesIntegration; },
  "sendFeedback": function() { return /* reexport */ react_esm/* sendFeedback */.fA; },
  "sessionTimingIntegration": function() { return /* reexport */ react_esm/* sessionTimingIntegration */.rE; },
  "setContext": function() { return /* reexport */ react_esm/* setContext */.v; },
  "setCurrentClient": function() { return /* reexport */ react_esm/* setCurrentClient */.KW; },
  "setExtra": function() { return /* reexport */ react_esm/* setExtra */.sU; },
  "setExtras": function() { return /* reexport */ react_esm/* setExtras */.rJ; },
  "setHttpStatus": function() { return /* reexport */ react_esm/* setHttpStatus */.Q0; },
  "setMeasurement": function() { return /* reexport */ react_esm/* setMeasurement */.oi; },
  "setTag": function() { return /* reexport */ react_esm/* setTag */.YA; },
  "setTags": function() { return /* reexport */ react_esm/* setTags */.mG; },
  "setUser": function() { return /* reexport */ react_esm/* setUser */.av; },
  "showReportDialog": function() { return /* reexport */ react_esm/* showReportDialog */.jp; },
  "spanStatusfromHttpCode": function() { return /* reexport */ react_esm/* spanStatusfromHttpCode */.Zd; },
  "startBrowserTracingNavigationSpan": function() { return /* reexport */ react_esm/* startBrowserTracingNavigationSpan */.og; },
  "startBrowserTracingPageLoadSpan": function() { return /* reexport */ react_esm/* startBrowserTracingPageLoadSpan */.Wo; },
  "startInactiveSpan": function() { return /* reexport */ react_esm/* startInactiveSpan */.Qb; },
  "startSession": function() { return /* reexport */ react_esm/* startSession */.yj; },
  "startSpan": function() { return /* reexport */ react_esm/* startSpan */.GK; },
  "startSpanManual": function() { return /* reexport */ react_esm/* startSpanManual */.V0; },
  "startTransaction": function() { return /* reexport */ react_esm/* startTransaction */.Yr; },
  "trace": function() { return /* reexport */ react_esm/* trace */.g4; },
  "useProfiler": function() { return /* reexport */ react_esm/* useProfiler */.ED; },
  "winjsStackLineParser": function() { return /* reexport */ react_esm/* winjsStackLineParser */.R2; },
  "withActiveSpan": function() { return /* reexport */ react_esm/* withActiveSpan */._d; },
  "withErrorBoundary": function() { return /* reexport */ react_esm/* withErrorBoundary */.Pf; },
  "withIsolationScope": function() { return /* reexport */ react_esm/* withIsolationScope */.wi; },
  "withProfiler": function() { return /* reexport */ react_esm/* withProfiler */.zH; },
  "withScope": function() { return /* reexport */ react_esm/* withScope */.$e; },
  "withSentryConfig": function() { return /* reexport */ withSentryConfig; },
  "withSentryGetServerSideProps": function() { return /* reexport */ withSentryGetServerSideProps; },
  "withSentryGetStaticProps": function() { return /* reexport */ withSentryGetStaticProps; },
  "withSentryReactRouterV6Routing": function() { return /* reexport */ react_esm/* withSentryReactRouterV6Routing */.H0; },
  "withSentryRouting": function() { return /* reexport */ react_esm/* withSentryRouting */.gy; },
  "withSentryServerSideAppGetInitialProps": function() { return /* reexport */ withSentryServerSideAppGetInitialProps; },
  "withSentryServerSideDocumentGetInitialProps": function() { return /* reexport */ withSentryServerSideDocumentGetInitialProps; },
  "withSentryServerSideErrorGetInitialProps": function() { return /* reexport */ withSentryServerSideErrorGetInitialProps; },
  "withSentryServerSideGetInitialProps": function() { return /* reexport */ withSentryServerSideGetInitialProps; },
  "withServerActionInstrumentation": function() { return /* reexport */ withServerActionInstrumentation; },
  "wrap": function() { return /* reexport */ react_esm/* wrap */.re; },
  "wrapApiHandlerWithSentryVercelCrons": function() { return /* reexport */ wrapApiHandlerWithSentryVercelCrons; },
  "wrapAppGetInitialPropsWithSentry": function() { return /* reexport */ wrapAppGetInitialPropsWithSentry; },
  "wrapCreateBrowserRouter": function() { return /* reexport */ react_esm/* wrapCreateBrowserRouter */.vG; },
  "wrapDocumentGetInitialPropsWithSentry": function() { return /* reexport */ wrapDocumentGetInitialPropsWithSentry; },
  "wrapErrorGetInitialPropsWithSentry": function() { return /* reexport */ wrapErrorGetInitialPropsWithSentry; },
  "wrapGenerationFunctionWithSentry": function() { return /* reexport */ wrapGenerationFunctionWithSentry; },
  "wrapGetInitialPropsWithSentry": function() { return /* reexport */ wrapGetInitialPropsWithSentry; },
  "wrapGetServerSidePropsWithSentry": function() { return /* reexport */ wrapGetServerSidePropsWithSentry; },
  "wrapGetStaticPropsWithSentry": function() { return /* reexport */ wrapGetStaticPropsWithSentry; },
  "wrapMiddlewareWithSentry": function() { return /* reexport */ wrapMiddlewareWithSentry; },
  "wrapPageComponentWithSentry": function() { return /* reexport */ wrapPageComponentWithSentry; },
  "wrapRouteHandlerWithSentry": function() { return /* reexport */ wrapRouteHandlerWithSentry; },
  "wrapServerComponentWithSentry": function() { return /* reexport */ wrapServerComponentWithSentry; },
  "wrapUseRoutes": function() { return /* reexport */ react_esm/* wrapUseRoutes */.M1; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(61650);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(7554);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/index.js + 33 modules
var esm = __webpack_require__(34615);
// EXTERNAL MODULE: ../../node_modules/@sentry/react/esm/sdk.js
var sdk = __webpack_require__(12793);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(13976);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/sdk.js
var esm_sdk = __webpack_require__(20113);
// EXTERNAL MODULE: ../../node_modules/@sentry/react/esm/index.js + 8 modules
var react_esm = __webpack_require__(25622);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(90907);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(83815);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(91617);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(77257);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(46595);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(75771);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(71207);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/common/debug-build.js
var debug_build = __webpack_require__(20858);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js
var backgroundtab = __webpack_require__(89591);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(94423);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js + 2 modules
var metrics = __webpack_require__(29350);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/request.js + 1 modules
var request = __webpack_require__(79727);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(24703);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/history.js + 1 modules
var instrument_history = __webpack_require__(16962);
// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(28997);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/router.js




/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types/* WINDOW */.m || !types/* WINDOW.location */.m.location) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types/* WINDOW.location.href */.m.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types/* WINDOW.location.pathname */.m.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      origin: 'auto.pageload.browser',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument_history/* addHistoryInstrumentationHandler */.a)(({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.end();
        }
        activeTransaction = customStartTransaction({
          name: types/* WINDOW.location.pathname */.m.location.pathname,
          op: 'navigation',
          origin: 'auto.navigation.browser',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js










const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...idletransaction/* TRACING_DEFAULTS */.AT,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  enableInp: false,
  interactionsSampleRate: 1,
  _experiments: {},
  ...request/* defaultRequestInstrumentationOptions */.k3,
};

/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */
const MAX_INTERACTIONS = 10;

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */
class browsertracing_BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line deprecation/deprecation

   constructor(_options) {
    this.name = BROWSER_TRACING_INTEGRATION_ID;
    this._hasSetTracePropagationTargets = false;

    (0,hubextensions/* addTracingExtensions */.T)();

    if (debug_build/* DEBUG_BUILD */.X) {
      this._hasSetTracePropagationTargets = !!(
        _options &&
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      );
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = (0,metrics/* startTrackingWebVitals */.PR)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */
    this._interactionIdToRouteNameMapping = {};

    if (this.options.enableInp) {
      (0,metrics/* startTrackingINP */.NR)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
    }
    if (this.options.enableLongTask) {
      (0,metrics/* startTrackingLongTasks */.Fv)();
    }
    if (this.options._experiments.enableInteractions) {
      (0,metrics/* startTrackingInteractions */.sn)();
    }

    this._latestRoute = {
      name: undefined,
      context: undefined,
    };
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;
    const hub = getCurrentHub();
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const clientOptions = client && client.getOptions();

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
      _experiments,
    } = this.options;

    const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
    // There are three ways to configure tracePropagationTargets:
    // 1. via top level client option `tracePropagationTargets`
    // 2. via BrowserTracing option `tracePropagationTargets`
    // 3. via BrowserTracing option `tracingOrigins` (deprecated)
    //
    // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
    // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
    // This is done as it minimizes bundle size (we don't have to have undefined checks).
    //
    // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
    // eslint-disable-next-line deprecation/deprecation
    const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
    if (debug_build/* DEBUG_BUILD */.X && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
      logger/* logger.warn */.kg.warn(
        '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
      );
    }

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      (0,backgroundtab/* registerBackgroundTabDetection */.j)();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    if (this.options.enableInp) {
      this._registerInpInteractionListener();
    }

    (0,request/* instrumentOutgoingRequests */.L7)({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      debug_build/* DEBUG_BUILD */.X &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const hub = this._getCurrentHub();

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    let expandedContext;
    if (isPageloadTransaction) {
      const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
      const baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;
      const { traceId, dsc, parentSpanId, sampled } = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage);
      expandedContext = {
        traceId,
        parentSpanId,
        parentSampled: sampled,
        ...context,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...context.metadata,
          dynamicSamplingContext: dsc,
        },
        trimEnd: true,
      };
    } else {
      expandedContext = {
        trimEnd: true,
        ...context,
      };
    }

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    // eslint-disable-next-line deprecation/deprecation
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? // eslint-disable-next-line deprecation/deprecation
          { ...finalContext.metadata, source: 'custom' }
        : // eslint-disable-next-line deprecation/deprecation
          finalContext.metadata;

    this._latestRoute.name = finalContext.name;
    this._latestRoute.context = finalContext;

    // eslint-disable-next-line deprecation/deprecation
    if (finalContext.sampled === false) {
      debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = types/* WINDOW */.m;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.l)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
      isPageloadTransaction, // should wait for finish signal if it's a pageload transaction
    );

    if (isPageloadTransaction) {
      if (types/* WINDOW.document */.m.document) {
        types/* WINDOW.document.addEventListener */.m.document.addEventListener('readystatechange', () => {
          if (['interactive', 'complete'].includes(types/* WINDOW.document.readyState */.m.document.readyState)) {
            idleTransaction.sendAutoFinishSignal();
          }
        });

        if (['interactive', 'complete'].includes(types/* WINDOW.document.readyState */.m.document.readyState)) {
          idleTransaction.sendAutoFinishSignal();
        }
      }
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      (0,metrics/* addPerformanceEntries */.f7)(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      // eslint-disable-next-line deprecation/deprecation
      const currentTransaction = (0,utils/* getActiveTransaction */.x1)();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        debug_build/* DEBUG_BUILD */.X &&
          logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.end();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRoute.name) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types/* WINDOW */.m;

      const context = {
        name: this._latestRoute.name,
        op,
        trimEnd: true,
        data: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: this._latestRoute.context
            ? getSource(this._latestRoute.context)
            : 'url',
        },
      };

      inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.l)(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      if (types/* WINDOW.document */.m.document) {
        addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
      }
    });
  }

  /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
   _registerInpInteractionListener() {
    const handleEntries = ({ entries }) => {
      const client = (0,esm_exports/* getClient */.s3)();
      // We need to get the replay, user, and activeTransaction from the current scope
      // so that we can associate replay id, profile id, and a user display to the span
      const replay =
        client !== undefined && client.getIntegrationByName !== undefined
          ? (client.getIntegrationByName('Replay') )
          : undefined;
      const replayId = replay !== undefined ? replay.getReplayId() : undefined;
      // eslint-disable-next-line deprecation/deprecation
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
      const currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
      const user = currentScope !== undefined ? currentScope.getUser() : undefined;
      entries.forEach(entry => {
        if (isPerformanceEventTiming(entry)) {
          const interactionId = entry.interactionId;
          if (interactionId === undefined) {
            return;
          }
          const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
          const duration = entry.duration;
          const startTime = entry.startTime;
          const keys = Object.keys(this._interactionIdToRouteNameMapping);
          const minInteractionId =
            keys.length > 0
              ? keys.reduce((a, b) => {
                  return this._interactionIdToRouteNameMapping[a].duration <
                    this._interactionIdToRouteNameMapping[b].duration
                    ? a
                    : b;
                })
              : undefined;
          // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
          // This is also checked in the web-vitals library.
          if (entry.entryType === 'first-input') {
            const matchingEntry = keys
              .map(key => this._interactionIdToRouteNameMapping[key])
              .some(interaction => {
                return interaction.duration === duration && interaction.startTime === startTime;
              });
            if (matchingEntry) {
              return;
            }
          }
          // Interactions with an id of 0 and are not first-input are not valid.
          if (!interactionId) {
            return;
          }
          // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
          if (existingInteraction) {
            existingInteraction.duration = Math.max(existingInteraction.duration, duration);
          } else if (
            keys.length < MAX_INTERACTIONS ||
            minInteractionId === undefined ||
            duration > this._interactionIdToRouteNameMapping[minInteractionId].duration
          ) {
            // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
            const routeName = this._latestRoute.name;
            const parentContext = this._latestRoute.context;
            if (routeName && parentContext) {
              if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._interactionIdToRouteNameMapping[minInteractionId];
              }
              this._interactionIdToRouteNameMapping[interactionId] = {
                routeName,
                duration,
                parentContext,
                user,
                activeTransaction,
                replayId,
                startTime,
              };
            }
          }
        }
      });
    };
    (0,instrument/* addPerformanceInstrumentationHandler */._j)('event', handleEntries);
    (0,instrument/* addPerformanceInstrumentationHandler */._j)('first-input', handleEntries);
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

function getSource(context) {
  const sourceFromAttributes = context.attributes && context.attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromData = context.data && context.data[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromMetadata = context.metadata && context.metadata.source;

  return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

function isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}


//# sourceMappingURL=browsertracing.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js
var browserTracingIntegration = __webpack_require__(46136);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(14828);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/fetch.js
var fetch = __webpack_require__(61245);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/routing/appRouterRoutingInstrumentation.js



const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-app-router',
} ;

/**
 * Instruments the Next.js Client App Router.
 */
// TODO(v8): Clean this function up by splitting into pageload and navigation instrumentation respectively. Also remove startTransactionCb in the process.
function appRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
  startPageloadSpanCallback,
  startNavigationSpanCallback,
) {
  // We keep track of the active transaction so we can finish it when we start a navigation transaction.
  let activeTransaction = undefined;

  // We keep track of the previous location name so we can set the `from` field on navigation transactions.
  // This is either a route or a pathname.
  let prevLocationName = helpers/* WINDOW.location.pathname */.m9.location.pathname;

  if (startTransactionOnPageLoad) {
    const transactionContext = {
      name: prevLocationName,
      op: 'pageload',
      origin: 'auto.pageload.nextjs.app_router_instrumentation',
      tags: DEFAULT_TAGS,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      metadata: { source: 'url' },
    } ;
    activeTransaction = startTransactionCb(transactionContext);
    startPageloadSpanCallback(transactionContext);
  }

  if (startTransactionOnLocationChange) {
    (0,fetch/* addFetchInstrumentationHandler */.U)(handlerData => {
      // The instrumentation handler is invoked twice - once for starting a request and once when the req finishes
      // We can use the existence of the end-timestamp to filter out "finishing"-events.
      if (handlerData.endTimestamp !== undefined) {
        return;
      }

      // Only GET requests can be navigating RSC requests
      if (handlerData.fetchData.method !== 'GET') {
        return;
      }

      const parsedNavigatingRscFetchArgs = parseNavigatingRscFetchArgs(handlerData.args);

      if (parsedNavigatingRscFetchArgs === null) {
        return;
      }

      const transactionName = parsedNavigatingRscFetchArgs.targetPathname;
      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.end();
      }

      const transactionContext = {
        name: transactionName,
        op: 'navigation',
        origin: 'auto.navigation.nextjs.app_router_instrumentation',
        tags,
        metadata: { source: 'url' },
      } ;

      startTransactionCb(transactionContext);
      startNavigationSpanCallback(transactionContext);
    });
  }
}

function parseNavigatingRscFetchArgs(fetchArgs)

 {
  // Make sure the first arg is a URL object
  if (!fetchArgs[0] || typeof fetchArgs[0] !== 'object' || (fetchArgs[0] ).searchParams === undefined) {
    return null;
  }

  // Make sure the second argument is some kind of fetch config obj that contains headers
  if (!fetchArgs[1] || typeof fetchArgs[1] !== 'object' || !('headers' in fetchArgs[1])) {
    return null;
  }

  try {
    const url = fetchArgs[0] ;
    const headers = fetchArgs[1].headers ;

    // Not an RSC request
    if (headers['RSC'] !== '1') {
      return null;
    }

    // Prefetch requests are not navigating RSC requests
    if (headers['Next-Router-Prefetch'] === '1') {
      return null;
    }

    return {
      targetPathname: url.pathname,
    };
  } catch (e) {
    return null;
  }
}


//# sourceMappingURL=appRouterRoutingInstrumentation.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(84808);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(53746);
// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/esm/common/debug-build.js
var common_debug_build = __webpack_require__(83687);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/routing/pagesRouterRoutingInstrumentation.js






const globalObject = helpers/* WINDOW */.m9

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      common_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }

  return nextDataTagInfo;
}

const pagesRouterRoutingInstrumentation_DEFAULT_TAGS = {
  'routing.instrumentation': 'next-pages-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_exports/* getClient */.s3)();

/**
 * Instruments the Next.js pages router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function pagesRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
  startPageloadSpanCallback,
  startNavigationSpanCallback,
) {
  const { route, params, sentryTrace, baggage } = extractNextDataTagInformation();
  // eslint-disable-next-line deprecation/deprecation
  const { traceparentData, dynamicSamplingContext, propagationContext } = (0,tracing/* tracingContextFromHeaders */.KA)(
    sentryTrace,
    baggage,
  );

  (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const transactionContext = {
      name: prevLocationName,
      op: 'pageload',
      origin: 'auto.pageload.nextjs.pages_router_instrumentation',
      tags: pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceparentData,
      metadata: {
        source,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    } ;
    activeTransaction = startTransactionCb(transactionContext);
    startPageloadSpanCallback(transactionContext);
  }

  if (startTransactionOnLocationChange) {
    router["default"].events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = (0,url/* stripUrlQueryAndFragment */.rt)(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.end();
      }

      const transactionContext = {
        name: transactionName,
        op: 'navigation',
        origin: 'auto.navigation.nextjs.pages_router_instrumentation',
        tags,
        metadata: { source: transactionSource },
      } ;
      const navigationTransaction = startTransactionCb(transactionContext);
      startNavigationSpanCallback(transactionContext);

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        // eslint-disable-next-line deprecation/deprecation
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          origin: 'auto.ui.nextjs.pages_router_instrumentation',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.end();
          router["default"].events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router["default"].events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- routeParts are from the build manifest, so no raw user input
  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=pagesRouterRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/routing/nextRoutingInstrumentation.js




/**
 * Instruments the Next.js Client Router.
 *
 * @deprecated Use `browserTracingIntegration()` as exported from `@sentry/nextjs` instead.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
  startPageloadSpanCallback,
  startNavigationSpanCallback,
) {
  const isAppRouter = !helpers/* WINDOW.document.getElementById */.m9.document.getElementById('__NEXT_DATA__');
  if (isAppRouter) {
    appRouterInstrumentation(
      startTransactionCb,
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
      startPageloadSpanCallback || (() => undefined),
      startNavigationSpanCallback || (() => undefined),
    );
  } else {
    pagesRouterInstrumentation(
      startTransactionCb,
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
      startPageloadSpanCallback || (() => undefined),
      startNavigationSpanCallback || (() => undefined),
    );
  }
}


//# sourceMappingURL=nextRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/browserTracingIntegration.js



/**
 * A custom BrowserTracing integration for Next.js.
 *
 * @deprecated Use `browserTracingIntegration` instead.
 */
// eslint-disable-next-line deprecation/deprecation
class BrowserTracing extends browsertracing_BrowserTracing {
  // eslint-disable-next-line deprecation/deprecation
   constructor(options) {
    super({
      // eslint-disable-next-line deprecation/deprecation
      tracingOrigins:
         false
          ? 0
          : // eslint-disable-next-line deprecation/deprecation
            [...request/* defaultRequestInstrumentationOptions.tracingOrigins */.k3.tracingOrigins, /^(api\/)/],
      // eslint-disable-next-line deprecation/deprecation
      routingInstrumentation: nextRouterInstrumentation,
      ...options,
    });
  }
}

/**
 * A custom BrowserTracing integration for Next.js.
 */
function browserTracingIntegration_browserTracingIntegration(
  options,
) {
  const browserTracingIntegrationInstance = (0,browserTracingIntegration/* browserTracingIntegration */.E8)({
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins:
       false
        ? 0
        : // eslint-disable-next-line deprecation/deprecation
          [...request/* defaultRequestInstrumentationOptions.tracingOrigins */.k3.tracingOrigins, /^(api\/)/],
    ...options,
    instrumentNavigation: false,
    instrumentPageLoad: false,
  });

  const fullOptions = {
    ...browserTracingIntegrationInstance.options,
    instrumentPageLoad: true,
    instrumentNavigation: true,
    ...options,
  };

  return {
    ...browserTracingIntegrationInstance,
    options: fullOptions,
    afterAllSetup(client) {
      const startPageloadCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
      };

      const startNavigationCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
      };

      // We need to run the navigation span instrumentation before the `afterAllSetup` hook on the normal browser
      // tracing integration because we need to ensure the order of execution is as follows:
      // Instrumentation to start span on RSC fetch request runs -> Instrumentation to put tracing headers from active span on fetch runs
      // If it were the other way around, the RSC fetch request would not receive the tracing headers from the navigation transaction.
      // eslint-disable-next-line deprecation/deprecation
      nextRouterInstrumentation(
        () => undefined,
        false,
        fullOptions.instrumentNavigation,
        startPageloadCallback,
        startNavigationCallback,
      );

      browserTracingIntegrationInstance.afterAllSetup(client);

      // eslint-disable-next-line deprecation/deprecation
      nextRouterInstrumentation(
        () => undefined,
        fullOptions.instrumentPageLoad,
        false,
        startPageloadCallback,
        startNavigationCallback,
      );
    },
  };
}


//# sourceMappingURL=browserTracingIntegration.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
var _optionalChain = __webpack_require__(57672);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(56102);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */
function splitPath(filename) {
  // Truncate files names greater than 1024 characters to avoid regex dos
  // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
  const parts = splitPathRe.exec(truncated);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/rewriteframes.js



const INTEGRATION_NAME = 'RewriteFrames';

const _rewriteFramesIntegration = ((options = {}) => {
  const root = options.root;
  const prefix = options.prefix || 'app:///';

  const iteratee =
    options.iteratee ||
    ((frame) => {
      if (!frame.filename) {
        return frame;
      }
      // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
      const isWindowsFrame =
        /^[a-zA-Z]:\\/.test(frame.filename) ||
        // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        (frame.filename.includes('\\') && !frame.filename.includes('/'));
      // Check if the frame filename begins with `/`
      const startsWithSlash = /^\//.test(frame.filename);
      if (isWindowsFrame || startsWithSlash) {
        const filename = isWindowsFrame
          ? frame.filename
              .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
              .replace(/\\/g, '/') // replace all `\\` instances with `/`
          : frame.filename;
        const base = root ? relative(root, filename) : basename(filename);
        frame.filename = `${prefix}${base}`;
      }
      return frame;
    });

  /** Process an exception event. */
  function _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: _processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** Process a stack trace. */
  function _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => iteratee(f)),
    };
  }

  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(originalEvent) {
      let processedEvent = originalEvent;

      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
        processedEvent = _processExceptionsEvent(processedEvent);
      }

      return processedEvent;
    },
  };
}) ;

const rewriteFramesIntegration = (0,integration/* defineIntegration */._I)(_rewriteFramesIntegration);

/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const RewriteFrames = (0,integration/* convertIntegrationFnToClass */.RN)(
  INTEGRATION_NAME,
  rewriteFramesIntegration,
)

;


//# sourceMappingURL=rewriteframes.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(81539);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/rewriteFramesIntegration.js





const globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2

;

const customRewriteFramesIntegration = ((options) => {
  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  return rewriteFramesIntegration({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = (0,_optionalChain/* _optionalChain */.x)([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
    ...options,
  });
}) ;

const rewriteFramesIntegration_rewriteFramesIntegration = (0,integration/* defineIntegration */._I)(customRewriteFramesIntegration);


//# sourceMappingURL=rewriteFramesIntegration.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(10959);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/tunnelRoute.js



const tunnelRoute_globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = tunnelRoute_globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = (0,dsn/* dsnFromString */.U4)(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest(?:\.([a-z]{2}))?\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const regionCode = sentrySaasDsnMatch[2];
      let tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      if (regionCode) {
        tunnelPath += `&r=${regionCode}`;
      }
      options.tunnel = tunnelPath;
      common_debug_build/* DEBUG_BUILD */.X && logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      common_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/esm/common/_error.js
var _error = __webpack_require__(51608);
// EXTERNAL MODULE: ../../node_modules/next/constants.js
var constants = __webpack_require__(12836);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/utils/isBuild.js
/* provided dependency */ var isBuild_process = __webpack_require__(90907);


/**
 * Decide if the currently running process is part of the build phase or happening at runtime.
 */
function isBuild() {
  return isBuild_process.env.NEXT_PHASE === constants.PHASE_PRODUCTION_BUILD;
}


//# sourceMappingURL=isBuild.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(28218);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(48593);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/utils/platformSupportsStreaming.js
/* provided dependency */ var platformSupportsStreaming_process = __webpack_require__(90907);
const platformSupportsStreaming = () => !platformSupportsStreaming_process.env.LAMBDA_TASK_ROOT && !platformSupportsStreaming_process.env.VERCEL;


//# sourceMappingURL=platformSupportsStreaming.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/esm/common/utils/responseEnd.js
var responseEnd = __webpack_require__(74801);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/utils/wrapperUtils.js






/**
 * Grabs a span off a Next.js datafetcher request object, if it was previously put there via
 * `setSpanOnRequest`.
 *
 * @param req The Next.js datafetcher request object
 * @returns the span on the request object if there is one, or `undefined` if the request object didn't have one.
 */
function getSpanFromRequest(req) {
  return req._sentrySpan;
}

function setSpanOnRequest(transaction, req) {
  req._sentrySpan = transaction;
}

/**
 * Wraps a function that potentially throws. If it does, the error is passed to `captureException` and rethrown.
 *
 * Note: This function turns the wrapped function into an asynchronous one.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorInstrumentation(
  origFunction,
) {
  return async function ( ...origFunctionArguments) {
    try {
      return await origFunction.apply(this, origFunctionArguments);
    } catch (e) {
      // TODO: Extract error logic from `withSentry` in here or create a new wrapper with said logic or something like that.
      (0,esm_exports/* captureException */.Tb)(e, { mechanism: { handled: false } });

      throw e;
    }
  };
}

/**
 * Calls a server-side data fetching function (that takes a `req` and `res` object in its context) with tracing
 * instrumentation. A transaction will be created for the incoming request (if it doesn't already exist) in addition to
 * a span for the wrapped data fetching function.
 *
 * All of the above happens in an isolated domain, meaning all thrown errors will be associated with the correct span.
 *
 * @param origDataFetcher The data fetching method to call.
 * @param origFunctionArguments The arguments to call the data fetching method with.
 * @param req The data fetching function's request object.
 * @param res The data fetching function's response object.
 * @param options Options providing details for the created transaction and span.
 * @returns what the data fetching method call returned.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withTracedServerSideDataFetcher(
  origDataFetcher,
  req,
  res,
  options

,
) {
  return async function ( ...args) {
    return (0,esm_exports/* withIsolationScope */.wi)(async isolationScope => {
      isolationScope.setSDKProcessingMetadata({
        request: req,
      });

      const sentryTrace =
        req.headers && (0,is/* isString */.HD)(req.headers['sentry-trace']) ? req.headers['sentry-trace'] : undefined;
      const baggage = (0,_optionalChain/* _optionalChain */.x)([req, 'access', _ => _.headers, 'optionalAccess', _2 => _2.baggage]);

      return (0,trace/* continueTrace */.yn)({ sentryTrace, baggage }, () => {
        let requestSpan = getSpanFromRequest(req);
        if (!requestSpan) {
          // TODO(v8): Simplify these checks when startInactiveSpan always returns a span
          requestSpan = (0,trace/* startInactiveSpan */.qp)({
            name: options.requestedRouteName,
            op: 'http.server',
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'route',
            },
          });
          if (requestSpan) {
            requestSpan.setStatus('ok');
            setSpanOnRequest(requestSpan, req);
            (0,responseEnd/* autoEndSpanOnResponseEnd */.RR)(requestSpan, res);
          }
        }

        const withActiveSpanCallback = () => {
          return (0,trace/* startSpanManual */.V0)(
            {
              op: 'function.nextjs',
              name: `${options.dataFetchingMethodName} (${options.dataFetcherRouteName})`,
              attributes: {
                [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs',
                [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'route',
              },
            },
            async dataFetcherSpan => {
              (0,_optionalChain/* _optionalChain */.x)([dataFetcherSpan, 'optionalAccess', _3 => _3.setStatus, 'call', _4 => _4('ok')]);
              try {
                return await origDataFetcher.apply(this, args);
              } catch (e) {
                (0,_optionalChain/* _optionalChain */.x)([dataFetcherSpan, 'optionalAccess', _5 => _5.setStatus, 'call', _6 => _6('internal_error')]);
                (0,_optionalChain/* _optionalChain */.x)([requestSpan, 'optionalAccess', _7 => _7.setStatus, 'call', _8 => _8('internal_error')]);
                throw e;
              } finally {
                (0,_optionalChain/* _optionalChain */.x)([dataFetcherSpan, 'optionalAccess', _9 => _9.end, 'call', _10 => _10()]);
                if (!platformSupportsStreaming()) {
                  await (0,responseEnd/* flushQueue */.DO)();
                }
              }
            },
          );
        };

        if (requestSpan) {
          return (0,esm_exports/* withActiveSpan */._d)(requestSpan, withActiveSpanCallback);
        } else {
          return withActiveSpanCallback();
        }
      });
    });
  };
}

/**
 * Call a data fetcher and trace it. Only traces the function if there is an active transaction on the scope.
 *
 * We only do the following until we move transaction creation into this function: When called, the wrapped function
 * will also update the name of the active transaction with a parameterized route provided via the `options` argument.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function callDataFetcherTraced(
  origFunction,
  origFunctionArgs,
  options

,
) {
  const { parameterizedRoute, dataFetchingMethodName } = options;

  return (0,trace/* startSpan */.GK)(
    {
      op: 'function.nextjs',
      name: `${dataFetchingMethodName} (${parameterizedRoute})`,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs',
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'route',
      },
    },
    async dataFetcherSpan => {
      (0,_optionalChain/* _optionalChain */.x)([dataFetcherSpan, 'optionalAccess', _11 => _11.setStatus, 'call', _12 => _12('ok')]);

      try {
        return await origFunction(...origFunctionArgs);
      } catch (e) {
        (0,_optionalChain/* _optionalChain */.x)([dataFetcherSpan, 'optionalAccess', _13 => _13.setStatus, 'call', _14 => _14('internal_error')]);
        (0,esm_exports/* captureException */.Tb)(e, { mechanism: { handled: false } });
        throw e;
      } finally {
        (0,_optionalChain/* _optionalChain */.x)([dataFetcherSpan, 'optionalAccess', _15 => _15.end, 'call', _16 => _16()]);
        if (!platformSupportsStreaming()) {
          await (0,responseEnd/* flushQueue */.DO)();
        }
      }
    },
  );
}


//# sourceMappingURL=wrapperUtils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapGetStaticPropsWithSentry.js





/**
 * Create a wrapped version of the user's exported `getStaticProps` function
 *
 * @param origGetStaticProps The user's `getStaticProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function wrapGetStaticPropsWithSentry(
  origGetStaticPropsa,
  parameterizedRoute,
) {
  return new Proxy(origGetStaticPropsa, {
    apply: (wrappingTarget, thisArg, args) => {
      if (isBuild()) {
        return wrappingTarget.apply(thisArg, args);
      }

      (0,hubextensions/* addTracingExtensions */.T)();

      const errorWrappedGetStaticProps = withErrorInstrumentation(wrappingTarget);
      const options = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3()]);

      if ((0,_optionalChain/* _optionalChain */.x)([options, 'optionalAccess', _4 => _4.instrumenter]) === 'sentry') {
        return callDataFetcherTraced(errorWrappedGetStaticProps, args, {
          parameterizedRoute,
          dataFetchingMethodName: 'getStaticProps',
        });
      }

      return errorWrappedGetStaticProps.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapGetStaticPropsWithSentry` instead.
 */
const withSentryGetStaticProps = wrapGetStaticPropsWithSentry;


//# sourceMappingURL=wrapGetStaticPropsWithSentry.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(18746);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_asyncNullishCoalesce.js


// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f

/**
 * Polyfill for the nullish coalescing operator (`??`), when used in situations where at least one of the values is the
 * result of an async operation.
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
async function _asyncNullishCoalesce(lhs, rhsFn) {
  return (0,_nullishCoalesce/* _nullishCoalesce */.h)(lhs, rhsFn);
}

// Sucrase version:
// async function _asyncNullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return await rhsFn();
//   }
// }


//# sourceMappingURL=_asyncNullishCoalesce.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/getRootSpan.js
var getRootSpan = __webpack_require__(43889);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(4859);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(59278);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(28308);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapGetInitialPropsWithSentry.js






/**
 * Create a wrapped version of the user's exported `getInitialProps` function
 *
 * @param origGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function wrapGetInitialPropsWithSentry(origGetInitialProps) {
  return new Proxy(origGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      if (isBuild()) {
        return wrappingTarget.apply(thisArg, args);
      }

      (0,hubextensions/* addTracingExtensions */.T)();

      const [context] = args;
      const { req, res } = context;

      const errorWrappedGetInitialProps = withErrorInstrumentation(wrappingTarget);
      const options = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3()]);

      // Generally we can assume that `req` and `res` are always defined on the server:
      // https://nextjs.org/docs/api-reference/data-fetching/get-initial-props#context-object
      // This does not seem to be the case in dev mode. Because we have no clean way of associating the the data fetcher
      // span with each other when there are no req or res objects, we simply do not trace them at all here.
      if (req && res && (0,_optionalChain/* _optionalChain */.x)([options, 'optionalAccess', _4 => _4.instrumenter]) === 'sentry') {
        const tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedGetInitialProps, req, res, {
          dataFetcherRouteName: context.pathname,
          requestedRouteName: context.pathname,
          dataFetchingMethodName: 'getInitialProps',
        });

        const initialProps

 = await _asyncNullishCoalesce((await tracedGetInitialProps.apply(thisArg, args)), async () => ( {})); // Next.js allows undefined to be returned from a getInitialPropsFunction.

        const activeSpan = (0,trace/* getActiveSpan */.HN)();
        const requestSpan = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), () => ( (activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined)));

        if (requestSpan) {
          initialProps._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestSpan);

          const dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestSpan);
          initialProps._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
        }

        return initialProps;
      } else {
        return errorWrappedGetInitialProps.apply(thisArg, args);
      }
    },
  });
}

/**
 * @deprecated Use `wrapGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideGetInitialProps = wrapGetInitialPropsWithSentry;


//# sourceMappingURL=wrapGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapAppGetInitialPropsWithSentry.js






/**
 * Create a wrapped version of the user's exported `getInitialProps` function in
 * a custom app ("_app.js").
 *
 * @param origAppGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function wrapAppGetInitialPropsWithSentry(origAppGetInitialProps) {
  return new Proxy(origAppGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      if (isBuild()) {
        return wrappingTarget.apply(thisArg, args);
      }

      (0,hubextensions/* addTracingExtensions */.T)();

      const [context] = args;
      const { req, res } = context.ctx;

      const errorWrappedAppGetInitialProps = withErrorInstrumentation(wrappingTarget);
      const options = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3()]);

      // Generally we can assume that `req` and `res` are always defined on the server:
      // https://nextjs.org/docs/api-reference/data-fetching/get-initial-props#context-object
      // This does not seem to be the case in dev mode. Because we have no clean way of associating the the data fetcher
      // span with each other when there are no req or res objects, we simply do not trace them at all here.
      if (req && res && (0,_optionalChain/* _optionalChain */.x)([options, 'optionalAccess', _4 => _4.instrumenter]) === 'sentry') {
        const tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedAppGetInitialProps, req, res, {
          dataFetcherRouteName: '/_app',
          requestedRouteName: context.ctx.pathname,
          dataFetchingMethodName: 'getInitialProps',
        });

        const appGetInitialProps

 = await tracedGetInitialProps.apply(thisArg, args);

        const activeSpan = (0,trace/* getActiveSpan */.HN)();
        const requestSpan = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), () => ( (activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined)));

        // Per definition, `pageProps` is not optional, however an increased amount of users doesn't seem to call
        // `App.getInitialProps(appContext)` in their custom `_app` pages which is required as per
        // https://nextjs.org/docs/advanced-features/custom-app - resulting in missing `pageProps`.
        // For this reason, we just handle the case where `pageProps` doesn't exist explicitly.
        if (!appGetInitialProps.pageProps) {
          appGetInitialProps.pageProps = {};
        }

        if (requestSpan) {
          appGetInitialProps.pageProps._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestSpan);
          const dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestSpan);
          appGetInitialProps.pageProps._sentryBaggage =
            (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
        }

        return appGetInitialProps;
      } else {
        return errorWrappedAppGetInitialProps.apply(thisArg, args);
      }
    },
  });
}

/**
 * @deprecated Use `wrapAppGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideAppGetInitialProps = wrapAppGetInitialPropsWithSentry;


//# sourceMappingURL=wrapAppGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapDocumentGetInitialPropsWithSentry.js





/**
 * Create a wrapped version of the user's exported `getInitialProps` function in
 * a custom document ("_document.js").
 *
 * @param origDocumentGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function wrapDocumentGetInitialPropsWithSentry(
  origDocumentGetInitialProps,
) {
  return new Proxy(origDocumentGetInitialProps, {
    apply: (wrappingTarget, thisArg, args) => {
      if (isBuild()) {
        return wrappingTarget.apply(thisArg, args);
      }

      (0,hubextensions/* addTracingExtensions */.T)();

      const [context] = args;
      const { req, res } = context;

      const errorWrappedGetInitialProps = withErrorInstrumentation(wrappingTarget);
      const options = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3()]);

      // Generally we can assume that `req` and `res` are always defined on the server:
      // https://nextjs.org/docs/api-reference/data-fetching/get-initial-props#context-object
      // This does not seem to be the case in dev mode. Because we have no clean way of associating the the data fetcher
      // span with each other when there are no req or res objects, we simply do not trace them at all here.
      if (req && res && (0,_optionalChain/* _optionalChain */.x)([options, 'optionalAccess', _4 => _4.instrumenter]) === 'sentry') {
        const tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedGetInitialProps, req, res, {
          dataFetcherRouteName: '/_document',
          requestedRouteName: context.pathname,
          dataFetchingMethodName: 'getInitialProps',
        });

        return tracedGetInitialProps.apply(thisArg, args);
      } else {
        return errorWrappedGetInitialProps.apply(thisArg, args);
      }
    },
  });
}

/**
 * @deprecated Use `wrapDocumentGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideDocumentGetInitialProps = wrapDocumentGetInitialPropsWithSentry;


//# sourceMappingURL=wrapDocumentGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapErrorGetInitialPropsWithSentry.js






/**
 * Create a wrapped version of the user's exported `getInitialProps` function in
 * a custom error page ("_error.js").
 *
 * @param origErrorGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function wrapErrorGetInitialPropsWithSentry(
  origErrorGetInitialProps,
) {
  return new Proxy(origErrorGetInitialProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      if (isBuild()) {
        return wrappingTarget.apply(thisArg, args);
      }

      (0,hubextensions/* addTracingExtensions */.T)();

      const [context] = args;
      const { req, res } = context;

      const errorWrappedGetInitialProps = withErrorInstrumentation(wrappingTarget);
      const options = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3()]);

      // Generally we can assume that `req` and `res` are always defined on the server:
      // https://nextjs.org/docs/api-reference/data-fetching/get-initial-props#context-object
      // This does not seem to be the case in dev mode. Because we have no clean way of associating the the data fetcher
      // span with each other when there are no req or res objects, we simply do not trace them at all here.
      if (req && res && (0,_optionalChain/* _optionalChain */.x)([options, 'optionalAccess', _4 => _4.instrumenter]) === 'sentry') {
        const tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedGetInitialProps, req, res, {
          dataFetcherRouteName: '/_error',
          requestedRouteName: context.pathname,
          dataFetchingMethodName: 'getInitialProps',
        });

        const errorGetInitialProps

 = await tracedGetInitialProps.apply(thisArg, args);

        const activeSpan = (0,trace/* getActiveSpan */.HN)();
        const requestSpan = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), () => ( (activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined)));

        if (requestSpan) {
          errorGetInitialProps._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestSpan);

          const dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestSpan);
          errorGetInitialProps._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
        }

        return errorGetInitialProps;
      } else {
        return errorWrappedGetInitialProps.apply(thisArg, args);
      }
    },
  });
}

/**
 * @deprecated Use `wrapErrorGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideErrorGetInitialProps = wrapErrorGetInitialPropsWithSentry;


//# sourceMappingURL=wrapErrorGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapGetServerSidePropsWithSentry.js






/**
 * Create a wrapped version of the user's exported `getServerSideProps` function
 *
 * @param origGetServerSideProps The user's `getServerSideProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function wrapGetServerSidePropsWithSentry(
  origGetServerSideProps,
  parameterizedRoute,
) {
  return new Proxy(origGetServerSideProps, {
    apply: async (wrappingTarget, thisArg, args) => {
      if (isBuild()) {
        return wrappingTarget.apply(thisArg, args);
      }

      (0,hubextensions/* addTracingExtensions */.T)();

      const [context] = args;
      const { req, res } = context;

      const errorWrappedGetServerSideProps = withErrorInstrumentation(wrappingTarget);
      const options = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3()]);

      if ((0,_optionalChain/* _optionalChain */.x)([options, 'optionalAccess', _4 => _4.instrumenter]) === 'sentry') {
        const tracedGetServerSideProps = withTracedServerSideDataFetcher(errorWrappedGetServerSideProps, req, res, {
          dataFetcherRouteName: parameterizedRoute,
          requestedRouteName: parameterizedRoute,
          dataFetchingMethodName: 'getServerSideProps',
        });

        const serverSideProps = await (tracedGetServerSideProps.apply(thisArg, args)

);

        if (serverSideProps && 'props' in serverSideProps) {
          const activeSpan = (0,trace/* getActiveSpan */.HN)();
          const requestTransaction = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), () => ( (activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined)));
          if (requestTransaction) {
            serverSideProps.props._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestTransaction);

            const dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestTransaction);
            serverSideProps.props._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
          }
        }

        return serverSideProps;
      } else {
        return errorWrappedGetServerSideProps.apply(thisArg, args);
      }
    },
  });
}

/**
 * @deprecated Use `withSentryGetServerSideProps` instead.
 */
const withSentryGetServerSideProps = wrapGetServerSidePropsWithSentry;


//# sourceMappingURL=wrapGetServerSidePropsWithSentry.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/handleCallbackErrors.js
var handleCallbackErrors = __webpack_require__(42885);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/debug-build.js
var esm_debug_build = __webpack_require__(40137);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/requestdata.js







const DEFAULT_INCLUDES = {
  ip: false,
  request: true,
  transaction: true,
  user: true,
};
const DEFAULT_REQUEST_INCLUDES = (/* unused pure expression or super */ null && (['cookies', 'data', 'headers', 'method', 'query_string', 'url']));
const DEFAULT_USER_INCLUDES = (/* unused pure expression or super */ null && (['id', 'username', 'email']));

/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */
function addRequestDataToTransaction(
  transaction,
  req,
  deps,
) {
  if (!transaction) return;
  // eslint-disable-next-line deprecation/deprecation
  if (!transaction.metadata.source || transaction.metadata.source === 'url') {
    // Attempt to grab a parameterized route off of the request
    const [name, source] = extractPathForTransaction(req, { path: true, method: true });
    transaction.updateName(name);
    // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
    // eslint-disable-next-line deprecation/deprecation
    transaction.setMetadata({ source });
  }
  transaction.setAttribute('url', req.originalUrl || req.url);
  if (req.baseUrl) {
    transaction.setAttribute('baseUrl', req.baseUrl);
  }
  // TODO: We need to rewrite this to a flat format?
  // eslint-disable-next-line deprecation/deprecation
  transaction.setData('query', extractQueryParams(req, deps));
}

/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */
function extractPathForTransaction(
  req,
  options = {},
) {
  const method = req.method && req.method.toUpperCase();

  let path = '';
  let source = 'url';

  // Check to see if there's a parameterized route we can use (as there is in Express)
  if (options.customRoute || req.route) {
    path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
    source = 'route';
  }

  // Otherwise, just take the original URL
  else if (req.originalUrl || req.url) {
    path = stripUrlQueryAndFragment(req.originalUrl || req.url || '');
  }

  let name = '';
  if (options.method && method) {
    name += method;
  }
  if (options.method && options.path) {
    name += ' ';
  }
  if (options.path && path) {
    name += path;
  }

  return [name, source];
}

/** JSDoc */
function extractTransaction(req, type) {
  switch (type) {
    case 'path': {
      return extractPathForTransaction(req, { path: true })[0];
    }
    case 'handler': {
      return (req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name) || '<anonymous>';
    }
    case 'methodPath':
    default: {
      // if exist _reconstructedRoute return that path instead of route.path
      const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
      return extractPathForTransaction(req, { path: true, method: true, customRoute })[0];
    }
  }
}

/** JSDoc */
function extractUserData(
  user

,
  keys,
) {
  const extractedUser = {};
  const attributes = Array.isArray(keys) ? keys : DEFAULT_USER_INCLUDES;

  attributes.forEach(key => {
    if (user && key in user) {
      extractedUser[key] = user[key];
    }
  });

  return extractedUser;
}

/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */
function extractRequestData(
  req,
  options

,
) {
  const { include = DEFAULT_REQUEST_INCLUDES, deps } = options || {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const requestData = {};

  // headers:
  //   node, express, koa, nextjs: req.headers
  const headers = (req.headers || {})

;
  // method:
  //   node, express, koa, nextjs: req.method
  const method = req.method;
  // host:
  //   express: req.hostname in > 4 and req.host in < 4
  //   koa: req.host
  //   node, nextjs: req.headers.host
  // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
  // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
  // Also: https://github.com/getsentry/sentry-javascript/issues/1917
  const host = headers.host || req.hostname || req.host || '<no host>';
  // protocol:
  //   node, nextjs: <n/a>
  //   express, koa: req.protocol
  const protocol = req.protocol === 'https' || (req.socket && req.socket.encrypted) ? 'https' : 'http';
  // url (including path and query string):
  //   node, express: req.originalUrl
  //   koa, nextjs: req.url
  const originalUrl = req.originalUrl || req.url || '';
  // absolute url
  const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
  include.forEach(key => {
    switch (key) {
      case 'headers': {
        requestData.headers = headers;

        // Remove the Cookie header in case cookie data should not be included in the event
        if (!include.includes('cookies')) {
          delete (requestData.headers ).cookie;
        }

        break;
      }
      case 'method': {
        requestData.method = method;
        break;
      }
      case 'url': {
        requestData.url = absoluteUrl;
        break;
      }
      case 'cookies': {
        // cookies:
        //   node, express, koa: req.headers.cookie
        //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
        requestData.cookies =
          // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
          // come off in v8
          req.cookies || (headers.cookie && parseCookie(headers.cookie)) || {};
        break;
      }
      case 'query_string': {
        // query string:
        //   node: req.url (raw)
        //   express, koa, nextjs: req.query
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        requestData.query_string = extractQueryParams(req, deps);
        break;
      }
      case 'data': {
        if (method === 'GET' || method === 'HEAD') {
          break;
        }
        // body data:
        //   express, koa, nextjs: req.body
        //
        //   when using node by itself, you have to read the incoming stream(see
        //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
        //   where they're going to store the final result, so they'll have to capture this data themselves
        if (req.body !== undefined) {
          requestData.data = isString(req.body) ? req.body : JSON.stringify(normalize(req.body));
        }
        break;
      }
      default: {
        if ({}.hasOwnProperty.call(req, key)) {
          requestData[key] = (req )[key];
        }
      }
    }
  });

  return requestData;
}

/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */
function addRequestDataToEvent(
  event,
  req,
  options,
) {
  const include = {
    ...DEFAULT_INCLUDES,
    ...(options && options.include),
  };

  if (include.request) {
    const extractedRequestData = Array.isArray(include.request)
      ? extractRequestData(req, { include: include.request, deps: options && options.deps })
      : extractRequestData(req, { deps: options && options.deps });

    event.request = {
      ...event.request,
      ...extractedRequestData,
    };
  }

  if (include.user) {
    const extractedUser = req.user && isPlainObject(req.user) ? extractUserData(req.user, include.user) : {};

    if (Object.keys(extractedUser).length) {
      event.user = {
        ...event.user,
        ...extractedUser,
      };
    }
  }

  // client ip:
  //   node, nextjs: req.socket.remoteAddress
  //   express, koa: req.ip
  if (include.ip) {
    const ip = req.ip || (req.socket && req.socket.remoteAddress);
    if (ip) {
      event.user = {
        ...event.user,
        ip_address: ip,
      };
    }
  }

  if (include.transaction && !event.transaction) {
    // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = extractTransaction(req, include.transaction);
  }

  return event;
}

function extractQueryParams(
  req,
  deps,
) {
  // url (including path and query string):
  //   node, express: req.originalUrl
  //   koa, nextjs: req.url
  let originalUrl = req.originalUrl || req.url || '';

  if (!originalUrl) {
    return;
  }

  // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
  // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
  if (originalUrl.startsWith('/')) {
    originalUrl = `http://dogs.are.great${originalUrl}`;
  }

  try {
    return (
      req.query ||
      (typeof URL !== 'undefined' && new URL(originalUrl).search.slice(1)) ||
      // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
      (deps && deps.url && deps.url.parse(originalUrl).query) ||
      undefined
    );
  } catch (e2) {
    return undefined;
  }
}

/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */
// TODO(v8): Make this function return undefined when the extraction fails.
function winterCGHeadersToDict(winterCGHeaders) {
  const headers = {};
  try {
    winterCGHeaders.forEach((value, key) => {
      if (typeof value === 'string') {
        // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
        headers[key] = value;
      }
    });
  } catch (e) {
    esm_debug_build/* DEBUG_BUILD */.X &&
      logger/* logger.warn */.kg.warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');
  }

  return headers;
}

/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */
function winterCGRequestToRequestData(req) {
  const headers = winterCGHeadersToDict(req.headers);
  return {
    method: req.method,
    url: req.url,
    headers,
  };
}


//# sourceMappingURL=requestdata.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/nextNavigationErrorUtils.js


/**
 * Determines whether input is a Next.js not-found error.
 * https://beta.nextjs.org/docs/api-reference/notfound#notfound
 */
function isNotFoundNavigationError(subject) {
  return (0,is/* isError */.VZ)(subject) && (subject ).digest === 'NEXT_NOT_FOUND';
}

/**
 * Determines whether input is a Next.js redirect error.
 * https://beta.nextjs.org/docs/api-reference/redirect#redirect
 */
function isRedirectNavigationError(subject) {
  return (
    (0,is/* isError */.VZ)(subject) &&
    typeof (subject ).digest === 'string' &&
    (subject ).digest.startsWith('NEXT_REDIRECT;') // a redirect digest looks like "NEXT_REDIRECT;[redirect path]"
  );
}


//# sourceMappingURL=nextNavigationErrorUtils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/utils/commonObjectTracing.js
const commonMap = new WeakMap();

/**
 * Takes a shared (garbage collectable) object between resources, e.g. a headers object shared between Next.js server components and returns a common propagation context.
 *
 * @param commonObject The shared object.
 * @param propagationContext The propagation context that should be shared between all the resources if no propagation context was registered yet.
 * @returns the shared propagation context.
 */
function commonObjectToPropagationContext(
  commonObject,
  propagationContext,
) {
  if (typeof commonObject === 'object' && commonObject) {
    const memoPropagationContext = commonMap.get(commonObject);
    if (memoPropagationContext) {
      return memoPropagationContext;
    } else {
      commonMap.set(commonObject, propagationContext);
      return propagationContext;
    }
  } else {
    return propagationContext;
  }
}


//# sourceMappingURL=commonObjectTracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapServerComponentWithSentry.js







/**
 * Wraps an `app` directory server component with Sentry error instrumentation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapServerComponentWithSentry(
  appDirComponent,
  context,
) {
  (0,hubextensions/* addTracingExtensions */.T)();
  const { componentRoute, componentType } = context;

  // Even though users may define server components as async functions, for the client bundles
  // Next.js will turn them into synchronous functions and it will transform any `await`s into instances of the `use`
  // hook. 🤯
  return new Proxy(appDirComponent, {
    apply: (originalFunction, thisArg, args) => {
      // TODO: If we ever allow withIsolationScope to take a scope, we should pass a scope here that is shared between all of the server components, similar to what `commonObjectToPropagationContext` does.
      return (0,esm_exports/* withIsolationScope */.wi)(isolationScope => {
        const completeHeadersDict = context.headers
          ? winterCGHeadersToDict(context.headers)
          : {};

        isolationScope.setSDKProcessingMetadata({
          request: {
            headers: completeHeadersDict,
          },
        });

        const incomingPropagationContext = (0,tracing/* propagationContextFromHeaders */.pT)(
          // eslint-disable-next-line deprecation/deprecation
          (0,_nullishCoalesce/* _nullishCoalesce */.h)(context.sentryTraceHeader, () => ( completeHeadersDict['sentry-trace'])),
          // eslint-disable-next-line deprecation/deprecation
          (0,_nullishCoalesce/* _nullishCoalesce */.h)(context.baggageHeader, () => ( completeHeadersDict['baggage'])),
        );

        const propagationContext = commonObjectToPropagationContext(context.headers, incomingPropagationContext);
        isolationScope.setPropagationContext(propagationContext);
        (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);

        return (0,trace/* startSpanManual */.V0)(
          {
            op: 'function.nextjs',
            name: `${componentType} Server Component (${componentRoute})`,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'component',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs',
            },
          },
          span => {
            return (0,handleCallbackErrors/* handleCallbackErrors */.i)(
              () => originalFunction.apply(thisArg, args),
              error => {
                if (isNotFoundNavigationError(error)) {
                  // We don't want to report "not-found"s
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _ => _.setStatus, 'call', _2 => _2('not_found')]);
                } else if (isRedirectNavigationError(error)) {
                  // We don't want to report redirects
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _3 => _3.setStatus, 'call', _4 => _4('ok')]);
                } else {
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _5 => _5.setStatus, 'call', _6 => _6('internal_error')]);
                  (0,esm_exports/* captureException */.Tb)(error, {
                    mechanism: {
                      handled: false,
                    },
                  });
                }
              },
              () => {
                (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _7 => _7.end, 'call', _8 => _8()]);

                // flushQueue should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0,responseEnd/* flushQueue */.DO)();
              },
            );
          },
        );
      });
    },
  });
}


//# sourceMappingURL=wrapServerComponentWithSentry.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(35818);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapRouteHandlerWithSentry.js
/* provided dependency */ var wrapRouteHandlerWithSentry_process = __webpack_require__(90907);







/**
 * Wraps a Next.js route handler with performance and error instrumentation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapRouteHandlerWithSentry(
  routeHandler,
  context,
) {
  (0,hubextensions/* addTracingExtensions */.T)();
  // eslint-disable-next-line deprecation/deprecation
  const { method, parameterizedRoute, baggageHeader, sentryTraceHeader, headers } = context;
  return new Proxy(routeHandler, {
    apply: (originalFunction, thisArg, args) => {
      return (0,esm_exports/* withIsolationScope */.wi)(async isolationScope => {
        isolationScope.setSDKProcessingMetadata({
          request: {
            headers: headers ? winterCGHeadersToDict(headers) : undefined,
          },
        });
        return (0,trace/* continueTrace */.yn)(
          {
            sentryTrace: (0,_nullishCoalesce/* _nullishCoalesce */.h)((0,_nullishCoalesce/* _nullishCoalesce */.h)(sentryTraceHeader, () => ( (0,_optionalChain/* _optionalChain */.x)([headers, 'optionalAccess', _ => _.get, 'call', _2 => _2('sentry-trace')]))), () => ( undefined)),
            baggage: (0,_nullishCoalesce/* _nullishCoalesce */.h)(baggageHeader, () => ( (0,_optionalChain/* _optionalChain */.x)([headers, 'optionalAccess', _3 => _3.get, 'call', _4 => _4('baggage')]))),
          },
          async () => {
            try {
              return await (0,trace/* startSpan */.GK)(
                {
                  op: 'http.server',
                  name: `${method} ${parameterizedRoute}`,
                  attributes: {
                    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'route',
                    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs',
                  },
                },
                async span => {
                  const response = await (0,handleCallbackErrors/* handleCallbackErrors */.i)(
                    () => originalFunction.apply(thisArg, args),
                    error => {
                      // Next.js throws errors when calling `redirect()`. We don't wanna report these.
                      if (!isRedirectNavigationError(error)) {
                        (0,esm_exports/* captureException */.Tb)(error, {
                          mechanism: {
                            handled: false,
                          },
                        });
                      }
                    },
                  );

                  try {
                    span && (0,spanstatus/* setHttpStatus */.Q0)(span, response.status);
                  } catch (e) {
                    // best effort - response may be undefined?
                  }

                  return response;
                },
              );
            } finally {
              if (!platformSupportsStreaming() || wrapRouteHandlerWithSentry_process.env.NEXT_RUNTIME === 'edge') {
                // 1. Edge transport requires manual flushing
                // 2. Lambdas require manual flushing to prevent execution freeze before the event is sent
                await (0,responseEnd/* flushQueue */.DO)();
              }
            }
          },
        );
      });
    },
  });
}


//# sourceMappingURL=wrapRouteHandlerWithSentry.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(10857);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapApiHandlerWithSentryVercelCrons.js



/**
 * Wraps a function with Sentry crons instrumentation by automaticaly sending check-ins for the given Vercel crons config.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapApiHandlerWithSentryVercelCrons(
  handler,
  vercelCronsConfig,
) {
  return new Proxy(handler, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    apply: (originalFunction, thisArg, args) => {
      return (0,hub/* runWithAsyncContext */.Ok)(() => {
        if (!args || !args[0]) {
          return originalFunction.apply(thisArg, args);
        }

        (0,hubextensions/* addTracingExtensions */.T)();
        const [req] = args ;

        let maybePromiseResult;
        const cronsKey = 'nextUrl' in req ? req.nextUrl.pathname : req.url;
        const userAgentHeader = 'nextUrl' in req ? req.headers.get('user-agent') : req.headers['user-agent'];

        if (
          !vercelCronsConfig || // do nothing if vercel crons config is missing
          !(0,_optionalChain/* _optionalChain */.x)([userAgentHeader, 'optionalAccess', _ => _.includes, 'call', _2 => _2('vercel-cron')]) // do nothing if endpoint is not called from vercel crons
        ) {
          return originalFunction.apply(thisArg, args);
        }

        const vercelCron = vercelCronsConfig.find(vercelCron => vercelCron.path === cronsKey);

        if (!vercelCron || !vercelCron.path || !vercelCron.schedule) {
          return originalFunction.apply(thisArg, args);
        }

        const monitorSlug = vercelCron.path;

        const checkInId = (0,esm_exports/* captureCheckIn */.c)(
          {
            monitorSlug,
            status: 'in_progress',
          },
          {
            maxRuntime: 60 * 12, // (minutes) so 12 hours - just a very high arbitrary number since we don't know the actual duration of the users cron job
            schedule: {
              type: 'crontab',
              value: vercelCron.schedule,
            },
          },
        );

        const startTime = Date.now() / 1000;

        const handleErrorCase = () => {
          (0,esm_exports/* captureCheckIn */.c)({
            checkInId,
            monitorSlug,
            status: 'error',
            duration: Date.now() / 1000 - startTime,
          });
        };

        try {
          maybePromiseResult = originalFunction.apply(thisArg, args);
        } catch (e) {
          handleErrorCase();
          throw e;
        }

        if (typeof maybePromiseResult === 'object' && maybePromiseResult !== null && 'then' in maybePromiseResult) {
          Promise.resolve(maybePromiseResult).then(
            () => {
              (0,esm_exports/* captureCheckIn */.c)({
                checkInId,
                monitorSlug,
                status: 'ok',
                duration: Date.now() / 1000 - startTime,
              });
            },
            () => {
              handleErrorCase();
            },
          );

          // It is very important that we return the original promise here, because Next.js attaches various properties
          // to that promise and will throw if they are not on the returned value.
          return maybePromiseResult;
        } else {
          (0,esm_exports/* captureCheckIn */.c)({
            checkInId,
            monitorSlug,
            status: 'ok',
            duration: Date.now() / 1000 - startTime,
          });
          return maybePromiseResult;
        }
      });
    },
  });
}


//# sourceMappingURL=wrapApiHandlerWithSentryVercelCrons.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/utils/edgeWrapperUtils.js




/**
 * Wraps a function on the edge runtime with error and performance monitoring.
 */
function withEdgeWrapping(
  handler,
  options,
) {
  return async function ( ...args) {
    (0,hubextensions/* addTracingExtensions */.T)();
    const req = args[0];

    let sentryTrace;
    let baggage;

    if (req instanceof Request) {
      sentryTrace = req.headers.get('sentry-trace') || '';
      baggage = req.headers.get('baggage');
    }

    return (0,trace/* continueTrace */.yn)(
      {
        sentryTrace,
        baggage,
      },
      () => {
        return (0,trace/* startSpan */.GK)(
          {
            name: options.spanDescription,
            op: options.spanOp,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'route',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs.withEdgeWrapping',
            },
            metadata: {
              request: req instanceof Request ? winterCGRequestToRequestData(req) : undefined,
            },
          },
          async span => {
            const handlerResult = await (0,handleCallbackErrors/* handleCallbackErrors */.i)(
              () => handler.apply(this, args),
              error => {
                (0,esm_exports/* captureException */.Tb)(error, {
                  mechanism: {
                    type: 'instrument',
                    handled: false,
                    data: {
                      function: options.mechanismFunctionName,
                    },
                  },
                });
              },
            );

            if (span) {
              if (handlerResult instanceof Response) {
                (0,spanstatus/* setHttpStatus */.Q0)(span, handlerResult.status);
              } else {
                span.setStatus('ok');
              }
            }

            return handlerResult;
          },
        ).finally(() => (0,responseEnd/* flushQueue */.DO)());
      },
    );
  };
}


//# sourceMappingURL=edgeWrapperUtils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapMiddlewareWithSentry.js


/**
 * Wraps Next.js middleware with Sentry error and performance instrumentation.
 *
 * @param middleware The middleware handler.
 * @returns a wrapped middleware handler.
 */
function wrapMiddlewareWithSentry(
  middleware,
) {
  return new Proxy(middleware, {
    apply: (wrappingTarget, thisArg, args) => {
      return withEdgeWrapping(wrappingTarget, {
        spanDescription: 'middleware',
        spanOp: 'middleware.nextjs',
        mechanismFunctionName: 'withSentryMiddleware',
      }).apply(thisArg, args);
    },
  });
}


//# sourceMappingURL=wrapMiddlewareWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapPageComponentWithSentry.js




function isReactClassComponent(target) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return typeof target === 'function' && (0,_optionalChain/* _optionalChain */.x)([target, 'optionalAccess', _ => _.prototype, 'optionalAccess', _2 => _2.isReactComponent]);
}

/**
 * Wraps a page component with Sentry error instrumentation.
 */
function wrapPageComponentWithSentry(pageComponent) {
  (0,hubextensions/* addTracingExtensions */.T)();
  if (isReactClassComponent(pageComponent)) {
    return class SentryWrappedPageComponent extends pageComponent {
       render(...args) {
        return (0,hub/* runWithAsyncContext */.Ok)(() => {
          const scope = (0,esm_exports/* getCurrentScope */.nZ)();
          // We extract the sentry trace data that is put in the component props by datafetcher wrappers
          const sentryTraceData =
            typeof this.props === 'object' &&
            this.props !== null &&
            '_sentryTraceData' in this.props &&
            typeof this.props._sentryTraceData === 'string'
              ? this.props._sentryTraceData
              : undefined;

          if (sentryTraceData) {
            const traceparentData = (0,tracing/* extractTraceparentData */.qG)(sentryTraceData);
            scope.setContext('trace', {
              span_id: (0,_optionalChain/* _optionalChain */.x)([traceparentData, 'optionalAccess', _3 => _3.parentSpanId]),
              trace_id: (0,_optionalChain/* _optionalChain */.x)([traceparentData, 'optionalAccess', _4 => _4.traceId]),
            });
          }

          try {
            return super.render(...args);
          } catch (e) {
            (0,esm_exports/* captureException */.Tb)(e, {
              mechanism: {
                handled: false,
              },
            });
            throw e;
          }
        });
      }
    };
  } else if (typeof pageComponent === 'function') {
    return new Proxy(pageComponent, {
      apply(target, thisArg, argArray) {
        return (0,hub/* runWithAsyncContext */.Ok)(() => {
          const scope = (0,esm_exports/* getCurrentScope */.nZ)();
          // We extract the sentry trace data that is put in the component props by datafetcher wrappers
          const sentryTraceData = (0,_optionalChain/* _optionalChain */.x)([argArray, 'optionalAccess', _5 => _5[0], 'optionalAccess', _6 => _6._sentryTraceData]);

          if (sentryTraceData) {
            const traceparentData = (0,tracing/* extractTraceparentData */.qG)(sentryTraceData);
            scope.setContext('trace', {
              span_id: (0,_optionalChain/* _optionalChain */.x)([traceparentData, 'optionalAccess', _7 => _7.parentSpanId]),
              trace_id: (0,_optionalChain/* _optionalChain */.x)([traceparentData, 'optionalAccess', _8 => _8.traceId]),
            });
          }

          try {
            return target.apply(thisArg, argArray);
          } catch (e) {
            (0,esm_exports/* captureException */.Tb)(e, {
              mechanism: {
                handled: false,
              },
            });
            throw e;
          }
        });
      },
    });
  } else {
    return pageComponent;
  }
}


//# sourceMappingURL=wrapPageComponentWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/wrapGenerationFunctionWithSentry.js






/**
 * Wraps a generation function (e.g. generateMetadata) with Sentry error and performance instrumentation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapGenerationFunctionWithSentry(
  generationFunction,
  context,
) {
  (0,hubextensions/* addTracingExtensions */.T)();
  const { requestAsyncStorage, componentRoute, componentType, generationFunctionIdentifier } = context;
  return new Proxy(generationFunction, {
    apply: (originalFunction, thisArg, args) => {
      let headers = undefined;
      // We try-catch here just in case anything goes wrong with the async storage here goes wrong since it is Next.js internal API
      try {
        headers = (0,_optionalChain/* _optionalChain */.x)([requestAsyncStorage, 'optionalAccess', _ => _.getStore, 'call', _2 => _2(), 'optionalAccess', _3 => _3.headers]);
      } catch (e) {
        /** empty */
      }

      let data = undefined;
      if ((0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _4 => _4(), 'optionalAccess', _5 => _5.getOptions, 'call', _6 => _6(), 'access', _7 => _7.sendDefaultPii])) {
        const props = args[0];
        const params = props && typeof props === 'object' && 'params' in props ? props.params : undefined;
        const searchParams =
          props && typeof props === 'object' && 'searchParams' in props ? props.searchParams : undefined;
        data = { params, searchParams };
      }

      return (0,esm_exports/* withIsolationScope */.wi)(isolationScope => {
        isolationScope.setSDKProcessingMetadata({
          request: {
            headers: headers ? winterCGHeadersToDict(headers) : undefined,
          },
        });
        isolationScope.setExtra('route_data', data);

        const incomingPropagationContext = (0,tracing/* propagationContextFromHeaders */.pT)(
          (0,_nullishCoalesce/* _nullishCoalesce */.h)((0,_optionalChain/* _optionalChain */.x)([headers, 'optionalAccess', _8 => _8.get, 'call', _9 => _9('sentry-trace')]), () => ( undefined)),
          (0,_optionalChain/* _optionalChain */.x)([headers, 'optionalAccess', _10 => _10.get, 'call', _11 => _11('baggage')]),
        );

        const propagationContext = commonObjectToPropagationContext(headers, incomingPropagationContext);
        isolationScope.setPropagationContext(propagationContext);
        (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);

        return (0,trace/* startSpanManual */.V0)(
          {
            op: 'function.nextjs',
            name: `${componentType}.${generationFunctionIdentifier} (${componentRoute})`,
            data,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'route',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.function.nextjs',
            },
          },
          span => {
            return (0,handleCallbackErrors/* handleCallbackErrors */.i)(
              () => originalFunction.apply(thisArg, args),
              err => {
                if (isNotFoundNavigationError(err)) {
                  // We don't want to report "not-found"s
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _12 => _12.setStatus, 'call', _13 => _13('not_found')]);
                } else if (isRedirectNavigationError(err)) {
                  // We don't want to report redirects
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _14 => _14.setStatus, 'call', _15 => _15('ok')]);
                } else {
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _16 => _16.setStatus, 'call', _17 => _17('internal_error')]);
                  (0,esm_exports/* captureException */.Tb)(err, {
                    mechanism: {
                      handled: false,
                    },
                  });
                }
              },
              () => {
                (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _18 => _18.end, 'call', _19 => _19()]);
              },
            );
          },
        );
      });
    },
  });
}


//# sourceMappingURL=wrapGenerationFunctionWithSentry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/withServerActionInstrumentation.js
/* provided dependency */ var withServerActionInstrumentation_process = __webpack_require__(90907);








/**
 * Wraps a Next.js Server Action implementation with Sentry Error and Performance instrumentation.
 */
function withServerActionInstrumentation(
  ...args
) {
  if (typeof args[1] === 'function') {
    const [serverActionName, callback] = args;
    return withServerActionInstrumentationImplementation(serverActionName, {}, callback);
  } else {
    const [serverActionName, options, callback] = args;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return withServerActionInstrumentationImplementation(serverActionName, options, callback);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function withServerActionInstrumentationImplementation(
  serverActionName,
  options,
  callback,
) {
  (0,hubextensions/* addTracingExtensions */.T)();
  return (0,esm_exports/* withIsolationScope */.wi)(isolationScope => {
    const sendDefaultPii = (0,_optionalChain/* _optionalChain */.x)([esm_exports/* getClient */.s3, 'call', _ => _(), 'optionalAccess', _2 => _2.getOptions, 'call', _3 => _3(), 'access', _4 => _4.sendDefaultPii]);

    let sentryTraceHeader;
    let baggageHeader;
    const fullHeadersObject = {};
    try {
      sentryTraceHeader = (0,_nullishCoalesce/* _nullishCoalesce */.h)((0,_optionalChain/* _optionalChain */.x)([options, 'access', _5 => _5.headers, 'optionalAccess', _6 => _6.get, 'call', _7 => _7('sentry-trace')]), () => ( undefined));
      baggageHeader = (0,_optionalChain/* _optionalChain */.x)([options, 'access', _8 => _8.headers, 'optionalAccess', _9 => _9.get, 'call', _10 => _10('baggage')]);
      (0,_optionalChain/* _optionalChain */.x)([options, 'access', _11 => _11.headers, 'optionalAccess', _12 => _12.forEach, 'call', _13 => _13((value, key) => {
        fullHeadersObject[key] = value;
      })]);
    } catch (e) {
      common_debug_build/* DEBUG_BUILD */.X &&
        logger/* logger.warn */.kg.warn(
          "Sentry wasn't able to extract the tracing headers for a server action. Will not trace this request.",
        );
    }

    isolationScope.setSDKProcessingMetadata({
      request: {
        headers: fullHeadersObject,
      },
    });

    return (0,trace/* continueTrace */.yn)(
      {
        sentryTrace: sentryTraceHeader,
        baggage: baggageHeader,
      },
      async () => {
        try {
          return await (0,trace/* startSpan */.GK)(
            {
              op: 'function.server_action',
              name: `serverAction/${serverActionName}`,
              metadata: {
                source: 'route',
              },
            },
            async span => {
              const result = await (0,handleCallbackErrors/* handleCallbackErrors */.i)(callback, error => {
                if (isNotFoundNavigationError(error)) {
                  // We don't want to report "not-found"s
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _14 => _14.setStatus, 'call', _15 => _15('not_found')]);
                } else if (isRedirectNavigationError(error)) {
                  // Don't do anything for redirects
                } else {
                  (0,_optionalChain/* _optionalChain */.x)([span, 'optionalAccess', _16 => _16.setStatus, 'call', _17 => _17('internal_error')]);
                  (0,esm_exports/* captureException */.Tb)(error, {
                    mechanism: {
                      handled: false,
                    },
                  });
                }
              });

              if (options.recordResponse !== undefined ? options.recordResponse : sendDefaultPii) {
                (0,hub/* getIsolationScope */.aF)().setExtra('server_action_result', result);
              }

              if (options.formData) {
                options.formData.forEach((value, key) => {
                  (0,hub/* getIsolationScope */.aF)().setExtra(
                    `server_action_form_data.${key}`,
                    typeof value === 'string' ? value : '[non-string value]',
                  );
                });
              }

              return result;
            },
          );
        } finally {
          if (!platformSupportsStreaming()) {
            // Lambdas require manual flushing to prevent execution freeze before the event is sent
            await (0,responseEnd/* flushQueue */.DO)();
          }

          if (withServerActionInstrumentation_process.env.NEXT_RUNTIME === 'edge') {
            // flushQueue should not throw
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0,responseEnd/* flushQueue */.DO)();
          }
        }
      },
    );
  });
}


//# sourceMappingURL=withServerActionInstrumentation.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/index.js


























/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */
const Integrations = {
  // eslint-disable-next-line deprecation/deprecation
  ...esm/* Integrations */.jK,
  BrowserTracing: BrowserTracing,
};

// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function init(options) {
  const opts = {
    environment: getVercelEnv(true) || "production",
    defaultIntegrations: getDefaultIntegrations(options),
    ...options,
  };

  fixBrowserTracingIntegration(opts);

  applyTunnelRouteOption(opts);
  (0,sdkMetadata/* applySdkMetadata */.V)(opts, 'nextjs', ['nextjs', 'react']);

  (0,sdk/* init */.S)(opts);

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  scope.setTag('runtime', 'browser');
  const filterTransactions = event =>
    event.type === 'transaction' && event.transaction === '/404' ? null : event;
  filterTransactions.id = 'NextClient404Filter';
  scope.addEventProcessor(filterTransactions);

  if (false) {}
}

// TODO v8: Remove this again
// We need to handle BrowserTracing passed to `integrations` that comes from `@sentry/tracing`, not `@sentry/nextjs` :(
function fixBrowserTracingIntegration(options) {
  const { integrations } = options;
  if (!integrations) {
    return;
  }

  if (Array.isArray(integrations)) {
    options.integrations = maybeUpdateBrowserTracingIntegration(integrations);
  } else {
    options.integrations = defaultIntegrations => {
      const userFinalIntegrations = integrations(defaultIntegrations);

      return maybeUpdateBrowserTracingIntegration(userFinalIntegrations);
    };
  }
}

function isNewBrowserTracingIntegration(
  integration,
) {
  // eslint-disable-next-line deprecation/deprecation
  return !!integration.afterAllSetup && !!(integration ).options;
}

function maybeUpdateBrowserTracingIntegration(integrations) {
  const browserTracing = integrations.find(integration => integration.name === 'BrowserTracing');

  if (!browserTracing) {
    return integrations;
  }

  // If `browserTracingIntegration()` was added, we need to force-convert it to our custom one
  if (isNewBrowserTracingIntegration(browserTracing)) {
    const { options } = browserTracing;
    // eslint-disable-next-line deprecation/deprecation
    integrations[integrations.indexOf(browserTracing)] = browserTracingIntegration_browserTracingIntegration(options);
  }

  // If BrowserTracing was added, but it is not our forked version,
  // replace it with our forked version with the same options
  // eslint-disable-next-line deprecation/deprecation
  if (!(browserTracing instanceof BrowserTracing)) {
    // eslint-disable-next-line deprecation/deprecation
    const options = (browserTracing ).options;
    // This option is overwritten by the custom integration
    delete options.routingInstrumentation;
    // eslint-disable-next-line deprecation/deprecation
    delete options.tracingOrigins;
    // eslint-disable-next-line deprecation/deprecation
    integrations[integrations.indexOf(browserTracing)] = new BrowserTracing(options);
  }

  return integrations;
}

function getDefaultIntegrations(options) {
  const customDefaultIntegrations = [...(0,esm_sdk/* getDefaultIntegrations */.nV)(options), rewriteFramesIntegration_rewriteFramesIntegration()];

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if ((0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
      customDefaultIntegrations.push(browserTracingIntegration_browserTracingIntegration());
    }
  }

  return customDefaultIntegrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/index.client.js


/***/ }),

/***/ 25622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oo": function() { return /* reexport */ esm/* Breadcrumbs */.Oo; },
  "RE": function() { return /* reexport */ esm/* BrowserClient */.RE; },
  "_p": function() { return /* reexport */ esm/* BrowserProfilingIntegration */._p; },
  "Iq": function() { return /* reexport */ esm/* Dedupe */.Iq; },
  "SV": function() { return /* reexport */ ErrorBoundary; },
  "x2": function() { return /* reexport */ esm/* Feedback */.x2; },
  "cq": function() { return /* reexport */ esm/* FunctionToString */.cq; },
  "dJ": function() { return /* reexport */ esm/* GlobalHandlers */.dJ; },
  "qT": function() { return /* reexport */ esm/* HttpContext */.qT; },
  "Xb": function() { return /* reexport */ esm/* Hub */.Xb; },
  "QD": function() { return /* reexport */ esm/* InboundFilters */.QD; },
  "iP": function() { return /* reexport */ esm/* LinkedErrors */.iP; },
  "_e": function() { return /* reexport */ esm/* ModuleMetadata */._e; },
  "Q1": function() { return /* reexport */ Profiler; },
  "UH": function() { return /* reexport */ esm/* Replay */.UH; },
  "$r": function() { return /* reexport */ esm/* ReplayCanvas */.$r; },
  "Jn": function() { return /* reexport */ esm/* SDK_VERSION */.Jn; },
  "$J": function() { return /* reexport */ esm/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J; },
  "S3": function() { return /* reexport */ esm/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3; },
  "TE": function() { return /* reexport */ esm/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.TE; },
  "Zj": function() { return /* reexport */ esm/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj; },
  "sX": function() { return /* reexport */ esm/* Scope */.sX; },
  "pT": function() { return /* reexport */ esm/* TryCatch */.pT; },
  "m9": function() { return /* reexport */ esm/* WINDOW */.m9; },
  "n_": function() { return /* reexport */ esm/* addBreadcrumb */.n_; },
  "Qy": function() { return /* reexport */ esm/* addEventProcessor */.Qy; },
  "cc": function() { return /* reexport */ esm/* addGlobalEventProcessor */.cc; },
  "M5": function() { return /* reexport */ esm/* addIntegration */.M5; },
  "Ts": function() { return /* reexport */ esm/* addTracingExtensions */.Ts; },
  "fQ": function() { return /* reexport */ esm/* breadcrumbsIntegration */.fQ; },
  "tP": function() { return /* reexport */ esm/* browserApiErrorsIntegration */.tP; },
  "xF": function() { return /* reexport */ esm/* browserProfilingIntegration */.xF; },
  "Xs": function() { return /* reexport */ esm/* captureConsoleIntegration */.Xs; },
  "eN": function() { return /* reexport */ esm/* captureEvent */.eN; },
  "Tb": function() { return /* reexport */ esm/* captureException */.Tb; },
  "uT": function() { return /* reexport */ esm/* captureMessage */.uT; },
  "cg": function() { return /* reexport */ esm/* captureSession */.cg; },
  "Jd": function() { return /* reexport */ esm/* captureUserFeedback */.Jd; },
  "$3": function() { return /* reexport */ esm/* chromeStackLineParser */.$3; },
  "xv": function() { return /* reexport */ esm/* close */.xv; },
  "e": function() { return /* reexport */ esm/* configureScope */.e; },
  "SZ": function() { return /* reexport */ esm/* contextLinesIntegration */.SZ; },
  "yn": function() { return /* reexport */ esm/* continueTrace */.yn; },
  "wS": function() { return /* reexport */ createReduxEnhancer; },
  "qv": function() { return /* reexport */ esm/* createTransport */.qv; },
  "rQ": function() { return /* reexport */ esm/* createUserFeedbackEnvelope */.rQ; },
  "sC": function() { return /* reexport */ esm/* debugIntegration */.sC; },
  "RH": function() { return /* reexport */ esm/* dedupeIntegration */.RH; },
  "SS": function() { return /* reexport */ esm/* defaultIntegrations */.SS; },
  "k3": function() { return /* reexport */ esm/* defaultRequestInstrumentationOptions */.k3; },
  "d8": function() { return /* reexport */ esm/* defaultStackLineParsers */.d8; },
  "Dt": function() { return /* reexport */ esm/* defaultStackParser */.Dt; },
  "TM": function() { return /* reexport */ esm/* endSession */.TM; },
  "dr": function() { return /* reexport */ esm/* eventFromException */.dr; },
  "aB": function() { return /* reexport */ esm/* eventFromMessage */.aB; },
  "GJ": function() { return /* reexport */ esm/* exceptionFromError */.GJ; },
  "EY": function() { return /* reexport */ esm/* extraErrorDataIntegration */.EY; },
  "qG": function() { return /* reexport */ esm/* extractTraceparentData */.qG; },
  "Xc": function() { return /* reexport */ esm/* feedbackIntegration */.Xc; },
  "yl": function() { return /* reexport */ esm/* flush */.yl; },
  "Eg": function() { return /* reexport */ esm/* forceLoad */.Eg; },
  "CP": function() { return /* reexport */ esm/* functionToStringIntegration */.CP; },
  "$Q": function() { return /* reexport */ esm/* geckoStackLineParser */.$Q; },
  "HN": function() { return /* reexport */ esm/* getActiveSpan */.HN; },
  "x1": function() { return /* reexport */ esm/* getActiveTransaction */.x1; },
  "s3": function() { return /* reexport */ esm/* getClient */.s3; },
  "Gd": function() { return /* reexport */ esm/* getCurrentHub */.Gd; },
  "nZ": function() { return /* reexport */ esm/* getCurrentScope */.nZ; },
  "nV": function() { return /* reexport */ esm/* getDefaultIntegrations */.nV; },
  "vi": function() { return /* reexport */ esm/* getHubFromCarrier */.vi; },
  "TF": function() { return /* reexport */ esm/* getReplay */.TF; },
  "ix": function() { return /* reexport */ esm/* getSpanStatusFromHttpCode */.ix; },
  "ks": function() { return /* reexport */ esm/* globalHandlersIntegration */.ks; },
  "lQ": function() { return /* reexport */ esm/* httpClientIntegration */.lQ; },
  "sA": function() { return /* reexport */ esm/* httpContextIntegration */.sA; },
  "SG": function() { return /* reexport */ esm/* inboundFiltersIntegration */.SG; },
  "L7": function() { return /* reexport */ esm/* instrumentOutgoingRequests */.L7; },
  "dk": function() { return /* reexport */ esm/* isInitialized */.dk; },
  "eW": function() { return /* reexport */ esm/* lastEventId */.eW; },
  "OB": function() { return /* reexport */ esm/* linkedErrorsIntegration */.OB; },
  "O1": function() { return /* reexport */ esm/* makeBrowserOfflineTransport */.O1; },
  "fD": function() { return /* reexport */ esm/* makeFetchTransport */.fD; },
  "pj": function() { return /* reexport */ esm/* makeMain */.pj; },
  "Wq": function() { return /* reexport */ esm/* makeMultiplexedTransport */.Wq; },
  "KC": function() { return /* reexport */ esm/* makeXHRTransport */.KC; },
  "qI": function() { return /* reexport */ esm/* metrics */.qI; },
  "wo": function() { return /* reexport */ esm/* moduleMetadataIntegration */.wo; },
  "lA": function() { return /* reexport */ esm/* onLoad */.lA; },
  "Uv": function() { return /* reexport */ esm/* onProfilingStartRouteTransaction */.Uv; },
  "NP": function() { return /* reexport */ esm/* opera10StackLineParser */.NP; },
  "HH": function() { return /* reexport */ esm/* opera11StackLineParser */.HH; },
  "XB": function() { return /* reexport */ esm/* parameterize */.XB; },
  "h1": function() { return /* reexport */ reactRouterV3BrowserTracingIntegration; },
  "XQ": function() { return /* reexport */ reactRouterV3Instrumentation; },
  "qi": function() { return /* reexport */ reactRouterV4BrowserTracingIntegration; },
  "qr": function() { return /* reexport */ reactRouterV4Instrumentation; },
  "zL": function() { return /* reexport */ reactRouterV5BrowserTracingIntegration; },
  "qp": function() { return /* reexport */ reactRouterV5Instrumentation; },
  "g3": function() { return /* reexport */ reactRouterV6BrowserTracingIntegration; },
  "KO": function() { return /* reexport */ reactRouterV6Instrumentation; },
  "mz": function() { return /* reexport */ esm/* replayCanvasIntegration */.mz; },
  "Gs": function() { return /* reexport */ esm/* replayIntegration */.Gs; },
  "yt": function() { return /* reexport */ esm/* reportingObserverIntegration */.yt; },
  "fA": function() { return /* reexport */ esm/* sendFeedback */.fA; },
  "rE": function() { return /* reexport */ esm/* sessionTimingIntegration */.rE; },
  "v": function() { return /* reexport */ esm/* setContext */.v; },
  "KW": function() { return /* reexport */ esm/* setCurrentClient */.KW; },
  "sU": function() { return /* reexport */ esm/* setExtra */.sU; },
  "rJ": function() { return /* reexport */ esm/* setExtras */.rJ; },
  "Q0": function() { return /* reexport */ esm/* setHttpStatus */.Q0; },
  "oi": function() { return /* reexport */ esm/* setMeasurement */.oi; },
  "YA": function() { return /* reexport */ esm/* setTag */.YA; },
  "mG": function() { return /* reexport */ esm/* setTags */.mG; },
  "av": function() { return /* reexport */ esm/* setUser */.av; },
  "jp": function() { return /* reexport */ esm/* showReportDialog */.jp; },
  "Zd": function() { return /* reexport */ esm/* spanStatusfromHttpCode */.Zd; },
  "og": function() { return /* reexport */ esm/* startBrowserTracingNavigationSpan */.og; },
  "Wo": function() { return /* reexport */ esm/* startBrowserTracingPageLoadSpan */.Wo; },
  "Qb": function() { return /* reexport */ esm/* startInactiveSpan */.qp; },
  "yj": function() { return /* reexport */ esm/* startSession */.yj; },
  "GK": function() { return /* reexport */ esm/* startSpan */.GK; },
  "V0": function() { return /* reexport */ esm/* startSpanManual */.V0; },
  "Yr": function() { return /* reexport */ esm/* startTransaction */.Yr; },
  "g4": function() { return /* reexport */ esm/* trace */.g4; },
  "ED": function() { return /* reexport */ useProfiler; },
  "R2": function() { return /* reexport */ esm/* winjsStackLineParser */.R2; },
  "_d": function() { return /* reexport */ esm/* withActiveSpan */._d; },
  "Pf": function() { return /* reexport */ withErrorBoundary; },
  "wi": function() { return /* reexport */ esm/* withIsolationScope */.wi; },
  "zH": function() { return /* reexport */ withProfiler; },
  "$e": function() { return /* reexport */ esm/* withScope */.$e; },
  "H0": function() { return /* reexport */ withSentryReactRouterV6Routing; },
  "gy": function() { return /* reexport */ withSentryRouting; },
  "re": function() { return /* reexport */ esm/* wrap */.re; },
  "vG": function() { return /* reexport */ wrapCreateBrowserRouter; },
  "M1": function() { return /* reexport */ wrapUseRoutes; }
});

// UNUSED EXPORTS: BrowserTracing, Integrations, browserTracingIntegration, init, rewriteFramesIntegration

// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/index.js + 33 modules
var esm = __webpack_require__(34615);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(28218);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(13976);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(4859);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(24703);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(83138);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/constants.js
const REACT_RENDER_OP = 'ui.react.render';

const REACT_UPDATE_OP = 'ui.react.update';

const REACT_MOUNT_OP = 'ui.react.mount';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/profiler.js







const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
const UNKNOWN_COMPONENT = 'unknown';

/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
class Profiler extends react.Component {
  /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */

  /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */

  // eslint-disable-next-line @typescript-eslint/member-ordering
   static __initStatic() {this.defaultProps = {
    disabled: false,
    includeRender: true,
    includeUpdates: true,
  };}

   constructor(props) {
    super(props);
    const { name, disabled = false } = this.props;

    if (disabled) {
      return;
    }

    this._mountSpan = (0,trace/* startInactiveSpan */.qp)({
      name: `<${name}>`,
      onlyIfParent: true,
      op: REACT_MOUNT_OP,
      origin: 'auto.ui.react.profiler',
      attributes: { 'ui.component_name': name },
    });
  }

  // If a component mounted, we can finish the mount activity.
   componentDidMount() {
    if (this._mountSpan) {
      this._mountSpan.end();
    }
  }

   shouldComponentUpdate({ updateProps, includeUpdates = true }) {
    // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
    // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
    // We are just trying to give baseline clues for further investigation.
    if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
      // See what props haved changed between the previous props, and the current props. This is
      // set as data on the span. We just store the prop keys as the values could be potenially very large.
      const changedProps = Object.keys(updateProps).filter(k => updateProps[k] !== this.props.updateProps[k]);
      if (changedProps.length > 0) {
        const now = (0,time/* timestampInSeconds */.ph)();
        this._updateSpan = (0,esm_exports/* withActiveSpan */._d)(this._mountSpan, () => {
          return (0,trace/* startInactiveSpan */.qp)({
            name: `<${this.props.name}>`,
            onlyIfParent: true,
            op: REACT_UPDATE_OP,
            origin: 'auto.ui.react.profiler',
            startTimestamp: now,
            attributes: {
              'ui.component_name': this.props.name,
              'ui.react.changed_props': changedProps,
            },
          });
        });
      }
    }

    return true;
  }

   componentDidUpdate() {
    if (this._updateSpan) {
      this._updateSpan.end();
      this._updateSpan = undefined;
    }
  }

  // If a component is unmounted, we can say it is no longer on the screen.
  // This means we can finish the span representing the component render.
   componentWillUnmount() {
    const endTimestamp = (0,time/* timestampInSeconds */.ph)();
    const { name, includeRender = true } = this.props;

    if (this._mountSpan && includeRender) {
      const startTimestamp = (0,spanUtils/* spanToJSON */.XU)(this._mountSpan).timestamp;
      (0,esm_exports/* withActiveSpan */._d)(this._mountSpan, () => {
        const renderSpan = (0,trace/* startInactiveSpan */.qp)({
          onlyIfParent: true,
          name: `<${name}>`,
          op: REACT_RENDER_OP,
          origin: 'auto.ui.react.profiler',
          startTimestamp,
          attributes: { 'ui.component_name': name },
        });
        if (renderSpan) {
          // Have to cast to Span because the type of _mountSpan is Span | undefined
          // and not getting narrowed properly
          renderSpan.end(endTimestamp);
        }
      });
    }
  }

   render() {
    return this.props.children;
  }
} Profiler.__initStatic();

/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(
  WrappedComponent,
  // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
  options,
) {
  const componentDisplayName =
    (options && options.name) || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  const Wrapped = (props) => (
    react.createElement(Profiler, { ...options, name: componentDisplayName, updateProps: props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
      , react.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}} )
    )
  );

  Wrapped.displayName = `profiler(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
  return Wrapped;
}

/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(
  name,
  options = {
    disabled: false,
    hasRenderSpan: true,
  },
) {
  const [mountSpan] = react.useState(() => {
    if (options && options.disabled) {
      return undefined;
    }

    return (0,trace/* startInactiveSpan */.qp)({
      name: `<${name}>`,
      onlyIfParent: true,
      op: REACT_MOUNT_OP,
      origin: 'auto.ui.react.profiler',
      attributes: { 'ui.component_name': name },
    });
  });

  react.useEffect(() => {
    if (mountSpan) {
      mountSpan.end();
    }

    return () => {
      if (mountSpan && options.hasRenderSpan) {
        const startTimestamp = (0,spanUtils/* spanToJSON */.XU)(mountSpan).timestamp;
        const endTimestamp = (0,time/* timestampInSeconds */.ph)();

        const renderSpan = (0,trace/* startInactiveSpan */.qp)({
          name: `<${name}>`,
          onlyIfParent: true,
          op: REACT_RENDER_OP,
          origin: 'auto.ui.react.profiler',
          startTimestamp,
          attributes: { 'ui.component_name': name },
        });
        if (renderSpan) {
          // Have to cast to Span because the type of _mountSpan is Span | undefined
          // and not getting narrowed properly
          renderSpan.end(endTimestamp);
        }
      }
    };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}


//# sourceMappingURL=profiler.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/sdk.js
var sdk = __webpack_require__(20113);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(48593);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58786);
;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/errorboundary.js






const errorboundary_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";

function isAtLeastReact17(version) {
  const major = version.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}

const errorboundary_UNKNOWN_COMPONENT = 'unknown';

const INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null,
};

function setCause(error, cause) {
  const seenErrors = new WeakMap();

  function recurse(error, cause) {
    // If we've already seen the error, there is a recursive loop somewhere in the error's
    // cause chain. Let's just bail out then to prevent a stack overflow.
    if (seenErrors.has(error)) {
      return;
    }
    if (error.cause) {
      seenErrors.set(error, true);
      return recurse(error.cause, cause);
    }
    error.cause = cause;
  }

  recurse(error, cause);
}

/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
class ErrorBoundary extends react.Component {

   constructor(props) {
    super(props);ErrorBoundary.prototype.__init.call(this);
    this.state = INITIAL_STATE;
    this._openFallbackReportDialog = true;

    const client = (0,esm_exports/* getClient */.s3)();
    if (client && client.on && props.showDialog) {
      this._openFallbackReportDialog = false;
      client.on('afterSendEvent', event => {
        if (!event.type && event.event_id === this._lastEventId) {
          // eslint-disable-next-line deprecation/deprecation
          (0,sdk/* showReportDialog */.jp)({ ...props.dialogOptions, eventId: this._lastEventId });
        }
      });
    }
  }

   componentDidCatch(error, { componentStack }) {
    const { beforeCapture, onError, showDialog, dialogOptions } = this.props;
    (0,esm_exports/* withScope */.$e)(scope => {
      // If on React version >= 17, create stack trace from componentStack param and links
      // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
      // Linking errors requires the `LinkedErrors` integration be enabled.
      // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
      //
      // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
      // with non-error objects. This is why we need to check if the error is an error-like object.
      // See: https://github.com/getsentry/sentry-javascript/issues/6167
      if (isAtLeastReact17(react.version) && (0,is/* isError */.VZ)(error)) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;

        // Using the `LinkedErrors` integration to link the errors together.
        setCause(error, errorBoundaryError);
      }

      if (beforeCapture) {
        beforeCapture(scope, error, componentStack);
      }

      const eventId = (0,esm_exports/* captureException */.Tb)(error, {
        captureContext: {
          contexts: { react: { componentStack } },
        },
        // If users provide a fallback component we can assume they are handling the error.
        // Therefore, we set the mechanism depending on the presence of the fallback prop.
        mechanism: { handled: !!this.props.fallback },
      });

      if (onError) {
        onError(error, componentStack, eventId);
      }
      if (showDialog) {
        this._lastEventId = eventId;
        if (this._openFallbackReportDialog) {
          (0,sdk/* showReportDialog */.jp)({ ...dialogOptions, eventId });
        }
      }

      // componentDidCatch is used over getDerivedStateFromError
      // so that componentStack is accessible through state.
      this.setState({ error, componentStack, eventId });
    });
  }

   componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

   componentWillUnmount() {
    const { error, componentStack, eventId } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack, eventId);
    }
  }

   __init() {this.resetErrorBoundary = () => {
    const { onReset } = this.props;
    const { error, componentStack, eventId } = this.state;
    if (onReset) {
      onReset(error, componentStack, eventId);
    }
    this.setState(INITIAL_STATE);
  };}

   render() {
    const { fallback, children } = this.props;
    const state = this.state;

    if (state.error) {
      let element = undefined;
      if (typeof fallback === 'function') {
        element = fallback({
          error: state.error,
          componentStack: state.componentStack,
          resetError: this.resetErrorBoundary,
          eventId: state.eventId,
        });
      } else {
        element = fallback;
      }

      if (react.isValidElement(element)) {
        return element;
      }

      if (fallback) {
        DEBUG_BUILD && logger/* logger.warn */.kg.warn('fallback did not produce a valid ReactElement');
      }

      // Fail gracefully if no fallback provided or is not valid
      return null;
    }

    if (typeof children === 'function') {
      return (children )();
    }
    return children;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(
  WrappedComponent,
  errorBoundaryOptions,
) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || errorboundary_UNKNOWN_COMPONENT;

  const Wrapped = (props) => (
    react.createElement(ErrorBoundary, { ...errorBoundaryOptions, __self: this, __source: {fileName: errorboundary_jsxFileName, lineNumber: 240}}
      , react.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: errorboundary_jsxFileName, lineNumber: 241}} )
    )
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Wrapped.displayName = `errorBoundary(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
  return Wrapped;
}


//# sourceMappingURL=errorboundary.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/scope.js
var scope = __webpack_require__(77172);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(76721);
;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/redux.js



/* eslint-disable @typescript-eslint/no-explicit-any */

const ACTION_BREADCRUMB_CATEGORY = 'redux.action';
const ACTION_BREADCRUMB_TYPE = 'info';

const defaultOptions = {
  attachReduxState: true,
  actionTransformer: action => action,
  stateTransformer: state => state || null,
};

/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */
function createReduxEnhancer(enhancerOptions) {
  // Note: We return an any type as to not have type conflicts.
  const options = {
    ...defaultOptions,
    ...enhancerOptions,
  };

  return (next) =>
    (reducer, initialState) => {
      options.attachReduxState &&
        (0,scope/* getGlobalScope */.lW)().addEventProcessor((event, hint) => {
          try {
            // @ts-expect-error try catch to reduce bundle size
            if (event.type === undefined && event.contexts.state.state.type === 'redux') {
              hint.attachments = [
                ...(hint.attachments || []),
                // @ts-expect-error try catch to reduce bundle size
                { filename: 'redux_state.json', data: JSON.stringify(event.contexts.state.state.value) },
              ];
            }
          } catch (_) {
            // empty
          }
          return event;
        });

      const sentryReducer = (state, action) => {
        const newState = reducer(state, action);

        const scope = (0,esm_exports/* getCurrentScope */.nZ)();

        /* Action breadcrumbs */
        const transformedAction = options.actionTransformer(action);
        if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
          scope.addBreadcrumb({
            category: ACTION_BREADCRUMB_CATEGORY,
            data: transformedAction,
            type: ACTION_BREADCRUMB_TYPE,
          });
        }

        /* Set latest state to scope */
        const transformedState = options.stateTransformer(newState);
        if (typeof transformedState !== 'undefined' && transformedState !== null) {
          const client = (0,esm_exports/* getClient */.s3)();
          const options = client && client.getOptions();
          const normalizationDepth = (options && options.normalizeDepth) || 3; // default state normalization depth to 3

          // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
          const newStateContext = { state: { type: 'redux', value: transformedState } };
          (0,object/* addNonEnumerableProperty */.xp)(
            newStateContext,
            '__sentry_override_normalization_depth__',
            3 + // 3 layers for `state.value.transformedState`
              normalizationDepth, // rest for the actual state
          );

          scope.setContext('state', newStateContext);
        } else {
          scope.setContext('state', null);
        }

        /* Allow user to configure scope with latest state */
        const { configureScopeWithState } = options;
        if (typeof configureScopeWithState === 'function') {
          configureScopeWithState(scope, newState);
        }

        return newState;
      };

      return next(sentryReducer, initialState);
    };
}


//# sourceMappingURL=redux.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js
var browserTracingIntegration = __webpack_require__(46136);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(14828);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(46595);
;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/reactrouterv3.js



// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.

/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV3BrowserTracingIntegration(
  options,
) {
  const integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)({
    ...options,
    instrumentPageLoad: false,
    instrumentNavigation: false,
  });

  const { history, routes, match, instrumentPageLoad = true, instrumentNavigation = true } = options;

  return {
    ...integration,
    afterAllSetup(client) {
      integration.afterAllSetup(client);

      const startPageloadCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
        return undefined;
      };

      const startNavigationCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
        return undefined;
      };

      // eslint-disable-next-line deprecation/deprecation
      const instrumentation = reactRouterV3Instrumentation(history, routes, match);

      // Now instrument page load & navigation with correct settings
      instrumentation(startPageloadCallback, instrumentPageLoad, false);
      instrumentation(startNavigationCallback, false, instrumentNavigation);
    },
  };
}

/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 *
 * @deprecated Use `reactRouterV3BrowserTracingIntegration()` instead
 */
function reactRouterV3Instrumentation(
  history,
  routes,
  match,
) {
  return (
    startTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
  ) => {
    let activeTransaction;
    let prevName;

    // Have to use window.location because history.location might not be defined.
    if (startTransactionOnPageLoad && helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
      normalizeTransactionName(
        routes,
        helpers/* WINDOW.location */.m9.location ,
        match,
        (localName, source = 'url') => {
          prevName = localName;
          activeTransaction = startTransaction({
            name: prevName,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'pageload',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.pageload.react.reactrouter_v3',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: source,
            },
          });
        },
      );
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen(location => {
        if (location.action === 'PUSH' || location.action === 'POP') {
          if (activeTransaction) {
            activeTransaction.end();
          }
          normalizeTransactionName(routes, location, match, (localName, source = 'url') => {
            prevName = localName;

            const attributes = {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'navigation',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.navigation.react.reactrouter_v3',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: source,
            };

            activeTransaction = startTransaction({
              name: prevName,
              attributes,
            });
          });
        }
      });
    }
  };
}

/**
 * Normalize transaction names using `Router.match`
 */
function normalizeTransactionName(
  appRoutes,
  location,
  match,
  callback,
) {
  let name = location.pathname;
  match(
    {
      location,
      routes: appRoutes,
    },
    (error, _redirectLocation, renderProps) => {
      if (error || !renderProps) {
        return callback(name);
      }

      const routePath = getRouteStringFromRoutes(renderProps.routes || []);
      if (routePath.length === 0 || routePath === '/*') {
        return callback(name);
      }

      name = routePath;
      return callback(name, 'route');
    },
  );
}

/**
 * Generate route name from array of routes
 */
function getRouteStringFromRoutes(routes) {
  if (!Array.isArray(routes) || routes.length === 0) {
    return '';
  }

  const routesWithPaths = routes.filter((route) => !!route.path);

  let index = -1;
  for (let x = routesWithPaths.length - 1; x >= 0; x--) {
    const route = routesWithPaths[x];
    if (route.path && route.path.startsWith('/')) {
      index = x;
      break;
    }
  }

  return routesWithPaths
    .slice(index)
    .filter(({ path }) => !!path)
    .map(({ path }) => path)
    .join('');
}


//# sourceMappingURL=reactrouterv3.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/getRootSpan.js
var getRootSpan = __webpack_require__(43889);
;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/reactrouter.js





const reactrouter_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";
// We need to disable eslint no-explict-any because any is required for the
// react-router typings.

let activeTransaction;

/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV4BrowserTracingIntegration(
  options,
) {
  const integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)({
    ...options,
    instrumentPageLoad: false,
    instrumentNavigation: false,
  });

  const { history, routes, matchPath, instrumentPageLoad = true, instrumentNavigation = true } = options;

  return {
    ...integration,
    afterAllSetup(client) {
      integration.afterAllSetup(client);

      const startPageloadCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
        return undefined;
      };

      const startNavigationCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
        return undefined;
      };

      // eslint-disable-next-line deprecation/deprecation
      const instrumentation = reactRouterV4Instrumentation(history, routes, matchPath);

      // Now instrument page load & navigation with correct settings
      instrumentation(startPageloadCallback, instrumentPageLoad, false);
      instrumentation(startNavigationCallback, false, instrumentNavigation);
    },
  };
}

/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV5BrowserTracingIntegration(
  options,
) {
  const integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)({
    ...options,
    instrumentPageLoad: false,
    instrumentNavigation: false,
  });

  const { history, routes, matchPath } = options;

  return {
    ...integration,
    afterAllSetup(client) {
      integration.afterAllSetup(client);

      const startPageloadCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
        return undefined;
      };

      const startNavigationCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
        return undefined;
      };

      // eslint-disable-next-line deprecation/deprecation
      const instrumentation = reactRouterV5Instrumentation(history, routes, matchPath);

      // Now instrument page load & navigation with correct settings
      instrumentation(startPageloadCallback, options.instrumentPageLoad, false);
      instrumentation(startNavigationCallback, false, options.instrumentNavigation);
    },
  };
}

/**
 * @deprecated Use `browserTracingReactRouterV4()` instead.
 */
function reactRouterV4Instrumentation(
  history,
  routes,
  matchPath,
) {
  return createReactRouterInstrumentation(history, 'reactrouter_v4', routes, matchPath);
}

/**
 * @deprecated Use `browserTracingReactRouterV5()` instead.
 */
function reactRouterV5Instrumentation(
  history,
  routes,
  matchPath,
) {
  return createReactRouterInstrumentation(history, 'reactrouter_v5', routes, matchPath);
}

function createReactRouterInstrumentation(
  history,
  instrumentationName,
  allRoutes = [],
  matchPath,
) {
  function getInitPathName() {
    if (history && history.location) {
      return history.location.pathname;
    }

    if (helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
      return helpers/* WINDOW.location.pathname */.m9.location.pathname;
    }

    return undefined;
  }

  /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */
  function normalizeTransactionName(pathname) {
    if (allRoutes.length === 0 || !matchPath) {
      return [pathname, 'url'];
    }

    const branches = matchRoutes(allRoutes, pathname, matchPath);
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let x = 0; x < branches.length; x++) {
      if (branches[x].match.isExact) {
        return [branches[x].match.path, 'route'];
      }
    }

    return [pathname, 'url'];
  }

  return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) => {
    const initPathName = getInitPathName();

    if (startTransactionOnPageLoad && initPathName) {
      const [name, source] = normalizeTransactionName(initPathName);
      activeTransaction = customStartTransaction({
        name,
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'pageload',
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: `auto.pageload.react.${instrumentationName}`,
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: source,
        },
      });
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen((location, action) => {
        if (action && (action === 'PUSH' || action === 'POP')) {
          if (activeTransaction) {
            activeTransaction.end();
          }

          const [name, source] = normalizeTransactionName(location.pathname);
          activeTransaction = customStartTransaction({
            name,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'navigation',
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: `auto.navigation.react.${instrumentationName}`,
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: source,
            },
          });
        }
      });
    }
  };
}

/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */
function matchRoutes(
  routes,
  pathname,
  matchPath,
  branch = [],
) {
  routes.some(route => {
    const match = route.path
      ? matchPath(pathname, route)
      : branch.length
        ? branch[branch.length - 1].match // use parent match
        : computeRootMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, matchPath, branch);
      }
    }

    return !!match;
  });

  return branch;
}

function computeRootMatch(pathname) {
  return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
function withSentryRouting(Route) {
  const componentDisplayName = (Route ).displayName || (Route ).name;

  const WrappedRoute = (props) => {
    if (props && props.computedMatch && props.computedMatch.isExact) {
      const route = props.computedMatch.path;
      const activeRootSpan = getActiveRootSpan();
      if (activeRootSpan) {
        activeRootSpan.updateName(route);
        activeRootSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, 'route');
      }
    }

    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return react.createElement(Route, { ...props, __self: this, __source: {fileName: reactrouter_jsxFileName, lineNumber: 279}} );
  };

  WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
  hoist_non_react_statics_cjs_default()(WrappedRoute, Route);
  // @ts-expect-error Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params:
  // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
  return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */

function getActiveRootSpan() {
  // Legacy behavior for "old" react router instrumentation
  if (activeTransaction) {
    return activeTransaction;
  }

  const span = (0,trace/* getActiveSpan */.HN)();
  const rootSpan = span ? (0,getRootSpan/* getRootSpan */.G)(span) : undefined;

  if (!rootSpan) {
    return undefined;
  }

  const op = (0,spanUtils/* spanToJSON */.XU)(rootSpan).op;

  // Only use this root span if it is a pageload or navigation span
  return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}


//# sourceMappingURL=reactrouter.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(84808);
;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/reactrouterv6.js







const reactrouterv6_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx";/* eslint-disable max-lines */

let reactrouterv6_activeTransaction;

let _useEffect;
let _useLocation;
let _useNavigationType;
let _createRoutesFromChildren;
let _matchRoutes;
let _customStartTransaction;
let _startTransactionOnLocationChange;
let _stripBasename = false;

/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV6BrowserTracingIntegration(
  options,
) {
  const integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)({
    ...options,
    instrumentPageLoad: false,
    instrumentNavigation: false,
  });

  const {
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
    stripBasename,
    instrumentPageLoad = true,
    instrumentNavigation = true,
  } = options;

  return {
    ...integration,
    afterAllSetup(client) {
      integration.afterAllSetup(client);

      const startNavigationCallback = (startSpanOptions) => {
        (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
        return undefined;
      };

      const initPathName = helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.pathname */.m9.location.pathname;
      if (instrumentPageLoad && initPathName) {
        (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, {
          name: initPathName,
          attributes: {
            [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url',
            [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'pageload',
            [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.pageload.react.reactrouter_v6',
          },
        });
      }

      _useEffect = useEffect;
      _useLocation = useLocation;
      _useNavigationType = useNavigationType;
      _matchRoutes = matchRoutes;
      _createRoutesFromChildren = createRoutesFromChildren;
      _stripBasename = stripBasename || false;

      _customStartTransaction = startNavigationCallback;
      _startTransactionOnLocationChange = instrumentNavigation;
    },
  };
}

/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */
function reactRouterV6Instrumentation(
  useEffect,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
  stripBasename,
) {
  return (
    customStartTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
  ) => {
    const initPathName = helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.pathname */.m9.location.pathname;
    if (startTransactionOnPageLoad && initPathName) {
      reactrouterv6_activeTransaction = customStartTransaction({
        name: initPathName,
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: 'url',
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'pageload',
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.pageload.react.reactrouter_v6',
        },
      });
    }

    _useEffect = useEffect;
    _useLocation = useLocation;
    _useNavigationType = useNavigationType;
    _matchRoutes = matchRoutes;
    _createRoutesFromChildren = createRoutesFromChildren;
    _stripBasename = stripBasename || false;

    _customStartTransaction = customStartTransaction;
    _startTransactionOnLocationChange = startTransactionOnLocationChange;
  };
}

/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */
function stripBasenameFromPathname(pathname, basename) {
  if (!basename || basename === '/') {
    return pathname;
  }

  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return pathname;
  }

  // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it
  const startIndex = basename.endsWith('/') ? basename.length - 1 : basename.length;
  const nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== '/') {
    // pathname does not start with basename/
    return pathname;
  }

  return pathname.slice(startIndex) || '/';
}

function getNormalizedName(
  routes,
  location,
  branches,
  basename = '',
) {
  if (!routes || routes.length === 0) {
    return [_stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname, 'url'];
  }

  let pathBuilder = '';
  if (branches) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let x = 0; x < branches.length; x++) {
      const branch = branches[x];
      const route = branch.route;
      if (route) {
        // Early return if index route
        if (route.index) {
          return [_stripBasename ? stripBasenameFromPathname(branch.pathname, basename) : branch.pathname, 'route'];
        }

        const path = route.path;
        if (path) {
          const newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : `/${path}`;
          pathBuilder += newPath;

          if (basename + branch.pathname === location.pathname) {
            if (
              // If the route defined on the element is something like
              // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
              // We should check against the branch.pathname for the number of / seperators
              (0,url/* getNumberOfUrlSegments */.$A)(pathBuilder) !== (0,url/* getNumberOfUrlSegments */.$A)(branch.pathname) &&
              // We should not count wildcard operators in the url segments calculation
              pathBuilder.slice(-2) !== '/*'
            ) {
              return [(_stripBasename ? '' : basename) + newPath, 'route'];
            }
            return [(_stripBasename ? '' : basename) + pathBuilder, 'route'];
          }
        }
      }
    }
  }

  return [_stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname, 'url'];
}

function updatePageloadTransaction(
  activeRootSpan,
  location,
  routes,
  matches,
  basename,
) {
  const branches = Array.isArray(matches)
    ? matches
    : (_matchRoutes(routes, location, basename) );

  if (activeRootSpan && branches) {
    const [name, source] = getNormalizedName(routes, location, branches, basename);
    activeRootSpan.updateName(name);
    activeRootSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source);
  }
}

function handleNavigation(
  location,
  routes,
  navigationType,
  matches,
  basename,
) {
  const branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);

  if (_startTransactionOnLocationChange && (navigationType === 'PUSH' || navigationType === 'POP') && branches) {
    if (reactrouterv6_activeTransaction) {
      reactrouterv6_activeTransaction.end();
    }

    const [name, source] = getNormalizedName(routes, location, branches, basename);
    reactrouterv6_activeTransaction = _customStartTransaction({
      name,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj]: source,
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J]: 'navigation',
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3]: 'auto.navigation.react.reactrouter_v6',
      },
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes) {
  if (
    !_useEffect ||
    !_useLocation ||
    !_useNavigationType ||
    !_createRoutesFromChildren ||
    !_matchRoutes ||
    !_customStartTransaction
  ) {
    DEBUG_BUILD &&
      logger/* logger.warn */.kg.warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${_useEffect}. useLocation: ${_useLocation}. useNavigationType: ${_useNavigationType}.
      createRoutesFromChildren: ${_createRoutesFromChildren}. matchRoutes: ${_matchRoutes}. customStartTransaction: ${_customStartTransaction}.`);

    return Routes;
  }

  let isMountRenderPass = true;

  const SentryRoutes = (props) => {
    const location = _useLocation();
    const navigationType = _useNavigationType();

    _useEffect(
      () => {
        const routes = _createRoutesFromChildren(props.children) ;

        if (isMountRenderPass) {
          updatePageloadTransaction(reactrouterv6_getActiveRootSpan(), location, routes);
          isMountRenderPass = false;
        } else {
          handleNavigation(location, routes, navigationType);
        }
      },
      // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
      // when the children change. We only want to start transactions when the location or navigation type change.
      [location, navigationType],
    );

    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return react.createElement(Routes, { ...props, __self: this, __source: {fileName: reactrouterv6_jsxFileName, lineNumber: 329}} );
  };

  hoist_non_react_statics_cjs_default()(SentryRoutes, Routes);

  // @ts-expect-error Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params
  return SentryRoutes;
}

function wrapUseRoutes(origUseRoutes) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes || !_customStartTransaction) {
    DEBUG_BUILD &&
      logger/* logger.warn */.kg.warn(
        'reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.',
      );

    return origUseRoutes;
  }

  let isMountRenderPass = true;

  const SentryRoutes

 = (props) => {
    const { routes, locationArg } = props;

    const Routes = origUseRoutes(routes, locationArg);

    const location = _useLocation();
    const navigationType = _useNavigationType();

    // A value with stable identity to either pick `locationArg` if available or `location` if not
    const stableLocationParam =
      typeof locationArg === 'string' || (locationArg && locationArg.pathname)
        ? (locationArg )
        : location;

    _useEffect(() => {
      const normalizedLocation =
        typeof stableLocationParam === 'string' ? { pathname: stableLocationParam } : stableLocationParam;

      if (isMountRenderPass) {
        updatePageloadTransaction(reactrouterv6_getActiveRootSpan(), normalizedLocation, routes);
        isMountRenderPass = false;
      } else {
        handleNavigation(normalizedLocation, routes, navigationType);
      }
    }, [navigationType, stableLocationParam]);

    return Routes;
  };

  // eslint-disable-next-line react/display-name
  return (routes, locationArg) => {
    return react.createElement(SentryRoutes, { routes: routes, locationArg: locationArg, __self: this, __source: {fileName: reactrouterv6_jsxFileName, lineNumber: 386}} );
  };
}

function wrapCreateBrowserRouter

(createRouterFunction) {
  // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
  // `basename` is the only option that is relevant for us, and it is the same for all.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (routes, opts) {
    const router = createRouterFunction(routes, opts);
    const basename = opts && opts.basename;

    const activeRootSpan = reactrouterv6_getActiveRootSpan();

    // The initial load ends when `createBrowserRouter` is called.
    // This is the earliest convenient time to update the transaction name.
    // Callbacks to `router.subscribe` are not called for the initial load.
    if (router.state.historyAction === 'POP' && activeRootSpan) {
      updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
    }

    router.subscribe((state) => {
      const location = state.location;
      if (_startTransactionOnLocationChange && (state.historyAction === 'PUSH' || state.historyAction === 'POP')) {
        handleNavigation(location, routes, state.historyAction, undefined, basename);
      }
    });

    return router;
  };
}

function reactrouterv6_getActiveRootSpan() {
  // Legacy behavior for "old" react router instrumentation
  if (reactrouterv6_activeTransaction) {
    return reactrouterv6_activeTransaction;
  }

  const span = (0,trace/* getActiveSpan */.HN)();
  const rootSpan = span ? (0,getRootSpan/* getRootSpan */.G)(span) : undefined;

  if (!rootSpan) {
    return undefined;
  }

  const op = (0,spanUtils/* spanToJSON */.XU)(rootSpan).op;

  // Only use this root span if it is a pageload or navigation span
  return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}


//# sourceMappingURL=reactrouterv6.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/index.js








//# sourceMappingURL=index.js.map


/***/ }),

/***/ 12793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ init; }
/* harmony export */ });
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20113);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61650);



/**
 * Inits the React SDK
 */
function init(options) {
  const opts = {
    ...options,
  };

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .applySdkMetadata */ .V)(opts, 'react');

  (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_1__/* .init */ .S1)(opts);
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 84596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ applyAggregateErrorsToEvent; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48593);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1466);



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(
  exceptionFromErrorImplementation,
  parser,
  maxValueLimit = 250,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException =
    event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException ,
        key,
        event.exception.values,
        originalException,
        0,
      ),
      maxValueLimit,
    );
  }
}

function aggregateExceptionsFromError(
  exceptionFromErrorImplementation,
  parser,
  limit,
  error,
  key,
  prevExceptions,
  exception,
  exceptionId,
) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  let newExceptions = [...prevExceptions];

  // Recursively call this function in order to walk down a chain of errors
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId,
    );
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId,
        );
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    ...(exception.type === 'AggregateError' && { is_exception_group: true }),
    exception_id: exceptionId,
  };
}

function applyExceptionGroupFieldsForChildException(
  exception,
  source,
  exceptionId,
  parentId,
) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId,
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = (0,_string_js__WEBPACK_IMPORTED_MODULE_1__/* .truncate */ .$G)(exception.value, maxValueLength);
    }
    return exception;
  });
}


//# sourceMappingURL=aggregate-errors.js.map


/***/ }),

/***/ 28308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; },
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40137);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48593);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58786);




const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      for (const key of Object.keys(currBaggageObject)) {
        acc[key] = currBaggageObject[key];
      }
      return acc;
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
        _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 71207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iY": function() { return /* binding */ getComponentName; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48593);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {
  if (!elem) {
    return '<unknown>';
  }

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  // @ts-expect-error WINDOW has HTMLElement
  if (WINDOW.HTMLElement) {
    // If using the component name annotation plugin, this value may be available on the DOM node
    if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) {
      return elem.dataset['sentryComponent'];
    }
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}

/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */
function getComponentName(elem) {
  // @ts-expect-error WINDOW has HTMLElement
  if (!WINDOW.HTMLElement) {
    return null;
  }

  let currentElem = elem ;
  const MAX_TRAVERSE_HEIGHT = 5;
  for (let i = 0; i < MAX_TRAVERSE_HEIGHT; i++) {
    if (!currentElem) {
      return null;
    }

    if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) {
      return currentElem.dataset['sentryComponent'];
    }

    currentElem = currentElem.parentNode;
  }

  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 18746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 57672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ _optionalChain; }
/* harmony export */ });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map


/***/ }),

/***/ 40137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 10959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U4": function() { return /* binding */ dsnFromString; },
/* harmony export */   "RA": function() { return /* binding */ dsnToString; },
/* harmony export */   "vK": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40137);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58786);



/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    (0,_logger_js__WEBPACK_IMPORTED_MODULE_0__/* .consoleSandbox */ .Cf)(() => {
      // eslint-disable-next-line no-console
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map


/***/ }),

/***/ 3932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-expect-error "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 73506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ addItemToEnvelope; },
/* harmony export */   "zQ": function() { return /* binding */ createAttachmentEnvelopeItem; },
/* harmony export */   "Jd": function() { return /* binding */ createEnvelope; },
/* harmony export */   "Cd": function() { return /* binding */ createEventEnvelopeHeaders; },
/* harmony export */   "R": function() { return /* binding */ envelopeContainsItemType; },
/* harmony export */   "mL": function() { return /* binding */ envelopeItemTypeToDataCategory; },
/* harmony export */   "gv": function() { return /* binding */ forEachEnvelopeItem; },
/* harmony export */   "HY": function() { return /* binding */ getSdkMetadataForEnvelopeHeader; },
/* harmony export */   "f4": function() { return /* binding */ parseEnvelope; },
/* harmony export */   "V$": function() { return /* binding */ serializeEnvelope; }
/* harmony export */ });
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10959);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14600);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76721);




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify((0,_normalize_js__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  feedback: 'feedback',
  span: 'span',
  statsd: 'metric_bucket',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: (0,_dsn_js__WEBPACK_IMPORTED_MODULE_2__/* .dsnToString */ .RA)(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map


/***/ }),

/***/ 34026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SentryError; }
/* harmony export */ });
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map


/***/ }),

/***/ 404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hj": function() { return /* binding */ addHandler; },
/* harmony export */   "D2": function() { return /* binding */ maybeInstrument; },
/* harmony export */   "rK": function() { return /* binding */ triggerHandlers; }
/* harmony export */ });
/* unused harmony export resetInstrumentationHandlers */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40137);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58786);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16398);




// We keep the handlers globally
const handlers = {};
const instrumented = {};

/** Add a handler function. */
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(handler);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key ] = undefined;
  });
}

/** Maybe run an instrumentation function, unless it was already called. */
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumentFn();
    instrumented[type] = true;
  }
}

/** Trigger handlers for a given instrumentation type. */
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}


//# sourceMappingURL=_handlers.js.map


/***/ }),

/***/ 17149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ addConsoleInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58786);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76721);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81539);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404);





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addConsoleInstrumentationHandler(handler) {
  const type = 'console';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentConsole);
}

function instrumentConsole() {
  if (!('console' in _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .n2)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.console */ .n2.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.console */ .n2.console, level, function (originalConsoleMethod) {
      _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .originalConsoleMethods */ .LD[level] = originalConsoleMethod;

      return function (...args) {
        const handlerData = { args, level };
        (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('console', handlerData);

        const log = _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .originalConsoleMethods */ .LD[level];
        log && log.apply(_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.console */ .n2.console, args);
      };
    });
  });
}


//# sourceMappingURL=console.js.map


/***/ }),

/***/ 9733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ addClickKeypressInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentDOM */
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40901);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76721);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(404);





const WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
const DEBOUNCE_DURATION = 1000;

let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;

/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addClickKeypressInstrumentationHandler(handler) {
  const type = 'dom';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .maybeInstrument */ .D2)(type, instrumentDOM);
}

/** Exported for tests only. */
function instrumentDOM() {
  if (!WINDOW.document) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = _handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers.bind */ .rK.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (WINDOW )[target] && (WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */
function isSimilarToLastCapturedEvent(event) {
  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (event.type !== lastCapturedEventType) {
    return false;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (!event.target || (event.target )._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return true;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(eventType, target) {
  // We are only interested in filtering `keypress` events for now.
  if (eventType !== 'keypress') {
    return false;
  }

  if (!target || !target.tagName) {
    return true;
  }

  // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
  // e.g.tabbing through elements, hotkeys, etc.
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return false;
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 */
function makeDOMEventHandler(
  handler,
  globalListener = false,
) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || event['_sentryCaptured']) {
      return;
    }

    const target = getEventTarget(event);

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }

    // Mark event as "seen"
    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(event, '_sentryCaptured', true);

    if (target && !target._sentryId) {
      // Add UUID to event target so we can identify if
      (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(target, '_sentryId', (0,_misc_js__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
    // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = { event, name, global: globalListener };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : undefined;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      lastCapturedEventTargetId = undefined;
      lastCapturedEventType = undefined;
    }, DEBOUNCE_DURATION);
  };
}

function getEventTarget(event) {
  try {
    return event.target ;
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    return null;
  }
}


//# sourceMappingURL=dom.js.map


/***/ }),

/***/ 61245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ addFetchInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export parseFetchArgs */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76721);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10264);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81539);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404);





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler) {
  const type = 'fetch';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentFetch);
}

function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_1__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(_worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .n2, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(_worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .n2, args).then(
        (response) => {
          const finishedHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          };

          (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch', finishedHandlerData);
          return response;
        },
        (error) => {
          const erroredHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          };

          (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('fetch', erroredHandlerData);
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}


//# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 80730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ addGlobalErrorInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81539);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404);



let _oldOnErrorHandler = null;

/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalErrorInstrumentationHandler(handler) {
  const type = 'error';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentError);
}

function instrumentError() {
  _oldOnErrorHandler = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror */ .n2.onerror;

  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror */ .n2.onerror = function (
    msg,
    url,
    line,
    column,
    error,
  ) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url,
    };
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('error', handlerData);

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ */ .n2.onerror.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=globalError.js.map


/***/ }),

/***/ 920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ addGlobalUnhandledRejectionInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81539);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404);



let _oldOnUnhandledRejectionHandler = null;

/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalUnhandledRejectionInstrumentationHandler(
  handler,
) {
  const type = 'unhandledrejection';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentUnhandledRejection);
}

function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection */ .n2.onunhandledrejection;

  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection */ .n2.onunhandledrejection = function (e) {
    const handlerData = e;
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)('unhandledrejection', handlerData);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ */ .n2.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=globalUnhandledRejection.js.map


/***/ }),

/***/ 16962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ addHistoryInstrumentationHandler; }
});

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(76721);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(81539);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chromeVar = (WINDOW ).chrome;
  const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument/_handlers.js
var _handlers = __webpack_require__(404);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/history.js







const history_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let lastHref;

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addHistoryInstrumentationHandler(handler) {
  const type = 'history';
  (0,_handlers/* addHandler */.Hj)(type, handler);
  (0,_handlers/* maybeInstrument */.D2)(type, instrumentHistory);
}

function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = history_WINDOW.onpopstate;
  history_WINDOW.onpopstate = function ( ...args) {
    const to = history_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    const handlerData = { from, to };
    (0,_handlers/* triggerHandlers */.rK)('history', handlerData);
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        const handlerData = { from, to };
        (0,_handlers/* triggerHandlers */.rK)('history', handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(history_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(history_WINDOW.history, 'replaceState', historyReplacementFunction);
}


//# sourceMappingURL=history.js.map


/***/ }),

/***/ 52868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xU": function() { return /* binding */ SENTRY_XHR_DATA_KEY; },
/* harmony export */   "UK": function() { return /* binding */ addXhrInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentXHR */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48593);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76721);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(404);





const WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v3__';

/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addXhrInstrumentationHandler(handler) {
  const type = 'xhr';
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .addHandler */ .Hj)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .maybeInstrument */ .D2)(type, instrumentXHR);
}

/** Exported only for tests. */
function instrumentXHR() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!(WINDOW ).XMLHttpRequest) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const startTimestamp = Date.now();

      // open() should always be called with two or more arguments
      // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
      const method = (0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : undefined;
      const url = parseUrl(args[1]);

      if (!method || !url) {
        return originalOpen.apply(this, args);
      }

      this[SENTRY_XHR_DATA_KEY] = {
        method,
        url,
        request_headers: {},
      };

      // if Sentry key appears in URL, don't capture it as a request
      if (method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          const handlerData = {
            args: [method, url],
            endTimestamp: Date.now(),
            startTimestamp,
            xhr: this,
          };
          (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers */ .rK)('xhr', handlerData);
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo && (0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(header) && (0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(value)) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];

      if (!sentryXhrData) {
        return originalSend.apply(this, args);
      }

      if (args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      const handlerData = {
        args: [sentryXhrData.method, sentryXhrData.url],
        startTimestamp: Date.now(),
        xhr: this,
      };
      (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers */ .rK)('xhr', handlerData);

      return originalSend.apply(this, args);
    };
  });
}

function parseUrl(url) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(url)) {
    return url;
  }

  try {
    // url can be a string or URL
    // but since URL is not available in IE11, we do not check for it,
    // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
    // If that fails, we just return undefined
    return (url ).toString();
  } catch (e2) {} // eslint-disable-line no-empty

  return undefined;
}


//# sourceMappingURL=xhr.js.map


/***/ }),

/***/ 48593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "Le": function() { return /* binding */ isParameterizedString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isParameterizedString(wat) {
  return (
    typeof wat === 'object' &&
    wat !== null &&
    '__sentry_template_string__' in wat &&
    '__sentry_template_values__' in wat
  );
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && ((wat ).__isVue || (wat )._isVue));
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 58786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "kg": function() { return /* binding */ logger; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40137);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);



/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = [
  'debug',
  'info',
  'warn',
  'error',
  'log',
  'assert',
  'trace',
] ;

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods

 = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!('console' in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedFuncs = {};

  const wrappedLevels = Object.keys(originalConsoleMethods) ;

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level] ;
    wrappedFuncs[level] = console[level] ;
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level] ;
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
  };

  if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

const logger = makeLogger();


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 40901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "go": function() { return /* binding */ addContextToFrame; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "DM": function() { return /* binding */ uuid4; }
/* harmony export */ });
/* unused harmony export parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76721);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1466);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => {
        // crypto.getRandomValues might return undefined instead of the typed array
        // in old Chromium versions (e.g. 23.0.1235.0 (151422))
        // However, `typedArray` is still filled in-place.
        // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
        const typedArray = new Uint8Array(1);
        crypto.getRandomValues(typedArray);
        return typedArray[0];
      };
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => (0,_string_js__WEBPACK_IMPORTED_MODULE_1__/* .snipLine */ .JM)(line, 0));

  frame.context_line = (0,_string_js__WEBPACK_IMPORTED_MODULE_1__/* .snipLine */ .JM)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => (0,_string_js__WEBPACK_IMPORTED_MODULE_1__/* .snipLine */ .JM)(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 26849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; }
/* harmony export */ });
/* unused harmony exports dynamicRequire, loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3932);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(90907);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 14600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: normalizeUrlToBase, walk

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(48593);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(76721);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(16398);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    if ((0,is/* isVueViewModel */.y1)(value)) {
      return '[VueViewModel]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */
function normalizeUrlToBase(url, basePath) {
  const escapedBase = basePath
    // Backslash to forward
    .replace(/\\/g, '/')
    // Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

  let newUrl = url;
  try {
    newUrl = decodeURI(url);
  } catch (_Oo) {
    // Sometime this breaks
  }
  return (
    newUrl
      .replace(/\\/g, '/')
      .replace(/webpack:\/?/g, '') // Remove intermediate base path
      // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
      .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///')
  );
}


//# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 76721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71207);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40137);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48593);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58786);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1466);






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true,
    });
  } catch (o_O) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_3__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPojo(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

function isPojo(input) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .PO)(input)) {
    return false;
  }

  try {
    const name = (Object.getPrototypeOf(input) ).constructor.name;
    return !name || name === 'Object';
  } catch (e) {
    return true;
  }
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 94050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ isRateLimited; },
/* harmony export */   "JY": function() { return /* binding */ parseRetryAfterHeader; },
/* harmony export */   "WG": function() { return /* binding */ updateRateLimits; }
/* harmony export */ });
/* unused harmony exports DEFAULT_RETRY_AFTER, disabledUntil */
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, dataCategory) {
  return limits[dataCategory] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, dataCategory, now = Date.now()) {
  return disabledUntil(limits, dataCategory) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          if (category === 'metric_bucket') {
            // namespaces will be present when category === 'metric_bucket'
            if (!namespaces || namespaces.split(';').includes('custom')) {
              updatedRateLimits[category] = now + delay;
            }
          } else {
            updatedRateLimits[category] = now + delay;
          }
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map


/***/ }),

/***/ 32798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VT": function() { return /* binding */ severityLevelFromString; }
/* harmony export */ });
/* unused harmony exports severityFromString, validSeverityLevels */
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map


/***/ }),

/***/ 16398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pE": function() { return /* binding */ createStackParser; },
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */



const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = Array.from(stack);

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();

    // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
    // is produced within the hub itself, making it:
    //
    //   Sentry.captureException()
    //   getCurrentHub().captureException()
    //
    // instead of just the top `Sentry` call itself.
    // This forces us to possibly strip an additional frame in the exact same was as above.
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
      localStack.pop();
    }
  }

  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 1466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "JM": function() { return /* binding */ snipLine; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "$G": function() { return /* binding */ truncate; }
/* harmony export */ });
/* unused harmony export isMatchingPattern */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48593);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
      // console warnings. This happens when a Vue template is rendered with
      // an undeclared variable, which we try to stringify, ultimately causing
      // Vue to issue another warning which repeats indefinitely.
      // see: https://github.com/getsentry/sentry-javascript/pull/8981
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
        output.push('[VueViewModel]');
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 10264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; },
/* harmony export */   "zb": function() { return /* binding */ supportsReportingObserver; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40137);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58786);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);




// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-expect-error It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (typeof EdgeRuntime === 'string') {
    return true;
  }

  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
        _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 17954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; },
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48593);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init2() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init3() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init4() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 24703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81539);


const ONE_SECOND_IN_MS = 1000;

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */
function dateTimestampInSeconds() {
  return Date.now() / ONE_SECOND_IN_MS;
}

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function createUnixTimestampInSecondsFunc() {
  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  if (!performance || !performance.now) {
    return dateTimestampInSeconds;
  }

  // Some browser and environments don't have a timeOrigin, so we fallback to
  // using Date.now() to compute the starting time.
  const approxStartingTimeOrigin = Date.now() - performance.now();
  const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;

  // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
  // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
  //
  // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
  // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
  // correct for this.
  // See: https://github.com/getsentry/sentry-javascript/issues/2590
  // See: https://github.com/mdn/content/issues/4713
  // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
  return () => {
    return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
  };
}

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = createUnixTimestampInSecondsFunc();

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 75771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; },
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "pT": function() { return /* binding */ propagationContextFromHeaders; },
/* harmony export */   "KA": function() { return /* binding */ tracingContextFromHeaders; }
/* harmony export */ });
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28308);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40901);



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */
// TODO(v8): Remove this function
function tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  if (!traceparentData) {
    return {
      traceparentData,
      dynamicSamplingContext: undefined,
      propagationContext: {
        traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
        spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      },
    };
  } else {
    return {
      traceparentData,
      dynamicSamplingContext: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      propagationContext: {
        traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
        parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
        spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      },
    };
  }
}

/**
 * Create a propagation context from incoming headers.
 */
function propagationContextFromHeaders(
  sentryTrace,
  baggage,
) {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  if (!traceparentData) {
    return {
      traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
      spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
    };
  } else {
    return {
      traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
      parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      sampled: parentSampled,
      dsc: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    };
  }
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
  spanId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map


/***/ }),

/***/ 84808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ getNumberOfUrlSegments; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony export getSanitizedUrlString */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        // TODO: Use new URL global if it exists
        .replace(/(:80)$/, '')
        .replace(/(:443)$/, '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map


/***/ }),

/***/ 81539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; },
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 6340:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDataUrlFromArr = getDataUrlFromArr;
exports.getImgFromDataUrl = getImgFromDataUrl;
exports.getImgFromArr = getImgFromArr;
/**
 * @function getDataUrlFromArr
 * @param {Uint8ClampedArray} arr
 * @param {int} w
 * @param {int} h
 * @returns {string}
 */
function getDataUrlFromArr(arr, w, h) {
  if (typeof w === 'undefined' || typeof h === 'undefined') {
    w = h = Math.sqrt(arr.length / 4);
  }

  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  canvas.width = w;
  canvas.height = h;

  var imgData = ctx.createImageData(w, h);
  imgData.data.set(arr);
  ctx.putImageData(imgData, 0, 0);

  return canvas.toDataURL();
}

/**
 * @function getImgFromDataUrl
 * @param {string} data
 * @returns {HTMLImageElement}
 */
function getImgFromDataUrl(data) {
  var img = document.createElement('img');
  img.src = data;
  return img;
}

/**
 * @function getImgFromArr
 * @param {Uint8ClampedArray} arr
 * @param {int} w
 * @param {int} h
 * @returns {HTMLImageElement}
 */
function getImgFromArr(arr, w, h) {
  return getImgFromDataUrl(getDataUrlFromArr(arr, w, h));
}


/***/ }),

/***/ 51654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ValidationError": function() { return /* reexport */ ValidationError; },
  "decode": function() { return /* reexport */ esm_decode; },
  "encode": function() { return /* reexport */ esm_encode; },
  "isBlurhashValid": function() { return /* reexport */ isBlurhashValid; }
});

;// CONCATENATED MODULE: ../../node_modules/blurhash/dist/esm/base83.js
const digitCharacters = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "#",
    "$",
    "%",
    "*",
    "+",
    ",",
    "-",
    ".",
    ":",
    ";",
    "=",
    "?",
    "@",
    "[",
    "]",
    "^",
    "_",
    "{",
    "|",
    "}",
    "~"
];
const decode83 = (str) => {
    let value = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str[i];
        const digit = digitCharacters.indexOf(c);
        value = value * 83 + digit;
    }
    return value;
};
const encode83 = (n, length) => {
    var result = "";
    for (let i = 1; i <= length; i++) {
        let digit = (Math.floor(n) / Math.pow(83, length - i)) % 83;
        result += digitCharacters[Math.floor(digit)];
    }
    return result;
};
//# sourceMappingURL=base83.js.map
;// CONCATENATED MODULE: ../../node_modules/blurhash/dist/esm/utils.js
const sRGBToLinear = (value) => {
    let v = value / 255;
    if (v <= 0.04045) {
        return v / 12.92;
    }
    else {
        return Math.pow((v + 0.055) / 1.055, 2.4);
    }
};
const linearTosRGB = (value) => {
    let v = Math.max(0, Math.min(1, value));
    if (v <= 0.0031308) {
        return Math.round(v * 12.92 * 255 + 0.5);
    }
    else {
        return Math.round((1.055 * Math.pow(v, 1 / 2.4) - 0.055) * 255 + 0.5);
    }
};
const sign = (n) => (n < 0 ? -1 : 1);
const signPow = (val, exp) => sign(val) * Math.pow(Math.abs(val), exp);
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ../../node_modules/blurhash/dist/esm/error.js
class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = "ValidationError";
        this.message = message;
    }
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ../../node_modules/blurhash/dist/esm/decode.js



/**
 * Returns an error message if invalid or undefined if valid
 * @param blurhash
 */
const validateBlurhash = (blurhash) => {
    if (!blurhash || blurhash.length < 6) {
        throw new ValidationError("The blurhash string must be at least 6 characters");
    }
    const sizeFlag = decode83(blurhash[0]);
    const numY = Math.floor(sizeFlag / 9) + 1;
    const numX = (sizeFlag % 9) + 1;
    if (blurhash.length !== 4 + 2 * numX * numY) {
        throw new ValidationError(`blurhash length mismatch: length is ${blurhash.length} but it should be ${4 + 2 * numX * numY}`);
    }
};
const isBlurhashValid = (blurhash) => {
    try {
        validateBlurhash(blurhash);
    }
    catch (error) {
        return { result: false, errorReason: error.message };
    }
    return { result: true };
};
const decodeDC = (value) => {
    const intR = value >> 16;
    const intG = (value >> 8) & 255;
    const intB = value & 255;
    return [sRGBToLinear(intR), sRGBToLinear(intG), sRGBToLinear(intB)];
};
const decodeAC = (value, maximumValue) => {
    const quantR = Math.floor(value / (19 * 19));
    const quantG = Math.floor(value / 19) % 19;
    const quantB = value % 19;
    const rgb = [
        signPow((quantR - 9) / 9, 2.0) * maximumValue,
        signPow((quantG - 9) / 9, 2.0) * maximumValue,
        signPow((quantB - 9) / 9, 2.0) * maximumValue
    ];
    return rgb;
};
const decode = (blurhash, width, height, punch) => {
    validateBlurhash(blurhash);
    punch = punch | 1;
    const sizeFlag = decode83(blurhash[0]);
    const numY = Math.floor(sizeFlag / 9) + 1;
    const numX = (sizeFlag % 9) + 1;
    const quantisedMaximumValue = decode83(blurhash[1]);
    const maximumValue = (quantisedMaximumValue + 1) / 166;
    const colors = new Array(numX * numY);
    for (let i = 0; i < colors.length; i++) {
        if (i === 0) {
            const value = decode83(blurhash.substring(2, 6));
            colors[i] = decodeDC(value);
        }
        else {
            const value = decode83(blurhash.substring(4 + i * 2, 6 + i * 2));
            colors[i] = decodeAC(value, maximumValue * punch);
        }
    }
    const bytesPerRow = width * 4;
    const pixels = new Uint8ClampedArray(bytesPerRow * height);
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            let r = 0;
            let g = 0;
            let b = 0;
            for (let j = 0; j < numY; j++) {
                for (let i = 0; i < numX; i++) {
                    const basis = Math.cos((Math.PI * x * i) / width) *
                        Math.cos((Math.PI * y * j) / height);
                    let color = colors[i + j * numX];
                    r += color[0] * basis;
                    g += color[1] * basis;
                    b += color[2] * basis;
                }
            }
            let intR = linearTosRGB(r);
            let intG = linearTosRGB(g);
            let intB = linearTosRGB(b);
            pixels[4 * x + 0 + y * bytesPerRow] = intR;
            pixels[4 * x + 1 + y * bytesPerRow] = intG;
            pixels[4 * x + 2 + y * bytesPerRow] = intB;
            pixels[4 * x + 3 + y * bytesPerRow] = 255; // alpha
        }
    }
    return pixels;
};
/* harmony default export */ var esm_decode = (decode);
//# sourceMappingURL=decode.js.map
;// CONCATENATED MODULE: ../../node_modules/blurhash/dist/esm/encode.js



const bytesPerPixel = 4;
const multiplyBasisFunction = (pixels, width, height, basisFunction) => {
    let r = 0;
    let g = 0;
    let b = 0;
    const bytesPerRow = width * bytesPerPixel;
    for (let x = 0; x < width; x++) {
        for (let y = 0; y < height; y++) {
            const basis = basisFunction(x, y);
            r +=
                basis * sRGBToLinear(pixels[bytesPerPixel * x + 0 + y * bytesPerRow]);
            g +=
                basis * sRGBToLinear(pixels[bytesPerPixel * x + 1 + y * bytesPerRow]);
            b +=
                basis * sRGBToLinear(pixels[bytesPerPixel * x + 2 + y * bytesPerRow]);
        }
    }
    let scale = 1 / (width * height);
    return [r * scale, g * scale, b * scale];
};
const encodeDC = (value) => {
    const roundedR = linearTosRGB(value[0]);
    const roundedG = linearTosRGB(value[1]);
    const roundedB = linearTosRGB(value[2]);
    return (roundedR << 16) + (roundedG << 8) + roundedB;
};
const encodeAC = (value, maximumValue) => {
    let quantR = Math.floor(Math.max(0, Math.min(18, Math.floor(signPow(value[0] / maximumValue, 0.5) * 9 + 9.5))));
    let quantG = Math.floor(Math.max(0, Math.min(18, Math.floor(signPow(value[1] / maximumValue, 0.5) * 9 + 9.5))));
    let quantB = Math.floor(Math.max(0, Math.min(18, Math.floor(signPow(value[2] / maximumValue, 0.5) * 9 + 9.5))));
    return quantR * 19 * 19 + quantG * 19 + quantB;
};
const encode = (pixels, width, height, componentX, componentY) => {
    if (componentX < 1 || componentX > 9 || componentY < 1 || componentY > 9) {
        throw new ValidationError("BlurHash must have between 1 and 9 components");
    }
    if (width * height * 4 !== pixels.length) {
        throw new ValidationError("Width and height must match the pixels array");
    }
    let factors = [];
    for (let y = 0; y < componentY; y++) {
        for (let x = 0; x < componentX; x++) {
            const normalisation = x == 0 && y == 0 ? 1 : 2;
            const factor = multiplyBasisFunction(pixels, width, height, (i, j) => normalisation *
                Math.cos((Math.PI * x * i) / width) *
                Math.cos((Math.PI * y * j) / height));
            factors.push(factor);
        }
    }
    const dc = factors[0];
    const ac = factors.slice(1);
    let hash = "";
    let sizeFlag = componentX - 1 + (componentY - 1) * 9;
    hash += encode83(sizeFlag, 1);
    let maximumValue;
    if (ac.length > 0) {
        let actualMaximumValue = Math.max(...ac.map(val => Math.max(...val)));
        let quantisedMaximumValue = Math.floor(Math.max(0, Math.min(82, Math.floor(actualMaximumValue * 166 - 0.5))));
        maximumValue = (quantisedMaximumValue + 1) / 166;
        hash += encode83(quantisedMaximumValue, 1);
    }
    else {
        maximumValue = 1;
        hash += encode83(0, 1);
    }
    hash += encode83(encodeDC(dc), 4);
    ac.forEach(factor => {
        hash += encode83(encodeAC(factor, maximumValue), 2);
    });
    return hash;
};
/* harmony default export */ var esm_encode = (encode);
//# sourceMappingURL=encode.js.map
;// CONCATENATED MODULE: ../../node_modules/blurhash/dist/esm/index.js



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* globals document, ImageData */

const parseFont = __webpack_require__(43112)

exports.parseFont = parseFont

exports.createCanvas = function (width, height) {
  return Object.assign(document.createElement('canvas'), { width: width, height: height })
}

exports.createImageData = function (array, width, height) {
  // Browser implementation of ImageData looks at the number of arguments passed
  switch (arguments.length) {
    case 0: return new ImageData()
    case 1: return new ImageData(array)
    case 2: return new ImageData(array, width)
    default: return new ImageData(array, width, height)
  }
}

exports.loadImage = function (src, options) {
  return new Promise(function (resolve, reject) {
    const image = Object.assign(document.createElement('img'), options)

    function cleanup () {
      image.onload = null
      image.onerror = null
    }

    image.onload = function () { cleanup(); resolve(image) }
    image.onerror = function () { cleanup(); reject(new Error('Failed to load the image "' + src + '"')) }

    image.src = src
  })
}


/***/ }),

/***/ 43112:
/***/ (function(module) {

"use strict";


/**
 * Font RegExp helpers.
 */

const weights = 'bold|bolder|lighter|[1-9]00'
const styles = 'italic|oblique'
const variants = 'small-caps'
const stretches = 'ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded'
const units = 'px|pt|pc|in|cm|mm|%|em|ex|ch|rem|q'
const string = '\'([^\']+)\'|"([^"]+)"|[\\w\\s-]+'

// [ [ <‘font-style’> || <font-variant-css21> || <‘font-weight’> || <‘font-stretch’> ]?
//    <‘font-size’> [ / <‘line-height’> ]? <‘font-family’> ]
// https://drafts.csswg.org/css-fonts-3/#font-prop
const weightRe = new RegExp(`(${weights}) +`, 'i')
const styleRe = new RegExp(`(${styles}) +`, 'i')
const variantRe = new RegExp(`(${variants}) +`, 'i')
const stretchRe = new RegExp(`(${stretches}) +`, 'i')
const sizeFamilyRe = new RegExp(
  `([\\d\\.]+)(${units}) *((?:${string})( *, *(?:${string}))*)`)

/**
 * Cache font parsing.
 */

const cache = {}

const defaultHeight = 16 // pt, common browser default

/**
 * Parse font `str`.
 *
 * @param {String} str
 * @return {Object} Parsed font. `size` is in device units. `unit` is the unit
 *   appearing in the input string.
 * @api private
 */

module.exports = str => {
  // Cached
  if (cache[str]) return cache[str]

  // Try for required properties first.
  const sizeFamily = sizeFamilyRe.exec(str)
  if (!sizeFamily) return // invalid

  // Default values and required properties
  const font = {
    weight: 'normal',
    style: 'normal',
    stretch: 'normal',
    variant: 'normal',
    size: parseFloat(sizeFamily[1]),
    unit: sizeFamily[2],
    family: sizeFamily[3].replace(/["']/g, '').replace(/ *, */g, ',')
  }

  // Optional, unordered properties.
  let weight, style, variant, stretch
  // Stop search at `sizeFamily.index`
  const substr = str.substring(0, sizeFamily.index)
  if ((weight = weightRe.exec(substr))) font.weight = weight[1]
  if ((style = styleRe.exec(substr))) font.style = style[1]
  if ((variant = variantRe.exec(substr))) font.variant = variant[1]
  if ((stretch = stretchRe.exec(substr))) font.stretch = stretch[1]

  // Convert to device units. (`font.unit` is the original unit)
  // TODO: ch, ex
  switch (font.unit) {
    case 'pt':
      font.size /= 0.75
      break
    case 'pc':
      font.size *= 16
      break
    case 'in':
      font.size *= 96
      break
    case 'cm':
      font.size *= 96.0 / 2.54
      break
    case 'mm':
      font.size *= 96.0 / 25.4
      break
    case '%':
      // TODO disabled because existing unit tests assume 100
      // font.size *= defaultHeight / 100 / 0.75
      break
    case 'em':
    case 'rem':
      font.size *= defaultHeight / 0.75
      break
    case 'q':
      font.size *= 96 / 25.4 / 4
      break
  }

  return (cache[str] = font)
}


/***/ }),

/***/ 48925:
/***/ (function(module) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 64467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ downshift_esm; },
  "resetIdCounter": function() { return /* binding */ resetIdCounter; },
  "useCombobox": function() { return /* binding */ useCombobox; },
  "useSelect": function() { return /* binding */ useSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(12720);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(61393);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(98911);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(8131);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(72621);
;// CONCATENATED MODULE: ../../node_modules/compute-scroll-into-view/dist/index.mjs
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}var i=function(e,i){var o=window,l=i.scrollMode,d=i.block,f=i.inline,h=i.boundary,u=i.skipOverflowHiddenElements,s="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var a,c,g=document.scrollingElement||document.documentElement,p=[],m=e;t(m)&&s(m);){if((m=null==(c=(a=m).parentElement)?a.getRootNode().host||null:c)===g){p.push(m);break}null!=m&&m===document.body&&n(m)&&!n(document.documentElement)||null!=m&&n(m,u)&&p.push(m)}for(var w=o.visualViewport?o.visualViewport.width:innerWidth,v=o.visualViewport?o.visualViewport.height:innerHeight,W=window.scrollX||pageXOffset,H=window.scrollY||pageYOffset,b=e.getBoundingClientRect(),y=b.height,E=b.width,M=b.top,V=b.right,x=b.bottom,I=b.left,C="start"===d||"nearest"===d?M:"end"===d?x:M+y/2,R="center"===f?I+E/2:"end"===f?V:I,T=[],k=0;k<p.length;k++){var B=p[k],D=B.getBoundingClientRect(),O=D.height,X=D.width,Y=D.top,L=D.right,S=D.bottom,j=D.left;if("if-needed"===l&&M>=0&&I>=0&&x<=v&&V<=w&&M>=Y&&x<=S&&I>=j&&V<=L)return T;var N=getComputedStyle(B),q=parseInt(N.borderLeftWidth,10),z=parseInt(N.borderTopWidth,10),A=parseInt(N.borderRightWidth,10),F=parseInt(N.borderBottomWidth,10),G=0,J=0,K="offsetWidth"in B?B.offsetWidth-B.clientWidth-q-A:0,P="offsetHeight"in B?B.offsetHeight-B.clientHeight-z-F:0,Q="offsetWidth"in B?0===B.offsetWidth?0:X/B.offsetWidth:0,U="offsetHeight"in B?0===B.offsetHeight?0:O/B.offsetHeight:0;if(g===B)G="start"===d?C:"end"===d?C-v:"nearest"===d?r(H,H+v,v,z,F,H+C,H+C+y,y):C-v/2,J="start"===f?R:"center"===f?R-w/2:"end"===f?R-w:r(W,W+w,w,q,A,W+R,W+R+E,E),G=Math.max(0,G+H),J=Math.max(0,J+W);else{G="start"===d?C-Y-z:"end"===d?C-S+F+P:"nearest"===d?r(Y,S,O,z,F+P,C,C+y,y):C-(Y+O/2)+P/2,J="start"===f?R-j-q:"center"===f?R-(j+X/2)+K/2:"end"===f?R-L+A+K:r(j,L,X,q,A+K,R,R+E,E);var Z=B.scrollLeft,$=B.scrollTop;C+=$-(G=Math.max(0,Math.min($+G/U,B.scrollHeight-O/U+P))),R+=Z-(J=Math.max(0,Math.min(Z+J/Q,B.scrollWidth-X/Q+K)))}T.push({el:B,top:G,left:J})}return T};
//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../../node_modules/downshift/dist/downshift.esm.js









var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (node === null) {
    return;
  }

  var actions = i(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child) {
  return parent === child || parent.contains && parent.contains(child);
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId() {
  return String(idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */


function resetIdCounter() {
  idCounter = 0;
}
/**
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage(_ref2) {
  var isOpen = _ref2.isOpen,
      selectedItem = _ref2.selectedItem,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount,
      itemToString = _ref2.itemToString;

  if (!isOpen) {
    return selectedItem ? itemToString(selectedItem) : '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */


function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ?
  /* istanbul ignore next (preact) */
  arg[0] : arg;

  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */


function isDOMElement(element) {
  // then we assume this is react
  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */


function getElementProps(element) {
  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */


function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */


function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */


function isControlledProp(props, key) {
  return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */


function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }

  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }

  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
  return nonDisabledNewIndex === -1 ? baseIndex : nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */


function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);

  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }

  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  }

  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }

  return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement} rootNode The element with combobox role.
 * @param {HTMLElement} menuNode The elements list with listbox role.
 * @param {Document} document The document.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */


function targetWithinDownshift(target, rootNode, menuNode, document, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }

  return [rootNode, menuNode].some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target) || checkActiveElement && isOrContainsNode(contextNode, document.activeElement));
  });
}

var cleanupStatus = debounce(function () {
  getStatusDiv().textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus();
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown =  false ? 0 : 0;
var mouseUp =  false ? 0 : 1;
var itemMouseEnter =  false ? 0 : 2;
var keyDownArrowUp =  false ? 0 : 3;
var keyDownArrowDown =  false ? 0 : 4;
var keyDownEscape =  false ? 0 : 5;
var keyDownEnter =  false ? 0 : 6;
var keyDownHome =  false ? 0 : 7;
var keyDownEnd =  false ? 0 : 8;
var clickItem =  false ? 0 : 9;
var blurInput =  false ? 0 : 10;
var changeInput =  false ? 0 : 11;
var keyDownSpaceButton =  false ? 0 : 12;
var clickButton =  false ? 0 : 13;
var blurButton =  false ? 0 : 14;
var controlledPropUpdatedSelectedItem =  false ? 0 : 15;
var touchEnd =  false ? 0 : 16;

var stateChangeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var Downshift =
/*#__PURE__*/
function () {
  var Downshift =
  /*#__PURE__*/
  function (_Component) {
    (0,inheritsLoose/* default */.Z)(Downshift, _Component);

    function Downshift(_props) {
      var _this = _Component.call(this, _props) || this;

      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";

      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };

      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];

      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);

        _this.timeoutIds.push(id);
      };

      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };

      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };

      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }

        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState((0,esm_extends/* default */.Z)({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };

      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };

      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState((0,esm_extends/* default */.Z)({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };

      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];

        if (item == null) {
          return;
        }

        _this.selectItem(item, otherStateToSet, cb);
      };

      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };

      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, (0,esm_extends/* default */.Z)({}, _this.getStateAndHelpers(), {}, stateToSet));
        }

        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed

          var nextFullState = {}; // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }

          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.


            if (key === 'type') {
              return;
            }

            nextFullState[key] = newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, (0,esm_extends/* default */.Z)({}, _this.getStateAndHelpers(), {}, newStateToSet));
          }

          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;

          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }

          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }

          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.


          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };

      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };

      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;

        var _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
            ref = _ref.ref,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["refKey", "ref"]);

        var _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;

        var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;

        return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };

      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();

              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                    highlightedIndex = _this2$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                  return _this2.getItemNodeFromIndex(index);
                });

                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();

              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                    highlightedIndex = _this3$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                  return _this3.getItemNodeFromIndex(index);
                });

                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          var _this$getState2 = this.getState(),
              isOpen = _this$getState2.isOpen,
              highlightedIndex = _this$getState2.highlightedIndex;

          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);

            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }

            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset({
            type: keyDownEscape,
            selectedItem: null,
            inputValue: ''
          });
        }
      };
      _this.buttonKeyDownHandlers = (0,esm_extends/* default */.Z)({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = (0,esm_extends/* default */.Z)({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this4 = this;

          event.preventDefault();
          var itemCount = this.getItemCount();

          var _this$getState3 = this.getState(),
              isOpen = _this$getState3.isOpen;

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting downwards from 0 if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
            return _this4.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;

          event.preventDefault();
          var itemCount = this.getItemCount();

          var _this$getState4 = this.getState(),
              isOpen = _this$getState4.isOpen;

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting upwards from last index if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
            return _this5.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });

      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick,
            onPress = _ref3.onPress,
            onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"]);

        var _this$getState5 = _this.getState(),
            isOpen = _this$getState5.isOpen;

        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return (0,esm_extends/* default */.Z)({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, {}, rest);
      };

      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };

      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if ( _this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.


        if (false) {} else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };

      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
              _this.reset({
                type: blurButton
              });
            }
        });
      };

      _this.getLabelProps = function (props) {
        return (0,esm_extends/* default */.Z)({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };

      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput,
            onChangeText = _ref4.onChangeText,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"]);

        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        onChangeKey = 'onChange';

        var _this$getState6 = _this.getState(),
            inputValue = _this$getState6.inputValue,
            isOpen = _this$getState6.isOpen,
            highlightedIndex = _this$getState6.highlightedIndex;

        if (!rest.disabled) {
          var _eventHandlers;

          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        /* istanbul ignore if (react-native) */


        return (0,esm_extends/* default */.Z)({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, {}, rest);
      };

      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };

      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);

          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };

      _this.menuRef = function (node) {
        _this._menuNode = node;
      };

      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;

        var _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
            ref = _ref5.ref,
            props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref5, ["refKey", "ref"]);

        var _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;

        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };

      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;

        var _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick,
            onPress = _ref7.onPress,
            index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ?  true ?
        /* istanbul ignore next */
        undefined : 0 : _ref7$item,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref7, ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]);

        if (index === undefined) {
          _this.items.push(item);

          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }

        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }

            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor


            _this.avoidScrolling = true;

            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return (0,esm_extends/* default */.Z)({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, {}, rest);
      };

      _this.clearItems = function () {
        _this.items = [];
      };

      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return (0,esm_extends/* default */.Z)({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };

      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return (0,esm_extends/* default */.Z)({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, {}, otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
              isOpen = _this$getState7.isOpen,
              highlightedIndex = _this$getState7.highlightedIndex;

          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }

          cbToCb(cb)();
        });
      };

      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };

      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };

      _this.updateStatus = debounce(function () {
        var state = _this.getState();

        var item = _this.items[state.highlightedIndex];

        var resultCount = _this.getItemCount();

        var status = _this.props.getA11yStatusMessage((0,esm_extends/* default */.Z)({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));

        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);

      // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided
      var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;

      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });

      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }

      _this.state = _state;
      return _this;
    }

    var _proto = Downshift.prototype;

    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    ;

    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }

      return getState(stateToMerge, this.props);
    };

    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;

      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }

      return itemCount;
    };

    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };

    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };

    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;

      var itemCount = this.getItemCount();

      var _this$getState8 = this.getState(),
          highlightedIndex = _this$getState8.highlightedIndex;

      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
          return _this6.getItemNodeFromIndex(index);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };

    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(),
          highlightedIndex = _this$getState9.highlightedIndex,
          inputValue = _this$getState9.inputValue,
          selectedItem = _this$getState9.selectedItem,
          isOpen = _this$getState9.isOpen;

      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    } //////////////////////////// ROOT
    ;

    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;

      /* istanbul ignore if (react-native) */
      if (false) {}
      /* istanbul ignore if (react-native) */


      {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function () {
          _this7.isMouseDown = true;
        };

        var onMouseUp = function (event) {
          _this7.isMouseDown = false; // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift

          var contextWithinDownshift = targetWithinDownshift(event.target, _this7._rootNode, _this7._menuNode, _this7.props.environment.document);

          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        }; // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping


        var onTouchStart = function () {
          _this7.isTouchMove = false;
        };

        var onTouchMove = function () {
          _this7.isTouchMove = true;
        };

        var onTouchEnd = function (event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, _this7._rootNode, _this7._menuNode, _this7.props.environment.document, false);

          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };

        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);

        this.cleanup = function () {
          _this7.internalClearTimeouts();

          _this7.updateStatus.cancel();

          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };

    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex;

      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex;

      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      return scrollWhenOpen || currentHighlightedIndex !== prevHighlightedIndex;
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      /* istanbul ignore else (react-native) */


      this.updateStatus();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };

    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.

      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.

      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

      this.getLabelProps.called = false; // and something similar for getInputProps

      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));

      if (!element) {
        return null;
      }

      if (this.getRootProps.called || this.props.suppressRefError) {
        if (false) {}

        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return (0,react.cloneElement)(element, this.getRootProps(getElementProps(element)));
      }
      /* istanbul ignore else */


      if (false) {}
      /* istanbul ignore next */


      return undefined;
    };

    return Downshift;
  }(react.Component);

  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }

      if (false) {}

      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: typeof window === 'undefined'
    /* istanbul ignore next (ssr) */
    ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes;
  return Downshift;
}();

 false ? 0 : void 0;

function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;

  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}

function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);

  if (isComposite && !refKeySpecified && !isForwardRef(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }

  if (!isForwardRef(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

function validateControlledUnchanged(prevProps, nextProps) {
  var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  ['selectedItem', 'isOpen', 'inputValue', 'highlightedIndex'].forEach(function (propKey) {
    if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
    } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
    }
  });
}

var defaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null
};

function getElementIds(generateDefaultId, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      id = _ref.id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId;

  var uniqueId = id === undefined ? "downshift-" + generateDefaultId() : id;
  return {
    labelId: labelId || uniqueId + "-label",
    menuId: menuId || uniqueId + "-menu",
    getItemId: getItemId || function (index) {
      return uniqueId + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || uniqueId + "-toggle-button"
  };
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function getPropTypesValidator(caller, propTypes) {
  // istanbul ignore next
  return function (options) {
    if (options === void 0) {
      options = {};
    }

    Object.entries(propTypes).forEach(function (_ref2) {
      var key = _ref2[0];
      PropTypes.checkPropTypes(propTypes, options, key, caller.name);
    });
  };
}

function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}

function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}

function invokeOnChangeHandler(propKey, props, state, changes) {
  var handler = "on" + capitalizeString(propKey) + "Change";

  if (props[handler] && changes[propKey] !== undefined && changes[propKey] !== state[propKey]) {
    props[handler](changes);
  }
}

function callOnChangeProps(props, state, changes) {
  Object.keys(state).forEach(function (stateKey) {
    invokeOnChangeHandler(stateKey, props, state, changes);
  });

  if (props.onStateChange && changes !== undefined) {
    props.onStateChange(changes);
  }
}

function useEnhancedReducer(reducer, initialState, props) {
  var enhancedReducer = (0,react.useCallback)(function (state, action) {
    state = getState(state, action.props);
    var stateReduceLocal = action.props.stateReducer;
    var changes = reducer(state, action);
    var newState = stateReduceLocal(state, (0,esm_extends/* default */.Z)({}, action, {
      changes: changes
    }));
    callOnChangeProps(action.props, state, newState);
    return newState;
  }, [reducer]);

  var _useReducer = (0,react.useReducer)(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return [getState(state, props), dispatch];
}

var lastId = 0; // istanbul ignore next

var genId = function () {
  return ++lastId;
};
/**
 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
 * Taken from @reach/auto-id
 * @see https://github.com/reach/reach-ui/blob/6e9dbcf716d5c9a3420e062e5bac1ac4671d01cb/packages/auto-id/src/index.js
 */
// istanbul ignore next


function useId() {
  var _useState = (0,react.useState)(null),
      id = _useState[0],
      setId = _useState[1];

  (0,react.useEffect)(function () {
    return setId(genId());
  }, []);
  return id;
}
/**
 * Checks if nextElement receives focus after the blur event.
 *
 * @param {FocusEvent} event The blur event.
 * @param {Element} nextElement The element to check that receive focus next.
 * @returns {boolean} If the focus lands on nextElement.
 */


function focusLandsOnElement(event, nextElement) {
  return !!nextElement && (event.relatedTarget === nextElement || // https://github.com/downshift-js/downshift/issues/832 - workaround for Firefox.
  event.nativeEvent && (nextElement === event.nativeEvent.explicitOriginalTarget || nextElement.contains(event.nativeEvent.explicitOriginalTarget)));
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */


function stateReducer(s, a) {
  return a.changes;
}
/**
 * Returns a message to be added to aria-live region when dropdown is open.
 *
 * @param {*} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11yStatusMessage$1(selectionParameters) {
  var isOpen = selectionParameters.isOpen,
      items = selectionParameters.items;

  if (!items) {
    return '';
  }

  var resultCount = items.length;

  if (isOpen) {
    if (resultCount === 0) {
      return 'No results are available';
    }

    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(selectedItem) + " has been selected.";
}

var defaultProps = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11yStatusMessage: getA11yStatusMessage$1,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  circularNavigation: false,
  environment: typeof window === 'undefined'
  /* istanbul ignore next (ssr) */
  ? {} : window
};

function getDefaultValue(props, propKey, defaultStateValuesLocal) {
  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return (0,esm_extends/* default */.Z)({}, defaultStateValues, {}, defaultStateValuesLocal)[propKey];
}

function getInitialValue(props, propKey, defaultStateValuesLocal) {
  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue(props, propKey, defaultStateValuesLocal);
}

function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex; // initialHighlightedIndex will give value to highlightedIndex on initial state only.

  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}

var defaultStateValues$1 = {
  keysSoFar: ''
};

function getDefaultValue$1(props, propKey) {
  return getDefaultValue(props, propKey, defaultStateValues$1);
}

function getInitialValue$1(props, propKey) {
  return getInitialValue(props, propKey, defaultStateValues$1);
}

function getInitialState(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    keysSoFar: ''
  };
}

function getItemIndexByCharacterKey(keysSoFar, highlightedIndex, items, itemToStringParam, getItemNodeFromIndex) {
  var lowerCasedItemStrings = items.map(function (item) {
    return itemToStringParam(item).toLowerCase();
  });
  var lowerCasedKeysSoFar = keysSoFar.toLowerCase();

  var isValid = function (itemString, index) {
    var element = getItemNodeFromIndex(index);
    return itemString.startsWith(lowerCasedKeysSoFar) && !(element && element.hasAttribute('disabled'));
  };

  for (var index = highlightedIndex + 1; index < lowerCasedItemStrings.length; index++) {
    var itemString = lowerCasedItemStrings[index];

    if (isValid(itemString, index)) {
      return index;
    }
  }

  for (var _index = 0; _index < highlightedIndex; _index++) {
    var _itemString = lowerCasedItemStrings[_index];

    if (isValid(_itemString, _index)) {
      return _index;
    }
  }

  return highlightedIndex;
}

var propTypes = {
  items: (prop_types_default()).array.isRequired,
  itemToString: (prop_types_default()).func,
  getA11yStatusMessage: (prop_types_default()).func,
  getA11ySelectionMessage: (prop_types_default()).func,
  circularNavigation: (prop_types_default()).bool,
  highlightedIndex: (prop_types_default()).number,
  defaultHighlightedIndex: (prop_types_default()).number,
  initialHighlightedIndex: (prop_types_default()).number,
  isOpen: (prop_types_default()).bool,
  defaultIsOpen: (prop_types_default()).bool,
  initialIsOpen: (prop_types_default()).bool,
  selectedItem: (prop_types_default()).any,
  initialSelectedItem: (prop_types_default()).any,
  defaultSelectedItem: (prop_types_default()).any,
  id: (prop_types_default()).string,
  labelId: (prop_types_default()).string,
  menuId: (prop_types_default()).string,
  getItemId: (prop_types_default()).func,
  toggleButtonId: (prop_types_default()).string,
  stateReducer: (prop_types_default()).func,
  onSelectedItemChange: (prop_types_default()).func,
  onHighlightedIndexChange: (prop_types_default()).func,
  onStateChange: (prop_types_default()).func,
  onIsOpenChange: (prop_types_default()).func,
  environment: prop_types_default().shape({
    addEventListener: (prop_types_default()).func,
    removeEventListener: (prop_types_default()).func,
    document: prop_types_default().shape({
      getElementById: (prop_types_default()).func,
      activeElement: (prop_types_default()).any,
      body: (prop_types_default()).any
    })
  })
};

var MenuKeyDownArrowDown =  false ? 0 : 0;
var MenuKeyDownArrowUp =  false ? 0 : 1;
var MenuKeyDownEscape =  false ? 0 : 2;
var MenuKeyDownHome =  false ? 0 : 3;
var MenuKeyDownEnd =  false ? 0 : 4;
var MenuKeyDownEnter =  false ? 0 : 5;
var MenuKeyDownSpaceButton =  false ? 0 : 6;
var MenuKeyDownCharacter =  false ? 0 : 7;
var MenuBlur =  false ? 0 : 8;
var MenuMouseLeave =  false ? 0 : 9;
var ItemMouseMove =  false ? 0 : 10;
var ItemClick =  false ? 0 : 11;
var ToggleButtonKeyDownCharacter =  false ? 0 : 12;
var ToggleButtonKeyDownArrowDown =  false ? 0 : 13;
var ToggleButtonKeyDownArrowUp =  false ? 0 : 14;
var ToggleButtonClick =  false ? 0 : 15;
var FunctionToggleMenu =  false ? 0 : 16;
var FunctionOpenMenu =  false ? 0 : 17;
var FunctionCloseMenu =  false ? 0 : 18;
var FunctionSetHighlightedIndex =  false ? 0 : 19;
var FunctionSelectItem =  false ? 0 : 20;
var FunctionClearKeysSoFar =  false ? 0 : 21;
var FunctionReset =  false ? 0 : 22;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
  MenuKeyDownEscape: MenuKeyDownEscape,
  MenuKeyDownHome: MenuKeyDownHome,
  MenuKeyDownEnd: MenuKeyDownEnd,
  MenuKeyDownEnter: MenuKeyDownEnter,
  MenuKeyDownSpaceButton: MenuKeyDownSpaceButton,
  MenuKeyDownCharacter: MenuKeyDownCharacter,
  MenuBlur: MenuBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionClearKeysSoFar: FunctionClearKeysSoFar,
  FunctionReset: FunctionReset
});

/* eslint-disable complexity */

function downshiftSelectReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;

    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case MenuKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownEnter:
    case MenuKeyDownSpaceButton:
      changes = (0,esm_extends/* default */.Z)({
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex')
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;

    case MenuKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var keysSoFar = "" + state.keysSoFar + lowercasedKey;
        var highlightedIndex = getItemIndexByCharacterKey(keysSoFar, state.highlightedIndex, props.items, props.itemToString, action.getItemNodeFromIndex);
        changes = (0,esm_extends/* default */.Z)({
          keysSoFar: keysSoFar
        }, highlightedIndex >= 0 && {
          highlightedIndex: highlightedIndex
        });
      }
      break;

    case MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case ToggleButtonKeyDownCharacter:
      {
        var _lowercasedKey = action.key;

        var _keysSoFar = "" + state.keysSoFar + _lowercasedKey;

        var itemIndex = getItemIndexByCharacterKey(_keysSoFar, state.selectedItem ? props.items.indexOf(state.selectedItem) : -1, props.items, props.itemToString, action.getItemNodeFromIndex);
        changes = (0,esm_extends/* default */.Z)({
          keysSoFar: _keysSoFar
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;

    case ToggleButtonKeyDownArrowDown:
      {
        changes = {
          isOpen: true,
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex)
        };
        break;
      }

    case ToggleButtonKeyDownArrowUp:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex)
      };
      break;

    case ToggleButtonClick:
    case FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    case FunctionClearKeysSoFar:
      changes = {
        keysSoFar: ''
      };
      break;

    case FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return (0,esm_extends/* default */.Z)({}, state, {}, changes);
}
/* eslint-enable complexity */

var validatePropTypes =  true ?
/* istanbul ignore next */
null : 0;
useSelect.stateChangeTypes = stateChangeTypes$1;

function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  /* istanbul ignore else */
  if (false) {} // Props defaults and destructuring.


  var props = (0,esm_extends/* default */.Z)({}, defaultProps, {}, userProps);

  var items = props.items,
      itemToString = props.itemToString,
      getA11yStatusMessage = props.getA11yStatusMessage,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment; // Initial state depending on controlled props.

  var initialState = getInitialState(props); // Reducer init.

  var _useEnhancedReducer = useEnhancedReducer(downshiftSelectReducer, initialState, props),
      _useEnhancedReducer$ = _useEnhancedReducer[0],
      isOpen = _useEnhancedReducer$.isOpen,
      highlightedIndex = _useEnhancedReducer$.highlightedIndex,
      selectedItem = _useEnhancedReducer$.selectedItem,
      keysSoFar = _useEnhancedReducer$.keysSoFar,
      dispatchWithoutProps = _useEnhancedReducer[1];

  var dispatch = function (action) {
    return dispatchWithoutProps((0,esm_extends/* default */.Z)({
      props: props
    }, action));
  }; // IDs generation.


  var _getElementIds = getElementIds(useId, props),
      labelId = _getElementIds.labelId,
      getItemId = _getElementIds.getItemId,
      menuId = _getElementIds.menuId,
      toggleButtonId = _getElementIds.toggleButtonId;
  /* Refs */


  var toggleButtonRef = (0,react.useRef)(null);
  var menuRef = (0,react.useRef)(null);
  var itemRefs = (0,react.useRef)();
  itemRefs.current = [];
  var isInitialMount = (0,react.useRef)(true);
  var shouldScroll = (0,react.useRef)(true);
  var clearTimeout = (0,react.useRef)(null);
  /* Effects */

  /* Sets a11y status message on changes in isOpen. */

  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11yStatusMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  /* Sets a11y status message on changes in selectedItem. */

  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11ySelectionMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  /* Sets cleanup for the keysSoFar after 500ms. */

  (0,react.useEffect)(function () {
    // init the clean function here as we need access to dispatch.
    if (isInitialMount.current) {
      clearTimeout.current = debounce(function (outerDispatch) {
        outerDispatch({
          type: FunctionClearKeysSoFar
        });
      }, 500);
    }

    if (!keysSoFar) {
      return;
    }

    clearTimeout.current(dispatch); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keysSoFar]);
  /* Controls the focus on the menu or the toggle button. */

  (0,react.useEffect)(function () {
    // Don't focus menu on first render.
    if (isInitialMount.current) {
      // Unless it was initialised as open.
      if (initialIsOpen || defaultIsOpen || isOpen) {
        menuRef.current.focus();
      }

      return;
    } // Focus menu on open.
    // istanbul ignore next


    if (isOpen) {
      menuRef.current.focus(); // Focus toggleButton on close.
    } else if (environment.document.activeElement === menuRef.current) {
      toggleButtonRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  /* Scroll on highlighted item if change comes from keyboard. */

  (0,react.useEffect)(function () {
    if (highlightedIndex < 0 || !isOpen || !itemRefs.current.length) {
      return;
    }

    if (shouldScroll.current === false) {
      shouldScroll.current = true;
    } else {
      scrollIntoView(itemRefs.current[highlightedIndex], menuRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  /* Make initial ref false. */

  (0,react.useEffect)(function () {
    isInitialMount.current = false;
  }, []);

  var getItemNodeFromIndex = function (index) {
    return itemRefs.current[index];
  };
  /* Event handler functions */


  var menuKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownArrowDown,
        shiftKey: event.shiftKey,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownArrowUp,
        shiftKey: event.shiftKey,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    Home: function Home(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownHome,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    End: function End(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownEnd,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    Escape: function Escape() {
      dispatch({
        type: MenuKeyDownEscape
      });
    },
    Enter: function Enter(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownEnter
      });
    },
    ' ': function _(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownSpaceButton
      });
    },
    Tab: function Tab(event) {
      // The exception that calls MenuBlur.
      // istanbul ignore next
      if (event.shiftKey) {
        dispatch({
          type: MenuBlur
        });
      }
    }
  };
  var toggleButtonKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: ToggleButtonKeyDownArrowDown,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: ToggleButtonKeyDownArrowUp,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    }
  }; // Event handlers.

  var menuHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && menuKeyDownHandlers[key]) {
      menuKeyDownHandlers[key](event);
    } else if (isAcceptedCharacterKey(key)) {
      dispatch({
        type: MenuKeyDownCharacter,
        key: key,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    }
  }; // Focus going back to the toggleButton is something we control (Escape, Enter, Click).
  // We are toggleing special actions for these cases in reducer, not MenuBlur.
  // Since Shift-Tab also lands focus on toggleButton, we will handle it as exception and call MenuBlur.


  var menuHandleBlur = function (event) {
    if (!focusLandsOnElement(event, toggleButtonRef.current)) {
      dispatch({
        type: MenuBlur
      });
    }
  };

  var menuHandleMouseLeave = function () {
    dispatch({
      type: MenuMouseLeave
    });
  };

  var toggleButtonHandleClick = function () {
    dispatch({
      type: ToggleButtonClick
    });
  };

  var toggleButtonHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && toggleButtonKeyDownHandlers[key]) {
      toggleButtonKeyDownHandlers[key](event);
    } else if (isAcceptedCharacterKey(key)) {
      dispatch({
        type: ToggleButtonKeyDownCharacter,
        key: key,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    }
  };

  var itemHandleMouseMove = function (index) {
    if (index === highlightedIndex) {
      return;
    }

    shouldScroll.current = false;
    dispatch({
      type: ItemMouseMove,
      index: index
    });
  };

  var itemHandleClick = function (index) {
    dispatch({
      type: ItemClick,
      index: index
    });
  }; // returns


  return {
    // prop getters.
    getToggleButtonProps: function getToggleButtonProps(_temp2) {
      var _extends3;

      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          onClick = _ref2.onClick,
          onKeyDown = _ref2.onKeyDown,
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          ref = _ref2.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["onClick", "onKeyDown", "refKey", "ref"]);

      var toggleProps = (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
        toggleButtonRef.current = toggleButtonNode;
      }), _extends3.id = toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = isOpen, _extends3['aria-labelledby'] = labelId + " " + toggleButtonId, _extends3), rest);

      if (!rest.disabled) {
        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
      }

      return toggleProps;
    },
    getLabelProps: function getLabelProps(labelProps) {
      return (0,esm_extends/* default */.Z)({
        id: labelId,
        htmlFor: toggleButtonId
      }, labelProps);
    },
    getMenuProps: function getMenuProps(_temp) {
      var _extends2;

      var _ref = _temp === void 0 ? {} : _temp,
          onKeyDown = _ref.onKeyDown,
          onBlur = _ref.onBlur,
          onMouseLeave = _ref.onMouseLeave,
          _ref$refKey = _ref.refKey,
          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
          ref = _ref.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onKeyDown", "onBlur", "onMouseLeave", "refKey", "ref"]);

      return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
        menuRef.current = menuNode;
      }), _extends2.id = menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = labelId, _extends2.tabIndex = -1, _extends2), highlightedIndex > -1 && {
        'aria-activedescendant': getItemId(highlightedIndex)
      }, {
        onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
        onBlur: callAllEventHandlers(onBlur, menuHandleBlur),
        onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave)
      }, rest);
    },
    getItemProps: function getItemProps(_temp3) {
      var _extends4;

      var _ref3 = _temp3 === void 0 ? {} : _temp3,
          item = _ref3.item,
          index = _ref3.index,
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          ref = _ref3.ref,
          onMouseMove = _ref3.onMouseMove,
          onClick = _ref3.onClick,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["item", "index", "refKey", "ref", "onMouseMove", "onClick"]);

      var itemIndex = getItemIndex(index, item, items);

      if (itemIndex < 0) {
        throw new Error('Pass either item or item index in getItemProps!');
      }

      var itemProps = (0,esm_extends/* default */.Z)((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (itemNode) {
        if (itemNode) {
          itemRefs.current.push(itemNode);
        }
      }), _extends4.role = 'option', _extends4['aria-selected'] = "" + (itemIndex === highlightedIndex), _extends4.id = getItemId(itemIndex), _extends4), rest);

      if (!rest.disabled) {
        itemProps.onMouseMove = callAllEventHandlers(onMouseMove, function () {
          return itemHandleMouseMove(itemIndex);
        });
        itemProps.onClick = callAllEventHandlers(onClick, function () {
          return itemHandleClick(itemIndex);
        });
      }

      return itemProps;
    },
    // actions.
    toggleMenu: function toggleMenu() {
      dispatch({
        type: FunctionToggleMenu
      });
    },
    openMenu: function openMenu() {
      dispatch({
        type: FunctionOpenMenu
      });
    },
    closeMenu: function closeMenu() {
      dispatch({
        type: FunctionCloseMenu
      });
    },
    setHighlightedIndex: function setHighlightedIndex(newHighlightedIndex) {
      dispatch({
        type: FunctionSetHighlightedIndex,
        highlightedIndex: newHighlightedIndex
      });
    },
    selectItem: function selectItem(newSelectedItem) {
      dispatch({
        type: FunctionSelectItem,
        selectedItem: newSelectedItem
      });
    },
    reset: function reset() {
      dispatch({
        type: FunctionReset
      });
    },
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem
  };
}

var defaultStateValues$2 = {
  inputValue: ''
};

function getElementIds$1(generateDefaultId, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      id = _ref.id,
      inputId = _ref.inputId,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["id", "inputId"]);

  var uniqueId = id === undefined ? "downshift-" + generateDefaultId() : id;
  return (0,esm_extends/* default */.Z)({
    inputId: inputId || uniqueId + "-input"
  }, getElementIds(generateDefaultId, (0,esm_extends/* default */.Z)({
    id: id
  }, rest)));
}

function getDefaultValue$2(props, propKey) {
  return getDefaultValue(props, propKey, defaultStateValues$2);
}

function getInitialValue$2(props, propKey) {
  return getInitialValue(props, propKey, defaultStateValues$2);
}

function getInitialState$1(props) {
  var selectedItem = getInitialValue$2(props, 'selectedItem');
  var isOpen = getInitialValue$2(props, 'isOpen');
  var highlightedIndex = getInitialValue$2(props, 'highlightedIndex');
  var inputValue = getInitialValue$2(props, 'inputValue');

  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }

  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var propTypes$1 = {
  items: (prop_types_default()).array.isRequired,
  itemToString: (prop_types_default()).func,
  getA11yStatusMessage: (prop_types_default()).func,
  getA11ySelectionMessage: (prop_types_default()).func,
  circularNavigation: (prop_types_default()).bool,
  highlightedIndex: (prop_types_default()).number,
  defaultHighlightedIndex: (prop_types_default()).number,
  initialHighlightedIndex: (prop_types_default()).number,
  isOpen: (prop_types_default()).bool,
  defaultIsOpen: (prop_types_default()).bool,
  initialIsOpen: (prop_types_default()).bool,
  selectedItem: (prop_types_default()).any,
  initialSelectedItem: (prop_types_default()).any,
  defaultSelectedItem: (prop_types_default()).any,
  inputValue: (prop_types_default()).string,
  defaultInputValue: (prop_types_default()).string,
  initialInputValue: (prop_types_default()).string,
  id: (prop_types_default()).string,
  labelId: (prop_types_default()).string,
  menuId: (prop_types_default()).string,
  getItemId: (prop_types_default()).func,
  inputId: (prop_types_default()).string,
  toggleButtonId: (prop_types_default()).string,
  stateReducer: (prop_types_default()).func,
  onSelectedItemChange: (prop_types_default()).func,
  onHighlightedIndexChange: (prop_types_default()).func,
  onStateChange: (prop_types_default()).func,
  onIsOpenChange: (prop_types_default()).func,
  onInputValueChange: (prop_types_default()).func,
  environment: prop_types_default().shape({
    addEventListener: (prop_types_default()).func,
    removeEventListener: (prop_types_default()).func,
    document: prop_types_default().shape({
      getElementById: (prop_types_default()).func,
      activeElement: (prop_types_default()).any,
      body: (prop_types_default()).any
    })
  })
};

var defaultProps$1 = (0,esm_extends/* default */.Z)({}, defaultProps, {
  circularNavigation: true
});

var InputKeyDownArrowDown =  false ? 0 : 0;
var InputKeyDownArrowUp =  false ? 0 : 1;
var InputKeyDownEscape =  false ? 0 : 2;
var InputKeyDownHome =  false ? 0 : 3;
var InputKeyDownEnd =  false ? 0 : 4;
var InputKeyDownEnter =  false ? 0 : 5;
var InputChange =  false ? 0 : 6;
var InputBlur =  false ? 0 : 7;
var MenuMouseLeave$1 =  false ? 0 : 8;
var ItemMouseMove$1 =  false ? 0 : 9;
var ItemClick$1 =  false ? 0 : 10;
var ToggleButtonClick$1 =  false ? 0 : 11;
var FunctionToggleMenu$1 =  false ? 0 : 12;
var FunctionOpenMenu$1 =  false ? 0 : 13;
var FunctionCloseMenu$1 =  false ? 0 : 14;
var FunctionSetHighlightedIndex$1 =  false ? 0 : 15;
var FunctionSelectItem$1 =  false ? 0 : 16;
var FunctionSetInputValue =  false ? 0 : 17;
var FunctionReset$1 =  false ? 0 : 18;

var stateChangeTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownEnter: InputKeyDownEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  ToggleButtonClick: ToggleButtonClick$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset$1
});

/* eslint-disable complexity */

function downshiftUseComboboxReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemMouseMove$1:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$2(props, 'isOpen'),
        highlightedIndex: getDefaultValue$2(props, 'highlightedIndex'),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;

    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: true
        };
      }

      break;

    case InputKeyDownArrowUp:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: true
        };
      }

      break;

    case InputKeyDownEnter:
      changes = (0,esm_extends/* default */.Z)({}, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue$2(props, 'isOpen'),
        highlightedIndex: getDefaultValue$2(props, 'highlightedIndex'),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;

    case InputKeyDownEscape:
      changes = {
        isOpen: false,
        selectedItem: null,
        highlightedIndex: -1,
        inputValue: ''
      };
      break;

    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputBlur:
      changes = (0,esm_extends/* default */.Z)({
        isOpen: false
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex]),
        highlightedIndex: -1
      });
      break;

    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue$2(props, 'highlightedIndex'),
        inputValue: action.inputValue
      };
      break;

    case MenuMouseLeave$1:
      changes = {
        highlightedIndex: -1
      };
      break;

    case ToggleButtonClick$1:
    case FunctionToggleMenu$1:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionOpenMenu$1:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionCloseMenu$1:
      changes = {
        isOpen: false
      };
      break;

    case FunctionSetHighlightedIndex$1:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    case FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;

    case FunctionReset$1:
      changes = {
        highlightedIndex: getDefaultValue$2(props, 'highlightedIndex'),
        isOpen: getDefaultValue$2(props, 'isOpen'),
        selectedItem: getDefaultValue$2(props, 'selectedItem'),
        inputValue: getDefaultValue$2(props, 'inputValue')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return (0,esm_extends/* default */.Z)({}, state, {}, changes);
}
/* eslint-enable complexity */

var validatePropTypes$1 =  true ?
/* istanbul ignore next */
null : 0;
useCombobox.stateChangeTypes = stateChangeTypes$2;

function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  /* istanbul ignore else */
  if (false) {} // Props defaults and destructuring.


  var props = (0,esm_extends/* default */.Z)({}, defaultProps$1, {}, userProps);

  var initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      items = props.items,
      scrollIntoView = props.scrollIntoView,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      getA11yStatusMessage = props.getA11yStatusMessage,
      itemToString = props.itemToString,
      environment = props.environment; // Initial state depending on controlled props.

  var initialState = getInitialState$1(props); // Reducer init.

  var _useEnhancedReducer = useEnhancedReducer(downshiftUseComboboxReducer, initialState, props),
      _useEnhancedReducer$ = _useEnhancedReducer[0],
      isOpen = _useEnhancedReducer$.isOpen,
      highlightedIndex = _useEnhancedReducer$.highlightedIndex,
      selectedItem = _useEnhancedReducer$.selectedItem,
      inputValue = _useEnhancedReducer$.inputValue,
      dispatchWithoutProps = _useEnhancedReducer[1];

  var dispatch = function (action) {
    return dispatchWithoutProps((0,esm_extends/* default */.Z)({
      props: props
    }, action));
  }; // IDs generation.


  var _getElementIds = getElementIds$1(useId, props),
      labelId = _getElementIds.labelId,
      getItemId = _getElementIds.getItemId,
      menuId = _getElementIds.menuId,
      toggleButtonId = _getElementIds.toggleButtonId,
      inputId = _getElementIds.inputId;
  /* Refs */


  var menuRef = (0,react.useRef)(null);
  var itemRefs = (0,react.useRef)();
  var inputRef = (0,react.useRef)(null);
  var toggleButtonRef = (0,react.useRef)(null);
  var comboboxRef = (0,react.useRef)(null);
  itemRefs.current = [];
  var shouldScroll = (0,react.useRef)(true);
  var isInitialMount = (0,react.useRef)(true);
  var mouseAndTouchTrackers = (0,react.useRef)({
    isMouseDown: false,
    isTouchMove: false
  });
  /* Effects */

  /* Sets a11y status message on changes in isOpen. */

  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11yStatusMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString,
      inputValue: inputValue
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  /* Sets a11y status message on changes in selectedItem. */

  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11ySelectionMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString,
      inputValue: inputValue
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  /* Scroll on highlighted item if change comes from keyboard. */

  (0,react.useEffect)(function () {
    if (highlightedIndex < 0 || !isOpen || !itemRefs.current.length) {
      return;
    }

    if (shouldScroll.current === false) {
      shouldScroll.current = true;
    } else {
      scrollIntoView(itemRefs.current[highlightedIndex], menuRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  /* Controls the focus on the menu or the toggle button. */

  (0,react.useEffect)(function () {
    // Don't focus menu on first render.
    if (isInitialMount.current) {
      // Unless it was initialised as open.
      if (initialIsOpen || defaultIsOpen || isOpen) {
        inputRef.current.focus();
      }

      return;
    } // Focus menu on open.
    // istanbul ignore next


    if (isOpen) {
      inputRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  /* Make initial ref false. */

  (0,react.useEffect)(function () {
    isInitialMount.current = false;
  }, []);
  /* Add mouse/touch events to document. */

  (0,react.useEffect)(function () {
    // The same strategy for checking if a click occurred inside or outside downsift
    // as in downshift.js.
    var onMouseDown = function () {
      mouseAndTouchTrackers.current.isMouseDown = true;
    };

    var onMouseUp = function (event) {
      mouseAndTouchTrackers.current.isMouseDown = false;

      if (isOpen && !targetWithinDownshift(event.target, comboboxRef.current, menuRef.current, environment.document)) {
        dispatch({
          type: InputBlur
        });
      }
    };

    var onTouchStart = function () {
      mouseAndTouchTrackers.current.isTouchMove = false;
    };

    var onTouchMove = function () {
      mouseAndTouchTrackers.current.isTouchMove = true;
    };

    var onTouchEnd = function (event) {
      if (isOpen && !mouseAndTouchTrackers.current.isTouchMove && !targetWithinDownshift(event.target, comboboxRef.current, menuRef.current, environment.document, false)) {
        dispatch({
          type: InputBlur
        });
      }
    };

    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function () {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    };
  });

  var getItemNodeFromIndex = function (index) {
    return itemRefs.current[index];
  };
  /* Event handler functions */


  var inputKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: InputKeyDownArrowDown,
        shiftKey: event.shiftKey,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: InputKeyDownArrowUp,
        shiftKey: event.shiftKey,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    Home: function Home(event) {
      event.preventDefault();
      dispatch({
        type: InputKeyDownHome,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    End: function End(event) {
      event.preventDefault();
      dispatch({
        type: InputKeyDownEnd,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    },
    Escape: function Escape() {
      dispatch({
        type: InputKeyDownEscape
      });
    },
    Enter: function Enter(event) {
      event.preventDefault();
      dispatch({
        type: InputKeyDownEnter,
        getItemNodeFromIndex: getItemNodeFromIndex
      });
    }
  }; // Event handlers.

  var inputHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && inputKeyDownHandlers[key]) {
      inputKeyDownHandlers[key](event);
    }
  };

  var inputHandleChange = function (event) {
    dispatch({
      type: InputChange,
      inputValue: event.target.value
    });
  };

  var inputHandleBlur = function (event) {
    var shouldBlur = !(mouseAndTouchTrackers.current.isMouseDown || focusLandsOnElement(event, toggleButtonRef.current));
    /* istanbul ignore else */

    if (shouldBlur) {
      dispatch({
        type: InputBlur
      });
    }
  };

  var menuHandleMouseLeave = function () {
    dispatch({
      type: MenuMouseLeave$1
    });
  };

  var itemHandleMouseMove = function (index) {
    if (index === highlightedIndex) {
      return;
    }

    shouldScroll.current = false;
    dispatch({
      type: ItemMouseMove$1,
      index: index
    });
  };

  var itemHandleClick = function (index) {
    dispatch({
      type: ItemClick$1,
      index: index
    });
  };

  var toggleButtonHandleClick = function () {
    dispatch({
      type: ToggleButtonClick$1
    });
  }; // returns


  return {
    // prop getters.
    getItemProps: function getItemProps(_temp2) {
      var _extends3, _ref3;

      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          item = _ref2.item,
          index = _ref2.index,
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          ref = _ref2.ref,
          onMouseMove = _ref2.onMouseMove,
          onClick = _ref2.onClick,
          onPress = _ref2.onPress,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"]);

      var itemIndex = getItemIndex(index, item, items);

      if (itemIndex < 0) {
        throw new Error('Pass either item or item index in getItemProps!');
      }

      var onSelectKey = 'onClick';
      var customClickHandler = onClick;
      return (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
        if (itemNode) {
          itemRefs.current.push(itemNode);
        }
      }), _extends3.role = 'option', _extends3['aria-selected'] = "" + (itemIndex === highlightedIndex), _extends3.id = getItemId(itemIndex), _extends3), !rest.disabled && (_ref3 = {
        onMouseMove: callAllEventHandlers(onMouseMove, function () {
          itemHandleMouseMove(itemIndex);
        })
      }, _ref3[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
        itemHandleClick(itemIndex);
      }), _ref3), {}, rest);
    },
    getLabelProps: function getLabelProps(labelProps) {
      return (0,esm_extends/* default */.Z)({
        id: labelId,
        htmlFor: inputId
      }, labelProps);
    },
    getMenuProps: function getMenuProps(_temp) {
      var _extends2;

      var _ref = _temp === void 0 ? {} : _temp,
          onMouseLeave = _ref.onMouseLeave,
          _ref$refKey = _ref.refKey,
          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
          ref = _ref.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onMouseLeave", "refKey", "ref"]);

      return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
        menuRef.current = menuNode;
      }), _extends2.id = menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
    },
    getInputProps: function getInputProps(_temp4) {
      var _extends5;

      var _ref5 = _temp4 === void 0 ? {} : _temp4,
          onKeyDown = _ref5.onKeyDown,
          onChange = _ref5.onChange,
          onInput = _ref5.onInput,
          onBlur = _ref5.onBlur,
          onChangeText = _ref5.onChangeText,
          _ref5$refKey = _ref5.refKey,
          refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
          ref = _ref5.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref5, ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"]);

      /* istanbul ignore next (preact) */
      var onChangeKey = 'onChange';
      var eventHandlers = {};

      if (!rest.disabled) {
        var _eventHandlers;

        eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers);
      }
      /* istanbul ignore if (react-native) */


      return (0,esm_extends/* default */.Z)((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
        inputRef.current = inputNode;
      }), _extends5.id = inputId, _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = menuId, _extends5), highlightedIndex > -1 && {
        'aria-activedescendant': getItemId(highlightedIndex)
      }, {
        'aria-labelledby': labelId,
        // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
        // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
        autoComplete: 'off',
        value: inputValue
      }, eventHandlers, {}, rest);
    },
    getComboboxProps: function getComboboxProps(_temp5) {
      var _extends6;

      var _ref6 = _temp5 === void 0 ? {} : _temp5,
          _ref6$refKey = _ref6.refKey,
          refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
          ref = _ref6.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref6, ["refKey", "ref"]);

      return (0,esm_extends/* default */.Z)((_extends6 = {}, _extends6[refKey] = handleRefs(ref, function (comboboxNode) {
        comboboxRef.current = comboboxNode;
      }), _extends6.role = 'combobox', _extends6['aria-haspopup'] = 'listbox', _extends6['aria-owns'] = menuId, _extends6['aria-expanded'] = isOpen, _extends6), rest);
    },
    getToggleButtonProps: function getToggleButtonProps(_temp3) {
      var _extends4;

      var _ref4 = _temp3 === void 0 ? {} : _temp3,
          onClick = _ref4.onClick,
          onPress = _ref4.onPress,
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          ref = _ref4.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["onClick", "onPress", "refKey", "ref"]);

      return (0,esm_extends/* default */.Z)((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
        toggleButtonRef.current = toggleButtonNode;
      }), _extends4.id = toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && (0,esm_extends/* default */.Z)({}, {
        onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
      }), {}, rest);
    },
    // actions.
    toggleMenu: function toggleMenu() {
      dispatch({
        type: FunctionToggleMenu$1
      });
    },
    openMenu: function openMenu() {
      dispatch({
        type: FunctionOpenMenu$1
      });
    },
    closeMenu: function closeMenu() {
      dispatch({
        type: FunctionCloseMenu$1
      });
    },
    setHighlightedIndex: function setHighlightedIndex(newHighlightedIndex) {
      dispatch({
        type: FunctionSetHighlightedIndex$1,
        highlightedIndex: newHighlightedIndex
      });
    },
    setInputValue: function setInputValue(newInputValue) {
      dispatch({
        type: FunctionSetInputValue,
        inputValue: newInputValue
      });
    },
    selectItem: function selectItem(newSelectedItem) {
      dispatch({
        type: FunctionSelectItem$1,
        selectedItem: newSelectedItem
      });
    },
    reset: function reset() {
      dispatch({
        type: FunctionReset$1
      });
    },
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

/* harmony default export */ var downshift_esm = (Downshift);



/***/ }),

/***/ 96349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ThemeProvider": function() { return /* binding */ ThemeProvider; },
  "useTheme": function() { return /* binding */ useTheme; },
  "withTheme": function() { return /* binding */ withTheme; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(4079);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js + 5 modules
var core_browser_esm = __webpack_require__(98464);
;// CONCATENATED MODULE: ../../node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ var weak_memoize_browser_esm = (weakMemoize);

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(61393);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(83138);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/emotion-theming/dist/emotion-theming.browser.esm.js







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _objectSpread({}, outerTheme, {}, theme);
};

var createCacheWithTheme = weak_memoize_browser_esm(function (outerTheme) {
  return weak_memoize_browser_esm(function (theme) {
    return getTheme(outerTheme, theme);
  });
});

var ThemeProvider = function ThemeProvider(props) {
  return /*#__PURE__*/(0,react.createElement)(core_browser_esm.ThemeContext.Consumer, null, function (theme) {
    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return /*#__PURE__*/(0,react.createElement)(core_browser_esm.ThemeContext.Provider, {
      value: theme
    }, props.children);
  });
};

// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(core_browser_esm.ThemeContext.Consumer, null, function (theme) {
      return /*#__PURE__*/(0,react.createElement)(Component, (0,esm_extends/* default */.Z)({
        theme: theme,
        ref: ref
      }, props));
    });
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/(0,react.forwardRef)(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoist_non_react_statics_cjs_default()(WithTheme, Component);
}

function useTheme() {
  return react.useContext(core_browser_esm.ThemeContext);
}




/***/ }),

/***/ 32953:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 38060:
/***/ (function(module) {

module.exports = stringify
stringify.default = stringify
stringify.stable = deterministicStringify
stringify.stableStringify = deterministicStringify

var LIMIT_REPLACE_NODE = '[...]'
var CIRCULAR_REPLACE_NODE = '[Circular]'

var arr = []
var replacerStack = []

function defaultOptions () {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  }
}

// Regular stringify
function stringify (obj, replacer, spacer, options) {
  if (typeof options === 'undefined') {
    options = defaultOptions()
  }

  decirc(obj, '', 0, [], undefined, 0, options)
  var res
  try {
    if (replacerStack.length === 0) {
      res = JSON.stringify(obj, replacer, spacer)
    } else {
      res = JSON.stringify(obj, replaceGetterValues(replacer), spacer)
    }
  } catch (_) {
    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
  } finally {
    while (arr.length !== 0) {
      var part = arr.pop()
      if (part.length === 4) {
        Object.defineProperty(part[0], part[1], part[3])
      } else {
        part[0][part[1]] = part[2]
      }
    }
  }
  return res
}

function setReplace (replace, val, k, parent) {
  var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k)
  if (propertyDescriptor.get !== undefined) {
    if (propertyDescriptor.configurable) {
      Object.defineProperty(parent, k, { value: replace })
      arr.push([parent, k, val, propertyDescriptor])
    } else {
      replacerStack.push([val, k, replace])
    }
  } else {
    parent[k] = replace
    arr.push([parent, k, val])
  }
}

function decirc (val, k, edgeIndex, stack, parent, depth, options) {
  depth += 1
  var i
  if (typeof val === 'object' && val !== null) {
    for (i = 0; i < stack.length; i++) {
      if (stack[i] === val) {
        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent)
        return
      }
    }

    if (
      typeof options.depthLimit !== 'undefined' &&
      depth > options.depthLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    if (
      typeof options.edgesLimit !== 'undefined' &&
      edgeIndex + 1 > options.edgesLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    stack.push(val)
    // Optimize for Arrays. Big arrays could kill the performance otherwise!
    if (Array.isArray(val)) {
      for (i = 0; i < val.length; i++) {
        decirc(val[i], i, i, stack, val, depth, options)
      }
    } else {
      var keys = Object.keys(val)
      for (i = 0; i < keys.length; i++) {
        var key = keys[i]
        decirc(val[key], key, i, stack, val, depth, options)
      }
    }
    stack.pop()
  }
}

// Stable-stringify
function compareFunction (a, b) {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

function deterministicStringify (obj, replacer, spacer, options) {
  if (typeof options === 'undefined') {
    options = defaultOptions()
  }

  var tmp = deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj
  var res
  try {
    if (replacerStack.length === 0) {
      res = JSON.stringify(tmp, replacer, spacer)
    } else {
      res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer)
    }
  } catch (_) {
    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
  } finally {
    // Ensure that we restore the object as it was.
    while (arr.length !== 0) {
      var part = arr.pop()
      if (part.length === 4) {
        Object.defineProperty(part[0], part[1], part[3])
      } else {
        part[0][part[1]] = part[2]
      }
    }
  }
  return res
}

function deterministicDecirc (val, k, edgeIndex, stack, parent, depth, options) {
  depth += 1
  var i
  if (typeof val === 'object' && val !== null) {
    for (i = 0; i < stack.length; i++) {
      if (stack[i] === val) {
        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent)
        return
      }
    }
    try {
      if (typeof val.toJSON === 'function') {
        return
      }
    } catch (_) {
      return
    }

    if (
      typeof options.depthLimit !== 'undefined' &&
      depth > options.depthLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    if (
      typeof options.edgesLimit !== 'undefined' &&
      edgeIndex + 1 > options.edgesLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    stack.push(val)
    // Optimize for Arrays. Big arrays could kill the performance otherwise!
    if (Array.isArray(val)) {
      for (i = 0; i < val.length; i++) {
        deterministicDecirc(val[i], i, i, stack, val, depth, options)
      }
    } else {
      // Create a temporary object in the required way
      var tmp = {}
      var keys = Object.keys(val).sort(compareFunction)
      for (i = 0; i < keys.length; i++) {
        var key = keys[i]
        deterministicDecirc(val[key], key, i, stack, val, depth, options)
        tmp[key] = val[key]
      }
      if (typeof parent !== 'undefined') {
        arr.push([parent, k, val])
        parent[k] = tmp
      } else {
        return tmp
      }
    }
    stack.pop()
  }
}

// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues (replacer) {
  replacer =
    typeof replacer !== 'undefined'
      ? replacer
      : function (k, v) {
        return v
      }
  return function (key, val) {
    if (replacerStack.length > 0) {
      for (var i = 0; i < replacerStack.length; i++) {
        var part = replacerStack[i]
        if (part[1] === key && part[0] === val) {
          val = part[2]
          replacerStack.splice(i, 1)
          break
        }
      }
    }
    return replacer.call(this, key, val)
  }
}


/***/ }),

/***/ 83138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(72621);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 88482:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 93074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Cookies = __webpack_require__(994);
// we seem to sometimes get the ES6 version despite requesting cjs here, not sure why
// this isn't the ideal fix, but it'll do for now
Cookies = Cookies.default || Cookies;

function nextCookies(ctx, options) {
  // Note: Next.js Static export sets ctx.req to a fake request with no headers
  var header = ctx.req && ctx.req.headers && ctx.req.headers.cookie;
  var uc = new Cookies(header);
  return uc.getAll(options);
}

module.exports = nextCookies;


/***/ }),

/***/ 9122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34885);

/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    t: function (k) { return (Array.isArray(k) ? k[0] : k); },
    lang: '',
}));


/***/ }),

/***/ 33872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/wrapTWithDefaultNs.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function wrapTWithDefaultNs(oldT, ns) {
    if (typeof ns !== 'string')
        return oldT;
    var t = function (key, query, options) {
        return oldT(key, query, __assign({ ns: ns }, options));
    };
    return t;
}

// EXTERNAL MODULE: ../../node_modules/next-translate/lib/esm/_context.js
var _context = __webpack_require__(9122);
;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/useTranslation.js
var useTranslation_assign = (undefined && undefined.__assign) || function () {
    useTranslation_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useTranslation_assign.apply(this, arguments);
};



function useTranslation(defaultNS) {
    var ctx = (0,react.useContext)(_context/* default */.Z);
    return (0,react.useMemo)(function () { return (useTranslation_assign(useTranslation_assign({}, ctx), { t: wrapTWithDefaultNs(ctx.t, defaultNS) })); }, [ctx, defaultNS]);
}


/***/ }),

/***/ 69009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(59445)


/***/ }),

/***/ 12836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(52803)


/***/ }),

/***/ 11225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2545)


/***/ }),

/***/ 83136:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75250)


/***/ }),

/***/ 77005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19337)


/***/ }),

/***/ 48347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(62469),g=__webpack_require__(34885);
exports.useSubscription=function(a){var c=a.getCurrentValue,d=a.subscribe,b=g.useState(function(){return{getCurrentValue:c,subscribe:d,value:c()}});a=b[0];var f=b[1];b=a.value;if(a.getCurrentValue!==c||a.subscribe!==d)b=c(),f({getCurrentValue:c,subscribe:d,value:b});g.useDebugValue(b);g.useEffect(function(){function b(){if(!a){var b=c();f(function(a){return a.getCurrentValue!==c||a.subscribe!==d||a.value===b?a:e({},a,{value:b})})}}var a=!1,h=d(b);b();return function(){a=!0;h()}},[c,d]);return b};


/***/ }),

/***/ 26362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(48347);
} else {}


/***/ }),

/***/ 53746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(84361)


/***/ }),

/***/ 10154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var pathToRegexp = __webpack_require__(33380);
var createError = __webpack_require__(34911);

module.exports = function (options) {
  options = options || {};

  return function (path) {
    var keys = [];
    var re = pathToRegexp(path, keys, options);

    return function (pathname, params) {
      var m = re.exec(pathname);
      if (!m) return false;

      params = params || {};

      var key, param;
      for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        param = m[i + 1];
        if (!param) continue;
        params[key.name] = decodeParam(param);
        if (key.repeat) params[key.name] = params[key.name].split(key.delimiter)
      }

      return params;
    }
  }
}

function decodeParam(param) {
  try {
    return decodeURIComponent(param);
  } catch (_) {
    throw createError(400, 'failed to decode param "' + param + '"');
  }
}


/***/ }),

/***/ 34911:
/***/ (function(module, exports, __webpack_require__) {


var statuses = __webpack_require__(44529);
var inherits = __webpack_require__(63790);

function toIdentifier(str) {
  return str.split(' ').map(function (token) {
    return token.slice(0, 1).toUpperCase() + token.slice(1)
  }).join('').replace(/[^ _0-9a-z]/gi, '')
}

exports = module.exports = function httpError() {
  // so much arity going on ~_~
  var err;
  var msg;
  var status = 500;
  var props = {};
  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    if (arg instanceof Error) {
      err = arg;
      status = err.status || err.statusCode || status;
      continue;
    }
    switch (typeof arg) {
      case 'string':
        msg = arg;
        break;
      case 'number':
        status = arg;
        break;
      case 'object':
        props = arg;
        break;
    }
  }

  if (typeof status !== 'number' || !statuses[status]) {
    status = 500
  }

  // constructor
  var HttpError = exports[status]

  if (!err) {
    // create error
    err = HttpError
      ? new HttpError(msg)
      : new Error(msg || statuses[status])
    Error.captureStackTrace(err, httpError)
  }

  if (!HttpError || !(err instanceof HttpError)) {
    // add properties to generic error
    err.expose = status < 500
    err.status = err.statusCode = status
  }

  for (var key in props) {
    if (key !== 'status' && key !== 'statusCode') {
      err[key] = props[key]
    }
  }

  return err;
};

var HttpError = exports.HttpError = function HttpError() {
  throw new TypeError('cannot construct abstract class');
};

inherits(HttpError, Error);

// create generic error objects
var codes = statuses.codes.filter(function (num) {
  return num >= 400;
});

codes.forEach(function (code) {
  var name = toIdentifier(statuses[code])
  var className = name.match(/Error$/) ? name : name + 'Error'

  if (code >= 500) {
    var ServerError = function ServerError(msg) {
      var self = new Error(msg != null ? msg : statuses[code])
      Error.captureStackTrace(self, ServerError)
      self.__proto__ = ServerError.prototype
      Object.defineProperty(self, 'name', {
        enumerable: false,
        configurable: true,
        value: className,
        writable: true
      })
      return self
    }
    inherits(ServerError, HttpError);
    ServerError.prototype.status =
    ServerError.prototype.statusCode = code;
    ServerError.prototype.expose = false;
    exports[code] =
    exports[name] = ServerError
    return;
  }

  var ClientError = function ClientError(msg) {
    var self = new Error(msg != null ? msg : statuses[code])
    Error.captureStackTrace(self, ClientError)
    self.__proto__ = ClientError.prototype
    Object.defineProperty(self, 'name', {
      enumerable: false,
      configurable: true,
      value: className,
      writable: true
    })
    return self
  }
  inherits(ClientError, HttpError);
  ClientError.prototype.status =
  ClientError.prototype.statusCode = code;
  ClientError.prototype.expose = true;
  exports[code] =
  exports[name] = ClientError
  return;
});

// backwards-compatibility
exports["I'mateapot"] = exports.ImATeapot


/***/ }),

/***/ 63790:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 1166:
/***/ (function(module) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 33380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isarray = __webpack_require__(1166)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),

/***/ 44529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * statuses
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var codes = __webpack_require__(14124)

/**
 * Module exports.
 * @public
 */

module.exports = status

// status code to message map
status.STATUS_CODES = codes

// array of status codes
status.codes = populateStatusesMap(status, codes)

// status codes for redirects
status.redirect = {
  300: true,
  301: true,
  302: true,
  303: true,
  305: true,
  307: true,
  308: true
}

// status codes for empty bodies
status.empty = {
  204: true,
  205: true,
  304: true
}

// status codes for when you should retry the request
status.retry = {
  502: true,
  503: true,
  504: true
}

/**
 * Populate the statuses map for given codes.
 * @private
 */

function populateStatusesMap (statuses, codes) {
  var arr = []

  Object.keys(codes).forEach(function forEachCode (code) {
    var message = codes[code]
    var status = Number(code)

    // Populate properties
    statuses[status] = message
    statuses[message] = status
    statuses[message.toLowerCase()] = status

    // Add to array
    arr.push(status)
  })

  return arr
}

/**
 * Get the status code.
 *
 * Given a number, this will throw if it is not a known status
 * code, otherwise the code will be returned. Given a string,
 * the string will be parsed for a number and return the code
 * if valid, otherwise will lookup the code assuming this is
 * the status message.
 *
 * @param {string|number} code
 * @returns {number}
 * @public
 */

function status (code) {
  if (typeof code === 'number') {
    if (!status[code]) throw new Error('invalid status code: ' + code)
    return code
  }

  if (typeof code !== 'string') {
    throw new TypeError('code must be a number or string')
  }

  // '403'
  var n = parseInt(code, 10)
  if (!isNaN(n)) {
    if (!status[n]) throw new Error('invalid status code: ' + n)
    return n
  }

  n = status[code.toLowerCase()]
  if (!n) throw new Error('invalid status message: "' + code + '"')
  return n
}


/***/ }),

/***/ 24842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map


/***/ }),

/***/ 11329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(85165)):0}("undefined"!=typeof self?self:this,function(t){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=20)}([function(t,e,n){"use strict";e.a=function(t){var e=this.constructor;return this.then(function(n){return e.resolve(t()).then(function(){return n})},function(n){return e.resolve(t()).then(function(){return e.reject(n)})})}},function(t,e,n){"use strict";e.__esModule=!0,e.createPreviewResolver=function(t,e,n){return{token:t,documentId:e,resolve:function(r,o,i){return e&&n?n(e,{ref:t}).then(function(t){if(t){var e=r(t);return i&&i(null,e),e}return i&&i(null,o),o}):Promise.resolve(o)}}}},function(t,e,n){"use strict";var r=this&&this.__assign||Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t};e.__esModule=!0;var o=n(5),i=n(4),u=n(6),a=n(12),s=n(1);e.PREVIEW_COOKIE="io.prismic.preview",e.EXPERIMENT_COOKIE="io.prismic.experiment";var f=function(){function t(t,e,n){this.data=t,this.masterRef=t.refs.filter(function(t){return t.isMasterRef})[0],this.experiments=new o.Experiments(t.experiments),this.bookmarks=t.bookmarks,this.httpClient=e,this.options=n,this.refs=t.refs,this.tags=t.tags,this.types=t.types,this.languages=t.languages}return t.prototype.form=function(t){var e=this.data.forms[t];return e?new i.SearchForm(e,this.httpClient):null},t.prototype.everything=function(){var t=this.form("everything");if(!t)throw new Error("Missing everything form");return t},t.prototype.master=function(){return this.masterRef.ref},t.prototype.ref=function(t){var e=this.data.refs.filter(function(e){return e.label===t})[0];return e?e.ref:null},t.prototype.currentExperiment=function(){return this.experiments.current()},t.prototype.query=function(t,n,r){void 0===r&&(r=function(){});var o="function"==typeof n?{options:{},callback:n}:{options:n||{},callback:r},i=o.options,u=o.callback,s=this.everything();for(var f in i)s=s.set(f,i[f]);if(!i.ref){var c="";this.options.req?c=this.options.req.headers.cookie||"":"undefined"!=typeof window&&window.document&&(c=window.document.cookie||"");var l=a.default.parse(c),p=l[e.PREVIEW_COOKIE],h=this.experiments.refFromCookie(l[e.EXPERIMENT_COOKIE]);s=s.ref(p||h||this.masterRef.ref)}return t&&s.query(t),s.submit(u)},t.prototype.queryFirst=function(t,e,n){var o="function"==typeof e?{options:{},callback:e}:{options:r({},e)||{},callback:n||function(){}},i=o.options,u=o.callback;return i.page=1,i.pageSize=1,this.query(t,i).then(function(t){var e=t&&t.results&&t.results[0];return u(null,e),e}).catch(function(t){throw u(t),t})},t.prototype.getByID=function(t,e,n){var o=e?r({},e):{};return o.lang||(o.lang="*"),this.queryFirst(u.default.at("document.id",t),o,n)},t.prototype.getByIDs=function(t,e,n){var o=e?r({},e):{};return o.lang||(o.lang="*"),this.query(u.default.in("document.id",t),o,n)},t.prototype.getByUID=function(t,e,n,o){var i=n?r({},n):{};if("*"===i.lang)throw new Error("FORDIDDEN. You can't use getByUID with *, use the predicates instead.");return i.page||(i.page=1),this.queryFirst(u.default.at("my."+t+".uid",e),i,o)},t.prototype.getSingle=function(t,e,n){var o=e?r({},e):{};return this.queryFirst(u.default.at("document.type",t),o,n)},t.prototype.getBookmark=function(t,e,n){var r=this.data.bookmarks[t];return r?this.getByID(r,e,n):Promise.reject("Error retrieving bookmarked id")},t.prototype.getPreviewResolver=function(t,e){return s.createPreviewResolver(t,e,this.getByID.bind(this))},t.prototype.previewSession=function(t,e,n,r){var o=this;return console.warn("previewSession function is deprecated in favor of getPreviewResolver function."),new Promise(function(i,u){o.httpClient.request(t,function(a,s){if(a)r&&r(a),u(a);else if(s){if(s.mainDocument)return o.getByID(s.mainDocument,{ref:t}).then(function(t){if(t){var o=e(t);r&&r(null,o),i(o)}else r&&r(null,n),i(n)}).catch(u);r&&r(null,n),i(n)}})})},t}();e.default=f},function(t,e,n){"use strict";e.__esModule=!0;var r=n(2),o=n(11);function i(t){return t.indexOf("?")>-1?"&":"?"}var u=function(){function t(t,e){if(this.options=e||{},this.url=t,this.options.accessToken){var n="access_token="+this.options.accessToken;this.url+=i(t)+n}this.options.routes&&(this.url+=i(t)+"routes="+encodeURIComponent(JSON.stringify(this.options.routes))),this.apiDataTTL=this.options.apiDataTTL||5,this.httpClient=new o.default(this.options.requestHandler,this.options.apiCache,this.options.proxyAgent,this.options.timeoutInMs)}return t.prototype.get=function(t){var e=this;return this.httpClient.cachedRequest(this.url,{ttl:this.apiDataTTL}).then(function(n){var o=new r.default(n,e.httpClient,e.options);return t&&t(null,o),o}).catch(function(e){throw t&&t(e),e})},t}();e.default=u},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t,e){this.id=t,this.api=e,this.fields={}}return t.prototype.set=function(t,e){return this.fields[t]=e,this},t.prototype.ref=function(t){return this.set("ref",t)},t.prototype.query=function(t){return this.set("q",t)},t.prototype.pageSize=function(t){return this.set("pageSize",t)},t.prototype.fetch=function(t){return console.warn("Warning: Using Fetch is deprecated. Use the property `graphQuery` instead."),this.set("fetch",t)},t.prototype.fetchLinks=function(t){return console.warn("Warning: Using FetchLinks is deprecated. Use the property `graphQuery` instead."),this.set("fetchLinks",t)},t.prototype.graphQuery=function(t){return this.set("graphQuery",t)},t.prototype.lang=function(t){return this.set("lang",t)},t.prototype.page=function(t){return this.set("page",t)},t.prototype.after=function(t){return this.set("after",t)},t.prototype.orderings=function(t){return this.set("orderings",t)},t.prototype.url=function(){var e=this;return this.api.get().then(function(n){return t.toSearchForm(e,n).url()})},t.prototype.submit=function(e){var n=this;return this.api.get().then(function(r){return t.toSearchForm(n,r).submit(e)})},t.toSearchForm=function(t,e){var n=e.form(t.id);if(n)return Object.keys(t.fields).reduce(function(e,n){var r=t.fields[n];return"q"===n?e.query(r):"pageSize"===n?e.pageSize(r):"fetch"===n?e.fetch(r):"fetchLinks"===n?e.fetchLinks(r):"graphQuery"===n?e.graphQuery(r):"lang"===n?e.lang(r):"page"===n?e.page(r):"after"===n?e.after(r):"orderings"===n?e.orderings(r):e.set(n,r)},n);throw new Error("Unable to access to form "+t.id)},t}();e.LazySearchForm=r;var o=function(){function t(t,e){for(var n in this.httpClient=e,this.form=t,this.data={},t.fields)t.fields[n].default&&(this.data[n]=[t.fields[n].default])}return t.prototype.set=function(t,e){var n=this.form.fields[t];if(!n)throw new Error("Unknown field "+t);var r=""===e||void 0===e?null:e,o=this.data[t]||[];return o=n.multiple?r?o.concat([r]):o:r?[r]:o,this.data[t]=o,this},t.prototype.ref=function(t){return this.set("ref",t)},t.prototype.query=function(t){if("string"==typeof t)return this.query([t]);if(Array.isArray(t))return this.set("q","["+t.join("")+"]");throw new Error("Invalid query : "+t)},t.prototype.pageSize=function(t){return this.set("pageSize",t)},t.prototype.fetch=function(t){console.warn("Warning: Using Fetch is deprecated. Use the property `graphQuery` instead.");var e=Array.isArray(t)?t.join(","):t;return this.set("fetch",e)},t.prototype.fetchLinks=function(t){console.warn("Warning: Using FetchLinks is deprecated. Use the property `graphQuery` instead.");var e=Array.isArray(t)?t.join(","):t;return this.set("fetchLinks",e)},t.prototype.graphQuery=function(t){return this.set("graphQuery",t)},t.prototype.lang=function(t){return this.set("lang",t)},t.prototype.page=function(t){return this.set("page",t)},t.prototype.after=function(t){return this.set("after",t)},t.prototype.orderings=function(t){return t?this.set("orderings","["+t.join(",")+"]"):this},t.prototype.url=function(){var t=this.form.action;if(this.data){var e=t.indexOf("?")>-1?"&":"?";for(var n in this.data)if(this.data.hasOwnProperty(n)){var r=this.data[n];if(r)for(var o=0;o<r.length;o++)t+=e+n+"="+encodeURIComponent(r[o]),e="&"}}return t},t.prototype.submit=function(t){return this.httpClient.cachedRequest(this.url()).then(function(e){return t&&t(null,e),e}).catch(function(e){throw t&&t(e),e})},t}();e.SearchForm=o},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t){this.data={},this.data=t}return t.prototype.id=function(){return this.data.id},t.prototype.ref=function(){return this.data.ref},t.prototype.label=function(){return this.data.label},t}();e.Variation=r;var o=function(){function t(t){this.data={},this.data=t,this.variations=(t.variations||[]).map(function(t){return new r(t)})}return t.prototype.id=function(){return this.data.id},t.prototype.googleId=function(){return this.data.googleId},t.prototype.name=function(){return this.data.name},t}();e.Experiment=o;var i=function(){function t(t){t&&(this.drafts=(t.drafts||[]).map(function(t){return new o(t)}),this.running=(t.running||[]).map(function(t){return new o(t)}))}return t.prototype.current=function(){return this.running.length>0?this.running[0]:null},t.prototype.refFromCookie=function(t){if(!t||""===t.trim())return null;var e=t.trim().split(" ");if(e.length<2)return null;var n=e[0],r=parseInt(e[1],10),o=this.running.filter(function(t){return t.googleId()===n&&t.variations.length>r})[0];return o?o.variations[r].ref():null},t}();e.Experiments=i},function(t,e,n){"use strict";e.__esModule=!0;var r="at",o="not",i="missing",u="has",a="any",s="in",f="fulltext",c="similar",l="number.gt",p="number.lt",h="number.inRange",d="date.before",y="date.after",m="date.between",g="date.day-of-month",v="date.day-of-month-after",w="date.day-of-month-before",b="date.day-of-week",_="date.day-of-week-after",k="date.day-of-week-before",I="date.month",T="date.month-before",E="date.month-after",O="date.year",A="date.hour",x="date.hour-before",M="date.hour-after",P="geopoint.near";function j(t){if("string"==typeof t)return'"'+t+'"';if("number"==typeof t)return t.toString();if(t instanceof Date)return t.getTime().toString();if(Array.isArray(t))return"["+t.map(function(t){return j(t)}).join(",")+"]";if("boolean"==typeof t)return t.toString();throw new Error("Unable to encode "+t+" of type "+typeof t)}var q={near:function(t,e,n,r){return"["+P+"("+t+", "+e+", "+n+", "+r+")]"}},R={before:function(t,e){return"["+d+"("+t+", "+j(e)+")]"},after:function(t,e){return"["+y+"("+t+", "+j(e)+")]"},between:function(t,e,n){return"["+m+"("+t+", "+j(e)+", "+j(n)+")]"},dayOfMonth:function(t,e){return"["+g+"("+t+", "+e+")]"},dayOfMonthAfter:function(t,e){return"["+v+"("+t+", "+e+")]"},dayOfMonthBefore:function(t,e){return"["+w+"("+t+", "+e+")]"},dayOfWeek:function(t,e){return"["+b+"("+t+", "+j(e)+")]"},dayOfWeekAfter:function(t,e){return"["+_+"("+t+", "+j(e)+")]"},dayOfWeekBefore:function(t,e){return"["+k+"("+t+", "+j(e)+")]"},month:function(t,e){return"["+I+"("+t+", "+j(e)+")]"},monthBefore:function(t,e){return"["+T+"("+t+", "+j(e)+")]"},monthAfter:function(t,e){return"["+E+"("+t+", "+j(e)+")]"},year:function(t,e){return"["+O+"("+t+", "+e+")]"},hour:function(t,e){return"["+A+"("+t+", "+e+")]"},hourBefore:function(t,e){return"["+x+"("+t+", "+e+")]"},hourAfter:function(t,e){return"["+M+"("+t+", "+e+")]"}},S={gt:function(t,e){return"["+l+"("+t+", "+e+")]"},lt:function(t,e){return"["+p+"("+t+", "+e+")]"},inRange:function(t,e,n){return"["+h+"("+t+", "+e+", "+n+")]"}};e.default={at:function(t,e){return"["+r+"("+t+", "+j(e)+")]"},not:function(t,e){return"["+o+"("+t+", "+j(e)+")]"},missing:function(t){return"["+i+"("+t+")]"},has:function(t){return"["+u+"("+t+")]"},any:function(t,e){return"["+a+"("+t+", "+j(e)+")]"},in:function(t,e){return"["+s+"("+t+", "+j(e)+")]"},fulltext:function(t,e){return"["+f+"("+t+", "+j(e)+")]"},similar:function(t,e){return"["+c+'("'+t+'", '+e+")]"},date:R,dateBefore:R.before,dateAfter:R.after,dateBetween:R.between,dayOfMonth:R.dayOfMonth,dayOfMonthAfter:R.dayOfMonthAfter,dayOfMonthBefore:R.dayOfMonthBefore,dayOfWeek:R.dayOfWeek,dayOfWeekAfter:R.dayOfWeekAfter,dayOfWeekBefore:R.dayOfWeekBefore,month:R.month,monthBefore:R.monthBefore,monthAfter:R.monthAfter,year:R.year,hour:R.hour,hourBefore:R.hourBefore,hourAfter:R.hourAfter,number:S,gt:S.gt,lt:S.lt,inRange:S.inRange,near:q.near,geopoint:q}},function(t,e,n){"use strict";(function(t){var r=n(0),o=setTimeout;function i(){}function u(t){if(!(this instanceof u))throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(t,this)}function a(t,e){for(;3===t._state;)t=t._value;0!==t._state?(t._handled=!0,u._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null!==n){var r;try{r=n(t._value)}catch(t){return void f(e.promise,t)}s(e.promise,r)}else(1===t._state?s:f)(e.promise,t._value)})):t._deferreds.push(e)}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof u)return t._state=3,t._value=e,void c(t);if("function"==typeof n)return void l(function(t,e){return function(){t.apply(e,arguments)}}(n,e),t)}t._state=1,t._value=e,c(t)}catch(e){f(t,e)}}function f(t,e){t._state=2,t._value=e,c(t)}function c(t){2===t._state&&0===t._deferreds.length&&u._immediateFn(function(){t._handled||u._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function l(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,f(e,t))})}catch(t){if(n)return;n=!0,f(e,t)}}u.prototype.catch=function(t){return this.then(null,t)},u.prototype.then=function(t,e){var n=new this.constructor(i);return a(this,new function(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}(t,e,n)),n},u.prototype.finally=r.a,u.all=function(t){return new u(function(e,n){if(!t||void 0===t.length)throw new TypeError("Promise.all accepts an array");var r=Array.prototype.slice.call(t);if(0===r.length)return e([]);var o=r.length;function i(t,u){try{if(u&&("object"==typeof u||"function"==typeof u)){var a=u.then;if("function"==typeof a)return void a.call(u,function(e){i(t,e)},n)}r[t]=u,0==--o&&e(r)}catch(t){n(t)}}for(var u=0;u<r.length;u++)i(u,r[u])})},u.resolve=function(t){return t&&"object"==typeof t&&t.constructor===u?t:new u(function(e){e(t)})},u.reject=function(t){return new u(function(e,n){n(t)})},u.race=function(t){return new u(function(e,n){for(var r=0,o=t.length;r<o;r++)t[r].then(e,n)})},u._immediateFn="function"==typeof t&&function(e){t(e)}||function(t){o(t,0)},u._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},e.a=u}).call(this,n(18).setImmediate)},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t){this.options=t||{}}return t.prototype.request=function(t,e){!function(t,e,n){var r,o={headers:{Accept:"application/json"}};e&&e.proxyAgent&&(o.agent=e.proxyAgent);var i=fetch(t,o);(e.timeoutInMs?Promise.race([i,new Promise(function(n,o){r=setTimeout(function(){return o(new Error(t+" response timeout"))},e.timeoutInMs)})]):i).then(function(e){return clearTimeout(r),~~(e.status/100!=2)?e.text().then(function(){var n=new Error("Unexpected status code ["+e.status+"] on URL "+t);throw n.status=e.status,n}):e.json().then(function(t){var r=e.headers.get("cache-control"),o=r?/max-age=(\d+)/.exec(r):null,i=o?parseInt(o[1],10):void 0;n(null,t,e,i)})}).catch(function(t){clearTimeout(r),n(t)})}(t,this.options,e)},t}();e.DefaultRequestHandler=r},function(t,e,n){"use strict";function r(t){this.size=0,this.limit=t,this._keymap={}}e.__esModule=!0,e.MakeLRUCache=function(t){return new r(t)},r.prototype.put=function(t,e){var n={key:t,value:e};if(this._keymap[t]=n,this.tail?(this.tail.newer=n,n.older=this.tail):this.head=n,this.tail=n,this.size===this.limit)return this.shift();this.size++},r.prototype.shift=function(){var t=this.head;return t&&(this.head.newer?(this.head=this.head.newer,this.head.older=void 0):this.head=void 0,t.newer=t.older=void 0,delete this._keymap[t.key]),console.log("purging ",t.key),t},r.prototype.get=function(t,e){var n=this._keymap[t];if(void 0!==n)return n===this.tail?e?n:n.value:(n.newer&&(n===this.head&&(this.head=n.newer),n.newer.older=n.older),n.older&&(n.older.newer=n.newer),n.newer=void 0,n.older=this.tail,this.tail&&(this.tail.newer=n),this.tail=n,e?n:n.value)},r.prototype.find=function(t){return this._keymap[t]},r.prototype.set=function(t,e){var n,r=this.get(t,!0);return r?(n=r.value,r.value=e):(n=this.put(t,e))&&(n=n.value),n},r.prototype.remove=function(t){var e=this._keymap[t];if(e)return delete this._keymap[e.key],e.newer&&e.older?(e.older.newer=e.newer,e.newer.older=e.older):e.newer?(e.newer.older=void 0,this.head=e.newer):e.older?(e.older.newer=void 0,this.tail=e.older):this.head=this.tail=void 0,this.size--,e.value},r.prototype.removeAll=function(){this.head=this.tail=void 0,this.size=0,this._keymap={}},"function"==typeof Object.keys?r.prototype.keys=function(){return Object.keys(this._keymap)}:r.prototype.keys=function(){var t=[];for(var e in this._keymap)t.push(e);return t},r.prototype.forEach=function(t,e,n){var r;if(!0===e?(n=!0,e=void 0):"object"!=typeof e&&(e=this),n)for(r=this.tail;r;)t.call(e,r.key,r.value,this),r=r.older;else for(r=this.head;r;)t.call(e,r.key,r.value,this),r=r.newer},r.prototype.toString=function(){for(var t="",e=this.head;e;)t+=String(e.key)+":"+e.value,(e=e.newer)&&(t+=" < ");return t}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(9),o=function(){function t(t){void 0===t&&(t=1e3),this.lru=r.MakeLRUCache(t)}return t.prototype.isExpired=function(t){var e=this.lru.get(t,!1);return!!e&&(0!==e.expiredIn&&e.expiredIn<Date.now())},t.prototype.get=function(t,e){var n=this.lru.get(t,!1);n&&!this.isExpired(t)?e(null,n.data):e&&e(null)},t.prototype.set=function(t,e,n,r){this.lru.remove(t),this.lru.put(t,{data:e,expiredIn:n?Date.now()+1e3*n:0}),r&&r(null)},t.prototype.remove=function(t,e){this.lru.remove(t),e&&e(null)},t.prototype.clear=function(t){this.lru.removeAll(),t&&t(null)},t}();e.DefaultApiCache=o},function(t,e,n){"use strict";e.__esModule=!0;var r=n(10),o=n(8),i=function(){function t(t,e,n,i){this.requestHandler=t||new o.DefaultRequestHandler({proxyAgent:n,timeoutInMs:i}),this.cache=e||new r.DefaultApiCache}return t.prototype.request=function(t,e){this.requestHandler.request(t,function(t,n,r,o){t?e&&e(t,null,r,o):n&&e&&e(null,n,r,o)})},t.prototype.cachedRequest=function(t,e){var n=this,r=e||{};return new Promise(function(e,o){!function(e){var o=r.cacheKey||t;n.cache.get(o,function(i,u){i||u?e(i,u):n.request(t,function(t,i,u,a){if(t)e(t,null);else{var s=a||r.ttl;s&&n.cache.set(o,i,s,e),e(null,i)}})})}(function(t,n){t&&o(t),n&&e(n)})})},t}();e.default=i},function(t,e,n){"use strict";e.__esModule=!0;var r=decodeURIComponent;e.default={parse:function(t,e){if("string"!=typeof t)throw new TypeError("argument str must be a string");var n={},o=e||{},i=t.split(/; */),u=o.decode||r;return i.forEach(function(t){var e=t.indexOf("=");if(!(e<0)){var r=t.substr(0,e).trim(),o=t.substr(++e,t.length).trim();'"'==o[0]&&(o=o.slice(1,-1)),void 0==n[r]&&(n[r]=function(t,e){try{return e(t)}catch(e){return t}}(o,u))}}),n}}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(4),o=n(3),i=n(1),u=function(){function t(t,e){this.api=new o.default(t,e)}return t.prototype.getApi=function(){return this.api.get()},t.prototype.everything=function(){return this.form("everything")},t.prototype.form=function(t){return new r.LazySearchForm(t,this.api)},t.prototype.query=function(t,e,n){return this.getApi().then(function(r){return r.query(t,e,n)})},t.prototype.queryFirst=function(t,e,n){return this.getApi().then(function(r){return r.queryFirst(t,e,n)})},t.prototype.getByID=function(t,e,n){return this.getApi().then(function(r){return r.getByID(t,e,n)})},t.prototype.getByIDs=function(t,e,n){return this.getApi().then(function(r){return r.getByIDs(t,e,n)})},t.prototype.getByUID=function(t,e,n,r){return this.getApi().then(function(o){return o.getByUID(t,e,n,r)})},t.prototype.getSingle=function(t,e,n){return this.getApi().then(function(r){return r.getSingle(t,e,n)})},t.prototype.getBookmark=function(t,e,n){return this.getApi().then(function(r){return r.getBookmark(t,e,n)})},t.prototype.previewSession=function(t,e,n,r){return this.getApi().then(function(o){return o.previewSession(t,e,n,r)})},t.prototype.getPreviewResolver=function(t,e){var n=this;return i.createPreviewResolver(t,e,function(t){return n.getApi().then(function(e){return e.getByID(t)})})},t.getApi=function(t,e){return new o.default(t,e).get()},t}();e.DefaultClient=u},function(t,e,n){"use strict";var r,o=n(6),i=n(5),u=n(13),a=n(3),s=n(2);!function(t){function e(t,e){return u.DefaultClient.getApi(t,e)}t.experimentCookie=s.EXPERIMENT_COOKIE,t.previewCookie=s.PREVIEW_COOKIE,t.Predicates=o.default,t.Experiments=i.Experiments,t.Api=a.default,t.client=function(t,e){return new u.DefaultClient(t,e)},t.getApi=e,t.api=function(t,n){return e(t,n)}}(r||(r={})),t.exports=r},function(e,n){e.exports=t},function(t,e){var n,r,o=t.exports={};function i(){throw new Error("setTimeout has not been defined")}function u(){throw new Error("clearTimeout has not been defined")}function a(t){if(n===setTimeout)return setTimeout(t,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i}catch(t){n=i}try{r="function"==typeof clearTimeout?clearTimeout:u}catch(t){r=u}}();var s,f=[],c=!1,l=-1;function p(){c&&s&&(c=!1,s.length?f=s.concat(f):l=-1,f.length&&h())}function h(){if(!c){var t=a(p);c=!0;for(var e=f.length;e;){for(s=f,f=[];++l<e;)s&&s[l].run();l=-1,e=f.length}s=null,c=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===u||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function d(t,e){this.fun=t,this.array=e}function y(){}o.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];f.push(new d(t,e)),1!==f.length||c||a(h)},d.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=y,o.addListener=y,o.once=y,o.off=y,o.removeListener=y,o.removeAllListeners=y,o.emit=y,o.prependListener=y,o.prependOnceListener=y,o.listeners=function(t){return[]},o.binding=function(t){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(t){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(t,e,n){(function(t){!function(e,n){"use strict";if(!e.setImmediate){var r,o=1,i={},u=!1,a=e.document,s=Object.getPrototypeOf&&Object.getPrototypeOf(e);s=s&&s.setTimeout?s:e,"[object process]"==={}.toString.call(e.process)?r=function(e){t.nextTick(function(){c(e)})}:function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&c(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),r=function(n){e.postMessage(t+n,"*")}}():e.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){c(t.data)},r=function(e){t.port2.postMessage(e)}}():a&&"onreadystatechange"in a.createElement("script")?function(){var t=a.documentElement;r=function(e){var n=a.createElement("script");n.onreadystatechange=function(){c(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():r=function(t){setTimeout(c,0,t)},s.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var u={callback:t,args:e};return i[o]=u,r(o),o++},s.clearImmediate=f}function f(t){delete i[t]}function c(t){if(u)setTimeout(c,0,t);else{var e=i[t];if(e){u=!0;try{!function(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(n,r)}}(e)}finally{f(t),u=!1}}}}}("undefined"==typeof self?"undefined"==typeof __webpack_require__.g?this:__webpack_require__.g:self)}).call(this,n(16))},function(t,e,n){var r="undefined"!=typeof __webpack_require__.g&&__webpack_require__.g||"undefined"!=typeof self&&self||window,o=Function.prototype.apply;function i(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new i(o.call(setTimeout,r,arguments),clearTimeout)},e.setInterval=function(){return new i(o.call(setInterval,r,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(r,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(17),e.setImmediate="undefined"!=typeof self&&self.setImmediate||"undefined"!=typeof __webpack_require__.g&&__webpack_require__.g.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||"undefined"!=typeof __webpack_require__.g&&__webpack_require__.g.clearImmediate||this&&this.clearImmediate},function(t,e,n){"use strict";n.r(e);var r=n(7),o=n(0),i=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof __webpack_require__.g)return __webpack_require__.g;throw new Error("unable to locate global object")}();i.Promise?i.Promise.prototype.finally||(i.Promise.prototype.finally=o.a):i.Promise=r.a},function(t,e,n){n(19),n(15),t.exports=n(14)}])});

/***/ }),

/***/ 85165:
/***/ (function() {

(function(self) {

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob();
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    };

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue+','+value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) { items.push(name); });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) { items.push(value); });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) { items.push([name, value]); });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'omit';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);
      var xhr = new XMLHttpRequest();

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  };
  self.fetch.polyfill = true;
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 56410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(34885));
	else {}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_691__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_691__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_691__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_691__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_691__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_691__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_691__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_691__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_691__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_691__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_691__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_691__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_691__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_691__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_691__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_691__(__nested_webpack_require_691__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/***/ }),

/***/ "./node_modules/prismic-helpers/dist/prismic-helpers.min.js":
/*!******************************************************************!*\
  !*** ./node_modules/prismic-helpers/dist/prismic-helpers.min.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

!function (e, t) {
    true ? module.exports = t() : 0;
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    e.exports = n(1);
  }, function (e, t, n) {
    var r = n(2),
        o = n(3);
    e.exports = {
      Link: r,
      Date: o
    };
  }, function (e, t, n) {
    e.exports = {
      url: function (e, t) {
        if (e && [e.link_type, e._linkType, e.linkType].some(function (e) {
          return e && ["Document", "Link.Document", "Link.document"].includes(e);
        }) && t && "function" == typeof t) {
          var n = t(e);
          if (n) return n;
        }

        return e && e.url ? e.url : "";
      }
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (!e) return null;
      var t = 24 == e.length ? "".concat(e.substring(0, 22), ":").concat(e.substring(22, 24)) : e;
      return new Date(t);
    };
  }]);
});

/***/ }),

/***/ "./node_modules/prismic-richtext/dist/prismic-richtext.min.js":
/*!********************************************************************!*\
  !*** ./node_modules/prismic-richtext/dist/prismic-richtext.min.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

!function (e, t) {
    true ? module.exports = t() : 0;
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 9);
  }([function (e, t, n) {
    var r = n(3);

    e.exports = function (e) {
      return function t(n) {
        return 0 === arguments.length || r(n) ? t : e.apply(this, arguments);
      };
    };
  }, function (e, t, n) {
    var r = n(0),
        o = n(3);

    e.exports = function (e) {
      return function t(n, i) {
        switch (arguments.length) {
          case 0:
            return t;

          case 1:
            return o(n) ? t : r(function (t) {
              return e(n, t);
            });

          default:
            return o(n) && o(i) ? t : o(n) ? r(function (t) {
              return e(t, i);
            }) : o(i) ? r(function (t) {
              return e(n, t);
            }) : e(n, i);
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r;

    function o(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PRIORITIES = t.NODE_TYPES = void 0;
    var i = {
      heading1: "heading1",
      heading2: "heading2",
      heading3: "heading3",
      heading4: "heading4",
      heading5: "heading5",
      heading6: "heading6",
      paragraph: "paragraph",
      preformatted: "preformatted",
      strong: "strong",
      em: "em",
      listItem: "list-item",
      oListItem: "o-list-item",
      list: "group-list-item",
      oList: "group-o-list-item",
      image: "image",
      embed: "embed",
      hyperlink: "hyperlink",
      label: "label",
      span: "span"
    };
    t.NODE_TYPES = i;
    var u = (o(r = {}, i.heading1, 4), o(r, i.heading2, 4), o(r, i.heading3, 4), o(r, i.heading4, 4), o(r, i.heading5, 4), o(r, i.heading6, 4), o(r, i.paragraph, 3), o(r, i.preformatted, 5), o(r, i.strong, 6), o(r, i.em, 6), o(r, i.oList, 1), o(r, i.list, 1), o(r, i.listItem, 1), o(r, i.oListItem, 1), o(r, i.image, 1), o(r, i.embed, 1), o(r, i.hyperlink, 3), o(r, i.label, 4), o(r, i.span, 7), r);
    t.PRIORITIES = u;
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e && !0 === e["@@functional/placeholder"];
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = d(n(12)),
        o = d(n(15)),
        i = d(n(16)),
        u = d(n(17)),
        c = d(n(21)),
        a = d(n(7)),
        l = n(23),
        f = n(2),
        s = n(8);

    function d(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function p(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function h(e) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function y(e, t) {
      var n = t.others.reduce(function (n, r) {
        var o = n.inner,
            i = n.outer,
            u = function (e, t, n) {
          return n.start < t.start ? {
            inner: s.SpanNode.slice(n, t.start, n.end, e),
            outer: s.SpanNode.slice(n, n.start, t.start, e)
          } : n.end > t.end ? {
            inner: s.SpanNode.slice(n, n.start, t.end, e),
            outer: s.SpanNode.slice(n, t.end, n.end, e)
          } : {
            inner: n
          };
        }(e, t.elected, r);

        return {
          inner: o.concat(u.inner),
          outer: u.outer ? i.concat(u.outer) : i
        };
      }, {
        inner: [],
        outer: []
      }),
          r = n.inner,
          o = n.outer;
      return [t.elected.setChildren(x(e, r, t.elected.boundaries()))].concat(b(e, o));
    }

    function v(e) {
      return function (e, t) {
        return t.reduce(function (t, n) {
          var r = (0, c.default)(t);

          if (r) {
            if (r.some(function (e) {
              return e.isParentOf(n);
            })) return (0, u.default)(t).concat([r.concat(n)]);
            var o = (0, c.default)(r);
            return o && e(o, n) ? (0, u.default)(t).concat([r.concat(n)]) : t.concat([[n]]);
          }

          return [[n]];
        }, []);
      }(function (e, t) {
        return e.end >= t.start;
      }, (0, i.default)([function (e, t) {
        return e.start - t.start;
      }, function (e, t) {
        return e.end - t.end;
      }], e));
    }

    function m(e) {
      if (0 === e.length) throw new Error("Unable to elect node on empty list");
      var t = h(e.sort(function (e, t) {
        if (e.isParentOf(t)) return -1;
        if (t.isParentOf(e)) return 1;
        var n = f.PRIORITIES[e.type] - f.PRIORITIES[t.type];
        return 0 === n ? e.text.length - t.text.length : n;
      }));
      return {
        elected: t[0],
        others: t.slice(1)
      };
    }

    function x(e, t, n) {
      if (t.length > 0) return function (e, t, n) {
        return t.reduce(function (r, o, i) {
          var u = [],
              c = 0 === i && o.start > n.lower,
              a = i === t.length - 1 && n.upper > o.end;

          if (c) {
            var l = new s.TextNode(n.lower, o.start, e.slice(n.lower, o.start));
            u = u.concat(l);
          } else {
            var f = t[i - 1];

            if (f && o.start > f.end) {
              var d = e.slice(f.end, o.start),
                  p = new s.TextNode(f.end, o.start, d);
              u = u.concat(p);
            }
          }

          if (u = u.concat(o), a) {
            var h = new s.TextNode(o.end, n.upper, e.slice(o.end, n.upper));
            u = u.concat(h);
          }

          return r.concat(u);
        }, []);
      }(e, b(e, t), n);
      var r = e.slice(n.lower, n.upper);
      return [new s.TextNode(n.lower, n.upper, r)];
    }

    function b(e, t) {
      var n = v((0, o.default)(function (e) {
        return e.start;
      }, t)).map(m),
          i = (0, r.default)(n.map(function (t) {
        return y(e, t);
      }));
      return (0, o.default)(function (e) {
        return e.start;
      }, i);
    }

    var g = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }

      var t, n, r;
      return t = e, r = [{
        key: "fromRichText",
        value: function (e) {
          return {
            key: (0, a.default)(),
            children: e.reduce(function (e, t, n) {
              if (l.RichTextBlock.isEmbedBlock(t.type) || l.RichTextBlock.isImageBlock(t.type)) return e.concat(new s.BlockNode(t.type, t));

              var r = function (e) {
                var t = e.spans.map(function (t) {
                  var n = e.text.slice(t.start, t.end);
                  return new s.SpanNode(t.start, t.end, t.type, n, [], t);
                }),
                    n = {
                  lower: 0,
                  upper: e.text.length
                };
                return x(e.text, t, n);
              }(t),
                  o = e[e.length - 1];

              if (l.RichTextBlock.isListItem(t.type) && o && o instanceof s.ListBlockNode) {
                var i = new s.ListItemBlockNode(t, r),
                    c = o.addChild(i);
                return (0, u.default)(e).concat(c);
              }

              if (l.RichTextBlock.isOrderedListItem(t.type) && o && o instanceof s.OrderedListBlockNode) {
                var a = new s.OrderedListItemBlockNode(t, r),
                    f = o.addChild(a);
                return (0, u.default)(e).concat(f);
              }

              if (l.RichTextBlock.isListItem(t.type)) {
                var d = new s.ListItemBlockNode(t, r),
                    p = new s.ListBlockNode(l.RichTextBlock.emptyList(), [d]);
                return e.concat(p);
              }

              if (l.RichTextBlock.isOrderedListItem(t.type)) {
                var h = new s.OrderedListItemBlockNode(t, r),
                    y = new s.OrderedListBlockNode(l.RichTextBlock.emptyOrderedList(), [h]);
                return e.concat(y);
              }

              return e.concat(new s.BlockNode(t.type, t, r));
            }, [])
          };
        }
      }], (n = null) && p(t.prototype, n), r && p(t, r), e;
    }();

    t.default = g;
  }, function (e, t) {
    e.exports = Array.isArray || function (e) {
      return null != e && e.length >= 0 && "[object Array]" === Object.prototype.toString.call(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "[object String]" === Object.prototype.toString.call(e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function () {
      var e = new Date().getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
        var n = (e + 16 * Math.random()) % 16 | 0;
        return e = Math.floor(e / 16), ("x" == t ? n : 3 & n | 8).toString(16);
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ListBlockNode = t.OrderedListBlockNode = t.OrderedListItemBlockNode = t.ListItemBlockNode = t.BlockNode = t.TextNode = t.SpanNode = t.Node = void 0;
    var r,
        o = (r = n(7)) && r.__esModule ? r : {
      default: r
    },
        i = n(2);

    function u(e) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function c(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function a(e, t, n) {
      return t && c(e.prototype, t), n && c(e, n), e;
    }

    function l(e, t) {
      return !t || "object" !== u(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function f(e) {
      return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && d(e, t);
    }

    function d(e, t) {
      return (d = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function p(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    var h = function e(t, n, r) {
      p(this, e), this.key = (0, o.default)(), this.type = t, this.element = n, this.children = r;
    };

    t.Node = h;

    var y = function (e) {
      function t(e, n, r, o, i, u) {
        var c;
        return p(this, t), (c = l(this, f(t).call(this, r, u, i))).start = e, c.end = n, c.text = o, c.children = i, c;
      }

      return s(t, h), a(t, [{
        key: "boundaries",
        value: function () {
          return {
            lower: this.start,
            upper: this.end
          };
        }
      }, {
        key: "isParentOf",
        value: function (e) {
          return this.start <= e.start && this.end >= e.end;
        }
      }, {
        key: "setChildren",
        value: function (e) {
          return new t(this.start, this.end, this.type, this.text, e, this.element);
        }
      }], [{
        key: "slice",
        value: function (e, n, r, o) {
          return new t(n, r, e.type, o.slice(n, r), e.children, e.element);
        }
      }]), t;
    }();

    t.SpanNode = y;

    var v = function (e) {
      function t(e, n, r) {
        p(this, t);
        var o = {
          type: i.NODE_TYPES.span,
          start: e,
          end: n,
          text: r
        };
        return l(this, f(t).call(this, e, n, i.NODE_TYPES.span, r, [], o));
      }

      return s(t, y), t;
    }();

    t.TextNode = v;

    var m = function (e) {
      function t(e, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
        return p(this, t), l(this, f(t).call(this, e, n, r));
      }

      return s(t, h), t;
    }();

    t.BlockNode = m;

    var x = function (e) {
      function t(e, n) {
        return p(this, t), l(this, f(t).call(this, i.NODE_TYPES.listItem, e, n));
      }

      return s(t, m), t;
    }();

    t.ListItemBlockNode = x;

    var b = function (e) {
      function t(e, n) {
        return p(this, t), l(this, f(t).call(this, i.NODE_TYPES.oListItem, e, n));
      }

      return s(t, m), t;
    }();

    t.OrderedListItemBlockNode = b;

    var g = function (e) {
      function t(e, n) {
        return p(this, t), l(this, f(t).call(this, i.NODE_TYPES.oList, e, n));
      }

      return s(t, m), a(t, [{
        key: "addChild",
        value: function (e) {
          var n = this.children.concat(e);
          return new t(this.element, n);
        }
      }]), t;
    }();

    t.OrderedListBlockNode = g;

    var O = function (e) {
      function t(e, n) {
        return p(this, t), l(this, f(t).call(this, i.NODE_TYPES.list, e, n));
      }

      return s(t, m), a(t, [{
        key: "addChild",
        value: function (e) {
          var n = this.children.concat(e);
          return new t(this.element, n);
        }
      }]), t;
    }();

    t.ListBlockNode = O;
  }, function (e, t, n) {
    e.exports = n(10);
  }, function (e, t, n) {
    "use strict";

    var r = c(n(11)),
        o = c(n(4)),
        i = c(n(24)),
        u = n(2);

    function c(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    e.exports = {
      asText: r.default,
      asTree: o.default.fromRichText,
      serialize: i.default,
      Elements: u.NODE_TYPES
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var r = function (e, t) {
      var n = "string" == typeof t ? t : " ";
      return e.map(function (e) {
        return e.text;
      }).join(n);
    };

    t.default = r;
  }, function (e, t, n) {
    var r = n(0)(n(13)(!0));
    e.exports = r;
  }, function (e, t, n) {
    var r = n(14);

    e.exports = function (e) {
      return function t(n) {
        for (var o, i, u, c = [], a = 0, l = n.length; a < l;) {
          if (r(n[a])) for (u = 0, i = (o = e ? t(n[a]) : n[a]).length; u < i;) c[c.length] = o[u], u += 1;else c[c.length] = n[a];
          a += 1;
        }

        return c;
      };
    };
  }, function (e, t, n) {
    var r = n(0),
        o = n(5),
        i = n(6),
        u = r(function (e) {
      return !!o(e) || !!e && "object" == typeof e && !i(e) && (1 === e.nodeType ? !!e.length : 0 === e.length || e.length > 0 && e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1));
    });
    e.exports = u;
  }, function (e, t, n) {
    var r = n(1)(function (e, t) {
      return Array.prototype.slice.call(t, 0).sort(function (t, n) {
        var r = e(t),
            o = e(n);
        return r < o ? -1 : r > o ? 1 : 0;
      });
    });
    e.exports = r;
  }, function (e, t, n) {
    var r = n(1)(function (e, t) {
      return Array.prototype.slice.call(t, 0).sort(function (t, n) {
        for (var r = 0, o = 0; 0 === r && o < e.length;) r = e[o](t, n), o += 1;

        return r;
      });
    });
    e.exports = r;
  }, function (e, t, n) {
    var r = n(18)(0, -1);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(19),
        o = n(20)(r("slice", function (e, t, n) {
      return Array.prototype.slice.call(n, e, t);
    }));
    e.exports = o;
  }, function (e, t, n) {
    var r = n(5);

    e.exports = function (e, t) {
      return function () {
        var n = arguments.length;
        if (0 === n) return t();
        var o = arguments[n - 1];
        return r(o) || "function" != typeof o[e] ? t.apply(this, arguments) : o[e].apply(o, Array.prototype.slice.call(arguments, 0, n - 1));
      };
    };
  }, function (e, t, n) {
    var r = n(0),
        o = n(1),
        i = n(3);

    e.exports = function (e) {
      return function t(n, u, c) {
        switch (arguments.length) {
          case 0:
            return t;

          case 1:
            return i(n) ? t : o(function (t, r) {
              return e(n, t, r);
            });

          case 2:
            return i(n) && i(u) ? t : i(n) ? o(function (t, n) {
              return e(t, u, n);
            }) : i(u) ? o(function (t, r) {
              return e(n, t, r);
            }) : r(function (t) {
              return e(n, u, t);
            });

          default:
            return i(n) && i(u) && i(c) ? t : i(n) && i(u) ? o(function (t, n) {
              return e(t, n, c);
            }) : i(n) && i(c) ? o(function (t, n) {
              return e(t, u, n);
            }) : i(u) && i(c) ? o(function (t, r) {
              return e(n, t, r);
            }) : i(n) ? r(function (t) {
              return e(t, u, c);
            }) : i(u) ? r(function (t) {
              return e(n, t, c);
            }) : i(c) ? r(function (t) {
              return e(n, u, t);
            }) : e(n, u, c);
        }
      };
    };
  }, function (e, t, n) {
    var r = n(22)(-1);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(1),
        o = n(6),
        i = r(function (e, t) {
      var n = e < 0 ? t.length + e : e;
      return o(t) ? t.charAt(n) : t[n];
    });
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RichTextBlock = void 0;
    var r = n(2);

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var i = function () {
      function e(t, n, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.type = t, this.text = n, this.spans = r;
      }

      var t, n, i;
      return t = e, i = [{
        key: "isEmbedBlock",
        value: function (e) {
          return e === r.NODE_TYPES.embed;
        }
      }, {
        key: "isImageBlock",
        value: function (e) {
          return e === r.NODE_TYPES.image;
        }
      }, {
        key: "isList",
        value: function (e) {
          return e === r.NODE_TYPES.list;
        }
      }, {
        key: "isOrderedList",
        value: function (e) {
          return e === r.NODE_TYPES.oList;
        }
      }, {
        key: "isListItem",
        value: function (e) {
          return e === r.NODE_TYPES.listItem;
        }
      }, {
        key: "isOrderedListItem",
        value: function (e) {
          return e === r.NODE_TYPES.oListItem;
        }
      }, {
        key: "emptyList",
        value: function () {
          return {
            type: r.NODE_TYPES.list,
            spans: [],
            text: ""
          };
        }
      }, {
        key: "emptyOrderedList",
        value: function () {
          return {
            type: r.NODE_TYPES.oList,
            spans: [],
            text: ""
          };
        }
      }], (n = null) && o(t.prototype, n), i && o(t, i), e;
    }();

    t.RichTextBlock = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r,
        o = (r = n(4)) && r.__esModule ? r : {
      default: r
    },
        i = n(8);

    var u = function (e, t, n) {
      return o.default.fromRichText(e).children.map(function (e, r) {
        return function (e, t, n, r) {
          return function e(n, o) {
            var u = n instanceof i.SpanNode ? n.text : null,
                c = n.children.reduce(function (t, n, r) {
              return t.concat([e(n, r)]);
            }, []),
                a = r && r(n.type, n.element, u, c, o);
            return a || t(n.type, n.element, u, c, o);
          }(e, n);
        }(e, t, r, n);
      });
    };

    t.default = u;
  }]);
});

/***/ }),

/***/ "./node_modules/prop-types/checkPropTypes.js":
/*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_32578__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var printWarning = function () {};

if (true) {
  var ReactPropTypesSecret = __nested_webpack_require_32578__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");

  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (true) {
    loggedTypeFailures = {};
  }
};

module.exports = checkPropTypes;

/***/ }),

/***/ "./node_modules/prop-types/factoryWithTypeCheckers.js":
/*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_36545__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var ReactIs = __nested_webpack_require_36545__(/*! react-is */ "./node_modules/react-is/index.js");

var assign = __nested_webpack_require_36545__(/*! object-assign */ "./node_modules/object-assign/index.js");

var ReactPropTypesSecret = __nested_webpack_require_36545__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");

var checkPropTypes = __nested_webpack_require_36545__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};

if (true) {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (  true && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (true) {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
        true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = assign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/***/ }),

/***/ "./node_modules/prop-types/index.js":
/*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_58252__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (true) {
  var ReactIs = __nested_webpack_require_58252__(/*! react-is */ "./node_modules/react-is/index.js"); // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod


  var throwOnDirectAccess = true;
  module.exports = __nested_webpack_require_58252__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
} else {}

/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.development.js":
/*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


if (true) {
  (function () {
    'use strict';

    Object.defineProperty(exports, '__esModule', {
      value: true
    }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE);
    }
    /**
     * Forked from fbjs/warning:
     * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
     *
     * Only change is we use console.warn instead of console.error,
     * and do nothing when 'console' is not supported.
     * This really simplifies the code.
     * ---
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */


    var lowPriorityWarning = function () {};

    {
      var printWarning = function (format) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function () {
          return args[argIndex++];
        });

        if (typeof console !== 'undefined') {
          console.warn(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };

      lowPriorityWarning = function (condition, format) {
        if (format === undefined) {
          throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
        }

        if (!condition) {
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }

          printWarning.apply(undefined, [format].concat(args));
        }
      };
    }
    var lowPriorityWarning$1 = lowPriorityWarning;

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_LAZY_TYPE:
          case REACT_MEMO_TYPE:
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true;
          lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.typeOf = typeOf;
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isValidElementType = isValidElementType;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
  })();
}

/***/ }),

/***/ "./node_modules/react-is/index.js":
/*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_69524__) {

"use strict";


if (false) {} else {
  module.exports = __nested_webpack_require_69524__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
}

/***/ }),

/***/ "./src/Component.js":
/*!**************************!*\
  !*** ./src/Component.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_69932__) {

"use strict";
__nested_webpack_require_69932__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_69932__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_69932__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_69932__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__nested_webpack_require_69932__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prismic_richtext__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_69932__(/*! prismic-richtext */ "./node_modules/prismic-richtext/dist/prismic-richtext.min.js");
/* harmony import */ var prismic_richtext__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__nested_webpack_require_69932__.n(prismic_richtext__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _richtext__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_69932__(/*! ./richtext */ "./src/richtext.js");
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var createHtmlSerializer = function createHtmlSerializer() {
  var bucket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var serializers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var processors = serializers.reduce(function (acc, _ref) {
    var type = _ref.type,
        fn = _ref.fn;
    return Object.assign({}, acc, _defineProperty({}, type, fn));
  }, {});
  return function (type) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return processors[type] ? processors[type].apply(processors, [type].concat(args)) : null;
  };
};

var RichText = function RichText(_ref2) {
  var Component = _ref2.Component,
      elements = _ref2.elements,
      htmlSerializer = _ref2.htmlSerializer,
      linkResolver = _ref2.linkResolver,
      render = _ref2.render,
      renderAsText = _ref2.renderAsText,
      serializeHyperlink = _ref2.serializeHyperlink,
      rest = _objectWithoutProperties(_ref2, ["Component", "elements", "htmlSerializer", "linkResolver", "render", "renderAsText", "serializeHyperlink"]);

  var maybeSerializer = htmlSerializer || serializeHyperlink && createHtmlSerializer({}, [{
    type: prismic_richtext__WEBPACK_IMPORTED_MODULE_2__["Elements"].hyperlink,
    fn: serializeHyperlink
  }]);
  return render ? Object(_richtext__WEBPACK_IMPORTED_MODULE_3__["renderRichText"])(render, linkResolver, maybeSerializer, Component, elements, rest) : null;
};

RichText.propTypes = {
  Component: prop_types__WEBPACK_IMPORTED_MODULE_1__["elementType"],
  linkResolver: prop_types__WEBPACK_IMPORTED_MODULE_1__["func"],
  htmlSerializer: prop_types__WEBPACK_IMPORTED_MODULE_1__["func"],
  elements: prop_types__WEBPACK_IMPORTED_MODULE_1__["object"],
  serializeHyperlink: function serializeHyperlink(props, _, componentName) {
    if (props.serializeHyperlink && props.htmlSerializer) {
      return new Error("You cannot specify both 'htmlSerializer' and 'serializeHyperlink'. The latter will be ignored by '".concat(componentName, "'."));
    }
  },
  render: function render(props, _, componentName) {
    if (!props.render) {
      return new Error("Prop 'render' was not specified in '".concat(componentName, "'."));
    }
  }
};
RichText.asText = _richtext__WEBPACK_IMPORTED_MODULE_3__["asText"];
RichText.render = _richtext__WEBPACK_IMPORTED_MODULE_3__["renderRichText"];
RichText.displayName = 'RichText';
/* harmony default export */ __webpack_exports__["default"] = (RichText);

/***/ }),

/***/ "./src/embeds.js":
/*!***********************!*\
  !*** ./src/embeds.js ***!
  \***********************/
/*! exports provided: createScript, embeds */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_74844__) {

"use strict";
__nested_webpack_require_74844__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_74844__.d(__webpack_exports__, "createScript", function() { return createScript; });
/* harmony export (binding) */ __nested_webpack_require_74844__.d(__webpack_exports__, "embeds", function() { return embeds; });
function createScript(_ref) {
  var property = _ref.property,
      src = _ref.src,
      id = _ref.id;

  if (!window) {
    return;
  }

  (function (src, id) {
    var js,
        fjs = document.getElementsByTagName('script')[0],
        t = window[property] || {};

    if (document.getElementById(id)) {
      return t;
    }

    js = document.createElement('script');
    js.id = id;
    js.src = src;
    fjs.parentNode.insertBefore(js, fjs);
    t._e = [];

    t.ready = function (f) {
      t._e.push(f);
    };

    return t;
  })(src, id);
}
var embeds = {
  Twitter: {
    property: 'twttr',
    src: 'https://platform.twitter.com/widgets.js',
    id: 'twitter-wjs',
    load: function load() {
      if (window && window.twttr && window.twttr.widgets) {
        window.twttr.widgets.load();
      }
    }
  },
  Facebook: {
    property: 'FB',
    src: 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.3',
    id: 'fb-wjs',
    load: function load(ref) {
      if (window && window.FB) {
        window.FB.XFBML.parse(ref);
      }
    }
  },
  Instagram: {
    property: 'instgrm',
    src: 'https://www.instagram.com/embed.js',
    id: 'insta-wjs',
    load: function load() {
      if (window && window.instgrm) {
        window.instgrm.Embeds.process();
      }
    }
  }
};

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_76660__) {

var PrismicHelpers = __nested_webpack_require_76660__(/*! prismic-helpers */ "./node_modules/prismic-helpers/dist/prismic-helpers.min.js");

var PrismicRichText = __nested_webpack_require_76660__(/*! prismic-richtext */ "./node_modules/prismic-richtext/dist/prismic-richtext.min.js");

var Component = __nested_webpack_require_76660__(/*! ./Component */ "./src/Component.js");

module.exports = {
  Date: PrismicHelpers.Date,
  Elements: PrismicRichText.Elements,
  Link: PrismicHelpers.Link,
  RichText: Component["default"]
};

/***/ }),

/***/ "./src/richtext.js":
/*!*************************!*\
  !*** ./src/richtext.js ***!
  \*************************/
/*! exports provided: asText, renderRichText */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_77398__) {

"use strict";
__nested_webpack_require_77398__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_77398__.d(__webpack_exports__, "asText", function() { return asText; });
/* harmony export (binding) */ __nested_webpack_require_77398__.d(__webpack_exports__, "renderRichText", function() { return renderRichText; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_77398__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_77398__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prismic_richtext__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_77398__(/*! prismic-richtext */ "./node_modules/prismic-richtext/dist/prismic-richtext.min.js");
/* harmony import */ var prismic_richtext__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__nested_webpack_require_77398__.n(prismic_richtext__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prismic_helpers__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_77398__(/*! prismic-helpers */ "./node_modules/prismic-helpers/dist/prismic-helpers.min.js");
/* harmony import */ var prismic_helpers__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__nested_webpack_require_77398__.n(prismic_helpers__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _embeds__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_77398__(/*! ./embeds */ "./src/embeds.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var createScript = typeof window !== "undefined" ? __nested_webpack_require_77398__(/*! ./embeds */ "./src/embeds.js").createScript : function () {};

function serialize(linkResolver, elements, type, element, content, children, index) {
  if (elements[type]) {
    return serializeElement(elements[type], type, element, content, children, index);
  }

  switch (type) {
    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].heading1:
      return serializeStandardTag('h1', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].heading2:
      return serializeStandardTag('h2', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].heading3:
      return serializeStandardTag('h3', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].heading4:
      return serializeStandardTag('h4', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].heading5:
      return serializeStandardTag('h5', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].heading6:
      return serializeStandardTag('h6', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].paragraph:
      return serializeStandardTag('p', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].preformatted:
      return serializeStandardTag('pre', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].strong:
      return serializeStandardTag('strong', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].em:
      return serializeStandardTag('em', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].listItem:
      return serializeStandardTag('li', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].oListItem:
      return serializeStandardTag('li', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].list:
      return serializeStandardTag('ul', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].oList:
      return serializeStandardTag('ol', element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].image:
      return serializeImage(linkResolver, element, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].embed:
      return serializeEmbed(element, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].hyperlink:
      return serializeHyperlink(linkResolver, element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].label:
      return serializeLabel(element, children, index);

    case prismic_richtext__WEBPACK_IMPORTED_MODULE_1__["Elements"].span:
      return serializeSpan(content);

    default:
      return null;
  }
}

function propsWithUniqueKey() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return Object.assign(props, {
    key: key
  });
}

function serializeElement(Element, type, props, content, children, index) {
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Element, _objectSpread({
    key: "element-".concat(type, "-").concat(index + 1)
  }, props, {
    children: children && children.length ? children : undefined
  }, type === 'image' ? {
    src: props.url,
    url: undefined
  } : null));
}

function serializeStandardTag(tag, element, children, key) {
  var props = element.label ? Object.assign({}, {
    className: element.label
  }) : {};
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(tag, propsWithUniqueKey(props, key), children);
}

function serializeHyperlink(linkResolver, element, children, key) {
  var targetAttr = element.data.target ? {
    target: element.data.target
  } : {};
  var relAttr = element.data.target ? {
    rel: 'noopener'
  } : {};
  var props = Object.assign({
    href: prismic_helpers__WEBPACK_IMPORTED_MODULE_2__["Link"].url(element.data, linkResolver)
  }, targetAttr, relAttr);
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('a', propsWithUniqueKey(props, key), children);
}

function serializeLabel(element, children, key) {
  var props = element.data ? Object.assign({}, {
    className: element.data.label
  }) : {};
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('span', propsWithUniqueKey(props, key), children);
}

function serializeSpan(content) {
  if (content) {
    return content.split("\n").reduce(function (acc, p) {
      if (acc.length === 0) {
        return [p];
      } else {
        var brIndex = (acc.length + 1) / 2 - 1;
        var br = Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('br', propsWithUniqueKey({}, brIndex));
        return acc.concat([br, p]);
      }
    }, []);
  } else {
    return null;
  }
}

function serializeImage(linkResolver, element, key) {
  var linkUrl = element.linkTo ? prismic_helpers__WEBPACK_IMPORTED_MODULE_2__["Link"].url(element.linkTo, linkResolver) : null;
  var linkTarget = element.linkTo && element.linkTo.target ? {
    target: element.linkTo.target
  } : {};
  var relAttr = linkTarget.target ? {
    rel: 'noopener'
  } : {};
  var img = Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('img', {
    src: element.url,
    alt: element.alt || ''
  });
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('p', propsWithUniqueKey({
    className: [element.label || '', 'block-img'].join(' ')
  }, key), linkUrl ? Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('a', Object.assign({
    href: linkUrl
  }, linkTarget, relAttr), img) : img);
}

function serializeEmbed(element, key) {
  if (_embeds__WEBPACK_IMPORTED_MODULE_3__["embeds"][element.oembed.provider_name]) {
    createScript(_embeds__WEBPACK_IMPORTED_MODULE_3__["embeds"][element.oembed.provider_name]);
  }

  var className = "embed embed-".concat(element.oembed.provider_name.toLowerCase());
  var props = Object.assign({
    "data-oembed": element.oembed.embed_url,
    "data-oembed-type": element.oembed.type,
    "data-oembed-provider": element.oembed.provider_name,
    ref: function ref(_ref) {
      if (_embeds__WEBPACK_IMPORTED_MODULE_3__["embeds"][element.oembed.provider_name]) {
        _embeds__WEBPACK_IMPORTED_MODULE_3__["embeds"][element.oembed.provider_name].load(_ref);
      }
    }
  }, element.label ? {
    className: "".concat(className, " ").concat(element.label)
  } : {
    className: className
  });
  var embedHtml = Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('div', {
    dangerouslySetInnerHTML: {
      __html: element.oembed.html
    }
  });
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])('div', propsWithUniqueKey(props, key), embedHtml);
}

var asText = function asText(structuredText) {
  if (Object.prototype.toString.call(structuredText) !== '[object Array]') {
    console.warn("Rich text argument should be an Array. Received ".concat(_typeof(structuredText)));
    return null;
  }

  return prismic_richtext__WEBPACK_IMPORTED_MODULE_1___default.a.asText(structuredText);
};
var renderRichText = function renderRichText(richText, linkResolver, htmlSerializer) {
  var Component = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : react__WEBPACK_IMPORTED_MODULE_0__["Fragment"];
  var elements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var args = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  if (Object.prototype.toString.call(richText) !== '[object Array]') {
    console.warn("Rich text argument should be an Array. Received ".concat(_typeof(richText)));
    return null;
  }

  var serializedChildren = prismic_richtext__WEBPACK_IMPORTED_MODULE_1___default.a.serialize(richText, serialize.bind(null, linkResolver, elements), htmlSerializer);
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Component, args, serializedChildren);
};

/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_88737__) {

module.exports = __nested_webpack_require_88737__(/*! D:\Libraries\Desktop\prismic\sdk\reactjs/src/index.js */"./src/index.js");


/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});

/***/ }),

/***/ 90907:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 41251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90297);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 8131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(41251)();
}


/***/ }),

/***/ 90297:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 69549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AutoFocusInside": function() { return /* reexport */ es2015_AutoFocusInside; },
  "FocusLockUI": function() { return /* reexport */ Lock; },
  "FreeFocusInside": function() { return /* reexport */ es2015_FreeFocusInside; },
  "InFocusGuard": function() { return /* reexport */ FocusGuard; },
  "MoveFocusInside": function() { return /* reexport */ es2015_MoveFocusInside; },
  "default": function() { return /* binding */ es2015; },
  "useFocusController": function() { return /* reexport */ useFocusController; },
  "useFocusInside": function() { return /* reexport */ useFocusInside; },
  "useFocusScope": function() { return /* reexport */ useFocusScope; },
  "useFocusState": function() { return /* reexport */ useFocusState; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(12720);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(61393);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/constants.js
/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

;// CONCATENATED MODULE: ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ../../node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};
var InFocusGuard = function InFocusGuard(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/react.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};
InFocusGuard.propTypes =  false ? 0 : {};
/* harmony default export */ var FocusGuard = (InFocusGuard);
;// CONCATENATED MODULE: ../../node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});

;// CONCATENATED MODULE: ../../node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/medium.js

var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
    currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true,
  ssr: typeof document !== 'undefined'
});
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/scope.js

var focusScope = /*#__PURE__*/(0,react.createContext)(undefined);
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/Lock.js








var emptyArray = [];
var FocusLock = /*#__PURE__*/(0,react.forwardRef)(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _useState = (0,react.useState)(),
    realObserved = _useState[0],
    setObserved = _useState[1];
  var observed = (0,react.useRef)();
  var isActive = (0,react.useRef)(false);
  var originalFocusedElement = (0,react.useRef)(null);
  var _useState2 = (0,react.useState)({}),
    update = _useState2[1];
  var children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$noFocusGuards = props.noFocusGuards,
    noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards,
    _props$persistentFocu = props.persistentFocus,
    persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu,
    _props$crossFrame = props.crossFrame,
    crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    allowTextSelection = props.allowTextSelection,
    group = props.group,
    className = props.className,
    whiteList = props.whiteList,
    hasPositiveIndices = props.hasPositiveIndices,
    _props$shards = props.shards,
    shards = _props$shards === void 0 ? emptyArray : _props$shards,
    _props$as = props.as,
    Container = _props$as === void 0 ? 'div' : _props$as,
    _props$lockProps = props.lockProps,
    containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
    SideCar = props.sideCar,
    _props$returnFocus = props.returnFocus,
    shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus,
    focusOptions = props.focusOptions,
    onActivationCallback = props.onActivation,
    onDeactivationCallback = props.onDeactivation;
  var _useState3 = (0,react.useState)({}),
    id = _useState3[0];
  var onActivation = (0,react.useCallback)(function (_ref) {
    var captureFocusRestore = _ref.captureFocusRestore;
    if (!originalFocusedElement.current) {
      var _document;
      var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
      originalFocusedElement.current = activeElement;
      if (activeElement !== document.body) {
        originalFocusedElement.current = captureFocusRestore(activeElement);
      }
    }
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
    update();
  }, [onActivationCallback]);
  var onDeactivation = (0,react.useCallback)(function () {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
    update();
  }, [onDeactivationCallback]);
  var returnFocus = (0,react.useCallback)(function (allowDefer) {
    var focusRestore = originalFocusedElement.current;
    if (focusRestore) {
      var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus = (0,react.useCallback)(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium;
  var setObserveNode = (0,react.useCallback)(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (false) {}
  var lockProps = (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  var focusScopeValue = (0,react.useMemo)(function () {
    return {
      observed: observed,
      shards: shards,
      enabled: !disabled,
      active: isActive.current
    };
  }, [disabled, isActive.current, shards, realObserved]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), hasPositiveIndices ? /*#__PURE__*/react.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/react.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions,
    noFocusGuards: noFocusGuards
  }), /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), /*#__PURE__*/react.createElement(focusScope.Provider, {
    value: focusScopeValue
  }, children)), hasTailingGuards && /*#__PURE__*/react.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? 0 : {};
/* harmony default export */ var Lock = (FocusLock);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(98911);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js + 3 modules
var defineProperty = __webpack_require__(4079);
;// CONCATENATED MODULE: ../../node_modules/react-clientside-effect/lib/index.es.js




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {}

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {}

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      (0,inheritsLoose/* default */.Z)(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/react.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(react.PureComponent);

    (0,defineProperty/* default */.Z)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ var index_es = (withSideEffect);

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/array.js
/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/is.js

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isInert = function (node) { return node.hasAttribute('inert'); };
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && !isInert(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/tabOrder.js

var tabSort = function (a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) {
            return 1;
        }
        if (!bTab) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var getTabIndex = function (node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) {
            return 0;
        }
    }
    return node.tabIndex;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) {
        var tabIndex = getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : tabIndex,
        };
    })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/tabbables.js
/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/tabUtils.js



var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/DOMutils.js




/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * !__WARNING__! Low level API.
 * @returns all tabbable nodes
 *
 * @see {@link getFocusableNodes} to get any focusable element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * !__WARNING__! Low level API.
 *
 * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
 * (without guards, as long as they are not expected to be ever focused)
 *
 * @see {@link getTabbableNodes} to get only tabble nodes element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getFocusableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains = function (scope, element) {
    if (scope.shadowRoot) {
        return contains(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains(iframeBody, element);
                }
                return false;
            }
            return contains(child, element);
        });
    }
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
/**
 * returns active element from document or from nested shadowdoms
 */

/**
 * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
 * @param [inDocument]
 */
var getActiveElement = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement(activeElement.contentWindow.document)
            : activeElement);
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/focusIsHidden.js




/**
 * checks if focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 *
 * This is a utility function coupled with {@link FOCUS_ALLOW} constant
 *
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains(node, activeElement); });
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/all-affected.js


/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node - node or nodes to look inside
 * @returns Element[]
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/focusInside.js




var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes.
 * Supports nodes hidden inside shadowDom
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function (target, focusOptions) {
    if (!target) {
        // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
        return;
    }
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/correctFocus.js

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/firstFocus.js

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, node) {
    return nodes.indexOf(correctNode(node, nodes));
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/solver.js



var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes - used to control "return focus"
 * @param innerTabbables - used to control "autofocus"
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) {
            return lastNodeInside;
        }
        return NEW_FOCUS;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function (node) { return node.tabIndex >= 0; });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0
        ? // old/new are tabbables, measure distance in tabbable space
            previousTabbableIndex - currentTabbableIndex
        : // or else measure in focusable space
            previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) {
        // an edge case with no tabbable elements
        // return the last focusable one
        // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
        return lastNodeInside;
    }
    var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
    var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/auto-focus.js



var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/utils/parenting.js



var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/focusSolver.js








var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * contains the main logic of the `focus-lock` package.
 *
 * ! you probably dont need this function !
 *
 * given top node(s) and the last active element returns the element to be focused next
 * @returns element which should be focused to move focus inside
 * @param topNode
 * @param lastNode
 */
var focusSolver = function (topNode, lastNode) {
    var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getFocusableNodes(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        return undefined;
    }
    var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function (_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = 
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries, visibilityCache)) ||
            pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/moveFocusInside.js


var guardCount = 0;
var lockDisabled = false;
/**
 * The main functionality of the focus-lock package
 *
 * Contains focus at a given node.
 * The last focused element will help to determine which element(first or last) should be focused.
 * The found element will be focused.
 *
 * This is one time action (move), not a persistent focus-lock
 *
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @see {@link focusSolver} for the same functionality without autofocus
 */
var moveFocusInside = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = focusSolver(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/
        if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/return-focus.js

function weakRef(value) {
    if (!value)
        return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') {
        return function () { return value || null; };
    }
    var w = value ? new WeakRef(value) : null;
    return function () { return (w === null || w === void 0 ? void 0 : w.deref()) || null; };
}
var recordElementLocation = function (element) {
    if (!element) {
        return null;
    }
    var stack = [];
    var currentElement = element;
    while (currentElement && currentElement !== document.body) {
        stack.push({
            current: weakRef(currentElement),
            parent: weakRef(currentElement.parentElement),
            left: weakRef(currentElement.previousElementSibling),
            right: weakRef(currentElement.nextElementSibling),
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument,
    };
};
var restoreFocusTo = function (location) {
    var _a, _b, _c, _d, _e;
    if (!location) {
        return undefined;
    }
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = getTabbableNodes([parent_1], visibilityCache);
            var aim = 
            // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : 
            // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : 
            // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : 
            // or somebody to the left, something?
            left;
            while (aim) {
                for (var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++) {
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) {
                        return focusable.node;
                    }
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) {
                // if parent contains a focusable - move there
                return focusables[0].node;
            }
        }
    }
    // nothing matched
    return undefined;
};
/**
 * Captures the current focused element to restore focus as close as possible in the future
 * Handles situations where the focused element is removed from the DOM or no longer focusable
 * moving focus to the closest focusable element
 * @param targetElement - element where focus should be restored
 * @returns a function returning a new element to focus
 */
var captureFocusRestore = function (targetElement) {
    var location = recordElementLocation(targetElement);
    return function () {
        return restoreFocusTo(location);
    };
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/focusables.js





/**
 * traverses all related nodes (including groups) returning a list of all nodes(outer and internal) with meta information
 * This is low-level API!
 * @returns list of focusable elements inside a given top(!) node.
 * @see {@link getFocusableNodes} providing a simpler API
 */
var expandFocusableNodes = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
    var innerElements = getFocusables(entries, false);
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

;// CONCATENATED MODULE: ../../node_modules/focus-lock/dist/es2015/sibling.js



/**
 * for a given `element` in a given `scope` returns focusable siblings
 * @param element - base element
 * @param scope - common parent. Can be document, but better to narrow it down for performance reasons
 * @returns {prev,next} - references to a focusable element before and after
 * @returns undefined - if operation is not applicable
 */
var getRelativeFocusable = function (element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = asArray(scope);
    if (shards.every(function (shard) { return !contains(shard, element); })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables
        ? getTabbableNodes(shards, new Map())
        : getFocusableNodes(shards, new Map());
    var current = focusables.findIndex(function (_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) {
        // an edge case, when anchor element is not found
        return undefined;
    }
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1],
    };
};
var getBoundary = function (shards, useTabbables) {
    var set = useTabbables
        ? getTabbableNodes(asArray(shards), new Map())
        : getFocusableNodes(asArray(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1],
    };
};
var defaultOptions = function (options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true,
    }, options);
};
var moveFocus = function (fromElement, options, cb) {
    if (options === void 0) { options = {}; }
    var newOptions = defaultOptions(options);
    var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) {
        return;
    }
    var target = cb(solution, newOptions.cycle);
    if (target) {
        focusOn(target.node, newOptions.focusOptions);
    }
};
/**
 * focuses next element in the tab-order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusNextElement = function (fromElement, options) {
    if (options === void 0) { options = {}; }
    moveFocus(fromElement, options, function (_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || (cycle && first);
    });
};
/**
 * focuses prev element in the tab order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusPrevElement = function (fromElement, options) {
    if (options === void 0) { options = {}; }
    moveFocus(fromElement, options, function (_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || (cycle && last);
    });
};
var pickBoundary = function (scope, options, what) {
    var _a;
    var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) {
        focusOn(node.node, options.focusOptions);
    }
};
/**
 * focuses first element in the tab-order
 * @param {FocusNextOptions} options - focus options
 */
var focusFirstElement = function (scope, options) {
    if (options === void 0) { options = {}; }
    pickBoundary(scope, options, 'first');
};
/**
 * focuses last element in the tab order
 * @param {FocusNextOptions} options - focus options
 */
var focusLastElement = function (scope, options) {
    if (options === void 0) { options = {}; }
    pickBoundary(scope, options, 'last');
};

;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};
var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/Trap.js






var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var tryRestoreFocus = function tryRestoreFocus() {
  return null;
};
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var windowFocused = false;
var defaultWhitelist = function defaultWhitelist() {
  return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;
  do {
    var item = allNodes[i];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === 'meanwhile';
};
var checkInHost = function checkInHost(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};
var getNodeFocusables = function getNodeFocusables(nodes) {
  return getFocusableNodes(nodes, new Map());
};
var isNotFocusable = function isNotFocusable(node) {
  return !getNodeFocusables([node.parentNode]).some(function (el) {
    return el.node === node;
  });
};
var activateTrap = function activateTrap() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
      observed = _lastActiveTrap.observed,
      persistentFocus = _lastActiveTrap.persistentFocus,
      autoFocus = _lastActiveTrap.autoFocus,
      shards = _lastActiveTrap.shards,
      crossFrame = _lastActiveTrap.crossFrame,
      focusOptions = _lastActiveTrap.focusOptions,
      noFocusGuards = _lastActiveTrap.noFocusGuards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body) {
      if (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus)) {
        var newTarget = tryRestoreFocus();
        if (newTarget) {
          newTarget.focus();
        }
      }
    }
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
        if (!focusWasOutside(crossFrame) || !noFocusGuards || !lastActiveFocus || windowFocused) {
          return false;
        }
        var nodes = getNodeFocusables(workingArea);
        var lastIndex = nodes.findIndex(function (_ref) {
          var node = _ref.node;
          return node === lastActiveFocus;
        });
        return lastIndex === 0 || lastIndex === nodes.length - 1;
      };
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || shouldForceRestoreFocus() || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }
          lastActiveFocus = document && document.activeElement;
          if (lastActiveFocus !== document.body) {
            tryRestoreFocus = captureFocusRestore(lastActiveFocus);
          }
          focusWasOutsideWindow = false;
        }
      }
      if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function (_ref2) {
          var node = _ref2.node;
          return node;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function (_ref3) {
            var guard = _ref3.guard,
              node = _ref3.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref4) {
            var node = _ref4.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher() {
  return null;
};
var FocusTrap = function FocusTrap(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/react.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};
FocusTrap.propTypes =  false ? 0 : {};
var onWindowFocus = function onWindowFocus() {
  windowFocused = true;
};
var onWindowBlur = function onWindowBlur() {
  windowFocused = false;
  focusWasOutsideWindow = 'just';
  deferAction(function () {
    focusWasOutsideWindow = 'meanwhile';
  });
};
var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('focus', onWindowFocus);
  window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('focus', onWindowFocus);
  window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function (_ref6) {
    var disabled = _ref6.disabled;
    return !disabled;
  });
}
var focusLockAPI = {
  moveFocusInside: moveFocusInside,
  focusInside: focusInside,
  focusNextElement: focusNextElement,
  focusPrevElement: focusPrevElement,
  focusFirstElement: focusFirstElement,
  focusLastElement: focusLastElement,
  captureFocusRestore: captureFocusRestore
};
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function (_ref7) {
      var id = _ref7.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation(focusLockAPI);
    }
    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb(focusLockAPI);
});
/* harmony default export */ var Trap = (index_es(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/Combination.js





var FocusLockCombination = /*#__PURE__*/(0,react.forwardRef)(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/react.createElement(Lock, (0,esm_extends/* default */.Z)({
    sideCar: Trap,
    ref: ref
  }, props));
});
var _ref = Lock.propTypes || {},
  sideCar = _ref.sideCar,
  propTypes = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["sideCar"]);
FocusLockCombination.propTypes =  false ? 0 : {};
/* harmony default export */ var Combination = (FocusLockCombination);
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js





var AutoFocusInside = function AutoFocusInside(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className;
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, inlineProp(FOCUS_AUTO, !disabled), {
    className: className
  }), children);
};
AutoFocusInside.propTypes =  false ? 0 : {};
/* harmony default export */ var es2015_AutoFocusInside = (AutoFocusInside);
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/MoveFocusInside.js






var useFocusInside = function useFocusInside(observedRef) {
  (0,react.useEffect)(function () {
    var enabled = true;
    mediumEffect.useMedium(function (car) {
      var observed = observedRef && observedRef.current;
      if (enabled && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
    return function () {
      enabled = false;
    };
  }, [observedRef]);
};
function MoveFocusInside(_ref) {
  var _ref$disabled = _ref.disabled,
    isDisabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className,
    children = _ref.children;
  var ref = (0,react.useRef)(null);
  useFocusInside(isDisabled ? undefined : ref);
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, inlineProp(FOCUS_AUTO, !isDisabled), {
    ref: ref,
    className: className
  }), children);
}
MoveFocusInside.propTypes =  false ? 0 : {};
/* harmony default export */ var es2015_MoveFocusInside = (MoveFocusInside);
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/FreeFocusInside.js





var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, inlineProp(FOCUS_ALLOW, true), {
    className: className
  }), children);
};
FreeFocusInside.propTypes =  false ? 0 : {};
/* harmony default export */ var es2015_FreeFocusInside = (FreeFocusInside);
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/use-focus-scope.js





var collapseRefs = function collapseRefs(shards) {
  return shards.map(extractRef).filter(Boolean);
};
var withMedium = function withMedium(fn) {
  return new Promise(function (resolve) {
    return mediumEffect.useMedium(function () {
      resolve(fn.apply(void 0, arguments));
    });
  });
};
var useFocusController = function useFocusController() {
  for (var _len = arguments.length, shards = new Array(_len), _key = 0; _key < _len; _key++) {
    shards[_key] = arguments[_key];
  }
  if (!shards.length) {
    throw new Error('useFocusController requires at least one target element');
  }
  var ref = (0,react.useRef)(shards);
  ref.current = shards;
  return (0,react.useMemo)(function () {
    return {
      autoFocus: function autoFocus(focusOptions) {
        if (focusOptions === void 0) {
          focusOptions = {};
        }
        return withMedium(function (car) {
          return car.moveFocusInside(collapseRefs(ref.current), null, focusOptions);
        });
      },
      focusNext: function focusNext(options) {
        return withMedium(function (car) {
          car.moveFocusInside(collapseRefs(ref.current), null);
          car.focusNextElement(document.activeElement, (0,esm_extends/* default */.Z)({
            scope: collapseRefs(ref.current)
          }, options));
        });
      },
      focusPrev: function focusPrev(options) {
        return withMedium(function (car) {
          car.moveFocusInside(collapseRefs(ref.current), null);
          car.focusPrevElement(document.activeElement, (0,esm_extends/* default */.Z)({
            scope: collapseRefs(ref.current)
          }, options));
        });
      },
      focusFirst: function focusFirst(options) {
        return withMedium(function (car) {
          car.focusFirstElement(collapseRefs(ref.current), options);
        });
      },
      focusLast: function focusLast(options) {
        return withMedium(function (car) {
          car.focusLastElement(collapseRefs(ref.current), options);
        });
      }
    };
  }, []);
};
var useFocusScope = function useFocusScope() {
  var scope = (0,react.useContext)(focusScope);
  if (!scope) {
    throw new Error('FocusLock is required to operate with FocusScope');
  }
  return useFocusController.apply(void 0, [scope.observed].concat(scope.shards));
};
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/nano-events.js
var createNanoEvents = function createNanoEvents() {
  return {
    emit: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      for (var i = 0, callbacks = this.events[event] || [], length = callbacks.length; i < length; i++) {
        callbacks[i].apply(callbacks, args);
      }
    },
    events: {},
    on: function on(event, cb) {
      var _this$events,
        _this = this;
      ((_this$events = this.events)[event] || (_this$events[event] = [])).push(cb);
      return function () {
        var _this$events$event;
        _this.events[event] = (_this$events$event = _this.events[event]) == null ? void 0 : _this$events$event.filter(function (i) {
          return cb !== i;
        });
      };
    }
  };
};
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/use-focus-state.js


var mainbus = createNanoEvents();
var subscribeCounter = 0;
var onFocusIn = function onFocusIn(event) {
  return mainbus.emit('assign', event.target);
};
var onFocusOut = function onFocusOut(event) {
  return mainbus.emit('reset', event.target);
};
var useDocumentFocusSubscribe = function useDocumentFocusSubscribe() {
  (0,react.useEffect)(function () {
    if (!subscribeCounter) {
      document.addEventListener('focusin', onFocusIn);
      document.addEventListener('focusout', onFocusOut);
    }
    subscribeCounter += 1;
    return function () {
      subscribeCounter -= 1;
      if (!subscribeCounter) {
        document.removeEventListener('focusin', onFocusIn);
        document.removeEventListener('focusout', onFocusOut);
      }
    };
  }, []);
};
var getFocusState = function getFocusState(target, current) {
  if (target === current) {
    return 'self';
  }
  if (current.contains(target)) {
    return 'within';
  }
  return 'within-boundary';
};
var useFocusState = function useFocusState(callbacks) {
  if (callbacks === void 0) {
    callbacks = {};
  }
  var _useState = (0,react.useState)(false),
    active = _useState[0],
    setActive = _useState[1];
  var _useState2 = (0,react.useState)(''),
    state = _useState2[0],
    setState = _useState2[1];
  var ref = (0,react.useRef)(null);
  var focusState = (0,react.useRef)({});
  var stateTracker = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    if (ref.current) {
      var isAlreadyFocused = ref.current === document.activeElement || ref.current.contains(document.activeElement);
      setActive(isAlreadyFocused);
      setState(getFocusState(document.activeElement, ref.current));
      if (isAlreadyFocused && callbacks.onFocus) {
        callbacks.onFocus();
      }
    }
  }, []);
  var onFocus = (0,react.useCallback)(function (e) {
    focusState.current = {
      focused: true,
      state: getFocusState(e.target, e.currentTarget)
    };
  }, []);
  useDocumentFocusSubscribe();
  (0,react.useEffect)(function () {
    var fout = mainbus.on('reset', function () {
      focusState.current = {};
    });
    var fin = mainbus.on('assign', function () {
      var newState = focusState.current.focused || false;
      setActive(newState);
      setState(focusState.current.state || '');
      if (newState !== stateTracker.current) {
        stateTracker.current = newState;
        if (newState) {
          callbacks.onFocus && callbacks.onFocus();
        } else {
          callbacks.onBlur && callbacks.onBlur();
        }
      }
    });
    return function () {
      fout();
      fin();
    };
  }, []);
  return {
    active: active,
    state: state,
    onFocus: onFocus,
    ref: ref
  };
};
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/UI.js








/* harmony default export */ var UI = ((/* unused pure expression or super */ null && (FocusLockUI)));
;// CONCATENATED MODULE: ../../node_modules/react-focus-lock/dist/es2015/index.js


/* harmony default export */ var es2015 = (Combination);

/***/ }),

/***/ 25890:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 72621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(25890);
} else {}


/***/ }),

/***/ 15247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 95831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(34885);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44661);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(8131);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(2386);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(52775);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(2447);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(15247);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 2386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(34885);

var _propTypes = __webpack_require__(8131);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(62520);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(39110);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(52775);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(3037);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(2447);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(39508);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(18876);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 52775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(84313);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(2447);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 18876:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(39508);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 3037:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 62520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(56390);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 39508:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 2447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(32953);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 39110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(56390);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 56390:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

// match the whole word to prevent fuzzy searching
var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 34434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(95831);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 71682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Provider": function() { return /* reexport */ components_Provider; },
  "ReactReduxContext": function() { return /* reexport */ ReactReduxContext; },
  "batch": function() { return /* reexport */ react_dom.unstable_batchedUpdates; },
  "connect": function() { return /* reexport */ components_connect; },
  "createDispatchHook": function() { return /* reexport */ createDispatchHook; },
  "createSelectorHook": function() { return /* reexport */ createSelectorHook; },
  "createStoreHook": function() { return /* reexport */ createStoreHook; },
  "shallowEqual": function() { return /* reexport */ shallowEqual; },
  "useDispatch": function() { return /* reexport */ useDispatch; },
  "useSelector": function() { return /* reexport */ useSelector; },
  "useStore": function() { return /* reexport */ useStore_useStore; }
});

// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(30926);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(70821);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(44661);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/Context.js

const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis :
/* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
{};

function getContext() {
  var _gT$ContextKey;

  if (!react.createContext) return {};
  const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
  let realContext = contextMap.get(react.createContext);

  if (!realContext) {
    realContext = react.createContext(null);

    if (false) {}

    contextMap.set(react.createContext, realContext);
  }

  return realContext;
}

const ReactReduxContext = /*#__PURE__*/getContext();
/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext() {
    const contextValue = (0,react.useContext)(context);

    if (false) {}

    return contextValue;
  };
}
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

const useReduxContext_useReduxContext = /*#__PURE__*/createReduxContextHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/useSyncExternalStore.js
const notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};

const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : createReduxContextHook(context);
  return function useSelector(selector, equalityFnOrOptions = {}) {
    const {
      equalityFn = refEquality,
      stabilityCheck = undefined,
      noopCheck = undefined
    } = typeof equalityFnOrOptions === 'function' ? {
      equalityFn: equalityFnOrOptions
    } : equalityFnOrOptions;

    if (false) {}

    const {
      store,
      subscription,
      getServerState,
      stabilityCheck: globalStabilityCheck,
      noopCheck: globalNoopCheck
    } = useReduxContext();
    const firstRun = (0,react.useRef)(true);
    const wrappedSelector = (0,react.useCallback)({
      [selector.name](state) {
        const selected = selector(state);

        if (false) {}

        return selected;
      }

    }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(61393);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(12720);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(83138);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../../node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(85610);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/selectorFactory.js

const _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, {
  areStatesEqual,
  areOwnPropsEqual,
  areStatePropsEqual
}) {
  let hasRunAtLeastOnce = false;
  let state;
  let ownProps;
  let stateProps;
  let dispatchProps;
  let mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    const nextStateProps = mapStateToProps(state, ownProps);
    const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
// TODO: Add more comments
// The selector returned by selectorFactory will memoize its results,
// allowing connect's shouldComponentUpdate to return false if final
// props have not changed.
function finalPropsSelectorFactory(dispatch, _ref) {
  let {
    initMapStateToProps,
    initMapDispatchToProps,
    initMergeProps
  } = _ref,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);

  const mapStateToProps = initMapStateToProps(dispatch, options);
  const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  const mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  const boundActionCreators = {};

  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = (...args) => dispatch(actionCreator(...args));
    }
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant( // * Note:
//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
  return function initConstantSelector(dispatch) {
    const constant = getConstant(dispatch);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, {
    displayName
  }) {
    const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      let props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/invalidArgFactory.js
function createInvalidArgFactory(arg, name) {
  return (dispatch, options) => {
    throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mapDispatchToProps.js



function mapDispatchToPropsFactory(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(dispatch => // @ts-ignore
  bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant(dispatch => ({
    dispatch
  })) : typeof mapDispatchToProps === 'function' ? // @ts-ignore
  wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : createInvalidArgFactory(mapDispatchToProps, 'mapDispatchToProps');
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mapStateToProps.js


function mapStateToPropsFactory(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(() => ({})) : typeof mapStateToProps === 'function' ? // @ts-ignore
  wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : createInvalidArgFactory(mapStateToProps, 'mapStateToProps');
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mergeProps.js



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  // @ts-ignore
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, {
    displayName,
    areMergedPropsEqual
  }) {
    let hasRunOnce = false;
    let mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function mergePropsFactory(mergeProps) {
  return !mergeProps ? () => defaultMergeProps : typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, 'mergeProps');
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },

    notify() {
      batch(() => {
        let listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },

    get() {
      let listeners = [];
      let listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },

    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }

  };
}

const nullListeners = {
  notify() {},

  get: () => []
};
function createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners; // Reasons to keep the subscription active

  let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)

  let selfSubscribed = false;

  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener); // cleanup nested sub

    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return selfSubscribed;
  }

  function trySubscribe() {
    subscriptionsAmount++;

    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    subscriptionsAmount--;

    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }

  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }

  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/connect.js


const connect_excluded = ["reactReduxForwardedRef"];

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = notInitialized;
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = [null, null]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage


function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, // actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.


function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, // forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it


    const latestStoreState = store.getState();
    let newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer


const initStateUpdates = () => EMPTY_ARRAY;

function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */


let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}

  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);

  const wrapWithConnect = WrappedComponent => {
    if (false) {}

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };

    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = react.useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
          reactReduxForwardedRef
        } = props,
              wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, connect_excluded);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = react.useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && // @ts-ignore
        (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = react.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = react.useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = react.useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = react.useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = react.useRef();
      const lastWrapperProps = react.useRef(wrapperProps);
      const childPropsFromStoreUpdate = react.useRef();
      const renderIsScheduled = react.useRef(false);
      const isProcessingDispatch = react.useRef(false);
      const isMounted = react.useRef(false);
      const latestSubscriptionCallbackError = react.useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = react.useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.


          return childPropsSelector(store.getState(), wrapperProps);
        };

        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = react.useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }

          return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };

        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;

      try {
        actualChildProps = useSyncExternalStore( // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }

        throw err;
      }

      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = react.useMemo(() => {
        return (
          /*#__PURE__*/
          // @ts-ignore
          react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = react.useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }

    const _Connect = react.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      const _forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };

  return wrapWithConnect;
}

/* harmony default export */ var components_connect = (connect);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/Provider.js





function Provider({
  store,
  context,
  children,
  serverState,
  stabilityCheck = 'once',
  noopCheck = 'once'
}) {
  const contextValue = react.useMemo(() => {
    const subscription = createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined,
      stabilityCheck,
      noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  const previousState = react.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useStore.js


/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = ReactReduxContext) {
  const useReduxContext = // @ts-ignore
  context === ReactReduxContext ? useReduxContext_useReduxContext : // @ts-ignore
  createReduxContextHook(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = ReactReduxContext) {
  const useStore = // @ts-ignore
  context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ../../node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 43342:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 85610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43342);
} else {}


/***/ }),

/***/ 96775:
/***/ (function(module) {

!function(n,t){ true?module.exports=t():0}("undefined"!=typeof self?self:this,function(){return function(n){var t={};function e(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return n[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}return e.m=n,e.c=t,e.d=function(n,t,r){e.o(n,t)||Object.defineProperty(n,t,{enumerable:!0,get:r})},e.r=function(n){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(n,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(n,"__esModule",{value:!0})},e.t=function(n,t){if(1&t&&(n=e(n)),8&t)return n;if(4&t&&"object"==typeof n&&n&&n.__esModule)return n;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:n}),2&t&&"string"!=typeof n)for(var o in n)e.d(r,o,function(t){return n[t]}.bind(null,o));return r},e.n=function(n){var t=n&&n.__esModule?function(){return n.default}:function(){return n};return e.d(t,"a",t),t},e.o=function(n,t){return Object.prototype.hasOwnProperty.call(n,t)},e.p="",e(e.s=0)}([function(n,t,e){"use strict";function r(n){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(n){return typeof n}:function(n){return n&&"function"==typeof Symbol&&n.constructor===Symbol&&n!==Symbol.prototype?"symbol":typeof n})(n)}function o(n,t,e){return t in n?Object.defineProperty(n,t,{value:e,enumerable:!0,configurable:!0,writable:!0}):n[t]=e,n}function i(n,t){if(!(n instanceof t))throw new TypeError("Cannot call a class as a function")}function u(n,t){for(var e=0;e<t.length;e++){var r=t[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r)}}function a(n,t,e){return t&&u(n.prototype,t),e&&u(n,e),n}e.r(t);var f=function(){function n(t,e,r){i(this,n),this.name=t,this.from=e,this.to=r}return a(n,[{key:"css",value:function(n){return this.mediaQuery?"@media ".concat(this.mediaQuery," {\n                ").concat(n,"\n            }"):n}},{key:"cssObject",value:function(n){return this.mediaQuery?o({},"@media ".concat(this.mediaQuery),n):n}},{key:"isInfinite",get:function(){return void 0===this.to||null===this.to}},{key:"isCurrent",get:function(){return this.from<=window.innerWidth&&(void 0===this.to||window.innerWidth<=this.to)}},{key:"mediaQuery",get:function(){var n="undefined"===this.from||null===this.from||0===this.from?void 0:"(min-width: ".concat(this.from,"px)"),t=this.isInfinite?void 0:"(max-width: ".concat(this.to,"px)");return n&&t?"".concat(n," and ").concat(t):!n&&t?t:n&&!t?n:void 0}}]),n}(),c=function(){function n(t){i(this,n),this._rangesArray=[];var e=Object.entries(t);e=e.sort(function(n,t){return n[1]-t[1]});for(var r=0;r<e.length;r++){var o=e[r],u=o[0],a=o[1],c=void 0;r<e.length-1&&(c=e[r+1][1]-1);var s=new f(u,a,c);this._rangesArray.push(s),this[u]=s}}return a(n,[{key:"get",value:function(n){for(var t=0;t<this._rangesArray.length;t++)if(this._rangesArray[t].name===n)return this._rangesArray[t]}},{key:"fromTo",value:function(n,t){var e=this.get(n),r=this.get(t);return new f(void 0,e.from,r.to)}},{key:"from",value:function(n){var t=this.get(n);return new f(void 0,t.from,void 0)}},{key:"to",value:function(n){var t=this.get(n);return new f(void 0,0,t.to)}},{key:"map",get:function(){var n={};return this.array.forEach(function(t){n[t.name]=t}),n}},{key:"array",get:function(){return this._rangesArray}},{key:"first",get:function(){return this._rangesArray[0]}},{key:"second",get:function(){return this._rangesArray[1]}},{key:"last",get:function(){return this._rangesArray[this._rangesArray.length-1]}},{key:"current",get:function(){for(var n=0;n<this._rangesArray.length;n++)if(this._rangesArray[n].isCurrent)return this._rangesArray[n]}}]),n}(),s=new c({xs:0,xs_plus:420,sm:720,md:960,lg:1200,lg_plus:1366,xl:1600,xl_plus:2e3}),l="undefined"!=typeof __RANGES__?new c(__RANGES__):s,v=function(){function n(t,e){var o;if(i(this,n),"object"===r(t)){var u=!0;Object.keys(t).forEach(function(n){!l.get(n)&&isNaN(parseInt(n))&&(u=!1)}),o=u?t:{0:t}}else o={0:t};Object.keys(o).forEach(function(t){var e=o[t];delete o[t],o[n._normalizeKey(t)]=e}),this._map=o}return a(n,[{key:"get",value:function(n){return this._map[n]}},{key:"set",value:function(n,t){this._map[n]=t}},{key:"value",value:function(n){var t;return this.forEach(function(e,r){r.from<=n&&(r.isInfinite||n<=r.to)&&(t=e)}),t}},{key:"forEach",value:function(n){var t=this;this.rangeSet.array.forEach(function(e){n(t._map[e.name],e)})}},{key:"crosssect",value:function(t){for(var e,r,o,i=this,u=this.rangeSet,a=t.rangeSet,f=0,c=0,s=0,l=null,v=null,y={},p=function(){e!==s&&(y[s]={val1:i.get(l.name),val2:t.get(v.name)})};;){if(r=u.array[f],o=a.array[c],void 0===r&&void 0===o){e=null,p();break}void 0===r?(e=o.from,p(),v=o,c++):void 0===o?(e=r.from,p(),l=r,f++):r.from>=o.from?(e=o.from,p(),v=o,c++):(e=r.from,p(),l=r,f++),s=e}return new n(y)}},{key:"css",value:function(n){var t="";return this.forEach(function(e,r){t+=r.css(n(e,r))}),t}},{key:"cssObject",value:function(n){var t={};return this.forEach(function(e,r){t=function(n){for(var t=1;t<arguments.length;t++){var e=null!=arguments[t]?arguments[t]:{},r=Object.keys(e);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(e).filter(function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),r.forEach(function(t){o(n,t,e[t])})}return n}({},t,r.cssObject(n(e,r)))}),t}},{key:"rangeSet",get:function(){var n=Object.keys(this._map),t={};return n.forEach(function(n){t[n]=parseInt(n)}),new c(t)}},{key:"current",get:function(){return this.value(window.innerWidth)}}]),n}();function y(n){return n instanceof v?n:new v(n)}v._normalizeKey=function(n){return"string"==typeof n&&isNaN(parseInt(n))?l.get(n).from:n};var p=l;function m(n,t,e){return(m=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(n){return!1}}()?Reflect.construct:function(n,t,e){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(n,r));return e&&h(o,e.prototype),o}).apply(null,arguments)}function h(n,t){return(h=Object.setPrototypeOf||function(n,t){return n.__proto__=t,n})(n,t)}function d(n){for(var t=1;t<arguments.length;t++){var e=null!=arguments[t]?arguments[t]:{},r=Object.keys(e);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(e).filter(function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),r.forEach(function(t){b(n,t,e[t])})}return n}function b(n,t,e){return t in n?Object.defineProperty(n,t,{value:e,enumerable:!0,configurable:!0,writable:!0}):n[t]=e,n}function g(n){return(g="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(n){return typeof n}:function(n){return n&&"function"==typeof Symbol&&n.constructor===Symbol&&n!==Symbol.prototype?"symbol":typeof n})(n)}function _(n,t){if(!(n instanceof t))throw new TypeError("Cannot call a class as a function")}function w(n,t){for(var e=0;e<t.length;e++){var r=t[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r)}}function k(n,t,e){return t&&w(n.prototype,t),e&&w(n,e),n}var O=function(){function n(){var t=this;_(this,n),this._vals={};for(var e=arguments.length,r=new Array(e),o=0;o<e;o++)r[o]=arguments[o];r.forEach(function(n){t.add$(n)})}return k(n,[{key:"clone",value:function(){var t=[];return Object.entries(this._vals).forEach(function(n){var e=n[0],r=n[1];t.push({unit:e,val:"object"===g(r)?d({},r):r})}),m(n,t)}},{key:"add",value:function(n){return this.clone().add$(n)}},{key:"add$",value:function(t){var e=this;return n._normalizeVal(t).forEach(function(n){"lin"===n.unit?(e._vals.lin||(e._vals.lin={from:0,slope:0}),e._vals.lin.from+=n.val.from,e._vals.lin.slope+=n.val.slope):(e._vals[n.unit]||(e._vals[n.unit]=0),e._vals[n.unit]+=n.val)}),this}},{key:"subtract",value:function(t){return this.clone().add$(new n(t).multiply$(-1))}},{key:"multiply$",value:function(n){var t=this;return Object.entries(this._vals).forEach(function(e){var r=e[0],o=e[1];"lin"===r?(o.from*=n,o.slope*=n):t._vals[r]*=n}),this}},{key:"multiply",value:function(n){return this.clone().multiply$(n)}},{key:"divide",value:function(n){return this.clone().multiply$(1/n)}},{key:"getValueFromOffset",value:function(n){var t=this.clone();return t.vals.lin&&(t.vals.lin.from+=t.vals.lin.slope*n),t}},{key:"val",value:function(n,t){return t=t||0,"px"===n?this._vals.lin?this._vals.lin.from+this._vals.lin.slope*t:0:this._vals[n]?this._vals[n]:0}},{key:"css",value:function(n){var t="";return Object.entries(this._vals).forEach(function(e){var r=e[0],o=e[1];""!==t&&(t+=" + "),"lin"===e[0]?t+="".concat(o.slope,"*100vw + ").concat(-o.slope*n+o.from,"px"):t+="".concat(o).concat(r)}),"calc(".concat(t,")")}},{key:"vals",get:function(){return this._vals}}]),n}();O._normalizeVal=function(n){if(n instanceof O){var t=[];return Object.entries(n.vals).forEach(function(n){t.push({unit:n[0],val:n[1]})}),t}if(Array.isArray(n))return[{unit:"lin",val:{from:n[0],slope:n[1]}}];if("object"===g(n))return[n];if("number"==typeof n)return[{unit:"lin",val:{from:n,slope:0}}];if("string"==typeof n){var e=n.match(/([\d\.]+)([a-z%]*)/),r=parseFloat(e[1]),o=e[2];return""===o||"px"===o?[{unit:"lin",val:{from:r,slope:0}}]:[{unit:o,val:r}]}throw"Bad input argument for _normalizeVal in ResponsiveSizeSegmentValue"};var j=function(){function n(t){if(_(this,n),void 0===t||"null"==typeof t)throw new Error("ResponsiveSize must not be constructed with undefined or null");if(Array.isArray(t))throw new Error("ResponsiveSize must not be constructed with array: ".concat(t,". Maybe you meant rslin instead of rs?"));if("object"!==g(t))t={0:t};else if(0===Object.keys(t).length)throw new Error("ResponsiveSize input object can't be empty!");var e;e=t instanceof v?t:new v(t);var r=new v({});e.forEach(function(t,o){t instanceof O?r.set(o.from,{rssv:t,from:o.from}):t instanceof n?t._rangeMap.crosssect(e).forEach(function(n,t){var e=n.val1;n.val2;o.from<=t.from&&(o.isInfinite||t.to<=o.to)&&r.set(t.from,{rssv:e.rssv.getValueFromOffset(t.from-e.from),from:t.from})}):r.set(o.from,{rssv:new O(t),from:o.from})}),this._rangeMap=r}return k(n,[{key:"css",value:function(n){return this._rangeMap.css(function(t,e){return"".concat(function(n){return n.replace(/([A-Z])/g,function(n){return"-".concat(n[0].toLowerCase())})}(n),": ").concat(t.rssv.css(e.from),";")})}},{key:"cssObject",value:function(n){return this._rangeMap.cssObject(function(t,e){return b({},n,t.rssv.css(e.from))})}},{key:"multiply",value:function(t){var e=n._normalizeScalarInput(t),r={};return e.crosssect(this._rangeMap).forEach(function(n,t){var e=n.val1,o=n.val2.rssv;r[t.from]=o.multiply(e)}),new n(r)}},{key:"divide",value:function(t){var e=n._normalizeScalarInput(t),r={};return e.forEach(function(n,t){r[t.from]=1/n}),this.multiply(r)}},{key:"add",value:function(t){t=E(t);var e=this.map.crosssect(t.map),r={};return e.forEach(function(n,t){var e=n.val1.from,o=n.val1.rssv.getValueFromOffset(t.from-e),i=n.val2.from,u=n.val2.rssv.getValueFromOffset(t.from-i),a=o.add(u);r[t.from]=a}),new n(r)}},{key:"subtract",value:function(n){return n=E(n),this.add(n.multiply(-1))}},{key:"val",value:function(n,t){var e=this._rangeMap.value(n).from,r=this._rangeMap.value(n).rssv;return void 0===t?r:r.val(t,n-e)}},{key:"map",get:function(){return this._rangeMap}}]),n}();function S(n){return new O(n)}function E(n){return n instanceof j?n:new j(n)}function A(n,t,e){e=e||!1;var r={0:n},o=(t-n)/(p.last.from-p.second.from);return r[p.second.from]=[n,o],e||(r[p.last.from]=t),new j(r)}j._normalizeScalarInput=function(n){var t;if(n instanceof v)t=n;else if("object"===g(n))t=new v(n);else{if("number"!=typeof n)throw new Error("bad input for RangeMap.multiply or RangeMap.divide");t=new v({0:n})}return t},e.d(t,"ResponsiveSize",function(){return j}),e.d(t,"ResponsiveSizeSegmentValue",function(){return O}),e.d(t,"rs",function(){return E}),e.d(t,"rssv",function(){return S}),e.d(t,"rslin",function(){return A}),e.d(t,"RangeMap",function(){return v}),e.d(t,"RangeSet",function(){return c}),e.d(t,"Range",function(){return f}),e.d(t,"rm",function(){return y}),e.d(t,"R",function(){return p})}])});

/***/ }),

/***/ 27687:
/***/ (function(module) {

/**
 * Promise wrapper for superagent
 */

function wrap(superagent, Promise) {
  /**
   * Request object similar to superagent.Request, but with end() returning
   * a promise.
   */
  function PromiseRequest() {
    superagent.Request.apply(this, arguments);
  }

  // Inherit form superagent.Request
  PromiseRequest.prototype = Object.create(superagent.Request.prototype);

  /** Send request and get a promise that `end` was emitted */
  PromiseRequest.prototype.end = function(cb) {
    var _end = superagent.Request.prototype.end;
    var self = this;

    return new Promise(function(accept, reject) {
      _end.call(self, function(err, response) {
        if (cb) {
          cb(err, response);
        }

        if (err) {
          err.response = response;
          reject(err);
        } else {
          accept(response);
        }
      });
    });
  };

  /** Provide a more promise-y interface */
  PromiseRequest.prototype.then = function(resolve, reject) {
    var _end = superagent.Request.prototype.end;
    var self = this;

    return new Promise(function(accept, reject) {
      _end.call(self, function(err, response) {
        if (err) {
          err.response = response;
          reject(err);
        } else {
          accept(response);
        }
      });
    }).then(resolve, reject);
  };

  /**
   * Request builder with same interface as superagent.
   * It is convenient to import this as `request` in place of superagent.
   */
  var request = function(method, url) {
    return new PromiseRequest(method, url);
  };

  /** Helper for making an options request */
  request.options = function(url) {
    return request('OPTIONS', url);
  }

  /** Helper for making a head request */
  request.head = function(url, data) {
    var req = request('HEAD', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a get request */
  request.get = function(url, data) {
    var req = request('GET', url);
    if (data) {
      req.query(data);
    }
    return req;
  };

  /** Helper for making a post request */
  request.post = function(url, data) {
    var req = request('POST', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a put request */
  request.put = function(url, data) {
    var req = request('PUT', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a patch request */
  request.patch = function(url, data) {
    var req = request('PATCH', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a delete request */
  request.del = function(url) {
    return request('DELETE', url);
  };

  // Export the request builder
  return request;
}

module.exports = wrap;


/***/ }),

/***/ 15312:
/***/ (function(module) {

"use strict";


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function Agent() {
  this._defaults = [];
}

['use', 'on', 'once', 'set', 'query', 'type', 'accept', 'auth', 'withCredentials', 'sortQuery', 'retry', 'ok', 'redirects', 'timeout', 'buffer', 'serialize', 'parse', 'ca', 'key', 'pfx', 'cert', 'disableTLSCerts'].forEach(function (fn) {
  // Default setting for all requests from this agent
  Agent.prototype[fn] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this._defaults.push({
      fn: fn,
      args: args
    });

    return this;
  };
});

Agent.prototype._setDefaults = function (req) {
  this._defaults.forEach(function (def) {
    req[def.fn].apply(req, _toConsumableArray(def.args));
  });
};

module.exports = Agent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 84703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Root reference for iframes.
 */
var root;

if (typeof window !== 'undefined') {
  // Browser window
  root = window;
} else if (typeof self === 'undefined') {
  // Other environments
  console.warn('Using browser-only version of superagent in non-browser environment');
  root = void 0;
} else {
  // Web Worker
  root = self;
}

var Emitter = __webpack_require__(48925);

var safeStringify = __webpack_require__(38060);

var RequestBase = __webpack_require__(13124);

var isObject = __webpack_require__(43358);

var ResponseBase = __webpack_require__(61571);

var Agent = __webpack_require__(15312);
/**
 * Noop.
 */


function noop() {}
/**
 * Expose `request`.
 */


module.exports = function (method, url) {
  // callback
  if (typeof url === 'function') {
    return new exports.Request('GET', method).end(url);
  } // url first


  if (arguments.length === 1) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
};

exports = module.exports;
var request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest && (!root.location || root.location.protocol !== 'file:' || !root.ActiveXObject)) {
    return new XMLHttpRequest();
  }

  try {
    return new ActiveXObject('Microsoft.XMLHTTP');
  } catch (_unused) {}

  try {
    return new ActiveXObject('Msxml2.XMLHTTP.6.0');
  } catch (_unused2) {}

  try {
    return new ActiveXObject('Msxml2.XMLHTTP.3.0');
  } catch (_unused3) {}

  try {
    return new ActiveXObject('Msxml2.XMLHTTP');
  } catch (_unused4) {}

  throw new Error('Browser-only version of superagent could not find XHR');
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */


var trim = ''.trim ? function (s) {
  return s.trim();
} : function (s) {
  return s.replace(/(^\s*|\s*$)/g, '');
};
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) pushEncodedKeyValuePair(pairs, key, obj[key]);
  }

  return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */


function pushEncodedKeyValuePair(pairs, key, val) {
  if (val === undefined) return;

  if (val === null) {
    pairs.push(encodeURI(key));
    return;
  }

  if (Array.isArray(val)) {
    val.forEach(function (v) {
      pushEncodedKeyValuePair(pairs, key, v);
    });
  } else if (isObject(val)) {
    for (var subkey in val) {
      if (Object.prototype.hasOwnProperty.call(val, subkey)) pushEncodedKeyValuePair(pairs, "".concat(key, "[").concat(subkey, "]"), val[subkey]);
    }
  } else {
    pairs.push(encodeURI(key) + '=' + encodeURIComponent(val));
  }
}
/**
 * Expose serialization method.
 */


request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');

    if (pos === -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}
/**
 * Expose parser.
 */


request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  form: 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': safeStringify
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');

    if (index === -1) {
      // could be empty line, just skip it
      continue;
    }

    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */


function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[/+]json($|[^-\w])/.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */


function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr; // responseText is accessible only if responseType is '' or 'text' and on older browsers

  this.text = this.req.method !== 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status; // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request

  if (status === 1223) {
    status = 204;
  }

  this._setStatusProperties(status);

  this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  this.header = this.headers; // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.

  this.header['content-type'] = this.xhr.getResponseHeader('content-type');

  this._setHeaderProperties(this.header);

  if (this.text === null && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method === 'HEAD' ? null : this._parseBody(this.text ? this.text : this.xhr.response);
  }
} // eslint-disable-next-line new-cap


ResponseBase(Response.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function (str) {
  var parse = request.parse[this.type];

  if (this.req._parser) {
    return this.req._parser(this, str);
  }

  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }

  return parse && str && (str.length > 0 || str instanceof Object) ? parse(str) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */


Response.prototype.toError = function () {
  var req = this.req;
  var method = req.method;
  var url = req.url;
  var msg = "cannot ".concat(method, " ").concat(url, " (").concat(this.status, ")");
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;
  return err;
};
/**
 * Expose `Response`.
 */


request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case

  this._header = {}; // coerces header names to lowercase

  this.on('end', function () {
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch (err_) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = err_; // issue #675: return the raw response if the response parsing fails

      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType === 'undefined' ? self.xhr.responseText : self.xhr.response; // issue #876: return the http status code if the response parsing fails

        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);
    var new_err;

    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || res.text || 'Unsuccessful HTTP response');
      }
    } catch (err_) {
      new_err = err_; // ok() callback can throw
    } // #1000 don't catch errors from the callback to avoid double calling it


    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */
// eslint-disable-next-line new-cap


Emitter(Request.prototype); // eslint-disable-next-line new-cap

RequestBase(Request.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function (type) {
  this.set('Content-Type', request.types[type] || type);
  return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.accept = function (type) {
  this.set('Accept', request.types[type] || type);
  return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.auth = function (user, pass, options) {
  if (arguments.length === 1) pass = '';

  if (_typeof(pass) === 'object' && pass !== null) {
    // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }

  if (!options) {
    options = {
      type: typeof btoa === 'function' ? 'basic' : 'auto'
    };
  }

  var encoder = function encoder(string) {
    if (typeof btoa === 'function') {
      return btoa(string);
    }

    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.query = function (val) {
  if (typeof val !== 'string') val = serialize(val);
  if (val) this._query.push(val);
  return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.attach = function (field, file, options) {
  if (file) {
    if (this._data) {
      throw new Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }

  return this;
};

Request.prototype._getFormData = function () {
  if (!this._formData) {
    this._formData = new root.FormData();
  }

  return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */


Request.prototype.callback = function (err, res) {
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */


Request.prototype.crossDomainError = function () {
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;
  err.status = this.status;
  err.method = this.method;
  err.url = this.url;
  this.callback(err);
}; // This only warns, because the request is still likely to work


Request.prototype.agent = function () {
  console.warn('This is not supported in browser version of superagent');
  return this;
};

Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca; // This throws, because it can't send/receive data as expected

Request.prototype.write = function () {
  throw new Error('Streaming is not supported in browser version of superagent');
};

Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */

Request.prototype._isHost = function (obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && _typeof(obj) === 'object' && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.end = function (fn) {
  if (this._endCalled) {
    console.warn('Warning: .end() was called twice. This is not supported in superagent');
  }

  this._endCalled = true; // store callback

  this._callback = fn || noop; // querystring

  this._finalizeQueryString();

  this._end();
};

Request.prototype._setUploadTimeout = function () {
  var self = this; // upload timeout it's wokrs only if deadline timeout is off

  if (this._uploadTimeout && !this._uploadTimeoutTimer) {
    this._uploadTimeoutTimer = setTimeout(function () {
      self._timeoutError('Upload timeout of ', self._uploadTimeout, 'ETIMEDOUT');
    }, this._uploadTimeout);
  }
}; // eslint-disable-next-line complexity


Request.prototype._end = function () {
  if (this._aborted) return this.callback(new Error('The request has been aborted even before .end() was called'));
  var self = this;
  this.xhr = request.getXHR();
  var xhr = this.xhr;
  var data = this._formData || this._data;

  this._setTimeouts(); // state change


  xhr.onreadystatechange = function () {
    var readyState = xhr.readyState;

    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }

    if (readyState !== 4) {
      return;
    } // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"


    var status;

    try {
      status = xhr.status;
    } catch (_unused5) {
      status = 0;
    }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }

    self.emit('end');
  }; // progress


  var handleProgress = function handleProgress(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;

      if (e.percent === 100) {
        clearTimeout(self._uploadTimeoutTimer);
      }
    }

    e.direction = direction;
    self.emit('progress', e);
  };

  if (this.hasListeners('progress')) {
    try {
      xhr.addEventListener('progress', handleProgress.bind(null, 'download'));

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', handleProgress.bind(null, 'upload'));
      }
    } catch (_unused6) {// Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  if (xhr.upload) {
    this._setUploadTimeout();
  } // initiate request


  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  } // CORS


  if (this._withCredentials) xhr.withCredentials = true; // body

  if (!this._formData && this.method !== 'GET' && this.method !== 'HEAD' && typeof data !== 'string' && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];

    var _serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];

    if (!_serialize && isJSON(contentType)) {
      _serialize = request.serialize['application/json'];
    }

    if (_serialize) data = _serialize(data);
  } // set header fields


  for (var field in this.header) {
    if (this.header[field] === null) continue;
    if (Object.prototype.hasOwnProperty.call(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  } // send stuff


  this.emit('request', this); // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined

  xhr.send(typeof data === 'undefined' ? null : data);
};

request.agent = function () {
  return new Agent();
};

['GET', 'POST', 'OPTIONS', 'PATCH', 'PUT', 'DELETE'].forEach(function (method) {
  Agent.prototype[method.toLowerCase()] = function (url, fn) {
    var req = new request.Request(method, url);

    this._setDefaults(req);

    if (fn) {
      req.end(fn);
    }

    return req;
  };
});
Agent.prototype.del = Agent.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function (url, data, fn) {
  var req = request('GET', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.head = function (url, data, fn) {
  var req = request('HEAD', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.options = function (url, data, fn) {
  var req = request('OPTIONS', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


function del(url, data, fn) {
  var req = request('DELETE', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function (url, data, fn) {
  var req = request('PATCH', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.post = function (url, data, fn) {
  var req = request('POST', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.put = function (url, data, fn) {
  var req = request('PUT', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 43358:
/***/ (function(module) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
function isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
}

module.exports = isObject;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pcy1vYmplY3QuanMiXSwibmFtZXMiOlsiaXNPYmplY3QiLCJvYmoiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7O0FBQUE7Ozs7Ozs7QUFRQSxTQUFTQSxRQUFULENBQWtCQyxHQUFsQixFQUF1QjtBQUNyQixTQUFPQSxHQUFHLEtBQUssSUFBUixJQUFnQixRQUFPQSxHQUFQLE1BQWUsUUFBdEM7QUFDRDs7QUFFREMsTUFBTSxDQUFDQyxPQUFQLEdBQWlCSCxRQUFqQiIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ2hlY2sgaWYgYG9iamAgaXMgYW4gb2JqZWN0LlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBvYmpcbiAqIEByZXR1cm4ge0Jvb2xlYW59XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBpc09iamVjdChvYmopIHtcbiAgcmV0dXJuIG9iaiAhPT0gbnVsbCAmJiB0eXBlb2Ygb2JqID09PSAnb2JqZWN0Jztcbn1cblxubW9kdWxlLmV4cG9ydHMgPSBpc09iamVjdDtcbiJdfQ==

/***/ }),

/***/ 13124:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(43358);
/**
 * Expose `RequestBase`.
 */


module.exports = RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */


function mixin(obj) {
  for (var key in RequestBase.prototype) {
    if (Object.prototype.hasOwnProperty.call(RequestBase.prototype, key)) obj[key] = RequestBase.prototype[key];
  }

  return obj;
}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.clearTimeout = function () {
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  clearTimeout(this._uploadTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  delete this._uploadTimeoutTimer;
  return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */


RequestBase.prototype.parse = function (fn) {
  this._parser = fn;
  return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.responseType = function (val) {
  this._responseType = val;
  return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */


RequestBase.prototype.serialize = function (fn) {
  this._serializer = fn;
  return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.timeout = function (options) {
  if (!options || _typeof(options) !== 'object') {
    this._timeout = options;
    this._responseTimeout = 0;
    this._uploadTimeout = 0;
    return this;
  }

  for (var option in options) {
    if (Object.prototype.hasOwnProperty.call(options, option)) {
      switch (option) {
        case 'deadline':
          this._timeout = options.deadline;
          break;

        case 'response':
          this._responseTimeout = options.response;
          break;

        case 'upload':
          this._uploadTimeout = options.upload;
          break;

        default:
          console.warn('Unknown timeout option', option);
      }
    }
  }

  return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.retry = function (count, fn) {
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = ['ECONNRESET', 'ETIMEDOUT', 'EADDRINFO', 'ESOCKETTIMEDOUT'];
/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */

RequestBase.prototype._shouldRetry = function (err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }

  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);

      if (override === true) return true;
      if (override === false) return false; // undefined falls back to defaults
    } catch (err_) {
      console.error(err_);
    }
  }

  if (res && res.status && res.status >= 500 && res.status !== 501) return true;

  if (err) {
    if (err.code && ERROR_CODES.includes(err.code)) return true; // Superagent timeout

    if (err.timeout && err.code === 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }

  return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */


RequestBase.prototype._retry = function () {
  this.clearTimeout(); // node

  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;
  this.timedoutError = null;
  return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */


RequestBase.prototype.then = function (resolve, reject) {
  var _this = this;

  if (!this._fullfilledPromise) {
    var self = this;

    if (this._endCalled) {
      console.warn('Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises');
    }

    this._fullfilledPromise = new Promise(function (resolve, reject) {
      self.on('abort', function () {
        if (_this._maxRetries && _this._maxRetries > _this._retries) {
          return;
        }

        if (_this.timedout && _this.timedoutError) {
          reject(_this.timedoutError);
          return;
        }

        var err = new Error('Aborted');
        err.code = 'ABORTED';
        err.status = _this.status;
        err.method = _this.method;
        err.url = _this.url;
        reject(err);
      });
      self.end(function (err, res) {
        if (err) reject(err);else resolve(res);
      });
    });
  }

  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype.catch = function (cb) {
  return this.then(undefined, cb);
};
/**
 * Allow for extension
 */


RequestBase.prototype.use = function (fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function (cb) {
  if (typeof cb !== 'function') throw new Error('Callback required');
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */


RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */


RequestBase.prototype.getHeader = RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function (field, val) {
  if (isObject(field)) {
    for (var key in field) {
      if (Object.prototype.hasOwnProperty.call(field, key)) this.set(key, field[key]);
    }

    return this;
  }

  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */


RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.field = function (name, val) {
  // name should be either a string or an object.
  if (name === null || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      if (Object.prototype.hasOwnProperty.call(name, key)) this.field(key, name[key]);
    }

    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      if (Object.prototype.hasOwnProperty.call(val, i)) this.field(name, val[i]);
    }

    return this;
  } // val should be defined now


  if (val === null || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }

  if (typeof val === 'boolean') {
    val = String(val);
  }

  this._getFormData().append(name, val);

  return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */


RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }

  this._aborted = true;
  if (this.xhr) this.xhr.abort(); // browser

  if (this.req) this.req.abort(); // node

  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', "Basic ".concat(base64Encoder("".concat(user, ":").concat(pass))));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer':
      // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', "Bearer ".concat(user));
      break;

    default:
      break;
  }

  return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */


RequestBase.prototype.withCredentials = function (on) {
  // This is browser-only functionality. Node side is no-op.
  if (on === undefined) on = true;
  this._withCredentials = on;
  return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;
  return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */


RequestBase.prototype.maxResponseSize = function (n) {
  if (typeof n !== 'number') {
    throw new TypeError('Invalid argument');
  }

  this._maxResponseSize = n;
  return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */


RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */
// eslint-disable-next-line complexity


RequestBase.prototype.send = function (data) {
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw new Error("Can't merge these send calls");
  } // merge


  if (isObj && isObject(this._data)) {
    for (var key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) this._data[key] = data[key];
    }
  } else if (typeof data === 'string') {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];

    if (type === 'application/x-www-form-urlencoded') {
      this._data = this._data ? "".concat(this._data, "&").concat(data) : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  } // default to json


  if (!type) this.type('json');
  return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.sortQuery = function (sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */


RequestBase.prototype._finalizeQueryString = function () {
  var query = this._query.join('&');

  if (query) {
    this.url += (this.url.includes('?') ? '&' : '?') + query;
  }

  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');

    if (index >= 0) {
      var queryArr = this.url.slice(index + 1).split('&');

      if (typeof this._sort === 'function') {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }

      this.url = this.url.slice(0, index) + '?' + queryArr.join('&');
    }
  }
}; // For backwards compat only


RequestBase.prototype._appendQueryString = function () {
  console.warn('Unsupported');
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */


RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }

  var err = new Error("".concat(reason + timeout, "ms exceeded"));
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.timedoutError = err;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function () {
  var self = this; // deadline

  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function () {
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  } // response timeout


  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function () {
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 61571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */
var utils = __webpack_require__(8497);
/**
 * Expose `ResponseBase`.
 */


module.exports = ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */


function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    if (Object.prototype.hasOwnProperty.call(ResponseBase.prototype, key)) obj[key] = ResponseBase.prototype[key];
  }

  return obj;
}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */


ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */


ResponseBase.prototype._setHeaderProperties = function (header) {
  // TODO: moar!
  // TODO: make this a util
  // content-type
  var ct = header['content-type'] || '';
  this.type = utils.type(ct); // params

  var params = utils.params(ct);

  for (var key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) this[key] = params[key];
  }

  this.links = {}; // links

  try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (_unused) {// ignore
  }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */


ResponseBase.prototype._setStatusProperties = function (status) {
  var type = status / 100 | 0; // status / class

  this.statusCode = status;
  this.status = this.statusCode;
  this.statusType = type; // basics

  this.info = type === 1;
  this.ok = type === 2;
  this.redirect = type === 3;
  this.clientError = type === 4;
  this.serverError = type === 5;
  this.error = type === 4 || type === 5 ? this.toError() : false; // sugar

  this.created = status === 201;
  this.accepted = status === 202;
  this.noContent = status === 204;
  this.badRequest = status === 400;
  this.unauthorized = status === 401;
  this.notAcceptable = status === 406;
  this.forbidden = status === 403;
  this.notFound = status === 404;
  this.unprocessableEntity = status === 422;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8497:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */
exports.type = function (str) {
  return str.split(/ *; */).shift();
};
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */


exports.params = function (str) {
  return str.split(/ *; */).reduce(function (obj, str) {
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();
    if (key && val) obj[key] = val;
    return obj;
  }, {});
};
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */


exports.parseLinks = function (str) {
  return str.split(/ *, */).reduce(function (obj, str) {
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */


exports.cleanHeader = function (header, changesOrigin) {
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header.host; // secuirty

  if (changesOrigin) {
    delete header.authorization;
    delete header.cookie;
  }

  return header;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 56157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SWRConfig": function() { return /* reexport */ SWRConfig; },
  "cache": function() { return /* reexport */ config_cache; },
  "default": function() { return /* binding */ esm; },
  "mutate": function() { return /* reexport */ mutate; },
  "trigger": function() { return /* reexport */ trigger; },
  "useSWRPages": function() { return /* reexport */ useSWRPages; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/swr/node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(54172);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ../../node_modules/swr/esm/libs/is-document-visible.js
function isDocumentVisible() {
    if (typeof document !== 'undefined' &&
        typeof document.visibilityState !== 'undefined') {
        return document.visibilityState !== 'hidden';
    }
    // always assume it's visible
    return true;
}

;// CONCATENATED MODULE: ../../node_modules/swr/esm/libs/is-online.js
function isOnline() {
    if (typeof navigator.onLine !== 'undefined') {
        return navigator.onLine;
    }
    // always assume it's online
    return true;
}

;// CONCATENATED MODULE: ../../node_modules/swr/esm/libs/hash.js
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// hashes an array of objects and returns a string
function hash(args) {
    if (!args.length)
        return '';
    var key = 'arg';
    for (var i = 0; i < args.length; ++i) {
        var _hash = void 0;
        if (args[i] === null || typeof args[i] !== 'object') {
            // need to consider the case that args[i] is a string:
            // args[i]        _hash
            // "undefined" -> '"undefined"'
            // undefined   -> 'undefined'
            // 123         -> '123'
            // null        -> 'null'
            // "null"      -> '"null"'
            if (typeof args[i] === 'string') {
                _hash = '"' + args[i] + '"';
            }
            else {
                _hash = String(args[i]);
            }
        }
        else {
            if (!table.has(args[i])) {
                _hash = counter;
                table.set(args[i], counter++);
            }
            else {
                _hash = table.get(args[i]);
            }
        }
        key += '@' + _hash;
    }
    return key;
}

;// CONCATENATED MODULE: ../../node_modules/swr/esm/cache.js


var Cache = /** @class */ (function () {
    function Cache(initialData) {
        if (initialData === void 0) { initialData = {}; }
        this.__cache = new Map(Object.entries(initialData));
        this.__listeners = [];
    }
    Cache.prototype.get = function (key) {
        var _key = this.serializeKey(key)[0];
        return this.__cache.get(_key);
    };
    Cache.prototype.set = function (key, value, shouldNotify) {
        if (shouldNotify === void 0) { shouldNotify = true; }
        var _key = this.serializeKey(key)[0];
        this.__cache.set(_key, value);
        if (shouldNotify)
            mutate(key, value, false);
        this.notify();
    };
    Cache.prototype.keys = function () {
        return Array.from(this.__cache.keys());
    };
    Cache.prototype.has = function (key) {
        var _key = this.serializeKey(key)[0];
        return this.__cache.has(_key);
    };
    Cache.prototype.clear = function (shouldNotify) {
        if (shouldNotify === void 0) { shouldNotify = true; }
        if (shouldNotify)
            this.__cache.forEach(function (key) { return mutate(key, null, false); });
        this.__cache.clear();
        this.notify();
    };
    Cache.prototype.delete = function (key, shouldNotify) {
        if (shouldNotify === void 0) { shouldNotify = true; }
        var _key = this.serializeKey(key)[0];
        if (shouldNotify)
            mutate(key, null, false);
        this.__cache.delete(_key);
        this.notify();
    };
    // TODO: introduce namespace for the cache
    Cache.prototype.serializeKey = function (key) {
        var args = null;
        if (typeof key === 'function') {
            try {
                key = key();
            }
            catch (err) {
                // dependencies not ready
                key = '';
            }
        }
        if (Array.isArray(key)) {
            // args array
            args = key;
            key = hash(key);
        }
        else {
            // convert null to ''
            key = String(key || '');
        }
        var errorKey = key ? 'err@' + key : '';
        return [key, args, errorKey];
    };
    Cache.prototype.subscribe = function (listener) {
        var _this = this;
        if (typeof listener !== 'function') {
            throw new Error('Expected the listener to be a function.');
        }
        var isSubscribed = true;
        this.__listeners.push(listener);
        return function () {
            if (!isSubscribed)
                return;
            isSubscribed = false;
            var index = _this.__listeners.indexOf(listener);
            if (index > -1) {
                _this.__listeners[index] = _this.__listeners[_this.__listeners.length - 1];
                _this.__listeners.length--;
            }
        };
    };
    // Notify Cache subscribers about a change in the cache
    Cache.prototype.notify = function () {
        for (var _i = 0, _a = this.__listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener();
        }
    };
    return Cache;
}());
/* harmony default export */ var cache = (Cache);

;// CONCATENATED MODULE: ../../node_modules/swr/esm/config.js




// cache
var config_cache = new cache();
// state managers
var CONCURRENT_PROMISES = {};
var CONCURRENT_PROMISES_TS = {};
var FOCUS_REVALIDATORS = {};
var CACHE_REVALIDATORS = {};
var MUTATION_TS = {};
// error retry
function onErrorRetry(_, __, config, revalidate, opts) {
    if (!isDocumentVisible()) {
        // if it's hidden, stop
        // it will auto revalidate when focus
        return;
    }
    if (config.errorRetryCount && opts.retryCount > config.errorRetryCount) {
        return;
    }
    // exponential backoff
    var count = Math.min(opts.retryCount || 0, 8);
    var timeout = ~~((Math.random() + 0.5) * (1 << count)) * config.errorRetryInterval;
    setTimeout(revalidate, timeout, opts);
}
// client side: need to adjust the config
// based on the browser status
// slow connection (<= 70Kbps)
var slowConnection = typeof window !== 'undefined' &&
    navigator['connection'] &&
    ['slow-2g', '2g'].indexOf(navigator['connection'].effectiveType) !== -1;
// config
var defaultConfig = {
    // events
    onLoadingSlow: function () { },
    onSuccess: function () { },
    onError: function () { },
    onErrorRetry: onErrorRetry,
    errorRetryInterval: (slowConnection ? 10 : 5) * 1000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: (slowConnection ? 5 : 3) * 1000,
    refreshInterval: 0,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    shouldRetryOnError: true,
    suspense: false,
    compare: (fast_deep_equal_default())
};
// Focus revalidate
var eventsBinded = false;
if (typeof window !== 'undefined' && window.addEventListener && !eventsBinded) {
    var revalidate = function () {
        if (!isDocumentVisible() || !isOnline())
            return;
        for (var key in FOCUS_REVALIDATORS) {
            if (FOCUS_REVALIDATORS[key][0])
                FOCUS_REVALIDATORS[key][0]();
        }
    };
    window.addEventListener('visibilitychange', revalidate, false);
    window.addEventListener('focus', revalidate, false);
    // only bind the events once
    eventsBinded = true;
}

/* harmony default export */ var esm_config = (defaultConfig);

;// CONCATENATED MODULE: ../../node_modules/swr/esm/libs/throttle.js
function throttle(fn, interval) {
    var pending = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (pending)
            return;
        pending = true;
        fn.apply(void 0, args);
        setTimeout(function () { return (pending = false); }, interval);
    };
}

;// CONCATENATED MODULE: ../../node_modules/swr/esm/swr-config-context.js

var SWRConfigContext = (0,react.createContext)({});
SWRConfigContext.displayName = 'SWRConfigContext';
/* harmony default export */ var swr_config_context = (SWRConfigContext);

;// CONCATENATED MODULE: ../../node_modules/swr/esm/use-swr.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var IS_SERVER = typeof window === 'undefined';
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react.useEffect : react.useLayoutEffect;
var trigger = function (_key, shouldRevalidate) {
    if (shouldRevalidate === void 0) { shouldRevalidate = true; }
    // we are ignoring the second argument which correspond to the arguments
    // the fetcher will receive when key is an array
    var _a = config_cache.serializeKey(_key), key = _a[0], keyErr = _a[2];
    if (!key)
        return Promise.resolve();
    var updaters = CACHE_REVALIDATORS[key];
    if (key && updaters) {
        var currentData = config_cache.get(key);
        var currentError = config_cache.get(keyErr);
        var promises = [];
        for (var i = 0; i < updaters.length; ++i) {
            promises.push(updaters[i](shouldRevalidate, currentData, currentError, i > 0));
        }
        // return new updated value
        return Promise.all(promises).then(function () { return config_cache.get(key); });
    }
    return Promise.resolve(config_cache.get(key));
};
var broadcastState = function (key, data, error) {
    var updaters = CACHE_REVALIDATORS[key];
    if (key && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](false, data, error);
        }
    }
};
var mutate = function (_key, _data, shouldRevalidate) {
    if (shouldRevalidate === void 0) { shouldRevalidate = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var key, data, error, beforeMutationTs, beforeConcurrentPromisesTs, err_1, err_2, updaters, promises, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = config_cache.serializeKey(_key)[0];
                    if (!key)
                        return [2 /*return*/];
                    // if there is no new data, call revalidate against the key
                    if (typeof _data === 'undefined')
                        return [2 /*return*/, trigger(_key, shouldRevalidate)
                            // update timestamp
                        ];
                    // update timestamp
                    MUTATION_TS[key] = Date.now() - 1;
                    beforeMutationTs = MUTATION_TS[key];
                    beforeConcurrentPromisesTs = CONCURRENT_PROMISES_TS[key];
                    if (!(_data && typeof _data === 'function')) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, _data(config_cache.get(key))];
                case 2:
                    data = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    error = err_1;
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 11];
                case 5:
                    if (!(_data && typeof _data.then === 'function')) return [3 /*break*/, 10];
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, _data];
                case 7:
                    data = _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    err_2 = _a.sent();
                    error = err_2;
                    return [3 /*break*/, 9];
                case 9: return [3 /*break*/, 11];
                case 10:
                    data = _data;
                    _a.label = 11;
                case 11:
                    // Check if other mutations have occurred since we've started awaiting, if so then do not persist this change
                    if (beforeMutationTs !== MUTATION_TS[key] ||
                        beforeConcurrentPromisesTs !== CONCURRENT_PROMISES_TS[key]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    if (typeof data !== 'undefined') {
                        // update cached data, avoid notifying from the cache
                        config_cache.set(key, data, false);
                    }
                    updaters = CACHE_REVALIDATORS[key];
                    if (updaters) {
                        promises = [];
                        for (i = 0; i < updaters.length; ++i) {
                            promises.push(updaters[i](!!shouldRevalidate, data, error, i > 0));
                        }
                        // return new updated value
                        return [2 /*return*/, Promise.all(promises).then(function () { return config_cache.get(key); })];
                    }
                    // throw error or return data to be used by caller of mutate
                    if (error)
                        throw error;
                    return [2 /*return*/, data];
            }
        });
    });
};
function useSWR() {
    var _this = this;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _key, fn, config = {};
    if (args.length >= 1) {
        _key = args[0];
    }
    if (args.length > 2) {
        fn = args[1];
        config = args[2];
    }
    else {
        if (typeof args[1] === 'function') {
            fn = args[1];
        }
        else if (typeof args[1] === 'object') {
            config = args[1];
        }
    }
    // we assume `key` as the identifier of the request
    // `key` can change but `fn` shouldn't
    // (because `revalidate` only depends on `key`)
    // `keyErr` is the cache key for error objects
    var _a = config_cache.serializeKey(_key), key = _a[0], fnArgs = _a[1], keyErr = _a[2];
    config = Object.assign({}, esm_config, (0,react.useContext)(swr_config_context), config);
    if (typeof fn === 'undefined') {
        // use a global fetcher
        fn = config.fetcher;
    }
    var initialData = config_cache.get(key) || config.initialData;
    var initialError = config_cache.get(keyErr);
    // if a state is accessed (data, error or isValidating),
    // we add the state to dependencies so if the state is
    // updated in the future, we can trigger a rerender
    var stateDependencies = (0,react.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    var stateRef = (0,react.useRef)({
        data: initialData,
        error: initialError,
        isValidating: false
    });
    var rerender = (0,react.useState)(null)[1];
    var dispatch = (0,react.useCallback)(function (payload) {
        var shouldUpdateState = false;
        for (var k in payload) {
            stateRef.current[k] = payload[k];
            if (stateDependencies.current[k]) {
                shouldUpdateState = true;
            }
        }
        if (shouldUpdateState || config.suspense) {
            rerender({});
        }
    }, []);
    // error ref inside revalidate (is last request errored?)
    var unmountedRef = (0,react.useRef)(false);
    var keyRef = (0,react.useRef)(key);
    // do unmount check for callbacks
    var eventsRef = (0,react.useRef)({
        emit: function (event) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            if (unmountedRef.current)
                return;
            config[event].apply(config, params);
        }
    });
    var boundMutate = (0,react.useCallback)(function (data, shouldRevalidate) {
        return mutate(key, data, shouldRevalidate);
    }, [key]);
    // start a revalidation
    var revalidate = (0,react.useCallback)(function (revalidateOpts) {
        if (revalidateOpts === void 0) { revalidateOpts = {}; }
        return __awaiter(_this, void 0, void 0, function () {
            var loading, shouldDeduping, newData, startAt, newState, err_3, retryCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!key || !fn)
                            return [2 /*return*/, false];
                        if (unmountedRef.current)
                            return [2 /*return*/, false];
                        revalidateOpts = Object.assign({ dedupe: false }, revalidateOpts);
                        loading = true;
                        shouldDeduping = typeof CONCURRENT_PROMISES[key] !== 'undefined' && revalidateOpts.dedupe;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        dispatch({
                            isValidating: true
                        });
                        newData = void 0;
                        startAt = void 0;
                        if (!shouldDeduping) return [3 /*break*/, 3];
                        // there's already an ongoing request,
                        // this one needs to be deduplicated.
                        startAt = CONCURRENT_PROMISES_TS[key];
                        return [4 /*yield*/, CONCURRENT_PROMISES[key]];
                    case 2:
                        newData = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        // if not deduping the request (hard revalidate) but
                        // there're other ongoing request(s) at the same time,
                        // we need to ignore the other result(s) to avoid
                        // possible race conditions:
                        // req1------------------>res1
                        //      req2-------->res2
                        // in that case, the second response should not be overridden
                        // by the first one.
                        if (CONCURRENT_PROMISES[key]) {
                            // we can mark it as a mutation to ignore
                            // all requests which are fired before this one
                            MUTATION_TS[key] = Date.now() - 1;
                        }
                        // if no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !config_cache.get(key)) {
                            setTimeout(function () {
                                if (loading)
                                    eventsRef.current.emit('onLoadingSlow', key, config);
                            }, config.loadingTimeout);
                        }
                        if (fnArgs !== null) {
                            CONCURRENT_PROMISES[key] = fn.apply(void 0, fnArgs);
                        }
                        else {
                            CONCURRENT_PROMISES[key] = fn(key);
                        }
                        CONCURRENT_PROMISES_TS[key] = startAt = Date.now();
                        return [4 /*yield*/, CONCURRENT_PROMISES[key]];
                    case 4:
                        newData = _a.sent();
                        setTimeout(function () {
                            delete CONCURRENT_PROMISES[key];
                            delete CONCURRENT_PROMISES_TS[key];
                        }, config.dedupingInterval);
                        // trigger the success event,
                        // only do this for the original request.
                        eventsRef.current.emit('onSuccess', newData, key, config);
                        _a.label = 5;
                    case 5:
                        // if the revalidation happened earlier than the local mutation,
                        // we have to ignore the result because it could override.
                        // meanwhile, a new revalidation should be triggered by the mutation.
                        if (MUTATION_TS[key] && startAt <= MUTATION_TS[key]) {
                            dispatch({ isValidating: false });
                            return [2 /*return*/, false];
                        }
                        config_cache.set(key, newData, false);
                        config_cache.set(keyErr, undefined, false);
                        newState = {
                            isValidating: false
                        };
                        if (typeof stateRef.current.error !== 'undefined') {
                            // we don't have an error
                            newState.error = undefined;
                        }
                        if (!config.compare(stateRef.current.data, newData)) {
                            // deep compare to avoid extra re-render
                            // data changed
                            newState.data = newData;
                        }
                        // merge the new state
                        dispatch(newState);
                        if (!shouldDeduping) {
                            // also update other hooks
                            broadcastState(key, newData, undefined);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        err_3 = _a.sent();
                        delete CONCURRENT_PROMISES[key];
                        delete CONCURRENT_PROMISES_TS[key];
                        config_cache.set(keyErr, err_3, false);
                        // get a new error
                        // don't use deep equal for errors
                        if (stateRef.current.error !== err_3) {
                            // we keep the stale data
                            dispatch({
                                isValidating: false,
                                error: err_3
                            });
                            if (!shouldDeduping) {
                                // also broadcast to update other hooks
                                broadcastState(key, undefined, err_3);
                            }
                        }
                        // events and retry
                        eventsRef.current.emit('onError', err_3, key, config);
                        if (config.shouldRetryOnError) {
                            retryCount = (revalidateOpts.retryCount || 0) + 1;
                            eventsRef.current.emit('onErrorRetry', err_3, key, config, revalidate, Object.assign({ dedupe: true }, revalidateOpts, { retryCount: retryCount }));
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        loading = false;
                        return [2 /*return*/, true];
                }
            });
        });
    }, [key]);
    // mounted (client side rendering)
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return undefined;
        // after `key` updates, we need to mark it as mounted
        unmountedRef.current = false;
        // after the component is mounted (hydrated),
        // we need to update the data from the cache
        // and trigger a revalidation
        var currentHookData = stateRef.current.data;
        var latestKeyedData = config_cache.get(key) || config.initialData;
        // update the state if the key changed (not the inital render) or cache updated
        if (keyRef.current !== key ||
            !config.compare(currentHookData, latestKeyedData)) {
            dispatch({ data: latestKeyedData });
            keyRef.current = key;
        }
        // revalidate with deduping
        var softRevalidate = function () { return revalidate({ dedupe: true }); };
        // trigger a revalidation
        if (config.revalidateOnMount ||
            (!config.initialData && config.revalidateOnMount === undefined)) {
            if (typeof latestKeyedData !== 'undefined' &&
                !IS_SERVER &&
                window['requestIdleCallback']) {
                // delay revalidate if there's cache
                // to not block the rendering
                window['requestIdleCallback'](softRevalidate);
            }
            else {
                softRevalidate();
            }
        }
        // whenever the window gets focused, revalidate
        var onFocus;
        if (config.revalidateOnFocus) {
            // throttle: avoid being called twice from both listeners
            // and tabs being switched quickly
            onFocus = throttle(softRevalidate, config.focusThrottleInterval);
            if (!FOCUS_REVALIDATORS[key]) {
                FOCUS_REVALIDATORS[key] = [onFocus];
            }
            else {
                FOCUS_REVALIDATORS[key].push(onFocus);
            }
        }
        // register global cache update listener
        var onUpdate = function (shouldRevalidate, updatedData, updatedError, dedupe) {
            if (shouldRevalidate === void 0) { shouldRevalidate = true; }
            if (dedupe === void 0) { dedupe = true; }
            // update hook state
            var newState = {};
            var needUpdate = false;
            if (typeof updatedData !== 'undefined' &&
                !config.compare(stateRef.current.data, updatedData)) {
                newState.data = updatedData;
                needUpdate = true;
            }
            // always update error
            // because it can be `undefined`
            if (stateRef.current.error !== updatedError) {
                newState.error = updatedError;
                needUpdate = true;
            }
            if (needUpdate) {
                dispatch(newState);
            }
            if (shouldRevalidate) {
                if (dedupe) {
                    return softRevalidate();
                }
                else {
                    return revalidate();
                }
            }
            return false;
        };
        // add updater to listeners
        if (!CACHE_REVALIDATORS[key]) {
            CACHE_REVALIDATORS[key] = [onUpdate];
        }
        else {
            CACHE_REVALIDATORS[key].push(onUpdate);
        }
        // set up reconnecting when the browser regains network connection
        var reconnect = null;
        if (!IS_SERVER && window.addEventListener && config.revalidateOnReconnect) {
            window.addEventListener('online', (reconnect = softRevalidate));
        }
        return function () {
            // cleanup
            dispatch = function () { return null; };
            // mark it as unmounted
            unmountedRef.current = true;
            if (onFocus && FOCUS_REVALIDATORS[key]) {
                var revalidators = FOCUS_REVALIDATORS[key];
                var index = revalidators.indexOf(onFocus);
                if (index >= 0) {
                    // 10x faster than splice
                    // https://jsperf.com/array-remove-by-index
                    revalidators[index] = revalidators[revalidators.length - 1];
                    revalidators.pop();
                }
            }
            if (CACHE_REVALIDATORS[key]) {
                var revalidators = CACHE_REVALIDATORS[key];
                var index = revalidators.indexOf(onUpdate);
                if (index >= 0) {
                    revalidators[index] = revalidators[revalidators.length - 1];
                    revalidators.pop();
                }
            }
            if (!IS_SERVER && window.removeEventListener && reconnect !== null) {
                window.removeEventListener('online', reconnect);
            }
        };
    }, [key, revalidate]);
    // set up polling
    useIsomorphicLayoutEffect(function () {
        var timer = null;
        var tick = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!stateRef.current.error &&
                            (config.refreshWhenHidden || isDocumentVisible()) &&
                            (config.refreshWhenOffline || isOnline()))) return [3 /*break*/, 2];
                        // only revalidate when the page is visible
                        // if API request errored, we stop polling in this round
                        // and let the error retry function handle it
                        return [4 /*yield*/, revalidate({ dedupe: true })];
                    case 1:
                        // only revalidate when the page is visible
                        // if API request errored, we stop polling in this round
                        // and let the error retry function handle it
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (config.refreshInterval) {
                            timer = setTimeout(tick, config.refreshInterval);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (config.refreshInterval) {
            timer = setTimeout(tick, config.refreshInterval);
        }
        return function () {
            if (timer)
                clearTimeout(timer);
        };
    }, [
        config.refreshInterval,
        config.refreshWhenHidden,
        config.refreshWhenOffline,
        revalidate
    ]);
    // suspense
    if (config.suspense) {
        // in suspense mode, we can't return empty state
        // (it should be suspended)
        // try to get data and error from cache
        var latestData = config_cache.get(key) || initialData;
        var latestError = config_cache.get(keyErr) || initialError;
        if (typeof latestData === 'undefined' &&
            typeof latestError === 'undefined') {
            // need to start the request if it hasn't
            if (!CONCURRENT_PROMISES[key]) {
                // trigger revalidate immediately
                // to get the promise
                revalidate();
            }
            if (CONCURRENT_PROMISES[key] &&
                typeof CONCURRENT_PROMISES[key].then === 'function') {
                // if it is a promise
                throw CONCURRENT_PROMISES[key];
            }
            // it's a value, return it directly (override)
            latestData = CONCURRENT_PROMISES[key];
        }
        if (typeof latestData === 'undefined' && latestError) {
            // in suspense mode, throw error if there's no content
            throw latestError;
        }
        // return the latest data / error from cache
        // in case `key` has changed
        return {
            error: latestError,
            data: latestData,
            revalidate: revalidate,
            mutate: boundMutate,
            isValidating: stateRef.current.isValidating
        };
    }
    // define returned state
    // can be memorized since the state is a ref
    return (0,react.useMemo)(function () {
        var state = { revalidate: revalidate, mutate: boundMutate };
        Object.defineProperties(state, {
            error: {
                // `key` might be changed in the upcoming hook re-render,
                // but the previous state will stay
                // so we need to match the latest key and data (fallback to `initialData`)
                get: function () {
                    stateDependencies.current.error = true;
                    return keyRef.current === key ? stateRef.current.error : initialError;
                },
                enumerable: true
            },
            data: {
                get: function () {
                    stateDependencies.current.data = true;
                    return keyRef.current === key ? stateRef.current.data : initialData;
                },
                enumerable: true
            },
            isValidating: {
                get: function () {
                    stateDependencies.current.isValidating = true;
                    return stateRef.current.isValidating;
                },
                enumerable: true
            }
        });
        return state;
    }, [revalidate]);
}
var SWRConfig = swr_config_context.Provider;

/* harmony default export */ var use_swr = (useSWR);

;// CONCATENATED MODULE: ../../node_modules/swr/esm/use-swr-pages.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};


/*
The idea

A "Page" component renders the content of 1 API request, it accepts an offset (in this example it's from),
uses a SWR hook (useSWR(API + '?limit=' + limit + '&from=' + from)) and returns items (Projects).

The UI:
      +------------------------------------------+
      |   Projects                               |
+------------------------------------------------------+
|     |   +----------------+                     |     |
|     |                                          |     |
|     |   +------------+                         |     |
|     |                                          |     +--> 1 Page
|     |   +-----------------+                    |     |
|     |                                          |     |  /projects/list?limit=4
|     |   +---------+                            |     |
+------------------------------------------------------+
      |                                          |
      |   +------------+                         |     +  /projects/list?limit=4&from=123
      |                                          |     |
      |   +----------------+                     |     |
      |                                          |     |
      |   +---------+                            |     |
      |                                          |     |
      |   +--------------+                       |     +
      |                                          |
      |   +-------------------+                  |     +  /projects/list?limit=4&from=456
      |                                          |     |
      |   +------------+                         |     |
      |                                          |     |
      |   +----------------+                     |     |
      |                                          |     |
      |                                          |     +

The API
// (inside `render`)

function App () {
  const {
    pages,    // an array of each page component
    pageSWRs, // an array of SWRs of each page
    isLoadingMore,
    isReachingEnd,
    isEmpty,
    loadMore
  } = useSWRPages(
    'project-page', // key of this page

    // ======== the actual Page component!
    ({ offset, withSWR }) => {
      // required: use `withSWR` to wrap your main SWR (source of your pagination API)
      const { data } = withSWR(
        useSWR(API + '?limit=10&from=' + offset) // request projects with offset
      )
      if (!data) return <Placeholder>
      return data.projects.map(project => <Card project={project} team={team}>)
    },
    // ========

    // a function accepts a SWR's `data`, and returns the offset of the next page (or null)
    data => data && data.length >= 10 ? data[data.length - 1].createdAt : null,

    // (optional) outside deps of your Page component. in this case it's empty
    []
  )

  // ...

  if (isEmpty) return <EmptyProjectsPage/>

  return <div>
    {pages}
    {isReachingEnd
      ? null
      : <button loading={isLoadingMore} onClick={loadMore}>Load More</button>}
  </div>
}
*/
var pageCacheMap = new Map();
function useSWRPages(pageKey, pageFn, SWRToOffset, deps) {
    if (deps === void 0) { deps = []; }
    var pageCountKey = "_swr_page_count_" + pageKey;
    var pageOffsetKey = "_swr_page_offset_" + pageKey;
    var _a = (0,react.useState)(config_cache.get(pageCountKey) || 1), pageCount = _a[0], setPageCount = _a[1];
    var _b = (0,react.useState)(config_cache.get(pageOffsetKey) || [null]), pageOffsets = _b[0], setPageOffsets = _b[1];
    var _c = (0,react.useState)([]), pageSWRs = _c[0], setPageSWRs = _c[1];
    var pageFnRef = (0,react.useRef)(pageFn);
    var emptyPageRef = (0,react.useRef)(false);
    // Page component (wraps `pageFn`)
    // for performance reason we need to memorize it
    var Page = (0,react.useCallback)(function (props) {
        // render the page component
        var dataList = pageFnRef.current(props);
        // if dataList is [], we can assume this page is empty
        // TODO: this API is not stable
        if (dataList && !dataList.length) {
            emptyPageRef.current = true;
        }
        else {
            emptyPageRef.current = false;
        }
        return dataList;
    }, []);
    // Doesn't have a next page
    var isReachingEnd = pageOffsets[pageCount] === null;
    var isLoadingMore = pageCount === pageOffsets.length;
    var isEmpty = isReachingEnd && pageCount === 1 && emptyPageRef.current;
    var loadMore = (0,react.useCallback)(function () {
        if (isLoadingMore || isReachingEnd)
            return;
        setPageCount(function (c) {
            config_cache.set(pageCountKey, c + 1);
            return c + 1;
        });
    }, [isLoadingMore || isReachingEnd]);
    var _pageFn = (0,react.useCallback)(pageFn, deps);
    pageFnRef.current = _pageFn;
    var pages = (0,react.useMemo)(function () {
        var getWithSWR = function (id) { return function (swr) {
            if (!pageSWRs[id] ||
                pageSWRs[id].data !== swr.data ||
                pageSWRs[id].error !== swr.error ||
                pageSWRs[id].revalidate !== swr.revalidate) {
                // hoist side effects: setPageSWRs and setPageOffsets -- https://reactjs.org/blog/2020/02/26/react-v16.13.0.html#warnings-for-some-updates-during-render
                setTimeout(function () {
                    setPageSWRs(function (swrs) {
                        var _swrs = __spreadArrays(swrs);
                        _swrs[id] = {
                            data: swr.data,
                            error: swr.error,
                            revalidate: swr.revalidate,
                            isValidating: swr.isValidating,
                            mutate: swr.mutate
                        };
                        return _swrs;
                    });
                    if (typeof swr.data !== 'undefined') {
                        // set next page's offset
                        var newPageOffset_1 = SWRToOffset(swr, id);
                        if (pageOffsets[id + 1] !== newPageOffset_1) {
                            setPageOffsets(function (arr) {
                                var _arr = __spreadArrays(arr);
                                _arr[id + 1] = newPageOffset_1;
                                config_cache.set(pageOffsetKey, _arr);
                                return _arr;
                            });
                        }
                    }
                });
            }
            return swr;
        }; };
        // render each page
        var p = [];
        if (!pageCacheMap.has(pageKey)) {
            pageCacheMap.set(pageKey, []);
        }
        var pageCache = pageCacheMap.get(pageKey);
        for (var i = 0; i < pageCount; ++i) {
            if (!pageCache[i] ||
                pageCache[i].offset !== pageOffsets[i] ||
                pageCache[i].pageFn !== _pageFn) {
                // when props change or at init
                // render the page and cache it
                pageCache[i] = {
                    component: (react.createElement(Page, { key: "page-" + pageOffsets[i] + "-" + i, offset: pageOffsets[i], withSWR: getWithSWR(i) })),
                    pageFn: _pageFn,
                    offset: pageOffsets[i]
                };
            }
            p.push(pageCache[i].component);
        }
        return p;
    }, [_pageFn, pageCount, pageSWRs, pageOffsets, pageKey]);
    return {
        pages: pages,
        pageCount: pageCount,
        pageSWRs: pageSWRs,
        isLoadingMore: isLoadingMore,
        isReachingEnd: isReachingEnd,
        isEmpty: isEmpty,
        loadMore: loadMore
    };
}

;// CONCATENATED MODULE: ../../node_modules/swr/esm/index.js




/* harmony default export */ var esm = (use_swr);


/***/ }),

/***/ 54172:
/***/ (function(module) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),

/***/ 994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ../../node_modules/universal-cookie/node_modules/cookie/index.js
var cookie = __webpack_require__(78705);
;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ }),

/***/ 78705:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 47519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(34885);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 76242:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(34885),
  shim = __webpack_require__(30926);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 30926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(47519);
} else {}


/***/ }),

/***/ 70821:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(76242);
} else {}


/***/ }),

/***/ 84313:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 8636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AccountContextProvider = exports.useAccount = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _agent = __webpack_require__(37642);
var _TokenProvider = __webpack_require__(36286);
var _LanguageProvider = __webpack_require__(8989);
var _MessageHandlerProvider = __webpack_require__(82425);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _mapAddressNew = _interopRequireDefault(__webpack_require__(12248));
var _CartProvider = __webpack_require__(57955);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AccountContext = /*#__PURE__*/_react["default"].createContext();
var defaultAddress = {
  customer: null,
  shippingAddress: null,
  billingAddress: null,
  email: null
};
var AccountContextProvider = function AccountContextProvider(props) {
  var _useState = (0, _react.useState)(defaultAddress),
    accountDataState = _useState[0],
    setAccountDataState = _useState[1];
  var _useCart = (0, _CartProvider.useCart)(),
    cart = _useCart.cart;
  (0, _react.useEffect)(function () {
    var _JSON$parse;
    setAccountDataState((_JSON$parse = JSON.parse(sessionStorage.getItem("accountData"))) !== null && _JSON$parse !== void 0 ? _JSON$parse : defaultAddress);
  }, [cart]);
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var websiteIds = __webpack_require__.g.__appConfig__.websiteIds;
  var translations = {
    passwordSaved: (0, _langLibrary["default"])("Password saved"),
    nameSaved: (0, _langLibrary["default"])("Firstname and Lastname saved"),
    addressSaved: (0, _langLibrary["default"])("Address saved"),
    addressDeleted: (0, _langLibrary["default"])("Address deleted")
  };
  var setAccountFromCart = function setAccountFromCart() {
    if (!(accountDataState !== null && accountDataState !== void 0 && accountDataState.email)) {
      var _JSON$parse2;
      setAccountDataState((_JSON$parse2 = JSON.parse(sessionStorage.getItem("accountData"))) !== null && _JSON$parse2 !== void 0 ? _JSON$parse2 : defaultAddress);
    }
  };
  var setNewDataAfterLogin = function setNewDataAfterLogin() {
    var _sessionStorage, _accountDataNew$custo, _accountDataState$cus;
    var accountDataNew = JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("accountData"));
    if ((accountDataNew === null || accountDataNew === void 0 ? void 0 : (_accountDataNew$custo = accountDataNew.customer) === null || _accountDataNew$custo === void 0 ? void 0 : _accountDataNew$custo.email) !== (accountDataState === null || accountDataState === void 0 ? void 0 : (_accountDataState$cus = accountDataState.customer) === null || _accountDataState$cus === void 0 ? void 0 : _accountDataState$cus.email)) {
      setAccountDataState(accountDataNew);
    }
  };
  var refreshData = function refreshData(data) {
    sessionStorage.setItem("accountData", JSON.stringify(data));
    setAccountDataState(data);
  };
  var clearAccountData = function clearAccountData() {
    var _sessionStorage2;
    (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.removeItem("accountData");
    setAccountDataState(defaultAddress);
  };
  var saveName = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(values) {
      var newData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _agent.requests.put(__webpack_require__.g.__appConfig__.customerDataUrl, {
                customer: {
                  firstname: values.firstName,
                  lastname: values.lastName,
                  email: accountDataState.customer.email,
                  website_id: websiteIds[language.language]
                }
              }, token, language);
            case 3:
              newData = _context.sent;
              handleMessage(translations.nameSaved, false, false);
              refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                customer: newData
              }));
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              handleMessage(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function saveName(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var savePassword = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(values) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _agent.requests.put("/customers/me/password", {
                currentPassword: values.oldPassword,
                newPassword: values.newPassword
              }, token, language);
            case 3:
              handleMessage(translations.passwordSaved, false, false);
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              handleMessage(_context2.t0);
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return function savePassword(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var saveAddress = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(id, values) {
      var _accountDataState$cus2, _accountDataState$cus3;
      var addresses, isCompany, newAddress, newData, lastAddedAddress;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              addresses = [];
              (_accountDataState$cus2 = accountDataState.customer) === null || _accountDataState$cus2 === void 0 ? void 0 : (_accountDataState$cus3 = _accountDataState$cus2.addresses) === null || _accountDataState$cus3 === void 0 ? void 0 : _accountDataState$cus3.map(function (address) {
                if ((address === null || address === void 0 ? void 0 : address.id) !== parseInt(id)) {
                  addresses.push(address);
                }
              });
              isCompany = values.fields.isCompany;
              newAddress = {
                id: id,
                firstname: values.fields.firstName,
                lastname: values.fields.lastName,
                street: Array.isArray(values.fields.street) ? values.fields.street : [values.fields.street],
                postcode: values.fields.postalCode,
                city: values.fields.city,
                telephone: values.fields.phone,
                country_id: values.fields.country.id,
                defaultBilling: values.isDefaultBilling,
                defaultShipping: values.isDefaultShipping,
                company: isCompany ? values.fields.companyName : "",
                vat_id: isCompany ? values.fields.vatId : ""
              };
              addresses.push(newAddress);
              _context3.prev = 5;
              _context3.next = 8;
              return _agent.requests.put(__webpack_require__.g.__appConfig__.customerDataUrl, {
                customer: {
                  firstname: accountDataState.customer.firstname,
                  lastname: accountDataState.customer.lastname,
                  email: accountDataState.customer.email,
                  website_id: websiteIds[language.language],
                  addresses: addresses
                }
              }, token, language);
            case 8:
              newData = _context3.sent;
              handleMessage(translations.addressSaved, false, false);
              lastAddedAddress = !accountDataState.hasAddressInCart && (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, addresses === null || addresses === void 0 ? void 0 : addresses[addresses.length - 1]), {}, {
                email: accountDataState.customer.email,
                country: [{
                  id: values.fields.country.id
                }]
              }));
              if (newAddress.defaultBilling) {
                refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                  customer: newData,
                  billingAddress: (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, newAddress), {}, {
                    email: accountDataState.customer.email,
                    country: [{
                      id: values.fields.country.id
                    }]
                  }))
                }));
              } else if (newAddress.defaultShipping) {
                refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                  customer: newData,
                  shippingAddress: (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, newAddress), {}, {
                    email: accountDataState.customer.email,
                    country: [{
                      id: values.fields.country.id
                    }]
                  }))
                }));
              } else {
                refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                  customer: newData
                }));
              }
              _context3.next = 17;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](5);
              handleMessage(_context3.t0);
            case 17:
              return _context3.abrupt("return", true);
            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 14]]);
    }));
    return function saveAddress(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var deleteAddress = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(id) {
      var _accountDataState$cus4;
      var addresses;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              addresses = (_accountDataState$cus4 = accountDataState.customer) === null || _accountDataState$cus4 === void 0 ? void 0 : _accountDataState$cus4.addresses;
              addresses.splice(addresses.findIndex(function (address) {
                return address.id === parseInt(id);
              }), 1);
              _context4.prev = 2;
              _context4.next = 5;
              return _agent.requests.put(__webpack_require__.g.__appConfig__.customerDataUrl, {
                customer: {
                  firstname: accountDataState.customer.firstname,
                  lastname: accountDataState.customer.lastname,
                  email: accountDataState.customer.email,
                  website_id: websiteIds[language.language],
                  addresses: addresses
                }
              }, token, language);
            case 5:
              handleMessage(translations.addressDeleted, false, false);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              handleMessage(_context4.t0);
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }));
    return function deleteAddress(_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  return __jsx(AccountContext.Provider, {
    value: {
      accountData: accountDataState,
      clearAccountData: clearAccountData,
      setNewDataAfterLogin: setNewDataAfterLogin,
      saveName: saveName,
      savePassword: savePassword,
      saveAddress: saveAddress,
      refreshData: refreshData,
      deleteAddress: deleteAddress,
      setAccountFromCart: setAccountFromCart
    }
  }, props.children);
};
exports.AccountContextProvider = AccountContextProvider;
var useAccount = function useAccount() {
  return (0, _react.useContext)(AccountContext);
};
exports.useAccount = useAccount;

/***/ }),

/***/ 15191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _mapCartData = __webpack_require__(90180);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var _mapAddressNew = _interopRequireDefault(__webpack_require__(12248));
var _useProductsBySkus = __webpack_require__(78108);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getLanguageFromCustomer = function getLanguageFromCustomer(language) {
  if (language.includes("_")) {
    var match = /_(.+)/.exec(language);
    return match ? match[1].toUpperCase() : "";
  } else {
    return language.toUpperCase();
  }
};
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(cartId, token, language) {
    var _cartResponse, _cartResponse$extensi, _cartResponse$extensi2, _cartResponse$extensi3, _cartResponse2, _cartResponse$extensi4, _ref3, _shippingResponse$add, _cartResponse3, _ref4, _cartResponse$billing, _cartResponse4, _sessionStorage, _customer$email, cartResponse, _error$error, shippingResponse, isShippingMethodPicked, shippingMethodPicked, customer, totals, getProductsBySku, products, mappedProducts, findProductBySku, cartItems, currency, mappedTotals, shippingAddress, billingAddress, accountData, _customer$email2, userHasAddresses, billingAddressesCustomer, shippingAddressCustomer, _customer$addresses$f, _customer$addresses, _customer$addresses$f2, _customer$addresses2, _billingAddress$email, _billingAddress$email2, _error$error2;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(token && !cartId)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return _agent.requests.get(token ? "/carts/mine" : "/guest-carts/".concat(cartId), false, token, language);
          case 6:
            cartResponse = _context.sent;
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", (_error$error = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.error) !== null && _error$error !== void 0 ? _error$error : _context.t0);
          case 12:
            shippingResponse = (_cartResponse = cartResponse) === null || _cartResponse === void 0 ? void 0 : (_cartResponse$extensi = _cartResponse.extension_attributes) === null || _cartResponse$extensi === void 0 ? void 0 : (_cartResponse$extensi2 = _cartResponse$extensi.shipping_assignments) === null || _cartResponse$extensi2 === void 0 ? void 0 : (_cartResponse$extensi3 = _cartResponse$extensi2[0]) === null || _cartResponse$extensi3 === void 0 ? void 0 : _cartResponse$extensi3.shipping;
            isShippingMethodPicked = !!(shippingResponse !== null && shippingResponse !== void 0 && shippingResponse.method);
            shippingMethodPicked = shippingResponse === null || shippingResponse === void 0 ? void 0 : shippingResponse.method;
            customer = cartResponse.customer;
            _context.next = 18;
            return _agent.requests.get(token ? __webpack_require__.g.__appConfig__.cartsTotalsUrl : (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.guestCartsTotalsUrl, {
              cartId: cartId
            }), false, token, language);
          case 18:
            totals = _context.sent;
            getProductsBySku = function getProductsBySku(response) {
              var skus = response.items.map(function (item) {
                return item.sku;
              });
              return (0, _useProductsBySkus.fetcher)({
                skus: skus,
                pageSize: 250,
                language: language,
                visibility: true
              });
            };
            _context.next = 22;
            return getProductsBySku(cartResponse);
          case 22:
            products = _context.sent;
            mappedProducts = products;
            findProductBySku = function findProductBySku(_ref2) {
              var sku = _ref2.sku,
                itemId = _ref2.itemId;
              var foundIndex = mappedProducts.findIndex(function (product) {
                return product.sku === sku;
              });
              if (foundIndex !== -1) {
                var _totals$items$find;
                var product = mappedProducts[foundIndex];
                var discountFromTotals = (_totals$items$find = totals.items.find(function (item) {
                  return item.item_id === itemId;
                })) === null || _totals$items$find === void 0 ? void 0 : _totals$items$find.discount_amount;
                return _objectSpread(_objectSpread({}, product), {}, {
                  price: _objectSpread(_objectSpread({}, product.price), {}, {
                    discountFromTotals: discountFromTotals
                  })
                });
              }
            };
            cartItems = cartResponse.items.map(function (cartItem) {
              return (0, _mapCartData.mapItem)(cartItem);
            });
            cartItems.forEach(function (item) {
              item.product = findProductBySku({
                sku: item.sku,
                itemId: item.itemId
              });
            });
            currency = cartResponse.currency.store_currency_code;
            mappedTotals = totals ? {
              id: cartId,
              currency: currency,
              items: cartItems,
              isShippingMethodPicked: isShippingMethodPicked,
              shippingMethodPicked: shippingMethodPicked,
              shippingAddress: isShippingMethodPicked ? (0, _mapAddressNew["default"])(_objectSpread({}, shippingResponse.address), true) : null,
              billingAddress: isShippingMethodPicked ? (0, _mapAddressNew["default"])(_objectSpread({}, (_cartResponse2 = cartResponse) === null || _cartResponse2 === void 0 ? void 0 : _cartResponse2.billing_address), true) : null,
              totals: (0, _mapCartData.mapTotals)(_objectSpread(_objectSpread({}, totals), {}, {
                ePremiaPoints: (_cartResponse$extensi4 = cartResponse.extension_attributes) === null || _cartResponse$extensi4 === void 0 ? void 0 : _cartResponse$extensi4.rewardpoints_spent
              }))
            } : {
              id: cartId,
              currency: currency,
              items: [],
              totals: {
                tax: 0,
                productsTotalPrice: 0,
                cartTotalPrice: 0,
                shippingCost: 0,
                discount: 0,
                ePremia: null,
                ePremiaPoints: null
              }
            };
            localStorage.setItem("minicartContent", JSON.stringify(_objectSpread({}, mappedTotals)));
            shippingAddress = isShippingMethodPicked || token ? (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, shippingResponse === null || shippingResponse === void 0 ? void 0 : shippingResponse.address), {}, {
              country: [{
                id: (_ref3 = (_shippingResponse$add = shippingResponse === null || shippingResponse === void 0 ? void 0 : shippingResponse.address.country_id) !== null && _shippingResponse$add !== void 0 ? _shippingResponse$add : getLanguageFromCustomer(cartResponse.customer.created_in)) !== null && _ref3 !== void 0 ? _ref3 : language
              }]
            })) : null;
            billingAddress = isShippingMethodPicked || token ? (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, (_cartResponse3 = cartResponse) === null || _cartResponse3 === void 0 ? void 0 : _cartResponse3.billing_address), {}, {
              country: [{
                id: (_ref4 = (_cartResponse$billing = (_cartResponse4 = cartResponse) === null || _cartResponse4 === void 0 ? void 0 : _cartResponse4.billing_address.country_id) !== null && _cartResponse$billing !== void 0 ? _cartResponse$billing : getLanguageFromCustomer(cartResponse.customer.created_in)) !== null && _ref4 !== void 0 ? _ref4 : language
              }]
            })) : null;
            accountData = JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("accountData"));
            if ((customer === null || customer === void 0 ? void 0 : (_customer$email = customer.email) === null || _customer$email === void 0 ? void 0 : _customer$email.length) > 0) {
              userHasAddresses = customer.addresses.length > 0;
              billingAddressesCustomer = billingAddress;
              shippingAddressCustomer = shippingAddress;
              if (userHasAddresses && !isShippingMethodPicked) {
                billingAddressesCustomer = (_customer$addresses$f = customer.addresses.find(function (address) {
                  return address.default_billing;
                })) !== null && _customer$addresses$f !== void 0 ? _customer$addresses$f : (_customer$addresses = customer.addresses) === null || _customer$addresses === void 0 ? void 0 : _customer$addresses[0];
                billingAddressesCustomer = (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, billingAddressesCustomer), {}, {
                  email: customer.email,
                  country: [{
                    id: billingAddressesCustomer.country_id
                  }]
                }));
              }
              if (userHasAddresses && !isShippingMethodPicked) {
                shippingAddressCustomer = (_customer$addresses$f2 = customer.addresses.find(function (address) {
                  return address.default_shipping;
                })) !== null && _customer$addresses$f2 !== void 0 ? _customer$addresses$f2 : (_customer$addresses2 = customer.addresses) === null || _customer$addresses2 === void 0 ? void 0 : _customer$addresses2[0];
                shippingAddressCustomer = (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, shippingAddressCustomer), {}, {
                  email: customer.email,
                  country: [{
                    id: shippingAddressCustomer.country_id
                  }]
                }));
              }
              sessionStorage.setItem("accountData", JSON.stringify({
                customer: customer,
                billingAddress: userHasAddresses ? billingAddressesCustomer : billingAddress,
                shippingAddress: userHasAddresses ? shippingAddressCustomer : shippingAddress,
                email: (_customer$email2 = customer === null || customer === void 0 ? void 0 : customer.email) !== null && _customer$email2 !== void 0 ? _customer$email2 : null
              }));
            } else {
              if (accountData) {
                sessionStorage.setItem("accountData", JSON.stringify(_objectSpread(_objectSpread({}, accountData), {}, {
                  billingAddress: billingAddress,
                  shippingAddress: shippingAddress,
                  email: (_billingAddress$email = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email) !== null && _billingAddress$email !== void 0 ? _billingAddress$email : null
                })));
              } else {
                sessionStorage.setItem("accountData", JSON.stringify({
                  billingAddress: billingAddress,
                  shippingAddress: shippingAddress,
                  email: (_billingAddress$email2 = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email) !== null && _billingAddress$email2 !== void 0 ? _billingAddress$email2 : null
                }));
              }
            }
            return _context.abrupt("return", {
              id: cartId,
              currency: currency,
              items: cartItems,
              totals: (0, _mapCartData.mapTotals)(totals),
              isShippingMethodPicked: isShippingMethodPicked,
              shippingMethodPicked: shippingMethodPicked,
              shippingAddress: shippingAddress,
              billingAddress: billingAddress
            });
          case 37:
            _context.prev = 37;
            _context.t1 = _context["catch"](0);
            console.log(_context.t1);
            return _context.abrupt("return", (_error$error2 = _context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.error) !== null && _error$error2 !== void 0 ? _error$error2 : _context.t1);
          case 41:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 37], [3, 9]]);
  }));
  return function fetcher(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 57955:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useCart = useCart;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var _router = _interopRequireDefault(__webpack_require__(53746));
var _TokenProvider = __webpack_require__(36286);
var _agent = __webpack_require__(37642);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var _mapCartData = __webpack_require__(90180);
var _fetcher = _interopRequireDefault(__webpack_require__(15191));
var _AccountProvider = __webpack_require__(8636);
var _useErrorCart2 = _interopRequireDefault(__webpack_require__(38975));
var _useMinicart2 = __webpack_require__(34698);
var _usePromotions2 = _interopRequireDefault(__webpack_require__(59901));
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(26367));
var _useShippingMethods2 = _interopRequireDefault(__webpack_require__(63896));
var _useCheckoutData2 = _interopRequireDefault(__webpack_require__(98753));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CartContext = /*#__PURE__*/_react["default"].createContext({});
function CartProvider(props) {
  var isFirstRun = (0, _react.useRef)(true);
  var isErrorPending = (0, _react.useRef)(false);
  var children = props.children;
  var _useCheckoutData = (0, _useCheckoutData2["default"])(),
    clearData = _useCheckoutData.clearData,
    setBillingCountryFromCart = _useCheckoutData.setBillingCountryFromCart;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token,
    deleteToken = _useToken.deleteToken;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var _useState = (0, _react.useState)(true),
    isRevalidated = _useState[0],
    revalidate = _useState[1];
  var _useState2 = (0, _react.useState)({
      language: language,
      domain: domain
    }),
    languageAndDomain = _useState2[0],
    setLanguageAndDomain = _useState2[1];
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    setMinicartContentFromStorage = _useMinicart.setMinicartContentFromStorage,
    setCouponCodeFormPromotions = _useMinicart.setCouponCodeFormPromotions,
    minicartState = _useMinicart.minicartState;
  var _useState3 = (0, _react.useState)(null),
    cart = _useState3[0],
    setCart = _useState3[1];
  var _useAccount = (0, _AccountProvider.useAccount)(),
    accountData = _useAccount.accountData,
    setNewDataAfterLogin = _useAccount.setNewDataAfterLogin,
    clearAccountData = _useAccount.clearAccountData;
  var _useState4 = (0, _react.useState)(true),
    isItemsChange = _useState4[0],
    setItemChange = _useState4[1];
  var _useErrorCart = (0, _useErrorCart2["default"])(),
    checkErrorCart = _useErrorCart.checkErrorCart;
  var _useShippingMethods = (0, _useShippingMethods2["default"])(),
    shippingMethods = _useShippingMethods.shippingMethods;
  var _useState5 = (0, _react.useState)([]),
    productsWithQuantity = _useState5[0],
    setProductsWithQuantity = _useState5[1];
  var getCartId = function getCartId() {
    return _jsCookie["default"].get("cartId");
  };
  var getCartIdFromStorage = function getCartIdFromStorage() {
    if (typeof window === "undefined") return [];
    var cartIdInStorage = localStorage.getItem("cartId");
    return cartIdInStorage ? JSON.parse(cartIdInStorage) : null;
  };
  var getCartFromStorage = function getCartFromStorage() {
    if (typeof window === "undefined") return [];
    var cartInStorage = localStorage.getItem("minicartContent");
    return cartInStorage ? JSON.parse(cartInStorage) : [];
  };
  var removeMinicartDataFromStorage = function removeMinicartDataFromStorage() {
    localStorage.setItem("minicartContent", "[]");
    localStorage.removeItem("cartId");
  };
  var _useSWR = (0, _swr["default"])(getCartId() && !token ? [getCartId(), null, languageAndDomain] : null, _fetcher["default"]),
    guestCart = _useSWR.data,
    updateGuestCart = _useSWR.mutate;
  var _useSWR2 = (0, _swr["default"])(token ? [getCartId(), token, languageAndDomain] : null, _fetcher["default"]),
    customerCart = _useSWR2.data,
    updateCustomerCart = _useSWR2.mutate;
  (0, _react.useEffect)(function () {
    var _cartTemporary$respon, _cartTemporary$respon2, _cartTemporary$respon3, _cart$totals;
    var cartTemporary = token ? customerCart : guestCart;
    if (cartTemporary && cartTemporary !== null && cartTemporary !== void 0 && (_cartTemporary$respon = cartTemporary.response) !== null && _cartTemporary$respon !== void 0 && _cartTemporary$respon.statusCode && cartTemporary !== null && cartTemporary !== void 0 && (_cartTemporary$respon2 = cartTemporary.response) !== null && _cartTemporary$respon2 !== void 0 && (_cartTemporary$respon3 = _cartTemporary$respon2.body) !== null && _cartTemporary$respon3 !== void 0 && _cartTemporary$respon3.message) {
      handleResponseErrors(cartTemporary);
    }
    checkStorage();
    setBillingCountryFromCart();
    setMinicartContentFromStorage();
    if (cart !== null && cart !== void 0 && (_cart$totals = cart.totals) !== null && _cart$totals !== void 0 && _cart$totals.couponCode && !minicartState.isCouponCodeFormPromotions) {
      var _cart$totals2;
      isCouponFromPromotions(cart === null || cart === void 0 ? void 0 : (_cart$totals2 = cart.totals) === null || _cart$totals2 === void 0 ? void 0 : _cart$totals2.couponCode).then(function (hasCoupon) {
        return setCouponCodeFormPromotions(hasCoupon);
      });
    }
  }, [customerCart, guestCart]);
  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      checkStorage();
    }
  }, []);
  var checkStorage = function checkStorage() {
    var cartIdInStorage = localStorage.getItem("cartId");
    if (!_jsCookie["default"].get("cartId") && cartIdInStorage) {
      _jsCookie["default"].set("cartId", JSON.parse(cartIdInStorage));
    }
    if (cartIdInStorage) {
      var initialCartFromStorage = localStorage.getItem("minicartContent");
      setCart(initialCartFromStorage ? JSON.parse(initialCartFromStorage) : []);
    } else {
      localStorage.removeItem("minicartContent");
    }
  };
  var handleResponseErrors = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(error) {
      var typeError, _global$__appConfig__, _global$__appConfig__2;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              typeError = checkErrorCart(error);
              if (!(typeError === (_useErrorCart2["default"] === null || _useErrorCart2["default"] === void 0 ? void 0 : _useErrorCart2["default"].LOGOUT) && !isErrorPending.current)) {
                _context.next = 12;
                break;
              }
              isErrorPending.current = true;
              _jsCookie["default"].remove("cartId");
              deleteToken();
              clearAccountData();
              clearData();
              updateCart(null, false);
              _router["default"].push((_global$__appConfig__ = __webpack_require__.g.__appConfig__.sessionExpiredReturnUrl) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : "/login", "".concat((_global$__appConfig__2 = __webpack_require__.g.__appConfig__.sessionExpiredReturnUrl) !== null && _global$__appConfig__2 !== void 0 ? _global$__appConfig__2 : "/login", "?=session-expired"), {
                shallow: true
              }).then(function () {
                isErrorPending.current = false;
              });
              return _context.abrupt("return");
            case 12:
              if (!(typeError === (_useErrorCart2["default"] === null || _useErrorCart2["default"] === void 0 ? void 0 : _useErrorCart2["default"].REMOVE_CART) && !isErrorPending.current)) {
                _context.next = 24;
                break;
              }
              isErrorPending.current = true;
              _jsCookie["default"].remove("cartId");
              clearAccountData();
              clearData();
              updateCart(null, false);
              _context.next = 20;
              return createCart(token || null);
            case 20:
              setMinicartContentFromStorage();
              isErrorPending.current = false;
              if (_router["default"].router.asPath.includes("checkout")) {
                _router["default"].push("/");
              }
              return _context.abrupt("return");
            case 24:
              return _context.abrupt("return", typeError);
            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleResponseErrors(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var updateCart = token ? updateCustomerCart : updateGuestCart;
  (0, _react.useEffect)(function () {
    var _cart$response, _cart$response2, _cart$response2$body;
    if (cart && cart !== null && cart !== void 0 && (_cart$response = cart.response) !== null && _cart$response !== void 0 && _cart$response.statusCode && cart !== null && cart !== void 0 && (_cart$response2 = cart.response) !== null && _cart$response2 !== void 0 && (_cart$response2$body = _cart$response2.body) !== null && _cart$response2$body !== void 0 && _cart$response2$body.message) {
      handleResponseErrors(cart);
    } else if (cart) {
      if (token && !(accountData !== null && accountData !== void 0 && accountData.customer)) {
        setNewDataAfterLogin();
      }
    }
  }, [cart]);
  (0, _react.useEffect)(function () {
    var _cart$items;
    var userJustFinishedCheckout = token && !getCartId();
    var guestWithoutCart = !getCartId() && !token;
    if (guestWithoutCart || userJustFinishedCheckout || (cart === null || cart === void 0 ? void 0 : (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.length) === 0 || !isItemsChange) {
      return;
    }
    setItemChange(false);

    //Todo czy musimy tutaj zawsze wywolywac estimate shipping, czy wystarczy tylko w checkout? mamy sprobowac bez, decyzja Kamila
    //updateShipping({ token, cartId: getCartId() });
  }, [getCartId(), token, cart === null || cart === void 0 ? void 0 : cart.items]);
  var getCartTotals = function getCartTotals() {
    var _cart$totals3, _shipping, _cart$totals4, _cart$totals5, _cart$totals6, _cart$totals7;
    var onlyForCheckout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var shippingPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shipping = {};
    if (onlyForCheckout) {
      shipping = {
        price: shippingPrice
      };
    } else {
      shipping = shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods.find(function (method) {
        var _cart$shippingMethodP, _cart$shippingMethodP2;
        return cart !== null && cart !== void 0 && cart.isShippingMethodPicked ? cart === null || cart === void 0 ? void 0 : (_cart$shippingMethodP = cart.shippingMethodPicked) === null || _cart$shippingMethodP === void 0 ? void 0 : (_cart$shippingMethodP2 = _cart$shippingMethodP.includes) === null || _cart$shippingMethodP2 === void 0 ? void 0 : _cart$shippingMethodP2.call(_cart$shippingMethodP, method.id) : method.id === "tablerate";
      });
    }
    var shippingCost = cart !== null && cart !== void 0 && (_cart$totals3 = cart.totals) !== null && _cart$totals3 !== void 0 && _cart$totals3.couponCode ? cart.totals.shippingCost : ((_shipping = shipping) === null || _shipping === void 0 ? void 0 : _shipping.price) || 0;
    var cartTotalPrice = onlyForCheckout ? (cart === null || cart === void 0 ? void 0 : (_cart$totals4 = cart.totals) === null || _cart$totals4 === void 0 ? void 0 : _cart$totals4.productsTotalPrice) + shippingCost : cart !== null && cart !== void 0 && cart.isShippingMethodPicked || cart !== null && cart !== void 0 && (_cart$totals5 = cart.totals) !== null && _cart$totals5 !== void 0 && _cart$totals5.discount ? cart === null || cart === void 0 ? void 0 : (_cart$totals6 = cart.totals) === null || _cart$totals6 === void 0 ? void 0 : _cart$totals6.cartTotalPrice : (cart === null || cart === void 0 ? void 0 : (_cart$totals7 = cart.totals) === null || _cart$totals7 === void 0 ? void 0 : _cart$totals7.cartTotalPrice) + shippingCost;
    return _objectSpread(_objectSpread({}, cart === null || cart === void 0 ? void 0 : cart.totals), {}, {
      items: cart,
      shippingCost: shippingCost,
      cartTotalPrice: cartTotalPrice
    });
  };
  var getShippingCost = function getShippingCost() {
    var shipping = shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods.find(function (method) {
      return method.id === "tablerate";
    });
    return (shipping === null || shipping === void 0 ? void 0 : shipping.price) || 0;
  };
  var createCart = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(localToken) {
      var cartIdCookie, actualToken, cartId;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cartIdCookie = getCartId();
              actualToken = localToken ? localToken : cartIdCookie;
              _context2.prev = 2;
              _context2.next = 5;
              return _agent.requests.post(actualToken ? __webpack_require__.g.__appConfig__.createCustomerCartUrl : __webpack_require__.g.__appConfig__.createGuestCartUrl, {}, actualToken, languageAndDomain);
            case 5:
              cartId = _context2.sent;
              _jsCookie["default"].set("cartId", cartId, {
                expires: parseInt(__webpack_require__.g.__appConfig__.sessionUserLoginMaxDays)
              });
              localStorage.setItem("cartId", JSON.stringify(cartId));
              localStorage.setItem("minicartContent", "[]");
              return _context2.abrupt("return", cartId);
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](2);
              handleResponseErrors(_context2.t0);
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 12]]);
    }));
    return function createCart(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var addProduct = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(product, quantity, isProductPageHit) {
      var _cart$items2, _cartItem$product$pri, _cartItem$product, _cartItem$product2;
      var cartIdInStorage, cartId, cart, itemAlreadyInCart, _cart$totals8, cartItemResponse, cartItem, newCart, cartItemPrice;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              cartIdInStorage = getCartIdFromStorage();
              if (!cartIdInStorage) {
                _context3.next = 5;
                break;
              }
              _context3.t0 = cartIdInStorage;
              _context3.next = 8;
              break;
            case 5:
              _context3.next = 7;
              return createCart();
            case 7:
              _context3.t0 = _context3.sent;
            case 8:
              cartId = _context3.t0;
              cart = getCartFromStorage();
              itemAlreadyInCart = cart && ((_cart$items2 = cart.items) === null || _cart$items2 === void 0 ? void 0 : _cart$items2.find(function (item) {
                return item.sku === product.sku;
              }));
              if (!itemAlreadyInCart) {
                _context3.next = 15;
                break;
              }
              _context3.next = 14;
              return updateItemQuantity(product.sku, itemAlreadyInCart.quantity + quantity, isProductPageHit, (_cart$totals8 = cart.totals) === null || _cart$totals8 === void 0 ? void 0 : _cart$totals8.couponCode);
            case 14:
              return _context3.abrupt("return", _context3.sent);
            case 15:
              _context3.prev = 15;
              _context3.next = 18;
              return _agent.requests.post(token ? __webpack_require__.g.__appConfig__.customerAddProductToCartUrl : (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.guestAddProductToCartUrl, {
                cartId: cartId
              }), {
                cartItem: {
                  quote_id: cartId,
                  sku: product.sku,
                  qty: quantity
                }
              }, token, languageAndDomain);
            case 18:
              cartItemResponse = _context3.sent;
              setItemChange(true);
              _context3.next = 26;
              break;
            case 22:
              _context3.prev = 22;
              _context3.t1 = _context3["catch"](15);
              handleResponseErrors(_context3.t1);
              throw _context3.t1;
            case 26:
              cartItem = (0, _mapCartData.mapItem)(cartItemResponse);
              cartItem.product = product;
              _context3.next = 30;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 30:
              newCart = _context3.sent;
              isProductFromPromotions(product.sku, isProductPageHit);
              if (newCart) {
                _context3.next = 35;
                break;
              }
              revalidate(!isRevalidated);
              return _context3.abrupt("return");
            case 35:
              cartItemPrice = (_cartItem$product$pri = cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product = cartItem.product) === null || _cartItem$product === void 0 ? void 0 : _cartItem$product.price.special) !== null && _cartItem$product$pri !== void 0 ? _cartItem$product$pri : cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product2 = cartItem.product) === null || _cartItem$product2 === void 0 ? void 0 : _cartItem$product2.price.regular;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: newCart.totals.productsTotalPrice + cartItemPrice,
                  cartTotalPrice: newCart.totals.cartTotalPrice + cartItemPrice
                })
              }));
              setMinicartContentFromStorage();
            case 38:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[15, 22]]);
    }));
    return function addProduct(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateShippingMethod = function updateShippingMethod(method, isShippingMethodPicked, billingAddress, shippingAddress) {
    setCart(_objectSpread(_objectSpread({}, cart), {}, {
      billingAddress: billingAddress,
      shippingAddress: shippingAddress,
      shippingMethodPicked: method,
      isShippingMethodPicked: isShippingMethodPicked
    }));
  };
  var refreshCart = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(freshTokenAfterLogin) {
      var newCart;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _fetcher["default"])(getCartIdFromStorage(), freshTokenAfterLogin !== null && freshTokenAfterLogin !== void 0 ? freshTokenAfterLogin : token, languageAndDomain);
            case 2:
              newCart = _context4.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: newCart.totals.productsTotalPrice,
                  cartTotalPrice: newCart.totals.cartTotalPrice
                })
              }));
              return _context4.abrupt("return");
            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function refreshCart(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  var updateItemQuantity = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(sku, quantity, isProductPageHit, hasCouponCode) {
      var _cartItem$product$pri2, _cartItem$product3, _cartItem$product4;
      var cart, cartId, cartItem, newCart, cartItemPrice;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              cart = getCartFromStorage();
              cartId = getCartIdFromStorage();
              cartItem = cart.items.find(function (item) {
                return item.sku === sku;
              });
              if (cartItem) {
                _context5.next = 5;
                break;
              }
              throw Error("There is no product with sku ".concat(sku, " in cart"));
            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return _agent.requests.put(token ? (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.customerUpdateProductInCartUrl, {
                itemId: cartItem.itemId
              }) : (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.guestUpdateProductInCartUrl, {
                cartId: cartId,
                itemId: cartItem.itemId
              }), {
                cartItem: {
                  quote_id: cartId,
                  sku: cartItem.sku,
                  qty: quantity
                }
              }, token, languageAndDomain);
            case 8:
              _context5.next = 14;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](5);
              handleResponseErrors(_context5.t0);
              throw _context5.t0;
            case 14:
              cart.items.forEach(function (item) {
                if (item.sku === sku) {
                  item.quantity = quantity;
                }
              });
              setItemChange(true);
              _context5.next = 18;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 18:
              newCart = _context5.sent;
              cartItemPrice = (_cartItem$product$pri2 = cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product3 = cartItem.product) === null || _cartItem$product3 === void 0 ? void 0 : _cartItem$product3.price.special) !== null && _cartItem$product$pri2 !== void 0 ? _cartItem$product$pri2 : cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product4 = cartItem.product) === null || _cartItem$product4 === void 0 ? void 0 : _cartItem$product4.price.regular;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: parseFloat(newCart.totals.productsTotalPrice + (quantity - cartItem.quantity) * cartItemPrice).toFixed(2),
                  cartTotalPrice: parseFloat(newCart.totals.cartTotalPrice + (quantity - cartItem.quantity) * cartItemPrice).toFixed(2),
                  shippingCost: newCart.totals.shippingCost
                })
              }));
              setMinicartContentFromStorage();
              if (!hasCouponCode) {
                isProductFromPromotions(sku, isProductPageHit);
              }
            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[5, 10]]);
    }));
    return function updateItemQuantity(_x7, _x8, _x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
  var removeItem = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(sku) {
      var cart, cartId, cartItem, itemId, url, newCart;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              cart = getCartFromStorage();
              cartId = getCartIdFromStorage();
              cartItem = cart.items.find(function (item) {
                return item.sku === sku;
              });
              if (cartItem) {
                _context6.next = 5;
                break;
              }
              throw Error("There is no product with sku ".concat(sku, " in cart"));
            case 5:
              itemId = cartItem.itemId;
              url = token ? (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.customerRemoveProductFromCartUrl, {
                itemId: itemId
              }) : (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.guestRemoveProductFromCartUrl, {
                cartId: cartId,
                itemId: itemId
              });
              _context6.prev = 7;
              _context6.next = 10;
              return _agent.requests.del(url, token, languageAndDomain);
            case 10:
              _context6.next = 16;
              break;
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](7);
              handleResponseErrors(_context6.t0);
              throw _context6.t0;
            case 16:
              setItemChange(true);
              _context6.next = 19;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 19:
              newCart = _context6.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                items: newCart.items.filter(function (item) {
                  return item.sku !== cartItem.sku;
                }),
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: newCart.totals.productsTotalPrice,
                  cartTotalPrice: newCart.totals.cartTotalPrice,
                  shippingCost: newCart.totals.shippingCost
                })
              }));
              setMinicartContentFromStorage();
            case 22:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[7, 12]]);
    }));
    return function removeItem(_x11) {
      return _ref6.apply(this, arguments);
    };
  }();
  var clearUserCartItems = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
      var _cart$items3;
      var cart;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (token) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              cart = getCartFromStorage();
              if (!(!(cart !== null && cart !== void 0 && cart.items) || (cart === null || cart === void 0 ? void 0 : (_cart$items3 = cart.items) === null || _cart$items3 === void 0 ? void 0 : _cart$items3.length) === 0)) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return");
            case 5:
              _context7.prev = 5;
              _context7.next = 8;
              return Promise.all(cart.items.map(function (item) {
                return _agent.requests.del((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.customerRemoveProductFromCartUrl, {
                  itemId: item.itemId
                }), token, languageAndDomain);
              }));
            case 8:
              localStorage.setItem("minicartContent", "[]");
              setMinicartContentFromStorage();
              _context7.next = 16;
              break;
            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](5);
              handleResponseErrors(_context7.t0);
              throw _context7.t0;
            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 12]]);
    }));
    return function clearUserCartItems() {
      return _ref7.apply(this, arguments);
    };
  }();

  // @TODO: Merge!
  var mergeCart = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(guestCartItems, customerToken, customerCartId) {
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return Promise.all(guestCartItems.map(function (item) {
                return _agent.requests.post(__webpack_require__.g.__appConfig__.customerAddProductToCartUrl, {
                  cartItem: {
                    quote_id: customerCartId,
                    sku: item.sku,
                    qty: item.quantity
                  }
                }, customerToken, languageAndDomain);
              }));
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 6:
              _context8.prev = 6;
              _context8.t0 = _context8["catch"](0);
              handleResponseErrors(_context8.t0);
            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 6]]);
    }));
    return function mergeCart(_x12, _x13, _x14) {
      return _ref8.apply(this, arguments);
    };
  }();
  var addCouponCode = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(couponCode) {
      var checkPromotions,
        cartId,
        newCart,
        _args9 = arguments;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              checkPromotions = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : true;
              cartId = getCartIdFromStorage();
              _context9.t0 = checkPromotions;
              if (!_context9.t0) {
                _context9.next = 7;
                break;
              }
              _context9.next = 6;
              return checkCouponBeforeSendToMagento(couponCode);
            case 6:
              _context9.t0 = _context9.sent;
            case 7:
              if (!_context9.t0) {
                _context9.next = 9;
                break;
              }
              return _context9.abrupt("return");
            case 9:
              _context9.prev = 9;
              _context9.next = 12;
              return _agent.requests.put((0, _createParametrizedUrl["default"])(token ? __webpack_require__.g.__appConfig__.customerCouponUrl : __webpack_require__.g.__appConfig__.guestCouponUrl, {
                couponCode: couponCode,
                cartId: getCartId()
              }), {}, token, languageAndDomain);
            case 12:
              _context9.next = 14;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 14:
              newCart = _context9.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread({}, newCart.totals)
              }));
              _context9.t1 = setCouponCodeFormPromotions;
              _context9.next = 19;
              return isCouponFromPromotions(couponCode);
            case 19:
              _context9.t2 = _context9.sent;
              (0, _context9.t1)(_context9.t2);
              setMinicartContentFromStorage();
              _context9.next = 28;
              break;
            case 24:
              _context9.prev = 24;
              _context9.t3 = _context9["catch"](9);
              handleResponseErrors(_context9.t3);
              throw _context9.t3;
            case 28:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[9, 24]]);
    }));
    return function addCouponCode(_x15) {
      return _ref9.apply(this, arguments);
    };
  }();
  var deleteCouponCode = /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10() {
      var cartId, newCart;
      return _regenerator["default"].wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              cartId = getCartIdFromStorage();
              _context10.prev = 1;
              _context10.next = 4;
              return _agent.requests.del((0, _createParametrizedUrl["default"])(token ? __webpack_require__.g.__appConfig__.deleteCustomerCouponUrl : __webpack_require__.g.__appConfig__.deleteGuestCouponUrl, {
                cartId: getCartId()
              }), token, languageAndDomain);
            case 4:
              _context10.next = 6;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 6:
              newCart = _context10.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread({}, newCart.totals)
              }));
              setCouponCodeFormPromotions(false);
              setMinicartContentFromStorage();
              _context10.next = 15;
              break;
            case 12:
              _context10.prev = 12;
              _context10.t0 = _context10["catch"](1);
              handleResponseErrors(_context10.t0);
            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 12]]);
    }));
    return function deleteCouponCode() {
      return _ref10.apply(this, arguments);
    };
  }();
  var truncateCart = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11() {
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _jsCookie["default"].remove("cartId");
              removeMinicartDataFromStorage();
              _context11.next = 4;
              return updateCart(null, false);
            case 4:
              _context11.next = 6;
              return createCart(token);
            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return function truncateCart() {
      return _ref11.apply(this, arguments);
    };
  }();
  var clearCart = function clearCart() {
    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref12$removeMinicart = _ref12.removeMinicart,
      removeMinicart = _ref12$removeMinicart === void 0 ? false : _ref12$removeMinicart;
    setCart(null);
    _jsCookie["default"].remove(__webpack_require__.g.__appConfig__.shippingMethodIdCookieName);
    if (removeMinicart) {
      _jsCookie["default"].remove("cartId");
      removeMinicartDataFromStorage();
      clearAccountData();
    }
  };
  var _usePromotions = (0, _usePromotions2["default"])({
      cart: cart,
      getCartId: getCartId,
      addCouponCode: addCouponCode,
      addProduct: addProduct
    }),
    checkCouponBeforeSendToMagento = _usePromotions.checkCouponBeforeSendToMagento,
    isProductFromPromotions = _usePromotions.isProductFromPromotions,
    isCouponFromPromotions = _usePromotions.isCouponFromPromotions;
  return __jsx(CartContext.Provider, {
    value: {
      getCartTotals: getCartTotals,
      addCouponCode: addCouponCode,
      deleteCouponCode: deleteCouponCode,
      cart: cart,
      shippingCost: getShippingCost(),
      updateShippingMethod: updateShippingMethod,
      handleResponseErrors: handleResponseErrors,
      getCartId: getCartId,
      truncateCart: truncateCart,
      createCart: createCart,
      mergeCart: mergeCart,
      fetchCart: _fetcher["default"],
      updateItemQuantity: updateItemQuantity,
      addProduct: addProduct,
      removeItem: removeItem,
      refreshCart: refreshCart,
      shippingMethods: shippingMethods,
      productsWithQuantity: productsWithQuantity,
      setProductsWithQuantity: setProductsWithQuantity,
      clearCart: clearCart,
      clearUserCartItems: clearUserCartItems
    }
  }, children);
}
function useCart() {
  var context = (0, _react.useContext)(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}
var _default = CartProvider;
exports["default"] = _default;

/***/ }),

/***/ 26929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CheckoutRegisterContextProvider = exports.useCheckoutRegister = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var Sentry = _interopRequireWildcard(__webpack_require__(44159));
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _agent = __webpack_require__(37642);
var _CartProvider = __webpack_require__(57955);
var _TokenProvider = __webpack_require__(36286);
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(26367));
var _router = __webpack_require__(53746);
var _OrdersProvider = __webpack_require__(64239);
var _EPoints = __webpack_require__(73223);
var _useErrorCheckout2 = _interopRequireDefault(__webpack_require__(72088));
var _useProductsBySkus = __webpack_require__(78108);
var _useCheckoutData2 = _interopRequireDefault(__webpack_require__(98753));
var _useCategoryTree2 = __webpack_require__(28452);
var _useAnalytics4AndCommerceTags = _interopRequireDefault(__webpack_require__(79892));
var _useShippingMethods2 = _interopRequireDefault(__webpack_require__(63896));
var _useSalesmanago = _interopRequireDefault(__webpack_require__(54569));
var _useAdyenCheckout2 = _interopRequireDefault(__webpack_require__(34251));
var _MessageHandlerProvider = __webpack_require__(82425);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _handleAdyenErrorMessage = _interopRequireDefault(__webpack_require__(36928));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CheckoutRegisterContext = /*#__PURE__*/_react["default"].createContext();
var orderIdCookieName = __webpack_require__.g.__appConfig__.orderIdCookieName;
var CheckoutRegisterContextProvider = function CheckoutRegisterContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    isPageLocked = _useState[0],
    setPageLocked = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    tokenNewRegister = _useState2[0],
    setTokenNewRegister = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    hadError = _useState3[0],
    setHadError = _useState3[1];
  var router = (0, _router.useRouter)();
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useCart = (0, _CartProvider.useCart)(),
    truncateCart = _useCart.truncateCart,
    cart = _useCart.cart,
    addCouponCode = _useCart.addCouponCode,
    getCartTotals = _useCart.getCartTotals,
    setProductsWithQuantity = _useCart.setProductsWithQuantity,
    handleResponseErrors = _useCart.handleResponseErrors,
    clearCart = _useCart.clearCart;
  var _useOrders = (0, _OrdersProvider.useOrders)(),
    removeUserOrders = _useOrders.removeUserOrders;
  var _useEPoints = (0, _EPoints.useEPoints)(),
    clearEPoints = _useEPoints.clearEPoints;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var _useCheckoutData = (0, _useCheckoutData2["default"])(),
    billingAddress = _useCheckoutData.billingAddress,
    email = _useCheckoutData.email,
    emailConsentForDelivery = _useCheckoutData.emailConsentForDelivery,
    updateOrderId = _useCheckoutData.updateOrderId;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    cartPurchased = _useAnalyticsAndComme.cartPurchased;
  var _useShippingMethods = (0, _useShippingMethods2["default"])(),
    selectedShippingMethod = _useShippingMethods.selectedShippingMethod;
  var translations = {
    error: (0, _langLibrary["default"])("Error"),
    something: (0, _langLibrary["default"])("Something went wrong"),
    adyenPaymentRefused: (0, _langLibrary["default"])("adyen_error_message"),
    adyenPaymentRefusedNoAmount: (0, _langLibrary["default"])("adyen_error_message_amount_exceeded")
  };
  var _useErrorCheckout = (0, _useErrorCheckout2["default"])(),
    checkError = _useErrorCheckout.checkError;
  var _useAdyenCheckout = (0, _useAdyenCheckout2["default"])({
      setPageLocked: setPageLocked
    }),
    handleAdyenPayment = _useAdyenCheckout.handleAdyenPayment;
  var clearCheckoutData = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              clearEPoints();
              _context.next = 3;
              return truncateCart();
            case 3:
              _context.next = 5;
              return removeUserOrders();
            case 5:
              clearCart();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "checkout_success"
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function clearCheckoutData() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (isPageLocked && router.pathname && !router.pathname.includes("payment")) {
      setPageLocked(false);
    }
  }, [router === null || router === void 0 ? void 0 : router.pathname]);
  var sendPaymentInformation = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
      var _values$paymentMethod, _values$adyenPayload, _values$adyenPayload2, _additional_data$bran;
      var values, onSuccess, onError, isAdyen, method, additional_data, adyenInfo, street, payload, url, _additional_data$bran2, paymentResponse, _getCartTotals$coupon, _getCartTotals, _values$paymentMethod2, isPayPal, orderData, cartTotals, _err$response, _err$response2, _err$response2$body, is404, skus, _additional_data$bran3, errorTranslate;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref2.values, onSuccess = _ref2.onSuccess, onError = _ref2.onError;
              if (!(!billingAddress || !(cart !== null && cart !== void 0 && cart.id))) {
                _context2.next = 4;
                break;
              }
              onError({
                globalErrors: [{
                  level: "negative",
                  title: translations.error,
                  description: checkError(_useErrorCheckout2["default"].ADDRESS_NOT_SET)
                }]
              });
              return _context2.abrupt("return");
            case 4:
              isAdyen = (_values$paymentMethod = values.paymentMethod) === null || _values$paymentMethod === void 0 ? void 0 : _values$paymentMethod.adyen;
              method = isAdyen ? values.paymentMethod.adyen : values.paymentMethod.id;
              additional_data = isAdyen ? values === null || values === void 0 ? void 0 : (_values$adyenPayload = values.adyenPayload) === null || _values$adyenPayload === void 0 ? void 0 : _values$adyenPayload.additionalData : {};
              adyenInfo = isAdyen ? {
                authenticationData: {
                  threeDSRequestData: {
                    nativeThreeDS: "preferred"
                  }
                },
                browserInfo: (_values$adyenPayload2 = values.adyenPayload) === null || _values$adyenPayload2 === void 0 ? void 0 : _values$adyenPayload2.browserInfo,
                channel: "Web",
                origin: "https://".concat(domain, "/")
              } : {};
              street = Array.isArray(billingAddress.street) ? billingAddress.street : [billingAddress.street];
              payload = _objectSpread({
                email: email,
                paymentMethod: {
                  method: method,
                  additional_data: additional_data
                },
                billing_address: {
                  email: email,
                  country_id: billingAddress.country.id,
                  street: emailConsentForDelivery ? [billingAddress.street, "Wyrażono zgodę na przekazanie adresu email kurierowi"] : street,
                  postcode: billingAddress.postalCode,
                  city: billingAddress.city,
                  telephone: billingAddress.phone,
                  firstname: billingAddress.firstName,
                  lastname: billingAddress.lastName,
                  company: billingAddress.companyName,
                  vat_id: billingAddress.vatId
                }
              }, adyenInfo);
              url = token ? __webpack_require__.g.__appConfig__.customerPlaceOrderUrl : (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.guestPlaceOrderUrl, {
                cartId: cart.id
              });
              if (additional_data !== null && additional_data !== void 0 && (_additional_data$bran = additional_data.brand_code) !== null && _additional_data$bran !== void 0 && _additional_data$bran.includes("blik")) {
                Sentry.setTag("payment_method", "blik");
                Sentry.setContext("blik_before_request_payment-information", {
                  payload: payload,
                  additional_data: additional_data
                });
                Sentry.captureMessage("BLIK: Payment processing before payment-information", "info");
              }
              _context2.prev = 12;
              _context2.next = 15;
              return _agent.requests.post(url, payload, token, {
                language: language,
                domain: domain
              });
            case 15:
              paymentResponse = _context2.sent;
              if (additional_data !== null && additional_data !== void 0 && (_additional_data$bran2 = additional_data.brand_code) !== null && _additional_data$bran2 !== void 0 && _additional_data$bran2.includes("blik")) {
                Sentry.setTag("payment_method", "blik");
                Sentry.setContext("blik_after_request_payment-information", {
                  paymentResponse: paymentResponse
                });
                Sentry.captureMessage("BLIK: Payment processing after payment-information", "info");
              }
              if (onSuccess) {
                cart.items.map(function (item, index) {
                  var _item$product, _item$product$categor;
                  cart.items[index].categoryName = getCategoryNameForGivenCategoryId((_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$categor = _item$product.category) === null || _item$product$categor === void 0 ? void 0 : _item$product$categor.id);
                });
                isPayPal = paymentResponse.includes("paypal");
                orderData = JSON.parse(paymentResponse);
                cartTotals = {
                  shippingTotal: getCartTotals().shippingCost,
                  subtotalPrice: getCartTotals().productsTotalPrice,
                  discountPrice: getCartTotals().discount,
                  totalPrice: getCartTotals().cartTotalPrice,
                  tax: getCartTotals().tax
                };
                cartPurchased(cart, cartTotals, language, isPayPal ? cart.id : orderData.orderId, (_getCartTotals$coupon = (_getCartTotals = getCartTotals()) === null || _getCartTotals === void 0 ? void 0 : _getCartTotals.couponCode) !== null && _getCartTotals$coupon !== void 0 ? _getCartTotals$coupon : "");
                _jsCookie["default"].remove(__webpack_require__.g.__appConfig__.shippingMethodIdCookieName);
                handleSalesmanagoEvent("PURCHASE", {
                  email: cart.billingAddress.email,
                  products: cart.items.map(function (item) {
                    return item.sku;
                  }),
                  value: cartTotals.totalPrice,
                  details: [cart.currency, selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.label, (_values$paymentMethod2 = values.paymentMethod) === null || _values$paymentMethod2 === void 0 ? void 0 : _values$paymentMethod2.label]
                });
                onSuccess(orderData);
              }
              _context2.next = 44;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](12);
              is404 = false;
              if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$response = _context2.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.statusCode) === 400) {
                // Sentry.captureException({
                //   err,
                //   payload,
                //   paymentAdditionalData: payload.paymentMethod.additional_data
                // });
                is404 = true;
                skus = [];
                cart.items.forEach(function (item) {
                  skus.push(item.product.sku);
                });
                (0, _useProductsBySkus.fetcher)({
                  skus: skus.toString(),
                  pageSize: 250,
                  language: {
                    language: language,
                    domain: domain
                  },
                  getQuantity: true,
                  visibility: true
                }).then(function (response) {
                  var skusAndQuantity = [];
                  response.forEach(function (item) {
                    skusAndQuantity.push({
                      sku: item.sku,
                      quantity: item.availability.quantity
                    });
                  });
                  setProductsWithQuantity(skusAndQuantity);
                });
              }
              if (!isAdyen) {
                _context2.next = 40;
                break;
              }
              if (!(additional_data !== null && additional_data !== void 0 && (_additional_data$bran3 = additional_data.brand_code) !== null && _additional_data$bran3 !== void 0 && _additional_data$bran3.includes("blik"))) {
                _context2.next = 38;
                break;
              }
              Sentry.setTag("payment_method", "blik");
              Sentry.setContext("blik_after_request_error_payment-information", {
                additional_data: additional_data,
                err: _context2.t0
              });
              Sentry.captureMessage("BLIK: Payment processing after request payment-information", "info");
              if (!_context2.t0.message.includes("Request has been terminated")) {
                _context2.next = 38;
                break;
              }
              Sentry.setTag("payment_method", "blik");
              Sentry.setContext("blik_request_has_been_terminated", {
                additional_data: additional_data,
                err: _context2.t0
              });
              Sentry.captureMessage("BLIK: Payment processing after request payment-information: blik request has been terminated", "error");
              _context2.next = 35;
              return clearCheckoutData();
            case 35:
              _jsCookie["default"].remove(orderIdCookieName);
              router.push("/checkout/success-partial");
              return _context2.abrupt("return");
            case 38:
              setHadError(404);
              (0, _handleAdyenErrorMessage["default"])({
                message: is404 ? translations.adyenPaymentRefusedNoAmount : translations.adyenPaymentRefused
              }, values.adyenPayload.component, handleMessage);
            case 40:
              handleResponseErrors(_context2.t0);
              errorTranslate = checkError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$body = _err$response2.body) === null || _err$response2$body === void 0 ? void 0 : _err$response2$body.message);
              onError(isAdyen ? null : {
                fieldErrors: errorTranslate,
                globalErrors: [{
                  level: "negative",
                  title: translations.error,
                  description: errorTranslate
                }]
              });
              setPageLocked(false);
            case 44:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[12, 20]]);
    }));
    return function sendPaymentInformation(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    var _JSON$parse;
    var setShippingAndPaymentInformation = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _agent.requests.post(__webpack_require__.g.__appConfig__.customerSetShippingInformation, tokenNewRegister.payload, token, {
                  language: language,
                  domain: domain
                });
              case 2:
                _context3.next = 4;
                return paymentInformation(tokenNewRegister.values, {
                  setErrors: tokenNewRegister.setErrors
                }, tokenNewRegister.alert);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function setShippingAndPaymentInformation() {
        return _ref4.apply(this, arguments);
      };
    }();
    if (tokenNewRegister && (tokenNewRegister === null || tokenNewRegister === void 0 ? void 0 : tokenNewRegister.customerCartId) === (cart === null || cart === void 0 ? void 0 : cart.id) && token && ((_JSON$parse = JSON.parse(localStorage.getItem("minicartContent"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id) > 0) {
      setTokenNewRegister(null);
      setPageLocked(true);
      if (tokenNewRegister.payload.couponCode) {
        addCouponCode(tokenNewRegister.payload.couponCode).then(_agent.requests.post(__webpack_require__.g.__appConfig__.customerSetShippingInformation, tokenNewRegister.payload, token, {
          language: language,
          domain: domain
        })).then(function () {
          paymentInformation(tokenNewRegister.values, {
            setErrors: tokenNewRegister.setErrors
          }, tokenNewRegister.alert).then(function () {});
        });
      } else {
        setShippingAndPaymentInformation().then()["catch"](function (err) {
          console.log("Error pay on register user", err);
          handleResponseErrors(err);
          setPageLocked(false);
        });
      }
    }
  }, [tokenNewRegister === null || tokenNewRegister === void 0 ? void 0 : tokenNewRegister.customerCartId, cart === null || cart === void 0 ? void 0 : cart.id, token]);
  var paymentInformation = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(values, _ref5, alert) {
      var setErrors;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setErrors = _ref5.setErrors;
              setPageLocked(true);
              _context5.prev = 2;
              setPageLocked(true);
              _context5.next = 6;
              return sendPaymentInformation({
                values: values,
                onError: function onError(errors) {
                  setPageLocked(false);
                  if (errors.globalErrors.length > 0) {
                    alert.show({
                      payload: errors.globalErrors[0]
                    });
                  }
                  var adyenComponent = values.adyenPayload.component;
                  if (adyenComponent) {
                    values.adyenPayload.component.unmount();
                    values.adyenPayload.component.mount(values.adyenPayload.component.elementRef.elementRef._node);
                  }
                  // setErrors(errors.fieldErrors); // TODO: sprawdzić czy potrzebne? zabija zmiane formy platnosci po 400 na POST payment-information
                },
                onSuccess: function () {
                  var _onSuccess = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(orderData) {
                    var redirectUrl, orderId, isAdyenPayment, _adyenResponse$action, _adyenResponse$action2, _adyenResponse$action3, adyenResponse;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            redirectUrl = orderData.redirectUrl, orderId = orderData.orderId;
                            isAdyenPayment = redirectUrl === null || redirectUrl === void 0 ? void 0 : redirectUrl.includes("adyen");
                            if (isAdyenPayment) {
                              _context4.next = 12;
                              break;
                            }
                            setPageLocked(true);
                            clearEPoints();
                            _context4.next = 7;
                            return truncateCart();
                          case 7:
                            _context4.next = 9;
                            return removeUserOrders();
                          case 9:
                            clearCart();
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: "checkout_success"
                            });
                          case 12:
                            if (!redirectUrl) {
                              _context4.next = 23;
                              break;
                            }
                            if (!isAdyenPayment) {
                              _context4.next = 20;
                              break;
                            }
                            _context4.next = 16;
                            return handleAdyenPayment({
                              orderId: orderId,
                              component: values.adyenPayload.component
                            });
                          case 16:
                            adyenResponse = _context4.sent;
                            if (!(adyenResponse !== null && adyenResponse !== void 0 && adyenResponse.isFinal) && adyenResponse !== null && adyenResponse !== void 0 && (_adyenResponse$action = adyenResponse.action) !== null && _adyenResponse$action !== void 0 && (_adyenResponse$action2 = _adyenResponse$action.type) !== null && _adyenResponse$action2 !== void 0 && (_adyenResponse$action3 = _adyenResponse$action2.includes) !== null && _adyenResponse$action3 !== void 0 && _adyenResponse$action3.call(_adyenResponse$action2, "threeDS2")) {
                              setPageLocked(false);
                            }
                            _context4.next = 21;
                            break;
                          case 20:
                            window.location.replace(redirectUrl.replace(/^.*\/\/[^\/]+/, ""));
                          case 21:
                            _context4.next = 24;
                            break;
                          case 23:
                            if (orderId > 0) {
                              router.push("/checkout/success").then(function () {
                                return setPageLocked(false);
                              });
                            }
                          case 24:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));
                  function onSuccess(_x5) {
                    return _onSuccess.apply(this, arguments);
                  }
                  return onSuccess;
                }()
              });
            case 6:
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](2);
              setPageLocked(false);
            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 8]]);
    }));
    return function paymentInformation(_x2, _x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }();
  return __jsx(CheckoutRegisterContext.Provider, {
    value: {
      isPageLocked: isPageLocked,
      setPageLocked: setPageLocked,
      hadError: hadError,
      setHadError: setHadError,
      setTokenNewRegister: setTokenNewRegister,
      paymentInformation: paymentInformation
    }
  }, props.children);
};
exports.CheckoutRegisterContextProvider = CheckoutRegisterContextProvider;
var useCheckoutRegister = function useCheckoutRegister() {
  var context = (0, _react.useContext)(CheckoutRegisterContext);
  if (!context) {
    throw new Error("useCheckoutRegister must be used within a CheckoutRegisterContext");
  }
  return context;
};
exports.useCheckoutRegister = useCheckoutRegister;

/***/ }),

/***/ 38073:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CurrencyContextProvider = exports.useCurrency = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var CurrencyContext = /*#__PURE__*/_react["default"].createContext();
var CurrencyContextProvider = function CurrencyContextProvider(_ref) {
  var children = _ref.children,
    currencyData = _ref.currencyData;
  var _useState = (0, _react.useState)(currencyData),
    currency = _useState[0],
    setCurrency = _useState[1];
  return __jsx(CurrencyContext.Provider, {
    value: {
      currency: currency
    }
  }, children);
};
exports.CurrencyContextProvider = CurrencyContextProvider;
var useCurrency = function useCurrency() {
  return (0, _react.useContext)(CurrencyContext);
};
exports.useCurrency = useCurrency;

/***/ }),

/***/ 73223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.EPointsContextProvider = exports.useEPoints = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _TokenProvider = __webpack_require__(36286);
var _agent = __webpack_require__(37642);
var _LanguageProvider = __webpack_require__(8989);
var _CartProvider = __webpack_require__(57955);
var _MessageHandlerProvider = __webpack_require__(82425);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _mapEPoints = _interopRequireDefault(__webpack_require__(90576));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EPointsContext = /*#__PURE__*/_react["default"].createContext();
var defaultEPoints = {
  availablePoints: null,
  lockedPoints: null,
  pointsSavedInCart: null,
  history: []
};
var defaultPending = {
  ePointsData: false,
  pointsToEarn: false
};
var EPointsContextProvider = function EPointsContextProvider(_ref) {
  var children = _ref.children;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useCart = (0, _CartProvider.useCart)(),
    handleResponseErrors = _useCart.handleResponseErrors,
    cart = _useCart.cart;
  var _useState = (0, _react.useState)(_objectSpread({}, defaultPending)),
    isPending = _useState[0],
    setPending = _useState[1];
  var _useState2 = (0, _react.useState)(_objectSpread({}, defaultEPoints)),
    ePoints = _useState2[0],
    setEPoints = _useState2[1];
  var translations = {
    errorPoints: (0, _langLibrary["default"])("You don't have enough points"),
    totalPriceUnderZero: (0, _langLibrary["default"])("Too many points provided")
  };
  var getPointsSavedInCart = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _cart$totals, points;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (token) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(isPending !== null && isPending !== void 0 && isPending.pointsToEarn)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", ePoints !== null && ePoints !== void 0 && ePoints.pointsSavedInCart ? ePoints.pointsSavedInCart : undefined);
            case 4:
              setPending(_objectSpread(_objectSpread({}, isPending), {}, {
                pointsToEarn: true
              }));
              _context.prev = 5;
              points = (_cart$totals = cart.totals) === null || _cart$totals === void 0 ? void 0 : _cart$totals.ePremiaPoints;
              setEPoints(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  pointsSavedInCart: points
                });
              });
              return _context.abrupt("return", points);
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 11]]);
    }));
    return function getPointsSavedInCart() {
      return _ref2.apply(this, arguments);
    };
  }();
  var isPendingEPointsData = false;
  var getEPoints = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var ePremiaMapped;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (token) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", null);
            case 2:
              if (!isPendingEPointsData) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              if (!(isPending !== null && isPending !== void 0 && isPending.ePointsData)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", ePoints ? ePoints : null);
            case 6:
              isPendingEPointsData = true;
              setPending(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  ePointsData: true
                });
              });
              _context2.prev = 8;
              _context2.t0 = _mapEPoints["default"];
              _context2.next = 12;
              return _agent.requests.get(__webpack_require__.g.__appConfig__.ePointsAccount, false, token, language);
            case 12:
              _context2.t1 = _context2.sent;
              ePremiaMapped = (0, _context2.t0)(_context2.t1);
              setEPoints(function (prev) {
                return _objectSpread(_objectSpread({}, prev), ePremiaMapped);
              });
              return _context2.abrupt("return", ePremiaMapped);
            case 18:
              _context2.prev = 18;
              _context2.t2 = _context2["catch"](8);
            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 18]]);
    }));
    return function getEPoints() {
      return _ref3.apply(this, arguments);
    };
  }();
  var clearEPoints = function clearEPoints() {
    setEPoints(_objectSpread({}, defaultEPoints));
    setPending(_objectSpread({}, defaultPending));
  };
  var addPoints = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(points) {
      var _cart$totals2;
      var isErrorCart;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              points = parseInt(points);
              if (!(!ePoints.pointsSavedInCart && points === 0 || !token)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              if (!(points > (ePoints === null || ePoints === void 0 ? void 0 : ePoints.availablePoints))) {
                _context3.next = 6;
                break;
              }
              handleMessage(translations.errorPoints, false);
              return _context3.abrupt("return");
            case 6:
              if (!(((_cart$totals2 = cart.totals) === null || _cart$totals2 === void 0 ? void 0 : _cart$totals2.cartTotalPrice) - points / 100 < 0)) {
                _context3.next = 9;
                break;
              }
              handleMessage(translations.totalPriceUnderZero, false);
              return _context3.abrupt("return");
            case 9:
              _context3.prev = 9;
              _context3.next = 12;
              return _agent.requests.put(__webpack_require__.g.__appConfig__.ePointsAddPoints + "/".concat(points), false, token, language);
            case 12:
              //Todo po co to ? :)
              // await setPaymentWithTotals(null);

              setEPoints(_objectSpread(_objectSpread({}, ePoints), {}, {
                pointsSavedInCart: points
              }));
              _context3.next = 21;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](9);
              _context3.next = 19;
              return handleResponseErrors(_context3.t0);
            case 19:
              isErrorCart = _context3.sent;
              if (!isErrorCart) {
                handleMessage(_context3.t0);
              }
            case 21:
              return _context3.abrupt("return", points);
            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 15]]);
    }));
    return function addPoints(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return __jsx(EPointsContext.Provider, {
    value: {
      availablePoints: ePoints === null || ePoints === void 0 ? void 0 : ePoints.availablePoints,
      history: ePoints === null || ePoints === void 0 ? void 0 : ePoints.history,
      pointsInCart: ePoints === null || ePoints === void 0 ? void 0 : ePoints.pointsSavedInCart,
      getEPoints: getEPoints,
      addPoints: addPoints,
      getPointsSavedInCart: getPointsSavedInCart,
      clearEPoints: clearEPoints
    }
  }, children);
};
exports.EPointsContextProvider = EPointsContextProvider;
var useEPoints = function useEPoints() {
  var loadEPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useContext = (0, _react.useContext)(EPointsContext),
    getEPoints = _useContext.getEPoints,
    availablePoints = _useContext.availablePoints,
    history = _useContext.history,
    addPoints = _useContext.addPoints,
    pointsInCart = _useContext.pointsInCart,
    getPointsSavedInCart = _useContext.getPointsSavedInCart,
    clearEPoints = _useContext.clearEPoints;
  (0, _react.useEffect)(function () {
    if (loadEPoints) {
      getEPoints();
    }
  }, [loadEPoints]);
  var pointsSavedInCart = function pointsSavedInCart() {
    var loadPointsSavedInCart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    (0, _react.useEffect)(function () {
      if (!loadPointsSavedInCart) return;
      if (!pointsInCart) {
        getPointsSavedInCart();
      }
    }, [loadPointsSavedInCart]);
    return pointsInCart;
  };
  return {
    availablePoints: availablePoints,
    history: history,
    addPoints: addPoints,
    pointsSavedInCart: pointsSavedInCart,
    clearEPoints: clearEPoints
  };
};
exports.useEPoints = useEPoints;

/***/ }),

/***/ 64239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.OrdersContextProvider = exports.useOrders = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _agent = __webpack_require__(37642);
var _useProductsBySkus = __webpack_require__(78108);
var _AccountProvider = __webpack_require__(8636);
var _TokenProvider = __webpack_require__(36286);
var _CartProvider = __webpack_require__(57955);
var _LanguageProvider = __webpack_require__(8989);
var _mapOrder = _interopRequireDefault(__webpack_require__(90731));
var _mapAddressNew = _interopRequireDefault(__webpack_require__(12248));
var _createSearchUrl = __webpack_require__(8371);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OrdersContext = /*#__PURE__*/_react["default"].createContext();
OrdersContext.IN_PROGRESS = "inProgress";
OrdersContext.COMPLETE = "complete";
var OrdersContextProvider = function OrdersContextProvider(props) {
  var children = props.children;
  var _useState = (0, _react.useState)({
      customerId: null,
      mostRecentOrder: null
    }),
    ordersState = _useState[0],
    setOrdersState = _useState[1];
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useCart = (0, _CartProvider.useCart)(),
    handleResponseErrors = _useCart.handleResponseErrors;
  var _useAccount = (0, _AccountProvider.useAccount)(),
    accountData = _useAccount.accountData;
  var getOrders = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(ordersType, pageSize, currentPage) {
      var isMostRecentOrder,
        _sessionStorage,
        ordersInStorage,
        id,
        ordersFilters,
        ordersRequestParams,
        orderList,
        ordersSkus,
        uniqueSkus,
        products,
        _sessionStorage2,
        idAndOrders,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isMostRecentOrder = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
              if (!(typeof window !== "undefined")) {
                _context.next = 40;
                break;
              }
              _context.prev = 2;
              ordersInStorage = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("mostRecentOrderAndCustomerId");
              if (!(ordersInStorage && isMostRecentOrder)) {
                _context.next = 7;
                break;
              }
              setOrdersState(JSON.parse(ordersInStorage));
              return _context.abrupt("return");
            case 7:
              id = ordersState.customerId;
              if (!id) {
                id = accountData.id;
              }
              _context.t0 = ordersType;
              _context.next = _context.t0 === OrdersContext.IN_PROGRESS ? 12 : _context.t0 === OrdersContext.COMPLETE ? 14 : 16;
              break;
            case 12:
              ordersFilters = {
                field: "state",
                condition_type: "nin",
                value: ["complete", "cancelled"],
                connector: _createSearchUrl.CONNECTORS.AND
              };
              return _context.abrupt("break", 17);
            case 14:
              ordersFilters = {
                field: "state",
                condition_type: "in",
                value: ["complete", "cancelled"],
                connector: _createSearchUrl.CONNECTORS.AND
              };
              return _context.abrupt("break", 17);
            case 16:
              ordersFilters = null;
            case 17:
              ordersRequestParams = ordersType ? [ordersFilters, {
                sort_field: "created_at",
                direction: "desc",
                connector: _createSearchUrl.CONNECTORS.AND
              }, {
                pageSize: pageSize
              }, {
                currentPage: currentPage
              }] : [{
                sort_field: "created_at",
                direction: "desc",
                connector: _createSearchUrl.CONNECTORS.AND
              }, {
                pageSize: pageSize
              }, {
                currentPage: currentPage
              }];
              _context.next = 20;
              return _agent.requests.get((0, _createSearchUrl.createSearchUrl)(__webpack_require__.g.__appConfig__.orders, ordersRequestParams), false, token, language);
            case 20:
              orderList = _context.sent;
              orderList === null || orderList === void 0 ? void 0 : orderList.items.map(function (order) {
                var _order$extension_attr, _order$extension_attr2, _order$extension_attr3;
                order.skus = order.items.map(function (product) {
                  return product.sku.toString();
                });
                order.products = order.items;
                var shippingOrder = order === null || order === void 0 ? void 0 : (_order$extension_attr = order.extension_attributes) === null || _order$extension_attr === void 0 ? void 0 : (_order$extension_attr2 = _order$extension_attr.shipping_assignments) === null || _order$extension_attr2 === void 0 ? void 0 : (_order$extension_attr3 = _order$extension_attr2[0]) === null || _order$extension_attr3 === void 0 ? void 0 : _order$extension_attr3.shipping;
                order.billingAddress = (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, order.billing_address), {}, {
                  country: [{
                    id: order.billing_address.country_id
                  }]
                }));
                order.shippingAddress = shippingOrder !== null && shippingOrder !== void 0 && shippingOrder.address ? (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, shippingOrder.address), {}, {
                  country: [{
                    id: shippingOrder.address.country_id
                  }]
                })) : null;
              });
              ordersSkus = orderList.items.map(function (order) {
                return order.skus;
              }).toString();
              uniqueSkus = ordersSkus ? ordersSkus.split(",").reduce(function (uniqueSku, sku) {
                return uniqueSku.includes(sku) ? uniqueSku : [].concat((0, _toConsumableArray2["default"])(uniqueSku), [sku]);
              }, []) : null;
              if (!uniqueSkus) {
                _context.next = 30;
                break;
              }
              _context.next = 27;
              return (0, _useProductsBySkus.fetcher)({
                skus: uniqueSkus,
                pageSize: 10,
                language: language
              });
            case 27:
              _context.t1 = _context.sent;
              _context.next = 31;
              break;
            case 30:
              _context.t1 = [];
            case 31:
              products = _context.t1;
              if (isMostRecentOrder) {
                idAndOrders = {
                  customerId: id,
                  mostRecentOrder: orderList ? orderList === null || orderList === void 0 ? void 0 : orderList.items.map(function (order) {
                    return (0, _mapOrder["default"])(order, products.filter(function (product) {
                      return order.skus.includes(product.sku);
                    }));
                  }) : []
                };
                (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.setItem("mostRecentOrderAndCustomerId", JSON.stringify(idAndOrders));
                setOrdersState(idAndOrders);
              }
              return _context.abrupt("return", {
                orders: orderList ? orderList === null || orderList === void 0 ? void 0 : orderList.items.map(function (order) {
                  return (0, _mapOrder["default"])(order, products.filter(function (product) {
                    return order.skus.includes(product.sku);
                  }));
                }) : [],
                totalCount: orderList.total_count
              });
            case 36:
              _context.prev = 36;
              _context.t2 = _context["catch"](2);
              console.log("There was an error while fetching customer's order list");
              handleResponseErrors(_context.t2);
            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 36]]);
    }));
    return function getOrders(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var removeUserOrders = function removeUserOrders() {
    var _sessionStorage3, _sessionStorage4;
    (_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.removeItem("mostRecentOrderAndCustomerId");
    (_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : _sessionStorage4.removeItem("ordersList");
    setOrdersState({
      customerId: null,
      mostRecentOrder: null
    });
  };
  var getFullOrdersList = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(currentPage, ordersType, pageSize) {
      var orders;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getOrders(ordersType, pageSize !== null && pageSize !== void 0 ? pageSize : __webpack_require__.g.__appConfig__.ordersPageSize, currentPage, false);
            case 2:
              orders = _context2.sent;
              return _context2.abrupt("return", orders);
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function getFullOrdersList(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
  return __jsx(OrdersContext.Provider, {
    value: {
      getOrders: getOrders,
      mostRecentOrder: ordersState.mostRecentOrder,
      removeUserOrders: removeUserOrders,
      getFullOrdersList: getFullOrdersList,
      ordersTypes: {
        inProgress: OrdersContext.IN_PROGRESS,
        complete: OrdersContext.COMPLETE
      }
    }
  }, children);
};
exports.OrdersContextProvider = OrdersContextProvider;
var useOrders = function useOrders() {
  var loadOrders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useContext = (0, _react.useContext)(OrdersContext),
    getOrders = _useContext.getOrders,
    mostRecentOrder = _useContext.mostRecentOrder,
    removeUserOrders = _useContext.removeUserOrders,
    getFullOrdersList = _useContext.getFullOrdersList,
    ordersTypes = _useContext.ordersTypes;
  (0, _react.useEffect)(function () {
    if (loadOrders && !mostRecentOrder) {
      getOrders(null, 1, 0, true);
    }
  }, [loadOrders]);
  return {
    getOrders: getOrders,
    mostRecentOrder: mostRecentOrder,
    removeUserOrders: removeUserOrders,
    getFullOrdersList: getFullOrdersList,
    ordersTypes: ordersTypes
  };
};
exports.useOrders = useOrders;
var _default = OrdersContextProvider;
exports["default"] = _default;

/***/ }),

/***/ 54730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WishlistContextProvider = exports.useWishlist = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _agent = __webpack_require__(37642);
var _TokenProvider = __webpack_require__(36286);
var _LanguageProvider = __webpack_require__(8989);
var _MessageHandlerProvider = __webpack_require__(82425);
var _useProductsBySkus = __webpack_require__(78108);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _CartProvider = __webpack_require__(57955);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var WishlistContext = /*#__PURE__*/_react["default"].createContext();
var WishlistContextProvider = function WishlistContextProvider(props) {
  var _useState = (0, _react.useState)(),
    wishlistSkus = _useState[0],
    setWishlistSkus = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    wishlistProducts = _useState2[0],
    setWishlistProducts = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    wishlistLoading = _useState3[0],
    setWishlistLoading = _useState3[1];
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useCart = (0, _CartProvider.useCart)(),
    addProduct = _useCart.addProduct;
  var wishlistEndpoint = "https://".concat(language.domain, "/").concat(__webpack_require__.g.__appConfig__.wishlistEndpointUrl, "/");
  var translations = {
    addedToWishlist: (0, _langLibrary["default"])("Added to wishlist"),
    removedFromWishlist: (0, _langLibrary["default"])("Removed from wishlist")
  };
  (0, _react.useEffect)(function () {
    var _sessionStorage;
    var isCanceled = false;
    var fetchWishlistSkus = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var wishList;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(wishlistSkus === undefined)) {
                  _context.next = 11;
                  break;
                }
                _context.prev = 1;
                _context.next = 4;
                return _agent.requests.getExternal(wishlistEndpoint, false, token);
              case 4:
                wishList = _context.sent;
                if (!isCanceled) {
                  setWishlistSkus(wishList.skus);
                  sessionStorage.setItem("wishlist", JSON.stringify(wishList.skus));
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                handleMessage(_context.t0);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function fetchWishlistSkus() {
        return _ref.apply(this, arguments);
      };
    }();
    var storedWishlist = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("wishlist");
    if (token) {
      if (storedWishlist) {
        setWishlistSkus(JSON.parse(storedWishlist));
      } else {
        fetchWishlistSkus().then();
      }
    } else {
      sessionStorage.removeItem("wishlist");
      setWishlistSkus(undefined);
    }
    return function () {
      isCanceled = true;
    };
  }, [token]);
  (0, _react.useEffect)(function () {
    var isCanceled = false;
    var getProducts = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(skusToFetch) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _useProductsBySkus.fetcher)({
                  skus: skusToFetch,
                  pageSize: 1000,
                  language: language
                });
              case 3:
                return _context2.abrupt("return", _context2.sent);
              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);
                return _context2.abrupt("return", []);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));
      return function getProducts(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    if (!wishlistSkus) {
      setWishlistProducts([]);
      return;
    }
    if (wishlistProducts.length === 0) {
      getProducts(wishlistSkus).then(function (result) {
        if (!isCanceled) {
          setWishlistProducts(result);
        }
      });
    } else if (wishlistSkus.length > wishlistProducts.length) {
      getProducts(wishlistSkus[wishlistSkus.length - 1]).then(function (result) {
        if (!isCanceled) {
          setWishlistProducts(function (currentProducts) {
            return [].concat((0, _toConsumableArray2["default"])(currentProducts), [result[0]]);
          });
        }
      });
    } else {
      var productsToSave = wishlistProducts.filter(function (product) {
        return wishlistSkus.includes(product.sku);
      });
      setWishlistProducts(productsToSave);
    }
    return function () {
      isCanceled = true;
    };
  }, [wishlistSkus]);
  var addToWishlist = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(sku) {
      var newList;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _agent.requests.postExternal(wishlistEndpoint + sku, false, token);
            case 3:
              newList = [].concat((0, _toConsumableArray2["default"])(wishlistSkus), [sku]);
              setWishlistSkus(newList);
              sessionStorage.setItem("wishlist", JSON.stringify(newList));
              handleMessage(translations.addedToWishlist, false, false);
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              handleMessage(_context3.t0);
            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));
    return function addToWishlist(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var removeFromWishlist = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(sku) {
      var newList;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _agent.requests.delExternal(wishlistEndpoint + sku, false, token);
            case 3:
              newList = wishlistSkus.filter(function (id) {
                return id !== sku;
              });
              setWishlistSkus(newList);
              sessionStorage.setItem("wishlist", JSON.stringify(newList));
              handleMessage(translations.removedFromWishlist, false, true);
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              handleMessage(_context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));
    return function removeFromWishlist(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var addWholeWishlistToCart = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(currentPage, pageSize) {
      var addSingle, skusFiltered, skusFilteredPromises;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              addSingle = /*#__PURE__*/function () {
                var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(sku) {
                  return _regenerator["default"].wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;
                          _context5.next = 3;
                          return addProduct({
                            sku: sku
                          }, 1);
                        case 3:
                          return _context5.abrupt("return", _context5.sent);
                        case 6:
                          _context5.prev = 6;
                          _context5.t0 = _context5["catch"](0);
                          console.log(_context5.t0);
                          return _context5.abrupt("return");
                        case 10:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[0, 6]]);
                }));
                return function addSingle(_x6) {
                  return _ref6.apply(this, arguments);
                };
              }();
              skusFiltered = wishlistSkus === null || wishlistSkus === void 0 ? void 0 : wishlistSkus.filter(function (_, index) {
                return index >= currentPage * pageSize - pageSize && index < currentPage * pageSize;
              });
              skusFilteredPromises = skusFiltered.map(addSingle);
              _context6.next = 5;
              return Promise.all(skusFilteredPromises);
            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function addWholeWishlistToCart(_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  return __jsx(WishlistContext.Provider, {
    value: {
      accountWishlist: wishlistSkus,
      wishlistProducts: wishlistProducts,
      setWishlistSkus: setWishlistSkus,
      wishlistLoading: wishlistLoading,
      setWishlistLoading: setWishlistLoading,
      addWholeWishlistToCart: addWholeWishlistToCart,
      addToWishlist: addToWishlist,
      removeFromWishlist: removeFromWishlist
    }
  }, props.children);
};
exports.WishlistContextProvider = WishlistContextProvider;
var useWishlist = function useWishlist() {
  return (0, _react.useContext)(WishlistContext);
};
exports.useWishlist = useWishlist;

/***/ }),

/***/ 82106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _CartProvider = __webpack_require__(57955);
var _useMinicart2 = __webpack_require__(34698);
var _MessageHandlerProvider = __webpack_require__(82425);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _useAnalytics4AndCommerceTags = _interopRequireDefault(__webpack_require__(79892));
var _useSalesmanago = _interopRequireDefault(__webpack_require__(54569));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function useCartModifier(props) {
  var product = props.product,
    categoryName = props.categoryName,
    listId = props.listId,
    listType = props.listType,
    listPosition = props.listPosition,
    isProductPageHit = props.isProductPageHit;
  var _useState = (0, _react.useState)(false),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useCart = (0, _CartProvider.useCart)(),
    addProduct = _useCart.addProduct,
    removeItem = _useCart.removeItem,
    updateItemQuantity = _useCart.updateItemQuantity,
    cart = _useCart.cart;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    setMinicartLoading = _useMinicart.setMinicartLoading,
    addNewItemToMinicart = _useMinicart.addNewItemToMinicart,
    removeItemFromMinicart = _useMinicart.removeItemFromMinicart,
    updateMinicartContent = _useMinicart.updateMinicartContent,
    setMinicartContentFromStorage = _useMinicart.setMinicartContentFromStorage,
    minicartState = _useMinicart.minicartState,
    updateTemporaryData = _useMinicart.updateTemporaryData;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productAddedToCart = _useAnalyticsAndComme.productAddedToCart,
    productRemovedFromCart = _useAnalyticsAndComme.productRemovedFromCart;
  var translations = {
    productAddedToCart: (0, _langLibrary["default"])("Product was added to cart")
  };
  var qtyUpdateDifference = function qtyUpdateDifference(quantity, changedProduct) {
    return quantity - minicartState.minicartContent.find(function (stateProduct) {
      return stateProduct.sku === changedProduct.sku;
    }).quantity;
  };
  var add = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(quantity) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setMinicartLoading(true);
              updateTemporaryData(quantity, product);
              _context.prev = 3;
              _context.next = 6;
              return addProduct(product, quantity, isProductPageHit);
            case 6:
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              addNewItemToMinicart(product, quantity);
              handleMessage(translations.productAddedToCart, false, false);
              productAddedToCart(product, quantity, categoryName, cart === null || cart === void 0 ? void 0 : cart.currency, listId, listType, listPosition);
              handleSalesmanagoEvent("CART", {
                products: [product.sku],
                details: [translations.productAddedToCart],
                value: product.price.special ? product.price.special : product.price.regular
              });
              _context.next = 21;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](3);
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              handleMessage(_context.t0);
            case 21:
              setMinicartContentFromStorage();
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 15]]);
    }));
    return function add(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var update = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(quantity) {
      var qtyDifference;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              setMinicartLoading(true);
              qtyDifference = qtyUpdateDifference(quantity, product);
              updateTemporaryData(qtyDifference, product);
              _context2.prev = 4;
              _context2.next = 7;
              return updateItemQuantity(product.sku, quantity);
            case 7:
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              qtyDifference > 0 ? productAddedToCart(product, qtyDifference, categoryName) : productRemovedFromCart(product, categoryName, Math.abs(qtyDifference));
              updateMinicartContent(product.sku, quantity);
              handleSalesmanagoEvent("CART", {
                products: [product.sku],
                details: [translations.productUpdated, "Qty: " + quantity],
                value: product.price.special ? product.price.special : product.price.regular
              });
              _context2.next = 22;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](4);
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              handleMessage(_context2.t0);
              throw _context2.t0;
            case 22:
              setMinicartContentFromStorage();
            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 15]]);
    }));
    return function update(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var remove = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(productCategoryName, quantity) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              setMinicartLoading(true);
              removeItemFromMinicart(product.sku);
              _context3.prev = 3;
              _context3.next = 6;
              return removeItem(product.sku);
            case 6:
              setLoading(false);
              setMinicartLoading(false);
              productRemovedFromCart(product, productCategoryName, quantity);
              handleSalesmanagoEvent("CART", {
                products: [product.sku],
                details: [translations.productDeleted],
                value: product.price.special ? product.price.special : product.price.regular
              });
              _context3.next = 17;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              setLoading(false);
              setMinicartLoading(false);
              handleMessage(_context3.t0);
            case 17:
              setMinicartContentFromStorage();
            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));
    return function remove(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    loading: loading,
    add: add,
    remove: remove,
    update: update
  };
}
var _default = useCartModifier;
exports["default"] = _default;

/***/ }),

/***/ 5549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _mapCategories = _interopRequireDefault(__webpack_require__(85973));
var _searchTree = _interopRequireDefault(__webpack_require__(50802));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(lang) {
    var categoriesData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _agent.requests.get(__webpack_require__.g.__appConfig__.categoriesWithImagesUrl, true, null, lang);
          case 2:
            categoriesData = _context.sent;
            categoriesData = (0, _searchTree["default"])(categoriesData, __webpack_require__.g.__appConfig__.menuSelectByCategoryID, true);
            return _context.abrupt("return", (0, _mapCategories["default"])(categoriesData));
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 79592:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _useCategories["default"];
  }
});
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
__webpack_unused_export__ = void 0;
var _useCategories = _interopRequireDefault(__webpack_require__(37095));
var _fetcher = _interopRequireDefault(__webpack_require__(5549));
var _default = _useCategories["default"];
__webpack_unused_export__ = _default;

/***/ }),

/***/ 37095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(5549));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var useCategories = function useCategories(language, fetchedCategories) {
  return (0, _swr["default"])([language, "useCategories"], _fetcher["default"], {
    initialData: fetchedCategories
  });
};
var _default = useCategories;
exports["default"] = _default;

/***/ }),

/***/ 11324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _mapMenu = _interopRequireDefault(__webpack_require__(24350));
var _sortMenuByPosition = _interopRequireDefault(__webpack_require__(28991));
var _searchTree2 = _interopRequireDefault(__webpack_require__(50802));
var _rootCategory = __webpack_require__(84660);
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(getUrl, lang) {
    var _searchTree$children_, _searchTree, _menu, _menu$;
    var menu, rootCategory, categoryTree;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _agent.requests.get(__webpack_require__.g.__appConfig__.menuWithImagesUrl, 1, null, lang);
          case 2:
            menu = _context.sent;
            menu = (_searchTree$children_ = (_searchTree = (0, _searchTree2["default"])(menu, __webpack_require__.g.__appConfig__.menuSelectByCategoryID, true)) === null || _searchTree === void 0 ? void 0 : _searchTree.children_data) !== null && _searchTree$children_ !== void 0 ? _searchTree$children_ : [];
            rootCategory = (0, _rootCategory.getRootCategory)((_menu = menu) === null || _menu === void 0 ? void 0 : (_menu$ = _menu[0]) === null || _menu$ === void 0 ? void 0 : _menu$.url_path);
            categoryTree = (0, _sortMenuByPosition["default"])((0, _mapMenu["default"])(menu, getUrl));
            return _context.abrupt("return", {
              categoryTree: categoryTree,
              rootCategory: rootCategory
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 43974:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _useCategoryTree["default"];
  }
});
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
__webpack_unused_export__ = void 0;
var _useCategoryTree = _interopRequireDefault(__webpack_require__(81746));
var _fetcher = _interopRequireDefault(__webpack_require__(11324));
var _default = _useCategoryTree["default"];
__webpack_unused_export__ = _default;

/***/ }),

/***/ 81746:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(11324));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var useCategoryTree = function useCategoryTree(lang, fetchedCategoryTree) {
  return (0, _swr["default"])(["useCategoryTree"], _fetcher["default"], {
    initialData: fetchedCategoryTree
  });
};
var _default = useCategoryTree;
exports["default"] = _default;

/***/ }),

/***/ 16674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _mapProductDataNew = _interopRequireDefault(__webpack_require__(69729));
var _agent = __webpack_require__(37642);
var _createSearchUrl = __webpack_require__(8371);
var fetcher = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var skus, language, _ref$pageSize, pageSize, _ref$getQuantity, getQuantity, _ref$visibility, visibility, productsBySkusMapped, productsBySkus;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            skus = _ref.skus, language = _ref.language, _ref$pageSize = _ref.pageSize, pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize, _ref$getQuantity = _ref.getQuantity, getQuantity = _ref$getQuantity === void 0 ? false : _ref$getQuantity, _ref$visibility = _ref.visibility, visibility = _ref$visibility === void 0 ? false : _ref$visibility;
            productsBySkusMapped = [];
            if (skus) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", productsBySkusMapped);
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return _agent.requests.get("".concat((0, _createSearchUrl.createSearchUrl)("/products", [{
              field: "sku",
              condition_type: "in",
              value: skus,
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "type_id",
              value: "simple",
              connector: _createSearchUrl.CONNECTORS.AND
            }, visibility ? {} : {
              field: "visibility",
              condition_type: "in",
              value: [2, 4],
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              pageSize: pageSize
            }])).concat(getQuantity ? "&additionalFields=qty" : ""), getQuantity ? false : __webpack_require__.g.__appConfig__.elasticEnabled, null, language);
          case 7:
            productsBySkus = _context.sent;
            if (productsBySkus.total_count > 0) {
              productsBySkusMapped = (0, _mapProductDataNew["default"])(productsBySkus.items);
            } else {
              productsBySkusMapped = [];
            }
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            console.log("There was an error while fetching products by skus ".concat(skus));
            productsBySkusMapped = [];
          case 15:
            return _context.abrupt("return", productsBySkusMapped);
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));
  return function fetcher(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 78108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "useProductsBySkus", ({
  enumerable: true,
  get: function get() {
    return _useProductsBySkus["default"];
  }
}));
Object.defineProperty(exports, "fetcher", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
exports["default"] = void 0;
var _useProductsBySkus = _interopRequireDefault(__webpack_require__(58810));
var _fetcher = _interopRequireDefault(__webpack_require__(16674));
var _default = _useProductsBySkus["default"];
exports["default"] = _default;

/***/ }),

/***/ 58810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(16674));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var _LanguageProvider = __webpack_require__(8989);
var useProductsBySkus = function useProductsBySkus(skus, pageSize, fetchedProductsBySkus) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([skus, pageSize, language, "useProductsBySkus"], function (skus, pageSize, language) {
    return (0, _fetcher["default"])({
      skus: skus,
      pageSize: pageSize,
      language: language
    });
  }, {
    initialData: fetchedProductsBySkus
  });
};
var _default = useProductsBySkus;
exports["default"] = _default;

/***/ }),

/***/ 59901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _react = __webpack_require__(34885);
var _agent = __webpack_require__(37642);
var _router = _interopRequireDefault(__webpack_require__(53746));
var _useProductsBySkus = __webpack_require__(78108);
var _LanguageProvider = __webpack_require__(8989);
var _couponHit = _interopRequireDefault(__webpack_require__(62639));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var skusActions = {
  notIncluded: function notIncluded(_ref) {
    var group = _ref.group,
      items = _ref.items,
      producer = _ref.producer,
      skus = _ref.skus;
    return group.every(function (sku) {
      return !skus.includes(sku);
    });
  },
  isOneOf: function isOneOf(_ref2) {
    var group = _ref2.group,
      items = _ref2.items,
      producer = _ref2.producer,
      skus = _ref2.skus;
    if (producer) {
      return items.find(function (item) {
        var _ref3, _item$product, _item$product$produce;
        return (_ref3 = (item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$produce = _item$product.producer) === null || _item$product$produce === void 0 ? void 0 : _item$product$produce.toUpperCase()) === (producer === null || producer === void 0 ? void 0 : producer.toUpperCase())) !== null && _ref3 !== void 0 ? _ref3 : false;
      });
    }
    return group.some(function (sku) {
      return skus.includes(sku);
    });
  }
};
var cartActions = {
  equalOrGreater: function equalOrGreater(_ref4) {
    var cartPrice = _ref4.cartPrice,
      conditionPrice = _ref4.conditionPrice;
    return cartPrice >= conditionPrice;
  }
};
var checkParticipatingSkus = function checkParticipatingSkus(_ref5) {
  var participatingSkus = _ref5.participatingSkus,
    itemsInCart = _ref5.itemsInCart,
    skusInCart = _ref5.skusInCart;
  if (!participatingSkus) {
    return true;
  }
  return participatingSkus.every(function (participating) {
    var _skusActions$particip;
    return (_skusActions$particip = skusActions[participating.type]) === null || _skusActions$particip === void 0 ? void 0 : _skusActions$particip.call(skusActions, {
      group: participating.group,
      items: itemsInCart,
      producer: participating.producer,
      skus: skusInCart
    });
  });
};
var checkCartTotalPriceWithProducer = function checkCartTotalPriceWithProducer(_ref6) {
  var _length, _ref7;
  var totals = _ref6.totals,
    cart = _ref6.cart;
  var producers = totals.producer,
    producerType = totals.producerType,
    producerQty = totals.producerQty,
    producerQtyType = totals.producerQtyType;
  var items = cart.items;
  var cartTotalPrice = 0;
  producers = producers.map(function (producer) {
    var _producer$toUpperCase;
    return (_producer$toUpperCase = producer === null || producer === void 0 ? void 0 : producer.toUpperCase()) !== null && _producer$toUpperCase !== void 0 ? _producer$toUpperCase : producer;
  });
  var itemsOfProducers = items.filter(function (item) {
    var _item$product$produce2, _item$product2, _item$product2$produc;
    return producers.includes((_item$product$produce2 = (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$produc = _item$product2.producer) === null || _item$product2$produc === void 0 ? void 0 : _item$product2$produc.toUpperCase()) !== null && _item$product$produce2 !== void 0 ? _item$product$produce2 : false);
  });
  var producersInCartQty = (_length = (_ref7 = (0, _toConsumableArray2["default"])(new Set((0, _toConsumableArray2["default"])(itemsOfProducers.map(function (item) {
    return itemsOfProducers[item.producer];
  }))))) === null || _ref7 === void 0 ? void 0 : _ref7.length) !== null && _length !== void 0 ? _length : 0;
  if (producerType === "any" && producersInCartQty === 0) {
    return false;
  }
  if (producerType === "all" && producersInCartQty !== producers.length) {
    return false;
  }
  if (producerQty !== null) {
    var _cartActions$producer;
    var sumQty = itemsOfProducers.reduce(function (accumulator, item) {
      return accumulator + item.quantity;
    }, 0);
    if (cartActions !== null && cartActions !== void 0 && (_cartActions$producer = cartActions[producerQtyType]) !== null && _cartActions$producer !== void 0 && _cartActions$producer.call(cartActions, {
      cartPrice: sumQty,
      conditionPrice: producerQty
    })) {
      return cart === null || cart === void 0 ? void 0 : cart.totals.productsTotalPrice;
    }
  }
  itemsOfProducers.forEach(function (item) {
    var _item$product3, _item$product3$produc;
    if (producers.includes(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : (_item$product3$produc = _item$product3.producer) === null || _item$product3$produc === void 0 ? void 0 : _item$product3$produc.toUpperCase())) {
      var _item$product4, _item$product4$price, _item$product5, _item$product5$price, _item$product6, _item$product6$price;
      var price = item !== null && item !== void 0 && (_item$product4 = item.product) !== null && _item$product4 !== void 0 && (_item$product4$price = _item$product4.price) !== null && _item$product4$price !== void 0 && _item$product4$price.special ? item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : (_item$product5$price = _item$product5.price) === null || _item$product5$price === void 0 ? void 0 : _item$product5$price.special : item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : (_item$product6$price = _item$product6.price) === null || _item$product6$price === void 0 ? void 0 : _item$product6$price.regular;
      cartTotalPrice += price * item.quantity;
    }
  });
  return cartTotalPrice;
};
var promotionActions = {
  redirectToPdp: function redirectToPdp(_ref8) {
    var _skusGift$every;
    var condition = _ref8.condition,
      cart = _ref8.cart,
      setSkusToWatch = _ref8.setSkusToWatch,
      couponCode = _ref8.couponCode;
    var participatingSkus = condition.participatingSkus,
      skusGift = condition.skusGift,
      date = condition.date,
      totalsCart = condition.totalsCart,
      redirectUrl = condition.redirectUrl;
    var itemsInCart = cart.items;
    var skusInCart = cart.items.map(function (item) {
      return item.sku;
    });
    var isValidCondition = checkParticipatingSkus({
      participatingSkus: participatingSkus,
      itemsInCart: itemsInCart,
      skusInCart: skusInCart
    });
    var isValidSkusGift = (_skusGift$every = skusGift === null || skusGift === void 0 ? void 0 : skusGift.every(function (gift) {
      var _skusActions$gift$typ;
      return (_skusActions$gift$typ = skusActions[gift.type]) === null || _skusActions$gift$typ === void 0 ? void 0 : _skusActions$gift$typ.call(skusActions, {
        group: gift.group,
        skus: skusInCart
      });
    })) !== null && _skusGift$every !== void 0 ? _skusGift$every : true;
    var cartTotalPrice = cart === null || cart === void 0 ? void 0 : cart.totals.productsTotalPrice;
    if (totalsCart !== null && totalsCart !== void 0 && totalsCart.producer) {
      cartTotalPrice = checkCartTotalPriceWithProducer({
        totals: totalsCart,
        cart: cart
      });
    }
    var isValidPrice = cartActions === null || cartActions === void 0 ? void 0 : cartActions[totalsCart.type]({
      cartPrice: cartTotalPrice,
      conditionPrice: totalsCart.price
    });
    if (isValidCondition && isValidSkusGift && isValidPrice && validDate(_objectSpread({}, date))) {
      setSkusToWatch({
        skus: skusGift[0].group,
        couponCode: couponCode
      });
      _router["default"].push(redirectUrl, redirectUrl, {
        shallow: true
      });
      return skusGift[0].group;
    }
    return false;
  },
  addToCart: function () {
    var _addToCart = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref9) {
      var _skusGift$every2;
      var condition, cart, couponCode, addCouponCode, addProduct, language, participatingSkus, skusGift, date, totalsCart, productAddedToCart, itemsInCart, skusInCart, isValidCondition, isValidSkusGift, cartTotalPrice, isValidPrice, products;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              condition = _ref9.condition, cart = _ref9.cart, couponCode = _ref9.couponCode, addCouponCode = _ref9.addCouponCode, addProduct = _ref9.addProduct, language = _ref9.language;
              participatingSkus = condition.participatingSkus, skusGift = condition.skusGift, date = condition.date, totalsCart = condition.totalsCart, productAddedToCart = condition.productAddedToCart;
              itemsInCart = cart.items;
              skusInCart = cart.items.map(function (item) {
                return item.sku;
              });
              isValidCondition = checkParticipatingSkus({
                participatingSkus: participatingSkus,
                itemsInCart: itemsInCart,
                skusInCart: skusInCart
              });
              isValidSkusGift = (_skusGift$every2 = skusGift === null || skusGift === void 0 ? void 0 : skusGift.every(function (gift) {
                var _skusActions$gift$typ2;
                return (_skusActions$gift$typ2 = skusActions[gift.type]) === null || _skusActions$gift$typ2 === void 0 ? void 0 : _skusActions$gift$typ2.call(skusActions, {
                  group: gift.group,
                  skus: skusInCart
                });
              })) !== null && _skusGift$every2 !== void 0 ? _skusGift$every2 : true;
              cartTotalPrice = cart === null || cart === void 0 ? void 0 : cart.totals.productsTotalPrice;
              if (totalsCart !== null && totalsCart !== void 0 && totalsCart.producer) {
                cartTotalPrice = checkCartTotalPriceWithProducer({
                  totals: totalsCart,
                  cart: cart
                });
              }
              isValidPrice = cartActions === null || cartActions === void 0 ? void 0 : cartActions[totalsCart.type]({
                cartPrice: cartTotalPrice,
                conditionPrice: totalsCart.price
              });
              if (!(isValidCondition && isValidSkusGift && isValidPrice && validDate(_objectSpread({}, date)))) {
                _context.next = 20;
                break;
              }
              _context.next = 12;
              return (0, _useProductsBySkus.fetcher)({
                skus: productAddedToCart,
                language: language
              });
            case 12:
              products = _context.sent;
              if (!(products.length === 0)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return", false);
            case 15:
              _context.next = 17;
              return Promise.all(products.map(function (product) {
                return addProduct(product, 1);
              }));
            case 17:
              _context.next = 19;
              return addCouponCode(couponCode, false);
            case 19:
              return _context.abrupt("return", productAddedToCart);
            case 20:
              return _context.abrupt("return", false);
            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function addToCart(_x) {
      return _addToCart.apply(this, arguments);
    }
    return addToCart;
  }()
};
var validDate = function validDate(_ref10) {
  var start = _ref10.start,
    end = _ref10.end;
  var currentDate = Date.now();
  start = typeof start !== "number" ? new Date(start).getTime() : start;
  end = typeof end !== "number" ? new Date(end).getTime() : end;
  return start < currentDate && end > currentDate;
};
var usePromotions = function usePromotions(_ref11) {
  var cart = _ref11.cart,
    addCouponCode = _ref11.addCouponCode,
    addProduct = _ref11.addProduct;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useState = (0, _react.useState)(null),
    skusPromotion = _useState[0],
    setSkusPromotion = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    skusToWatch = _useState2[0],
    setSkusToWatch = _useState2[1];
  var isPending = (0, _react.useRef)(false);
  var getSkus = /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _agent.requests.getExternal("".concat(__webpack_require__.g.__appConfig__.promotionsUrl));
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function getSkus() {
      return _ref12.apply(this, arguments);
    };
  }();
  var getAndSetPromotionsSkus = /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var skusData;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!isPending.current) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              isPending.current = true;
              _context3.prev = 3;
              _context3.next = 6;
              return getSkus();
            case 6:
              skusData = _context3.sent;
              setSkusPromotion(skusData);
              isPending.current = false;
              return _context3.abrupt("return", skusData);
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              console.log("Get Promotions error - ".concat(_context3.t0));
            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));
    return function getAndSetPromotionsSkus() {
      return _ref13.apply(this, arguments);
    };
  }();
  var hasPromotionsAndItems = function hasPromotionsAndItems(skus) {
    var _cart$items;
    return skus && Object.values(skus).length > 0 && (cart === null || cart === void 0 ? void 0 : (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.length) > 0;
  };
  var getPromotions = /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var _cart$items2;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!skusPromotion && (cart === null || cart === void 0 ? void 0 : (_cart$items2 = cart.items) === null || _cart$items2 === void 0 ? void 0 : _cart$items2.length) > 0)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return getAndSetPromotionsSkus();
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
              return _context4.abrupt("return", skusPromotion);
            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function getPromotions() {
      return _ref14.apply(this, arguments);
    };
  }();
  var findCouponCode = function findCouponCode(_ref15) {
    var couponsCode = _ref15.couponsCode,
      couponCodeToFind = _ref15.couponCodeToFind;
    return couponsCode === null || couponsCode === void 0 ? void 0 : couponsCode.find(function (couponCode) {
      return couponCode.name.toUpperCase() === couponCodeToFind.toUpperCase();
    });
  };
  var checkCouponBeforeSendToMagento = /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(couponCode) {
      var skus, foundCouponCode, _promotionActions$fou, result;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return getPromotions();
            case 2:
              skus = _context5.sent;
              _context5.prev = 3;
              foundCouponCode = findCouponCode({
                couponsCode: skus,
                couponCodeToFind: couponCode
              });
              if (!(hasPromotionsAndItems(skus) && foundCouponCode)) {
                _context5.next = 10;
                break;
              }
              _context5.next = 8;
              return promotionActions === null || promotionActions === void 0 ? void 0 : (_promotionActions$fou = promotionActions[foundCouponCode.action]) === null || _promotionActions$fou === void 0 ? void 0 : _promotionActions$fou.call(promotionActions, {
                condition: foundCouponCode === null || foundCouponCode === void 0 ? void 0 : foundCouponCode.condition,
                cart: cart,
                addCouponCode: addCouponCode,
                addProduct: addProduct,
                setSkusToWatch: setSkusToWatch,
                couponCode: couponCode,
                language: language
              });
            case 8:
              result = _context5.sent;
              return _context5.abrupt("return", result);
            case 10:
              _context5.next = 16;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](3);
              return _context5.abrupt("return", false);
            case 16:
              return _context5.abrupt("return", false);
            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 12]]);
    }));
    return function checkCouponBeforeSendToMagento(_x2) {
      return _ref16.apply(this, arguments);
    };
  }();
  var isCouponFromPromotions = /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(couponCode) {
      var skus;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(couponCode === (0, _couponHit["default"])(language.language))) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", true);
            case 2:
              _context6.next = 4;
              return getPromotions();
            case 4:
              skus = _context6.sent;
              return _context6.abrupt("return", !!findCouponCode({
                couponsCode: skus,
                couponCodeToFind: couponCode
              }));
            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function isCouponFromPromotions(_x3) {
      return _ref17.apply(this, arguments);
    };
  }();
  var isProductFromPromotions = function isProductFromPromotions(newSku) {
    var isProductPageHit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    try {
      if (isProductPageHit) {
        addCouponCode((0, _couponHit["default"])(language.language), false)["catch"](console.error);
      } else if (skusToWatch && skusToWatch.skus.includes(newSku)) {
        addCouponCode(skusToWatch.couponCode, false);
        setSkusToWatch(null);
      }
    } catch (error) {
      console.log("Problem with product from promotion: ".concat(error));
    }
  };
  return {
    checkCouponBeforeSendToMagento: checkCouponBeforeSendToMagento,
    isProductFromPromotions: isProductFromPromotions,
    isCouponFromPromotions: isCouponFromPromotions
  };
};
var _default = usePromotions;
exports["default"] = _default;

/***/ }),

/***/ 17577:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _fetcher = _interopRequireDefault(__webpack_require__(68419));
var _react = __webpack_require__(34885);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dataFetchReducer = function dataFetchReducer(state, action) {
  switch (action.type) {
    case "FETCH_INIT":
      return _objectSpread(_objectSpread({}, state), {}, {
        data: [],
        isLoading: true
      });
    case "FETCH_SUCCESS":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: action.payload
      });
    case "FETCH_FAILURE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: []
      });
    default:
      throw new Error();
  }
};
var useQuickSearch = function useQuickSearch(language) {
  var _useState = (0, _react.useState)(null),
    phrase = _useState[0],
    setPhrase = _useState[1];
  var _useReducer = (0, _react.useReducer)(dataFetchReducer, {
      isLoading: false,
      isError: false,
      data: []
    }),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  (0, _react.useEffect)(function () {
    var didCancel = false;
    if (!phrase) return;
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: "FETCH_INIT"
                });
                _context.prev = 1;
                _context.next = 4;
                return (0, _fetcher["default"])({
                  phrase: phrase,
                  language: language,
                  isQuickSearch: true
                });
              case 4:
                result = _context.sent;
                if (!didCancel) {
                  dispatch({
                    type: "FETCH_SUCCESS",
                    payload: result
                  });
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                if (!didCancel) {
                  dispatch({
                    type: "FETCH_FAILURE"
                  });
                }
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchData();
    return function () {
      didCancel = true;
    };
  }, [phrase]);
  return {
    state: state,
    setPhrase: setPhrase,
    phrase: phrase
  };
};
var _default = useQuickSearch;
exports["default"] = _default;

/***/ }),

/***/ 54569:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _LanguageProvider = __webpack_require__(8989);
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _CookieAgreementsProvider = __webpack_require__(2616);
var _AccountProvider = __webpack_require__(8636);
var _isSalesmanagoEnabled = _interopRequireDefault(__webpack_require__(58592));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSalesmanago = function useSalesmanago() {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useAccount = (0, _AccountProvider.useAccount)(),
    accountData = _useAccount.accountData;
  var domains = __webpack_require__.g.__appConfig__.domainLanguages;
  var domain = Object.keys(domains).find(function (key) {
    return domains[key] === language.language;
  });
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements;
  var translations = {
    purchase: (0, _langLibrary["default"])("Products purchase"),
    shoppingCart: (0, _langLibrary["default"])("Change in the shopping cart"),
    visitUrl: (0, _langLibrary["default"])("Url changed"),
    action: (0, _langLibrary["default"])("Action performed"),
    visitProduct: (0, _langLibrary["default"])("Visit to the product page"),
    logIn: (0, _langLibrary["default"])("User logged in"),
    transaction: (0, _langLibrary["default"])("Checkout started")
  };
  var timestamp = new Date().getTime();
  var handleSalesmanagoEvent = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(type, additionalData) {
      var _accountData$customer, _additionalData$detai, _additionalData$detai2, _additionalData$detai3;
      var smClient, userId, contactData, baseEventData, products, additionalEventData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!(0, _isSalesmanagoEnabled["default"])({
                language: language.language
              }) || !cookieAgreements.salesmanago)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              smClient = _jsCookie["default"].get("smclient");
              userId = smClient ? {
                contactId: smClient,
                email: null
              } : accountData !== null && accountData !== void 0 && accountData.email ? {
                email: accountData === null || accountData === void 0 ? void 0 : (_accountData$customer = accountData.customer) === null || _accountData$customer === void 0 ? void 0 : _accountData$customer.email,
                contactId: null
              } : {
                email: additionalData === null || additionalData === void 0 ? void 0 : additionalData.email,
                contactId: null
              };
              if (Object.values(userId).some(function (value) {
                return value;
              })) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              contactData = _objectSpread({}, userId);
              baseEventData = {
                date: timestamp,
                location: language.language,
                contactExtEventType: type,
                detail1: additionalData !== null && additionalData !== void 0 && additionalData.details ? (_additionalData$detai = additionalData === null || additionalData === void 0 ? void 0 : additionalData.details[0]) !== null && _additionalData$detai !== void 0 ? _additionalData$detai : null : null,
                detail2: additionalData !== null && additionalData !== void 0 && additionalData.details ? (_additionalData$detai2 = additionalData === null || additionalData === void 0 ? void 0 : additionalData.details[1]) !== null && _additionalData$detai2 !== void 0 ? _additionalData$detai2 : null : null,
                detail3: additionalData !== null && additionalData !== void 0 && additionalData.details ? (_additionalData$detai3 = additionalData === null || additionalData === void 0 ? void 0 : additionalData.details[2]) !== null && _additionalData$detai3 !== void 0 ? _additionalData$detai3 : null : null,
                shopDomain: domain
              };
              products = "";
              if ((additionalData === null || additionalData === void 0 ? void 0 : additionalData.products) !== undefined) {
                additionalData.products.forEach(function (product, index) {
                  products += product;
                  products += additionalData.products.length === index + 1 ? "" : ",";
                });
              }
              if (!(type in ["PURCHASE", "CART", "OFFER"])) {
                _context.next = 13;
                break;
              }
              if (!(products.length === 0 || additionalData.value === undefined)) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              _context.t0 = type;
              _context.next = _context.t0 === "PURCHASE" ? 16 : _context.t0 === "CART" ? 18 : _context.t0 === "VISIT" ? 20 : _context.t0 === "OTHER" ? 22 : _context.t0 === "OFFER" ? 24 : _context.t0 === "LOGIN" ? 26 : _context.t0 === "TRANSACTION" ? 28 : 30;
              break;
            case 16:
              additionalEventData = {
                description: translations.purchase,
                products: products,
                value: additionalData.value
              };
              return _context.abrupt("break", 31);
            case 18:
              additionalEventData = {
                description: translations.shoppingCart,
                products: products,
                value: additionalData.value
              };
              return _context.abrupt("break", 31);
            case 20:
              additionalEventData = {
                description: translations.visitUrl
              };
              return _context.abrupt("break", 31);
            case 22:
              additionalEventData = {
                description: translations.action
              };
              return _context.abrupt("break", 31);
            case 24:
              additionalEventData = {
                description: translations.visitProduct,
                products: products,
                value: additionalData.value
              };
              return _context.abrupt("break", 31);
            case 26:
              additionalEventData = {
                description: translations.logIn
              };
              return _context.abrupt("break", 31);
            case 28:
              additionalEventData = {
                description: translations.purchase
              };
              return _context.abrupt("break", 31);
            case 30:
              return _context.abrupt("break", 31);
            case 31:
              _context.prev = 31;
              _context.next = 34;
              return _agent.requests.postExternal("".concat(__webpack_require__.g.__appConfig__.salesmanagoApiAddContact), _objectSpread(_objectSpread({}, contactData), {}, {
                contactEvent: _objectSpread(_objectSpread({}, baseEventData), additionalEventData)
              }));
            case 34:
              _context.next = 40;
              break;
            case 36:
              _context.prev = 36;
              _context.t1 = _context["catch"](31);
              console.log(_context.t1);
              return _context.abrupt("return", false);
            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[31, 36]]);
    }));
    return function handleSalesmanagoEvent(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return handleSalesmanagoEvent;
};
var _default = useSalesmanago;
exports["default"] = _default;

/***/ }),

/***/ 68419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _sendProductSearchRequest = _interopRequireDefault(__webpack_require__(91030));
var _sendCategorySearchRequest = _interopRequireDefault(__webpack_require__(78145));
var _mapProductDataNew = _interopRequireDefault(__webpack_require__(69729));
var _mapCategory = _interopRequireDefault(__webpack_require__(7543));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapFilters = function mapFilters(filters) {
  return filters.map(function (item) {
    var newItem = _objectSpread(_objectSpread({}, item), {}, {
      label: item.name
    });
    if (item.items) {
      newItem.options = item.items.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          label: option.name,
          id: option.id + ""
        });
      });
    }
    if (item.type === "color") {
      newItem.type = "multiselect";
    }
    if (item.type === "select") {
      newItem.type = "multiselect";
    }
    if (item.id === "sort") {
      item.options = item.options.filter(function (option) {
        return option.id !== "position-desc";
      });
    }
    return newItem;
  });
};
var fetcher = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var _categories$items;
    var phrase, language, pickedFilters, _ref$currentPage, currentPage, _ref$pageSize, pageSize, _ref$initialFilters, initialFilters, _ref$isQuickSearch, isQuickSearch, _yield$Promise$all, _yield$Promise$all2, result, categories, defaultFilters, filters;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            phrase = _ref.phrase, language = _ref.language, pickedFilters = _ref.pickedFilters, _ref$currentPage = _ref.currentPage, currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage, _ref$pageSize = _ref.pageSize, pageSize = _ref$pageSize === void 0 ? __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange : _ref$pageSize, _ref$initialFilters = _ref.initialFilters, initialFilters = _ref$initialFilters === void 0 ? null : _ref$initialFilters, _ref$isQuickSearch = _ref.isQuickSearch, isQuickSearch = _ref$isQuickSearch === void 0 ? false : _ref$isQuickSearch;
            _context.next = 3;
            return Promise.all([(0, _sendProductSearchRequest["default"])({
              query: phrase,
              currentPage: currentPage,
              pageSize: pageSize,
              lang: language,
              pickedFilters: pickedFilters
            }), (0, _sendCategorySearchRequest["default"])({
              query: phrase,
              lang: language
            })]);
          case 3:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
            result = _yield$Promise$all2[0];
            categories = _yield$Promise$all2[1];
            defaultFilters = result.filters.items; // if (!initialFilters && !isQuickSearch) {
            //   defaultFilters = await sendProductSearchRequest({
            //     query: phrase,
            //     currentPage: 1,
            //     pageSize,
            //     lang: language,
            //     pickedFilters: {}
            //   });
            //   defaultFilters = defaultFilters?.filters?.items;
            // }
            filters = result.filters.items ? mapFilters(result.filters.items) : [];
            if (filters && pickedFilters) {
              if (pickedFilters["sort"]) {
                filters.push({
                  id: "sort",
                  value: pickedFilters["sort"]
                });
              }
              filters.forEach(function (filter) {
                if (pickedFilters[filter.id]) {
                  if (filter.type === "multiselect") {
                    filter.value = pickedFilters[filter.id];
                  }
                }
                if (pickedFilters[filter.id]) {
                  if (filter.type === "range") {
                    var initialFilter = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.find(function (initialFilter) {
                      return initialFilter.id === filter.id;
                    });
                    if (initialFilter) {
                      filter.min = initialFilter.min;
                      filter.max = initialFilter.max;
                    }
                    filter.value = pickedFilters[filter.id];
                  }
                }
              });
            }
            return _context.abrupt("return", {
              categories: (_categories$items = categories.items) === null || _categories$items === void 0 ? void 0 : _categories$items.map(_mapCategory["default"]).filter(function (category) {
                return category !== undefined;
              }),
              results: (0, _mapProductDataNew["default"])(result.items),
              totalCount: result.total_count,
              filters: filters,
              defaultFilters: defaultFilters
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 2616:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CookieAgreementsContextProvider = exports.useCookieAgreements = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _router = __webpack_require__(53746);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var CookieAgreementsContext = /*#__PURE__*/_react["default"].createContext();
var CookieAgreementsContextProvider = function CookieAgreementsContextProvider(_ref) {
  var children = _ref.children,
    analyticsID = _ref.analyticsID,
    gtmID = _ref.gtmID,
    fbID = _ref.fbID;
  var cookieName = __webpack_require__.g.__appConfig__.agreementsCookieName;
  var cookie = _jsCookie["default"].get(cookieName);
  var _useState = (0, _react.useState)(cookie ? JSON.parse(cookie) : false),
    cookieAgreements = _useState[0],
    setCookieAgreementsValue = _useState[1];
  if (!cookieAgreements) {
    if (cookie) {
      setCookieAgreementsValue(JSON.parse(cookie));
    }
  }
  var setCookieAgreementsState = function setCookieAgreementsState(values) {
    setCookieAgreementsValue(values);
  };
  var setCookieAgreements = function setCookieAgreements(values) {
    _jsCookie["default"].set(cookieName, JSON.stringify(values), {
      expires: 60
    });
    setCookieAgreementsValue(values);
  };
  return __jsx(CookieAgreementsContext.Provider, {
    value: {
      cookieAgreements: cookieAgreements,
      analyticsID: analyticsID,
      gtmID: gtmID,
      fbID: fbID,
      setCookieAgreementsState: setCookieAgreementsState,
      setCookieAgreements: setCookieAgreements
    }
  }, children);
};
exports.CookieAgreementsContextProvider = CookieAgreementsContextProvider;
var useCookieAgreements = function useCookieAgreements() {
  var router = (0, _router.useRouter)();
  var cookie = _jsCookie["default"].get(__webpack_require__.g.__appConfig__.agreementsCookieName);
  var _useContext = (0, _react.useContext)(CookieAgreementsContext),
    cookieAgreements = _useContext.cookieAgreements,
    setCookieAgreementsState = _useContext.setCookieAgreementsState;
  (0, _react.useEffect)(function () {
    if (cookie && !cookieAgreements) {
      setCookieAgreementsState(JSON.parse(cookie));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!cookie) {
      setCookieAgreementsState(false);
    }
  }, [router.asPath]);
  return (0, _react.useContext)(CookieAgreementsContext);
};
exports.useCookieAgreements = useCookieAgreements;

/***/ }),

/***/ 8989:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LanguageContextProvider = exports.useLanguage = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var LanguageContext = /*#__PURE__*/_react["default"].createContext();
var LanguageContextProvider = function LanguageContextProvider(_ref) {
  var children = _ref.children,
    language = _ref.language;
  var changeLanguage = function changeLanguage(lang) {
    var domains = __webpack_require__.g.__appConfig__.domainLanguages;
    var domain = Object.keys(domains).find(function (key) {
      return domains[key] === lang;
    });
    window.location.href = "http://".concat(domain);
  };
  return __jsx(LanguageContext.Provider, {
    value: {
      language: language,
      changeLanguage: changeLanguage
    }
  }, children);
};
exports.LanguageContextProvider = LanguageContextProvider;
var useLanguage = function useLanguage() {
  return (0, _react.useContext)(LanguageContext);
};
exports.useLanguage = useLanguage;

/***/ }),

/***/ 82425:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MessageHandlerProvider = exports.useHandleMessage = void 0;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _NotificationSystem = __webpack_require__(86901);
var _Box = _interopRequireDefault(__webpack_require__(40300));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var MessageHandlerContext = /*#__PURE__*/_react["default"].createContext();
var MessageHandlerProvider = function MessageHandlerProvider(props) {
  var systemNotification = (0, _NotificationSystem.useNotificationSystem)();
  var _useState = (0, _react.useState)(1),
    messageId = _useState[0],
    setMessageId = _useState[1];
  var handleMessage = function handleMessage(message) {
    var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var defaultNotification = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var additionalHtml = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var forceErrorColors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var forceBgColor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : props.forceBgColor;
    setMessageId(messageId + 1);
    if (!isError) {
      systemNotification.show({
        id: messageId,
        timeout: 7000,
        content: function content(_ref) {
          var close = _ref.close;
          return __jsx(_Box["default"], {
            "data-test": "message-success",
            sx: {
              position: "relative"
            }
          }, __jsx(props.notificationComponent, {
            isError: forceErrorColors || isError,
            defaultNotification: defaultNotification,
            message: message,
            onClick: close,
            additionalHtml: additionalHtml,
            forceBgColor: forceBgColor
          }));
        },
        placement: props.errorsPlacement
      });
    } else {
      var finalMessage;
      if (!message.response) {
        return;
      }
      if (message.response.body.parameters === undefined) {
        if (message.hasOwnProperty("message")) {
          finalMessage = message.response.body.message;
        }
      } else {
        if (message.hasOwnProperty("message")) {
          if (Array.isArray(message.response.body.parameters)) {
            finalMessage = message.response.body.parameters.reduce(function (prev, current, index) {
              return prev.replace("%".concat(index + 1), current);
            }, message.response.body.message);
          } else if (typeof message.response.body.parameters === "object") {
            finalMessage = Object.entries(message.response.body.parameters).reduce(function (prev, current) {
              var _current = (0, _slicedToArray2["default"])(current, 2),
                key = _current[0],
                value = _current[1];
              return prev.replace("%" + key, value);
            }, message.response.body.message);
          }
        }
      }
      if (finalMessage !== undefined) {
        systemNotification.show({
          id: messageId,
          timeout: 7000,
          content: function content(_ref2) {
            var close = _ref2.close;
            return __jsx(_Box["default"], {
              sx: {
                position: "relative"
              }
            }, __jsx(props.notificationComponent, {
              isError: isError,
              defaultNotification: false,
              message: finalMessage,
              onClick: close
            }));
          },
          placement: props.errorsPlacement
        });
      }
    }
  };
  return __jsx(MessageHandlerContext.Provider, {
    value: {
      handleMessage: handleMessage
    }
  }, props.children);
};
exports.MessageHandlerProvider = MessageHandlerProvider;
var useHandleMessage = function useHandleMessage() {
  return (0, _react.useContext)(MessageHandlerContext);
};
exports.useHandleMessage = useHandleMessage;

/***/ }),

/***/ 86901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getNotificationOffset = getNotificationOffset;
exports.useNotificationSystem = exports.NotificationSystemProvider = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _reactDom = _interopRequireDefault(__webpack_require__(44661));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _core = __webpack_require__(79329);
var _useWindowSize = _interopRequireDefault(__webpack_require__(47272));
var _uniqueId = _interopRequireDefault(__webpack_require__(68646));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NotificationsContext = /*#__PURE__*/_react["default"].createContext({});

// TODO: make alerts visually-hidden instead of removing from DOM
// TODO: make it possible to show notification into ref

// notificationSystemOffset
// notificationSystemOffsetX notificationSystemOffsetY, notificationSystemMenuOffsetY notificationSystemMenuOffsetX

function getNotificationOffset(theme) {
  var s = theme.space;
  var top = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var bottom = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var topMenu = {
    x: s.notificationSystemOffsetMenuX || s.notificationSystemOffsetMenu || s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetMenuY || s.notificationSystemOffsetMenu || s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  return {
    top: top,
    bottom: bottom,
    topMenu: topMenu
  };
}
var NotificationSystemProvider = function NotificationSystemProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(false),
    mounted = _useState[0],
    setMounted = _useState[1];
  var _useResponsiveHelpers = (0, _core.useResponsiveHelpers)(),
    currentValue = _useResponsiveHelpers.currentValue;
  var _useState2 = (0, _react.useState)([]),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    isLayerOpen = _useState3[0],
    setLayerOpen = _useState3[1];
  var _close = function close(notificationToClose) {
    setNotifications(function (notifications) {
      return notifications.filter(function (notification) {
        return notification.id !== notificationToClose.id;
      });
    });
  };
  (0, _react.useEffect)(function () {
    window.window.__cui_notificationSystemSetLayerOpen = function (isOpen) {
      // We do it this way so that Layer doesn't have to import MenuLayout if not needed (code split!)
      setLayerOpen(isOpen);
    };
  }, []);
  var show = function show(config) {
    var id = config.id || (0, _uniqueId["default"])();
    var index = notifications.findIndex(function (notification) {
      return notification.id === id;
    });
    if (index > -1) {
      clearTimeout(notifications[index].timeout);
    }
    var newNotification = _objectSpread(_objectSpread({}, config), {}, {
      id: id
    });
    if (typeof config.timeout === "number" && config.timeout > 0) {
      newNotification.timeout = setTimeout(function () {
        _close(newNotification);
      }, config.timeout);
    }
    if (index > -1) {
      var newNotifications = (0, _toConsumableArray2["default"])(notifications);
      newNotifications[index] = newNotification;
      setNotifications(newNotifications);
    } else {
      setNotifications(function (notifications) {
        return [].concat((0, _toConsumableArray2["default"])(notifications), [newNotification]);
      });
    }
  };
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);
  var _ = (0, _useWindowSize["default"])(); // unused but rerenders on resize

  var portals;
  if (mounted) {
    var topLeft = [];
    var topRight = [];
    var topMobile = [];
    var topLeftMenu = [];
    var topRightMenu = [];
    var topMobileMenu = [];
    var bottomLeft = [];
    var bottomRight = [];
    var bottomMobile = [];
    var refs = new Map();
    notifications.forEach(function (notification) {
      var placement = currentValue(notification.placement); // TODO: this function can't use hook!!!

      var content = typeof notification.content === "function" ? notification.content({
        close: function close() {
          _close(notification);
        }
      }) : notification.content;

      // TODO: accessibility!!
      content = __jsx(_Box["default"], {
        sx: {
          display: "contents"
        },
        role: "alert",
        key: notification.id
      }, content);
      if (typeof placement === "string") {
        // Menu placement is replaced by standard placement when dialogs are open
        if (placement === "topLeftMenu" && isLayerOpen) {
          placement = "topLeft";
        } else if (placement === "topRightMenu" && isLayerOpen) {
          placement = "topRight";
        }
        if (placement === "topLeft") {
          topLeft.push(content);
          topMobile.push(content);
        } else if (placement === "topRight") {
          topRight.push(content);
          topMobile.push(content);
        } else if (placement === "bottomLeft") {
          bottomLeft.push(content);
          bottomMobile.push(content);
        } else if (placement === "bottomRight") {
          bottomRight.push(content);
          bottomMobile.push(content);
        } else if (placement === "topLeftMenu") {
          topLeftMenu.push(content);
          topMobileMenu.push(content);
        } else if (placement === "topRightMenu") {
          topRightMenu.push(content);
          topMobileMenu.push(content);
        } else {
          throw new Error("unknown position " + placement + " for notification");
        }
      } else {
        if (!placement.current) {
          throw new Error("placement for notification can be either string with position (topLeft, topRight, etc...) or ref");
        }
        if (refs.has(placement.current)) {
          refs.set(placement.current, [].concat((0, _toConsumableArray2["default"])(refs.get(placement.current)), [content]));
        } else {
          refs.set(placement.current, [content]);
        }
      }
    });
    portals = [/*#__PURE__*/_reactDom["default"].createPortal(topLeftMenu, document.getElementById("__notifications-menu-topLeft__") || document.getElementById("__notifications-topLeft__")), /*#__PURE__*/_reactDom["default"].createPortal(topRightMenu, document.getElementById("__notifications-menu-topRight__") || document.getElementById("__notifications-topRight__")), /*#__PURE__*/_reactDom["default"].createPortal(topMobileMenu, document.getElementById("__notifications-menu-topMobile__") || document.getElementById("__notifications-topMobile__")), /*#__PURE__*/_reactDom["default"].createPortal(topLeft, document.getElementById("__notifications-topLeft__")), /*#__PURE__*/_reactDom["default"].createPortal(topRight, document.getElementById("__notifications-topRight__")), /*#__PURE__*/_reactDom["default"].createPortal(topMobile, document.getElementById("__notifications-topMobile__")), /*#__PURE__*/_reactDom["default"].createPortal(bottomLeft, document.getElementById("__notifications-bottomLeft__")), /*#__PURE__*/_reactDom["default"].createPortal(bottomRight, document.getElementById("__notifications-bottomRight__")), /*#__PURE__*/_reactDom["default"].createPortal(bottomMobile, document.getElementById("__notifications-bottomMobile__"))];
    refs.forEach(function (value, keyRef) {
      portals.push(/*#__PURE__*/_reactDom["default"].createPortal(value, keyRef));
    });
  }
  return __jsx(NotificationsContext.Provider, {
    value: {
      show: show
    }
  }, children, portals);
};

// export function Notifications
exports.NotificationSystemProvider = NotificationSystemProvider;
var useNotificationSystem = function useNotificationSystem() {
  return (0, _react.useContext)(NotificationsContext);
};
exports.useNotificationSystem = useNotificationSystem;

/***/ }),

/***/ 36286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TokenContextProvider = exports.useToken = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var TokenContext = /*#__PURE__*/_react["default"].createContext();
var TokenContextProvider = function TokenContextProvider(props) {
  var _useState = (0, _react.useState)(props.token),
    token = _useState[0],
    updateToken = _useState[1];
  var setToken = function setToken(newToken) {
    updateToken(newToken);
    _jsCookie["default"].set(__webpack_require__.g.__appConfig__.tokenCookieName, newToken, {
      secure: true,
      expires: parseInt(__webpack_require__.g.__appConfig__.sessionUserLoginMaxDays)
    });
  };
  var deleteToken = function deleteToken() {
    var _localStorage, _localStorage2;
    updateToken(undefined);
    _jsCookie["default"].remove(__webpack_require__.g.__appConfig__.tokenCookieName);
    _jsCookie["default"].remove("cartId");
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem("minicartContent", "[]");
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.removeItem("cartId");
  };
  return __jsx(TokenContext.Provider, {
    value: {
      token: token,
      setToken: setToken,
      deleteToken: deleteToken
    }
  }, props.children);
};
exports.TokenContextProvider = TokenContextProvider;
var useToken = function useToken() {
  return (0, _react.useContext)(TokenContext);
};
exports.useToken = useToken;

/***/ }),

/***/ 85556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AdvertPopupContextProvider = exports.useAdvertPopup = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _CookieAgreementsProvider = __webpack_require__(2616);
var _router = __webpack_require__(53746);
var _LanguageProvider = __webpack_require__(8989);
var _isNewsletterEnabled = _interopRequireDefault(__webpack_require__(98250));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var AdvertPopupContext = /*#__PURE__*/_react["default"].createContext();
var AdvertPopupContextProvider = function AdvertPopupContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    popupVisible = _useState[0],
    setPopupVisible = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    dontDisplayAgain = _useState2[0],
    setDontDisplayAgain = _useState2[1];
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements;
  var isFirstRun = (0, _react.useRef)(true);
  var router = (0, _router.useRouter)();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var displayConfig;
  var displayConfigStorage;
  var setCookie = function setCookie() {
    _jsCookie["default"].set("AdvertPopupDisplayed", true, {
      expires: 60
    });
  };
  var killPopup = function killPopup() {
    setPopupVisible(false);
    dontDisplayAgain && setCookie();
  };
  var displayPopup = function displayPopup(config) {
    if (config.showToKnownUsers === false && config.isKnownUser) {
      setCookie();
      setDontDisplayAgain(true);
      return;
    }
    if ((0, _isNewsletterEnabled["default"])({
      language: language.language
    })) {
      setTimeout(function () {
        setPopupVisible(true);
      }, config.popupDelay === undefined ? 0 : config.popupDelay);
    }
  };
  var cookie = _jsCookie["default"].get("AdvertPopupDisplayed");
  (0, _react.useEffect)(function () {
    var _displayConfig;
    if (dontDisplayAgain) {
      return;
    }
    if (isFirstRun.current && cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.salesmanago) {
      var _localStorage, _displayConfigStorage, _displayConfigStorage2;
      displayConfigStorage = JSON.parse((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("_smvc"));
      var configDataArray = (_displayConfigStorage = displayConfigStorage) === null || _displayConfigStorage === void 0 ? void 0 : (_displayConfigStorage2 = _displayConfigStorage._v) === null || _displayConfigStorage2 === void 0 ? void 0 : _displayConfigStorage2.i;
      if ((configDataArray === null || configDataArray === void 0 ? void 0 : configDataArray.length) > 0) {
        displayConfig = {
          showToKnownUsers: configDataArray[0].ohp,
          popupDelay: configDataArray[0].cfg.delay,
          dontShowAfterClose: configDataArray[0].cfg.nsa.close,
          displayOnSpecificUrl: configDataArray[0].url,
          dontDisplayUrl: configDataArray[0].exurl,
          isKnownUser: configDataArray[0].monitored === "I"
        };
        if (cookie === undefined) {
          if (displayConfig.displayOnSpecificUrl.length > 0 && displayConfig.displayOnSpecificUrl.includes(router.asPath.slice(1)) === false || displayConfig.dontDisplayUrl.length > 0 && displayConfig.dontDisplayUrl.includes(router.asPath.slice(1)) === true) {
            return;
          }
          displayPopup(displayConfig);
        }
      }
    }
    isFirstRun.current = false;
    if (!dontDisplayAgain && (_displayConfig = displayConfig) !== null && _displayConfig !== void 0 && _displayConfig.dontShowAfterClose) {
      setDontDisplayAgain(true);
    }
  });
  return __jsx(AdvertPopupContext.Provider, {
    value: {
      popupVisible: popupVisible,
      killPopup: killPopup
    }
  }, props.children);
};
exports.AdvertPopupContextProvider = AdvertPopupContextProvider;
var useAdvertPopup = function useAdvertPopup() {
  return (0, _react.useContext)(AdvertPopupContext);
};
exports.useAdvertPopup = useAdvertPopup;

/***/ }),

/***/ 34251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _router = __webpack_require__(53746);
var _jsCookie = _interopRequireDefault(__webpack_require__(88482));
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(26367));
var _agent = __webpack_require__(37642);
var _CartProvider = __webpack_require__(57955);
var _EPoints = __webpack_require__(73223);
var _OrdersProvider = __webpack_require__(64239);
var _MessageHandlerProvider = __webpack_require__(82425);
var _handleAdyenErrorMessage = _interopRequireDefault(__webpack_require__(36928));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var resultCodes = {
  REFUSED: "Refused",
  ERROR: "Error",
  AUTHORISED: "Authorised",
  RECEIVED: "Received",
  PRESENT_TO_SHOPPER: "PresentToShopper",
  PENDING: "Pending"
};
var actionTypes = {
  REDIRECT: "redirect",
  AWAIT: "await",
  QR_CODE: "qrCode",
  SDK: "sdk",
  THREE_DS: "threeDS2",
  VOUCHER: "voucher"
};
var orderIdCookieName = __webpack_require__.g.__appConfig__.orderIdCookieName;

// https://docs.adyen.com/plugins/adobe-commerce/set-up-vesion-8/headless-integration/?tab=rest3_1#place-order
var useAdyenCheckout = function useAdyenCheckout() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    form: {}
  };
  var translations = {
    adyenPaymentRefused: (0, _langLibrary["default"])("adyen_error_message")
  };
  var router = (0, _router.useRouter)();
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var _useCart = (0, _CartProvider.useCart)(),
    truncateCart = _useCart.truncateCart,
    clearCart = _useCart.clearCart;
  var _useEPoints = (0, _EPoints.useEPoints)(),
    clearEPoints = _useEPoints.clearEPoints;
  var _useOrders = (0, _OrdersProvider.useOrders)(),
    removeUserOrders = _useOrders.removeUserOrders;
  var clearCheckoutData = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              clearEPoints();
              _context.next = 3;
              return truncateCart();
            case 3:
              _context.next = 5;
              return removeUserOrders();
            case 5:
              clearCart();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "checkout_success"
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function clearCheckoutData() {
      return _ref.apply(this, arguments);
    };
  }();
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var getPaymentStatus = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(orderId) {
      var response;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _agent.requests.post("/adyen/orders/payment-status", {
                orderId: orderId
              }, __webpack_require__.g.__appConfig__.adyenMagentoIntegrationToken, {
                language: language,
                domain: domain
              });
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", JSON.parse(response));
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function getPaymentStatus(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleAdyenPayment = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
      var orderId, component, paymentStatus;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              orderId = _ref3.orderId, component = _ref3.component;
              _context3.prev = 1;
              _jsCookie["default"].set(orderIdCookieName, orderId);
              _context3.next = 5;
              return getPaymentStatus(orderId);
            case 5:
              paymentStatus = _context3.sent;
              _context3.next = 8;
              return handlePaymentResult({
                paymentStatus: paymentStatus,
                component: component
              });
            case 8:
              return _context3.abrupt("return", paymentStatus);
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              (0, _handleAdyenErrorMessage["default"])({
                message: translations.adyenPaymentRefused
              }, component, handleMessage);
            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11]]);
    }));
    return function handleAdyenPayment(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleAdyenAction = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref5) {
      var action, component;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              action = _ref5.action, component = _ref5.component;
              _context4.prev = 1;
              if (!(action.type === "redirect")) {
                _context4.next = 5;
                break;
              }
              _context4.next = 5;
              return clearCheckoutData();
            case 5:
              component.handleAction(action);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              (0, _handleAdyenErrorMessage["default"])({
                message: translations.adyenPaymentRefused
              }, component, handleMessage);
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function handleAdyenAction(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var handlePaymentResult = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref7) {
      var paymentStatus, component;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              paymentStatus = _ref7.paymentStatus, component = _ref7.component;
              if (!paymentStatus.isFinal) {
                _context5.next = 9;
                break;
              }
              if (!(paymentStatus.resultCode === resultCodes.AUTHORISED || paymentStatus.resultCode === resultCodes.RECEIVED || paymentStatus.resultCode === resultCodes.PRESENT_TO_SHOPPER)) {
                _context5.next = 7;
                break;
              }
              _context5.next = 5;
              return clearCheckoutData();
            case 5:
              _jsCookie["default"].remove(orderIdCookieName);
              router.push("/checkout/success");
            case 7:
              _context5.next = 15;
              break;
            case 9:
              if (!paymentStatus.action) {
                _context5.next = 14;
                break;
              }
              _context5.next = 12;
              return handleAdyenAction({
                action: paymentStatus.action,
                component: component
              });
            case 12:
              _context5.next = 15;
              break;
            case 14:
              (0, _handleAdyenErrorMessage["default"])({
                message: translations.adyenPaymentRefused
              }, component, handleMessage);
            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function handlePaymentResult(_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  return {
    handleAdyenPayment: handleAdyenPayment
  };
};
var _default = useAdyenCheckout;
exports["default"] = _default;

/***/ }),

/***/ 79892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _LanguageProvider = __webpack_require__(8989);
var _CookieAgreementsProvider = __webpack_require__(2616);
var useAnalyticsAndCommerceTags = function useAnalyticsAndCommerceTags() {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements;
  var currencyList = __webpack_require__.g.__appConfig__.currencyList;
  var defaultCurrencyCode = currencyList && language.language && currencyList[language.language].code;
  var getBrandName = function getBrandName(technicalData) {
    var _producer$name;
    var producer = technicalData === null || technicalData === void 0 ? void 0 : technicalData.find(function (data) {
      return data.label === "brand" && data.name;
    });
    return (_producer$name = producer === null || producer === void 0 ? void 0 : producer.name) !== null && _producer$name !== void 0 ? _producer$name : null;
  };
  return {
    productVisited: function productVisited(product, categoryName) {
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var _product$producer, _product$info;
        gtag("event", "view_item", {
          currency: defaultCurrencyCode,
          value: product.price.special ? product.price.special : product.price.regular,
          items: [{
            item_id: product.sku,
            item_name: product.name,
            affiliation: "Dajar",
            discount: product.price.special ? product.price.regular - product.price.special : 0,
            item_brand: (_product$producer = product.producer) !== null && _product$producer !== void 0 ? _product$producer : getBrandName((_product$info = product.info) === null || _product$info === void 0 ? void 0 : _product$info.technicalData),
            item_category: categoryName,
            item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
            quantity: 1
          }]
        });
      }
      __webpack_require__.g.__appConfig__.facebookEnabled && (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && fbq("track", "ViewContent", {
        content_type: "product",
        content_ids: [product.sku]
      });
    },
    viewList: function viewList(products) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var listType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      __webpack_require__.g.__appConfig__.facebookEnabled && (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && fbq("track", "ViewContent", {
        content_type: "category",
        content_ids: products.map(function (product) {
          return product.sku;
        })
      });
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      var listProducts = products.map(function (product, index) {
        var _product$producer2, _product$info2;
        return {
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          currency: defaultCurrencyCode,
          discount: product.price.special ? product.price.regular - product.price.special : 0,
          index: index,
          item_brand: (_product$producer2 = product.producer) !== null && _product$producer2 !== void 0 ? _product$producer2 : getBrandName((_product$info2 = product.info) === null || _product$info2 === void 0 ? void 0 : _product$info2.technicalData),
          item_category: name,
          item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
          price: product.price.special ? product.price.special : product.price.regular,
          quantity: 1
        };
      });
      __webpack_require__.g.__appConfig__.promotionCategory === id ? gtag("event", "select_promotion", {
        promotion_id: id,
        promotion_name: "sale",
        items: listProducts
      }) : gtag("event", "view_item_list", {
        item_list_id: id,
        item_list_name: name,
        items: listProducts
      });
    },
    productClicked: function productClicked(product, category, listName, listPosition) {
      var _category, _product$producer3, _product$info3;
      var listId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      category = (_category = category) !== null && _category !== void 0 ? _category : "";
      gtag("event", "select_item", {
        item_list_id: listId,
        item_list_name: category,
        // list_name
        items: [{
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          discount: product.price.special ? product.price.regular - product.price.special : 0,
          index: listPosition !== null && listPosition !== void 0 ? listPosition : "",
          item_brand: (_product$producer3 = product.producer) !== null && _product$producer3 !== void 0 ? _product$producer3 : getBrandName((_product$info3 = product.info) === null || _product$info3 === void 0 ? void 0 : _product$info3.technicalData),
          item_category: category,
          item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
          price: product.price.special ? product.price.special : product.price.regular,
          quantity: 1
        }]
      });
    },
    viewCart: function viewCart(cartContent) {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      var cartValue = 0;
      var cartItems = [];
      cartContent === null || cartContent === void 0 ? void 0 : cartContent.forEach(function (product, index) {
        var _product$product, _product$product$pric, _product$product2, _product$product2$pri, _product$product3, _product$producer4, _product$product4, _product$product4$inf, _product$product5, _product$product5$pic, _product$product6, _product$product7, _product$product8;
        cartValue += product !== null && product !== void 0 && (_product$product = product.product) !== null && _product$product !== void 0 && (_product$product$pric = _product$product.price) !== null && _product$product$pric !== void 0 && _product$product$pric.special ? parseFloat(product.product.price.special) * parseInt(product.quantity) : parseFloat(product === null || product === void 0 ? void 0 : (_product$product2 = product.product) === null || _product$product2 === void 0 ? void 0 : (_product$product2$pri = _product$product2.price) === null || _product$product2$pri === void 0 ? void 0 : _product$product2$pri.regular) * parseInt(product === null || product === void 0 ? void 0 : product.quantity);
        cartItems.push({
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          currency: defaultCurrencyCode,
          discount: (_product$product3 = product.product) !== null && _product$product3 !== void 0 && _product$product3.price.special ? product.product.price.regular - product.product.price.special : 0,
          index: index,
          item_brand: (_product$producer4 = product === null || product === void 0 ? void 0 : product.producer) !== null && _product$producer4 !== void 0 ? _product$producer4 : getBrandName((_product$product4 = product.product) === null || _product$product4 === void 0 ? void 0 : (_product$product4$inf = _product$product4.info) === null || _product$product4$inf === void 0 ? void 0 : _product$product4$inf.technicalData),
          item_variant: ((_product$product5 = product.product) === null || _product$product5 === void 0 ? void 0 : (_product$product5$pic = _product$product5.pickedOptions) === null || _product$product5$pic === void 0 ? void 0 : _product$product5$pic.length) > 0 ? product.product.pickedOptions[0].name : "",
          price: product !== null && product !== void 0 && (_product$product6 = product.product) !== null && _product$product6 !== void 0 && _product$product6.price.special ? product === null || product === void 0 ? void 0 : (_product$product7 = product.product) === null || _product$product7 === void 0 ? void 0 : _product$product7.price.special : product === null || product === void 0 ? void 0 : (_product$product8 = product.product) === null || _product$product8 === void 0 ? void 0 : _product$product8.price.regular,
          quantity: product.quantity
        });
      });
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "view_cart", {
        currency: defaultCurrencyCode,
        value: cartValue,
        items: cartItems
      });
    },
    productAddedToCart: function productAddedToCart(product, quantity, categoryName, currency) {
      var listId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var listType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
      var listPosition = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var _product$producer5, _product$info4;
        gtag("event", "add_to_cart", {
          currency: defaultCurrencyCode,
          value: product.price.special ? product.price.special * quantity : product.price.regular * quantity,
          items: [{
            item_id: product.sku,
            item_name: product.name,
            affiliation: "Dajar",
            currency: defaultCurrencyCode,
            discount: product.price.special ? product.price.regular - product.price.special : 0,
            index: listPosition,
            item_brand: (_product$producer5 = product === null || product === void 0 ? void 0 : product.producer) !== null && _product$producer5 !== void 0 ? _product$producer5 : getBrandName((_product$info4 = product.info) === null || _product$info4 === void 0 ? void 0 : _product$info4.technicalData),
            item_category: categoryName,
            item_list_id: listId,
            item_list_name: listType,
            item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
            price: product.price.special ? product.price.special : product.price.regular,
            quantity: quantity
          }]
        });
      }
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && __webpack_require__.g.__appConfig__.facebookEnabled && fbq("track", "AddToCart", {
        content_ids: [product.sku],
        content_name: product.name,
        currency: currency !== null && currency !== void 0 ? currency : defaultCurrencyCode,
        value: product.price.special ? product.price.special : product.price.regular
      });
    },
    checkoutBegin: function checkoutBegin(cart, coupon) {
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        gtag("event", "begin_checkout", {
          currency: defaultCurrencyCode,
          value: cart.totals.cartTotalPrice,
          coupon: coupon !== null && coupon !== void 0 ? coupon : "",
          items: cart.items.filter(function (item) {
            return item === null || item === void 0 ? void 0 : item.product;
          }).map(function (item) {
            var _item$product, _item$product2, _item$product$produce, _item$product3, _item$product3$info;
            return {
              item_id: item.sku,
              item_name: item.name,
              affiliation: "Dajar",
              quantity: item.quantity,
              price: (_item$product = item.product) !== null && _item$product !== void 0 && _item$product.price.special ? item.product.price.special : item.product.price.regular,
              discount: (_item$product2 = item.product) !== null && _item$product2 !== void 0 && _item$product2.price.special ? item.product.price.regular - item.product.price.special : 0,
              item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : "",
              item_brand: (_item$product$produce = item.product.producer) !== null && _item$product$produce !== void 0 ? _item$product$produce : getBrandName((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : (_item$product3$info = _item$product3.info) === null || _item$product3$info === void 0 ? void 0 : _item$product3$info.technicalData)
            };
          })
        });
      }
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.pixelFb) {
        __webpack_require__.g.__appConfig__.facebookEnabled && fbq("track", "InitiateCheckout");
      }
    },
    cartPurchased: function cartPurchased(cart, checkout, language, order, coupon) {
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var _window;
        var dataLayer = ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer) || [];
        dataLayer.push({
          purchasedCartInfo: {
            email: cart.billingAddress.email,
            phone_number: cart.billingAddress.phone,
            first_name: cart.billingAddress.firstName,
            last_name: cart.billingAddress.lastName,
            home_address: {
              street: cart.billingAddress.street,
              city: cart.billingAddress.city,
              region: "",
              postal_code: cart.billingAddress.postalCode,
              country: cart.billingAddress.country.id
            }
          }
        });
        gtag("event", "purchase", {
          transaction_id: order,
          affiliation: "Dajar",
          value: checkout.totalPrice,
          tax: cart.totals.tax,
          shipping: checkout.shippingTotal,
          currency: cart.currency,
          coupon: coupon !== null && coupon !== void 0 ? coupon : "",
          items: cart.items.filter(function (item) {
            return item === null || item === void 0 ? void 0 : item.product;
          }).map(function (item, index) {
            var _item$product4, _item$product5, _item$product$produce2, _item$product6, _item$product6$info;
            return {
              item_id: item.sku,
              item_name: item.name,
              affiliation: "Dajar",
              quantity: item.quantity,
              price: (_item$product4 = item.product) !== null && _item$product4 !== void 0 && _item$product4.price.special ? item.product.price.special : item.product.price.regular,
              currency: cart.currency,
              discount: (_item$product5 = item.product) !== null && _item$product5 !== void 0 && _item$product5.price.special ? item.product.price.regular - item.product.price.special : 0,
              index: index,
              item_brand: (_item$product$produce2 = item.product.producer) !== null && _item$product$produce2 !== void 0 ? _item$product$produce2 : getBrandName((_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : (_item$product6$info = _item$product6.info) === null || _item$product6$info === void 0 ? void 0 : _item$product6$info.technicalData),
              item_category: item.categoryName,
              item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : ""
            };
          })
        });
      }
      __webpack_require__.g.__appConfig__.facebookEnabled && (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && fbq("track", "Purchase", {
        transaction_id: order,
        value: checkout.totalPrice,
        currency: cart.currency,
        content_type: "product",
        contents: cart.items.map(function (item) {
          return {
            id: item.sku,
            quantity: item.quantity
          };
        })
      });
    },
    productRemovedFromCart: function productRemovedFromCart(product) {
      var _product$producer6, _product$info5;
      var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var quantity = arguments.length > 2 ? arguments[2] : undefined;
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "remove_from_cart", {
        currency: defaultCurrencyCode,
        value: product.price.special ? product.price.special : product.price.regular,
        items: [{
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          currency: defaultCurrencyCode,
          discount: product.price.special ? product.price.regular - product.price.special : 0,
          item_brand: (_product$producer6 = product.producer) !== null && _product$producer6 !== void 0 ? _product$producer6 : getBrandName((_product$info5 = product.info) === null || _product$info5 === void 0 ? void 0 : _product$info5.technicalData),
          item_category: category,
          item_list_name: "cart",
          item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
          price: product.price.special ? product.price.special : product.price.regular,
          quantity: quantity
        }]
      });
    },
    setCheckoutOption: function setCheckoutOption(step, option, value, cart) {
      var methods = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var coupon = arguments.length > 5 ? arguments[5] : undefined;
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var selectedMethod = methods.find(function (method) {
          return (method === null || method === void 0 ? void 0 : method.methodCode) === value;
        });
        if (step === 2 && option === "shipping method") {
          gtag("event", "add_shipping_info", {
            shipping_tier: value,
            value: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.price,
            currency: cart.currency,
            coupon: coupon !== null && coupon !== void 0 ? coupon : "",
            items: cart.items.filter(function (item) {
              return item === null || item === void 0 ? void 0 : item.product;
            }).map(function (item, index) {
              var _item$product7, _item$product8, _item$product$produce3, _item$product9, _item$product9$info, _item$categoryName;
              return {
                item_id: item.sku,
                item_name: item.name,
                affiliation: "Dajar",
                quantity: item.quantity,
                price: (_item$product7 = item.product) !== null && _item$product7 !== void 0 && _item$product7.price.special ? item.product.price.special : item.product.price.regular,
                currency: cart.currency,
                discount: (_item$product8 = item.product) !== null && _item$product8 !== void 0 && _item$product8.price.special ? item.product.price.regular - item.product.price.special : 0,
                index: index,
                item_brand: (_item$product$produce3 = item.product.producer) !== null && _item$product$produce3 !== void 0 ? _item$product$produce3 : getBrandName((_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : (_item$product9$info = _item$product9.info) === null || _item$product9$info === void 0 ? void 0 : _item$product9$info.technicalData),
                item_category: (_item$categoryName = item.categoryName) !== null && _item$categoryName !== void 0 ? _item$categoryName : "",
                item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : ""
              };
            })
          });
        }
        if (step === 3 && option === "payment method") {
          gtag("event", "add_payment_info", {
            payment_type: value,
            currency: cart.currency,
            coupon: coupon !== null && coupon !== void 0 ? coupon : "",
            items: cart.items.filter(function (item) {
              return item === null || item === void 0 ? void 0 : item.product;
            }).map(function (item, index) {
              var _item$product10, _item$product11, _item$product$produce4, _item$product12, _item$product12$info, _item$categoryName2;
              return {
                item_id: item.sku,
                item_name: item.name,
                affiliation: "Dajar",
                quantity: item.quantity,
                price: (_item$product10 = item.product) !== null && _item$product10 !== void 0 && _item$product10.price.special ? item.product.price.special : item.product.price.regular,
                currency: cart.currency,
                discount: (_item$product11 = item.product) !== null && _item$product11 !== void 0 && _item$product11.price.special ? item.product.price.regular - item.product.price.special : 0,
                index: index,
                item_brand: (_item$product$produce4 = item.product.producer) !== null && _item$product$produce4 !== void 0 ? _item$product$produce4 : getBrandName((_item$product12 = item.product) === null || _item$product12 === void 0 ? void 0 : (_item$product12$info = _item$product12.info) === null || _item$product12$info === void 0 ? void 0 : _item$product12$info.technicalData),
                item_category: (_item$categoryName2 = item.categoryName) !== null && _item$categoryName2 !== void 0 ? _item$categoryName2 : "",
                item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : ""
              };
            })
          });
        }
      }
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && __webpack_require__.g.__appConfig__.facebookEnabled && step === 3 && fbq("track", "AddPaymentInfo", {
        content_ids: [value]
      });
    },
    setProductOption: function setProductOption() {
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && __webpack_require__.g.__appConfig__.facebookEnabled && fbq("track", "CustomizeProduct");
    },
    searchPhrase: function searchPhrase(phrase) {
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.analytics) && gtag("event", "search", {
        search_term: phrase
      });
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && __webpack_require__.g.__appConfig__.facebookEnabled && fbq("track", "Search", {
        search_string: phrase
      });
    },
    selectContent: function selectContent(type, id) {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "select_content", {
        content_type: type,
        item_id: id
      });
    },
    logIn: function logIn() {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "login", {
        method: "Form"
      });
    },
    signUp: function signUp() {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "sign_up", {
        method: "Form"
      });
    }
  };
};
var _default = useAnalyticsAndCommerceTags;
exports["default"] = _default;

/***/ }),

/***/ 13959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BackLinkContextProvider = exports.useBackLink = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _router = _interopRequireDefault(__webpack_require__(53746));
var _LanguageProvider = __webpack_require__(8989);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var BackLinkContext = /*#__PURE__*/_react["default"].createContext();
var BackLinkContextProvider = function BackLinkContextProvider(props) {
  var _global$__appConfig__;
  var urlsToSkip = ["/checkout", "/checkout/payment", "/checkout/success"];
  var isUrlToSkip = function isUrlToSkip(url) {
    return urlsToSkip.some(function (page) {
      return url.includes(page);
    });
  };
  var url = props.router.asPath;
  var _useState = (0, _react.useState)([url]),
    urlHistory = _useState[0],
    setUrlHistory = _useState[1];
  var _useState2 = (0, _react.useState)("/"),
    backLink = _useState2[0],
    setBackLink = _useState2[1];
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var domains = (_global$__appConfig__ = __webpack_require__.g.__appConfig__.domainLanguages) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : [];
  var baseUrl = "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  }));
  (0, _react.useEffect)(function () {
    var handler = function handler(url) {
      setUrlHistory(function (prevUrlHistory) {
        var lastUrl = prevUrlHistory[prevUrlHistory.length - 1];
        setBackLink(isUrlToSkip(lastUrl) ? "/" : lastUrl);
        return [].concat((0, _toConsumableArray2["default"])(prevUrlHistory), [url]).slice(-2);
      });
    };
    _router["default"].events.on("routeChangeComplete", handler);
    return function () {
      _router["default"].events.off("routeChangeComplete", handler);
    };
  }, []);
  return __jsx(BackLinkContext.Provider, {
    value: {
      backLink: backLink
    }
  }, props.children);
};
exports.BackLinkContextProvider = BackLinkContextProvider;
var useBackLink = function useBackLink() {
  var _useContext = (0, _react.useContext)(BackLinkContext),
    backLink = _useContext.backLink;
  return backLink;
};
exports.useBackLink = useBackLink;

/***/ }),

/***/ 28452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useCategoryTree = useCategoryTree;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _searchTree = _interopRequireDefault(__webpack_require__(50802));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CategoryTreeContext = /*#__PURE__*/_react["default"].createContext({});
function CategoryTreeProvider(_ref) {
  var tree = _ref.tree,
    children = _ref.children;
  var getCategoryNameForGivenCategoryId = function getCategoryNameForGivenCategoryId(id) {
    if (id === undefined) {
      return;
    }
    var result = getCategoryById(id);
    return result ? result.name : result;
  };
  var getCategoryById = function getCategoryById(id) {
    return (0, _searchTree["default"])(tree.categoryTree, id);
  };
  var getPath = function getPath(categoryId) {
    if (!categoryId) {
      return [];
    }
    var result;
    var categoryFound;
    tree.categoryTree.some(function (category) {
      result = (0, _searchTree["default"])(category, categoryId);
      categoryFound = category;
      return Object.keys(result).length > 0;
    });
    return result ? {
      categoryFound: categoryFound,
      categoryIds: result.path
    } : [];
  };
  var createBreadcrumbsPro = function createBreadcrumbsPro(categoryId) {
    if (!categoryId) {
      return [];
    }
    var _getPath = getPath(categoryId),
      categoryFound = _getPath.categoryFound,
      categoryIds = _getPath.categoryIds;
    var result = [];
    categoryIds.forEach(function (id) {
      var category = (0, _searchTree["default"])(categoryFound, id);
      var name = category.name,
        url = category.url,
        level = category.level;
      result.push({
        name: name,
        url: url,
        level: level,
        id: id
      });
    });
    return result;
  };
  var createBreadcrumbsPaths = function createBreadcrumbsPaths(path) {
    if (!path) {
      return;
    }
    var paths = [];
    var urlParts = path.split("/");
    var mainCategoryPath = urlParts[0] + "/" + urlParts[1];
    var treePart = tree.categoryTree.find(function (category) {
      if (category.url === mainCategoryPath) {
        paths.push({
          name: category.name,
          url: category.url
        });
        return category;
      }
    });
    if (urlParts.length < 3) {
      return paths;
    }
    treePart === null || treePart === void 0 ? void 0 : treePart.subcategories.find(function (category) {
      var subcategory = category.find(function (subcategory) {
        return subcategory.url === mainCategoryPath + "/" + urlParts[2];
      });
      if (subcategory) {
        paths.push({
          name: subcategory.name,
          url: subcategory.url
        });
        if (subcategory.subcategories.length > 0) {
          var lastCategory = subcategory.subcategories.find(function (category) {
            return category.url === mainCategoryPath + "/" + urlParts[2] + "/" + urlParts[3];
          });
          paths.push({
            name: lastCategory.name,
            url: lastCategory.url
          });
        }
        return true;
      }
    });
    return paths;
  };
  var chooseCategoryTree = function chooseCategoryTree(id) {
    var _treeFragment$subcate;
    var getTreeByIdPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (id === undefined) {
      return;
    }
    var activeCategory = getCategoryById(id);
    if (!activeCategory) {
      return;
    }
    var urlParts = activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.url.split("/");
    var mainCategoryPath = urlParts[0] + "/" + urlParts[1];
    var treeFragment;
    if (getTreeByIdPro) {
      var _activeCategory$path;
      treeFragment = _objectSpread({}, getCategoryById((_activeCategory$path = activeCategory.path) === null || _activeCategory$path === void 0 ? void 0 : _activeCategory$path[0]));
    } else {
      var _tree$categoryTree$fi;
      treeFragment = (_tree$categoryTree$fi = tree.categoryTree.find(function (category) {
        return category.url === mainCategoryPath;
      })) !== null && _tree$categoryTree$fi !== void 0 ? _tree$categoryTree$fi : [];
    }
    var fixedSubcategories = [];
    (_treeFragment$subcate = treeFragment.subcategories) === null || _treeFragment$subcate === void 0 ? void 0 : _treeFragment$subcate.forEach(function (subcategory) {
      subcategory.forEach(function (singleSubcategory) {
        fixedSubcategories.push(singleSubcategory);
      });
    });
    treeFragment.subcategories = [];
    treeFragment.subcategories.push(fixedSubcategories);
    return {
      tree: treeFragment,
      parentId: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.parentId,
      productCategoryId: id
    };
  };
  return __jsx(CategoryTreeContext.Provider, {
    value: {
      getCategoryNameForGivenCategoryId: getCategoryNameForGivenCategoryId,
      createBreadcrumbsPro: createBreadcrumbsPro,
      getCategoryById: getCategoryById,
      createBreadcrumbsPaths: createBreadcrumbsPaths,
      chooseCategoryTree: chooseCategoryTree
    }
  }, children);
}
function useCategoryTree() {
  return (0, _react.useContext)(CategoryTreeContext);
}
var _default = CategoryTreeProvider;
exports["default"] = _default;

/***/ }),

/***/ 38975:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var AUTHORIZATION_ERROR = 401;
var CART_HAS_EXPIRED = 404;
var CART_HAS_EXPIRED_QUOTE_ID = 400;
var REQUEST_GET = "GET";
var REQUEST_POST = "POST";
var QUOTE_ID = "quoteId";
var CART_ID = "cartId";
var useErrorCart = function useErrorCart() {
  return {
    checkErrorCart: function checkErrorCart(error) {
      var _error$response, _error$response2, _error$response3, _error$response3$req, _error$response4, _error$response5, _error$response5$req, _error$response6, _error$response6$body, _error$response6$body2, _error$response7, _error$response8, _error$response8$body, _error$response8$body2;
      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.statusCode) === AUTHORIZATION_ERROR) {
        return useErrorCart.LOGOUT;
      } else if ((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.statusCode) === CART_HAS_EXPIRED && REQUEST_GET === (error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$req = _error$response3.req) === null || _error$response3$req === void 0 ? void 0 : _error$response3$req.method)) {
        return useErrorCart.REMOVE_CART;
      } else if ((error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.statusCode) === CART_HAS_EXPIRED && REQUEST_POST === (error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$req = _error$response5.req) === null || _error$response5$req === void 0 ? void 0 : _error$response5$req.method) && (error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$body = _error$response6.body) === null || _error$response6$body === void 0 ? void 0 : (_error$response6$body2 = _error$response6$body.parameters) === null || _error$response6$body2 === void 0 ? void 0 : _error$response6$body2.fieldName) === CART_ID) {
        return useErrorCart.REMOVE_CART;
      } else if ((error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.statusCode) === CART_HAS_EXPIRED_QUOTE_ID && (error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : (_error$response8$body = _error$response8.body) === null || _error$response8$body === void 0 ? void 0 : (_error$response8$body2 = _error$response8$body.parameters) === null || _error$response8$body2 === void 0 ? void 0 : _error$response8$body2.fieldName) === QUOTE_ID) {
        return useErrorCart.REMOVE_CART;
      }
      return;
    }
  };
};
useErrorCart.REMOVE_CART = "remove cart";
useErrorCart.LOGOUT = "logout";
var _default = useErrorCart;
exports["default"] = _default;

/***/ }),

/***/ 72088:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var SHIPPING_METHOD_NOT_AVAILABLE = "Carrier with such method not found: %1, %2";
var PAYMENT_METHOD_NOT_AVAILABLE = "The requested Payment Method is not available.";
var PAYMENT_METHOD_ERROR = "Error with payment method, please select a different payment method.";
var useErrorCheckout = function useErrorCheckout() {
  var translations = {
    shippingMethod: (0, _langLibrary["default"])("This method is not available"),
    dontShip: (0, _langLibrary["default"])("We don't ship to this country, sorry"),
    payment: (0, _langLibrary["default"])("This method is not available"),
    paymentError: (0, _langLibrary["default"])("Error with payment method"),
    billing: (0, _langLibrary["default"])("Fill in the delivery details")
  };
  return {
    checkError: function checkError(error) {
      switch (error) {
        case SHIPPING_METHOD_NOT_AVAILABLE:
          return {
            shippingMethod: translations.shippingMethod,
            shippingAddress: {
              country: translations.dontShip
            }
          };
          break;
        case PAYMENT_METHOD_NOT_AVAILABLE:
          return {
            paymentMethod: translations.payment
          };
        case PAYMENT_METHOD_ERROR:
          return translations.paymentError;
        case useErrorCheckout.ADDRESS_NOT_SET:
          return translations.billing;
        default:
          return error;
      }
    }
  };
};
useErrorCheckout.ADDRESS_NOT_SET = "Address not set";
var _default = useErrorCheckout;
exports["default"] = _default;

/***/ }),

/***/ 87573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoaderContextProvider = exports.useLoader = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _router = _interopRequireDefault(__webpack_require__(53746));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var LoaderContext = /*#__PURE__*/_react["default"].createContext(false);
var LoaderContextProvider = function LoaderContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    isLoading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    submenuLoaded = _useState2[0],
    setSubmenuLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    cookieNoticeLoaded = _useState3[0],
    setCookieNoticeLoaded = _useState3[1];
  var _useState4 = (0, _react.useState)(props.externalContentTimeout),
    externalContentTimeout = _useState4[0],
    setExternalContentTimeout = _useState4[1];
  (0, _react.useEffect)(function () {
    var handlerComplete = function handlerComplete() {
      return setLoading(false);
    };
    var handlerStart = function handlerStart() {
      return setLoading(true);
    };
    _router["default"].events.on("routeChangeStart", handlerStart);
    _router["default"].events.on("routeChangeComplete", handlerComplete);
    return function () {
      _router["default"].events.off("routeChangeStart", handlerStart);
      _router["default"].events.off("routeChangeComplete", handlerComplete);
    };
  }, []);
  return __jsx(LoaderContext.Provider, {
    value: {
      isLoading: isLoading,
      externalContentTimeout: externalContentTimeout,
      setExternalContentTimeout: setExternalContentTimeout,
      submenuLoaded: submenuLoaded,
      setSubmenuLoaded: setSubmenuLoaded,
      cookieNoticeLoaded: cookieNoticeLoaded,
      setCookieNoticeLoaded: setCookieNoticeLoaded
    }
  }, props.children);
};
exports.LoaderContextProvider = LoaderContextProvider;
var useLoader = function useLoader() {
  return (0, _react.useContext)(LoaderContext);
};
exports.useLoader = useLoader;

/***/ }),

/***/ 34698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MinicartContextProvider = exports.useMinicart = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MinicartContext = /*#__PURE__*/_react["default"].createContext();
var minicartDefault = {
  isMinicartVisible: false,
  minicartContent: [],
  isSetFromLocalStorage: false,
  temporaryMinicartQty: null,
  temporaryChangedProduct: null,
  temporaryQtyChange: null,
  isCouponCodeFormPromotions: false
};
var MinicartContextProvider = function MinicartContextProvider(props) {
  var isFirstRun = (0, _react.useRef)(true);
  var _useState = (0, _react.useState)(false),
    isMinicartLoading = _useState[0],
    setMinicartLoading = _useState[1];
  var _useState2 = (0, _react.useState)(minicartDefault),
    minicartState = _useState2[0],
    changeMinicartState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      var _localStorage;
      isFirstRun.current = false;
      var initialCart = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("minicartContent");
      var parsedInitialCart = initialCart ? JSON.parse(initialCart).items : [];
      changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
        minicartContent: parsedInitialCart,
        isSetFromLocalStorage: true
      }));
    }
  }, []);
  var countItemsAmount = function countItemsAmount(currentMinicartContent) {
    if (!currentMinicartContent || (currentMinicartContent === null || currentMinicartContent === void 0 ? void 0 : currentMinicartContent.length) === 0) return 0;
    var itemsAmount = 0;
    currentMinicartContent.forEach(function (item) {
      itemsAmount += item.quantity;
    });
    return itemsAmount;
  };
  var updateTemporaryData = function updateTemporaryData() {
    var quantityDifference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var changedProduct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    quantityDifference === null ? changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      temporaryMinicartQty: quantityDifference,
      temporaryChangedProduct: changedProduct,
      temporaryQtyChange: quantityDifference
    })) : changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      temporaryMinicartQty: countItemsAmount(minicartState.minicartContent) + quantityDifference,
      temporaryChangedProduct: changedProduct,
      temporaryQtyChange: quantityDifference
    }));
  };
  var getCurrentPrice = function getCurrentPrice(price, quantity, isCheckout, discountTemp) {
    if (!price) return 0;
    if (price !== null && price !== void 0 && price.discountFromTotals) {
      return ((price === null || price === void 0 ? void 0 : price.special) || (price === null || price === void 0 ? void 0 : price.regular)) * quantity - (isCheckout ? 0 : price === null || price === void 0 ? void 0 : price.discountFromTotals);
    }
    return ((price === null || price === void 0 ? void 0 : price.special) || (price === null || price === void 0 ? void 0 : price.regular) || 0) * quantity;
  };
  var getMinicartTotalPrice = function getMinicartTotalPrice(currentMinicartContent) {
    var isCheckout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!currentMinicartContent || (currentMinicartContent === null || currentMinicartContent === void 0 ? void 0 : currentMinicartContent.length) === 0) return 0;
    var price = 0;
    var temporaryPriceAddition = 0;
    currentMinicartContent.map(function (item, index) {
      var _item$product;
      var itemPrice = getCurrentPrice(item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.price, item.quantity, isCheckout);
      price += itemPrice;
      if (minicartState.temporaryMinicartQty !== null) {
        var _ref;
        var qtyBefore = minicartState.temporaryQtyChange * -1 + minicartState.temporaryMinicartQty;
        var discountDiffrence = 0;
        if (qtyBefore === item.quantity) {
          var _item$product2, _item$product2$price, _item$product3, _item$product3$price;
          discountDiffrence = (item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$price = _item$product2.price) === null || _item$product2$price === void 0 ? void 0 : _item$product2$price.discountFromTotals) / qtyBefore * minicartState.temporaryMinicartQty * -1 + ((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : (_item$product3$price = _item$product3.price) === null || _item$product3$price === void 0 ? void 0 : _item$product3$price.discountFromTotals);
        }
        var _minicartState$tempor = minicartState.temporaryChangedProduct.price,
          special = _minicartState$tempor.special,
          regular = _minicartState$tempor.regular;
        temporaryPriceAddition = (_ref = (special || regular) * minicartState.temporaryQtyChange + discountDiffrence) !== null && _ref !== void 0 ? _ref : 0;
      }
    });
    return minicartState.temporaryMinicartQty === null ? price : price + temporaryPriceAddition;
  };
  var toggleMinicartVisibility = function toggleMinicartVisibility() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        close: false
      },
      close = _ref2.close;
    if (close && !minicartState.isMinicartVisible) {
      return;
    }
    if (close) {
      changeMinicartState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isMinicartVisible: false
        });
      });
      return;
    }
    if (isMinicartLoading) return;
    changeMinicartState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isMinicartVisible: !prev.isMinicartVisible
      });
    });
  };
  var updateMinicartContent = function updateMinicartContent(sku, quantity) {
    var minicartWithUpdatedProductQuantity = [];
    minicartState.minicartContent.map(function (item) {
      if (parseInt(item.product.sku) === parseInt(sku)) {
        item.quantity = quantity;
      }
      minicartWithUpdatedProductQuantity.push(item);
    });
    changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      minicartContent: minicartWithUpdatedProductQuantity
    }));
  };
  var addNewItemToMinicart = function addNewItemToMinicart(product, quantity) {
    var _minicartState$minica;
    var itemInCart = (_minicartState$minica = minicartState.minicartContent) === null || _minicartState$minica === void 0 ? void 0 : _minicartState$minica.find(function (item) {
      var _item$product4;
      return parseInt((_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.sku) === parseInt(product.sku);
    });
    if (itemInCart) {
      updateMinicartContent(product.sku, itemInCart.quantity + quantity);
      return;
    }
    var minicartWithNewItemAdded = [].concat((0, _toConsumableArray2["default"])(minicartState.minicartContent), [{
      name: product.name,
      sku: product.sku,
      product: product,
      quantity: quantity
    }]);
    changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      minicartContent: minicartWithNewItemAdded
    }));
  };
  var removeItemFromMinicart = function removeItemFromMinicart(sku) {
    var minicartWithItemRemoved = minicartState.minicartContent.filter(function (item) {
      return parseInt(item.sku) !== parseInt(sku);
    });
    changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      minicartContent: minicartWithItemRemoved
    }));
  };
  var setMinicartContentFromStorage = function setMinicartContentFromStorage() {
    var cart = localStorage.getItem("minicartContent");
    var parsedCart = cart ? JSON.parse(cart) : [];
    changeMinicartState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        minicartContent: parsedCart !== null && parsedCart !== void 0 && parsedCart.items ? parsedCart.items : [],
        isSetFromLocalStorage: true
      });
    });
  };
  var setCouponCodeFormPromotions = function setCouponCodeFormPromotions(isCouponCodeFormPromotions) {
    changeMinicartState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isCouponCodeFormPromotions: isCouponCodeFormPromotions
      });
    });
  };
  var clearMinicartState = function clearMinicartState() {
    changeMinicartState(minicartDefault);
  };
  return __jsx(MinicartContext.Provider, {
    value: {
      isMinicartLoading: isMinicartLoading,
      setMinicartLoading: setMinicartLoading,
      isMinicartVisible: minicartState.isMinicartVisible,
      minicartContent: minicartState.minicartContent,
      itemsAmount: minicartState.temporaryMinicartQty === null ? countItemsAmount(minicartState.minicartContent) : minicartState.temporaryMinicartQty,
      minicartTotalPrice: function minicartTotalPrice(isCheckout) {
        return getMinicartTotalPrice(minicartState.minicartContent, isCheckout);
      },
      setCouponCodeFormPromotions: setCouponCodeFormPromotions,
      showDiscountInProductRow: minicartState.isCouponCodeFormPromotions,
      toggleMinicartVisibility: toggleMinicartVisibility,
      addNewItemToMinicart: addNewItemToMinicart,
      removeItemFromMinicart: removeItemFromMinicart,
      updateMinicartContent: updateMinicartContent,
      setMinicartContentFromStorage: setMinicartContentFromStorage,
      changeMinicartState: changeMinicartState,
      minicartState: minicartState,
      clearMinicartState: clearMinicartState,
      updateTemporaryData: updateTemporaryData
    }
  }, props.children);
};
exports.MinicartContextProvider = MinicartContextProvider;
var useMinicart = function useMinicart() {
  return (0, _react.useContext)(MinicartContext);
};
exports.useMinicart = useMinicart;

/***/ }),

/***/ 95514:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PaginationPaginationLoaderProvider = exports.usePaginationLoader = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var PaginationLoader = /*#__PURE__*/_react["default"].createContext(false);
var PaginationPaginationLoaderProvider = function PaginationPaginationLoaderProvider(props) {
  var _useState = (0, _react.useState)(false),
    isLoading = _useState[0],
    setLoading = _useState[1];
  var setPaginationLoadingState = function setPaginationLoadingState(state) {
    setLoading(state);
  };
  return __jsx(PaginationLoader.Provider, {
    value: {
      isLoading: isLoading,
      setPaginationLoadingState: setPaginationLoadingState
    }
  }, props.children);
};
exports.PaginationPaginationLoaderProvider = PaginationPaginationLoaderProvider;
var usePaginationLoader = function usePaginationLoader() {
  return (0, _react.useContext)(PaginationLoader);
};
exports.usePaginationLoader = usePaginationLoader;

/***/ }),

/***/ 81890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _priceFormat = _interopRequireDefault(__webpack_require__(93340));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _CurrencyProvider = __webpack_require__(38073);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function usePriceWithCurrency() {
  var _useCurrency = (0, _CurrencyProvider.useCurrency)(),
    currency = _useCurrency.currency;
  return function (price) {
    var isReturnPlainText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return isReturnPlainText ? "".concat((0, _priceFormat["default"])(price), " ").concat(currency === null || currency === void 0 ? void 0 : currency.symbol) : __jsx(_Box["default"], {
      as: "span"
    }, __jsx(_Box["default"], {
      as: "span",
      "data-test": "total-checkout"
    }, (0, _priceFormat["default"])(price), "\xA0"), __jsx(_Box["default"], {
      as: "span"
    }, currency === null || currency === void 0 ? void 0 : currency.symbol));
  };
}
var _default = usePriceWithCurrency;
exports["default"] = _default;

/***/ }),

/***/ 79105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.RecentlyViewedContextProvider = exports.useRecentlyViewedProducts = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var RecentlyViewedContext = /*#__PURE__*/_react["default"].createContext();
var RecentlyViewedContextProvider = function RecentlyViewedContextProvider(props) {
  var _useState = (0, _react.useState)(null),
    product = _useState[0],
    setProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    recentlyViewedProducts = _useState2[0],
    setRecentlyViewedProducts = _useState2[1];
  var isFirstRun = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      var recentlyViewedProductsStorage = localStorage.getItem("recentlyViewedProducts");
      setRecentlyViewedProducts(recentlyViewedProductsStorage ? JSON.parse(recentlyViewedProductsStorage) : []);
      return;
    }
    if (product && !recentlyViewedProducts.find(function (prod) {
      return prod.sku === product.sku;
    })) {
      var products = [product].concat((0, _toConsumableArray2["default"])(recentlyViewedProducts.slice(0, 5)));
      setRecentlyViewedProducts(products);
      localStorage.setItem("recentlyViewedProducts", JSON.stringify(products));
    }
  }, [product]);
  return __jsx(RecentlyViewedContext.Provider, {
    value: {
      recentlyViewedProducts: recentlyViewedProducts,
      setProduct: setProduct,
      product: product
    }
  }, props.children);
};
exports.RecentlyViewedContextProvider = RecentlyViewedContextProvider;
var useRecentlyViewedProducts = function useRecentlyViewedProducts(product) {
  var _useContext = (0, _react.useContext)(RecentlyViewedContext),
    setProduct = _useContext.setProduct,
    recentlyViewedProducts = _useContext.recentlyViewedProducts,
    lastAddedProduct = _useContext.product;
  (0, _react.useEffect)(function () {
    if (product) {
      setProduct(product);
    }
  }, []);
  return recentlyViewedProducts && lastAddedProduct ? recentlyViewedProducts.filter(function (prod) {
    return prod.sku !== lastAddedProduct.sku;
  }) : recentlyViewedProducts;
};
exports.useRecentlyViewedProducts = useRecentlyViewedProducts;

/***/ }),

/***/ 51427:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Client = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(98986));
var _createClass2 = _interopRequireDefault(__webpack_require__(30428));
var _prismicJavascript = _interopRequireDefault(__webpack_require__(11329));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Client = function Client() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return new PrismicClient().getClient();
};
exports.Client = Client;
var PrismicClient = /*#__PURE__*/function () {
  function PrismicClient() {
    (0, _classCallCheck2["default"])(this, PrismicClient);
    if (!PrismicClient.instance) {
      PrismicClient.instance = _prismicJavascript["default"].client(__webpack_require__.g.__appConfig__.prismicEndpointUrl, this.createClientOptions(null, __webpack_require__.g.__appConfig__.prismicToken));
    }
  }
  (0, _createClass2["default"])(PrismicClient, [{
    key: "createClientOptions",
    value: function createClientOptions() {
      var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var prismicAccessToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var prismicTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __webpack_require__.g.__appConfig__.prismicTimeout;
      var reqOption = req ? {
        req: req
      } : {};
      var accessTokenOption = prismicAccessToken ? prismicTimeout ? {
        accessToken: prismicAccessToken,
        timeoutInMs: prismicTimeout
      } : {
        accessToken: prismicAccessToken
      } : prismicTimeout ? {
        timeoutInMs: prismicTimeout
      } : {};
      return _objectSpread(_objectSpread({}, reqOption), accessTokenOption);
    }
  }, {
    key: "getClient",
    value: function getClient() {
      return PrismicClient.instance;
    }
  }]);
  return PrismicClient;
}();

/***/ }),

/***/ 63981:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getResponsePrismicByUID = exports.getLanguage = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _getPrismicDocumentLang = _interopRequireDefault(__webpack_require__(544));
var _getLanguageFromHostname = _interopRequireDefault(__webpack_require__(81509));
var _cache = __webpack_require__(75800);
var _prismicConfiguration = __webpack_require__(51427);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getLanguage = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var language, filename, currentLanguage, lang, cacheFilePath, cachedFilePrismic;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            language = _ref.language, filename = _ref.filename;
            currentLanguage = language ? language === null || language === void 0 ? void 0 : language.language : (0, _getLanguageFromHostname["default"])();
            lang = (0, _getPrismicDocumentLang["default"])(language ? language === null || language === void 0 ? void 0 : language.language : (0, _getLanguageFromHostname["default"])());
            cacheFilePath = "".concat(currentLanguage, "/");
            _context.next = 6;
            return readCacheFilePrismic({
              cacheFilePath: cacheFilePath,
              constantFileName: "".concat(filename)
            });
          case 6:
            cachedFilePrismic = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, cachedFilePrismic), {}, {
              lang: lang,
              cacheFilePath: cacheFilePath
            }));
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getLanguage(_x) {
    return _ref2.apply(this, arguments);
  };
}();
exports.getLanguage = getLanguage;
var readCacheFilePrismic = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var cacheFilePath, constantFileName, _yield$readCacheFile, cacheFileExist, cachedRequest;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cacheFilePath = _ref3.cacheFilePath, constantFileName = _ref3.constantFileName;
            _context2.next = 3;
            return (0, _cache.readCacheFile)({
              cacheFilePath: cacheFilePath,
              constantFileName: constantFileName,
              contextRequest: true,
              forPrismic: true
            });
          case 3:
            _yield$readCacheFile = _context2.sent;
            cacheFileExist = _yield$readCacheFile.cacheFileExist;
            cachedRequest = _yield$readCacheFile.cachedRequest;
            if (cacheFileExist) {
              cachedRequest = Object.values(cachedRequest).length ? cachedRequest : false;
            }
            return _context2.abrupt("return", {
              cacheFileExist: cacheFileExist,
              cachedRequest: cachedRequest
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function readCacheFilePrismic(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getResponsePrismicByUID = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref5) {
    var uid, type, lang, _ref5$withPrefix, withPrefix;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            uid = _ref5.uid, type = _ref5.type, lang = _ref5.lang, _ref5$withPrefix = _ref5.withPrefix, withPrefix = _ref5$withPrefix === void 0 ? true : _ref5$withPrefix;
            _context3.next = 3;
            return (0, _prismicConfiguration.Client)().getByUID("".concat(withPrefix ? __webpack_require__.g.__appConfig__.prismicPrefix : "") + type, uid, {
              lang: lang
            });
          case 3:
            return _context3.abrupt("return", _context3.sent);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function getResponsePrismicByUID(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
exports.getResponsePrismicByUID = getResponsePrismicByUID;

/***/ }),

/***/ 11651:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _prismicConfiguration = __webpack_require__(51427);
var _agent = __webpack_require__(37642);
var _createSearchUrl = __webpack_require__(8371);
var _saleBanner = _interopRequireDefault(__webpack_require__(96759));
var _prismicDataMapper = _interopRequireDefault(__webpack_require__(78438));
var _blogger = _interopRequireDefault(__webpack_require__(38422));
var _mapProductDataNew = _interopRequireDefault(__webpack_require__(69729));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(type, uid, language) {
    var withPrefix,
      _ret,
      _getLanguage,
      cacheFileExist,
      cachedRequest,
      _args6 = arguments;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            withPrefix = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : true;
            _context6.prev = 1;
            return _context6.delegateYield(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_response$data, _response$data$body, _response$data2, _response$data3, _response$data4, _relatedArticlesConte, _response$data5, _response$data5$saleb, _response$data$seotit, _response$data$seodes) {
              var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, linkedContent, linkedContentResponse, linkedContentResponseData, mappedResponse, getBlogger, getSalesBanner, getProducts, getRelated, featuredProducts, relatedFirst, relatedSecond, relatedArticlesIds, relatedArticlesContent, bloggersIDs, bloggersToFetch, bloggersResponse, mappedBloggers, _i, _Object$entries, _Object$entries$_i, key, value, mappedArticles, saleBannerUid, saleBanner, productsData, mappedSaleBanner, seoTitle, seoDescription;
              return _regenerator["default"].wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return (0, _prismicHelper.getLanguage)({
                        language: language,
                        filename: uid
                      });
                    case 2:
                      _yield$getLanguage = _context5.sent;
                      cacheFileExist = _yield$getLanguage.cacheFileExist;
                      cachedRequest = _yield$getLanguage.cachedRequest;
                      lang = _yield$getLanguage.lang;
                      cacheFilePath = _yield$getLanguage.cacheFilePath;
                      if (!cacheFileExist) {
                        _context5.next = 9;
                        break;
                      }
                      return _context5.abrupt("return", {
                        v: cachedRequest
                      });
                    case 9:
                      _context5.next = 11;
                      return (0, _prismicHelper.getResponsePrismicByUID)({
                        type: type,
                        uid: uid,
                        lang: lang,
                        withPrefix: withPrefix
                      });
                    case 11:
                      response = _context5.sent;
                      if (response) {
                        _context5.next = 14;
                        break;
                      }
                      return _context5.abrupt("return", {
                        v: false
                      });
                    case 14:
                      linkedContent = [];
                      (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.filter(function (item) {
                        if (item.slice_type === "linked_content") {
                          linkedContent.push(item);
                        }
                      });
                      _context5.next = 18;
                      return Promise.all(linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.map(function (item) {
                        return (0, _prismicConfiguration.Client)().getByID(item.primary.linked_content.id);
                      }));
                    case 18:
                      linkedContentResponse = _context5.sent;
                      linkedContentResponseData = [];
                      linkedContentResponse.length > 0 ? linkedContentResponse.map(function (element) {
                        linkedContentResponseData.push(element.data.body[0]);
                      }) : linkedContentResponseData = false;
                      response.linkedContentResponse = linkedContentResponseData;
                      mappedResponse = response && (0, _prismicDataMapper["default"])(response);
                      getBlogger = /*#__PURE__*/function () {
                        var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(bloggerId) {
                          return _regenerator["default"].wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return (0, _prismicConfiguration.Client)().getByID(bloggerId);
                                case 2:
                                  return _context.abrupt("return", _context.sent);
                                case 3:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));
                        return function getBlogger(_x4) {
                          return _ref2.apply(this, arguments);
                        };
                      }();
                      getSalesBanner = /*#__PURE__*/function () {
                        var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(bannerId) {
                          return _regenerator["default"].wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return (0, _prismicConfiguration.Client)().getByID(bannerId);
                                case 2:
                                  return _context2.abrupt("return", _context2.sent);
                                case 3:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));
                        return function getSalesBanner(_x5) {
                          return _ref3.apply(this, arguments);
                        };
                      }();
                      getProducts = /*#__PURE__*/function () {
                        var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(productsIDs) {
                          var productsInPrismicOrder, _response;
                          return _regenerator["default"].wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  if (productsIDs) {
                                    _context3.next = 2;
                                    break;
                                  }
                                  return _context3.abrupt("return");
                                case 2:
                                  productsInPrismicOrder = [];
                                  _context3.prev = 3;
                                  _context3.next = 6;
                                  return _agent.requests.get((0, _createSearchUrl.createSearchUrl)("/products", productsIDs.map(function (sku) {
                                    return {
                                      field: "sku",
                                      value: sku,
                                      condition_type: "in",
                                      connector: _createSearchUrl.CONNECTORS.OR
                                    };
                                  })), true, null, language);
                                case 6:
                                  _response = _context3.sent;
                                  (_response === null || _response === void 0 ? void 0 : _response.total_count) > 0 && productsIDs.map(function (productID) {
                                    _response.items.map(function (resultItem) {
                                      if (productID === resultItem.sku) {
                                        productsInPrismicOrder.push(resultItem);
                                      }
                                    });
                                  });
                                  _context3.next = 13;
                                  break;
                                case 10:
                                  _context3.prev = 10;
                                  _context3.t0 = _context3["catch"](3);
                                  console.log("usePrismic - getProducts - ".concat(_context3.t0));
                                case 13:
                                  return _context3.abrupt("return", (0, _mapProductDataNew["default"])(productsInPrismicOrder));
                                case 14:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, null, [[3, 10]]);
                        }));
                        return function getProducts(_x6) {
                          return _ref4.apply(this, arguments);
                        };
                      }();
                      getRelated = /*#__PURE__*/function () {
                        var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(relatedIds) {
                          return _regenerator["default"].wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  _context4.next = 2;
                                  return (0, _prismicConfiguration.Client)().getByIDs(relatedIds);
                                case 2:
                                  return _context4.abrupt("return", _context4.sent);
                                case 3:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));
                        return function getRelated(_x7) {
                          return _ref5.apply(this, arguments);
                        };
                      }();
                      featuredProducts = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.featured_products;
                      relatedFirst = (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.related_article_first;
                      relatedSecond = (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.related_article_second;
                      relatedArticlesIds = [];
                      (relatedFirst === null || relatedFirst === void 0 ? void 0 : relatedFirst.id) && relatedArticlesIds.push(relatedFirst.id);
                      (relatedSecond === null || relatedSecond === void 0 ? void 0 : relatedSecond.id) && relatedArticlesIds.push(relatedSecond.id);
                      if (!(relatedArticlesIds.length > 0)) {
                        _context5.next = 39;
                        break;
                      }
                      _context5.next = 36;
                      return getRelated(relatedArticlesIds);
                    case 36:
                      _context5.t0 = _context5.sent;
                      _context5.next = 40;
                      break;
                    case 39:
                      _context5.t0 = "";
                    case 40:
                      relatedArticlesContent = _context5.t0;
                      bloggersIDs = [];
                      mappedResponse.inspirations.map(function (inspiration) {
                        if (inspiration.bloggerId) {
                          bloggersIDs.push(inspiration.bloggerId);
                        } else {
                          bloggersIDs.push("0");
                        }
                      });
                      if (mappedResponse.blogger) {
                        bloggersIDs.push(mappedResponse.blogger);
                      }
                      bloggersToFetch = Array.from(new Set(bloggersIDs));
                      _context5.next = 47;
                      return Promise.all(bloggersToFetch.map(function (id) {
                        return id === "0" ? id : getBlogger(id);
                      }));
                    case 47:
                      bloggersResponse = _context5.sent;
                      mappedBloggers = bloggersResponse.map(function (blogger) {
                        return blogger === "0" ? blogger : (0, _blogger["default"])(blogger);
                      });
                      for (_i = 0, _Object$entries = Object.entries(mappedResponse); _i < _Object$entries.length; _i++) {
                        _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        if (Array.isArray(value)) {
                          value.map(function (content) {
                            mappedBloggers.map(function (blogger) {
                              if (blogger.id === content.bloggerId) {
                                content.influencerData = blogger;
                              }
                            });
                          });
                        }
                      }
                      mappedArticles = [];
                      (relatedArticlesContent === null || relatedArticlesContent === void 0 ? void 0 : relatedArticlesContent.results) && ((_relatedArticlesConte = relatedArticlesContent.results) === null || _relatedArticlesConte === void 0 ? void 0 : _relatedArticlesConte.map(function (result) {
                        var _result$article$conte;
                        result = (0, _prismicDataMapper["default"])(result);
                        var image = {};
                        (_result$article$conte = result.article.content) === null || _result$article$conte === void 0 ? void 0 : _result$article$conte.map(function (articleContent) {
                          if (articleContent.type === "image" && articleContent.mode === "width with larger margin") {
                            image = articleContent.image;
                          }
                        });
                        mappedArticles.push({
                          title: result.article.title,
                          description: result.article.subtitle,
                          route: result.url,
                          image: image
                        });
                      }));
                      saleBannerUid = (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$saleb = _response$data5.salebanner) === null || _response$data5$saleb === void 0 ? void 0 : _response$data5$saleb.id;
                      if (!saleBannerUid) {
                        _context5.next = 59;
                        break;
                      }
                      _context5.next = 56;
                      return getSalesBanner(saleBannerUid);
                    case 56:
                      _context5.t1 = _context5.sent;
                      _context5.next = 60;
                      break;
                    case 59:
                      _context5.t1 = false;
                    case 60:
                      saleBanner = _context5.t1;
                      if (!(featuredProducts !== null && featuredProducts !== void 0 && featuredProducts.length)) {
                        _context5.next = 67;
                        break;
                      }
                      _context5.next = 64;
                      return getProducts(featuredProducts.replace(/\s+/g, "").split(","));
                    case 64:
                      _context5.t2 = _context5.sent;
                      _context5.next = 68;
                      break;
                    case 67:
                      _context5.t2 = [];
                    case 68:
                      productsData = _context5.t2;
                      mappedSaleBanner = saleBanner ? (0, _saleBanner["default"])(saleBanner.data) : false;
                      seoTitle = ((_response$data$seotit = response.data.seotitle) === null || _response$data$seotit === void 0 ? void 0 : _response$data$seotit.length) > 0 ? response.data.seotitle[0].text : false;
                      seoDescription = ((_response$data$seodes = response.data.seodescription) === null || _response$data$seodes === void 0 ? void 0 : _response$data$seodes.length) > 0 ? response.data.seodescription[0].text : false;
                      _context5.next = 74;
                      return (0, _cache.saveCacheFile)({
                        cacheFilePath: cacheFilePath,
                        filenameCategoryCache: "".concat(uid, ".json"),
                        result: {
                          seoTitle: seoTitle,
                          seoDescription: seoDescription,
                          content: mappedResponse,
                          blogger: mappedBloggers,
                          products: productsData,
                          related: mappedArticles,
                          saleBanner: mappedSaleBanner
                        }
                      });
                    case 74:
                      return _context5.abrupt("return", {
                        v: {
                          seoTitle: seoTitle,
                          seoDescription: seoDescription,
                          content: mappedResponse,
                          blogger: mappedBloggers,
                          products: productsData,
                          related: mappedArticles,
                          saleBanner: mappedSaleBanner
                        }
                      });
                    case 75:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            })(), "t0", 3);
          case 3:
            _ret = _context6.t0;
            if (!(typeof _ret === "object")) {
              _context6.next = 6;
              break;
            }
            return _context6.abrupt("return", _ret.v);
          case 6:
            _context6.next = 14;
            break;
          case 8:
            _context6.prev = 8;
            _context6.t1 = _context6["catch"](1);
            _getLanguage = (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            }), cacheFileExist = _getLanguage.cacheFileExist, cachedRequest = _getLanguage.cachedRequest;
            if (!cacheFileExist) {
              _context6.next = 13;
              break;
            }
            return _context6.abrupt("return", cachedRequest);
          case 13:
            return _context6.abrupt("return", (0, _prismicErrorHandle["default"])(_context6.t1, "Prismic - type: ".concat(type, " uid: ").concat(uid, " - ").concat(_context6.t1)));
          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 8]]);
  }));
  return function fetcher(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 22686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "xD", ({
  enumerable: true,
  get: function get() {
    return _usePrismic["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismic = _interopRequireDefault(__webpack_require__(21136));
var _fetcher = _interopRequireDefault(__webpack_require__(11651));

/***/ }),

/***/ 21136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(11651));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismic = function usePrismic(type, uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([type, uid, language, "usePrismic"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismic;
exports["default"] = _default;

/***/ }),

/***/ 7775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _categoryBanners = _interopRequireDefault(__webpack_require__(29439));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var filename = "categorybanners";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedCategoryBanners, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: __webpack_require__.g.__appConfig__.prismicCategoryBanners,
              lang: lang
            });
          case 12:
            response = _context.sent;
            mappedCategoryBanners = (0, _categoryBanners["default"])(response);
            _context.next = 16;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, ".json"),
              result: mappedCategoryBanners
            });
          case 16:
            return _context.abrupt("return", mappedCategoryBanners);
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            _context.next = 23;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 23:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 28;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 28:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - category banners - ".concat(_context.t0)));
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 19]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 62778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _usePrismicCategoryBanners["default"];
  }
});
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicCategoryBanners = _interopRequireDefault(__webpack_require__(89447));
var _fetcher = _interopRequireDefault(__webpack_require__(7775));

/***/ }),

/***/ 89447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(7775));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicCategoryBanners = function usePrismicCategoryBanners(language, fetchedPrismicContent) {
  return (0, _swr["default"])([language, "usePrismicCategoryBanners"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicCategoryBanners;
exports["default"] = _default;

/***/ }),

/***/ 84427:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _footer = _interopRequireDefault(__webpack_require__(55735));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var filename = "footer";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedFooter, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: uid,
              lang: lang
            });
          case 12:
            response = _context.sent;
            mappedFooter = (0, _footer["default"])(response);
            _context.next = 16;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, ".json"),
              result: mappedFooter
            });
          case 16:
            return _context.abrupt("return", mappedFooter);
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            _context.next = 23;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 23:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 28;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 28:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - footer"));
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 19]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 17947:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _usePrismicFooter["default"];
  }
});
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicFooter = _interopRequireDefault(__webpack_require__(8392));
var _fetcher = _interopRequireDefault(__webpack_require__(84427));

/***/ }),

/***/ 8392:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(84427));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicFooter = function usePrismicFooter(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicFooter"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicFooter;
exports["default"] = _default;

/***/ }),

/***/ 19612:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _menuBanners = _interopRequireDefault(__webpack_require__(57873));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var filename = "menubanners";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedMenuBanners, _getLanguage, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: __webpack_require__.g.__appConfig__.prismicMenuBanners,
              lang: lang
            });
          case 12:
            response = _context.sent;
            mappedMenuBanners = (0, _menuBanners["default"])(response);
            _context.next = 16;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, ".json"),
              result: mappedMenuBanners
            });
          case 16:
            return _context.abrupt("return", mappedMenuBanners);
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            _getLanguage = (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            }), _cacheFileExist = _getLanguage.cacheFileExist, _cachedRequest = _getLanguage.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 24;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 24:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - list"));
          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 19]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 7293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _usePrismicMenuBanners["default"];
  }
});
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicMenuBanners = _interopRequireDefault(__webpack_require__(61240));
var _fetcher = _interopRequireDefault(__webpack_require__(19612));

/***/ }),

/***/ 61240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(19612));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicMenuBanners = function usePrismicMenuBanners(language, fetchedPrismicContent) {
  return (0, _swr["default"])([language, "usePrismicMenuBanners"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicMenuBanners;
exports["default"] = _default;

/***/ }),

/***/ 71171:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _saleBanner = _interopRequireDefault(__webpack_require__(96759));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var filename = "salebanner";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, saleBanner, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: uid,
              lang: lang
            });
          case 12:
            response = _context.sent;
            saleBanner = (0, _saleBanner["default"])(response === null || response === void 0 ? void 0 : response.data);
            _context.next = 16;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, ".json"),
              result: saleBanner
            });
          case 16:
            return _context.abrupt("return", {
              saleBanner: saleBanner
            });
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            _context.next = 23;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 23:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 28;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 28:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - sale banner"));
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 19]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 63064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _usePrismicSaleBanner["default"];
  }
});
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicSaleBanner = _interopRequireDefault(__webpack_require__(66185));
var _fetcher = _interopRequireDefault(__webpack_require__(71171));

/***/ }),

/***/ 66185:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(71171));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicSaleBanner = function usePrismicSaleBanner(uid, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, "usePrismicSaleBanner"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicSaleBanner;
exports["default"] = _default;

/***/ }),

/***/ 98753:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _reactRedux = __webpack_require__(71682);
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(26367));
var _checkoutDataSlice = __webpack_require__(70071);
var _excluded = ["email"],
  _excluded2 = ["email"]; //Tutaj hook dla Api tylko, nie moze byc np. uzyty ten sam @deosite/hooks on korzysta miedzyinnymi z z useCart itd nested cycle. Teraz powielony kod w stosunku do @deosite/hooks, ale teraz jest mix, jakby cart podeszedl do reduxa by bylo ladniej :)
var useCheckoutData = function useCheckoutData() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.checkoutData;
    }),
    email = _useSelector.email,
    billingAddress = _useSelector.billingAddress,
    shippingAddress = _useSelector.shippingAddress,
    shippingAddressSameAsBilling = _useSelector.shippingAddressSameAsBilling,
    additionalInformation = _useSelector.additionalInformation,
    emailConsentForDelivery = _useSelector.emailConsentForDelivery;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var dispatch = (0, _reactRedux.useDispatch)();
  var updateOrderId = function updateOrderId(orderId) {
    dispatch((0, _checkoutDataSlice.setOrder)(orderId));
  };
  var setAddressOnSubmit = function setAddressOnSubmit(values) {
    dispatch((0, _checkoutDataSlice.setAddresses)(values));
  };
  var setBillingCountryFromCart = function setBillingCountryFromCart() {
    if (window === undefined) {
      return;
    }
    var accountData = JSON.parse(sessionStorage.getItem("accountData"));
    if (billingAddress.country.id) {
      return;
    }
    var _ref = accountData !== null && accountData !== void 0 ? accountData : {},
      emailStorage = _ref.email,
      billing = _ref.billingAddress,
      shipping = _ref.shippingAddress,
      customer = _ref.customer;
    if (emailStorage) {
      dispatch((0, _checkoutDataSlice.setEmail)(emailStorage));
    }
    if (billing) {
      var _email = billing.email,
        billingWithoutEmail = (0, _objectWithoutProperties2["default"])(billing, _excluded);
      dispatch((0, _checkoutDataSlice.setBillingAddress)(billingWithoutEmail));
    } else {
      dispatch((0, _checkoutDataSlice.setBillingCountry)(language.toUpperCase()));
    }
    if (shipping) {
      var _email2 = shipping.email,
        shippingWithoutEmail = (0, _objectWithoutProperties2["default"])(shipping, _excluded2);
      dispatch((0, _checkoutDataSlice.setShippingAddress)(shippingWithoutEmail));
    } else {
      dispatch((0, _checkoutDataSlice.setShippingCountry)(language.toUpperCase()));
    }
  };
  return {
    email: email,
    billingAddress: billingAddress,
    shippingAddress: shippingAddress,
    clearData: function clearData() {
      return dispatch((0, _checkoutDataSlice.clearData)());
    },
    setBillingCountry: function setBillingCountry(country) {
      return dispatch((0, _checkoutDataSlice.setBillingCountry)(country.toUpperCase()));
    },
    setShippingCountry: function setShippingCountry(country) {
      return dispatch((0, _checkoutDataSlice.setShippingCountry)(country.toUpperCase()));
    },
    shippingAddressSameAsBilling: shippingAddressSameAsBilling,
    setShippingAddressSameAsBilling: function setShippingAddressSameAsBilling(bool) {
      return dispatch((0, _checkoutDataSlice.setShippingAddressSameAsBilling)(bool));
    },
    setEmailConsentForDelivery: function setEmailConsentForDelivery(bool) {
      return dispatch((0, _checkoutDataSlice.setEmailConsentForDelivery)(bool));
    },
    additionalInformation: additionalInformation,
    emailConsentForDelivery: emailConsentForDelivery,
    setAdditionalInformation: function setAdditionalInformation(text) {
      return dispatch((0, _checkoutDataSlice.setAdditionalInformation)(text));
    },
    setAddressOnSubmit: setAddressOnSubmit,
    setEmail: function setEmail(email) {
      return dispatch((0, _checkoutDataSlice.setEmail)(email));
    },
    updateOrderId: updateOrderId,
    setBillingCountryFromCart: setBillingCountryFromCart
  };
};
var _default = useCheckoutData;
exports["default"] = _default;

/***/ }),

/***/ 63896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _reactRedux = __webpack_require__(71682);
var _shippingMethodsSlice = __webpack_require__(59591);
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(26367));
var useShippingMethods = function useShippingMethods() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.shippingMethods;
    }),
    shippingMethods = _useSelector.shippingMethods,
    selectedPickupPoint = _useSelector.selectedPickupPoint,
    pickedShippingMethod = _useSelector.pickedShippingMethod,
    pickupPoints = _useSelector.pickupPoints,
    selectedShippingMethod = _useSelector.selectedShippingMethod,
    loadingPickupPoints = _useSelector.loadingPickupPoints,
    loading = _useSelector.loading,
    inpostLockerChosen = _useSelector.inpostLockerChosen,
    dhlParcelChosen = _useSelector.dhlParcelChosen,
    shippingMethodsCountry = _useSelector.shippingMethodsCountry;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectShippingMethod = function selectShippingMethod(type) {
    dispatch((0, _shippingMethodsSlice.setShippingMethod)(type));
  };
  var updatePickupPoint = function updatePickupPoint(type) {
    dispatch((0, _shippingMethodsSlice.setPickupPoint)(type));
  };
  var updateInpost = function updateInpost(detail) {
    dispatch((0, _shippingMethodsSlice.setInpostLockerChosen)(detail));
  };
  var updateDhl = function updateDhl(detail) {
    dispatch((0, _shippingMethodsSlice.setDhlParcelChosen)(detail));
  };
  var updateShipping = function updateShipping(_ref) {
    var token = _ref.token,
      cartId = _ref.cartId;
    dispatch((0, _shippingMethodsSlice.fetchShippingMethods)({
      token: token,
      language: language,
      domain: domain,
      cartId: cartId,
      country: language
    }));
  };
  return {
    shippingMethods: shippingMethods,
    selectShippingMethod: selectShippingMethod,
    pickupPoints: pickupPoints,
    updatePickupPoint: updatePickupPoint,
    selectedPickupPoint: selectedPickupPoint,
    pickedShippingMethod: pickedShippingMethod,
    selectedShippingMethod: selectedShippingMethod,
    updateInpost: updateInpost,
    inpostLockerChosen: inpostLockerChosen,
    loadingPickupPoints: loadingPickupPoints,
    loading: loading,
    dhlParcelChosen: dhlParcelChosen,
    updateDhl: updateDhl,
    shippingMethodsCountry: shippingMethodsCountry,
    updateShipping: updateShipping
  };
};
var _default = useShippingMethods;
exports["default"] = _default;

/***/ }),

/***/ 37642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.requests = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _superagentPromise = _interopRequireDefault(__webpack_require__(27687));
var _superagent2 = _interopRequireDefault(__webpack_require__(84703));
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var superagent = (0, _superagentPromise["default"])(_superagent2["default"], __webpack_require__.g.Promise);
var handleErrors = function handleErrors(_ref) {
  var _err$response$status2, _err$response2;
  var err = _ref.err,
    url = _ref.url,
    language = _ref.language,
    elastic = _ref.elastic,
    _ref$isExternal = _ref.isExternal,
    isExternal = _ref$isExternal === void 0 ? false : _ref$isExternal;
  if (typeof window !== "undefined") {
    return err;
  }
  if (isExternal) {
    var _err$response$status, _err$response;
    console.error("Request error external url: ".concat((_err$response$status = err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) !== null && _err$response$status !== void 0 ? _err$response$status : JSON.stringify(err), ", url: ").concat(url));
  }
  var _ref2 = language !== null && language !== void 0 ? language : {},
    lang = _ref2.lang,
    domain = _ref2.domain;
  var directUrl = "".concat((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.elasticEndpointUrl, {
    lang: lang,
    domain: domain
  })).concat(url);
  if (!elastic) {
    directUrl = "".concat((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.restRootEndpointUrl, {
      lang: lang,
      domain: domain
    })).concat(url);
  }
  console.error("Request get errors status: ".concat((_err$response$status2 = err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status) !== null && _err$response$status2 !== void 0 ? _err$response$status2 : JSON.stringify(err), ", url: ").concat(directUrl, ", lang: ").concat(JSON.stringify(lang)));
  return err;
};
var responseBody = function responseBody(res) {
  return res.body;
};
var tokenPlugin = function tokenPlugin(req, token) {
  if (token) {
    req.set("Authorization", "Bearer ".concat(token));
  }
};
var requests = {
  del: function del(url, token, lang) {
    return superagent.del(requests.getUrl(url, false, lang)).withCredentials().use(function (req) {
      return tokenPlugin(req, token);
    }).then(responseBody);
  },
  get: function () {
    var _get = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
      var elastic,
        token,
        lang,
        request,
        res,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              elastic = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              token = _args.length > 2 ? _args[2] : undefined;
              lang = _args.length > 3 ? _args[3] : undefined;
              _context.prev = 3;
              request = superagent.get(requests.getUrl(url, elastic, lang)).withCredentials().use(function (req) {
                return tokenPlugin(req, token);
              });
              if (typeof window === "undefined") {
                request.set("User-Agent", "DAppRequester/1.0");
              }
              _context.next = 8;
              return request;
            case 8:
              res = _context.sent;
              return _context.abrupt("return", responseBody(res));
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              return _context.abrupt("return", handleErrors({
                err: _context.t0,
                url: url,
                language: lang,
                elastic: elastic
              }));
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));
    function get(_x) {
      return _get.apply(this, arguments);
    }
    return get;
  }(),
  put: function put(url, body, token, lang) {
    return superagent.put(requests.getUrl(url, false, lang), body).withCredentials().use(function (req) {
      return tokenPlugin(req, token);
    }).then(responseBody);
  },
  post: function post(url, body, token, lang) {
    return superagent.post(requests.getUrl(url, false, lang), body).withCredentials().use(function (req) {
      return tokenPlugin(req, token);
    }).then(responseBody);
  },
  putExternal: function putExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.put(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    }).then(responseBody);
  },
  postExternal: function postExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.post(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    }).then(responseBody);
  },
  delExternal: function delExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.del(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    });
  },
  getExternal: function getExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.get(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    }).withCredentials().then(responseBody);
  },
  getWithKey: function getWithKey(url, keyName, keyValue, query) {
    return superagent.get(url).query(query).set(keyName, keyValue).then(responseBody);
  },
  getUrl: function getUrl(url) {
    var elastic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var language = arguments.length > 2 ? arguments[2] : undefined;
    var lang = language.language,
      domain = language.domain;
    if (!elastic) {
      return "".concat((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.restRootEndpointUrl, {
        lang: lang,
        domain: domain
      })).concat(url);
    }
    return "".concat((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.elasticEndpointUrl, {
      lang: lang,
      domain: domain
    })).concat(url);
  }
};
exports.requests = requests;

/***/ }),

/***/ 79949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Image = {};
var imageProps = {
  allegroImage: _propTypes["default"].bool,
  arrangedImage: _propTypes["default"].bool,
  altText: _propTypes["default"].string,
  originalSrc: _propTypes["default"].string.isRequired,
  variants: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    aspectRatio: _propTypes["default"].number,
    srcset: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      url: _propTypes["default"].string,
      w: _propTypes["default"].number,
      h: _propTypes["default"].number
    }))
  })),
  id: _propTypes["default"].string
};
Image.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, imageProps[prop]));
  }, {})) : _propTypes["default"].shape(imageProps);
};
var _default = Image;
exports["default"] = _default;

/***/ }),

/***/ 71438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Product = {};
Product.LINK_TYPE = {
  UPSELL: "upsell"
};
var productProps = {
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].number,
  sku: _propTypes["default"].string.isRequired,
  labelText: _propTypes["default"].string,
  producer: _propTypes["default"].string,
  url: _propTypes["default"].string,
  price: _propTypes["default"].shape({
    regular: _propTypes["default"].number.isRequired,
    special: _propTypes["default"].number,
    lowest: _propTypes["default"].number,
    discountFromTotals: _propTypes["default"].number
  }),
  collection: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    url: _propTypes["default"].string,
    id: _propTypes["default"].string
  }),
  relatedProducts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    linkType: _propTypes["default"].string,
    sku: _propTypes["default"].string
  })),
  logo: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    src: _propTypes["default"].array
  }),
  info: _propTypes["default"].shape({
    description: _propTypes["default"].string,
    shortDescription: _propTypes["default"].string,
    technicalData: _propTypes["default"].arrayOf(_propTypes["default"].object)
  }),
  availability: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    level: _propTypes["default"].string,
    stock: _propTypes["default"].string
  }),
  category: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    ids: _propTypes["default"].arrayOf(_propTypes["default"].number),
    parentId: _propTypes["default"].string
  }),
  images: _propTypes["default"].arrayOf(_propTypes["default"].object),
  image: _propTypes["default"].object.isRequired,
  pickedOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    attribute_code: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })),
  otherVariants: _propTypes["default"].array,
  isNew: _propTypes["default"].bool
};
Product.AVAILABILITY = {
  OUT_OF_STOCK: 117,
  LOW_AVAILABILITY: 118
};
Product.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, productProps[prop]));
  }, {})) : _propTypes["default"].shape(productProps);
};
var _default = Product;
exports["default"] = _default;

/***/ }),

/***/ 98903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.setHost = exports.appConfigurationSlice = void 0;
var _toolkit = __webpack_require__(33076);
var initialState = {
  domain: null,
  language: null,
  host: null
};
var appConfigurationSlice = (0, _toolkit.createSlice)({
  name: "appConfiguration",
  initialState: initialState,
  reducers: {
    setHost: function setHost(state, action) {
      var host = action.payload.host;
      state.host = host;
      state.language = __webpack_require__.g.__appConfig__.domainLanguages[host] || "pl";
      state.domain = Object.keys(__webpack_require__.g.__appConfig__.domainLanguages).find(function (key) {
        return key === host;
      });
    },
    changeLanguage: function changeLanguage(state, action) {
      var language = action.payload.language;
      var domains = __webpack_require__.g.__appConfig__.domainLanguages;
      var domain = Object.keys(domains).find(function (key) {
        return domains[key] === language;
      });
      window.location.href = "http://".concat(domain);
    }
  }
});
exports.appConfigurationSlice = appConfigurationSlice;
var setHost = appConfigurationSlice.actions.setHost;
exports.setHost = setHost;
var _default = appConfigurationSlice.reducer;
exports["default"] = _default;

/***/ }),

/***/ 26367:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _reactRedux = __webpack_require__(71682);
var useAppConfiguration = function useAppConfiguration() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.appConfiguration;
    }),
    domain = _useSelector.domain,
    language = _useSelector.language,
    host = _useSelector.host;
  return {
    domain: domain,
    language: language,
    host: host
  };
};
var _default = useAppConfiguration;
exports["default"] = _default;

/***/ }),

/***/ 70071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.clearData = exports.setOrder = exports.setAddresses = exports.setShippingAddress = exports.setBillingAddress = exports.setEmail = exports.setShippingAddressSameAsBilling = exports.setBillingCountry = exports.setShippingCountry = exports.setEmailConsentForDelivery = exports.setAdditionalInformation = exports["default"] = exports.checkoutDataSlice = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _toolkit = __webpack_require__(33076);
var _excluded = ["save_in_address_book", "isParcel", "isLocker", "email"],
  _excluded2 = ["email"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var emptyAddress = {
  firstName: "",
  lastName: "",
  street: "",
  city: "",
  postalCode: "",
  country: {
    id: null
  },
  phone: "",
  isCompany: false,
  companyName: "",
  vatId: ""
};
var addCompany = function addCompany(address) {
  var _address$isCompany = address.isCompany,
    isCompany = _address$isCompany === void 0 ? false : _address$isCompany,
    _address$vatId = address.vatId,
    vatId = _address$vatId === void 0 ? "" : _address$vatId,
    _address$companyName = address.companyName,
    companyName = _address$companyName === void 0 ? "" : _address$companyName;
  if (vatId && companyName) {
    isCompany = true;
  }
  return _objectSpread(_objectSpread({}, address), {}, {
    isCompany: isCompany ? isCompany : false,
    vatId: vatId ? vatId : ""
  });
};
var initialState = {
  email: "",
  shippingAddressSameAsBilling: true,
  billingAddress: emptyAddress,
  shippingAddress: emptyAddress,
  emailConsentForDelivery: false,
  additionalInformation: "",
  orderId: null
};
var setCheckoutData = (0, _toolkit.createAction)("checkout/setCheckoutData");
var checkoutDataSlice = (0, _toolkit.createSlice)({
  name: "checkoutFormData",
  initialState: initialState,
  reducers: {
    clearData: function clearData(state, action) {
      Object.keys(initialState).forEach(function (key) {
        state[key] = initialState[key];
      });
    },
    setBillingCountry: function setBillingCountry(state, action) {
      state.billingAddress.country.id = action.payload;
    },
    setShippingCountry: function setShippingCountry(state, action) {
      state.shippingAddress.country.id = action.payload;
    },
    setBillingAddress: function setBillingAddress(state, action) {
      state.billingAddress = action.payload;
    },
    setShippingAddress: function setShippingAddress(state, action) {
      state.shippingAddress = action.payload;
    },
    setShippingAddressSameAsBilling: function setShippingAddressSameAsBilling(state, action) {
      state.shippingAddressSameAsBilling = action.payload;
    },
    setEmailConsentForDelivery: function setEmailConsentForDelivery(state, action) {
      state.emailConsentForDelivery = action.payload;
    },
    setAdditionalInformation: function setAdditionalInformation(state, action) {
      state.additionalInformation = action.payload;
    },
    setEmail: function setEmail(state, action) {
      state.email = action.payload;
    },
    setOrder: function setOrder(state, action) {
      state.orderId = action.payload;
    },
    setAddresses: function setAddresses(state, action) {
      var _action$payload = action.payload,
        billingAddress = _action$payload.billingAddress,
        shippingAddress = _action$payload.shippingAddress,
        email = _action$payload.email;
      var save_in_address_book = shippingAddress.save_in_address_book,
        isParcel = shippingAddress.isParcel,
        isLocker = shippingAddress.isLocker,
        emailShipping = shippingAddress.email,
        shippingAddressWithoutEmail = (0, _objectWithoutProperties2["default"])(shippingAddress, _excluded);
      var emailBilling = billingAddress.email,
        billingAddressWithoutEmail = (0, _objectWithoutProperties2["default"])(billingAddress, _excluded2);
      state.email = email;
      state.billingAddress = addCompany(billingAddressWithoutEmail);
      state.shippingAddress = addCompany(shippingAddressWithoutEmail);
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(setCheckoutData, function (state, action) {
      var _action$payload2 = action.payload,
        email = _action$payload2.email,
        shipping = _action$payload2.shipping,
        billing = _action$payload2.billing;
      state.email = email;
      state.billingAddress = billing;
      state.shippingAddress = shipping;
    });
  }
});
exports.checkoutDataSlice = checkoutDataSlice;
var _default = checkoutDataSlice.reducer;
exports["default"] = _default;
var _checkoutDataSlice$ac = checkoutDataSlice.actions,
  setAdditionalInformation = _checkoutDataSlice$ac.setAdditionalInformation,
  setEmailConsentForDelivery = _checkoutDataSlice$ac.setEmailConsentForDelivery,
  setShippingCountry = _checkoutDataSlice$ac.setShippingCountry,
  setBillingCountry = _checkoutDataSlice$ac.setBillingCountry,
  setShippingAddressSameAsBilling = _checkoutDataSlice$ac.setShippingAddressSameAsBilling,
  setEmail = _checkoutDataSlice$ac.setEmail,
  setBillingAddress = _checkoutDataSlice$ac.setBillingAddress,
  setShippingAddress = _checkoutDataSlice$ac.setShippingAddress,
  setAddresses = _checkoutDataSlice$ac.setAddresses,
  setOrder = _checkoutDataSlice$ac.setOrder,
  clearData = _checkoutDataSlice$ac.clearData;
exports.clearData = clearData;
exports.setOrder = setOrder;
exports.setAddresses = setAddresses;
exports.setShippingAddress = setShippingAddress;
exports.setBillingAddress = setBillingAddress;
exports.setEmail = setEmail;
exports.setShippingAddressSameAsBilling = setShippingAddressSameAsBilling;
exports.setBillingCountry = setBillingCountry;
exports.setShippingCountry = setShippingCountry;
exports.setEmailConsentForDelivery = setEmailConsentForDelivery;
exports.setAdditionalInformation = setAdditionalInformation;

/***/ }),

/***/ 31648:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setShippingCountriesAvailable = exports.setCountriesFromLocalStorage = exports["default"] = exports.fetchCountriesShipping = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _toolkit = __webpack_require__(33076);
var _mapAvailableCountries = _interopRequireDefault(__webpack_require__(25037));
var initialState = {
  countries: null,
  shippingCountriesAvailable: null,
  loading: false,
  error: ""
};
var fetchCountriesShipping = (0, _toolkit.createAsyncThunk)("shipping/getCountries", /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arg) {
    var language, domain;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            language = arg.language, domain = arg.domain;
            _context.next = 3;
            return _agent.requests.get("/directory/countries", false, null, {
              language: language,
              domain: domain
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
exports.fetchCountriesShipping = fetchCountriesShipping;
var countriesShipping = (0, _toolkit.createSlice)({
  name: "countriesShipping",
  initialState: initialState,
  reducers: {
    setCountriesFromLocalStorage: function setCountriesFromLocalStorage(state, action) {
      state.countries = action.payload;
    },
    setShippingCountriesAvailable: function setShippingCountriesAvailable(state, action) {
      state.shippingCountriesAvailable = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchCountriesShipping.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(fetchCountriesShipping.fulfilled, function (state, action) {
      var _localStorage;
      state.loading = false;
      var mappedCountries = (0, _mapAvailableCountries["default"])(action.payload);
      (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem("availableCountries", JSON.stringify(mappedCountries));
      state.countries = mappedCountries;
    });
    builder.addCase(fetchCountriesShipping.rejected, function (state, action) {
      state.loading = false;
      state.error = action.error.message;
    });
  }
});
var _default = countriesShipping.reducer;
exports["default"] = _default;
var _countriesShipping$ac = countriesShipping.actions,
  setCountriesFromLocalStorage = _countriesShipping$ac.setCountriesFromLocalStorage,
  setShippingCountriesAvailable = _countriesShipping$ac.setShippingCountriesAvailable;
exports.setShippingCountriesAvailable = setShippingCountriesAvailable;
exports.setCountriesFromLocalStorage = setCountriesFromLocalStorage;

/***/ }),

/***/ 88656:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.clearData = exports.setSortedPayments = exports.setClearAdyenData = exports.setPaymentMethod = exports.getAdyenPaymentMethods = exports.setPaymentWithTotals = exports.getPaymentMethods = exports.paymentMethodsSlice = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _toolkit = __webpack_require__(33076);
var _agent = __webpack_require__(37642);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var initialState = {
  availablePaymentMethodsMagento: null,
  sortedPayments: null,
  pickedPaymentMethod: null,
  adyenResponse: null,
  error: null,
  paymentTotals: null
};
var mapPaymentMethods = function mapPaymentMethods(paymentMethods) {
  var mappedPaymentMethods = paymentMethods.map(function (method) {
    return {
      id: method.code,
      label: method.title
    };
  });
  var freePayment = mappedPaymentMethods.filter(function (payment) {
    return payment.id === __webpack_require__.g.__appConfig__.paymentMethodFree;
  });
  return freePayment.length > 0 ? freePayment : mappedPaymentMethods;
};
var getPaymentMethods = (0, _toolkit.createAsyncThunk)("payment/getPaymentMethods", /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arg) {
    var token, language, domain, cartId;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = arg.token, language = arg.language, domain = arg.domain, cartId = arg.cartId;
            if (!token) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", _agent.requests.get("/carts/mine/payment-information", false, token, {
              domain: domain,
              language: language
            }));
          case 3:
            return _context.abrupt("return", _agent.requests.get("/guest-carts/".concat(cartId, "/payment-information"), false, null, {
              language: language,
              domain: domain
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
exports.getPaymentMethods = getPaymentMethods;
var getAdyenPaymentMethods = (0, _toolkit.createAsyncThunk)("payment/getAdyenPaymentMethods", /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(arg) {
    var token, language, domain, cartId;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            token = arg.token, language = arg.language, domain = arg.domain, cartId = arg.cartId;
            if (!token) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", _agent.requests.post("/carts/mine/retrieve-adyen-payment-methods", {
              cart_id: cartId
            }, __webpack_require__.g.__appConfig__.adyenMagentoIntegrationToken, {
              language: language,
              domain: domain
            }));
          case 3:
            return _context2.abrupt("return", _agent.requests.post("/guest-carts/".concat(cartId, "/retrieve-adyen-payment-methods"), null, __webpack_require__.g.__appConfig__.adyenMagentoIntegrationToken, {
              language: language,
              domain: domain
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
exports.getAdyenPaymentMethods = getAdyenPaymentMethods;
var mappedPaymentTotals = function mappedPaymentTotals(totals) {
  return {
    shippingCost: totals.base_shipping_incl_tax,
    productsTotalPrice: totals.subtotal_incl_tax,
    discount: totals.discount_amount,
    cartTotalPrice: totals.base_grand_total,
    tax: totals.base_tax_amount
  };
};
var setPaymentWithTotals = (0, _toolkit.createAsyncThunk)("payment/getPaymentWithTotals", /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(arg) {
    var token, language, domain, cartId, body, url;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            token = arg.token, language = arg.language, domain = arg.domain, cartId = arg.cartId, body = arg.body;
            url = token ? __webpack_require__.g.__appConfig__.setPaymentGetTotalsCustomerUrl : (0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.setPaymentGetTotalsGuestUrl, {
              cartId: cartId
            });
            _context3.next = 4;
            return _agent.requests.post(url, body, token, {
              language: language,
              domain: domain
            });
          case 4:
            return _context3.abrupt("return", _context3.sent);
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}());
exports.setPaymentWithTotals = setPaymentWithTotals;
var paymentMethodsSlice = (0, _toolkit.createSlice)({
  name: "paymentMethods",
  initialState: initialState,
  reducers: {
    setPaymentMethod: function setPaymentMethod(state, action) {
      state.pickedPaymentMethod = action.payload;
    },
    setClearAdyenData: function setClearAdyenData(state, action) {
      state.adyenResponse = null;
      state.sortedPayments = null;
    },
    setSortedPayments: function setSortedPayments(state, action) {
      state.sortedPayments = action.payload;
    },
    clearData: function clearData(state, action) {
      Object.keys(initialState).forEach(function (key) {
        state[key] = initialState[key];
      });
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getPaymentMethods.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(getPaymentMethods.fulfilled, function (state, action) {
      state.loading = false;
      state.availablePaymentMethodsMagento = action.payload.payment_methods ? mapPaymentMethods(action.payload.payment_methods) : [];
    });
    builder.addCase(getPaymentMethods.rejected, function (state, action) {
      state.loading = false;
      state.error = JSON.parse(action.error.message).message;
    });
    builder.addCase(getAdyenPaymentMethods.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(getAdyenPaymentMethods.fulfilled, function (state, action) {
      state.loading = false;
      var responseParsed = JSON.parse(action.payload);
      state.adyenResponse = responseParsed;
    });
    builder.addCase(getAdyenPaymentMethods.rejected, function (state, action) {
      state.loading = false;
      state.error = JSON.parse(action.error.message).message;
      state.adyenResponse = [];
    });
    builder.addCase(setPaymentWithTotals.pending, function (state) {
      state.loading = true;
      state.paymentTotals = null;
    });
    builder.addCase(setPaymentWithTotals.fulfilled, function (state, action) {
      state.loading = false;
      state.paymentTotals = mappedPaymentTotals(action.payload);
    });
    builder.addCase(setPaymentWithTotals.rejected, function (state, action) {
      state.loading = false;
      state.error = JSON.parse(action.error.message).message;
    });
  }
});
exports.paymentMethodsSlice = paymentMethodsSlice;
var _paymentMethodsSlice$ = paymentMethodsSlice.actions,
  setPaymentMethod = _paymentMethodsSlice$.setPaymentMethod,
  setClearAdyenData = _paymentMethodsSlice$.setClearAdyenData,
  setSortedPayments = _paymentMethodsSlice$.setSortedPayments,
  clearData = _paymentMethodsSlice$.clearData;
exports.clearData = clearData;
exports.setSortedPayments = setSortedPayments;
exports.setClearAdyenData = setClearAdyenData;
exports.setPaymentMethod = setPaymentMethod;
var _default = paymentMethodsSlice.reducer;
exports["default"] = _default;

/***/ }),

/***/ 59591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.clearData = exports.resetError = exports.setShippingMethodsCountry = exports.setInpostLockerChosen = exports.setPickupPoint = exports.setShippingMethod = exports.setDhlParcelChosen = exports["default"] = exports.fetchPickupPoints = exports.fetchShippingMethods = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _toolkit = __webpack_require__(33076);
var _mapShippingMethods = _interopRequireDefault(__webpack_require__(9745));
var _mapPickupPoints = _interopRequireDefault(__webpack_require__(861));
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var inpostLockerChosenDefault = {
  status: false,
  locker: {
    name: null,
    street: null,
    city: null,
    postcode: null
  }
};
var dhlLockerChosenDefault = {
  name: null,
  street: null,
  city: null,
  postcode: null
};
var initialState = {
  shippingMethods: null,
  pickupPoints: null,
  selectedPickupPoint: null,
  selectedShippingMethod: null,
  loadingPickupPoints: false,
  pickupPointsLoaded: false,
  loadingShippingMethods: false,
  inpostLockerChosen: inpostLockerChosenDefault,
  dhlParcelChosen: null,
  shippingMethodsCountry: null
};

///fetchShippingMethods odsiwezamy obecnie w cart gdy zmienia sie, [getCartId(), token, cart?.items]

var fetchShippingMethods = (0, _toolkit.createAsyncThunk)("shipping/getShippingMethods", /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arg, thunkApi) {
    var cartId, language, domain, token, country, url, address;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cartId = arg.cartId, language = arg.language, domain = arg.domain, token = arg.token, country = arg.country;
            url = "/guest-carts/".concat(cartId, "/estimate-shipping-methods");
            if (token) {
              url = "/carts/mine/estimate-shipping-methods";
            }
            address = {
              country_id: country.toUpperCase()
            };
            return _context.abrupt("return", _agent.requests.post(url, {
              address: address
            }, token, {
              language: language,
              domain: domain
            }).then(function (response) {
              return response;
            })["catch"](function (error) {
              return thunkApi.rejectWithValue(error);
            }));
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
exports.fetchShippingMethods = fetchShippingMethods;
var fetchPickupPoints = (0, _toolkit.createAsyncThunk)("checkout/getPickupPoints", /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(arg, thunkApi) {
    var language, domain, token;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            language = arg.language, domain = arg.domain, token = arg.token;
            return _context2.abrupt("return", _agent.requests.get((0, _createParametrizedUrl["default"])("/deosite/shipping/pickup-points", {
              lang: language
            }), false, token, {
              language: language,
              domain: domain
            }).then(function (response) {
              return response;
            })["catch"](function (error) {
              var _error$response;
              return thunkApi.rejectWithValue((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || error);
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
exports.fetchPickupPoints = fetchPickupPoints;
var shippingMethods = (0, _toolkit.createSlice)({
  name: "shippingMethods",
  initialState: initialState,
  reducers: {
    setShippingMethod: function setShippingMethod(state, action) {
      state.selectedShippingMethod = action.payload;
    },
    setPickupPoint: function setPickupPoint(state, action) {
      state.selectedPickupPoint = action.payload;
    },
    setInpostLockerChosen: function setInpostLockerChosen(state, action) {
      state.inpostLockerChosen = action.payload ? action.payload : inpostLockerChosenDefault;
    },
    setDhlParcelChosen: function setDhlParcelChosen(state, action) {
      state.dhlParcelChosen = action.payload ? action.payload : dhlLockerChosenDefault;
    },
    setShippingMethodsCountry: function setShippingMethodsCountry(state, action) {
      state.shippingMethodsCountry = action.payload;
    },
    resetError: function resetError(state) {
      state.error = null;
    },
    clearData: function clearData(state, action) {
      Object.keys(initialState).forEach(function (key) {
        state[key] = initialState[key];
      });
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchShippingMethods.pending, function (state) {
      state.loadingShippingMethods = true;
    });
    builder.addCase(fetchShippingMethods.fulfilled, function (state, action) {
      state.loadingShippingMethods = false;
      state.shippingMethods = (0, _mapShippingMethods["default"])(action.payload.filter(function (method) {
        return method.available;
      }));
    });
    builder.addCase(fetchShippingMethods.rejected, function (state, action) {
      state.loadingShippingMethods = false;
      state.error = action.payload;
    });
    builder.addCase(fetchPickupPoints.pending, function (state) {
      state.loadingPickupPoints = true;
    });
    builder.addCase(fetchPickupPoints.fulfilled, function (state, action) {
      state.loadingPickupPoints = false;
      state.pickupPoints = (0, _mapPickupPoints["default"])(action.payload); //mapPickupPoints(action.payload);
      state.pickupPointsLoaded = true;
    });
    builder.addCase(fetchPickupPoints.rejected, function (state, action) {
      state.loadingPickupPoints = false;
      state.error = action.error.message;
    });
  }
});
var _default = shippingMethods.reducer;
exports["default"] = _default;
var _shippingMethods$acti = shippingMethods.actions,
  setDhlParcelChosen = _shippingMethods$acti.setDhlParcelChosen,
  setShippingMethod = _shippingMethods$acti.setShippingMethod,
  setPickupPoint = _shippingMethods$acti.setPickupPoint,
  setInpostLockerChosen = _shippingMethods$acti.setInpostLockerChosen,
  setShippingMethodsCountry = _shippingMethods$acti.setShippingMethodsCountry,
  resetError = _shippingMethods$acti.resetError,
  clearData = _shippingMethods$acti.clearData;
exports.clearData = clearData;
exports.resetError = resetError;
exports.setShippingMethodsCountry = setShippingMethodsCountry;
exports.setInpostLockerChosen = setInpostLockerChosen;
exports.setPickupPoint = setPickupPoint;
exports.setShippingMethod = setShippingMethod;
exports.setDhlParcelChosen = setDhlParcelChosen;

/***/ }),

/***/ 57048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.setAddress = exports.getUserData = exports.userSlice = void 0;
var _toolkit = __webpack_require__(33076);
var _agent = __webpack_require__(37642);
var _mapAddressesCollection = _interopRequireDefault(__webpack_require__(33074));
var initialState = {
  firstName: "",
  lastName: "",
  email: "",
  addresses: [],
  orders: [],
  loading: false,
  ePoints: 0,
  checkoutAddress: null
};
var getUserData = (0, _toolkit.createAsyncThunk)("user/getUserData", function (arg) {
  var token = arg.token,
    language = arg.language;
  return _agent.requests.get(__webpack_require__.g.__appConfig__.customerDataUrl, false, token, language);
});
exports.getUserData = getUserData;
var userSlice = (0, _toolkit.createSlice)({
  name: "user",
  initialState: initialState,
  reducers: {
    setAddress: function setAddress(state, action) {
      state.checkoutAddress = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getUserData.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(getUserData.fulfilled, function (state, action) {
      state.loading = false;
      state.email = action.payload.email;
      state.addresses = (0, _mapAddressesCollection["default"])(action.payload);
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.ePoints = action.payload.extension_attributes.rewardpoints_balance;
    });
  }
});
exports.userSlice = userSlice;
var setAddress = userSlice.actions.setAddress;
exports.setAddress = setAddress;
var _default = userSlice.reducer;
exports["default"] = _default;

/***/ }),

/***/ 37489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _reactRedux = __webpack_require__(71682);
var _store = __webpack_require__(36789);
var _appConfigurationSlice = __webpack_require__(98903);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var StoreProvider = function StoreProvider(_ref) {
  var language = _ref.language,
    children = _ref.children;
  var storeRef = (0, _react.useRef)();
  if (!storeRef.current) {
    storeRef.current = (0, _store.makeStore)();
    storeRef.current.dispatch((0, _appConfigurationSlice.setHost)(language));
  }
  return __jsx(_reactRedux.Provider, {
    store: storeRef.current
  }, children);
};
var _default = StoreProvider;
exports.Z = _default;

/***/ }),

/***/ 36789:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.makeStore = void 0;
var _reduxThunk = __webpack_require__(24759);
var _toolkit = __webpack_require__(33076);
var _userSlice = _interopRequireDefault(__webpack_require__(57048));
var _appConfigurationSlice = _interopRequireDefault(__webpack_require__(98903));
var _paymentMethodsSlice = _interopRequireDefault(__webpack_require__(88656));
var _shippingMethodsSlice = _interopRequireDefault(__webpack_require__(59591));
var _checkoutDataSlice = _interopRequireDefault(__webpack_require__(70071));
var _countriesShippingSlice = _interopRequireDefault(__webpack_require__(31648));
var makeStore = function makeStore(context) {
  return (0, _toolkit.configureStore)({
    reducer: {
      user: _userSlice["default"],
      paymentMethods: _paymentMethodsSlice["default"],
      appConfiguration: _appConfigurationSlice["default"],
      shippingMethods: _shippingMethodsSlice["default"],
      checkoutData: _checkoutDataSlice["default"],
      countriesShipping: _countriesShippingSlice["default"]
    },
    middleware: function middleware() {
      return [_reduxThunk.thunk];
    }
  });
};
exports.makeStore = makeStore;

/***/ }),

/***/ 35865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _RouteContext = __webpack_require__(73157);
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var __jsx = _react["default"].createElement;
var NextIcon = function NextIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.117 13.438l-6.542 6.99.876.82 7.87-8.41-7.87-8.41-.876.82 6.542 6.99H3.5v1.2h15.617z"
  }));
};
NextIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CheckoutSteps = function CheckoutSteps(props) {
  var steps = props.steps,
    activeStep = props.activeStep,
    _props$font = props.font,
    font = _props$font === void 0 ? "body2" : _props$font;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var stepsNumber = steps.length;
  return __jsx(_Box["default"], {
    sx: {
      font: font,
      color: "main",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center"
    }
  }, steps.map(function (step, index) {
    return __jsx(_Box["default"], {
      sx: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      key: "steps" + index
    }, index < activeStep ? __jsx(Link, {
      route: step.route
    }, __jsx(_LinkRaw["default"], {
      title: step.text
    }, __jsx(_Box["default"], {
      as: "span",
      sx: {
        color: "main",
        cursor: "pointer",
        textDecoration: "underline"
      }
    }, step.text))) : __jsx(_Box["default"], {
      as: "span",
      sx: {
        color: index == activeStep ? "active" : "neutral700"
      }
    }, step.text), index < stepsNumber - 1 && __jsx(_Box["default"], {
      as: "span",
      sx: {
        display: "flex",
        alignItems: "center",
        mx: "s6",
        svg: {
          transform: "scaleX(0.5) scaleY(0.5)"
        }
      }
    }, __jsx(NextIcon, null)));
  }));
};
var _default = CheckoutSteps;
exports["default"] = _default;

/***/ }),

/***/ 4189:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _CookieAgreementsProvider = __webpack_require__(2616);
var _LanguageProvider = __webpack_require__(8989);
var _useDebounce = _interopRequireDefault(__webpack_require__(25686));
var _setAgreementsCookie = _interopRequireDefault(__webpack_require__(56260));
var _router = __webpack_require__(53746);
var _useLoader2 = __webpack_require__(87573);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var CookieContainer = function CookieContainer(_ref) {
  var cookieNotice = _ref.cookieNotice,
    cookiesPanel = _ref.cookiesPanel;
  var _useState = (0, _react.useState)(false),
    showPanel = _useState[0],
    setShowPanel = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    showImportComponent = _useState2[0],
    setShowImportComponent = _useState2[1];
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var router = (0, _router.useRouter)();
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements,
    setCookieAgreements = _useCookieAgreements.setCookieAgreements,
    analyticsID = _useCookieAgreements.analyticsID,
    gtmID = _useCookieAgreements.gtmID,
    fbID = _useCookieAgreements.fbID;
  var _useLoader = (0, _useLoader2.useLoader)(),
    setCookieNoticeLoaded = _useLoader.setCookieNoticeLoaded;
  var _useState3 = (0, _react.useState)(-1),
    displayedElement = _useState3[0],
    setDisplayedElement = _useState3[1];
  (0, _react.useEffect)(function () {
    setDisplayedElement(cookieAgreements ? -1 : 1);
  }, [cookieAgreements]);
  var domain = language.domain.split(".");
  var domainForTranslation = "".concat(domain[0].toUpperCase(), ".").concat(domain[1]);
  var cookieInfo = /*#__PURE__*/_react["default"].cloneElement(cookieNotice, {
    onAcceptButtonClick: function onAcceptButtonClick() {
      return setAllAgreementsTrue();
    },
    onManageOptionsButtonClick: function onManageOptionsButtonClick() {
      setShowPanel(true);
    },
    domain: domainForTranslation
  });
  var setAllAgreementsTrue = function setAllAgreementsTrue() {
    (0, _setAgreementsCookie["default"])({
      agreements: true,
      language: language,
      cookieAgreements: {
        setCookieAgreements: setCookieAgreements,
        analyticsID: analyticsID,
        gtmID: gtmID,
        fbID: fbID
      }
    });
  };
  var importComponentsDebounce = (0, _useDebounce["default"])(parseInt(__webpack_require__.g.__appConfig__.cookieContainerLoadTimeout), function () {
    setShowImportComponent(true);
    setCookieNoticeLoaded(true);
  });
  var importComponent = function importComponent(show) {
    var CookiesPanel = cookiesPanel;
    return __jsx(_react["default"].Fragment, null, __jsx(CookiesPanel, {
      showPanel: show,
      setShowPanel: setShowPanel,
      domain: domainForTranslation
    }));
  };
  var panel = __jsx(_react["default"].Fragment, null, typeof window !== "undefined" && !cookieAgreements && !showPanel && __jsx(_Container["default"], {
    sx: {
      pb: 20
    }
  }, cookieInfo), showImportComponent ? importComponent(showPanel) : importComponentsDebounce());
  var noBackground = __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: 0,
      zIndex: 999
    }
  }, panel);
  var background = __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      bg: "rgba(0, 0, 0, 0.3)",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: !cookieAgreements && displayedElement === 1 ? "flex" : "none",
      alignItems: "flex-end",
      zIndex: 999
    }
  }, panel);
  return __jsx(_Box["default"], null, !cookieAgreements && router.pathname === "/info/[info]" ? noBackground : background);
};
var _default = CookieContainer;
exports.Z = _default;

/***/ }),

/***/ 81481:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _core = __webpack_require__(79329);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _router = __webpack_require__(53746);
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _LanguageProvider = __webpack_require__(8989);
var _RouteContext = __webpack_require__(73157);
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(__webpack_require__(36229));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var textToShow = function textToShow(infoText, showMore) {
  var isTextTooLong = !infoText.length <= __webpack_require__.g.__appConfig__.cookieNoticeMaxLength;
  return isTextTooLong ? "".concat(infoText.slice(0, __webpack_require__.g.__appConfig__.cookieNoticeMaxLength) + "\u2026 <span>".concat(showMore, "</span>")) : infoText;
};
var CookieNotice = function CookieNotice(props) {
  var onAcceptButtonClick = props.onAcceptButtonClick,
    onManageOptionsButtonClick = props.onManageOptionsButtonClick,
    confirmButton = props.confirmButton,
    manageButton = props.manageButton,
    domain = props.domain;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    acceptAllCookies: (0, _langLibrary["default"])("Accept all cookies"),
    cookiesPanelTitle: (0, _langLibrary["default"])("Manage cookie settings"),
    cookieNotice: (0, _langLibrary["default"])("Cookie notice", {
      domain: domain
    }),
    showMore: (0, _langLibrary["default"])("show more")
  };
  var router = (0, _router.useRouter)();
  var infoText = translations.cookieNotice;
  var manageOptionsButtonLabel = translations.cookiesPanelTitle;
  var _useState = (0, _react.useState)(null),
    text = _useState[0],
    setText = _useState[1];
  (0, _react.useEffect)(function () {
    setText(textToShow(infoText, translations.showMore));
  }, []);
  var confirmButtonDisplay = /*#__PURE__*/_react["default"].cloneElement(confirmButton, {
    onClick: onAcceptButtonClick
  }, translations.acceptAllCookies);
  var manageButtonDisplay = /*#__PURE__*/_react["default"].cloneElement(manageButton, {
    onClick: onManageOptionsButtonClick
  }, translations.cookiesPanelTitle);
  return __jsx(_Box["default"], {
    sx: {
      background: "white",
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 4px 16px",
      borderRadius: "5px",
      p: (0, _core.lin)("s8", "s9"),
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      justifyContent: "space-between"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "body2",
      maxHeight: "60vh",
      overflow: ["scroll", null, null, "hidden"],
      maxWidth: ["100%", null, null, "80%", "85%", "90%"],
      pr: [null, null, null, "s5", null, null],
      "-webkit-text-size-adjust": "100%",
      color: "main",
      a: {
        color: "active",
        ":focus": {
          outline: "none"
        }
      },
      span: {
        color: "active",
        cursor: "pointer"
      }
    }
  }, __jsx(_Box["default"], {
    onClick: function onClick(e) {
      e.preventDefault();
      var link = e.target.getAttribute("href");
      if (link) router.push(link);
      setText(infoText);
    },
    as: "p",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), (0, _hasStoreAdditionalFunctionalities["default"])(language) && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      mt: 20,
      a: {
        color: "main",
        textDecoration: "underline",
        font: "xs"
      }
    }
  }, __jsx(Link, {
    href: "/info/privacy"
  }, __jsx(_LinkRaw["default"], {
    title: "Datenschutzerklärung"
  }, "Datenschutzerklärung")), __jsx(_Box["default"], {
    sx: {
      margin: "2px 10px 0 10px",
      height: 15,
      borderLeftStyle: "solid",
      borderLeftColor: "black",
      borderLeftWidth: "1px"
    }
  }), __jsx(Link, {
    href: "/info/impressum"
  }, __jsx(_LinkRaw["default"], {
    title: "Impressum"
  }, "Impressum")))), __jsx(_Box["default"], {
    sx: {
      textAlign: "right",
      display: "flex",
      flexDirection: ["column", "row", null, "column", null, null],
      alignItems: ["center", null, "stretch"],
      justifyContent: "center",
      mt: ["s8", null, null, "s0", null, null]
    }
  }, confirmButtonDisplay, manageOptionsButtonLabel && manageButtonDisplay));
};
var _default = CookieNotice;
exports.Z = _default;

/***/ }),

/***/ 90451:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ROUNDNESS = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _image = _interopRequireDefault(__webpack_require__(83136));
var _core = __webpack_require__(79329);
var _blurhash = __webpack_require__(51654);
var _arrayToImage = __webpack_require__(6340);
var _generateBlurUrl = _interopRequireDefault(__webpack_require__(63424));
var _Image = _interopRequireDefault(__webpack_require__(79949));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var addCloudflareToUrl = function addCloudflareToUrl(url, width, quality, cloudflareEnabled) {
  var imgQuality = quality ? "quality=" + quality + "," : "";
  if (url.includes("$width")) {
    var newUrl = url.replace(/^https?:\/\/[^#?\/]+/, "");
    return "https://".concat(__webpack_require__.g.__appConfig__.imageServer).concat(newUrl.replace(/\$width/, width));
  }
  return url.indexOf("static/") > 0 ? url : isCloudflareDisabled(cloudflareEnabled) ? "".concat(__webpack_require__.g.__appConfig__.dajarmediaImgUrl).concat(url.replace(/^https?:\/\/[^#?\/]+/, "")) : "".concat(__webpack_require__.g.__appConfig__.cloudflareImgUrl, "width=").concat(width, ",") + imgQuality + "format=auto".concat(url.replace(/^https?:\/\/[^#?\/]+/, ""));
};
var isCloudflareDisabled = function isCloudflareDisabled(cloudflareEnabled) {
  return parseInt(__webpack_require__.g.__appConfig__.cloudflareForceDisable) ? __webpack_require__.g.__appConfig__.cloudflareForceDisable : cloudflareEnabled === undefined || !parseInt(cloudflareEnabled);
};
var findVariant = function findVariant(image, variant) {
  return image.variants.find(function (v) {
    return v.name === variant;
  });
};
var ROUNDNESS = {
  soft: "15px",
  medium: "25px",
  hard: "30px",
  none: "0px"
};
exports.ROUNDNESS = ROUNDNESS;
Object.freeze(ROUNDNESS);
var defaultProps = {
  overlay: false,
  roundness: ROUNDNESS.none,
  minified: false,
  borderSpace: "false",
  position: "center center",
  overlayOpacity: 0.03,
  overlayColor: "black",
  localImgSrc: false,
  borderWidth: 1,
  staticImage: false
};
var Image = function Image(props) {
  var _image$originalSrc, _sx$variant, _image$altText, _image$altText2;
  var _props$overlay = props.overlay,
    overlay = _props$overlay === void 0 ? defaultProps.overlay : _props$overlay,
    _props$overlayOpacity = props.overlayOpacity,
    overlayOpacity = _props$overlayOpacity === void 0 ? defaultProps.overlayOpacity : _props$overlayOpacity,
    _props$minified = props.minified,
    minified = _props$minified === void 0 ? defaultProps.minified : _props$minified,
    _props$roundness = props.roundness,
    roundness = _props$roundness === void 0 ? defaultProps.roundness : _props$roundness,
    _props$borderSpace = props.borderSpace,
    borderSpace = _props$borderSpace === void 0 ? defaultProps.borderSpace : _props$borderSpace,
    _props$borderWidth = props.borderWidth,
    borderWidth = _props$borderWidth === void 0 ? defaultProps.borderSpace : _props$borderWidth,
    _props$position = props.position,
    position = _props$position === void 0 ? defaultProps.position : _props$position,
    _props$overlayColor = props.overlayColor,
    overlayColor = _props$overlayColor === void 0 ? defaultProps.overlayColor : _props$overlayColor,
    image = props.image,
    cloudflareEnabled = props.cloudflareEnabled,
    sizes = props.sizes,
    quality = props.quality,
    sx = props.sx,
    priority = props.priority,
    mode = props.mode,
    highlighted = props.highlighted,
    selected = props.selected,
    additionalStyles = props.additionalStyles,
    borderColor = props.borderColor,
    children = props.children,
    _props$localImgSrc = props.localImgSrc,
    localImgSrc = _props$localImgSrc === void 0 ? defaultProps.localImgSrc : _props$localImgSrc;
  var _props$staticImage = props.staticImage,
    staticImage = _props$staticImage === void 0 ? defaultProps.staticImage : _props$staticImage;
  var isSvg = image === null || image === void 0 ? void 0 : (_image$originalSrc = image.originalSrc) === null || _image$originalSrc === void 0 ? void 0 : _image$originalSrc.includes(".svg", -4);
  staticImage = staticImage && !isSvg;
  var blurUrl, imageWidth, imageHeight;
  if (__webpack_require__.g.__appConfig__.imageBlurhash && image !== null && image !== void 0 && image.blurhash) {
    var pixels;
    var widthImageBlur = 32,
      heightImageBlur = 32;
    var imageString = image.blurhash;
    pixels = (0, _blurhash.decode)(imageString, widthImageBlur, heightImageBlur);
    if (true) {
      var imageBlur = (0, _arrayToImage.getImgFromArr)(pixels, widthImageBlur, heightImageBlur);
      blurUrl = imageBlur.src;
    } else { var _imageBlur; }
  }
  var $aspectRatio = sx === null || sx === void 0 ? void 0 : sx.aspectRatio;
  var variant = (_sx$variant = sx === null || sx === void 0 ? void 0 : sx.variant) !== null && _sx$variant !== void 0 ? _sx$variant : ["natural"];
  var paddingBottom = $aspectRatio ? (0, _core.responsiveValueMap)($aspectRatio, function (x) {
    return "".concat(x * 100, "%");
  }) : (0, _core.responsiveValueMap)(variant, function (variantName) {
    var _findVariant;
    return "".concat(1 / ((_findVariant = findVariant(image, variantName)) === null || _findVariant === void 0 ? void 0 : _findVariant.aspectRatio) * 100, "%");
  });
  if (!(image !== null && image !== void 0 && image.originalSrc)) {
    return null;
  }
  var originalSrc = image.originalSrc;
  if ((sx === null || sx === void 0 ? void 0 : sx.variant) === "mobile") {
    var _image$variants$find$, _image$variants$find, _image$variants$find$2, _image$variants$find$3;
    originalSrc = (_image$variants$find$ = (_image$variants$find = image.variants.find(function (variant) {
      return variant.name === "mobile";
    })) === null || _image$variants$find === void 0 ? void 0 : (_image$variants$find$2 = _image$variants$find.srcset) === null || _image$variants$find$2 === void 0 ? void 0 : (_image$variants$find$3 = _image$variants$find$2[0]) === null || _image$variants$find$3 === void 0 ? void 0 : _image$variants$find$3.url) !== null && _image$variants$find$ !== void 0 ? _image$variants$find$ : image === null || image === void 0 ? void 0 : image.originalSrc;
  }
  var isFromPrismic = image.originalSrc.split("/")[2] === __webpack_require__.g.__appConfig__.prismicMediaDomain;
  var myLoader = function myLoader(_ref) {
    var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
    if (isFromPrismic || isSvg) {
      var _isMobileImg;
      src = (_isMobileImg = isMobileImg(width)) !== null && _isMobileImg !== void 0 ? _isMobileImg : src;
      if (!isSvg && !src.match(/w=[0-9]*&h=[0-9]*/)) {
        var _image$variants, _image$variants$0$src2;
        var _image$variants$0$src = (_image$variants = image.variants) === null || _image$variants === void 0 ? void 0 : (_image$variants$0$src2 = _image$variants[0].srcset) === null || _image$variants$0$src2 === void 0 ? void 0 : _image$variants$0$src2[0],
          w = _image$variants$0$src.w,
          h = _image$variants$0$src.h;
        src += "&rect=0,0,".concat(w, ",").concat(h, "&w=").concat(width);
      } else {
        src = src.replace(/w=[0-9]*&h=[0-9]*/, "w=".concat(width));
      }
    } else {
      src = localImgSrc ? src : addCloudflareToUrl(src, width, quality, cloudflareEnabled, blurUrl);
    }
    return src;
  };
  var isMobileImg = function isMobileImg(width) {
    var _sx$variant2, _sx$variant3;
    if (sx !== null && sx !== void 0 && (_sx$variant2 = sx.variant) !== null && _sx$variant2 !== void 0 && _sx$variant2.includes("mobile") && variant.includes("mobile") && width < 961) {
      var _image$variants$find2, _image$variants$find3, _image$variants$find4;
      return (_image$variants$find2 = image.variants.find(function (variant) {
        return variant.name === "mobile";
      })) === null || _image$variants$find2 === void 0 ? void 0 : (_image$variants$find3 = _image$variants$find2.srcset) === null || _image$variants$find3 === void 0 ? void 0 : (_image$variants$find4 = _image$variants$find3[0]) === null || _image$variants$find4 === void 0 ? void 0 : _image$variants$find4.url;
    } else if (sx !== null && sx !== void 0 && (_sx$variant3 = sx.variant) !== null && _sx$variant3 !== void 0 && _sx$variant3.includes("mobilesecond") && variant.includes("mobilesecond") && width < 961) {
      var _image$variants$find5, _image$variants$find6, _image$variants$find7;
      return (_image$variants$find5 = image.variants.find(function (variant) {
        return variant.name === "mobilesecond";
      })) === null || _image$variants$find5 === void 0 ? void 0 : (_image$variants$find6 = _image$variants$find5.srcset) === null || _image$variants$find6 === void 0 ? void 0 : (_image$variants$find7 = _image$variants$find6[0]) === null || _image$variants$find7 === void 0 ? void 0 : _image$variants$find7.url;
    }
  };
  if (staticImage) {
    var _image$variants$find8, _image$variants$find9;
    var currentImage = (_image$variants$find8 = image.variants.find(function (variant) {
      return variant.name === (isMobileImg(960) ? "mobile" : "natural");
    })) === null || _image$variants$find8 === void 0 ? void 0 : (_image$variants$find9 = _image$variants$find8.srcset) === null || _image$variants$find9 === void 0 ? void 0 : _image$variants$find9[0];
    imageWidth = currentImage.w;
    imageHeight = currentImage.h;
    originalSrc = currentImage.url;
  }
  return staticImage ? __jsx(_image["default"], {
    src: originalSrc,
    loader: myLoader,
    sizes: "100vw",
    blurDataURL: blurUrl,
    style: {
      width: "100%",
      height: "auto"
    },
    width: imageWidth,
    height: imageHeight
  }) : minified ? __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: "100%",
      img: _objectSpread(_objectSpread({}, additionalStyles), {}, {
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        objectFit: "contain",
        objectPosition: "center center",
        display: "block",
        margin: "auto",
        borderColor: borderColor !== null && borderColor !== void 0 ? borderColor : "black",
        borderStyle: "solid",
        boxSizing: "border-box",
        borderWidth: highlighted || selected ? "".concat(borderWidth, "px") : 0,
        borderRadius: roundness,
        padding: borderSpace ? "3px" : 0,
        background: highlighted || selected ? "white" : "none"
      })
    }
  }, __jsx("img", {
    src: myLoader({
      src: originalSrc,
      width: 100,
      quality: quality
    }),
    alt: image.altText
  })) : __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "relative",
      borderRadius: roundness,
      overflow: "hidden"
    }, sx)
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      paddingBottom: paddingBottom
    }
  }), blurUrl ? __jsx(_image["default"], {
    sizes: sizes,
    loader: myLoader,
    src: originalSrc,
    alt: (_image$altText = image.altText) !== null && _image$altText !== void 0 ? _image$altText : "",
    layout: "fill",
    quality: quality !== null && quality !== void 0 ? quality : 70,
    objectPosition: position,
    objectFit: mode !== null && mode !== void 0 ? mode : "contain",
    placeholder: "blur",
    blurDataURL: blurUrl,
    priority: priority
  }) : __jsx(_image["default"], {
    sizes: sizes,
    loader: myLoader,
    src: originalSrc,
    alt: (_image$altText2 = image.altText) !== null && _image$altText2 !== void 0 ? _image$altText2 : "",
    layout: "fill",
    quality: quality !== null && quality !== void 0 ? quality : 70,
    objectPosition: position,
    objectFit: mode !== null && mode !== void 0 ? mode : "contain",
    priority: priority
  }), overlay && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      bg: overlayColor,
      opacity: overlayOpacity
    }
  }), children);
};
var _default = Image;
exports["default"] = _default;

/***/ }),

/***/ 44637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _core = __webpack_require__(98464);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Loader = function Loader() {
  var animation = (0, _core.keyframes)({
    "0%": {
      boxShadow: "0 1em 0 -1.3em"
    },
    "80%": {
      boxShadow: "0 1em 0 -1.3em"
    },
    "100%": {
      boxShadow: "0 1em 0 -1.3em"
    },
    "40%": {
      boxShadow: "0 1em 0 0"
    }
  });
  var sharedStyles = {
    content: '""',
    borderRadius: "50%",
    height: "1em",
    width: "1em",
    animationFillMode: "both",
    animation: "".concat(animation, " 1.4s infinite ease-in-out")
  };
  var additionalStyles = {
    position: "absolute",
    top: 0
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      padding: ["35vh 0 44vh", null, null, "38vh 0 52vh", null]
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, sharedStyles), {}, {
      margin: "auto",
      color: "neutral900",
      fontSize: "10px",
      transform: "translateZ(0)",
      animationDelay: "0",
      "::after": _objectSpread(_objectSpread(_objectSpread({}, sharedStyles), additionalStyles), {}, {
        left: "2.5em",
        animationDelay: "0.16s"
      }),
      "::before": _objectSpread(_objectSpread(_objectSpread({}, sharedStyles), additionalStyles), {}, {
        left: "-2.5em",
        animationDelay: "-0.16s"
      })
    })
  }));
};
var _default = Loader;
exports["default"] = _default;

/***/ }),

/***/ 72030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _useAdvertPopup2 = __webpack_require__(85556);
var _Dialog = _interopRequireDefault(__webpack_require__(21277));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _dialogImages = _interopRequireDefault(__webpack_require__(46726));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Button = _interopRequireDefault(__webpack_require__(51586));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z"
  }));
};
CloseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defautProps = {
  advertTextFont: "xl_sans",
  advertSloganFont: "l"
};
var NewsletterPopup = function NewsletterPopup(props) {
  var placement = props.placement,
    width = props.width,
    advertSlogan = props.advertSlogan,
    advertText = props.advertText,
    buttonLabel = props.buttonLabel,
    advertLink = props.advertLink,
    _props$advertTextFont = props.advertTextFont,
    advertTextFont = _props$advertTextFont === void 0 ? defautProps.advertTextFont : _props$advertTextFont,
    _props$advertSloganFo = props.advertSloganFont,
    advertSloganFont = _props$advertSloganFo === void 0 ? defautProps.advertSloganFont : _props$advertSloganFo;
  var _useAdvertPopup = (0, _useAdvertPopup2.useAdvertPopup)(),
    popupVisible = _useAdvertPopup.popupVisible,
    killPopup = _useAdvertPopup.killPopup;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Dialog["default"], {
    isOpen: popupVisible,
    anchoredTo: "window",
    sx: {
      width: ["90vw", null, null, width],
      placement: ["center", null, placement],
      overflow: "scroll",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      background: "white",
      display: "flex",
      flexDirection: ["column", null, null, "row"]
    }
  }, __jsx(_Box["default"], {
    sx: {
      flex: "50%"
    }
  }, __jsx(_Image["default"], {
    image: _objectSpread(_objectSpread({}, _dialogImages["default"]), {}, {
      blurhash: "LFNv.3;4JCJ.,.8wD4~qD$%2$lRP"
    }),
    mode: "cover",
    sizes: "100vw"
  })), __jsx(_Box["default"], {
    sx: {
      flex: "50%",
      p: "s8",
      textAlign: "center",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      cursor: "pointer",
      "float": "right",
      position: ["absolute", null, null, "static"],
      right: 20,
      top: 20
    }
  }, __jsx(CloseIcon, {
    onClick: function onClick() {
      return killPopup();
    }
  })), advertSlogan && __jsx(_Box["default"], {
    sx: {
      font: advertSloganFont,
      mt: ["s6", null, null, "s10"]
    }
  }, advertSlogan), advertText && __jsx(_Box["default"], {
    sx: {
      font: advertTextFont,
      mt: "s7"
    }
  }, advertText), __jsx(Link, {
    href: advertLink
  }, __jsx(_Box["default"], {
    sx: {
      px: "s6",
      mt: ["s8", null, null, "s11"]
    }
  }, __jsx(_Button["default"], {
    sx: {
      width: ["unset", null, null, "100%"],
      height: 40,
      minWidth: 235,
      $secondFont: true
    },
    onClick: function onClick() {
      return killPopup();
    }
  }, buttonLabel))))));
};
var _default = NewsletterPopup;
exports.Z = _default;

/***/ }),

/***/ 58015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var defaultProps = {
  defaultNotification: true,
  additionalHtml: "",
  forceBgColor: "",
  fonts: {
    small: "s_sans_bold",
    normal: "base_sans_bold"
  }
};
var Notification = function Notification(props) {
  var message = props.message,
    messageButton = props.messageButton,
    messageButtonLabel = props.messageButtonLabel,
    onMessageButtonClick = props.onMessageButtonClick,
    closeButton = props.closeButton,
    closeButtonLabel = props.closeButtonLabel,
    onCloseClick = props.onCloseClick,
    _props$defaultNotific = props.defaultNotification,
    defaultNotification = _props$defaultNotific === void 0 ? defaultProps.defaultNotification : _props$defaultNotific,
    isError = props.isError,
    onClick = props.onClick,
    _props$additionalHtml = props.additionalHtml,
    additionalHtml = _props$additionalHtml === void 0 ? defaultProps.additionalHtml : _props$additionalHtml,
    _props$forceBgColor = props.forceBgColor,
    forceBgColor = _props$forceBgColor === void 0 ? defaultProps.forceBgColor : _props$forceBgColor,
    _props$fonts = props.fonts,
    fonts = _props$fonts === void 0 ? defaultProps.fonts : _props$fonts;
  var ActionButton = messageButton ? /*#__PURE__*/_react["default"].cloneElement(messageButton, {
    onClick: function onClick() {
      return onMessageButtonClick();
    }
  }, messageButtonLabel) : "";
  var QuitButton = closeButton ? /*#__PURE__*/_react["default"].cloneElement(closeButton, {
    onClick: function onClick() {
      return onCloseClick();
    }
  }, closeButtonLabel) : "";
  return __jsx(_Box["default"], {
    sx: {
      borderRadius: "4px",
      bg: forceBgColor ? forceBgColor : defaultNotification ? "main" : isError ? "main" : "positive500",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
      py: ["s6", null, null, "s9"],
      px: ["s8", null, null, "s10"]
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      color: "white",
      mb: ActionButton || QuitButton ? "s6" : 0,
      font: [fonts.small, null, null, fonts.normal]
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "absolute",
      top: 5,
      right: "s4",
      cursor: "pointer",
      width: 20,
      height: 20,
      svg: {
        fill: "white",
        width: 20,
        height: 20
      }
    },
    onClick: onClick
  }, __jsx(CloseIcon, null)), message), (ActionButton || QuitButton) && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexWrap: "nowrap",
      justifyContent: "space-between"
    }
  }, ActionButton && __jsx(_Box["default"], null, ActionButton), QuitButton && __jsx(_Box["default"], null, QuitButton)), __jsx(_Box["default"], {
    dangerouslySetInnerHTML: {
      __html: additionalHtml
    }
  }));
};
var _default = Notification;
exports.Z = _default;

/***/ }),

/***/ 7090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var _useCategoryTree2 = __webpack_require__(28452);
var _useAnalytics4AndCommerceTags = _interopRequireDefault(__webpack_require__(79892));
var _percentDecrease = _interopRequireDefault(__webpack_require__(28532));
var _getPromoCategory = _interopRequireDefault(__webpack_require__(5446));
var _getLowProductAvailability = _interopRequireDefault(__webpack_require__(63712));
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(15366));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  otherDefaultImage: false,
  reducedMargins: false,
  showProductId: true,
  labelAdditionalStyles: {},
  labelPosition: {}
};
var ProductBox = function ProductBox(props) {
  var _product$availability, _product$category;
  var product = props.product,
    colors = props.colors,
    _props$otherDefaultIm = props.otherDefaultImage,
    otherDefaultImage = _props$otherDefaultIm === void 0 ? defaultProps.otherDefaultImage : _props$otherDefaultIm,
    roundness = props.roundness,
    _props$reducedMargins = props.reducedMargins,
    reducedMargins = _props$reducedMargins === void 0 ? defaultProps.reducedMargins : _props$reducedMargins,
    _props$showProductId = props.showProductId,
    showProductId = _props$showProductId === void 0 ? defaultProps.showProductId : _props$showProductId,
    _props$labelAdditiona = props.labelAdditionalStyles,
    labelAdditionalStyles = _props$labelAdditiona === void 0 ? defaultProps.labelAdditionalStyles : _props$labelAdditiona,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? defaultProps.labelPosition : _props$labelPosition,
    mainColor = props.mainColor,
    imageOverlayOpacity = props.imageOverlayOpacity,
    parentListType = props.parentListType,
    parentListIndex = props.parentListIndex;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var price = product.price,
    image = product.image,
    name = product.name,
    collection = product.collection,
    promoLabelIndex = product.promoLabelIndex;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var outOfStock = (0, _getLowProductAvailability["default"])((_product$availability = product.availability) === null || _product$availability === void 0 ? void 0 : _product$availability.level);
  var translations = {
    more: (0, _langLibrary["default"])("more"),
    "new": (0, _langLibrary["default"])("New arrival"),
    outOfStock: (0, _langLibrary["default"])("Out of stock"),
    productCode: (0, _langLibrary["default"])("product code"),
    hitOfWeek: (0, _langLibrary["default"])("Hit of the week"),
    hitOfMonth: (0, _langLibrary["default"])("Hit of the month"),
    outlet: (0, _langLibrary["default"])("Outlet"),
    additionalPromoLabel: (0, _langLibrary["default"])("additional_promo_label")
  };
  var circleLabelStyles = _objectSpread({
    width: "35px",
    height: "35px",
    borderRadius: "50px",
    color: "white",
    font: "xxs_caps",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "36px",
    textAlign: "center"
  }, labelAdditionalStyles);
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var promoLabels = [translations.hitOfWeek, translations.hitOfMonth, translations["new"], translations.outlet];
  var currentProductGotAdditionalLabel = (0, _getPromoCategory["default"])({
    language: language,
    ids: product === null || product === void 0 ? void 0 : (_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.ids
  });
  return __jsx(_Box["default"], {
    "data-test": "product-box",
    sx: {
      width: "100%",
      position: "relative"
    }
  }, __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: product.name,
    onClick: function onClick() {
      return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id), parentListType, parentListIndex);
    }
  }, image && __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Image["default"], {
    overlay: true,
    overlayOpacity: imageOverlayOpacity,
    roundness: roundness,
    sx: {
      aspectRatio: 1,
      objectFit: "contain",
      mb: "s5"
    },
    image: otherDefaultImage ? otherDefaultImage.originalSrc ? otherDefaultImage : image : image,
    sizes: "(max-width: 460px) and (min-width: 10px) 210px, 420px",
    cloudflareEnabled: __webpack_require__.g.__appConfig__.smallImageCloudflareEnabled,
    quality: __webpack_require__.g.__appConfig__.smallImageQuality
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      width: "100%",
      color: "neutral700",
      font: "xs",
      my: reducedMargins ? 0 : "s3",
      display: "flex",
      justifyContent: collection.name ? "space-between" : "flex-end",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "1",
      overflow: "hidden"
    }
  }, collection.name && __jsx(_Box["default"], {
    as: "span"
  }, collection.name), product.sku && showProductId && __jsx(_Box["default"], {
    as: "span",
    sx: {
      textTransform: "uppercase"
    }
  }, translations.productCode, " ", product.sku)), __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      width: "100%",
      font: "s_sans",
      color: outOfStock ? "beigeDarken" : mainColor !== null && mainColor !== void 0 ? mainColor : "main",
      pt: "s3",
      maxHeight: "70px",
      overflow: "hidden",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "3",
      mb: "s6"
    }
  }, promoLabelIndex !== undefined && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "positive",
      display: "block"
    }
  }, promoLabels[promoLabelIndex]), currentProductGotAdditionalLabel && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "negative",
      display: "block"
    }
  }, translations.additionalPromoLabel), outOfStock && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "neutral900",
      display: "block"
    }
  }, translations.outOfStock), name)), __jsx(_Box["default"], {
    sx: {
      font: "".concat(price.special ? "base_sans_regular_discount" : "base_sans_bold"),
      color: outOfStock ? "beigeDarken" : mainColor !== null && mainColor !== void 0 ? mainColor : "main"
    }
  }, priceWithCurrency(price.regular)), price.special && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      color: outOfStock ? "beigeDarken" : "negative",
      font: "base_sans_bold"
    }
  }, priceWithCurrency(price.special))), price.special && __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "absolute",
      top: "0",
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      p: "s5"
    }, labelPosition)
  }, __jsx(_Box["default"], {
    as: "span",
    sx: _objectSpread(_objectSpread({}, circleLabelStyles), {}, {
      bg: outOfStock ? "beigeDarken" : "negative"
    })
  }, "-", (0, _percentDecrease["default"])(product.price.regular, product.price.special), "%")))), colors && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      mt: "s7",
      display: "flex",
      alignItems: "center",
      flexDirection: "row"
    }
  }, colors.slice(0, 5).map(function (color, index) {
    return __jsx(_Box["default"], {
      sx: {
        bg: color,
        width: "16px",
        height: "16px",
        mr: "s3",
        border: "0px"
      },
      key: index
    });
  }), colors.length > 5 && __jsx(_Box["default"], {
    as: "span"
  }, "+", colors.length - 5, " ", translations.more)));
};
var _default = ProductBox;
exports.Z = _default;

/***/ }),

/***/ 56277:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _QuantityPicker = __webpack_require__(34345);
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var _useCartModifier2 = _interopRequireDefault(__webpack_require__(82106));
var _useCategoryTree2 = __webpack_require__(28452);
var _useAnalytics4AndCommerceTags = _interopRequireDefault(__webpack_require__(79892));
var _useMinicart2 = __webpack_require__(34698);
var _LanguageProvider = __webpack_require__(8989);
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(__webpack_require__(36229));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _ProductRowPrice = _interopRequireDefault(__webpack_require__(54825));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  otherDefaultImage: false,
  skuDisabled: false,
  isQuantityPickerEnabled: true,
  isOrderView: false,
  isProductUnavailable: false,
  rounded: false,
  showDiscountFromTotals: false,
  showAddToCartButton: false,
  maxLineName: 2,
  onLinkClick: function onLinkClick() {}
};
var ProductRow = function ProductRow(props) {
  var _product$collection, _extendedStyles$colle, _product$collection2, _product$collection3, _extendedStyles$produ, _extendedStyles$produ2, _extendedStyles$produ3, _extendedStyles$produ4, _extendedStyles$produ5, _extendedStyles$produ6;
  var product = props.product,
    deleteButton = props.deleteButton,
    qtyPicker = props.qtyPicker,
    quantity = props.quantity,
    addToCartButton = props.addToCartButton,
    _props$onLinkClick = props.onLinkClick,
    onLinkClick = _props$onLinkClick === void 0 ? defaultProps.onLinkClick : _props$onLinkClick,
    _props$isOrderView = props.isOrderView,
    isOrderView = _props$isOrderView === void 0 ? defaultProps.isOrderView : _props$isOrderView,
    _props$isQuantityPick = props.isQuantityPickerEnabled,
    isQuantityPickerEnabled = _props$isQuantityPick === void 0 ? defaultProps.isQuantityPickerEnabled : _props$isQuantityPick,
    productCategoryName = props.productCategoryName,
    _props$isProductUnava = props.isProductUnavailable,
    isProductUnavailable = _props$isProductUnava === void 0 ? defaultProps.isProductUnavailable : _props$isProductUnava,
    _props$otherDefaultIm = props.otherDefaultImage,
    otherDefaultImage = _props$otherDefaultIm === void 0 ? defaultProps.otherDefaultImage : _props$otherDefaultIm,
    _props$skuDisabled = props.skuDisabled,
    skuDisabled = _props$skuDisabled === void 0 ? defaultProps.skuDisabled : _props$skuDisabled,
    _props$maxLineName = props.maxLineName,
    maxLineName = _props$maxLineName === void 0 ? defaultProps.maxLineName : _props$maxLineName,
    roundness = props.roundness,
    extendedStyles = props.extendedStyles,
    imageOverlayOpacity = props.imageOverlayOpacity,
    _props$rounded = props.rounded,
    rounded = _props$rounded === void 0 ? defaultProps.rounded : _props$rounded,
    _props$showDiscountFr = props.showDiscountFromTotals,
    showDiscountFromTotals = _props$showDiscountFr === void 0 ? defaultProps.showDiscountFromTotals : _props$showDiscountFr,
    _props$showAddToCartB = props.showAddToCartButton,
    showAddToCartButton = _props$showAddToCartB === void 0 ? defaultProps.showAddToCartButton : _props$showAddToCartB;
  var translations = {
    productCode: (0, _langLibrary["default"])("product code"),
    addToCart: (0, _langLibrary["default"])("add to cart")
  };
  var price = product.price,
    image = product.image,
    name = product.name;
  var _useCartModifier = (0, _useCartModifier2["default"])({
      product: product
    }),
    loading = _useCartModifier.loading,
    update = _useCartModifier.update,
    remove = _useCartModifier.remove,
    add = _useCartModifier.add;
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    isMinicartLoading = _useMinicart.isMinicartLoading;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    defaultValue: quantity,
    maxValue: __webpack_require__.g.__appConfig__.quantityPickerMaxValue,
    onChange: function () {
      var _onChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(newQty) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return update(newQty);
              case 3:
                _context.next = 8;
                break;
              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                quantityPicker.setAmount(quantity);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      return onChange;
    }()
  });
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var rowFlexStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "no-wrap",
    justifyContent: "space-between",
    alignItems: "center"
  };
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var opacityStyle = {
    opacity: isProductUnavailable ? 0.1 : 1.0
  };
  var priceRow = __jsx(_ProductRowPrice["default"], {
    showDiscountFromTotals: showDiscountFromTotals,
    price: price,
    isOrderView: isOrderView,
    opacityStyle: opacityStyle,
    isQuantityPickerEnabled: isQuantityPickerEnabled,
    quantityPicker: quantityPicker,
    extendedStyles: extendedStyles,
    quantity: quantity
  });
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, product !== null && product !== void 0 && product.url ? __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      var _product$category;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.id));
      onLinkClick();
    },
    sx: {
      minWidth: isQuantityPickerEnabled ? "96px" : "80px",
      height: isQuantityPickerEnabled ? "96px" : "80px"
    }
  }, __jsx(_Image["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      aspectRatio: 1,
      objectFit: "contain"
    }),
    roundness: roundness,
    image: otherDefaultImage ? otherDefaultImage.originalSrc ? otherDefaultImage : image : image,
    sizes: "210px",
    overlay: true,
    overlayOpacity: imageOverlayOpacity,
    cloudflareEnabled: __webpack_require__.g.__appConfig__.bigImageCloudflareEnabled,
    quality: __webpack_require__.g.__appConfig__.bigImageQuality,
    minified: props === null || props === void 0 ? void 0 : props.minified
  }))) : __jsx(_Box["default"], {
    sx: {
      minWidth: isQuantityPickerEnabled ? "96px" : "80px",
      height: isQuantityPickerEnabled ? "96px" : "80px"
    }
  }, __jsx(_Image["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      aspectRatio: 1,
      objectFit: "contain"
    }),
    roundness: rounded ? _Image["default"].ROUND_SOFT : _Image["default"].NO_ROUNDNESS,
    image: image,
    overlay: true,
    overlayOpacity: imageOverlayOpacity,
    sizes: "210px",
    minified: props === null || props === void 0 ? void 0 : props.minified
  })), __jsx(_Box["default"], {
    sx: {
      pl: "s6",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      color: "main",
      fill: "main",
      width: "calc(100%)",
      position: "relative",
      zIndex: 1
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, rowFlexStyle), {}, {
      font: "body2"
    })
  }, __jsx(_Box["default"], {
    sx: {
      maxWidth: "calc(100% - 30px)"
    }
  }, showAddToCartButton || isQuantityPickerEnabled ? __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      var _product$category2;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category2 = product.category) === null || _product$category2 === void 0 ? void 0 : _product$category2.id));
      onLinkClick();
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      overflow: "hidden",
      display: "-webkit-box",
      maxWidth: "100%"
    }, !((0, _hasStoreAdditionalFunctionalities["default"])(language) && isQuantityPickerEnabled) && {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: showAddToCartButton ? 1 : 3
    })
  }, name), __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: "xs_underline",
      textDecoration: "none",
      color: "neutral700",
      textTransform: "uppercase",
      position: "relative"
      //  position: showAddToCartButton ? "absolute" : "static",
      //  bottom: 45
    })
  }, translations.productCode, " ", product.sku))) : __jsx(_Box["default"], null, __jsx(_Box["default"], {
    title: product === null || product === void 0 ? void 0 : (_product$collection = product.collection) === null || _product$collection === void 0 ? void 0 : _product$collection.name,
    sx: {
      display: "inline-flex",
      width: "100%",
      font: (_extendedStyles$colle = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.collectionFont) !== null && _extendedStyles$colle !== void 0 ? _extendedStyles$colle : "xs_underline",
      textDecoration: "none",
      color: "neutral700"
    }
  }, (product === null || product === void 0 ? void 0 : (_product$collection2 = product.collection) === null || _product$collection2 === void 0 ? void 0 : _product$collection2.name) && __jsx(_Box["default"], {
    as: "span",
    sx: {
      width: "50%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      display: "block"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: product.collection.url ? product.collection : product
  }, __jsx(_LinkRaw["default"], {
    title: product.collection.name,
    onClick: function onClick() {
      var _product$category3;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category3 = product.category) === null || _product$category3 === void 0 ? void 0 : _product$category3.id));
      onLinkClick();
    }
  }, product.collection.name))), !skuDisabled && __jsx(_Box["default"], {
    as: "span",
    sx: {
      display: "block",
      width: "50%",
      textAlign: product !== null && product !== void 0 && (_product$collection3 = product.collection) !== null && _product$collection3 !== void 0 && _product$collection3.name ? "right" : "left",
      textTransform: "uppercase"
    }
  }, translations.productCode, " ", product.sku)), product !== null && product !== void 0 && product.url ? __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      var _product$category4;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category4 = product.category) === null || _product$category4 === void 0 ? void 0 : _product$category4.id));
      onLinkClick();
    },
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: (_extendedStyles$produ = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFont) !== null && _extendedStyles$produ !== void 0 ? _extendedStyles$produ : "s_sans",
      color: (_extendedStyles$produ2 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ2 !== void 0 ? _extendedStyles$produ2 : "main",
      mt: "s3",
      WebkitLineClamp: maxLineName,
      WebkitBoxOrient: "vertical",
      display: "-webkit-box",
      overflow: "hidden"
    })
  }, name)) : __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: (_extendedStyles$produ3 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFont) !== null && _extendedStyles$produ3 !== void 0 ? _extendedStyles$produ3 : "s_sans",
      color: (_extendedStyles$produ4 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ4 !== void 0 ? _extendedStyles$produ4 : "main",
      mt: "s3"
    })
  }, name)), showAddToCartButton && /*#__PURE__*/_react["default"].cloneElement(addToCartButton, {
    sx: {
      $size: "small",
      position: "absolute",
      display: ["none", "flex"],
      zIndex: 2,
      bottom: 0
    },
    isLoading: loading,
    onClick: function onClick() {
      if (!loading) {
        add(1);
      }
    }
  }, translations.addToCart)), isQuantityPickerEnabled && deleteButton && __jsx(_Box["default"], {
    sx: {
      flexBasis: "30px"
    }
  }, /*#__PURE__*/_react["default"].cloneElement(deleteButton, {
    "data-test": "delete-product-minicart",
    disabled: loading || isMinicartLoading,
    onClick: function onClick() {
      if (!loading && !isMinicartLoading) {
        remove(productCategoryName, quantity);
      }
    }
  }))), __jsx(_Box["default"], {
    sx: isQuantityPickerEnabled ? rowFlexStyle : {
      display: "flex",
      font: "xs_underline",
      textDecoration: "none",
      color: (_extendedStyles$produ5 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ5 !== void 0 ? _extendedStyles$produ5 : "main"
    }
  }, __jsx(_Box["default"], {
    sx: isQuantityPickerEnabled ? rowFlexStyle : {
      display: "block-inline",
      font: "xs_underline",
      textDecoration: "none",
      color: (_extendedStyles$produ6 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ6 !== void 0 ? _extendedStyles$produ6 : "main"
    }
  }, isQuantityPickerEnabled && qtyPicker && /*#__PURE__*/_react["default"].cloneElement(qtyPicker, {
    "data-test": "quantity-picker-minicart",
    controller: quantityPicker,
    loading: loading || isMinicartLoading
  }), isOrderView && quantity), !showAddToCartButton && priceRow), showAddToCartButton && __jsx(_Box["default"], {
    sx: {
      position: ["relative", "absolute"],
      right: 0,
      bottom: [0, "s6"]
    }
  }, priceRow, /*#__PURE__*/_react["default"].cloneElement(addToCartButton, {
    sx: {
      $size: "small",
      position: "relative",
      display: ["block", "none"],
      top: "s5",
      zIndex: 2,
      bottom: 0
    },
    isLoading: loading,
    onClick: function onClick() {
      if (!loading) {
        add(1);
      }
    }
  }, translations.addToCart))));
};
var _default = ProductRow;
exports["default"] = _default;

/***/ }),

/***/ 54825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _useProductRowPrice2 = _interopRequireDefault(__webpack_require__(79903));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ProductRowPrice = function ProductRowPrice(_ref) {
  var _extendedStyles$cross, _extendedStyles$produ, _extendedStyles$final, _extendedStyles$final2, _extendedStyles$produ2;
  var price = _ref.price,
    isOrderView = _ref.isOrderView,
    opacityStyle = _ref.opacityStyle,
    isQuantityPickerEnabled = _ref.isQuantityPickerEnabled,
    quantityPicker = _ref.quantityPicker,
    extendedStyles = _ref.extendedStyles,
    quantity = _ref.quantity,
    showDiscountFromTotals = _ref.showDiscountFromTotals;
  var _useProductRowPrice = (0, _useProductRowPrice2["default"])({
      price: price,
      isQuantityPickerEnabled: isQuantityPickerEnabled,
      quantityPicker: quantityPicker,
      quantity: quantity,
      showDiscountFromTotals: showDiscountFromTotals
    }),
    finalRegularPrice = _useProductRowPrice.finalRegularPrice,
    finalPrice = _useProductRowPrice.finalPrice,
    isProductForFree = _useProductRowPrice.isProductForFree,
    hasDiscount = _useProductRowPrice.hasDiscount;
  var translations = {
    productForFree: (0, _langLibrary["default"])("Product for free")
  };
  var orderViewProps = isOrderView ? {
    width: "100%",
    textAlign: "right"
  } : {};
  if (isProductForFree) {
    return __jsx(_Box["default"], {
      sx: orderViewProps
    }, __jsx(_Box["default"], {
      sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
        font: "s_sans_bold",
        display: isQuantityPickerEnabled ? "block" : "flex",
        justifyContent: isOrderView ? "flex-end" : "flex-start",
        color: "positive"
      })
    }, translations.productForFree));
  }
  return __jsx(_Box["default"], {
    sx: orderViewProps
  }, hasDiscount ? __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      display: isQuantityPickerEnabled ? "block" : "flex",
      justifyContent: isOrderView ? "flex-end" : "flex-start"
    })
  }, __jsx(_Box["default"], {
    sx: {
      font: isQuantityPickerEnabled ? "s_sans" : (_extendedStyles$cross = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.crossedOutPriceFont) !== null && _extendedStyles$cross !== void 0 ? _extendedStyles$cross : "xs_underline",
      color: (_extendedStyles$produ = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ !== void 0 ? _extendedStyles$produ : "main",
      textDecoration: "line-through",
      order: 1
    }
  }, finalRegularPrice), __jsx(_Box["default"], {
    sx: {
      font: isQuantityPickerEnabled ? "s_sans_bold" : (_extendedStyles$final = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.finalPriceFont) !== null && _extendedStyles$final !== void 0 ? _extendedStyles$final : "xs_underline",
      textDecoration: "none",
      color: "negative",
      order: 0,
      mr: "s5"
    },
    "data-test": "price-product-row"
  }, finalPrice)) : __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: isOrderView || isQuantityPickerEnabled ? "s_sans_bold" : (_extendedStyles$final2 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.finalPriceFont) !== null && _extendedStyles$final2 !== void 0 ? _extendedStyles$final2 : "xs_underline",
      textDecoration: "none",
      color: (_extendedStyles$produ2 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ2 !== void 0 ? _extendedStyles$produ2 : "main",
      margin: "auto 0"
    }),
    "data-test": "price-product-row"
  }, finalRegularPrice));
};
var _default = ProductRowPrice;
exports["default"] = _default;

/***/ }),

/***/ 79903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _isDiscount = _interopRequireDefault(__webpack_require__(46484));
var _totalPrice = _interopRequireDefault(__webpack_require__(26109));
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var useProductRowPrice = function useProductRowPrice(_ref) {
  var price = _ref.price,
    isQuantityPickerEnabled = _ref.isQuantityPickerEnabled,
    quantityPicker = _ref.quantityPicker,
    quantity = _ref.quantity,
    showDiscountFromTotals = _ref.showDiscountFromTotals;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var hasDiscount = (0, _isDiscount["default"])(price.regular, price.special);
  var discountFromTotals = price.discountFromTotals;
  var qty = isQuantityPickerEnabled ? quantityPicker.amount : quantity;
  if (isQuantityPickerEnabled && quantityPicker.amount !== quantity) {
    var discountPerItem = discountFromTotals / quantity;
    discountFromTotals = discountPerItem * quantityPicker.amount;
  }
  var finalPrice = (hasDiscount ? price.special : price.regular) * qty;
  var finalRegularPrice = price.regular * qty;
  if (showDiscountFromTotals && discountFromTotals) {
    if (hasDiscount) {
      finalPrice = finalPrice - discountFromTotals;
      finalRegularPrice = (price.special || price.regular) * qty;
    }
    if (!hasDiscount) {
      finalPrice = finalRegularPrice - discountFromTotals;
      hasDiscount = true;
    }
  }
  return {
    isProductForFree: finalPrice === 0,
    finalPrice: priceWithCurrency((0, _totalPrice["default"])(finalPrice, 1), true),
    finalRegularPrice: priceWithCurrency((0, _totalPrice["default"])(finalRegularPrice, 1), true),
    hasDiscount: hasDiscount
  };
};
var _default = useProductRowPrice;
exports["default"] = _default;

/***/ }),

/***/ 52133:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var _useCategoryTree2 = __webpack_require__(28452);
var _useAnalytics4AndCommerceTags = _interopRequireDefault(__webpack_require__(79892));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var RecentlyViewed = function RecentlyViewed(props) {
  var products = props.products,
    roundness = props.roundness;
  var wrapper = (0, _react.useRef)(null);
  var translations = {
    recentlyViewed: (0, _langLibrary["default"])("Recently viewed")
  };
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var productImageWidth = 65;
  var _useState = (0, _react.useState)(6),
    productsAmount = _useState[0],
    setProductsAmount = _useState[1];
  (0, _react.useEffect)(function () {
    setProductsAmount(Math.floor(wrapper.current.offsetWidth / productImageWidth));
  }, []);
  var productsToDisplay = productsAmount < 7 ? products.slice(0, productsAmount) : products.slice(0, 6);
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  return __jsx(_Box["default"], {
    ref: wrapper
  }, __jsx(_Box["default"], {
    sx: {
      font: "body2",
      mb: "s7",
      textAlign: "center",
      color: "main"
    },
    as: "h4"
  }, translations.recentlyViewed), __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    }
  }, productsToDisplay.map(function (product, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        width: productImageWidth + "px",
        mr: "4px",
        "&:last-of-type": {
          mr: "0px"
        }
      },
      onClick: function onClick() {
        return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id));
      }
    }, __jsx(Link, {
      route: "product-page",
      params: product
    }, __jsx(_LinkRaw["default"], {
      title: product.name
    }, __jsx(_Image["default"], {
      overlay: true,
      image: product.image,
      quality: __webpack_require__.g.__appConfig__.smallImageQuality,
      cloudflareEnabled: __webpack_require__.g.__appConfig__.smallImageCloudflareEnabled,
      minified: true,
      roundness: roundness
    }))));
  })));
};
var _default = RecentlyViewed;
exports.Z = _default;

/***/ }),

/***/ 81400:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
var ArrowBackIcon = function ArrowBackIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M4.883 13.438l6.542 6.99-.876.82-7.87-8.41 7.87-8.41.876.82-6.542 6.99H20.5v1.2H4.883z"
  }));
};
ArrowBackIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ReturnText = function ReturnText(props) {
  var label = props.label,
    onClick = props.onClick;
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: onClick
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      height: "24px",
      svg: {
        transform: "scaleX(0.5) scaleY(0.5)"
      }
    }
  }, __jsx(ArrowBackIcon, null)), __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "xs",
      color: "main"
    }
  }, label));
};
var _default = ReturnText;
exports["default"] = _default;

/***/ }),

/***/ 52510:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _MessageHandlerProvider = __webpack_require__(82425);
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
var CopyIcon = function CopyIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M22 6v16H6V6h16zm2-2H4v20h20V4zM0 21V0h21v2H2v19H0z"
  }));
};
CopyIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var defaultProps = {
  minified: false,
  minifiedPaddingBottom: "s5",
  bigTitleFontMinified: "s_sans_bold",
  salesTextFont: "s_sans",
  subheadingFont: "l",
  bigTitleFont: "xl_sans"
};
var SalesBox = function SalesBox(props) {
  var banner = props.banner,
    background = props.background,
    _props$minified = props.minified,
    minified = _props$minified === void 0 ? defaultProps.minified : _props$minified,
    _props$minifiedPaddin = props.minifiedPaddingBottom,
    minifiedPaddingBottom = _props$minifiedPaddin === void 0 ? defaultProps.minifiedPaddingBottom : _props$minifiedPaddin,
    _props$bigTitleFontMi = props.bigTitleFontMinified,
    bigTitleFontMinified = _props$bigTitleFontMi === void 0 ? defaultProps.bigTitleFontMinified : _props$bigTitleFontMi,
    _props$salesTextFont = props.salesTextFont,
    salesTextFont = _props$salesTextFont === void 0 ? defaultProps.salesTextFont : _props$salesTextFont,
    _props$subheadingFont = props.subheadingFont,
    subheadingFont = _props$subheadingFont === void 0 ? defaultProps.subheadingFont : _props$subheadingFont,
    _props$bigTitleFont = props.bigTitleFont,
    bigTitleFont = _props$bigTitleFont === void 0 ? defaultProps.bigTitleFont : _props$bigTitleFont;
  var bigTitle = banner.bigTitle,
    promoCode = banner.promoCode,
    subheading = banner.subheading,
    linkText = banner.linkText,
    url = banner.url;
  if (!banner) {
    return null;
  }
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var translations = {
    promoCodeCopied: (0, _langLibrary["default"])("Promo code was added to clipboard")
  };
  var salesBannerWrapperStyles = {
    width: "100%",
    bg: background ? background : "negative",
    color: "white",
    py: "s6",
    mb: [0, null, null, minifiedPaddingBottom],
    font: bigTitleFontMinified,
    justifyContent: "center",
    display: "flex",
    px: ["s8", null, null, 0]
  };
  if (minified) {
    if (promoCode) {
      var title = bigTitle === null || bigTitle === void 0 ? void 0 : bigTitle.split(promoCode);
      return __jsx(_Box["default"], {
        sx: salesBannerWrapperStyles
      }, __jsx(_Box["default"], null, "".concat(subheading, " ").concat(title[0]), __jsx(_Box["default"], {
        as: "span",
        id: "promoCode",
        sx: {
          svg: {
            fill: "white",
            width: 11,
            height: 15,
            ml: 4
          },
          cursor: "default"
        }
      }, __jsx(_Box["default"], {
        onClick: (/*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
            var _event$target$innerTe;
            var textToCopy;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    textToCopy = (_event$target$innerTe = event.target.innerText) === null || _event$target$innerTe === void 0 ? void 0 : _event$target$innerTe.replace(/\s/g, "");
                    _context.next = 3;
                    return navigator.clipboard.writeText(textToCopy);
                  case 3:
                    handleMessage(translations.promoCodeCopied, false, false);
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()),
        as: "span",
        sx: {
          cursor: "pointer"
        }
      }, promoCode), __jsx(CopyIcon, null)), bigTitle && title[1] && "".concat(title[1])), __jsx(_Box["default"], {
        sx: {
          font: salesTextFont,
          textDecoration: "underline",
          ml: 5,
          mt: -1
        }
      }, __jsx(Link, {
        href: url
      }, __jsx(_LinkRaw["default"], {
        title: linkText
      }, linkText))));
    }
    return __jsx(Link, {
      href: url
    }, __jsx(_LinkRaw["default"], {
      title: linkText
    }, __jsx(_Box["default"], {
      sx: salesBannerWrapperStyles
    }, __jsx(_Box["default"], null, "".concat(subheading, " ").concat(bigTitle)), "\xA0", __jsx(_Box["default"], {
      sx: {
        font: salesTextFont,
        textDecoration: "underline"
      }
    }, linkText))));
  }
  return __jsx(Link, {
    href: url
  }, __jsx(_LinkRaw["default"], {
    title: linkText
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      bg: background ? background : "negative",
      color: "white",
      py: "s8",
      px: "18%",
      display: "flex",
      flexDirection: ["column", null, null, "row"],
      justifyContent: "space-between",
      textAlign: ["center", null, null, "left"]
    }
  }, __jsx(_Box["default"], null, subheading && __jsx(_Box["default"], {
    sx: {
      font: subheadingFont,
      mb: "s5"
    }
  }, subheading), bigTitle && __jsx(_Box["default"], {
    sx: {
      font: bigTitleFont
    }
  }, bigTitle)), linkText && __jsx(_Box["default"], {
    sx: {
      width: ["100%", null, null, "auto"],
      mt: "s8",
      font: salesTextFont,
      alignSelf: "flex-end",
      textDecoration: "underline",
      textAlign: ["right", null, null, "center"]
    }
  }, linkText))));
};
var _default = SalesBox;
exports.Z = _default;

/***/ }),

/***/ 3376:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _router = __webpack_require__(53746);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _RouteContext = __webpack_require__(73157);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Search = _interopRequireWildcard(__webpack_require__(26282));
var _Layer = _interopRequireDefault(__webpack_require__(24946));
var _useQuickSearch = _interopRequireDefault(__webpack_require__(17577));
var _LanguageProvider = __webpack_require__(8989);
var _ProductRow = _interopRequireDefault(__webpack_require__(56277));
var _getDefaultProductImage = __webpack_require__(705);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconSearch = function IconSearch(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
IconSearch.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  dropDownStyles: {
    height: 424,
    width: 890,
    top: "auto",
    left: "auto"
  }
};
var SearchDesktop = function SearchDesktop(props) {
  var inputSecondary = props.inputSecondary,
    _props$dropDownStyles = props.dropDownStyles,
    dropDownStyles = _props$dropDownStyles === void 0 ? defaultProps.dropDownStyles : _props$dropDownStyles;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var router = (0, _router.useRouter)();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var hitEnter = (0, _react.useRef)(false);
  var _useSearch = (0, _useQuickSearch["default"])(language),
    _useSearch$state = _useSearch.state,
    state = _useSearch$state === void 0 ? {} : _useSearch$state,
    setPhrase = _useSearch.setPhrase,
    phrase = _useSearch.phrase;
  var _state$data = state.data,
    data = _state$data === void 0 ? [] : _state$data,
    _state$isLoading = state.isLoading,
    isLoading = _state$isLoading === void 0 ? false : _state$isLoading;
  var _data$results = data.results,
    results = _data$results === void 0 ? [] : _data$results,
    _data$totalCount = data.totalCount,
    totalCount = _data$totalCount === void 0 ? null : _data$totalCount,
    _data$categories = data.categories,
    categories = _data$categories === void 0 ? [] : _data$categories;
  var translations = {
    search: (0, _langLibrary["default"])("Search"),
    seeAllSuggestions: (0, _langLibrary["default"])("See all suggestions ({{resultsLength}})", {
      resultsLength: totalCount ? totalCount : 0
    })
  };
  var searchController = (0, _Search.useSearch)({
    onChange: function onChange(val) {
      return setPhrase(val);
    },
    onSubmit: function onSubmit(val) {
      if (phrase !== val) {
        hitEnter.current = true;
      } else if ((results === null || results === void 0 ? void 0 : results.length) === 1) {
        router.push("/[...categoryOrProductPage]", "/".concat(results[0].url));
      } else {
        router.push("/catalogsearch/result/[...query]", "/catalogsearch/result/".concat(val));
      }
    }
  });
  (0, _react.useEffect)(function () {
    if (!isLoading && hitEnter.current) {
      hitEnter.current = false;
      if ((results === null || results === void 0 ? void 0 : results.length) === 1) {
        router.push("/[...categoryOrProductPage]", "/".concat(results[0].url));
      } else {
        router.push("/catalogsearch/result/[...query]", "/catalogsearch/result/".concat(phrase));
      }
    }
  }, [isLoading]);
  (0, _react.useEffect)(function () {
    if ((phrase === null || phrase === void 0 ? void 0 : phrase.length) > 0 && !router.asPath.includes("/catalogsearch/result/")) {
      searchController.clear();
    }
  }, [router.asPath]);
  var searchInput = /*#__PURE__*/_react["default"].cloneElement(inputSecondary, {
    placeholder: translations.search,
    leftEnhancer: __jsx(IconSearch, null),
    clearable: true,
    "data-test": "search-desktop"
  });
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Search["default"], {
    input: searchInput,
    layer: __jsx(_Layer["default"], {
      root: {
        boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
        bg: "white",
        overflowY: "auto",
        display: "flex",
        top: dropDownStyles.top,
        left: dropDownStyles.left,
        borderRadius: dropDownStyles.roundness
      },
      width: dropDownStyles.width,
      height: dropDownStyles.height
    }),
    controller: searchController
  }, results && results.length > 0 && function (_ref) {
    var _dropDownStyles$leftC, _dropDownStyles$exten, _dropDownStyles$exten2, _dropDownStyles$exten3, _dropDownStyles$exten4, _dropDownStyles$exten9, _dropDownStyles$exten10, _dropDownStyles$exten11, _dropDownStyles$exten12;
    var close = _ref.close;
    return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
      sx: {
        pt: "s9",
        display: "flex",
        flexDirection: "row"
      }
    }, __jsx(_Box["default"], {
      sx: {
        width: (_dropDownStyles$leftC = dropDownStyles.leftColumnWidth) !== null && _dropDownStyles$leftC !== void 0 ? _dropDownStyles$leftC : "240px",
        ml: "s9",
        pr: "s8",
        color: (_dropDownStyles$exten = (_dropDownStyles$exten2 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten2 === void 0 ? void 0 : _dropDownStyles$exten2.categoryColor) !== null && _dropDownStyles$exten !== void 0 ? _dropDownStyles$exten : "main",
        font: (_dropDownStyles$exten3 = (_dropDownStyles$exten4 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten4 === void 0 ? void 0 : _dropDownStyles$exten4.categoryFont) !== null && _dropDownStyles$exten3 !== void 0 ? _dropDownStyles$exten3 : "base_sans_regular_discount",
        textDecoration: "none"
      }
    }, categories.slice(0, 8).map(function (item) {
      return item.url && __jsx(Link, {
        route: "category-page",
        params: item
      }, __jsx(_LinkRaw["default"], {
        sx: {
          ":hover": {
            bg: "neutral100"
          },
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: "1",
          overflow: "hidden",
          py: "s4"
        },
        title: item.name
      }, item.name));
    })), __jsx(_Box["default"], {
      sx: {
        width: "277px",
        height: "80px"
      }
    }, (results === null || results === void 0 ? void 0 : results.length) > 0 && results.slice(0, dropDownStyles.leftColumnWidth ? 4 : 3).map(function (item) {
      var _dropDownStyles$exten5, _dropDownStyles$exten6, _dropDownStyles$exten7, _dropDownStyles$exten8;
      return __jsx(_Box["default"], {
        sx: {
          height: "80px",
          mb: "s8"
        }
      }, __jsx(_ProductRow["default"], {
        product: item,
        otherDefaultImage: (0, _getDefaultProductImage.getDefaultCategoryProductImage)(__webpack_require__.g.__appConfig__.searchDefaultImage, language === null || language === void 0 ? void 0 : language.language, item),
        quantity: 1,
        isQuantityPickerEnabled: false,
        onLinkClick: function onLinkClick() {
          return close();
        },
        skuDisabled: dropDownStyles.customColumns !== undefined,
        roundness: dropDownStyles.roundness,
        extendedStyles: dropDownStyles.extendedStyles ? {
          collectionFont: (_dropDownStyles$exten5 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten5 === void 0 ? void 0 : _dropDownStyles$exten5.productCollectionFont,
          productFont: (_dropDownStyles$exten6 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten6 === void 0 ? void 0 : _dropDownStyles$exten6.productNameFont,
          productFontColor: (_dropDownStyles$exten7 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten7 === void 0 ? void 0 : _dropDownStyles$exten7.productNameColor,
          crossedOutPriceFont: (_dropDownStyles$exten8 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten8 === void 0 ? void 0 : _dropDownStyles$exten8.crossedOutPriceFont
        } : undefined,
        isOrderView: false
      }));
    }), results.length > 0 && __jsx(Link, {
      route: "catalogsearch",
      params: {
        query: phrase
      }
    }, __jsx(_LinkRaw["default"], {
      sx: {
        color: (_dropDownStyles$exten9 = (_dropDownStyles$exten10 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten10 === void 0 ? void 0 : _dropDownStyles$exten10.categoryColor) !== null && _dropDownStyles$exten9 !== void 0 ? _dropDownStyles$exten9 : "main",
        font: (_dropDownStyles$exten11 = (_dropDownStyles$exten12 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten12 === void 0 ? void 0 : _dropDownStyles$exten12.productNameFont) !== null && _dropDownStyles$exten11 !== void 0 ? _dropDownStyles$exten11 : "s_sans_bold",
        pt: "s6",
        display: "flex",
        alignItems: "center",
        svg: {
          ml: "s6",
          mt: -3,
          pointerEvents: "none"
        }
      },
      title: translations.seeAllSuggestions
    }, translations.seeAllSuggestions, !dropDownStyles.customColumns && __jsx(ArrowRightIcon, null)))), !dropDownStyles.customColumns && __jsx(_Box["default"], {
      sx: {
        width: "277px",
        ml: "s8"
      }
    }, (results === null || results === void 0 ? void 0 : results.length) > 3 && results.slice(3, 6).map(function (item) {
      return __jsx(_Box["default"], {
        sx: {
          height: "80px",
          mb: "s8"
        }
      }, __jsx(_ProductRow["default"], {
        sx: {
          height: "80px",
          mb: "s8"
        },
        product: item,
        quantity: 1,
        isQuantityPickerEnabled: false
      }));
    }))));
  }));
};
var _default = SearchDesktop;
exports.Z = _default;

/***/ }),

/***/ 50666:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _router = __webpack_require__(53746);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Search = __webpack_require__(26282);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _useQuickSearch = _interopRequireDefault(__webpack_require__(17577));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _ProductRow = _interopRequireDefault(__webpack_require__(56277));
var _RouteContext = __webpack_require__(73157);
var _bodyScrollLock = __webpack_require__(28198);
var _LanguageProvider = __webpack_require__(8989);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var IconSearch = function IconSearch(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
IconSearch.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchMobile = function SearchMobile(props) {
  var _popularSearches$cont;
  var popularSearches = props.popularSearches,
    closeSearch = props.closeSearch,
    inputBare = props.inputBare,
    mobileSearchOpen = props.mobileSearchOpen;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useSearch = (0, _useQuickSearch["default"])(language),
    _useSearch$state = _useSearch.state,
    state = _useSearch$state === void 0 ? {} : _useSearch$state,
    setPhrase = _useSearch.setPhrase,
    phrase = _useSearch.phrase;
  var _state$data = state.data,
    data = _state$data === void 0 ? [] : _state$data;
  var _data$results = data.results,
    results = _data$results === void 0 ? [] : _data$results,
    _data$totalCount = data.totalCount,
    totalCount = _data$totalCount === void 0 ? null : _data$totalCount,
    _data$categories = data.categories,
    categories = _data$categories === void 0 ? [] : _data$categories;
  var router = (0, _router.useRouter)();
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    popularSearches: (0, _langLibrary["default"])("Popular searches"),
    cancel: (0, _langLibrary["default"])("Cancel"),
    searchCollection: (0, _langLibrary["default"])("Search collections, products, etc..."),
    seeAllSuggestions: (0, _langLibrary["default"])("See all suggestions ({{resultsLength}})", {
      resultsLength: totalCount
    })
  };
  var popularSearchesContent = __webpack_require__.g.__appConfig__.popularSearchesFromJson ? popularSearches !== null && popularSearches !== void 0 ? popularSearches : {} : (_popularSearches$cont = popularSearches.content) === null || _popularSearches$cont === void 0 ? void 0 : _popularSearches$cont.popularSearches;
  var handleCloseSearch = function handleCloseSearch() {
    setPhrase(null);
    closeSearch(false);
  };
  var popularSearchesView = __jsx(_Box["default"], {
    sx: {
      ml: "6vw",
      mr: "6vw"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "xxs_caps_ext",
      color: "neutral700",
      textDecoration: "uppercase",
      pt: "s8",
      mb: "s7"
    }
  }, translations.popularSearches), popularSearches && (popularSearchesContent === null || popularSearchesContent === void 0 ? void 0 : popularSearchesContent.map(function (searchResult, index) {
    return searchResult && __jsx(_Box["default"], {
      sx: {
        color: "main",
        font: "l_normal",
        textDecoration: "none",
        ":hover": {
          bg: "neutral100"
        },
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "1",
        overflow: "hidden",
        py: "s4"
      },
      key: index
    }, __jsx(Link, {
      route: "category-page",
      params: searchResult
    }, __jsx(_LinkRaw["default"], {
      title: searchResult.title,
      onClick: function onClick() {
        return handleCloseSearch();
      }
    }, searchResult.title)));
  })));
  var searchInput = /*#__PURE__*/_react["default"].cloneElement(inputBare, {
    placeholder: translations.searchCollection,
    leftEnhancer: __jsx(IconSearch, null),
    autoFocus: true,
    clearable: true,
    "data-test": "search-mobile"
  });
  (0, _react.useEffect)(function () {
    var _document;
    var element = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById("layerUi");
    if (mobileSearchOpen) {
      (0, _bodyScrollLock.disableBodyScroll)(element);
    } else {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }
  }, [mobileSearchOpen]);
  return __jsx(_Search.SearchInline, {
    input: searchInput,
    mode: "fixed",
    inputContainer: function inputContainer(_ref) {
      var input = _ref.input;
      return __jsx(_Box["default"], {
        sx: {
          p: "s3",
          borderBottomStyle: "solid",
          borderBottomColor: "neutral",
          borderBottomWidth: "1px",
          bg: "white"
        }
      }, __jsx(_Box["default"], {
        sx: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, __jsx(_Box["default"], {
        sx: {
          flex: "1 1 auto"
        }
      }, input), __jsx(_Box["default"], {
        sx: {
          flex: "0 0 auto",
          pr: "s6"
        },
        onClick: function onClick() {
          return handleCloseSearch();
        }
      }, __jsx(_Box["default"], {
        sx: {
          color: "active",
          font: "base_sans",
          cursor: "pointer"
        }
      }, translations.cancel))));
    },
    onChange: function onChange(val) {
      return setPhrase(val);
    },
    onSubmit: function onSubmit(val) {
      handleCloseSearch();
      if ((results === null || results === void 0 ? void 0 : results.length) === 1) {
        router.push("/[...categoryOrProductPage]", "/".concat(results[0].url));
      } else {
        router.push("/catalogsearch/result/[...query]/", "/catalogsearch/result/".concat(val));
      }
    }
  }, !phrase || (phrase === null || phrase === void 0 ? void 0 : phrase.length) === 0 ? popularSearchesView : (results === null || results === void 0 ? void 0 : results.length) > 0 && __jsx(_Box["default"], {
    sx: {
      py: "s9"
    }
  }, __jsx(_Box["default"], {
    sx: {
      ml: "6vw",
      mr: "6vw"
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "l_normal",
      textDecoration: "none"
    }
  }, categories.slice(0, 3).map(function (item) {
    return __jsx(Link, {
      route: "product-page",
      params: item,
      key: item.id
    }, __jsx(_LinkRaw["default"], {
      sx: {
        ":hover": {
          bg: "neutral100"
        },
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "1",
        overflow: "hidden",
        py: "s4"
      },
      title: item.name,
      onClick: function onClick() {
        return handleCloseSearch();
      }
    }, item.name));
  })), __jsx(_Box["default"], {
    sx: {
      mt: "s9"
    }
  }, (results === null || results === void 0 ? void 0 : results.length) > 0 && results.slice(0, 5).map(function (item) {
    return __jsx(_Box["default"], {
      sx: {
        height: "80px",
        mb: "s8"
      },
      key: item.id
    }, __jsx(_ProductRow["default"], {
      product: item,
      quantity: 1,
      isQuantityPickerEnabled: false,
      onLinkClick: handleCloseSearch
    }));
  }), results.length > 0 && __jsx(Link, {
    route: "catalogsearch",
    params: {
      query: phrase
    }
  }, __jsx(_LinkRaw["default"], {
    title: translations.seeAllSuggestions,
    onClick: function onClick() {
      return handleCloseSearch();
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "base_sans_bold",
      pt: "s6",
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      height: "24px"
    }
  }, " ", translations.seeAllSuggestions, " "), " ", __jsx(_Box["default"], {
    sx: {
      ml: "s6"
    }
  }, __jsx(ArrowRightIcon, null)))))))));
};
var _default = SearchMobile;
exports.Z = _default;

/***/ }),

/***/ 84807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useSelect = useSelect;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _downshift = __webpack_require__(64467);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Layer = _interopRequireDefault(__webpack_require__(24946));
var _SelectInline = __webpack_require__(71070);
var _useSelectState = _interopRequireDefault(__webpack_require__(88829));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSelect(props) {
  /**
   * we keep a bit different naming:
   * - options
   * - value
   * - onChange
   */

  var selectState = (0, _useSelectState["default"])(props);
  var options = selectState.options,
    value = selectState.value,
    setValue = selectState.setValue;

  // Stateful / Stateless
  var downshiftOptions = {
    items: options,
    selectedItem: value,
    onSelectedItemChange: function onSelectedItemChange(item) {
      setValue(item.selectedItem);
    }
  };
  var downshiftSelect = (0, _downshift.useSelect)(downshiftOptions);
  var buttonPropsDownshift = downshiftSelect.getToggleButtonProps();
  var anchorRef = (0, _react.useRef)(null);
  var buttonRef = function buttonRef(element) {
    buttonPropsDownshift.ref(element);
    anchorRef.current = element;
  };
  var buttonProps = _objectSpread(_objectSpread({}, buttonPropsDownshift), {}, {
    buttonRef: buttonRef
  });
  delete buttonProps.ref;
  var newOptions = options.map(function (option, index) {
    var itemDownshiftProps = downshiftSelect.getItemProps({
      index: index,
      item: option
    });
    itemDownshiftProps._ref = itemDownshiftProps.ref;
    delete itemDownshiftProps.ref;
    return _objectSpread(_objectSpread({}, option), {}, {
      selectableProps: _objectSpread({
        selected: value && option.id === value.id,
        highlighted: downshiftSelect.highlightedIndex === index,
        disabled: !!option.disabled,
        option: option,
        value: option.id,
        key: option.id,
        label: option.label
      }, itemDownshiftProps)
    });
  });
  var layerProps = {
    isOpen: downshiftSelect.isOpen
  };
  return _objectSpread(_objectSpread(_objectSpread({}, downshiftSelect), selectState), {}, {
    // TODO: open, close functions

    options: newOptions,
    menuProps: downshiftSelect.getMenuProps(),
    layerProps: layerProps,
    anchorRef: anchorRef,
    buttonProps: buttonProps
  });
}

/**
 * Select can be styled as 'InputContainer' and also as with a separate custom button.
 * We should clean this up and especially clean up InputContainer concept.
 *
 */
function Select2(props) {
  var label = props.label,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "Select value" : _props$placeholder,
    onClick = props.onClick,
    controller = props.controller,
    button = props.button,
    separator = props.separator,
    selectable = props.selectable,
    width = props.width,
    height = props.height,
    minWidth = props.minWidth,
    minHeight = props.minHeight,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    animationTime = props.animationTime,
    animationEase = props.animationEase,
    backgroundColor = props.backgroundColor,
    root = props.root,
    container = props.container,
    placement = props.placement,
    anchoredTo = props.anchoredTo,
    header = props.header,
    footer = props.footer,
    children = props.children;
  var layerProps = {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    animationTime: animationTime,
    animationEase: animationEase,
    backgroundColor: backgroundColor,
    root: root,
    container: container,
    placement: placement,
    anchoredTo: anchoredTo,
    header: header,
    footer: footer
  };
  if (!controller) {
    controller = (0, _useSelectState["default"])(props);
  }
  var _controller = controller,
    buttonProps = _controller.buttonProps,
    menuProps = _controller.menuProps,
    anchorRef = _controller.anchorRef,
    options = _controller.options,
    value = _controller.value,
    isOpen = _controller.isOpen,
    openMenu = _controller.openMenu;
  options = controller.options;

  // TODO: should be possible to make it a function
  // TODO: pass "selected", "disabled", "error", "placehoder", "selectedOption", "selectedValue"
  // const button = React.cloneElement($button, {
  //   ...buttonProps,
  //   sx: { ...$button.props.sx, ...restSx }
  // });

  button = typeof button === "function" ? button(controller) : button;
  return __jsx(_Layer["default"], (0, _extends2["default"])({}, layerProps, {
    button: /*#__PURE__*/_react["default"].cloneElement(button, buttonProps)
  }), function (_ref) {
    var close = _ref.close;
    var items = [];
    var selectableProps = (0, _SelectInline.getSelectableProps)(controller, props, {
      allowUnselect: false
    });
    selectableProps = selectableProps.map(function (props) {
      return _objectSpread(_objectSpread({}, props), {}, {
        onClick: function onClick() {
          props.onClick.apply(props, arguments);
          close();
        }
      });
    });
    if (typeof children === "function") {
      var optionsArg = options.map(function (option, index) {
        return _objectSpread(_objectSpread({}, option), {}, {
          selectableProps: selectableProps[index]
        });
      });
      items = children({
        options: optionsArg
      });
    } else {
      options.forEach(function (option, i) {
        var item = typeof selectable === "function" ? selectable({
          option: option
        }) : selectable;
        items.push(/*#__PURE__*/_react["default"].cloneElement(item, selectableProps[i])); // TODO: we need more flexibility with item look

        if (separator && i < options.length - 1) {
          items.push(/*#__PURE__*/_react["default"].cloneElement(separator, {
            role: "separator",
            key: "separator-" + i
          }));
        }
      });
    }
    return __jsx(_Box["default"], null, items);
  });
}
var _default = Select2;
exports["default"] = _default;

/***/ }),

/***/ 74047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Select2Ui = _interopRequireDefault(__webpack_require__(84807));
var _ItemRow = _interopRequireDefault(__webpack_require__(627));
var _useSelectOptions = _interopRequireDefault(__webpack_require__(18781));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var IconChevronDown = function IconChevronDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconChevronDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  colorOptionSelect: "main",
  colorLabel: "greyLight",
  borderRadius: "4px",
  height: "48px",
  my: "s5",
  keyValue: "id",
  textTransform: "none",
  borderColor: "neutral700",
  bg: "none",
  font: "base_sans",
  pl: "14px",
  valueMarginTop: "14px",
  colorArrow: "main",
  icon: __jsx(IconChevronDown, null),
  mt: 0
};
var SelectInDialog = function SelectInDialog(props) {
  var _ref$current$offsetWi, _ref$current;
  var _props$colorOptionSel = props.colorOptionSelect,
    colorOptionSelect = _props$colorOptionSel === void 0 ? defaultProps.colorOptionSelect : _props$colorOptionSel,
    _props$colorLabel = props.colorLabel,
    colorLabel = _props$colorLabel === void 0 ? defaultProps.colorLabel : _props$colorLabel,
    _props$borderRadius = props.borderRadius,
    borderRadius = _props$borderRadius === void 0 ? defaultProps.borderRadius : _props$borderRadius,
    _props$height = props.height,
    height = _props$height === void 0 ? defaultProps.height : _props$height,
    _props$my = props.my,
    my = _props$my === void 0 ? defaultProps.my : _props$my,
    _props$mb = props.mb,
    mb = _props$mb === void 0 ? defaultProps.mb : _props$mb,
    _props$keyValue = props.keyValue,
    keyValue = _props$keyValue === void 0 ? defaultProps.keyValue : _props$keyValue,
    _props$textTransform = props.textTransform,
    textTransform = _props$textTransform === void 0 ? defaultProps.textTransform : _props$textTransform,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? defaultProps.borderColor : _props$borderColor,
    _props$bg = props.bg,
    bg = _props$bg === void 0 ? defaultProps.bg : _props$bg,
    _props$font = props.font,
    font = _props$font === void 0 ? defaultProps.font : _props$font,
    _props$pl = props.pl,
    pl = _props$pl === void 0 ? defaultProps.pl : _props$pl,
    _props$valueMarginTop = props.valueMarginTop,
    valueMarginTop = _props$valueMarginTop === void 0 ? defaultProps.valueMarginTop : _props$valueMarginTop,
    _props$colorArrow = props.colorArrow,
    colorArrow = _props$colorArrow === void 0 ? defaultProps.colorArrow : _props$colorArrow,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? defaultProps.icon : _props$icon,
    _props$mt = props.mt,
    mt = _props$mt === void 0 ? defaultProps.mt : _props$mt;
  var controller = props.controller || (0, _useSelectOptions["default"])(props);
  var ref = (0, _react.useRef)(null);
  var dataTest = props["data-test"] ? {
    "data-test": props["data-test"]
  } : {};
  return __jsx(_Box["default"], null, __jsx(_Box["default"], (0, _extends2["default"])({
    sx: {
      color: "main",
      font: "text2",
      my: my,
      mb: mb,
      bg: bg,
      border: "1px solid",
      borderColor: borderColor,
      borderRadius: borderRadius,
      height: height,
      position: "relative",
      pl: pl,
      mt: mt
    },
    _ref: ref
  }, dataTest), __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: colorLabel,
      font: "xxs_caps",
      my: "s4",
      position: "absolute",
      textTransform: textTransform
    }
  }, controller.selectProps.label), __jsx(_Select2Ui["default"], (0, _extends2["default"])({}, controller.selectProps, {
    button: function button(_ref) {
      var _value$keyValue;
      var value = _ref.value;
      return __jsx(_Box["default"], {
        sx: {
          width: "100%",
          font: "body2",
          lineHeight: 1,
          minWidth: "100%",
          height: "100%",
          cursor: "pointer",
          color: props.loading ? "neutral" : "black"
        }
      }, __jsx(_Box["default"], {
        sx: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          textAlign: "right",
          width: "100%",
          height: "100%",
          paddingRight: "10px",
          color: colorArrow
        }
      }, __jsx(_Box["default"], {
        sx: {
          color: colorOptionSelect,
          textAlign: "left",
          width: "90%",
          alignItems: "center",
          marginTop: valueMarginTop,
          font: font,
          textTransform: textTransform
        }
      }, (_value$keyValue = value === null || value === void 0 ? void 0 : value[keyValue]) !== null && _value$keyValue !== void 0 ? _value$keyValue : value), icon));
    },
    selectable: __jsx(_ItemRow["default"], {
      textTransform: textTransform
    }),
    allowEmpty: true,
    anchoredTo: ["window", null, ref],
    placement: ["center", null, "bottomLeft"],
    width: (_ref$current$offsetWi = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetWidth) !== null && _ref$current$offsetWi !== void 0 ? _ref$current$offsetWi : ["90vw", null, "20vw"],
    root: {
      height: ["70vh", null, 300],
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
      bg: "white"
    }
  }))));
};
SelectInDialog.labelInside = true;
var _default = SelectInDialog;
exports.Z = _default;

/***/ }),

/***/ 18781:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var useSelectOptions = function useSelectOptions() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = props.options;
  options.filter(function (product) {
    return product.alternativeVariantAvailable;
  }).forEach(function (product) {
    var alternativeVariantAvailable = product.alternativeVariantAvailable;
    if (alternativeVariantAvailable) {
      product.label = "".concat(product.name, "*");
    }
  });
  var onChange = props.onChange,
    label = props.label;
  var setValue = function setValue(number) {
    onChange(number);
  };
  var selectProps = {
    options: options,
    value: props.value,
    onChange: function onChange(val) {
      setValue(val);
    },
    label: label,
    placeholder: label
  };
  return {
    selectProps: selectProps,
    controller: {
      selectProps: selectProps
    }
  };
};
var _default = useSelectOptions;
exports["default"] = _default;

/***/ }),

/***/ 51586:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _ButtonText = _interopRequireDefault(__webpack_require__(27210));
var _Spinner = _interopRequireDefault(__webpack_require__(25558));
var _core = __webpack_require__(79329);
var __jsx = _react["default"].createElement;
var heights = {
  extraSmall: "32px",
  small: "36px",
  standard: "48px",
  large: "58px"
};
var _default = (0, _core.createComponent)(_ButtonText["default"], function (_ref) {
  var _ref$$size = _ref.$size,
    $size = _ref$$size === void 0 ? "standard" : _ref$$size,
    _ref$$outline = _ref.$outline,
    $outline = _ref$$outline === void 0 ? false : _ref$$outline,
    _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? "main" : _ref$$color,
    _ref$$colorFont = _ref.$colorFont,
    $colorFont = _ref$$colorFont === void 0 ? false : _ref$$colorFont,
    _ref$$selectable = _ref.$selectable,
    $selectable = _ref$$selectable === void 0 ? false : _ref$$selectable,
    _ref$$rounded = _ref.$rounded,
    $rounded = _ref$$rounded === void 0 ? false : _ref$$rounded,
    _ref$$secondFont = _ref.$secondFont,
    $secondFont = _ref$$secondFont === void 0 ? false : _ref$$secondFont,
    _ref$$forceSquare = _ref.$forceSquare,
    $forceSquare = _ref$$forceSquare === void 0 ? false : _ref$$forceSquare,
    _ref$$borderMainColor = _ref.$borderMainColor,
    $borderMainColor = _ref$$borderMainColor === void 0 ? "neutral" : _ref$$borderMainColor,
    _ref$$switchBg = _ref.$switchBg,
    $switchBg = _ref$$switchBg === void 0 ? false : _ref$$switchBg,
    _ref$$extraRound = _ref.$extraRound,
    $extraRound = _ref$$extraRound === void 0 ? false : _ref$$extraRound,
    _ref$$extraColor = _ref.$extraColor,
    $extraColor = _ref$$extraColor === void 0 ? "" : _ref$$extraColor,
    _ref$$gradientBg = _ref.$gradientBg,
    $gradientBg = _ref$$gradientBg === void 0 ? false : _ref$$gradientBg,
    _ref$$gradientBaseCol = _ref.$gradientBaseColor,
    $gradientBaseColor = _ref$$gradientBaseCol === void 0 ? "" : _ref$$gradientBaseCol,
    _ref$$gradientEndColo = _ref.$gradientEndColor,
    $gradientEndColor = _ref$$gradientEndColo === void 0 ? "#323232" : _ref$$gradientEndColo,
    _ref$$iconButton = _ref.$iconButton,
    $iconButton = _ref$$iconButton === void 0 ? false : _ref$$iconButton;
  return function (_ref2) {
    var disabled = _ref2.disabled,
      selected = _ref2.selected;
    return {
      height: $iconButton ? "40px" : heights[$size],
      minWidth: $iconButton ? "40px" : $rounded ? "auto" : "158px",
      width: $iconButton ? "40px" : "auto",
      borderRadius: $forceSquare ? "0" : $extraRound ? "30px" : $rounded ? "5px" : "2px",
      overflow: "hidden",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      },
      borderColor: disabled ? $borderMainColor : selected && $rounded ? $borderMainColor : !$selectable || selected ? "gradientEnd" : $borderMainColor,
      borderStyle: "solid",
      borderWidth: $outline ? "1px" : 0,
      $background: {
        bg: $switchBg ? $extraColor ? $extraColor : "main" : disabled && !$outline ? "neutral" : selected && $rounded ? "neutral" : $outline ? $extraRound ? "none" : "white" : $color,
        backgroundImage: $gradientBg ? "linear-gradient(to right, ".concat($gradientBaseColor, ", ").concat($gradientEndColor, ")") : "none",
        transition: "all .15s"
      },
      $body: {
        color: $switchBg ? "white" : $colorFont ? $colorFont : disabled ? "neutral700" : $outline ? $color : "white",
        font: $secondFont ? "s_caps" : "xs_caps" /** WAŻNE!!! Nie dodawajmy tutaj żadnych marginesów / paddingów zeby wyrównać font. Ten font jest niepoprawnie zakodownay, trzeba coś z tym zrobić inaczej **/,
        px: $iconButton ? 0 : 12,
        transition: "color .15s"
      },
      $gap: "8px",
      $iconSize: 24,
      $loader: {
        __children: __jsx(_Spinner["default"], {
          sx: {
            $color: disabled && $outline ? "neutral" : disabled && !$outline ? "neutral900" : $outline ? $color : "white",
            $color2: "rgba(255,255,255,0.2)"
          }
        })
      }
    };
  };
});
exports["default"] = _default;

/***/ }),

/***/ 95574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _ButtonIcon = _interopRequireDefault(__webpack_require__(7859));
var _Spinner = _interopRequireDefault(__webpack_require__(25558));
var _core = __webpack_require__(79329);
var __jsx = _react["default"].createElement;
var _default = (0, _core.createComponent)(_ButtonIcon["default"], function (_ref) {
  var _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? "main" : _ref$$color;
  return {
    height: "44px",
    width: "44px",
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    },
    $body: function $body(_ref2) {
      var disabled = _ref2.disabled;
      return {
        color: disabled ? "neutral700" : $color
      };
    },
    $loader: {
      __children: __jsx(_Spinner["default"], {
        sx: {
          $color: $color,
          $color2: "rgba(255,255,255,0.2)"
        }
      })
    }
  };
});
exports["default"] = _default;

/***/ }),

/***/ 627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Selectable = _interopRequireDefault(__webpack_require__(53910));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
var IconTick = function IconTick(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.67 7.673l-9.196 11.6-6.095-6.007.842-.855 5.144 5.07L18.73 6.926l.94.746z"
  }));
};
IconTick.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ItemRow = function ItemRow(props) {
  var _props$font = props.font,
    font = _props$font === void 0 ? "body2" : _props$font,
    _props$bgColor = props.bgColor,
    bgColor = _props$bgColor === void 0 ? "white" : _props$bgColor,
    _props$bgColorSelecte = props.bgColorSelected,
    bgColorSelected = _props$bgColorSelecte === void 0 ? "neutral100" : _props$bgColorSelecte;
  return __jsx(_Selectable["default"], props, function (_ref) {
    var disabled = _ref.disabled,
      highlighted = _ref.highlighted,
      selected = _ref.selected,
      label = _ref.label,
      textTransform = _ref.textTransform;
    return __jsx(_Box["default"], {
      sx: {
        width: "100%",
        // minWidth: "250px",
        height: "44px",
        display: "flex",
        padding: "12px",
        alignItems: "center",
        // pointerEvents: "none",
        lineHeight: 1,
        font: font,
        bg: highlighted || selected ? bgColorSelected : bgColor,
        opacity: disabled ? 0.5 : 1,
        justifyContent: "space-between"
      }
    }, __jsx(_Box["default"], {
      sx: {
        textTransform: textTransform
      }
    }, label), selected && __jsx(_Box["default"], {
      sx: {
        svg: {
          display: "block"
        }
      }
    }, __jsx(IconTick, null)));
  });
};
var _default = ItemRow;
exports["default"] = _default;

/***/ }),

/***/ 70491:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(98986));
var _createClass2 = _interopRequireDefault(__webpack_require__(30428));
var _inherits2 = _interopRequireDefault(__webpack_require__(10564));
var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5153));
var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(53531));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _cache = _interopRequireDefault(__webpack_require__(739));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2["default"])(t); if (r) { var s = (0, _getPrototypeOf2["default"])(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2["default"])(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var isServer = typeof window === "undefined";
var __NEXT_CACHE__ = "__NEXT_CACHE__";
function getOrCreateCache() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Always make a new cache if server, otherwise state is shared between requests
  if (isServer) {
    return new _cache["default"](initialState);
  }
  if (!window[__NEXT_CACHE__]) {
    window[__NEXT_CACHE__] = new _cache["default"](initialState);
  }
  return window[__NEXT_CACHE__];
}
var withCache = function withCache(App) {
  return /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(AppWithCache, _React$Component);
    var _super = _createSuper(AppWithCache);
    function AppWithCache(props) {
      var _this;
      (0, _classCallCheck2["default"])(this, AppWithCache);
      _this = _super.call(this, props);
      _this.cache = getOrCreateCache(props.initialCacheState);
      return _this;
    }
    (0, _createClass2["default"])(AppWithCache, [{
      key: "render",
      value: function render() {
        return __jsx(App, (0, _extends2["default"])({}, this.props, {
          cache: this.cache
        }));
      }
    }], [{
      key: "getInitialProps",
      value: function () {
        var _getInitialProps = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(appContext) {
          var cache, appProps;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Get or Create the store with `undefined` as initialState
                  // This allows you to set a custom default initialState
                  cache = getOrCreateCache(); // Provide the store to getInitialProps of pages
                  appContext.ctx.cache = cache;
                  appProps = {};
                  if (!(typeof App.getInitialProps === "function")) {
                    _context.next = 7;
                    break;
                  }
                  _context.next = 6;
                  return App.getInitialProps(appContext);
                case 6:
                  appProps = _context.sent;
                case 7:
                  return _context.abrupt("return", _objectSpread(_objectSpread({}, appProps), {}, {
                    initialCacheState: cache.extract()
                  }));
                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        function getInitialProps(_x) {
          return _getInitialProps.apply(this, arguments);
        }
        return getInitialProps;
      }()
    }]);
    return AppWithCache;
  }(_react["default"].Component);
};
var _default = withCache;
exports.Z = _default;

/***/ }),

/***/ 93355:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _analyticsAndCommerceScripts = __webpack_require__(41652);
var _isSalesmanagoEnabled = _interopRequireDefault(__webpack_require__(58592));
var _isNewsletterEnabled = _interopRequireDefault(__webpack_require__(98250));
var addFacebookPixel = function addFacebookPixel(src) {
  var facebookPixel = document.createElement("img");
  facebookPixel.setAttribute("width", "1px");
  facebookPixel.setAttribute("height", "1px");
  facebookPixel.setAttribute("src", src);
  var footer = document.getElementById("footer");
  if (footer) {
    footer.appendChild(facebookPixel);
  } else {
    document.body.appendChild(facebookPixel);
  }
};
var addTurnstileDialog = function addTurnstileDialog(label, key) {
  var turnstileDiv = document.createElement("dialog");
  var closeButton = document.createElement("div");
  var dialogLabel = document.createElement("span");
  turnstileDiv.setAttribute("class", "cf-turnstile");
  turnstileDiv.setAttribute("data-sitekey", key);
  turnstileDiv.setAttribute("data-callback", "javascriptCallback");
  dialogLabel.innerText = label;
  closeButton.setAttribute("onClick", "closeTurnstile()");
  turnstileDiv.appendChild(closeButton);
  turnstileDiv.appendChild(dialogLabel);
  var footer = document.getElementById("footer");
  if (footer) {
    footer.appendChild(turnstileDiv);
  } else {
    document.body.appendChild(turnstileDiv);
  }
};
var addGTMNoScript = function addGTMNoScript(gtmID) {
  var noScript = document.createElement("noscript");
  var iframe = document.createElement("iframe");
  iframe.setAttribute("width", "1px");
  iframe.setAttribute("height", "1px");
  iframe.setAttribute("style", "display:none;visibility:hidden;");
  iframe.setAttribute("src", (0, _analyticsAndCommerceScripts.gtmNoscriptSrc)(gtmID));
  noScript.appendChild(iframe);
  document.body.appendChild(noScript);
};
var loadScript = function loadScript(script, src) {
  var defer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var tag = document.createElement("script");
  tag.setAttribute("async", "true");
  tag.setAttribute("type", "text/javascript");
  if (defer) {
    tag.setAttribute("defer", "true");
  }
  if (script) {
    tag.innerHTML = script;
  }
  if (src) {
    tag.setAttribute("src", src);
  }
  document.body.appendChild(tag);
};
var addSalesmanago = function addSalesmanago(language) {
  return (0, _isNewsletterEnabled["default"])({
    language: language
  }) || (0, _isSalesmanagoEnabled["default"])({
    language: language
  });
};
var addAnalyticsAndCommerceScripts = function addAnalyticsAndCommerceScripts(currentLanguage, cookieAgreements, ids) {
  var scripts = [];
  var srcs = [];
  var cfToken = sessionStorage.getItem("cfToken");
  var turnstileEnabled = Boolean(parseInt(__webpack_require__.g.__appConfig__.turnstileConfig[currentLanguage].enabled)) && !cfToken;
  if (addSalesmanago(currentLanguage) && cookieAgreements.salesmanago) {
    scripts.push((0, _analyticsAndCommerceScripts.salesmanago)(__webpack_require__.g.__appConfig__.salesmanagoID));
  }
  if (cookieAgreements.gtm) {
    srcs.push((0, _analyticsAndCommerceScripts.gtmSrc)(ids.analyticsID));
    scripts.push((0, _analyticsAndCommerceScripts.ga4Script)(ids.analyticsID));
    addGTMNoScript(ids.gtmID);
  }
  if (cookieAgreements.pixelFb) {
    if (__webpack_require__.g.__appConfig__.facebookEnabled) {
      scripts.push((0, _analyticsAndCommerceScripts.facebookScript)(ids.fbID));
      addFacebookPixel((0, _analyticsAndCommerceScripts.facebookSrc)(ids.fbID));
    }
  }
  turnstileEnabled && addTurnstileDialog(__webpack_require__.g.__appConfig__.turnstileConfig[currentLanguage].label, __webpack_require__.g.__appConfig__.turnstileConfig[currentLanguage].siteKey);
  if (turnstileEnabled) {
    scripts.push((0, _analyticsAndCommerceScripts.turnstile)());
    loadScript(false, __webpack_require__.g.__appConfig__.turnstileScriptUrl, true);
  }
  scripts.map(function (script) {
    return loadScript(script);
  });
  srcs.map(function (src) {
    return loadScript(false, src);
  });
};
var _default = addAnalyticsAndCommerceScripts;
exports["default"] = _default;

/***/ }),

/***/ 32170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _getLanguageFromUrl = _interopRequireDefault(__webpack_require__(15851));
var addLanguagePrefixToUrl = function addLanguagePrefixToUrl(prefix) {
  return function (url) {
    var subpath = (0, _getLanguageFromUrl["default"])(url, prefix.replace("/", ""));
    return subpath ? url : prefix + url;
  };
};
var _default = addLanguagePrefixToUrl;
exports["default"] = _default;

/***/ }),

/***/ 97110:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var addLanguageSufixToRouteName = function addLanguageSufixToRouteName(sufix) {
  return function (routeName) {
    return routeName + sufix.replace("/", "");
  };
};
var _default = addLanguageSufixToRouteName;
exports["default"] = _default;

/***/ }),

/***/ 41652:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.turnstile = exports.salesmanago = exports.facebookSrc = exports.facebookScript = exports.gtmNoscriptSrc = exports.gtmSrc = exports.ga4Script = void 0;
var ga4Script = function ga4Script(id) {
  return "       \n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config', '".concat(id, "');\n        gtag('consent', 'default', {\n          'ad_storage': 'granted',\n          'ad_user_data': 'granted',\n          'ad_personalization': 'granted',\n          'analytics_storage': 'granted'\n        });\n          ");
};
exports.ga4Script = ga4Script;
var facebookScript = function facebookScript(id) {
  return "\n                          !function(f,b,e,v,n,t,s)\n{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\nn.callMethod.apply(n,arguments):n.queue.push(arguments)};\nif(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\nn.queue=[];t=b.createElement(e);t.async=!0;\nt.src=v;s=b.getElementsByTagName(e)[0];\ns.parentNode.insertBefore(t,s)}(window,document,'script',\n'https://connect.facebook.net/en_US/fbevents.js');\nfbq('init', '".concat(id, "');\nfbq('track', 'PageView');");
};
exports.facebookScript = facebookScript;
var gtmSrc = function gtmSrc(id) {
  return "https://www.googletagmanager.com/gtag/js?id=".concat(id);
};
exports.gtmSrc = gtmSrc;
var gtmNoscriptSrc = function gtmNoscriptSrc(id) {
  return "https://www.googletagmanager.com/ns.html?id=".concat(id);
};
exports.gtmNoscriptSrc = gtmNoscriptSrc;
var facebookSrc = function facebookSrc(id) {
  return "https://www.facebook.com/tr?id=".concat(id, "&ev=PageView&noscript=1");
};
exports.facebookSrc = facebookSrc;
var salesmanago = function salesmanago(id) {
  return "var _smid = \"".concat(id, "\";\n    (function(w, r, a, sm, s ) {\n        w['SalesmanagoObject'] = r;\n        w[r] = w[r] || function () {( w[r].q = w[r].q || [] ).push(arguments)};\n        sm = document.createElement('script'); sm.type = 'text/javascript'; sm.async = true; sm.src = a;\n        s = document.getElementsByTagName('script')[0];\n        s.parentNode.insertBefore(sm, s);\n    })(window, 'sm', '/sm.js');");
};
exports.salesmanago = salesmanago;
var turnstile = function turnstile() {
  return "function closeTurnstile() {\n  const turnstileDialog = document.getElementsByClassName('cf-turnstile');\n  turnstileDialog[0].setAttribute(\"style\", \"display: none\");\n}\n\ndocument.addEventListener(\"DOMContentLoaded\", function() {\n  const turnstileDialog = document.getElementsByClassName('cf-turnstile');\n  if (turnstileDialog[0].addEventListener) {\n    turnstileDialog[0].addEventListener ('DOMNodeInserted', onNodeInserted, false);\n  }\n  \n  function onNodeInserted() {\n    if(this.childNodes.length > 2) {\n      const responseInput = this.childNodes[2];\n      const turnstileResponseInput = document.getElementsByName('cf-turnstile-response')[0]\n      const config = { attributes: true, childList: true, subtree: true };\n\n      const callback = (mutationList, observer) => {\n      const chosenMutation =  mutationList.find(mutation => mutation.type === \"attributes\" && mutation.attributeName === \"value\")\n      \n      if(!chosenMutation) {\n        observer.disconnect();\n        return\n      }\n\n    if(turnstileResponseInput.value.length > 0) {\n      closeTurnstile();\n      sessionStorage.setItem(\"cfToken\", turnstileResponseInput.value);\n      \n    }\n    observer.disconnect();\n    };\n\nconst observer = new MutationObserver(callback);\nobserver.observe(turnstileResponseInput, config);\n\n    }\n  }})\n  ";
};
exports.turnstile = turnstile;

/***/ }),

/***/ 75800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.saveCacheFile = exports.readCacheFile = exports.setUrlInCache = exports.getResultFromCache = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _fs = _interopRequireDefault(__webpack_require__(68054));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var makeFolder = function makeFolder(categoryName) {
  var _categoryName$match, _categoryName$match$s;
  var foundFolderMoreTheOne = categoryName === null || categoryName === void 0 ? void 0 : (_categoryName$match = categoryName.match(/[^\s\/]*\//g)) === null || _categoryName$match === void 0 ? void 0 : (_categoryName$match$s = _categoryName$match.splice(0, 3)) === null || _categoryName$match$s === void 0 ? void 0 : _categoryName$match$s.join("");
  return foundFolderMoreTheOne ? foundFolderMoreTheOne : "".concat(categoryName, "/");
};
var hasSpecialCharactersInUrl = function hasSpecialCharactersInUrl(url) {
  return /[?;=&%]/.test(url);
};
var fileExist = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var fullCacheFilePath, fileHandle;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fullCacheFilePath = _ref.fullCacheFilePath;
            _context.prev = 1;
            _context.next = 4;
            return _fs["default"].promises.open(fullCacheFilePath);
          case 4:
            fileHandle = _context.sent;
            return _context.abrupt("return", {
              fileHandle: fileHandle
            });
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {
              fileHandle: false
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function fileExist(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var fileStats = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var fullCacheFilePath, stats;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fullCacheFilePath = _ref3.fullCacheFilePath;
            _context2.prev = 1;
            _context2.next = 4;
            return _fs["default"].promises.stat(fullCacheFilePath);
          case 4:
            stats = _context2.sent;
            return _context2.abrupt("return", {
              stats: stats
            });
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            throw Error("Stats file ".concat(fullCacheFilePath, " error ").concat(_context2.t0, " "));
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return function fileStats(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var writeFile = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref5) {
    var fileName, result, jsonData;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fileName = _ref5.fileName, result = _ref5.result;
            _context3.prev = 1;
            jsonData = JSON.stringify(Array.isArray(result) ? (0, _toConsumableArray2["default"])(result) : _objectSpread({}, result));
            _context3.next = 5;
            return _fs["default"].promises.writeFile(fileName, jsonData);
          case 5:
            return _context3.abrupt("return");
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            console.log("Error on write file", fileName, _context3.t0);
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return function writeFile(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var mkdir = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref7) {
    var folders;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            folders = _ref7.folders;
            _context4.prev = 1;
            _context4.next = 4;
            return _fs["default"].promises.mkdir(folders, {
              recursive: true
            });
          case 4:
            return _context4.abrupt("return", {
              folderCreated: true
            });
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", {
              folderCreated: false
            });
          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 7]]);
  }));
  return function mkdir(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
var access = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref9) {
    var fileOrFolder;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            fileOrFolder = _ref9.fileOrFolder;
            _context5.prev = 1;
            _context5.next = 4;
            return _fs["default"].promises.access(fileOrFolder);
          case 4:
            return _context5.abrupt("return", {
              isExist: true
            });
          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", {
              isExist: false
            });
          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 7]]);
  }));
  return function access(_x5) {
    return _ref10.apply(this, arguments);
  };
}();
var isCharsInLimit = function isCharsInLimit(fileName) {
  return !fileName || fileName.length < 255;
};
var readCacheFile = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref11) {
    var cacheFilePath, contextRequest, requestPath, _ref11$constantFileNa, constantFileName, _ref11$separateFolder, separateFolder, _ref11$forPrismic, forPrismic, _requestPath$replace, _requestPath$replace$, _filenameCategoryCach, initialCacheFilePath, filenameCategoryCache, fullCacheFilePath, hasFolder, _yield$fileExist, fileHandle, _yield$fileStats, stats, diffTime, result;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            cacheFilePath = _ref11.cacheFilePath, contextRequest = _ref11.contextRequest, requestPath = _ref11.requestPath, _ref11$constantFileNa = _ref11.constantFileName, constantFileName = _ref11$constantFileNa === void 0 ? false : _ref11$constantFileNa, _ref11$separateFolder = _ref11.separateFolder, separateFolder = _ref11$separateFolder === void 0 ? false : _ref11$separateFolder, _ref11$forPrismic = _ref11.forPrismic, forPrismic = _ref11$forPrismic === void 0 ? false : _ref11$forPrismic;
            if (!(__webpack_require__.g.__appConfig__.cacheSystemEnabled && contextRequest && !true && 0 && 0)) {
              _context6.next = 40;
              break;
            }
            initialCacheFilePath = "".concat(__webpack_require__.g.__appConfig__.cachePath).concat(cacheFilePath);
            filenameCategoryCache = !separateFolder ? requestPath === null || requestPath === void 0 ? void 0 : (_requestPath$replace = requestPath.replace(/\//gi, "---")) === null || _requestPath$replace === void 0 ? void 0 : (_requestPath$replace$ = _requestPath$replace.replace(/\?/gi, "--")) === null || _requestPath$replace$ === void 0 ? void 0 : _requestPath$replace$.replace(/&/gi, "--") : requestPath;
            filenameCategoryCache = "".concat(constantFileName ? constantFileName : filenameCategoryCache, ".json");
            fullCacheFilePath = "".concat(initialCacheFilePath);
            hasFolder = separateFolder && ((_filenameCategoryCach = filenameCategoryCache.match(/[a-z-]*\//gm)) === null || _filenameCategoryCach === void 0 ? void 0 : _filenameCategoryCach.join(""));
            if (separateFolder && !hasFolder) {
              hasFolder = makeFolder(filenameCategoryCache.replace(".json", "").replace(/-\d+(?!\d+)$/gm, "").replace(/-/gm, "/"));
              filenameCategoryCache = "".concat(hasFolder).concat(filenameCategoryCache);
              fullCacheFilePath += "".concat(hasFolder);
            }
            fullCacheFilePath += "".concat(filenameCategoryCache);
            _context6.next = 11;
            return fileExist({
              fullCacheFilePath: fullCacheFilePath
            });
          case 11:
            _yield$fileExist = _context6.sent;
            fileHandle = _yield$fileExist.fileHandle;
            if (!fileHandle) {
              _context6.next = 37;
              break;
            }
            _context6.next = 16;
            return fileStats({
              fullCacheFilePath: fullCacheFilePath
            });
          case 16:
            _yield$fileStats = _context6.sent;
            stats = _yield$fileStats.stats;
            diffTime = Date.now() - stats.mtime;
            if (!(forPrismic ? diffTime > __webpack_require__.g.__appConfig__.prismicCacheStoreTimeInMilliseconds : diffTime > __webpack_require__.g.__appConfig__.invalidateCacheTime)) {
              _context6.next = 22;
              break;
            }
            _context6.next = 22;
            return _fs["default"].unlink(fullCacheFilePath, function (error) {
              if (error) {
                console.log("Cache unlink error", error);
              }
            });
          case 22:
            _context6.next = 24;
            return fileHandle.readFile({
              encoding: "utf8"
            });
          case 24:
            result = _context6.sent;
            _context6.next = 27;
            return fileHandle.close();
          case 27:
            _context6.prev = 27;
            return _context6.abrupt("return", {
              cacheFileExist: true,
              cachedRequest: JSON.parse(result),
              filenameCategoryCache: filenameCategoryCache
            });
          case 31:
            _context6.prev = 31;
            _context6.t0 = _context6["catch"](27);
            console.error("readCacheFile url: ".concat(filenameCategoryCache, ", error: ").concat(_context6.t0));
            _context6.next = 36;
            return _fs["default"].unlink(fullCacheFilePath, function (error) {
              if (error) {
                console.log("Cache unlink error after reading file", error);
              }
            });
          case 36:
            return _context6.abrupt("return", {
              cacheFileExist: false,
              cachedRequest: null,
              filenameCategoryCache: filenameCategoryCache
            });
          case 37:
            return _context6.abrupt("return", {
              cacheFileExist: false,
              cachedRequest: null,
              filenameCategoryCache: filenameCategoryCache
            });
          case 40:
            return _context6.abrupt("return", {
              cacheFileExist: null,
              cachedRequest: null,
              filenameCategoryCache: null
            });
          case 41:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[27, 31]]);
  }));
  return function readCacheFile(_x6) {
    return _ref12.apply(this, arguments);
  };
}();
exports.readCacheFile = readCacheFile;
var saveCacheFile = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref13) {
    var cacheFilePath, filenameCategoryCache, result, folders, fileName, _yield$access, isExistFile, _yield$access2, isExistFolder;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            cacheFilePath = _ref13.cacheFilePath, filenameCategoryCache = _ref13.filenameCategoryCache, result = _ref13.result;
            _context7.prev = 1;
            if (true) {
              _context7.next = 26;
              break;
            }
            folders = "".concat(__webpack_require__.g.__appConfig__.cachePath).concat(cacheFilePath).concat(filenameCategoryCache.replace(/[^\/]+.json$/, ""));
            _context7.prev = 4;
            fileName = "".concat(__webpack_require__.g.__appConfig__.cachePath).concat(cacheFilePath).concat(filenameCategoryCache);
            _context7.next = 8;
            return access({
              fileOrFolder: fileName
            });
          case 8:
            _yield$access = _context7.sent;
            isExistFile = _yield$access.isExist;
            if (isExistFile) {
              _context7.next = 21;
              break;
            }
            _context7.next = 13;
            return access({
              fileOrFolder: folders
            });
          case 13:
            _yield$access2 = _context7.sent;
            isExistFolder = _yield$access2.isExist;
            if (isExistFolder) {
              _context7.next = 18;
              break;
            }
            _context7.next = 18;
            return mkdir({
              folders: folders
            });
          case 18:
            _context7.next = 20;
            return writeFile({
              fileName: fileName,
              result: result
            });
          case 20:
            return _context7.abrupt("return");
          case 21:
            _context7.next = 26;
            break;
          case 23:
            _context7.prev = 23;
            _context7.t0 = _context7["catch"](4);
            console.log("Cache write error", "".concat(__webpack_require__.g.__appConfig__.cachePath).concat(cacheFilePath).concat(filenameCategoryCache), _context7.t0);
          case 26:
            _context7.next = 31;
            break;
          case 28:
            _context7.prev = 28;
            _context7.t1 = _context7["catch"](1);
            console.log("Error on saveCacheFile", filenameCategoryCache, _context7.t1);
          case 31:
            return _context7.abrupt("return");
          case 32:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 28], [4, 23]]);
  }));
  return function saveCacheFile(_x7) {
    return _ref14.apply(this, arguments);
  };
}();
exports.saveCacheFile = saveCacheFile;
var getResultFromCache = function getResultFromCache(url, cache) {
  var _cache$data, _url$match, _cache$data2;
  var isPagination = url === null || url === void 0 ? void 0 : url.includes("p=");
  var result = (_cache$data = cache.data) === null || _cache$data === void 0 ? void 0 : _cache$data[url];
  if (result) {
    return result;
  }
  var ampersandOrQuestionMark = url.includes("?") ? "&" : "?";
  var urlWithPagination = ((_url$match = url.match(/p=[0-9]*/)) === null || _url$match === void 0 ? void 0 : _url$match[0]) === "p=1" ? url.replace(/(\?|\&)p=1/, "") : url;
  return (_cache$data2 = cache.data) === null || _cache$data2 === void 0 ? void 0 : _cache$data2[isPagination ? urlWithPagination : "".concat(url).concat(ampersandOrQuestionMark, "p=1")];
};
exports.getResultFromCache = getResultFromCache;
var setUrlInCache = function setUrlInCache(url, result, cache) {
  return cache.data[url] = result;
};
exports.setUrlInCache = setUrlInCache;

/***/ }),

/***/ 78611:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = checkIfSpecialPriceApplies;
function checkIfSpecialPriceApplies(fromDate, toDate) {
  if (!toDate && !fromDate) return true;
  var currentTime = new Date().getTime();
  var toDateTime = toDate && new Date(toDate.replace(" ", "T")).getTime();
  var fromDateTime = fromDate && new Date(fromDate.replace(" ", "T")).getTime();
  if (!fromDate) {
    return currentTime <= toDateTime;
  }
  if (!toDate) {
    return currentTime >= fromDateTime;
  }
  return !(currentTime > toDateTime || currentTime < fromDateTime);
}

/***/ }),

/***/ 62639:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getDate = function getDate() {
  var date = new Date();
  var day = String(date.getDate()).padStart(2, "0");
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var year = String(date.getFullYear());
  return "".concat(year).concat(month).concat(day);
};
var couponHit = function couponHit(language) {
  return "HD".concat(getDate()).concat(language.toUpperCase());
};
var _default = couponHit;
exports["default"] = _default;

/***/ }),

/***/ 18934:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createParametrizedUrl;
function createParametrizedUrl(url, params) {
  Object.keys(params).forEach(function (key) {
    return url = url.replace("{".concat(key, "}"), params[key]);
  });
  return url;
}

/***/ }),

/***/ 8371:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CONNECTORS = exports.createSearchUrl = exports["default"] = void 0;
var CONNECTORS = {
  AND: "and",
  OR: "or"
};
exports.CONNECTORS = CONNECTORS;
var createSearchUrl = function createSearchUrl(url, params) {
  return url + params.map(function (param, index, array) {
    var searchQuery = "";
    var ampersand = array.length === 1 || index <= 0 ? "?" : "&";
    var filtersGroupIndex = param.connector === CONNECTORS.AND ? index : 0;
    var filtersIndex = param.connector === CONNECTORS.OR ? index : 0;
    if (param.field) {
      searchQuery += "".concat(ampersand, "searchCriteria[filter_groups][").concat(filtersGroupIndex, "][filters][").concat(filtersIndex, "][field]=").concat(param.field);
    }
    if (param.value !== undefined) {
      searchQuery += "&searchCriteria[filter_groups][".concat(filtersGroupIndex, "][filters][").concat(filtersIndex, "][value]=").concat(param.value);
    }
    if (param.condition_type) {
      searchQuery += "&searchCriteria[filter_groups][".concat(filtersGroupIndex, "][filters][").concat(filtersIndex, "][condition_type]=").concat(param.condition_type);
    }
    if (param.sort_field) {
      searchQuery += "".concat(ampersand, "searchCriteria[sortOrders][").concat(filtersGroupIndex, "][direction]=").concat(param.direction);
    }
    if (param.direction) {
      searchQuery += "&searchCriteria[sortOrders][".concat(filtersGroupIndex, "][field]=").concat(param.sort_field);
    }
    if (param.search_phrase) {
      searchQuery += "".concat(ampersand, "searchCriteria[search_phrase]=").concat(param.search_phrase);
    }
    if (param.pageSize) {
      searchQuery += "".concat(ampersand, "searchCriteria[pageSize]=").concat(param.pageSize);
    }
    if (param.currentPage) {
      searchQuery += "".concat(ampersand, "searchCriteria[currentPage]=").concat(param.currentPage);
    }
    return searchQuery;
  }).join("");
};
exports.createSearchUrl = createSearchUrl;
var _default = createSearchUrl;
exports["default"] = _default;

/***/ }),

/***/ 96273:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var createUrlWithNameId = function createUrlWithNameId(name, id) {
  var nameToDisplay = name ? name.toLowerCase() : "";
  nameToDisplay = nameToDisplay.replace(/ą/g, "a").replace(/ć/g, "c").replace(/ę/g, "e").replace(/ł/g, "l").replace(/ó/g, "o").replace(/ś/g, "s").replace(/ż/g, "z").replace(/ź/g, "z").replace(/,/g, "").replace(/\s/g, "-");
  nameToDisplay = nameToDisplay + "-" + id;
  return nameToDisplay;
};
var _default = createUrlWithNameId;
exports["default"] = _default;

/***/ }),

/***/ 63424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _canvas = __webpack_require__(83319);
var generateBlurUrl = function generateBlurUrl(arr, width, height) {
  return getDataUrlFromArr(arr, width, height);
};
function getDataUrlFromArr(arr, width, height) {
  if (typeof width === "undefined" || typeof height === "undefined") {
    width = height = Math.sqrt(arr.length / 4);
  }
  var canvas = new _canvas.createCanvas();
  var ctx = canvas.getContext("2d");
  canvas.width = width;
  canvas.height = height;
  var imgData = ctx.createImageData(width, height);
  imgData.data.set(arr);
  ctx.putImageData(imgData, 0, 0);
  return canvas.toDataURL();
}
var _default = generateBlurUrl;
exports["default"] = _default;

/***/ }),

/***/ 36575:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getAttribute;
function getAttribute(custom_attributes) {
  if (custom_attributes === undefined) throw Error("Custom attributes s\u0105 puste");
  return function (attributeName) {
    var attribute = custom_attributes.filter(function (attribute) {
      return attribute.attribute_code.toLowerCase() === attributeName.toLowerCase();
    });
    return function (attributeKey) {
      return attribute.length ? attribute[0][attributeKey] : null;
    };
  };
}

/***/ }),

/***/ 705:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDefaultCategoryProductImage = exports["default"] = void 0;
var getDefaultProductImage = function getDefaultProductImage(imageType, language, productData) {
  var findImageAndMapImages = function findImageAndMapImages(imageType) {
    var _productData$product;
    var defaultProductImage = productData === null || productData === void 0 ? void 0 : (_productData$product = productData.product) === null || _productData$product === void 0 ? void 0 : _productData$product.images.find(function (image) {
      return image[imageType];
    });
    if (!defaultProductImage) return false;
    var newProductImages = [];
    if (defaultProductImage) {
      var _productData$product2;
      (_productData$product2 = productData.product) === null || _productData$product2 === void 0 ? void 0 : _productData$product2.images.forEach(function (image) {
        if (!image[imageType]) {
          newProductImages.push(image);
        }
      });
    }
    newProductImages.unshift(defaultProductImage);
    return newProductImages;
  };
  var defaultAllegroImage = imageType[language] === "allegro";
  var defaultArrangedImage = imageType[language] === "arranged";
  if (defaultAllegroImage) {
    return findImageAndMapImages("allegroImage");
  } else if (defaultArrangedImage) {
    return findImageAndMapImages("arrangedImage");
  }
  return false;
};
var getDefaultCategoryProductImage = function getDefaultCategoryProductImage(imageType, language, product) {
  if (!product) return false;
  var defaultImage;
  if (imageType[language] === "allegro") {
    product.images.find(function (image) {
      if (image.allegroImage) {
        defaultImage = image;
      }
    });
  } else if (imageType[language] === "arranged") {
    product.images.find(function (image) {
      if (image.arrangedImage) {
        defaultImage = image;
      }
    });
  }
  return defaultImage;
};
exports.getDefaultCategoryProductImage = getDefaultCategoryProductImage;
var _default = getDefaultProductImage;
exports["default"] = _default;

/***/ }),

/***/ 2955:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var getDomainAndLanguage = function getDomainAndLanguage(_ref) {
  var host = _ref.host;
  var hostWithoutWww = host.replace("www.", "");
  var language = __webpack_require__.g.__appConfig__.domainLanguages[hostWithoutWww];
  var domain = Object.keys(__webpack_require__.g.__appConfig__.domainLanguages).find(function (key) {
    return key === hostWithoutWww;
  });
  if (!language || !domain) {
    console.error("Error configuration with language and domain: ".concat(language, " ").concat(domain, ", host: ").concat(host, ", ").concat(JSON.stringify(__webpack_require__.g.__appConfig__.domainLanguages)));
    return {
      error: true
    };
  }
  return {
    language: language,
    domain: domain,
    host: hostWithoutWww
  };
};
var _default = getDomainAndLanguage;
exports.Z = _default;

/***/ }),

/***/ 81509:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getLanguageFromHostname = function getLanguageFromHostname() {
  if (typeof window === "undefined") return undefined;
  var langDomains = __webpack_require__.g.__appConfig__.domainLanguages;
  var chosenLanguage = langDomains[window.location.hostname];
  if (chosenLanguage === undefined) {
    var fullUrl = window.location.href;
    var language = fullUrl.replace(/(https|http):\/\/[^\/]+\//, "");
    if (language.length > 0) {
      chosenLanguage = language;
    } else {
      Object.values(langDomains).every(function (lang) {
        if (fullUrl.includes("/" + lang + "/")) {
          chosenLanguage = lang;
          return false;
        }
        return true;
      });
    }
  }
  return chosenLanguage;
};
var _default = getLanguageFromHostname;
exports["default"] = _default;

/***/ }),

/***/ 15851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _pathMatch = _interopRequireDefault(__webpack_require__(10154));
var route = (0, _pathMatch["default"])();
var languages = function languages(_languages) {
  return (_languages ? _languages : __webpack_require__.g.__appConfig__.languages).split(",").reduce(function (lang, elem) {
    lang[elem] = elem;
    return lang;
  }, {});
};
var getLanguageFromUrl = function getLanguageFromUrl(url, langs) {
  if (url[0] !== "/") {
    url = "/".concat(url);
  }
  var lang = route("/:subpath(".concat(Object.values(languages(langs)).join("|"), ")(.*)"))(url);
  return lang ? lang.subpath : "";
};
var _default = getLanguageFromUrl;
exports["default"] = _default;

/***/ }),

/***/ 63712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getLowProductAvailability = function getLowProductAvailability(availabilityLevel) {
  var outOfStockCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return outOfStockCheck ? availabilityLevel === __webpack_require__.g.__appConfig__.outOfStockProductAvailability : availabilityLevel === __webpack_require__.g.__appConfig__.lowProductAvailability;
};
var _default = getLowProductAvailability;
exports["default"] = _default;

/***/ }),

/***/ 544:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getPrismicDocumentLang = function getPrismicDocumentLang(language) {
  switch (language) {
    case "pl":
      return "pl";
    case "en":
      return "en-gb";
    case "gb":
      return "en-gb";
    case "es":
      return "es-es";
    case "fr":
      return "fr-fr";
    case "de":
      return "de-de";
    case "it":
      return "it-it";
    case "ro":
      return "ro";
    case "se":
      return "sv-se";
    case "sk":
      return "sk";
    case "cz":
      return "cs-cz";
    case undefined:
      return "en-gb";
    default:
      return "en-gb";
  }
};
var _default = getPrismicDocumentLang;
exports["default"] = _default;

/***/ }),

/***/ 5446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getPromoCategory = function getPromoCategory(_ref) {
  var _global$__appConfig__;
  var language = _ref.language,
    ids = _ref.ids;
  if (!__webpack_require__.g.__appConfig__.promoCategoryPerCountry || !ids) {
    return;
  }
  return ids === null || ids === void 0 ? void 0 : ids.includes((_global$__appConfig__ = __webpack_require__.g.__appConfig__.promoCategoryPerCountry[language]) === null || _global$__appConfig__ === void 0 ? void 0 : _global$__appConfig__.category);
};
var _default = getPromoCategory;
exports["default"] = _default;

/***/ }),

/***/ 61328:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getRouteFromUrl = function getRouteFromUrl(url) {
  if (!url) return;
  if (firstWord({
    url: url,
    word: "article/"
  })) return "article";
  if (firstWord({
    url: url,
    word: "inspirations"
  })) return "inspirations";
  if (firstWord({
    url: url,
    word: "promotions"
  })) return "promotions";
  if (firstWord({
    url: url,
    word: "info/"
  })) return "info";
  if (firstWord({
    url: url,
    word: "newsletter/signup"
  })) return "newsletter-signup";
  if (firstWord({
    url: url,
    word: "newsletter/signoff"
  })) return "newsletter-signoff";
  return "category-page";
};
var firstWord = function firstWord(_ref) {
  var url = _ref.url,
    word = _ref.word;
  if (url[0] === "/") {
    url = url.slice(1);
  }
  return url.substring(0, word.length).includes(word);
};
var _default = getRouteFromUrl;
exports["default"] = _default;

/***/ }),

/***/ 40408:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _createSearchUrl = __webpack_require__(8371);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var getSearchUrl = function getSearchUrl(_ref) {
  var url = _ref.url,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? null : _ref$query,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 0 : _ref$currentPage,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
    _ref$pickedFilters = _ref.pickedFilters,
    pickedFilters = _ref$pickedFilters === void 0 ? {} : _ref$pickedFilters,
    categoryId = _ref.categoryId,
    lang = _ref.lang,
    _ref$productSearch = _ref.productSearch,
    productSearch = _ref$productSearch === void 0 ? true : _ref$productSearch;
  var params = Object.keys(pickedFilters).reduce(function (currentFilters, filterName) {
    if (filterName === "sort") {
      currentFilters.push({
        sort_field: pickedFilters[filterName].value.split("-")[0],
        direction: pickedFilters[filterName].value.split("-")[1],
        connector: _createSearchUrl.CONNECTORS.AND
      });
      return currentFilters;
    }
    if (Array.isArray(pickedFilters[filterName])) {
      currentFilters.push({
        field: filterName === "cat" ? "category_id" : filterName,
        value: pickedFilters[filterName].map(function (el) {
          return el.id;
        }),
        condition_type: "in",
        connector: _createSearchUrl.CONNECTORS.AND
      });
    } else {
      Object.keys(pickedFilters[filterName]).forEach(function (key) {
        currentFilters.push({
          field: filterName,
          value: pickedFilters[filterName][key],
          condition_type: key.replace("max", "to").replace("min", "from"),
          connector: _createSearchUrl.CONNECTORS.AND
        });
      });
    }
    return currentFilters;
  }, []);
  if (!pickedFilters["cat"] && categoryId) {
    params.unshift({
      field: "category_id",
      condition_type: "eq",
      value: categoryId,
      connector: _createSearchUrl.CONNECTORS.AND
    });
  }
  if (query) {
    params.unshift({
      search_phrase: query,
      connector: _createSearchUrl.CONNECTORS.AND
    });
  }
  if (productSearch) {
    params.push(pageSize ? {
      pageSize: pageSize
    } : {}, currentPage ? {
      currentPage: currentPage
    } : {}, {
      field: "type_id",
      value: "simple",
      connector: _createSearchUrl.CONNECTORS.AND
    }, {
      field: "visibility",
      condition_type: "in",
      value: __webpack_require__.g.__appConfig__.visibilityValuesForProductsList,
      connector: _createSearchUrl.CONNECTORS.AND
    });
  }
  if (categoryId) {
    if (!("sort" in pickedFilters)) {
      params.push({
        sort_field: __webpack_require__.g.__appConfig__.defaultSort.split("-")[0],
        direction: __webpack_require__.g.__appConfig__.defaultSort.split("-")[1],
        connector: _createSearchUrl.CONNECTORS.AND
      });
      params.push({
        sort_field: __webpack_require__.g.__appConfig__.defaultSortAdditionalParameter.split("-")[0],
        direction: __webpack_require__.g.__appConfig__.defaultSortAdditionalParameter.split("-")[1],
        connector: _createSearchUrl.CONNECTORS.AND
      });
    }
  }
  return __webpack_require__.g.__appConfig__.elasticEnabled ? "".concat((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.elasticEndpointUrl, {
    lang: lang.language,
    domain: lang.domain
  })).concat((0, _createSearchUrl.createSearchUrl)(url, params.filter(function (param) {
    return Object.keys(param).length > 0;
  }))) : "".concat((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.restRootEndpointUrl, {
    lang: lang
  })).concat((0, _createSearchUrl.createSearchUrl)(url, [{
    field: "type_id",
    value: "simple",
    connector: _createSearchUrl.CONNECTORS.AND
  }, {
    field: "name",
    value: "".concat(encodeURI(query)),
    condition_type: "like",
    connector: _createSearchUrl.CONNECTORS.AND
  }, {
    pageSize: pageSize
  }, {
    currentPage: currentPage
  }]));
};
var _default = getSearchUrl;
exports["default"] = _default;

/***/ }),

/***/ 36928:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var handleAdyenErrorMessage = function handleAdyenErrorMessage(responseError) {
  var adyenComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var handleMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  handleMessage && responseError.message && handleMessage(responseError.message, false, false, "", true);
  if (adyenComponent) {
    adyenComponent.unmount();
    adyenComponent.mount(adyenComponent.elementRef.elementRef._node);
  }
  return responseError.message;
};
var _default = handleAdyenErrorMessage;
exports["default"] = _default;

/***/ }),

/***/ 36229:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var hasStoreAdditionalFunctionalities = function hasStoreAdditionalFunctionalities(language) {
  var _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  return Boolean(parseInt((_global$__appConfig__ = (_global$__appConfig__2 = __webpack_require__.g.__appConfig__) === null || _global$__appConfig__2 === void 0 ? void 0 : (_global$__appConfig__3 = _global$__appConfig__2.storeAdditionalFunctionalities) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3[language === null || language === void 0 ? void 0 : language.language]) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : 0));
};
var _default = hasStoreAdditionalFunctionalities;
exports["default"] = _default;

/***/ }),

/***/ 46484:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var isDiscount = function isDiscount(regularPrice, specialPrice) {
  return specialPrice !== null && parseFloat(specialPrice) < parseFloat(regularPrice);
};
var _default = isDiscount;
exports["default"] = _default;

/***/ }),

/***/ 98250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var newsletterSignUpLanguages = function newsletterSignUpLanguages(_ref) {
  var _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  var language = _ref.language;
  return (_global$__appConfig__ = __webpack_require__.g.__appConfig__) === null || _global$__appConfig__ === void 0 ? void 0 : (_global$__appConfig__2 = _global$__appConfig__.newsletterSignUpLanguages) === null || _global$__appConfig__2 === void 0 ? void 0 : (_global$__appConfig__3 = _global$__appConfig__2.split(",")) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3.includes(language);
};
var _default = newsletterSignUpLanguages;
exports["default"] = _default;

/***/ }),

/***/ 58592:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var isSalesmanagoEnabled = function isSalesmanagoEnabled(_ref) {
  var _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  var language = _ref.language;
  return (_global$__appConfig__ = __webpack_require__.g.__appConfig__) === null || _global$__appConfig__ === void 0 ? void 0 : (_global$__appConfig__2 = _global$__appConfig__.salesmanagoEnabledLang) === null || _global$__appConfig__2 === void 0 ? void 0 : (_global$__appConfig__3 = _global$__appConfig__2.split(",")) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3.includes(language);
};
var _default = isSalesmanagoEnabled;
exports["default"] = _default;

/***/ }),

/***/ 51493:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _useTranslation2 = _interopRequireDefault(__webpack_require__(33872));
var translate = function translate(string) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _useTranslation = (0, _useTranslation2["default"])(),
    t = _useTranslation.t;
  return params ? t(string, params) : t(string);
};
var _default = translate;
exports["default"] = _default;

/***/ }),

/***/ 12248:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapAddressNew = function mapAddressNew(address) {
  var _address$email, _address$firstname, _address$lastname, _address$postcode, _address$city, _address$country, _address$telephone, _address$company, _address$vat_id;
  var isCartFetcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    email: (_address$email = address.email) !== null && _address$email !== void 0 ? _address$email : "",
    isCompany: !!(address.company && address.vat_id),
    firstName: (_address$firstname = address.firstname) !== null && _address$firstname !== void 0 ? _address$firstname : "",
    lastName: (_address$lastname = address.lastname) !== null && _address$lastname !== void 0 ? _address$lastname : "",
    street: address.street,
    postalCode: (_address$postcode = address.postcode) !== null && _address$postcode !== void 0 ? _address$postcode : "",
    city: (_address$city = address.city) !== null && _address$city !== void 0 ? _address$city : "",
    country: isCartFetcher ? {
      id: address === null || address === void 0 ? void 0 : address.country_id
    } : (_address$country = address.country) === null || _address$country === void 0 ? void 0 : _address$country[0],
    phone: (_address$telephone = address.telephone) !== null && _address$telephone !== void 0 ? _address$telephone : "",
    companyName: (_address$company = address.company) !== null && _address$company !== void 0 ? _address$company : "",
    vatId: (_address$vat_id = address.vat_id) !== null && _address$vat_id !== void 0 ? _address$vat_id : ""
  };
};
var _default = mapAddressNew;
exports["default"] = _default;

/***/ }),

/***/ 33074:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _mapAddressNew = _interopRequireDefault(__webpack_require__(12248));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapAddressesCollection = function mapAddressesCollection(accountData, separateEmail) {
  var _accountData$addresse, _accountData$addresse2;
  return (_accountData$addresse = accountData === null || accountData === void 0 ? void 0 : (_accountData$addresse2 = accountData.addresses) === null || _accountData$addresse2 === void 0 ? void 0 : _accountData$addresse2.map(function (address) {
    var _address$companyName, _address$vatId;
    return {
      id: address.id + "",
      isDefaultShipping: !!address.default_shipping,
      isDefaultBilling: !!address.default_billing,
      fields: _objectSpread({}, (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, address), {}, {
        isCompany: address.company !== undefined,
        firstName: address.firstname,
        lastName: address.lastname,
        email: !separateEmail ? accountData.email : separateEmail,
        companyName: (_address$companyName = address.companyName) !== null && _address$companyName !== void 0 ? _address$companyName : "",
        vatId: (_address$vatId = address.vatId) !== null && _address$vatId !== void 0 ? _address$vatId : "",
        street: Array.isArray(address.street) ? address.street[0] : address.street,
        postalCode: address.postcode,
        phone: address.telephone,
        city: address.city,
        country: [{
          id: address.country_id
        }]
      })))
    };
  })) !== null && _accountData$addresse !== void 0 ? _accountData$addresse : [];
};
var _default = mapAddressesCollection;
exports["default"] = _default;

/***/ }),

/***/ 25037:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapAvailableCountries = function mapAvailableCountries(countries) {
  return countries.map(function (country) {
    return {
      id: country.id,
      label: country.full_name_locale
    };
  });
};
var _default = mapAvailableCountries;
exports["default"] = _default;

/***/ }),

/***/ 90180:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.mapTotals = exports.mapItem = void 0;
var mapItem = function mapItem(item) {
  return {
    itemId: item.item_id,
    name: item.name,
    sku: item.sku,
    quantity: item.qty,
    price: item.price
  };
};
exports.mapItem = mapItem;
var mapTotals = function mapTotals(totals) {
  var _totals$total_segment, _totals$total_segment2, _totals$total_segment3, _totals$total_segment4, _totals$total_segment5, _totals$total_segment6;
  return {
    tax: totals === null || totals === void 0 ? void 0 : totals.base_tax_amount,
    productsTotalPrice: totals === null || totals === void 0 ? void 0 : totals.subtotal_incl_tax,
    cartTotalPrice: totals === null || totals === void 0 ? void 0 : totals.base_grand_total,
    shippingCost: totals === null || totals === void 0 ? void 0 : totals.base_shipping_incl_tax,
    discount: totals === null || totals === void 0 ? void 0 : totals.discount_amount,
    ePremia: totals === null || totals === void 0 ? void 0 : (_totals$total_segment = totals.total_segments.find(function (segment) {
      return segment.code === "rewardpoints_discount";
    })) === null || _totals$total_segment === void 0 ? void 0 : _totals$total_segment.value,
    ePremiaPoints: totals === null || totals === void 0 ? void 0 : totals.ePremiaPoints,
    couponCode: totals === null || totals === void 0 ? void 0 : totals.coupon_code,
    taxPercent: makeNumber(totals === null || totals === void 0 ? void 0 : (_totals$total_segment2 = totals.total_segments.find(function (segment) {
      return segment.code === "tax";
    })) === null || _totals$total_segment2 === void 0 ? void 0 : (_totals$total_segment3 = _totals$total_segment2.extension_attributes.tax_grandtotal_details) === null || _totals$total_segment3 === void 0 ? void 0 : (_totals$total_segment4 = _totals$total_segment3[0]) === null || _totals$total_segment4 === void 0 ? void 0 : (_totals$total_segment5 = _totals$total_segment4.rates) === null || _totals$total_segment5 === void 0 ? void 0 : (_totals$total_segment6 = _totals$total_segment5[0]) === null || _totals$total_segment6 === void 0 ? void 0 : _totals$total_segment6.percent)
  };
};
exports.mapTotals = mapTotals;
var makeNumber = function makeNumber(percent) {
  if (!percent) return null;
  return parseFloat("0.".concat(percent));
};

/***/ }),

/***/ 85973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = mapCategories;
var _createUrlWithNameId = _interopRequireDefault(__webpack_require__(96273));
var _rootCategory = __webpack_require__(84660);
function mapCategories(response) {
  var mapCategoryData = function mapCategoryData(categoryData) {
    return response.hasOwnProperty("children_data") && categoryData.children_data.map(function (category) {
      var finalUrl = category.special_url ? category.special_url : category.url_path ? category.url_path : (0, _createUrlWithNameId["default"])(category.name, category.id);
      return {
        name: category.name,
        id: category.id,
        parentId: category.parent_id,
        hasSpecialUrl: category.special_url !== null,
        image: {
          altText: category.name,
          originalSrc: category.image && category.image[0].src,
          variants: [{
            name: "natural",
            aspectRatio: category.image && category.image[0].width / category.image[0].height,
            srcset: [{
              url: category.image && category.image[0].src,
              w: category.image && category.image[0].width,
              h: category.image && category.image[0].height
            }]
          }]
        },
        url: (0, _rootCategory.removeRootCategory)(finalUrl),
        subcategories: mapCategoryData(category),
        visibleInMenu: category.include_in_menu
      };
    });
  };
  return mapCategoryData(response);
}

/***/ }),

/***/ 7543:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = mapCategory;
var _getAttribute = _interopRequireDefault(__webpack_require__(36575));
var _rootCategory = __webpack_require__(84660);
function mapCategory(response) {
  var isFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var getUrl = arguments.length > 3 ? arguments[3] : undefined;
  var isForMenu = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var addSubcategory = function addSubcategory(subcategories, path, isFirst) {
    var subcategory = subcategories.map(function (category) {
      return createCategory(category, false, path);
    }).filter(function (category) {
      return category !== undefined;
    });
    if (subcategory.length === 0) {
      return [];
    }
    return isFirst && response.children_data.length ? [subcategory] : subcategory;
  };
  var mapImage = function mapImage(category) {
    if (__webpack_require__.g.__appConfig__.categoryImageEnabled && category.image != null && category.image[0].src) {
      category.image[0].src = category.image[0].src.replace(__webpack_require__.g.__appConfig__.svgImgUrl, "");
      return {
        altText: category.name,
        originalSrc: category.image[0].src,
        variants: [{
          name: "natural",
          aspectRatio: 1,
          srcset: [{
            url: category.image[0].src,
            w: category.image[0].width,
            h: category.image[0].height
          }]
        }]
      };
    }
    if (!category.extension_attributes || !category.extension_attributes.image_dimensions) return {};
    var imageDimensions = category.extension_attributes.image_dimensions;
    return {
      altText: category.name,
      originalSrc: imageDimensions[0].src,
      variants: [{
        name: "natural",
        aspectRatio: imageDimensions ? imageDimensions[0].width / imageDimensions[0].height : 1,
        srcset: [{
          url: imageDimensions[0].src,
          w: imageDimensions[0].width,
          h: imageDimensions[0].height
        }]
      }]
    };
  };
  var createUrl = function createUrl(category) {
    return category.special_url ? category.special_url : category.url_path ? category.url_path : getUrl("category-page", {
      id: category.id
    }).as;
  };
  var mapUrl = function mapUrl(url) {
    var _url$find;
    return (_url$find = url.find(function (attribute) {
      if (attribute.attribute_code === "url_path") {
        return attribute.value;
      }
    })) === null || _url$find === void 0 ? void 0 : _url$find.value;
  };
  var createCategory = function createCategory(response) {
    var isFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (!response || !response.children_data && !response.custom_attributes || isForMenu && !response.include_in_menu) return;
    path = path.concat([response.id]);
    return {
      name: response.name,
      id: response.id,
      level: response.level,
      meta: {
        title: response.custom_attributes ? (0, _getAttribute["default"])(response.custom_attributes)("meta_title")("value") : null,
        description: response.custom_attributes ? (0, _getAttribute["default"])(response.custom_attributes)("meta_description")("value") : null
      },
      parentId: response.parent_id,
      theme: response.custom_attributes ? (0, _getAttribute["default"])(response.custom_attributes)("layout_update")("value") : null,
      columnInMenu: response.menu_column ? parseInt(response.menu_column) : 0,
      positionInColumn: response.menu_position ? parseInt(response.menu_position) : 0,
      special: false,
      hasSpecialUrl: response.special_url !== null,
      path: path,
      url: (0, _rootCategory.removeRootCategory)(response.children_data && !response.extension_attributes ? createUrl(response) : mapUrl(response.custom_attributes)),
      subcategories: response.custom_attributes ? [] : addSubcategory(response.children_data, path, isFirst),
      image: mapImage(response)
    };
  };
  return createCategory(response, isFirst, path);
}

/***/ }),

/***/ 90576:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapPoints = function mapPoints(ePremia) {
  return {
    availablePoints: ePremia.balance,
    lockedPoints: ePremia.balance_locked,
    history: ePremia.history.map(function (history) {
      return mapEPointsHistory(history);
    }).sort(function (current, next) {
      return new Date(next.date) - new Date(current.date);
    })
  };
};
var mapEPointsHistory = function mapEPointsHistory(history) {
  return history !== null && history !== void 0 && history.email ? {
    date: history.date,
    email: history.email,
    action: history.action,
    event: history.event
  } : {
    date: history.order_date,
    order: history.order,
    action: history.action,
    event: history.event,
    points: history.points
  };
};
var _default = mapPoints;
exports["default"] = _default;

/***/ }),

/***/ 24350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _mapCategory = _interopRequireDefault(__webpack_require__(7543));
var mapMenu = function mapMenu(menu, getUrl) {
  return menu.map(function (category) {
    if (category.is_active && category.include_in_menu) {
      return (0, _mapCategory["default"])(category, true, [], getUrl, true);
    }
  }).filter(function (category) {
    return category !== undefined;
  });
};
var _default = mapMenu;
exports["default"] = _default;

/***/ }),

/***/ 90731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = mapOrder;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _mapProductOrder = _interopRequireDefault(__webpack_require__(56212));
var _imagesNew = __webpack_require__(19611);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mapOrder(order, productsForImage) {
  var _order$payment, _order$payment$additi;
  var billingAddress = order.billingAddress,
    shippingAddress = order.shippingAddress,
    shipments = order.shipments;
  var products = order.products;
  products = products.map(function (product) {
    var _productsForImage$fil;
    var productImage = productsForImage === null || productsForImage === void 0 ? void 0 : (_productsForImage$fil = productsForImage.filter(function (productImage) {
      return productImage.sku === product.sku;
    })) === null || _productsForImage$fil === void 0 ? void 0 : _productsForImage$fil[0];
    return (0, _mapProductOrder["default"])(_objectSpread(_objectSpread({}, product), {}, {
      image: productImage !== null && productImage !== void 0 && productImage.image ? productImage === null || productImage === void 0 ? void 0 : productImage.image : _imagesNew.no_image,
      url: productImage === null || productImage === void 0 ? void 0 : productImage.url
    }));
  });
  var tracks = shipments === null || shipments === void 0 ? void 0 : shipments[0].tracks.map(function (track) {
    return {
      trackNumber: track.track_number,
      courierName: track.title
    };
  });
  return {
    id: order.increment_id,
    totalPrice: order.base_grand_total,
    status: order.status,
    isPaymentPaid: order.payment.amount_ordered === order.payment.amount_paid,
    methodPayment: order.payment.method,
    paymentType: (_order$payment = order.payment) === null || _order$payment === void 0 ? void 0 : (_order$payment$additi = _order$payment.additional_information) === null || _order$payment$additi === void 0 ? void 0 : _order$payment$additi[0],
    billingAddress: billingAddress,
    shippingAddress: shippingAddress,
    skus: order.skus,
    tracks: tracks,
    creationDate: order.created_at,
    updateDate: order.updated_at,
    shippingPrice: order.shipping_incl_tax,
    tax: order.base_tax_amount,
    discount: order.base_discount_amount,
    subtotal: order.base_subtotal_incl_tax,
    products: products,
    ePoints: order.extension_attributes.rewardpoints_earn ? {
      ePointsEarned: order.extension_attributes.rewardpoints_earn,
      ePointsSpent: order.extension_attributes.rewardpoints_spent,
      priceDiscount: order.extension_attributes.rewardpoints_discount
    } : {}
  };
}

/***/ }),

/***/ 861:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapPickupPoints = function mapPickupPoints(pointsData) {
  var mappedPoints = [];
  if (pointsData != undefined && pointsData.items.length > 0) {
    pointsData.items.map(function (singlePoint) {
      mappedPoints.push({
        id: singlePoint.pickup_location_code,
        label: singlePoint.name + " " + singlePoint.street + " " + singlePoint.city,
        data: singlePoint
      });
    });
    return mappedPoints;
  }
  return null;
};
var _default = mapPickupPoints;
exports["default"] = _default;

/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var checkCategoryIdByPath = function checkCategoryIdByPath(_ref) {
  var paths = _ref.paths,
    id = _ref.id;
  var rootCategory = "/29/";
  var pathList = [];
  paths.forEach(function (path, index) {
    if (!path.path.includes(rootCategory)) {
      pathList.push(paths[index].path);
    }
  });
  if (pathList.length === 0) {
    return null;
  }
  if (pathList.find(function (path) {
    return path.includes("".concat(id));
  })) {
    return id;
  }
  return null;
};
var _default = checkCategoryIdByPath;
exports["default"] = _default;

/***/ }),

/***/ 78667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _checkCategoryIdByPath = _interopRequireDefault(__webpack_require__(7414));
var getMainCategoryId = function getMainCategoryId(_ref) {
  var idList = _ref.idList,
    paths = _ref.paths;
  var mainCategory = 2;
  if (idList.length > 0) {
    var ids = (0, _toConsumableArray2["default"])(new Set(idList));
    mainCategory = ids.find(function (category) {
      return (0, _checkCategoryIdByPath["default"])({
        paths: paths,
        id: category
      }) === category;
    });
  }
  return mainCategory;
};
var _default = getMainCategoryId;
exports["default"] = _default;

/***/ }),

/***/ 69729:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = mapProductData;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _imagesNew = _interopRequireDefault(__webpack_require__(19611));
var _checkIfSpecialPriceIsActive = _interopRequireDefault(__webpack_require__(78611));
var _getAttribute = _interopRequireDefault(__webpack_require__(36575));
var _getMainCategoryId = _interopRequireDefault(__webpack_require__(78667));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapProduct = function mapProduct(data, differentiators) {
  var _data$extension_attri, _data$extension_attri2, _data$extension_attri3, _data$extension_attri4, _data$custom_attribut, _data$extension_attri5, _data$extension_attri6, _data$extension_attri7, _data$product_links, _data$extension_attri8, _data$extension_attri9, _data$extension_attri10, _data$extension_attri11, _data$extension_attri12, _ref2, _firstImageBlur$filen, _data$extension_attri13, _data$extension_attri14, _firstImageBlur$filen2, _data$extension_attri15, _data$extension_attri16;
  var customAttributes = (0, _getAttribute["default"])(data.custom_attributes);
  var hasSpecialPrice = (0, _checkIfSpecialPriceIsActive["default"])(customAttributes("special_from_date")("value"), customAttributes("special_to_date")("value"));
  var specialPrice = function specialPrice(hasSpecialPrice, _specialPrice) {
    return !hasSpecialPrice ? null : _specialPrice ? parseFloat(_specialPrice) : null;
  };
  var getBlurAndFileNameImage = function getBlurAndFileNameImage(imageFile) {
    var _imageFound$extension2, _imageFound$extension3;
    if (!imageFile) {
      return;
    }
    var imageFileNew = imageFile.replace("media/catalog/product/", "");
    var imageFound = data.media_gallery_entries.find(function (image) {
      return image.file === imageFileNew;
    });
    if (!imageFound || !(imageFound !== null && imageFound !== void 0 && imageFound.extension_attributes)) {
      return;
    }
    imageFileNew = imageFileNew.replace(/([^\/]+)$/, "$width/");
    var _imageFound$extension = imageFound === null || imageFound === void 0 ? void 0 : imageFound.extension_attributes,
      blurhash = _imageFound$extension.blurhash,
      filename = _imageFound$extension.filename;
    return {
      blurhash: blurhash,
      filename: parseInt(imageFound === null || imageFound === void 0 ? void 0 : (_imageFound$extension2 = imageFound.extension_attributes) === null || _imageFound$extension2 === void 0 ? void 0 : _imageFound$extension2.servlocal) ? imageFileNew + filename : imageFile,
      servlocal: parseInt(imageFound === null || imageFound === void 0 ? void 0 : (_imageFound$extension3 = imageFound.extension_attributes) === null || _imageFound$extension3 === void 0 ? void 0 : _imageFound$extension3.servlocal)
    };
  };
  var dajarCollection = customAttributes("dajar_collection");
  var availability = customAttributes("availability");
  var producer = customAttributes("producer")("name");
  var producerId = customAttributes("producer")("value");
  var pickedOptions = differentiators ? data.custom_attributes.filter(function (attribute) {
    var _attribute$attribute_;
    return differentiators.includes((_attribute$attribute_ = attribute === null || attribute === void 0 ? void 0 : attribute.attribute_code) !== null && _attribute$attribute_ !== void 0 ? _attribute$attribute_ : attribute.label);
  }).map(function (attribute) {
    if (attribute.attribute_code === "capacity") {
      return _objectSpread(_objectSpread({}, attribute), {}, {
        name: (parseInt(attribute.name) / 1000).toString()
      });
    }
    return attribute;
  }) : [];
  var mapOptionImage = function mapOptionImage(image) {
    if (image !== null && image !== void 0 && image.extension_attributes) {
      var imageBlur = getBlurAndFileNameImage(image.file);
      var url = imageBlur !== null && imageBlur !== void 0 && imageBlur.servlocal ? "".concat(imageBlur.filename) : "/media/catalog/product".concat(imageBlur.filename);
      return {
        altText: "image",
        originalSrc: url,
        blurhash: imageBlur.blurhash,
        variants: [{
          name: "natural",
          aspectRatio: 1,
          srcset: [{
            url: url,
            w: 50,
            h: 50
          }]
        }]
      };
    }
    return {
      altText: "image",
      originalSrc: "/media/catalog/product".concat(image.file),
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: "/media/catalog/product".concat(image.file),
          w: 50,
          h: 50
        }]
      }]
    };
  };
  var findOptionPickerImage = function findOptionPickerImage(imagesArray) {
    if ((imagesArray === null || imagesArray === void 0 ? void 0 : imagesArray.length) === 0) return;
    var swatchImage = false;
    imagesArray.find(function (image) {
      if (image.types.includes("swatch_image")) {
        swatchImage = mapOptionImage(image, true);
      }
    });
    !swatchImage && imagesArray.find(function (image) {
      if (image.types.includes("allegro_image")) {
        swatchImage = mapOptionImage(image);
      }
    });
    if (swatchImage) return swatchImage;
    return mapOptionImage(imagesArray[0]);
  };
  var firstImageBlur = (_data$extension_attri = data.extension_attributes) !== null && _data$extension_attri !== void 0 && (_data$extension_attri2 = _data$extension_attri.image_dimensions[0]) !== null && _data$extension_attri2 !== void 0 && _data$extension_attri2.product_page_image_medium ? getBlurAndFileNameImage((_data$extension_attri3 = data.extension_attributes.image_dimensions[0].product_page_image_medium) === null || _data$extension_attri3 === void 0 ? void 0 : _data$extension_attri3.src) : _imagesNew["default"].no_image;
  if (((_data$extension_attri4 = data.extension_attributes.ean) === null || _data$extension_attri4 === void 0 ? void 0 : _data$extension_attri4.length) > 0) {
    data.custom_attributes.push({
      attribute_code: "ean",
      name: data.extension_attributes.ean
    });
  }
  var findImageByType = function findImageByType(imageToCheck, imagesData) {
    var _imageToCheck$product, _imageToCheck$product2, _imageToCheck$product3, _finalImage$types;
    var imageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "allegro_image";
    if (!(imageToCheck !== null && imageToCheck !== void 0 && imageToCheck.product_page_image_medium)) {
      return false;
    }
    var imagePath = (_imageToCheck$product = imageToCheck.product_page_image_medium) === null || _imageToCheck$product === void 0 ? void 0 : (_imageToCheck$product2 = _imageToCheck$product.src) === null || _imageToCheck$product2 === void 0 ? void 0 : (_imageToCheck$product3 = _imageToCheck$product2.split("/product")) === null || _imageToCheck$product3 === void 0 ? void 0 : _imageToCheck$product3.pop();
    var finalImage = imagesData.find(function (image) {
      return image.file === imagePath;
    });
    return finalImage === null || finalImage === void 0 ? void 0 : (_finalImage$types = finalImage.types) === null || _finalImage$types === void 0 ? void 0 : _finalImage$types.includes(imageType);
  };
  var productImages;
  if (data.extension_attributes.image_dimensions.length) {
    productImages = data.extension_attributes.image_dimensions.map(function (image) {
      var _image$product_page_i, _ref, _imageBlur$filename, _image$product_page_i2, _images$no_image, _imageBlur$filename2, _image$product_page_i3, _image$product_page_i4, _image$product_page_i5;
      var imageBlur = image !== null && image !== void 0 && image.product_page_image_medium ? getBlurAndFileNameImage((_image$product_page_i = image.product_page_image_medium) === null || _image$product_page_i === void 0 ? void 0 : _image$product_page_i.src) : null;
      return {
        allegroImage: findImageByType(image, data.media_gallery_entries, "allegro_image"),
        arrangedImage: findImageByType(image, data.media_gallery_entries, "arranged_image"),
        altText: data.name,
        originalSrc: (_ref = (_imageBlur$filename = imageBlur === null || imageBlur === void 0 ? void 0 : imageBlur.filename) !== null && _imageBlur$filename !== void 0 ? _imageBlur$filename : image === null || image === void 0 ? void 0 : (_image$product_page_i2 = image.product_page_image_medium) === null || _image$product_page_i2 === void 0 ? void 0 : _image$product_page_i2.src) !== null && _ref !== void 0 ? _ref : (_images$no_image = _imagesNew["default"].no_image) === null || _images$no_image === void 0 ? void 0 : _images$no_image.originalSrc,
        blurhash: imageBlur === null || imageBlur === void 0 ? void 0 : imageBlur.blurhash,
        variants: image !== null && image !== void 0 && image.product_page_image_medium ? [{
          name: "natural",
          aspectRatio: 1,
          srcset: [{
            url: (_imageBlur$filename2 = imageBlur === null || imageBlur === void 0 ? void 0 : imageBlur.filename) !== null && _imageBlur$filename2 !== void 0 ? _imageBlur$filename2 : (_image$product_page_i3 = image.product_page_image_medium) === null || _image$product_page_i3 === void 0 ? void 0 : _image$product_page_i3.src,
            w: (_image$product_page_i4 = image.product_page_image_medium) === null || _image$product_page_i4 === void 0 ? void 0 : _image$product_page_i4.width,
            h: (_image$product_page_i5 = image.product_page_image_medium) === null || _image$product_page_i5 === void 0 ? void 0 : _image$product_page_i5.height
          }]
        }] : _imagesNew["default"].no_image.variants
      };
    });
    productImages.find(function (image, index) {
      if (image.pdpDefault) {
        productImages.splice(index, 1);
        productImages.unshift(image);
      }
    });
  } else {
    productImages = [_objectSpread({
      altText: data.name
    }, _imagesNew["default"].no_image)];
  }
  var attributes = ((_data$custom_attribut = data.custom_attributes) === null || _data$custom_attribut === void 0 ? void 0 : _data$custom_attribut[0]) && data.custom_attributes;
  var technicalData = [];
  var productWeight = (_data$extension_attri5 = data.extension_attributes) === null || _data$extension_attri5 === void 0 ? void 0 : _data$extension_attri5.weight_net;
  if (attributes) {
    var technicalDataNamesOrder = ["brand", "producer", "dajar_collection", "diameter", "capacity", "length", "width", "height", "depth", "thickness", "weight", "max_load", "number_of_people", "material", "composition", "application", "feature", "color_list", "pattern_list", "country_of_origin",
    // nie wiem czy taki jest kod, nie kojarze tego
    "ean"];
    technicalDataNamesOrder.map(function (dataName) {
      if (dataName !== "weight") {
        var attribute = attributes === null || attributes === void 0 ? void 0 : attributes.find(function (attribute) {
          return attribute.attribute_code === dataName;
        });
        technicalData.push({
          label: dataName,
          name: attribute === null || attribute === void 0 ? void 0 : attribute.name
        });
        return;
      }
      technicalData.push({
        label: "weight",
        name: productWeight
      });
    });
  } else {
    productWeight && technicalData.push({
      label: "weight",
      name: productWeight
    });
  }
  var productCategoryIdList = (_data$extension_attri6 = data.extension_attributes) === null || _data$extension_attri6 === void 0 ? void 0 : (_data$extension_attri7 = _data$extension_attri6.category_links) === null || _data$extension_attri7 === void 0 ? void 0 : _data$extension_attri7.map(function (category) {
    return parseInt(category.category_id);
  });
  return {
    name: data.name,
    id: data.id,
    sku: data.sku,
    url: data.url_key,
    isNew: checkIfNew(data.category_paths),
    promoLabelIndex: checkPromotionsLabelIndex(data.category_paths),
    price: {
      regular: data.price,
      special: specialPrice(hasSpecialPrice, customAttributes("special_price")("value")),
      lowest: customAttributes("lowest_price")("value")
    },
    relatedProducts: data === null || data === void 0 ? void 0 : (_data$product_links = data.product_links) === null || _data$product_links === void 0 ? void 0 : _data$product_links.map(function (productLink) {
      return {
        linkType: productLink.link_type,
        sku: productLink.linked_product_sku
      };
    }),
    labelText: customAttributes("opportunity")("name"),
    collection: {
      id: dajarCollection("value"),
      name: dajarCollection("name"),
      url: getUrlFromAttributeData(dajarCollection("data"), "value")
    },
    producer: producer,
    producerId: producerId,
    logo: {
      altText: customAttributes("brand")("name"),
      originalSrc: data.custom_attributes.filter(function (attribute) {
        return attribute.attribute_code === "brand";
      })[0] !== undefined ? data.custom_attributes.filter(function (attribute) {
        return attribute.attribute_code === "brand";
      }).map(function (option) {
        if (option.data.swatch_image === undefined) {
          return undefined;
        } else {
          return option.data.swatch_image.src;
        }
      })[0] : undefined,
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: data.custom_attributes.filter(function (attribute) {
            return attribute.attribute_code === "brand";
          })[0] !== undefined ? data.custom_attributes.filter(function (attribute) {
            return attribute.attribute_code === "brand";
          }).map(function (option) {
            if (option.data.swatch_image === undefined) {
              return undefined;
            } else {
              return option.data.swatch_image.src;
            }
          })[0] : undefined,
          w: 30,
          h: 20
        }]
      }]
    },
    info: {
      description: customAttributes("description")("value"),
      shortDescription: customAttributes("short_description")("value"),
      technicalData: technicalData
    },
    availability: {
      name: availability("name"),
      level: availability("value"),
      stock: availability("value") === null ? " " : availability("value") === 0 ? "out of stock" : "in stock",
      quantity: (_data$extension_attri8 = data.extension_attributes) === null || _data$extension_attri8 === void 0 ? void 0 : _data$extension_attri8.qty
    },
    category: {
      id: __webpack_require__.g.__appConfig__.appDomain === undefined || __webpack_require__.g.__appConfig__.appDomain.includes("dajar") ? ((_data$extension_attri9 = data.extension_attributes) === null || _data$extension_attri9 === void 0 ? void 0 : (_data$extension_attri10 = _data$extension_attri9.category_links) === null || _data$extension_attri10 === void 0 ? void 0 : _data$extension_attri10.length) > 0 && parseInt((_data$extension_attri11 = data.extension_attributes) === null || _data$extension_attri11 === void 0 ? void 0 : (_data$extension_attri12 = _data$extension_attri11.category_links) === null || _data$extension_attri12 === void 0 ? void 0 : _data$extension_attri12[0].category_id) : (0, _getMainCategoryId["default"])({
        idList: productCategoryIdList,
        paths: data.category_paths
      }),
      ids: productCategoryIdList,
      pathIds: categoryPathIds(data.category_paths),
      main: getMainCategory(data.category_paths)
    },
    images: productImages,
    image: data.extension_attributes.image_dimensions.length ? {
      altText: data.name,
      originalSrc: (_ref2 = (_firstImageBlur$filen = firstImageBlur === null || firstImageBlur === void 0 ? void 0 : firstImageBlur.filename) !== null && _firstImageBlur$filen !== void 0 ? _firstImageBlur$filen : (_data$extension_attri13 = data.extension_attributes) === null || _data$extension_attri13 === void 0 ? void 0 : (_data$extension_attri14 = _data$extension_attri13.image_dimensions[0]) === null || _data$extension_attri14 === void 0 ? void 0 : _data$extension_attri14.product_page_image_medium.src) !== null && _ref2 !== void 0 ? _ref2 : _imagesNew["default"].no_image.originalSrc,
      blurhash: firstImageBlur === null || firstImageBlur === void 0 ? void 0 : firstImageBlur.blurhash,
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: (_firstImageBlur$filen2 = firstImageBlur === null || firstImageBlur === void 0 ? void 0 : firstImageBlur.filename) !== null && _firstImageBlur$filen2 !== void 0 ? _firstImageBlur$filen2 : (_data$extension_attri15 = data.extension_attributes) === null || _data$extension_attri15 === void 0 ? void 0 : (_data$extension_attri16 = _data$extension_attri15.image_dimensions[0]) === null || _data$extension_attri16 === void 0 ? void 0 : _data$extension_attri16.product_page_image_medium.src,
          w: data.extension_attributes.image_dimensions[0] && data.extension_attributes.image_dimensions[0].product_page_image_medium.width,
          h: data.extension_attributes.image_dimensions[0] && data.extension_attributes.image_dimensions[0].product_page_image_medium.height
        }]
      }]
    } : _objectSpread({
      altText: data.name
    }, _imagesNew["default"].no_image),
    optionPickerImage: findOptionPickerImage(data.media_gallery_entries),
    isVisible: data.visibility !== 0 && data.visibility !== 1,
    pickedOptions: pickedOptions
  };
};
function mapProductData(productFamily, skipConfigurableProductObjects) {
  var differentiators = productFamily.extension_attributes ? productFamily.extension_attributes.configurable_product_options.map(function (item) {
    var _item$extension_attri, _item$extension_attri2;
    return (_item$extension_attri = item === null || item === void 0 ? void 0 : (_item$extension_attri2 = item.extension_attributes) === null || _item$extension_attri2 === void 0 ? void 0 : _item$extension_attri2.attribute_code) !== null && _item$extension_attri !== void 0 ? _item$extension_attri : item.label.toLowerCase();
  }) : [];
  if (skipConfigurableProductObjects) {
    return Array.isArray(productFamily) ? productFamily.map(function (data) {
      return mapProduct(data);
    }) : mapProduct(productFamily);
  }
  if (!productFamily) {
    return;
  }
  return productFamily.extension_attributes && productFamily.extension_attributes.configurable_product_objects ? productFamily.extension_attributes.configurable_product_objects.map(function (data) {
    return mapProduct(data, differentiators);
  }) : productFamily.map(function (data) {
    return mapProduct(data);
  });
}
var getUrlFromAttributeData = function getUrlFromAttributeData(attribute, valueKey) {
  return attribute ? attribute[valueKey] : null;
};
var getMainCategory = function getMainCategory(categoryPath) {
  if (categoryPath && categoryPath.length) {
    var categoriesId = categoryPath[0].path.match(/\d+/g);
    return categoriesId.length > 2 ? categoriesId[2] : __webpack_require__.g.__appConfig__.defaultCategoryIdForBestsellerProducts;
  }
  return __webpack_require__.g.__appConfig__.defaultCategoryIdForBestsellerProducts;
};
var categoryPathIds = function categoryPathIds(categoryPaths) {
  var reducer = function reducer(acc, current) {
    var currentNumbers = current.path.split("/").map(Number);
    return (0, _toConsumableArray2["default"])(new Set([].concat((0, _toConsumableArray2["default"])(acc), (0, _toConsumableArray2["default"])(currentNumbers))));
  };
  return categoryPaths.reduce(reducer, []);
};
var checkIfNew = function checkIfNew(categoryPath) {
  var isNew = false;
  categoryPath.map(function (singlePath) {
    singlePath.path.split("/").map(function (category) {
      if (category === __webpack_require__.g.__appConfig__.newProductsCategoryIdPL) {
        isNew = true;
      }
    });
  });
  return isNew;
};
var checkPromotionsLabelIndex = function checkPromotionsLabelIndex(categoryPath) {
  var _global$__appConfig__, _global$__appConfig__2;
  var currentHighestIndex;
  var promotionCategoriesArray = (_global$__appConfig__ = (_global$__appConfig__2 = __webpack_require__.g.__appConfig__.promotionCategoriesOrder) === null || _global$__appConfig__2 === void 0 ? void 0 : _global$__appConfig__2.split(",")) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : [];
  categoryPath.forEach(function (singlePath) {
    promotionCategoriesArray.forEach(function (categoryId, index) {
      if (singlePath.path.split("/").includes(categoryId)) {
        currentHighestIndex = currentHighestIndex === undefined ? index : currentHighestIndex < index ? currentHighestIndex : index;
      }
    });
  });
  return currentHighestIndex;
};

/***/ }),

/***/ 56212:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapProductOrder = function mapProductOrder(product) {
  return {
    sku: product.sku,
    name: product.name,
    image: product.image,
    url: product.url,
    price: {
      regular: product.base_original_price,
      special: product.base_original_price !== product.price_incl_tax ? product.price_incl_tax : null
    },
    quantity: product.qty_ordered
  };
};
var _default = mapProductOrder;
exports["default"] = _default;

/***/ }),

/***/ 9745:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapShippingMethods = function mapShippingMethods(shippingMethods) {
  return shippingMethods.map(function (method) {
    return {
      id: method.carrier_code,
      label: method.carrier_title,
      methodCode: method.method_code,
      carrierCode: method.carrier_code,
      price: method.amount
    };
  });
};
var _default = mapShippingMethods;
exports["default"] = _default;

/***/ }),

/***/ 52509:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var pageRefreshWithTime = function pageRefreshWithTime(_ref) {
  var _global$__appConfig__;
  var router = _ref.router;
  if (!((_global$__appConfig__ = __webpack_require__.g.__appConfig__) !== null && _global$__appConfig__ !== void 0 && _global$__appConfig__.timeAfterRefreshPage)) {
    return;
  }
  if (!document.body.dataset.firstTimeRegistered) {
    document.body.dataset.firstTimeRegistered = Date.now();
    document.addEventListener("click", function () {
      var timeToRefreshPage = Date.now() - document.body.dataset.firstTimeRegistered > __webpack_require__.g.__appConfig__.timeAfterRefreshPage;
      if (timeToRefreshPage) {
        router.reload();
      }
    });
  }
};
var _default = pageRefreshWithTime;
exports.Z = _default;

/***/ }),

/***/ 28532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var percentDecrease = function percentDecrease(price, special) {
  var discountPercent = (price - special) / price * 100;
  if (discountPercent > 0 && discountPercent <= 1) {
    return 1;
  }
  return Math.floor(discountPercent);
};
var _default = percentDecrease;
exports["default"] = _default;

/***/ }),

/***/ 93340:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var priceFormat = function priceFormat(price) {
  var showComma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var priceToParse = typeof price === "string" ? price.replace(",", ".") : price;
  return showComma ? parseFloat(priceToParse).toFixed(2).replace(".", ",") : parseFloat(priceToParse).toFixed(2);
};
var _default = priceFormat;
exports["default"] = _default;

/***/ }),

/***/ 82223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapArticle = function mapArticle(responseData) {
  var _responseData$title$, _responseData$title, _responseData$title$2, _responseData$subtitl, _responseData$subtitl2, _responseData$subtitl3, _responseData$descrip, _responseData$descrip2, _responseData$descrip3;
  if (!responseData) return false;
  var articleContent = [];
  responseData.body.filter(function (item) {
    if (item.slice_type === "image") {
      var _item$primary$blurhas;
      articleContent.push({
        type: "image",
        image: (0, _image["default"])(item.primary.image, ((_item$primary$blurhas = item.primary.blurhash) === null || _item$primary$blurhas === void 0 ? void 0 : _item$primary$blurhas.length) > 0 && item.primary.blurhash[0].text),
        mode: item.primary.image_mode
      });
    }
    if (item.slice_type === "text") {
      articleContent.push({
        type: "text",
        text: item.primary.text
      });
    }
  });
  return {
    title: (_responseData$title$ = responseData === null || responseData === void 0 ? void 0 : (_responseData$title = responseData.title) === null || _responseData$title === void 0 ? void 0 : (_responseData$title$2 = _responseData$title[0]) === null || _responseData$title$2 === void 0 ? void 0 : _responseData$title$2.text) !== null && _responseData$title$ !== void 0 ? _responseData$title$ : "",
    subtitle: (_responseData$subtitl = responseData === null || responseData === void 0 ? void 0 : (_responseData$subtitl2 = responseData.subtitle) === null || _responseData$subtitl2 === void 0 ? void 0 : (_responseData$subtitl3 = _responseData$subtitl2[0]) === null || _responseData$subtitl3 === void 0 ? void 0 : _responseData$subtitl3.text) !== null && _responseData$subtitl !== void 0 ? _responseData$subtitl : "",
    description: (_responseData$descrip = responseData === null || responseData === void 0 ? void 0 : (_responseData$descrip2 = responseData.description) === null || _responseData$descrip2 === void 0 ? void 0 : (_responseData$descrip3 = _responseData$descrip2[0]) === null || _responseData$descrip3 === void 0 ? void 0 : _responseData$descrip3.text) !== null && _responseData$descrip !== void 0 ? _responseData$descrip : "",
    content: articleContent
  };
};
var _default = mapArticle;
exports["default"] = _default;

/***/ }),

/***/ 62139:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapBanners = function mapBanners(bannersSlice) {
  if (!bannersSlice || bannersSlice.length === 0) return;
  var bannersArray = [];
  bannersSlice.map(function (banner) {
    var _banner$primary$image, _banner$primary$blurh, _banner$primary$url, _banner$primary$url2, _banner$primary$url2$;
    bannersArray.push({
      title: banner.primary.title.length > 0 ? banner.primary.title[0].text : "",
      subHeading: banner.primary.subtitle && banner.primary.subtitle.length > 0 ? banner.primary.subtitle[0].text : "",
      svgTitle: (_banner$primary$image = banner.primary.imagetitle) !== null && _banner$primary$image !== void 0 && _banner$primary$image.url ? {
        svg: banner.primary.imagetitle.url,
        width: banner.primary.imagetitle.dimensions ? banner.primary.imagetitle.dimensions.width : "75px",
        height: banner.primary.imagetitle.dimensions ? banner.primary.imagetitle.dimensions.height : "75px"
      } : undefined,
      buttonLabel: banner.primary.buttontext.length > 0 ? banner.primary.buttontext[0].text : "",
      description: banner.primary.description && banner.primary.description.length > 0 ? banner.primary.description[0].text : "",
      image: (0, _image["default"])(banner.primary.image, ((_banner$primary$blurh = banner.primary.blurhash) === null || _banner$primary$blurh === void 0 ? void 0 : _banner$primary$blurh.length) > 0 && banner.primary.blurhash[0].text),
      colorSchema: {
        fontColor: banner.primary.textcolor,
        bgColor: banner.primary.background
      },
      link: banner.primary.is_url_external ? (_banner$primary$url = banner.primary.url) === null || _banner$primary$url === void 0 ? void 0 : _banner$primary$url.url : (_banner$primary$url2 = banner.primary.url) === null || _banner$primary$url2 === void 0 ? void 0 : (_banner$primary$url2$ = _banner$primary$url2.url) === null || _banner$primary$url2$ === void 0 ? void 0 : _banner$primary$url2$.replace("https:/", ""),
      position: banner.primary.contentposition
    });
  });
  return bannersArray;
};
var _default = mapBanners;
exports["default"] = _default;

/***/ }),

/***/ 38422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapBlogger = function mapBlogger(response) {
  var _response$data$blurha;
  if (!response) return;
  return {
    name: response.data.firstname,
    id: response.id,
    image: (0, _image["default"])(response.data.image, ((_response$data$blurha = response.data.blurhash) === null || _response$data$blurha === void 0 ? void 0 : _response$data$blurha.length) > 0 && response.data.blurhash[0].text),
    url: response.data.profile_link,
    username: response.data.company,
    description: response.data.content && response.data.content.length > 0 && response.data.content[0].text
  };
};
var _default = mapBlogger;
exports["default"] = _default;

/***/ }),

/***/ 29439:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapCategoryBanners = function mapCategoryBanners(response) {
  if (!response) return false;
  return response.data.body.map(function (banner) {
    if (banner.slice_type === "categorybanner") {
      var _banner$primary$url, _banner$primary$url2, _banner$primary$text$;
      return {
        categoryId: banner.primary.categoryid,
        position: banner.primary.position,
        url: (_banner$primary$url = banner.primary.url) !== null && _banner$primary$url !== void 0 && _banner$primary$url.url ? (_banner$primary$url2 = banner.primary.url) === null || _banner$primary$url2 === void 0 ? void 0 : _banner$primary$url2.url.replace("https:/", "") : "/",
        text: (_banner$primary$text$ = banner.primary.text[0]) === null || _banner$primary$text$ === void 0 ? void 0 : _banner$primary$text$.text,
        image: (0, _image["default"])(banner.primary.image)
      };
    }
  });
};
var _default = mapCategoryBanners;
exports["default"] = _default;

/***/ }),

/***/ 20837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapCollection = function mapCollection(collection) {
  var _collection$primary$u, _collection$primary, _collection$primary$t, _collection$primary2, _collection$primary$s, _collection$primary$m;
  return {
    link: (_collection$primary$u = collection.primary.url) !== null && _collection$primary$u !== void 0 && _collection$primary$u.url ? collection.primary.url.url.replace("https:/", "") : "/",
    title: ((_collection$primary = collection.primary) === null || _collection$primary === void 0 ? void 0 : _collection$primary.title) && ((_collection$primary$t = collection.primary.title[0]) === null || _collection$primary$t === void 0 ? void 0 : _collection$primary$t.text) || "",
    subtitle: ((_collection$primary2 = collection.primary) === null || _collection$primary2 === void 0 ? void 0 : _collection$primary2.subtitle) && ((_collection$primary$s = collection.primary.subtitle[0]) === null || _collection$primary$s === void 0 ? void 0 : _collection$primary$s.text) || undefined,
    mainImage: ((_collection$primary$m = collection.primary.mainimage) === null || _collection$primary$m === void 0 ? void 0 : _collection$primary$m.url) && (0, _image["default"])(collection.primary.mainimage),
    thumbnails: (collection === null || collection === void 0 ? void 0 : collection.items.length) > 0 && collection.items.map(function (image) {
      return (0, _image["default"])(image.thumbnails);
    })
  };
};
var _default = mapCollection;
exports["default"] = _default;

/***/ }),

/***/ 4938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapDeals = function mapDeals(dealsSlice) {
  if (!dealsSlice || dealsSlice.length === 0) return false;
  var deals = [];
  dealsSlice.map(function (dealSlice) {
    dealSlice.items.map(function (deal) {
      var _deal$subtitle, _deal$url, _deal$blurhash;
      deals.push({
        title: deal.title && deal.title[0].text,
        subtitle: ((_deal$subtitle = deal.subtitle) === null || _deal$subtitle === void 0 ? void 0 : _deal$subtitle.length) > 0 && deal.subtitle[0].text,
        url: (_deal$url = deal.url) !== null && _deal$url !== void 0 && _deal$url.url ? deal.url.url.replace("https:/", "") : "/",
        image: (0, _image["default"])(deal.image, ((_deal$blurhash = deal.blurhash) === null || _deal$blurhash === void 0 ? void 0 : _deal$blurhash.length) > 0 && deal.blurhash[0].text),
        label: {
          svg: deal.label.url
        }
      });
    });
  });
  return deals;
};
var _default = mapDeals;
exports["default"] = _default;

/***/ }),

/***/ 55735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapFooter = function mapFooter(response) {
  var _response$data$rights, _response$data$social;
  if (!response || response.type !== __webpack_require__.g.__appConfig__.prismicPrefix + "footer") return;
  var footer = {};
  footer.columns = [];
  var footerColumns = ["footer1", "footer2", "footer3", "footer4"];
  footerColumns === null || footerColumns === void 0 ? void 0 : footerColumns.map(function (column) {
    var columnPart = {};
    columnPart.items = [];
    if (column === "footer4") {
      var _response$data$column;
      columnPart.title = response.data[column] && response.data[column][0].text;
      columnPart.content = (_response$data$column = response.data[column]) === null || _response$data$column === void 0 ? void 0 : _response$data$column.slice(1);
    } else {
      var _response$data$column2;
      (_response$data$column2 = response.data[column]) === null || _response$data$column2 === void 0 ? void 0 : _response$data$column2.map(function (columnData) {
        if (columnData.type === "paragraph") {
          columnPart.title = columnData.text;
        }
        if (columnData.type === "list-item") {
          var _columnData$spans$0$d;
          columnPart.items.push({
            text: columnData.text,
            url: columnData.spans && (_columnData$spans$0$d = columnData.spans[0].data) !== null && _columnData$spans$0$d !== void 0 && _columnData$spans$0$d.url ? columnData.spans[0].data.url.replace("https:/", "") : "/"
          });
        }
      });
    }
    footer.columns.push(columnPart);
  });
  footer.rights = {};
  footer.rights.items = [];
  response.data.rights && ((_response$data$rights = response.data.rights) === null || _response$data$rights === void 0 ? void 0 : _response$data$rights.map(function (rightsData) {
    if (rightsData.type === "paragraph") {
      footer.rights.text = rightsData.text;
    }
    if (rightsData.type === "list-item") {
      var _rightsData$spans$0$d;
      footer.rights.items.push({
        text: rightsData.text,
        url: rightsData.spans && rightsData.spans && (_rightsData$spans$0$d = rightsData.spans[0].data) !== null && _rightsData$spans$0$d !== void 0 && _rightsData$spans$0$d.url ? rightsData.spans[0].data.url.replace("https:/", "") : "/"
      });
    }
  }));
  footer.social = [];
  response.data.social && ((_response$data$social = response.data.social) === null || _response$data$social === void 0 ? void 0 : _response$data$social.map(function (socialData) {
    if (socialData.type === "list-item") {
      footer.social.push({
        text: socialData.text,
        url: socialData.spans && socialData.spans[0].data.url
      });
    }
  }));
  return footer;
};
var _default = mapFooter;
exports["default"] = _default;

/***/ }),

/***/ 26055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapFullImage = function mapFullImage(imageSlice) {
  if (!imageSlice || imageSlice.length === 0) return;
  var fullImagesArray = imageSlice.map(function (image) {
    var _image$primary$blurha, _image$primary$url, _image$primary$url$ur;
    return {
      title: image.primary.bigtitle.length > 0 ? image.primary.bigtitle[0].text : "",
      subHeading: image.primary.subtitle && image.primary.subtitle.length > 0 ? image.primary.subtitle[0].text : "",
      buttonLabel: image.primary.buttontext.length > 0 ? image.primary.buttontext[0].text : "",
      image: (0, _image["default"])(image.primary.image, ((_image$primary$blurha = image.primary.blurhash) === null || _image$primary$blurha === void 0 ? void 0 : _image$primary$blurha.length) > 0 && image.primary.blurhash.text),
      colorSchema: {
        fontColor: image.primary.textcolor,
        bgColor: image.primary.background
      },
      link: (_image$primary$url = image.primary.url) === null || _image$primary$url === void 0 ? void 0 : (_image$primary$url$ur = _image$primary$url.url) === null || _image$primary$url$ur === void 0 ? void 0 : _image$primary$url$ur.replace("https:/", "")
    };
  });
  return fullImagesArray;
};
var _default = mapFullImage;
exports["default"] = _default;

/***/ }),

/***/ 43733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.mapRichImage = exports.mapImage = exports["default"] = void 0;
var _global$__appConfig__;
var getImageVariantsKeys = function getImageVariantsKeys(image) {
  // to get all responsive dimensions names
  if (!image) return;
  var imageVariants = ["mobile", "mobilesecond"];
  return Object.keys(image).filter(function (key) {
    return imageVariants.includes(key);
  });
};
var imageQuality = (_global$__appConfig__ = __webpack_require__.g.__appConfig__) !== null && _global$__appConfig__ !== void 0 && _global$__appConfig__.prismicImageQuality ? "?q=".concat(__webpack_require__.g.__appConfig__.prismicImageQuality, "&") : "?q=70&";
var mapImage = function mapImage(image, blurhash) {
  var _image$url, _image$url2;
  if (!image) return;
  var correctBlurhash = blurhash ? blurhash.length > 0 ? blurhash : false : false;
  var imageVariantsKeys = getImageVariantsKeys(image);
  var mappedImage = {
    altText: image.alt,
    originalSrc: (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace(/\?/, imageQuality),
    blurhash: (correctBlurhash === null || correctBlurhash === void 0 ? void 0 : correctBlurhash.length) === 28 ? correctBlurhash : false,
    variants: [{
      name: "natural",
      aspectRatio: image.dimensions ? image.dimensions.width / image.dimensions.height : 1,
      srcset: [{
        url: (_image$url2 = image.url) === null || _image$url2 === void 0 ? void 0 : _image$url2.replace(/\?/, imageQuality),
        w: image.dimensions && image.dimensions.width,
        h: image.dimensions && image.dimensions.height
      }]
    }]
  };
  var imageVariants = imageVariantsKeys.map(function (variant) {
    var _image$variant, _image$variant$url, _image$variant2, _image$variant2$dimen, _image$variant3, _image$variant3$dimen;
    return {
      name: variant,
      srcset: [{
        url: (_image$variant = image[variant]) === null || _image$variant === void 0 ? void 0 : (_image$variant$url = _image$variant.url) === null || _image$variant$url === void 0 ? void 0 : _image$variant$url.replace(/\?/, imageQuality),
        w: (_image$variant2 = image[variant]) === null || _image$variant2 === void 0 ? void 0 : (_image$variant2$dimen = _image$variant2.dimensions) === null || _image$variant2$dimen === void 0 ? void 0 : _image$variant2$dimen.width,
        h: (_image$variant3 = image[variant]) === null || _image$variant3 === void 0 ? void 0 : (_image$variant3$dimen = _image$variant3.dimensions) === null || _image$variant3$dimen === void 0 ? void 0 : _image$variant3$dimen.height
      }]
    };
  });
  imageVariants.length > 0 && mappedImage.variants.push(imageVariants[0]);
  imageVariants.length > 1 && mappedImage.variants.push(imageVariants[1]);
  return mappedImage;
};
exports.mapImage = mapImage;
var mapRichImage = function mapRichImage(image) {
  var _image$blurhash;
  var mappedImage = {};
  mappedImage.image = mapImage(image.image, ((_image$blurhash = image.blurhash) === null || _image$blurhash === void 0 ? void 0 : _image$blurhash.length) && image.blurhash[0].text);
  mappedImage.title = image.title && image.title[0].text;
  mappedImage.link = image.url ? image.url.url : "/";
  mappedImage.tags = image.tags ? image.tags[0].text.replace(" ", "").split(",") : [];
  return mappedImage;
};
exports.mapRichImage = mapRichImage;
var _default = mapImage;
exports["default"] = _default;

/***/ }),

/***/ 78438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var _inspiration = _interopRequireDefault(__webpack_require__(69052));
var _collection = _interopRequireDefault(__webpack_require__(20837));
var _tiles = _interopRequireDefault(__webpack_require__(73828));
var _types = _interopRequireDefault(__webpack_require__(53052));
var _instagramTiles = _interopRequireDefault(__webpack_require__(21702));
var _seo = _interopRequireDefault(__webpack_require__(75711));
var _banner = _interopRequireDefault(__webpack_require__(62139));
var _article = _interopRequireDefault(__webpack_require__(82223));
var _deals = _interopRequireDefault(__webpack_require__(4938));
var _inspirationPage = _interopRequireDefault(__webpack_require__(28239));
var _fullImage = _interopRequireDefault(__webpack_require__(26055));
var mapBlockResponse = function mapBlockResponse(response) {
  var _instagramLink, _response$data, _response$data2, _response$data3, _response$data3$categ, _response$data4, _response$data5, _response$data5$categ, _response$data6, _response$data7, _logoSlice$, _response$data$bestse, _response$data8, _response$data$newpro, _response$data9, _response$data10, _response$data11, _response$data11$prom, _response$data12, _response$data13, _response$data13$prom, _response$data14, _response$data14$prom, _response$data14$prom2, _response$data15, _response$data16, _response$data17;
  if (!response) return;
  var findSliceByType = function findSliceByType(sliceName) {
    return response.data.body && response.data.body.filter(function (item) {
      return item.slice_type === sliceName;
    });
  };
  var blogger = response.data.blogger && response.data.blogger.id;
  var inspirationSlice = findSliceByType("inspiration");
  var inspirations = [];
  inspirationSlice && inspirationSlice.length > 0 && (inspirationSlice === null || inspirationSlice === void 0 ? void 0 : inspirationSlice.map(function (inspiration) {
    inspirations.push((0, _inspiration["default"])(inspiration));
  }));
  var collectionsSlice = findSliceByType("collection");
  var collections = [];
  collectionsSlice && collectionsSlice.length > 0 && (collectionsSlice === null || collectionsSlice === void 0 ? void 0 : collectionsSlice.map(function (collection) {
    collections.push((0, _collection["default"])(collection));
  }));
  var instagramTiles = (0, _instagramTiles["default"])(findSliceByType("instagramtiles"));
  var instagramLink = findSliceByType("instagramlink");
  instagramLink = ((_instagramLink = instagramLink) === null || _instagramLink === void 0 ? void 0 : _instagramLink.length) > 0 ? instagramLink[0].primary.link.url : "https://www.instagram.com/dajar.pl/";
  var collageBannerSlice = findSliceByType("collagebanner");
  var basicBannerSlice = findSliceByType("basicbanner");
  var fullImageSlice = findSliceByType("full_img");
  var collageBanners = (0, _banner["default"])(collageBannerSlice);
  var basicBanners = (0, _banner["default"])(basicBannerSlice);
  var fullImageBanners = (0, _fullImage["default"])(fullImageSlice);
  var tiles = (0, _tiles["default"])(findSliceByType("tiles"));
  var types = (0, _types["default"])(findSliceByType("types"));
  var seo = (0, _seo["default"])(findSliceByType("seo"));
  var inspirationPage = (0, _inspirationPage["default"])(findSliceByType("inspirationpage"), ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.blogger) && response.data.blogger.id);
  var article = (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.body ? (0, _article["default"])(response.data) : false;
  var deals = (0, _deals["default"])(findSliceByType("deals"));
  var descriptionSlice = findSliceByType("description");
  var description = descriptionSlice && descriptionSlice.length > 0 ? {
    content: descriptionSlice[0].primary.text
  } : null;
  var categoryName = ((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$categ = _response$data3.category_name) === null || _response$data3$categ === void 0 ? void 0 : _response$data3$categ.length) > 0 && ((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.category_name[0].text);
  var categoryDescription = ((_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$categ = _response$data5.category_description) === null || _response$data5$categ === void 0 ? void 0 : _response$data5$categ.length) > 0 && ((_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.category_description[0].text);
  var newsletterBackgroundSlice = findSliceByType("newsletter_bg");
  var newsletterBackground = (newsletterBackgroundSlice === null || newsletterBackgroundSlice === void 0 ? void 0 : newsletterBackgroundSlice.length) > 0 && (0, _image["default"])(newsletterBackgroundSlice[0].primary.image);
  var popularSearches = (response === null || response === void 0 ? void 0 : response.type) === "popularsearches" && ((_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.links.map(function (link) {
    var _link$title, _link$link, _link$link$url;
    return ((_link$title = link.title) === null || _link$title === void 0 ? void 0 : _link$title.length) > 0 ? {
      url: (_link$link = link.link) === null || _link$link === void 0 ? void 0 : (_link$link$url = _link$link.url) === null || _link$link$url === void 0 ? void 0 : _link$link$url.replace("https://", ""),
      title: link.title[0].text
    } : null;
  }));
  var logoSlice = findSliceByType("logo");
  var logo = logoSlice ? (0, _image["default"])((_logoSlice$ = logoSlice[0]) === null || _logoSlice$ === void 0 ? void 0 : _logoSlice$.primary.image) : false;
  var bestsellers = (_response$data$bestse = (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.bestsellers) !== null && _response$data$bestse !== void 0 ? _response$data$bestse : "";
  var newProducts = (_response$data$newpro = (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.newproducts) !== null && _response$data$newpro !== void 0 ? _response$data$newpro : "";
  Array.isArray(response.linkedContentResponse) && response.linkedContentResponse.map(function (element) {
    if (element.slice_type === "inspiration") {
      inspirations.push((0, _inspiration["default"])(element));
    }
  });
  var categoryBanner = (_response$data10 = response.data) !== null && _response$data10 !== void 0 && _response$data10.category_banner ? (0, _image["default"])(response.data.category_banner) : null;
  var promoBanner = ((_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : (_response$data11$prom = _response$data11.promobanner) === null || _response$data11$prom === void 0 ? void 0 : _response$data11$prom.url) === undefined ? null : {
    url: (_response$data12 = response.data) !== null && _response$data12 !== void 0 && _response$data12.is_url_external ? (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : (_response$data13$prom = _response$data13.promobanner_url) === null || _response$data13$prom === void 0 ? void 0 : _response$data13$prom.url : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : (_response$data14$prom = _response$data14.promobanner_url) === null || _response$data14$prom === void 0 ? void 0 : (_response$data14$prom2 = _response$data14$prom.url) === null || _response$data14$prom2 === void 0 ? void 0 : _response$data14$prom2.replace("https:/", ""),
    image: (_response$data15 = response.data) !== null && _response$data15 !== void 0 && _response$data15.promobanner ? (0, _image["default"])((_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.promobanner) : null
  };
  return {
    url: response.uid,
    headerLightMode: (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.header_light_mode,
    logo: logo,
    inspirations: inspirations,
    collections: collections,
    instagramTiles: instagramTiles,
    categoryName: categoryName,
    categoryDescription: categoryDescription,
    instagramLink: instagramLink,
    collageBanners: collageBanners,
    basicBanners: basicBanners,
    fullImageBanners: fullImageBanners,
    article: article,
    tiles: tiles,
    types: types,
    popularSearches: popularSearches,
    description: description,
    deals: deals,
    blogger: blogger,
    inspirationPage: inspirationPage,
    newsletterBackground: newsletterBackground,
    seo: seo,
    bestsellers: bestsellers,
    newProducts: newProducts,
    categoryBanner: categoryBanner,
    promoBanner: promoBanner
  };
};
var _default = mapBlockResponse;
exports["default"] = _default;

/***/ }),

/***/ 69052:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapInspiration = function mapInspiration(inspiration) {
  var _inspiration$primary$, _inspiration$primary$2, _inspiration$primary, _inspiration$primary$3, _inspiration$primary$4;
  return {
    cardLink: (_inspiration$primary$ = inspiration.primary.url) !== null && _inspiration$primary$ !== void 0 && _inspiration$primary$.url ? inspiration.primary.url.url.replace("https:/", "") : "/",
    title: inspiration.primary.title && ((_inspiration$primary$2 = inspiration.primary.title) === null || _inspiration$primary$2 === void 0 ? void 0 : _inspiration$primary$2[0].text),
    bloggerId: (_inspiration$primary = inspiration.primary) !== null && _inspiration$primary !== void 0 && _inspiration$primary.blogger && inspiration.primary.blogger.id ? inspiration.primary.blogger.id : 0,
    mainImage: ((_inspiration$primary$3 = inspiration.primary.mainimage) === null || _inspiration$primary$3 === void 0 ? void 0 : _inspiration$primary$3.url) && (0, _image["default"])(inspiration.primary.mainimage, ((_inspiration$primary$4 = inspiration.primary.blurhash) === null || _inspiration$primary$4 === void 0 ? void 0 : _inspiration$primary$4.length) > 0 && inspiration.primary.blurhash[0].text),
    thumbnails: (inspiration === null || inspiration === void 0 ? void 0 : inspiration.items.length) > 0 && inspiration.items.map(function (image) {
      return (0, _image["default"])(image.thumbnails);
    })
  };
};
var _default = mapInspiration;
exports["default"] = _default;

/***/ }),

/***/ 28239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapInspirationPage = function mapInspirationPage(inspirationPageSlice, bloggerData) {
  if (!inspirationPageSlice || inspirationPageSlice.length === 0) return false;
  var inspirationPage = [];
  inspirationPageSlice.map(function (slice) {
    var inspirationPageImages = [];
    slice === null || slice === void 0 ? void 0 : slice.items.map(function (image) {
      var _image$blurhash;
      inspirationPageImages.push({
        image: (0, _image["default"])(image.image, ((_image$blurhash = image.blurhash) === null || _image$blurhash === void 0 ? void 0 : _image$blurhash.length) > 0 && image.blurhash[0].text)
      });
    });
    inspirationPage.push({
      bloggerId: bloggerData,
      images: inspirationPageImages
    });
  });
  return inspirationPage;
};
var _default = mapInspirationPage;
exports["default"] = _default;

/***/ }),

/***/ 21702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _image = __webpack_require__(43733);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapInstagramTiles = function mapInstagramTiles(response) {
  if (!response) return false;
  var instagramTiles = [];
  response && response.length > 0 && response[0].items.map(function (image) {
    instagramTiles.push((0, _image.mapRichImage)(_objectSpread(_objectSpread({}, image), {}, {
      blurhash: image.blurhash
    })));
  });
  return instagramTiles;
};
var _default = mapInstagramTiles;
exports["default"] = _default;

/***/ }),

/***/ 57873:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapMenuBanners = function mapMenuBanners(response) {
  var _response$data, _response$data$body;
  if (!response) return false;
  return (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.map(function (banner) {
    var _banner$primary$title, _banner$primary$subti, _banner$primary$url;
    return {
      categoryId: banner.primary.categoryid,
      image: banner.primary.image && (0, _image["default"])(banner.primary.image),
      title: (_banner$primary$title = banner.primary.title[0]) === null || _banner$primary$title === void 0 ? void 0 : _banner$primary$title.text,
      subtitle: (_banner$primary$subti = banner.primary.subtitle[0]) === null || _banner$primary$subti === void 0 ? void 0 : _banner$primary$subti.text,
      url: (_banner$primary$url = banner.primary.url) !== null && _banner$primary$url !== void 0 && _banner$primary$url.url ? banner.primary.url.url.replace("https:/", "") : "/"
    };
  });
};
var _default = mapMenuBanners;
exports["default"] = _default;

/***/ }),

/***/ 96759:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapSaleBanner = function mapSaleBanner(response) {
  var _response$body$;
  if (!response || !response.body) return false;
  var categoriesToDisplay = response.category_ids ? response.category_ids.replace(" ", "").split(",").map(function (id) {
    return parseInt(id);
  }) : false;
  var bannerContent = response.body.map(function (banner) {
    var _banner$primary$bigti, _banner$primary, _banner$primary$promo, _banner$primary$promo2, _banner$primary$subti, _banner$primary$linkt, _banner$primary$url;
    return {
      bigTitle: banner.primary.bigtitle && ((_banner$primary$bigti = banner.primary.bigtitle[0]) === null || _banner$primary$bigti === void 0 ? void 0 : _banner$primary$bigti.text),
      promoCode: (_banner$primary = banner.primary) === null || _banner$primary === void 0 ? void 0 : (_banner$primary$promo = _banner$primary.promocode) === null || _banner$primary$promo === void 0 ? void 0 : (_banner$primary$promo2 = _banner$primary$promo[0]) === null || _banner$primary$promo2 === void 0 ? void 0 : _banner$primary$promo2.text,
      subheading: banner.primary.subtitle && ((_banner$primary$subti = banner.primary.subtitle[0]) === null || _banner$primary$subti === void 0 ? void 0 : _banner$primary$subti.text),
      linkText: (_banner$primary$linkt = banner.primary.linktext[0]) === null || _banner$primary$linkt === void 0 ? void 0 : _banner$primary$linkt.text,
      url: (_banner$primary$url = banner.primary.url) !== null && _banner$primary$url !== void 0 && _banner$primary$url.url ? banner.primary.url.url.replace("https:/", "") : "/"
    };
  });
  return {
    categories: categoriesToDisplay,
    showInCategory: response.display_categorypage,
    showInProduct: response.display_productpage,
    content: bannerContent,
    background: response === null || response === void 0 ? void 0 : (_response$body$ = response.body[0]) === null || _response$body$ === void 0 ? void 0 : _response$body$.primary.background
  };
};
var _default = mapSaleBanner;
exports["default"] = _default;

/***/ }),

/***/ 75711:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapSeo = function mapSeo(slice) {
  if (!slice || slice.length < 1) return false;
  return {
    h1: slice[0].primary.h1[0].text,
    h4: slice[0].primary.h4[0].text,
    text: slice[0].primary.text[0].text
  };
};
var _default = mapSeo;
exports["default"] = _default;

/***/ }),

/***/ 73828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapTiles = function mapTiles(tilesSlice) {
  if (!tilesSlice || tilesSlice.length === 0) return false;
  var tiles = [];
  tilesSlice.map(function (tileSlice) {
    tileSlice.items.map(function (tile) {
      var _tile$title$, _tile$link, _tile$link2, _tile$blurhash, _tile$label;
      tiles.push({
        title: (_tile$title$ = tile.title[0]) === null || _tile$title$ === void 0 ? void 0 : _tile$title$.text,
        url: tile.is_url_external ? (_tile$link = tile.link) === null || _tile$link === void 0 ? void 0 : _tile$link.url : (_tile$link2 = tile.link) !== null && _tile$link2 !== void 0 && _tile$link2.url ? tile.link.url.replace("https:/", "") : "/",
        image: (0, _image["default"])(tile.image, ((_tile$blurhash = tile.blurhash) === null || _tile$blurhash === void 0 ? void 0 : _tile$blurhash.length) > 0 && tile.blurhash[0].text),
        promoLabel: {
          labelText: ((_tile$label = tile.label) === null || _tile$label === void 0 ? void 0 : _tile$label.length) > 0 && tile.label[0].text,
          labelColor: tile.color ? tile.color : "active"
        }
      });
    });
  });
  return tiles;
};
var _default = mapTiles;
exports["default"] = _default;

/***/ }),

/***/ 53052:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapTypes = function mapTypes(typesSlice) {
  if (!typesSlice || typesSlice.length === 0) return false;
  var types = [];
  typesSlice.map(function (typeSlice) {
    typeSlice.items.map(function (tile) {
      var _tile$url;
      types.push({
        name: tile.title && tile.title[0].text,
        url: (_tile$url = tile.url) !== null && _tile$url !== void 0 && _tile$url.url ? tile.url.url.replace("https:/", "") : "/",
        image: (0, _image["default"])(tile.image)
      });
    });
  });
  return types;
};
var _default = mapTypes;
exports["default"] = _default;

/***/ }),

/***/ 38115:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.TIMEOUT = void 0;
var TIMEOUT = "timeout";
exports.TIMEOUT = TIMEOUT;
var prismicErrorHandle = function prismicErrorHandle(error, description) {
  if (error.message.includes("response timeout")) {
    return TIMEOUT;
  }
  console.log("".concat(description, " - ").concat(error));
  return false;
};
var _default = prismicErrorHandle;
exports["default"] = _default;

/***/ }),

/***/ 84660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getRootCategory = exports.removeRootCategory = void 0;
var rootFromUrl = new RegExp(/^.*?(\/)/);
var removeRootCategory = function removeRootCategory(url) {
  return __webpack_require__.g.__appConfig__.rootCategoryHideInUrl ? url.replace(rootFromUrl, "") : url;
};
exports.removeRootCategory = removeRootCategory;
var getRootCategory = function getRootCategory(url) {
  var _url$match;
  return __webpack_require__.g.__appConfig__.rootCategoryHideInUrl ? url === null || url === void 0 ? void 0 : (_url$match = url.match(rootFromUrl)) === null || _url$match === void 0 ? void 0 : _url$match[0] : "";
};
exports.getRootCategory = getRootCategory;

/***/ }),

/***/ 50802:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchTree = function searchTree(category, id) {
  var _result;
  var pureCategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var keyChildren = "subcategories";
  if (pureCategory) {
    keyChildren = "children_data";
  }
  var result;
  var findCategory = function findCategory(category, id) {
    for (var i = 0; i < category.length; i++) {
      var _category$i, _category$i$keyChildr, _category$i2, _category$i2$keyChild;
      if (category[i].id === id) {
        result = category[i];
        break;
      }
      (_category$i = category[i]) === null || _category$i === void 0 ? void 0 : (_category$i$keyChildr = _category$i[keyChildren]) === null || _category$i$keyChildr === void 0 ? void 0 : _category$i$keyChildr.forEach(function (subcategory) {
        if (Array.isArray(subcategory)) {
          findCategory(subcategory, id);
        }
      });
      if (((_category$i2 = category[i]) === null || _category$i2 === void 0 ? void 0 : (_category$i2$keyChild = _category$i2[keyChildren]) === null || _category$i2$keyChild === void 0 ? void 0 : _category$i2$keyChild.length) > 0) {
        var _category$i3;
        findCategory((_category$i3 = category[i]) === null || _category$i3 === void 0 ? void 0 : _category$i3[keyChildren], id);
      }
    }
  };
  findCategory(Array.isArray(category) ? category : [category], id);
  return (_result = result) !== null && _result !== void 0 ? _result : [];
};
var _default = searchTree;
exports["default"] = _default;

/***/ }),

/***/ 78145:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _superagent2 = _interopRequireDefault(__webpack_require__(84703));
var _getSearchUrl = _interopRequireDefault(__webpack_require__(40408));
var sendCategorySearchRequest = function sendCategorySearchRequest(_ref) {
  var query = _ref.query,
    lang = _ref.lang;
  return _superagent2["default"].get((0, _getSearchUrl["default"])({
    url: "/categories/list",
    query: query,
    lang: lang,
    pageSize: 10,
    currentPage: 1,
    productSearch: false
  })).withCredentials().then(function (res) {
    return res.body;
  });
};
var _default = sendCategorySearchRequest;
exports["default"] = _default;

/***/ }),

/***/ 91030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _superagent2 = _interopRequireDefault(__webpack_require__(84703));
var _getSearchUrl = _interopRequireDefault(__webpack_require__(40408));
var sendProductSearchRequest = function sendProductSearchRequest(_ref) {
  var query = _ref.query,
    currentPage = _ref.currentPage,
    pageSize = _ref.pageSize,
    categoryId = _ref.categoryId,
    lang = _ref.lang,
    pickedFilters = _ref.pickedFilters;
  return _superagent2["default"].get((0, _getSearchUrl["default"])({
    url: "/products",
    query: query,
    currentPage: currentPage,
    pageSize: pageSize,
    pickedFilters: pickedFilters,
    categoryId: categoryId,
    lang: lang
  })).withCredentials().then(function (res) {
    return res.body;
  });
};
var _default = sendProductSearchRequest;
exports["default"] = _default;

/***/ }),

/***/ 56260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _addAnalyticsAndCommerceScripts = _interopRequireDefault(__webpack_require__(93355));
var allAgreements = {
  gtm: true,
  analytics: true,
  pixelFb: true,
  salesmanago: true
};
var setAgreements = function setAgreements(_ref) {
  var _ref$agreements = _ref.agreements,
    agreements = _ref$agreements === void 0 ? true : _ref$agreements,
    cookieAgreements = _ref.cookieAgreements,
    language = _ref.language;
  var setCookieAgreements = cookieAgreements.setCookieAgreements,
    analyticsID = cookieAgreements.analyticsID,
    gtmID = cookieAgreements.gtmID,
    fbID = cookieAgreements.fbID;
  var currentAgreements = agreements === true ? allAgreements : {
    gtm: agreements.analytic,
    analytics: agreements.analytic,
    pixelFb: agreements.tracking,
    salesmanago: agreements.tracking
  };
  setCookieAgreements(currentAgreements);
  var currentLanguage = language === null || language === void 0 ? void 0 : language.language;
  (0, _addAnalyticsAndCommerceScripts["default"])(currentLanguage, currentAgreements, {
    analyticsID: analyticsID,
    gtmID: gtmID,
    fbID: fbID
  });
};
var _default = setAgreements;
exports["default"] = _default;

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var setSaleBannerVisibility = function setSaleBannerVisibility(pageProps, banner) {
  if (!banner || !pageProps) return false;
  if (pageProps.pageType === "category") {
    return setSalesBannerVisibilityForCategoryPage(banner, pageProps.categoryId);
  } else if (pageProps.pageType === "product") {
    return setSalesBannerVisibilityForProductPage(banner, pageProps.product);
  }
};
var setSalesBannerVisibilityForCategoryPage = function setSalesBannerVisibilityForCategoryPage(banner, categoryId) {
  if (!(banner !== null && banner !== void 0 && banner.showInCategory)) {
    return false;
  }
  if (banner.showInCategory && !banner.categories) {
    return true;
  }
  if (banner.categories.indexOf(parseInt(categoryId)) > -1) {
    return true;
  }
  return false;
};
var setSalesBannerVisibilityForProductPage = function setSalesBannerVisibilityForProductPage(banner, product) {
  var _product$category$ids, _product$category, _product$collection, _banner$categories$fi;
  if (!(banner !== null && banner !== void 0 && banner.showInProduct)) {
    return false;
  }
  if (banner.showInProduct && !banner.categories) {
    return true;
  }
  var bannerCategoriesAndCollections = {
    categoryIds: (_product$category$ids = product === null || product === void 0 ? void 0 : (_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.ids) !== null && _product$category$ids !== void 0 ? _product$category$ids : [],
    collection: (product === null || product === void 0 ? void 0 : (_product$collection = product.collection) === null || _product$collection === void 0 ? void 0 : _product$collection.id) && parseInt(product.collection.id)
  };
  if (((_banner$categories$fi = banner.categories.filter(function (category) {
    return bannerCategoriesAndCollections.categoryIds.includes(category);
  })) === null || _banner$categories$fi === void 0 ? void 0 : _banner$categories$fi.length) > 0 || banner.categories.indexOf(bannerCategoriesAndCollections.collection) > -1) {
    return true;
  }
  return false;
};
var _default = setSaleBannerVisibility;
exports.Z = _default;

/***/ }),

/***/ 28991:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
var sortByPosition = function sortByPosition(categories) {
  categories.sort(function (submenuA, submenuB) {
    return submenuA.positionInColumn - submenuB.positionInColumn;
  });
};
var sortById = function sortById(categories) {
  categories.sort(function (submenuA, submenuB) {
    return submenuA.id - submenuB.id;
  });
};
var sortMenu = function sortMenu(menu) {
  menu.map(function (mainCategory) {
    var _global$__appConfig__;
    if (mainCategory.subcategories.length === 0) return;
    var columnsNumber = (_global$__appConfig__ = __webpack_require__.g.__appConfig__.menuColumnsNumber) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : 4;
    var columnsInSubmenu = Array.from(Array(columnsNumber), function () {
      return [];
    });
    var categoriesWithUnsetColumnPosition = [];
    mainCategory.subcategories.forEach(function (subcategories) {
      sortByPosition(subcategories);
      subcategories.map(function (category) {
        return (category === null || category === void 0 ? void 0 : category.subcategories) && sortByPosition(category.subcategories);
      });
      subcategories.map(function (subcategory) {
        var _columnsInSubmenu;
        return (subcategory === null || subcategory === void 0 ? void 0 : subcategory.columnInMenu) && subcategory.columnInMenu !== 0 && (columnsInSubmenu === null || columnsInSubmenu === void 0 ? void 0 : (_columnsInSubmenu = columnsInSubmenu[subcategory.columnInMenu - 1]) === null || _columnsInSubmenu === void 0 ? void 0 : _columnsInSubmenu.push(subcategory));
      });
      categoriesWithUnsetColumnPosition = [].concat((0, _toConsumableArray2["default"])(categoriesWithUnsetColumnPosition), (0, _toConsumableArray2["default"])(subcategories.filter(function (subcategory) {
        return subcategory && subcategory.columnInMenu === 0;
      })));
      sortById(categoriesWithUnsetColumnPosition);
      categoriesWithUnsetColumnPosition.map(function (subcategory) {
        var _iterator = _createForOfIteratorHelper(columnsInSubmenu.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
              index = _step$value[0],
              column = _step$value[1];
            if (column.length === 0 || index === columnsInSubmenu.length - 1) {
              column.push(subcategory);
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    });
    mainCategory.subcategories = columnsInSubmenu;
    return mainCategory;
  });
  return menu;
};
var _default = sortMenu;
exports["default"] = _default;

/***/ }),

/***/ 26109:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _priceFormat = _interopRequireDefault(__webpack_require__(93340));
var totalPrice = function totalPrice(price, amount) {
  return (0, _priceFormat["default"])(price * amount);
};
var _default = totalPrice;
exports["default"] = _default;

/***/ }),

/***/ 15366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _reactRedux = __webpack_require__(71682);
var useAppConfiguration = function useAppConfiguration() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.appConfiguration;
    }),
    domain = _useSelector.domain,
    language = _useSelector.language,
    host = _useSelector.host;
  return {
    domain: domain,
    language: language,
    host: host
  };
};
var _default = useAppConfiguration;
exports["default"] = _default;

/***/ }),

/***/ 73157:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InjectRouteContext = InjectRouteContext;
exports.useRouteContext = exports.RouteContext = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _addLanguagePrefixToUrl = _interopRequireDefault(__webpack_require__(32170));
var _addLanguageSufixToRouteName = _interopRequireDefault(__webpack_require__(97110));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var RouteContext = /*#__PURE__*/(0, _react.createContext)();
exports.RouteContext = RouteContext;
function InjectRouteContext(props) {
  var result = (0, _react.useRef)(props.getUrl);
  var propsMemorized = (0, _react.useMemo)(function () {
    return {
      Link: props.Link,
      Router: props.Router,
      addLanguagePrefixToUrl: (0, _addLanguagePrefixToUrl["default"])(props.languagePrefix),
      addLanguageSufixToRouteName: (0, _addLanguageSufixToRouteName["default"])(props.languagePrefix)
    };
  }, [result.current]);
  return __jsx(RouteContext.Provider, {
    value: propsMemorized
  }, props.children);
}
var useRouteContext = function useRouteContext() {
  return (0, _react.useContext)(RouteContext);
};
exports.useRouteContext = useRouteContext;

/***/ }),

/***/ 28198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.enableBodyScroll = exports.clearAllBodyScrollLocks = exports.disableBodyScroll = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== "undefined") {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener("testPassive", null, passiveTestOptions);
  window.removeEventListener("testPassive", null, passiveTestOptions);
}
var isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting;
var previousBodyPosition;
var previousBodyPaddingRight;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }
    return false;
  });
};
var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
};
var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (reserveScrollBarGap && scrollBarGap > 0) {
      var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = "".concat(computedBodyPaddingRight + scrollBarGap, "px");
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
};
var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }
  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};
var setPositionFixed = function setPositionFixed() {
  return window.requestAnimationFrame(function () {
    // If previousBodyPosition is already set, don't set it again.
    if (previousBodyPosition === undefined) {
      previousBodyPosition = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };

      // Update the dom inside an animation frame - removed, caused zoom
      // const { scrollY, scrollX, innerHeight } = window;
      // document.body.style.position = 'fixed';
      // document.body.style.top = `${-scrollY}px`;
      // document.body.style.left = `${-scrollX}px`;

      setTimeout(function () {
        return window.requestAnimationFrame(function () {
          // Attempt to check if the bottom bar appeared due to the position change
          var bottomBarHeight = innerHeight - window.innerHeight;
          if (bottomBarHeight && scrollY >= innerHeight) {
            // Move the content further up so that the bottom bar doesn't hide it
            document.body.style.top = -(scrollY + bottomBarHeight);
          }
        });
      }, 300);
    }
  });
};
var restorePositionSetting = function restorePositionSetting() {
  if (previousBodyPosition !== undefined) {
    // Convert the position from "px" to Int
    var y = -parseInt(document.body.style.top, 10);
    var x = -parseInt(document.body.style.left, 10);

    // Restore styles
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;

    // Restore scroll
    window.scrollTo(x, y);
    previousBodyPosition = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;
  if (allowTouchMove(event.target)) {
    return false;
  }
  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }
  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }
  event.stopPropagation();
  return true;
};
var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }
  var lock = {
    targetElement: targetElement,
    options: options || {}
  };
  locks = [].concat((0, _toConsumableArray2["default"])(locks), [lock]);
  if (isIosDevice) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }
  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };
    if (!documentListenerAdded) {
      document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = true;
    }
  }
};
exports.disableBodyScroll = disableBodyScroll;
var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });
    if (documentListenerAdded) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  }
  if (isIosDevice) {
    restorePositionSetting();
    restoreOverflowSetting();
  } else {
    restoreOverflowSetting();
  }
  locks = [];
};
exports.clearAllBodyScrollLocks = clearAllBodyScrollLocks;
var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });
  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;
    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }
  }
  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
};
exports.enableBodyScroll = enableBodyScroll;

/***/ }),

/***/ 739:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(98986));
var _createClass2 = _interopRequireDefault(__webpack_require__(30428));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var Cache = /*#__PURE__*/function () {
  function Cache(data) {
    (0, _classCallCheck2["default"])(this, Cache);
    (0, _defineProperty2["default"])(this, "data", {});
    this.data = data;
  }
  (0, _createClass2["default"])(Cache, [{
    key: "set",
    value: function set(key, value) {
      this.data[key] = value;
    }
  }, {
    key: "get",
    value: function get(key, defaultValue) {
      if (key in this.data) {
        return this.data[key];
      }
      if (defaultValue !== undefined) {
        return defaultValue;
      }
      throw Error("There is no such key \"".concat(key, "\" in cache and no default value was provided"));
    }
  }, {
    key: "extract",
    value: function extract() {
      return this.data;
    }
  }]);
  return Cache;
}();
var _default = Cache;
exports["default"] = _default;

/***/ }),

/***/ 25686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = useDebounce;
var _react = __webpack_require__(34885);
function useDebounce(delay, cb) {
  var handler = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(handler.current);
    };
  }, []);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(handler.current);
    handler.current = setTimeout(function () {
      return cb.apply(void 0, args);
    }, delay);
  };
}

/***/ }),

/***/ 46726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var newsletterImage = {
  altText: "Newsletter image",
  originalSrc: "/static/images/dialog/newsletter_dialog.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/newsletter_top.jpg",
      w: 465,
      h: 350
    }]
  }]
};
var _default = newsletterImage;
exports["default"] = _default;

/***/ }),

/***/ 64616:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.G = void 0;
var headerLinks = [{
  name: "O nas",
  url: "/about-us"
}, {
  name: "Obsługa klienta",
  url: "/contact"
}];
exports.G = headerLinks;

/***/ }),

/***/ 40775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var __jsx = _react["default"].createElement;
var ArianeLogoIcon = function ArianeLogoIcon(props) {
  return __jsx("svg", props, __jsx("title", null, "ariane-logo"), __jsx("path", {
    fill: "none",
    d: "M6.97 61.51h3.51v3.51H6.97zM40.51 61.51h3.51v3.51h-3.51zM-.09 0h3.51v3.51H-.09zM49.28 61.51h3.51v3.51h-3.51z"
  }), __jsx("path", {
    d: "M10.39 57.7h-.12c-.17 0-.25.1-.25.29v1h.43v.18H10v1.64h-.16v-1.66h-.25V59h.25v-1a.37.37 0 0 1 .43-.42h.24v.18zM11.7 58.64a.17.17 0 0 1-.1 0 .16.16 0 0 1 0-.11c0-.08 0-.13.15-.15s.12 0 .15.15a.13.13 0 0 1-.15.15m-.09.33h.18v1.82h-.18zM14.3 60.79V59.7c0-.39-.18-.58-.52-.58a.5.5 0 0 0-.39.15.58.58 0 0 0-.14.41v1.11h-.18V59h.18v.22a.54.54 0 0 1 .53-.24.69.69 0 0 1 .52.2.76.76 0 0 1 .18.54v1.11zM16 59.84a.83.83 0 0 0 .2.59.75.75 0 0 0 .57.22.89.89 0 0 0 .34-.06.76.76 0 0 0 .34-.32l.16.08a.88.88 0 0 1-.53.44 1 1 0 0 1-.31 0 1 1 0 0 1-.68-1.62.93.93 0 0 1 .68-.27.94.94 0 0 1 .67.25.85.85 0 0 1 .27.65zm1.25-.58a.8.8 0 0 0-.48-.15.72.72 0 0 0-.75.56h1.49a.61.61 0 0 0-.26-.41zM22.65 60.55a1 1 0 0 1-1.43-.1v1.2H21V59h.18v.34a.95.95 0 1 1 1.43 1.24m-.13-1.21a.76.76 0 0 0-1.31.54.73.73 0 0 0 .23.54.77.77 0 0 0 1.31-.54.73.73 0 0 0-.2-.57zM25.69 60.55a1 1 0 0 1-1.35 0 1 1 0 0 1 0-1.34.9.9 0 0 1 .67-.28.94.94 0 0 1 .95.95.91.91 0 0 1-.27.67m-.13-1.21a.74.74 0 0 0-.55-.22.76.76 0 0 0-.54 1.31.77.77 0 0 0 1.09-1.08zM28.18 59.24l-.18-.09a.45.45 0 0 0-.17 0 .24.24 0 0 0-.14 0 .51.51 0 0 0-.12.11.63.63 0 0 0-.08.15.48.48 0 0 0 0 .15v1.2h-.18V59h.18v.25a.74.74 0 0 1 .15-.19.29.29 0 0 1 .21-.08.71.71 0 0 1 .22 0 .73.73 0 0 1 .2.11zM30.31 60.83a.93.93 0 0 1-.68-.27 1 1 0 0 1 0-1.35.93.93 0 0 1 .68-.27.91.91 0 0 1 .56.16v.22l-.12-.08-.12-.07a1 1 0 0 0-.32-.06.74.74 0 0 0-.77.77.74.74 0 0 0 .22.55.75.75 0 0 0 .56.22.82.82 0 0 0 .56-.21v.23a1 1 0 0 1-.56.16M32.05 59.84a.83.83 0 0 0 .2.59.75.75 0 0 0 .57.22.89.89 0 0 0 .34-.06.77.77 0 0 0 .34-.32l.16.08a.89.89 0 0 1-.53.44 1 1 0 0 1-.31 0 1 1 0 0 1-.68-1.62.93.93 0 0 1 .68-.27.94.94 0 0 1 .68.25.85.85 0 0 1 .27.65zm1.25-.58a.8.8 0 0 0-.48-.15.72.72 0 0 0-.75.56h1.49a.62.62 0 0 0-.26-.41z",
    fill: "#252525",
    fillRule: "evenodd"
  }), __jsx("path", {
    fill: "#252525",
    d: "M35.13 57.52h.18v3.27h-.18z"
  }), __jsx("path", {
    d: "M38.36 60.79v-.31a.94.94 0 0 1-1.68-.6.9.9 0 0 1 .27-.67 1 1 0 0 1 1.41.07V59h.18v1.82zm-.19-1.45a.77.77 0 0 0-1.31.54.73.73 0 0 0 .23.54.76.76 0 0 0 1.31-.54.73.73 0 0 0-.23-.54zM40.1 58.64a.17.17 0 0 1-.1 0 .16.16 0 0 1 0-.11c0-.08 0-.13.15-.15s.12 0 .15.15a.13.13 0 0 1-.15.15M40 59h.18v1.82H40zM42.7 60.79V59.7q0-.58-.52-.58a.5.5 0 0 0-.39.15.59.59 0 0 0-.14.41v1.11h-.18V59h.18v.22a.54.54 0 0 1 .53-.24.68.68 0 0 1 .52.2.76.76 0 0 1 .18.54v1.11zM3.51 51.16v.11q-.2.51-.36 1t-.3.92a4.49 4.49 0 0 0-.21 1 .67.67 0 0 0 .12.35 1 1 0 0 0 .53.34 2.51 2.51 0 0 0 .57.15l.55.08v.3H.1v-.3A4.4 4.4 0 0 0 .64 55a1.5 1.5 0 0 0 .49-.22 2 2 0 0 0 .6-.53 3.71 3.71 0 0 0 .37-.72l2-5.19 2-5h.46l4.07 10.43a2.06 2.06 0 0 0 .33.59 3.54 3.54 0 0 0 .47.45 2.39 2.39 0 0 0 .46.18 3.52 3.52 0 0 0 .51.12v.3H7.63v-.3a5.24 5.24 0 0 0 1-.16L9 54.8a.36.36 0 0 0 .23-.35v-.17a.78.78 0 0 0-.09-.28l-1.06-2.84-1.71-.11v-.3h1.54l-2.13-5.4-2.07 5.39zM18.29 47a1 1 0 0 1 .78.31 1.17 1.17 0 0 1 .28.82 1.31 1.31 0 0 1-.17.65.57.57 0 0 1-.54.3.89.89 0 0 1-.62-.19.58.58 0 0 1-.22-.44 2 2 0 0 1 0-.34 1.73 1.73 0 0 1 .06-.26l.05-.21h-.21a2 2 0 0 0-1 .35 2.93 2.93 0 0 0-1 1v5a.92.92 0 0 0 .59.94 2.17 2.17 0 0 0 .52.13l.52.06v.25h-4.19v-.25h.36a1.25 1.25 0 0 0 .32-.07c.39-.11.59-.42.59-.93v-5.25a1.26 1.26 0 0 0-.55-1.1c-.2-.12-.1-.19-.43-.23v-.24l2.24-.16v1.59l.3-.37a3.71 3.71 0 0 1 1.21-1 2.56 2.56 0 0 1 1.1-.32M22.95 47.14V54a.93.93 0 0 0 .19.66 1.23 1.23 0 0 0 .41.29.28.28 0 0 0 .12 0 2.14 2.14 0 0 0 .53.16v.25h-3.8v-.25h.35a1.25 1.25 0 0 0 .35-.11q.59-.16.59-.93v-5.2c0-.42-.22-1.73-.22-1.73h1.48zM32.54 54.91a.84.84 0 0 0 .36.09h.53v.26a4.67 4.67 0 0 1-.62.2 2.73 2.73 0 0 1-.6.06 1.26 1.26 0 0 1-1.44-1.1l-.05-.32-.23.23a4.31 4.31 0 0 1-1.26.94 3.45 3.45 0 0 1-1.44.28 2.07 2.07 0 0 1-1.48-.53 1.86 1.86 0 0 1-.56-1.41 2.17 2.17 0 0 1 .52-1.47 1.86 1.86 0 0 1 .29-.26 3.08 3.08 0 0 1 .35-.22l.32-.16.21-.1 1.56-.48 1-.35a5.06 5.06 0 0 0 .66-.3h.09v-1a3.26 3.26 0 0 0-.05-.47 2.29 2.29 0 0 0-.21-.64 1.63 1.63 0 0 0-1.53-.87 2.23 2.23 0 0 0-.82.14 1.79 1.79 0 0 0-.53.3l-.05.05v.07a1.42 1.42 0 0 0 0 .21c0 .08 0 .17.05.26a2.75 2.75 0 0 1 .09.65.59.59 0 0 1-.22.43.9.9 0 0 1-.63.2.57.57 0 0 1-.36-.11.76.76 0 0 1-.29-.51 1.72 1.72 0 0 1 0-.21 1.09 1.09 0 0 1 .25-.66 2.39 2.39 0 0 1 .69-.59 3.45 3.45 0 0 1 .92-.4A3.74 3.74 0 0 1 29 47a7.34 7.34 0 0 1 1.23.09 2.05 2.05 0 0 1 .92.41 2.46 2.46 0 0 1 .85 2.13v4.17a1.24 1.24 0 0 0 .13.61 1.15 1.15 0 0 0 .44.41m-1.78-4.34l-.23.09-1.29.5a10.18 10.18 0 0 0-1.06.5 1.82 1.82 0 0 0-.77.72 2.06 2.06 0 0 0-.28 1.07 1.57 1.57 0 0 0 .44 1.16 1.52 1.52 0 0 0 1.07.39 2.26 2.26 0 0 0 1.24-.35 2.67 2.67 0 0 0 .44-.34 4.18 4.18 0 0 0 .33-.36v-.05zM43 55a2 2 0 0 0 .34.12l.34.05v.25h-3.82v-.25h.39a1.29 1.29 0 0 0 .34-.07q.58-.16.59-.93v-4.44a2.3 2.3 0 0 0-.46-1.5 1.47 1.47 0 0 0-1.17-.55 3 3 0 0 0-1.62.51 2.55 2.55 0 0 0-.74.85V54a.91.91 0 0 0 .19.64 1.31 1.31 0 0 0 .39.29 2.65 2.65 0 0 0 .73.19v.25h-3.9v-.25h.35a1.26 1.26 0 0 0 .32-.07c.39-.11.58-.42.58-.93v-5.25a1.31 1.31 0 0 0-.53-1.1c-.2-.12-.1-.19-.43-.23v-.24l2.24-.16v1.5l.28-.26a.67.67 0 0 0 .12-.12l.46-.41a5.11 5.11 0 0 1 .55-.41 4 4 0 0 1 .68-.31 2.92 2.92 0 0 1 1-.15 2.22 2.22 0 0 1 1.17.27 2 2 0 0 1 .68.67 2.36 2.36 0 0 1 .31.86 5.56 5.56 0 0 1 .07.83V54a.93.93 0 0 0 .55 1M50.85 54.62a3.52 3.52 0 0 0 1-1.18l.32.19a3.93 3.93 0 0 1-1.39 1.47 3.57 3.57 0 0 1-1.9.52 3.66 3.66 0 0 1-3-1.27 5 5 0 0 1-1-3.11 4.76 4.76 0 0 1 .27-1.6A4.63 4.63 0 0 1 46 48.3a3.62 3.62 0 0 1 1.21-1 3.44 3.44 0 0 1 1.55-.3 3.19 3.19 0 0 1 2.58 1 4 4 0 0 1 .73 2.45v.41h-5.68v.16a6.42 6.42 0 0 0 .18 1.61 3.72 3.72 0 0 0 .53 1.19 2.9 2.9 0 0 0 3.1 1.06 2.53 2.53 0 0 0 .65-.3m-4.46-4.11h4.3v-.18-.36-.53a4.53 4.53 0 0 0-.11-.59 2.89 2.89 0 0 0-.2-.55 1.66 1.66 0 0 0-1.58-1 2 2 0 0 0-1.65.81 3.73 3.73 0 0 0-.69 2.19zM22.18 43.66a.87.87 0 0 1-.64-.29 1 1 0 0 1-.28-.7 1 1 0 0 1 .28-.71.86.86 0 0 1 .64-.3.93.93 0 0 1 .68.27.9.9 0 0 1 .27.66 1.09 1.09 0 0 1-.27.75.88.88 0 0 1-.68.31",
    fill: "#252525",
    fillRule: "evenodd"
  }), __jsx("path", {
    fill: "#929292",
    d: "M0 59.61h7.03v.61H0z"
  }), __jsx("path", {
    fill: "#979797",
    d: "M45.77 59.61h7.03v.61h-7.03z"
  }), __jsx("path", {
    d: "M26.48 35.05a15.74 15.74 0 1 1 15.84-15.74 15.81 15.81 0 0 1-15.84 15.74",
    fill: "#252525",
    fillRule: "evenodd"
  }), __jsx("path", {
    d: "M24.23 19.67v.09c-.11.28-.2.54-.29.79s-.17.5-.25.75a3.67 3.67 0 0 0-.17.84.55.55 0 0 0 .1.29.82.82 0 0 0 .43.27 2 2 0 0 0 .46.12l.45.07v.24h-3.51v-.24l.44-.09a1.21 1.21 0 0 0 .4-.18 1.56 1.56 0 0 0 .49-.43 3 3 0 0 0 .3-.59l1.67-4.24 1.59-4.08h.38L30 21.79a1.65 1.65 0 0 0 .27.48 2.87 2.87 0 0 0 .38.37 2 2 0 0 0 .38.15 3.06 3.06 0 0 0 .42.09v.24h-3.86v-.24a4.26 4.26 0 0 0 .82-.13l.28-.11a.3.3 0 0 0 .19-.29v-.14a.61.61 0 0 0-.05-.22L28 19.67l-1.4-.09v-.24h1.25l-1.72-4.39-1.7 4.39z",
    fill: "#fff",
    fillRule: "evenodd"
  }), __jsx("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: "10",
    strokeWidth: ".91",
    d: "M36.43 19.29h3.2M23.24 32a13.21 13.21 0 0 1-9.79-11"
  }), __jsx("path", {
    d: "M37.9 21a11.54 11.54 0 0 1-9.82 9.66 11.67 11.67 0 0 1-1.6.11V29.2a9.94 9.94 0 1 1 1.6-.13",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: "10",
    strokeWidth: ".91"
  }), __jsx("path", {
    d: "M13.45 17.56a13.14 13.14 0 0 1 13-11.32h.05a13.06 13.06 0 0 1 1.56 26M26.43 6.29v3.13M28.17 8a11.54 11.54 0 0 1 9.72 9.61M11.82 19.29h3",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: "10",
    strokeWidth: ".91"
  }), __jsx("path", {
    d: "M26.48 30.79V34a14.74 14.74 0 1 0-1.57-.08v-3.2h-.08a11.52 11.52 0 0 1-9.91-11.36v-.13A11.52 11.52 0 0 1 24.7 8",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: "10",
    strokeWidth: ".91"
  }));
};
ArianeLogoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52.8 65"
};
var Sale30Icon = function Sale30Icon(props) {
  return __jsx("svg", props, __jsx("rect", {
    x: ".418",
    y: ".533",
    width: "52",
    height: "52",
    rx: "26",
    fill: "#DF4F5C"
  }), __jsx("path", {
    d: "M17.292 21.533h-1.553v-1.597c-.42 1.167-1.199 1.75-2.336 1.75-.674 0-1.209-.207-1.604-.622-.396-.42-.593-1.003-.593-1.75v-5.178h1.706v4.819c0 .532.117.881.352 1.047.234.166.463.25.688.25.361 0 .73-.162 1.106-.484.376-.327.564-1.02.564-2.08v-3.552h1.67v7.397zm3.713 2.497h-1.699v-9.895h1.597v1.29c.513-.962 1.267-1.443 2.263-1.443.82 0 1.475.356 1.963 1.069s.732 1.624.732 2.732c0 1.05-.234 1.963-.703 2.74-.464.776-1.157 1.164-2.08 1.164-.952 0-1.643-.396-2.073-1.187v3.53zm0-5.53c0 .538.16.985.476 1.341.323.352.68.527 1.07.527.532 0 .92-.231 1.164-.695.25-.47.374-1.062.374-1.78 0-.752-.125-1.363-.374-1.831-.249-.474-.62-.71-1.113-.71-.444 0-.823.192-1.135.578-.308.386-.462.891-.462 1.516v1.055zm13.565 1.73v1.303c-.498.107-.884.161-1.157.161-.45 0-.835-.088-1.158-.264a1.683 1.683 0 0 1-.71-.732c-.147-.313-.22-.791-.22-1.436v-3.83h-.923v-1.296h1.018l.154-1.927 1.37-.124v2.05h1.487v1.297h-1.487v3.61c0 .465.083.782.249.953.17.166.49.249.96.249.131 0 .27-.005.417-.015zm4.02 1.457c-1.093 0-1.928-.393-2.504-1.18-.576-.786-.864-1.686-.864-2.702 0-1.094.317-2.005.952-2.732.64-.728 1.482-1.091 2.527-1.091.99 0 1.804.354 2.439 1.062.64.708.96 1.628.96 2.76 0 1.168-.333 2.108-.997 2.82-.66.709-1.497 1.063-2.512 1.063zm.06-1.377c1.123 0 1.684-.838 1.684-2.512 0-.757-.134-1.353-.403-1.787-.268-.44-.681-.66-1.238-.66-.576 0-1.003.227-1.281.681-.279.45-.418 1.048-.418 1.795 0 .806.147 1.42.44 1.846.297.424.703.637 1.215.637zM11.41 34.043v1.37H7.731v-1.37h3.677zm4.634.074v-1.421h.915c.547 0 1.004-.122 1.37-.367.366-.244.55-.608.55-1.091 0-.474-.157-.83-.47-1.07-.307-.239-.705-.358-1.193-.358-.986 0-1.658.483-2.014 1.45l-1.648-.286c.185-.761.612-1.384 1.281-1.867.674-.484 1.485-.725 2.432-.725.942 0 1.746.244 2.41.732.669.483 1.003 1.133 1.003 1.948 0 .606-.18 1.123-.542 1.553-.356.43-.798.664-1.326.703.655.098 1.18.369 1.575.813.4.444.6.98.6 1.604 0 .86-.346 1.568-1.04 2.124-.688.552-1.606.828-2.753.828-1.06 0-1.936-.269-2.63-.806-.688-.542-1.123-1.162-1.303-1.86l1.706-.418c.342 1.114 1.08 1.67 2.212 1.67.586 0 1.057-.149 1.414-.447.361-.302.542-.666.542-1.09 0-.43-.157-.807-.469-1.129-.308-.327-.774-.49-1.399-.49h-1.223zm11.527 4.57c-1.226 0-2.17-.474-2.835-1.421-.664-.952-.996-2.16-.996-3.626 0-1.582.347-2.854 1.04-3.816.698-.962 1.634-1.442 2.805-1.442.845 0 1.558.227 2.14.68.585.45 1.02 1.077 1.303 1.883.288.8.432 1.553.432 2.256 0 1.177-.134 2.143-.403 2.9a4.216 4.216 0 0 1-1.282 1.86c-.585.484-1.32.726-2.204.726zm-.008-1.414c.508 0 .918-.156 1.23-.469.313-.312.526-.75.638-1.31.113-.562.169-1.338.169-2.33 0-.82-.14-1.599-.418-2.336-.273-.737-.8-1.106-1.582-1.106-1.357 0-2.036 1.255-2.036 3.765 0 1.137.144 2.053.432 2.746.288.694.81 1.04 1.568 1.04zm8.73-3.26c-.704 0-1.268-.273-1.692-.82-.42-.551-.63-1.222-.63-2.014 0-.776.212-1.425.637-1.948.425-.527.994-.79 1.707-.79.795 0 1.384.275 1.765.827.385.552.578 1.181.578 1.89 0 .878-.23 1.574-.688 2.087-.46.513-1.018.769-1.678.769zm.007-1.083c.674 0 1.01-.586 1.01-1.758 0-1.113-.324-1.67-.974-1.67-.659 0-.988.554-.988 1.663 0 1.177.317 1.765.952 1.765zm6.636-4.395l-6.19 9.998h-1.105l6.21-9.998h1.084zm-.733 10.086c-.66 0-1.206-.254-1.64-.762-.43-.513-.645-1.157-.645-1.934 0-.893.24-1.596.718-2.109.483-.517 1.037-.776 1.662-.776.591 0 1.12.24 1.59.718.468.478.703 1.2.703 2.167 0 .811-.227 1.463-.681 1.956-.45.493-1.018.74-1.707.74zm.059-1.062c.346 0 .598-.166.754-.498.161-.337.242-.723.242-1.157 0-.63-.078-1.08-.235-1.348a.75.75 0 0 0-.703-.41c-.693 0-1.04.569-1.04 1.706 0 1.138.327 1.707.982 1.707z",
    fill: "#fff"
  }));
};
Sale30Icon.defaultProps = {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Sale70Icon = function Sale70Icon(props) {
  return __jsx("svg", props, __jsx("rect", {
    width: "52",
    height: "52",
    rx: "26",
    fill: "#DF4F5C"
  }), __jsx("path", {
    d: "M17.777 12.668v4.71c0 .638-.072 1.129-.215 1.473-.143.343-.42.64-.832.891-.409.247-.908.37-1.499.37-.598 0-1.09-.107-1.477-.321a1.889 1.889 0 0 1-.827-.881c-.168-.376-.253-.854-.253-1.434v-4.807h1.349v4.71c0 .644.134 1.069.402 1.273.272.2.587.3.946.3.411 0 .74-.107.988-.322.247-.218.37-.635.37-1.251v-4.71h1.048zM20.607 20h-1.32v-7.332h3.002c.855 0 1.49.217 1.9.65.416.43.624.939.624 1.526 0 .67-.224 1.212-.671 1.627-.448.416-1.015.623-1.703.623h-1.832V20zm0-4.04h1.563c.409 0 .72-.1.935-.3.215-.2.322-.467.322-.8 0-.3-.1-.559-.3-.774-.197-.214-.555-.322-1.075-.322h-1.445v2.197zM31.194 20h-1.418v-6.198h-1.95v-1.133h5.318v1.133h-1.95V20zm5.296.113c-.974 0-1.733-.365-2.278-1.096-.54-.73-.81-1.633-.81-2.707 0-1.067.288-1.959.864-2.675.577-.72 1.337-1.08 2.283-1.08.952 0 1.704.36 2.256 1.08.555.716.832 1.613.832 2.691 0 1.132-.288 2.047-.864 2.745-.574.694-1.334 1.042-2.283 1.042zm.01-1.064c.477 0 .88-.197 1.209-.59.33-.394.494-1.109.494-2.144 0-.841-.136-1.5-.408-1.976-.272-.48-.695-.72-1.268-.72-1.131 0-1.697.911-1.697 2.734 0 .884.143 1.556.43 2.014.29.455.703.682 1.24.682zM10.992 32.51v1.37H7.314v-1.37h3.677zm2.394-5.508h7.097v1.275c-1.23 1.596-2.048 2.98-2.454 4.153-.4 1.172-.642 2.695-.725 4.57h-2.058c.171-3.237 1.406-6.055 3.706-8.452h-5.72l.154-1.546zm13.768 10.152c-1.226 0-2.17-.474-2.835-1.421-.664-.952-.996-2.16-.996-3.626 0-1.582.347-2.854 1.04-3.816.699-.961 1.634-1.442 2.806-1.442.844 0 1.557.227 2.138.68.586.45 1.02 1.077 1.304 1.883.288.8.432 1.553.432 2.256 0 1.177-.134 2.144-.403 2.9a4.216 4.216 0 0 1-1.282 1.86c-.585.484-1.32.726-2.204.726zm-.008-1.414c.508 0 .919-.156 1.231-.468.313-.313.525-.75.637-1.312.112-.561.169-1.337.169-2.329 0-.82-.14-1.599-.418-2.336-.273-.737-.8-1.106-1.582-1.106-1.357 0-2.036 1.255-2.036 3.765 0 1.137.144 2.053.432 2.746.288.694.81 1.04 1.567 1.04zm8.73-3.259c-.704 0-1.268-.273-1.692-.82-.42-.552-.63-1.224-.63-2.015 0-.776.212-1.425.637-1.948.425-.527.994-.79 1.707-.79.795 0 1.384.275 1.765.827.385.552.578 1.181.578 1.89 0 .878-.23 1.574-.688 2.087-.46.513-1.018.769-1.678.769zm.007-1.084c.674 0 1.01-.586 1.01-1.758 0-1.113-.324-1.67-.974-1.67-.659 0-.988.554-.988 1.663 0 1.177.317 1.765.952 1.765zm6.636-4.395L36.328 37h-1.105l6.21-9.998h1.085zm-.733 10.086c-.659 0-1.206-.254-1.64-.762-.43-.513-.645-1.157-.645-1.933 0-.894.24-1.597.718-2.11.483-.517 1.037-.776 1.662-.776.591 0 1.121.24 1.59.718.468.478.703 1.2.703 2.168 0 .81-.227 1.462-.681 1.955-.45.493-1.018.74-1.707.74zm.059-1.062c.346 0 .598-.166.754-.498a2.65 2.65 0 0 0 .242-1.157c0-.63-.078-1.08-.235-1.348a.75.75 0 0 0-.703-.41c-.693 0-1.04.569-1.04 1.706 0 1.138.328 1.707.982 1.707z",
    fill: "#fff"
  }));
};
Sale70Icon.defaultProps = {
  width: "52",
  height: "52",
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchIcon = function SearchIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
SearchIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var LogoIcon = function LogoIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M20.841.27H.341v1.442h1.703c2.685 0 3.864 1.179 3.864 3.864v35.237c0 2.685-1.179 3.93-3.864 3.93H.34v1.375h19.256c16.832 0 24.168-11.92 24.168-23.579C43.765 11.274 36.953.271 20.84.271zm-1.375 44.145h-4.061c-2.161 0-3.144-1.048-3.144-3.21V1.975h7.205c12.378 0 17.487 10.741 17.487 21.155 0 10.414-4.978 21.286-17.487 21.286zM86.118 44.677c-2.227 0-3.471-.786-4.126-2.358L65.159.271h-1.964L46.886 41.99c-.458 1.18-1.31 2.686-4.388 2.686H41.45v1.441h14.278v-1.375H53.37c-2.292 0-3.34-.983-3.34-2.555 0-.655.13-1.31.393-2.03l3.21-8.45H71.12l3.274 8.45c.262.72.459 1.375.459 1.965 0 1.768-1.18 2.62-3.537 2.62h-2.292v1.375h18.208v-1.44h-1.114zm-31.7-15.064L62.212 8.72l8.122 20.893H54.418zM115.525.27H96.728v1.442h2.947c2.685 0 3.93 1.179 3.93 3.864v30.718c0 3.209-.393 6.484-2.62 8.842-1.638-3.603-4.585-4.978-6.812-4.978-2.161 0-3.668 1.244-3.668 2.947 0 2.162 3.079 3.734 6.681 3.734 5.633 0 12.706-3.734 12.706-15V5.577c0-2.685 1.179-3.864 3.865-3.864h1.768V.27zM156.59 44.677c-2.226 0-3.471-.786-4.126-2.358L135.632.271h-1.965l-16.309 41.72c-.458 1.18-1.31 2.686-4.388 2.686h-1.048v1.441H126.2v-1.375h-2.358c-2.292 0-3.34-.983-3.34-2.555 0-.655.131-1.31.393-2.03l3.209-8.45h17.488l3.275 8.45c.262.72.458 1.375.458 1.965 0 1.768-1.179 2.62-3.537 2.62h-2.292v1.375h18.208v-1.44h-1.114zm-31.7-15.064l7.794-20.893 8.122 20.893H124.89zM196.215 41.86l-4.061-8.317c-3.733-7.729-7.794-9.432-12.248-10.545 7.532-.524 14.606-4.52 14.606-11.724 0-5.895-4.716-11.003-14.737-11.003H160.65v1.44h1.703c2.685 0 3.864 1.18 3.864 3.865v35.237c0 2.685-1.179 3.93-3.864 3.93h-1.703v1.375h17.488v-1.375h-1.703c-2.62 0-3.865-1.245-3.865-3.93V23.587h1.245c4.847 0 7.597 3.537 10.676 9.497l2.161 4.192c1.834 3.537 2.947 6.091 4.257 8.842h9.432v-1.375c-2.031-.066-3.209-.983-4.126-2.882zm-19.584-19.976h-4.061V1.974h4.585c7.336 0 10.545 4.584 10.545 9.89 0 5.501-3.471 10.02-11.069 10.02z"
  }));
};
LogoIcon.defaultProps = {
  viewBox: "0 0 201 47",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var KettlerLogoWhite = function KettlerLogoWhite(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#a)"
  }, __jsx("path", {
    d: "M206.601 70.24V57.43l13.34 13.93V51.94h-2.76v12.72l-13.35-14V70.2l2.77.04zm-6.39-18.3h-10.1v18.3h10.1v-2.59h-7.31v-6.12h7.13v-2.59h-7.13v-4.4h7.34l-.03-2.6zm-25 2.6h1.24a7.61 7.61 0 0 1 5.35 1.67 6.377 6.377 0 0 1 2 4.88 6.255 6.255 0 0 1-2 4.85 6.3 6.3 0 0 1-2.2 1.32 10.5 10.5 0 0 1-3.1.39h-1.24l-.05-13.11zm1 15.7c1.451.053 2.901-.12 4.3-.51a8.664 8.664 0 0 0 3.11-1.81 8.7 8.7 0 0 0 2.95-6.83 8.76 8.76 0 0 0-2.84-6.79 8.125 8.125 0 0 0-3.11-1.81 13.773 13.773 0 0 0-4.36-.55h-3.84v18.3h3.79zm-15.65-15.7h1c2.54 0 3.81.93 3.81 2.81s-1.3 3-3.92 3h-.88l-.01-5.81zm6.38 6.11a5.196 5.196 0 0 0 1.11-3.34 5 5 0 0 0-1.77-4c-1.08-.91-2.82-1.37-5.24-1.37h-3.14v18.3h2.76v-7.49h.5l5.23 7.49h3.38l-5.67-7.81a4.91 4.91 0 0 0 2.94-1.79l-.1.01zm-22.9 2.54l2.84-6.22 2.72 6.23-5.56-.01zm8.6 7h3l-8.74-19.45-9 19.45h3l2-4.44h7.83l1.91 4.44zm-22.87-6.93h4.56a4.883 4.883 0 0 1-1.81 3.32 5.552 5.552 0 0 1-3.66 1.37 6.53 6.53 0 0 1-4.45-1.84 6.454 6.454 0 0 1-2.19-5 6.65 6.65 0 0 1 2-4.93 6.527 6.527 0 0 1 4.87-2 6.673 6.673 0 0 1 5.48 3l2-1.88a11.666 11.666 0 0 0-3.6-2.87 9.36 9.36 0 0 0-4-.87 9.261 9.261 0 0 0-6.78 2.78 9.16 9.16 0 0 0-2.79 6.79 9.18 9.18 0 0 0 2.73 6.68 8.919 8.919 0 0 0 6.58 2.78 8.275 8.275 0 0 0 6.48-2.87 7.735 7.735 0 0 0 1.6-2.75c.345-1.185.51-2.416.49-3.65v-.61h-7.56l.05 2.55zM123.069 29.92h-2.76v18.3h2.76v-8.55h7.9v8.55h2.76v-18.3h-2.76v7.16h-7.9v-7.16zM154.509 39.07a6.733 6.733 0 0 1-2 4.91 6.577 6.577 0 0 1-4.86 2 6.52 6.52 0 0 1-4.68-2 6.607 6.607 0 0 1-2-5 6.637 6.637 0 0 1 2-4.86 6.543 6.543 0 0 1 4.82-2 6.489 6.489 0 0 1 4.82 2 6.726 6.726 0 0 1 2 4.91l-.1.04zm2.89-.04a9.145 9.145 0 0 0-2.91-6.6 9.136 9.136 0 0 0-6.71-2.8 9.318 9.318 0 0 0-6.78 2.77 9.003 9.003 0 0 0-2.83 6.64 9.007 9.007 0 0 0 3.1 7.11 9.432 9.432 0 0 0 6.33 2.4 9.454 9.454 0 0 0 6.84-2.76 9.006 9.006 0 0 0 2.82-6.69M163.962 48.22l1.97-11.06 5.26 11.9 5.41-11.89 1.77 11.05h2.83l-3.46-19.67-6.5 14.22-6.28-14.22-3.86 19.67h2.86zM196.151 29.92h-10.1v18.3h10.1v-2.6h-7.34v-6.11h7.13v-2.6h-7.13v-4.39h7.34v-2.6zM212.379 44.15c-1.64 1.58-3.07 2.37-4.33 2.37a3.334 3.334 0 0 1-2.38-1 3.28 3.28 0 0 1-1.07-2.34 2.56 2.56 0 0 1 .71-1.7 17.607 17.607 0 0 1 2.77-2.05l4.3 4.72zm-2.08-8.72c-.33.26-.75.56-1.25.9l-.3.2a1.917 1.917 0 0 1-.18-.21l-.89-1a2.761 2.761 0 0 1-.84-1.86 1.573 1.573 0 0 1 .67-1.32 2.441 2.441 0 0 1 1.63-.55 2.601 2.601 0 0 1 1.7.53 1.711 1.711 0 0 1 .63 1.38 1.89 1.89 0 0 1-.46 1.27c-.215.236-.453.45-.71.64v.02zm7.12 7.16c.352-.35.686-.717 1-1.1l-1.91-1.78c-.32.38-.84 1-1.18 1.37l-1 1.07-3.73-4.11a12.245 12.245 0 0 0 2.63-2.3c.479-.61.736-1.364.73-2.14a3.57 3.57 0 0 0-1.36-2.85 5.12 5.12 0 0 0-3.4-1.12 5.08 5.08 0 0 0-3.46 1.16 3.81 3.81 0 0 0-1.32 3 5.47 5.47 0 0 0 2 3.8l-.18.13-.09.06-1.31.82a5.314 5.314 0 0 0-2.87 4.55 4.926 4.926 0 0 0 1.81 3.86 6.73 6.73 0 0 0 4.5 1.56 8.29 8.29 0 0 0 5.7-2.6l2 2.24h3.74l-3.69-4.18c.54-.55 1-1 1.4-1.45M88.491 85.88c4.73 0 4.73-7.48 0-7.48h-9.62v13h4.94v-4.45c1 1.48 2 3 3 4.45h5.79l-4.08-5.52h-.03zm-2.6-1.45h-2.09V81.8h2.09c1.49 0 1.46 2.63 0 2.63zM53 82.12h3.47v-3.73H33.84v3.73h3.46v9.27h4.95v-9.27h5.81v9.27H53v-9.27zM77.841 82.12h-5.71v1.56h5.71v3.03h-5.71v1.39h5.71v3.29h-10.65v-13h10.65v3.73zM27.62 88.1h5.67v3.29H22.68v-13h10.61v3.73h-5.67v1.56h5.67v3.03h-5.67v1.39zM61.94 78.39v9.71h4.66v3.29H57v-13h4.94zM13.362 91.39v-4.88l2.95 4.88h5.89l-4.63-6.62 4.63-6.38h-5.89l-2.95 4.8v-4.8h-4.85v13h4.85z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M76.339 53.63h-44.12l7.47 10.67h44.12l-7.47-10.67z",
    fill: "#009CC4"
  }), __jsx("path", {
    d: "M24.41 41.98h44.12L76 31.31H31.88",
    fill: "#FC0"
  }), __jsx("path", {
    d: "M40.031 19.67h44.13l7.47-10.68h-44.12l-7.48 10.68 7.48-10.68-7.48 10.68z",
    fill: "#E3000F"
  }), __jsx("path", {
    d: "M32.219 30.82h44.12l7.47-10.67h-44.12",
    fill: "#F39100"
  }), __jsx("path", {
    d: "M47.511 75.46l-7.48-10.67 7.48 10.67h44.12l-7.47-10.67h-44.13",
    fill: "#134094"
  }), __jsx("path", {
    d: "M31.88 53.14H76l-7.47-10.67H24.41l7.47 10.67-7.47-10.67 7.47 10.67z",
    fill: "#76B828"
  }), __jsx("path", {
    d: "M42.722 8.51H8.512v67.44h34.21l-23.61-33.72 23.61-33.72z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M1.078 98.82h97.74V1.08H1.078v97.74zm94-3.71H4.788V4.79h90.32l-.03 90.32z",
    fill: "#fff"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    d: "M0 0h219.97v99.9H0z"
  }))));
};
KettlerLogoWhite.defaultProps = {
  width: "220",
  height: "100",
  viewBox: "0 0 220 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var KettlerLogoBlack = function KettlerLogoBlack(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#a)"
  }, __jsx("path", {
    d: "M206.601 70.24V57.43l13.34 13.93V51.94h-2.76v12.72l-13.35-14V70.2l2.77.04zm-6.39-18.3h-10.1v18.3h10.1v-2.59h-7.31v-6.12h7.13v-2.59h-7.13v-4.4h7.34l-.03-2.6zm-25 2.6h1.24a7.61 7.61 0 0 1 5.35 1.67 6.377 6.377 0 0 1 2 4.88 6.255 6.255 0 0 1-2 4.85 6.3 6.3 0 0 1-2.2 1.32 10.5 10.5 0 0 1-3.1.39h-1.24l-.05-13.11zm1 15.7c1.451.053 2.901-.12 4.3-.51a8.664 8.664 0 0 0 3.11-1.81 8.7 8.7 0 0 0 2.95-6.83 8.76 8.76 0 0 0-2.84-6.79 8.125 8.125 0 0 0-3.11-1.81 13.773 13.773 0 0 0-4.36-.55h-3.84v18.3h3.79zm-15.65-15.7h1c2.54 0 3.81.93 3.81 2.81s-1.3 3-3.92 3h-.88l-.01-5.81zm6.38 6.11a5.196 5.196 0 0 0 1.11-3.34 5 5 0 0 0-1.77-4c-1.08-.91-2.82-1.37-5.24-1.37h-3.14v18.3h2.76v-7.49h.5l5.23 7.49h3.38l-5.67-7.81a4.91 4.91 0 0 0 2.94-1.79l-.1.01zm-22.9 2.54l2.84-6.22 2.72 6.23-5.56-.01zm8.6 7h3l-8.74-19.45-9 19.45h3l2-4.44h7.83l1.91 4.44zm-22.87-6.93h4.56a4.883 4.883 0 0 1-1.81 3.32 5.552 5.552 0 0 1-3.66 1.37 6.53 6.53 0 0 1-4.45-1.84 6.454 6.454 0 0 1-2.19-5 6.65 6.65 0 0 1 2-4.93 6.527 6.527 0 0 1 4.87-2 6.673 6.673 0 0 1 5.48 3l2-1.88a11.666 11.666 0 0 0-3.6-2.87 9.36 9.36 0 0 0-4-.87 9.261 9.261 0 0 0-6.78 2.78 9.16 9.16 0 0 0-2.79 6.79 9.18 9.18 0 0 0 2.73 6.68 8.919 8.919 0 0 0 6.58 2.78 8.275 8.275 0 0 0 6.48-2.87 7.735 7.735 0 0 0 1.6-2.75c.345-1.185.51-2.416.49-3.65v-.61h-7.56l.05 2.55zM123.069 29.92h-2.76v18.3h2.76v-8.55h7.9v8.55h2.76v-18.3h-2.76v7.16h-7.9v-7.16zM154.509 39.07a6.733 6.733 0 0 1-2 4.91 6.577 6.577 0 0 1-4.86 2 6.52 6.52 0 0 1-4.68-2 6.607 6.607 0 0 1-2-5 6.637 6.637 0 0 1 2-4.86 6.543 6.543 0 0 1 4.82-2 6.489 6.489 0 0 1 4.82 2 6.726 6.726 0 0 1 2 4.91l-.1.04zm2.89-.04a9.145 9.145 0 0 0-2.91-6.6 9.136 9.136 0 0 0-6.71-2.8 9.318 9.318 0 0 0-6.78 2.77 9.003 9.003 0 0 0-2.83 6.64 9.007 9.007 0 0 0 3.1 7.11 9.432 9.432 0 0 0 6.33 2.4 9.454 9.454 0 0 0 6.84-2.76 9.006 9.006 0 0 0 2.82-6.69M163.962 48.22l1.97-11.06 5.26 11.9 5.41-11.89 1.77 11.05h2.83l-3.46-19.67-6.5 14.22-6.28-14.22-3.86 19.67h2.86zM196.151 29.92h-10.1v18.3h10.1v-2.6h-7.34v-6.11h7.13v-2.6h-7.13v-4.39h7.34v-2.6zM212.379 44.15c-1.64 1.58-3.07 2.37-4.33 2.37a3.334 3.334 0 0 1-2.38-1 3.28 3.28 0 0 1-1.07-2.34 2.56 2.56 0 0 1 .71-1.7 17.607 17.607 0 0 1 2.77-2.05l4.3 4.72zm-2.08-8.72c-.33.26-.75.56-1.25.9l-.3.2a1.917 1.917 0 0 1-.18-.21l-.89-1a2.761 2.761 0 0 1-.84-1.86 1.573 1.573 0 0 1 .67-1.32 2.441 2.441 0 0 1 1.63-.55 2.601 2.601 0 0 1 1.7.53 1.711 1.711 0 0 1 .63 1.38 1.89 1.89 0 0 1-.46 1.27c-.215.236-.453.45-.71.64v.02zm7.12 7.16c.352-.35.686-.717 1-1.1l-1.91-1.78c-.32.38-.84 1-1.18 1.37l-1 1.07-3.73-4.11a12.245 12.245 0 0 0 2.63-2.3c.479-.61.736-1.364.73-2.14a3.57 3.57 0 0 0-1.36-2.85 5.12 5.12 0 0 0-3.4-1.12 5.08 5.08 0 0 0-3.46 1.16 3.81 3.81 0 0 0-1.32 3 5.47 5.47 0 0 0 2 3.8l-.18.13-.09.06-1.31.82a5.314 5.314 0 0 0-2.87 4.55 4.926 4.926 0 0 0 1.81 3.86 6.73 6.73 0 0 0 4.5 1.56 8.29 8.29 0 0 0 5.7-2.6l2 2.24h3.74l-3.69-4.18c.54-.55 1-1 1.4-1.45M88.491 85.88c4.73 0 4.73-7.48 0-7.48h-9.62v13h4.94v-4.45c1 1.48 2 3 3 4.45h5.79l-4.08-5.52h-.03zm-2.6-1.45h-2.09V81.8h2.09c1.49 0 1.46 2.63 0 2.63zM53 82.12h3.47v-3.73H33.84v3.73h3.46v9.27h4.95v-9.27h5.81v9.27H53v-9.27zM77.841 82.12h-5.71v1.56h5.71v3.03h-5.71v1.39h5.71v3.29h-10.65v-13h10.65v3.73zM27.62 88.1h5.67v3.29H22.68v-13h10.61v3.73h-5.67v1.56h5.67v3.03h-5.67v1.39zM61.94 78.39v9.71h4.66v3.29H57v-13h4.94zM13.362 91.39v-4.88l2.95 4.88h5.89l-4.63-6.62 4.63-6.38h-5.89l-2.95 4.8v-4.8h-4.85v13h4.85z",
    fill: "#000"
  }), __jsx("path", {
    d: "M76.339 53.63h-44.12l7.47 10.67h44.12l-7.47-10.67z",
    fill: "#009CC4"
  }), __jsx("path", {
    d: "M24.41 41.98h44.12L76 31.31H31.88",
    fill: "#FC0"
  }), __jsx("path", {
    d: "M40.031 19.67h44.13l7.47-10.68h-44.12l-7.48 10.68 7.48-10.68-7.48 10.68z",
    fill: "#E3000F"
  }), __jsx("path", {
    d: "M32.219 30.82h44.12l7.47-10.67h-44.12",
    fill: "#F39100"
  }), __jsx("path", {
    d: "M47.511 75.46l-7.48-10.67 7.48 10.67h44.12l-7.47-10.67h-44.13",
    fill: "#134094"
  }), __jsx("path", {
    d: "M31.88 53.14H76l-7.47-10.67H24.41l7.47 10.67-7.47-10.67 7.47 10.67z",
    fill: "#76B828"
  }), __jsx("path", {
    d: "M42.722 8.51H8.512v67.44h34.21l-23.61-33.72 23.61-33.72z",
    fill: "#000"
  }), __jsx("path", {
    d: "M1.078 98.82h97.74V1.08H1.078v97.74zm94-3.71H4.788V4.79h90.32l-.03 90.32z",
    fill: "#000"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    d: "M0 0h219.97v99.9H0z"
  }))));
};
KettlerLogoBlack.defaultProps = {
  width: "220",
  height: "100",
  viewBox: "0 0 220 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WeberLogoWhite = function WeberLogoWhite(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#a)"
  }, __jsx("path", {
    d: "M151.999 54.235c0-.21-.19-.25-.36-.25h-.35v.51h.3c.22 0 .41-.01.41-.26zM111.791 53.405a1.202 1.202 0 0 0-1.138.715 1.197 1.197 0 0 0 1.554 1.595 1.195 1.195 0 0 0 .744-1.12 1.151 1.151 0 0 0-.329-.84 1.167 1.167 0 0 0-.831-.35zm.42 2l-.44-.72h-.29v.72h-.25v-1.61h.63c.39 0 .59.14.59.47a.428.428 0 0 1-.258.425.434.434 0 0 1-.172.035l.47.73-.28-.05z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M151.599 53.405a1.201 1.201 0 0 0-.899 2.037 1.2 1.2 0 0 0 2.059-.847 1.169 1.169 0 0 0-.329-.84 1.156 1.156 0 0 0-.831-.35zm.42 2l-.44-.72h-.29v.72h-.25v-1.61h.63c.39 0 .59.14.59.47a.44.44 0 0 1-.258.425.43.43 0 0 1-.172.035l.47.73-.28-.05zM91.72 20.045a2.4 2.4 0 0 0-2.18 0 1.06 1.06 0 0 0-.58.94v10.7h3.33v-10.67a1.1 1.1 0 0 0-.57-.97zM53.24 21.015a1.121 1.121 0 0 0-.56-1 2.421 2.421 0 0 0-2.19 0 1.061 1.061 0 0 0-.58.94v10.73h3.33v-10.67zM112.18 54.235c0-.21-.18-.25-.36-.25h-.34v.51h.3c.21 0 .4-.01.4-.26zM71.13 54.365a1.46 1.46 0 0 0 1.62-1.38v-32.12c0-.64-.62-1.06-1.56-1.06-.94 0-1.67.36-1.67 1.06v32.12a1.47 1.47 0 0 0 1.61 1.38z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M153.218 2.795H7.458a7.35 7.35 0 0 0-7.46 7.73v51a7.65 7.65 0 0 0 7.88 7.57h145.44a7.752 7.752 0 0 0 7.6-7.52v-51.31a7.503 7.503 0 0 0-2.28-5.353 7.518 7.518 0 0 0-5.42-2.117zm4.95 58.8a4.998 4.998 0 0 1-4.85 4.77H7.878a4.93 4.93 0 0 1-5.13-4.82v-51c0-3 1.89-5 4.71-5h145.76a4.804 4.804 0 0 1 4.548 2.872 4.8 4.8 0 0 1 .402 1.848v51.33z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M153.219 7.795h-83.68v10.92l.41-.42c.76-.77 3.67-1.16 5.94-.2 1.79.75 2.74 2.46 2.74 4.92v28.94c0 2-2.61 4.83-7.48 4.83-5 0-7.39-2.87-7.39-4.83V9.685c0-1.48-.89-1.62-1.56-1.89H7.46c-1.81 0-2.51 1.23-2.51 2.78v51a2.76 2.76 0 0 0 2.93 2.62h145.44a2.767 2.767 0 0 0 2.64-2.57v-51.36a2.58 2.58 0 0 0-2.74-2.47zm-113.68 42.47c0 4.16-4 6.45-11.41 6.45s-11.43-2.24-11.44-6.45v-28c0-2.36-2.25-1.33-2.25-2.77v-1.32h7.94v34.3a1.62 1.62 0 0 0 1.69 1.62 1.6 1.6 0 0 0 1.68-1.62v-34.33h4.66v34.33a1.55 1.55 0 0 0 .75 1.32 2 2 0 0 0 1.86 0 1.54 1.54 0 0 0 .74-1.37v-34.28h5.78v32.12zm12.58 6.47h-1c-4.7 0-6.9-2.87-6.91-4.83v-29.66c0-1.68 2-4.82 6.87-4.82h1c4.88 0 6.9 3.14 6.9 4.82v14h-9.06v16.73a1.47 1.47 0 0 0 1.62 1.42 1.558 1.558 0 0 0 1.71-1.42v-13.22h5.72v12.15c.01 1.96-2.19 4.83-6.89 4.83h.04zm45.94-20.49H89v16.73a1.48 1.48 0 0 0 1.63 1.42 1.55 1.55 0 0 0 1.7-1.42v-13.22h5.73v12.15c0 2-2.19 4.83-6.89 4.83h-1c-4.7 0-6.9-2.87-6.91-4.83v-29.66c0-1.68 2-4.82 6.86-4.82h1c4.87 0 6.91 3.14 6.91 4.82l.03 14zm13.77 19.79a1.44 1.44 0 1 1 1.45-1.44 1.421 1.421 0 0 1-.436 1.04 1.43 1.43 0 0 1-1.054.4h.04zm5.71-19.82h-5.81v-15.11a1.221 1.221 0 0 0-.64-1.06 2.15 2.15 0 0 0-2.06 0 1.154 1.154 0 0 0-.59.76v35.31h-5.7v-33.78c0-2.35-2.25-1.33-2.25-2.76v-1.34h8v.56l.41-.28c2.09-1.53 5.1-1.12 7-.13a3 3 0 0 1 1.64 2.81v15.02zm34 19.82a1.44 1.44 0 1 1 1.45-1.44 1.428 1.428 0 0 1-1.39 1.44h-.06z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M145.54 50.305c-.15-.01-.3-.01-.45 0l-3.19-9.07c.76-.3 1.21-.64 1.21-1s-.75-.89-2-1.18l-1-2.74c4-1.76 6.25-6.07 6.25-8 .071-.376.112-.757.12-1.14-.05-.29.32-.23.32-.23.51-.25.09-1.71 0-1.71s-.41.07-.45-.14c-1-4.27-5.05-5.32-8.13-5.59.093-.325.133-.662.12-1a1.756 1.756 0 0 0 0-.34h.08a.659.659 0 0 0 0-1.31 13.694 13.694 0 0 0-2.52-.15 14.76 14.76 0 0 0-2.45.15.652.652 0 0 0-.511 1.088.649.649 0 0 0 .451.212 3.405 3.405 0 0 0 0 .35c-.01.316.02.632.09.94-3.12.09-7.67.74-8.59 5.64h-.39c-.24 0-.53 1.25-.2 1.78.1.17.35.05.57.07.06.5.09.56.15 1.25a11.007 11.007 0 0 0 6 7.78l-1.09 2.94c-1.42.3-2.3.74-2.3 1.26s.53.78 1.42 1.09l-5.46 14.63h1.2l1.12-2.78h16.67a2.9 2.9 0 1 0 2.9-2.92l.06.12zm-5.66-11.51a30.024 30.024 0 0 0-3.85-.3v-1.44a10.33 10.33 0 0 0 3.09-.4l.76 2.14zm-.14 11.81l1.28.65-6 .09 4.72-.74zm-2.6-.22c.27-.215.5-.475.68-.77l1 .49-1.68.28zm.06-32.18v.34c-.015.336.019.673.1 1h-2.84c.077-.328.111-.664.1-1a1.756 1.756 0 0 0 0-.34h2.64zm-5.22 18.2a8.247 8.247 0 0 0 3 .57v1.52a29.856 29.856 0 0 0-3.9.26l.9-2.35zm-1.91 5.18c1.624.34 3.28.511 4.94.51v3.19a2.879 2.879 0 0 0-2.58 2.85c-.001.36.067.716.2 1.05l-6.34 2.67 3.78-10.27zm2.93 8.25c.348.465.829.814 1.38 1l-6.56 1.11 5.18-2.11zm9.72 2.54l-13.86-.06 3.76-.52h9.45-.06l.77.39-.06.19zm.44-.92l-5-2.5c.081-.266.121-.542.12-.82a2.89 2.89 0 0 0-2.2-2.79v-3.21a22.871 22.871 0 0 0 4.81-.56l3.22 9.12a2.798 2.798 0 0 0-.95.8v-.04z",
    fill: "#E30613"
  })), __jsx("path", {
    d: "M184.234 8.55h5.024l2.24 16.032h.064l2.24-16.032h5.024v22.4h-3.328V13.99h-.064l-2.56 16.96h-2.944l-2.56-16.96h-.064v16.96h-3.072V8.55zm20.579 0h4.768l3.648 22.4h-3.52l-.64-4.448v.064h-4l-.64 4.384h-3.264l3.648-22.4zm3.84 14.976l-1.568-11.072h-.064l-1.536 11.072h3.168zm11.406 7.744c-1.707 0-2.998-.48-3.872-1.44-.875-.981-1.312-2.379-1.312-4.192v-1.28h3.328v1.536c0 1.45.608 2.176 1.824 2.176.597 0 1.045-.17 1.344-.512.32-.363.48-.939.48-1.728 0-.939-.214-1.76-.64-2.464-.427-.725-1.216-1.59-2.368-2.592-1.451-1.28-2.464-2.432-3.04-3.456-.576-1.045-.864-2.219-.864-3.52 0-1.77.448-3.136 1.344-4.096.896-.981 2.197-1.472 3.904-1.472 1.685 0 2.954.49 3.808 1.472.874.96 1.312 2.347 1.312 4.16v.928h-3.328v-1.152c0-.768-.15-1.323-.448-1.664-.299-.363-.736-.544-1.312-.544-1.174 0-1.76.715-1.76 2.144 0 .81.213 1.568.64 2.272.448.704 1.248 1.557 2.4 2.56 1.472 1.28 2.485 2.443 3.04 3.488.554 1.045.832 2.272.832 3.68 0 1.835-.459 3.243-1.376 4.224-.896.981-2.208 1.472-3.936 1.472zm10.722-19.52h-3.68v-3.2h10.88v3.2h-3.68v19.2h-3.52v-19.2zm9.544-3.2h9.6v3.2h-6.08v5.92h4.832v3.2h-4.832v6.88h6.08v3.2h-9.6V8.55zm12.265 0h5.216c1.813 0 3.136.427 3.968 1.28.832.832 1.248 2.123 1.248 3.872v1.376c0 2.325-.768 3.797-2.304 4.416v.064c.853.256 1.451.779 1.792 1.568.363.79.544 1.845.544 3.168v3.936c0 .64.021 1.163.064 1.568.043.384.149.768.32 1.152h-3.584a5.152 5.152 0 0 1-.256-1.024c-.043-.32-.064-.896-.064-1.728v-4.096c0-1.024-.171-1.739-.512-2.144-.32-.405-.885-.608-1.696-.608h-1.216v9.6h-3.52V8.55zm4.8 9.6c.704 0 1.227-.181 1.568-.544.363-.363.544-.97.544-1.824v-1.728c0-.81-.149-1.397-.448-1.76-.277-.363-.725-.544-1.344-.544h-1.6v6.4h1.28zm-68.164 43.12c-1.707 0-3.008-.48-3.904-1.44-.896-.981-1.344-2.379-1.344-4.192V43.862c0-1.813.448-3.2 1.344-4.16.896-.981 2.197-1.472 3.904-1.472 1.707 0 3.008.49 3.904 1.472.896.96 1.344 2.347 1.344 4.16v1.92h-3.328v-2.144c0-1.472-.608-2.208-1.824-2.208-1.216 0-1.824.736-1.824 2.208v12.256c0 1.45.608 2.176 1.824 2.176 1.216 0 1.824-.725 1.824-2.176V51.51h-1.76v-3.2h5.088v7.328c0 1.813-.448 3.21-1.344 4.192-.896.96-2.197 1.44-3.904 1.44zm8.148-22.72h5.216c1.813 0 3.136.427 3.968 1.28.832.832 1.248 2.123 1.248 3.872v1.376c0 2.325-.768 3.797-2.304 4.416v.064c.853.256 1.451.779 1.792 1.568.363.79.544 1.845.544 3.168v3.936c0 .64.021 1.163.064 1.568.043.384.149.768.32 1.152h-3.584a5.152 5.152 0 0 1-.256-1.024c-.043-.32-.064-.896-.064-1.728v-4.096c0-1.024-.171-1.739-.512-2.144-.32-.405-.885-.608-1.696-.608h-1.216v9.6h-3.52v-22.4zm4.8 9.6c.704 0 1.227-.181 1.568-.544.363-.363.544-.97.544-1.824v-1.728c0-.81-.149-1.397-.448-1.76-.277-.363-.725-.544-1.344-.544h-1.6v6.4h1.28zm8.746-9.6h3.52v22.4h-3.52v-22.4zm6.796 0h3.52v19.2h5.792v3.2h-9.312v-22.4zm11.64 0h3.52v19.2h5.792v3.2h-9.312v-22.4z",
    fill: "#fff"
  }), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    transform: "translate(0 2.795)",
    d: "M0 0h160.92v66.31H0z"
  }))));
};
WeberLogoWhite.defaultProps = {
  width: "271",
  height: "72",
  viewBox: "0 0 271 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WeberLogoBlack = function WeberLogoBlack(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#a)"
  }, __jsx("path", {
    d: "M151.999 54.235c0-.21-.19-.25-.36-.25h-.35v.51h.3c.22 0 .41-.01.41-.26zM111.791 53.405a1.202 1.202 0 0 0-1.138.715 1.197 1.197 0 0 0 1.554 1.595 1.195 1.195 0 0 0 .744-1.12 1.151 1.151 0 0 0-.329-.84 1.167 1.167 0 0 0-.831-.35zm.42 2l-.44-.72h-.29v.72h-.25v-1.61h.63c.39 0 .59.14.59.47a.428.428 0 0 1-.258.425.434.434 0 0 1-.172.035l.47.73-.28-.05z",
    fill: "#111313"
  }), __jsx("path", {
    d: "M151.599 53.405a1.201 1.201 0 0 0-.899 2.037 1.2 1.2 0 0 0 2.059-.847 1.169 1.169 0 0 0-.329-.84 1.156 1.156 0 0 0-.831-.35zm.42 2l-.44-.72h-.29v.72h-.25v-1.61h.63c.39 0 .59.14.59.47a.44.44 0 0 1-.258.425.43.43 0 0 1-.172.035l.47.73-.28-.05zM91.72 20.045a2.4 2.4 0 0 0-2.18 0 1.06 1.06 0 0 0-.58.94v10.7h3.33v-10.67a1.1 1.1 0 0 0-.57-.97zM53.24 21.015a1.121 1.121 0 0 0-.56-1 2.421 2.421 0 0 0-2.19 0 1.061 1.061 0 0 0-.58.94v10.73h3.33v-10.67zM112.18 54.235c0-.21-.18-.25-.36-.25h-.34v.51h.3c.21 0 .4-.01.4-.26zM71.13 54.365a1.46 1.46 0 0 0 1.62-1.38v-32.12c0-.64-.62-1.06-1.56-1.06-.94 0-1.67.36-1.67 1.06v32.12a1.47 1.47 0 0 0 1.61 1.38z",
    fill: "#111313"
  }), __jsx("path", {
    d: "M153.218 2.795H7.458a7.35 7.35 0 0 0-7.46 7.73v51a7.65 7.65 0 0 0 7.88 7.57h145.44a7.752 7.752 0 0 0 7.6-7.52v-51.31a7.503 7.503 0 0 0-2.28-5.353 7.518 7.518 0 0 0-5.42-2.117zm4.95 58.8a4.998 4.998 0 0 1-4.85 4.77H7.878a4.93 4.93 0 0 1-5.13-4.82v-51c0-3 1.89-5 4.71-5h145.76a4.804 4.804 0 0 1 4.548 2.872 4.8 4.8 0 0 1 .402 1.848v51.33z",
    fill: "#111313"
  }), __jsx("path", {
    d: "M153.219 7.795h-83.68v10.92l.41-.42c.76-.77 3.67-1.16 5.94-.2 1.79.75 2.74 2.46 2.74 4.92v28.94c0 2-2.61 4.83-7.48 4.83-5 0-7.39-2.87-7.39-4.83V9.685c0-1.48-.89-1.62-1.56-1.89H7.46c-1.81 0-2.51 1.23-2.51 2.78v51a2.76 2.76 0 0 0 2.93 2.62h145.44a2.767 2.767 0 0 0 2.64-2.57v-51.36a2.58 2.58 0 0 0-2.74-2.47zm-113.68 42.47c0 4.16-4 6.45-11.41 6.45s-11.43-2.24-11.44-6.45v-28c0-2.36-2.25-1.33-2.25-2.77v-1.32h7.94v34.3a1.62 1.62 0 0 0 1.69 1.62 1.6 1.6 0 0 0 1.68-1.62v-34.33h4.66v34.33a1.55 1.55 0 0 0 .75 1.32 2 2 0 0 0 1.86 0 1.54 1.54 0 0 0 .74-1.37v-34.28h5.78v32.12zm12.58 6.47h-1c-4.7 0-6.9-2.87-6.91-4.83v-29.66c0-1.68 2-4.82 6.87-4.82h1c4.88 0 6.9 3.14 6.9 4.82v14h-9.06v16.73a1.47 1.47 0 0 0 1.62 1.42 1.558 1.558 0 0 0 1.71-1.42v-13.22h5.72v12.15c.01 1.96-2.19 4.83-6.89 4.83h.04zm45.94-20.49H89v16.73a1.48 1.48 0 0 0 1.63 1.42 1.55 1.55 0 0 0 1.7-1.42v-13.22h5.73v12.15c0 2-2.19 4.83-6.89 4.83h-1c-4.7 0-6.9-2.87-6.91-4.83v-29.66c0-1.68 2-4.82 6.86-4.82h1c4.87 0 6.91 3.14 6.91 4.82l.03 14zm13.77 19.79a1.44 1.44 0 1 1 1.45-1.44 1.421 1.421 0 0 1-.436 1.04 1.43 1.43 0 0 1-1.054.4h.04zm5.71-19.82h-5.81v-15.11a1.221 1.221 0 0 0-.64-1.06 2.15 2.15 0 0 0-2.06 0 1.154 1.154 0 0 0-.59.76v35.31h-5.7v-33.78c0-2.35-2.25-1.33-2.25-2.76v-1.34h8v.56l.41-.28c2.09-1.53 5.1-1.12 7-.13a3 3 0 0 1 1.64 2.81v15.02zm34 19.82a1.44 1.44 0 1 1 1.45-1.44 1.428 1.428 0 0 1-1.39 1.44h-.06z",
    fill: "#111313"
  }), __jsx("path", {
    d: "M145.54 50.305c-.15-.01-.3-.01-.45 0l-3.19-9.07c.76-.3 1.21-.64 1.21-1s-.75-.89-2-1.18l-1-2.74c4-1.76 6.25-6.07 6.25-8 .071-.376.112-.757.12-1.14-.05-.29.32-.23.32-.23.51-.25.09-1.71 0-1.71s-.41.07-.45-.14c-1-4.27-5.05-5.32-8.13-5.59.093-.325.133-.662.12-1a1.756 1.756 0 0 0 0-.34h.08a.659.659 0 0 0 0-1.31 13.694 13.694 0 0 0-2.52-.15 14.76 14.76 0 0 0-2.45.15.652.652 0 0 0-.511 1.088.649.649 0 0 0 .451.212 3.405 3.405 0 0 0 0 .35c-.01.316.02.632.09.94-3.12.09-7.67.74-8.59 5.64h-.39c-.24 0-.53 1.25-.2 1.78.1.17.35.05.57.07.06.5.09.56.15 1.25a11.007 11.007 0 0 0 6 7.78l-1.09 2.94c-1.42.3-2.3.74-2.3 1.26s.53.78 1.42 1.09l-5.46 14.63h1.2l1.12-2.78h16.67a2.9 2.9 0 1 0 2.9-2.92l.06.12zm-5.66-11.51a30.024 30.024 0 0 0-3.85-.3v-1.44a10.33 10.33 0 0 0 3.09-.4l.76 2.14zm-.14 11.81l1.28.65-6 .09 4.72-.74zm-2.6-.22c.27-.215.5-.475.68-.77l1 .49-1.68.28zm.06-32.18v.34c-.015.336.019.673.1 1h-2.84c.077-.328.111-.664.1-1a1.756 1.756 0 0 0 0-.34h2.64zm-5.22 18.2a8.247 8.247 0 0 0 3 .57v1.52a29.856 29.856 0 0 0-3.9.26l.9-2.35zm-1.91 5.18c1.624.34 3.28.511 4.94.51v3.19a2.879 2.879 0 0 0-2.58 2.85c-.001.36.067.716.2 1.05l-6.34 2.67 3.78-10.27zm2.93 8.25c.348.465.829.814 1.38 1l-6.56 1.11 5.18-2.11zm9.72 2.54l-13.86-.06 3.76-.52h9.45-.06l.77.39-.06.19zm.44-.92l-5-2.5c.081-.266.121-.542.12-.82a2.89 2.89 0 0 0-2.2-2.79v-3.21a22.871 22.871 0 0 0 4.81-.56l3.22 9.12a2.798 2.798 0 0 0-.95.8v-.04z",
    fill: "#E30613"
  })), __jsx("path", {
    d: "M184.234 8.55h5.024l2.24 16.032h.064l2.24-16.032h5.024v22.4h-3.328V13.99h-.064l-2.56 16.96h-2.944l-2.56-16.96h-.064v16.96h-3.072V8.55zm20.579 0h4.768l3.648 22.4h-3.52l-.64-4.448v.064h-4l-.64 4.384h-3.264l3.648-22.4zm3.84 14.976l-1.568-11.072h-.064l-1.536 11.072h3.168zm11.406 7.744c-1.707 0-2.998-.48-3.872-1.44-.875-.981-1.312-2.379-1.312-4.192v-1.28h3.328v1.536c0 1.45.608 2.176 1.824 2.176.597 0 1.045-.17 1.344-.512.32-.363.48-.939.48-1.728 0-.939-.214-1.76-.64-2.464-.427-.725-1.216-1.59-2.368-2.592-1.451-1.28-2.464-2.432-3.04-3.456-.576-1.045-.864-2.219-.864-3.52 0-1.77.448-3.136 1.344-4.096.896-.981 2.197-1.472 3.904-1.472 1.685 0 2.954.49 3.808 1.472.874.96 1.312 2.347 1.312 4.16v.928h-3.328v-1.152c0-.768-.15-1.323-.448-1.664-.299-.363-.736-.544-1.312-.544-1.174 0-1.76.715-1.76 2.144 0 .81.213 1.568.64 2.272.448.704 1.248 1.557 2.4 2.56 1.472 1.28 2.485 2.443 3.04 3.488.554 1.045.832 2.272.832 3.68 0 1.835-.459 3.243-1.376 4.224-.896.981-2.208 1.472-3.936 1.472zm10.722-19.52h-3.68v-3.2h10.88v3.2h-3.68v19.2h-3.52v-19.2zm9.544-3.2h9.6v3.2h-6.08v5.92h4.832v3.2h-4.832v6.88h6.08v3.2h-9.6V8.55zm12.265 0h5.216c1.813 0 3.136.427 3.968 1.28.832.832 1.248 2.123 1.248 3.872v1.376c0 2.325-.768 3.797-2.304 4.416v.064c.853.256 1.451.779 1.792 1.568.363.79.544 1.845.544 3.168v3.936c0 .64.021 1.163.064 1.568.043.384.149.768.32 1.152h-3.584a5.152 5.152 0 0 1-.256-1.024c-.043-.32-.064-.896-.064-1.728v-4.096c0-1.024-.171-1.739-.512-2.144-.32-.405-.885-.608-1.696-.608h-1.216v9.6h-3.52V8.55zm4.8 9.6c.704 0 1.227-.181 1.568-.544.363-.363.544-.97.544-1.824v-1.728c0-.81-.149-1.397-.448-1.76-.277-.363-.725-.544-1.344-.544h-1.6v6.4h1.28zm-68.164 43.12c-1.707 0-3.008-.48-3.904-1.44-.896-.981-1.344-2.379-1.344-4.192V43.862c0-1.813.448-3.2 1.344-4.16.896-.981 2.197-1.472 3.904-1.472 1.707 0 3.008.49 3.904 1.472.896.96 1.344 2.347 1.344 4.16v1.92h-3.328v-2.144c0-1.472-.608-2.208-1.824-2.208-1.216 0-1.824.736-1.824 2.208v12.256c0 1.45.608 2.176 1.824 2.176 1.216 0 1.824-.725 1.824-2.176V51.51h-1.76v-3.2h5.088v7.328c0 1.813-.448 3.21-1.344 4.192-.896.96-2.197 1.44-3.904 1.44zm8.148-22.72h5.216c1.813 0 3.136.427 3.968 1.28.832.832 1.248 2.123 1.248 3.872v1.376c0 2.325-.768 3.797-2.304 4.416v.064c.853.256 1.451.779 1.792 1.568.363.79.544 1.845.544 3.168v3.936c0 .64.021 1.163.064 1.568.043.384.149.768.32 1.152h-3.584a5.152 5.152 0 0 1-.256-1.024c-.043-.32-.064-.896-.064-1.728v-4.096c0-1.024-.171-1.739-.512-2.144-.32-.405-.885-.608-1.696-.608h-1.216v9.6h-3.52v-22.4zm4.8 9.6c.704 0 1.227-.181 1.568-.544.363-.363.544-.97.544-1.824v-1.728c0-.81-.149-1.397-.448-1.76-.277-.363-.725-.544-1.344-.544h-1.6v6.4h1.28zm8.746-9.6h3.52v22.4h-3.52v-22.4zm6.796 0h3.52v19.2h5.792v3.2h-9.312v-22.4zm11.64 0h3.52v19.2h5.792v3.2h-9.312v-22.4z",
    fill: "#000"
  }), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    transform: "translate(0 2.795)",
    d: "M0 0h160.92v66.31H0z"
  }))));
};
WeberLogoBlack.defaultProps = {
  width: "271",
  height: "72",
  viewBox: "0 0 271 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TitleSvg = function TitleSvg(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M16.212 53.9h.12-.12a.36.36 0 0 0-.24.24c0 .04.04.06.12.06.16-.04.22-.02.18.06-.04.04-.22.18-.54.42-.32.24-.46.48-.42.72a.255.255 0 0 0-.24 0l-.18.06c0 .08-.02.14-.06.18 0 .08-.02.16-.06.24a.46.46 0 0 0-.06.18l-.12-.12c.04-.08.04-.12 0-.12s-.14.1-.3.3c-.16.24-.34.34-.54.3-.04.04-.06.1-.06.18.04.08.02.12-.06.12v-.06.06c-.12.24-.38.38-.78.42 0 .16-.06.26-.18.3a.76.76 0 0 1-.36.18c-.16.08-.26.12-.3.12-.12 0-.18-.1-.18-.3 0 .04-.12.12-.36.24.04.12.1.16.18.12.12-.04.2-.04.24 0-.04.08-.12.14-.24.18-.12.08-.2.1-.24.06 0 .16.04.24.12.24l-.96.48c-.48.24-.9.42-1.26.54-.04 0-.1.04-.18.12-.04.08-.08.12-.12.12-.04.04-.12.06-.24.06-.08.04-.14.04-.18 0-1.12.76-2.8 1.18-5.04 1.26-1.08-.2-1.82-.82-2.22-1.86-.4-1.04-.46-2.24-.18-3.6.2-.64.46-1.22.78-1.74s.74-1.02 1.26-1.5c.56-.44 1.02-.8 1.38-1.08.36-.24.94-.6 1.74-1.08.8-.44 1.32-.74 1.56-.9 2.08-.8 3.4-1.22 3.96-1.26-.04.16-.04.26 0 .3.08.04.2.04.36 0-.4.4-.62.68-.66.84-1 .16-1.92.62-2.76 1.38.04.08.12.08.24 0 .12-.04.24-.02.36.06.24 0 .32-.1.24-.3 0-.08-.04-.12-.12-.12.04 0 .12-.08.24-.24.16-.16.3-.22.42-.18 0 .08-.06.18-.18.3-.12.08-.18.18-.18.3 0 .04.02.04.06 0 .08-.04.16-.04.24 0-.44.32-.7.5-.78.54 0 .12.06.14.18.06.16-.08.26-.12.3-.12 0 .12-.04.2-.12.24-.08.08-.22.14-.42.18-.16.04-.26.06-.3.06-.16.24-.5.5-1.02.78-.52.32-.86.62-1.02.9-.16 0-.32.06-.48.18-.16.12-.28.18-.36.18.04.08 0 .14-.12.18-.08.08-.12.16-.12.24-1.44.84-2.62 2.08-3.54 3.72.04 0 .06.12.06.36.2.2.44.34.72.42.28.08.56.12.84.12.28.04.62.02 1.02-.06.44-.04.76-.08.96-.12.24-.04.56-.12.96-.24.44-.12.7-.18.78-.18 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12.08.04.12.08.12.12-.04.08-.04.14 0 .18.68-.52 1.34-.84 1.98-.96.64-.48 1.2-.8 1.68-.96 1.04-.76 2.5-2.04 4.38-3.84.6-1.04 1.02-1.64 1.26-1.8.64-1.28.96-2.52.96-3.72-.08-.64-.26-1.2-.54-1.68-.24-.52-.58-1.04-1.02-1.56-.44-.52-.74-.92-.9-1.2 0-.04-.04-.04-.12 0-.08 0-.12-.02-.12-.06-.72-.84-2.12-1.96-4.2-3.36-.04 0-.1-.04-.18-.12-.04-.12-.1-.2-.18-.24 0-.04-.08-.06-.24-.06a.753.753 0 0 1-.3-.18c-.04 0-.06-.02-.06-.06l-.06-.12c-.2-.16-.62-.36-1.26-.6-1.44-1-2.74-1.82-3.9-2.46-.2-.2-.54-.46-1.02-.78-.44-.32-.82-.62-1.14-.9-.28-.32-.5-.66-.66-1.02-.48-.32-.84-.84-1.08-1.56-.8-2.64.18-5.16 2.94-7.56 0-.08.04-.2.12-.36.12 0 .26-.08.42-.24.16-.16.32-.24.48-.24.2-.44.66-.8 1.38-1.08.08 0 .1-.02.06-.06a.46.46 0 0 1-.06-.18c.2-.08.56-.3 1.08-.66.52-.36.96-.58 1.32-.66.04-.16.18-.3.42-.42.28-.16.48-.22.6-.18.56-.44 1.2-.86 1.92-1.26s1.58-.84 2.58-1.32c1.04-.48 1.78-.84 2.22-1.08.04 0 .08-.02.12-.06v-.06c3.72-1.48 6.16-2.4 7.32-2.76v-.24c.36.04.86-.04 1.5-.24.64-.24 1.08-.36 1.32-.36 1-.44 2.14-.74 3.42-.9 1.28-.16 2.5-.06 3.66.3.2.28.3.44.3.48.24.04.44.24.6.6.2.36.34.58.42.66.76.92.96 1.76.6 2.52-.04.04-.1.12-.18.24l-.18.18c-.32.04-.84.34-1.56.9 0-.04-.14-.06-.42-.06.44-1.36.68-2.28.72-2.76-.72-.24-1.64-.32-2.76-.24-1.08.08-1.92.18-2.52.3-.56.12-1.36.32-2.4.6-1.04.24-1.84.42-2.4.54-.16.12-.42.26-.78.42-.36.12-.6.22-.72.3-.08 0-.14-.02-.18-.06-.04-.04-.08-.06-.12-.06v.24c-.44.08-1.38.4-2.82.96 0 .04-.04.06-.12.06h-.18c-.08-.04-.14-.04-.18 0-.24.32-.7.58-1.38.78-.68.16-1.12.38-1.32.66-.04 0-.06-.06-.06-.18-.04 0-.08.06-.12.18 0 .08-.04.14-.12.18a.805.805 0 0 0-.66.18c-.16.16-.26.24-.3.24-.08.08-.2.12-.36.12-.16 0-.26.02-.3.06-.12.04-.32.16-.6.36-.28.2-.52.3-.72.3 0 .12-.1.24-.3.36l-.6.3c-.24.12-.42.22-.54.3-.32.32-.78.54-1.38.66-.08.04-.1.08-.06.12.04.08.06.14.06.18-.76.24-1.66.74-2.7 1.5-1.04.76-1.7 1.22-1.98 1.38v.12c0 .04.02.04.06 0 0 .2-.08.22-.24.06-.28.2-.64.54-1.08 1.02-.44.44-.76.74-.96.9-.04.08-.04.14 0 .18.04.04.06.08.06.12-1.12.88-1.56 1.9-1.32 3.06.04.12.14.28.3.48.16.2.26.38.3.54.36.2.9.6 1.62 1.2.76.56 1.4.92 1.92 1.08.28.36.54.56.78.6v.18c.16 0 .28.02.36.06.08.08.18.12.3.12.08.16.12.28.12.36.36.04.86.28 1.5.72.64.4 1.12.66 1.44.78.28.32.88.8 1.8 1.44.96.64 1.62 1.22 1.98 1.74 2.16 1.68 3.62 3.92 4.38 6.72-.08-.04-.14-.18-.18-.42 0-.28-.04-.44-.12-.48.2.96.3 2.6.3 4.92-.12.4-.32.84-.6 1.32-.28.52-.44.92-.48 1.2-.12 0-.22.04-.3.12-.04.2-.2.42-.48.66-.24.28-.36.52-.36.72-.04 0-.12.04-.24.12-.16.12-.26.1-.3-.06zm5.1-39.96c0-.04-.04-.06-.12-.06-.04 0-.06.02-.06.06h.18zm-.9.24c-.04.04-.08.06-.12.06h-.06c.12 0 .18-.02.18-.06zm-1.02.36c.04 0 .08.02.12.06.08.04.12.02.12-.06-.16-.04-.24-.04-.24 0zm-.9.48c.04-.04.1-.06.18-.06h.18c.08-.04.12-.1.12-.18-.32 0-.48.08-.48.24zm-.54.12c-.04-.04-.08-.06-.12-.06l.12.06zm-.6.3h.18v-.12h-.18v.12zm-.42.18c.24-.04.36-.1.36-.18-.2 0-.32.06-.36.18zm-.9.3c-.04.12-.16.22-.36.3-.16.04-.26.1-.3.18l.06.06c.04.04.08.06.12.06.04-.08.16-.16.36-.24.2-.08.36-.14.48-.18.12-.08.12-.18 0-.3.04.08 0 .14-.12.18-.08.04-.16.02-.24-.06zm-.9.54l-.06.06h-.06c.08 0 .12-.02.12-.06zm-1.32.42c-.04.12.14.18.54.18-.04-.04-.06-.1-.06-.18 0-.12-.04-.18-.12-.18 0 .12-.12.18-.36.18zm.96.42c.04.04.08.02.12-.06 0-.16-.02-.24-.06-.24 0 .04-.02.08-.06.12v.18zm-.48.24c0-.04.02-.06.06-.06.08 0 .12-.04.12-.12-.04-.04-.1.02-.18.18zm2.34.12c.12.04.2 0 .24-.12 0-.04.02-.08.06-.12-.2.08-.3.16-.3.24zm-4.26.12c.4.12.68.02.84-.3-.44.08-.72.18-.84.3zm-.3.12h.18c0-.08-.06-.12-.18-.12v.12zm1.32 0c-.32 0-.5.1-.54.3.28-.08.46-.18.54-.3zm-2.16.48c.04.08.12.12.24.12.16-.04.26-.12.3-.24-.08-.2-.26-.16-.54.12zm2.64-.18c-.2 0-.3.02-.3.06.04.04.08.06.12.06.08 0 .14-.04.18-.12zm.9.12c.04 0 .08.02.12.06h.12c.16-.08.26-.14.3-.18l-.54.12zm-2.16.06c.04 0 .1-.04.18-.12-.12 0-.18.04-.18.12zm-1.56 0v.18c.04.04.08.02.12-.06.04-.12.02-.18-.06-.18 0 .08-.02.1-.06.06zm-.54.3c0 .04.04.08.12.12.12 0 .18.02.18.06-.04.04-.16.06-.36.06-.16-.04-.24 0-.24.12.32.12.52.06.6-.18 0-.12-.06-.22-.18-.3l-.12.12zm.54 0c0-.08-.06-.12-.18-.12a.46.46 0 0 0-.06.18c.04 0 .12-.02.24-.06zm.42.24c-.16 0-.28.04-.36.12 0 .04.12 0 .36-.12.08 0 .16-.04.24-.12l.18-.12c-.08-.04-.14-.04-.18 0 0 .04-.04.1-.12.18-.04.04-.08.06-.12.06zm2.16-.06c.16 0 .22-.06.18-.18h-.12c0 .04-.02.08-.06.12v.06zm-4.62.72c0 .12.06.22.18.3.04-.16.06-.26.06-.3l.72-.24c-.04-.08-.02-.14.06-.18.08-.08.12-.14.12-.18-.12.04-.3.14-.54.3-.2.16-.4.26-.6.3zm3.42-.36h.12v-.18h-.12v.18zm-1.62.12v-.18.18zm1.92-.06c-.04.16.04.24.24.24-.12-.16-.2-.24-.24-.24zm-2.22.24h.06l.06.06c0-.16-.04-.24-.12-.24v.18zm1.32-.12v.06l-.06.06c.04-.04.06-.08.06-.12zm-1.62.18c-.24.08-.42.22-.54.42.24-.08.42-.22.54-.42zm1.98 0c.16 0 .26-.02.3-.06-.2-.08-.3-.06-.3.06zm-1.26.18c.04 0 .08.02.12.06h.18c.04-.12-.02-.18-.18-.18-.04 0-.08.04-.12.12zm-2.76.48c.12-.04.26-.06.42-.06.16-.04.26-.06.3-.06 0-.12-.04-.22-.12-.3-.08-.04-.14-.02-.18.06.08.08.04.12-.12.12-.2.08-.3.16-.3.24zm3.12-.24c.32 0 .5-.06.54-.18-.04 0-.1.02-.18.06-.2 0-.32.04-.36.12zm.96-.18c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.56.66c.12-.04.18-.12.18-.24l-.06.06v-.12c0 .12-.04.22-.12.3zm-2.7-.24c-.24.08-.36.18-.36.3.08-.04.12-.02.12.06h.3c0-.04-.02-.1-.06-.18-.04-.04-.04-.1 0-.18zm.84.3c.12-.12.18-.2.18-.24-.16.08-.22.16-.18.24zm1.02.06c.04 0 .06-.04.06-.12l-.06.12zm.6 0h-.18.18zm-1.92 0c-.28.08-.54.24-.78.48.16.04.42-.12.78-.48zm-1.26.24c-.08-.08-.14-.12-.18-.12 0 .08-.04.12-.12.12-.08-.04-.14-.02-.18.06.16.12.32.14.48.06.2-.08.34-.2.42-.36h-.3c0 .16-.04.24-.12.24zm-.66.42c.08-.04.18-.04.3 0v-.06c-.04-.08-.08-.12-.12-.12 0 .04-.04.06-.12.06h-.06v.12zm2.34-.18c-.04 0-.06.02-.06.06.04 0 .06-.02.06-.06zm-2.16.6c.56-.2.88-.38.96-.54-.08.04-.4.22-.96.54zm1.62-.18h-.12.12zm-2.46.18h.12v-.12h-.12v.12zm.18.48c.28-.04.5-.18.66-.42h-.36c0 .08-.02.14-.06.18-.04 0-.1.02-.18.06-.04.04-.06.1-.06.18zm-.78-.12c.04.16-.06.28-.3.36.08 0 .2-.04.36-.12.24-.08.36-.06.36.06v.12c.12 0 .22-.08.3-.24-.08 0-.16-.06-.24-.18-.04-.12-.08-.18-.12-.18 0 .12-.02.2-.06.24l-.06-.06h-.24zm2.22-.12l-.12.06c-.04 0-.06.02-.06.06h.06l.12-.12zm.36.18c.04.08.1.12.18.12.08-.04.12-.1.12-.18-.2 0-.3.02-.3.06zm-.06-.06c-.08 0-.12.02-.12.06.04 0 .08-.02.12-.06zm-1.08.48h.18v-.06h-.18v.06zm-2.1.12h.12l.06-.06v-.06h-.06c-.04-.04-.08-.06-.12-.06v.18zm1.02-.18c-.08 0-.14.02-.18.06.12 0 .18-.02.18-.06zm1.38.18h.18v-.12h-.18v.12zm-.84.06l.24-.12c-.16 0-.24.04-.24.12zm-2.1.96c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm.54.3l-.06-.06c-.04-.04-.08-.06-.12-.06-.04.08.02.12.18.12zm-.18.72c.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12 0 .16.06.24.18.24zm-.36.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.8 1.38c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18l-.12.24zm.12.84c-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06-.04.08-.02.14.06.18.12.04.18.02.18-.06zm3.66 7.62h.18v-.12h-.18v.12zm3.72 1.14h.12v-.06h-.12v.06zm.42.12c.04-.08-.02-.12-.18-.12-.04.04-.04.08 0 .12.04.04.1.04.18 0zm-1.38.18h.06v-.18h-.06v.18zm.78.36c0-.16-.1-.24-.3-.24-.04.08 0 .14.12.18.12 0 .18.02.18.06zm1.86.36h.12v-.06h-.12v.06zm-.66.48c.08-.12.1-.2.06-.24h-.12c0 .12.02.2.06.24zm-.54-.12l-.12.12.12-.12zm.78.48c0-.04.04-.08.12-.12.08-.04.1-.1.06-.18a.46.46 0 0 1-.18-.06c0 .04-.02.1-.06.18-.04.08-.02.14.06.18zm1.56-.18l-.18.06c-.04.08-.04.12 0 .12.08-.04.14-.1.18-.18zm.12.3h.06v-.12h-.06v.12zm-.18.72h.12v-.12h-.12v.12zm.6.42a.68.68 0 0 0-.24-.24l-.18-.18c.04.24.18.38.42.42zm.18.12h.12v-.06c.04 0 .06-.02.06-.06h-.24c-.04.04-.02.08.06.12zm1.08.84c.12.16.64.66 1.56 1.5-.28-.6-.8-1.1-1.56-1.5l-.3-.3c-.12-.16-.22-.26-.3-.3-.08-.08-.18-.08-.3 0 .12.04.26.16.42.36.16.16.32.24.48.24zm2.1 1.98c-.04-.16-.16-.28-.36-.36.08.2.2.32.36.36zm-5.4 6.36c.24 0 .36-.04.36-.12-.16 0-.28.04-.36.12zm-.48.36c-.32.12-.48.22-.48.3.04-.04.1-.06.18-.06.08-.04.14-.08.18-.12.08-.04.12-.08.12-.12h.12v-.24c-.08 0-.12.08-.12.24zm-.72.36h.18v-.18h-.18v.18zm-.66.36c.32-.08.5-.16.54-.24l-.06-.06c-.04-.04-.1-.04-.18 0 .04.08 0 .14-.12.18-.12.04-.18.08-.18.12zm-.48.18h-.42l-.06.12c0 .08-.02.12-.06.12-.08-.04-.18-.02-.3.06-.08.04-.16.02-.24-.06.04.08.02.14-.06.18-.04.04-.06.08-.06.12h.12c.08.04.16.06.24.06 0-.04.12-.12.36-.24s.4-.24.48-.36zm-1.86.6c-.12.24-.16.34-.12.3-.04.08-.1.06-.18-.06 0 .04-.04.1-.12.18-.16.2-.2.34-.12.42.08-.04.18-.06.3-.06.04-.16.1-.28.18-.36.08-.08.2-.16.36-.24.2-.04.32-.06.36-.06-.04 0-.08-.02-.12-.06 0-.04-.02-.06-.06-.06h-.48zm1.08.54c-.68.2-1.16.52-1.44.96l-.36.18c-.16.08-.3.16-.42.24-.08.08-.1.16-.06.24.08-.08.22-.18.42-.3.24-.08.44-.18.6-.3.16-.12.3-.26.42-.42 0 .08.06.1.18.06.04-.08.26-.2.66-.36.4-.16.62-.42.66-.78h-.18c-.04.16-.12.26-.24.3-.12.08-.2.14-.24.18zm-3.96 1.8c.16-.08.46-.3.9-.66.48-.32.86-.54 1.14-.66v-.24c-.12.08-.34.22-.66.42-.32.2-.6.38-.84.54-.2.2-.38.4-.54.6zm1.38-.06c.16 0 .24-.06.24-.18h-.18l-.06.06v.12zm10.44.18c-.08-.2-.14-.3-.18-.3-.12.2-.06.3.18.3zm-10.86-.06c-.04.16-.16.28-.36.36-.2.12-.3.22-.3.3.56-.32.86-.56.9-.72-.04-.04-.12-.02-.24.06zm-1.2.24c0-.04.02-.08.06-.12.08 0 .12-.02.12-.06-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06 0 .16.02.26.06.3zm11.58 0c.04.08.08.1.12.06.08-.04.14-.1.18-.18-.2 0-.3.04-.3.12zm-11.94.12c-.04 0-.06-.02-.06-.06h-.06c-.04.12-.2.24-.48.36-.24.12-.38.24-.42.36.36-.24.6-.36.72-.36 0-.12.04-.2.12-.24.08.08.14.12.18.12v-.18h.18c0-.04-.02-.08-.06-.12l-.12.12zm12.42 0c.08 0 .12-.04.12-.12-.12 0-.16.04-.12.12zm-.6.06c-.04 0-.08.02-.12.06-.08 0-.12.02-.12.06.16 0 .24-.04.24-.12zm.36.24h-.06a.36.36 0 0 0-.24.24c.12.04.2-.04.24-.24h.06zm-.36 0h-.12c-.04 0-.06.02-.06.06.12 0 .18-.02.18-.06zm-.06.6l-.3.24c.12.04.22-.04.3-.24h.06c.12-.12.12-.2 0-.24-.08.08-.1.16-.06.24zm-11.7.06c.12.04.22 0 .3-.12-.08 0-.14.02-.18.06-.04.04-.08.06-.12.06zm10.86.18c0-.12-.04-.18-.12-.18 0 .12.04.18.12.18zm-.12.78c-.12 0-.22.08-.3.24.2-.12.3-.2.3-.24.12.04.2-.02.24-.18 0-.04-.02-.08-.06-.12 0 .08-.04.14-.12.18-.04.04-.06.08-.06.12zm-.84 0l-.06.06h-.06c.08 0 .12-.02.12-.06zm-10.56.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm10.92.3c.08-.2.1-.3.06-.3l-.06.06c-.12.12-.12.2 0 .24zm-.84-.12c-.12 0-.18.02-.18.06.08 0 .14-.02.18-.06zm.06.78c.2-.08.42-.28.66-.6-.24.04-.46.24-.66.6zm-.6-.3c-.04 0-.08-.02-.12-.06-.04-.04-.08-.04-.12 0-.04.08-.02.12.06.12.08.04.16.04.24 0v-.12c0-.12-.02-.18-.06-.18v.24zm1.98-.18v.18l.12-.12c0-.08-.02-.12-.06-.12 0 .08-.02.1-.06.06zm-2.52.42c.04-.04.08-.04.12 0 .04.04.08.06.12.06 0-.16-.08-.24-.24-.24V56zm.9.24c.12 0 .18-.04.18-.12h-.12l-.06.12zm.84 0l-.12.06c.04 0 .08-.02.12-.06zm-2.46.42c-.28.04-.56.12-.84.24-.28.16-.6.36-.96.6-.32.24-.58.4-.78.48.08-.04.16-.06.24-.06.08.04.14.06.18.06.04.04.08.02.12-.06-.12 0-.18-.06-.18-.18.24.04.42-.02.54-.18.16-.12.28-.16.36-.12.12-.24.34-.4.66-.48.32-.04.54-.14.66-.3l.18-.06c.12-.04.16-.12.12-.24-.12-.04-.22-.04-.3 0-.04.08-.04.18 0 .3zm1.2 0c.08-.08.16-.12.24-.12.08.04.12.04.12 0-.04-.08-.12-.12-.24-.12s-.16.08-.12.24zm.66 0c.16.04.28.02.36-.06.04-.04.02-.08-.06-.12-.04.08-.12.12-.24.12l-.06.06zm-.42.36c.2-.08.32-.2.36-.36-.16 0-.28.12-.36.36zm-.84-.06c-.08-.04-.16-.02-.24.06-.04.08-.02.14.06.18 0-.04.04-.06.12-.06.08-.04.1-.1.06-.18.08 0 .12-.06.12-.18-.08 0-.12.06-.12.18zm.12.36c.24.16.42.12.54-.12h-.3c-.12.04-.2.08-.24.12zm-1.8.48v.3l.18-.18c.12-.04.2-.1.24-.18a.255.255 0 0 0-.24 0 .46.46 0 0 1-.18.06zm1.02.24c.08.08.12.04.12-.12l-.12-.12v.24zm-4.38.12c0-.04-.12-.06-.36-.06-.04.12 0 .18.12.18.16 0 .24-.04.24-.12zm1.8-.06c-.04.04-.08.06-.12.06h-.06c.08 0 .14-.02.18-.06zm1.08.24h.12v-.24h-.18c0 .12.02.2.06.24zm-1.62 0c-.16 0-.24.08-.24.24.08.04.12 0 .12-.12.04-.08.08-.12.12-.12.16 0 .26-.06.3-.18-.2 0-.3.06-.3.18zm-3.3.36c.16.28.26.42.3.42-.08 0-.12-.06-.12-.18.52 0 .82-.08.9-.24-.12 0-.2-.02-.24-.06.04-.04.12-.06.24-.06.16 0 .26-.04.3-.12-.2-.04-.46 0-.78.12-.28.12-.48.16-.6.12zm1.56-.18h.12c.04-.04 0-.08-.12-.12-.08-.04-.12-.02-.12.06l.12.06zm3.06.12c.08-.16.08-.24 0-.24 0 .04-.02.08-.06.12-.04.08-.02.12.06.12zm-2.1-.06c-.08.16-.12.28-.12.36l.24-.24.36-.18h-.3a.46.46 0 0 1-.18.06zm1.74.06h.06c.04.04.08.06.12.06-.04-.12-.1-.18-.18-.18v.12zm-2.82.06h.12v-.12h-.12v.12zm3.66 0h.06v-.12h-.06v.12zm-5.28.06c-.76.08-1.22.24-1.38.48.04 0 .1-.02.18-.06a.46.46 0 0 1 .18-.06c.04-.08.14-.14.3-.18.16 0 .26.06.3.18-.04.04-.08.04-.12 0-.04-.04-.08-.06-.12-.06.04.16.16.22.36.18.2 0 .36-.06.48-.18l-.12-.06c-.08 0-.12-.02-.12-.06.04 0 .06-.06.06-.18zm1.02.6c.08-.04.24-.08.48-.12.24 0 .44-.02.6-.06.16-.04.26-.14.3-.3-.76.16-1.22.32-1.38.48zm-.42.06c-.2 0-.3.02-.3.06.2.08.3.06.3-.06zm13.86-13.5c.08 0 .12.06.12.18h-.12v-.18zm0 .24c.08 0 .14.08.18.24v.18c-.12 0-.18-.14-.18-.42zm.12 1.02c.12.08.18.26.18.54.04.24-.02.38-.18.42v-.96zm0 1.32v.3-.3zm-8.4.84l-.18.06a.94.94 0 0 1-.24.18c0-.28.14-.36.42-.24zm3.18 7.32c0-.04.02-.08.06-.12-.04 0-.06.04-.06.12zM36.403 8.18c-.08.2-.16.54-.24 1.02-.04.48-.12.88-.24 1.2-.12.32-.28.56-.48.72-.08 1.24-.48 2.94-1.2 5.1-.68 2.16-1.08 3.54-1.2 4.14.96.12 2.54.14 4.74.06.76.12 1.94.2 3.54.24 1.64 0 3.12.1 4.44.3 1.32.2 2.5.6 3.54 1.2-.08.04-.22.06-.42.06-.2-.04-.32-.02-.36.06-1.76-.64-4.54-1.02-8.34-1.14-3.8-.12-6.1-.24-6.9-.36-.32.08-.52.3-.6.66 0 .12.1.2.3.24.24 0 .38.04.42.12.12-.32.2-.48.24-.48 0 .16.12.28.36.36.28.04.48-.04.6-.24.2.08.38.14.54.18.2 0 .4-.02.6-.06.24-.04.42-.06.54-.06.08.04.12.12.12.24.04.08.08.14.12.18.16 0 .24-.04.24-.12.04 0 .06.02.06.06l.06.06c.12-.04.1-.12-.06-.24.04-.12.12-.08.24.12.08 0 .1-.04.06-.12a.982.982 0 0 1-.06-.24c.28.32.74.48 1.38.48.64 0 1.12.04 1.44.12.04 0 .06-.06.06-.18.12.08.24.1.36.06.16-.04.32-.02.48.06.04-.04.02-.08-.06-.12a.698.698 0 0 0-.18-.12c-.08-.04-.12-.1-.12-.18.08.04.3.06.66.06.08.12.08.16 0 .12l-.12.06c.28.2.72.28 1.32.24.6-.04 1.06 0 1.38.12.16-.08.28-.2.36-.36.04 0 .06.08.06.24.04.16.12.22.24.18.04 0 .04-.04 0-.12a.982.982 0 0 1-.06-.24c.32.4.46.64.42.72.16 0 .24-.12.24-.36.08.08.2.1.36.06.16-.08.24-.08.24 0 .08 0 .12-.06.12-.18v-.18c.16.12.5.18 1.02.18.56-.04 1.02.02 1.38.18-.68.2-1.34.2-1.98 0-.04.04-.12.14-.24.3-.08.16-.18.22-.3.18-.12-.04-.2-.16-.24-.36-.04.08-.12.14-.24.18-.12.04-.24.06-.36.06-.08 0-.16.02-.24.06-.08.04-.12.12-.12.24-.12.04-.2 0-.24-.12 0-.16-.04-.24-.12-.24 0 .16-.08.24-.24.24-.16 0-.28.02-.36.06 0-.12.08-.18.24-.18 0-.16-.08-.2-.24-.12-.08 0-.1.06-.06.18-.04 0-.1-.04-.18-.12-.04-.12-.12-.16-.24-.12-.08 0-.2.12-.36.36-2.56-.32-5.92-.38-10.08-.18-.08.04-.16.18-.24.42-.04.2-.12.3-.24.3 0 .64-.2 1.52-.6 2.64-.4 1.08-.64 1.86-.72 2.34-.32.88-.82 2.26-1.5 4.14l-1.44 3.9c-.28.8-.98 2.22-2.1 4.26-1.12 2.04-1.76 3.74-1.92 5.1 0 1.04-.08 1.84-.24 2.4.08 1.44.04 2.5-.12 3.18.08 4.04.84 6.66 2.28 7.86-.92-.12-1.68-.52-2.28-1.2-.6-.64-1-1.28-1.2-1.92-.2-.64-.4-1.5-.6-2.58-.2-2.36-.26-3.94-.18-4.74.04 0 .08.04.12.12 0 .08.04.1.12.06 0-.84.04-1.32.12-1.44-.16.08-.24.22-.24.42-.04.2-.06.32-.06.36 0-1.52.12-2.5.36-2.94v-.6c-.04-.32-.06-.56-.06-.72 0-.2-.04-.42-.12-.66-.08-.24-.18-.44-.3-.6.08-.08.22-.26.42-.54.16-.28.3-.48.42-.6.56-4.32 1.88-10.4 3.96-18.24-.52-.08-1.62.08-3.3.48-1.64.36-2.66.28-3.06-.24-.16-.76-.12-1.4.12-1.92s.7-.7 1.38-.54c.64-.16 1.64-.3 3-.42s2.26-.22 2.7-.3c.32-1 .82-2.7 1.5-5.1.72-2.4 1.26-4.16 1.62-5.28.12-.32.38-1.16.78-2.52.4-1.4.7-2.38.9-2.94.2-.56.56-1.26 1.08-2.1.52-.84 1.08-1.5 1.68-1.98 1.08.08 1.78.68 2.1 1.8.36 1.08.34 2.18-.06 3.3.16.16.22.4.18.72.04 0 .08-.06.12-.18v-.12c.12.24.08.58-.12 1.02-.2.4-.28.7-.24.9h-.06c-.04-.04-.08-.06-.12-.06v.3l.06-.06h.06zm-3-1.5c-.08.16-.14.24-.18.24h-.12c-.12.12-.14.28-.06.48l-.12.12h-.06c0 .08-.06.24-.18.48-.08.24-.06.4.06.48 0-.04.04-.16.12-.36.08-.24.1-.44.06-.6l.12-.12h.06c0-.12.02-.18.06-.18-.36 1.32-1 3.48-1.92 6.48-.92 3-1.58 5.24-1.98 6.72.2.04.44.06.72.06.32-.04.56-.06.72-.06.28-1.08.82-2.88 1.62-5.4.8-2.56 1.4-4.74 1.8-6.54.44-1.84.72-3.64.84-5.4-.56.84-1.08 2.04-1.56 3.6zm-1.26 13.56l.12-.18c0-.04-.04-.1-.12-.18a.982.982 0 0 1-.06-.24c.04-.08.08-.18.12-.3.08-.12.14-.24.18-.36.04-.12.06-.26.06-.42.04-.04.1-.06.18-.06.08 0 .16-.04.24-.12v-.42c-.12 0-.18-.02-.18-.06.04-.08.08-.26.12-.54.08-.32.18-.52.3-.6 0 .08.02.12.06.12l.18-.36c.12-.24.14-.44.06-.6-.04.04-.08.14-.12.3 0 .16-.04.26-.12.3-.04-.12.06-.48.3-1.08.04 0 .06.04.06.12 0 .08.02.12.06.12.4-1.08.64-1.9.72-2.46-.12.16-.26.52-.42 1.08-.12.52-.26.82-.42.9.16-.64.44-1.66.84-3.06.44-1.4.8-2.66 1.08-3.78.28-1.12.48-2.2.6-3.24.04 0 .06-.02.06-.06 0-.04-.02-.06-.06-.06a.982.982 0 0 1-.06-.24l.12-.12c.08-.04.12-.08.12-.12-.2-.08-.24-.18-.12-.3-.24.6-.46 1.7-.66 3.3-.04.04-.1.04-.18 0-.04-.04-.08-.06-.12-.06 0 .04.02.1.06.18.04.08.06.16.06.24-.2.16-.38.48-.54.96-.12.48-.1.88.06 1.2-.04.04-.1.06-.18.06a.255.255 0 0 0-.24 0c-.24 1.2-.74 2.98-1.5 5.34s-1.24 4.04-1.44 5.04c.16.04.4-.1.72-.42 0 .04.02.08.06.12v.06zm4.02-12.3c.08-.04.12-.12.12-.24s-.04-.2-.12-.24c0 .04-.02.1-.06.18a.46.46 0 0 0-.06.18c0 .04.04.08.12.12zm-3.72 1.02c.12.04.18 0 .18-.12 0-.16-.04-.24-.12-.24.04.08.04.14 0 .18a.46.46 0 0 0-.06.18zm-1.08.06c-.04 0-.06.06-.06.18.04 0 .06-.06.06-.18zm3.96.06h.12v-.12h-.12v.12zm-2.94.48c0-.04.02-.1.06-.18.08-.2.06-.3-.06-.3 0 .08-.04.18-.12.3-.04.12 0 .18.12.18zm-1.74-.12v.18c.08.04.12.02.12-.06.04-.12.02-.18-.06-.18 0 .08-.02.1-.06.06zm5.28.48v-.36l-.06.3.06.06zm-5.4.24c.04-.04.08-.12.12-.24a.46.46 0 0 0 .06-.18c-.12 0-.18.14-.18.42zm1.62.12c.16-.32.18-.5.06-.54 0 .04-.02.1-.06.18 0 .08-.02.16-.06.24 0 .04.02.08.06.12zm-1.14-.18c0-.04.02-.06.06-.06 0-.12-.04-.16-.12-.12 0 .12.02.18.06.18zm-.12.66c-.04-.08-.04-.18 0-.3s0-.18-.12-.18c.04.04.04.1 0 .18v.24c.04.04.08.06.12.06zm4.08-.42v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-4.62.36h.06c-.04-.08-.04-.14 0-.18.08-.08.12-.14.12-.18-.12.04-.18.16-.18.36zm1.68.06v-.3.3zm2.94.12c.12-.16.12-.24 0-.24-.12.16-.12.24 0 .24zm-4.68.24c0-.04.02-.1.06-.18.08-.08.06-.12-.06-.12v.3zm4.32.6c.12 0 .18-.04.18-.12.04-.16.1-.22.18-.18-.04-.04-.04-.12 0-.24s0-.18-.12-.18c0 .08-.04.2-.12.36l-.12.36zm-4.02-.18c0-.04.02-.1.06-.18.08-.24.06-.34-.06-.3 0 .04-.04.14-.12.3-.04.12 0 .18.12.18zm4.68-.18c0-.08.02-.12.06-.12 0-.08-.04-.12-.12-.12 0 .16.02.24.06.24zm-5.34.72h.06c.12-.52.18-.8.18-.84-.08.24-.16.52-.24.84zm1.74-.18c0-.04.02-.1.06-.18.04-.08.02-.12-.06-.12v.3zm-1.5.72c.08.04.12.04.12 0 .04-.08.06-.18.06-.3-.08-.04-.12.02-.12.18 0 .08-.02.12-.06.12zm-.6.54c.28-.2.36-.42.24-.66 0 .08-.04.18-.12.3l-.12.36zm5.4-.48h.12v-.12h-.12v.12zm-5.04.54v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-.48.78c0-.04.02-.12.06-.24.08-.16.12-.26.12-.3.04-.08 0-.16-.12-.24.04.12.02.28-.06.48-.08.16-.08.26 0 .3zm.36.12c0-.04.02-.06.06-.06 0-.12-.06-.16-.18-.12l.06.06c0 .08.02.12.06.12zm-.66.48c.08 0 .14-.06.18-.18.04-.12.02-.22-.06-.3 0 .04-.02.12-.06.24 0 .12-.02.2-.06.24zm.36.6c.12-.4.14-.64.06-.72 0 .08-.02.18-.06.3 0 .12-.02.2-.06.24 0 .04.02.1.06.18zm-.9 1.08c-.68 2.24-1.06 3.64-1.14 4.2.76-2.08 1.14-3.48 1.14-4.2.4-.72.58-1.26.54-1.62-.12.12-.3.66-.54 1.62zm.72-.84h-.06c-.04.2-.12.48-.24.84-.08.32-.14.62-.18.9.32-.4.48-.98.48-1.74zm1.2.48l-.06-.12c0-.08-.02-.12-.06-.12-.04.04-.06.1-.06.18.04.04.1.06.18.06zm-2.64 4.56c.04-.08.38-1.14 1.02-3.18h-.18c-.08.4-.24.94-.48 1.62-.2.68-.32 1.2-.36 1.56zm1.98-2.82c.12 0 .18-.1.18-.3-.08-.04-.12.02-.12.18 0 .08-.02.12-.06.12zm-.24.96c.04 0 .1-.1.18-.3-.12-.04-.18.02-.18.18v.12zm-.18.84c.08-.2.08-.32 0-.36 0 .04-.02.1-.06.18-.04.08-.02.14.06.18zm2.16 1.86c0-.04.04-.08.12-.12.08-.08.1-.16.06-.24-.4 0-.64.04-.72.12.08.04.08.08 0 .12-.12.08-.14.22-.06.42.04 0 .1-.02.18-.06.08-.08.18-.1.3-.06 0-.04.04-.1.12-.18zm-1.68 0c0-.08-.08-.16-.24-.24-.08.04-.2.06-.36.06-.12 0-.2.04-.24.12.08 0 .16.06.24.18.08.12.2.16.36.12.04-.08.02-.16-.06-.24-.04-.08-.02-.12.06-.12.08.16.12.26.12.3.12.08.26.06.42-.06.2-.12.24-.24.12-.36 0 .2-.08.22-.24.06-.04-.04-.08-.06-.12-.06 0-.04-.02-.08-.06-.12-.04.04-.02.12.06.24.04.04.02.08-.06.12zm1.32.66c.04 0 .06.02.06.06h.06c0-.16-.04-.22-.12-.18v.12zm12.72.42c0-.12-.04-.18-.12-.18 0 .16.04.22.12.18zm-.42 0h.12v-.12h-.12v.12zm-4.14.18c.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12 0 .16.06.24.18.24zm-9.6 5.22c.04 0 .06-.04.06-.12 0-.08.04-.16.12-.24-.08 0-.14-.02-.18-.06.4-.68.54-1.16.42-1.44l.36-.12c.08-.76.22-1.26.42-1.5-.12-.04-.18-.16-.18-.36 0-.2.08-.32.24-.36v.12c.08-.08.12-.22.12-.42 0-.2-.04-.34-.12-.42h-.24c-.12 0-.22.02-.3.06-.08.56-.3 1.3-.66 2.22-.36.88-.58 1.56-.66 2.04-.52.96-.86 1.92-1.02 2.88l-.18-.18c-.04.08-.06.2-.06.36.04.12.06.22.06.3.04.04.04.08 0 .12-.04 0-.08-.04-.12-.12 0-.08-.04-.1-.12-.06-.08.56-.3 1.26-.66 2.1-.36.8-.58 1.36-.66 1.68a.51.51 0 0 1 .48 0c.16-.52.46-1.26.9-2.22.44-1 .74-1.7.9-2.1.08 0 .1.06.06.18 0 .08.02.12.06.12 0-.12.04-.18.12-.18 0-.08-.02-.14-.06-.18 0-.04-.02-.08-.06-.12-.04-.04-.06-.1-.06-.18.2.08.32.08.36 0-.16-.2-.18-.38-.06-.54.04-.08.12-.06.24.06.08-.12.06-.22-.06-.3a.645.645 0 0 1-.12-.36c.08 0 .12.02.12.06l.06.12c.08-.08.08-.16 0-.24-.04-.12-.04-.2 0-.24.04 0 .08.02.12.06.08.04.14.08.18.12 0-.08.02-.16.06-.24.08-.12.12-.22.12-.3zm-1.32-4.74c-.28.92-.68 2.5-1.2 4.74-.52 2.2-.98 3.88-1.38 5.04.08.16.06.42-.06.78-.12.36-.12.56 0 .6 1.92-5 3.26-8.74 4.02-11.22-.24-.04-.5-.04-.78 0s-.48.06-.6.06zm-2.88 4.14c-.6.92-.76 1.66-.48 2.22.2-.64.46-1.68.78-3.12.36-1.44.62-2.44.78-3h-.24c-.08.36-.24.96-.48 1.8-.2.8-.32 1.5-.36 2.1zm1.14-3.06c.08 0 .14-.06.18-.18.08-.16.12-.28.12-.36.04-.12.02-.2-.06-.24-.04.12-.1.28-.18.48-.04.16-.06.26-.06.3zm-.3 1.68c0-.16.04-.36.12-.6.12-.28.18-.48.18-.6.04-.12.02-.26-.06-.42 0 .16-.08.44-.24.84-.12.36-.12.62 0 .78zm-.24.66h.12c0-.12-.04-.2-.12-.24v.24zm-.36 1.8h.06c.04-.12.08-.3.12-.54.04-.28.06-.44.06-.48-.28.12-.36.46-.24 1.02zm-.24 1.14c0-.08.04-.24.12-.48.08-.24.06-.4-.06-.48-.16.6-.18.92-.06.96zm-.24.66c0-.04.02-.12.06-.24.08-.2.06-.32-.06-.36v.6zm-1.5 4.32v.12c-.04.04-.08.06-.12.06 0 .2-.06.3-.18.3-.08-.04-.12-.04-.12 0 .04 0 .08.02.12.06l.12.06c-.48 1.24-.68 2.14-.6 2.7-.08.04-.16.32-.24.84-.24.24-.26.54-.06.9-.08-.08-.14-.1-.18-.06-.04.04-.04.1 0 .18.12 0 .18.02.18.06 0 .08-.06.18-.18.3-.12.08-.18.16-.18.24h.12c.08.04.12.08.12.12-.12 0-.2.06-.24.18-.04.08.02.14.18.18-.4.28-.46.5-.18.66-.04-.12 0-.24.12-.36s.14-.22.06-.3c0-.04.04-.06.12-.06.16-.96.36-2.08.6-3.36.28-1.28.46-2.22.54-2.82.04-.2.22-.88.54-2.04.36-1.2.52-2.14.48-2.82-.08.16-.16.46-.24.9-.08.4-.16.68-.24.84.08.08.04.24-.12.48-.12.2-.12.38 0 .54-.04 0-.08-.02-.12-.06l-.06.12c.12.16.06.52-.18 1.08-.2.52-.28.84-.24.96h.18zm1.14-3.12c.16-.4.2-.66.12-.78 0 .08-.04.22-.12.42-.08.16-.08.28 0 .36zm3.6-.6c.08-.08.08-.14 0-.18v.18zm-3.78 1.26l.18-.36c-.08-.04-.14-.02-.18.06v.3zm-.36 1.56h-.06c0 .12-.04.28-.12.48-.08.2-.08.34 0 .42-.12.08-.2.3-.24.66-.04.32-.08.52-.12.6.16-.12.24-.34.24-.66.04-.32.08-.52.12-.6.04 0 .1-.3.18-.9.24-.12.3-.48.18-1.08l-.18 1.08zm1.86 1.14v-.18.18zm-2.76 3.24c0-.04.06-.22.18-.54.12-.32.14-.56.06-.72 0 .08-.04.22-.12.42-.08.2-.14.36-.18.48 0 .08.02.2.06.36zm-.24 1.44c0-.08.04-.22.12-.42.08-.2.12-.34.12-.42 0-.08-.04-.2-.12-.36-.08.76-.12 1.16-.12 1.2zm-1.62 7.08c.08-.2.06-.32-.06-.36v.18c0 .12.02.18.06.18zm-.06.3v-.24.24zm.48.48c.12.08.18.02.18-.18 0-.08-.02-.12-.06-.12 0 .08-.02.14-.06.18-.04.04-.06.08-.06.12zm-.54.24c.2 0 .3-.1.3-.3-.2 0-.3.1-.3.3zm0 1.98v-.18c0-.12-.02-.18-.06-.18-.08.24-.06.36.06.36zm.54.36c0-.32-.04-.46-.12-.42 0 .04.02.12.06.24 0 .08.02.14.06.18zm-.42.12v-.3c.04-.08.02-.14-.06-.18v.3c-.04.08-.02.14.06.18zm.36.72c.08-.28.08-.5 0-.66-.04.04-.06.14-.06.3 0 .16.02.28.06.36zm-.42 0c0-.04.02-.1.06-.18.04-.04.02-.08-.06-.12 0 .04-.02.06-.06.06-.04 0-.06.02-.06.06l.06.06c0 .08.02.12.06.12zm.42 1.2c0-.08.02-.28.06-.6 0-.28-.04-.44-.12-.48 0 .12-.02.32-.06.6-.04.32 0 .48.12.48zm-.36-.6c0-.24-.02-.36-.06-.36-.08.08-.1.16-.06.24 0 .08.04.12.12.12zM35.983 5l-.06.06.06.06V5zm-2.82 1.92h.06c0 .2-.02.3-.06.3v-.3zm1.56 2.28c.12 0 .18.06.18.18-.08.04-.12.02-.12-.06-.04-.04-.06-.08-.06-.12zm-1.44 4.92h.18v.3h-.18v-.3zm-.78 4.08h.18v.12c-.04 0-.06.02-.06.06h-.18v-.12l.06-.06zm4.26 3.6c-.12-.08-.22-.26-.3-.54.12.08.22.26.3.54zm2.4-.48c.32.08.5.2.54.36-.08 0-.16-.04-.24-.12-.12-.08-.2-.04-.24.12-.12.04-.16 0-.12-.12 0-.12.02-.2.06-.24zm2.34.12c.08-.04.12 0 .12.12.04.08.08.12.12.12-.08.04-.16-.04-.24-.24zm-3.66.06c.04 0 .08.02.12.06h.18c0 .08-.08.1-.24.06-.08 0-.1-.04-.06-.12zm4.56.06c0-.04.06-.06.18-.06v.18l-.06-.06c-.04-.04-.08-.06-.12-.06zm.42-.06c.08 0 .12.06.12.18.04.08.02.14-.06.18-.08 0-.1-.06-.06-.18v-.18zm-.9.06c.04.04.12.06.24.06 0 .04-.04.08-.12.12-.08 0-.12.04-.12.12-.08 0-.1-.04-.06-.12.08-.08.1-.14.06-.18zm2.76.24c.16 0 .2.08.12.24-.08 0-.12-.08-.12-.24zm.3 0c.08 0 .12.08.12.24-.08 0-.12-.08-.12-.24zm-15.18 6l-.12-.12c.08 0 .12.04.12.12zm-8.28 25.74v.18c-.12 0-.18-.06-.18-.18h.18zm20.726-5.1c5.68-4.76 9.4-7.84 11.16-9.24.96.16 1.48.56 1.56 1.2-1.48 1.56-3.74 3.62-6.78 6.18-3.04 2.56-5.14 4.42-6.3 5.58 0 .68-.04 1.6-.12 2.76-.08 1.2-.12 2.1-.12 2.7-1.28 10.72-2.96 18.78-5.04 24.18-.52 2.44-1.54 4.88-3.06 7.32-.68 1.2-1.3 2.18-1.86 2.94-.52.76-1.22 1.56-2.1 2.4-.88.88-1.88 1.52-3 1.92-1.12.4-2.38.58-3.78.54-.64-.28-1.12-.44-1.44-.48-.08-.2-.12-.34-.12-.42-.76-.28-1.44-.8-2.04-1.56-.6-.76-1.02-1.48-1.26-2.16-.28-.64-.6-1.54-.96-2.7-.08-.4-.12-.82-.12-1.26v-1.2c0-.36.04-.76.12-1.2.04-.44.1-.82.18-1.14.04-.28.14-.66.3-1.14.12-.44.22-.78.3-1.02.04-.2.16-.56.36-1.08.2-.48.34-.82.42-1.02.08-.16.24-.5.48-1.02.2-.52.32-.84.36-.96 1.96-4.6 3.92-8.14 5.88-10.62.8-1.36 1.78-2.82 2.94-4.38 1.12-1.52 2.06-2.72 2.82-3.6.76-.88 1.92-2.22 3.48-4.02 1.6-1.76 2.66-2.94 3.18-3.54.24-.16 1-.88 2.28-2.16.32-5.24.52-8.32.6-9.24-.4.32-1.56 1.4-3.48 3.24-1.88 1.8-3.48 3.02-4.8 3.66-.92-.12-1.6-.44-2.04-.96-.44-.52-.62-1.18-.54-1.98.04-.8.14-1.54.3-2.22.16-.72.42-1.56.78-2.52.36-.96.58-1.62.66-1.98.6.16 1.04.44 1.32.84.28.4.38.9.3 1.5-.04.56-.14 1.1-.3 1.62-.12.48-.32 1.04-.6 1.68-.24.64-.4 1.1-.48 1.38 2.08-1.24 5.16-3.86 9.24-7.86.36-.24.72-.3 1.08-.18.36.12.62.38.78.78 0 1.04-.1 2.76-.3 5.16-.2 2.4-.28 4.16-.24 5.28zm10.2-7.8c.56-.44.8-.7.72-.78a.68.68 0 0 1-.24.24l-.36.24c-.08.08-.12.18-.12.3zm1.14.12c-.04-.08-.02-.14.06-.18.08-.04.12-.1.12-.18-.12-.08-.22-.06-.3.06-.04.08-.08.14-.12.18-.52.4-4.26 3.52-11.22 9.36 0 .48-.02.82-.06 1.02 1-.72 1.66-1.32 1.98-1.8.68-.2 1.24-.74 1.68-1.62.4.08.86-.22 1.38-.9.52-.68.98-1.02 1.38-1.02.52-.72 1.5-1.66 2.94-2.82 1.48-1.2 2.44-2.06 2.88-2.58h-.24c-.08.28-.24.44-.48.48zm-2.22.84l.3-.3c.16-.12.28-.22.36-.3.12-.12.18-.24.18-.36-.04.12-.2.26-.48.42-.24.12-.36.3-.36.54zm-1.44 1.44c0-.04.04-.1.12-.18l.12-.18c0-.04-.04-.1-.12-.18-.16.32-.2.5-.12.54zm-1.02.78c.04-.08.16-.18.36-.3.2-.12.32-.24.36-.36-.44.16-.68.38-.72.66zm-.3.12c.08.04.14.04.18 0 .04-.08.02-.14-.06-.18-.04-.04-.08-.04-.12 0v.18zm-1.38 1.08c.8-.44 1.18-.78 1.14-1.02-.12.12-.32.3-.6.54-.24.2-.42.36-.54.48zm0 .24c-.4.04-.98.42-1.74 1.14-.72.72-1.28 1.12-1.68 1.2-.04.32-.32.66-.84 1.02-.52.32-.76.64-.72.96.2-.08.46-.32.78-.72.36-.44.66-.66.9-.66.08-.44.24-.56.48-.36.24-.32.5-.62.78-.9.32-.28.68-.58 1.08-.9.44-.36.76-.62.96-.78zm-8.22 6.6c.08.16.02.32-.18.48-.2.2-.3.36-.3.48-.04.04-.1.02-.18-.06h-.18c-.12.08-.34.28-.66.6-.32.32-.58.56-.78.72.24.04.68-.26 1.32-.9v.12c.04.08.1.1.18.06.24-.08.48-.36.72-.84.28-.44.5-.64.66-.6.28-.28.36-.52.24-.72-.52.4-.8.62-.84.66zM27.49 67.7c0 .12-.04.24-.12.36-.08.12-.12.24-.12.36-.16.16-.24.3-.24.42l.12-.12c.08-.12.12-.22.12-.3.48-.4.76-.8.84-1.2-.12 0-.22.08-.3.24-.12.16-.22.24-.3.24.28-.48.62-.96 1.02-1.44 0 .12-.06.24-.18.36-.12.16-.18.28-.18.36.56-.56 1.32-1.48 2.28-2.76.92-1.28 1.68-2.2 2.28-2.76a.3.3 0 0 1 0-.36c.08-.08.1-.16.06-.24-.52.6-.84.96-.96 1.08.8-1.2 1.6-2.2 2.4-3 0 .04-.04.1-.12.18-.04.08-.04.16 0 .24.12-.04.24-.14.36-.3.12-.12.16-.24.12-.36-.08.16-.2.24-.36.24.88-1.16 1.62-1.98 2.22-2.46-.04.08-.12.18-.24.3s-.18.24-.18.36c.12-.04.26-.16.42-.36.2-.2.38-.28.54-.24-.16-.08-.16-.22 0-.42.16-.16.3-.32.42-.48.16-.12.16-.22 0-.3.08-.04.18-.16.3-.36.16-.16.3-.26.42-.3l-.18.36c.68-.4 1.14-.88 1.38-1.44-.16.04-.34.2-.54.48-.16.28-.32.4-.48.36.08-.24.38-.58.9-1.02.52-.44.68-.84.48-1.2-.04.12-.2.3-.48.54-.28.24-.42.44-.42.6-1.08.68-1.74 1.4-1.98 2.16-5.96 6.04-11.22 13.54-15.78 22.5-.16.52-.36 1.1-.6 1.74-.28.68-.48 1.22-.6 1.62l1.44-2.88c.6-1.24 1.18-2.38 1.74-3.42.52-1.04 1.04-1.98 1.56-2.82v.3c.24-.24.46-.5.66-.78s.36-.54.48-.78c.12-.2.28-.48.48-.84.2-.36.36-.64.48-.84-.2.08-.4.34-.6.78-.24.44-.48.72-.72.84.8-1.4 1.52-2.48 2.16-3.24zm11.1-15.12l-.12-.3c0 .2.04.3.12.3zm-1.38 1.74c.32-.12.54-.34.66-.66l-.66.66zm-6.9 10.8c0 .08-.02.16-.06.24-.04.12-.06.24-.06.36-.68.76-1.36 1.62-2.04 2.58-.68.96-1.4 2.06-2.16 3.3-.76 1.24-1.34 2.16-1.74 2.76-.28.68-.8 1.82-1.56 3.42-.76 1.64-1.32 2.9-1.68 3.78-.36.88-.74 2.08-1.14 3.6-.4 1.52-.64 3.04-.72 4.56-.12.04-.18.22-.18.54-.04.36-.1.6-.18.72-.04-.04-.04-.12 0-.24v-.3c-.04-.08-.1-.12-.18-.12-.08.48.06 1.32.42 2.52.6.92 1.56 1.5 2.88 1.74 1.28.24 2.5.06 3.66-.54 1.76-1 3.32-2.46 4.68-4.38 1.36-1.92 2.3-3.54 2.82-4.86.56-1.28 1.36-3.42 2.4-6.42.2-.52.34-.9.42-1.14.08-.32.26-1.16.54-2.52.32-1.32.52-2.22.6-2.7.12-.48.32-1.36.6-2.64.28-1.28.48-2.26.6-2.94.12-.68.28-1.62.48-2.82.2-1.16.34-2.2.42-3.12.12-.88.22-1.88.3-3 .12-1.08.2-2.14.24-3.18 0-.04-.02-.06-.06-.06-1.72 1.88-4.82 5.5-9.3 10.86zm5.64-10.02c.24 0 .44-.12.6-.36.04-.12 0-.22-.12-.3-.04.08-.14.18-.3.3-.12.12-.18.24-.18.36zm.66.06c-.04-.04-.02-.1.06-.18.08-.08.08-.14 0-.18 0 .04-.02.08-.06.12-.12.12-.12.2 0 .24zm1.14.24c0-.04.02-.08.06-.12.08-.08.08-.14 0-.18 0 .04-.02.08-.06.12-.08.08-.08.14 0 .18zm-2.58.6c.08 0 .16-.08.24-.24.08-.12.2-.14.36-.06.08-.28.08-.42 0-.42 0 .08-.1.18-.3.3-.2.12-.3.26-.3.42zm-.3.24c.24 0 .36-.02.36-.06-.16-.16-.28-.14-.36.06zm.54 0c.16 0 .24-.04.24-.12-.08 0-.16.04-.24.12zm-.18.18v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-.9.36c.32 0 .48-.1.48-.3-.24.04-.4.14-.48.3zm-.24.42h-.12c-.04.04-.06.1-.06.18.04.12.1.18.18.18v-.36c.24 0 .36-.04.36-.12-.24-.24-.36-.2-.36.12zm1.86.3v.06c.08.04.14.02.18-.06l-.12-.06v-.24c-.28.2-.42.36-.42.48.12.04.2.02.24-.06.04-.08.08-.12.12-.12zm-2.34.36l.06.06h.12c0-.28-.02-.42-.06-.42-.08.08-.12.2-.12.36zm.54 0c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18 0 .04-.04.06-.12.06-.04.04-.04.1 0 .18zm.54.78c.04-.04.14-.1.3-.18.16-.08.28-.16.36-.24.08-.04.1-.1.06-.18 0 .08-.04.12-.12.12 0-.16-.04-.24-.12-.24-.08.08-.16.2-.24.36-.08.16-.16.28-.24.36zm-1.8-.06c-.6.4-.88.8-.84 1.2.16-.08.32-.26.48-.54.2-.28.36-.46.48-.54l-.12-.12h.36c.12-.2.18-.4.18-.6-.2.04-.28.18-.24.42h-.3v.18zm.48.18c.4-.24.54-.44.42-.6 0 .04-.08.12-.24.24-.16.12-.22.24-.18.36zm-.6.9c0-.04.02-.1.06-.18 0-.12-.02-.18-.06-.18 0 .04-.02.1-.06.18-.04.12-.02.18.06.18zm-.78.9c.04-.04.12-.14.24-.3.16-.12.26-.22.3-.3.04-.08.02-.18-.06-.3 0 .12-.1.26-.3.42-.2.2-.26.36-.18.48zm1.02.12c.36-.28.56-.5.6-.66-.12 0-.22.02-.3.06-.08.08-.14.18-.18.3-.04.16-.08.26-.12.3zM30.13 62c.28-.04.6-.32.96-.84.32-.52.54-.84.66-.96-.16.04-.32.14-.48.3-.16.16-.28.3-.36.42-.12.12-.26.32-.42.6-.2.28-.32.44-.36.48zm1.08-.6c.08 0 .16-.06.24-.18.08-.12.08-.22 0-.3 0 .04-.04.1-.12.18-.08.12-.12.22-.12.3zm-1.62 1.26c.16.12.32.08.48-.12.12-.2.06-.32-.18-.36 0 .04-.04.12-.12.24-.08.12-.14.2-.18.24zm.96-.36h-.06c-.08.08-.12.16-.12.24.12-.04.18-.12.18-.24zm-1.32.78c.28 0 .42-.08.42-.24-.16-.16-.3-.08-.42.24zm0 .18c-.04 0-.06-.02-.06-.06h-.06c-.08.04-.08.08 0 .12.08.04.12.02.12-.06zm-4.26 6.06h-.06a240.27 240.27 0 0 1-1.8 3c-.44.52-.66 1.04-.66 1.56.2-.32.42-.84.66-1.56.32-.2.64-.64.96-1.32.32-.64.62-1.06.9-1.26v-.42c.24-.12.46-.38.66-.78.16-.4.36-.66.6-.78 0-.16-.02-.28-.06-.36.44-.36 1.42-1.64 2.94-3.84-1.56 1.56-2.94 3.48-4.14 5.76zm13.5-1.08h.3c-.04-.16-.02-.46.06-.9.12-.4.12-.68 0-.84-.04.16-.1.44-.18.84-.04.4-.1.7-.18.9zm.84-.84c0-.04.02-.08.06-.12.08-.2.06-.32-.06-.36.04.08.04.18 0 .3s-.04.18 0 .18zm-.84 1.38c.08 0 .14-.04.18-.12.04-.08.04-.16 0-.24 0-.08-.04-.12-.12-.12-.04.08-.06.16-.06.24v.24zm.54-.12c.12.08.18.02.18-.18 0-.08-.02-.12-.06-.12 0 .04-.02.08-.06.12a.46.46 0 0 0-.06.18zm-12.36.36v.12c.08.12.16.08.24-.12v-.06h.06c-.04-.04-.08-.04-.12 0a.46.46 0 0 1-.18.06zm10.86 4.5h-.06c-.04.32-.18.56-.42.72 0 .16.06.2.18.12-.84 3.36-1.44 5.48-1.8 6.36h-.24c0 .08-.06.12-.18.12-.12-.04-.16 0-.12.12.04.08.12.1.24.06.12 0 .2.02.24.06-.04.08-.14.32-.3.72-.12.4-.24.68-.36.84-.04-.08-.1-.08-.18 0-.04.12-.12.14-.24.06 0 .04-.02.1-.06.18-.04.08-.08.14-.12.18 0 .08.02.14.06.18.04-.16.14-.28.3-.36.12-.04.2-.1.24-.18.08.24.06.4-.06.48a.46.46 0 0 1-.18-.06c.12.2.1.44-.06.72-.16.28-.24.52-.24.72-.16 0-.24.04-.24.12-.04.04-.08.18-.12.42-.04.28-.12.46-.24.54a.68.68 0 0 1-.24-.24c-.04-.08-.1-.12-.18-.12.04.08.02.18-.06.3-.08.16-.08.26 0 .3.04-.16.1-.22.18-.18.12.04.22.04.3 0-.16.12-.28.38-.36.78-.04.44-.22.74-.54.9 0 .12.06.14.18.06-.4.28-.8.82-1.2 1.62-.4.84-.72 1.4-.96 1.68.04 0 .1-.02.18-.06.04-.04.08-.02.12.06-.12.2-.26.26-.42.18-.12.24-.34.54-.66.9-.36.36-.6.66-.72.9-.32.12-.54.38-.66.78.2.04.36-.02.48-.18s.22-.24.3-.24c.04-.08.04-.16 0-.24-.08-.04-.12-.08-.12-.12.08-.04.18-.02.3.06-.04-.12 0-.28.12-.48.12-.16.22-.22.3-.18 0 .04-.02.06-.06.06-.08.08-.1.16-.06.24.28-.12.44-.32.48-.6-.04 0-.1.02-.18.06-.08.08-.12.06-.12-.06.6-.08.98-.5 1.14-1.26h.18c.04-.08.12-.22.24-.42.12-.16.18-.3.18-.42.04-.08.02-.2-.06-.36.08 0 .14-.08.18-.24.04-.16.1-.24.18-.24.04.04.04.12 0 .24-.04.08-.04.14 0 .18.8-1.36 2.1-4.36 3.9-9 0 .04.04.1.12.18.08-.08.12-.16.12-.24 0-.08.04-.16.12-.24-.08 0-.16.04-.24.12l-.12.18c.12-.52.38-1.58.78-3.18.44-1.56.72-2.76.84-3.6.32-.96.66-2.48 1.02-4.56-.16.08-.26.34-.3.78 0 .48-.12.74-.36.78.16.28.14.78-.06 1.5-.2.76-.3 1.26-.3 1.5zm1.44-4.2c.08 0 .14-.04.18-.12 0-.12-.06-.2-.18-.24v.36zm-.36 1.56c.08 0 .14-.04.18-.12.08-.12.04-.18-.12-.18 0 .04-.02.08-.06.12v.18zm-1.14.96c.16 0 .24-.1.24-.3-.08-.04-.14-.04-.18 0-.04.08-.06.18-.06.3zm.72.9c.12.04.2 0 .24-.12 0-.08.02-.14.06-.18-.04 0-.08-.02-.12-.06h-.12c.04.16.02.28-.06.36zm-.84.18h.12v-.18h-.12v.18zm-13.14.18h.24c0-.12-.08-.16-.24-.12v.12zm-.18.72c0-.04.04-.12.12-.24a.94.94 0 0 0 .18-.24c0-.04-.06-.1-.18-.18 0 .04-.04.14-.12.3-.08.2-.08.32 0 .36zm12.96-.3c.08.04.12 0 .12-.12l-.06-.12c0 .04-.02.08-.06.12v.12zm-14.94.72c.2.04.3-.04.3-.24-.08-.04-.14-.02-.18.06-.04.12-.08.18-.12.18zm1.62.18c0-.04.02-.1.06-.18.08-.16.06-.24-.06-.24 0 .04-.02.12-.06.24-.08.12-.06.18.06.18zm-.6.78l.12.06c0-.16-.04-.22-.12-.18v.12zm13.38.24v.12c.08.04.12 0 .12-.12.04-.08.02-.12-.06-.12 0 .08-.02.12-.06.12zm-15.18.72c0-.04.04-.1.12-.18.08-.16.08-.26 0-.3l-.12.24c-.12.12-.12.2 0 .24zm15.06 0c.12 0 .18-.1.18-.3-.08-.04-.14-.04-.18 0v.3zm-.3 1.14v.06-.06zm.84.12h-.06c.04.04.02.06-.06.06v.18c.08 0 .12-.08.12-.24zm-.9.3h.12v-.12h-.12v.12zm.72.66c0-.04.02-.1.06-.18.04-.08 0-.12-.12-.12 0 .16.02.26.06.3zm-.96.18c.16 0 .24-.08.24-.24-.04-.12-.1-.18-.18-.18-.04.08-.06.22-.06.42zm.18 2.4c0-.04.02-.06.06-.06 0-.12-.06-.18-.18-.18 0 .04.02.08.06.12 0 .08.02.12.06.12zm-.3.6c.08 0 .14-.04.18-.12.04-.04.04-.12 0-.24 0-.08-.02-.12-.06-.12-.08.24-.12.4-.12.48zm-16.02.96c0-.08.04-.2.12-.36.04-.12.08-.22.12-.3 0-.04-.04-.1-.12-.18-.12.48-.16.76-.12.84zm16.08-.48h.12v-.12h-.12v.12zm-.36.48c-.28.28-.32.48-.12.6.08-.32.12-.52.12-.6h.06l.06-.3-.06-.06c.04.08.04.14 0 .18-.04.04-.06.1-.06.18zm-16.08.84c.16-.12.24-.32.24-.6-.08 0-.16.2-.24.6zm14.58.54c.04 0 .08-.04.12-.12.08-.04.1-.12.06-.24 0-.08-.02-.12-.06-.12 0 .08-.04.24-.12.48zm.42-.12v-.3c0 .04-.04.1-.12.18-.04.08 0 .12.12.12zm-.78 1.26c.04-.08.08-.2.12-.36l.18-.36c-.16.04-.3.14-.42.3-.08.2-.04.34.12.42zm-.72 1.56h-.06c-.04 0-.08.04-.12.12 0 .08.04.12.12.12.04-.04.06-.12.06-.24l.3-.48c0-.04-.04-.08-.12-.12.04.12.02.22-.06.3-.08.08-.12.18-.12.3zm-.42.72c.04-.08.08-.18.12-.3-.08.16-.12.26-.12.3zm-.48.9c.16-.16.2-.28.12-.36 0 .04-.04.1-.12.18-.08.08-.08.14 0 .18zm-.18.42c.08 0 .12-.06.12-.18 0 .04-.02.06-.06.06l-.06.12zm-.42.72c.08.04.16-.02.24-.18.08-.12.04-.18-.12-.18 0 .08-.02.14-.06.18a.46.46 0 0 0-.06.18zm-.24.3h.12v-.12h-.12v.12zm-.12.6c0-.08.02-.14.06-.18.04-.08.06-.16.06-.24-.16-.04-.26.04-.3.24 0 .08.06.14.18.18zm-.66.9c0-.04.02-.08.06-.12.04-.04.08-.1.12-.18l.12-.12c-.04 0-.08-.02-.12-.06-.08-.04-.14-.04-.18 0 0 .08-.04.18-.12.3-.08.12-.04.18.12.18zm-.78.9c.04-.08.1-.16.18-.24l.18-.18c.04-.04.08-.1.12-.18.04-.04.04-.1 0-.18-.04.04-.08.1-.12.18l-.18.18c-.08.04-.14.1-.18.18-.04.08-.04.16 0 .24zm-2.46 2.22h-.18v.12c.12.04.18 0 .18-.12.56-.28.92-.64 1.08-1.08l-1.08 1.08zm-2.4.48c-.28.12-.56.2-.84.24-.32.08-.62.1-.9.06-.32-.04-.58-.08-.78-.12-.2 0-.48-.06-.84-.18-.36-.08-.62-.14-.78-.18.32.44.96.68 1.92.72.92.04 1.66-.14 2.22-.54zm28.98-53.88c-.04.08-.14.16-.3.24-.12.04-.2.1-.24.18a.533.533 0 0 1-.06-.24c.04-.08.12-.14.24-.18.12-.04.24-.04.36 0zm-1.38 1.08c.32-.44.56-.64.72-.6-.16.28-.4.48-.72.6zm0 0c-.04.16-.18.28-.42.36.16-.24.3-.36.42-.36zm-6.12 5.4h.12v.12c-.04 0-.06.02-.06.06h-.12v-.12l.06-.06zm-7.92 7.32c0-.16.04-.24.12-.24 0 .08-.04.16-.12.24zm-1.02 1.02c0 .12-.08.22-.24.3-.12.12-.18.24-.18.36-.08-.12-.06-.26.06-.42.12-.12.24-.2.36-.24zm-1.14 1.8c.04 0 .06-.02.06-.06-.04-.04-.06-.02-.06.06zm-4.14 4.44c.04.12-.02.22-.18.3 0-.08.06-.18.18-.3zm-.24.36c0-.04.02-.06.06-.06 0 .04-.02.06-.06.06zm-.24.18c.04.32-.18.62-.66.9.08-.12.2-.28.36-.48a3 3 0 0 0 .3-.42zm-2.82 3.78c.88-1.32 1.56-2.2 2.04-2.64-.8 1.28-1.48 2.16-2.04 2.64zM25.27 71c.08.08.14.12.18.12 0 .04-.04.1-.12.18-.08.12-.12.2-.12.24-.12-.04-.14-.14-.06-.3l.12-.24zm-.36.54c.12.04.14.12.06.24-.12.16-.18.26-.18.3-.08-.08-.12-.14-.12-.18l.12-.18c.08-.08.12-.14.12-.18zm6.18 19.02c-.08 0-.1-.06-.06-.18.12 0 .14.06.06.18zM55.167 50.3v.12c.04.08.06.14.06.18.04 0 .1-.04.18-.12.08.04.16.1.24.18.08.12.14.2.18.24a8.04 8.04 0 0 0 2.16-.84c.72-.36 1.26-.66 1.62-.9.36-.24.94-.68 1.74-1.32.84-.68 1.34-1.08 1.5-1.2 3.52-3.04 6.46-5.66 8.82-7.86h.3c.04 0 .08-.06.12-.18 0-.08.04-.12.12-.12-.12.28-.46.72-1.02 1.32-.56.6-.88 1.08-.96 1.44-.56-.04-1.22.52-1.98 1.68-.08.04-.16 0-.24-.12v.36c-.32-.12-.52-.02-.6.3-.56.2-.8.44-.72.72-.4.12-.68.32-.84.6.04 0 .1-.04.18-.12.08-.08.14-.06.18.06-.12.12-.28.18-.48.18 0 .08-.02.14-.06.18h-.12c-.04 0-.08.02-.12.06l.06.18c-.12.04-.22.02-.3-.06 0 .12-.16.32-.48.6-.28.28-.42.5-.42.66l-.12-.12c.04.04.06.02.06-.06l-.06.06-.48.48c-.24.2-.42.36-.54.48.04.12.12.12.24 0 .16-.16.3-.18.42-.06.04-.24.22-.48.54-.72.36-.28.66-.38.9-.3-.12.16-.32.36-.6.6-.24.2-.42.38-.54.54.24-.16.58-.42 1.02-.78.44-.4.8-.66 1.08-.78-.36.44-.96 1-1.8 1.68-.84.64-1.44 1.18-1.8 1.62.08.08.18.08.3 0 .16-.08.26-.18.3-.3.12.08.12.22 0 .42-.08.08-.16.08-.24 0-.08.24-.04.36.12.36-1.92 1.84-3.8 2.84-5.64 3-1.6-.28-2.88-1.04-3.84-2.28-.96-1.24-1.48-2.8-1.56-4.68.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12.52-2.12.58-3.76.18-4.92.44-.44.78-1.28 1.02-2.52.2-1.24.32-1.92.36-2.04.08 0 .1.08.06.24-.04.16-.06.28-.06.36.12-.12.18-.3.18-.54.04-.28-.02-.46-.18-.54 1.6-8 3.98-16 7.14-24 .24-.44.76-1.4 1.56-2.88.84-1.52 1.46-2.62 1.86-3.3.44-.72 1.06-1.6 1.86-2.64.84-1.04 1.68-1.88 2.52-2.52 1.24.08 2.1.64 2.58 1.68.52 1 .72 2.08.6 3.24-.12 1.12-.38 2.22-.78 3.3 0 1.52-.44 3.12-1.32 4.8a98.5 98.5 0 0 1-1.8 5.04c-.68 1.72-1.28 3.16-1.8 4.32-.48 1.12-1.18 2.68-2.1 4.68-.88 2-1.54 3.52-1.98 4.56-.16.16-.3.28-.42.36 0 .04.02.12.06.24.04.08.04.16 0 .24-.4.6-.96 1.6-1.68 3-.68 1.4-1.36 2.6-2.04 3.6-.68.96-1.48 1.74-2.4 2.34-.2.24-.36.74-.48 1.5-.12.72-.24 1.18-.36 1.38.08.64.08 1.28 0 1.92-.08.6-.08 1.3 0 2.1.12.76.36 1.38.72 1.86zm12.54-47.34c-.04 0-.08-.04-.12-.12 0-.12-.04-.16-.12-.12-.04.08-.02.14.06.18.08.04.12.08.12.12-.12.08-.28.26-.48.54-.16.24-.32.4-.48.48.04-.12.02-.2-.06-.24-.12.12-.3.38-.54.78 0 .08.04.06.12-.06.12-.12.2-.12.24 0-.04.08-.16.26-.36.54-.16.24-.3.44-.42.6-.08.12-.2.26-.36.42-.16.16-.3.24-.42.24.08.28.08.5 0 .66-.04.12-.16.3-.36.54-.2.24-.32.42-.36.54 0 .08.04.14.12.18.12.04.16.12.12.24-.2 0-.32.02-.36.06-.04.04 0 .12.12.24-.04 0-.08.02-.12.06-.04.04-.1.04-.18 0 .12.16.06.46-.18.9-.2.4-.2.68 0 .84-.04 0-.12.06-.24.18-.08.08-.18.12-.3.12-.04.08-.02.14.06.18.08 0 .12.02.12.06-.16.36-.44.94-.84 1.74-.36.76-.66 1.46-.9 2.1-.24.6-.42 1.2-.54 1.8-.2.32-.46.96-.78 1.92s-.7 1.64-1.14 2.04c-.04.08 0 .14.12.18.16.04.24.08.24.12-.04.08-.12.38-.24.9-.12.48-.28.82-.48 1.02 0 .36-.12.9-.36 1.62-.2.68-.32 1.16-.36 1.44-.04.04-.12.06-.24.06-.08 0-.12.02-.12.06.12 0 .18.08.18.24.04.16 0 .3-.12.42-.08.12-.18.18-.3.18.08 1.52-.22 2.68-.9 3.48.12.12.16.3.12.54 0 .24.02.44.06.6-.12 0-.22.06-.3.18-.04.08-.08.22-.12.42 0 .16-.02.28-.06.36.16 0 .26-.08.3-.24-.64 2.6-.96 4.12-.96 4.56 1.28-2.08 2.48-4.24 3.6-6.48 1.12-2.28 2.46-5.18 4.02-8.7 1.6-3.56 2.6-5.8 3-6.72.2-.76.54-1.86 1.02-3.3.52-1.44.92-2.72 1.2-3.84.32-1.12.54-2.22.66-3.3.16-.24.24-.64.24-1.2V1.88c-.16 0-.3-.02-.42-.06-.08-.04-.2.02-.36.18l-.36.36-.3.3c-.12.16-.18.26-.18.3zm2.52.84h.12c0-.04.02-.08.06-.12.04-.04.04-.08 0-.12h-.18v.24zm.06.3c-.12.32-.14.66-.06 1.02-.04.08-.1.1-.18.06-.04-.04-.08-.06-.12-.06.04.04.08.18.12.42.04.2.1.32.18.36 0-.24.04-.58.12-1.02.08-.44.06-.7-.06-.78zm-4.68 1.2c.04 0 .18-.18.42-.54-.2 0-.34.18-.42.54zm-6.06 10.02c1.24-2.64 2.98-6.08 5.22-10.32-1.96 2.88-3.7 6.32-5.22 10.32zm10.44-8.7v-.18l.12-.24a.46.46 0 0 0 .06-.18c-.16 0-.26-.02-.3-.06-.08.08-.12.2-.12.36.04.16.12.26.24.3zm-.72 1.44h.24c0 .08-.04.14-.12.18-.08.04-.12.1-.12.18.16.04.26.02.3-.06.08-.12.12-.28.12-.48.04-.2.08-.34.12-.42-.04 0-.08-.04-.12-.12-.04-.12-.1-.18-.18-.18-.12.12-.18.28-.18.48.04.16.02.3-.06.42zm.66 0c0-.04.04-.12.12-.24.12-.2.1-.32-.06-.36 0 .08-.04.2-.12.36-.04.16-.02.24.06.24zm-6.6.54c-.04.12 0 .18.12.18.2-.04.32-.12.36-.24-.2.04-.36.06-.48.06zm5.94.48l.18-.36a.46.46 0 0 1-.18-.06c-.04-.08-.1-.1-.18-.06-.04.24.02.4.18.48zm-.18.54c-.16-.04-.26.02-.3.18-.04.04-.02.08.06.12.08-.04.16-.02.24.06.04-.04.06-.1.06-.18.04-.12.06-.24.06-.36.04-.12.06-.2.06-.24-.16 0-.26-.02-.3-.06-.04.04 0 .2.12.48zm.36.24h.12v-.18h-.12v.18zm-6.42.12h-.3c.04 0 .1.04.18.12.08.04.12 0 .12-.12zm5.58.3c.2 0 .3-.04.3-.12-.16-.04-.26 0-.3.12zm-6.12.48c.08.04.14.02.18-.06.08-.12.08-.18 0-.18 0 .04-.04.08-.12.12-.04 0-.06.04-.06.12zm6.36-.06c.04-.12.02-.18-.06-.18a.255.255 0 0 0-.24 0c0 .12.1.18.3.18zm.06.36c.4-.08.5-.26.3-.54-.12 0-.22.18-.3.54zm-.84.66c.28.16.44.16.48 0l-.06-.06c-.12 0-.16-.06-.12-.18l.48-.48c-.24-.08-.4-.16-.48-.24 0 .16-.02.28-.06.36-.04.08-.08.18-.12.3-.04.08-.08.18-.12.3zm.66.06h.12v-.12h-.12v.12zm-3.18 6.54h-.06c0 .12-.08.18-.24.18.08.2.06.38-.06.54-.08.12-.1.24-.06.36l-.36.18c-.04.08-.04.16 0 .24.04.08.06.14.06.18 0 .04-.06.06-.18.06-.08 0-.12.02-.12.06.08.2.06.42-.06.66-.08.2-.2.34-.36.42-.04.16-.06.28-.06.36.04.04.08.1.12.18.08.04.12.08.12.12-.24-.04-.4.02-.48.18-.08.16-.1.36-.06.6-.16 0-.28.08-.36.24.08.08.12.16.12.24-.08.16-.24.4-.48.72-.2.32-.36.58-.48.78-.08.16-.18.42-.3.78-.08.32-.02.58.18.78-.04 0-.08.02-.12.06-.04.04-.1.04-.18 0V26c-.4.44-.86 1.24-1.38 2.4-.48 1.16-.9 1.96-1.26 2.4 0 .12-.02.26-.06.42-.08.2-.04.32.12.36.08-.04.08-.08 0-.12a.533.533 0 0 1-.06-.24c.04-.04.14-.1.3-.18.16-.08.26-.16.3-.24 0-.2.04-.42.12-.66.12-.24.26-.5.42-.78l.36-.72c.08 0 .14.06.18.18 0 .08.04.12.12.12 0-.12.08-.26.24-.42 0 .08.02.12.06.12.04-.04.08-.12.12-.24-.04 0-.08.02-.12.06l-.06.06c0-.36.08-.54.24-.54.04-.08.02-.14-.06-.18-.08-.08-.1-.14-.06-.18.08 0 .14.04.18.12.08.08.16.1.24.06.12-.08.12-.14 0-.18-.08-.04-.12-.1-.12-.18.04-.08.08-.08.12 0 .08.04.16.06.24.06-.12-.24-.12-.56 0-.96.08.08.12.14.12.18 0 .04-.02.1-.06.18-.04.04-.06.1-.06.18.32-.44.72-1.24 1.2-2.4.48-1.2.9-2 1.26-2.4-.16-.2-.1-.34.18-.42.04-.08.04-.16 0-.24a.46.46 0 0 1-.06-.18c.24-.08.32-.24.24-.48.04 0 .1-.04.18-.12.08-.12.16-.18.24-.18 0-.08-.04-.14-.12-.18-.08-.08-.12-.14-.12-.18 0-.04.04-.06.12-.06.12 0 .18-.04.18-.12-.04-.08-.1-.1-.18-.06-.04 0-.08-.02-.12-.06 0-.16.08-.2.24-.12.04.04.08.06.12.06.04-.12.1-.32.18-.6.08-.32.16-.56.24-.72-.04 0-.1.04-.18.12-.04.08-.1.1-.18.06 0-.04.02-.1.06-.18.04-.08.02-.14-.06-.18 0 .16-.06.16-.18 0v-.12c.08.04.12.02.12-.06 0-.12.06-.16.18-.12-.04.08-.04.14 0 .18.04.04.08.04.12 0 .04 0 .06-.06.06-.18 0-.16.06-.24.18-.24 0 .04-.02.1-.06.18-.08.24-.06.38.06.42 0-.12.04-.26.12-.42.12-.16.16-.32.12-.48-.12.08-.24.04-.36-.12l.18-.12c-.12-.12-.14-.2-.06-.24.08 0 .14.06.18.18.08.12.18.18.3.18-.04-.2.02-.4.18-.6.16-.24.24-.42.24-.54 0-.04-.04-.06-.12-.06-.08 0-.14-.04-.18-.12.12-.2.2-.32.24-.36.04.08.04.16 0 .24-.04.04-.06.08-.06.12.2.04.36 0 .48-.12-.04-.08-.08-.18-.12-.3v-.36a.46.46 0 0 1 .18-.06c.12.04.18-.04.18-.24-.12 0-.24-.02-.36-.06a.982.982 0 0 0-.24-.06c0-.12.08-.2.24-.24.2-.04.32-.08.36-.12-.08.08-.12.18-.12.3.04.08.1.12.18.12v-.42c.04-.24.08-.4.12-.48-.04-.04-.08-.04-.12 0l-.06.06c-.04-.12-.02-.18.06-.18.08-.04.12-.08.12-.12-.16-.04-.16-.14 0-.3.16-.2.26-.22.3-.06 0-.04.04-.18.12-.42.12-.24.1-.38-.06-.42-.04 0-.06.06-.06.18 0 .2-.06.28-.18.24.04-.04.06-.1.06-.18v-.3c0-.08.02-.14.06-.18.04-.08.12-.12.24-.12 0-.08-.06-.14-.18-.18-.08-.08-.1-.18-.06-.3-.6.88-.7 1.36-.3 1.44-.08.2-.14.3-.18.3l-.06-.06h-.18c-.04.24-.14.56-.3.96-.16.4-.26.72-.3.96-.04.04-.12.08-.24.12-.08.04-.14.08-.18.12-.04.08-.04.16 0 .24.04.08.06.14.06.18-.08-.04-.14-.02-.18.06 0 .08-.02.12-.06.12.08.12.06.26-.06.42-.08.16-.12.3-.12.42h-.3c.04.16 0 .3-.12.42-.08.12-.12.22-.12.3.04.08.06.24.06.48zm2.46-4.44h.12v-.12h-.12v.12zm-9.54 4.32c.32-.52.68-1.38 1.08-2.58 0-.12-.04-.14-.12-.06-.04.04-.2.42-.48 1.14-.24.68-.4 1.18-.48 1.5zm9.06-2.46c.04-.04.08-.06.12-.06-.08-.08-.14-.12-.18-.12 0 .12.02.18.06.18zm-9.36 3.18c.16 0 .26-.08.3-.24.08-.16.08-.28 0-.36-.12.04-.22.24-.3.6zm-.06.3h.18v-.18h-.18v.18zm-.42 1.14c.12-.04.22-.14.3-.3.08-.2.08-.36 0-.48-.16.32-.26.58-.3.78zm.72 0c.08.08.12.04.12-.12l-.12-.12v.24zm-.12.48h.12v-.24h-.12v.24zm-.84.12c.12.04.2-.02.24-.18.04-.04.02-.08-.06-.12 0 .04-.02.08-.06.12-.08.04-.12.1-.12.18zm.12.6v-.18c0-.08-.02-.12-.06-.12 0-.04-.04-.06-.12-.06-.08.08-.1.18-.06.3.04.08.12.1.24.06zm.54 0c0-.04.02-.06.06-.06 0-.12-.04-.16-.12-.12 0 .12.02.18.06.18zm-1.38 1.68c.16-.16.3-.42.42-.78.16-.4.2-.66.12-.78l-.24.72c-.12.36-.22.64-.3.84zm1.74-.12h.18v-.18h-.18v.18zm-1.8.36h.06c.04.04.08.06.12.06-.08-.16-.14-.24-.18-.24v.18zm-.3 1.14c0-.08.04-.2.12-.36.12-.16.18-.28.18-.36.04-.08.02-.16-.06-.24 0 .08-.06.24-.18.48-.08.2-.1.36-.06.48zm-.24.66c.16 0 .24-.12.24-.36-.12.04-.2.16-.24.36zm-.3 1.5c0-.12.04-.24.12-.36.08-.12.14-.24.18-.36-.04 0-.08-.02-.12-.06-.04-.04-.08-.04-.12 0 0 .08-.02.18-.06.3-.04.12-.08.22-.12.3 0 .04.04.1.12.18zm.9.54c.08.04.14.04.18 0 .04-.08.02-.14-.06-.18-.04-.04-.08-.04-.12 0v.18zm-1.2.36h.12v-.24h-.12v.24zm1.14.18h.18v-.18h-.18v.18zm4.26 1.38h.12v-.18h-.12v.18zm.3.12c.08.04.14-.02.18-.18.04-.04.02-.08-.06-.12 0 .04-.04.08-.12.12-.04.04-.04.1 0 .18zm-.6.72c0-.08.04-.18.12-.3.08-.16.14-.3.18-.42-.12.04-.22.16-.3.36-.08.16-.08.28 0 .36zm.3 0c.08-.04.14-.12.18-.24.04-.12.08-.2.12-.24-.2 0-.3.16-.3.48zm-6.6 2.82c.12-.12.14-.24.06-.36-.04-.04-.1-.06-.18-.06v.24c-.04.08 0 .14.12.18zm-.18.18h.18v-.12h-.18v.12zm15.9 7.5c.16 0 .26-.06.3-.18 0-.04-.04-.08-.12-.12 0 .08-.04.12-.12.12a.46.46 0 0 0-.06.18zm-17.4 3.78c0 .04-.02.08-.06.12v.06c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18zm.06.48l-.06-.06-.06-.06c0 .04.04.08.12.12zm.36 2.46c0-.2-.02-.3-.06-.3-.12.16-.1.26.06.3zm9.36.66c.08 0 .3-.12.66-.36-.04 0-.06-.04-.06-.12l-.06-.06-.54.54zm1.14-.12c.2 0 .3-.08.3-.24-.12 0-.22.08-.3.24zm-1.86.6v.12h.18c.08-.08.04-.14-.12-.18 0 .04-.02.06-.06.06zm.66 1.14c0-.04.02-.06.06-.06.08-.08.1-.16.06-.24-.12-.04-.18.02-.18.18-.04.04-.02.08.06.12zm-.24.42c.08.04.16.02.24-.06.08-.08.08-.14 0-.18 0 .04-.04.08-.12.12-.12 0-.16.04-.12.12zm-2.76.9c.48-.2.72-.34.72-.42-.04.08-.16.14-.36.18-.2.08-.32.16-.36.24zm1.62-.06c.2-.08.32-.16.36-.24-.16-.04-.28.04-.36.24zm8.52-43.38c.16.04.18.14.06.3-.04 0-.06-.1-.06-.3zm-1.8 6.72l-.18.18c.12.04.18-.02.18-.18zm-.66 1.62c0-.24.08-.36.24-.36-.08.24-.16.36-.24.36zm-.3-.18h.18v.12h-.18v-.12zm-.12.36l.06.24c0 .08-.04.1-.12.06.04-.04.06-.14.06-.3zm.06.42h.12v.12h-.12v-.12zm-1.32 2.64c.16.08.24.18.24.3-.16-.08-.24-.18-.24-.3zm.24.36v.24c-.16.08-.28 0-.36-.24.04-.04.08-.04.12 0h.24zm-.48.6c-.04 0-.08.04-.12.12 0 .08-.04.12-.12.12l.06-.12c0-.12.06-.16.18-.12zm-.36.42c.08 0 .14.02.18.06.08.08.14.12.18.12-.04.24-.16.26-.36.06a.255.255 0 0 1 0-.24zm-.24.6c.2 0 .3.06.3.18-.2 0-.3-.06-.3-.18zm.06.54v.24-.24zm-.72.9c.12 0 .18.12.18.36-.12.04-.2.02-.24-.06-.04-.12-.02-.22.06-.3zm0 .48c.16 0 .24.06.24.18h-.24v-.18zm-.3.3c.04-.04.08-.06.12-.06.08 0 .12.02.12.06.04.08 0 .12-.12.12-.08 0-.12-.04-.12-.12zm0 .42h.18v.18h-.18v-.18zm-.48.6c.04-.04.08-.04.12 0 .04.04.08.06.12.06 0 .08-.06.12-.18.12-.08-.04-.1-.1-.06-.18zm-.48 1.62l.12-.12c.08.04.08.12 0 .24-.04.04-.06.08-.06.12-.12 0-.14-.08-.06-.24zm-1.2 2.34c0 .2-.06.3-.18.3-.2-.2-.14-.3.18-.3zm10.44 11.22c.12.08.02.26-.3.54-.12.08-.18.16-.18.24-.08-.12.08-.38.48-.78zm-.9 1.08c-.12.32-.32.54-.6.66.04-.16.24-.38.6-.66zm-1.14.96c.08 0 .12.06.12.18-.04.04-.08.04-.12 0-.04-.04-.08-.06-.12-.06l.12-.12zm-.18.24h.18v.18h-.18v-.18zm-.9 1.02c-.04-.04-.04-.08 0-.12.08.04.14.08.18.12h-.18zm0 0c0 .08-.04.16-.12.24-.08 0-.1-.04-.06-.12.04-.12.1-.16.18-.12zm.9.06c.12.08.08.16-.12.24 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12zm-1.08.3h.24c-.04 0-.08.06-.12.18 0 .08-.04.1-.12.06v-.24zm.78 0h.18v.18c-.04-.04-.06-.02-.06.06h-.18v-.18c.04.04.06.02.06-.06zm-1.5.54c0-.16.08-.24.24-.24 0 .16-.08.24-.24.24zm.72-.24h.36c-.4.4-.7.68-.9.84-.08.04-.14.04-.18 0-.04-.08-.08-.12-.12-.12.24-.12.38-.28.42-.48.04 0 .08.02.12.06.04.04.08.06.12.06.04 0 .02-.04-.06-.12a.46.46 0 0 1-.06-.18c.04 0 .1.02.18.06l.06.06c.04-.04.06-.1.06-.18zm-1.14.06h.06-.06zm.42.18c.04.08.02.14-.06.18-.04.04-.12.04-.24 0 .08-.16.18-.22.3-.18zm.96.36c-.4.56-1.16 1.34-2.28 2.34-1.12.96-1.78 1.54-1.98 1.74 0 .04.02.06.06.06.08-.04.14-.08.18-.12-.04.16-.24.4-.6.72-.36.28-.56.5-.6.66-.04 0-.08-.04-.12-.12 0-.08-.04-.1-.12-.06.12-.24.16-.5.12-.78.04 0 .18.04.42.12.08 0 .08-.02 0-.06-.08-.04-.1-.1-.06-.18 2.24-1.92 3.9-3.36 4.98-4.32zm-4.68 4.44c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18 0 .04-.02.08-.06.12-.04.04-.06.08-.06.12zm3.36-4.26c.08-.04.14-.02.18.06.04.08.1.12.18.12-.04.08-.12.18-.24.3l-.18.18c-.16-.08-.24-.18-.24-.3.04-.04.1-.04.18 0h.18c0-.04-.02-.08-.06-.12a.255.255 0 0 1 0-.24zm-.18.78c-.2-.04-.38-.04-.54 0 0-.08.04-.14.12-.18.28-.08.42-.02.42.18zm-.9-.12h.18v.12h-.18v-.12zm-.12.42c-.12 0-.18-.06-.18-.18.12 0 .2.02.24.06 0 .04-.02.06-.06.06v.06zm.36-.06c.12.04.2.04.24 0 .08-.08.16-.12.24-.12 0 .04-.04.08-.12.12-.04 0-.04.04 0 .12l-.36-.12zm-.72.06c.16.2.26.32.3.36-.12.04-.22-.08-.3-.36zm.36 0c.16 0 .2.06.12.18h-.12v-.18zm-.6.42h.18v.24h-.24v-.12c.04 0 .06-.04.06-.12zm-13.8.12h.12v.12h-.12v-.12zm13.14.18h.18v.18h-.18v-.18zm.24 0h.3c-.08.16-.18.24-.3.24v-.24zm.36 1.32c.08.04.08.1 0 .18-.08.04-.16.04-.24 0 0-.04.04-.06.12-.06.08-.04.12-.08.12-.12zm-.6.42c.16.04.18.12.06.24-.04.04-.1.06-.18.06-.04-.08-.04-.14 0-.18.08-.04.12-.08.12-.12zm-10.2 1.5c.04 0 .14.14.3.42-.2 0-.3-.14-.3-.42zm8.4.18c.12-.04.18.02.18.18h-.24c.04-.04.06-.1.06-.18zm-7.8 1.08c-.04 0-.08-.02-.12-.06l-.12-.12c0-.12-.04-.26-.12-.42.08-.08.14-.06.18.06.08.12.14.3.18.54zM76.046 28.1c.36.64.42 1.3.18 1.98-.2.64-.62 1.06-1.26 1.26-1.08-.4-1.68-.92-1.8-1.56.16-.12.4-.36.72-.72.36-.36.7-.62 1.02-.78.32-.16.7-.22 1.14-.18zm1.5 18.18v.12c-.48.24-.82.44-1.02.6.44.08.78-.12 1.02-.6.36-.04 1.24-.52 2.64-1.44.28-.08.66-.3 1.14-.66.52-.36.96-.6 1.32-.72.44-.36 1.62-1.12 3.54-2.28 0 .04-.04.12-.12.24-.08.12-.1.24-.06.36-.8.12-1.42.52-1.86 1.2-.68.32-1.4.72-2.16 1.2-.76.48-1.6 1.02-2.52 1.62-.92.6-1.64 1.06-2.16 1.38-.12 0-.18.04-.18.12.12 0 .18-.04.18-.12 1.72-.96 2.62-1.48 2.7-1.56.48-.24 1.24-.7 2.28-1.38 1.04-.72 1.66-1.14 1.86-1.26.16.04.28 0 .36-.12.12-.12.24-.18.36-.18.04.08.02.16-.06.24-.08.04-.1.1-.06.18-.4 0-.6.1-.6.3l-.06.06c-.04.04-.1.08-.18.12-.04.04-.08.06-.12.06 0 .16.08.22.24.18-.04.08-.16.12-.36.12.04.2-.04.4-.24.6-.16 0-.26-.08-.3-.24 0-.12.08-.18.24-.18-.2-.12-.44.02-.72.42-.28.36-.52.54-.72.54l.12.18c.12.12.12.2 0 .24-.28 0-.4-.08-.36-.24-.04 0-.08.04-.12.12 0 .08-.04.1-.12.06 0 .08.04.12.12.12.12 0 .16.06.12.18-.12.08-.22.08-.3 0a.407.407 0 0 0-.3-.12c-.04.12-.02.2.06.24.04.04.06.08.06.12-.08.04-.16.02-.24-.06-.04-.08-.1-.1-.18-.06-.04.08-.02.14.06.18.08 0 .12.02.12.06-.92.84-1.8 1.46-2.64 1.86-.04 0-.06.1-.06.3-.36 0-.58.2-.66.6-1.04.8-2.24 1.34-3.6 1.62-1.32.32-2.58.22-3.78-.3-1.24-.48-2.04-1.44-2.4-2.88-.04-.68.06-1.62.3-2.82.16-.44.42-1.24.78-2.4.36-1.16.74-2.1 1.14-2.82.36-.72.86-1.32 1.5-1.8 1.08.12 1.74.76 1.98 1.92-.24.08-.44.12-.6.12-1.4 2.4-2.28 4.76-2.64 7.08-.28.36-.34 1.04-.18 2.04 1.56.24 3.82-.46 6.78-2.1 0-.04-.02-.08-.06-.12-.04-.08-.04-.14 0-.18.4-.08.64-.1.72-.06zm-.9 1.38c.12 0 .2-.02.24-.06.08-.04.1-.1.06-.18-.12 0-.22.08-.3.24zm9.72-6.36c.2 0 .3-.04.3-.12h.18c0-.12-.06-.18-.18-.18.04-.04.14-.12.3-.24.16-.16.26-.32.3-.48-.88.4-2.12 1.14-3.72 2.22-1.6 1.04-2.82 1.74-3.66 2.1 0 .08.06.16.18.24-.28.08-.62.28-1.02.6-.4.28-.74.46-1.02.54 0-.08-.02-.12-.06-.12 4.24-3 7.72-5.12 10.44-6.36 0 .04-.08.1-.24.18-.16.08-.24.14-.24.18 0 .08.06.08.18 0s.22-.1.3-.06c-.12.12-.32.34-.6.66-.24.28-.48.52-.72.72-.2.16-.46.28-.78.36 0-.04.02-.08.06-.12.04-.04.04-.08 0-.12zm.96-1.02c.2 0 .3-.06.3-.18-.2 0-.3.06-.3.18zm-.66.9c-.16 0-.26.04-.3.12h-.18c.04-.08.1-.14.18-.18.08-.04.14-.08.18-.12 0 .04.02.08.06.12.04 0 .06.02.06.06zm-.48.9c0 .04-.1.1-.3.18 0-.12.1-.18.3-.18zm-1.14.66c.04-.28.3-.42.78-.42-.16.2-.42.34-.78.42zm-.18.06c0-.04.06-.06.18-.06-.04.04-.1.06-.18.06zm-.72.72h.18v.24c-.2 0-.28-.06-.24-.18.04 0 .06-.02.06-.06zm-1.38 1.26c.08-.16.2-.16.36 0-.04.08-.16.08-.36 0zm-2.7.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm2.52 0c.2.08.2.2 0 .36-.16.12-.28.14-.36.06 0-.04.04-.1.12-.18.12-.08.2-.16.24-.24zm-2.46.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm-2.46.96h.24c0 .04-.02.1-.06.18-.04.04-.02.06.06.06-.08.08-.16 0-.24-.24zm16.37-9.42l.18.36c.28-.04.7.08 1.26.36 0 .04-.06.06-.18.06.84.84 1.14 1.56.9 2.16 0 .04.06.04.18 0 .12-.08.22-.08.3 0 0 .08-.04.18-.12.3-.04.08-.04.18 0 .3h-.18c-.08 0-.16.02-.24.06.08.04.14.16.18.36 0 .12.04.14.12.06.04.12.04.2 0 .24 0 .04-.06.12-.18.24-.08.08-.12.14-.12.18.04 0 .1-.02.18-.06.04-.04.1-.04.18 0-.16.16-.3.46-.42.9-.08.4-.2.7-.36.9 0 .04.1.06.3.06-.56 1.4-.46 2.84.3 4.32 0 .16-.14.22-.42.18-.24-.04-.38-.06-.42-.06-.8-.64-1.26-1.46-1.38-2.46-.12-1-.08-2.18.12-3.54.2-1.4.24-2.5.12-3.3-.32.2-.7.6-1.14 1.2-.44.56-.8.94-1.08 1.14-.76 1.56-1.56 2.8-2.4 3.72-.16.24-.44.72-.84 1.44-.36.72-.66 1.24-.9 1.56-.2.32-.54.68-1.02 1.08-.48.36-1.02.56-1.62.6-.8-.36-1.2-1.1-1.2-2.22-.04-1.16.18-2.12.66-2.88.12-.72.68-2.4 1.68-5.04 1.28.08 2.08.36 2.4.84-.08.28-.26.68-.54 1.2-.24.52-.4.94-.48 1.26.24-.16.52-.48.84-.96.32-.52.6-.86.84-1.02.12-.16.38-.56.78-1.2.44-.68.76-1.14.96-1.38.24-.28.6-.54 1.08-.78.52-.24 1.08-.3 1.68-.18zm-1.32.66h.18c0-.12-.06-.18-.18-.18v.18zm.42.24c-.12.08-.28.28-.48.6-.16.28-.34.44-.54.48 0-.04-.02-.06-.06-.06v-.06c0-.08.14-.16.42-.24 0-.04.02-.1.06-.18.04-.12.06-.2.06-.24 0-.04-.02-.1-.06-.18 0 .08-.04.1-.12.06-.04-.08-.1-.1-.18-.06-.16.36-.6.62-1.32.78-.04.08-.02.14.06.18.08.04.12.08.12.12-.12 0-.22.08-.3.24-.12-.04-.3.12-.54.48.36-.12.56-.12.6 0 0 .04-.02.1-.06.18-.04-.04-.28-.06-.72-.06v.36c0 .04-.06.04-.18 0-.04.12 0 .22.12.3.16.04.24.1.24.18-.08.04-.14.04-.18 0-.04-.04-.1-.06-.18-.06 0 .04-.02.1-.06.18l-.12.12c-.04.04-.06.08-.06.12.16.08.26.06.3-.06.04-.12.12-.16.24-.12-.04.04-.08.1-.12.18 0 .08-.02.16-.06.24-.04.04-.08.06-.12.06 0-.04-.04-.08-.12-.12h-.18v.3c.04.12.04.18 0 .18-.2-.12-.32-.12-.36 0 .24.08.3.22.18.42-.08.08-.12.14-.12.18.24 0 .44-.18.6-.54.16-.36.42-.52.78-.48.08-.24.22-.36.42-.36a.46.46 0 0 1-.06-.18c.04-.08.1-.14.18-.18l.18-.18c.04-.04.1-.08.18-.12.12-.04.2-.08.24-.12.08-.4.34-.84.78-1.32.48-.52.76-.9.84-1.14-.08-.04-.14-.02-.18.06-.04.04-.08.06-.12.06v-.18c-.08.04-.16.06-.24.06-.08-.04-.12-.02-.12.06.08.08.2.1.36.06zm-3.96 4.8c.32-.04.3-.16-.06-.36 0 .04.02.1.06.18.04.04.04.1 0 .18zm5.7.72c.08.04.12.02.12-.06l-.06-.24c0 .04-.02.08-.06.12-.04.04-.04.1 0 .18zm0 .42v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-.24.66c.16 0 .28-.12.36-.36-.28 0-.4.12-.36.36zm0 .42c.12 0 .18-.06.18-.18 0-.08-.04-.12-.12-.12 0 .04-.02.1-.06.18v.12zm-3.84-5.58c-.04.2.02.3.18.3.32-.08.48-.26.48-.54-.2 0-.3.12-.3.36a.46.46 0 0 1-.18-.06c-.04-.08-.1-.1-.18-.06zm1.32-.24c-.08.04-.18.12-.3.24-.08.12-.14.2-.18.24.08-.32.24-.48.48-.48zm-.6.6c.04.12 0 .24-.12.36-.12.08-.22.08-.3 0 .04 0 .1-.06.18-.18.08-.12.16-.18.24-.18zm-.84.6c-.08.16-.2.24-.36.24 0-.28.12-.36.36-.24zm.12.3h.18v.12h-.18v-.12zm-.18.12c.24 0 .24.14 0 .42-.08.08-.16.12-.24.12 0-.12.04-.22.12-.3.08-.08.12-.16.12-.24zm17.897.78c1.28-1.76 2.64-3.26 4.08-4.5.32-.04.66.04 1.02.24.36.16.58.24.66.24.4.92.64 2 .72 3.24.12 1.2.16 2.64.12 4.32-.04 1.64-.06 2.72-.06 3.24 0 .04.04.08.12.12.08 0 .1.04.06.12 2-.28 3.76 0 5.28.84 1.52.8 2.6 2 3.24 3.6 0 .08-.04.14-.12.18-.04.08-.04.16 0 .24.16.4.3.7.42.9.04.08 0 .14-.12.18-.08.04-.12.08-.12.12.24.6.22.96-.06 1.08 0-2.12-.82-3.68-2.46-4.68-1.6-1-3.62-1.18-6.06-.54-.08.44-.18 1.58-.3 3.42-.12 1.88-.38 3.24-.78 4.08.04.04.1.06.18.06l.06.06c-.08 1.8-.36 3.42-.84 4.86.08.16.08.4 0 .72-.04.36-.16.58-.36.66 0 .04.06.06.18.06-.16.44-.34 1.12-.54 2.04-.16.96-.36 1.82-.6 2.58s-.56 1.42-.96 1.98c0 .04.02.08.06.12.04.08.06.14.06.18.04.08.06.16.06.24l-.12.12c-.08.08-.16.1-.24.06-.2 1.44-.66 2.48-1.38 3.12.24 0 .26.18.06.54-.08.12-.2.22-.36.3.16.44.02.78-.42 1.02 0 .36-.06.68-.18.96-.12.28-.36.66-.72 1.14-.36.52-.56.8-.6.84.28.16.26.34-.06.54-.08.04-.18.06-.3.06.12.12.14.3.06.54-.08.04-.16.02-.24-.06 0 .08.02.14.06.18.04.04.06.08.06.12h-.18c-.08.04-.14.08-.18.12.08.08.08.18 0 .3s-.12.22-.12.3c-.16.12-.36.42-.6.9-.24.48-.48.78-.72.9-1.12 2.32-3.2 4.08-6.24 5.28-1.08 0-2.06-.22-2.94-.66-.88-.44-1.6-.94-2.16-1.5-.56-.52-1.1-1.3-1.62-2.34-.56-1-.94-1.8-1.14-2.4-.24-.56-.54-1.38-.9-2.46.08-.24.1-.44.06-.6-.96-4.76.34-9.8 3.9-15.12.2-.48.46-.96.78-1.44s.58-.84.78-1.08c.2-.24.56-.66 1.08-1.26.52-.56.84-.9.96-1.02-4 5.08-6.42 9.94-7.26 14.58 0 .28-.06.96-.18 2.04-.12 1.12-.08 1.7.12 1.74 0-.52.08-1.32.24-2.4.16-1.08.24-1.82.24-2.22.2-.4.24-.66.12-.78 1.96-5.56 4.32-9.8 7.08-12.72v-.12c-.04-.04-.06-.08-.06-.12.56-.12 1.16-.78 1.8-1.98l.18.18 1.44-1.44c.72-.64 1.2-1.12 1.44-1.44.08-.04.14-.04.18 0 .04.04.08.06.12.06.12-.4.36-.6.72-.6 0-.24-.04-.34-.12-.3 0-.04.02-.06.06-.06l.06-.12c.08 0 .12.04.12.12-.04.08 0 .14.12.18.12-.08.26-.18.42-.3.16-.12.28-.22.36-.3.12-.04.24-.14.36-.3.12-.12.22-.26.3-.42.24.08.52-.02.84-.3.36-.24.6-.36.72-.36.08-.04.1-.1.06-.18-.04-.08-.04-.14 0-.18.08.04.12.08.12.12l.06.06c.08-.04.12-.12.12-.24.04-.12.14-.16.3-.12 0 .04-.02.06-.06.06l-.06.12c.68-.24 1-.48.96-.72.16.24.36.24.6 0 .12-.08.14-.18.06-.3.12 0 .18.06.18.18l.06.06c.08-.04.22-.1.42-.18.24-.12.4-.22.48-.3.16-.12.32-.16.48-.12v-.24c.12-.08.28-.14.48-.18.2-.04.36-.08.48-.12.12-.08.18-.18.18-.3.12 0 .26-.04.42-.12.16-.08.28-.12.36-.12.04-1.28.02-4.3-.06-9.06-.52.64-1.44 1.84-2.76 3.6-1.32 1.76-2.48 3.2-3.48 4.32a28.6 28.6 0 0 1-3.18 3.06c-.44-.04-.76.04-.96.24-.72-.08-1.54-.62-2.46-1.62-.16-2.32.34-4.6 1.5-6.84 1.2-2.28 2.7-4.18 4.5-5.7.12.04.36.08.72.12.36.04.6.08.72.12.16 0 .36.06.6.18.28.08.48.16.6.24.16.08.3.22.42.42.12.16.2.36.24.6-.08 0-.12.02-.12.06.28.88.08 1.6-.6 2.16-.68.56-1.42.56-2.22 0-.04-.16-.04-.38 0-.66.08-.28.1-.52.06-.72-1.96 1.96-3.5 5.1-4.62 9.42.88-.52 1.7-1.18 2.46-1.98s1.54-1.7 2.34-2.7c.84-1.04 1.5-1.82 1.98-2.34 0-.08-.04-.12-.12-.12zm2.58-1.2h-.06c-.16.12-.28.32-.36.6.12-.04.26-.24.42-.6l.36-.36c.16-.16.3-.32.42-.48.12-.16.22-.32.3-.48h.12c0-.08.04-.14.12-.18a.94.94 0 0 0 .18-.24c.08-.08.1-.14.06-.18 0 .04-.04.06-.12.06-.04 0-.06-.02-.06-.06.24-.2.28-.38.12-.54-2.6 2.52-4.76 5.02-6.48 7.5.56-.44 1.1-.94 1.62-1.5.56-.56 1.16-1.22 1.8-1.98.68-.8 1.18-1.36 1.5-1.68v.06c.04 0 .06.02.06.06zm-.66.96c0-.04.02-.08.06-.12.04-.04.06-.08.06-.12-.08-.04-.14-.02-.18.06-.04.08-.02.14.06.18zm-4.74 4.5c.12.04.22 0 .3-.12.08-.12.08-.22 0-.3 0 .04-.06.1-.18.18-.12.08-.16.16-.12.24zm9.54 3.3c.88 0 1.4-.06 1.56-.18-.96.08-1.48.14-1.56.18zm1.62 0c.08-.04.18-.06.3-.06.12-.04.2-.06.24-.06-.08-.08-.2-.12-.36-.12-.12 0-.18.08-.18.24zm1.26-.18v.12c.04.04.08.04.12 0v-.18c0 .04-.04.06-.12.06zm.9.3c0-.16-.08-.24-.24-.24 0 .16.08.24.24.24zm-3.24.36c1 0 1.58-.04 1.74-.12-.24-.2-.82-.16-1.74.12zm2.34 0c.16 0 .26.02.3.06.04-.16-.02-.28-.18-.36-.08.08-.12.18-.12.3zm-.36 0c.08-.12.08-.2 0-.24v.24zm-5.52.06v.18c0 .12.02.18.06.18.04-.12.16-.14.36-.06.08-.2.2-.28.36-.24.04-.08 0-.14-.12-.18-.12-.04-.18-.08-.18-.12-.08.08-.24.16-.48.24zm3.48.12h-.18v.18c.12 0 .18-.06.18-.18zm-23.64 21.96c-.04.04-.04.14 0 .3 0 .16-.02.28-.06.36-.04.08-.14.12-.3.12-.04.08 0 .14.12.18.08.04.12.08.12.12h-.3c.04.24.06.6.06 1.08-.08-.04-.14-.02-.18.06-.04.08-.08.12-.12.12.08.2.06.58-.06 1.14-.16.56-.14.9.06 1.02-.04-.16-.02-.36.06-.6s.06-.4-.06-.48c.2-.48.52-1.58.96-3.3.44-1.68.9-2.9 1.38-3.66 0-.16-.04-.36-.12-.6h.36v-.24c0-.12.02-.2.06-.24h.18c0-.28.12-.58.36-.9v.12h.12c.04-.08 0-.12-.12-.12.12-.36.34-.68.66-.96-.08-.08-.04-.2.12-.36.12-.16.12-.32 0-.48.08 0 .18-.08.3-.24.08-.12.2-.16.36-.12 0-.08-.02-.16-.06-.24-.04-.04-.06-.08-.06-.12.68-.68.98-1.22.9-1.62.36-.08.72-.42 1.08-1.02.36-.6.68-.92.96-.96.04-.24.2-.52.48-.84.24-.28.46-.34.66-.18 0-.6.26-.96.78-1.08.16 0 .24-.04.24-.12-.08 0-.16.04-.24.12-.04 0-.06-.02-.06-.06.12-.08.42-.4.9-.96.52-.52.94-.86 1.26-1.02-.08-.12-.02-.22.18-.3.24-.04.32-.12.24-.24.04.04.12.06.24.06 0-.2.02-.3.06-.3 0 .12.04.18.12.18.16-.32.52-.68 1.08-1.08.56-.36.92-.66 1.08-.9.04.04.06.1.06.18.08.16.18.22.3.18 0-.04-.02-.1-.06-.18-.08-.16-.06-.26.06-.3.08-.04.12 0 .12.12.04.16.08.24.12.24 0-.08.06-.16.18-.24.16-.04.24-.08.24-.12-.04-.08-.1-.1-.18-.06-.04.04-.1.04-.18 0-.04 0-.06-.06-.06-.18.16.04.26-.02.3-.18.04-.12.14-.18.3-.18 0 .08.06.14.18.18-.08-.04-.1-.12-.06-.24.04-.08.08-.12.12-.12.36 0 .84-.3 1.44-.9.24.08.64-.06 1.2-.42.6-.32 1-.48 1.2-.48.04-.12.18-.24.42-.36.28-.16.46-.32.54-.48-2.32.76-4.94 2.16-7.86 4.2l-.06-.06c-.04-.04-.08-.06-.12-.06-.04.04-.06.08-.06.12.04.08.06.16.06.24-.2.16-.74.6-1.62 1.32-.84.76-1.44 1.3-1.8 1.62-.36.32-.82.8-1.38 1.44-.56.64-1.02 1.26-1.38 1.86-.08-.08-.18-.06-.3.06-.16.12-.28.12-.36 0 0 .08.04.14.12.18.04.08.06.14.06.18-.28.2-.64.64-1.08 1.32-.48.72-.92 1.14-1.32 1.26.04.08.08.12.12.12l.12.06c-.8 1.52-1.24 2.34-1.32 2.46.16 0 .24.02.24.06-.6.84-1.3 2.68-2.1 5.52zm20.22-21.3c.2 0 .3-.08.3-.24-.2.12-.3.2-.3.24zm.3.24h.12v-.18h-.12v.18zm-1.74.48c.2 0 .3-.08.3-.24-.2 0-.3.08-.3.24zm-8.34 6.36c-1.12 1.32-2.6 2.96-4.44 4.92-.2.64-.48 1.04-.84 1.2.2.04.2.16 0 .36-.12.12-.26.14-.42.06 0 .04.02.1.06.18.04.08.04.16 0 .24-1.48 1.88-2.5 4.16-3.06 6.84-.24.28-.42.74-.54 1.38-.12.68-.28 1.16-.48 1.44-.4 5.48.32 9.42 2.16 11.82.6.24 1.22.32 1.86.24.64-.08 1.2-.16 1.68-.24.44-.08.9-.3 1.38-.66.48-.36.88-.7 1.2-1.02.36-.28.74-.68 1.14-1.2.4-.48.72-.9.96-1.26s.54-.8.9-1.32.66-.92.9-1.2c.28-.6.74-1.5 1.38-2.7.64-1.16 1.18-2.24 1.62-3.24.44-.96.78-1.96 1.02-3 .4-.6.82-1.68 1.26-3.24.44-1.56.76-2.58.96-3.06.64-3.84 1.08-6.12 1.32-6.84 0-.08-.06-.16-.18-.24-.12-.04-.16-.1-.12-.18.32-.68.52-1.58.6-2.7.08-1.12.2-1.96.36-2.52-.2-.16-.36-.34-.48-.54-3.76 1.84-7.16 4-10.2 6.48zm8.04-6.24c.16.04.24 0 .24-.12-.16 0-.24.04-.24.12zm-1.98.72c-.04.12-.02.18.06.18.08.04.14.06.18.06.08 0 .12.04.12.12.32-.12.5-.24.54-.36-.04 0-.08.02-.12.06-.16.08-.26.06-.3-.06.04-.04.14-.1.3-.18.2-.04.3-.12.3-.24-.24.12-.6.26-1.08.42zm1.44-.24v.12h.12c.12-.12.1-.2-.06-.24 0 .08-.02.12-.06.12zm-3.12 1.8c.16 0 .24-.06.24-.18h-.18c0 .08-.02.14-.06.18zm-.84.6h.12v-.12h-.12v.12zm-1.26.48c-.08 0-.12.06-.12.18.08-.08.12-.14.12-.18.36-.08.56-.2.6-.36-.16 0-.36.12-.6.36zm-.6.72c0 .04-.06.08-.18.12-.08.08-.12.16-.12.24.44-.2.72-.42.84-.66-.08 0-.16.06-.24.18-.08.12-.18.16-.3.12-.04-.08-.02-.14.06-.18.08 0 .1-.04.06-.12h-.18c-.08 0-.14.02-.18.06-.04.04-.06.12-.06.24h.3zm.72.06h.12v-.18h-.12v.18zm-1.44.66c.12 0 .18-.06.18-.18-.12 0-.18.06-.18.18zm-.66.48c.12.12.24.08.36-.12-.16-.04-.28 0-.36.12zm-.78.78c.08 0 .18-.04.3-.12.12-.08.14-.16.06-.24l-.36.36c-.12-.04-.14-.1-.06-.18.08-.08.12-.14.12-.18-.12 0-.22.06-.3.18-.08.12-.18.16-.3.12.08.08.08.14 0 .18-.08.08-.12.16-.12.24.08-.04.16-.04.24 0 .12.04.2 0 .24-.12-.04-.08-.1-.1-.18-.06l.06-.12c0-.04.02-.06.06-.06 0 .08.04.12.12.12.08 0 .12-.04.12-.12zm-.84.9c.04-.08.08-.14.12-.18.08-.04.12-.08.12-.12-.12-.04-.22 0-.3.12-.04.08-.02.14.06.18zm-.42.42h.18v-.18h-.18v.18zm-.36.18c.08.04.16-.04.24-.24h-.24v.24zm.66-.06c.08 0 .16-.04.24-.12-.16 0-.24.04-.24.12zm-2.76.6c.12 0 .22-.06.3-.18.08-.12.14-.2.18-.24-.28.08-.44.22-.48.42zm1.74-.24v.18h.18c0-.08.02-.12.06-.12v-.12h-.18c0 .04-.02.06-.06.06zm-2.1.66c.16 0 .24-.1.24-.3-.08 0-.16.1-.24.3zm.9.96c0-.04.02-.08.06-.12.04-.04.06-.08.06-.12-.2-.16-.42-.06-.66.3.32-.08.5-.1.54-.06zm-2.94 1.62c.08.04.14-.02.18-.18.04-.04.02-.08-.06-.12 0 .04-.02.08-.06.12-.08.04-.1.1-.06.18zm-.54.78c.08.04.16-.04.24-.24-.08-.04-.14-.04-.18 0-.04.08-.06.16-.06.24zm.3 1.62h.3c0-.2-.02-.3-.06-.3 0 .04-.04.08-.12.12-.08.04-.12.1-.12.18zm-1.32 0h.18v-.18h-.18v.18zm1.08.72c0-.04.04-.12.12-.24.04-.08.08-.14.12-.18 0-.04-.02-.1-.06-.18-.24.36-.3.56-.18.6zm-.42.48c.12.08.2.04.24-.12.04-.08.02-.14-.06-.18 0 .04-.02.08-.06.12-.04.08-.08.14-.12.18zm16.44.36v.18c.08.04.12 0 .12-.12.04-.08.02-.12-.06-.12 0 .04-.02.06-.06.06zm-.18.3c.04.04.04.06 0 .06v-.06zm-16.38.24c-.04 0-.1-.04-.18-.12-.08.08-.02.12.18.12zm16.56.78c.08.04.12 0 .12-.12l.06-.12h-.18v.24zm-17.46.3c.16.04.24-.04.24-.24 0-.08-.02-.12-.06-.12l-.18.36zm16.8.48c.16.08.26-.02.3-.3 0-.08-.02-.14-.06-.18 0 .08-.04.16-.12.24-.08.08-.12.16-.12.24zm0 .6c.24-.24.24-.4 0-.48 0 .08-.02.16-.06.24-.08.12-.06.2.06.24zm-.66.18h.18v-.12h-.18v.12zm-.06.3c.04.08.08.08.12 0 .04-.08.02-.12-.06-.12 0 .04-.02.06-.06.06v.06zm.72.3h.12c0-.04.04-.1.12-.18-.04 0-.08-.02-.12-.06h-.12v.24zm-.96.66c0-.04.04-.1.12-.18.04-.04.06-.1.06-.18-.2-.04-.3.04-.3.24 0 .08.04.12.12.12zm.18.54c.2-.04.32-.24.36-.6 0-.16-.06-.24-.18-.24 0 .32-.06.6-.18.84zm-.42.18c0-.08.02-.18.06-.3.04-.12.08-.22.12-.3-.12 0-.22.08-.3.24-.04.2 0 .32.12.36zm-.36.96c.16-.48.22-.76.18-.84-.24.28-.3.56-.18.84zm-16.5-.54c0-.08.02-.1.06-.06 0-.12-.04-.18-.12-.18 0 .16.02.24.06.24zm16.02 1.38c.16 0 .24-.1.24-.3.04-.16.02-.26-.06-.3 0 .04-.06.12-.18.24a.3.3 0 0 0 0 .36zm.66-.36h.18c.04-.12 0-.2-.12-.24.04.08.02.16-.06.24zm-.36.84h.18v-.12h-.18v.12zm.36 0h.18v-.12h-.18v.12zm-1.14 2.04c.44-1 .64-1.52.6-1.56-.4.8-.6 1.32-.6 1.56zm-.66-.3c.24-.04.38-.06.42-.06 0-.16.08-.36.24-.6.16-.2.2-.36.12-.48-.4.4-.66.78-.78 1.14zm1.02.42l.36-.72c-.16 0-.28.1-.36.3-.08.2-.08.34 0 .42zm-1.2 0c.08 0 .16-.1.24-.3h-.18c0 .16-.02.26-.06.3zm.06 1.38c.2-.08.36-.3.48-.66.16-.32.18-.54.06-.66-.04.08-.22.52-.54 1.32zm-.3-.9c.12.04.18 0 .18-.12.04-.12.02-.2-.06-.24 0 .04-.02.1-.06.18a.46.46 0 0 0-.06.18zm0 .36c-.08.36-.28.82-.6 1.38l-.54 1.08c-.12.08-.18.22-.18.42 0-.04.02-.06.06-.06h.12v-.36h.06c.24-.32.68-1.16 1.32-2.52h-.12c-.04.04-.08.06-.12.06 0-.16-.02-.24-.06-.24 0 .04-.04.12-.12.24-.08.12-.14.2-.18.24 0 .08.02.16.06.24.04-.04.08-.12.12-.24.04-.12.1-.2.18-.24zm.24-.12h.12v-.12h-.12v.12zm.48.72c.28-.4.38-.66.3-.78 0 .12-.08.24-.24.36-.12.16-.14.3-.06.42zm-16.62-.36c0-.04.04-.1.12-.18.04-.04.04-.1 0-.18-.12 0-.18.02-.18.06.04 0 .04.04 0 .12-.04.12-.02.18.06.18zm14.94 1.14c.12 0 .2-.04.24-.12.08-.08.14-.2.18-.36.04-.12.08-.2.12-.24-.12.04-.22.16-.3.36-.08.2-.16.32-.24.36zm-15.9-.06c.12.08.2.02.24-.18 0-.12-.02-.2-.06-.24-.12.24-.18.38-.18.42zm15.06 3.18c-.12.16-.44.6-.96 1.32-.48.76-.78 1.32-.9 1.68 1.12-1.52 1.74-2.52 1.86-3 .52-.6 1.14-1.66 1.86-3.18-.36.44-.98 1.5-1.86 3.18zm-15.06-2.52c.16.04.24-.02.24-.18 0-.2-.08-.32-.24-.36v.54zm16.62.48l.18-.18c-.08 0-.14.06-.18.18zm-1.62.78c.04.16.04.3 0 .42s-.1.26-.18.42c-.08.16-.14.3-.18.42.12-.08.36-.56.72-1.44-.08.16-.2.22-.36.18zm-14.34.6c0-.24-.1-.36-.3-.36.08.24.18.36.3.36zm13.08 2.04c-.76.96-1.18 1.58-1.26 1.86.08-.12.22-.3.42-.54.2-.24.36-.46.48-.66.16-.2.28-.42.36-.66.28-.24.58-.68.9-1.32-.28.12-.58.56-.9 1.32zm.96-.18c.08.04.12.02.12-.06.04-.08.08-.12.12-.12-.16-.04-.24.02-.24.18zm-2.82 3.3c.04-.08.18-.22.42-.42.24-.16.42-.32.54-.48.12-.16.14-.3.06-.42-.08.16-.26.36-.54.6-.24.28-.4.52-.48.72zm.3-.96c-.12.04-.24.16-.36.36.24-.04.36-.16.36-.36h.06c.16-.16.16-.24 0-.24l-.06.06v.18zm-1.8.6c.16 0 .28-.06.36-.18-.04-.08-.16-.02-.36.18zm.12 1.02c.88-.52 1.24-.9 1.08-1.14-.08.2-.26.4-.54.6-.28.24-.46.42-.54.54zm-.72-.48c-.04 0-.16.1-.36.3.24-.08.36-.18.36-.3.2-.04.38-.18.54-.42-.24.08-.42.22-.54.42zm1.8.06c.16 0 .24-.08.24-.24-.08 0-.14.04-.18.12 0 .08-.02.12-.06.12zm-.36.36c-.08-.04-.14-.02-.18.06-.04.08-.02.14.06.18 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12.12.04.22 0 .3-.12.04-.08.02-.14-.06-.18 0 .08-.04.14-.12.18-.08.04-.12.08-.12.12zm-.54.42h.3v-.18c-.08-.04-.18.02-.3.18zm-1.02.3c-.08 0-.16.04-.24.12-.12 0-.18.06-.18.18.12 0 .18-.06.18-.18.16.04.24 0 .24-.12.16-.04.3-.1.42-.18.12-.08.14-.16.06-.24-.04.04-.12.08-.24.12-.16.08-.24.18-.24.3zm.24.36c.08 0 .32-.2.72-.6-.44.24-.68.44-.72.6zm-2.34-.24v.18c.08.04.14 0 .18-.12 0-.08-.04-.12-.12-.12 0 .08-.02.1-.06.06zm14.28-47.88h-.18c0-.12.06-.18.18-.18v.18zm-.42.24c-.04.16-.16.32-.36.48-.16.16-.26.28-.3.36-.08-.24.14-.52.66-.84zm-3.36 2.4l.12-.12c0 .08-.04.12-.12.12zm-.48 9.36c.04-.16.18-.24.42-.24-.04.16-.18.24-.42.24zm-4.02 2.4c-.12.2-.24.3-.36.3.08-.16.2-.26.36-.3zm8.46.96c.08-.12.16-.14.24-.06.08.08.08.18 0 .3-.08 0-.12-.04-.12-.12 0-.08-.04-.12-.12-.12zm-10.62.66h.12v.12h-.12v-.12zm-.66.54h.12v.18h-.12v-.18zm55.295-1.08h.12-.12a.36.36 0 0 0-.24.24c0 .04.04.06.12.06.16-.04.22-.02.18.06-.04.04-.22.18-.54.42-.32.24-.46.48-.42.72a.255.255 0 0 0-.24 0l-.18.06c0 .08-.02.14-.06.18 0 .08-.02.16-.06.24a.46.46 0 0 0-.06.18l-.12-.12c.04-.08.04-.12 0-.12s-.14.1-.3.3c-.16.24-.34.34-.54.3-.04.04-.06.1-.06.18.04.08.02.12-.06.12v-.06.06c-.12.24-.38.38-.78.42 0 .16-.06.26-.18.3a.76.76 0 0 1-.36.18c-.16.08-.26.12-.3.12-.12 0-.18-.1-.18-.3 0 .04-.12.12-.36.24.04.12.1.16.18.12.12-.04.2-.04.24 0-.04.08-.12.14-.24.18-.12.08-.2.1-.24.06 0 .16.04.24.12.24l-.96.48c-.48.24-.9.42-1.26.54-.04 0-.1.04-.18.12-.04.08-.08.12-.12.12-.04.04-.12.06-.24.06-.08.04-.14.04-.18 0-1.12.76-2.8 1.18-5.04 1.26-1.08-.2-1.82-.82-2.22-1.86-.4-1.04-.46-2.24-.18-3.6.2-.64.46-1.22.78-1.74s.74-1.02 1.26-1.5c.56-.44 1.02-.8 1.38-1.08.36-.24.94-.6 1.74-1.08.8-.44 1.32-.74 1.56-.9 2.08-.8 3.4-1.22 3.96-1.26-.04.16-.04.26 0 .3.08.04.2.04.36 0-.4.4-.62.68-.66.84-1 .16-1.92.62-2.76 1.38.04.08.12.08.24 0 .12-.04.24-.02.36.06.24 0 .32-.1.24-.3 0-.08-.04-.12-.12-.12.04 0 .12-.08.24-.24.16-.16.3-.22.42-.18 0 .08-.06.18-.18.3-.12.08-.18.18-.18.3 0 .04.02.04.06 0 .08-.04.16-.04.24 0-.44.32-.7.5-.78.54 0 .12.06.14.18.06.16-.08.26-.12.3-.12 0 .12-.04.2-.12.24-.08.08-.22.14-.42.18-.16.04-.26.06-.3.06-.16.24-.5.5-1.02.78-.52.32-.86.62-1.02.9-.16 0-.32.06-.48.18-.16.12-.28.18-.36.18.04.08 0 .14-.12.18-.08.08-.12.16-.12.24-1.44.84-2.62 2.08-3.54 3.72.04 0 .06.12.06.36.2.2.44.34.72.42.28.08.56.12.84.12.28.04.62.02 1.02-.06.44-.04.76-.08.96-.12.24-.04.56-.12.96-.24.44-.12.7-.18.78-.18 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12.08.04.12.08.12.12-.04.08-.04.14 0 .18.68-.52 1.34-.84 1.98-.96.64-.48 1.2-.8 1.68-.96 1.04-.76 2.5-2.04 4.38-3.84.6-1.04 1.02-1.64 1.26-1.8.64-1.28.96-2.52.96-3.72-.08-.64-.26-1.2-.54-1.68-.24-.52-.58-1.04-1.02-1.56-.44-.52-.74-.92-.9-1.2 0-.04-.04-.04-.12 0-.08 0-.12-.02-.12-.06-.72-.84-2.12-1.96-4.2-3.36-.04 0-.1-.04-.18-.12-.04-.12-.1-.2-.18-.24 0-.04-.08-.06-.24-.06a.753.753 0 0 1-.3-.18c-.04 0-.06-.02-.06-.06l-.06-.12c-.2-.16-.62-.36-1.26-.6-1.44-1-2.74-1.82-3.9-2.46-.2-.2-.54-.46-1.02-.78-.44-.32-.82-.62-1.14-.9-.28-.32-.5-.66-.66-1.02-.48-.32-.84-.84-1.08-1.56-.8-2.64.18-5.16 2.94-7.56 0-.08.04-.2.12-.36.12 0 .26-.08.42-.24.16-.16.32-.24.48-.24.2-.44.66-.8 1.38-1.08.08 0 .1-.02.06-.06a.46.46 0 0 1-.06-.18c.2-.08.56-.3 1.08-.66.52-.36.96-.58 1.32-.66.04-.16.18-.3.42-.42.28-.16.48-.22.6-.18.56-.44 1.2-.86 1.92-1.26s1.58-.84 2.58-1.32c1.04-.48 1.78-.84 2.22-1.08.04 0 .08-.02.12-.06v-.06c3.72-1.48 6.16-2.4 7.32-2.76v-.24c.36.04.86-.04 1.5-.24.64-.24 1.08-.36 1.32-.36 1-.44 2.14-.74 3.42-.9 1.28-.16 2.5-.06 3.66.3.2.28.3.44.3.48.24.04.44.24.6.6.2.36.34.58.42.66.76.92.96 1.76.6 2.52-.04.04-.1.12-.18.24l-.18.18c-.32.04-.84.34-1.56.9 0-.04-.14-.06-.42-.06.44-1.36.68-2.28.72-2.76-.72-.24-1.64-.32-2.76-.24-1.08.08-1.92.18-2.52.3-.56.12-1.36.32-2.4.6-1.04.24-1.84.42-2.4.54-.16.12-.42.26-.78.42-.36.12-.6.22-.72.3-.08 0-.14-.02-.18-.06-.04-.04-.08-.06-.12-.06v.24c-.44.08-1.38.4-2.82.96 0 .04-.04.06-.12.06h-.18c-.08-.04-.14-.04-.18 0-.24.32-.7.58-1.38.78-.68.16-1.12.38-1.32.66-.04 0-.06-.06-.06-.18-.04 0-.08.06-.12.18 0 .08-.04.14-.12.18a.805.805 0 0 0-.66.18c-.16.16-.26.24-.3.24-.08.08-.2.12-.36.12-.16 0-.26.02-.3.06-.12.04-.32.16-.6.36-.28.2-.52.3-.72.3 0 .12-.1.24-.3.36l-.6.3c-.24.12-.42.22-.54.3-.32.32-.78.54-1.38.66-.08.04-.1.08-.06.12.04.08.06.14.06.18-.76.24-1.66.74-2.7 1.5-1.04.76-1.7 1.22-1.98 1.38v.12c0 .04.02.04.06 0 0 .2-.08.22-.24.06-.28.2-.64.54-1.08 1.02-.44.44-.76.74-.96.9-.04.08-.04.14 0 .18.04.04.06.08.06.12-1.12.88-1.56 1.9-1.32 3.06.04.12.14.28.3.48.16.2.26.38.3.54.36.2.9.6 1.62 1.2.76.56 1.4.92 1.92 1.08.28.36.54.56.78.6v.18c.16 0 .28.02.36.06.08.08.18.12.3.12.08.16.12.28.12.36.36.04.86.28 1.5.72.64.4 1.12.66 1.44.78.28.32.88.8 1.8 1.44.96.64 1.62 1.22 1.98 1.74 2.16 1.68 3.62 3.92 4.38 6.72-.08-.04-.14-.18-.18-.42 0-.28-.04-.44-.12-.48.2.96.3 2.6.3 4.92-.12.4-.32.84-.6 1.32-.28.52-.44.92-.48 1.2-.12 0-.22.04-.3.12-.04.2-.2.42-.48.66-.24.28-.36.52-.36.72-.04 0-.12.04-.24.12-.16.12-.26.1-.3-.06zm5.1-39.96c0-.04-.04-.06-.12-.06-.04 0-.06.02-.06.06h.18zm-.9.24c-.04.04-.08.06-.12.06h-.06c.12 0 .18-.02.18-.06zm-1.02.36c.04 0 .08.02.12.06.08.04.12.02.12-.06-.16-.04-.24-.04-.24 0zm-.9.48c.04-.04.1-.06.18-.06h.18c.08-.04.12-.1.12-.18-.32 0-.48.08-.48.24zm-.54.12c-.04-.04-.08-.06-.12-.06l.12.06zm-.6.3h.18v-.12h-.18v.12zm-.42.18c.24-.04.36-.1.36-.18-.2 0-.32.06-.36.18zm-.9.3c-.04.12-.16.22-.36.3-.16.04-.26.1-.3.18l.06.06c.04.04.08.06.12.06.04-.08.16-.16.36-.24.2-.08.36-.14.48-.18.12-.08.12-.18 0-.3.04.08 0 .14-.12.18-.08.04-.16.02-.24-.06zm-.9.54l-.06.06h-.06c.08 0 .12-.02.12-.06zm-1.32.42c-.04.12.14.18.54.18-.04-.04-.06-.1-.06-.18 0-.12-.04-.18-.12-.18 0 .12-.12.18-.36.18zm.96.42c.04.04.08.02.12-.06 0-.16-.02-.24-.06-.24 0 .04-.02.08-.06.12v.18zm-.48.24c0-.04.02-.06.06-.06.08 0 .12-.04.12-.12-.04-.04-.1.02-.18.18zm2.34.12c.12.04.2 0 .24-.12 0-.04.02-.08.06-.12-.2.08-.3.16-.3.24zm-4.26.12c.4.12.68.02.84-.3-.44.08-.72.18-.84.3zm-.3.12h.18c0-.08-.06-.12-.18-.12v.12zm1.32 0c-.32 0-.5.1-.54.3.28-.08.46-.18.54-.3zm-2.16.48c.04.08.12.12.24.12.16-.04.26-.12.3-.24-.08-.2-.26-.16-.54.12zm2.64-.18c-.2 0-.3.02-.3.06.04.04.08.06.12.06.08 0 .14-.04.18-.12zm.9.12c.04 0 .08.02.12.06h.12c.16-.08.26-.14.3-.18l-.54.12zm-2.16.06c.04 0 .1-.04.18-.12-.12 0-.18.04-.18.12zm-1.56 0v.18c.04.04.08.02.12-.06.04-.12.02-.18-.06-.18 0 .08-.02.1-.06.06zm-.54.3c0 .04.04.08.12.12.12 0 .18.02.18.06-.04.04-.16.06-.36.06-.16-.04-.24 0-.24.12.32.12.52.06.6-.18 0-.12-.06-.22-.18-.3l-.12.12zm.54 0c0-.08-.06-.12-.18-.12a.46.46 0 0 0-.06.18c.04 0 .12-.02.24-.06zm.42.24c-.16 0-.28.04-.36.12 0 .04.12 0 .36-.12.08 0 .16-.04.24-.12l.18-.12c-.08-.04-.14-.04-.18 0 0 .04-.04.1-.12.18-.04.04-.08.06-.12.06zm2.16-.06c.16 0 .22-.06.18-.18h-.12c0 .04-.02.08-.06.12v.06zm-4.62.72c0 .12.06.22.18.3.04-.16.06-.26.06-.3l.72-.24c-.04-.08-.02-.14.06-.18.08-.08.12-.14.12-.18-.12.04-.3.14-.54.3-.2.16-.4.26-.6.3zm3.42-.36h.12v-.18h-.12v.18zm-1.62.12v-.18.18zm1.92-.06c-.04.16.04.24.24.24-.12-.16-.2-.24-.24-.24zm-2.22.24h.06l.06.06c0-.16-.04-.24-.12-.24v.18zm1.32-.12v.06l-.06.06c.04-.04.06-.08.06-.12zm-1.62.18c-.24.08-.42.22-.54.42.24-.08.42-.22.54-.42zm1.98 0c.16 0 .26-.02.3-.06-.2-.08-.3-.06-.3.06zm-1.26.18c.04 0 .08.02.12.06h.18c.04-.12-.02-.18-.18-.18-.04 0-.08.04-.12.12zm-2.76.48c.12-.04.26-.06.42-.06.16-.04.26-.06.3-.06 0-.12-.04-.22-.12-.3-.08-.04-.14-.02-.18.06.08.08.04.12-.12.12-.2.08-.3.16-.3.24zm3.12-.24c.32 0 .5-.06.54-.18-.04 0-.1.02-.18.06-.2 0-.32.04-.36.12zm.96-.18c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.56.66c.12-.04.18-.12.18-.24l-.06.06v-.12c0 .12-.04.22-.12.3zm-2.7-.24c-.24.08-.36.18-.36.3.08-.04.12-.02.12.06h.3c0-.04-.02-.1-.06-.18-.04-.04-.04-.1 0-.18zm.84.3c.12-.12.18-.2.18-.24-.16.08-.22.16-.18.24zm1.02.06c.04 0 .06-.04.06-.12l-.06.12zm.6 0h-.18.18zm-1.92 0c-.28.08-.54.24-.78.48.16.04.42-.12.78-.48zm-1.26.24c-.08-.08-.14-.12-.18-.12 0 .08-.04.12-.12.12-.08-.04-.14-.02-.18.06.16.12.32.14.48.06.2-.08.34-.2.42-.36h-.3c0 .16-.04.24-.12.24zm-.66.42c.08-.04.18-.04.3 0v-.06c-.04-.08-.08-.12-.12-.12 0 .04-.04.06-.12.06h-.06v.12zm2.34-.18c-.04 0-.06.02-.06.06.04 0 .06-.02.06-.06zm-2.16.6c.56-.2.88-.38.96-.54-.08.04-.4.22-.96.54zm1.62-.18h-.12.12zm-2.46.18h.12v-.12h-.12v.12zm.18.48c.28-.04.5-.18.66-.42h-.36c0 .08-.02.14-.06.18-.04 0-.1.02-.18.06-.04.04-.06.1-.06.18zm-.78-.12c.04.16-.06.28-.3.36.08 0 .2-.04.36-.12.24-.08.36-.06.36.06v.12c.12 0 .22-.08.3-.24-.08 0-.16-.06-.24-.18-.04-.12-.08-.18-.12-.18 0 .12-.02.2-.06.24l-.06-.06h-.24zm2.22-.12l-.12.06c-.04 0-.06.02-.06.06h.06l.12-.12zm.36.18c.04.08.1.12.18.12.08-.04.12-.1.12-.18-.2 0-.3.02-.3.06zm-.06-.06c-.08 0-.12.02-.12.06.04 0 .08-.02.12-.06zm-1.08.48h.18v-.06h-.18v.06zm-2.1.12h.12l.06-.06v-.06h-.06c-.04-.04-.08-.06-.12-.06v.18zm1.02-.18c-.08 0-.14.02-.18.06.12 0 .18-.02.18-.06zm1.38.18h.18v-.12h-.18v.12zm-.84.06l.24-.12c-.16 0-.24.04-.24.12zm-2.1.96c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm.54.3l-.06-.06c-.04-.04-.08-.06-.12-.06-.04.08.02.12.18.12zm-.18.72c.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12 0 .16.06.24.18.24zm-.36.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.8 1.38c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18l-.12.24zm.12.84c-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06-.04.08-.02.14.06.18.12.04.18.02.18-.06zm3.66 7.62h.18v-.12h-.18v.12zm3.72 1.14h.12v-.06h-.12v.06zm.42.12c.04-.08-.02-.12-.18-.12-.04.04-.04.08 0 .12.04.04.1.04.18 0zm-1.38.18h.06v-.18h-.06v.18zm.78.36c0-.16-.1-.24-.3-.24-.04.08 0 .14.12.18.12 0 .18.02.18.06zm1.86.36h.12v-.06h-.12v.06zm-.66.48c.08-.12.1-.2.06-.24h-.12c0 .12.02.2.06.24zm-.54-.12l-.12.12.12-.12zm.78.48c0-.04.04-.08.12-.12.08-.04.1-.1.06-.18a.46.46 0 0 1-.18-.06c0 .04-.02.1-.06.18-.04.08-.02.14.06.18zm1.56-.18l-.18.06c-.04.08-.04.12 0 .12.08-.04.14-.1.18-.18zm.12.3h.06v-.12h-.06v.12zm-.18.72h.12v-.12h-.12v.12zm.6.42a.68.68 0 0 0-.24-.24l-.18-.18c.04.24.18.38.42.42zm.18.12h.12v-.06c.04 0 .06-.02.06-.06h-.24c-.04.04-.02.08.06.12zm1.08.84c.12.16.64.66 1.56 1.5-.28-.6-.8-1.1-1.56-1.5l-.3-.3c-.12-.16-.22-.26-.3-.3-.08-.08-.18-.08-.3 0 .12.04.26.16.42.36.16.16.32.24.48.24zm2.1 1.98c-.04-.16-.16-.28-.36-.36.08.2.2.32.36.36zm-5.4 6.36c.24 0 .36-.04.36-.12-.16 0-.28.04-.36.12zm-.48.36c-.32.12-.48.22-.48.3.04-.04.1-.06.18-.06.08-.04.14-.08.18-.12.08-.04.12-.08.12-.12h.12v-.24c-.08 0-.12.08-.12.24zm-.72.36h.18v-.18h-.18v.18zm-.66.36c.32-.08.5-.16.54-.24l-.06-.06c-.04-.04-.1-.04-.18 0 .04.08 0 .14-.12.18-.12.04-.18.08-.18.12zm-.48.18h-.42l-.06.12c0 .08-.02.12-.06.12-.08-.04-.18-.02-.3.06-.08.04-.16.02-.24-.06.04.08.02.14-.06.18-.04.04-.06.08-.06.12h.12c.08.04.16.06.24.06 0-.04.12-.12.36-.24s.4-.24.48-.36zm-1.86.6c-.12.24-.16.34-.12.3-.04.08-.1.06-.18-.06 0 .04-.04.1-.12.18-.16.2-.2.34-.12.42.08-.04.18-.06.3-.06.04-.16.1-.28.18-.36.08-.08.2-.16.36-.24.2-.04.32-.06.36-.06-.04 0-.08-.02-.12-.06 0-.04-.02-.06-.06-.06h-.48zm1.08.54c-.68.2-1.16.52-1.44.96l-.36.18c-.16.08-.3.16-.42.24-.08.08-.1.16-.06.24.08-.08.22-.18.42-.3.24-.08.44-.18.6-.3.16-.12.3-.26.42-.42 0 .08.06.1.18.06.04-.08.26-.2.66-.36.4-.16.62-.42.66-.78h-.18c-.04.16-.12.26-.24.3-.12.08-.2.14-.24.18zm-3.96 1.8c.16-.08.46-.3.9-.66.48-.32.86-.54 1.14-.66v-.24c-.12.08-.34.22-.66.42-.32.2-.6.38-.84.54-.2.2-.38.4-.54.6zm1.38-.06c.16 0 .24-.06.24-.18h-.18l-.06.06v.12zm10.44.18c-.08-.2-.14-.3-.18-.3-.12.2-.06.3.18.3zm-10.86-.06c-.04.16-.16.28-.36.36-.2.12-.3.22-.3.3.56-.32.86-.56.9-.72-.04-.04-.12-.02-.24.06zm-1.2.24c0-.04.02-.08.06-.12.08 0 .12-.02.12-.06-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06 0 .16.02.26.06.3zm11.58 0c.04.08.08.1.12.06.08-.04.14-.1.18-.18-.2 0-.3.04-.3.12zm-11.94.12c-.04 0-.06-.02-.06-.06h-.06c-.04.12-.2.24-.48.36-.24.12-.38.24-.42.36.36-.24.6-.36.72-.36 0-.12.04-.2.12-.24.08.08.14.12.18.12v-.18h.18c0-.04-.02-.08-.06-.12l-.12.12zm12.42 0c.08 0 .12-.04.12-.12-.12 0-.16.04-.12.12zm-.6.06c-.04 0-.08.02-.12.06-.08 0-.12.02-.12.06.16 0 .24-.04.24-.12zm.36.24h-.06a.36.36 0 0 0-.24.24c.12.04.2-.04.24-.24h.06zm-.36 0h-.12c-.04 0-.06.02-.06.06.12 0 .18-.02.18-.06zm-.06.6l-.3.24c.12.04.22-.04.3-.24h.06c.12-.12.12-.2 0-.24-.08.08-.1.16-.06.24zm-11.7.06c.12.04.22 0 .3-.12-.08 0-.14.02-.18.06-.04.04-.08.06-.12.06zm10.86.18c0-.12-.04-.18-.12-.18 0 .12.04.18.12.18zm-.12.78c-.12 0-.22.08-.3.24.2-.12.3-.2.3-.24.12.04.2-.02.24-.18 0-.04-.02-.08-.06-.12 0 .08-.04.14-.12.18-.04.04-.06.08-.06.12zm-.84 0l-.06.06h-.06c.08 0 .12-.02.12-.06zm-10.56.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm10.92.3c.08-.2.1-.3.06-.3l-.06.06c-.12.12-.12.2 0 .24zm-.84-.12c-.12 0-.18.02-.18.06.08 0 .14-.02.18-.06zm.06.78c.2-.08.42-.28.66-.6-.24.04-.46.24-.66.6zm-.6-.3c-.04 0-.08-.02-.12-.06-.04-.04-.08-.04-.12 0-.04.08-.02.12.06.12.08.04.16.04.24 0v-.12c0-.12-.02-.18-.06-.18v.24zm1.98-.18v.18l.12-.12c0-.08-.02-.12-.06-.12 0 .08-.02.1-.06.06zm-2.52.42c.04-.04.08-.04.12 0 .04.04.08.06.12.06 0-.16-.08-.24-.24-.24V56zm.9.24c.12 0 .18-.04.18-.12h-.12l-.06.12zm.84 0l-.12.06c.04 0 .08-.02.12-.06zm-2.46.42c-.28.04-.56.12-.84.24-.28.16-.6.36-.96.6-.32.24-.58.4-.78.48.08-.04.16-.06.24-.06.08.04.14.06.18.06.04.04.08.02.12-.06-.12 0-.18-.06-.18-.18.24.04.42-.02.54-.18.16-.12.28-.16.36-.12.12-.24.34-.4.66-.48.32-.04.54-.14.66-.3l.18-.06c.12-.04.16-.12.12-.24-.12-.04-.22-.04-.3 0-.04.08-.04.18 0 .3zm1.2 0c.08-.08.16-.12.24-.12.08.04.12.04.12 0-.04-.08-.12-.12-.24-.12s-.16.08-.12.24zm.66 0c.16.04.28.02.36-.06.04-.04.02-.08-.06-.12-.04.08-.12.12-.24.12l-.06.06zm-.42.36c.2-.08.32-.2.36-.36-.16 0-.28.12-.36.36zm-.84-.06c-.08-.04-.16-.02-.24.06-.04.08-.02.14.06.18 0-.04.04-.06.12-.06.08-.04.1-.1.06-.18.08 0 .12-.06.12-.18-.08 0-.12.06-.12.18zm.12.36c.24.16.42.12.54-.12h-.3c-.12.04-.2.08-.24.12zm-1.8.48v.3l.18-.18c.12-.04.2-.1.24-.18a.255.255 0 0 0-.24 0 .46.46 0 0 1-.18.06zm1.02.24c.08.08.12.04.12-.12l-.12-.12v.24zm-4.38.12c0-.04-.12-.06-.36-.06-.04.12 0 .18.12.18.16 0 .24-.04.24-.12zm1.8-.06c-.04.04-.08.06-.12.06h-.06c.08 0 .14-.02.18-.06zm1.08.24h.12v-.24h-.18c0 .12.02.2.06.24zm-1.62 0c-.16 0-.24.08-.24.24.08.04.12 0 .12-.12.04-.08.08-.12.12-.12.16 0 .26-.06.3-.18-.2 0-.3.06-.3.18zm-3.3.36c.16.28.26.42.3.42-.08 0-.12-.06-.12-.18.52 0 .82-.08.9-.24-.12 0-.2-.02-.24-.06.04-.04.12-.06.24-.06.16 0 .26-.04.3-.12-.2-.04-.46 0-.78.12-.28.12-.48.16-.6.12zm1.56-.18h.12c.04-.04 0-.08-.12-.12-.08-.04-.12-.02-.12.06l.12.06zm3.06.12c.08-.16.08-.24 0-.24 0 .04-.02.08-.06.12-.04.08-.02.12.06.12zm-2.1-.06c-.08.16-.12.28-.12.36l.24-.24.36-.18h-.3a.46.46 0 0 1-.18.06zm1.74.06h.06c.04.04.08.06.12.06-.04-.12-.1-.18-.18-.18v.12zm-2.82.06h.12v-.12h-.12v.12zm3.66 0h.06v-.12h-.06v.12zm-5.28.06c-.76.08-1.22.24-1.38.48.04 0 .1-.02.18-.06a.46.46 0 0 1 .18-.06c.04-.08.14-.14.3-.18.16 0 .26.06.3.18-.04.04-.08.04-.12 0-.04-.04-.08-.06-.12-.06.04.16.16.22.36.18.2 0 .36-.06.48-.18l-.12-.06c-.08 0-.12-.02-.12-.06.04 0 .06-.06.06-.18zm1.02.6c.08-.04.24-.08.48-.12.24 0 .44-.02.6-.06.16-.04.26-.14.3-.3-.76.16-1.22.32-1.38.48zm-.42.06c-.2 0-.3.02-.3.06.2.08.3.06.3-.06zm13.86-13.5c.08 0 .12.06.12.18h-.12v-.18zm0 .24c.08 0 .14.08.18.24v.18c-.12 0-.18-.14-.18-.42zm.12 1.02c.12.08.18.26.18.54.04.24-.02.38-.18.42v-.96zm0 1.32v.3-.3zm-8.4.84l-.18.06a.94.94 0 0 1-.24.18c0-.28.14-.36.42-.24zm3.18 7.32c0-.04.02-.08.06-.12-.04 0-.06.04-.06.12zm18.991-19.68c-.04.16-.08.4-.12.72 0 .28-.02.48-.06.6-.04.12-.12.28-.24.48-.12.16-.3.3-.54.42-.2.52-.5 1-.9 1.44-.4.44-.92.9-1.56 1.38-.64.48-1.08.82-1.32 1.02-.2.04-.5.12-.9.24-.36.12-.68.22-.96.3-.24.04-.54.06-.9.06-.32-.04-.6-.16-.84-.36-.28.36-.62 1.46-1.02 3.3.56.4 1.24.6 2.04.6.84 0 1.56-.1 2.16-.3.64-.2 1.44-.48 2.4-.84.96-.4 1.62-.66 1.98-.78 1.6-.92 3.08-1.66 4.44-2.22.08-.08.2-.16.36-.24.2-.12.32-.2.36-.24.04.16-.04.32-.24.48-.16.12-.4.26-.72.42-.28.16-.46.28-.54.36 0 .04.08.06.24.06-1.44 1.28-3.36 2.34-5.76 3.18.88 0 1.5-.1 1.86-.3-.04.16-.22.32-.54.48 0 .04.04.06.12.06.12 0 .16.04.12.12-.2.08-.44.2-.72.36-.24.16-.44.28-.6.36-.16.08-.3.08-.42 0-.12.04-.18.1-.18.18.04.08.04.16 0 .24-1.8.8-3.4 1.2-4.8 1.2-2.4-.52-3.36-2.52-2.88-6 .6-1.8 1.48-3.48 2.64-5.04 1.16-1.6 2.52-2.78 4.08-3.54.24-.12.88-.18 1.92-.18.16.04.34.14.54.3.2.12.36.18.48.18.08.4.42.9 1.02 1.5zm-4.68 1.08c.08 0 .18-.04.3-.12.12-.12.22-.14.3-.06-1.08.84-1.98 1.72-2.7 2.64 2.36-1.2 4-2.54 4.92-4.02-.12.04-.38.14-.78.3-.36.16-.64.28-.84.36-.16.08-.36.2-.6.36-.24.16-.44.34-.6.54zm-.84 9.54h.18c.08 0 .12.02.12.06.04.04.06.14.06.3.32-.2.58-.2.78 0 .04-.04.04-.1 0-.18 0-.12.04-.18.12-.18.44 0 .94-.18 1.5-.54-.32.16-.82.26-1.5.3-.64.04-1.06.12-1.26.24zm23.82-10.2a4.5 4.5 0 0 0-.84-.48c-.64.28-1.48.82-2.52 1.62-1.04.8-1.84 1.3-2.4 1.5-.12.6-.4.96-.84 1.08-2.48 3.48-4.16 6.08-5.04 7.8-.16 1.32-.82 2.2-1.98 2.64-.68-.32-1.14-.86-1.38-1.62-.28-.8-.4-1.52-.36-2.16.04-.68.18-1.6.42-2.76.2-1.2.32-1.96.36-2.28.2-.4.42-1.16.66-2.28.2-1.12.42-1.88.66-2.28.52.12.92.32 1.2.6.28.24.44.6.48 1.08.04.44.04.8 0 1.08 0 .28-.06.74-.18 1.38-.12.64-.2 1.04-.24 1.2.84-1.28 2.46-3.16 4.86-5.64.64-.52 1.38-.98 2.22-1.38.88-.4 1.8-.56 2.76-.48 1 .04 1.72.5 2.16 1.38zm-4.44-.42c.16.04.3.02.42-.06.12-.12.22-.16.3-.12-.08-.16-.02-.24.18-.24.24-.04.36-.12.36-.24-.48.12-.8.16-.96.12-3.12 1.84-5.7 4.64-7.74 8.4 2.52-3.64 5-6.26 7.44-7.86zm1.74-.06c0 .08-.04.16-.12.24.36-.08.56-.2.6-.36-.24.08-.4.12-.48.12zm-.6.54c.08 0 .22-.1.42-.3a.3.3 0 0 0-.36 0c-.12.04-.14.14-.06.3zm-1.68.9c.16 0 .38-.12.66-.36.32-.24.56-.36.72-.36 0-.04.02-.12.06-.24v-.06c0-.04-.04-.06-.12-.06-.12.16-.34.36-.66.6-.32.2-.54.36-.66.48zm-.48.48c.32-.2.48-.34.48-.42-.04.04-.12.08-.24.12-.12.04-.2.08-.24.12-.04.04-.04.1 0 .18zm-.78 1.02l.24-.24c.16-.16.24-.3.24-.42h-.18c0 .12-.08.24-.24.36-.12.12-.14.22-.06.3zm-.6.48c0-.04.02-.06.06-.06 0-.12-.04-.16-.12-.12 0 .12.02.18.06.18zm2.4-3.36v-.06.06zm9.225-8.88c.36.64.42 1.3.18 1.98-.2.64-.62 1.06-1.26 1.26-1.08-.4-1.68-.92-1.8-1.56.16-.12.4-.36.72-.72.36-.36.7-.62 1.02-.78.32-.16.7-.22 1.14-.18zm1.5 18.18v.12c-.48.24-.82.44-1.02.6.44.08.78-.12 1.02-.6.36-.04 1.24-.52 2.64-1.44.28-.08.66-.3 1.14-.66.52-.36.96-.6 1.32-.72.44-.36 1.62-1.12 3.54-2.28 0 .04-.04.12-.12.24-.08.12-.1.24-.06.36-.8.12-1.42.52-1.86 1.2-.68.32-1.4.72-2.16 1.2-.76.48-1.6 1.02-2.52 1.62-.92.6-1.64 1.06-2.16 1.38-.12 0-.18.04-.18.12.12 0 .18-.04.18-.12 1.72-.96 2.62-1.48 2.7-1.56.48-.24 1.24-.7 2.28-1.38 1.04-.72 1.66-1.14 1.86-1.26.16.04.28 0 .36-.12.12-.12.24-.18.36-.18.04.08.02.16-.06.24-.08.04-.1.1-.06.18-.4 0-.6.1-.6.3l-.06.06c-.04.04-.1.08-.18.12-.04.04-.08.06-.12.06 0 .16.08.22.24.18-.04.08-.16.12-.36.12.04.2-.04.4-.24.6-.16 0-.26-.08-.3-.24 0-.12.08-.18.24-.18-.2-.12-.44.02-.72.42-.28.36-.52.54-.72.54l.12.18c.12.12.12.2 0 .24-.28 0-.4-.08-.36-.24-.04 0-.08.04-.12.12 0 .08-.04.1-.12.06 0 .08.04.12.12.12.12 0 .16.06.12.18-.12.08-.22.08-.3 0a.407.407 0 0 0-.3-.12c-.04.12-.02.2.06.24.04.04.06.08.06.12-.08.04-.16.02-.24-.06-.04-.08-.1-.1-.18-.06-.04.08-.02.14.06.18.08 0 .12.02.12.06-.92.84-1.8 1.46-2.64 1.86-.04 0-.06.1-.06.3-.36 0-.58.2-.66.6-1.04.8-2.24 1.34-3.6 1.62-1.32.32-2.58.22-3.78-.3-1.24-.48-2.04-1.44-2.4-2.88-.04-.68.06-1.62.3-2.82.16-.44.42-1.24.78-2.4.36-1.16.74-2.1 1.14-2.82.36-.72.86-1.32 1.5-1.8 1.08.12 1.74.76 1.98 1.92-.24.08-.44.12-.6.12-1.4 2.4-2.28 4.76-2.64 7.08-.28.36-.34 1.04-.18 2.04 1.56.24 3.82-.46 6.78-2.1 0-.04-.02-.08-.06-.12-.04-.08-.04-.14 0-.18.4-.08.64-.1.72-.06zm-.9 1.38c.12 0 .2-.02.24-.06.08-.04.1-.1.06-.18-.12 0-.22.08-.3.24zm9.72-6.36c.2 0 .3-.04.3-.12h.18c0-.12-.06-.18-.18-.18.04-.04.14-.12.3-.24.16-.16.26-.32.3-.48-.88.4-2.12 1.14-3.72 2.22-1.6 1.04-2.82 1.74-3.66 2.1 0 .08.06.16.18.24-.28.08-.62.28-1.02.6-.4.28-.74.46-1.02.54 0-.08-.02-.12-.06-.12 4.24-3 7.72-5.12 10.44-6.36 0 .04-.08.1-.24.18-.16.08-.24.14-.24.18 0 .08.06.08.18 0s.22-.1.3-.06c-.12.12-.32.34-.6.66-.24.28-.48.52-.72.72-.2.16-.46.28-.78.36 0-.04.02-.08.06-.12.04-.04.04-.08 0-.12zm.96-1.02c.2 0 .3-.06.3-.18-.2 0-.3.06-.3.18zm-.66.9c-.16 0-.26.04-.3.12h-.18c.04-.08.1-.14.18-.18.08-.04.14-.08.18-.12 0 .04.02.08.06.12.04 0 .06.02.06.06zm-.48.9c0 .04-.1.1-.3.18 0-.12.1-.18.3-.18zm-1.14.66c.04-.28.3-.42.78-.42-.16.2-.42.34-.78.42zm-.18.06c0-.04.06-.06.18-.06-.04.04-.1.06-.18.06zm-.72.72h.18v.24c-.2 0-.28-.06-.24-.18.04 0 .06-.02.06-.06zm-1.38 1.26c.08-.16.2-.16.36 0-.04.08-.16.08-.36 0zm-2.7.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm2.52 0c.2.08.2.2 0 .36-.16.12-.28.14-.36.06 0-.04.04-.1.12-.18.12-.08.2-.16.24-.24zm-2.46.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm-2.46.96h.24c0 .04-.02.1-.06.18-.04.04-.02.06.06.06-.08.08-.16 0-.24-.24zm18.83-8.88c-.04.16-.08.4-.12.72 0 .28-.02.48-.06.6-.04.12-.12.28-.24.48-.12.16-.3.3-.54.42-.2.52-.5 1-.9 1.44-.4.44-.92.9-1.56 1.38-.64.48-1.08.82-1.32 1.02-.2.04-.5.12-.9.24-.36.12-.68.22-.96.3-.24.04-.54.06-.9.06-.32-.04-.6-.16-.84-.36-.28.36-.62 1.46-1.02 3.3.56.4 1.24.6 2.04.6.84 0 1.56-.1 2.16-.3.64-.2 1.44-.48 2.4-.84.96-.4 1.62-.66 1.98-.78 1.6-.92 3.08-1.66 4.44-2.22.08-.08.2-.16.36-.24.2-.12.32-.2.36-.24.04.16-.04.32-.24.48-.16.12-.4.26-.72.42-.28.16-.46.28-.54.36 0 .04.08.06.24.06-1.44 1.28-3.36 2.34-5.76 3.18.88 0 1.5-.1 1.86-.3-.04.16-.22.32-.54.48 0 .04.04.06.12.06.12 0 .16.04.12.12-.2.08-.44.2-.72.36-.24.16-.44.28-.6.36-.16.08-.3.08-.42 0-.12.04-.18.1-.18.18.04.08.04.16 0 .24-1.8.8-3.4 1.2-4.8 1.2-2.4-.52-3.36-2.52-2.88-6 .6-1.8 1.48-3.48 2.64-5.04 1.16-1.6 2.52-2.78 4.08-3.54.24-.12.88-.18 1.92-.18.16.04.34.14.54.3.2.12.36.18.48.18.08.4.42.9 1.02 1.5zm-4.68 1.08c.08 0 .18-.04.3-.12.12-.12.22-.14.3-.06-1.08.84-1.98 1.72-2.7 2.64 2.36-1.2 4-2.54 4.92-4.02-.12.04-.38.14-.78.3-.36.16-.64.28-.84.36-.16.08-.36.2-.6.36-.24.16-.44.34-.6.54zm-.84 9.54h.18c.08 0 .12.02.12.06.04.04.06.14.06.3.32-.2.58-.2.78 0 .04-.04.04-.1 0-.18 0-.12.04-.18.12-.18.44 0 .94-.18 1.5-.54-.32.16-.82.26-1.5.3-.64.04-1.06.12-1.26.24zm21.66-4.86c0 .12.04.18.12.18h.06c0-.04.02-.06.06-.06.04-.08-.04-.12-.24-.12.56-.52 1.4-1.22 2.52-2.1 1.16-.92 1.98-1.6 2.46-2.04.08.16.18.24.3.24-.32 1.16-.84 1.9-1.56 2.22-.04.12 0 .16.12.12h.12c-.36.56-.66.8-.9.72-.08.04-.1.08-.06.12.04.08.06.14.06.18-.68.24-1.12.6-1.32 1.08-.24 0-.5.08-.78.24-.24.16-.5.36-.78.6s-.5.4-.66.48c.2.12.42.04.66-.24.28-.28.54-.42.78-.42.04.08.02.14-.06.18-.04.04-.06.08-.06.12.04 0 .1-.04.18-.12.08-.08.18-.1.3-.06 0-.04-.04-.12-.12-.24-.04-.12-.02-.2.06-.24.2.08.42.02.66-.18.24-.2.44-.3.6-.3v.42c-.12 0-.28.08-.48.24-.16.12-.3.14-.42.06 0 .16.04.24.12.24-.52.56-1.42 1.26-2.7 2.1-1.24.84-2 1.38-2.28 1.62-.04 0-.06-.02-.06-.06l-.06-.12c-.72.64-1.96 1.58-3.72 2.82-1.76 1.28-3.04 2.32-3.84 3.12.04.36.22 1.6.54 3.72.36 2.12.46 3.78.3 4.98-.24 1.04-.74 2.14-1.5 3.3-2.04 1.72-3.88 2.3-5.52 1.74-1.32-.76-2.3-2.34-2.94-4.74-.16-1-.16-1.72 0-2.16.44-1.12 1.1-2.28 1.98-3.48.84-1.16 1.5-2 1.98-2.52l2.76-2.76c0-.2-.02-.52-.06-.96-.04-.44-.04-.78 0-1.02h.24c-.08-.96-.1-1.66-.06-2.1 0-.48.04-1.26.12-2.34.08-1.08.12-1.96.12-2.64.16-.32.38-.8.66-1.44.24-.68.46-1.2.66-1.56.16-.4.4-.82.72-1.26.32-.44.7-.8 1.14-1.08 1.64.68 2.32 1.5 2.04 2.46-.48-.04-.98.16-1.5.6-.88 1.76-1.46 3.4-1.74 4.92-.24 1.52-.26 3.26-.06 5.22.48-.32 1.58-1.08 3.3-2.28 1.72-1.24 3.04-2.12 3.96-2.64 0-.04-.02-.08-.06-.12-.04-.04-.04-.08 0-.12.16-.04.42-.2.78-.48.36-.32.72-.5 1.08-.54V44c.08.08.1.16.06.24.08-.04.32-.26.72-.66.44-.44.84-.72 1.2-.84zm4.14-2.82c-.04-.08-.04-.14 0-.18.08-.08.12-.14.12-.18-.12-.04-.2 0-.24.12-.04.12 0 .2.12.24zm-.24.54c.08 0 .14-.06.18-.18 0 .04-.04.08-.12.12-.08 0-.1.02-.06.06zm-.48.3c0 .12.02.2.06.24-.28.08-.54.3-.78.66.16-.04.32-.12.48-.24.16-.12.3-.26.42-.42l.18-.3c-.04-.08-.12-.08-.24 0-.04.04-.08.06-.12.06zm-1.02.3c-.4.24-.66.46-.78.66.4-.24.66-.46.78-.66.08.04.14.02.18-.06.04-.08.02-.14-.06-.18 0 .04-.02.08-.06.12-.04.04-.06.08-.06.12zm-.6 1.38c0-.08.06-.1.18-.06.16.04.28.06.36.06l-.12-.18c0-.04.02-.1.06-.18.08-.08.12-.16.12-.24-.48.24-.68.44-.6.6zm-1.26.06c.08 0 .14-.02.18-.06.08-.04.14-.08.18-.12l.18-.18c-.04-.04-.14 0-.3.12a.68.68 0 0 0-.24.24zm.72.12c.04 0 .08.06.12.18.08.08.16.1.24.06 0-.04-.1-.16-.3-.36 0 .04-.02.06-.06.06v.06zm-1.02.84c.12 0 .28-.08.48-.24.24-.2.42-.22.54-.06.04-.64-.2-.66-.72-.06-.16.16-.26.28-.3.36zm-.72-.24c.08 0 .16-.04.24-.12-.16 0-.24.04-.24.12zm.12.72c-.28 0-.46.14-.54.42-.52.04-1.06.34-1.62.9.08.04.16.06.24.06.12-.04.2-.02.24.06.12-.44.48-.72 1.08-.84-.2.48-.66.96-1.38 1.44-.72.48-1.2.88-1.44 1.2 1.36-.84 2.22-1.44 2.58-1.8-.12-.08-.22-.06-.3.06.04-.04.16-.08.36-.12.2-.08.36-.16.48-.24.12-.08.16-.18.12-.3-.04.16-.12.18-.24.06-.04-.04-.06-.1-.06-.18.4-.36.56-.6.48-.72.08 0 .18-.04.3-.12.12-.12.22-.16.3-.12 0-.12-.04-.18-.12-.18-.08-.04-.18-.02-.3.06l-.24.12v.12c.04.04.06.08.06.12zm-2.7 1.08c.04 0 .18-.12.42-.36-.28.08-.42.2-.42.36zm1.44.06h.12v-.12h-.12v.12zm-1.32.54c.12 0 .22-.02.3-.06.08-.04.1-.12.06-.24-.24 0-.36.1-.36.3zm-5.88 5.04c.12-.04.24-.16.36-.36.12-.16.22-.26.3-.3 0 .04-.04.1-.12.18-.04.08 0 .12.12.12 0-.04.04-.08.12-.12.08-.04.1-.1.06-.18h-.18c.04-.04.04-.1 0-.18a.987.987 0 0 1-.06-.3c0-.08.08-.12.24-.12.04.04.02.16-.06.36.2-.08.3-.08.3 0 0 .04-.02.1-.06.18.2-.08.46-.26.78-.54.36-.28.64-.46.84-.54 0-.08-.08-.14-.24-.18-.12-.08-.18-.14-.18-.18.16-.24.32-.36.48-.36 0 .04-.06.12-.18.24-.08.08-.06.14.06.18.28.04.58-.08.9-.36.36-.32.64-.5.84-.54-.04-.08-.02-.2.06-.36.08-.16.12-.3.12-.42.16-.04.4-.18.72-.42.32-.24.52-.44.6-.6-.04.12-.12.12-.24 0 0-.04.04-.08.12-.12.12 0 .16-.04.12-.12-.72.36-1.12.64-1.2.84 0 .04.02.06.06.06.08 0 .12.02.12.06-.24.12-.38.18-.42.18-.16-.12-.46-.04-.9.24-.44.24-.74.5-.9.78.24 0 .36.02.36.06-.04 0-.08.02-.12.06-.04.04-.08.06-.12.06-.2-.12-.36-.16-.48-.12-.04.04-.1.14-.18.3-.08.24-.16.32-.24.24 0-.04.02-.06.06-.06.08-.04.1-.1.06-.18-1.16.64-1.64 1.12-1.44 1.44-.44-.16-.8-.08-1.08.24-.24.32-.36.74-.36 1.26.08 0 .16-.04.24-.12 0-.16.06-.22.18-.18 0 .2.04.3.12.3.2-.2.34-.3.42-.3v-.12zm-4.26.84c.08-.44.04-.9-.12-1.38v.66c0 .36.04.6.12.72zm2.82-.96h.12v-.12h-.12v.12zm-.66.3c0 .16.04.34.12.54.12.2.1.34-.06.42.16-.04.24.02.24.18.64-.28 1-.58 1.08-.9-.16.16-.28.26-.36.3 0-.32-.06-.54-.18-.66-.04.04-.04.1 0 .18.04.12.02.2-.06.24l-.06-.06h-.12c.04.04.04.12 0 .24s-.1.18-.18.18c0-.04-.04-.1-.12-.18a.533.533 0 0 1-.06-.24l.36-.54c-.12.04-.24.1-.36.18-.08.08-.16.12-.24.12zm-2.88 1.98c-.12-.04-.22.02-.3.18.08 0 .18-.06.3-.18.12 0 .22-.08.3-.24-.12 0-.22.08-.3.24zm-.6.6l.06-.06c.08-.04.12-.08.12-.12h-.24c0 .12.02.18.06.18zm-1.14.84v.12h.24v-.24h-.18c0 .08-.02.12-.06.12zm-.78 1.14h.12c0 .04.04.06.12.06-.04-.12.02-.26.18-.42.12-.12.18-.22.18-.3-.36.12-.56.34-.6.66zm-1.56 9c.16.12.32.2.48.24.16.08.36.1.6.06.2 0 .38-.02.54-.06.12 0 .32-.06.6-.18.28-.08.46-.14.54-.18.08-.04.26-.12.54-.24l.48-.24c1.08-.8 1.76-2.12 2.04-3.96.28-1.84.18-3.5-.3-4.98 0-.04-.02-.06-.06-.06l-.9.9-.96.96c-.16.2-.44.52-.84.96-.44.48-.74.86-.9 1.14-.2.28-.44.66-.72 1.14-.28.52-.48.98-.6 1.38-.12.44-.24.92-.36 1.44-.12.56-.18 1.12-.18 1.68zm.54-7.8c.6-.28.84-.62.72-1.02-.04.12-.16.28-.36.48-.2.2-.32.38-.36.54zm-.78 1.14c.2-.04.34-.22.42-.54-.08 0-.14.02-.18.06-.08.08-.12.16-.12.24-.04.12-.08.2-.12.24zm-.3.24c.16.04.18.1.06.18-.08.04-.12.1-.12.18.16 0 .28-.16.36-.48-.2-.08-.3-.04-.3.12zm-.18.66c.12 0 .18-.06.18-.18-.12.16-.18.22-.18.18zm-.36.66c.04 0 .08-.02.12-.06.04-.16.02-.26-.06-.3 0 .04-.02.1-.06.18-.04.08-.04.14 0 .18zm23.1-17.52l-.42.42c-.04-.12-.04-.2 0-.24.04-.04.1-.06.18-.06.12-.04.2-.08.24-.12zm-.42.6c-.08.36-.42.62-1.02.78-.12-.32.1-.56.66-.72h.24c.04-.04.08-.06.12-.06zm-8.16 4.74c0 .08-.06.14-.18.18l-.24.12c-.08.04-.08.1 0 .18 0 .04-.06.08-.18.12-.08 0-.1.04-.06.12a.698.698 0 0 0-.12-.18c0-.08.06-.16.18-.24.12-.08.22-.14.3-.18.08-.04.18-.08.3-.12zm-2.16.84h.12v.18h-.12v-.18zm-.72.66c-.08.2-.34.44-.78.72.16-.28.42-.52.78-.72zm.24.6c-.08.08-.16.12-.24.12-.04-.08.04-.12.24-.12zm-1.56.72c.04-.04.08-.02.12.06v.12a.46.46 0 0 0-.18-.06c-.04.04-.08.04-.12 0 0-.04.02-.06.06-.06.08 0 .12-.02.12-.06zm-.84.42v-.24c.16 0 .2.1.12.3-.04 0-.06-.02-.06-.06h-.06zm.66.3c-.4-.12-.48-.28-.24-.48.16.04.24.2.24.48zm-.66-.3l-.06.06v.12c-.04 0-.08-.02-.12-.06.08-.04.14-.08.18-.12z"
  }), __jsx("path", {
    d: "M16.212 53.9h.12-.12a.36.36 0 0 0-.24.24c0 .04.04.06.12.06.16-.04.22-.02.18.06-.04.04-.22.18-.54.42-.32.24-.46.48-.42.72a.255.255 0 0 0-.24 0l-.18.06c0 .08-.02.14-.06.18 0 .08-.02.16-.06.24a.46.46 0 0 0-.06.18l-.12-.12c.04-.08.04-.12 0-.12s-.14.1-.3.3c-.16.24-.34.34-.54.3-.04.04-.06.1-.06.18.04.08.02.12-.06.12v-.06.06c-.12.24-.38.38-.78.42 0 .16-.06.26-.18.3a.76.76 0 0 1-.36.18c-.16.08-.26.12-.3.12-.12 0-.18-.1-.18-.3 0 .04-.12.12-.36.24.04.12.1.16.18.12.12-.04.2-.04.24 0-.04.08-.12.14-.24.18-.12.08-.2.1-.24.06 0 .16.04.24.12.24l-.96.48c-.48.24-.9.42-1.26.54-.04 0-.1.04-.18.12-.04.08-.08.12-.12.12-.04.04-.12.06-.24.06-.08.04-.14.04-.18 0-1.12.76-2.8 1.18-5.04 1.26-1.08-.2-1.82-.82-2.22-1.86-.4-1.04-.46-2.24-.18-3.6.2-.64.46-1.22.78-1.74s.74-1.02 1.26-1.5c.56-.44 1.02-.8 1.38-1.08.36-.24.94-.6 1.74-1.08.8-.44 1.32-.74 1.56-.9 2.08-.8 3.4-1.22 3.96-1.26-.04.16-.04.26 0 .3.08.04.2.04.36 0-.4.4-.62.68-.66.84-1 .16-1.92.62-2.76 1.38.04.08.12.08.24 0 .12-.04.24-.02.36.06.24 0 .32-.1.24-.3 0-.08-.04-.12-.12-.12.04 0 .12-.08.24-.24.16-.16.3-.22.42-.18 0 .08-.06.18-.18.3-.12.08-.18.18-.18.3 0 .04.02.04.06 0 .08-.04.16-.04.24 0-.44.32-.7.5-.78.54 0 .12.06.14.18.06.16-.08.26-.12.3-.12 0 .12-.04.2-.12.24-.08.08-.22.14-.42.18-.16.04-.26.06-.3.06-.16.24-.5.5-1.02.78-.52.32-.86.62-1.02.9-.16 0-.32.06-.48.18-.16.12-.28.18-.36.18.04.08 0 .14-.12.18-.08.08-.12.16-.12.24-1.44.84-2.62 2.08-3.54 3.72.04 0 .06.12.06.36.2.2.44.34.72.42.28.08.56.12.84.12.28.04.62.02 1.02-.06.44-.04.76-.08.96-.12.24-.04.56-.12.96-.24.44-.12.7-.18.78-.18 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12.08.04.12.08.12.12-.04.08-.04.14 0 .18.68-.52 1.34-.84 1.98-.96.64-.48 1.2-.8 1.68-.96 1.04-.76 2.5-2.04 4.38-3.84.6-1.04 1.02-1.64 1.26-1.8.64-1.28.96-2.52.96-3.72-.08-.64-.26-1.2-.54-1.68-.24-.52-.58-1.04-1.02-1.56-.44-.52-.74-.92-.9-1.2 0-.04-.04-.04-.12 0-.08 0-.12-.02-.12-.06-.72-.84-2.12-1.96-4.2-3.36-.04 0-.1-.04-.18-.12-.04-.12-.1-.2-.18-.24 0-.04-.08-.06-.24-.06a.753.753 0 0 1-.3-.18c-.04 0-.06-.02-.06-.06l-.06-.12c-.2-.16-.62-.36-1.26-.6-1.44-1-2.74-1.82-3.9-2.46-.2-.2-.54-.46-1.02-.78-.44-.32-.82-.62-1.14-.9-.28-.32-.5-.66-.66-1.02-.48-.32-.84-.84-1.08-1.56-.8-2.64.18-5.16 2.94-7.56 0-.08.04-.2.12-.36.12 0 .26-.08.42-.24.16-.16.32-.24.48-.24.2-.44.66-.8 1.38-1.08.08 0 .1-.02.06-.06a.46.46 0 0 1-.06-.18c.2-.08.56-.3 1.08-.66.52-.36.96-.58 1.32-.66.04-.16.18-.3.42-.42.28-.16.48-.22.6-.18.56-.44 1.2-.86 1.92-1.26s1.58-.84 2.58-1.32c1.04-.48 1.78-.84 2.22-1.08.04 0 .08-.02.12-.06v-.06c3.72-1.48 6.16-2.4 7.32-2.76v-.24c.36.04.86-.04 1.5-.24.64-.24 1.08-.36 1.32-.36 1-.44 2.14-.74 3.42-.9 1.28-.16 2.5-.06 3.66.3.2.28.3.44.3.48.24.04.44.24.6.6.2.36.34.58.42.66.76.92.96 1.76.6 2.52-.04.04-.1.12-.18.24l-.18.18c-.32.04-.84.34-1.56.9 0-.04-.14-.06-.42-.06.44-1.36.68-2.28.72-2.76-.72-.24-1.64-.32-2.76-.24-1.08.08-1.92.18-2.52.3-.56.12-1.36.32-2.4.6-1.04.24-1.84.42-2.4.54-.16.12-.42.26-.78.42-.36.12-.6.22-.72.3-.08 0-.14-.02-.18-.06-.04-.04-.08-.06-.12-.06v.24c-.44.08-1.38.4-2.82.96 0 .04-.04.06-.12.06h-.18c-.08-.04-.14-.04-.18 0-.24.32-.7.58-1.38.78-.68.16-1.12.38-1.32.66-.04 0-.06-.06-.06-.18-.04 0-.08.06-.12.18 0 .08-.04.14-.12.18a.805.805 0 0 0-.66.18c-.16.16-.26.24-.3.24-.08.08-.2.12-.36.12-.16 0-.26.02-.3.06-.12.04-.32.16-.6.36-.28.2-.52.3-.72.3 0 .12-.1.24-.3.36l-.6.3c-.24.12-.42.22-.54.3-.32.32-.78.54-1.38.66-.08.04-.1.08-.06.12.04.08.06.14.06.18-.76.24-1.66.74-2.7 1.5-1.04.76-1.7 1.22-1.98 1.38v.12c0 .04.02.04.06 0 0 .2-.08.22-.24.06-.28.2-.64.54-1.08 1.02-.44.44-.76.74-.96.9-.04.08-.04.14 0 .18.04.04.06.08.06.12-1.12.88-1.56 1.9-1.32 3.06.04.12.14.28.3.48.16.2.26.38.3.54.36.2.9.6 1.62 1.2.76.56 1.4.92 1.92 1.08.28.36.54.56.78.6v.18c.16 0 .28.02.36.06.08.08.18.12.3.12.08.16.12.28.12.36.36.04.86.28 1.5.72.64.4 1.12.66 1.44.78.28.32.88.8 1.8 1.44.96.64 1.62 1.22 1.98 1.74 2.16 1.68 3.62 3.92 4.38 6.72-.08-.04-.14-.18-.18-.42 0-.28-.04-.44-.12-.48.2.96.3 2.6.3 4.92-.12.4-.32.84-.6 1.32-.28.52-.44.92-.48 1.2-.12 0-.22.04-.3.12-.04.2-.2.42-.48.66-.24.28-.36.52-.36.72-.04 0-.12.04-.24.12-.16.12-.26.1-.3-.06zm5.1-39.96c0-.04-.04-.06-.12-.06-.04 0-.06.02-.06.06h.18zm-.9.24c-.04.04-.08.06-.12.06h-.06c.12 0 .18-.02.18-.06zm-1.02.36c.04 0 .08.02.12.06.08.04.12.02.12-.06-.16-.04-.24-.04-.24 0zm-.9.48c.04-.04.1-.06.18-.06h.18c.08-.04.12-.1.12-.18-.32 0-.48.08-.48.24zm-.54.12c-.04-.04-.08-.06-.12-.06l.12.06zm-.6.3h.18v-.12h-.18v.12zm-.42.18c.24-.04.36-.1.36-.18-.2 0-.32.06-.36.18zm-.9.3c-.04.12-.16.22-.36.3-.16.04-.26.1-.3.18l.06.06c.04.04.08.06.12.06.04-.08.16-.16.36-.24.2-.08.36-.14.48-.18.12-.08.12-.18 0-.3.04.08 0 .14-.12.18-.08.04-.16.02-.24-.06zm-.9.54l-.06.06h-.06c.08 0 .12-.02.12-.06zm-1.32.42c-.04.12.14.18.54.18-.04-.04-.06-.1-.06-.18 0-.12-.04-.18-.12-.18 0 .12-.12.18-.36.18zm.96.42c.04.04.08.02.12-.06 0-.16-.02-.24-.06-.24 0 .04-.02.08-.06.12v.18zm-.48.24c0-.04.02-.06.06-.06.08 0 .12-.04.12-.12-.04-.04-.1.02-.18.18zm2.34.12c.12.04.2 0 .24-.12 0-.04.02-.08.06-.12-.2.08-.3.16-.3.24zm-4.26.12c.4.12.68.02.84-.3-.44.08-.72.18-.84.3zm-.3.12h.18c0-.08-.06-.12-.18-.12v.12zm1.32 0c-.32 0-.5.1-.54.3.28-.08.46-.18.54-.3zm-2.16.48c.04.08.12.12.24.12.16-.04.26-.12.3-.24-.08-.2-.26-.16-.54.12zm2.64-.18c-.2 0-.3.02-.3.06.04.04.08.06.12.06.08 0 .14-.04.18-.12zm.9.12c.04 0 .08.02.12.06h.12c.16-.08.26-.14.3-.18l-.54.12zm-2.16.06c.04 0 .1-.04.18-.12-.12 0-.18.04-.18.12zm-1.56 0v.18c.04.04.08.02.12-.06.04-.12.02-.18-.06-.18 0 .08-.02.1-.06.06zm-.54.3c0 .04.04.08.12.12.12 0 .18.02.18.06-.04.04-.16.06-.36.06-.16-.04-.24 0-.24.12.32.12.52.06.6-.18 0-.12-.06-.22-.18-.3l-.12.12zm.54 0c0-.08-.06-.12-.18-.12a.46.46 0 0 0-.06.18c.04 0 .12-.02.24-.06zm.42.24c-.16 0-.28.04-.36.12 0 .04.12 0 .36-.12.08 0 .16-.04.24-.12l.18-.12c-.08-.04-.14-.04-.18 0 0 .04-.04.1-.12.18-.04.04-.08.06-.12.06zm2.16-.06c.16 0 .22-.06.18-.18h-.12c0 .04-.02.08-.06.12v.06zm-4.62.72c0 .12.06.22.18.3.04-.16.06-.26.06-.3l.72-.24c-.04-.08-.02-.14.06-.18.08-.08.12-.14.12-.18-.12.04-.3.14-.54.3-.2.16-.4.26-.6.3zm3.42-.36h.12v-.18h-.12v.18zm-1.62.12v-.18.18zm1.92-.06c-.04.16.04.24.24.24-.12-.16-.2-.24-.24-.24zm-2.22.24h.06l.06.06c0-.16-.04-.24-.12-.24v.18zm1.32-.12v.06l-.06.06c.04-.04.06-.08.06-.12zm-1.62.18c-.24.08-.42.22-.54.42.24-.08.42-.22.54-.42zm1.98 0c.16 0 .26-.02.3-.06-.2-.08-.3-.06-.3.06zm-1.26.18c.04 0 .08.02.12.06h.18c.04-.12-.02-.18-.18-.18-.04 0-.08.04-.12.12zm-2.76.48c.12-.04.26-.06.42-.06.16-.04.26-.06.3-.06 0-.12-.04-.22-.12-.3-.08-.04-.14-.02-.18.06.08.08.04.12-.12.12-.2.08-.3.16-.3.24zm3.12-.24c.32 0 .5-.06.54-.18-.04 0-.1.02-.18.06-.2 0-.32.04-.36.12zm.96-.18c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.56.66c.12-.04.18-.12.18-.24l-.06.06v-.12c0 .12-.04.22-.12.3zm-2.7-.24c-.24.08-.36.18-.36.3.08-.04.12-.02.12.06h.3c0-.04-.02-.1-.06-.18-.04-.04-.04-.1 0-.18zm.84.3c.12-.12.18-.2.18-.24-.16.08-.22.16-.18.24zm1.02.06c.04 0 .06-.04.06-.12l-.06.12zm.6 0h-.18.18zm-1.92 0c-.28.08-.54.24-.78.48.16.04.42-.12.78-.48zm-1.26.24c-.08-.08-.14-.12-.18-.12 0 .08-.04.12-.12.12-.08-.04-.14-.02-.18.06.16.12.32.14.48.06.2-.08.34-.2.42-.36h-.3c0 .16-.04.24-.12.24zm-.66.42c.08-.04.18-.04.3 0v-.06c-.04-.08-.08-.12-.12-.12 0 .04-.04.06-.12.06h-.06v.12zm2.34-.18c-.04 0-.06.02-.06.06.04 0 .06-.02.06-.06zm-2.16.6c.56-.2.88-.38.96-.54-.08.04-.4.22-.96.54zm1.62-.18h-.12.12zm-2.46.18h.12v-.12h-.12v.12zm.18.48c.28-.04.5-.18.66-.42h-.36c0 .08-.02.14-.06.18-.04 0-.1.02-.18.06-.04.04-.06.1-.06.18zm-.78-.12c.04.16-.06.28-.3.36.08 0 .2-.04.36-.12.24-.08.36-.06.36.06v.12c.12 0 .22-.08.3-.24-.08 0-.16-.06-.24-.18-.04-.12-.08-.18-.12-.18 0 .12-.02.2-.06.24l-.06-.06h-.24zm2.22-.12l-.12.06c-.04 0-.06.02-.06.06h.06l.12-.12zm.36.18c.04.08.1.12.18.12.08-.04.12-.1.12-.18-.2 0-.3.02-.3.06zm-.06-.06c-.08 0-.12.02-.12.06.04 0 .08-.02.12-.06zm-1.08.48h.18v-.06h-.18v.06zm-2.1.12h.12l.06-.06v-.06h-.06c-.04-.04-.08-.06-.12-.06v.18zm1.02-.18c-.08 0-.14.02-.18.06.12 0 .18-.02.18-.06zm1.38.18h.18v-.12h-.18v.12zm-.84.06l.24-.12c-.16 0-.24.04-.24.12zm-2.1.96c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm.54.3l-.06-.06c-.04-.04-.08-.06-.12-.06-.04.08.02.12.18.12zm-.18.72c.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12 0 .16.06.24.18.24zm-.36.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.8 1.38c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18l-.12.24zm.12.84c-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06-.04.08-.02.14.06.18.12.04.18.02.18-.06zm3.66 7.62h.18v-.12h-.18v.12zm3.72 1.14h.12v-.06h-.12v.06zm.42.12c.04-.08-.02-.12-.18-.12-.04.04-.04.08 0 .12.04.04.1.04.18 0zm-1.38.18h.06v-.18h-.06v.18zm.78.36c0-.16-.1-.24-.3-.24-.04.08 0 .14.12.18.12 0 .18.02.18.06zm1.86.36h.12v-.06h-.12v.06zm-.66.48c.08-.12.1-.2.06-.24h-.12c0 .12.02.2.06.24zm-.54-.12l-.12.12.12-.12zm.78.48c0-.04.04-.08.12-.12.08-.04.1-.1.06-.18a.46.46 0 0 1-.18-.06c0 .04-.02.1-.06.18-.04.08-.02.14.06.18zm1.56-.18l-.18.06c-.04.08-.04.12 0 .12.08-.04.14-.1.18-.18zm.12.3h.06v-.12h-.06v.12zm-.18.72h.12v-.12h-.12v.12zm.6.42a.68.68 0 0 0-.24-.24l-.18-.18c.04.24.18.38.42.42zm.18.12h.12v-.06c.04 0 .06-.02.06-.06h-.24c-.04.04-.02.08.06.12zm1.08.84c.12.16.64.66 1.56 1.5-.28-.6-.8-1.1-1.56-1.5l-.3-.3c-.12-.16-.22-.26-.3-.3-.08-.08-.18-.08-.3 0 .12.04.26.16.42.36.16.16.32.24.48.24zm2.1 1.98c-.04-.16-.16-.28-.36-.36.08.2.2.32.36.36zm-5.4 6.36c.24 0 .36-.04.36-.12-.16 0-.28.04-.36.12zm-.48.36c-.32.12-.48.22-.48.3.04-.04.1-.06.18-.06.08-.04.14-.08.18-.12.08-.04.12-.08.12-.12h.12v-.24c-.08 0-.12.08-.12.24zm-.72.36h.18v-.18h-.18v.18zm-.66.36c.32-.08.5-.16.54-.24l-.06-.06c-.04-.04-.1-.04-.18 0 .04.08 0 .14-.12.18-.12.04-.18.08-.18.12zm-.48.18h-.42l-.06.12c0 .08-.02.12-.06.12-.08-.04-.18-.02-.3.06-.08.04-.16.02-.24-.06.04.08.02.14-.06.18-.04.04-.06.08-.06.12h.12c.08.04.16.06.24.06 0-.04.12-.12.36-.24s.4-.24.48-.36zm-1.86.6c-.12.24-.16.34-.12.3-.04.08-.1.06-.18-.06 0 .04-.04.1-.12.18-.16.2-.2.34-.12.42.08-.04.18-.06.3-.06.04-.16.1-.28.18-.36.08-.08.2-.16.36-.24.2-.04.32-.06.36-.06-.04 0-.08-.02-.12-.06 0-.04-.02-.06-.06-.06h-.48zm1.08.54c-.68.2-1.16.52-1.44.96l-.36.18c-.16.08-.3.16-.42.24-.08.08-.1.16-.06.24.08-.08.22-.18.42-.3.24-.08.44-.18.6-.3.16-.12.3-.26.42-.42 0 .08.06.1.18.06.04-.08.26-.2.66-.36.4-.16.62-.42.66-.78h-.18c-.04.16-.12.26-.24.3-.12.08-.2.14-.24.18zm-3.96 1.8c.16-.08.46-.3.9-.66.48-.32.86-.54 1.14-.66v-.24c-.12.08-.34.22-.66.42-.32.2-.6.38-.84.54-.2.2-.38.4-.54.6zm1.38-.06c.16 0 .24-.06.24-.18h-.18l-.06.06v.12zm10.44.18c-.08-.2-.14-.3-.18-.3-.12.2-.06.3.18.3zm-10.86-.06c-.04.16-.16.28-.36.36-.2.12-.3.22-.3.3.56-.32.86-.56.9-.72-.04-.04-.12-.02-.24.06zm-1.2.24c0-.04.02-.08.06-.12.08 0 .12-.02.12-.06-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06 0 .16.02.26.06.3zm11.58 0c.04.08.08.1.12.06.08-.04.14-.1.18-.18-.2 0-.3.04-.3.12zm-11.94.12c-.04 0-.06-.02-.06-.06h-.06c-.04.12-.2.24-.48.36-.24.12-.38.24-.42.36.36-.24.6-.36.72-.36 0-.12.04-.2.12-.24.08.08.14.12.18.12v-.18h.18c0-.04-.02-.08-.06-.12l-.12.12zm12.42 0c.08 0 .12-.04.12-.12-.12 0-.16.04-.12.12zm-.6.06c-.04 0-.08.02-.12.06-.08 0-.12.02-.12.06.16 0 .24-.04.24-.12zm.36.24h-.06a.36.36 0 0 0-.24.24c.12.04.2-.04.24-.24h.06zm-.36 0h-.12c-.04 0-.06.02-.06.06.12 0 .18-.02.18-.06zm-.06.6l-.3.24c.12.04.22-.04.3-.24h.06c.12-.12.12-.2 0-.24-.08.08-.1.16-.06.24zm-11.7.06c.12.04.22 0 .3-.12-.08 0-.14.02-.18.06-.04.04-.08.06-.12.06zm10.86.18c0-.12-.04-.18-.12-.18 0 .12.04.18.12.18zm-.12.78c-.12 0-.22.08-.3.24.2-.12.3-.2.3-.24.12.04.2-.02.24-.18 0-.04-.02-.08-.06-.12 0 .08-.04.14-.12.18-.04.04-.06.08-.06.12zm-.84 0l-.06.06h-.06c.08 0 .12-.02.12-.06zm-10.56.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm10.92.3c.08-.2.1-.3.06-.3l-.06.06c-.12.12-.12.2 0 .24zm-.84-.12c-.12 0-.18.02-.18.06.08 0 .14-.02.18-.06zm.06.78c.2-.08.42-.28.66-.6-.24.04-.46.24-.66.6zm-.6-.3c-.04 0-.08-.02-.12-.06-.04-.04-.08-.04-.12 0-.04.08-.02.12.06.12.08.04.16.04.24 0v-.12c0-.12-.02-.18-.06-.18v.24zm1.98-.18v.18l.12-.12c0-.08-.02-.12-.06-.12 0 .08-.02.1-.06.06zm-2.52.42c.04-.04.08-.04.12 0 .04.04.08.06.12.06 0-.16-.08-.24-.24-.24V56zm.9.24c.12 0 .18-.04.18-.12h-.12l-.06.12zm.84 0l-.12.06c.04 0 .08-.02.12-.06zm-2.46.42c-.28.04-.56.12-.84.24-.28.16-.6.36-.96.6-.32.24-.58.4-.78.48.08-.04.16-.06.24-.06.08.04.14.06.18.06.04.04.08.02.12-.06-.12 0-.18-.06-.18-.18.24.04.42-.02.54-.18.16-.12.28-.16.36-.12.12-.24.34-.4.66-.48.32-.04.54-.14.66-.3l.18-.06c.12-.04.16-.12.12-.24-.12-.04-.22-.04-.3 0-.04.08-.04.18 0 .3zm1.2 0c.08-.08.16-.12.24-.12.08.04.12.04.12 0-.04-.08-.12-.12-.24-.12s-.16.08-.12.24zm.66 0c.16.04.28.02.36-.06.04-.04.02-.08-.06-.12-.04.08-.12.12-.24.12l-.06.06zm-.42.36c.2-.08.32-.2.36-.36-.16 0-.28.12-.36.36zm-.84-.06c-.08-.04-.16-.02-.24.06-.04.08-.02.14.06.18 0-.04.04-.06.12-.06.08-.04.1-.1.06-.18.08 0 .12-.06.12-.18-.08 0-.12.06-.12.18zm.12.36c.24.16.42.12.54-.12h-.3c-.12.04-.2.08-.24.12zm-1.8.48v.3l.18-.18c.12-.04.2-.1.24-.18a.255.255 0 0 0-.24 0 .46.46 0 0 1-.18.06zm1.02.24c.08.08.12.04.12-.12l-.12-.12v.24zm-4.38.12c0-.04-.12-.06-.36-.06-.04.12 0 .18.12.18.16 0 .24-.04.24-.12zm1.8-.06c-.04.04-.08.06-.12.06h-.06c.08 0 .14-.02.18-.06zm1.08.24h.12v-.24h-.18c0 .12.02.2.06.24zm-1.62 0c-.16 0-.24.08-.24.24.08.04.12 0 .12-.12.04-.08.08-.12.12-.12.16 0 .26-.06.3-.18-.2 0-.3.06-.3.18zm-3.3.36c.16.28.26.42.3.42-.08 0-.12-.06-.12-.18.52 0 .82-.08.9-.24-.12 0-.2-.02-.24-.06.04-.04.12-.06.24-.06.16 0 .26-.04.3-.12-.2-.04-.46 0-.78.12-.28.12-.48.16-.6.12zm1.56-.18h.12c.04-.04 0-.08-.12-.12-.08-.04-.12-.02-.12.06l.12.06zm3.06.12c.08-.16.08-.24 0-.24 0 .04-.02.08-.06.12-.04.08-.02.12.06.12zm-2.1-.06c-.08.16-.12.28-.12.36l.24-.24.36-.18h-.3a.46.46 0 0 1-.18.06zm1.74.06h.06c.04.04.08.06.12.06-.04-.12-.1-.18-.18-.18v.12zm-2.82.06h.12v-.12h-.12v.12zm3.66 0h.06v-.12h-.06v.12zm-5.28.06c-.76.08-1.22.24-1.38.48.04 0 .1-.02.18-.06a.46.46 0 0 1 .18-.06c.04-.08.14-.14.3-.18.16 0 .26.06.3.18-.04.04-.08.04-.12 0-.04-.04-.08-.06-.12-.06.04.16.16.22.36.18.2 0 .36-.06.48-.18l-.12-.06c-.08 0-.12-.02-.12-.06.04 0 .06-.06.06-.18zm1.02.6c.08-.04.24-.08.48-.12.24 0 .44-.02.6-.06.16-.04.26-.14.3-.3-.76.16-1.22.32-1.38.48zm-.42.06c-.2 0-.3.02-.3.06.2.08.3.06.3-.06zm13.86-13.5c.08 0 .12.06.12.18h-.12v-.18zm0 .24c.08 0 .14.08.18.24v.18c-.12 0-.18-.14-.18-.42zm.12 1.02c.12.08.18.26.18.54.04.24-.02.38-.18.42v-.96zm0 1.32v.3-.3zm-8.4.84l-.18.06a.94.94 0 0 1-.24.18c0-.28.14-.36.42-.24zm3.18 7.32c0-.04.02-.08.06-.12-.04 0-.06.04-.06.12zM36.403 8.18c-.08.2-.16.54-.24 1.02-.04.48-.12.88-.24 1.2-.12.32-.28.56-.48.72-.08 1.24-.48 2.94-1.2 5.1-.68 2.16-1.08 3.54-1.2 4.14.96.12 2.54.14 4.74.06.76.12 1.94.2 3.54.24 1.64 0 3.12.1 4.44.3 1.32.2 2.5.6 3.54 1.2-.08.04-.22.06-.42.06-.2-.04-.32-.02-.36.06-1.76-.64-4.54-1.02-8.34-1.14-3.8-.12-6.1-.24-6.9-.36-.32.08-.52.3-.6.66 0 .12.1.2.3.24.24 0 .38.04.42.12.12-.32.2-.48.24-.48 0 .16.12.28.36.36.28.04.48-.04.6-.24.2.08.38.14.54.18.2 0 .4-.02.6-.06.24-.04.42-.06.54-.06.08.04.12.12.12.24.04.08.08.14.12.18.16 0 .24-.04.24-.12.04 0 .06.02.06.06l.06.06c.12-.04.1-.12-.06-.24.04-.12.12-.08.24.12.08 0 .1-.04.06-.12a.982.982 0 0 1-.06-.24c.28.32.74.48 1.38.48.64 0 1.12.04 1.44.12.04 0 .06-.06.06-.18.12.08.24.1.36.06.16-.04.32-.02.48.06.04-.04.02-.08-.06-.12a.698.698 0 0 0-.18-.12c-.08-.04-.12-.1-.12-.18.08.04.3.06.66.06.08.12.08.16 0 .12l-.12.06c.28.2.72.28 1.32.24.6-.04 1.06 0 1.38.12.16-.08.28-.2.36-.36.04 0 .06.08.06.24.04.16.12.22.24.18.04 0 .04-.04 0-.12a.982.982 0 0 1-.06-.24c.32.4.46.64.42.72.16 0 .24-.12.24-.36.08.08.2.1.36.06.16-.08.24-.08.24 0 .08 0 .12-.06.12-.18v-.18c.16.12.5.18 1.02.18.56-.04 1.02.02 1.38.18-.68.2-1.34.2-1.98 0-.04.04-.12.14-.24.3-.08.16-.18.22-.3.18-.12-.04-.2-.16-.24-.36-.04.08-.12.14-.24.18-.12.04-.24.06-.36.06-.08 0-.16.02-.24.06-.08.04-.12.12-.12.24-.12.04-.2 0-.24-.12 0-.16-.04-.24-.12-.24 0 .16-.08.24-.24.24-.16 0-.28.02-.36.06 0-.12.08-.18.24-.18 0-.16-.08-.2-.24-.12-.08 0-.1.06-.06.18-.04 0-.1-.04-.18-.12-.04-.12-.12-.16-.24-.12-.08 0-.2.12-.36.36-2.56-.32-5.92-.38-10.08-.18-.08.04-.16.18-.24.42-.04.2-.12.3-.24.3 0 .64-.2 1.52-.6 2.64-.4 1.08-.64 1.86-.72 2.34-.32.88-.82 2.26-1.5 4.14l-1.44 3.9c-.28.8-.98 2.22-2.1 4.26-1.12 2.04-1.76 3.74-1.92 5.1 0 1.04-.08 1.84-.24 2.4.08 1.44.04 2.5-.12 3.18.08 4.04.84 6.66 2.28 7.86-.92-.12-1.68-.52-2.28-1.2-.6-.64-1-1.28-1.2-1.92-.2-.64-.4-1.5-.6-2.58-.2-2.36-.26-3.94-.18-4.74.04 0 .08.04.12.12 0 .08.04.1.12.06 0-.84.04-1.32.12-1.44-.16.08-.24.22-.24.42-.04.2-.06.32-.06.36 0-1.52.12-2.5.36-2.94v-.6c-.04-.32-.06-.56-.06-.72 0-.2-.04-.42-.12-.66-.08-.24-.18-.44-.3-.6.08-.08.22-.26.42-.54.16-.28.3-.48.42-.6.56-4.32 1.88-10.4 3.96-18.24-.52-.08-1.62.08-3.3.48-1.64.36-2.66.28-3.06-.24-.16-.76-.12-1.4.12-1.92s.7-.7 1.38-.54c.64-.16 1.64-.3 3-.42s2.26-.22 2.7-.3c.32-1 .82-2.7 1.5-5.1.72-2.4 1.26-4.16 1.62-5.28.12-.32.38-1.16.78-2.52.4-1.4.7-2.38.9-2.94.2-.56.56-1.26 1.08-2.1.52-.84 1.08-1.5 1.68-1.98 1.08.08 1.78.68 2.1 1.8.36 1.08.34 2.18-.06 3.3.16.16.22.4.18.72.04 0 .08-.06.12-.18v-.12c.12.24.08.58-.12 1.02-.2.4-.28.7-.24.9h-.06c-.04-.04-.08-.06-.12-.06v.3l.06-.06h.06zm-3-1.5c-.08.16-.14.24-.18.24h-.12c-.12.12-.14.28-.06.48l-.12.12h-.06c0 .08-.06.24-.18.48-.08.24-.06.4.06.48 0-.04.04-.16.12-.36.08-.24.1-.44.06-.6l.12-.12h.06c0-.12.02-.18.06-.18-.36 1.32-1 3.48-1.92 6.48-.92 3-1.58 5.24-1.98 6.72.2.04.44.06.72.06.32-.04.56-.06.72-.06.28-1.08.82-2.88 1.62-5.4.8-2.56 1.4-4.74 1.8-6.54.44-1.84.72-3.64.84-5.4-.56.84-1.08 2.04-1.56 3.6zm-1.26 13.56l.12-.18c0-.04-.04-.1-.12-.18a.982.982 0 0 1-.06-.24c.04-.08.08-.18.12-.3.08-.12.14-.24.18-.36.04-.12.06-.26.06-.42.04-.04.1-.06.18-.06.08 0 .16-.04.24-.12v-.42c-.12 0-.18-.02-.18-.06.04-.08.08-.26.12-.54.08-.32.18-.52.3-.6 0 .08.02.12.06.12l.18-.36c.12-.24.14-.44.06-.6-.04.04-.08.14-.12.3 0 .16-.04.26-.12.3-.04-.12.06-.48.3-1.08.04 0 .06.04.06.12 0 .08.02.12.06.12.4-1.08.64-1.9.72-2.46-.12.16-.26.52-.42 1.08-.12.52-.26.82-.42.9.16-.64.44-1.66.84-3.06.44-1.4.8-2.66 1.08-3.78.28-1.12.48-2.2.6-3.24.04 0 .06-.02.06-.06 0-.04-.02-.06-.06-.06a.982.982 0 0 1-.06-.24l.12-.12c.08-.04.12-.08.12-.12-.2-.08-.24-.18-.12-.3-.24.6-.46 1.7-.66 3.3-.04.04-.1.04-.18 0-.04-.04-.08-.06-.12-.06 0 .04.02.1.06.18.04.08.06.16.06.24-.2.16-.38.48-.54.96-.12.48-.1.88.06 1.2-.04.04-.1.06-.18.06a.255.255 0 0 0-.24 0c-.24 1.2-.74 2.98-1.5 5.34s-1.24 4.04-1.44 5.04c.16.04.4-.1.72-.42 0 .04.02.08.06.12v.06zm4.02-12.3c.08-.04.12-.12.12-.24s-.04-.2-.12-.24c0 .04-.02.1-.06.18a.46.46 0 0 0-.06.18c0 .04.04.08.12.12zm-3.72 1.02c.12.04.18 0 .18-.12 0-.16-.04-.24-.12-.24.04.08.04.14 0 .18a.46.46 0 0 0-.06.18zm-1.08.06c-.04 0-.06.06-.06.18.04 0 .06-.06.06-.18zm3.96.06h.12v-.12h-.12v.12zm-2.94.48c0-.04.02-.1.06-.18.08-.2.06-.3-.06-.3 0 .08-.04.18-.12.3-.04.12 0 .18.12.18zm-1.74-.12v.18c.08.04.12.02.12-.06.04-.12.02-.18-.06-.18 0 .08-.02.1-.06.06zm5.28.48v-.36l-.06.3.06.06zm-5.4.24c.04-.04.08-.12.12-.24a.46.46 0 0 0 .06-.18c-.12 0-.18.14-.18.42zm1.62.12c.16-.32.18-.5.06-.54 0 .04-.02.1-.06.18 0 .08-.02.16-.06.24 0 .04.02.08.06.12zm-1.14-.18c0-.04.02-.06.06-.06 0-.12-.04-.16-.12-.12 0 .12.02.18.06.18zm-.12.66c-.04-.08-.04-.18 0-.3s0-.18-.12-.18c.04.04.04.1 0 .18v.24c.04.04.08.06.12.06zm4.08-.42v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-4.62.36h.06c-.04-.08-.04-.14 0-.18.08-.08.12-.14.12-.18-.12.04-.18.16-.18.36zm1.68.06v-.3.3zm2.94.12c.12-.16.12-.24 0-.24-.12.16-.12.24 0 .24zm-4.68.24c0-.04.02-.1.06-.18.08-.08.06-.12-.06-.12v.3zm4.32.6c.12 0 .18-.04.18-.12.04-.16.1-.22.18-.18-.04-.04-.04-.12 0-.24s0-.18-.12-.18c0 .08-.04.2-.12.36l-.12.36zm-4.02-.18c0-.04.02-.1.06-.18.08-.24.06-.34-.06-.3 0 .04-.04.14-.12.3-.04.12 0 .18.12.18zm4.68-.18c0-.08.02-.12.06-.12 0-.08-.04-.12-.12-.12 0 .16.02.24.06.24zm-5.34.72h.06c.12-.52.18-.8.18-.84-.08.24-.16.52-.24.84zm1.74-.18c0-.04.02-.1.06-.18.04-.08.02-.12-.06-.12v.3zm-1.5.72c.08.04.12.04.12 0 .04-.08.06-.18.06-.3-.08-.04-.12.02-.12.18 0 .08-.02.12-.06.12zm-.6.54c.28-.2.36-.42.24-.66 0 .08-.04.18-.12.3l-.12.36zm5.4-.48h.12v-.12h-.12v.12zm-5.04.54v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-.48.78c0-.04.02-.12.06-.24.08-.16.12-.26.12-.3.04-.08 0-.16-.12-.24.04.12.02.28-.06.48-.08.16-.08.26 0 .3zm.36.12c0-.04.02-.06.06-.06 0-.12-.06-.16-.18-.12l.06.06c0 .08.02.12.06.12zm-.66.48c.08 0 .14-.06.18-.18.04-.12.02-.22-.06-.3 0 .04-.02.12-.06.24 0 .12-.02.2-.06.24zm.36.6c.12-.4.14-.64.06-.72 0 .08-.02.18-.06.3 0 .12-.02.2-.06.24 0 .04.02.1.06.18zm-.9 1.08c-.68 2.24-1.06 3.64-1.14 4.2.76-2.08 1.14-3.48 1.14-4.2.4-.72.58-1.26.54-1.62-.12.12-.3.66-.54 1.62zm.72-.84h-.06c-.04.2-.12.48-.24.84-.08.32-.14.62-.18.9.32-.4.48-.98.48-1.74zm1.2.48l-.06-.12c0-.08-.02-.12-.06-.12-.04.04-.06.1-.06.18.04.04.1.06.18.06zm-2.64 4.56c.04-.08.38-1.14 1.02-3.18h-.18c-.08.4-.24.94-.48 1.62-.2.68-.32 1.2-.36 1.56zm1.98-2.82c.12 0 .18-.1.18-.3-.08-.04-.12.02-.12.18 0 .08-.02.12-.06.12zm-.24.96c.04 0 .1-.1.18-.3-.12-.04-.18.02-.18.18v.12zm-.18.84c.08-.2.08-.32 0-.36 0 .04-.02.1-.06.18-.04.08-.02.14.06.18zm2.16 1.86c0-.04.04-.08.12-.12.08-.08.1-.16.06-.24-.4 0-.64.04-.72.12.08.04.08.08 0 .12-.12.08-.14.22-.06.42.04 0 .1-.02.18-.06.08-.08.18-.1.3-.06 0-.04.04-.1.12-.18zm-1.68 0c0-.08-.08-.16-.24-.24-.08.04-.2.06-.36.06-.12 0-.2.04-.24.12.08 0 .16.06.24.18.08.12.2.16.36.12.04-.08.02-.16-.06-.24-.04-.08-.02-.12.06-.12.08.16.12.26.12.3.12.08.26.06.42-.06.2-.12.24-.24.12-.36 0 .2-.08.22-.24.06-.04-.04-.08-.06-.12-.06 0-.04-.02-.08-.06-.12-.04.04-.02.12.06.24.04.04.02.08-.06.12zm1.32.66c.04 0 .06.02.06.06h.06c0-.16-.04-.22-.12-.18v.12zm12.72.42c0-.12-.04-.18-.12-.18 0 .16.04.22.12.18zm-.42 0h.12v-.12h-.12v.12zm-4.14.18c.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12 0 .16.06.24.18.24zm-9.6 5.22c.04 0 .06-.04.06-.12 0-.08.04-.16.12-.24-.08 0-.14-.02-.18-.06.4-.68.54-1.16.42-1.44l.36-.12c.08-.76.22-1.26.42-1.5-.12-.04-.18-.16-.18-.36 0-.2.08-.32.24-.36v.12c.08-.08.12-.22.12-.42 0-.2-.04-.34-.12-.42h-.24c-.12 0-.22.02-.3.06-.08.56-.3 1.3-.66 2.22-.36.88-.58 1.56-.66 2.04-.52.96-.86 1.92-1.02 2.88l-.18-.18c-.04.08-.06.2-.06.36.04.12.06.22.06.3.04.04.04.08 0 .12-.04 0-.08-.04-.12-.12 0-.08-.04-.1-.12-.06-.08.56-.3 1.26-.66 2.1-.36.8-.58 1.36-.66 1.68a.51.51 0 0 1 .48 0c.16-.52.46-1.26.9-2.22.44-1 .74-1.7.9-2.1.08 0 .1.06.06.18 0 .08.02.12.06.12 0-.12.04-.18.12-.18 0-.08-.02-.14-.06-.18 0-.04-.02-.08-.06-.12-.04-.04-.06-.1-.06-.18.2.08.32.08.36 0-.16-.2-.18-.38-.06-.54.04-.08.12-.06.24.06.08-.12.06-.22-.06-.3a.645.645 0 0 1-.12-.36c.08 0 .12.02.12.06l.06.12c.08-.08.08-.16 0-.24-.04-.12-.04-.2 0-.24.04 0 .08.02.12.06.08.04.14.08.18.12 0-.08.02-.16.06-.24.08-.12.12-.22.12-.3zm-1.32-4.74c-.28.92-.68 2.5-1.2 4.74-.52 2.2-.98 3.88-1.38 5.04.08.16.06.42-.06.78-.12.36-.12.56 0 .6 1.92-5 3.26-8.74 4.02-11.22-.24-.04-.5-.04-.78 0s-.48.06-.6.06zm-2.88 4.14c-.6.92-.76 1.66-.48 2.22.2-.64.46-1.68.78-3.12.36-1.44.62-2.44.78-3h-.24c-.08.36-.24.96-.48 1.8-.2.8-.32 1.5-.36 2.1zm1.14-3.06c.08 0 .14-.06.18-.18.08-.16.12-.28.12-.36.04-.12.02-.2-.06-.24-.04.12-.1.28-.18.48-.04.16-.06.26-.06.3zm-.3 1.68c0-.16.04-.36.12-.6.12-.28.18-.48.18-.6.04-.12.02-.26-.06-.42 0 .16-.08.44-.24.84-.12.36-.12.62 0 .78zm-.24.66h.12c0-.12-.04-.2-.12-.24v.24zm-.36 1.8h.06c.04-.12.08-.3.12-.54.04-.28.06-.44.06-.48-.28.12-.36.46-.24 1.02zm-.24 1.14c0-.08.04-.24.12-.48.08-.24.06-.4-.06-.48-.16.6-.18.92-.06.96zm-.24.66c0-.04.02-.12.06-.24.08-.2.06-.32-.06-.36v.6zm-1.5 4.32v.12c-.04.04-.08.06-.12.06 0 .2-.06.3-.18.3-.08-.04-.12-.04-.12 0 .04 0 .08.02.12.06l.12.06c-.48 1.24-.68 2.14-.6 2.7-.08.04-.16.32-.24.84-.24.24-.26.54-.06.9-.08-.08-.14-.1-.18-.06-.04.04-.04.1 0 .18.12 0 .18.02.18.06 0 .08-.06.18-.18.3-.12.08-.18.16-.18.24h.12c.08.04.12.08.12.12-.12 0-.2.06-.24.18-.04.08.02.14.18.18-.4.28-.46.5-.18.66-.04-.12 0-.24.12-.36s.14-.22.06-.3c0-.04.04-.06.12-.06.16-.96.36-2.08.6-3.36.28-1.28.46-2.22.54-2.82.04-.2.22-.88.54-2.04.36-1.2.52-2.14.48-2.82-.08.16-.16.46-.24.9-.08.4-.16.68-.24.84.08.08.04.24-.12.48-.12.2-.12.38 0 .54-.04 0-.08-.02-.12-.06l-.06.12c.12.16.06.52-.18 1.08-.2.52-.28.84-.24.96h.18zm1.14-3.12c.16-.4.2-.66.12-.78 0 .08-.04.22-.12.42-.08.16-.08.28 0 .36zm3.6-.6c.08-.08.08-.14 0-.18v.18zm-3.78 1.26l.18-.36c-.08-.04-.14-.02-.18.06v.3zm-.36 1.56h-.06c0 .12-.04.28-.12.48-.08.2-.08.34 0 .42-.12.08-.2.3-.24.66-.04.32-.08.52-.12.6.16-.12.24-.34.24-.66.04-.32.08-.52.12-.6.04 0 .1-.3.18-.9.24-.12.3-.48.18-1.08l-.18 1.08zm1.86 1.14v-.18.18zm-2.76 3.24c0-.04.06-.22.18-.54.12-.32.14-.56.06-.72 0 .08-.04.22-.12.42-.08.2-.14.36-.18.48 0 .08.02.2.06.36zm-.24 1.44c0-.08.04-.22.12-.42.08-.2.12-.34.12-.42 0-.08-.04-.2-.12-.36-.08.76-.12 1.16-.12 1.2zm-1.62 7.08c.08-.2.06-.32-.06-.36v.18c0 .12.02.18.06.18zm-.06.3v-.24.24zm.48.48c.12.08.18.02.18-.18 0-.08-.02-.12-.06-.12 0 .08-.02.14-.06.18-.04.04-.06.08-.06.12zm-.54.24c.2 0 .3-.1.3-.3-.2 0-.3.1-.3.3zm0 1.98v-.18c0-.12-.02-.18-.06-.18-.08.24-.06.36.06.36zm.54.36c0-.32-.04-.46-.12-.42 0 .04.02.12.06.24 0 .08.02.14.06.18zm-.42.12v-.3c.04-.08.02-.14-.06-.18v.3c-.04.08-.02.14.06.18zm.36.72c.08-.28.08-.5 0-.66-.04.04-.06.14-.06.3 0 .16.02.28.06.36zm-.42 0c0-.04.02-.1.06-.18.04-.04.02-.08-.06-.12 0 .04-.02.06-.06.06-.04 0-.06.02-.06.06l.06.06c0 .08.02.12.06.12zm.42 1.2c0-.08.02-.28.06-.6 0-.28-.04-.44-.12-.48 0 .12-.02.32-.06.6-.04.32 0 .48.12.48zm-.36-.6c0-.24-.02-.36-.06-.36-.08.08-.1.16-.06.24 0 .08.04.12.12.12zM35.983 5l-.06.06.06.06V5zm-2.82 1.92h.06c0 .2-.02.3-.06.3v-.3zm1.56 2.28c.12 0 .18.06.18.18-.08.04-.12.02-.12-.06-.04-.04-.06-.08-.06-.12zm-1.44 4.92h.18v.3h-.18v-.3zm-.78 4.08h.18v.12c-.04 0-.06.02-.06.06h-.18v-.12l.06-.06zm4.26 3.6c-.12-.08-.22-.26-.3-.54.12.08.22.26.3.54zm2.4-.48c.32.08.5.2.54.36-.08 0-.16-.04-.24-.12-.12-.08-.2-.04-.24.12-.12.04-.16 0-.12-.12 0-.12.02-.2.06-.24zm2.34.12c.08-.04.12 0 .12.12.04.08.08.12.12.12-.08.04-.16-.04-.24-.24zm-3.66.06c.04 0 .08.02.12.06h.18c0 .08-.08.1-.24.06-.08 0-.1-.04-.06-.12zm4.56.06c0-.04.06-.06.18-.06v.18l-.06-.06c-.04-.04-.08-.06-.12-.06zm.42-.06c.08 0 .12.06.12.18.04.08.02.14-.06.18-.08 0-.1-.06-.06-.18v-.18zm-.9.06c.04.04.12.06.24.06 0 .04-.04.08-.12.12-.08 0-.12.04-.12.12-.08 0-.1-.04-.06-.12.08-.08.1-.14.06-.18zm2.76.24c.16 0 .2.08.12.24-.08 0-.12-.08-.12-.24zm.3 0c.08 0 .12.08.12.24-.08 0-.12-.08-.12-.24zm-15.18 6l-.12-.12c.08 0 .12.04.12.12zm-8.28 25.74v.18c-.12 0-.18-.06-.18-.18h.18zm20.726-5.1c5.68-4.76 9.4-7.84 11.16-9.24.96.16 1.48.56 1.56 1.2-1.48 1.56-3.74 3.62-6.78 6.18-3.04 2.56-5.14 4.42-6.3 5.58 0 .68-.04 1.6-.12 2.76-.08 1.2-.12 2.1-.12 2.7-1.28 10.72-2.96 18.78-5.04 24.18-.52 2.44-1.54 4.88-3.06 7.32-.68 1.2-1.3 2.18-1.86 2.94-.52.76-1.22 1.56-2.1 2.4-.88.88-1.88 1.52-3 1.92-1.12.4-2.38.58-3.78.54-.64-.28-1.12-.44-1.44-.48-.08-.2-.12-.34-.12-.42-.76-.28-1.44-.8-2.04-1.56-.6-.76-1.02-1.48-1.26-2.16-.28-.64-.6-1.54-.96-2.7-.08-.4-.12-.82-.12-1.26v-1.2c0-.36.04-.76.12-1.2.04-.44.1-.82.18-1.14.04-.28.14-.66.3-1.14.12-.44.22-.78.3-1.02.04-.2.16-.56.36-1.08.2-.48.34-.82.42-1.02.08-.16.24-.5.48-1.02.2-.52.32-.84.36-.96 1.96-4.6 3.92-8.14 5.88-10.62.8-1.36 1.78-2.82 2.94-4.38 1.12-1.52 2.06-2.72 2.82-3.6.76-.88 1.92-2.22 3.48-4.02 1.6-1.76 2.66-2.94 3.18-3.54.24-.16 1-.88 2.28-2.16.32-5.24.52-8.32.6-9.24-.4.32-1.56 1.4-3.48 3.24-1.88 1.8-3.48 3.02-4.8 3.66-.92-.12-1.6-.44-2.04-.96-.44-.52-.62-1.18-.54-1.98.04-.8.14-1.54.3-2.22.16-.72.42-1.56.78-2.52.36-.96.58-1.62.66-1.98.6.16 1.04.44 1.32.84.28.4.38.9.3 1.5-.04.56-.14 1.1-.3 1.62-.12.48-.32 1.04-.6 1.68-.24.64-.4 1.1-.48 1.38 2.08-1.24 5.16-3.86 9.24-7.86.36-.24.72-.3 1.08-.18.36.12.62.38.78.78 0 1.04-.1 2.76-.3 5.16-.2 2.4-.28 4.16-.24 5.28zm10.2-7.8c.56-.44.8-.7.72-.78a.68.68 0 0 1-.24.24l-.36.24c-.08.08-.12.18-.12.3zm1.14.12c-.04-.08-.02-.14.06-.18.08-.04.12-.1.12-.18-.12-.08-.22-.06-.3.06-.04.08-.08.14-.12.18-.52.4-4.26 3.52-11.22 9.36 0 .48-.02.82-.06 1.02 1-.72 1.66-1.32 1.98-1.8.68-.2 1.24-.74 1.68-1.62.4.08.86-.22 1.38-.9.52-.68.98-1.02 1.38-1.02.52-.72 1.5-1.66 2.94-2.82 1.48-1.2 2.44-2.06 2.88-2.58h-.24c-.08.28-.24.44-.48.48zm-2.22.84l.3-.3c.16-.12.28-.22.36-.3.12-.12.18-.24.18-.36-.04.12-.2.26-.48.42-.24.12-.36.3-.36.54zm-1.44 1.44c0-.04.04-.1.12-.18l.12-.18c0-.04-.04-.1-.12-.18-.16.32-.2.5-.12.54zm-1.02.78c.04-.08.16-.18.36-.3.2-.12.32-.24.36-.36-.44.16-.68.38-.72.66zm-.3.12c.08.04.14.04.18 0 .04-.08.02-.14-.06-.18-.04-.04-.08-.04-.12 0v.18zm-1.38 1.08c.8-.44 1.18-.78 1.14-1.02-.12.12-.32.3-.6.54-.24.2-.42.36-.54.48zm0 .24c-.4.04-.98.42-1.74 1.14-.72.72-1.28 1.12-1.68 1.2-.04.32-.32.66-.84 1.02-.52.32-.76.64-.72.96.2-.08.46-.32.78-.72.36-.44.66-.66.9-.66.08-.44.24-.56.48-.36.24-.32.5-.62.78-.9.32-.28.68-.58 1.08-.9.44-.36.76-.62.96-.78zm-8.22 6.6c.08.16.02.32-.18.48-.2.2-.3.36-.3.48-.04.04-.1.02-.18-.06h-.18c-.12.08-.34.28-.66.6-.32.32-.58.56-.78.72.24.04.68-.26 1.32-.9v.12c.04.08.1.1.18.06.24-.08.48-.36.72-.84.28-.44.5-.64.66-.6.28-.28.36-.52.24-.72-.52.4-.8.62-.84.66zM27.49 67.7c0 .12-.04.24-.12.36-.08.12-.12.24-.12.36-.16.16-.24.3-.24.42l.12-.12c.08-.12.12-.22.12-.3.48-.4.76-.8.84-1.2-.12 0-.22.08-.3.24-.12.16-.22.24-.3.24.28-.48.62-.96 1.02-1.44 0 .12-.06.24-.18.36-.12.16-.18.28-.18.36.56-.56 1.32-1.48 2.28-2.76.92-1.28 1.68-2.2 2.28-2.76a.3.3 0 0 1 0-.36c.08-.08.1-.16.06-.24-.52.6-.84.96-.96 1.08.8-1.2 1.6-2.2 2.4-3 0 .04-.04.1-.12.18-.04.08-.04.16 0 .24.12-.04.24-.14.36-.3.12-.12.16-.24.12-.36-.08.16-.2.24-.36.24.88-1.16 1.62-1.98 2.22-2.46-.04.08-.12.18-.24.3s-.18.24-.18.36c.12-.04.26-.16.42-.36.2-.2.38-.28.54-.24-.16-.08-.16-.22 0-.42.16-.16.3-.32.42-.48.16-.12.16-.22 0-.3.08-.04.18-.16.3-.36.16-.16.3-.26.42-.3l-.18.36c.68-.4 1.14-.88 1.38-1.44-.16.04-.34.2-.54.48-.16.28-.32.4-.48.36.08-.24.38-.58.9-1.02.52-.44.68-.84.48-1.2-.04.12-.2.3-.48.54-.28.24-.42.44-.42.6-1.08.68-1.74 1.4-1.98 2.16-5.96 6.04-11.22 13.54-15.78 22.5-.16.52-.36 1.1-.6 1.74-.28.68-.48 1.22-.6 1.62l1.44-2.88c.6-1.24 1.18-2.38 1.74-3.42.52-1.04 1.04-1.98 1.56-2.82v.3c.24-.24.46-.5.66-.78s.36-.54.48-.78c.12-.2.28-.48.48-.84.2-.36.36-.64.48-.84-.2.08-.4.34-.6.78-.24.44-.48.72-.72.84.8-1.4 1.52-2.48 2.16-3.24zm11.1-15.12l-.12-.3c0 .2.04.3.12.3zm-1.38 1.74c.32-.12.54-.34.66-.66l-.66.66zm-6.9 10.8c0 .08-.02.16-.06.24-.04.12-.06.24-.06.36-.68.76-1.36 1.62-2.04 2.58-.68.96-1.4 2.06-2.16 3.3-.76 1.24-1.34 2.16-1.74 2.76-.28.68-.8 1.82-1.56 3.42-.76 1.64-1.32 2.9-1.68 3.78-.36.88-.74 2.08-1.14 3.6-.4 1.52-.64 3.04-.72 4.56-.12.04-.18.22-.18.54-.04.36-.1.6-.18.72-.04-.04-.04-.12 0-.24v-.3c-.04-.08-.1-.12-.18-.12-.08.48.06 1.32.42 2.52.6.92 1.56 1.5 2.88 1.74 1.28.24 2.5.06 3.66-.54 1.76-1 3.32-2.46 4.68-4.38 1.36-1.92 2.3-3.54 2.82-4.86.56-1.28 1.36-3.42 2.4-6.42.2-.52.34-.9.42-1.14.08-.32.26-1.16.54-2.52.32-1.32.52-2.22.6-2.7.12-.48.32-1.36.6-2.64.28-1.28.48-2.26.6-2.94.12-.68.28-1.62.48-2.82.2-1.16.34-2.2.42-3.12.12-.88.22-1.88.3-3 .12-1.08.2-2.14.24-3.18 0-.04-.02-.06-.06-.06-1.72 1.88-4.82 5.5-9.3 10.86zm5.64-10.02c.24 0 .44-.12.6-.36.04-.12 0-.22-.12-.3-.04.08-.14.18-.3.3-.12.12-.18.24-.18.36zm.66.06c-.04-.04-.02-.1.06-.18.08-.08.08-.14 0-.18 0 .04-.02.08-.06.12-.12.12-.12.2 0 .24zm1.14.24c0-.04.02-.08.06-.12.08-.08.08-.14 0-.18 0 .04-.02.08-.06.12-.08.08-.08.14 0 .18zm-2.58.6c.08 0 .16-.08.24-.24.08-.12.2-.14.36-.06.08-.28.08-.42 0-.42 0 .08-.1.18-.3.3-.2.12-.3.26-.3.42zm-.3.24c.24 0 .36-.02.36-.06-.16-.16-.28-.14-.36.06zm.54 0c.16 0 .24-.04.24-.12-.08 0-.16.04-.24.12zm-.18.18v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-.9.36c.32 0 .48-.1.48-.3-.24.04-.4.14-.48.3zm-.24.42h-.12c-.04.04-.06.1-.06.18.04.12.1.18.18.18v-.36c.24 0 .36-.04.36-.12-.24-.24-.36-.2-.36.12zm1.86.3v.06c.08.04.14.02.18-.06l-.12-.06v-.24c-.28.2-.42.36-.42.48.12.04.2.02.24-.06.04-.08.08-.12.12-.12zm-2.34.36l.06.06h.12c0-.28-.02-.42-.06-.42-.08.08-.12.2-.12.36zm.54 0c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18 0 .04-.04.06-.12.06-.04.04-.04.1 0 .18zm.54.78c.04-.04.14-.1.3-.18.16-.08.28-.16.36-.24.08-.04.1-.1.06-.18 0 .08-.04.12-.12.12 0-.16-.04-.24-.12-.24-.08.08-.16.2-.24.36-.08.16-.16.28-.24.36zm-1.8-.06c-.6.4-.88.8-.84 1.2.16-.08.32-.26.48-.54.2-.28.36-.46.48-.54l-.12-.12h.36c.12-.2.18-.4.18-.6-.2.04-.28.18-.24.42h-.3v.18zm.48.18c.4-.24.54-.44.42-.6 0 .04-.08.12-.24.24-.16.12-.22.24-.18.36zm-.6.9c0-.04.02-.1.06-.18 0-.12-.02-.18-.06-.18 0 .04-.02.1-.06.18-.04.12-.02.18.06.18zm-.78.9c.04-.04.12-.14.24-.3.16-.12.26-.22.3-.3.04-.08.02-.18-.06-.3 0 .12-.1.26-.3.42-.2.2-.26.36-.18.48zm1.02.12c.36-.28.56-.5.6-.66-.12 0-.22.02-.3.06-.08.08-.14.18-.18.3-.04.16-.08.26-.12.3zM30.13 62c.28-.04.6-.32.96-.84.32-.52.54-.84.66-.96-.16.04-.32.14-.48.3-.16.16-.28.3-.36.42-.12.12-.26.32-.42.6-.2.28-.32.44-.36.48zm1.08-.6c.08 0 .16-.06.24-.18.08-.12.08-.22 0-.3 0 .04-.04.1-.12.18-.08.12-.12.22-.12.3zm-1.62 1.26c.16.12.32.08.48-.12.12-.2.06-.32-.18-.36 0 .04-.04.12-.12.24-.08.12-.14.2-.18.24zm.96-.36h-.06c-.08.08-.12.16-.12.24.12-.04.18-.12.18-.24zm-1.32.78c.28 0 .42-.08.42-.24-.16-.16-.3-.08-.42.24zm0 .18c-.04 0-.06-.02-.06-.06h-.06c-.08.04-.08.08 0 .12.08.04.12.02.12-.06zm-4.26 6.06h-.06a240.27 240.27 0 0 1-1.8 3c-.44.52-.66 1.04-.66 1.56.2-.32.42-.84.66-1.56.32-.2.64-.64.96-1.32.32-.64.62-1.06.9-1.26v-.42c.24-.12.46-.38.66-.78.16-.4.36-.66.6-.78 0-.16-.02-.28-.06-.36.44-.36 1.42-1.64 2.94-3.84-1.56 1.56-2.94 3.48-4.14 5.76zm13.5-1.08h.3c-.04-.16-.02-.46.06-.9.12-.4.12-.68 0-.84-.04.16-.1.44-.18.84-.04.4-.1.7-.18.9zm.84-.84c0-.04.02-.08.06-.12.08-.2.06-.32-.06-.36.04.08.04.18 0 .3s-.04.18 0 .18zm-.84 1.38c.08 0 .14-.04.18-.12.04-.08.04-.16 0-.24 0-.08-.04-.12-.12-.12-.04.08-.06.16-.06.24v.24zm.54-.12c.12.08.18.02.18-.18 0-.08-.02-.12-.06-.12 0 .04-.02.08-.06.12a.46.46 0 0 0-.06.18zm-12.36.36v.12c.08.12.16.08.24-.12v-.06h.06c-.04-.04-.08-.04-.12 0a.46.46 0 0 1-.18.06zm10.86 4.5h-.06c-.04.32-.18.56-.42.72 0 .16.06.2.18.12-.84 3.36-1.44 5.48-1.8 6.36h-.24c0 .08-.06.12-.18.12-.12-.04-.16 0-.12.12.04.08.12.1.24.06.12 0 .2.02.24.06-.04.08-.14.32-.3.72-.12.4-.24.68-.36.84-.04-.08-.1-.08-.18 0-.04.12-.12.14-.24.06 0 .04-.02.1-.06.18-.04.08-.08.14-.12.18 0 .08.02.14.06.18.04-.16.14-.28.3-.36.12-.04.2-.1.24-.18.08.24.06.4-.06.48a.46.46 0 0 1-.18-.06c.12.2.1.44-.06.72-.16.28-.24.52-.24.72-.16 0-.24.04-.24.12-.04.04-.08.18-.12.42-.04.28-.12.46-.24.54a.68.68 0 0 1-.24-.24c-.04-.08-.1-.12-.18-.12.04.08.02.18-.06.3-.08.16-.08.26 0 .3.04-.16.1-.22.18-.18.12.04.22.04.3 0-.16.12-.28.38-.36.78-.04.44-.22.74-.54.9 0 .12.06.14.18.06-.4.28-.8.82-1.2 1.62-.4.84-.72 1.4-.96 1.68.04 0 .1-.02.18-.06.04-.04.08-.02.12.06-.12.2-.26.26-.42.18-.12.24-.34.54-.66.9-.36.36-.6.66-.72.9-.32.12-.54.38-.66.78.2.04.36-.02.48-.18s.22-.24.3-.24c.04-.08.04-.16 0-.24-.08-.04-.12-.08-.12-.12.08-.04.18-.02.3.06-.04-.12 0-.28.12-.48.12-.16.22-.22.3-.18 0 .04-.02.06-.06.06-.08.08-.1.16-.06.24.28-.12.44-.32.48-.6-.04 0-.1.02-.18.06-.08.08-.12.06-.12-.06.6-.08.98-.5 1.14-1.26h.18c.04-.08.12-.22.24-.42.12-.16.18-.3.18-.42.04-.08.02-.2-.06-.36.08 0 .14-.08.18-.24.04-.16.1-.24.18-.24.04.04.04.12 0 .24-.04.08-.04.14 0 .18.8-1.36 2.1-4.36 3.9-9 0 .04.04.1.12.18.08-.08.12-.16.12-.24 0-.08.04-.16.12-.24-.08 0-.16.04-.24.12l-.12.18c.12-.52.38-1.58.78-3.18.44-1.56.72-2.76.84-3.6.32-.96.66-2.48 1.02-4.56-.16.08-.26.34-.3.78 0 .48-.12.74-.36.78.16.28.14.78-.06 1.5-.2.76-.3 1.26-.3 1.5zm1.44-4.2c.08 0 .14-.04.18-.12 0-.12-.06-.2-.18-.24v.36zm-.36 1.56c.08 0 .14-.04.18-.12.08-.12.04-.18-.12-.18 0 .04-.02.08-.06.12v.18zm-1.14.96c.16 0 .24-.1.24-.3-.08-.04-.14-.04-.18 0-.04.08-.06.18-.06.3zm.72.9c.12.04.2 0 .24-.12 0-.08.02-.14.06-.18-.04 0-.08-.02-.12-.06h-.12c.04.16.02.28-.06.36zm-.84.18h.12v-.18h-.12v.18zm-13.14.18h.24c0-.12-.08-.16-.24-.12v.12zm-.18.72c0-.04.04-.12.12-.24a.94.94 0 0 0 .18-.24c0-.04-.06-.1-.18-.18 0 .04-.04.14-.12.3-.08.2-.08.32 0 .36zm12.96-.3c.08.04.12 0 .12-.12l-.06-.12c0 .04-.02.08-.06.12v.12zm-14.94.72c.2.04.3-.04.3-.24-.08-.04-.14-.02-.18.06-.04.12-.08.18-.12.18zm1.62.18c0-.04.02-.1.06-.18.08-.16.06-.24-.06-.24 0 .04-.02.12-.06.24-.08.12-.06.18.06.18zm-.6.78l.12.06c0-.16-.04-.22-.12-.18v.12zm13.38.24v.12c.08.04.12 0 .12-.12.04-.08.02-.12-.06-.12 0 .08-.02.12-.06.12zm-15.18.72c0-.04.04-.1.12-.18.08-.16.08-.26 0-.3l-.12.24c-.12.12-.12.2 0 .24zm15.06 0c.12 0 .18-.1.18-.3-.08-.04-.14-.04-.18 0v.3zm-.3 1.14v.06-.06zm.84.12h-.06c.04.04.02.06-.06.06v.18c.08 0 .12-.08.12-.24zm-.9.3h.12v-.12h-.12v.12zm.72.66c0-.04.02-.1.06-.18.04-.08 0-.12-.12-.12 0 .16.02.26.06.3zm-.96.18c.16 0 .24-.08.24-.24-.04-.12-.1-.18-.18-.18-.04.08-.06.22-.06.42zm.18 2.4c0-.04.02-.06.06-.06 0-.12-.06-.18-.18-.18 0 .04.02.08.06.12 0 .08.02.12.06.12zm-.3.6c.08 0 .14-.04.18-.12.04-.04.04-.12 0-.24 0-.08-.02-.12-.06-.12-.08.24-.12.4-.12.48zm-16.02.96c0-.08.04-.2.12-.36.04-.12.08-.22.12-.3 0-.04-.04-.1-.12-.18-.12.48-.16.76-.12.84zm16.08-.48h.12v-.12h-.12v.12zm-.36.48c-.28.28-.32.48-.12.6.08-.32.12-.52.12-.6h.06l.06-.3-.06-.06c.04.08.04.14 0 .18-.04.04-.06.1-.06.18zm-16.08.84c.16-.12.24-.32.24-.6-.08 0-.16.2-.24.6zm14.58.54c.04 0 .08-.04.12-.12.08-.04.1-.12.06-.24 0-.08-.02-.12-.06-.12 0 .08-.04.24-.12.48zm.42-.12v-.3c0 .04-.04.1-.12.18-.04.08 0 .12.12.12zm-.78 1.26c.04-.08.08-.2.12-.36l.18-.36c-.16.04-.3.14-.42.3-.08.2-.04.34.12.42zm-.72 1.56h-.06c-.04 0-.08.04-.12.12 0 .08.04.12.12.12.04-.04.06-.12.06-.24l.3-.48c0-.04-.04-.08-.12-.12.04.12.02.22-.06.3-.08.08-.12.18-.12.3zm-.42.72c.04-.08.08-.18.12-.3-.08.16-.12.26-.12.3zm-.48.9c.16-.16.2-.28.12-.36 0 .04-.04.1-.12.18-.08.08-.08.14 0 .18zm-.18.42c.08 0 .12-.06.12-.18 0 .04-.02.06-.06.06l-.06.12zm-.42.72c.08.04.16-.02.24-.18.08-.12.04-.18-.12-.18 0 .08-.02.14-.06.18a.46.46 0 0 0-.06.18zm-.24.3h.12v-.12h-.12v.12zm-.12.6c0-.08.02-.14.06-.18.04-.08.06-.16.06-.24-.16-.04-.26.04-.3.24 0 .08.06.14.18.18zm-.66.9c0-.04.02-.08.06-.12.04-.04.08-.1.12-.18l.12-.12c-.04 0-.08-.02-.12-.06-.08-.04-.14-.04-.18 0 0 .08-.04.18-.12.3-.08.12-.04.18.12.18zm-.78.9c.04-.08.1-.16.18-.24l.18-.18c.04-.04.08-.1.12-.18.04-.04.04-.1 0-.18-.04.04-.08.1-.12.18l-.18.18c-.08.04-.14.1-.18.18-.04.08-.04.16 0 .24zm-2.46 2.22h-.18v.12c.12.04.18 0 .18-.12.56-.28.92-.64 1.08-1.08l-1.08 1.08zm-2.4.48c-.28.12-.56.2-.84.24-.32.08-.62.1-.9.06-.32-.04-.58-.08-.78-.12-.2 0-.48-.06-.84-.18-.36-.08-.62-.14-.78-.18.32.44.96.68 1.92.72.92.04 1.66-.14 2.22-.54zm28.98-53.88c-.04.08-.14.16-.3.24-.12.04-.2.1-.24.18a.533.533 0 0 1-.06-.24c.04-.08.12-.14.24-.18.12-.04.24-.04.36 0zm-1.38 1.08c.32-.44.56-.64.72-.6-.16.28-.4.48-.72.6zm0 0c-.04.16-.18.28-.42.36.16-.24.3-.36.42-.36zm-6.12 5.4h.12v.12c-.04 0-.06.02-.06.06h-.12v-.12l.06-.06zm-7.92 7.32c0-.16.04-.24.12-.24 0 .08-.04.16-.12.24zm-1.02 1.02c0 .12-.08.22-.24.3-.12.12-.18.24-.18.36-.08-.12-.06-.26.06-.42.12-.12.24-.2.36-.24zm-1.14 1.8c.04 0 .06-.02.06-.06-.04-.04-.06-.02-.06.06zm-4.14 4.44c.04.12-.02.22-.18.3 0-.08.06-.18.18-.3zm-.24.36c0-.04.02-.06.06-.06 0 .04-.02.06-.06.06zm-.24.18c.04.32-.18.62-.66.9.08-.12.2-.28.36-.48a3 3 0 0 0 .3-.42zm-2.82 3.78c.88-1.32 1.56-2.2 2.04-2.64-.8 1.28-1.48 2.16-2.04 2.64zM25.27 71c.08.08.14.12.18.12 0 .04-.04.1-.12.18-.08.12-.12.2-.12.24-.12-.04-.14-.14-.06-.3l.12-.24zm-.36.54c.12.04.14.12.06.24-.12.16-.18.26-.18.3-.08-.08-.12-.14-.12-.18l.12-.18c.08-.08.12-.14.12-.18zm6.18 19.02c-.08 0-.1-.06-.06-.18.12 0 .14.06.06.18zM55.167 50.3v.12c.04.08.06.14.06.18.04 0 .1-.04.18-.12.08.04.16.1.24.18.08.12.14.2.18.24a8.04 8.04 0 0 0 2.16-.84c.72-.36 1.26-.66 1.62-.9.36-.24.94-.68 1.74-1.32.84-.68 1.34-1.08 1.5-1.2 3.52-3.04 6.46-5.66 8.82-7.86h.3c.04 0 .08-.06.12-.18 0-.08.04-.12.12-.12-.12.28-.46.72-1.02 1.32-.56.6-.88 1.08-.96 1.44-.56-.04-1.22.52-1.98 1.68-.08.04-.16 0-.24-.12v.36c-.32-.12-.52-.02-.6.3-.56.2-.8.44-.72.72-.4.12-.68.32-.84.6.04 0 .1-.04.18-.12.08-.08.14-.06.18.06-.12.12-.28.18-.48.18 0 .08-.02.14-.06.18h-.12c-.04 0-.08.02-.12.06l.06.18c-.12.04-.22.02-.3-.06 0 .12-.16.32-.48.6-.28.28-.42.5-.42.66l-.12-.12c.04.04.06.02.06-.06l-.06.06-.48.48c-.24.2-.42.36-.54.48.04.12.12.12.24 0 .16-.16.3-.18.42-.06.04-.24.22-.48.54-.72.36-.28.66-.38.9-.3-.12.16-.32.36-.6.6-.24.2-.42.38-.54.54.24-.16.58-.42 1.02-.78.44-.4.8-.66 1.08-.78-.36.44-.96 1-1.8 1.68-.84.64-1.44 1.18-1.8 1.62.08.08.18.08.3 0 .16-.08.26-.18.3-.3.12.08.12.22 0 .42-.08.08-.16.08-.24 0-.08.24-.04.36.12.36-1.92 1.84-3.8 2.84-5.64 3-1.6-.28-2.88-1.04-3.84-2.28-.96-1.24-1.48-2.8-1.56-4.68.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12.52-2.12.58-3.76.18-4.92.44-.44.78-1.28 1.02-2.52.2-1.24.32-1.92.36-2.04.08 0 .1.08.06.24-.04.16-.06.28-.06.36.12-.12.18-.3.18-.54.04-.28-.02-.46-.18-.54 1.6-8 3.98-16 7.14-24 .24-.44.76-1.4 1.56-2.88.84-1.52 1.46-2.62 1.86-3.3.44-.72 1.06-1.6 1.86-2.64.84-1.04 1.68-1.88 2.52-2.52 1.24.08 2.1.64 2.58 1.68.52 1 .72 2.08.6 3.24-.12 1.12-.38 2.22-.78 3.3 0 1.52-.44 3.12-1.32 4.8a98.5 98.5 0 0 1-1.8 5.04c-.68 1.72-1.28 3.16-1.8 4.32-.48 1.12-1.18 2.68-2.1 4.68-.88 2-1.54 3.52-1.98 4.56-.16.16-.3.28-.42.36 0 .04.02.12.06.24.04.08.04.16 0 .24-.4.6-.96 1.6-1.68 3-.68 1.4-1.36 2.6-2.04 3.6-.68.96-1.48 1.74-2.4 2.34-.2.24-.36.74-.48 1.5-.12.72-.24 1.18-.36 1.38.08.64.08 1.28 0 1.92-.08.6-.08 1.3 0 2.1.12.76.36 1.38.72 1.86zm12.54-47.34c-.04 0-.08-.04-.12-.12 0-.12-.04-.16-.12-.12-.04.08-.02.14.06.18.08.04.12.08.12.12-.12.08-.28.26-.48.54-.16.24-.32.4-.48.48.04-.12.02-.2-.06-.24-.12.12-.3.38-.54.78 0 .08.04.06.12-.06.12-.12.2-.12.24 0-.04.08-.16.26-.36.54-.16.24-.3.44-.42.6-.08.12-.2.26-.36.42-.16.16-.3.24-.42.24.08.28.08.5 0 .66-.04.12-.16.3-.36.54-.2.24-.32.42-.36.54 0 .08.04.14.12.18.12.04.16.12.12.24-.2 0-.32.02-.36.06-.04.04 0 .12.12.24-.04 0-.08.02-.12.06-.04.04-.1.04-.18 0 .12.16.06.46-.18.9-.2.4-.2.68 0 .84-.04 0-.12.06-.24.18-.08.08-.18.12-.3.12-.04.08-.02.14.06.18.08 0 .12.02.12.06-.16.36-.44.94-.84 1.74-.36.76-.66 1.46-.9 2.1-.24.6-.42 1.2-.54 1.8-.2.32-.46.96-.78 1.92s-.7 1.64-1.14 2.04c-.04.08 0 .14.12.18.16.04.24.08.24.12-.04.08-.12.38-.24.9-.12.48-.28.82-.48 1.02 0 .36-.12.9-.36 1.62-.2.68-.32 1.16-.36 1.44-.04.04-.12.06-.24.06-.08 0-.12.02-.12.06.12 0 .18.08.18.24.04.16 0 .3-.12.42-.08.12-.18.18-.3.18.08 1.52-.22 2.68-.9 3.48.12.12.16.3.12.54 0 .24.02.44.06.6-.12 0-.22.06-.3.18-.04.08-.08.22-.12.42 0 .16-.02.28-.06.36.16 0 .26-.08.3-.24-.64 2.6-.96 4.12-.96 4.56 1.28-2.08 2.48-4.24 3.6-6.48 1.12-2.28 2.46-5.18 4.02-8.7 1.6-3.56 2.6-5.8 3-6.72.2-.76.54-1.86 1.02-3.3.52-1.44.92-2.72 1.2-3.84.32-1.12.54-2.22.66-3.3.16-.24.24-.64.24-1.2V1.88c-.16 0-.3-.02-.42-.06-.08-.04-.2.02-.36.18l-.36.36-.3.3c-.12.16-.18.26-.18.3zm2.52.84h.12c0-.04.02-.08.06-.12.04-.04.04-.08 0-.12h-.18v.24zm.06.3c-.12.32-.14.66-.06 1.02-.04.08-.1.1-.18.06-.04-.04-.08-.06-.12-.06.04.04.08.18.12.42.04.2.1.32.18.36 0-.24.04-.58.12-1.02.08-.44.06-.7-.06-.78zm-4.68 1.2c.04 0 .18-.18.42-.54-.2 0-.34.18-.42.54zm-6.06 10.02c1.24-2.64 2.98-6.08 5.22-10.32-1.96 2.88-3.7 6.32-5.22 10.32zm10.44-8.7v-.18l.12-.24a.46.46 0 0 0 .06-.18c-.16 0-.26-.02-.3-.06-.08.08-.12.2-.12.36.04.16.12.26.24.3zm-.72 1.44h.24c0 .08-.04.14-.12.18-.08.04-.12.1-.12.18.16.04.26.02.3-.06.08-.12.12-.28.12-.48.04-.2.08-.34.12-.42-.04 0-.08-.04-.12-.12-.04-.12-.1-.18-.18-.18-.12.12-.18.28-.18.48.04.16.02.3-.06.42zm.66 0c0-.04.04-.12.12-.24.12-.2.1-.32-.06-.36 0 .08-.04.2-.12.36-.04.16-.02.24.06.24zm-6.6.54c-.04.12 0 .18.12.18.2-.04.32-.12.36-.24-.2.04-.36.06-.48.06zm5.94.48l.18-.36a.46.46 0 0 1-.18-.06c-.04-.08-.1-.1-.18-.06-.04.24.02.4.18.48zm-.18.54c-.16-.04-.26.02-.3.18-.04.04-.02.08.06.12.08-.04.16-.02.24.06.04-.04.06-.1.06-.18.04-.12.06-.24.06-.36.04-.12.06-.2.06-.24-.16 0-.26-.02-.3-.06-.04.04 0 .2.12.48zm.36.24h.12v-.18h-.12v.18zm-6.42.12h-.3c.04 0 .1.04.18.12.08.04.12 0 .12-.12zm5.58.3c.2 0 .3-.04.3-.12-.16-.04-.26 0-.3.12zm-6.12.48c.08.04.14.02.18-.06.08-.12.08-.18 0-.18 0 .04-.04.08-.12.12-.04 0-.06.04-.06.12zm6.36-.06c.04-.12.02-.18-.06-.18a.255.255 0 0 0-.24 0c0 .12.1.18.3.18zm.06.36c.4-.08.5-.26.3-.54-.12 0-.22.18-.3.54zm-.84.66c.28.16.44.16.48 0l-.06-.06c-.12 0-.16-.06-.12-.18l.48-.48c-.24-.08-.4-.16-.48-.24 0 .16-.02.28-.06.36-.04.08-.08.18-.12.3-.04.08-.08.18-.12.3zm.66.06h.12v-.12h-.12v.12zm-3.18 6.54h-.06c0 .12-.08.18-.24.18.08.2.06.38-.06.54-.08.12-.1.24-.06.36l-.36.18c-.04.08-.04.16 0 .24.04.08.06.14.06.18 0 .04-.06.06-.18.06-.08 0-.12.02-.12.06.08.2.06.42-.06.66-.08.2-.2.34-.36.42-.04.16-.06.28-.06.36.04.04.08.1.12.18.08.04.12.08.12.12-.24-.04-.4.02-.48.18-.08.16-.1.36-.06.6-.16 0-.28.08-.36.24.08.08.12.16.12.24-.08.16-.24.4-.48.72-.2.32-.36.58-.48.78-.08.16-.18.42-.3.78-.08.32-.02.58.18.78-.04 0-.08.02-.12.06-.04.04-.1.04-.18 0V26c-.4.44-.86 1.24-1.38 2.4-.48 1.16-.9 1.96-1.26 2.4 0 .12-.02.26-.06.42-.08.2-.04.32.12.36.08-.04.08-.08 0-.12a.533.533 0 0 1-.06-.24c.04-.04.14-.1.3-.18.16-.08.26-.16.3-.24 0-.2.04-.42.12-.66.12-.24.26-.5.42-.78l.36-.72c.08 0 .14.06.18.18 0 .08.04.12.12.12 0-.12.08-.26.24-.42 0 .08.02.12.06.12.04-.04.08-.12.12-.24-.04 0-.08.02-.12.06l-.06.06c0-.36.08-.54.24-.54.04-.08.02-.14-.06-.18-.08-.08-.1-.14-.06-.18.08 0 .14.04.18.12.08.08.16.1.24.06.12-.08.12-.14 0-.18-.08-.04-.12-.1-.12-.18.04-.08.08-.08.12 0 .08.04.16.06.24.06-.12-.24-.12-.56 0-.96.08.08.12.14.12.18 0 .04-.02.1-.06.18-.04.04-.06.1-.06.18.32-.44.72-1.24 1.2-2.4.48-1.2.9-2 1.26-2.4-.16-.2-.1-.34.18-.42.04-.08.04-.16 0-.24a.46.46 0 0 1-.06-.18c.24-.08.32-.24.24-.48.04 0 .1-.04.18-.12.08-.12.16-.18.24-.18 0-.08-.04-.14-.12-.18-.08-.08-.12-.14-.12-.18 0-.04.04-.06.12-.06.12 0 .18-.04.18-.12-.04-.08-.1-.1-.18-.06-.04 0-.08-.02-.12-.06 0-.16.08-.2.24-.12.04.04.08.06.12.06.04-.12.1-.32.18-.6.08-.32.16-.56.24-.72-.04 0-.1.04-.18.12-.04.08-.1.1-.18.06 0-.04.02-.1.06-.18.04-.08.02-.14-.06-.18 0 .16-.06.16-.18 0v-.12c.08.04.12.02.12-.06 0-.12.06-.16.18-.12-.04.08-.04.14 0 .18.04.04.08.04.12 0 .04 0 .06-.06.06-.18 0-.16.06-.24.18-.24 0 .04-.02.1-.06.18-.08.24-.06.38.06.42 0-.12.04-.26.12-.42.12-.16.16-.32.12-.48-.12.08-.24.04-.36-.12l.18-.12c-.12-.12-.14-.2-.06-.24.08 0 .14.06.18.18.08.12.18.18.3.18-.04-.2.02-.4.18-.6.16-.24.24-.42.24-.54 0-.04-.04-.06-.12-.06-.08 0-.14-.04-.18-.12.12-.2.2-.32.24-.36.04.08.04.16 0 .24-.04.04-.06.08-.06.12.2.04.36 0 .48-.12-.04-.08-.08-.18-.12-.3v-.36a.46.46 0 0 1 .18-.06c.12.04.18-.04.18-.24-.12 0-.24-.02-.36-.06a.982.982 0 0 0-.24-.06c0-.12.08-.2.24-.24.2-.04.32-.08.36-.12-.08.08-.12.18-.12.3.04.08.1.12.18.12v-.42c.04-.24.08-.4.12-.48-.04-.04-.08-.04-.12 0l-.06.06c-.04-.12-.02-.18.06-.18.08-.04.12-.08.12-.12-.16-.04-.16-.14 0-.3.16-.2.26-.22.3-.06 0-.04.04-.18.12-.42.12-.24.1-.38-.06-.42-.04 0-.06.06-.06.18 0 .2-.06.28-.18.24.04-.04.06-.1.06-.18v-.3c0-.08.02-.14.06-.18.04-.08.12-.12.24-.12 0-.08-.06-.14-.18-.18-.08-.08-.1-.18-.06-.3-.6.88-.7 1.36-.3 1.44-.08.2-.14.3-.18.3l-.06-.06h-.18c-.04.24-.14.56-.3.96-.16.4-.26.72-.3.96-.04.04-.12.08-.24.12-.08.04-.14.08-.18.12-.04.08-.04.16 0 .24.04.08.06.14.06.18-.08-.04-.14-.02-.18.06 0 .08-.02.12-.06.12.08.12.06.26-.06.42-.08.16-.12.3-.12.42h-.3c.04.16 0 .3-.12.42-.08.12-.12.22-.12.3.04.08.06.24.06.48zm2.46-4.44h.12v-.12h-.12v.12zm-9.54 4.32c.32-.52.68-1.38 1.08-2.58 0-.12-.04-.14-.12-.06-.04.04-.2.42-.48 1.14-.24.68-.4 1.18-.48 1.5zm9.06-2.46c.04-.04.08-.06.12-.06-.08-.08-.14-.12-.18-.12 0 .12.02.18.06.18zm-9.36 3.18c.16 0 .26-.08.3-.24.08-.16.08-.28 0-.36-.12.04-.22.24-.3.6zm-.06.3h.18v-.18h-.18v.18zm-.42 1.14c.12-.04.22-.14.3-.3.08-.2.08-.36 0-.48-.16.32-.26.58-.3.78zm.72 0c.08.08.12.04.12-.12l-.12-.12v.24zm-.12.48h.12v-.24h-.12v.24zm-.84.12c.12.04.2-.02.24-.18.04-.04.02-.08-.06-.12 0 .04-.02.08-.06.12-.08.04-.12.1-.12.18zm.12.6v-.18c0-.08-.02-.12-.06-.12 0-.04-.04-.06-.12-.06-.08.08-.1.18-.06.3.04.08.12.1.24.06zm.54 0c0-.04.02-.06.06-.06 0-.12-.04-.16-.12-.12 0 .12.02.18.06.18zm-1.38 1.68c.16-.16.3-.42.42-.78.16-.4.2-.66.12-.78l-.24.72c-.12.36-.22.64-.3.84zm1.74-.12h.18v-.18h-.18v.18zm-1.8.36h.06c.04.04.08.06.12.06-.08-.16-.14-.24-.18-.24v.18zm-.3 1.14c0-.08.04-.2.12-.36.12-.16.18-.28.18-.36.04-.08.02-.16-.06-.24 0 .08-.06.24-.18.48-.08.2-.1.36-.06.48zm-.24.66c.16 0 .24-.12.24-.36-.12.04-.2.16-.24.36zm-.3 1.5c0-.12.04-.24.12-.36.08-.12.14-.24.18-.36-.04 0-.08-.02-.12-.06-.04-.04-.08-.04-.12 0 0 .08-.02.18-.06.3-.04.12-.08.22-.12.3 0 .04.04.1.12.18zm.9.54c.08.04.14.04.18 0 .04-.08.02-.14-.06-.18-.04-.04-.08-.04-.12 0v.18zm-1.2.36h.12v-.24h-.12v.24zm1.14.18h.18v-.18h-.18v.18zm4.26 1.38h.12v-.18h-.12v.18zm.3.12c.08.04.14-.02.18-.18.04-.04.02-.08-.06-.12 0 .04-.04.08-.12.12-.04.04-.04.1 0 .18zm-.6.72c0-.08.04-.18.12-.3.08-.16.14-.3.18-.42-.12.04-.22.16-.3.36-.08.16-.08.28 0 .36zm.3 0c.08-.04.14-.12.18-.24.04-.12.08-.2.12-.24-.2 0-.3.16-.3.48zm-6.6 2.82c.12-.12.14-.24.06-.36-.04-.04-.1-.06-.18-.06v.24c-.04.08 0 .14.12.18zm-.18.18h.18v-.12h-.18v.12zm15.9 7.5c.16 0 .26-.06.3-.18 0-.04-.04-.08-.12-.12 0 .08-.04.12-.12.12a.46.46 0 0 0-.06.18zm-17.4 3.78c0 .04-.02.08-.06.12v.06c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18zm.06.48l-.06-.06-.06-.06c0 .04.04.08.12.12zm.36 2.46c0-.2-.02-.3-.06-.3-.12.16-.1.26.06.3zm9.36.66c.08 0 .3-.12.66-.36-.04 0-.06-.04-.06-.12l-.06-.06-.54.54zm1.14-.12c.2 0 .3-.08.3-.24-.12 0-.22.08-.3.24zm-1.86.6v.12h.18c.08-.08.04-.14-.12-.18 0 .04-.02.06-.06.06zm.66 1.14c0-.04.02-.06.06-.06.08-.08.1-.16.06-.24-.12-.04-.18.02-.18.18-.04.04-.02.08.06.12zm-.24.42c.08.04.16.02.24-.06.08-.08.08-.14 0-.18 0 .04-.04.08-.12.12-.12 0-.16.04-.12.12zm-2.76.9c.48-.2.72-.34.72-.42-.04.08-.16.14-.36.18-.2.08-.32.16-.36.24zm1.62-.06c.2-.08.32-.16.36-.24-.16-.04-.28.04-.36.24zm8.52-43.38c.16.04.18.14.06.3-.04 0-.06-.1-.06-.3zm-1.8 6.72l-.18.18c.12.04.18-.02.18-.18zm-.66 1.62c0-.24.08-.36.24-.36-.08.24-.16.36-.24.36zm-.3-.18h.18v.12h-.18v-.12zm-.12.36l.06.24c0 .08-.04.1-.12.06.04-.04.06-.14.06-.3zm.06.42h.12v.12h-.12v-.12zm-1.32 2.64c.16.08.24.18.24.3-.16-.08-.24-.18-.24-.3zm.24.36v.24c-.16.08-.28 0-.36-.24.04-.04.08-.04.12 0h.24zm-.48.6c-.04 0-.08.04-.12.12 0 .08-.04.12-.12.12l.06-.12c0-.12.06-.16.18-.12zm-.36.42c.08 0 .14.02.18.06.08.08.14.12.18.12-.04.24-.16.26-.36.06a.255.255 0 0 1 0-.24zm-.24.6c.2 0 .3.06.3.18-.2 0-.3-.06-.3-.18zm.06.54v.24-.24zm-.72.9c.12 0 .18.12.18.36-.12.04-.2.02-.24-.06-.04-.12-.02-.22.06-.3zm0 .48c.16 0 .24.06.24.18h-.24v-.18zm-.3.3c.04-.04.08-.06.12-.06.08 0 .12.02.12.06.04.08 0 .12-.12.12-.08 0-.12-.04-.12-.12zm0 .42h.18v.18h-.18v-.18zm-.48.6c.04-.04.08-.04.12 0 .04.04.08.06.12.06 0 .08-.06.12-.18.12-.08-.04-.1-.1-.06-.18zm-.48 1.62l.12-.12c.08.04.08.12 0 .24-.04.04-.06.08-.06.12-.12 0-.14-.08-.06-.24zm-1.2 2.34c0 .2-.06.3-.18.3-.2-.2-.14-.3.18-.3zm10.44 11.22c.12.08.02.26-.3.54-.12.08-.18.16-.18.24-.08-.12.08-.38.48-.78zm-.9 1.08c-.12.32-.32.54-.6.66.04-.16.24-.38.6-.66zm-1.14.96c.08 0 .12.06.12.18-.04.04-.08.04-.12 0-.04-.04-.08-.06-.12-.06l.12-.12zm-.18.24h.18v.18h-.18v-.18zm-.9 1.02c-.04-.04-.04-.08 0-.12.08.04.14.08.18.12h-.18zm0 0c0 .08-.04.16-.12.24-.08 0-.1-.04-.06-.12.04-.12.1-.16.18-.12zm.9.06c.12.08.08.16-.12.24 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12zm-1.08.3h.24c-.04 0-.08.06-.12.18 0 .08-.04.1-.12.06v-.24zm.78 0h.18v.18c-.04-.04-.06-.02-.06.06h-.18v-.18c.04.04.06.02.06-.06zm-1.5.54c0-.16.08-.24.24-.24 0 .16-.08.24-.24.24zm.72-.24h.36c-.4.4-.7.68-.9.84-.08.04-.14.04-.18 0-.04-.08-.08-.12-.12-.12.24-.12.38-.28.42-.48.04 0 .08.02.12.06.04.04.08.06.12.06.04 0 .02-.04-.06-.12a.46.46 0 0 1-.06-.18c.04 0 .1.02.18.06l.06.06c.04-.04.06-.1.06-.18zm-1.14.06h.06-.06zm.42.18c.04.08.02.14-.06.18-.04.04-.12.04-.24 0 .08-.16.18-.22.3-.18zm.96.36c-.4.56-1.16 1.34-2.28 2.34-1.12.96-1.78 1.54-1.98 1.74 0 .04.02.06.06.06.08-.04.14-.08.18-.12-.04.16-.24.4-.6.72-.36.28-.56.5-.6.66-.04 0-.08-.04-.12-.12 0-.08-.04-.1-.12-.06.12-.24.16-.5.12-.78.04 0 .18.04.42.12.08 0 .08-.02 0-.06-.08-.04-.1-.1-.06-.18 2.24-1.92 3.9-3.36 4.98-4.32zm-4.68 4.44c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18 0 .04-.02.08-.06.12-.04.04-.06.08-.06.12zm3.36-4.26c.08-.04.14-.02.18.06.04.08.1.12.18.12-.04.08-.12.18-.24.3l-.18.18c-.16-.08-.24-.18-.24-.3.04-.04.1-.04.18 0h.18c0-.04-.02-.08-.06-.12a.255.255 0 0 1 0-.24zm-.18.78c-.2-.04-.38-.04-.54 0 0-.08.04-.14.12-.18.28-.08.42-.02.42.18zm-.9-.12h.18v.12h-.18v-.12zm-.12.42c-.12 0-.18-.06-.18-.18.12 0 .2.02.24.06 0 .04-.02.06-.06.06v.06zm.36-.06c.12.04.2.04.24 0 .08-.08.16-.12.24-.12 0 .04-.04.08-.12.12-.04 0-.04.04 0 .12l-.36-.12zm-.72.06c.16.2.26.32.3.36-.12.04-.22-.08-.3-.36zm.36 0c.16 0 .2.06.12.18h-.12v-.18zm-.6.42h.18v.24h-.24v-.12c.04 0 .06-.04.06-.12zm-13.8.12h.12v.12h-.12v-.12zm13.14.18h.18v.18h-.18v-.18zm.24 0h.3c-.08.16-.18.24-.3.24v-.24zm.36 1.32c.08.04.08.1 0 .18-.08.04-.16.04-.24 0 0-.04.04-.06.12-.06.08-.04.12-.08.12-.12zm-.6.42c.16.04.18.12.06.24-.04.04-.1.06-.18.06-.04-.08-.04-.14 0-.18.08-.04.12-.08.12-.12zm-10.2 1.5c.04 0 .14.14.3.42-.2 0-.3-.14-.3-.42zm8.4.18c.12-.04.18.02.18.18h-.24c.04-.04.06-.1.06-.18zm-7.8 1.08c-.04 0-.08-.02-.12-.06l-.12-.12c0-.12-.04-.26-.12-.42.08-.08.14-.06.18.06.08.12.14.3.18.54zM76.046 28.1c.36.64.42 1.3.18 1.98-.2.64-.62 1.06-1.26 1.26-1.08-.4-1.68-.92-1.8-1.56.16-.12.4-.36.72-.72.36-.36.7-.62 1.02-.78.32-.16.7-.22 1.14-.18zm1.5 18.18v.12c-.48.24-.82.44-1.02.6.44.08.78-.12 1.02-.6.36-.04 1.24-.52 2.64-1.44.28-.08.66-.3 1.14-.66.52-.36.96-.6 1.32-.72.44-.36 1.62-1.12 3.54-2.28 0 .04-.04.12-.12.24-.08.12-.1.24-.06.36-.8.12-1.42.52-1.86 1.2-.68.32-1.4.72-2.16 1.2-.76.48-1.6 1.02-2.52 1.62-.92.6-1.64 1.06-2.16 1.38-.12 0-.18.04-.18.12.12 0 .18-.04.18-.12 1.72-.96 2.62-1.48 2.7-1.56.48-.24 1.24-.7 2.28-1.38 1.04-.72 1.66-1.14 1.86-1.26.16.04.28 0 .36-.12.12-.12.24-.18.36-.18.04.08.02.16-.06.24-.08.04-.1.1-.06.18-.4 0-.6.1-.6.3l-.06.06c-.04.04-.1.08-.18.12-.04.04-.08.06-.12.06 0 .16.08.22.24.18-.04.08-.16.12-.36.12.04.2-.04.4-.24.6-.16 0-.26-.08-.3-.24 0-.12.08-.18.24-.18-.2-.12-.44.02-.72.42-.28.36-.52.54-.72.54l.12.18c.12.12.12.2 0 .24-.28 0-.4-.08-.36-.24-.04 0-.08.04-.12.12 0 .08-.04.1-.12.06 0 .08.04.12.12.12.12 0 .16.06.12.18-.12.08-.22.08-.3 0a.407.407 0 0 0-.3-.12c-.04.12-.02.2.06.24.04.04.06.08.06.12-.08.04-.16.02-.24-.06-.04-.08-.1-.1-.18-.06-.04.08-.02.14.06.18.08 0 .12.02.12.06-.92.84-1.8 1.46-2.64 1.86-.04 0-.06.1-.06.3-.36 0-.58.2-.66.6-1.04.8-2.24 1.34-3.6 1.62-1.32.32-2.58.22-3.78-.3-1.24-.48-2.04-1.44-2.4-2.88-.04-.68.06-1.62.3-2.82.16-.44.42-1.24.78-2.4.36-1.16.74-2.1 1.14-2.82.36-.72.86-1.32 1.5-1.8 1.08.12 1.74.76 1.98 1.92-.24.08-.44.12-.6.12-1.4 2.4-2.28 4.76-2.64 7.08-.28.36-.34 1.04-.18 2.04 1.56.24 3.82-.46 6.78-2.1 0-.04-.02-.08-.06-.12-.04-.08-.04-.14 0-.18.4-.08.64-.1.72-.06zm-.9 1.38c.12 0 .2-.02.24-.06.08-.04.1-.1.06-.18-.12 0-.22.08-.3.24zm9.72-6.36c.2 0 .3-.04.3-.12h.18c0-.12-.06-.18-.18-.18.04-.04.14-.12.3-.24.16-.16.26-.32.3-.48-.88.4-2.12 1.14-3.72 2.22-1.6 1.04-2.82 1.74-3.66 2.1 0 .08.06.16.18.24-.28.08-.62.28-1.02.6-.4.28-.74.46-1.02.54 0-.08-.02-.12-.06-.12 4.24-3 7.72-5.12 10.44-6.36 0 .04-.08.1-.24.18-.16.08-.24.14-.24.18 0 .08.06.08.18 0s.22-.1.3-.06c-.12.12-.32.34-.6.66-.24.28-.48.52-.72.72-.2.16-.46.28-.78.36 0-.04.02-.08.06-.12.04-.04.04-.08 0-.12zm.96-1.02c.2 0 .3-.06.3-.18-.2 0-.3.06-.3.18zm-.66.9c-.16 0-.26.04-.3.12h-.18c.04-.08.1-.14.18-.18.08-.04.14-.08.18-.12 0 .04.02.08.06.12.04 0 .06.02.06.06zm-.48.9c0 .04-.1.1-.3.18 0-.12.1-.18.3-.18zm-1.14.66c.04-.28.3-.42.78-.42-.16.2-.42.34-.78.42zm-.18.06c0-.04.06-.06.18-.06-.04.04-.1.06-.18.06zm-.72.72h.18v.24c-.2 0-.28-.06-.24-.18.04 0 .06-.02.06-.06zm-1.38 1.26c.08-.16.2-.16.36 0-.04.08-.16.08-.36 0zm-2.7.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm2.52 0c.2.08.2.2 0 .36-.16.12-.28.14-.36.06 0-.04.04-.1.12-.18.12-.08.2-.16.24-.24zm-2.46.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm-2.46.96h.24c0 .04-.02.1-.06.18-.04.04-.02.06.06.06-.08.08-.16 0-.24-.24zm16.37-9.42l.18.36c.28-.04.7.08 1.26.36 0 .04-.06.06-.18.06.84.84 1.14 1.56.9 2.16 0 .04.06.04.18 0 .12-.08.22-.08.3 0 0 .08-.04.18-.12.3-.04.08-.04.18 0 .3h-.18c-.08 0-.16.02-.24.06.08.04.14.16.18.36 0 .12.04.14.12.06.04.12.04.2 0 .24 0 .04-.06.12-.18.24-.08.08-.12.14-.12.18.04 0 .1-.02.18-.06.04-.04.1-.04.18 0-.16.16-.3.46-.42.9-.08.4-.2.7-.36.9 0 .04.1.06.3.06-.56 1.4-.46 2.84.3 4.32 0 .16-.14.22-.42.18-.24-.04-.38-.06-.42-.06-.8-.64-1.26-1.46-1.38-2.46-.12-1-.08-2.18.12-3.54.2-1.4.24-2.5.12-3.3-.32.2-.7.6-1.14 1.2-.44.56-.8.94-1.08 1.14-.76 1.56-1.56 2.8-2.4 3.72-.16.24-.44.72-.84 1.44-.36.72-.66 1.24-.9 1.56-.2.32-.54.68-1.02 1.08-.48.36-1.02.56-1.62.6-.8-.36-1.2-1.1-1.2-2.22-.04-1.16.18-2.12.66-2.88.12-.72.68-2.4 1.68-5.04 1.28.08 2.08.36 2.4.84-.08.28-.26.68-.54 1.2-.24.52-.4.94-.48 1.26.24-.16.52-.48.84-.96.32-.52.6-.86.84-1.02.12-.16.38-.56.78-1.2.44-.68.76-1.14.96-1.38.24-.28.6-.54 1.08-.78.52-.24 1.08-.3 1.68-.18zm-1.32.66h.18c0-.12-.06-.18-.18-.18v.18zm.42.24c-.12.08-.28.28-.48.6-.16.28-.34.44-.54.48 0-.04-.02-.06-.06-.06v-.06c0-.08.14-.16.42-.24 0-.04.02-.1.06-.18.04-.12.06-.2.06-.24 0-.04-.02-.1-.06-.18 0 .08-.04.1-.12.06-.04-.08-.1-.1-.18-.06-.16.36-.6.62-1.32.78-.04.08-.02.14.06.18.08.04.12.08.12.12-.12 0-.22.08-.3.24-.12-.04-.3.12-.54.48.36-.12.56-.12.6 0 0 .04-.02.1-.06.18-.04-.04-.28-.06-.72-.06v.36c0 .04-.06.04-.18 0-.04.12 0 .22.12.3.16.04.24.1.24.18-.08.04-.14.04-.18 0-.04-.04-.1-.06-.18-.06 0 .04-.02.1-.06.18l-.12.12c-.04.04-.06.08-.06.12.16.08.26.06.3-.06.04-.12.12-.16.24-.12-.04.04-.08.1-.12.18 0 .08-.02.16-.06.24-.04.04-.08.06-.12.06 0-.04-.04-.08-.12-.12h-.18v.3c.04.12.04.18 0 .18-.2-.12-.32-.12-.36 0 .24.08.3.22.18.42-.08.08-.12.14-.12.18.24 0 .44-.18.6-.54.16-.36.42-.52.78-.48.08-.24.22-.36.42-.36a.46.46 0 0 1-.06-.18c.04-.08.1-.14.18-.18l.18-.18c.04-.04.1-.08.18-.12.12-.04.2-.08.24-.12.08-.4.34-.84.78-1.32.48-.52.76-.9.84-1.14-.08-.04-.14-.02-.18.06-.04.04-.08.06-.12.06v-.18c-.08.04-.16.06-.24.06-.08-.04-.12-.02-.12.06.08.08.2.1.36.06zm-3.96 4.8c.32-.04.3-.16-.06-.36 0 .04.02.1.06.18.04.04.04.1 0 .18zm5.7.72c.08.04.12.02.12-.06l-.06-.24c0 .04-.02.08-.06.12-.04.04-.04.1 0 .18zm0 .42v.12c.04.04.08.04.12 0 0-.08-.02-.14-.06-.18 0 .04-.02.06-.06.06zm-.24.66c.16 0 .28-.12.36-.36-.28 0-.4.12-.36.36zm0 .42c.12 0 .18-.06.18-.18 0-.08-.04-.12-.12-.12 0 .04-.02.1-.06.18v.12zm-3.84-5.58c-.04.2.02.3.18.3.32-.08.48-.26.48-.54-.2 0-.3.12-.3.36a.46.46 0 0 1-.18-.06c-.04-.08-.1-.1-.18-.06zm1.32-.24c-.08.04-.18.12-.3.24-.08.12-.14.2-.18.24.08-.32.24-.48.48-.48zm-.6.6c.04.12 0 .24-.12.36-.12.08-.22.08-.3 0 .04 0 .1-.06.18-.18.08-.12.16-.18.24-.18zm-.84.6c-.08.16-.2.24-.36.24 0-.28.12-.36.36-.24zm.12.3h.18v.12h-.18v-.12zm-.18.12c.24 0 .24.14 0 .42-.08.08-.16.12-.24.12 0-.12.04-.22.12-.3.08-.08.12-.16.12-.24zm17.897.78c1.28-1.76 2.64-3.26 4.08-4.5.32-.04.66.04 1.02.24.36.16.58.24.66.24.4.92.64 2 .72 3.24.12 1.2.16 2.64.12 4.32-.04 1.64-.06 2.72-.06 3.24 0 .04.04.08.12.12.08 0 .1.04.06.12 2-.28 3.76 0 5.28.84 1.52.8 2.6 2 3.24 3.6 0 .08-.04.14-.12.18-.04.08-.04.16 0 .24.16.4.3.7.42.9.04.08 0 .14-.12.18-.08.04-.12.08-.12.12.24.6.22.96-.06 1.08 0-2.12-.82-3.68-2.46-4.68-1.6-1-3.62-1.18-6.06-.54-.08.44-.18 1.58-.3 3.42-.12 1.88-.38 3.24-.78 4.08.04.04.1.06.18.06l.06.06c-.08 1.8-.36 3.42-.84 4.86.08.16.08.4 0 .72-.04.36-.16.58-.36.66 0 .04.06.06.18.06-.16.44-.34 1.12-.54 2.04-.16.96-.36 1.82-.6 2.58s-.56 1.42-.96 1.98c0 .04.02.08.06.12.04.08.06.14.06.18.04.08.06.16.06.24l-.12.12c-.08.08-.16.1-.24.06-.2 1.44-.66 2.48-1.38 3.12.24 0 .26.18.06.54-.08.12-.2.22-.36.3.16.44.02.78-.42 1.02 0 .36-.06.68-.18.96-.12.28-.36.66-.72 1.14-.36.52-.56.8-.6.84.28.16.26.34-.06.54-.08.04-.18.06-.3.06.12.12.14.3.06.54-.08.04-.16.02-.24-.06 0 .08.02.14.06.18.04.04.06.08.06.12h-.18c-.08.04-.14.08-.18.12.08.08.08.18 0 .3s-.12.22-.12.3c-.16.12-.36.42-.6.9-.24.48-.48.78-.72.9-1.12 2.32-3.2 4.08-6.24 5.28-1.08 0-2.06-.22-2.94-.66-.88-.44-1.6-.94-2.16-1.5-.56-.52-1.1-1.3-1.62-2.34-.56-1-.94-1.8-1.14-2.4-.24-.56-.54-1.38-.9-2.46.08-.24.1-.44.06-.6-.96-4.76.34-9.8 3.9-15.12.2-.48.46-.96.78-1.44s.58-.84.78-1.08c.2-.24.56-.66 1.08-1.26.52-.56.84-.9.96-1.02-4 5.08-6.42 9.94-7.26 14.58 0 .28-.06.96-.18 2.04-.12 1.12-.08 1.7.12 1.74 0-.52.08-1.32.24-2.4.16-1.08.24-1.82.24-2.22.2-.4.24-.66.12-.78 1.96-5.56 4.32-9.8 7.08-12.72v-.12c-.04-.04-.06-.08-.06-.12.56-.12 1.16-.78 1.8-1.98l.18.18 1.44-1.44c.72-.64 1.2-1.12 1.44-1.44.08-.04.14-.04.18 0 .04.04.08.06.12.06.12-.4.36-.6.72-.6 0-.24-.04-.34-.12-.3 0-.04.02-.06.06-.06l.06-.12c.08 0 .12.04.12.12-.04.08 0 .14.12.18.12-.08.26-.18.42-.3.16-.12.28-.22.36-.3.12-.04.24-.14.36-.3.12-.12.22-.26.3-.42.24.08.52-.02.84-.3.36-.24.6-.36.72-.36.08-.04.1-.1.06-.18-.04-.08-.04-.14 0-.18.08.04.12.08.12.12l.06.06c.08-.04.12-.12.12-.24.04-.12.14-.16.3-.12 0 .04-.02.06-.06.06l-.06.12c.68-.24 1-.48.96-.72.16.24.36.24.6 0 .12-.08.14-.18.06-.3.12 0 .18.06.18.18l.06.06c.08-.04.22-.1.42-.18.24-.12.4-.22.48-.3.16-.12.32-.16.48-.12v-.24c.12-.08.28-.14.48-.18.2-.04.36-.08.48-.12.12-.08.18-.18.18-.3.12 0 .26-.04.42-.12.16-.08.28-.12.36-.12.04-1.28.02-4.3-.06-9.06-.52.64-1.44 1.84-2.76 3.6-1.32 1.76-2.48 3.2-3.48 4.32a28.6 28.6 0 0 1-3.18 3.06c-.44-.04-.76.04-.96.24-.72-.08-1.54-.62-2.46-1.62-.16-2.32.34-4.6 1.5-6.84 1.2-2.28 2.7-4.18 4.5-5.7.12.04.36.08.72.12.36.04.6.08.72.12.16 0 .36.06.6.18.28.08.48.16.6.24.16.08.3.22.42.42.12.16.2.36.24.6-.08 0-.12.02-.12.06.28.88.08 1.6-.6 2.16-.68.56-1.42.56-2.22 0-.04-.16-.04-.38 0-.66.08-.28.1-.52.06-.72-1.96 1.96-3.5 5.1-4.62 9.42.88-.52 1.7-1.18 2.46-1.98s1.54-1.7 2.34-2.7c.84-1.04 1.5-1.82 1.98-2.34 0-.08-.04-.12-.12-.12zm2.58-1.2h-.06c-.16.12-.28.32-.36.6.12-.04.26-.24.42-.6l.36-.36c.16-.16.3-.32.42-.48.12-.16.22-.32.3-.48h.12c0-.08.04-.14.12-.18a.94.94 0 0 0 .18-.24c.08-.08.1-.14.06-.18 0 .04-.04.06-.12.06-.04 0-.06-.02-.06-.06.24-.2.28-.38.12-.54-2.6 2.52-4.76 5.02-6.48 7.5.56-.44 1.1-.94 1.62-1.5.56-.56 1.16-1.22 1.8-1.98.68-.8 1.18-1.36 1.5-1.68v.06c.04 0 .06.02.06.06zm-.66.96c0-.04.02-.08.06-.12.04-.04.06-.08.06-.12-.08-.04-.14-.02-.18.06-.04.08-.02.14.06.18zm-4.74 4.5c.12.04.22 0 .3-.12.08-.12.08-.22 0-.3 0 .04-.06.1-.18.18-.12.08-.16.16-.12.24zm9.54 3.3c.88 0 1.4-.06 1.56-.18-.96.08-1.48.14-1.56.18zm1.62 0c.08-.04.18-.06.3-.06.12-.04.2-.06.24-.06-.08-.08-.2-.12-.36-.12-.12 0-.18.08-.18.24zm1.26-.18v.12c.04.04.08.04.12 0v-.18c0 .04-.04.06-.12.06zm.9.3c0-.16-.08-.24-.24-.24 0 .16.08.24.24.24zm-3.24.36c1 0 1.58-.04 1.74-.12-.24-.2-.82-.16-1.74.12zm2.34 0c.16 0 .26.02.3.06.04-.16-.02-.28-.18-.36-.08.08-.12.18-.12.3zm-.36 0c.08-.12.08-.2 0-.24v.24zm-5.52.06v.18c0 .12.02.18.06.18.04-.12.16-.14.36-.06.08-.2.2-.28.36-.24.04-.08 0-.14-.12-.18-.12-.04-.18-.08-.18-.12-.08.08-.24.16-.48.24zm3.48.12h-.18v.18c.12 0 .18-.06.18-.18zm-23.64 21.96c-.04.04-.04.14 0 .3 0 .16-.02.28-.06.36-.04.08-.14.12-.3.12-.04.08 0 .14.12.18.08.04.12.08.12.12h-.3c.04.24.06.6.06 1.08-.08-.04-.14-.02-.18.06-.04.08-.08.12-.12.12.08.2.06.58-.06 1.14-.16.56-.14.9.06 1.02-.04-.16-.02-.36.06-.6s.06-.4-.06-.48c.2-.48.52-1.58.96-3.3.44-1.68.9-2.9 1.38-3.66 0-.16-.04-.36-.12-.6h.36v-.24c0-.12.02-.2.06-.24h.18c0-.28.12-.58.36-.9v.12h.12c.04-.08 0-.12-.12-.12.12-.36.34-.68.66-.96-.08-.08-.04-.2.12-.36.12-.16.12-.32 0-.48.08 0 .18-.08.3-.24.08-.12.2-.16.36-.12 0-.08-.02-.16-.06-.24-.04-.04-.06-.08-.06-.12.68-.68.98-1.22.9-1.62.36-.08.72-.42 1.08-1.02.36-.6.68-.92.96-.96.04-.24.2-.52.48-.84.24-.28.46-.34.66-.18 0-.6.26-.96.78-1.08.16 0 .24-.04.24-.12-.08 0-.16.04-.24.12-.04 0-.06-.02-.06-.06.12-.08.42-.4.9-.96.52-.52.94-.86 1.26-1.02-.08-.12-.02-.22.18-.3.24-.04.32-.12.24-.24.04.04.12.06.24.06 0-.2.02-.3.06-.3 0 .12.04.18.12.18.16-.32.52-.68 1.08-1.08.56-.36.92-.66 1.08-.9.04.04.06.1.06.18.08.16.18.22.3.18 0-.04-.02-.1-.06-.18-.08-.16-.06-.26.06-.3.08-.04.12 0 .12.12.04.16.08.24.12.24 0-.08.06-.16.18-.24.16-.04.24-.08.24-.12-.04-.08-.1-.1-.18-.06-.04.04-.1.04-.18 0-.04 0-.06-.06-.06-.18.16.04.26-.02.3-.18.04-.12.14-.18.3-.18 0 .08.06.14.18.18-.08-.04-.1-.12-.06-.24.04-.08.08-.12.12-.12.36 0 .84-.3 1.44-.9.24.08.64-.06 1.2-.42.6-.32 1-.48 1.2-.48.04-.12.18-.24.42-.36.28-.16.46-.32.54-.48-2.32.76-4.94 2.16-7.86 4.2l-.06-.06c-.04-.04-.08-.06-.12-.06-.04.04-.06.08-.06.12.04.08.06.16.06.24-.2.16-.74.6-1.62 1.32-.84.76-1.44 1.3-1.8 1.62-.36.32-.82.8-1.38 1.44-.56.64-1.02 1.26-1.38 1.86-.08-.08-.18-.06-.3.06-.16.12-.28.12-.36 0 0 .08.04.14.12.18.04.08.06.14.06.18-.28.2-.64.64-1.08 1.32-.48.72-.92 1.14-1.32 1.26.04.08.08.12.12.12l.12.06c-.8 1.52-1.24 2.34-1.32 2.46.16 0 .24.02.24.06-.6.84-1.3 2.68-2.1 5.52zm20.22-21.3c.2 0 .3-.08.3-.24-.2.12-.3.2-.3.24zm.3.24h.12v-.18h-.12v.18zm-1.74.48c.2 0 .3-.08.3-.24-.2 0-.3.08-.3.24zm-8.34 6.36c-1.12 1.32-2.6 2.96-4.44 4.92-.2.64-.48 1.04-.84 1.2.2.04.2.16 0 .36-.12.12-.26.14-.42.06 0 .04.02.1.06.18.04.08.04.16 0 .24-1.48 1.88-2.5 4.16-3.06 6.84-.24.28-.42.74-.54 1.38-.12.68-.28 1.16-.48 1.44-.4 5.48.32 9.42 2.16 11.82.6.24 1.22.32 1.86.24.64-.08 1.2-.16 1.68-.24.44-.08.9-.3 1.38-.66.48-.36.88-.7 1.2-1.02.36-.28.74-.68 1.14-1.2.4-.48.72-.9.96-1.26s.54-.8.9-1.32.66-.92.9-1.2c.28-.6.74-1.5 1.38-2.7.64-1.16 1.18-2.24 1.62-3.24.44-.96.78-1.96 1.02-3 .4-.6.82-1.68 1.26-3.24.44-1.56.76-2.58.96-3.06.64-3.84 1.08-6.12 1.32-6.84 0-.08-.06-.16-.18-.24-.12-.04-.16-.1-.12-.18.32-.68.52-1.58.6-2.7.08-1.12.2-1.96.36-2.52-.2-.16-.36-.34-.48-.54-3.76 1.84-7.16 4-10.2 6.48zm8.04-6.24c.16.04.24 0 .24-.12-.16 0-.24.04-.24.12zm-1.98.72c-.04.12-.02.18.06.18.08.04.14.06.18.06.08 0 .12.04.12.12.32-.12.5-.24.54-.36-.04 0-.08.02-.12.06-.16.08-.26.06-.3-.06.04-.04.14-.1.3-.18.2-.04.3-.12.3-.24-.24.12-.6.26-1.08.42zm1.44-.24v.12h.12c.12-.12.1-.2-.06-.24 0 .08-.02.12-.06.12zm-3.12 1.8c.16 0 .24-.06.24-.18h-.18c0 .08-.02.14-.06.18zm-.84.6h.12v-.12h-.12v.12zm-1.26.48c-.08 0-.12.06-.12.18.08-.08.12-.14.12-.18.36-.08.56-.2.6-.36-.16 0-.36.12-.6.36zm-.6.72c0 .04-.06.08-.18.12-.08.08-.12.16-.12.24.44-.2.72-.42.84-.66-.08 0-.16.06-.24.18-.08.12-.18.16-.3.12-.04-.08-.02-.14.06-.18.08 0 .1-.04.06-.12h-.18c-.08 0-.14.02-.18.06-.04.04-.06.12-.06.24h.3zm.72.06h.12v-.18h-.12v.18zm-1.44.66c.12 0 .18-.06.18-.18-.12 0-.18.06-.18.18zm-.66.48c.12.12.24.08.36-.12-.16-.04-.28 0-.36.12zm-.78.78c.08 0 .18-.04.3-.12.12-.08.14-.16.06-.24l-.36.36c-.12-.04-.14-.1-.06-.18.08-.08.12-.14.12-.18-.12 0-.22.06-.3.18-.08.12-.18.16-.3.12.08.08.08.14 0 .18-.08.08-.12.16-.12.24.08-.04.16-.04.24 0 .12.04.2 0 .24-.12-.04-.08-.1-.1-.18-.06l.06-.12c0-.04.02-.06.06-.06 0 .08.04.12.12.12.08 0 .12-.04.12-.12zm-.84.9c.04-.08.08-.14.12-.18.08-.04.12-.08.12-.12-.12-.04-.22 0-.3.12-.04.08-.02.14.06.18zm-.42.42h.18v-.18h-.18v.18zm-.36.18c.08.04.16-.04.24-.24h-.24v.24zm.66-.06c.08 0 .16-.04.24-.12-.16 0-.24.04-.24.12zm-2.76.6c.12 0 .22-.06.3-.18.08-.12.14-.2.18-.24-.28.08-.44.22-.48.42zm1.74-.24v.18h.18c0-.08.02-.12.06-.12v-.12h-.18c0 .04-.02.06-.06.06zm-2.1.66c.16 0 .24-.1.24-.3-.08 0-.16.1-.24.3zm.9.96c0-.04.02-.08.06-.12.04-.04.06-.08.06-.12-.2-.16-.42-.06-.66.3.32-.08.5-.1.54-.06zm-2.94 1.62c.08.04.14-.02.18-.18.04-.04.02-.08-.06-.12 0 .04-.02.08-.06.12-.08.04-.1.1-.06.18zm-.54.78c.08.04.16-.04.24-.24-.08-.04-.14-.04-.18 0-.04.08-.06.16-.06.24zm.3 1.62h.3c0-.2-.02-.3-.06-.3 0 .04-.04.08-.12.12-.08.04-.12.1-.12.18zm-1.32 0h.18v-.18h-.18v.18zm1.08.72c0-.04.04-.12.12-.24.04-.08.08-.14.12-.18 0-.04-.02-.1-.06-.18-.24.36-.3.56-.18.6zm-.42.48c.12.08.2.04.24-.12.04-.08.02-.14-.06-.18 0 .04-.02.08-.06.12-.04.08-.08.14-.12.18zm16.44.36v.18c.08.04.12 0 .12-.12.04-.08.02-.12-.06-.12 0 .04-.02.06-.06.06zm-.18.3c.04.04.04.06 0 .06v-.06zm-16.38.24c-.04 0-.1-.04-.18-.12-.08.08-.02.12.18.12zm16.56.78c.08.04.12 0 .12-.12l.06-.12h-.18v.24zm-17.46.3c.16.04.24-.04.24-.24 0-.08-.02-.12-.06-.12l-.18.36zm16.8.48c.16.08.26-.02.3-.3 0-.08-.02-.14-.06-.18 0 .08-.04.16-.12.24-.08.08-.12.16-.12.24zm0 .6c.24-.24.24-.4 0-.48 0 .08-.02.16-.06.24-.08.12-.06.2.06.24zm-.66.18h.18v-.12h-.18v.12zm-.06.3c.04.08.08.08.12 0 .04-.08.02-.12-.06-.12 0 .04-.02.06-.06.06v.06zm.72.3h.12c0-.04.04-.1.12-.18-.04 0-.08-.02-.12-.06h-.12v.24zm-.96.66c0-.04.04-.1.12-.18.04-.04.06-.1.06-.18-.2-.04-.3.04-.3.24 0 .08.04.12.12.12zm.18.54c.2-.04.32-.24.36-.6 0-.16-.06-.24-.18-.24 0 .32-.06.6-.18.84zm-.42.18c0-.08.02-.18.06-.3.04-.12.08-.22.12-.3-.12 0-.22.08-.3.24-.04.2 0 .32.12.36zm-.36.96c.16-.48.22-.76.18-.84-.24.28-.3.56-.18.84zm-16.5-.54c0-.08.02-.1.06-.06 0-.12-.04-.18-.12-.18 0 .16.02.24.06.24zm16.02 1.38c.16 0 .24-.1.24-.3.04-.16.02-.26-.06-.3 0 .04-.06.12-.18.24a.3.3 0 0 0 0 .36zm.66-.36h.18c.04-.12 0-.2-.12-.24.04.08.02.16-.06.24zm-.36.84h.18v-.12h-.18v.12zm.36 0h.18v-.12h-.18v.12zm-1.14 2.04c.44-1 .64-1.52.6-1.56-.4.8-.6 1.32-.6 1.56zm-.66-.3c.24-.04.38-.06.42-.06 0-.16.08-.36.24-.6.16-.2.2-.36.12-.48-.4.4-.66.78-.78 1.14zm1.02.42l.36-.72c-.16 0-.28.1-.36.3-.08.2-.08.34 0 .42zm-1.2 0c.08 0 .16-.1.24-.3h-.18c0 .16-.02.26-.06.3zm.06 1.38c.2-.08.36-.3.48-.66.16-.32.18-.54.06-.66-.04.08-.22.52-.54 1.32zm-.3-.9c.12.04.18 0 .18-.12.04-.12.02-.2-.06-.24 0 .04-.02.1-.06.18a.46.46 0 0 0-.06.18zm0 .36c-.08.36-.28.82-.6 1.38l-.54 1.08c-.12.08-.18.22-.18.42 0-.04.02-.06.06-.06h.12v-.36h.06c.24-.32.68-1.16 1.32-2.52h-.12c-.04.04-.08.06-.12.06 0-.16-.02-.24-.06-.24 0 .04-.04.12-.12.24-.08.12-.14.2-.18.24 0 .08.02.16.06.24.04-.04.08-.12.12-.24.04-.12.1-.2.18-.24zm.24-.12h.12v-.12h-.12v.12zm.48.72c.28-.4.38-.66.3-.78 0 .12-.08.24-.24.36-.12.16-.14.3-.06.42zm-16.62-.36c0-.04.04-.1.12-.18.04-.04.04-.1 0-.18-.12 0-.18.02-.18.06.04 0 .04.04 0 .12-.04.12-.02.18.06.18zm14.94 1.14c.12 0 .2-.04.24-.12.08-.08.14-.2.18-.36.04-.12.08-.2.12-.24-.12.04-.22.16-.3.36-.08.2-.16.32-.24.36zm-15.9-.06c.12.08.2.02.24-.18 0-.12-.02-.2-.06-.24-.12.24-.18.38-.18.42zm15.06 3.18c-.12.16-.44.6-.96 1.32-.48.76-.78 1.32-.9 1.68 1.12-1.52 1.74-2.52 1.86-3 .52-.6 1.14-1.66 1.86-3.18-.36.44-.98 1.5-1.86 3.18zm-15.06-2.52c.16.04.24-.02.24-.18 0-.2-.08-.32-.24-.36v.54zm16.62.48l.18-.18c-.08 0-.14.06-.18.18zm-1.62.78c.04.16.04.3 0 .42s-.1.26-.18.42c-.08.16-.14.3-.18.42.12-.08.36-.56.72-1.44-.08.16-.2.22-.36.18zm-14.34.6c0-.24-.1-.36-.3-.36.08.24.18.36.3.36zm13.08 2.04c-.76.96-1.18 1.58-1.26 1.86.08-.12.22-.3.42-.54.2-.24.36-.46.48-.66.16-.2.28-.42.36-.66.28-.24.58-.68.9-1.32-.28.12-.58.56-.9 1.32zm.96-.18c.08.04.12.02.12-.06.04-.08.08-.12.12-.12-.16-.04-.24.02-.24.18zm-2.82 3.3c.04-.08.18-.22.42-.42.24-.16.42-.32.54-.48.12-.16.14-.3.06-.42-.08.16-.26.36-.54.6-.24.28-.4.52-.48.72zm.3-.96c-.12.04-.24.16-.36.36.24-.04.36-.16.36-.36h.06c.16-.16.16-.24 0-.24l-.06.06v.18zm-1.8.6c.16 0 .28-.06.36-.18-.04-.08-.16-.02-.36.18zm.12 1.02c.88-.52 1.24-.9 1.08-1.14-.08.2-.26.4-.54.6-.28.24-.46.42-.54.54zm-.72-.48c-.04 0-.16.1-.36.3.24-.08.36-.18.36-.3.2-.04.38-.18.54-.42-.24.08-.42.22-.54.42zm1.8.06c.16 0 .24-.08.24-.24-.08 0-.14.04-.18.12 0 .08-.02.12-.06.12zm-.36.36c-.08-.04-.14-.02-.18.06-.04.08-.02.14.06.18 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12.12.04.22 0 .3-.12.04-.08.02-.14-.06-.18 0 .08-.04.14-.12.18-.08.04-.12.08-.12.12zm-.54.42h.3v-.18c-.08-.04-.18.02-.3.18zm-1.02.3c-.08 0-.16.04-.24.12-.12 0-.18.06-.18.18.12 0 .18-.06.18-.18.16.04.24 0 .24-.12.16-.04.3-.1.42-.18.12-.08.14-.16.06-.24-.04.04-.12.08-.24.12-.16.08-.24.18-.24.3zm.24.36c.08 0 .32-.2.72-.6-.44.24-.68.44-.72.6zm-2.34-.24v.18c.08.04.14 0 .18-.12 0-.08-.04-.12-.12-.12 0 .08-.02.1-.06.06zm14.28-47.88h-.18c0-.12.06-.18.18-.18v.18zm-.42.24c-.04.16-.16.32-.36.48-.16.16-.26.28-.3.36-.08-.24.14-.52.66-.84zm-3.36 2.4l.12-.12c0 .08-.04.12-.12.12zm-.48 9.36c.04-.16.18-.24.42-.24-.04.16-.18.24-.42.24zm-4.02 2.4c-.12.2-.24.3-.36.3.08-.16.2-.26.36-.3zm8.46.96c.08-.12.16-.14.24-.06.08.08.08.18 0 .3-.08 0-.12-.04-.12-.12 0-.08-.04-.12-.12-.12zm-10.62.66h.12v.12h-.12v-.12zm-.66.54h.12v.18h-.12v-.18zm55.295-1.08h.12-.12a.36.36 0 0 0-.24.24c0 .04.04.06.12.06.16-.04.22-.02.18.06-.04.04-.22.18-.54.42-.32.24-.46.48-.42.72a.255.255 0 0 0-.24 0l-.18.06c0 .08-.02.14-.06.18 0 .08-.02.16-.06.24a.46.46 0 0 0-.06.18l-.12-.12c.04-.08.04-.12 0-.12s-.14.1-.3.3c-.16.24-.34.34-.54.3-.04.04-.06.1-.06.18.04.08.02.12-.06.12v-.06.06c-.12.24-.38.38-.78.42 0 .16-.06.26-.18.3a.76.76 0 0 1-.36.18c-.16.08-.26.12-.3.12-.12 0-.18-.1-.18-.3 0 .04-.12.12-.36.24.04.12.1.16.18.12.12-.04.2-.04.24 0-.04.08-.12.14-.24.18-.12.08-.2.1-.24.06 0 .16.04.24.12.24l-.96.48c-.48.24-.9.42-1.26.54-.04 0-.1.04-.18.12-.04.08-.08.12-.12.12-.04.04-.12.06-.24.06-.08.04-.14.04-.18 0-1.12.76-2.8 1.18-5.04 1.26-1.08-.2-1.82-.82-2.22-1.86-.4-1.04-.46-2.24-.18-3.6.2-.64.46-1.22.78-1.74s.74-1.02 1.26-1.5c.56-.44 1.02-.8 1.38-1.08.36-.24.94-.6 1.74-1.08.8-.44 1.32-.74 1.56-.9 2.08-.8 3.4-1.22 3.96-1.26-.04.16-.04.26 0 .3.08.04.2.04.36 0-.4.4-.62.68-.66.84-1 .16-1.92.62-2.76 1.38.04.08.12.08.24 0 .12-.04.24-.02.36.06.24 0 .32-.1.24-.3 0-.08-.04-.12-.12-.12.04 0 .12-.08.24-.24.16-.16.3-.22.42-.18 0 .08-.06.18-.18.3-.12.08-.18.18-.18.3 0 .04.02.04.06 0 .08-.04.16-.04.24 0-.44.32-.7.5-.78.54 0 .12.06.14.18.06.16-.08.26-.12.3-.12 0 .12-.04.2-.12.24-.08.08-.22.14-.42.18-.16.04-.26.06-.3.06-.16.24-.5.5-1.02.78-.52.32-.86.62-1.02.9-.16 0-.32.06-.48.18-.16.12-.28.18-.36.18.04.08 0 .14-.12.18-.08.08-.12.16-.12.24-1.44.84-2.62 2.08-3.54 3.72.04 0 .06.12.06.36.2.2.44.34.72.42.28.08.56.12.84.12.28.04.62.02 1.02-.06.44-.04.76-.08.96-.12.24-.04.56-.12.96-.24.44-.12.7-.18.78-.18 0-.04.02-.08.06-.12.04-.04.06-.08.06-.12.08.04.12.08.12.12-.04.08-.04.14 0 .18.68-.52 1.34-.84 1.98-.96.64-.48 1.2-.8 1.68-.96 1.04-.76 2.5-2.04 4.38-3.84.6-1.04 1.02-1.64 1.26-1.8.64-1.28.96-2.52.96-3.72-.08-.64-.26-1.2-.54-1.68-.24-.52-.58-1.04-1.02-1.56-.44-.52-.74-.92-.9-1.2 0-.04-.04-.04-.12 0-.08 0-.12-.02-.12-.06-.72-.84-2.12-1.96-4.2-3.36-.04 0-.1-.04-.18-.12-.04-.12-.1-.2-.18-.24 0-.04-.08-.06-.24-.06a.753.753 0 0 1-.3-.18c-.04 0-.06-.02-.06-.06l-.06-.12c-.2-.16-.62-.36-1.26-.6-1.44-1-2.74-1.82-3.9-2.46-.2-.2-.54-.46-1.02-.78-.44-.32-.82-.62-1.14-.9-.28-.32-.5-.66-.66-1.02-.48-.32-.84-.84-1.08-1.56-.8-2.64.18-5.16 2.94-7.56 0-.08.04-.2.12-.36.12 0 .26-.08.42-.24.16-.16.32-.24.48-.24.2-.44.66-.8 1.38-1.08.08 0 .1-.02.06-.06a.46.46 0 0 1-.06-.18c.2-.08.56-.3 1.08-.66.52-.36.96-.58 1.32-.66.04-.16.18-.3.42-.42.28-.16.48-.22.6-.18.56-.44 1.2-.86 1.92-1.26s1.58-.84 2.58-1.32c1.04-.48 1.78-.84 2.22-1.08.04 0 .08-.02.12-.06v-.06c3.72-1.48 6.16-2.4 7.32-2.76v-.24c.36.04.86-.04 1.5-.24.64-.24 1.08-.36 1.32-.36 1-.44 2.14-.74 3.42-.9 1.28-.16 2.5-.06 3.66.3.2.28.3.44.3.48.24.04.44.24.6.6.2.36.34.58.42.66.76.92.96 1.76.6 2.52-.04.04-.1.12-.18.24l-.18.18c-.32.04-.84.34-1.56.9 0-.04-.14-.06-.42-.06.44-1.36.68-2.28.72-2.76-.72-.24-1.64-.32-2.76-.24-1.08.08-1.92.18-2.52.3-.56.12-1.36.32-2.4.6-1.04.24-1.84.42-2.4.54-.16.12-.42.26-.78.42-.36.12-.6.22-.72.3-.08 0-.14-.02-.18-.06-.04-.04-.08-.06-.12-.06v.24c-.44.08-1.38.4-2.82.96 0 .04-.04.06-.12.06h-.18c-.08-.04-.14-.04-.18 0-.24.32-.7.58-1.38.78-.68.16-1.12.38-1.32.66-.04 0-.06-.06-.06-.18-.04 0-.08.06-.12.18 0 .08-.04.14-.12.18a.805.805 0 0 0-.66.18c-.16.16-.26.24-.3.24-.08.08-.2.12-.36.12-.16 0-.26.02-.3.06-.12.04-.32.16-.6.36-.28.2-.52.3-.72.3 0 .12-.1.24-.3.36l-.6.3c-.24.12-.42.22-.54.3-.32.32-.78.54-1.38.66-.08.04-.1.08-.06.12.04.08.06.14.06.18-.76.24-1.66.74-2.7 1.5-1.04.76-1.7 1.22-1.98 1.38v.12c0 .04.02.04.06 0 0 .2-.08.22-.24.06-.28.2-.64.54-1.08 1.02-.44.44-.76.74-.96.9-.04.08-.04.14 0 .18.04.04.06.08.06.12-1.12.88-1.56 1.9-1.32 3.06.04.12.14.28.3.48.16.2.26.38.3.54.36.2.9.6 1.62 1.2.76.56 1.4.92 1.92 1.08.28.36.54.56.78.6v.18c.16 0 .28.02.36.06.08.08.18.12.3.12.08.16.12.28.12.36.36.04.86.28 1.5.72.64.4 1.12.66 1.44.78.28.32.88.8 1.8 1.44.96.64 1.62 1.22 1.98 1.74 2.16 1.68 3.62 3.92 4.38 6.72-.08-.04-.14-.18-.18-.42 0-.28-.04-.44-.12-.48.2.96.3 2.6.3 4.92-.12.4-.32.84-.6 1.32-.28.52-.44.92-.48 1.2-.12 0-.22.04-.3.12-.04.2-.2.42-.48.66-.24.28-.36.52-.36.72-.04 0-.12.04-.24.12-.16.12-.26.1-.3-.06zm5.1-39.96c0-.04-.04-.06-.12-.06-.04 0-.06.02-.06.06h.18zm-.9.24c-.04.04-.08.06-.12.06h-.06c.12 0 .18-.02.18-.06zm-1.02.36c.04 0 .08.02.12.06.08.04.12.02.12-.06-.16-.04-.24-.04-.24 0zm-.9.48c.04-.04.1-.06.18-.06h.18c.08-.04.12-.1.12-.18-.32 0-.48.08-.48.24zm-.54.12c-.04-.04-.08-.06-.12-.06l.12.06zm-.6.3h.18v-.12h-.18v.12zm-.42.18c.24-.04.36-.1.36-.18-.2 0-.32.06-.36.18zm-.9.3c-.04.12-.16.22-.36.3-.16.04-.26.1-.3.18l.06.06c.04.04.08.06.12.06.04-.08.16-.16.36-.24.2-.08.36-.14.48-.18.12-.08.12-.18 0-.3.04.08 0 .14-.12.18-.08.04-.16.02-.24-.06zm-.9.54l-.06.06h-.06c.08 0 .12-.02.12-.06zm-1.32.42c-.04.12.14.18.54.18-.04-.04-.06-.1-.06-.18 0-.12-.04-.18-.12-.18 0 .12-.12.18-.36.18zm.96.42c.04.04.08.02.12-.06 0-.16-.02-.24-.06-.24 0 .04-.02.08-.06.12v.18zm-.48.24c0-.04.02-.06.06-.06.08 0 .12-.04.12-.12-.04-.04-.1.02-.18.18zm2.34.12c.12.04.2 0 .24-.12 0-.04.02-.08.06-.12-.2.08-.3.16-.3.24zm-4.26.12c.4.12.68.02.84-.3-.44.08-.72.18-.84.3zm-.3.12h.18c0-.08-.06-.12-.18-.12v.12zm1.32 0c-.32 0-.5.1-.54.3.28-.08.46-.18.54-.3zm-2.16.48c.04.08.12.12.24.12.16-.04.26-.12.3-.24-.08-.2-.26-.16-.54.12zm2.64-.18c-.2 0-.3.02-.3.06.04.04.08.06.12.06.08 0 .14-.04.18-.12zm.9.12c.04 0 .08.02.12.06h.12c.16-.08.26-.14.3-.18l-.54.12zm-2.16.06c.04 0 .1-.04.18-.12-.12 0-.18.04-.18.12zm-1.56 0v.18c.04.04.08.02.12-.06.04-.12.02-.18-.06-.18 0 .08-.02.1-.06.06zm-.54.3c0 .04.04.08.12.12.12 0 .18.02.18.06-.04.04-.16.06-.36.06-.16-.04-.24 0-.24.12.32.12.52.06.6-.18 0-.12-.06-.22-.18-.3l-.12.12zm.54 0c0-.08-.06-.12-.18-.12a.46.46 0 0 0-.06.18c.04 0 .12-.02.24-.06zm.42.24c-.16 0-.28.04-.36.12 0 .04.12 0 .36-.12.08 0 .16-.04.24-.12l.18-.12c-.08-.04-.14-.04-.18 0 0 .04-.04.1-.12.18-.04.04-.08.06-.12.06zm2.16-.06c.16 0 .22-.06.18-.18h-.12c0 .04-.02.08-.06.12v.06zm-4.62.72c0 .12.06.22.18.3.04-.16.06-.26.06-.3l.72-.24c-.04-.08-.02-.14.06-.18.08-.08.12-.14.12-.18-.12.04-.3.14-.54.3-.2.16-.4.26-.6.3zm3.42-.36h.12v-.18h-.12v.18zm-1.62.12v-.18.18zm1.92-.06c-.04.16.04.24.24.24-.12-.16-.2-.24-.24-.24zm-2.22.24h.06l.06.06c0-.16-.04-.24-.12-.24v.18zm1.32-.12v.06l-.06.06c.04-.04.06-.08.06-.12zm-1.62.18c-.24.08-.42.22-.54.42.24-.08.42-.22.54-.42zm1.98 0c.16 0 .26-.02.3-.06-.2-.08-.3-.06-.3.06zm-1.26.18c.04 0 .08.02.12.06h.18c.04-.12-.02-.18-.18-.18-.04 0-.08.04-.12.12zm-2.76.48c.12-.04.26-.06.42-.06.16-.04.26-.06.3-.06 0-.12-.04-.22-.12-.3-.08-.04-.14-.02-.18.06.08.08.04.12-.12.12-.2.08-.3.16-.3.24zm3.12-.24c.32 0 .5-.06.54-.18-.04 0-.1.02-.18.06-.2 0-.32.04-.36.12zm.96-.18c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.56.66c.12-.04.18-.12.18-.24l-.06.06v-.12c0 .12-.04.22-.12.3zm-2.7-.24c-.24.08-.36.18-.36.3.08-.04.12-.02.12.06h.3c0-.04-.02-.1-.06-.18-.04-.04-.04-.1 0-.18zm.84.3c.12-.12.18-.2.18-.24-.16.08-.22.16-.18.24zm1.02.06c.04 0 .06-.04.06-.12l-.06.12zm.6 0h-.18.18zm-1.92 0c-.28.08-.54.24-.78.48.16.04.42-.12.78-.48zm-1.26.24c-.08-.08-.14-.12-.18-.12 0 .08-.04.12-.12.12-.08-.04-.14-.02-.18.06.16.12.32.14.48.06.2-.08.34-.2.42-.36h-.3c0 .16-.04.24-.12.24zm-.66.42c.08-.04.18-.04.3 0v-.06c-.04-.08-.08-.12-.12-.12 0 .04-.04.06-.12.06h-.06v.12zm2.34-.18c-.04 0-.06.02-.06.06.04 0 .06-.02.06-.06zm-2.16.6c.56-.2.88-.38.96-.54-.08.04-.4.22-.96.54zm1.62-.18h-.12.12zm-2.46.18h.12v-.12h-.12v.12zm.18.48c.28-.04.5-.18.66-.42h-.36c0 .08-.02.14-.06.18-.04 0-.1.02-.18.06-.04.04-.06.1-.06.18zm-.78-.12c.04.16-.06.28-.3.36.08 0 .2-.04.36-.12.24-.08.36-.06.36.06v.12c.12 0 .22-.08.3-.24-.08 0-.16-.06-.24-.18-.04-.12-.08-.18-.12-.18 0 .12-.02.2-.06.24l-.06-.06h-.24zm2.22-.12l-.12.06c-.04 0-.06.02-.06.06h.06l.12-.12zm.36.18c.04.08.1.12.18.12.08-.04.12-.1.12-.18-.2 0-.3.02-.3.06zm-.06-.06c-.08 0-.12.02-.12.06.04 0 .08-.02.12-.06zm-1.08.48h.18v-.06h-.18v.06zm-2.1.12h.12l.06-.06v-.06h-.06c-.04-.04-.08-.06-.12-.06v.18zm1.02-.18c-.08 0-.14.02-.18.06.12 0 .18-.02.18-.06zm1.38.18h.18v-.12h-.18v.12zm-.84.06l.24-.12c-.16 0-.24.04-.24.12zm-2.1.96c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm.54.3l-.06-.06c-.04-.04-.08-.06-.12-.06-.04.08.02.12.18.12zm-.18.72c.04-.08.02-.12-.06-.12-.08-.04-.12-.08-.12-.12 0 .16.06.24.18.24zm-.36.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm-1.8 1.38c.08.04.14.02.18-.06.04-.08.02-.14-.06-.18l-.12.24zm.12.84c-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06-.04.08-.02.14.06.18.12.04.18.02.18-.06zm3.66 7.62h.18v-.12h-.18v.12zm3.72 1.14h.12v-.06h-.12v.06zm.42.12c.04-.08-.02-.12-.18-.12-.04.04-.04.08 0 .12.04.04.1.04.18 0zm-1.38.18h.06v-.18h-.06v.18zm.78.36c0-.16-.1-.24-.3-.24-.04.08 0 .14.12.18.12 0 .18.02.18.06zm1.86.36h.12v-.06h-.12v.06zm-.66.48c.08-.12.1-.2.06-.24h-.12c0 .12.02.2.06.24zm-.54-.12l-.12.12.12-.12zm.78.48c0-.04.04-.08.12-.12.08-.04.1-.1.06-.18a.46.46 0 0 1-.18-.06c0 .04-.02.1-.06.18-.04.08-.02.14.06.18zm1.56-.18l-.18.06c-.04.08-.04.12 0 .12.08-.04.14-.1.18-.18zm.12.3h.06v-.12h-.06v.12zm-.18.72h.12v-.12h-.12v.12zm.6.42a.68.68 0 0 0-.24-.24l-.18-.18c.04.24.18.38.42.42zm.18.12h.12v-.06c.04 0 .06-.02.06-.06h-.24c-.04.04-.02.08.06.12zm1.08.84c.12.16.64.66 1.56 1.5-.28-.6-.8-1.1-1.56-1.5l-.3-.3c-.12-.16-.22-.26-.3-.3-.08-.08-.18-.08-.3 0 .12.04.26.16.42.36.16.16.32.24.48.24zm2.1 1.98c-.04-.16-.16-.28-.36-.36.08.2.2.32.36.36zm-5.4 6.36c.24 0 .36-.04.36-.12-.16 0-.28.04-.36.12zm-.48.36c-.32.12-.48.22-.48.3.04-.04.1-.06.18-.06.08-.04.14-.08.18-.12.08-.04.12-.08.12-.12h.12v-.24c-.08 0-.12.08-.12.24zm-.72.36h.18v-.18h-.18v.18zm-.66.36c.32-.08.5-.16.54-.24l-.06-.06c-.04-.04-.1-.04-.18 0 .04.08 0 .14-.12.18-.12.04-.18.08-.18.12zm-.48.18h-.42l-.06.12c0 .08-.02.12-.06.12-.08-.04-.18-.02-.3.06-.08.04-.16.02-.24-.06.04.08.02.14-.06.18-.04.04-.06.08-.06.12h.12c.08.04.16.06.24.06 0-.04.12-.12.36-.24s.4-.24.48-.36zm-1.86.6c-.12.24-.16.34-.12.3-.04.08-.1.06-.18-.06 0 .04-.04.1-.12.18-.16.2-.2.34-.12.42.08-.04.18-.06.3-.06.04-.16.1-.28.18-.36.08-.08.2-.16.36-.24.2-.04.32-.06.36-.06-.04 0-.08-.02-.12-.06 0-.04-.02-.06-.06-.06h-.48zm1.08.54c-.68.2-1.16.52-1.44.96l-.36.18c-.16.08-.3.16-.42.24-.08.08-.1.16-.06.24.08-.08.22-.18.42-.3.24-.08.44-.18.6-.3.16-.12.3-.26.42-.42 0 .08.06.1.18.06.04-.08.26-.2.66-.36.4-.16.62-.42.66-.78h-.18c-.04.16-.12.26-.24.3-.12.08-.2.14-.24.18zm-3.96 1.8c.16-.08.46-.3.9-.66.48-.32.86-.54 1.14-.66v-.24c-.12.08-.34.22-.66.42-.32.2-.6.38-.84.54-.2.2-.38.4-.54.6zm1.38-.06c.16 0 .24-.06.24-.18h-.18l-.06.06v.12zm10.44.18c-.08-.2-.14-.3-.18-.3-.12.2-.06.3.18.3zm-10.86-.06c-.04.16-.16.28-.36.36-.2.12-.3.22-.3.3.56-.32.86-.56.9-.72-.04-.04-.12-.02-.24.06zm-1.2.24c0-.04.02-.08.06-.12.08 0 .12-.02.12-.06-.04 0-.08-.02-.12-.06-.04-.04-.08-.06-.12-.06 0 .16.02.26.06.3zm11.58 0c.04.08.08.1.12.06.08-.04.14-.1.18-.18-.2 0-.3.04-.3.12zm-11.94.12c-.04 0-.06-.02-.06-.06h-.06c-.04.12-.2.24-.48.36-.24.12-.38.24-.42.36.36-.24.6-.36.72-.36 0-.12.04-.2.12-.24.08.08.14.12.18.12v-.18h.18c0-.04-.02-.08-.06-.12l-.12.12zm12.42 0c.08 0 .12-.04.12-.12-.12 0-.16.04-.12.12zm-.6.06c-.04 0-.08.02-.12.06-.08 0-.12.02-.12.06.16 0 .24-.04.24-.12zm.36.24h-.06a.36.36 0 0 0-.24.24c.12.04.2-.04.24-.24h.06zm-.36 0h-.12c-.04 0-.06.02-.06.06.12 0 .18-.02.18-.06zm-.06.6l-.3.24c.12.04.22-.04.3-.24h.06c.12-.12.12-.2 0-.24-.08.08-.1.16-.06.24zm-11.7.06c.12.04.22 0 .3-.12-.08 0-.14.02-.18.06-.04.04-.08.06-.12.06zm10.86.18c0-.12-.04-.18-.12-.18 0 .12.04.18.12.18zm-.12.78c-.12 0-.22.08-.3.24.2-.12.3-.2.3-.24.12.04.2-.02.24-.18 0-.04-.02-.08-.06-.12 0 .08-.04.14-.12.18-.04.04-.06.08-.06.12zm-.84 0l-.06.06h-.06c.08 0 .12-.02.12-.06zm-10.56.24c-.08 0-.12.02-.12.06.08 0 .12-.02.12-.06zm10.92.3c.08-.2.1-.3.06-.3l-.06.06c-.12.12-.12.2 0 .24zm-.84-.12c-.12 0-.18.02-.18.06.08 0 .14-.02.18-.06zm.06.78c.2-.08.42-.28.66-.6-.24.04-.46.24-.66.6zm-.6-.3c-.04 0-.08-.02-.12-.06-.04-.04-.08-.04-.12 0-.04.08-.02.12.06.12.08.04.16.04.24 0v-.12c0-.12-.02-.18-.06-.18v.24zm1.98-.18v.18l.12-.12c0-.08-.02-.12-.06-.12 0 .08-.02.1-.06.06zm-2.52.42c.04-.04.08-.04.12 0 .04.04.08.06.12.06 0-.16-.08-.24-.24-.24V56zm.9.24c.12 0 .18-.04.18-.12h-.12l-.06.12zm.84 0l-.12.06c.04 0 .08-.02.12-.06zm-2.46.42c-.28.04-.56.12-.84.24-.28.16-.6.36-.96.6-.32.24-.58.4-.78.48.08-.04.16-.06.24-.06.08.04.14.06.18.06.04.04.08.02.12-.06-.12 0-.18-.06-.18-.18.24.04.42-.02.54-.18.16-.12.28-.16.36-.12.12-.24.34-.4.66-.48.32-.04.54-.14.66-.3l.18-.06c.12-.04.16-.12.12-.24-.12-.04-.22-.04-.3 0-.04.08-.04.18 0 .3zm1.2 0c.08-.08.16-.12.24-.12.08.04.12.04.12 0-.04-.08-.12-.12-.24-.12s-.16.08-.12.24zm.66 0c.16.04.28.02.36-.06.04-.04.02-.08-.06-.12-.04.08-.12.12-.24.12l-.06.06zm-.42.36c.2-.08.32-.2.36-.36-.16 0-.28.12-.36.36zm-.84-.06c-.08-.04-.16-.02-.24.06-.04.08-.02.14.06.18 0-.04.04-.06.12-.06.08-.04.1-.1.06-.18.08 0 .12-.06.12-.18-.08 0-.12.06-.12.18zm.12.36c.24.16.42.12.54-.12h-.3c-.12.04-.2.08-.24.12zm-1.8.48v.3l.18-.18c.12-.04.2-.1.24-.18a.255.255 0 0 0-.24 0 .46.46 0 0 1-.18.06zm1.02.24c.08.08.12.04.12-.12l-.12-.12v.24zm-4.38.12c0-.04-.12-.06-.36-.06-.04.12 0 .18.12.18.16 0 .24-.04.24-.12zm1.8-.06c-.04.04-.08.06-.12.06h-.06c.08 0 .14-.02.18-.06zm1.08.24h.12v-.24h-.18c0 .12.02.2.06.24zm-1.62 0c-.16 0-.24.08-.24.24.08.04.12 0 .12-.12.04-.08.08-.12.12-.12.16 0 .26-.06.3-.18-.2 0-.3.06-.3.18zm-3.3.36c.16.28.26.42.3.42-.08 0-.12-.06-.12-.18.52 0 .82-.08.9-.24-.12 0-.2-.02-.24-.06.04-.04.12-.06.24-.06.16 0 .26-.04.3-.12-.2-.04-.46 0-.78.12-.28.12-.48.16-.6.12zm1.56-.18h.12c.04-.04 0-.08-.12-.12-.08-.04-.12-.02-.12.06l.12.06zm3.06.12c.08-.16.08-.24 0-.24 0 .04-.02.08-.06.12-.04.08-.02.12.06.12zm-2.1-.06c-.08.16-.12.28-.12.36l.24-.24.36-.18h-.3a.46.46 0 0 1-.18.06zm1.74.06h.06c.04.04.08.06.12.06-.04-.12-.1-.18-.18-.18v.12zm-2.82.06h.12v-.12h-.12v.12zm3.66 0h.06v-.12h-.06v.12zm-5.28.06c-.76.08-1.22.24-1.38.48.04 0 .1-.02.18-.06a.46.46 0 0 1 .18-.06c.04-.08.14-.14.3-.18.16 0 .26.06.3.18-.04.04-.08.04-.12 0-.04-.04-.08-.06-.12-.06.04.16.16.22.36.18.2 0 .36-.06.48-.18l-.12-.06c-.08 0-.12-.02-.12-.06.04 0 .06-.06.06-.18zm1.02.6c.08-.04.24-.08.48-.12.24 0 .44-.02.6-.06.16-.04.26-.14.3-.3-.76.16-1.22.32-1.38.48zm-.42.06c-.2 0-.3.02-.3.06.2.08.3.06.3-.06zm13.86-13.5c.08 0 .12.06.12.18h-.12v-.18zm0 .24c.08 0 .14.08.18.24v.18c-.12 0-.18-.14-.18-.42zm.12 1.02c.12.08.18.26.18.54.04.24-.02.38-.18.42v-.96zm0 1.32v.3-.3zm-8.4.84l-.18.06a.94.94 0 0 1-.24.18c0-.28.14-.36.42-.24zm3.18 7.32c0-.04.02-.08.06-.12-.04 0-.06.04-.06.12zm18.991-19.68c-.04.16-.08.4-.12.72 0 .28-.02.48-.06.6-.04.12-.12.28-.24.48-.12.16-.3.3-.54.42-.2.52-.5 1-.9 1.44-.4.44-.92.9-1.56 1.38-.64.48-1.08.82-1.32 1.02-.2.04-.5.12-.9.24-.36.12-.68.22-.96.3-.24.04-.54.06-.9.06-.32-.04-.6-.16-.84-.36-.28.36-.62 1.46-1.02 3.3.56.4 1.24.6 2.04.6.84 0 1.56-.1 2.16-.3.64-.2 1.44-.48 2.4-.84.96-.4 1.62-.66 1.98-.78 1.6-.92 3.08-1.66 4.44-2.22.08-.08.2-.16.36-.24.2-.12.32-.2.36-.24.04.16-.04.32-.24.48-.16.12-.4.26-.72.42-.28.16-.46.28-.54.36 0 .04.08.06.24.06-1.44 1.28-3.36 2.34-5.76 3.18.88 0 1.5-.1 1.86-.3-.04.16-.22.32-.54.48 0 .04.04.06.12.06.12 0 .16.04.12.12-.2.08-.44.2-.72.36-.24.16-.44.28-.6.36-.16.08-.3.08-.42 0-.12.04-.18.1-.18.18.04.08.04.16 0 .24-1.8.8-3.4 1.2-4.8 1.2-2.4-.52-3.36-2.52-2.88-6 .6-1.8 1.48-3.48 2.64-5.04 1.16-1.6 2.52-2.78 4.08-3.54.24-.12.88-.18 1.92-.18.16.04.34.14.54.3.2.12.36.18.48.18.08.4.42.9 1.02 1.5zm-4.68 1.08c.08 0 .18-.04.3-.12.12-.12.22-.14.3-.06-1.08.84-1.98 1.72-2.7 2.64 2.36-1.2 4-2.54 4.92-4.02-.12.04-.38.14-.78.3-.36.16-.64.28-.84.36-.16.08-.36.2-.6.36-.24.16-.44.34-.6.54zm-.84 9.54h.18c.08 0 .12.02.12.06.04.04.06.14.06.3.32-.2.58-.2.78 0 .04-.04.04-.1 0-.18 0-.12.04-.18.12-.18.44 0 .94-.18 1.5-.54-.32.16-.82.26-1.5.3-.64.04-1.06.12-1.26.24zm23.82-10.2a4.5 4.5 0 0 0-.84-.48c-.64.28-1.48.82-2.52 1.62-1.04.8-1.84 1.3-2.4 1.5-.12.6-.4.96-.84 1.08-2.48 3.48-4.16 6.08-5.04 7.8-.16 1.32-.82 2.2-1.98 2.64-.68-.32-1.14-.86-1.38-1.62-.28-.8-.4-1.52-.36-2.16.04-.68.18-1.6.42-2.76.2-1.2.32-1.96.36-2.28.2-.4.42-1.16.66-2.28.2-1.12.42-1.88.66-2.28.52.12.92.32 1.2.6.28.24.44.6.48 1.08.04.44.04.8 0 1.08 0 .28-.06.74-.18 1.38-.12.64-.2 1.04-.24 1.2.84-1.28 2.46-3.16 4.86-5.64.64-.52 1.38-.98 2.22-1.38.88-.4 1.8-.56 2.76-.48 1 .04 1.72.5 2.16 1.38zm-4.44-.42c.16.04.3.02.42-.06.12-.12.22-.16.3-.12-.08-.16-.02-.24.18-.24.24-.04.36-.12.36-.24-.48.12-.8.16-.96.12-3.12 1.84-5.7 4.64-7.74 8.4 2.52-3.64 5-6.26 7.44-7.86zm1.74-.06c0 .08-.04.16-.12.24.36-.08.56-.2.6-.36-.24.08-.4.12-.48.12zm-.6.54c.08 0 .22-.1.42-.3a.3.3 0 0 0-.36 0c-.12.04-.14.14-.06.3zm-1.68.9c.16 0 .38-.12.66-.36.32-.24.56-.36.72-.36 0-.04.02-.12.06-.24v-.06c0-.04-.04-.06-.12-.06-.12.16-.34.36-.66.6-.32.2-.54.36-.66.48zm-.48.48c.32-.2.48-.34.48-.42-.04.04-.12.08-.24.12-.12.04-.2.08-.24.12-.04.04-.04.1 0 .18zm-.78 1.02l.24-.24c.16-.16.24-.3.24-.42h-.18c0 .12-.08.24-.24.36-.12.12-.14.22-.06.3zm-.6.48c0-.04.02-.06.06-.06 0-.12-.04-.16-.12-.12 0 .12.02.18.06.18zm2.4-3.36v-.06.06zm9.225-8.88c.36.64.42 1.3.18 1.98-.2.64-.62 1.06-1.26 1.26-1.08-.4-1.68-.92-1.8-1.56.16-.12.4-.36.72-.72.36-.36.7-.62 1.02-.78.32-.16.7-.22 1.14-.18zm1.5 18.18v.12c-.48.24-.82.44-1.02.6.44.08.78-.12 1.02-.6.36-.04 1.24-.52 2.64-1.44.28-.08.66-.3 1.14-.66.52-.36.96-.6 1.32-.72.44-.36 1.62-1.12 3.54-2.28 0 .04-.04.12-.12.24-.08.12-.1.24-.06.36-.8.12-1.42.52-1.86 1.2-.68.32-1.4.72-2.16 1.2-.76.48-1.6 1.02-2.52 1.62-.92.6-1.64 1.06-2.16 1.38-.12 0-.18.04-.18.12.12 0 .18-.04.18-.12 1.72-.96 2.62-1.48 2.7-1.56.48-.24 1.24-.7 2.28-1.38 1.04-.72 1.66-1.14 1.86-1.26.16.04.28 0 .36-.12.12-.12.24-.18.36-.18.04.08.02.16-.06.24-.08.04-.1.1-.06.18-.4 0-.6.1-.6.3l-.06.06c-.04.04-.1.08-.18.12-.04.04-.08.06-.12.06 0 .16.08.22.24.18-.04.08-.16.12-.36.12.04.2-.04.4-.24.6-.16 0-.26-.08-.3-.24 0-.12.08-.18.24-.18-.2-.12-.44.02-.72.42-.28.36-.52.54-.72.54l.12.18c.12.12.12.2 0 .24-.28 0-.4-.08-.36-.24-.04 0-.08.04-.12.12 0 .08-.04.1-.12.06 0 .08.04.12.12.12.12 0 .16.06.12.18-.12.08-.22.08-.3 0a.407.407 0 0 0-.3-.12c-.04.12-.02.2.06.24.04.04.06.08.06.12-.08.04-.16.02-.24-.06-.04-.08-.1-.1-.18-.06-.04.08-.02.14.06.18.08 0 .12.02.12.06-.92.84-1.8 1.46-2.64 1.86-.04 0-.06.1-.06.3-.36 0-.58.2-.66.6-1.04.8-2.24 1.34-3.6 1.62-1.32.32-2.58.22-3.78-.3-1.24-.48-2.04-1.44-2.4-2.88-.04-.68.06-1.62.3-2.82.16-.44.42-1.24.78-2.4.36-1.16.74-2.1 1.14-2.82.36-.72.86-1.32 1.5-1.8 1.08.12 1.74.76 1.98 1.92-.24.08-.44.12-.6.12-1.4 2.4-2.28 4.76-2.64 7.08-.28.36-.34 1.04-.18 2.04 1.56.24 3.82-.46 6.78-2.1 0-.04-.02-.08-.06-.12-.04-.08-.04-.14 0-.18.4-.08.64-.1.72-.06zm-.9 1.38c.12 0 .2-.02.24-.06.08-.04.1-.1.06-.18-.12 0-.22.08-.3.24zm9.72-6.36c.2 0 .3-.04.3-.12h.18c0-.12-.06-.18-.18-.18.04-.04.14-.12.3-.24.16-.16.26-.32.3-.48-.88.4-2.12 1.14-3.72 2.22-1.6 1.04-2.82 1.74-3.66 2.1 0 .08.06.16.18.24-.28.08-.62.28-1.02.6-.4.28-.74.46-1.02.54 0-.08-.02-.12-.06-.12 4.24-3 7.72-5.12 10.44-6.36 0 .04-.08.1-.24.18-.16.08-.24.14-.24.18 0 .08.06.08.18 0s.22-.1.3-.06c-.12.12-.32.34-.6.66-.24.28-.48.52-.72.72-.2.16-.46.28-.78.36 0-.04.02-.08.06-.12.04-.04.04-.08 0-.12zm.96-1.02c.2 0 .3-.06.3-.18-.2 0-.3.06-.3.18zm-.66.9c-.16 0-.26.04-.3.12h-.18c.04-.08.1-.14.18-.18.08-.04.14-.08.18-.12 0 .04.02.08.06.12.04 0 .06.02.06.06zm-.48.9c0 .04-.1.1-.3.18 0-.12.1-.18.3-.18zm-1.14.66c.04-.28.3-.42.78-.42-.16.2-.42.34-.78.42zm-.18.06c0-.04.06-.06.18-.06-.04.04-.1.06-.18.06zm-.72.72h.18v.24c-.2 0-.28-.06-.24-.18.04 0 .06-.02.06-.06zm-1.38 1.26c.08-.16.2-.16.36 0-.04.08-.16.08-.36 0zm-2.7.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm2.52 0c.2.08.2.2 0 .36-.16.12-.28.14-.36.06 0-.04.04-.1.12-.18.12-.08.2-.16.24-.24zm-2.46.06c.04 0 .06.02.06.06-.04 0-.06-.02-.06-.06zm-2.46.96h.24c0 .04-.02.1-.06.18-.04.04-.02.06.06.06-.08.08-.16 0-.24-.24zm18.83-8.88c-.04.16-.08.4-.12.72 0 .28-.02.48-.06.6-.04.12-.12.28-.24.48-.12.16-.3.3-.54.42-.2.52-.5 1-.9 1.44-.4.44-.92.9-1.56 1.38-.64.48-1.08.82-1.32 1.02-.2.04-.5.12-.9.24-.36.12-.68.22-.96.3-.24.04-.54.06-.9.06-.32-.04-.6-.16-.84-.36-.28.36-.62 1.46-1.02 3.3.56.4 1.24.6 2.04.6.84 0 1.56-.1 2.16-.3.64-.2 1.44-.48 2.4-.84.96-.4 1.62-.66 1.98-.78 1.6-.92 3.08-1.66 4.44-2.22.08-.08.2-.16.36-.24.2-.12.32-.2.36-.24.04.16-.04.32-.24.48-.16.12-.4.26-.72.42-.28.16-.46.28-.54.36 0 .04.08.06.24.06-1.44 1.28-3.36 2.34-5.76 3.18.88 0 1.5-.1 1.86-.3-.04.16-.22.32-.54.48 0 .04.04.06.12.06.12 0 .16.04.12.12-.2.08-.44.2-.72.36-.24.16-.44.28-.6.36-.16.08-.3.08-.42 0-.12.04-.18.1-.18.18.04.08.04.16 0 .24-1.8.8-3.4 1.2-4.8 1.2-2.4-.52-3.36-2.52-2.88-6 .6-1.8 1.48-3.48 2.64-5.04 1.16-1.6 2.52-2.78 4.08-3.54.24-.12.88-.18 1.92-.18.16.04.34.14.54.3.2.12.36.18.48.18.08.4.42.9 1.02 1.5zm-4.68 1.08c.08 0 .18-.04.3-.12.12-.12.22-.14.3-.06-1.08.84-1.98 1.72-2.7 2.64 2.36-1.2 4-2.54 4.92-4.02-.12.04-.38.14-.78.3-.36.16-.64.28-.84.36-.16.08-.36.2-.6.36-.24.16-.44.34-.6.54zm-.84 9.54h.18c.08 0 .12.02.12.06.04.04.06.14.06.3.32-.2.58-.2.78 0 .04-.04.04-.1 0-.18 0-.12.04-.18.12-.18.44 0 .94-.18 1.5-.54-.32.16-.82.26-1.5.3-.64.04-1.06.12-1.26.24zm21.66-4.86c0 .12.04.18.12.18h.06c0-.04.02-.06.06-.06.04-.08-.04-.12-.24-.12.56-.52 1.4-1.22 2.52-2.1 1.16-.92 1.98-1.6 2.46-2.04.08.16.18.24.3.24-.32 1.16-.84 1.9-1.56 2.22-.04.12 0 .16.12.12h.12c-.36.56-.66.8-.9.72-.08.04-.1.08-.06.12.04.08.06.14.06.18-.68.24-1.12.6-1.32 1.08-.24 0-.5.08-.78.24-.24.16-.5.36-.78.6s-.5.4-.66.48c.2.12.42.04.66-.24.28-.28.54-.42.78-.42.04.08.02.14-.06.18-.04.04-.06.08-.06.12.04 0 .1-.04.18-.12.08-.08.18-.1.3-.06 0-.04-.04-.12-.12-.24-.04-.12-.02-.2.06-.24.2.08.42.02.66-.18.24-.2.44-.3.6-.3v.42c-.12 0-.28.08-.48.24-.16.12-.3.14-.42.06 0 .16.04.24.12.24-.52.56-1.42 1.26-2.7 2.1-1.24.84-2 1.38-2.28 1.62-.04 0-.06-.02-.06-.06l-.06-.12c-.72.64-1.96 1.58-3.72 2.82-1.76 1.28-3.04 2.32-3.84 3.12.04.36.22 1.6.54 3.72.36 2.12.46 3.78.3 4.98-.24 1.04-.74 2.14-1.5 3.3-2.04 1.72-3.88 2.3-5.52 1.74-1.32-.76-2.3-2.34-2.94-4.74-.16-1-.16-1.72 0-2.16.44-1.12 1.1-2.28 1.98-3.48.84-1.16 1.5-2 1.98-2.52l2.76-2.76c0-.2-.02-.52-.06-.96-.04-.44-.04-.78 0-1.02h.24c-.08-.96-.1-1.66-.06-2.1 0-.48.04-1.26.12-2.34.08-1.08.12-1.96.12-2.64.16-.32.38-.8.66-1.44.24-.68.46-1.2.66-1.56.16-.4.4-.82.72-1.26.32-.44.7-.8 1.14-1.08 1.64.68 2.32 1.5 2.04 2.46-.48-.04-.98.16-1.5.6-.88 1.76-1.46 3.4-1.74 4.92-.24 1.52-.26 3.26-.06 5.22.48-.32 1.58-1.08 3.3-2.28 1.72-1.24 3.04-2.12 3.96-2.64 0-.04-.02-.08-.06-.12-.04-.04-.04-.08 0-.12.16-.04.42-.2.78-.48.36-.32.72-.5 1.08-.54V44c.08.08.1.16.06.24.08-.04.32-.26.72-.66.44-.44.84-.72 1.2-.84zm4.14-2.82c-.04-.08-.04-.14 0-.18.08-.08.12-.14.12-.18-.12-.04-.2 0-.24.12-.04.12 0 .2.12.24zm-.24.54c.08 0 .14-.06.18-.18 0 .04-.04.08-.12.12-.08 0-.1.02-.06.06zm-.48.3c0 .12.02.2.06.24-.28.08-.54.3-.78.66.16-.04.32-.12.48-.24.16-.12.3-.26.42-.42l.18-.3c-.04-.08-.12-.08-.24 0-.04.04-.08.06-.12.06zm-1.02.3c-.4.24-.66.46-.78.66.4-.24.66-.46.78-.66.08.04.14.02.18-.06.04-.08.02-.14-.06-.18 0 .04-.02.08-.06.12-.04.04-.06.08-.06.12zm-.6 1.38c0-.08.06-.1.18-.06.16.04.28.06.36.06l-.12-.18c0-.04.02-.1.06-.18.08-.08.12-.16.12-.24-.48.24-.68.44-.6.6zm-1.26.06c.08 0 .14-.02.18-.06.08-.04.14-.08.18-.12l.18-.18c-.04-.04-.14 0-.3.12a.68.68 0 0 0-.24.24zm.72.12c.04 0 .08.06.12.18.08.08.16.1.24.06 0-.04-.1-.16-.3-.36 0 .04-.02.06-.06.06v.06zm-1.02.84c.12 0 .28-.08.48-.24.24-.2.42-.22.54-.06.04-.64-.2-.66-.72-.06-.16.16-.26.28-.3.36zm-.72-.24c.08 0 .16-.04.24-.12-.16 0-.24.04-.24.12zm.12.72c-.28 0-.46.14-.54.42-.52.04-1.06.34-1.62.9.08.04.16.06.24.06.12-.04.2-.02.24.06.12-.44.48-.72 1.08-.84-.2.48-.66.96-1.38 1.44-.72.48-1.2.88-1.44 1.2 1.36-.84 2.22-1.44 2.58-1.8-.12-.08-.22-.06-.3.06.04-.04.16-.08.36-.12.2-.08.36-.16.48-.24.12-.08.16-.18.12-.3-.04.16-.12.18-.24.06-.04-.04-.06-.1-.06-.18.4-.36.56-.6.48-.72.08 0 .18-.04.3-.12.12-.12.22-.16.3-.12 0-.12-.04-.18-.12-.18-.08-.04-.18-.02-.3.06l-.24.12v.12c.04.04.06.08.06.12zm-2.7 1.08c.04 0 .18-.12.42-.36-.28.08-.42.2-.42.36zm1.44.06h.12v-.12h-.12v.12zm-1.32.54c.12 0 .22-.02.3-.06.08-.04.1-.12.06-.24-.24 0-.36.1-.36.3zm-5.88 5.04c.12-.04.24-.16.36-.36.12-.16.22-.26.3-.3 0 .04-.04.1-.12.18-.04.08 0 .12.12.12 0-.04.04-.08.12-.12.08-.04.1-.1.06-.18h-.18c.04-.04.04-.1 0-.18a.987.987 0 0 1-.06-.3c0-.08.08-.12.24-.12.04.04.02.16-.06.36.2-.08.3-.08.3 0 0 .04-.02.1-.06.18.2-.08.46-.26.78-.54.36-.28.64-.46.84-.54 0-.08-.08-.14-.24-.18-.12-.08-.18-.14-.18-.18.16-.24.32-.36.48-.36 0 .04-.06.12-.18.24-.08.08-.06.14.06.18.28.04.58-.08.9-.36.36-.32.64-.5.84-.54-.04-.08-.02-.2.06-.36.08-.16.12-.3.12-.42.16-.04.4-.18.72-.42.32-.24.52-.44.6-.6-.04.12-.12.12-.24 0 0-.04.04-.08.12-.12.12 0 .16-.04.12-.12-.72.36-1.12.64-1.2.84 0 .04.02.06.06.06.08 0 .12.02.12.06-.24.12-.38.18-.42.18-.16-.12-.46-.04-.9.24-.44.24-.74.5-.9.78.24 0 .36.02.36.06-.04 0-.08.02-.12.06-.04.04-.08.06-.12.06-.2-.12-.36-.16-.48-.12-.04.04-.1.14-.18.3-.08.24-.16.32-.24.24 0-.04.02-.06.06-.06.08-.04.1-.1.06-.18-1.16.64-1.64 1.12-1.44 1.44-.44-.16-.8-.08-1.08.24-.24.32-.36.74-.36 1.26.08 0 .16-.04.24-.12 0-.16.06-.22.18-.18 0 .2.04.3.12.3.2-.2.34-.3.42-.3v-.12zm-4.26.84c.08-.44.04-.9-.12-1.38v.66c0 .36.04.6.12.72zm2.82-.96h.12v-.12h-.12v.12zm-.66.3c0 .16.04.34.12.54.12.2.1.34-.06.42.16-.04.24.02.24.18.64-.28 1-.58 1.08-.9-.16.16-.28.26-.36.3 0-.32-.06-.54-.18-.66-.04.04-.04.1 0 .18.04.12.02.2-.06.24l-.06-.06h-.12c.04.04.04.12 0 .24s-.1.18-.18.18c0-.04-.04-.1-.12-.18a.533.533 0 0 1-.06-.24l.36-.54c-.12.04-.24.1-.36.18-.08.08-.16.12-.24.12zm-2.88 1.98c-.12-.04-.22.02-.3.18.08 0 .18-.06.3-.18.12 0 .22-.08.3-.24-.12 0-.22.08-.3.24zm-.6.6l.06-.06c.08-.04.12-.08.12-.12h-.24c0 .12.02.18.06.18zm-1.14.84v.12h.24v-.24h-.18c0 .08-.02.12-.06.12zm-.78 1.14h.12c0 .04.04.06.12.06-.04-.12.02-.26.18-.42.12-.12.18-.22.18-.3-.36.12-.56.34-.6.66zm-1.56 9c.16.12.32.2.48.24.16.08.36.1.6.06.2 0 .38-.02.54-.06.12 0 .32-.06.6-.18.28-.08.46-.14.54-.18.08-.04.26-.12.54-.24l.48-.24c1.08-.8 1.76-2.12 2.04-3.96.28-1.84.18-3.5-.3-4.98 0-.04-.02-.06-.06-.06l-.9.9-.96.96c-.16.2-.44.52-.84.96-.44.48-.74.86-.9 1.14-.2.28-.44.66-.72 1.14-.28.52-.48.98-.6 1.38-.12.44-.24.92-.36 1.44-.12.56-.18 1.12-.18 1.68zm.54-7.8c.6-.28.84-.62.72-1.02-.04.12-.16.28-.36.48-.2.2-.32.38-.36.54zm-.78 1.14c.2-.04.34-.22.42-.54-.08 0-.14.02-.18.06-.08.08-.12.16-.12.24-.04.12-.08.2-.12.24zm-.3.24c.16.04.18.1.06.18-.08.04-.12.1-.12.18.16 0 .28-.16.36-.48-.2-.08-.3-.04-.3.12zm-.18.66c.12 0 .18-.06.18-.18-.12.16-.18.22-.18.18zm-.36.66c.04 0 .08-.02.12-.06.04-.16.02-.26-.06-.3 0 .04-.02.1-.06.18-.04.08-.04.14 0 .18zm23.1-17.52l-.42.42c-.04-.12-.04-.2 0-.24.04-.04.1-.06.18-.06.12-.04.2-.08.24-.12zm-.42.6c-.08.36-.42.62-1.02.78-.12-.32.1-.56.66-.72h.24c.04-.04.08-.06.12-.06zm-8.16 4.74c0 .08-.06.14-.18.18l-.24.12c-.08.04-.08.1 0 .18 0 .04-.06.08-.18.12-.08 0-.1.04-.06.12a.698.698 0 0 0-.12-.18c0-.08.06-.16.18-.24.12-.08.22-.14.3-.18.08-.04.18-.08.3-.12zm-2.16.84h.12v.18h-.12v-.18zm-.72.66c-.08.2-.34.44-.78.72.16-.28.42-.52.78-.72zm.24.6c-.08.08-.16.12-.24.12-.04-.08.04-.12.24-.12zm-1.56.72c.04-.04.08-.02.12.06v.12a.46.46 0 0 0-.18-.06c-.04.04-.08.04-.12 0 0-.04.02-.06.06-.06.08 0 .12-.02.12-.06zm-.84.42v-.24c.16 0 .2.1.12.3-.04 0-.06-.02-.06-.06h-.06zm.66.3c-.4-.12-.48-.28-.24-.48.16.04.24.2.24.48zm-.66-.3l-.06.06v.12c-.04 0-.08-.02-.12-.06.08-.04.14-.08.18-.12z"
  }));
};
TitleSvg.defaultProps = {
  width: "238",
  height: "97",
  viewBox: "0 0 238 97",
  xmlns: "http://www.w3.org/2000/svg"
};
var BrandLogo = function BrandLogo(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M37.325.675h526.7c20.5 0 37.1 18.6 37.1 41.7 0 23-16.6 41.7-37.1 41.7h-525.7c-20.5 0-37.1-18.7-37.1-41.7 0-23 16.6-41.7 37.1-41.7h-1z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M37.325.675h526.7c20.5 0 37.1 18.6 37.1 41.7 0 23-16.6 41.7-37.1 41.7h-525.7c-20.5-.1-37.1-18.7-37.1-41.8 0-23 16.6-41.7 37.1-41.7h-1v.1z",
    stroke: "#686767",
    strokeWidth: ".987"
  }), __jsx("path", {
    d: "M78.525 47.675c-2.5 15.9-16.4 28.2-33.2 28.2-18.6 0-33.6-14.9-33.6-33.2 0-18.3 15.1-33.2 33.6-33.2 16.8 0 30.8 12.2 33.2 28.1h-9.3c-2.4-10.9-12.2-19-23.9-19-13.5 0-24.4 10.8-24.4 24.1s10.9 24.1 24.4 24.1c11.8 0 21.7-8.1 24-19.1h9.2",
    fill: "#231C1C"
  }), __jsx("path", {
    d: "M45.324 54.075c6.3 0 11.5-5.1 11.5-11.3 0-6.3-5.1-11.3-11.5-11.3-6.3 0-11.5 5.1-11.5 11.3 0 6.2 5.2 11.3 11.5 11.3z",
    fill: "#FF671B"
  }), __jsx("path", {
    d: "M45.325 21.175c-12 0-21.8 9.6-21.8 21.5s9.7 21.5 21.8 21.5c12 0 21.8-9.6 21.8-21.5 0-11.8-9.8-21.5-21.8-21.5zm0 35.6c-7.9 0-14.3-6.3-14.3-14.1s6.4-14.1 14.3-14.1 14.3 6.3 14.3 14.1-6.4 14.1-14.3 14.1zM558.924 22.375c0-3.9 3.2-7.1 7.2-7.1s7.2 3.1 7.2 7.1c0 3.9-3.2 7.1-7.2 7.1s-7.2-3.1-7.2-7.1zm1.2 0c0 3.3 2.7 5.9 6 5.9s6-2.6 6-5.9c0-3.3-2.7-5.9-6-5.9s-6 2.6-6 5.9zm9.3 4.1h-1.3l-2.1-3.7h-1.5v3.7h-1.2v-8h3.4c1.5 0 2.8.4 2.8 2.1 0 1.6-1.1 2.1-2.2 2.2l2.1 3.7zm-4.9-6.8v2h1.2c1.1 0 2.6.2 2.6-.9 0-1-.9-1.1-1.8-1.1h-2zM132.024 24.175h-16.1v35.4h39.8v-9.1h-23.7v-26.3zM173.723 46.075h23.5v-8.4h-23.5v-4.4h26.7v-9.1h-42.8v35.4h44.3v-9.1h-28.2v-4.4zM337.424 46.075h23.5v-8.4h-23.5v-4.4h26.7v-9.1h-42.8v35.4h44.4v-9.1h-28.3v-4.4zM478.723 46.075h23.4v-8.4h-23.4v-4.4h26.7v-9.1h-42.8v35.4h44.3v-9.1h-28.2v-4.4zM244.825 51.575c-7.5 0-9.9-5-9.9-9.7 0-4.8 2.4-9.7 9.9-9.7 6.7 0 8.1 3.9 8.4 5.2h15.6c-1.4-8.9-9.3-14-23.6-14-16.1 0-26.5 7.4-26.5 18.6 0 10.5 9.6 18.6 26.5 18.6 15.3 0 23.8-7.6 23.8-14.7h-15.8c-.8 3.2-2.9 5.7-8.4 5.7zM397.623 43.475c0 3.6 0 8.1-7.4 8.1-7.6 0-7.6-4.5-7.6-8.1v-19.3h-15.6v21.7c0 9.8 7.7 14.5 23.1 14.5 15.5 0 23-4.7 23-14.5v-21.7h-15.6v19.3h.1zM447.123 37.975c-7.4-1.4-14.8-1.9-15.2-4.5 0-2 3.6-2.4 5.8-2.4 1.6 0 3.5.2 4.8.9 1.3.6 2.2 1.5 1.9 2.8h15.2c-.4-8.6-10.5-11.6-21.8-11.6-10.7 0-21.1 3.5-21.1 11.7 0 7.2 9.4 8.7 17.7 10.3 9 1.7 11.3 2.2 11.3 4.1 0 2.6-4 3.2-6.7 3.2-3 0-6.5-.4-7.7-2.6-.4-.6-.6-1.4-.6-2.3h-16.1c.1 11.3 17 12.8 23 12.8 11.6 0 24.1-3 24.1-12.2.1-6.5-7.2-8.8-14.6-10.2zM507.324 24.175v9.1h13.3v26.3h16.1v-26.3h12.7v-9.1h-42.1zM308.723 43.575h.2c1-.1 2.4-.4 2.4-.4 5.3-1.4 7.8-5.2 7.8-8.9 0-6.7-7.9-10.1-17-10.1h-30.6v35.4h16.1v-12.3h6.7l7.8 12.7h16.6l-.6-1-9.4-15.4zm-12.7-3.9h-8.4v-7h7.5c6.1 0 8 1.3 8 3.5 0 3.1-4.1 3.5-7.1 3.5z",
    fill: "#231C1C"
  }));
};
BrandLogo.defaultProps = {
  viewBox: "0 0 602 85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DajarProLogo = function DajarProLogo(props) {
  return __jsx("svg", props, __jsx("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  }), __jsx("g", {
    className: "currentLayer"
  }, __jsx("title", null, "Layer 1"), __jsx("g", null, __jsx("path", {
    d: "M0 13.6v-.4l1.9-.1V.9L0 .8V.3h6.3c1.7 0 3.2.2 4.4.5 1.2.3 2.2.8 2.9 1.4.7.6 1.2 1.3 1.5 2.1.3.8.5 1.7.5 2.8 0 .8-.1 1.5-.3 2.1-.2.6-.5 1.3-1 1.8-.5.6-1 1-1.7 1.4-.7.4-1.5.7-2.5.9-1 .2-2.1.3-3.3.3H0zm5.1-.6c.5.1.9.1 1.2.1.9 0 1.6-.1 2.3-.3.7-.2 1.2-.5 1.7-.9.4-.4.8-.8 1.1-1.3.3-.5.5-1.1.6-1.7.1-.6.2-1.3.2-2s0-1.4-.1-1.9c-.1-.6-.3-1.1-.5-1.6-.3-.5-.6-1-1-1.3-.4-.3-1-.6-1.7-.8C8.2 1 7.4.9 6.5.9c-.5 0-.9 0-1.4.1v12zM25 13.6v-.4l1.5-.1L32.4 0h.6l6.1 13.1 1.7.1v.4h-6.7v-.4l1.7-.1-1.5-3.3h-5.6l-1.5 3.3 1.7.1v.4H25zm3.9-4.4l5.1-.1-2.5-5.7h-.1l-2.5 5.8zM48.9 16.2c0-.4.2-.7.5-1 .3-.3.8-.4 1.3-.4.6 0 1 .1 1.3.4.3.2.5.5.5.9 0 .2-.1.4-.3.7-.2.2-.4.4-.7.5.1.1.4.2.7.2h.3c.1 0 .2 0 .4-.1.2 0 .3-.1.4-.2.1-.1.2-.2.3-.4.1-.2.2-.4.2-.7.1-.3.1-.6.1-1V.9L51.5.8V.3h7.6v.4l-1.9.2v12.2c0 .8-.1 1.6-.4 2.2-.3.6-.6 1.1-.9 1.4-.4.3-.8.6-1.3.8-.5.2-.9.3-1.3.4-.4.1-.8.1-1.2.1-.9 0-1.6-.2-2.3-.5-.6-.3-.9-.7-.9-1.3zM68.4 13.6v-.4l1.5-.1L75.8 0h.6l6.1 13.1 1.7.1v.4h-6.7v-.4l1.7-.1-1.5-3.3h-5.6l-1.5 3.3 1.7.1v.4h-3.9zm3.9-4.4l5.1-.1-2.5-5.7h-.1l-2.5 5.8zM93.9 13.6v-.4l1.9-.1V.9L93.9.8V.3h6.7c.9 0 1.8.1 2.5.2s1.4.3 2 .6c.6.3 1 .6 1.4 1 .3.4.5.9.5 1.5 0 1.1-.5 1.9-1.4 2.5-1 .6-2.3 1-3.9 1.1.7 0 1.3.1 1.8.3.5.2.9.4 1.2.6.3.3.6.6.9 1 .2.3.4.7.8 1.3.3.6.7 1.1 1 1.5.3.4.5.6.8.8.3.2.5.3.7.4.2 0 .4.1.7.1v.5h-2.1c-.6 0-1.1 0-1.5-.1-.4-.1-.7-.2-1.1-.4-.4-.2-.7-.5-1-.9-.3-.4-.8-1.2-1.5-2.5-.1-.2-.2-.4-.4-.7-.2-.3-.4-.5-.5-.7-.1-.2-.3-.3-.5-.5s-.4-.3-.6-.4c-.2-.1-.4-.1-.6-.1H99v5.7l1.9.1v.4h-7zm5.2-6.7h.5c1.5 0 2.5-.3 3.1-.8.6-.5.9-1.3.9-2.4 0-.5-.1-1-.3-1.4s-.4-.7-.7-.9c-.3-.2-.7-.4-1.1-.4-.3-.1-.7-.1-1.2-.1-.3 0-.7 0-1.2.1v5.9z"
  }), __jsx("g", null, __jsx("path", {
    d: "M39.3 28.2c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6zM51 29.4c0-.4-.1-.7-.5-.9-.3-.2-.6-.2-.9-.2h-.4v2.3h.5c.8 0 1.3-.4 1.3-1.2zM80 31.6h2.2L81.1 29z"
  }), __jsx("path", {
    d: "M19.7 23.6v14.2H90V23.6H19.7zM30.1 34h-.7v-3.1h-3.3V34h-.7v-6.4h.7v2.6h3.3v-2.6h.7V34zm9.2.1c-1.9 0-3.3-1.4-3.3-3.3s1.5-3.3 3.3-3.3 3.3 1.4 3.3 3.3-1.5 3.3-3.3 3.3zm12-.1l-2-2.8h-.2V34h-.7v-6.4h1c.4 0 1.1 0 1.6.4.4.2.7.7.7 1.4 0 1-.6 1.7-1.6 1.8l2 2.9h-.8zm10-5.7h-2.6v1.9h2.5v.7h-2.5v2.5h2.6v.7H58v-6.4h3.3v.6zm11.1.7c-.2-.2-.5-.4-.8-.6-.3-.2-.7-.2-1.1-.2-1.5 0-2.6 1.2-2.6 2.7 0 1.7 1.4 2.6 2.6 2.6.4 0 .9-.1 1.2-.3.4-.2.6-.4.7-.5v.9c-.7.5-1.5.6-1.9.6-1.9 0-3.3-1.4-3.3-3.3s1.4-3.3 3.4-3.3c.4 0 1.1 0 1.9.6v.8zm10.8 5l-.8-1.8h-2.6L79 34h-.8l3-6.7 2.9 6.7h-.9z"
  })))));
};
DajarProLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "110",
  height: "38"
};
var Download = function Download(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M17.274 24.965l-1.81 2.043v-8.802c0-.943-.558-1.572-1.393-1.572-.836 0-1.393.63-1.393 1.572v8.802l-1.811-2.043c-.557-.629-1.393-.629-1.95 0a1.657 1.657 0 0 0 0 2.2l4.179 4.716c.557.628 1.393.628 1.95 0l4.179-4.716a1.658 1.658 0 0 0 0-2.2c-.558-.629-1.393-.629-1.95 0zm5.711-17.447c-2.089-5.5-7.8-8.173-12.814-5.658-3.204 1.572-5.433 4.872-5.85 8.802-2.926.786-4.876 4.244-4.18 7.544.697 2.672 3.065 4.716 5.572 4.716h2.09c.835-.63 1.81-.944 2.785-.63v-4.086c0-2.2 1.533-3.93 3.483-3.93 1.95 0 3.482 1.73 3.482 3.93v4.087c.975-.157 1.95 0 2.786.629h.696c3.9 0 6.965-3.458 6.965-7.86 0-3.457-1.95-6.444-5.015-7.544z",
    fill: "#000"
  }));
};
Download.defaultProps = {
  width: "28",
  height: "33",
  viewBox: "0 0 28 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var icons = {
  arianeLogoIcon: __jsx(ArianeLogoIcon, null),
  sale30Icon: __jsx(Sale30Icon, null),
  sale70Icon: __jsx(Sale70Icon, null),
  searchIcon: __jsx(SearchIcon, null),
  logoIcon: __jsx(LogoIcon, null),
  titleSvg: __jsx(TitleSvg, null),
  brandLogo: __jsx(BrandLogo, null),
  kettlerLogoWhite: __jsx(KettlerLogoWhite, null),
  kettlerLogoBlack: __jsx(KettlerLogoBlack, null),
  weberLogoWhite: __jsx(WeberLogoWhite, null),
  weberLogoBlack: __jsx(WeberLogoBlack, null),
  dajarProLogo: __jsx(DajarProLogo, null),
  downloadIcon: __jsx(Download, null)
};
var _default = icons;
exports.Z = _default;

/***/ }),

/***/ 19611:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.no_image = exports["default"] = void 0;
var catLandscape = {
  name: "natural",
  aspectRatio: 1.786,
  srcset: [{
    url: "/static/images/cat_420.png",
    w: 420,
    h: 236
  }, {
    url: "/static/images/cat_768.png",
    w: 768,
    h: 430
  }, {
    url: "/static/images/cat_1024.png",
    w: 1024,
    h: 534
  }, {
    url: "/static/images/cat_1280.png",
    w: 1280,
    h: 717
  }, {
    url: "/static/images/cat_1600.png",
    w: 1600,
    h: 896
  }, {
    url: "/static/images/cat_1920.png",
    w: 1920,
    h: 1075
  }]
};
var catPortrait = {
  name: "portrait",
  aspectRatio: 0.95611578,
  srcset: [{
    url: "/static/images/cat_p420.png",
    w: 420,
    h: 489
  }, {
    url: "/static/images/cat_p768.png",
    w: 768,
    h: 894
  }, {
    url: "/static/images/cat_p920.png",
    w: 1024,
    h: 1071
  }]
};
var bannerVertical = {
  name: "natural",
  aspectRatio: 0.8135,
  srcset: [{
    url: "/static/images/banner_vertical.jpg",
    w: 375,
    h: 461
  }]
};
var bannerSmall = {
  name: "natural",
  aspectRatio: 1.1719,
  srcset: [{
    url: "/static/images/banner_small.jpg",
    w: 375,
    h: 320
  }]
};
var bannerImageVertical = {
  id: 5678,
  altText: "Banner",
  originalSrc: "/static/images/banner_vertical.jpg",
  variants: [bannerVertical]
};
var bannerImageSmall = {
  id: 5678,
  altText: "Banner",
  originalSrc: "/static/images/banner_small.jpg",
  variants: [bannerSmall]
};
var catImage = {
  id: 1234,
  altText: "Sweet kitty",
  originalSrc: "/static/images/cat_1920.png",
  variants: [catLandscape, catPortrait]
};
var collectionTile1 = {
  altText: "Garden Essentials",
  originalSrc: "/static/images/collectiontile1.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile1.png",
      w: 306,
      h: 382
    }]
  }]
};
var garnki = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/garnki.jpg",
    w: 107,
    h: 107
  }]
};
var collectionTile2 = {
  altText: "Wooden kitchen tools",
  originalSrc: "/static/images/collectiontile2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile2.png",
      w: 306,
      h: 382
    }]
  }]
};
var patelnieKwadratowe = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/patelnia_kwadratowa.jpg",
    w: 107,
    h: 107
  }]
};
var collectionTile3 = {
  altText: "Garden furniture",
  originalSrc: "/static/images/collectiontile3.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile3.png",
      w: 306,
      h: 382
    }]
  }]
};
var patelnie = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/patelnia.jpg",
    w: 107,
    h: 107
  }]
};
var collectionTile4 = {
  altText: "Baking Essentials",
  originalSrc: "/static/images/collectiontile4.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile4.png",
      w: 306,
      h: 382
    }]
  }]
};
var kuchenne = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/kuchenne.jpg",
    w: 107,
    h: 107
  }]
};
var garnkiImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/garnek.jpg",
  variants: [garnki]
};
var patelnieKwadrawtoweImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/patelnia_kwadratowa.jpg",
  variants: [patelnieKwadratowe]
};
var patelnieImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/patelnia.jpg",
  variants: [patelnie]
};
var kuchenneImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/kuchenne.jpg",
  variants: [kuchenne]
};
var instagram1 = {
  altText: "Instagram photo1",
  originalSrc: "/static/images/instagram1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram1.jpg",
      w: 188,
      h: 188
    }]
  }]
};
var instagram2 = {
  altText: "Instagram photo2",
  originalSrc: "/static/images/instagram2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram2.jpg",
      w: 188,
      h: 188
    }]
  }]
};
var instagram3 = {
  altText: "Instagram photo3",
  originalSrc: "/static/images/instagram3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram3.jpg",
      w: 188,
      h: 188
    }]
  }]
};
var pot = {
  altText: "Pot",
  originalSrc: "/static/images/products/pot.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/pot.png",
      w: 160,
      h: 160
    }]
  }]
};
var mixer = {
  altText: "Mixer",
  originalSrc: "/static/images/products/mixer.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/mixer.png",
      w: 160,
      h: 160
    }]
  }]
};
var knife = {
  altText: "Knife",
  originalSrc: "/static/images/products/knife.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/knife.png",
      w: 160,
      h: 160
    }]
  }]
};
var chair = {
  altText: "Chair",
  originalSrc: "/static/images/products/chair.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/chair.png",
      w: 160,
      h: 160
    }]
  }]
};
var collectionMain = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection_card_main.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collections/collection_card_main.jpg",
      w: 223,
      h: 223
    }]
  }]
};
var collection1 = {
  altText: "Collection thumb photo1",
  originalSrc: "/static/images/collections/collection_card_thumb_1.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collections/collection_card_thumb_1.png",
      w: 111,
      h: 111
    }]
  }]
};
var collection2 = {
  altText: "Collection thumb photo2",
  originalSrc: "/static/images/collections/collection_card_thumb_2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collections/collection_card_thumb_2.png",
      w: 111,
      h: 111
    }]
  }]
};
var collectionPageMain1 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main1.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb1a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb1-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb1-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb1b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb1-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb1-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain2 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main2.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb2a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb2-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb2-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb2b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb2-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb2-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain3 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main3.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb3a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb3-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb3-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb3b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb3-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb3-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain4 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main4.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main4.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb4a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb4-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb4-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb4b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb4-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb4-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain5 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main5.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb5a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb5-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb5-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb5b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb5-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb5-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain6 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main6.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main6.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb6a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb6-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb6-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb6b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb6-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb6-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var inspirationMain = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain2 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main2.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain3 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main3.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain4 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main4.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main4.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain5 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main5.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain6 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main6.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main6.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationThumb1 = {
  altText: "Inspiration thumb photo1",
  originalSrc: "/static/images/inspiration-thumb-1.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-thumb-1.png",
      w: 111,
      h: 111
    }]
  }]
};
var inspirationThumb2 = {
  altText: "Inspiration thumb photo2",
  originalSrc: "/static/images/inspirtaion-thumb-2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspirtaion-thumb-2.png",
      w: 111,
      h: 111
    }]
  }]
};
var inspirationThumb3 = {
  altText: "Inspiration thumb photo3",
  originalSrc: "/static/images/inspiration-thumb-3.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-thumb-3.png",
      w: 111,
      h: 111
    }]
  }]
};
var influancerPhoto = {
  altText: "Instagram profile",
  originalSrc: "/static/images/instagram-profile.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram-profile.jpg",
      w: 251,
      h: 251
    }]
  }]
};
var newsletterTopImage = {
  altText: "Newsletter to image",
  originalSrc: "/static/images/newsletter_top.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.5,
    srcset: [{
      url: "/static/images/newsletter_top.jpg",
      w: 378,
      h: 251
    }]
  }]
};
var verticalPhoto = {
  altText: "Vertical image from figma",
  originalSrc: "/static/images/vertical_photo_five_two_wooden.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8135,
    srcset: [{
      url: "/static/images/vertical_photo_five_two_wooden.jpg",
      w: 160,
      h: 237
    }]
  }]
};
var glasses = [{
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/1/293695x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/1/293695x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/1/293695x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/1/293695x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/1/293695x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/1/293695x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/1/293695x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/2/293695x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/2/293692x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/2/293692x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/2/293692x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/2/293692x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/2/293692x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/2/293692x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/3/02232x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/3/02232x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/3/02232x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/3/02232x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/3/02232x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/3/02232x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/3/02232x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/4/03854x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/4/03854x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/4/03854x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/4/03854x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/4/03854x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/4/03854x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/4/03854x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var plates = [{
  altText: "Talerz płaski Vital Rectangle 4,3 x 8 cm ARIANE",
  originalSrc: "/static/images/products/plates/1/288389x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/1/288389x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/1/288389x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/1/288389x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Talerz płaski La Scala 21 cm VILLEROY&BOCH",
  originalSrc: "/static/images/products/plates/2/294730x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/2/294730x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/2/294730x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/2/294730x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Talerz prostokątny Raku Topaz Blue 26,9 x 12,7 cm CHURCHILL",
  originalSrc: "/static/images/products/plates/3/285096x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/3/285096x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/3/285096x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/3/285096x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Talerz głęboki do burgera Vital Coupe 26 cm ARIANE",
  originalSrc: "/static/images/products/plates/4/288593x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/4/288593x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/4/288593x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/4/288593x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var cutlery = [{
  altText: "Widelec stołowy Settecento Txt 20,1 cm PINTI INOX",
  originalSrc: "/static/images/products/cutlery/1/283734x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/1/283734x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/1/283734x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/1/283734x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Nóż deserowy Settecento Txt 20,2 cm PINTI INOX",
  originalSrc: "/static/images/products/cutlery/2/283738x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/2/283738x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/2/283738x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/2/283738x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Łyżeczka do kawy Settecento Txt 11,8 cm PINTI INOX",
  originalSrc: "/static/images/products/cutlery/3/283740x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/3/283740x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/3/283740x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/3/283740x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Chochelka do sosu Durban 18 cm SOLA",
  originalSrc: "/static/images/products/cutlery/4/304596x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/4/304596x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/4/304596x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/4/304596x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var pans = [{
  altText: "Patelnia Aries z powłoką Teflon™ PlatinumPlus 36 cm AMBITION",
  originalSrc: "/static/images/products/pans/1/85685x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/pans/1/85685x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/pans/1/85685x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/pans/1/85685x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var collage1 = {
  altText: "Collage png 1",
  originalSrc: "/static/images/collage1.png",
  variants: [{
    name: "natural",
    aspectRatio: 0.92,
    srcset: [{
      url: "/static/images/collage1.png",
      w: 590,
      h: 640
    }]
  }]
};
var collage2 = {
  altText: "Collage png 2",
  originalSrc: "/static/images/collage2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1.11,
    srcset: [{
      url: "/static/images/collage2.png",
      w: 700,
      h: 630
    }]
  }]
};
var verticalSlide1 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.7716,
    srcset: [{
      url: "/static/images/slide1.jpg",
      w: 375,
      h: 486
    }]
  }]
};
var verticalSlide2 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8659,
    srcset: [{
      url: "/static/images/slide2.jpg",
      w: 840,
      h: 970
    }]
  }]
};
var verticalSlide3 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8,
    srcset: [{
      url: "/static/images/slide3.jpg",
      w: 720,
      h: 900
    }]
  }]
};
var verticalSlide4 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide4.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8285,
    srcset: [{
      url: "/static/images/slide4.jpg",
      w: 580,
      h: 700
    }]
  }]
};
var verticalSlide5 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.74,
    srcset: [{
      url: "/static/images/slide5.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var basicBannerSingle = {
  altText: "Image for basic banner",
  originalSrc: "/static/images/slide5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 2.52,
    srcset: [{
      url: "/static/images/banners/basic_single.jpg",
      w: 566,
      h: 764
    }]
  }, {
    name: "mobile",
    aspectRatio: 1.33,
    srcset: [{
      url: "/static/images/banners/basic_single_mobile.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var basicBannerDouble = {
  altText: "Image for basic banner",
  originalSrc: "/static/images/banners/basic_double.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 2.52,
    srcset: [{
      url: "/static/images/banners/basic_double.jpg",
      w: 566,
      h: 764
    }]
  }, {
    name: "mobile",
    aspectRatio: 1.33,
    srcset: [{
      url: "/static/images/banners/basic_double_mobile.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var newsletterBackground = {
  altText: "Newsletter",
  originalSrc: "/static/images/newsletter_bg_desktop.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 2.52,
    srcset: [{
      url: "/static/images/newsletter_bg_desktop.jpg",
      w: 566,
      h: 764
    }]
  }, {
    name: "mobile",
    aspectRatio: 1.33,
    srcset: [{
      url: "/static/images/newsletter_bg_mobile.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var shopDeals1 = {
  altText: "Shop deals",
  originalSrc: "/static/images/deal1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.82,
    srcset: [{
      url: "/static/images/deal1.jpg",
      w: 429,
      h: 522
    }]
  }]
};
var shopDeals2 = {
  altText: "Shop deals",
  originalSrc: "/static/images/deal2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.82,
    srcset: [{
      url: "/static/images/deal2.jpg",
      w: 429,
      h: 522
    }]
  }]
};
var relatedStories1 = {
  altText: "GreenPan Nonstick Skillet",
  originalSrc: "/static/images/related1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/related1.jpg",
      w: 375,
      h: 375
    }]
  }]
};
var relatedStories2 = {
  altText: "GreenPan Nonstick Skillet",
  originalSrc: "/static/images/related2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/related2.jpg",
      w: 223,
      h: 223
    }]
  }]
};
var no_image = {
  originalSrc: "/static/images/no-image.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/no-image.jpg",
      w: 2000,
      h: 2000
    }]
  }]
};
exports.no_image = no_image;
var loginBg = {
  originalSrc: "/static/images/logowanie-zdjecie-tlo.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.85,
    srcset: [{
      url: "/static/images/logowanie-zdjecie-tlo.jpg",
      w: 1920,
      h: 1039
    }]
  }]
};
var images = {
  catImage: catImage,
  collectionTile1: collectionTile1,
  collectionTile2: collectionTile2,
  collectionTile3: collectionTile3,
  collectionTile4: collectionTile4,
  collectionMain: collectionMain,
  collection1: collection1,
  collection2: collection2,
  inspirationMain: inspirationMain,
  inspirationMain2: inspirationMain2,
  inspirationMain3: inspirationMain3,
  inspirationMain4: inspirationMain4,
  inspirationMain5: inspirationMain5,
  inspirationMain6: inspirationMain6,
  inspirationThumb1: inspirationThumb1,
  inspirationThumb2: inspirationThumb2,
  inspirationThumb3: inspirationThumb3,
  influancerPhoto: influancerPhoto,
  instagram1: instagram1,
  instagram2: instagram2,
  instagram3: instagram3,
  pot: pot,
  chair: chair,
  knife: knife,
  mixer: mixer,
  bannerImageVertical: bannerImageVertical,
  bannerImageSmall: bannerImageSmall,
  garnkiImage: garnkiImage,
  patelnieKwadrawtoweImage: patelnieKwadrawtoweImage,
  patelnieImage: patelnieImage,
  kuchenneImage: kuchenneImage,
  newsletterTopImage: newsletterTopImage,
  verticalPhoto: verticalPhoto,
  glasses: glasses,
  plates: plates,
  cutlery: cutlery,
  pans: pans,
  collage1: collage1,
  collage2: collage2,
  verticalSlide1: verticalSlide1,
  verticalSlide2: verticalSlide2,
  verticalSlide3: verticalSlide3,
  verticalSlide4: verticalSlide4,
  verticalSlide5: verticalSlide5,
  collectionPageMain1: collectionPageMain1,
  collectionPageMain2: collectionPageMain2,
  collectionPageMain3: collectionPageMain3,
  collectionPageMain4: collectionPageMain4,
  collectionPageMain5: collectionPageMain5,
  collectionPageMain6: collectionPageMain6,
  collectionPageThumb1a: collectionPageThumb1a,
  collectionPageThumb1b: collectionPageThumb1b,
  collectionPageThumb2a: collectionPageThumb2a,
  collectionPageThumb2b: collectionPageThumb2b,
  collectionPageThumb3a: collectionPageThumb3a,
  collectionPageThumb3b: collectionPageThumb3b,
  collectionPageThumb4a: collectionPageThumb4a,
  collectionPageThumb4b: collectionPageThumb4b,
  collectionPageThumb5a: collectionPageThumb5a,
  collectionPageThumb5b: collectionPageThumb5b,
  basicBannerSingle: basicBannerSingle,
  basicBannerDouble: basicBannerDouble,
  no_image: no_image,
  newsletterBackground: newsletterBackground,
  shopDeals1: shopDeals1,
  shopDeals2: shopDeals2,
  relatedStories1: relatedStories1,
  relatedStories2: relatedStories2,
  loginBg: loginBg
};
var _default = images;
exports["default"] = _default;

/***/ }),

/***/ 67180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _prismicReactjs = __webpack_require__(56410);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _core = __webpack_require__(79329);
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _getRouteFromUrl = _interopRequireDefault(__webpack_require__(61328));
var _prismicErrorHandle = __webpack_require__(38115);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FacebookIcon = function FacebookIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.347 10.9c0-5.557-4.478-10.062-10-10.062-5.523 0-10 4.505-10 10.062 0 5.021 3.657 9.184 8.437 9.938v-7.03H6.245v-2.909h2.54V8.683c0-2.522 1.492-3.914 3.776-3.914 1.094 0 2.239.196 2.239.196v2.476h-1.261c-1.242 0-1.63.776-1.63 1.571V10.9h2.774l-.444 2.909h-2.33v7.03c4.78-.754 8.438-4.917 8.438-9.939z"
  }));
};
FacebookIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "currentColor"
};
var YoutubeIcon = function YoutubeIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M23.33 6.992c-.222-1.225-1.279-2.117-2.506-2.395-1.835-.39-5.233-.668-8.909-.668-3.674 0-7.125.279-8.963.668C1.727 4.875.668 5.71.446 6.992.222 8.384 0 10.332 0 12.838c0 2.506.222 4.455.5 5.847.224 1.225 1.281 2.116 2.506 2.395 1.949.39 5.29.668 8.966.668 3.676 0 7.017-.279 8.966-.668 1.224-.279 2.281-1.114 2.505-2.395.222-1.392.5-3.397.557-5.847-.113-2.505-.392-4.454-.67-5.846zM8.91 16.736V8.941l6.792 3.897-6.793 3.898z"
  }));
};
YoutubeIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var InstagramIcon = function InstagramIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.84c-2.716 0-3.056.011-4.123.06-1.064.048-1.791.217-2.427.465a4.901 4.901 0 0 0-1.772 1.153 4.901 4.901 0 0 0-1.153 1.771c-.247.636-.416 1.363-.465 2.428C2.012 9.783 2 10.124 2 12.84c0 2.715.012 3.056.06 4.123.049 1.064.218 1.79.465 2.427a4.902 4.902 0 0 0 1.153 1.771 4.902 4.902 0 0 0 1.772 1.154c.636.247 1.363.416 2.427.464 1.067.05 1.407.06 4.123.06s3.056-.01 4.123-.06c1.064-.048 1.791-.217 2.427-.464a4.902 4.902 0 0 0 1.772-1.154 4.902 4.902 0 0 0 1.153-1.771c.247-.636.416-1.363.465-2.427.048-1.067.06-1.408.06-4.123 0-2.716-.012-3.057-.06-4.123-.049-1.065-.218-1.792-.465-2.428a4.902 4.902 0 0 0-1.153-1.771 4.902 4.902 0 0 0-1.772-1.153c-.636-.248-1.363-.417-2.427-.465-1.067-.049-1.407-.06-4.123-.06zm0 1.801c2.67 0 2.986.01 4.04.059.976.044 1.505.207 1.858.344.466.181.8.398 1.15.748.35.35.566.683.748 1.15.137.352.3.882.344 1.857.048 1.054.058 1.37.058 4.04s-.01 2.987-.058 4.042c-.045.974-.207 1.504-.344 1.856-.182.467-.398.8-.748 1.15-.35.35-.683.567-1.15.748-.353.137-.882.3-1.857.345-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.208-1.858-.345a3.097 3.097 0 0 1-1.15-.748 3.098 3.098 0 0 1-.748-1.15c-.137-.352-.3-.882-.344-1.856-.048-1.055-.058-1.371-.058-4.041 0-2.67.01-2.987.058-4.041.045-.975.207-1.505.344-1.857.182-.467.399-.8.748-1.15.35-.35.684-.567 1.15-.748.353-.137.882-.3 1.857-.344C9.014 4.652 9.33 4.64 12 4.64z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.173a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667zm0-8.469a5.135 5.135 0 1 0 0 10.27 5.135 5.135 0 0 0 0-10.27zM18.538 7.501a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0z"
  }));
};
InstagramIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var PinterestIcon = function PinterestIcon(props) {
  return __jsx("svg", props, __jsx("defs", null, __jsx("style", null, ".cls-1", "{", "fill:currentColor", "}")), __jsx("path", {
    className: "cls-1",
    d: "M250 20C123.09 20 20 123.09 20 250s103.09 230 230 230 230-103.09 230-230S376.91 20 250 20zm0 20a210 210 0 1 1-61 411c8.61-14.39 19.71-34.94 24.13-51.92C215.71 389 226.48 348 226.48 348c7 13.37 27.47 24.69 49.26 24.69 64.84 0 111.58-59.63 111.58-133.73 0-71-58-124.18-132.55-124.18-92.8 0-142.06 62.28-142.06 130.09 0 31.54 16.78 70.8 43.64 83.3 4.07 1.9 6.25 1.08 7.19-2.87.71-3 4.34-17.58 6-24.37a6.45 6.45 0 0 0-1.48-6.17c-8.89-10.79-16-30.59-16-49.07 0-47.42 35.9-93.32 97.07-93.32 52.82 0 89.81 36 89.81 87.48 0 58.16-29.37 98.46-67.58 98.46-21.1 0-36.91-17.46-31.84-38.87 6.08-25.55 17.82-53.12 17.82-71.58 0-16.5-8.86-30.27-27.21-30.27-21.58 0-38.91 22.3-38.91 52.21 0 19 6.45 31.91 6.45 31.91s-21.31 90.11-25.22 106.88-2.86 39.32-1.25 56.13A210 210 0 0 1 250 40z",
    transform: "translate(-20 -20)"
  }));
};
PinterestIcon.defaultProps = {
  id: "Warstwa_1",
  "'data-name'": "Warstwa 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "currentColor",
  viewBox: "0 0 460 460"
};
var defaultProps = {
  additionalSeparator: true,
  hoverColor: "neutral700",
  socialElementsAndLanguagePickerAsColumn: true,
  bgColor: "neutral",
  fontColor: "black",
  additionalFont: "label2",
  headingFont: "heading3",
  submenuFont: "body2",
  linksUnderline: true,
  topPadding: true,
  desktopTopPadding: "s12",
  threeColumns: false,
  directLinks: false
};
var isColumnFilled = function isColumnFilled(footerColumn) {
  var _footerColumn$items, _footerColumn$title, _footerColumn$content;
  return (footerColumn === null || footerColumn === void 0 ? void 0 : (_footerColumn$items = footerColumn.items) === null || _footerColumn$items === void 0 ? void 0 : _footerColumn$items.length) > 0 || (footerColumn === null || footerColumn === void 0 ? void 0 : (_footerColumn$title = footerColumn.title) === null || _footerColumn$title === void 0 ? void 0 : _footerColumn$title.length) || (footerColumn === null || footerColumn === void 0 ? void 0 : (_footerColumn$content = footerColumn.content) === null || _footerColumn$content === void 0 ? void 0 : _footerColumn$content.length);
};
var Footer = function Footer(_ref) {
  var _footerContent$social, _footerContent$social2, _footerContent$rights;
  var contentBlocks = _ref.contentBlocks,
    socialMediaElements = _ref.socialMediaElements,
    _ref$socialElementsAn = _ref.socialElementsAndLanguagePickerAsColumn,
    socialElementsAndLanguagePickerAsColumn = _ref$socialElementsAn === void 0 ? defaultProps.socialElementsAndLanguagePickerAsColumn : _ref$socialElementsAn,
    additionalInfo = _ref.additionalInfo,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? defaultProps.bgColor : _ref$bgColor,
    _ref$fontColor = _ref.fontColor,
    fontColor = _ref$fontColor === void 0 ? defaultProps.fontColor : _ref$fontColor,
    _ref$additionalFont = _ref.additionalFont,
    additionalFont = _ref$additionalFont === void 0 ? defaultProps.additionalFont : _ref$additionalFont,
    _ref$additionalSepara = _ref.additionalSeparator,
    additionalSeparator = _ref$additionalSepara === void 0 ? defaultProps.additionalSeparator : _ref$additionalSepara,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === void 0 ? defaultProps.hoverColor : _ref$hoverColor,
    footerContent = _ref.footerContent,
    languages = _ref.languages,
    _ref$headingFont = _ref.headingFont,
    headingFont = _ref$headingFont === void 0 ? defaultProps.headingFont : _ref$headingFont,
    _ref$submenuFont = _ref.submenuFont,
    submenuFont = _ref$submenuFont === void 0 ? defaultProps.submenuFont : _ref$submenuFont,
    _ref$linksUnderline = _ref.linksUnderline,
    linksUnderline = _ref$linksUnderline === void 0 ? defaultProps.linksUnderline : _ref$linksUnderline,
    _ref$topPadding = _ref.topPadding,
    topPadding = _ref$topPadding === void 0 ? defaultProps.topPadding : _ref$topPadding,
    _ref$desktopTopPaddin = _ref.desktopTopPadding,
    desktopTopPadding = _ref$desktopTopPaddin === void 0 ? defaultProps.desktopTopPadding : _ref$desktopTopPaddin,
    _ref$threeColumns = _ref.threeColumns,
    threeColumns = _ref$threeColumns === void 0 ? defaultProps.threeColumns : _ref$threeColumns,
    _ref$directLinks = _ref.directLinks,
    directLinks = _ref$directLinks === void 0 ? defaultProps.directLinks : _ref$directLinks;
  var translations = {
    rights: (0, _langLibrary["default"])("© 2020 DAJAR All rights reserved.")
  };
  var generateColumnLink = function generateColumnLink(item) {
    var routeFromUrl = (0, _getRouteFromUrl["default"])(item.url);
    var linkContent = __jsx(_LinkRaw["default"], {
      sx: {
        color: fontColor,
        textDecoration: "none",
        ":hover": {
          color: hoverColor
        }
      }
    }, item.text);
    return directLinks ? __jsx(Link, {
      href: item.url.includes(".") ? "https://" + item.url : item.url
    }, linkContent) : __jsx(Link, {
      route: routeFromUrl !== null && routeFromUrl !== void 0 ? routeFromUrl : item.url,
      params: {
        url: item.url
      }
    }, linkContent);
  };
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Box["default"], {
    id: "footer",
    sx: {
      bg: bgColor
    }
  }, __jsx(_Container["default"], {
    sx: {
      pt: topPadding ? ["s10", null, null, desktopTopPadding, null, null] : 0,
      pb: ["s10", null, null, "s8", null, null],
      mt: topPadding ? 0 : "-35px",
      font: submenuFont,
      color: fontColor
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      flexWrap: "nowrap"
    }
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: [null, null, null, "80%", "70%", "50%"]
    }
  }, contentBlocks && contentBlocks.length > 0 && __jsx(_Grid["default"], {
    cols: [2, null, null, contentBlocks.length, null, null]
  }, contentBlocks && contentBlocks.map(function (block) {
    return __jsx(_Box["default"], {
      sx: {
        mb: (0, _core.lin)("s4", "s7"),
        p: {
          m: "s0",
          font: headingFont
        },
        ul: {
          display: "flex",
          flexDirection: "column",
          listStyleType: "none",
          p: "s0",
          mt: "s9",
          mb: "s0"
        },
        li: {
          lineHeight: "40px"
        },
        a: {
          color: fontColor,
          textDecoration: "none",
          ":hover": {
            color: hoverColor
          }
        }
      },
      key: "grid-" + block.id,
      dangerouslySetInnerHTML: {
        __html: block.content
      }
    });
  })), footerContent && footerContent !== _prismicErrorHandle.TIMEOUT && __jsx(_Grid["default"], {
    cols: [threeColumns ? 2 : 1, 2, null, threeColumns ? 3 : 4, null, null]
  }, footerContent && footerContent.columns.map(function (footerColumn, index) {
    return isColumnFilled(footerColumn) && __jsx(_Box["default"], {
      key: index,
      sx: {
        mb: (0, _core.lin)("s4", "s7")
      }
    }, __jsx(_Box["default"], {
      sx: {
        m: "s0",
        font: headingFont
      }
    }, footerColumn.title), __jsx(_Box["default"], {
      as: "ul",
      sx: {
        display: "flex",
        flexDirection: "column",
        listStyleType: "none",
        p: "s0",
        mt: "s9",
        mb: "s0",
        a: {
          color: fontColor,
          textDecoration: "none",
          ":hover": {
            color: hoverColor
          }
        }
      }
    }, footerColumn.items.map(function (item, index) {
      return __jsx(_Box["default"], {
        as: "li",
        key: index,
        sx: {
          lineHeight: "40px"
        }
      }, generateColumnLink(item));
    }), footerColumn.content && __jsx(_Box["default"], {
      as: "li",
      sx: {
        p: {
          mt: "s5"
        }
      }
    }, _prismicReactjs.RichText.render(footerColumn.content))));
  }))), socialElementsAndLanguagePickerAsColumn && __jsx(_Box["default"], {
    sx: {
      flexBasis: [null, null, null, "20%", "30%", "50%"],
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: ["center", null, null, "flex-end", null, null]
    }
  }, socialMediaElements === null || socialMediaElements === void 0 ? void 0 : socialMediaElements.map(function (social, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        mx: ["s8", null, null, "s7", null, null],
        maxWidth: "24px",
        minWidth: "24px",
        fill: fontColor,
        ":hover": {
          fill: hoverColor
        },
        ":last-child": {
          mr: ["s8", null, null, "s0", null, null]
        },
        mt: ["s10", null, null, "s0", null, null]
      }
    }, __jsx(_LinkRaw["default"], {
      href: social.url,
      title: social.name
    }, __jsx(social.img, null)));
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      flexBasis: [threeColumns ? "165px" : "50%", null, null, "80%", "50%", threeColumns ? "130px" : "22.3%"],
      maxWidth: threeColumns ? "165px" : "156px"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      mb: "s8"
    }
  }, footerContent === null || footerContent === void 0 ? void 0 : (_footerContent$social = footerContent.social) === null || _footerContent$social === void 0 ? void 0 : _footerContent$social.map(function (social, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        display: "flex",
        alignItems: "center",
        maxWidth: "24px",
        minWidth: "24px",
        maxHeight: "24px",
        minHeight: "24px",
        textAlign: "center",
        "a:hover": {
          fill: hoverColor
        },
        mt: ["s10", null, null, "s0", null, null],
        a: {
          color: fontColor,
          display: "inline-block",
          width: "24px"
        }
      }
    }, __jsx("a", {
      href: social.url,
      title: social.text
    }, social.text.toLowerCase() === "facebook" ? __jsx(FacebookIcon, null) : social.text.toLowerCase() === "youtube" ? __jsx(YoutubeIcon, null) : social.text.toLowerCase() === "instagram" ? __jsx(InstagramIcon, null) : social.text.toLowerCase() === "pinterest" ? __jsx(PinterestIcon, null) : undefined));
  })), languages && __jsx(_Box["default"], null, languages)))), !socialElementsAndLanguagePickerAsColumn && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      alignItems: "center",
      mt: "s11"
    }
  }, languages && __jsx(_Box["default"], null, languages), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, footerContent === null || footerContent === void 0 ? void 0 : (_footerContent$social2 = footerContent.social) === null || _footerContent$social2 === void 0 ? void 0 : _footerContent$social2.map(function (social, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        maxWidth: "24px",
        height: "24px",
        minWidth: "24px",
        mt: ["s8", null, null, 0],
        ml: [index > 0 ? "s5" : 0, null, null, "s10"],
        svg: {
          fill: fontColor,
          ":hover": {
            fill: hoverColor
          }
        }
      }
    }, __jsx(Link, {
      href: social.url
    }, __jsx(_LinkRaw["default"], {
      title: social.text
    }, social.text === "Facebook" ? __jsx(FacebookIcon, null) : social.text === "YouTube" ? __jsx(YoutubeIcon, null) : social.text === "Instagram" ? __jsx(InstagramIcon, null) : undefined)));
  }))), __jsx(_Grid["default"], {
    cols: 1
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      mt: [threeColumns ? "s8" : "s10", null, null, "s12", null, null]
    }
  }, __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: additionalFont,
      pr: "s3",
      mb: ["s5", null, null, "s0", null, null]
    }
  }, footerContent !== null && footerContent !== void 0 && footerContent.rights ? __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexWrap: threeColumns ? ["wrap", null, null, "nowrap"] : "nowrap",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, !threeColumns && {
      display: ["none", null, null, "block"]
    }), {}, {
      mr: threeColumns ? "s3" : "s6",
      flexBasis: threeColumns ? ["100%", null, null, "auto"] : "auto",
      mb: threeColumns ? ["s4", null, null, 0] : 0
    })
  }, footerContent.rights.text), footerContent.rights.items.map(function (link, index) {
    var routeFromUrl = (0, _getRouteFromUrl["default"])(link.url);
    return __jsx(_Box["default"], {
      sx: {
        px: threeColumns ? 0 : ["s4", null, null, 0]
      }
    }, __jsx(_Box["default"], {
      as: "span",
      sx: {
        display: [index === 0 ? "none" : "inline", null, null, "inline"]
      }
    }, threeColumns ? "|" : ""), __jsx(Link, {
      key: index,
      route: routeFromUrl ? routeFromUrl : link.url,
      params: {
        url: link.url
      }
    }, __jsx(_LinkRaw["default"], {
      title: link.text,
      sx: {
        ml: threeColumns ? "s3" : [0, null, null, "s7"],
        textDecoration: linksUnderline ? "underline" : "none",
        ":hover": {
          color: hoverColor
        },
        mr: threeColumns ? "s3" : 0
      }
    }, link.text)));
  })) : translations.rights), additionalInfo && __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: additionalFont
    }
  }, additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.map(function (additional, index) {
    return __jsx(Link, {
      route: additional.url
    }, __jsx(_LinkRaw["default"], {
      key: index,
      title: additional.name
    }, additionalSeparator && __jsx(_Box["default"], {
      as: "span",
      sx: index === 0 && {
        display: ["none", null, null, "inline", null, null]
      }
    }, "|"), __jsx(_Box["default"], {
      as: "span",
      sx: {
        px: "s3",
        cursor: "pointer",
        textDecoration: "underline"
      }
    }, additional.name)));
  })), __jsx(_Box["default"], {
    sx: {
      display: threeColumns ? "none" : ["block", null, null, "none"],
      textAlign: "center",
      flexBasis: threeColumns ? ["100%", null, null, "auto"] : "auto",
      mt: "s7",
      font: additionalFont
    }
  }, footerContent === null || footerContent === void 0 ? void 0 : (_footerContent$rights = footerContent.rights) === null || _footerContent$rights === void 0 ? void 0 : _footerContent$rights.text)))));
};
var _default = Footer;
exports.Z = _default;

/***/ }),

/***/ 80747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _RouteContext = __webpack_require__(73157);
var _TokenProvider = __webpack_require__(36286);
var _CheckoutSteps = _interopRequireDefault(__webpack_require__(35865));
var _Display = _interopRequireDefault(__webpack_require__(35572));
var _useScrollSegment = _interopRequireDefault(__webpack_require__(23931));
var _useScrollDirection = _interopRequireDefault(__webpack_require__(90737));
var _useMinicart2 = __webpack_require__(34698);
var _useLoader2 = __webpack_require__(87573);
var __jsx = _react["default"].createElement;
var MobileMenuIcon = function MobileMenuIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.747 21.056h10.831v1.2H2.748v-1.2zM2.747 15.056h19.28v1.2H2.747v-1.2zM2.747 9.527h19.28v1.2H2.747v-1.2zM2.747 3.527h19.28v1.2H2.747v-1.2z"
  }));
};
MobileMenuIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CartIcon = function CartIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.723 8.944C2.723 7.54 3.914 6.4 5.384 6.4h14.33c1.47 0 2.662 1.14 2.662 2.544l1.023 13.7c0 1.406-1.191 2.545-2.661 2.545H4.36c-1.47 0-2.662-1.139-2.662-2.544l1.024-13.7zm2.661-1.37c-.791 0-1.433.614-1.433 1.37l-1.023 13.7c0 .758.641 1.37 1.433 1.37h16.377c.791 0 1.433-.613 1.433-1.37l-1.024-13.7c0-.756-.641-1.37-1.433-1.37H5.384z",
    fill: "#2E4557"
  }), __jsx("g", {
    clipPath: "url(#a)",
    stroke: "#2E4557",
    strokeWidth: "1.1",
    strokeMiterlimit: "10"
  }, __jsx("path", {
    d: "M17.8 9.55V5.57M7.55 5.45v4.17M17.8 5.68c0-2.83-2.29-5.12-5.12-5.12a5.12 5.12 0 0 0-5.13 5.12"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    transform: "translate(7)",
    d: "M0 0h11.35v9.62H0z"
  }))));
};
CartIcon.defaultProps = {
  width: "24",
  height: "26",
  viewBox: "0 0 24 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchIcon = function SearchIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
SearchIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  minifiedContent: false
};
var Header = function Header(props) {
  var onMobileMenuClick = props.onMobileMenuClick,
    onSearchClick = props.onSearchClick,
    onCartClick = props.onCartClick,
    logo = props.logo,
    button = props.button,
    desktopSearch = props.desktopSearch,
    scrollingPart = props.scrollingPart,
    _props$minifiedConten = props.minifiedContent,
    minifiedContent = _props$minifiedConten === void 0 ? defaultProps.minifiedContent : _props$minifiedConten,
    checkoutUrl = props.checkoutUrl,
    helpLink = props.helpLink,
    additionalLogo = props.additionalLogo,
    cssOverride = props.cssOverride,
    bgColor = props.bgColor,
    logoFillColor = props.logoFillColor;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useLoader = (0, _useLoader2.useLoader)(),
    submenuLoaded = _useLoader.submenuLoaded;
  var translations = {
    login: (0, _langLibrary["default"])("Log in"),
    register: (0, _langLibrary["default"])("Register"),
    myAccount: (0, _langLibrary["default"])("My account"),
    needHelp: (0, _langLibrary["default"])("Needs help?"),
    shipment: (0, _langLibrary["default"])("Shipment"),
    payment: (0, _langLibrary["default"])("Payment"),
    cart: (0, _langLibrary["default"])("Cart")
  };
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    itemsAmount = _useMinicart.itemsAmount;
  var steps = [{
    text: translations.shipment,
    route: "checkout"
  }, {
    text: translations.payment,
    route: "checkout-payment"
  }];
  var isNotAtTop = (0, _useScrollSegment["default"])({
    from: 1
  });
  var isScrollingDown = (0, _useScrollDirection["default"])();
  if (isScrollingDown === undefined && scrollingPart) {
    return __jsx(_react["default"].Fragment, null);
  } else {
    return __jsx("header", null, __jsx(_Box["default"], {
      sx: {
        borderBottomWidth: ["1px", null, null, null, "0", null],
        borderStyle: "solid",
        borderColor: "neutral",
        bg: bgColor !== null && bgColor !== void 0 ? bgColor : "transparent",
        display: scrollingPart && (!isNotAtTop || !isScrollingDown) ? "none" : "block"
      }
    }, __jsx(_Container["default"], {
      margin: isNotAtTop && isScrollingDown ? ["containerMargin", null, null, null, 26] : "containerMargin"
    }, __jsx(_Grid["default"], {
      cols: isNotAtTop && isScrollingDown ? [24, null, null, null, 20] : 1
    }, __jsx(_Box["default"], {
      sx: {
        gridColumn: checkoutUrl && (!isNotAtTop || !isScrollingDown) ? "span 24" : isNotAtTop && isScrollingDown ? ["span 24", null, null, null, "span 20"] : "unset",
        height: isNotAtTop && isScrollingDown ? cssOverride ? [cssOverride.scrollingHeaderHeightMobile + "px", null, null, null, cssOverride.scrollingHeaderHeight + "px"] : ["48px", null, null, null, "68px"] : cssOverride ? [cssOverride.headerHeightMobile + "px", null, null, null, cssOverride.headerHeight + "px", null] : ["48px", null, null, null, "72px", null],
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        color: "main",
        background: bgColor !== null && bgColor !== void 0 ? bgColor : "white"
      }
    }, !minifiedContent && __jsx(_Box["default"], {
      sx: {
        display: ["flex", null, null, null, "none", null],
        flex: [null, null, null, null, "1", null],
        zIndex: "1"
      },
      as: "div"
    }, /*#__PURE__*/_react["default"].cloneElement(button, {
      disabled: !submenuLoaded,
      onClick: onMobileMenuClick
    }, __jsx(MobileMenuIcon, null)), __jsx(_Box["default"], {
      sx: {
        pl: "s6"
      }
    }, /*#__PURE__*/_react["default"].cloneElement(button, {
      onClick: onSearchClick,
      "data-test": "open-search-mobile"
    }, __jsx(SearchIcon, null)))), !minifiedContent && __jsx(_Box["default"], {
      sx: {
        zIndex: 2
      }
    }, __jsx(_Box["default"], {
      sx: {
        display: isNotAtTop && isScrollingDown ? "none" : ["none", null, null, null, "block", null]
      }
    }, desktopSearch)), __jsx(_Box["default"], {
      sx: {
        width: isNotAtTop && isScrollingDown ? ["100%", null, null, null, "auto", null] : "100%",
        position: "absolute",
        textAlign: "center",
        zIndex: [0, null, null, null, 1, null],
        transition: "200ms",
        ":hover": {
          opacity: "0.9"
        },
        flex: ["1", null, null, null, "1", null],
        alignItems: "center",
        svg: {
          fill: logoFillColor !== null && logoFillColor !== void 0 ? logoFillColor : "main",
          width: isNotAtTop && isScrollingDown ? cssOverride ? ["auto", null, null, null, cssOverride.logoWidthScrolling + "px", null] : ["auto", null, null, null, "120px", null] : cssOverride ? ["auto", null, null, null, cssOverride.logoWidth + "px", null] : ["auto", null, null, null, "150px", null],
          height: ["24px", null, null, null, "44px", null],
          maxWidth: isNotAtTop && isScrollingDown ? ["unset", null, null, null, "8vw", null] : "unset"
        }
      }
    }, __jsx(_Box["default"], {
      sx: {
        height: "44px",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        alignContent: "center"
      }
    }, __jsx(Link, {
      route: "home-page"
    }, __jsx(_LinkRaw["default"], {
      title: "Dajar",
      sx: {
        display: "flex",
        justifyContent: "center"
      }
    }, isNotAtTop && isScrollingDown ? additionalLogo !== null && additionalLogo !== void 0 ? additionalLogo : logo : logo)))), !minifiedContent && __jsx(_Box["default"], {
      sx: {
        font: "body2",
        zIndex: "1",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center"
      }
    }, (!isNotAtTop || !isScrollingDown) && __jsx(_Box["default"], {
      sx: {
        mr: "s8",
        display: "inline-block"
      }
    }, token ? __jsx(_Box["default"], null, __jsx(_Box["default"], {
      sx: {
        display: ["none", null, null, null, "inline-block", null]
      }
    }, __jsx(Link, {
      route: "account-info"
    }, __jsx(_LinkRaw["default"], {
      title: translations.myAccount,
      "data-test": "my-account-link"
    }, translations.myAccount)))) : __jsx(_Box["default"], {
      sx: {
        display: ["none", null, null, null, "inline-block", null]
      }
    }, __jsx(Link, {
      route: "login"
    }, __jsx(_LinkRaw["default"], {
      title: translations.login,
      "data-test": "login-link"
    }, translations.login)))), !token && (!isNotAtTop || !isScrollingDown) && __jsx(_Box["default"], {
      sx: {
        mr: "s8",
        display: ["none", null, null, null, "inline-block", null]
      }
    }, __jsx(Link, {
      route: "register"
    }, __jsx(_LinkRaw["default"], {
      title: translations.register,
      "data-test": "registration-link"
    }, translations.register))), __jsx(_Box["default"], {
      "data-test": "mini-cart"
    }, /*#__PURE__*/_react["default"].cloneElement(button, {
      onClick: function onClick() {
        return onCartClick();
      }
    }, __jsx(_Box["default"], {
      sx: {
        font: "body2",
        color: "main",
        mr: "s4",
        display: ["none", null, "block"]
      }
    }, translations.cart), __jsx(_Box["default"], {
      sx: {
        width: "28px",
        height: "28px",
        position: "relative",
        display: "inline-block",
        textAlign: "center"
      }
    }, __jsx(CartIcon, null), __jsx(_Box["default"], {
      as: "span",
      sx: {
        position: "absolute",
        font: "xxs_caps",
        bottom: 2,
        right: [3, null, null, null, null, 4],
        width: "20px",
        height: "20px",
        lineHeight: "20px"
      }
    }, itemsAmount))))), minifiedContent && __jsx(_Display["default"], {
      when: [false, null, null, checkoutUrl !== "/checkout/success"]
    }, __jsx(_Box["default"], {
      sx: {
        position: "relative",
        zIndex: "1",
        py: "0px",
        left: isScrollingDown ? ["unset", null, null, "10vw", null, "8vw"] : "unset"
      }
    }, __jsx(_CheckoutSteps["default"], {
      steps: steps,
      activeStep: checkoutUrl === "/checkout" ? 0 : 1,
      sx: {
        position: "relative",
        zIndex: "1",
        py: "0px"
      }
    }))), minifiedContent && __jsx(_Box["default"], {
      sx: {
        position: "relative",
        zIndex: "1",
        marginLeft: "auto",
        marginRight: "0px"
      }
    }, __jsx(Link, {
      route: helpLink
    }, __jsx(_LinkRaw["default"], {
      title: translations.needHelp,
      sx: {
        font: "xs_underline",
        cursor: "pointer"
      }
    }, translations.needHelp))))))));
  }
};
var _default = Header;
exports.Z = _default;

/***/ }),

/***/ 79772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(55167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onRouterTransitionStart */
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12793);
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25622);

var _sentryCollisionFreeGlobalObject =  true ? window : 0;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "a7JY_wogkqogbnvjWioV6"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
_sentry_react__WEBPACK_IMPORTED_MODULE_0__/* .init */ .S({
    dsn: "https://c67a5c69549d7fe46e44c1c9f41a9c92@o4507723380555776.ingest.de.sentry.io/4509156596580432",
    tracesSampleRate: 0
});
var onRouterTransitionStart = _sentry_react__WEBPACK_IMPORTED_MODULE_1__.captureRouterTransitionStart;


/***/ }),

/***/ 75250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _head = _interopRequireDefault(__webpack_require__(77848));
var _imageConfig = __webpack_require__(51838);
var _useIntersection = __webpack_require__(7359);
var _imageConfigContext = __webpack_require__(38306);
function _defineProperty1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var configEnv = {"deviceSizes":[420,768,1600],"imageSizes":[100,210,1024,1400],"path":"/_next/image","loader":"default"};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    'lazy',
    'eager',
    undefined
]));
var loaders = new Map([
    [
        'default',
        defaultLoader
    ],
    [
        'imgix',
        imgixLoader
    ],
    [
        'cloudinary',
        cloudinaryLoader
    ],
    [
        'akamai',
        akamaiLoader
    ],
    [
        'custom',
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    'fill',
    'fixed',
    'intrinsic',
    'responsive',
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === 'object' && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === 'fill' || layout === 'responsive')) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: 'w'
            };
        }
        return {
            widths: allSizes,
            kind: 'w'
        };
    }
    if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
        return {
            widths: deviceSizes,
            kind: 'w'
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: 'x'
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === 'w' ? '100vw' : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
        }).join(', '),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === 'number') {
        return x;
    }
    if (typeof x === 'string') {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) === null || ref === void 0 ? void 0 : ref.loader) || 'default';
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(imgRef, src, layout, placeholder, onLoadingCompleteRef) {
    var handleLoad = function() {
        var img = imgRef.current;
        if (!img) {
            return;
        }
        if (img.src !== emptyDataURL) {
            var p = 'decode' in img ? img.decode() : Promise.resolve();
            p.catch(function() {}).then(function() {
                if (!imgRef.current) {
                    return;
                }
                loadedImageURLs.add(src);
                if (placeholder === 'blur') {
                    img.style.filter = '';
                    img.style.backgroundSize = '';
                    img.style.backgroundImage = '';
                    img.style.backgroundPosition = '';
                }
                if (onLoadingCompleteRef.current) {
                    var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
                    // Pass back read-only primitive values but not the
                    // underlying DOM element because it could be misused.
                    onLoadingCompleteRef.current({
                        naturalWidth: naturalWidth,
                        naturalHeight: naturalHeight
                    });
                }
                if (false) { var parent, ref; }
            });
        }
    };
    if (imgRef.current) {
        if (imgRef.current.complete) {
            // If the real image fails to load, this will still remove the placeholder.
            // This is the desired behavior for now, and will be revisited when error
            // handling is worked on for the image component itself.
            handleLoad();
        } else {
            imgRef.current.onload = handleLoad;
        }
    }
}
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? '200px' : _lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _loader = _param.loader, loader = _loader === void 0 ? defaultImageLoader : _loader, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? 'empty' : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutProperties(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "loader",
        "placeholder",
        "blurDataURL"
    ]);
    var imgRef = (0, _react).useRef(null);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _objectSpread({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? 'responsive' : 'intrinsic';
    if ('layout' in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread into image:
        delete rest['layout'];
    }
    var staticSrc = '';
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== 'fill') {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === 'string' ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');
    if (src.startsWith('data:') || src.startsWith('blob:')) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (false) { var url, urlStr, VALID_BLUR_EXT; }
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary,
        disabled: !isLazy
    }), 2), setIntersection = ref1[0], isIntersected = ref1[1];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: 'border-box',
        display: 'block',
        overflow: 'hidden',
        width: 'initial',
        height: 'initial',
        background: 'none',
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        width: 'initial',
        height: 'initial',
        background: 'none',
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var imgStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: 'border-box',
        padding: 0,
        border: 'none',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        minWidth: '100%',
        maxWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var blurStyle = placeholder === 'blur' ? {
        filter: 'blur(20px)',
        backgroundSize: objectFit || 'cover',
        backgroundImage: "url(\"".concat(blurDataURL, "\")"),
        backgroundPosition: objectPosition || '0% 0%'
    } : {};
    if (layout === 'fill') {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = 'block';
        wrapperStyle.position = 'absolute';
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined') {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");
        if (layout === 'responsive') {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = 'block';
            wrapperStyle.position = 'relative';
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === 'intrinsic') {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = 'inline-block';
            wrapperStyle.position = 'relative';
            wrapperStyle.maxWidth = '100%';
            hasSizer = true;
            sizerStyle.maxWidth = '100%';
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === 'fixed') {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = 'inline-block';
            wrapperStyle.position = 'relative';
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = 'imagesrcset';
    var imageSizesPropName = 'imagesizes';
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        setIntersection(imgRef.current);
    }, [
        setIntersection
    ]);
    (0, _react).useEffect(function() {
        handleLoading(imgRef, srcString, layout, placeholder, onLoadingCompleteRef);
    }, [
        srcString,
        layout,
        placeholder,
        isVisible
    ]);
    return(/*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: 'block',
            maxWidth: '100%',
            width: 'initial',
            height: 'initial',
            background: 'none',
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        ref: imgRef,
        style: _objectSpread({}, imgStyle, blurStyle)
    })), isLazy && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: src,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading || 'lazy'
    }))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: '__nimg-' + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null));
}
function normalizeSrc(src) {
    return src[0] === '/' ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set('auto', params.get('auto') || 'format');
    params.set('fit', params.get('fit') || 'max');
    params.set('w', params.get('w') || width.toString());
    if (quality) {
        params.set('q', quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        'f_auto',
        'c_limit',
        'w_' + width,
        'q_' + (quality || 'auto')
    ];
    var paramsString = params.join(',') + '/';
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error("Image with src \"".concat(src, "\" is missing \"loader\" prop.") + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var parsedSrc, missingValues; }
    if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 19337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _router = __webpack_require__(35802);
var _router1 = __webpack_require__(84361);
var _useIntersection = __webpack_require__(7359);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === 'A';
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === 'string') {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === 'object' && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: '200px'
    }), 2), setIntersectionRef = ref1[0], isVisible = ref1[1];
    var setRef = _react.default.useCallback(function(el) {
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === 'function') childRef(el);
            else if (typeof childRef === 'object') {
                childRef.current = el;
            }
        }
    }, [
        childRef,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
        var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === 'function') {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === 'function') {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === 'a' && !('href' in child.props)) {
        var curLocale1 = typeof locale !== 'undefined' ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return(/*#__PURE__*/ _react.default.cloneElement(child, childProps));
}
var _default = Link;
exports["default"] = _default; //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(34885);
var _requestIdleCallback = __webpack_require__(65040);
var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ''
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 59445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

var _runtimeJs = _interopRequireDefault(__webpack_require__(94986));
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _utils.AppInitialProps;
    }
});
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _utils.NextWebVitalsMetric;
    }
});
exports["default"] = void 0;
var _react = _interopRequireDefault1(__webpack_require__(34885));
var _utils = __webpack_require__(82575);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _interopRequireDefault1(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _appGetInitialProps() {
    _appGetInitialProps = /**
 * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
 * This allows for keeping state between navigation, custom error handling, injecting additional data.
 */ _asyncToGenerator(_runtimeJs.default.mark(function _callee(param) {
        var Component, ctx, pageProps;
        return _runtimeJs.default.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    Component = param.Component, ctx = param.ctx;
                    _ctx.next = 3;
                    return (0, _utils).loadGetInitialProps(Component, ctx);
                case 3:
                    pageProps = _ctx.sent;
                    return _ctx.abrupt("return", {
                        pageProps: pageProps
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _appGetInitialProps.apply(this, arguments);
}
function appGetInitialProps(_) {
    return _appGetInitialProps.apply(this, arguments);
}
var App = /*#__PURE__*/ function(_Component) {
    _inherits(App, _Component);
    var _super = _createSuper(App);
    function App() {
        _classCallCheck(this, App);
        return _super.apply(this, arguments);
    }
    _createClass(App, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Component = _props.Component, pageProps = _props.pageProps;
                return(/*#__PURE__*/ _react.default.createElement(Component, Object.assign({}, pageProps)));
            }
        }
    ]);
    return App;
}(_react.default.Component);
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App; //# sourceMappingURL=_app.js.map


/***/ }),

/***/ 52803:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.PHASE_PRODUCTION_BUILD = __webpack_unused_export__ = void 0;
var PHASE_EXPORT = 'phase-export';
__webpack_unused_export__ = PHASE_EXPORT;
var PHASE_PRODUCTION_BUILD = 'phase-production-build';
exports.PHASE_PRODUCTION_BUILD = PHASE_PRODUCTION_BUILD;
var PHASE_PRODUCTION_SERVER = 'phase-production-server';
__webpack_unused_export__ = PHASE_PRODUCTION_SERVER;
var PHASE_DEVELOPMENT_SERVER = 'phase-development-server';
__webpack_unused_export__ = PHASE_DEVELOPMENT_SERVER;
var PHASE_TEST = 'phase-test';
__webpack_unused_export__ = PHASE_TEST;
var PAGES_MANIFEST = 'pages-manifest.json';
__webpack_unused_export__ = PAGES_MANIFEST;
var BUILD_MANIFEST = 'build-manifest.json';
__webpack_unused_export__ = BUILD_MANIFEST;
var EXPORT_MARKER = 'export-marker.json';
__webpack_unused_export__ = EXPORT_MARKER;
var EXPORT_DETAIL = 'export-detail.json';
__webpack_unused_export__ = EXPORT_DETAIL;
var PRERENDER_MANIFEST = 'prerender-manifest.json';
__webpack_unused_export__ = PRERENDER_MANIFEST;
var ROUTES_MANIFEST = 'routes-manifest.json';
__webpack_unused_export__ = ROUTES_MANIFEST;
var IMAGES_MANIFEST = 'images-manifest.json';
__webpack_unused_export__ = IMAGES_MANIFEST;
var SERVER_FILES_MANIFEST = 'required-server-files.json';
__webpack_unused_export__ = SERVER_FILES_MANIFEST;
var DEV_CLIENT_PAGES_MANIFEST = '_devPagesManifest.json';
__webpack_unused_export__ = DEV_CLIENT_PAGES_MANIFEST;
var FUNCTIONS_MANIFEST = 'functions-manifest.json';
__webpack_unused_export__ = FUNCTIONS_MANIFEST;
var MIDDLEWARE_MANIFEST = 'middleware-manifest.json';
__webpack_unused_export__ = MIDDLEWARE_MANIFEST;
var DEV_MIDDLEWARE_MANIFEST = '_devMiddlewareManifest.json';
__webpack_unused_export__ = DEV_MIDDLEWARE_MANIFEST;
var REACT_LOADABLE_MANIFEST = 'react-loadable-manifest.json';
__webpack_unused_export__ = REACT_LOADABLE_MANIFEST;
var FONT_MANIFEST = 'font-manifest.json';
__webpack_unused_export__ = FONT_MANIFEST;
var SERVER_DIRECTORY = 'server';
__webpack_unused_export__ = SERVER_DIRECTORY;
var SERVERLESS_DIRECTORY = 'serverless';
__webpack_unused_export__ = SERVERLESS_DIRECTORY;
var CONFIG_FILES = [
    'next.config.js',
    'next.config.mjs'
];
__webpack_unused_export__ = CONFIG_FILES;
var BUILD_ID_FILE = 'BUILD_ID';
__webpack_unused_export__ = BUILD_ID_FILE;
var BLOCKED_PAGES = [
    '/_document',
    '/_app',
    '/_error'
];
__webpack_unused_export__ = BLOCKED_PAGES;
var CLIENT_PUBLIC_FILES_PATH = 'public';
__webpack_unused_export__ = CLIENT_PUBLIC_FILES_PATH;
var CLIENT_STATIC_FILES_PATH = 'static';
__webpack_unused_export__ = CLIENT_STATIC_FILES_PATH;
var CLIENT_STATIC_FILES_RUNTIME = 'runtime';
__webpack_unused_export__ = CLIENT_STATIC_FILES_RUNTIME;
var STRING_LITERAL_DROP_BUNDLE = '__NEXT_DROP_CLIENT_FILE__';
__webpack_unused_export__ = STRING_LITERAL_DROP_BUNDLE;
var MIDDLEWARE_FLIGHT_MANIFEST = 'middleware-flight-manifest';
__webpack_unused_export__ = MIDDLEWARE_FLIGHT_MANIFEST;
var MIDDLEWARE_BUILD_MANIFEST = 'middleware-build-manifest';
__webpack_unused_export__ = MIDDLEWARE_BUILD_MANIFEST;
var MIDDLEWARE_REACT_LOADABLE_MANIFEST = 'middleware-react-loadable-manifest';
__webpack_unused_export__ = MIDDLEWARE_REACT_LOADABLE_MANIFEST;
var CLIENT_STATIC_FILES_RUNTIME_MAIN = "main";
__webpack_unused_export__ = CLIENT_STATIC_FILES_RUNTIME_MAIN;
var CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = "react-refresh";
__webpack_unused_export__ = CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH;
var CLIENT_STATIC_FILES_RUNTIME_AMP = "amp";
__webpack_unused_export__ = CLIENT_STATIC_FILES_RUNTIME_AMP;
var CLIENT_STATIC_FILES_RUNTIME_WEBPACK = "webpack";
__webpack_unused_export__ = CLIENT_STATIC_FILES_RUNTIME_WEBPACK;
var CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = Symbol("polyfills");
__webpack_unused_export__ = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL;
var MIDDLEWARE_SSR_RUNTIME_WEBPACK = 'middleware-ssr-runtime';
__webpack_unused_export__ = MIDDLEWARE_SSR_RUNTIME_WEBPACK;
var MIDDLEWARE_RUNTIME_WEBPACK = 'middleware-runtime';
__webpack_unused_export__ = MIDDLEWARE_RUNTIME_WEBPACK;
var TEMPORARY_REDIRECT_STATUS = 307;
__webpack_unused_export__ = TEMPORARY_REDIRECT_STATUS;
var PERMANENT_REDIRECT_STATUS = 308;
__webpack_unused_export__ = PERMANENT_REDIRECT_STATUS;
var STATIC_PROPS_ID = '__N_SSG';
__webpack_unused_export__ = STATIC_PROPS_ID;
var SERVER_PROPS_ID = '__N_SSP';
__webpack_unused_export__ = SERVER_PROPS_ID;
var FLIGHT_PROPS_ID = '__N_RSC';
__webpack_unused_export__ = FLIGHT_PROPS_ID;
var GOOGLE_FONT_PROVIDER = 'https://fonts.googleapis.com/';
__webpack_unused_export__ = GOOGLE_FONT_PROVIDER;
var OPTIMIZED_FONT_PROVIDERS = [
    {
        url: GOOGLE_FONT_PROVIDER,
        preconnect: 'https://fonts.gstatic.com'
    },
    {
        url: 'https://use.typekit.net',
        preconnect: 'https://use.typekit.net'
    }, 
];
__webpack_unused_export__ = OPTIMIZED_FONT_PROVIDERS;
var STATIC_STATUS_PAGES = [
    '/500'
];
__webpack_unused_export__ = STATIC_STATUS_PAGES;
var TRACE_OUTPUT_VERSION = 1;
__webpack_unused_export__ = TRACE_OUTPUT_VERSION; //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 2545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _loadable = _interopRequireDefault(__webpack_require__(79160));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === 'undefined';
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        /*#__PURE__*/ return _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === 'function') {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === 'object') {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    if (true) {
        // Error if react root is not enabled and `suspense` option is set to true
        if ( true && suspenseOptions.suspense) {
            // TODO: add error doc when this feature is stable
            throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
        }
    }
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === 'boolean') {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 92047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 79160:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _useSubscription = __webpack_require__(26362);
var _loadableContext = __webpack_require__(92047);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== 'undefined' && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = 'LoadableComponent';
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === 'number') {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === 'number') {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 73873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
module.exports = {
    locales: [
        "pl",
        "cz",
        "de",
        "es",
        "fr",
        "gb",
        "it",
        "ro",
        "se",
        "sk"
    ],
    defaultLocale: "pl",
    localeDetection: false,
    defaultNS: "main",
    logBuild: false,
    pages: {
        "*": [
            "main"
        ]
    },
    domains: [
        {
            domain: "dajar.cz",
            defaultLocale: "cz"
        },
        {
            domain: "dajar.de",
            defaultLocale: "de"
        },
        {
            domain: "dajar.es",
            defaultLocale: "es"
        },
        {
            domain: "dajar.fr",
            defaultLocale: "fr"
        },
        {
            domain: "dajar.pl",
            defaultLocale: "pl"
        },
        {
            domain: "dajar.it",
            defaultLocale: "it"
        },
        {
            domain: "dajar.co.uk",
            defaultLocale: "gb"
        },
        {
            domain: "dajar.ro",
            defaultLocale: "ro"
        },
        {
            domain: "dajar.se",
            defaultLocale: "se"
        },
        {
            domain: "dajar.sk",
            defaultLocale: "sk"
        }
    ],
    loader: true,
    loadLocaleFrom: function(lang) {
        return Promise.resolve().then(function() {
            return _interopRequireWildcard(__webpack_require__(63587)("./".concat(lang, ".json")));
        }).then(function(m) {
            return m.default;
        });
    }
};


/***/ }),

/***/ 87122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_ProductBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7090);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProductBox = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_ProductBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductBox);


/***/ }),

/***/ 49793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_RecentlyViewed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52133);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RecentlyViewed = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_RecentlyViewed__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (RecentlyViewed);


/***/ }),

/***/ 4097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_SalesBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52510);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SalesBox = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_SalesBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (SalesBox);


/***/ }),

/***/ 73764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_PageContainer; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(11225);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../lib/dist/useDebounce.js
var useDebounce = __webpack_require__(25686);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(8131);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../API/dist/hooks/common/useRecentlyViewedProducts.js
var useRecentlyViewedProducts = __webpack_require__(79105);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(53746);
// EXTERNAL MODULE: ../sections/dist/Footer/index.js
var Footer = __webpack_require__(67180);
;// CONCATENATED MODULE: ./src/sections/Footer/index.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Footer_Footer = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Footer/* default */.Z, _objectSpread({
        bgColor: "blueDarken",
        fontColor: "neutral"
    }, props));
};
/* harmony default export */ var sections_Footer = (Footer_Footer);

// EXTERNAL MODULE: ./src/components/RecentlyViewed/index.js
var RecentlyViewed = __webpack_require__(49793);
// EXTERNAL MODULE: ../components-new/dist/ReturnText/index.js
var ReturnText = __webpack_require__(81400);
;// CONCATENATED MODULE: ./src/components/ReturnText/index.js



function ReturnText_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReturnText_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReturnText_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ReturnText_ReturnText = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ReturnText["default"], ReturnText_objectSpread({}, props));
};
/* harmony default export */ var components_ReturnText = (ReturnText_ReturnText);

// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ../API/dist/hooks/common/useMinicart.js
var useMinicart = __webpack_require__(34698);
// EXTERNAL MODULE: ../components-new/dist/Loader/index.js
var Loader = __webpack_require__(44637);
// EXTERNAL MODULE: ../API/dist/hooks/common/useLoader.js
var useLoader = __webpack_require__(87573);
// EXTERNAL MODULE: ../components-new/dist/SelectInDialog/index.js
var SelectInDialog = __webpack_require__(74047);
// EXTERNAL MODULE: ../API/dist/hooks/common/LanguageProvider.js
var LanguageProvider = __webpack_require__(8989);
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../API/dist/hooks/common/useAnalytics4AndCommerceTags.js
var useAnalytics4AndCommerceTags = __webpack_require__(79892);
// EXTERNAL MODULE: ../components-new/dist/NewsletterPopup/index.js
var NewsletterPopup = __webpack_require__(72030);
;// CONCATENATED MODULE: ./src/containers/UI/PageContainer/index.js




















var Dialog = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 21277, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21277)
            ];
        }
    }
});
var MinicartContent = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 1528).then(__webpack_require__.bind(__webpack_require__, 91528));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91528)
            ];
        }
    }
});
var Minicart = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 7012).then(__webpack_require__.bind(__webpack_require__, 57012));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57012)
            ];
        }
    }
});
var PriceProgress = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 2806).then(__webpack_require__.bind(__webpack_require__, 12806));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12806)
            ];
        }
    }
});
var OrderSummary = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 8922).then(__webpack_require__.bind(__webpack_require__, 35047));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35047)
            ];
        }
    }
});
var ProductRow = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 8066).then(__webpack_require__.bind(__webpack_require__, 38066));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38066)
            ];
        }
    }
});
var addScrollToPage = function() {
    document.getElementsByTagName("body")[0].style = "margin:0;overflow-x:hidden;-webkit-overflow-scrolling:touch";
};
var PageContainer = function(props) {
    var children = props.children, returnLinkLabel = props.returnLinkLabel, onReturnLabelClick = props.onReturnLabelClick, recentlyViewedActive = props.recentlyViewedActive, footerActive = props.footerActive, footerContent = props.footerContent, dataRequiredToHideLoader = props.dataRequiredToHideLoader, externalIntegrationsHtml = props.externalIntegrationsHtml, _skipFirstSectionMarginOnMobile = props.skipFirstSectionMarginOnMobile, skipFirstSectionMarginOnMobile = _skipFirstSectionMarginOnMobile === void 0 ? false : _skipFirstSectionMarginOnMobile;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,LanguageProvider.useLanguage)(), changeLanguage = ref4.changeLanguage, language = ref4.language;
    var translations = {
        languages: (0,langLibrary["default"])("languages"),
        select: (0,langLibrary["default"])("select"),
        cookieNotice: (0,langLibrary["default"])("Cookie notice"),
        accept: (0,langLibrary["default"])("Accept"),
        advertSlogan: (0,langLibrary["default"])("Subscribe to our newsletter"),
        advertText: (0,langLibrary["default"])("And get even 10% off"),
        subscribe: (0,langLibrary["default"])("Subscribe")
    };
    var ref1 = (0,react.useState)(null), minicartLoaded = ref1[0], setMinicartLoaded = ref1[1];
    var ref2 = (0,react.useState)(null), showImportComponent = ref2[0], setShowImportComponent = ref2[1];
    var lang1 = /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInDialog/* default */.Z, {
            options: Object.values(__webpack_require__.g.__appConfig__.domainLanguages),
            value: language.language,
            label: translations.languages.toUpperCase(),
            placeholder: translations.select,
            onChange: function(lang) {
                return changeLanguage(lang);
            },
            textTransform: "uppercase",
            colorLabel: "beigeDarken",
            borderColor: "beigeDarken",
            valueMarginTop: "s6",
            height: "45px",
            borderRadius: "0px",
            colorArrow: "beigeDarken",
            colorOptionSelect: "neutral",
            my: "0px",
            pl: "10px",
            font: "s_sans"
        })
    });
    var sectionBottomSpace = {
        mb: [
            "s11",
            null,
            null,
            "s12",
            null,
            null
        ]
    };
    var skipMobileSectionBottomSpace = {
        mb: [
            0,
            null,
            null,
            "s12",
            null,
            null
        ]
    };
    var recentlyViewedProducts = (0,useRecentlyViewedProducts.useRecentlyViewedProducts)();
    var ref3 = (0,useMinicart.useMinicart)(), isMinicartVisible = ref3.isMinicartVisible, toggleMinicartVisibility = ref3.toggleMinicartVisibility, minicartContent = ref3.minicartContent, itemsAmountInMinicart = ref3.itemsAmount, minicartTotalPrice = ref3.minicartTotalPrice, showDiscountInProductRow = ref3.showDiscountInProductRow;
    var isLoading = (0,useLoader.useLoader)().isLoading;
    var viewCart = (0,useAnalytics4AndCommerceTags["default"])().viewCart;
    (0,react.useEffect)(function() {
        if (isMinicartVisible && !minicartLoaded) {
            setMinicartLoaded(true);
        }
        if (!isMinicartVisible) {
            addScrollToPage();
        }
        isMinicartVisible && viewCart(minicartContent);
    }, [
        isMinicartVisible
    ]);
    (0,react.useEffect)(function() {
        if (isMinicartVisible) {
            toggleMinicartVisibility();
            addScrollToPage();
        }
    }, [
        router.asPath
    ]);
    var showMinicart = function() {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Dialog, {
            isOpen: isMinicartVisible,
            onRequestClose: toggleMinicartVisibility,
            anchoredTo: "window",
            sx: {
                width: [
                    "calc(100%)",
                    null,
                    null,
                    "calc(50%)",
                    "calc(35%)",
                    null
                ],
                placement: "right"
            },
            onClose: function() {
                if (!isMinicartVisible) return;
                toggleMinicartVisibility({
                    close: true
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minicart, {
                itemsAmountInCart: itemsAmountInMinicart,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinicartContent, {
                    itemsAmountInCart: itemsAmountInMinicart,
                    progressBar: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceProgress, {
                        currentPrice: minicartTotalPrice(),
                        limitPrice: __webpack_require__.g.__appConfig__.shippingLimitPrices[language.language]
                    }),
                    productRows: (ref = minicartContent === null || minicartContent === void 0 ? void 0 : minicartContent.filter(function(item) {
                        return item === null || item === void 0 ? void 0 : item.product;
                    })) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductRow, {
                            product: item.product,
                            quantity: item.quantity,
                            onLinkClick: toggleMinicartVisibility,
                            showDiscountFromTotals: showDiscountInProductRow
                        });
                    }),
                    orderSummary: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary, {
                        total: minicartTotalPrice(),
                        vatLabel: true,
                        isMinicart: true
                    })
                })
            })
        });
    };
    var importComponentsDebounce = (0,useDebounce["default"])(parseInt(__webpack_require__.g.__appConfig__.submenuLoadTimeout), function() {
        setShowImportComponent(true);
    });
    var importComponents = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Minicart, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MinicartContent, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceProgress, {})
            ]
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
        children: [
            minicartLoaded ? showMinicart() : /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                sx: {
                    display: "none"
                },
                children: showImportComponent ? importComponents() : importComponentsDebounce()
            }),
            returnLinkLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                sx: {
                    mt: "s7",
                    mb: "s8"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReturnText, {
                        label: returnLinkLabel,
                        onClick: onReturnLabelClick
                    })
                })
            }),
            !dataRequiredToHideLoader.every(function(param) {
                return param !== undefined;
            }) || isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader["default"], {}) : react.Children.toArray(children).map(function(child, index) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                    sx: skipFirstSectionMarginOnMobile && index === 0 ? skipMobileSectionBottomSpace : sectionBottomSpace,
                    children: child
                }, index));
            }),
            recentlyViewedActive && recentlyViewedProducts && recentlyViewedProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                sx: sectionBottomSpace,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentlyViewed/* default */.Z, {
                    products: recentlyViewedProducts
                })
            }),
            footerActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Footer, {
                additionalSeparator: false,
                additionalFont: "xs",
                footerContent: footerContent,
                languages: lang1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterPopup/* default */.Z, {
                placement: "center",
                width: 900,
                advertSlogan: translations.advertSlogan,
                advertText: translations.advertText,
                buttonLabel: translations.subscribe,
                advertLink: "/newsletter/signup"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                dangerouslySetInnerHTML: {
                    __html: (language === null || language === void 0 ? void 0 : language.language) === "pl" ? externalIntegrationsHtml : ""
                }
            })
        ]
    }));
};
PageContainer.defaultProps = {
    recentlyViewedActive: true,
    footerActive: true,
    dataRequiredToHideLoader: [],
    externalIntegrationsHtml: ""
};
PageContainer.propTypes = {
    cart: (prop_types_default()).array,
    router: (prop_types_default()).object,
    children: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).object
    ]),
    contentBlocks: (prop_types_default()).array,
    socialMediaElements: (prop_types_default()).array,
    logo: (prop_types_default()).object,
    returnLinkLabel: (prop_types_default()).string,
    onReturnLabelClick: (prop_types_default()).func,
    metaTagsData: (prop_types_default()).object,
    recentlyViewedActive: (prop_types_default()).bool,
    footerActive: (prop_types_default()).bool,
    dataRequiredToHideLoader: (prop_types_default()).array,
    externalIntegrationsHtml: (prop_types_default()).string
};
/* harmony default export */ var UI_PageContainer = (PageContainer);


/***/ }),

/***/ 79363:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getRoute = function(route, params) {
    switch(route){
        case "home-page":
            return {
                href: "/",
                as: "/"
            };
        case "login":
            return {
                href: "/login",
                as: "".concat((params === null || params === void 0 ? void 0 : params.session) ? "/login?=".concat(params === null || params === void 0 ? void 0 : params.session) : "/login")
            };
        case "register":
            return {
                href: "/register",
                as: "/register"
            };
        case "reset-password":
            return {
                href: "/reset-password",
                as: "/reset-password"
            };
        case "contact":
            return {
                href: "/contact",
                as: "/contact"
            };
        case "delivery":
            return {
                href: "/delivery",
                as: "/delivery"
            };
        case "payment":
            return {
                href: "/payment",
                as: "".concat((params === null || params === void 0 ? void 0 : params.query) ? "/payment?".concat(params === null || params === void 0 ? void 0 : params.query) : "/payment")
            };
        case "returns":
            return {
                href: "/returns",
                as: "/returns"
            };
        case "terms-conditions":
            return {
                href: "/terms-conditions",
                as: "/terms-conditions"
            };
        case "about-us":
            return {
                href: "/about-us",
                as: "/about-us"
            };
        case "our-promise":
            return {
                href: "/our-promise",
                as: "/our-promise"
            };
        case "privacy-policy":
            return {
                href: "/privacy-policy",
                as: "/privacy-policy"
            };
        case "about-cookies":
            return {
                href: "/about-cookies",
                as: "/about-cookies"
            };
        case "product-page":
            return {
                href: "/[...categoryOrProductPage]",
                as: "/".concat(params.url)
            };
        case "hit-product-page":
            return {
                href: "/hot-deal",
                as: "/hot-deal"
            };
        case "catalogsearch":
            return {
                href: "/catalogsearch/result/[...query]",
                as: "/catalogsearch/result/".concat(params.query)
            };
        case "cart":
            return {
                href: "/cart",
                as: "/cart"
            };
        case "category-page":
            return {
                href: "/[...categoryOrProductPage]",
                as: "/".concat(params.url)
            };
        case "article":
            return {
                href: "/article/[article]",
                as: "/".concat(params.url)
            };
        case "info":
            return {
                href: "/info/[info]",
                as: "".concat(params.url)
            };
        case "info/rules":
            return {
                href: "/info/[info]",
                as: "/info/rules"
            };
        case "checkout-payment":
            return {
                href: "/checkout/payment",
                as: "/checkout/payment"
            };
        case "checkout":
            return {
                href: "/checkout",
                as: "/checkout"
            };
        case "account":
            return {
                href: "/account",
                as: "/account"
            };
        case "account-order":
            return {
                href: "/account/orders/[id]",
                as: "/account/orders/".concat(params.id, "?page=").concat(params.page).concat(params.type ? "&type=".concat(params.type) : "")
            };
        case "account-orders":
            return {
                href: "/account/orders",
                as: "/account/orders"
            };
        case "account-info":
            return {
                href: "/account/personal-info",
                as: "/account/personal-info"
            };
        case "account-address":
            return {
                href: "/account/address-book/[id]",
                as: "/account/address-book/".concat(params)
            };
        case "account-address-book":
            return {
                href: "/account/address-book",
                as: "/account/address-book"
            };
        case "account-epoints-info":
            return {
                href: "/account/epoints-info/[page]",
                as: "/account/epoints-info/".concat(params.page)
            };
        case "churchill":
            return {
                href: "/churchill",
                as: "/churchill"
            };
        case "ariane":
            return {
                href: "/ariane",
                as: "/ariane"
            };
        case "sola":
            return {
                href: "/sola",
                as: "/sola"
            };
        case "alchemy":
            return {
                href: "/alchemy",
                as: "/alchemy"
            };
        case "ambition":
            return {
                href: "/ambition",
                as: "/ambition"
            };
        case "pasabahce":
            return {
                href: "/pasabahce",
                as: "/pasabahce"
            };
        case "newsletter-signup":
            return {
                href: "/newsletter/signup",
                as: "/newsletter/signup"
            };
        case "newsletter-signoff":
            return {
                href: "/newsletter/signoff",
                as: "/newsletter/signoff"
            };
        case "inspirations":
            return {
                href: "/inspirations",
                as: "/inspirations"
            };
        case "promotions":
            return {
                href: "/promotions",
                as: "/promotions"
            };
        default:
            return {
                href: route,
                as: route
            };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getRoute);


/***/ }),

/***/ 88084:
/***/ (function() {

var setGlobals = function() {
    if (false) {} else {
        window.__BROWSER__ = true;
        window.__DEV__ = true;
        window.__appConfig__ = {"restRootEndpointUrl":"https://{domain}/rest/{lang}/V1","elasticEndpointUrl":"https://{domain}/searchengine/{lang}/V1","currencyUrl":"/directory/currency","influencerBioImageCloudflareEnabled":"1","influencerBioImageQuality":"70","inspirationThumbnailImageCloudflareEnabled":"1","inspirationThumbnailImageImageQuality":"70","collectionCardMainImageCloudflareEnabled":"1","collectionCardMainImageQuality":"70","recentlyViewedImageQuality":"1","recentlyViewedImageQualityEnabled":"70","prismicEndpointUrl":"https://prismic.dajarmedia.com/api/v2","prismicMediaDomain":"images.prismic.io","languages":"pl,en","defaultLanguage":"pl","elasticEnabled":"1","productFamilyUrl":"/deosite/product-family/{sku}","guestCartsTotalsUrl":"/guest-carts/{cartId}/totals","cartsTotalsUrl":"/carts/mine/totals","categoriesWithImagesUrl":"/categories/","menuWithImagesUrl":"/menu/","cloudflareImgUrl":"https://dajarmedia.dajarmedia.com/cdn-cgi/image/","dajarmediaImgUrl":"https://dajarmedia.dajarmedia.com","smallImageCloudflareEnabled":"1","smallImageQuality":"70","bigImageCloudflareEnabled":"1","bigImageQuality":"70","bannerImageCloudflareEnabled":"1","bannerImageQuality":"100","logoBrandsImageCloudflareEnabled":"0","logoBrandsImageQuality":"0","categoryUrl":"/categories/{id}","customerAuthenticationUrl":"/integration/customer/token","createCustomerCartUrl":"/carts/mine","createGuestCartUrl":"/guest-carts","tokenCookieName":"token","customerAddProductToCartUrl":"/carts/mine/items","guestAddProductToCartUrl":"/guest-carts/{cartId}/items","registrationUrl":"/customers","customerPlaceOrderUrl":"/carts/mine/payment-information","guestPlaceOrderUrl":"/guest-carts/{cartId}/payment-information","customerSetShippingInformation":"/carts/mine/shipping-information","customerDataUrl":"/customers/me","guestSetShippingInformation":"/guest-carts/{cartId}/shipping-information","customerUpdateProductInCartUrl":"/carts/mine/items/{itemId}","guestUpdateProductInCartUrl":"/guest-carts/{cartId}/items/{itemId}","cloudflareForceDisable":"0","guestRemoveProductFromCartUrl":"/guest-carts/{cartId}/items/{itemId}","customerRemoveProductFromCartUrl":"/carts/mine/items/{itemId}","popularCategoryIdPL":"5016","popularCategoryIdEN":"xx","popularCategoryIdDE":"xx","popularCategoryIdSK":"xx","popularCategoryIdCZ":"xx","popularCategoryIdRO":"xx","popularCategoryIdIT":"xx","popularCategoryIdFR":"xx","popularCategoryIdES":"xx","popularCategoryIdSE":"xx","newInCategoryIdPL":"5017","newInCategoryIdEN":"xx","newInCategoryIdDE":"xx","newInCategoryIdSK":"xx","newInCategoryIdCZ":"xx","newInCategoryIdRO":"xx","newInCategoryIdIT":"xx","newInCategoryIdFR":"xx","newInCategoryIdES":"xx","newInCategoryIdSE":"xx","newProductsCategoryIdPL":"30","newProductsCategoryIdEN":"xx","newProductsCategoryIdDE":"xx","newProductsCategoryIdSK":"xx","newProductsCategoryIdCZ":"xx","newProductsCategoryIdRO":"xx","newProductsCategoryIdIT":"xx","newProductsCategoryIdFR":"xx","newProductsCategoryIdES":"xx","newProductsCategoryIdSE":"xx","customerPasswordUrl":"/customers/password","customerResetPasswordUrl":"/customers/resetPassword","resetPasswordEmailTemplate":"email_reset","customerCouponUrl":"/carts/mine/coupons/{couponCode}","sessionUserLoginMaxDays":"14","guestCouponUrl":"/guest-carts/{cartId}/coupons/{couponCode}","deleteCustomerCouponUrl":"/carts/mine/coupons","deleteGuestCouponUrl":"/guest-carts/{cartId}/coupons","pickupLocationsUrl":"/deosite/shipping/pickup-points","newsletterSubscribeUrl":"/deosite/newsletter/subscribe","newsletterUnsubscribeUrl":"/deosite/newsletter/unsubscribe","pickupMethodCode":"shipping_pickup_point","cashOnDeliveryCode":"cashondelivery","facebookEnabled":true,"visibilityValuesForProductsList":"2,4","defaultSortAdditionalParameter":"id-desc","defaultSort":"position-desc","categoryPageSize":"32","prismicSaleBannerName":"salesbanner","orders":"/orders/mine","domainLanguages":{"dajar.cz":"cz","dajar.de":"de","dajar.es":"es","dajar.fr":"fr","dajar.pl":"pl","dajar.it":"it","dajar.co.uk":"gb","dajar.ro":"ro","dajar.se":"se","dajar.sk":"sk"},"shippingLimitPrices":{"cz":3500,"de":200,"es":500,"fr":500,"pl":300,"it":500,"gb":400,"ro":1200,"se":5000,"sk":150},"storeIds":{"pl":1,"de":2,"gb":3,"cz":4,"sk":5,"ro":6,"it":7,"fr":8,"es":9,"se":10},"websiteIds":{"pl":1,"de":2,"gb":3,"cz":4,"sk":5,"ro":6,"it":7,"fr":8,"es":9,"se":10},"prismicImageQuality":"50","categoryPageSizeLargerRange":"24","outOfStockProductAvailability":"270","lowProductAvailability":"269","freeShippingAmountUrl":"/deosite/config/free-shipping-subtotal","setPaymentGetTotalsGuestUrl":"/guest-carts/{cartId}/set-payment-information-and-get-totals","setPaymentGetTotalsCustomerUrl":"/carts/mine/set-payment-information-and-get-totals","currencyList":{"de":{"code":"EUR","symbol":"€"},"cz":{"code":"CZK","symbol":"CZK"},"es":{"code":"EUR","symbol":"€"},"fr":{"code":"EUR","symbol":"€"},"pl":{"code":"PLN","symbol":"zł"},"it":{"code":"EUR","symbol":"€"},"gb":{"code":"GBP","symbol":"£"},"ro":{"code":"RON","symbol":"RON"},"se":{"code":"SEK","symbol":"kr"},"sk":{"code":"EUR","symbol":"€"}},"ordersPageSize":"2","ePointsAddPoints":"/carts/mine/epremia/points","ePointsAccount":"/carts/mine/epremia/account","submenuLoadTimeout":"1","cookieContainerLoadTimeout":"1","quantityPickerMaxValue":"99999","shopOffGB":"","prismicHomepage":"homepage","prismicPopularSearches":"popularsearches","prismicMenuBanners":"menubanners","prismicCategoryBanners":"categorybanners","prismicInspirationLandingUid":"inspirationslanding","prismicPromotionsLandingUid":"promotionslanding","prismicPrefix":"","prismicBrandInfo":"brandinfo","paginationQuantityPickerOptionsNumber":"10","newsletterSignupOnHomepageEnabled":"1","paymentMethodFree":"free","invalidateCacheTime":"72000000","cacheSystemEnabled":1,"cachePath":"/usr/src/app/cache/","agreementsCookieName":"userAgreementCookie","languageRouting":0,"showAddtionalInfoField":false,"swatchesImageCloudflareEnabled":"1","swatchesImageQuality":"80","productThumbnailsQuality":"80","productThumbnailsCloudflareEnabled":"1","useDefaultColorPickerImage":0,"cookieNoticeMaxLength":"460","packageCarryingInfoEnabled":false,"deliveryInfoEnabled":false,"prismicCacheStoreTimeInMilliseconds":86400000,"showAdditionalFeeInfo":null,"popularSearchesFromJson":1,"imageBlurhash":1,"imageServer":"dajarmedia.dajarmedia.com/media/new","productDefaultImageLanguages":{"de":"de","cz":"cz","sk":"sk","ro":"ro"},"checkoutAddressesMaxAmount":10,"specialCategoryId":5866,"blackCategoryId":5824,"boxingCategoryId":5829,"salesmanagoID":"k081qy0f9bax2ht6","salesmanagoEnabledLang":"pl","salesmanagoApiUrl":"smev/","salesmanagoApiAddContact":"/smev/addContactExtEvent","salesmanagoApiHasContact":"/smev/hasContact","popupLanguages":"pl,de,gb,sk,cz,se","newsletterSignUpLanguages":"pl,de,sk,cz,gb,se,fr,it,es","pdpDefaultImage":{"de":"allegro","pl":"arranged","cz":"allegro","sk":"allegro","ro":"allegro"},"categoryDefaultImage":{"pl":"arranged"},"searchDefaultImage":{"pl":"arranged"},"menuSelectByCategoryID":29,"epointsVisible":1,"rootCategoryHideInUrl":0,"pdpCatalogPriceVisibility":{"cz":0,"de":0,"es":0,"fr":0,"pl":1,"it":0,"gb":0,"ro":0,"se":0,"sk":0},"showLowestPrice":{"pl":2,"de":2,"gb":0,"cz":2,"sk":2,"ro":2,"it":2,"fr":2,"es":2,"se":2},"storeAdditionalFunctionalities":{"de":1},"inpostEnabled":"0","inpostShippingMethodId":"inpostlocker","inpostGeowidgetToken":"eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJzQlpXVzFNZzVlQnpDYU1XU3JvTlBjRWFveFpXcW9Ua2FuZVB3X291LWxvIn0.eyJleHAiOjE5ODU1NDMwMTQsImlhdCI6MTY3MDE4MzAxNCwianRpIjoiYzliYjBmYjAtZmNkYS00MzgxLTg3ZTgtOWNkOWY5N2JkZWFkIiwiaXNzIjoiaHR0cHM6Ly9sb2dpbi5pbnBvc3QucGwvYXV0aC9yZWFsbXMvZXh0ZXJuYWwiLCJzdWIiOiJmOjEyNDc1MDUxLTFjMDMtNGU1OS1iYTBjLTJiNDU2OTVlZjUzNTo1eDR5YnVJYmFVdFQ2YzJ1VTF5THJiejlvSWdmSk9tOE9VYS1RRXVWYl9BIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoic2hpcHgiLCJzZXNzaW9uX3N0YXRlIjoiZTUyYzAwNmQtOGMxZi00NjcwLThhZDItMjhhYTJmNzRmYWQ3Iiwic2NvcGUiOiJvcGVuaWQgYXBpOmFwaXBvaW50cyIsInNpZCI6ImU1MmMwMDZkLThjMWYtNDY3MC04YWQyLTI4YWEyZjc0ZmFkNyIsImFsbG93ZWRfcmVmZXJyZXJzIjoiZGFqYXIucGwiLCJ1dWlkIjoiZTgzNWUxN2EtYjdjNS00NjU5LTllMjYtODVjNGNlODliODY0In0.Ud7cBQtZ-QQKP6BgNCLrgszaSJbIcw097sNNDw4EBFelkixRcZMVUOE3P6a7pCSJW4wkkNsQHcD4IMbWeTBaIutdp6lPQNGH61zMrMn-Gv9kYk-60Ymk5xRt_7s9UXwxmw-7P23WFKADsPcygd_mE1KuPKA9N5Vm2atoR7NkPHQ5hF8CAQyR_4y3Xw-jRFIwRU7aOmJRDB_mlj0ws52LzZQjTPzPqDErIhM8zZlMKI-0RtvjNCjhw9HZNLB2IDMk-oFu3c6L49JiZuMAfk6V5puILXuTKV4YgnBfTdZLFZAOmOkBHiAdVNAc9RfTbFy1k5kapm98aRgX-MNfOpXAvw","inpostScriptSrc":"https://geowidget.inpost.pl/inpost-geowidget.js","dhlParcelMethodId":"dhl","dhlApiUrl":"https://api-sandbox.dhl.com/location-finder/v1/find-by-address","dhlApiKey":"ImTUvzVGniz8eg18Rc0wvj8ysGWFQUhP","shippingMethodIdCookieName":"shippingMethodId","checkoutCheckboxToCourier":false,"pdpLastItemsStockVisibility":{"cz":1,"de":0,"es":1,"fr":1,"pl":1,"it":1,"gb":1,"ro":1,"se":1,"sk":1},"categoryOutletId":{"pl":32},"shippingCountryAvailable":{"cz":["all"],"de":["de","at","be","dk","nl"],"es":["all"],"fr":["all"],"pl":["all"],"it":["all"],"gb":["all"],"ro":["all"],"se":["all"],"sk":["all"]},"promotionsUrl":"/promo/skuList/","wishlistEndpointUrl":"wishlistservice","wishlistPageSize":10,"promotionCategoriesOrder":"5418,31,30,32","currentHitEndpoint":"https://{domain}/promo/current/hit","currentHitStartTime":"00:00:00","currentHitEndTime":"23:59:59","currentHitRefreshSaleInterval":3000000,"showHitProgressNumber":5,"adyenMagentoIntegrationToken":"xs9f6tthhol4c1sw974jldyn6i9gsnet","adyenEnvironment":"live","orderIdCookieName":"orderId","paymentMethodsOrder":{"pl":["blik","scheme","bluepayment","dialcom_przelewy","paypal_express","applepay","googlepay","klarna","cashondelivery","banktransfer"],"de":["paypal_express","scheme","klarna","klarna_account","klarna_paynow","banktransfer","applepay","googlepay"],"gb":["scheme","paypal_express","applepay","googlepay","bluepayment","dialcom_przelewy","banktransfer"],"en":["scheme","paypal_express","applepay","googlepay","bluepayment","dialcom_przelewy","banktransfer"],"se":["scheme","klarna","klarna_account","klarna_paynow","paypal_express","applepay","googlepay","dialcom_przelewy","banktransfer"],"cz":["scheme","bluepayment","dialcom_przelewy","applepay","googlepay","banktransfer","cashondelivery"],"sk":["scheme","bluepayment","dialcom_przelewy","applepay","googlepay","banktransfer","cashondelivery"],"fr":["scheme","paypal_express","bluepayment","dialcom_przelewy","applepay","googlepay","klarna_account","banktransfer"],"it":["scheme","paypal_express","bluepayment","dialcom_przelewy","applepay","googlepay","klarna_account","banktransfer"],"es":["scheme","paypal_express","bluepayment","dialcom_przelewy","applepay","googlepay","klarna_account","banktransfer"],"ro":["scheme","applepay","googlepay","banktransfer"]},"adyenConfig":{"pl":{"merchantName":"Polska","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"de":{"merchantName":"Niemcy","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"se":{"merchantName":"Szwecja","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"sk":{"merchantName":"Slowacja","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"cz":{"merchantName":"Slowacja","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"fr":{"merchantName":"Francja","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"en":{"merchantName":"WielkaBrytania","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"hu":{"merchantName":"Wegry","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"gb":{"merchantName":"WielkaBrytania","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"it":{"merchantName":"Wlochy","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"ro":{"merchantName":"Rumunia","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"},"es":{"merchantName":"Hiszpania","clientKey":"live_XEICJS3LGBFIFID37BJU5GUPGAUY6WZU"}},"prismicTimeout":4500,"turnstileScriptUrl":"https://challenges.cloudflare.com/turnstile/v0/api.js","turnstileConfig":{"pl":{"enabled":0,"label":"Sprawdzamy bezpieczeństwo połączenia","siteKey":"0x4AAAAAAAV43YB7rXuwdqqV"},"de":{"enabled":0,"label":"Wir überprüfen die Sicherheit der Verbindung.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"gb":{"enabled":0,"label":"We are checking the security of the connection.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"cz":{"enabled":0,"label":"Kontrolujeme bezpečnost připojení.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"sk":{"enabled":0,"label":"Kontrolujeme bezpečnosť pripojenia.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"ro":{"enabled":0,"label":"Verificăm securitatea conexiunii.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"it":{"enabled":0,"label":"Stiamo verificando la sicurezza della connessione.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"fr":{"enabled":0,"label":"Nous vérifions la sécurité de la connexion.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"es":{"enabled":0,"label":"Estamos verificando la seguridad de la conexión.","siteKey":"0x4AAAAAAAWPJ3vNtk09n7Qh"},"se":{"enabled":1,"label":"Vi kontrollerar säkerheten för anslutningen.","siteKey":"0x4AAAAAAAV43YB7rXuwdqqV"}},"timeAfterRefreshPage":"86400000","promoCategoryPerCountry":{"pl":{"category":5792},"de":{"category":null}},"hideKlarnaIfDiscount":1,"producers":{"pl":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"de":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"cz":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"sk":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"fr":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"it":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"es":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"ro":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"gb":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}},"se":{"ambition":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ambition junior":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"aquaphor":{"address":"ul. Kijowska 7, lok. U1\n03-743 Warszawa ","email":"aquaphor@aquaphor.pl"},"arcopal":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arcoroc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"arranger":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"bestway":{"address":"Via Resistenza 5\n20098 San Giuliano M.se (Mi)","email":"compliance@bestwaycorp.eu"},"brabantia":{"address":"Marketing 32\n6921 RE Duiven","email":"info.germany@brabantia.com"},"branq":{"address":"ul. Przemysłowa 10\n76-206 Redzikowo","email":"office@branq.eu"},"browin":{"address":"ul. Pryncypalna 129/141\n93-373 Łódź","email":"browin@browin.pl"},"chef & sommelier":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"churchill":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"cristal d'arques":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"curver":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"czillo":{"address":"ul. Przemysłowa 7\n34-400 Nowy Targ","email":"biuro@czillo.pl"},"domotti":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"eko-drew":{"address":"Żurowa 224\n38-247 Ołpiny ","email":"poczta@eko-drew.pl"},"emalia olkusz":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ever":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"ferne":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"fiskars":{"address":"Keilaniementie 10\n02151 Espoo","email":"customerservice.warsaw@fiskars.com"},"fissler":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"gerber":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"guzzini":{"address":"Contrada Mattonata 60\n61019 Recanti MC","email":"support@guzzini.com"},"hagsen":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"jotta":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"kanał sportowy":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"karolina":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"keden":{"address":"ul. Wilkowska 968 \n43-378 Rybarzowice","email":"contact@prosperplast.pl"},"keter":{"address":"Aleje Jerozolimskie 212A\n02-486 Warszawa","email":"gpsr.ketereu@keter.com"},"kettler":{"address":"Otto-Hahn-Straße 5\n21509 Glinde","email":"info@kettler-garden.com"},"krosno":{"address":"ul. Tysiąclecia 13\n38-400 Krosno","email":"e-sklep@krosno.com"},"kutahya":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"luminarc":{"address":"104 avenue du Général de Gaulle\n62510 Arques","email":"contact@arc-intl.com"},"myhome":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"nardi":{"address":"Via delle Stangà 14\n36072 Chiampo (VI)","email":"info@nardioutdoor.com"},"ocuisine":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"ołer":{"address":"ul. Piwna 1\n59-216 Kunice","email":"info@oler.pl"},"optimum":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"orplast":{"address":"ul. Marynarki Polskiej 73a\n80-557 Gdańsk","email":"orplast@orplast.pl"},"pasabahce":{"address":"Strawinskylaan 1459 WTC Tower 10, 14th Floor\n1077XX Amsterdam","email":"musterihizmetleri@pasabahce.com"},"patio":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"paw":{"address":"ul. Nektarowa 9\n62-002 Suchy Las","email":"office@pawdecor.com"},"plast team":{"address":"Pl. Zwycięstwa 11\n76-200 Słupsk","email":"sklep@plast-team.pl"},"practic":{"address":"Targowisko 499A\n32-015 Targowisko","email":"bok@practic.com.pl"},"prosperplast":{"address":"ul. Wilkowska 968 \nRybarzowice 43-378","email":"contact@prosperplast.pl"},"pyrex":{"address":"85 Allée des Maisons Rouges\n36000 Châteauroux","email":"support@international-cookware.zendesk.com"},"rotho":{"address":"ul. Grabskiego 2\n75-209 Koszalin","email":"info@rotho.com"},"snb":{"address":"ul. Kraszewskiego 26/2\n15-025 Białystok","email":"snb@snb.pl"},"solingen":{"address":"ul. Metalowa 3\n62-095 Murowana Goślina","email":"office@formson.pl"},"spontex":{"address":"ul. Józefińska 2\n30-529 Kraków","email":"biuro.zamowienie@mspoland.com.pl"},"trend glass":{"address":"ul. Marii Fołtyn 11\n26-600 Radom","email":"office@trendglass.pl"},"tweakwood":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"velkea":{"address":"ul. Połtawska 6\n75-072 Koszalin","email":"reklamacje@dajar.pl"},"vileda":{"address":"ul. Puławska 182\n02-670 Warszawa","email":"reklamacje.vileda-pl@fhp-ww.com"},"weber":{"address":"ul. Mieczysława Pożaryskiego 32, p.3, lok.2\n04-703 Warszawa","email":"info-pl@weberstephen.com"},"zwoltex":{"address":"ul. Spacerowa 13\n98-220 Zduńska Wola","email":"reklamacje@zwoltex.pl"},"dajar":{"address":"ul. Połtawska 6\n75-720 Koszalin","email":"reklamacje@dajar.pl"}}}};
    }
};
setGlobals();


/***/ }),

/***/ 55167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94986);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(73873);
var i18n_default = /*#__PURE__*/__webpack_require__.n(i18n);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(53746);
// EXTERNAL MODULE: ../../node_modules/next-translate/lib/esm/_context.js
var _context = __webpack_require__(9122);
;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/transCore.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function splitNsKey(key, nsSeparator) {
    if (!nsSeparator)
        return { i18nKey: key };
    var i = key.indexOf(nsSeparator);
    if (i < 0)
        return { i18nKey: key };
    return {
        namespace: key.slice(0, i),
        i18nKey: key.slice(i + nsSeparator.length),
    };
}
function transCore(_a) {
    var config = _a.config, allNamespaces = _a.allNamespaces, pluralRules = _a.pluralRules, lang = _a.lang;
    var _b = config.logger, logger = _b === void 0 ? missingKeyLogger : _b;
    var t = function (key, query, options) {
        var _a;
        if (key === void 0) { key = ''; }
        var k = Array.isArray(key) ? key[0] : key;
        var _b = config.nsSeparator, nsSeparator = _b === void 0 ? ':' : _b, _c = config.loggerEnvironment, loggerEnvironment = _c === void 0 ? 'browser' : _c;
        var _d = splitNsKey(k, nsSeparator), i18nKey = _d.i18nKey, _e = _d.namespace, namespace = _e === void 0 ? (_a = options === null || options === void 0 ? void 0 : options.ns) !== null && _a !== void 0 ? _a : config.defaultNS : _e;
        var dic = (namespace && allNamespaces[namespace]) || {};
        var keyWithPlural = plural(pluralRules, dic, i18nKey, config, query);
        var value = getDicValue(dic, keyWithPlural, config, options);
        var empty = typeof value === 'undefined' ||
            (typeof value === 'object' && !Object.keys(value).length);
        var fallbacks = typeof (options === null || options === void 0 ? void 0 : options.fallback) === 'string'
            ? [options.fallback]
            : (options === null || options === void 0 ? void 0 : options.fallback) || [];
        if (empty &&
            (loggerEnvironment === 'both' ||
                loggerEnvironment ===
                    (typeof window === 'undefined' ? 'node' : 'browser'))) {
            logger({ namespace: namespace, i18nKey: i18nKey });
        }
        if (empty && Array.isArray(fallbacks) && fallbacks.length) {
            var firstFallback = fallbacks[0], restFallbacks = fallbacks.slice(1);
            if (typeof firstFallback === 'string') {
                return t(firstFallback, query, __assign(__assign({}, options), { fallback: restFallbacks }));
            }
        }
        if (empty && (options === null || options === void 0 ? void 0 : options.default) && (fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks.length) == 0) {
            return interpolation({ text: options === null || options === void 0 ? void 0 : options.default, query: query, config: config, lang: lang });
        }
        if (empty) {
            return k;
        }
        if (value instanceof Object) {
            return objectInterpolation({
                obj: value,
                query: query,
                config: config,
                lang: lang,
            });
        }
        return interpolation({ text: value, query: query, config: config, lang: lang });
    };
    return t;
}
function getDicValue(dic, key, config, options) {
    if (key === void 0) { key = ''; }
    if (options === void 0) { options = {
        returnObjects: false,
    }; }
    var _a = (config || {}).keySeparator, keySeparator = _a === void 0 ? '.' : _a;
    var keyParts = keySeparator ? key.split(keySeparator) : [key];
    if (key === keySeparator && options.returnObjects)
        return dic;
    var value = keyParts.reduce(function (val, key) {
        if (typeof val === 'string') {
            return {};
        }
        var res = val[key];
        return res || (typeof res === 'string' ? res : {});
    }, dic);
    if (typeof value === 'string' ||
        (value instanceof Object && options.returnObjects)) {
        return value;
    }
    return undefined;
}
function plural(pluralRules, dic, key, config, query) {
    if (!query || typeof query.count !== 'number')
        return key;
    var numKey = "".concat(key, "_").concat(query.count);
    if (getDicValue(dic, numKey, config) !== undefined)
        return numKey;
    var pluralKey = "".concat(key, "_").concat(pluralRules.select(query.count));
    if (getDicValue(dic, pluralKey, config) !== undefined) {
        return pluralKey;
    }
    var nestedNumKey = "".concat(key, ".").concat(query.count);
    if (getDicValue(dic, nestedNumKey, config) !== undefined)
        return nestedNumKey;
    var nestedKey = "".concat(key, ".").concat(pluralRules.select(query.count));
    if (getDicValue(dic, nestedKey, config) !== undefined)
        return nestedKey;
    return key;
}
function interpolation(_a) {
    var text = _a.text, query = _a.query, config = _a.config, lang = _a.lang;
    if (!text || !query)
        return text || '';
    var escapeRegex = function (str) {
        return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };
    var _b = config.interpolation || {}, _c = _b.format, format = _c === void 0 ? null : _c, _d = _b.prefix, prefix = _d === void 0 ? '{{' : _d, _e = _b.suffix, suffix = _e === void 0 ? '}}' : _e;
    var regexEnd = suffix === '' ? '' : "(?:[\\s,]+([\\w-]*))?\\s*".concat(escapeRegex(suffix));
    return Object.keys(query).reduce(function (all, varKey) {
        if (typeof all !== 'string')
            return all;
        var regex = new RegExp("".concat(escapeRegex(prefix), "\\s*").concat(varKey).concat(regexEnd), 'gm');
        return all.replace(regex, function (_match, $1) {
            return $1 && format
                ? format(query[varKey], $1, lang)
                : query[varKey];
        });
    }, text);
}
function objectInterpolation(_a) {
    var obj = _a.obj, query = _a.query, config = _a.config, lang = _a.lang;
    if (!query || Object.keys(query).length === 0)
        return obj;
    Object.keys(obj).forEach(function (key) {
        if (obj[key] instanceof Object)
            objectInterpolation({
                obj: obj[key],
                query: query,
                config: config,
                lang: lang,
            });
        if (typeof obj[key] === 'string')
            obj[key] = interpolation({
                text: obj[key],
                query: query,
                config: config,
                lang: lang,
            });
    });
    return obj;
}
function missingKeyLogger(_a) {
    var namespace = _a.namespace, i18nKey = _a.i18nKey;
    if (true)
        return;
    if (!namespace) {
        console.warn("[next-translate] The text \"".concat(i18nKey, "\" has no namespace in front of it."));
        return;
    }
    console.warn("[next-translate] \"".concat(namespace, ":").concat(i18nKey, "\" is missing in current namespace configuration. Try adding \"").concat(i18nKey, "\" to the namespace \"").concat(namespace, "\"."));
}

// EXTERNAL MODULE: ../../node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(33872);
;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/I18nProvider.js
var I18nProvider_assign = (undefined && undefined.__assign) || function () {
    I18nProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return I18nProvider_assign.apply(this, arguments);
};





var InternalContext = (0,react.createContext)({ ns: {}, config: {} });
function I18nProvider(_a) {
    var lng = _a.lang, _b = _a.namespaces, namespaces = _b === void 0 ? {} : _b, children = _a.children, _c = _a.config, newConfig = _c === void 0 ? {} : _c;
    var parentLang = (0,useTranslation["default"])().lang;
    var _d = (0,next_router.useRouter)() || {}, locale = _d.locale, defaultLocale = _d.defaultLocale;
    var internal = (0,react.useContext)(InternalContext);
    var allNamespaces = I18nProvider_assign(I18nProvider_assign(I18nProvider_assign({}, initialBrowserNamespaces()), internal.ns), namespaces);
    var lang = lng || parentLang || locale || defaultLocale || '';
    var config = I18nProvider_assign(I18nProvider_assign({}, internal.config), newConfig);
    var localesToIgnore = config.localesToIgnore || ['default'];
    var ignoreLang = localesToIgnore.includes(lang);
    var pluralRules = new Intl.PluralRules(ignoreLang ? undefined : lang);
    var t = transCore({ config: config, allNamespaces: allNamespaces, pluralRules: pluralRules, lang: lang });
    return (react.createElement(_context/* default.Provider */.Z.Provider, { value: { lang: lang, t: t } },
        react.createElement(InternalContext.Provider, { value: { ns: allNamespaces, config: config } }, children)));
}
function initialBrowserNamespaces() {
    var _a, _b;
    if (typeof window === 'undefined')
        return {};
    return ((_b = (_a = window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.__namespaces) || {};
}

;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/getConfig.js
function getConfig() {
    var g = typeof window === 'undefined' ? __webpack_require__.g : window;
    return g.i18nConfig;
}

;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/getPageNamespaces.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function flat(a) {
    return a.reduce(function (b, c) { return b.concat(c); }, []);
}
function getPageNamespaces(_a, page, ctx) {
    var _b = _a.pages, pages = _b === void 0 ? {} : _b;
    return __awaiter(this, void 0, void 0, function () {
        var rgx, getNs, rgxs, _c, _d, _e, _f;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    rgx = 'rgx:';
                    getNs = function (ns) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, typeof ns === 'function' ? ns(ctx) : ns || []];
                    }); }); };
                    rgxs = Object.keys(pages).reduce(function (arr, p) {
                        if (p.substring(0, rgx.length) === rgx &&
                            new RegExp(p.replace(rgx, '')).test(page)) {
                            arr.push(getNs(pages[p]));
                        }
                        return arr;
                    }, []);
                    _c = [[]];
                    return [4, getNs(pages['*'])];
                case 1:
                    _d = [__spreadArray.apply(void 0, _c.concat([(_g.sent()), true]))];
                    return [4, getNs(pages[page])];
                case 2:
                    _e = [__spreadArray.apply(void 0, _d.concat([(_g.sent()), true]))];
                    _f = flat;
                    return [4, Promise.all(rgxs)];
                case 3: return [2, __spreadArray.apply(void 0, _e.concat([_f.apply(void 0, [_g.sent()]), true]))];
            }
        });
    });
}

;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/loadNamespaces.js
/* provided dependency */ var process = __webpack_require__(90907);
var loadNamespaces_assign = (undefined && undefined.__assign) || function () {
    loadNamespaces_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return loadNamespaces_assign.apply(this, arguments);
};
var loadNamespaces_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var loadNamespaces_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var colorEnabled = process.env.NODE_DISABLE_COLORS == null &&
    process.env.NO_COLOR == null &&
    process.env.TERM !== 'dumb' &&
    process.env.FORCE_COLOR !== '0';
function loadNamespaces(config) {
    var _a, _b;
    if (config === void 0) { config = {}; }
    return loadNamespaces_awaiter(this, void 0, void 0, function () {
        var conf, localesToIgnore, __lang, page, namespaces, defaultLoader, pageNamespaces, color;
        return loadNamespaces_generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    conf = loadNamespaces_assign(loadNamespaces_assign({}, getConfig()), config);
                    localesToIgnore = conf.localesToIgnore || ['default'];
                    __lang = ((_a = conf.req) === null || _a === void 0 ? void 0 : _a.locale) ||
                        conf.locale ||
                        ((_b = conf.router) === null || _b === void 0 ? void 0 : _b.locale) ||
                        conf.defaultLocale ||
                        '';
                    if (!conf.pathname) {
                        console.warn('🚨 [next-translate] You forgot to pass the "pathname" inside "loadNamespaces" configuration');
                        return [2, { __lang: __lang }];
                    }
                    if (localesToIgnore.includes(__lang))
                        return [2, { __lang: __lang }];
                    if (!conf.loaderName && conf.loader !== false) {
                        console.warn('🚨 [next-translate] You can remove the "loadNamespaces" helper, unless you set "loader: false" in your i18n config file.');
                    }
                    page = removeTrailingSlash(conf.pathname.replace(/\/index$/, '')) || '/';
                    return [4, getPageNamespaces(conf, page, conf)];
                case 1:
                    namespaces = _c.sent();
                    defaultLoader = function () { return Promise.resolve({}); };
                    return [4, Promise.all(namespaces.map(function (ns) {
                            return typeof conf.loadLocaleFrom === 'function'
                                ? conf.loadLocaleFrom(__lang, ns).catch(function () { return ({}); })
                                : defaultLoader(__lang, ns);
                        }))];
                case 2:
                    pageNamespaces = (_c.sent()) || [];
                    if (conf.logBuild !== false && typeof window === 'undefined') {
                        color = function (c) { return (colorEnabled ? "\u001B[36m".concat(c, "\u001B[0m") : c); };
                        console.log(color('next-translate'), "- compiled page:", color(page), '- locale:', color(__lang), '- namespaces:', color(namespaces.join(', ')), '- used loader:', color(conf.loaderName || '-'));
                    }
                    return [2, {
                            __lang: __lang,
                            __namespaces: namespaces.reduce(function (obj, ns, i) {
                                obj[ns] = pageNamespaces[i] || null;
                                return obj;
                            }, {}),
                        }];
            }
        });
    });
}
function removeTrailingSlash(path) {
    if (path === void 0) { path = ''; }
    return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

;// CONCATENATED MODULE: ../../node_modules/next-translate/lib/esm/appWithI18n.js
var appWithI18n_assign = (undefined && undefined.__assign) || function () {
    appWithI18n_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return appWithI18n_assign.apply(this, arguments);
};
var appWithI18n_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var appWithI18n_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function appWithI18n(AppToTranslate, config) {
    var _this = this;
    if (config === void 0) { config = {}; }
    if (!config.isLoader && config.loader !== false) {
        console.warn('🚨 [next-translate] You can remove the "appWithI18n" HoC on the _app.js, unless you set "loader: false" in your i18n config file.');
    }
    function AppWithTranslations(props) {
        var _a, _b;
        var defaultLocale = config.defaultLocale;
        return (react.createElement(I18nProvider, { lang: ((_a = props.pageProps) === null || _a === void 0 ? void 0 : _a.__lang) || props.__lang || defaultLocale, namespaces: ((_b = props.pageProps) === null || _b === void 0 ? void 0 : _b.__namespaces) || props.__namespaces, config: config },
            react.createElement(AppToTranslate, appWithI18n_assign({}, props))));
    }
    if (typeof config.staticsHoc === 'function') {
        config.staticsHoc(AppWithTranslations, AppToTranslate);
    }
    if (typeof window === 'undefined')
        __webpack_require__.g.i18nConfig = config;
    else
        window.i18nConfig = config;
    if (config.skipInitialProps)
        return AppWithTranslations;
    AppWithTranslations.getInitialProps = function (appCtx) { return appWithI18n_awaiter(_this, void 0, void 0, function () {
        var ctx, appProps, _a;
        return appWithI18n_generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ctx = appWithI18n_assign(appWithI18n_assign({}, (appCtx.ctx || {})), (appCtx || {}));
                    appProps = { pageProps: {} };
                    if (!AppToTranslate.getInitialProps) return [3, 2];
                    return [4, AppToTranslate.getInitialProps(appCtx)];
                case 1:
                    appProps = (_b.sent()) || {};
                    _b.label = 2;
                case 2:
                    _a = [appWithI18n_assign({}, appProps)];
                    return [4, loadNamespaces(appWithI18n_assign(appWithI18n_assign(appWithI18n_assign({}, ctx), config), { loaderName: 'getInitialProps' }))];
                case 3: return [2, appWithI18n_assign.apply(void 0, _a.concat([(_b.sent())]))];
            }
        });
    }); };
    return AppWithTranslations;
}

// EXTERNAL MODULE: ../../node_modules/next/app.js
var app = __webpack_require__(69009);
// EXTERNAL MODULE: ../../node_modules/swr/esm/index.js + 9 modules
var esm = __webpack_require__(56157);
// EXTERNAL MODULE: ../../node_modules/@adyen/adyen-web/dist/adyen.css
var adyen = __webpack_require__(54788);
// EXTERNAL MODULE: ./src/pages/styles.css
var styles = __webpack_require__(74195);
;// CONCATENATED MODULE: ./conf/lang.analytics.json
var lang_analytics_namespaceObject = JSON.parse('{"cz":"G-TKCECG0RRF","de":"G-RSVRTSCZ4V","es":"G-J7DS3E0MPW","fr":"G-9SGFY6T2L1","pl":"G-25MSX90C1B","it":"G-HF9JWG0HG6","gb":"G-R65HKPQM6F","ro":"G-GF6NKX33DG","se":"G-TXX3THR0F5","sk":"G-RNJ8LHHC6T"}');
;// CONCATENATED MODULE: ./conf/lang.gtm.json
var lang_gtm_namespaceObject = JSON.parse('{"cz":"GTM-5GQ2VB5","de":"GTM-MX4WRGS","es":"","fr":"","pl":"GTM-PP8SRMV","it":"","gb":"","ro":"","se":"","sk":""}');
;// CONCATENATED MODULE: ./conf/lang.fb.json
var lang_fb_namespaceObject = JSON.parse('{"cz":"830937360791517","de":"431640770985688","es":"289505649356933","fr":"722367445110336","pl":"235248200811065","it":"751358858854025","gb":"1018036549030931","ro":"2879956048951715","se":"284815376380598","sk":"448585416456774"}');
;// CONCATENATED MODULE: ./conf/popularSearches.json
var popularSearches_namespaceObject = JSON.parse('{"de":[{"url":"haus-garten/esszimmer/tafelservices","title":"Tafelservices"},{"url":"haus-garten/garten/gartenmobel/hollywoodschaukel","title":"Hollywoodschaukel"},{"url":"haus-garten/esszimmer/ambition","title":"Ambition"},{"url":"haus-garten/kuche/kochen-backen/pfannen/nature","title":"Pfanne Nature"},{"url":"haus-garten/esszimmer/tafelservices/porto","title":"Tafelservices Porto"}],"cz":[{"url":"dum-a-zahrada/jidelna/jidelni-servisy/jidelni-servisy","title":"Jídelní servisy"},{"url":"dum-a-zahrada/zahrada/zahradni-nabytek/houpacky","title":"Houpačky"},{"url":"dum-a-zahrada/jidelna/ambition","title":"Ambition"},{"url":"dum-a-zahrada/kuchyn/vareni-a-peceni/nature","title":"Hrnce a pánve Nature"},{"url":"dum-a-zahrada/jidelna/porto","title":"Kolekce Porto"}],"es":[{"url":"casa-y-jardin/comedor/vajilla/juegos-de-vajilla","title":"Juegos de vajilla"},{"url":"casa-y-jardin/jardin/muebles-de-jardin/balancines/celebes","title":"Balancín de jardín Celebes"},{"url":"casa-y-jardin/comedor/ambition","title":"Ambition"},{"url":"casa-y-jardin/cocina/cocinar-y-hornear","title":"Sartén Nature"},{"url":"casa-y-jardin/comedor/porto","title":"Colección Porto"}],"fr":[{"url":"maison-et-jardin/arts-de-la-table/vaisselle-de-table","title":"Vaisselle de table"},{"url":"maison-et-jardin/jardin/mobilier-de-jardin/balancelles/celebes","title":"Balancelle de jardin Celebes"},{"url":"maison-et-jardin/arts-de-la-table/ambition","title":"Ambition"},{"url":"maison-et-jardin/cuisine/ustensiles-de-cuisson/poeles-sauteuses-woks/nature","title":"Poêles Nature"},{"url":"maison-et-jardin/arts-de-la-table/vaisselle-de-table/porto","title":"Colecction Porto"}],"pl":[{"url":"dom-i-ogrod/jadalnia/zastawa-stolowa/serwisy-obiadowe","title":"Serwisy obiadowe"},{"url":"dom-i-ogrod/jadalnia/porcelana-ambition","title":"Porcelana Ambition -10%"},{"url":"dom-i-ogrod/ogrod/meble-ogrodowe/hustawki/celebes","title":"Huśtawki Celebes"},{"url":"dom-i-ogrod/marki/ambition","title":"Marka Ambition"},{"url":"dom-i-ogrod/kuchnia/gotowanie-i-pieczenie/patelnie/nature","title":"Patelnie Nature"},{"url":"dom-i-ogrod/marki/ambition/porto","title":"Zastawa kolekcja Porto"},{"url":"dom-i-ogrod/ogrod/meble-ogrodowe/fotele-wiszace","title":"Fotel ogrodowy wiszący"}],"it":[{"url":"casa-giardino/arti-della-tavola/stoviglie-da-tavola","title":"Stoviglie da tavola"},{"url":"casa-giardino/giardino/arredamento-da-esterno/dondoli/celebes","title":"Dondolo da giardino Celebes"},{"url":"casa-giardino/arti-della-tavola/ambition","title":"Ambition"},{"url":"casa-giardino/cucina/cucina-e-cottura-in-forno/nature","title":"Padella Nature"},{"url":"casa-giardino/arti-della-tavola/porto","title":"Collezione Porto"}],"gb":[{"url":"home-garden/dining-room/tableware","title":"Tableware"},{"url":"home-garden/garden-outdoors/garden-furniture/swings/celebes","title":"Celebes Swings"},{"url":"home-garden/dining-room","title":"Ambition Brand"},{"url":"home-garden/kitchen/cooking-and-baking/nature","title":"Nature Pans &amp; Pots"},{"url":"home-garden/dining-room/porto","title":"Porto Tableware"}],"ro":[],"se":[{"url":"hus-och-tradgard/matsal/bordsservis","title":"Bordsservis"},{"url":"hus-och-tradgard/tradgard/tradgardsmobler/hammockar/celebes","title":"Celebes"},{"url":"hus-och-tradgard/matsal/ambition","title":"Ambition"},{"url":"hus-och-tradgard/kok/matlagning-och-bakning/stekpannor/nature","title":"Kollektion Nature"},{"url":"hus-och-tradgard/matsal/porto","title":"Kollektion Porto"}],"sk":[{"url":"dom-a-zahrada/jadalen/obedove-a-jedalenske-supravy","title":"Obedové a jedálenské súpravy"},{"url":"dom-a-zahrada/zahrada/zahradny-nabytok/hojdacky/celebes","title":"Hojdačky Celebes"},{"url":"dom-a-zahrada/jadalen/ambition","title":"Ambition"},{"url":"dom-a-zahrada/kuchyna/varenie-a-pecenie/panvice/nature","title":"Panvice Nature"},{"url":"dom-a-zahrada/jadalen/porto","title":"Kolekcia Porto"}]}');
// EXTERNAL MODULE: ./src/getRoute.js
var getRoute = __webpack_require__(79363);
// EXTERNAL MODULE: ../../node_modules/next-cookies/index.js
var next_cookies = __webpack_require__(93074);
var next_cookies_default = /*#__PURE__*/__webpack_require__.n(next_cookies);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(77005);
// EXTERNAL MODULE: ./src/globals.js
var globals = __webpack_require__(88084);
// EXTERNAL MODULE: ./src/theme.js
var theme = __webpack_require__(42223);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Root/index.js
var Root = __webpack_require__(11790);
var Root_default = /*#__PURE__*/__webpack_require__.n(Root);
// EXTERNAL MODULE: ../lib/dist/RouteContext.js
var RouteContext = __webpack_require__(73157);
// EXTERNAL MODULE: ../containers/dist/Infrastructure/cache/withCache.js
var withCache = __webpack_require__(70491);
// EXTERNAL MODULE: ../components-new/dist/Notification/index.js
var Notification = __webpack_require__(58015);
// EXTERNAL MODULE: ./src/components/SalesBox/index.js
var SalesBox = __webpack_require__(4097);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(11225);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/MenuLayout/index.js
var MenuLayout = __webpack_require__(48413);
var MenuLayout_default = /*#__PURE__*/__webpack_require__.n(MenuLayout);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Button/index.js
var Button = __webpack_require__(96088);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/LinkRaw/index.js
var LinkRaw = __webpack_require__(88244);
var LinkRaw_default = /*#__PURE__*/__webpack_require__.n(LinkRaw);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/useScrollDirection/index.js
var useScrollDirection = __webpack_require__(90737);
var useScrollDirection_default = /*#__PURE__*/__webpack_require__.n(useScrollDirection);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/useScrollSegment/index.js
var useScrollSegment = __webpack_require__(23931);
var useScrollSegment_default = /*#__PURE__*/__webpack_require__.n(useScrollSegment);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/useWindowSize.js
var useWindowSize = __webpack_require__(47272);
var useWindowSize_default = /*#__PURE__*/__webpack_require__.n(useWindowSize);
// EXTERNAL MODULE: ../sections/dist/Header/index.js
var Header = __webpack_require__(80747);
// EXTERNAL MODULE: ../components-new/dist/buttons/ButtonMinimalIcon/index.js
var ButtonMinimalIcon = __webpack_require__(95574);
// EXTERNAL MODULE: ../API/dist/hooks/common/useMinicart.js
var useMinicart = __webpack_require__(34698);
// EXTERNAL MODULE: ../API/dist/hooks/REST/CartProvider/index.js
var CartProvider = __webpack_require__(57955);
// EXTERNAL MODULE: ../mockData/dist/icons.js
var icons = __webpack_require__(40775);
;// CONCATENATED MODULE: ./src/sections/Header/index.js







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Header_Header = function(props) {
    var toggleMinicartVisibility = (0,useMinicart.useMinicart)().toggleMinicartVisibility;
    var cart = (0,CartProvider.useCart)().cart;
    var itemsAmountInCart = cart && cart.items ? cart.items.reduce(function(prev, next) {
        return parseInt(prev) + parseInt(next.quantity);
    }, 0) : 0;
    var propsExt = _objectSpread({}, props, {
        itemsAmountInCart: itemsAmountInCart,
        onCartClick: toggleMinicartVisibility,
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMinimalIcon["default"], {
            sx: {
                width: "auto",
                height: "auto"
            }
        }),
        logo: icons/* default.logoIcon */.Z.logoIcon
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ var sections_Header = (Header_Header);

// EXTERNAL MODULE: ../mockData/dist/headerLinks.js
var headerLinks = __webpack_require__(64616);
// EXTERNAL MODULE: ../components-new/dist/Image/index.js
var Image = __webpack_require__(90451);
// EXTERNAL MODULE: ../lib/dist/useDebounce.js
var useDebounce = __webpack_require__(25686);
// EXTERNAL MODULE: ../lib/dist/bodyScrollLock/index.js
var bodyScrollLock = __webpack_require__(28198);
// EXTERNAL MODULE: ../components-new/dist/SearchDesktop/index.js
var SearchDesktop = __webpack_require__(3376);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Input/index.js
var Input = __webpack_require__(65760);
var Input_default = /*#__PURE__*/__webpack_require__.n(Input);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/index.js
var core2 = __webpack_require__(79329);
// EXTERNAL MODULE: ./src/icons/close.svg
var icons_close = __webpack_require__(46565);
;// CONCATENATED MODULE: ./src/components/formControls/input/InputSecondary.js





var InputSecondary = (0,core2.createComponent)((Input_default()), {
    $root: function(param) {
        var focused = param.focused, disabled = param.disabled, invalid = param.invalid;
        return {
            height: "42px",
            border: "1px solid",
            borderColor: invalid ? "negative" : "main",
            bg: disabled ? "neutral100" : "transparent",
            borderRadius: "4px"
        };
    },
    $control: function(param) {
        var empty = param.empty;
        return {
            font: "base_sans",
            pr: "10px",
            pl: "10px",
            color: "main"
        };
    },
    $leftEnhancersContainer: {
        $gutter: "8px",
        pl: 10
    },
    $rightEnhancersContainer: {
        $gutter: "8px",
        pr: 10
    },
    $clearElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {
        style: {
            display: "block"
        }
    })
});
/* harmony default export */ var input_InputSecondary = (InputSecondary);

;// CONCATENATED MODULE: ./src/components/SearchDesktop/index.js




function SearchDesktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchDesktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchDesktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SearchDesktop_SearchDesktop = function(props) {
    var propsExt = SearchDesktop_objectSpread({}, props, {
        inputSecondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_InputSecondary, {
            sx: {
                width: 250,
                color: "main"
            }
        })
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDesktop/* default */.Z, SearchDesktop_objectSpread({}, propsExt)));
};
/* harmony default export */ var components_SearchDesktop = (SearchDesktop_SearchDesktop);

// EXTERNAL MODULE: ../API/dist/hooks/common/useLoader.js
var useLoader = __webpack_require__(87573);
;// CONCATENATED MODULE: ./src/icons/arrow_right.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgArrowRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  })));
}
/* harmony default export */ var arrow_right = (SvgArrowRight);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(34434);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../components-new/dist/SearchMobile/index.js
var SearchMobile = __webpack_require__(50666);
;// CONCATENATED MODULE: ./src/components/formControls/input/InputBare.js





var InputBare = (0,core2.createComponent)((Input_default()), {
    $root: function(param) {
        var focused = param.focused, disabled = param.disabled, invalid = param.invalid;
        return {
            height: "48px",
            bg: disabled ? "neutral100" : "transparent"
        };
    },
    $control: function(param) {
        var empty = param.empty;
        return {
            font: "base_sans",
            pr: "10px",
            pl: "10px",
            color: empty ? "neutral900" : "main"
        };
    },
    $leftEnhancersContainer: {
        $gutter: "8px",
        pl: 10
    },
    $rightEnhancersContainer: {
        $gutter: "8px",
        pr: 10
    },
    $clearElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {
        style: {
            display: "block"
        }
    })
});
/* harmony default export */ var input_InputBare = (InputBare);

;// CONCATENATED MODULE: ./src/components/SearchMobile/index.js




function SearchMobile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchMobile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchMobile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SearchMobile_SearchMobile = function(props) {
    var propsExt = SearchMobile_objectSpread({}, props, {
        inputBare: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_InputBare, {
            sx: {
                width: "100%"
            }
        })
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchMobile/* default */.Z, SearchMobile_objectSpread({}, propsExt)));
};
/* harmony default export */ var components_SearchMobile = (SearchMobile_SearchMobile);

// EXTERNAL MODULE: ../helpers/dist/prismicErrorHandle/index.js
var prismicErrorHandle = __webpack_require__(38115);
;// CONCATENATED MODULE: ./src/components/MenuDesktop/index.js

























function MenuDesktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MenuDesktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MenuDesktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MenuDesktop_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = MenuDesktop_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function MenuDesktop_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MenuMobileContent = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 6297).then(__webpack_require__.bind(__webpack_require__, 26297));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26297)
            ];
        }
    }
});
var MenuButton = function(_param) /*#__PURE__*/ {
    var children = _param.children, isSpecial = _param.isSpecial, restProps = MenuDesktop_objectWithoutProperties(_param, [
        "children",
        "isSpecial"
    ]);
    return (0,jsx_runtime.jsx)((Button_default()), MenuDesktop_objectSpread({}, restProps, {
        children: function(param) {
            var isHovered = param.isHovered, selected = param.selected;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)((Box_default()), {
                sx: {
                    font: "xs_caps",
                    color: isSpecial === "sale" ? "negative" : "main",
                    px: [
                        0,
                        null,
                        null,
                        null,
                        7,
                        10
                    ],
                    pb: 14,
                    position: "relative",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                    sx: {
                        position: "relative"
                    },
                    children: [
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                            sx: {
                                opacity: isHovered || selected ? 1 : 0,
                                transition: "opacity .15s",
                                position: "absolute",
                                width: "100%",
                                height: "2px",
                                bg: isSpecial === "sale" ? "negative" : "main"
                            }
                        })
                    ]
                })
            });
        }
    }));
};
var addSlash = function(href) {
    return href.indexOf("/") === 0 ? href : "/" + href;
};
var Submenu = /*#__PURE__*/ react.memo(function(param) {
    var submenu = param.submenu;
    var Link = (0,RouteContext.useRouteContext)().Link;
    var isSale = submenu.special && submenu.special === "sale";
    var props1 = submenu.hasSpecialUrl ? {
        href: addSlash(submenu.url)
    } : {
        route: "category-page",
        params: submenu
    };
    var columnWidth = [
        "150px",
        null,
        null,
        null,
        null,
        "180px"
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
        as: "ul",
        sx: {
            width: columnWidth
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                as: "li",
                sx: {
                    font: "base_sans_bold",
                    color: isSale ? "negative" : "main",
                    mt: "s8",
                    width: columnWidth
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, MenuDesktop_objectSpread({}, props1, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((LinkRaw_default()), {
                        title: submenu.name,
                        children: submenu.name
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                children: submenu.subcategories && Object.keys(submenu.subcategories).map(function(item, index) {
                    if (!submenu.subcategories[item]) {
                        return;
                    }
                    var props = submenu.subcategories[item].hasSpecialUrl ? {
                        href: submenu.subcategories[item].url
                    } : {
                        route: "category-page",
                        params: submenu.subcategories[item]
                    };
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                        as: "ul",
                        sx: {
                            width: columnWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                            as: "li",
                            sx: {
                                font: "s_sans",
                                color: "main",
                                mt: index === 0 ? "s5" : "s3",
                                width: columnWidth,
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, MenuDesktop_objectSpread({}, props, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((LinkRaw_default()), {
                                    title: submenu.subcategories[item].name,
                                    children: submenu.subcategories[item].name
                                })
                            }))
                        }, submenu.subcategories[item].url)
                    }, "submenuLinks-" + index));
                })
            })
        ]
    }, "fragment-" + submenu.name));
});
var MainMenu = /*#__PURE__*/ react.memo(function(param) {
    var menuContent = param.menuContent, onlyHeader = param.onlyHeader, isScrollingDown = param.isScrollingDown, menuBanners = param.menuBanners, isMobile = param.isMobile, popularSearches = param.popularSearches, hasSubmenu = param.hasSubmenu;
    var Link = (0,RouteContext.useRouteContext)().Link;
    var isLoading = (0,useLoader.useLoader)().isLoading;
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setOpen = ref3[1];
    var ref1 = (0,react.useState)(false), mobileSearchOpen = ref1[0], setMobileSearchOpen = ref1[1];
    var router = (0,next_router.useRouter)();
    var minifiedContent = router.asPath.slice(0, 9) == "/checkout";
    (0,react.useEffect)(function() {
        var element = document === null || document === void 0 ? void 0 : document.getElementById("layerUi");
        if (mobileSearchOpen) {
            (0,bodyScrollLock.disableBodyScroll)(element);
        } else {
            (0,bodyScrollLock.clearAllBodyScrollLocks)();
        }
    }, [
        mobileSearchOpen
    ]);
    var mobileMenu = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                " ",
                isMobile === true && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    isOpen: isOpen,
                    style: {
                        overlay: {
                            backgroundColor: "rgba(0, 0, 0, 0)"
                        },
                        content: {
                            inset: 0,
                            padding: 0,
                            border: "none",
                            backgroundColor: "rgba(0, 0, 0, 0.3)"
                        }
                    },
                    preventScroll: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                        sx: {
                            width: [
                                "100vw",
                                null,
                                "50vw",
                                null,
                                "33vw"
                            ],
                            bg: "white",
                            minHeight: "100vh"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuMobileContent, {
                            categoryList: menuContent,
                            pageLinks: [],
                            closeMenu: function() {
                                return setOpen(false);
                            },
                            router: router
                        })
                    })
                }),
                isMobile === true && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    isOpen: mobileSearchOpen,
                    style: {
                        overlay: {
                            background: "white",
                            height: "100vh"
                        },
                        content: {
                            width: "100vw",
                            inset: 0,
                            padding: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                        sx: {
                            height: "100%",
                            bg: "white",
                            p: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchMobile, {
                            popularSearches: popularSearches,
                            closeSearch: setMobileSearchOpen
                        })
                    })
                })
            ]
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Header, {
                    headerLinks: headerLinks/* headerLinks */.G,
                    onMobileMenuClick: function() {
                        return setOpen(true);
                    },
                    minifiedContent: minifiedContent,
                    checkoutUrl: minifiedContent && router.asPath,
                    helpLink: "/info/help",
                    desktopSearch: isMobile === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchDesktop, {}),
                    scrollingPart: !onlyHeader,
                    onSearchClick: function() {
                        return setMobileSearchOpen(true);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((Container_default()), {
                sx: {
                    display: onlyHeader ? "none" : [
                        "none",
                        null,
                        null,
                        null,
                        "block"
                    ],
                    position: "static"
                },
                children: [
                    mobileMenu(),
                    !minifiedContent && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                        "data-test": "main-categories",
                        sx: {
                            color: "main",
                            font: "xs_caps",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            position: isScrollingDown || isMobile ? "absolute" : "static",
                            left: 0,
                            top: "-64px",
                            pt: "s8",
                            pl: isScrollingDown ? "130px" : 0,
                            pr: isScrollingDown ? "65px" : 0
                        },
                        children: menuContent === null || menuContent === void 0 ? void 0 : menuContent.map(function(mainMenu, index1) {
                            var ref, ref2;
                            var props = mainMenu.hasSpecialUrl ? {
                                href: addSlash(mainMenu.url)
                            } : {
                                route: "category-page",
                                params: mainMenu
                            };
                            var defaultColor = {
                                color: "inherit"
                            };
                            var specialCategoryCss = {
                                color: "negative"
                            };
                            var blackCategoryCss = {
                                color: "white",
                                backgroundColor: "black",
                                paddingTop: 2,
                                paddingX: 4
                            };
                            var boxingCategoryCss = {
                                color: "white",
                                backgroundColor: "blueDark",
                                paddingTop: 2,
                                paddingX: 4
                            };
                            var sx = defaultColor;
                            if (parseInt(mainMenu.id) === __webpack_require__.g.__appConfig__.specialCategoryId) {
                                sx = specialCategoryCss;
                            }
                            if (parseInt(mainMenu.id) === __webpack_require__.g.__appConfig__.blackCategoryId) {
                                sx = blackCategoryCss;
                            }
                            if (parseInt(mainMenu.id) === __webpack_require__.g.__appConfig__.boxingCategoryId) {
                                sx = boxingCategoryCss;
                            }
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)((MenuLayout_default()).Dialog, {
                                button: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuButton, {
                                    isSpecial: mainMenu.special,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, MenuDesktop_objectSpread({}, props, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                            sx: MenuDesktop_objectSpread({
                                                position: "relative"
                                            }, sx),
                                            children: mainMenu.name
                                        })
                                    }))
                                }),
                                anchoredTo: "window",
                                children: !isMobile && hasSubmenu && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        position: "relative",
                                        overflow: "hidden",
                                        boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.15)",
                                        width: "100vw",
                                        display: ((mainMenu === null || mainMenu === void 0 ? void 0 : (ref = mainMenu.subcategories) === null || ref === void 0 ? void 0 : ref.length) > 0 || (menuBanners === null || menuBanners === void 0 ? void 0 : menuBanners.find(function(banner) {
                                            return banner.categoryId === mainMenu.id;
                                        }))) && !isLoading ? "block" : "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                        sx: {
                                            pt: "s3",
                                            pb: "s11",
                                            bg: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((Container_default()), {
                                            sx: {
                                                display: "flex",
                                                justifyContent: "center"
                                            },
                                            children: [
                                                mainMenu === null || mainMenu === void 0 ? void 0 : (ref2 = mainMenu.subcategories) === null || ref2 === void 0 ? void 0 : ref2.map(function(submenuColumn, index2) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)((Box_default()), {
                                                        sx: {
                                                            width: "180px",
                                                            ml: index2 === 0 ? "0" : "38px"
                                                        },
                                                        children: submenuColumn.map(function(sub, index) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Submenu, {
                                                                submenu: sub
                                                            }, "submenu-" + index);
                                                        })
                                                    }, "submenuGroup-" + index2);
                                                }),
                                                menuBanners && menuBanners.map(function(submenu, index) {
                                                    return submenu.categoryId === mainMenu.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: submenu.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((LinkRaw_default()), {
                                                            sx: {
                                                                width: 380,
                                                                minWidth: 380,
                                                                mt: "s8",
                                                                ml: index === 0 ? 80 : "s10",
                                                                overflow: "hidden"
                                                            },
                                                            title: submenu.title,
                                                            children: [
                                                                submenu.image.originalSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                                                                    sx: {
                                                                        aspectRatio: 0.75
                                                                    },
                                                                    image: submenu.image,
                                                                    sizes: "420px",
                                                                    cloudflareEnabled: false
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                                                                    sx: {
                                                                        font: "base_sans_bold",
                                                                        color: "main",
                                                                        mt: "s4",
                                                                        svg: {
                                                                            position: "relative",
                                                                            top: 5,
                                                                            ml: 5
                                                                        }
                                                                    },
                                                                    children: [
                                                                        submenu.title,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                                                    sx: {
                                                                        font: "s_sans",
                                                                        color: "main",
                                                                        mt: "s2"
                                                                    },
                                                                    children: submenu.subtitle
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, "mainCategory-" + mainMenu.name));
                        })
                    })
                ]
            })
        ]
    }));
});
var MenuDesktopLayout = function(param) {
    var children = param.children, menu = param.menu, noBorder = param.noBorder, menuBanners = param.menuBanners, popularSearches = param.popularSearches;
    var ref, ref4;
    var categoryTree = menu.categoryTree;
    var menuContent = (0,react.useMemo)(function() {
        return categoryTree;
    }, [
        categoryTree === null || categoryTree === void 0 ? void 0 : (ref = categoryTree[0]) === null || ref === void 0 ? void 0 : ref.id
    ]);
    popularSearches = (0,react.useMemo)(function() {
        return popularSearches;
    }, [
        (ref4 = popularSearches.content) === null || ref4 === void 0 ? void 0 : ref4.url
    ]);
    menuBanners = menuBanners && menuBanners !== prismicErrorHandle.TIMEOUT && !prismicErrorHandle.externalContentTimeout ? menuBanners : null;
    var isScrollingDown = useScrollDirection_default()();
    var isNotAtTop = useScrollSegment_default()({
        from: 1
    });
    var firstRender = (0,react.useRef)(true);
    var ref5 = (0,react.useState)(false), hasSubmenu = ref5[0], setSubmenu = ref5[1];
    var size = useWindowSize_default()();
    var ref6 = (0,react.useState)(null), isMobile = ref6[0], setMobile = ref6[1];
    var setSubmenuLoaded = (0,useLoader.useLoader)().setSubmenuLoaded;
    var setSubmenuInterval = (0,useDebounce["default"])(parseInt(__webpack_require__.g.__appConfig__.submenuLoadTimeout), function() {
        setSubmenu(true);
        setSubmenuLoaded(true);
    });
    (0,react.useEffect)(function() {
        var isMobileSize = size.width <= parseInt((0,theme/* default */.Z)().breakpoints.lg) - 1;
        if (isMobile !== isMobileSize) {
            setMobile(isMobileSize);
        }
    }, [
        size === null || size === void 0 ? void 0 : size.width
    ]);
    (0,react.useEffect)(function() {
        if (firstRender.current) {
            firstRender.current = false;
            !hasSubmenu && setSubmenuInterval();
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)((MenuLayout_default()), {
        offset: [
            48,
            null,
            null,
            null,
            126
        ],
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)((MenuLayout_default()).MenuBar, {
                sx: {
                    bg: "white"
                },
                open: !isScrollingDown,
                onMouseOver: function() {
                    return !hasSubmenu && setSubmenu(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu, {
                    menuContent: hasSubmenu ? menuContent : menuContent.map(function(menuTop) {
                        return MenuDesktop_objectSpread({}, menuTop, {
                            subcategories: []
                        });
                    }),
                    hasSubmenu: hasSubmenu,
                    onlyHeader: true,
                    menuBanners: menuBanners,
                    isMobile: isMobile,
                    popularSearches: popularSearches
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((MenuLayout_default()).MenuBar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                    sx: {
                        bg: "white",
                        color: "main",
                        display: isNotAtTop || !isScrollingDown || isMobile ? "block" : "flex",
                        position: isNotAtTop || !isScrollingDown || isMobile ? "relative" : "static",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    onMouseOver: function() {
                        return !hasSubmenu && setSubmenu(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu, {
                        menuContent: hasSubmenu ? menuContent : menuContent.map(function(menuTop) {
                            return MenuDesktop_objectSpread({}, menuTop, {
                                subcategories: []
                            });
                        }),
                        hasSubmenu: hasSubmenu,
                        isScrollingDown: isScrollingDown,
                        menuBanners: menuBanners,
                        onlyHeader: isMobile,
                        isMobile: isMobile,
                        popularSearches: popularSearches
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((MenuLayout_default()).MenuBar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                        sx: {
                            height: [
                                0,
                                null,
                                null,
                                1
                            ],
                            bg: "neutral",
                            transition: "opacity .2s",
                            opacity: isNotAtTop ? 1 : 0
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                            sx: {
                                borderBottom: noBorder ? 0 : isNotAtTop ? 0 : "1px",
                                borderStyle: "solid",
                                borderColor: [
                                    "transparent",
                                    null,
                                    null,
                                    null,
                                    "main"
                                ]
                            }
                        })
                    })
                ]
            }),
            children
        ]
    }));
};
/* harmony default export */ var MenuDesktop = (MenuDesktopLayout);

// EXTERNAL MODULE: ../components-new/dist/CookieContainer/index.js
var CookieContainer = __webpack_require__(4189);
// EXTERNAL MODULE: ../components-new/dist/CookieNotice/index.js
var CookieNotice = __webpack_require__(81481);
// EXTERNAL MODULE: ../components-new/dist/buttons/Button/index.js
var buttons_Button = __webpack_require__(51586);
;// CONCATENATED MODULE: ./src/components/CookieNotice/index.js





function CookieNotice_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CookieNotice_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CookieNotice_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var sharedStyles = {
    minWidth: "150px",
    maxWidth: [
        "150px",
        null,
        null,
        "100%",
        null,
        null
    ]
};
var CookieNotice_CookieNotice = function(props) {
    var cookieNoticeLoaded = (0,useLoader.useLoader)().cookieNoticeLoaded;
    var propsExt = CookieNotice_objectSpread({}, props, {
        confirmButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_Button["default"], {
            "data-test": "accept-cookies-button",
            sx: CookieNotice_objectSpread({}, sharedStyles),
            disabled: !cookieNoticeLoaded
        }),
        manageButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_Button["default"], {
            sx: CookieNotice_objectSpread({}, sharedStyles, {
                mt: [
                    "s6",
                    0,
                    null,
                    "s6",
                    null,
                    null
                ],
                ml: [
                    0,
                    "s5",
                    null,
                    "s0",
                    null,
                    null
                ],
                $outline: true
            }),
            disabled: !cookieNoticeLoaded
        })
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CookieNotice/* default */.Z, CookieNotice_objectSpread({}, propsExt)));
};
/* harmony default export */ var components_CookieNotice = (CookieNotice_CookieNotice);

;// CONCATENATED MODULE: ./src/components/CookieContainer/index.js





function CookieContainer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CookieContainer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CookieContainer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CookieContainerNew = function(props) {
    var propsExt = CookieContainer_objectSpread({}, props, {
        cookieNotice: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CookieNotice, {}),
        cookiesPanel: (0,dynamic["default"])(function() {
            return __webpack_require__.e(/* import() */ 9207).then(__webpack_require__.bind(__webpack_require__, 29207));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(29207)
                    ];
                }
            }
        })
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CookieContainer/* default */.Z, CookieContainer_objectSpread({}, propsExt)));
};
/* harmony default export */ var components_CookieContainer = (CookieContainerNew);

// EXTERNAL MODULE: ../API/dist/hooks/common/TokenProvider.js
var TokenProvider = __webpack_require__(36286);
// EXTERNAL MODULE: ../API/dist/hooks/common/useRecentlyViewedProducts.js
var useRecentlyViewedProducts = __webpack_require__(79105);
// EXTERNAL MODULE: ../app/dist/provider/index.js
var provider = __webpack_require__(37489);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useCategoryTree/index.js
var useCategoryTree = __webpack_require__(43974);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useCategories/index.js
var useCategories = __webpack_require__(79592);
// EXTERNAL MODULE: ../API/dist/hooks/REST/EPoints/index.js
var EPoints = __webpack_require__(73223);
// EXTERNAL MODULE: ../API/dist/hooks/REST/OrdersProvider.js
var OrdersProvider = __webpack_require__(64239);
// EXTERNAL MODULE: ../API/dist/hooks/REST/CurrencyProvider.js
var CurrencyProvider = __webpack_require__(38073);
// EXTERNAL MODULE: ../API/dist/hooks/REST/AccountProvider.js
var AccountProvider = __webpack_require__(8636);
// EXTERNAL MODULE: ../API/dist/hooks/REST/WishlistProvider.js
var WishlistProvider = __webpack_require__(54730);
// EXTERNAL MODULE: ../API/dist/hooks/REST/CheckoutRegisterProvider.js
var CheckoutRegisterProvider = __webpack_require__(26929);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismic/index.js
var usePrismic = __webpack_require__(22686);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicFooter/index.js
var usePrismicFooter = __webpack_require__(17947);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicSaleBanner/index.js
var usePrismicSaleBanner = __webpack_require__(63064);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicMenuBanners/index.js
var usePrismicMenuBanners = __webpack_require__(7293);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicCategoryBanners/index.js
var usePrismicCategoryBanners = __webpack_require__(62778);
// EXTERNAL MODULE: ../API/dist/hooks/common/useBackLink.js
var useBackLink = __webpack_require__(13959);
// EXTERNAL MODULE: ../API/dist/hooks/common/LanguageProvider.js
var LanguageProvider = __webpack_require__(8989);
// EXTERNAL MODULE: ../API/dist/hooks/common/MessageHandlerProvider.js
var MessageHandlerProvider = __webpack_require__(82425);
// EXTERNAL MODULE: ../API/dist/hooks/common/useCategoryTree.js
var common_useCategoryTree = __webpack_require__(28452);
// EXTERNAL MODULE: ../API/dist/hooks/common/usePaginationLoader.js
var usePaginationLoader = __webpack_require__(95514);
// EXTERNAL MODULE: ../API/dist/hooks/common/CookieAgreementsProvider.js
var CookieAgreementsProvider = __webpack_require__(2616);
// EXTERNAL MODULE: ../helpers/dist/cache/index.js
var cache = __webpack_require__(75800);
// EXTERNAL MODULE: ../helpers/dist/setSaleBannerVisibility/index.js
var setSaleBannerVisibility = __webpack_require__(71230);
// EXTERNAL MODULE: ../helpers/dist/addAnalyticsAndCommerceScripts/index.js
var addAnalyticsAndCommerceScripts = __webpack_require__(93355);
// EXTERNAL MODULE: ../helpers/dist/getDomainAndLanguage/index.js
var getDomainAndLanguage = __webpack_require__(2955);
// EXTERNAL MODULE: ../helpers/dist/pageRefreshWithTime/index.js
var pageRefreshWithTime = __webpack_require__(52509);
// EXTERNAL MODULE: ../API/dist/hooks/common/NotificationSystem/index.js
var NotificationSystem = __webpack_require__(86901);
// EXTERNAL MODULE: ../API/dist/hooks/common/useAdvertPopup.js
var useAdvertPopup = __webpack_require__(85556);
// EXTERNAL MODULE: ./src/pages/_error.js
var _error = __webpack_require__(98800);
// EXTERNAL MODULE: ./src/pages/_errorDomain.js
var _errorDomain = __webpack_require__(43779);
;// CONCATENATED MODULE: ./src/pages/_app.js






























































function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _app_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _app_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _app_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Link = function(props) {
    var href = props.href, route = props.route, params = props.params, children = props.children;
    var url = route ? (0,getRoute/* default */.Z)(route, params) : {
        href: href,
        as: href
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: url.href,
        as: url.as,
        passHref: true,
        prefetch: false,
        children: children
    }));
};
var MyApp = /*#__PURE__*/ function(App1) {
    "use strict";
    _inherits(MyApp, App1);
    var _super = _createSuper(MyApp);
    function MyApp() {
        _classCallCheck(this, MyApp);
        var _this;
        _this = _super.apply(this, arguments);
        _app_defineProperty(_assertThisInitialized(_this), "state", {});
        return _this;
    }
    _createClass(MyApp, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.log("CUSTOM ERROR HANDLING", error);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount(prevProps) {
                var ref;
                var scroll = function() {
                    window.scrollTo(0, 0);
                };
                if ((ref = this.props.cookies) === null || ref === void 0 ? void 0 : ref.userAgreementCookie) {
                    var agreements = this.props.cookies.userAgreementCookie;
                    var currentLanguage = this.props.language.language;
                    (0,addAnalyticsAndCommerceScripts["default"])(currentLanguage, agreements, {
                        analyticsID: lang_analytics_namespaceObject[currentLanguage],
                        gtmID: lang_gtm_namespaceObject[currentLanguage],
                        fbID: lang_fb_namespaceObject[currentLanguage]
                    });
                }
                (0,pageRefreshWithTime/* default */.Z)({
                    router: next_router["default"]
                });
                next_router["default"].events.on("routeChangeStart", scroll);
                return function() {
                    next_router["default"].events.off("routeChangeStart", scroll);
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var ref, ref1, ref2;
                var _props = this.props, Component = _props.Component, pageProps = _props.pageProps, language = _props.language, currency = _props.currency, menu = _props.menu, externalContentTimeout = _props.externalContentTimeout, errorDomain = _props.errorDomain, props = _app_objectWithoutProperties(_props, [
                    "Component",
                    "pageProps",
                    "language",
                    "currency",
                    "menu",
                    "externalContentTimeout",
                    "errorDomain"
                ]);
                if (errorDomain || pageProps === undefined) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(_errorDomain["default"], {}));
                }
                var error = pageProps.error;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(provider/* default */.Z, {
                    language: language,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageProvider.LanguageContextProvider, {
                        language: language,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyProvider.CurrencyContextProvider, {
                            currencyData: __webpack_require__.g.__appConfig__.currencyList[language.language],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_useCategoryTree["default"], {
                                tree: menu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.SWRConfig, {
                                    value: {
                                        revalidateOnFocus: false
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenProvider.TokenContextProvider, {
                                        token: (ref = this.props) === null || ref === void 0 ? void 0 : ref.cookies[__webpack_require__.g.__appConfig__.tokenCookieName],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieAgreementsProvider.CookieAgreementsContextProvider, {
                                            analyticsID: lang_analytics_namespaceObject[language.language],
                                            gtmID: lang_gtm_namespaceObject[language.language],
                                            fbID: lang_fb_namespaceObject[language.language],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useAdvertPopup.AdvertPopupContextProvider, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Root_default()), {
                                                    theme: (0,theme/* default */.Z)(),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationSystem.NotificationSystemProvider, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageHandlerProvider.MessageHandlerProvider, {
                                                            notificationComponent: Notification/* default */.Z,
                                                            errorsPlacement: "bottomLeft",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useRecentlyViewedProducts.RecentlyViewedContextProvider, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountProvider.AccountContextProvider, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useMinicart.MinicartContextProvider, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProvider["default"], {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistProvider.WishlistContextProvider, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useLoader.LoaderContextProvider, {
                                                                                    externalContentTimeout: externalContentTimeout,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EPoints.EPointsContextProvider, {
                                                                                        children: [
                                                                                            this.props.cookieNotice,
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RouteContext.InjectRouteContext, {
                                                                                                Link: Link,
                                                                                                Router: next_router["default"],
                                                                                                children: [
                                                                                                    props.showBanner && !externalContentTimeout && /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesBox/* default */.Z, {
                                                                                                        banner: (ref1 = props.saleBanner) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.saleBanner) === null || ref2 === void 0 ? void 0 : ref2.content[0],
                                                                                                        background: props.saleBanner.saleBanner.background,
                                                                                                        minified: true
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(useBackLink.BackLinkContextProvider, {
                                                                                                        router: props.router,
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrdersProvider["default"], {
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutRegisterProvider.CheckoutRegisterContextProvider, {
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CookieContainer, {}),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(usePaginationLoader.PaginationPaginationLoaderProvider, {
                                                                                                                        children: [
                                                                                                                            Component.hasNoMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps, props)),
                                                                                                                            !Component.hasNoMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDesktop, {
                                                                                                                                menu: menu,
                                                                                                                                menuBanners: props.menuBanners,
                                                                                                                                noBorder: props.router.route.length === 1 ? true : false,
                                                                                                                                popularSearches: props.popularSearches,
                                                                                                                                children: error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(_error["default"], _app_objectSpread({}, pageProps, props, {
                                                                                                                                    statusCode: error.statusCode ? error.statusCode : 404
                                                                                                                                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps, props, {
                                                                                                                                    categoryBanners: props.categoryBanners
                                                                                                                                }))
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var Component = param.Component, ctx = param.ctx, router = param.router;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    var pageProps, langFromUrl, menuBanners, footerContent, saleBanner, categoryBanners, menu, categories, popularSearches, externalContentTimeout, cacheFilePath, ref, cacheFileExist, filenameCategoryCache, cachedRequest, ref3, prismicCacheFileExist, prismicFilenameCategoryCache, prismicCachedRequest, ref4, ref5, ref6, ref7, cookies, showBanner;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                pageProps = {};
                                langFromUrl = ctx.cache.get("language", false);
                                if (langFromUrl) {
                                    _ctx.next = 8;
                                    break;
                                }
                                langFromUrl = (0,getDomainAndLanguage/* default */.Z)({
                                    host: ctx.req.headers.host
                                });
                                if (!(langFromUrl === null || langFromUrl === void 0 ? void 0 : langFromUrl.error)) {
                                    _ctx.next = 7;
                                    break;
                                }
                                pageProps.error = langFromUrl === null || langFromUrl === void 0 ? void 0 : langFromUrl.error;
                                return _ctx.abrupt("return", {
                                    pageProps: pageProps,
                                    errorDomain: true,
                                    language: langFromUrl
                                });
                            case 7:
                                ctx.cache.set("language", langFromUrl);
                            case 8:
                                menuBanners = ctx.cache.get("menuBanners", false);
                                footerContent = ctx.cache.get("footerContent", false);
                                saleBanner = ctx.cache.get("saleBanner", false);
                                categoryBanners = ctx.cache.get("categoryBanners", false);
                                menu = ctx.cache.get("menu", false);
                                categories = ctx.cache.get("categories", false);
                                popularSearches = __webpack_require__.g.__appConfig__.popularSearchesFromJson ? popularSearches_namespaceObject[langFromUrl.language] : ctx.cache.get("popularSearches", false);
                                externalContentTimeout = false;
                                cacheFilePath = "".concat(langFromUrl.language, "/");
                                _ctx.next = 19;
                                return (0,cache.readCacheFile)({
                                    cacheFilePath: cacheFilePath,
                                    constantFileName: "menu",
                                    contextRequest: ctx.req
                                });
                            case 19:
                                ref = _ctx.sent;
                                cacheFileExist = ref.cacheFileExist;
                                filenameCategoryCache = ref.filenameCategoryCache;
                                cachedRequest = ref.cachedRequest;
                                _ctx.next = 25;
                                return (0,cache.readCacheFile)({
                                    cacheFilePath: cacheFilePath,
                                    constantFileName: "prismicContent",
                                    contextRequest: ctx.req,
                                    forPrismic: true
                                });
                            case 25:
                                ref3 = _ctx.sent;
                                prismicCacheFileExist = ref3.cacheFileExist;
                                prismicFilenameCategoryCache = ref3.filenameCategoryCache;
                                prismicCachedRequest = ref3.cachedRequest;
                                if (cacheFileExist) {
                                    ;
                                    ref4 = _slicedToArray(cachedRequest, 2), menu = ref4[0], categories = ref4[1], ref4;
                                    ctx.cache.set("menu", menu);
                                    ctx.cache.set("categories", categories);
                                }
                                if (prismicCacheFileExist) {
                                    ;
                                    ref5 = _slicedToArray(prismicCachedRequest, 5), menuBanners = ref5[0], footerContent = ref5[1], saleBanner = ref5[2], categoryBanners = ref5[3], popularSearches = ref5[4], ref5;
                                    ctx.cache.set("menuBanners", menuBanners);
                                    ctx.cache.set("footerContent", footerContent);
                                    ctx.cache.set("saleBanner", saleBanner);
                                    ctx.cache.set("categoryBanners", categoryBanners);
                                    ctx.cache.set("popularSearches", __webpack_require__.g.__appConfig__.popularSearchesFromJson ? popularSearches_namespaceObject[langFromUrl.language] : popularSearches);
                                }
                                if (menu) {
                                    _ctx.next = 46;
                                    break;
                                }
                                ;
                                _ctx.t0 = _slicedToArray;
                                _ctx.next = 36;
                                return Promise.all([
                                    (0,useCategoryTree/* fetcher */._i)(getRoute/* default */.Z, langFromUrl),
                                    (0,useCategories/* fetcher */._i)(langFromUrl)
                                ]);
                            case 36:
                                _ctx.t1 = _ctx.sent;
                                ref6 = (0, _ctx.t0)(_ctx.t1, 2);
                                menu = ref6[0];
                                categories = ref6[1];
                                ref6;
                                ctx.cache.set("menu", menu);
                                ctx.cache.set("categories", categories);
                                if (!(cacheFileExist === false)) {
                                    _ctx.next = 46;
                                    break;
                                }
                                _ctx.next = 46;
                                return (0,cache.saveCacheFile)({
                                    cacheFilePath: cacheFilePath,
                                    filenameCategoryCache: filenameCategoryCache,
                                    result: [
                                        menu,
                                        categories
                                    ]
                                });
                            case 46:
                                if (!((prismicCacheFileExist === false || prismicCacheFileExist === null) && !footerContent)) {
                                    _ctx.next = 75;
                                    break;
                                }
                                _ctx.prev = 47;
                                ;
                                _ctx.t2 = _slicedToArray;
                                _ctx.next = 52;
                                return Promise.all([
                                    (0,usePrismicMenuBanners/* fetcher */._i)(langFromUrl),
                                    (0,usePrismicFooter/* fetcher */._i)("footer", langFromUrl),
                                    (0,usePrismicSaleBanner/* fetcher */._i)(__webpack_require__.g.__appConfig__.prismicSaleBannerName, langFromUrl),
                                    (0,usePrismicCategoryBanners/* fetcher */._i)(langFromUrl),
                                    __webpack_require__.g.__appConfig__.popularSearchesFromJson ? popularSearches_namespaceObject[langFromUrl.language] : (0,usePrismic/* fetcher */._i)("popularsearches", __webpack_require__.g.__appConfig__.prismicPopularSearches, langFromUrl, false)
                                ]);
                            case 52:
                                _ctx.t3 = _ctx.sent;
                                ref7 = (0, _ctx.t2)(_ctx.t3, 5);
                                menuBanners = ref7[0];
                                footerContent = ref7[1];
                                saleBanner = ref7[2];
                                categoryBanners = ref7[3];
                                popularSearches = ref7[4];
                                ref7;
                                if (menuBanners === prismicErrorHandle.TIMEOUT || footerContent === prismicErrorHandle.TIMEOUT || saleBanner === prismicErrorHandle.TIMEOUT || categoryBanners === prismicErrorHandle.TIMEOUT) {
                                    externalContentTimeout = true;
                                }
                                if (externalContentTimeout) {
                                    _ctx.next = 70;
                                    break;
                                }
                                ctx.cache.set("menuBanners", menuBanners);
                                ctx.cache.set("footerContent", footerContent);
                                ctx.cache.set("saleBanner", saleBanner);
                                ctx.cache.set("categoryBanners", categoryBanners);
                                ctx.cache.set("popularSearches", popularSearches);
                                if (!(prismicCacheFileExist === false)) {
                                    _ctx.next = 70;
                                    break;
                                }
                                _ctx.next = 70;
                                return (0,cache.saveCacheFile)({
                                    cacheFilePath: cacheFilePath,
                                    filenameCategoryCache: prismicFilenameCategoryCache,
                                    result: [
                                        menuBanners,
                                        footerContent,
                                        saleBanner,
                                        categoryBanners,
                                        popularSearches
                                    ]
                                });
                            case 70:
                                _ctx.next = 75;
                                break;
                            case 72:
                                _ctx.prev = 72;
                                _ctx.t4 = _ctx["catch"](47);
                                console.log("Prismic - app - error while fetching data - ".concat(_ctx.t4));
                            case 75:
                                cookies = next_cookies_default()(ctx);
                                if (!Component.getInitialProps) {
                                    _ctx.next = 80;
                                    break;
                                }
                                _ctx.next = 79;
                                return Component.getInitialProps(_app_objectSpread({}, ctx, {
                                    cookies: cookies,
                                    Router: next_router["default"],
                                    menu: menu,
                                    router: router,
                                    footerContent: footerContent,
                                    categoryBanners: categoryBanners,
                                    saleBanner: saleBanner,
                                    menuBanners: menuBanners,
                                    language: langFromUrl,
                                    categories: categories,
                                    popularSearches: popularSearches,
                                    externalContentTimeout: externalContentTimeout
                                }));
                            case 79:
                                pageProps = _ctx.sent;
                            case 80:
                                ;
                                if (!pageProps) {
                                    showBanner = false;
                                } else {
                                    showBanner = (0,setSaleBannerVisibility/* default */.Z)(pageProps, saleBanner.saleBanner);
                                }
                                return _ctx.abrupt("return", {
                                    cookies: cookies,
                                    pageProps: pageProps,
                                    menu: menu,
                                    footerContent: footerContent,
                                    categoryBanners: categoryBanners,
                                    saleBanner: saleBanner,
                                    menuBanners: menuBanners,
                                    language: langFromUrl,
                                    categories: categories,
                                    popularSearches: popularSearches,
                                    showBanner: showBanner,
                                    externalContentTimeout: externalContentTimeout
                                });
                            case 83:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            47,
                            72
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return MyApp;
}(app["default"]);
var __Page_Next_Translate__ = (0,withCache/* default */.Z)(MyApp);
/* harmony default export */ var _app = (appWithI18n(__Page_Next_Translate__, _app_objectSpread({}, (i18n_default()), {
    isLoader: true,
    skipInitialProps: false
})));


/***/ }),

/***/ 98800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88349);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51608);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51493);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73764);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88244);
/* harmony import */ var _commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _deosite_lib_RouteContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73157);
/* harmony import */ var _deosite_api_hooks_common_useRecentlyViewedProducts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79105);
/* harmony import */ var _components_ProductBox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87122);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_10__);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ErrorPage = function(props) {
    var translations = {
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Default seo title"),
        possibleFailure: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Possible service failure. Please wait a moment and try again."),
        pageNotFound: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Page not found"),
        goToHomePage: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Go to home page"),
        recentlyViewed: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Check recently viewed")
    };
    var Link = (0,_deosite_lib_RouteContext__WEBPACK_IMPORTED_MODULE_7__.useRouteContext)().Link;
    var recentlyViewedProducts = (0,_deosite_api_hooks_common_useRecentlyViewedProducts__WEBPACK_IMPORTED_MODULE_8__.useRecentlyViewedProducts)();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        recentlyViewedActive: false,
        footerContent: props.footerContent,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_4___default()), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5___default()), {
                sx: {
                    display: "flex",
                    mt: "s10",
                    color: "main",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    minHeight: "50vh"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5___default()), {
                        as: "p",
                        sx: {
                            font: "xxl"
                        },
                        children: props.statusCode ? props.statusCode === 404 ? translations.pageNotFound : translations.possibleFailure : translations.possibleFailure
                    }),
                    (recentlyViewedProducts === null || recentlyViewedProducts === void 0 ? void 0 : recentlyViewedProducts.length) > 0 && props.statusCode === 404 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5___default()), {
                        sx: {
                            mt: "s8"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_5___default()), {
                                as: "p",
                                sx: {
                                    color: "main",
                                    font: "base",
                                    my: "s8",
                                    textAlign: "center"
                                },
                                children: translations.recentlyViewed
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_10___default()), {
                                cols: [
                                    (recentlyViewedProducts === null || recentlyViewedProducts === void 0 ? void 0 : recentlyViewedProducts.length) / 2,
                                    null,
                                    recentlyViewedProducts === null || recentlyViewedProducts === void 0 ? void 0 : recentlyViewedProducts.length,
                                    null
                                ],
                                sx: {
                                    gridRowGap: "s11"
                                },
                                children: recentlyViewedProducts.map(function(product, index) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ProductBox__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        product: product
                                    }, index);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Link, {
                        route: "home-page",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6___default()), {
                            title: translations.goToHomePage,
                            sx: {
                                color: "active",
                                font: "base",
                                mt: "s8"
                            },
                            children: translations.goToHomePage
                        })
                    })
                ]
            })
        })
    }));
};
ErrorPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(contextData) {
        var res, err, statusCode;
        return _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_11__/* .captureUnderscoreErrorException */ .u(contextData);
                case 2:
                    res = contextData.res, err = contextData.err;
                    statusCode = res ? res.statusCode : err ? err.statusCode : 404;
                    return _ctx.abrupt("return", {
                        statusCode: statusCode
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(contextData) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ }),

/***/ 43779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34885);




var ErrorDomain = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
            sx: {
                display: "flex",
                mt: "s10",
                color: "main",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                minHeight: "50vh"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
                as: "p",
                sx: {
                    font: "xxl"
                },
                children: "Page not found. 404"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorDomain);


/***/ }),

/***/ 42223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _commerce_ui_core2_generateColorPalette__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41387);
/* harmony import */ var _commerce_ui_core2_generateColorPalette__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_generateColorPalette__WEBPACK_IMPORTED_MODULE_0__);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var theme = function() {
    var space = [];
    space.s0 = 0;
    space.s1 = 1;
    space.s2 = 2;
    space.s3 = 4;
    space.s4 = 6;
    space.s5 = 8;
    space.s6 = 12;
    space.s7 = 16;
    space.s8 = 24;
    space.s9 = 32;
    space.s10 = 48;
    space.s11 = 64;
    space.s12 = 96;
    space.s13 = 128;
    space.s14 = 160;
    space.containerMargin = [
        "5vw",
        null,
        null,
        null,
        "7.5vw",
        "calc(50vw - 706px)"
    ];
    space.gridGap = [
        10,
        null,
        null,
        15,
        25,
        32
    ];
    space.notificationSystemOffset = 16;
    space.notificationSystemSeparator = 16;
    space.notificationSystemWidth = 300;
    var breakpoints = [
        "420px",
        "720px",
        "960px",
        "1200px",
        "1600px"
    ];
    breakpoints.xs = breakpoints[0];
    breakpoints.sm = breakpoints[1];
    breakpoints.md = breakpoints[2];
    breakpoints.lg = breakpoints[3];
    breakpoints.xl = breakpoints[4];
    var FONT_NANTES = "'NantesWeb', serif";
    var FONT_FRANKLIN_MEDIUM = "'FranklinGothicURW-Med', sans-serif";
    var FONT_FRANKLIN_BOOK = "'FranklinGothicURW-Boo', sans-serif";
    var FONT_NORTHWELL = "'Northwell', sans-serif";
    var fonts = {
        xxl: {
            //heading1
            fontSize: 32,
            fontFamily: FONT_NANTES,
            lineHeight: 1,
            fontWeight: 400
        },
        xxl_handwritten: {
            fontSize: 60,
            fontFamily: FONT_NORTHWELL,
            lineHeight: 1.5,
            fontWeight: 400
        },
        xxl_sans: {
            fontSize: 40,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1,
            fontWeight: 500
        },
        xxl_sans_bigger: {
            fontSize: 72,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1,
            fontWeight: 500
        },
        xl: {
            fontSize: 32,
            fontFamily: FONT_NANTES,
            lineHeight: 1.14,
            fontWeight: 500
        },
        xl_handwritten: {
            fontSize: 48,
            fontFamily: FONT_NORTHWELL,
            lineHeight: 1.6,
            fontWeight: 400
        },
        xl_sans: {
            fontSize: 28,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.1,
            fontWeight: 500
        },
        l: {
            fontSize: 20,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.2,
            fontWeight: 500
        },
        base: {
            fontSize: 18,
            fontFamily: FONT_NANTES,
            lineHeight: 1.5,
            fontWeight: 400
        },
        base_sans: {
            fontSize: 17,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.3,
            fontWeight: 400
        },
        base_italic: {
            fontSize: 17,
            fontFamily: FONT_NANTES,
            lineHeight: 1.5,
            fontWeight: 400
        },
        s: {
            fontSize: 15,
            fontFamily: FONT_NANTES,
            lineHeight: 1.4,
            fontWeight: 400
        },
        s_sans: {
            fontSize: 16,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.4,
            fontWeight: 400
        },
        s_italic: {
            fontSize: 15,
            fontStyle: "italic",
            fontFamily: FONT_NANTES,
            lineHeight: 1.4,
            fontWeight: 400
        },
        s_caps: {
            fontSize: 15,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.3,
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.1em"
        },
        xs_caps: {
            fontSize: 14,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.14,
            fontWeight: 500,
            textTransform: "uppercase"
        },
        xxs_caps: {
            fontSize: 12,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.1,
            fontWeight: 500,
            textTransform: "uppercase"
        },
        xxs_caps_ext: {
            fontSize: 12,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.1,
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.1em"
        },
        base_sans_bold: {
            fontSize: 17,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.4,
            fontWeight: 500
        },
        // TODO: zmienic na np. strikethrough
        base_sans_regular_discount: {
            fontSize: 16,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.5,
            fontWeight: 500,
            textDecoration: "line-through"
        },
        xs: {
            fontSize: 13,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.2,
            fontWeight: 400
        },
        xs_underline: {
            fontSize: 13,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.2,
            fontWeight: 400,
            textDecoration: "underline"
        },
        s_sans_bold: {
            fontSize: 15,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 1.4,
            fontWeight: 500
        },
        s_sans_underline: {
            fontSize: 15,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.4,
            fontWeight: 400,
            textDecoration: "underline"
        },
        l_normal: {
            fontSize: 20,
            fontFamily: FONT_FRANKLIN_BOOK,
            lineHeight: 1.2,
            fontWeight: 400
        },
        xxl_sans_desktop: {
            fontSize: 84,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            fontWeight: 500,
            letterSpacing: "-0.015em"
        },
        heading_large: {
            fontSize: 35,
            lineHeight: 1.3,
            fontWeight: 500,
            fontFamily: FONT_FRANKLIN_MEDIUM
        },
        sans_serif_22: {
            fontSize: 22,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 0.8
        },
        sans_serif_40: {
            fontSize: 40,
            fontFamily: FONT_FRANKLIN_MEDIUM,
            lineHeight: 0.6
        }
    };
    var ref = (0,_commerce_ui_core2_generateColorPalette__WEBPACK_IMPORTED_MODULE_0__.generateColorPalette)("positive", "#6CAD85"), positive = ref.positive, positive100 = ref.positive100, positive300 = ref.positive300, positive500 = ref.positive500, positive700 = ref.positive700;
    var ref1 = (0,_commerce_ui_core2_generateColorPalette__WEBPACK_IMPORTED_MODULE_0__.generateColorPalette)("negative", "#DF4F5C"), negative = ref1.negative, negative100 = ref1.negative100, negative300 = ref1.negative300, negative500 = ref1.negative500, negative700 = ref1.negative700;
    var ref2 = (0,_commerce_ui_core2_generateColorPalette__WEBPACK_IMPORTED_MODULE_0__.generateColorPalette)("neutral", "#EEECE5"), neutral = ref2.neutral, neutral100 = ref2.neutral100, neutral300 = ref2.neutral300, neutral500 = ref2.neutral500, neutral700 = ref2.neutral700, neutral900 = ref2.neutral900;
    return {
        colors: {
            main: "#2E4557",
            active: "#B05781",
            positive: positive,
            positive100: positive100,
            positive500: positive500,
            positive700: positive700,
            negative: negative,
            negative100: negative100,
            neutral300: neutral300,
            negative500: negative500,
            negative700: negative700,
            neutral: neutral,
            neutral100: neutral100,
            neutral500: neutral500,
            neutral700: neutral700,
            neutral900: neutral900,
            blue: "#587A94",
            blueDark: "#1E47B0",
            blueDarken: "#192630",
            orange: "#ff824c",
            lightOrange: "#F9EBD9",
            darkOrange: "#DF773C",
            beigeLight: "#fdfdfc",
            beige: "#f4f3ee",
            beigeDarken: "#908F8A",
            darkViolet: "#904769",
            lightViolet: "#f9f2f5",
            greyLight: "#B7B8B1",
            grey: "#b8b7b1",
            christmasLightRed: "#af504a",
            christmasDarkRed: "#8A3733",
            christmasRed: "#a63b35",
            producerGrey: "#737F89",
            producerGreyLight: "#B8B7B1"
        },
        typography: _objectSpread({}, fonts, {
            body: fonts.base,
            body2: fonts.s_sans,
            heading1: fonts.xxl,
            heading2: fonts.xl,
            heading3: fonts.l,
            label: fonts.s_caps,
            label2: fonts.xs_caps
        }),
        space: space,
        breakpoints: breakpoints,
        hideFocus: true
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (theme);


/***/ }),

/***/ 54788:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 74195:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 63587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./cz.json": 49285,
	"./de.json": 55030,
	"./es.json": 71532,
	"./fr.json": 8659,
	"./gb.json": 47289,
	"./it.json": 80175,
	"./package.json": 26618,
	"./pl.json": 42537,
	"./ro.json": 9446,
	"./se.json": 61385,
	"./sk.json": 48123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63587;

/***/ }),

/***/ 68054:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(41193);

/***/ }),

/***/ 31764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93829);

/***/ }),

/***/ 53570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27079);

/***/ }),

/***/ 48449:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(50694);

/***/ }),

/***/ 78541:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(68323);

/***/ }),

/***/ 18396:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(23300);

/***/ }),

/***/ 99850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(98816);

/***/ }),

/***/ 95946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19502);

/***/ }),

/***/ 57919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(44562);

/***/ }),

/***/ 72817:
/***/ (function(module) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(41193);
function _arrayWithHoles(r) {
  if (_Array$isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 35620:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(41193);
var arrayLikeToArray = __webpack_require__(72817);
function _arrayWithoutHoles(r) {
  if (_Array$isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 38099:
/***/ (function(module) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 79779:
/***/ (function(module) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8286:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(50694);
var toPropertyKey = __webpack_require__(91298);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), _Object$defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), _Object$defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 24677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(50694);
var toPropertyKey = __webpack_require__(91298);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? _Object$defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$assign = __webpack_require__(27079);
function _extends() {
  return module.exports = _extends = _Object$assign ? _Object$assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 44034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$setPrototypeOf = __webpack_require__(94040);
var _Object$getPrototypeOf = __webpack_require__(92984);
function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = _Object$setPrototypeOf ? _Object$getPrototypeOf.bind() : function (t) {
    return t.__proto__ || _Object$getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 42071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$create = __webpack_require__(14763);
var _Object$defineProperty = __webpack_require__(50694);
var setPrototypeOf = __webpack_require__(62811);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = _Object$create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), _Object$defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 50365:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 72269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(58304)["default"]);
var _WeakMap = __webpack_require__(88363);
var _Object$defineProperty = __webpack_require__(50694);
var _Object$getOwnPropertyDescriptor = __webpack_require__(27151);
function _getRequireWildcardCache(e) {
  if ("function" != typeof _WeakMap) return null;
  var r = new _WeakMap(),
    t = new _WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = _Object$defineProperty && _Object$getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Symbol = __webpack_require__(58507);
var _Symbol$iterator = __webpack_require__(62568);
var _Array$from = __webpack_require__(88739);
function _iterableToArray(r) {
  if ("undefined" != typeof _Symbol && null != r[_Symbol$iterator] || null != r["@@iterator"]) return _Array$from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Symbol = __webpack_require__(58507);
var _Symbol$iterator = __webpack_require__(62568);
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof _Symbol && r[_Symbol$iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 11619:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 13753:
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 89811:
/***/ (function(module) {

function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = _objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 59415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$keys = __webpack_require__(23300);
var _Object$getOwnPropertySymbols = __webpack_require__(48939);
var _Object$getOwnPropertyDescriptor = __webpack_require__(27151);
var defineProperty = __webpack_require__(24677);
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? Object(arguments[r]) : {},
      o = _Object$keys(t);
    "function" == typeof _Object$getOwnPropertySymbols && o.push.apply(o, _Object$getOwnPropertySymbols(t).filter(function (e) {
      return _Object$getOwnPropertyDescriptor(t, e).enumerable;
    })), o.forEach(function (r) {
      defineProperty(e, r, t[r]);
    });
  }
  return e;
}
module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 39561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$getOwnPropertySymbols = __webpack_require__(48939);
var objectWithoutPropertiesLoose = __webpack_require__(96998);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (_Object$getOwnPropertySymbols) {
    var n = _Object$getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 96998:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 80899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(58304)["default"]);
var assertThisInitialized = __webpack_require__(38099);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 62811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$setPrototypeOf = __webpack_require__(94040);
function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = _Object$setPrototypeOf ? _Object$setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 14556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(69265);
var iterableToArrayLimit = __webpack_require__(51442);
var unsupportedIterableToArray = __webpack_require__(57138);
var nonIterableRest = __webpack_require__(11619);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Object$freeze = __webpack_require__(63273);
var _Object$defineProperties = __webpack_require__(71170);
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), _Object$freeze(_Object$defineProperties(e, {
    raw: {
      value: _Object$freeze(t)
    }
  }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(35620);
var iterableToArray = __webpack_require__(69613);
var unsupportedIterableToArray = __webpack_require__(57138);
var nonIterableSpread = __webpack_require__(13753);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 34953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Symbol$toPrimitive = __webpack_require__(4219);
var _typeof = (__webpack_require__(58304)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[_Symbol$toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 91298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(58304)["default"]);
var toPrimitive = __webpack_require__(34953);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 58304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Symbol = __webpack_require__(58507);
var _Symbol$iterator = __webpack_require__(62568);
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 57138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _Array$from = __webpack_require__(88739);
var arrayLikeToArray = __webpack_require__(72817);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 46917:
/***/ (function(module) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 75613:
/***/ (function(module) {

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 67757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(46917);
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 11112:
/***/ (function(module) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 2302:
/***/ (function(module) {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 98986:
/***/ (function(module) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 30428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(85334);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(85334);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 87193:
/***/ (function(module) {

function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 53531:
/***/ (function(module) {

function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 10564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(22839);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7125:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 80538:
/***/ (function(module) {

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 86927:
/***/ (function(module) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 43554:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18502:
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 88450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(20286);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20286:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 5153:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(93678)["default"]);
var assertThisInitialized = __webpack_require__(11112);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 63953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(93678)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 22839:
/***/ (function(module) {

function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(75613);
var iterableToArrayLimit = __webpack_require__(86927);
var unsupportedIterableToArray = __webpack_require__(69239);
var nonIterableRest = __webpack_require__(43554);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 50415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(67757);
var iterableToArray = __webpack_require__(80538);
var unsupportedIterableToArray = __webpack_require__(69239);
var nonIterableSpread = __webpack_require__(18502);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(93678)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 85334:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(93678)["default"]);
var toPrimitive = __webpack_require__(8278);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93678:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(46917);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 13027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(63953)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 24759:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  thunk: () => thunk,
  withExtraArgument: () => withExtraArgument
});
module.exports = __toCommonJS(src_exports);
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 4079:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _defineProperty; }
});

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 61393:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 98911:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}


/***/ }),

/***/ 12720:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 14124:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"100":"Continue","101":"Switching Protocols","102":"Processing","103":"Early Hints","200":"OK","201":"Created","202":"Accepted","203":"Non-Authoritative Information","204":"No Content","205":"Reset Content","206":"Partial Content","207":"Multi-Status","208":"Already Reported","226":"IM Used","300":"Multiple Choices","301":"Moved Permanently","302":"Found","303":"See Other","304":"Not Modified","305":"Use Proxy","306":"(Unused)","307":"Temporary Redirect","308":"Permanent Redirect","400":"Bad Request","401":"Unauthorized","402":"Payment Required","403":"Forbidden","404":"Not Found","405":"Method Not Allowed","406":"Not Acceptable","407":"Proxy Authentication Required","408":"Request Timeout","409":"Conflict","410":"Gone","411":"Length Required","412":"Precondition Failed","413":"Payload Too Large","414":"URI Too Long","415":"Unsupported Media Type","416":"Range Not Satisfiable","417":"Expectation Failed","418":"I\'m a teapot","421":"Misdirected Request","422":"Unprocessable Entity","423":"Locked","424":"Failed Dependency","425":"Unordered Collection","426":"Upgrade Required","428":"Precondition Required","429":"Too Many Requests","431":"Request Header Fields Too Large","451":"Unavailable For Legal Reasons","500":"Internal Server Error","501":"Not Implemented","502":"Bad Gateway","503":"Service Unavailable","504":"Gateway Timeout","505":"HTTP Version Not Supported","506":"Variant Also Negotiates","507":"Insufficient Storage","508":"Loop Detected","509":"Bandwidth Limit Exceeded","510":"Not Extended","511":"Network Authentication Required"}');

/***/ }),

/***/ 49285:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Slevový kód","Delete coupon code":"Vymazat kód","AllProducts{{brandName}}":"Všechny produkty {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Vytvořena {{authorName}} od {{authorProfileNick}}","Shop items below":"Prohlídněte si produkty níže","Curated by":"Pod dohledem","by":"od","from":"z","from range":"od","to range":"do","More":"Více","more":"více","starting at":"začíná od","or":"nebo","Login":"Přihlášení","My account":"Můj účet","Free delivery":"Doprava zdarma","to free standard shipping":"do dopravy zdarma","Shipping":"Doprava","Shipping method":"Způsob dopravy","Shipping address":"Doručovací adresa","Invoice data":"Údaje pro fakturu","Billing same as shipping":"Fakturační adresa je stejná jako doručovací adresa","Subtotal":"Obsah košíku","Discounts":"Slevy","Tax":"DPH","Tax and Shipping are estimated for ":"Daň a doprava se odhadují na","Tax included":"Včetně DPH","Total":"Celkem","Go to checkout":"K pokladně","Your cart":"Váš košík","Collections":"Série","View details":"Podrobnosti","Add to cart":"Do košíku","add to cart":"Přidej do košíku","More inspirations":"Více inspirací","Recently viewed":"Naposledy prohlíženo","Register":"Registrace","Sign Up":"Zaregistrujte se ","Sign Off":"Odhlásit","Log in":"Přihlášení","Log yourself":"Přihlašte se ","of":"z","Technical data":"Technické údaje","Product description":"Popis produktu","Color":"Barva","Size":"Rozměry","Story with":"Článek s účastí","Inspirations":"Inspirace","Home":"Hlavní strana","Arrivals by category":"Novinky dle kategorií","Already have an account?":"Máte již konto?","Rodo_agreement {{domain}}":"Souhlasím se zpracováním mých osobních údajů společností DAJAR sp.z o.o. za účelem nákupu v internetovém obchodě {{domain}}. Správcem osobních údajů poskytnutých při zadávání objednávky je DAJAR sp.z o.o. hlavní sídlo: Polsko 75-072 Koszalin, ul. Połtawska 6. Vezměte prosím na vědomí, že každý z našich klientů má právo na přístup, opravu, odstranění, omezení zpracování. Klient má právo vznést námitku proti zpracování svých osobních údajů a přenosu dat a to emailem na e-mailovou adresu dpo@dajar.pl. Také vás informujeme o možnosti podat stížnost dozorčímu orgánu v případě neoprávněného použití osobních údajů. Výše uvedený souhlas lze kdykoli odvolat na základě polského zákoníku čl. 23 odst. 1 bodu 1 zákona ze dne 29. srpna 1997 o ochraně osobních údajů a čl. 6 odst. 1a nařízení EU 2016/679. \\n\\n","Password":"Heslo","First Name":"Jméno","Last Name":"Příjmení","First, last name":"Jméno a příjmení","Street":"Ulice+číslo popisné","City":"Město","Country":"Země","Phone":"Telefon","Postal code":"PSČ","Company name":"Název firmy","Vat ID":"DIČ DPH","Company":"Společnost","Registration complete":"Registrace a přihlášení dokončeno","Required field":"Povinné pole","Required option":"Vybraná možnost musí být zaškrtnuta","Terms agreement":"Pokud se chcete zaregistrovat, musíte souhlasit s podmínkami používání této webové stránky","Invalid email":"Chybný email","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.cz","Forgot password?":"Zapomněli jste heslo?","Don\'t have an account?":"Nemáte konto?","All New in":"Všechny novinky v","New arrivals":"Novinky","New arrival":"Novinky","Password match":"Heslo musí být stejné","No products in cart":"V košíku nemáte žádné produkty","Thank you, your order has been placed!":"Děkujeme, Vaše objednávka je přijata","Completed order info":"Objednávka je v realizaci, o odeslání budete informovaní emailem.\\n","Back to home page":"Zpět na hlavní stranu","come back to main categories":"Hlavní menu","Needs help?":"Potřebujete pomoc?","Show cart summary":"Shrnutí košíku","Sign up for newsletter":"Zapište se k odběru Newsletter","Subscribe to newsletter":"Zapište se","Sign off from newsletter":"Odhlašte Newsletter","Sign up for newsletter seo title":"Zapiš do Newsletter","Sign up for newsletter seo description":"Přihlaste se k odběru našeho Newsletter. Informace o nových produktech a akcích","Sign off for newsletter seo title":"Odhlašte Newsletter","Sign off for newsletter seo description":"Z odběru našeho Newsletter se můžete kdykoli odhlásit","Sign up for newsletter success":"Zkontrolujte svůj e-mail a potvrďte registraci. ","Unsubscribe success":"Úspěšné odhlášení z odběru Newsletter","Our bestsellers":"Populární produkty","Shop the deals":"Příležitost","Popular categories":"Populární kategorie","Out of stock":"Není na skladě","Last items in stock":"Poslední kusy skladem","Also from this collection":"Jiné z této série","Complete the look":"Doplňte","Shop all{collectionName}}":"Podívejte se na celou sérii {{collectionName}}","Catalog price":"Katalogová cena:","Quantity":"Množství","Details":"Detail","Saved addresses":"Uložené adresy","Contact":"Kontakt","Continue to payment":"Přejít k platbě","Go back to cart":"Zpět do košíku","Go back to information":"Zpět k informacím","Create account":"Vytvořit konto","Payment method":"Způsob platby","Payment":"Platba","Waiting for payment":"Čekáme na platbu","Payment complete":"Platba dokončena","cash on delivery":"Dobírka-platba u kurýra","bank transfer":"Běžný převod","Newsletter description":"Buďte v obraze. Získejte informace o nových produktech a výprodejích.","Reset password":"Obnovit heslo","Reset password description":"Zadejte svou e-mailovou adresu a obdržíte pokyny, jak obnovit heslo.\\n","Reset":"Resetuj","Back to login":"Návrat k přihlášení","Newsletter agreement":"Souhlasím se zpracováním mých osobních údajů společností DAJAR sp.z o.o. za účelem zasílání obchodních informací od DAJAR sp.z o.o. na mnou uvedenou e-mailovou adresu. Správcem osobních údajů poskytnutých při zadávání objednávky je DAJAR sp.z o.o. hlavní sídlo: Polsko 75-072 Koszalin, ul. Połtawska 6. Vezměte prosím na vědomí, že každý z našich klientů má právo na přístup, opravu, odstranění, omezení zpracování. Klient má právo vznést námitku proti zpracování svých osobních údajů a přenosu dat a to emailem na e-mailovou adresu dpo@dajar.pl. Také vás informujeme o možnosti podat stížnost dozorčímu orgánu v případě neoprávněného použití osobních údajů. Výše uvedený souhlas lze kdykoli odvolat na základě polského zákoníku čl. 23 odst. 1 bodu 1 zákona ze dne 29. srpna 1997 o ochraně osobních údajů a čl. 6 odst. 1a nařízení EU 2016/679. ","Place order":"Vytvořit objednávku","See all":"Podívejte se na vše","Shop this story":"Doporučené produkty","Recommended categories":"Doporučené kategorie","Related stories":"Související z historie","I have coupon code":"Mám slevový kód","Submit":"Odeslat","price high to low":"Cena: od nejvyšší","price low to high":"Cena: od nejnižší","sortByNameDesc":"Dle názvu Z-A","sortByNameAsc":"Dle názvu A-Z","recommended":"Doporučujeme","All orders":"Všechny objednávky","Address book":"Seznam adres","Log out":"Odhlášení","Last order":"Poslední objednávky","Personal info":"Personální informace","My orders":"Moje objednávky","Account":"Konto","Orders":"Objednávky","Order":"Objednávka","Order number":"Objednávka číslo","Ongoing":"V průběhu","Past orders":"Předchozí objednávky","Account password change description":"Pro změnu hesla, klikněte na pravé tlačítko ","Edit":"Editovat","Change":"Změň","Save":"Uložit","Old password":"Staré heslo","New password":"Nové heslo","Continue shopping":"Pokračovat v nákupu","bonus ePoints":"bodů Dajar ePremia","Use":"Použít","Sale":"Sleva","Your order":"Vaše objednávka","Search":"Hledej","See all suggestions ({{resultsLength}})":"Zobrazit všechny výsledky ({{resultsLength}})","Cancel":"Zrušit","Sort":"Filtruj","all filters":"Všechny filtry","Clear":"Vyčistit","Filter":"Filtruj","select":"Vyber","selected":"Vybrané","Show result":"Ukázat výsledky","People also liked":"Podívejte se také","Popular searches":"Populární vyhledávání","Read more":"Číst dále","capacity":"Objem","diameter":"Průměr","material":"Materiál","size":"Rozměry","length":"Délka","color":"Barva","depth":"Hloubka","width":"Šířka","height":"Výška","shape":"Tvar","Search collections, products, etc...":"Hledej produkty, série, atd...","Shop by Collection":"Doporučené série","Shop by Type":"Kategorie produktů","show all":"Ukaž vše","show more":"Ukaž více","show less":"Ukaž méně","languages":"Jazyky","Please login, your session expired.":"Přihlaste se znovu, vaše relace vypršela.","pending":"Přijato do realizace","canceled":"Zrušeno","sending":"Připraveno k odeslání","processing":"ve zpracování","complete":"Odesláno","Delivered":"Doručeno","Tracking number":"Číslo zásilky","ready":"Hotovo","Track and trace":"Sledování zásilky","Copy":"Kopíruj","Out for delivery":"Na cestě","Expect your package today":"Od dnešního dne očekávejte svou zásilku","Courier":"Kurýr","Change password":"Změnit heslo","Default seo description":"Vítejte v obchode DAJAR.cz. Nabízíme zahradní nábytek, sedáky a houpačky. Náš obchod nabízí také nádobí, příbory, hrnce, pánve, jídelní soupravy a sklenice.","Default seo description - register":"Vítejte v obchode DAJAR.cz. Nabízíme zahradní nábytek, sedáky a houpačky. Náš obchod nabízí také nádobí, příbory, hrnce, pánve, jídelní soupravy a sklenice.","Default seo title":"DAJAR.cz - zahradní nábytek a nádobí","Default seo title - register":"DAJAR.cz - zahradní nábytek a nádobí","search results":"Výsledky hledání pro \\"{{phrase}}\\"","page":"Strana","rachunku":"Produkty v kategorii  {{categoryName}} v obchodě Dajar.cz Užijte si nakupování!","Accept terms":"Přečetl/a jsem si a souhlasím s podmínkama ","Terms":"Prodeje","Shipment":"Dodání","Cookie notice":"Vítejte v našem obchodě DAJAR.cz.\\nCookies (soubory cookies) používáme k analýze provozu na webu DAJAR.cz, k personalizaci obsahu na webu, zobrazování reklam na míru a zvyšování komfortu používání našeho webu. Kliknutím na „Akceptuji“ nás informujete, že souhlasíte s naším ukládáním cookies (souborů cookies) do vašeho prohlížeče a případně se zpracováním souvisejících údajů pro tyto účely. Svůj souhlas můžete spravovat a kdykoli ho odvolat pomocí nastavení ve vašem prohlížeči. Další informace naleznete v našich zásadách používání souborů cookies.","Accept":"Akceptuji","Default billing":"Přednastavená fakturace","Default billing address":"Přednastavená fakturační adresa","Default shipping":"Přednastavená doručení","Default shipping address":"Přednastavená doručovací adresa","Is default shipping address?":"Přednastavená doručovací adresa?","Is default billing address?":"Přednastavená fakturační adresa?","Add new address":"Přidejte novou adresu","Not set":"Nepřidáno","Default billing and shipping":"Přednastavená fakturační a dodací adresa","Product was added to cart":"Produkt byl přidán do košíku","number of people":"počet osob","Wrong street format":"Ulice a číslo domu jsou povinné","New address":"Nová adresa","Edit address":"Upravte adresu","Error":"Chyba","Something went wrong":"Něco se pokazilo.","Fill in the delivery details":"Vyplňte údaje o přepravě.","We don\'t ship to this country, sorry":"Omlouváme se, ale do této země nezasíláme","This method is not available":"Tato metoda není k dispozici","Incorrect phone number":"Neplatné telefonní číslo","Incorrect VAT ID":"Nesprávné DIČ DPH","Shipping same as billing":"Doručovací adresa je stejná jako fakturační","As Company":"Nakupuji na firmu","Name or Company":"Název firmy","Billing for":"Faktura pro","Choose pickup point":"","Deliver to company":"","Company address":"Adresa společnosti","Search results | Dajar":"Výsledky hledání | DAJAR.cz","Address saved":"Uložená adresa","ePoints":"DAJAR ePremia","Available ePoints":"Dostupné body DAJAR ePremia","You can use these points with your next purchase":"Můžete použít body DAJAR ePremia při příštím nákupu","Learn more":"Zjistit více","ePoints earned":"Zisk bodů DAJAR ePremia","paid with ePoints":"Zaplaceno body DAJAR ePremia","Settlement of ePoints":"Vyúčtování bodů DAJAR ePremia","Added by administrator":"Dodáno administrátorem","Purchase invoice":"Doklad o koupi","Purchase canceled":"Zrušený nákup","Spent with order":"Použito v objednávce","Spent with order canceled":"Zrušeno použití v objednávce","Order cancelation":"Zrušení objednávky","Max addresses reached":"Maximální počet uložených adres. Adresa nebyla přidána","Brexit":"","Pay less with ePoints":"Plaťte méně s DAJAR ePremia","Delete ePoints":"Vymazat body DAJAR ePremia","ePoints (you have {{points}})":"DAJAR ePremia (máte {{points}})","price":"Cena","Active":"Aktivní","Accept all cookies":"Akceptovat vše","Confirm my settings":"Akceptovat vybrané","Manage cookie settings":"Chci si vybrat ...","Third party cookies":"Seznam cookies","Back to cookie list":"Seznam cookies","Show cookie list":"Zobrazit soubory cookies","Cookie name":"Název","Duration":"Doba trvání","Type":"Typ","Required cookies description":"Soubory cookie, které potřebujeme pro řádný provoz našeho obchodu DAJAR.cz.","Analytic cookies description":"Zahrnují cookies, které nám pomáhají analyzovat a sledovat provoz na našem webu DAJAR.cz. Poskytuje nám to další znalosti pro vylepšení našich webových stránek.","Tracking cookies description":"Cookies, které nám umožňují přizpůsobit a měřit účinnost naší reklamy. S jejich pomocí vám poskytneme informace, které jsou pro vás nejdůležitější.","Necessary cookies":"Nezbytné cookies","Analytic cookies":"Analytické cookies","Tracking cookies":"Soubory cookies pro sledování chování","Third party":"Třetí strana ","day":"den","days":"dny","years":"roky","minute":"minuta","minutes":"minuty","month":"měsíc","months2":"měsíců","months":"měsíce","year":"rok","session":"relace","hour":"hodina","Own":"Own","Too many points provided":"Zadáno příliš mnoho bodů ","Last name must be different then first name":"Jméno musí být jiné než příjmení","Additonal fee":"Dodatečný poplatek +30 kč","price catalog high to low":"Katalogová cena: od nejvyšší","price catalog low to high":"Katalogová cena: od nejnižší","Additional information":"Dodatečné informace","Length [cm]":"Délka [cm]","Width [cm]":"šířka [cm]","Shape":"Tvar","Producer":"Výrobce","Height [cm]":"Výška [cm]","Depth [cm]":"Hloubka [cm]","Capacity [ml]":"Objem [ml]","Number of people":"Počet osob","Dajar collection":"Série","Material":"Materiál","Application":"Použití","Diameter [cm]":"Průměr [cm]","Color list":"Barva","Pattern list":"Vzor","Feature":"Funkce","Composition":"Materiál","Max load":"Maximální zatížení [kg]","Capacity [l]":"Objem [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Váha [kg]","Help":"Pomoc","The product is no longer available":"Produkt již není dostupný","Remove it from the cart or reduce the quantity ":"Prosíme odstraňte produkt z košíku","The product will be available":"Produkt bude dostupný","product available in different variant":"produkt je dostupný i v jiné variantě","Possible service failure. Please wait a moment and try again":"Možné selhání služby. Chvíli počkejte a zkuste to znovu","Page not found":"Stránka nenalezena","Go to home page":"Přejděte na hlavní stránku","Check recently viewed":"Zkontrolujte nedávno zobrazené","Do not hesitate":"S nákupem neváhejte, vložení položek do košíku neznamená jejich rezervaci ","Save new address":"Uložit","Other address":"Other address","Subscribe to the newsletter":"Zapiš do Newsletter","And get even 20% off":"Získejte dokonce 5% slevu","Subscribe":"ZAPIŠTE SE","Subscribe to our newsletter":"Přihlaste se k odběru našeho newsletteru","And get even 10% off":"Získejte až 5% slevu na nákupy v jakékoli hodnotě. ","Cart":"Košík","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"Žádné objednávky","Are you sure you want to remove this address?":"Opravdu chcete odstranit adresu?","Password saved":"Heslo uloženo","Firstname and Lastname saved":"Uloženo jméno a příjmení","Address deleted":"Adresa odstraněna","Yes":"Ano","No":"Ne","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Vaše platba se zpracovává. Zašleme Vám e-mail se stavem Vaší objednávky.","Thank you for your purchase":"Děkujeme za Vaši objednávku!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Nejnižší cena za posledních 30 dnů","Promo code was added to clipboard":"Slevový kód byl zkopírován","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Produkt byl přidán do seznamu oblíbených","Removed from wishlist":"Produkt byl odstraněn ze seznamu oblíbených","Product on wishlist":"Produkt je na seznamu oblíbených","Wishlist inactive tooltip":"Přihlaste se a přidejte produkt do seznamu oblíbených","Wishlist":"Seznam oblíbených","Add visible to cart":"Přidejte dostupné produkty do košíku","Wishlist products added to cart":"Dostupné položky seznamu oblíbených byly přidány do vašeho košíku","No products in the wishlist":"V seznamu oblíbených nejsou žádné produkty","Hit of the day":"Hit dne","Only {{qty}} left in stock":"Skladem {{qty}} kusů","Offer ends":"Nabídka končí za:","hours hit":"hod.","minutes hit":"min.","seconds hit":"sek.","sold out":"vyprodáno","left hits":"zůstatek","sold hits":"prodáno","Offer start":"Nová nabídka začíná za","Available qty for person in hit {{qty}}":"Můžete koupit max. {{qty}} ks. na osobu","Outlet":"Vyprodej","Hit of the week":"Hit týdne","Hit of the month":"Hit měsíce","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Příležitost!","Check out this great deal":"Podívejte se na tuto skvělou nabídku","A new unique offer every day":"Každý den nová jedinečná nabídka","Change parcel":"","card":"Platba platební kartou","banktransfer":"Běžný převod","cashondelivery":"Dobírka","dialcom_przelewy":"Rychlý převod","bluepayment":"Rychlý převod","blik":"Blik platba","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"Zadejte kód BLIK z aplikace vaší banky","applepay_info":"Kliknutím zaplatíte za objednávku","googlepay_info":"Kliknutím zaplatíte za objednávku","paypal_info":"Vybrán PayPal. Po kliknutí na Zaplatit budete přesměrováni na stránku, která vám umožní bezpečně dokončit další kroky.","bluepayment_info":"Vybrána platba Autopay. Po kliknutí na Zaplatit budete přesměrováni na stránku, která vám umožní bezpečně dokončit další kroky.","klarna_info":"Vybrána platba Klarna.<br />Po kliknutí dojde k přesměrování na stránku, která umožňuje bezpečné provedení dalších kroků.","banktransfer_info":"Byla zvolena platba převodem. Po kliknutí na Zaplatit obdržíte e-mail s bankovním spojením k úhradě.","cashondelivery_info":"Byla zvolena platba na dobírku. Objednávku zaplatíte kurýrovi při doručení zásilky.","The payment is REFUSED.":"Platba se nezdařila.","Payment refused. Choose payment method and retry":"Vyberte způsob platby a zkuste to znovu","Finish payment":"Dokončete platbu","klarna_paynow_button_label":"Zaplať nyní s Klarna","klarna_paylater_button_label":"Zaplať za 30 dní s Klarna","klarna_account_button_label":"Zaplať na splátky s Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Vaše platba byla odmítnuta nebo se v košíku nachází produkt, který je vyprodaný.","adyen_error_message":"Vaše platba byla zamítnuta.","Cannot set delivery method":"Nelze nastavit způsob doručení","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Tento výrobek lze používat bezpečným způsobem určeným výrobcem pouze v souladu s návodem k obsluze a údržbě, doporučeními, varováními nebo bezpečnostními informacemi umístěnými na výrobku nebo na jeho obalu nebo na letáku dodávaného s výrobkem.","safety_title":""}');

/***/ }),

/***/ 55030:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Rabattcode","Delete coupon code":"Code entfernen","AllProducts{{brandName}}":"Alle Produkte {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Erstellt von {{authorName}} von {{authorProfileNick}}","Shop items below":"Siehe Produkte unten","Curated by":"Unter Aufsicht von ","by":"von ","from":"aus","from range":"von ","to range":"bis","More":"Mehr","more":"mehr","starting at":"beginnt von ","or":"oder","Login":"Einloggen","My account":"Mein Konto","Free delivery":"Kostenlose Lieferung","to free standard shipping":"Zur kostenlosen Lieferung","Shipping":"Lieferung ","Shipping method":"Versandart","Shipping address":"Versandadresse","Invoice data":"Rechnungsangaben","Billing same as shipping":"Die Rechnungsadresse stimmt mit der Lieferadresse überein ","Subtotal":"Zwischensumme","Discounts":"Rabatt","Tax":"Steuer","Tax and Shipping are estimated for ":"Steuer und Versand berechnet für","Tax included":"Steuer inklusive","Total":"Gesamtpreis inkl. MwSt.","Go to checkout":"Zur Kasse","Your cart":"Dein Warenkorb","Collections":"Kollektionen","View details":"Details anzeigen ","Add to cart":"Zum Warenkorb ","add to cart":"In den Warenkorb legen ","More inspirations":"Weitere Inspirationen","Recently viewed":"Zuletzt angesehen","Register":"Anmeldung ","Sign Up":"Sich anmelden ","Sign Off":"Sich ausmelden ","Log in":"Einloggen","Log yourself":"Log dich ein ","of":"aus","Technical data":"Technische Angaben","Product description":"Produktbeschreibung","Color":"Farbe","Size":"Größe","Story with":"","Inspirations":"Inspirationen","Home":"Startseite ","Arrivals by category":"Neu nach Kategorie ","Already have an account?":"Wurde ein Konto bereits erstellt? ","Rodo_agreement {{domain}}":"Ich stimme der Verarbeitung meiner persönlichen Daten durch DAJAR GmbH zu, um die Einkäufe im {{domain}} Online-Shop zu tätigen. Der Betreiber bei der bei der Bestellung angegebenen personenbezogenen Daten ist DAJAR GmbH mit Hauptsitz in 10117 Berlin, c/o. Regus, Unter den Linden 21. Bitte beachten Sie, dass jeder unserer Kunde das Recht hat, auf die Verarbeitung seiner persönlichen Daten zuzugreifen, diese zu korrigieren, zu löschen, die Verarbeitung einzuschränken, der Verarbeitung seiner persönlichen Daten zu widersprechen und Daten zu übertragen. Bitte senden Sie das Anmeldeformular an die E-Mail-Adresse dpo@dajar.pl. Wir informieren Sie auch über die Möglichkeit, bei unbefugter Verwendung personenbezogener Daten eine Beschwerde bei der Aufsichtsbehörde einzureichen. Die vorstehende Einwilligung kann jederzeit auf der Grundlage von Artikel 23 Punkt 1 Unterpunkt 1 des Gesetzes vom 29. August 1997 über den Schutz personenbezogener Daten und Artikel 6 Punkt 1a der EU-Verordnung 2016/679 widerrufen werden","Password":"Passwort ","First Name":"Vorname","Last Name":"Nachname","First, last name":"Vor- und Nachname","Street":"Straße ","City":"Ort","Country":"Land","Phone":"Telefonnummer","Postal code":"Postleitzahl ","Company name":"Firmenname ","Vat ID":"Steuer-Nr","Company":"Firmenkunde","Registration complete":"Konto erstellt und eingeloggt ","Required field":"Pflichtfeld","Required option":"Pflichtoption ","Terms agreement":"Durch die Anmeldung stimmen Sie den Allgemeinen Geschäftsbedigungen zu ","Invalid email":"E-Mail-Adresse inkorrekt ","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.de","Forgot password?":"Passwort vergessen?","Don\'t have an account?":"Sie haben noch kein Kundenkonto?","All New in":"Alles neu in ","New arrivals":"Neu","New arrival":"Neu","Password match":"Passwort wiederholen","No products in cart":"Keine Artikel im Warenkorb","Thank you, your order has been placed!":"Vielen Dank, Ihre Bestellung wurde erfolgreich abgeschlossen!","Completed order info":"Bestellungsbearbeitung, über den Versand werden Sie per E-Mail informiert ","Back to home page":"Zur Startseite ","come back to main categories":"Hauptmenu ","Needs help?":"Hilfe benötigt?","Show cart summary":"Warenkorbzusammenfassung anzeigen","Sign up for newsletter":"Newsletter Anmeldung","Subscribe to newsletter":"Newsletter Abonnieren ","Sign off from newsletter":"Vom Newsletter abmelden ","Sign up for newsletter seo title":"Newsletter Anmeldung","Sign up for newsletter seo description":"Melden Sie sich für unseren Newsletten an. Informationen über neue Produkte und Werbeaktionen","Sign off for newsletter seo title":"Vom Newsletter abmelden ","Sign off for newsletter seo description":"Die Abmeldung von unserem Newsletter ist jederzeit möglich","Sign up for newsletter success":"Überprüfen Sie Ihre E-Mail und bestätigen Sie die Registrierung. ","Unsubscribe success":"Newsletter - Abmeldung erfolgreich","Our bestsellers":"Unsere Bestseller","Shop the deals":"Angebote","Popular categories":"Beliebte Kategorien ","Out of stock":"Nicht auf Lager","Last items in stock":"Letzte Artikel auf Lager","Also from this collection":"Andere in dieser Kollektion ","Complete the look":"Ergänze um ","Shop all{collectionName}}":"Zeige die ganze Kollektion  {{collectionName}}","Catalog price":"Katalogpreis:","Quantity":"Menge","Details":"Einzelheiten ","Saved addresses":"Gespeicherte Adressen ","Contact":"Kontakt","Continue to payment":"Zur Kasse","Go back to cart":"Zurück zum Warenkorb","Go back to information":"Zurück zur Informationen","Create account":"Konto erstellen","Payment method":"Zahlungsart","Payment":"Zahlung","Waiting for payment":"Zahlung wird erwartet","Payment complete":"Zahlung abgeschlossen ","cash on delivery":"Nachnahme","bank transfer":"Banküberweisung","Newsletter description":"Bleiben Sie auf dem Laufenden. Erhalten Sie Informationen über neue Produkte und Ausverkäufe","Reset password":"Passwort zurücksetzen","Reset password description":"Geben Sie Ihre E-Mail-Adresse an, um Anweisungen zum Zurücksetzen Ihres Passworts zu erhalten.","Reset":"Zurücksetzen","Back to login":"Zurück zum Einloggen ","Newsletter agreement":"Ich stimme der Verarbeitung meiner persönlichen Daten durch DAJAR GmbH. um Handelsinformationen von DAJAR GmbH an die angegebene E-Mail-Adresse zu erhalten. Der Betreiber der bei der Bestellung angegebenen personenbezogenen Daten ist DAJAR GmbH mit Hauptsitz in 10117 Berlin, c/o. Regus, Unter den Linden 21. Bitte beachten Sie, dass jeder unserer Kunden das Recht hat, auf die Verarbeitung seiner persönlichen Daten zuzugreifen, diese zu korrigieren, zu löschen, die Verarbeitung einzuschränken, der Verarbeitung seiner persönlichen Daten zu widersprechen und Daten zu übertragen. Bitte senden Sie das Anmeldeformular an die E-Mail-Adresse dpo@dajar.pl. Wir informieren Sie auch über die Möglichkeit, bei unbefugter Verwendung personenbezogener Daten eine Beschwerde bei der Aufsichtsbehörde einzureichen. Die vorstehende Einwilligung kann jederzeit auf der Grundlage von Artikel 23 Punkt 1 Unterpunkt 1 des Gesetzes vom 29. August 1997 über den Schutz personenbezogener Daten und Artikel 6 Punkt 1a der EU-Verordnung 2016/679 widerrufen werden.","Place order":"Zahlungspflichitig bestellen","See all":"Alle","Shop this story":"Empfohlene Produkte","Recommended categories":"Empfohlene Kategorien ","Related stories":"Stories ","I have coupon code":"Ich habe einen Rabattcode","Submit":"Senden ","price high to low":"Vom höchsten Preis","price low to high":"Vom niedrigsten  Preis","sortByNameDesc":"Nach der Bezeichnung  Z-A","sortByNameAsc":"Nach der Bezeichnung A-Z","recommended":"Empfohlen ","All orders":"Alle Bestellungen ","Address book":"Adressbuch","Log out":"Ausloggen ","Last order":"Letzte Bestellung","Personal info":"Persönliche Angaben ","My orders":"Meine Bestellungen","Account":"Konto ","Orders":"Bestellungen","Order":"Bestellung","Order number":"Bestellung Nummer","Ongoing":"In Bearbeitung","Past orders":"Letzte Bestellung ","Account password change description":"Klicken Sie auf die Schaltfläche rechts, um das Passwort zu ändern.","Edit":"Bearbeiten ","Change":"Ändern","Save":"Speichern","Old password":"Altes Passwort","New password":"Neues Passwort","Continue shopping":"Einkäufe fortsetzen ","bonus ePoints":"Punkte DAJAR ePrämie","Use":"Verwende","Sale":"Rabatt","Your order":"Deine Bestellung","Search":"Suche ","See all suggestions ({{resultsLength}})":"Alle Ergebnisse anzeigen ({{resultsLength}})","Cancel":"Stornieren","Sort":"Sortieren","all filters":"alle Filter","Clear":"Entfernen","Filter":"Filtern","select":"Auswählen ","selected":"markiert","Show result":"Zeige Ergebnisse","People also liked":"Zeige auch ","Popular searches":"Populäre Suchanfragen","Read more":"Lese weiter","capacity":"Kapazität","diameter":"Durchmesser","material":"Stoff","size":"Größe","length":"Länge","color":"Farbe","depth":"Tiefe","width":"Breite","height":"Höhe","shape":"Form ","Search collections, products, etc...":"Suche nach Produkten, Kollektionen, usw…","Shop by Collection":"Empfohlene Kollektinen","Shop by Type":"Produktkategorien","show all":"zeige alles","show more":"zeige mehr","show less":"zeige weniger","languages":"Sprachen ","Please login, your session expired.":"Melden Sie sich erneut an, Ihre Sitzung ist abgelaufen.","pending":"wird bearbeitet ","canceled":"Storniert","sending":"Zum Versand vorbereitet","processing":"wird verarbeitet","complete":"Versandt","Delivered":"Geliefert ","Tracking number":"Senungsnummer","ready":"Fertig","Track and trace":"Senungsverfolgung ","Copy":"Kopieren ","Out for delivery":"Auf dem Weg an den Empfänger","Expect your package today":"Die Zustellung des Paketes ist für heute geplant","Courier":"Lieferant ","Change password":"Ändere das Passwort","Default seo description":"Willkommen bei DAJAR.de. Wir bieten Gartenmöbel, Kissen und Hollywoodschaukeln an. In unserem Shop finden Sie auch Geschirr, Besteck, Töpfe, Pfannen, Tafelservices und Gläser.","Default seo description - register":"Willkommen bei DAJAR.de. Wir bieten Gartenmöbel, Kissen und Hollywoodschaukeln an. In unserem Shop finden Sie auch Geschirr, Besteck, Töpfe, Pfannen, Tafelservices und Gläser.","Default seo title":"DAJAR.de - Gartenmöbel und Geschirr","Default seo title - register":"DAJAR.de - Gartenmöbel und Geschirr","search results":"Suchergebnisse für \\"{{phrase}}\\"","page":"Seite","rachunku":"Produkte aus der Kategorie {{categoryName}} in dem DAJAR.de Online-Shop . Kaufen Sie bei uns ein!","Accept terms":"Es gelten unsere","Terms":"AGB","Shipment":"Versand","Cookie notice":"Willkommen in unserem DAJAR.de Shop.\\nWir verwenden Cookies (Cookies Files), um den Verkehr auf der DAJAR.de - Website zu analysieren, den Inhalt der Website zu personalisieren, angepasste Anzeigen anzuzeigen und den Komfort der Nutzung unserer Website zu erhöhen. Durch Klicken auf \\"\\"Akzeptieren\\"\\" teilen Sie uns mit, dass Sie mit der Platzierung von Cookies (Cookies Files) in Ihrem Browser und in angemessenen Fällen mit der Verarbeitung zugehöriger Daten für diese Zwecke einverstanden sind. Sie können Ihre Einwilligung jederzeit über die Einstellungen in Ihrem Browser verwalten und widerrufen. Weitere Informationen finden Sie in unserer <a href=\\"/info/privacy\\">Cookie-Richtlinie</a>.","Accept":"Ich akzeptiere","Default billing":"Standard-Rechnungsadresse","Default billing address":"Standard-Rechnungsadresse","Default shipping":"Standard-Lieferadresse","Default shipping address":"Standard-Lieferadresse","Is default shipping address?":"Ist Standard-Lieferadresse?","Is default billing address?":"Ist die Standard-Rechnungsadresse?","Add new address":"Neue Adresse hinzufügen","Not set":"Nicht eingestellt","Default billing and shipping":"Standard Rechnungs- und Lieferadresse","Product was added to cart":"Das Produkt wurde zum Einkaufswagen hinzugefügt","number of people":"Personenanzahl","Wrong street format":"Straßenname und Hausnummer erforderlich","New address":"Neue Adresse","Edit address":"Adresse bearbeiten","Error":"Fehler","Something went wrong":"Etwas ist schief gelaufen.","Fill in the delivery details":"Geben Sie die Versanddetails ein.","We don\'t ship to this country, sorry":"Wir werden nicht in dieses Land versenden, Entschuldigung.","This method is not available":"Diese Methode ist für die ausgewählten Daten nicht verfügbar.","Incorrect phone number":"Ungültige Telefonnummer","Incorrect VAT ID":"Falsche Umsatzsteuer-Identifikationsnummer","Shipping same as billing":"Die Lieferadresse ist dieselbe wie auf der Rechnung.","As Company":"Als Unternehmen","Name or Company":"Name oder Unternehmen","Billing for":"Abrechnung für","Choose pickup point":"Wählen Sie den Abholpunkt","Deliver to company":"Lieferung an das Unternehmen","Company address":"Firmenanschrift","Search results | Dajar":"Suchergebnisse | DAJAR.de","Address saved":"Gespeicherte Adresse","ePoints":"DAJAR ePrämie","Available ePoints":"verfügbare DAJAR ePrämie Punkte ","You can use these points with your next purchase":"Sie können DAJAR ePrämie-Punkte für Ihre nächsten Einkäufe verwenden","Learn more":"Finde mehr heraus","ePoints earned":"DAJAR ePrämie-Punkte wurden erhalten","paid with ePoints":"Bezahlt mit DAJAR ePrämie Punkten","Settlement of ePoints":"Abrechnung von DAJAR ePrämie-Punkten","Added by administrator":"Vom Administrator hinzugefügt","Purchase invoice":"Kaufrechnung","Purchase canceled":"Kauf storniert","Spent with order":"Wird bei der Bestellung ausgestellt","Spent with order canceled":"Die Verwendung auf Bestellung wurde storniert","Order cancelation":"Auftragsstornierung","Max addresses reached":"Maximale Anzahl gespeicherter Adressen. Die Adresse wurde nicht hinzugefügt","Brexit":"","Pay less with ePoints":"Zahlen Sie weniger mit DAJAR ePrämie","Delete ePoints":"Löschen Sie DAJAR ePrämie-Punkte","ePoints (you have {{points}})":"ePrämie (Sie haben {{Punkte}})","price":"Preis","Active":"Aktiv","Accept all cookies":"Akzeptiere","Confirm my settings":"Akzeptiere das Ausgewählte","Manage cookie settings":"Lass mich aussuchen ","Third party cookies":"Liste der Cookies ","Back to cookie list":"Liste der Cookies ","Show cookie list":"Cookies anzeigen","Cookie name":"Name","Duration":"Dauer","Type":"Art","Required cookies description":"Cookies die wir für das reibungslose Funktionieren unseres Shops DAJAR.DE benötigen.","Analytic cookies description":"Dazu gehören Cookies mit denen wir den Bewegung auf unserer Website DAJAR.DE analysieren können. Es gibt uns zusätzliches Informationen, um unsere Website für Sie zu verbessern.","Tracking cookies description":"Cookies die es uns ermöglichen, die Effektivität unserer Werbung anzupassen. Mit ihrer Hilfe präsentieren wir Ihnen die Informationen, die am besten zu Ihnen passen.","Necessary cookies":"Notwendige Cookies","Analytic cookies":"Analytische Cookies","Tracking cookies":"Cookies zur Verhaltensverfolgung","Third party":"Drittanbieter","day":"Tag","days":"Tage","years":"Jahre","minute":"Minute","minutes":"Minuten","month":"Monat","months2":"Monate","months":"Monate","year":"Jahr","session":"Sitzung","hour":"Stunde","Own":"Own","Too many points provided":"Es wurden zu viele Punkte angegeben","Last name must be different then first name":"Der Vorname muss sich vom Nachnamen unterscheiden","Additonal fee":"Aufpreis","price catalog high to low":"Katalogpreis: vom höchsten","price catalog low to high":"Katalogpreis: vom niedrigsten ","Additional information":"Zusätzliche Information","Length [cm]":"Länge [cm]","Width [cm]":"Breite [cm]","Shape":"Form","Producer":"Marke","Height [cm]":"Höhe [cm]","Depth [cm]":"Tiefe [cm]","Capacity [ml]":"Fassungsvermögen [ml]","Number of people":"Personenanzahl","Dajar collection":"Kollektion","Material":"Material","Application":"Anwendung","Diameter [cm]":"Durchmesser [cm]","Color list":"Farbe","Pattern list":"Muster","Feature":"Aufgabe","Composition":"Zusammensetzung","Max load":"Maximale Belastung [kg]","Capacity [l]":"Fassungsvermögen [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Gewicht [kg]","Help":"Fragen & Antworten","The product is no longer available":"Das Produkt ist nicht mehr verfügbar","Remove it from the cart or reduce the quantity ":"Bitte entfernen Sie es aus dem Warenkorb oder reduzieren Sie die Menge","The product will be available":"Das Produkt wird verfügbar sein","product available in different variant":"Produkt in einer anderen Variante erhältlich","Possible service failure. Please wait a moment and try again":"Möglicher Servicefehler. Warten Sie eine Weile und jetzt wieder","Page not found":"Seite nicht gefunden","Go to home page":"Gehe zur Startseite","Check recently viewed":"Kürzlich angesehen überprüfen","Do not hesitate":"Verzögern Sie niemals Ihren Kauf, denn das Hinzufügen von Artikeln in den Warenkorb bedeutet niemals eine Reservierung.","Save new address":"Speichern","Other address":"Other address","Subscribe to the newsletter":"Newsletter Anmeldung","And get even 20% off":"Erhalten Sie bis zu 5% Rabatt ","Subscribe":"ANMELDEN","Subscribe to our newsletter":"Newsletter Anmeldung","And get even 10% off":"Erhalten Sie bis zu 5% Rabatt auf jeden Einkaufswert.","Cart":"Warenkorb","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"inkl. MwSt., <a href=\\"/info/delivery\\">zzgl. Versand</a>","You don\'t have any orders":"Keine Bestellungen","Are you sure you want to remove this address?":"Möchten Sie die Adresse wirklich löschen?","Password saved":"Passwort gespeichert","Firstname and Lastname saved":"Vor- und Nachname gespeichert","Address deleted":"Adresse gelöscht","Yes":"Ja","No":"Nein","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Ihre Zahlung wird verarbeitet. Wir senden Ihnen eine E-Mail mit dem Status Ihrer Bestellung.","Thank you for your purchase":"Vielen Dank für Ihren Auftrag!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Niedrigster Preis der letzten 30 Tage","Promo code was added to clipboard":"Der Gutschein wurde kopiert","Clear filters - Pro":"","Delivery time":"Lieferzeit: 5-7 Werktage","Total with tax":"Gesamtpreis inkl. Mwst.","Resign from newsletter":"Sie können den Newsletter jederzeit kostenlos abbestellen","I agree to forward my email to the courier":"Ich stimme zu, meine E-Mail an den Lieferanten weiterzuleiten","Choose locker":"","Change locker":"","with VAT":"inkl. MwSt.","Unsubscribe info":"Sie können den Newsletter jederzeit kostenlos abbestellen","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"Als Abholpunkt festlegen","Choose parcel pickup point":"Abholpunkt auswählen","Get parcels addresses":"Abholpunktadressen herunterladen","Enter address to get nearest parcels":"Geben Sie eine Adresse ein, um die nächstgelegenen Abholpunkte abzurufen","Incorrect postal code":"Ungültige Postleitzahl","Parcel not found":"Abholstelle nicht gefunden","Change form values":"Daten im Formular ändern","Added to wishlist":"Produkt zur Wunschliste hinzugefügt","Removed from wishlist":"Artikel aus der Wunschliste entfernt","Product on wishlist":"Dieses Produkt befindet sich auf der Wunschliste","Wishlist inactive tooltip":"Melden Sie sich an, um dieses Produkt zu Ihrer Wunschliste hinzuzufügen","Wishlist":"Wunschliste","Add visible to cart":"In den Warenkorb legen","Wishlist products added to cart":"Verfügbare Artikel aus der Wunschliste wurden Ihrem Warenkorb hinzugefügt","No products in the wishlist":"Keine Produkte auf der Wunschliste","Hit of the day":"Tagesangebot","Only {{qty}} left in stock":"Noch: {{qty}} verfügbar","Offer ends":"Angebot endet in:","hours hit":"Std.","minutes hit":"Min.","seconds hit":"Sek.","sold out":"Ausverkauft","left hits":"Noch","sold hits":"Verkauft","Offer start":"Neues Angebot beginnt in","Available qty for person in hit {{qty}}":"Max. {{qty}} Stück pro Person","Outlet":"Sale","Hit of the week":"Wochenangebot","Hit of the month":"Monatsangebot","Choose DHL parcel":"Wählen Sie den Abholpunkt","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Top Angebot!","Check out this great deal":"Prüfen Sie das Superangebot","A new unique offer every day":"Jeden Tag ein neues, eindrucksvolles Angebot","Change parcel":"","card":"Kartenzahlung","banktransfer":"Vorkasse","cashondelivery":"-","dialcom_przelewy":"Kartenzahlung","bluepayment":"Kartenzahlung","blik":"-","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"-","applepay_info":"Klicken, um die Bestellung zu bezahlen","googlepay_info":"Klicken, um die Bestellung zu bezahlen","paypal_info":"PayPal ausgewählt. Nach dem Klicken auf \\"Zahlungspflichtig bestellen\\" wirst du zur Seite für sichere Zahlungsschritte weitergeleitet.","bluepayment_info":"Autopay ausgewählt. Nach dem Klicken auf \\"Zahlungspflichtig bestellen\\" wirst du zur Seite für sichere Zahlungsschritte weitergeleitet.","klarna_info":"Klarna-Zahlung ausgewählt.<br />Nach dem Klicken erfolgt eine Weiterleitung zur Seite, die das sichere Ausführen der nächsten Schritte ermöglicht.","banktransfer_info":"Überweisung ausgewählt. Nach dem Klicken auf \\"Zahlungspflichtig bestellen\\" erhältst du eine E-Mail mit den Überweisungsdaten.","cashondelivery_info":"-","The payment is REFUSED.":"Die Zahlung ist fehlgeschlagen.","Payment refused. Choose payment method and retry":"Wähle eine Zahlungsmethode und versuche es erneut.","Finish payment":"Beende die Zahlung.","klarna_paynow_button_label":"Jetzt mit Klarna bezahlen","klarna_paylater_button_label":"Bezahle in 30 Tagen mit Klarna","klarna_account_button_label":"Bezahle in Raten mit Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Ihre Zahlung wurde abgelehnt oder es befindet sich ein Produkt im Warenkorb, das ausverkauft ist.","adyen_error_message":"Ihre Zahlung wurde abgelehnt.","Cannot set delivery method":"Liefermethode kann nicht festgelegt werden","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Dieses Produkt kann sicher und gemäß den Vorgaben des Herstellers nur auf der Grundlage der Gebrauchsanweisungen, Pflegehinweise, Empfehlungen, Warnungen oder Sicherheitsinformationen verwendet werden, die auf dem Produkt, seiner Verpackung oder den dem Produkt beigefügten Unterlagen angegeben sind.","safety_title":""}');

/***/ }),

/***/ 71532:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Código de descuento","Delete coupon code":"Eliminar el código","AllProducts{{brandName}}":"Todos los productos {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Curado por {{authorName}} de {{authorProfileNick}}","Shop items below":"Ver los productos a continuación","Curated by":"Curado por","by":"por","from":"de","from range":"de","to range":"hasta","More":"Más","more":"más","starting at":"a partir de","or":"o","Login":"Iniciar sesión","My account":"Mi cuenta","Free delivery":"Entrega gratis","to free standard shipping":"para la entrega gratuita","Shipping":"Entrega","Shipping method":"Método de envío","Shipping address":"Dirección de envío","Invoice data":"Datos de facturación","Billing same as shipping":"Mismos datos de facturación que la entrega","Subtotal":"Subtotal de la cesta","Discounts":"Descuentos","Tax":"IVA","Tax and Shipping are estimated for ":"Los impuestos y los gastos de envío se estiman para","Tax included":"Impuestos incluidos","Total":"Importe total","Go to checkout":"Ir a la caja","Your cart":"Tu cesta","Collections":"Colecciones","View details":"Mostrar detalles","Add to cart":"a la cesta","add to cart":"Añadir a la cesta","More inspirations":"Más inspiraciones","Recently viewed":"Visto recientemente","Register":"Registrarse","Sign Up":"Registrarse","Sign Off":"Desinscribirse","Log in":"Iniciar sesión","Log yourself":"Inicia sesión","of":"de","Technical data":"Datos técnicos","Product description":"Descripción del producto","Color":"Color","Size":"Medidas","Story with":"Artículo curado por","Inspirations":"Inspiraciones","Home":"Pagina principal","Arrivals by category":"Novedades por categoria ","Already have an account?":"¿Ya tienes una cuenta?","Rodo_agreement {{domain}}":"Doy mi consentimiento para el procesamiento de mis datos personales por DAJAR sp. z o.o. (SARL) para fines relacionados con compras realizadas en la tienda en línea {{domain}}. El administrador de los datos personales facilitados al realizar pedidos es DAJAR sp. z o.o. con domicilio social en calle Połtawska no 6, a Koszalin 75-072, en Polonia.\\nNos gustaría informarle de que cada Cliente tiene el derecho a acceder, rectificar, suprimir, limitar el tratamiento, oponerse al tratamiento de sus datos personales y transferir sus datos. Dirija cualquier consulta o solicitud al respecto a la siguiente dirección de correo electrónico: dpo@dajar.pl. También le informamos de la posibilidad de presentar una reclamación ante el órgano de control competente en caso de uso no autorizado de sus datos personales. Este consentimiento puede retirarse en cualquier momento sobre la base del artículo 23 punto 1.1 de la ley de 29 de agosto de 1997 sobre protección de los datos personales y el artículo 6 punto 1a del reglamento UE 2016/679.\\n","Password":"Contraseña","First Name":"Nombre","Last Name":"Apellido","First, last name":"Nombre, apellido","Street":"Calle","City":"Ciudad","Country":"País","Phone":"número de teléfono","Postal code":"código postal","Company name":"Nombre de la empresa","Vat ID":"Número de IVA","Company":"Empresa","Registration complete":"Tu cuenta ha sido creada y se ha iniciado sesión","Required field":"Campo obligatorio","Required option":"Opción requerida","Terms agreement":"Si deseas registrarte, tienes que aceptar los términos de uso del sitio web","Invalid email":"Email inválido","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.es","Forgot password?":"¿Se te olvidó tu contraseña?","Don\'t have an account?":"¿No tienes una cuenta?","All New in":"Todas las Novedades en","New arrivals":"Novedades","New arrival":"Novedades","Password match":"La contraseña debe ser la misma","No products in cart":"No hay productos en el cesta","Thank you, your order has been placed!":"¡Acabas de hacer el pedido ¡Gracias!","Completed order info":"El pedido se está procesando, se le informará del envío por correo electrónico.","Back to home page":"Volver a la página inicial","come back to main categories":"Menú principal","Needs help?":"¿Necesitas ayuda?","Show cart summary":"Resumen de la cesta","Sign up for newsletter":"Suscríbete al boletín","Subscribe to newsletter":"Suscríbete","Sign off from newsletter":"Dejar de recibir el boletín","Sign up for newsletter seo title":"Suscríbete al boletín","Sign up for newsletter seo description":"Suscríbete al boletín para estar informado de nuestras novedades y promociones.","Sign off for newsletter seo title":"Dejar de recibir el boletín","Sign off for newsletter seo description":"Puedes darte de baja de nuestro boletín en cualquier momento","Sign up for newsletter success":"Revise su correo electrónico y confirme el registro.","Unsubscribe success":"Cancelación exitosa de la suscripción al boletín","Our bestsellers":"Nuestros bestsellers","Shop the deals":"Gangas","Popular categories":"Categorías populares","Out of stock":"Fuera de stock","Last items in stock":"Últimos artículos en stock","Also from this collection":"Otros productos de esta colección","Complete the look":"Completa con","Shop all{collectionName}}":"Ver la colección completa {{collectionName}}","Catalog price":"Precio de lista","Quantity":"Cantidad","Details":"Detalles","Saved addresses":"Direcciones guardadas","Contact":"Contacto","Continue to payment":"Proceder al pago","Go back to cart":"Volver al cesta","Go back to information":"Volver a la información","Create account":"Crear una cuenta","Payment method":"Método de pago","Payment":"Pago","Waiting for payment":"Pendiente de pago","Payment complete":"Pago realizado","cash on delivery":"","bank transfer":"transferencia bancaria","Newsletter description":"Manténte actualizado. Recibe información sobre los nuevos productos y las promociones.","Reset password":"Restablecer la contraseña","Reset password description":"Ingresa tu dirección de correo electrónico para recibir instrucciones sobre cómo restablecer su contraseña.","Reset":"Restablecer","Back to login":"Atrás para iniciar sesión","Newsletter agreement":"Doy mi consentimiento para el tratamiento de mis datos personales por parte de DAJAR sp.z o.o. para enviar información comercial de DAJAR sp.z o.o. a la dirección de correo electrónico facilitada. El administrador de los datos personales facilitados al realizar pedidos es DAJAR sp. z o.o. con domicilio social en calle Połtawska no 6, a Koszalin 75-072, en Polonia.\\nNos gustaría informarle de que cada Cliente tiene el derecho a acceder, rectificar, suprimir, limitar el tratamiento, oponerse al tratamiento de sus datos personales y transferir sus datos. Dirija cualquier consulta o solicitud al respecto a la siguiente dirección de correo electrónico: dpo@dajar.pl. También le informamos de la posibilidad de presentar una reclamación ante el órgano de control competente en caso de uso no autorizado de sus datos personales. Este consentimiento puede retirarse en cualquier momento sobre la base del artículo 23 punto 1.1 de la ley de 29 de agosto de 1997 sobre protección de los datos personales y el artículo 6 punto 1a del reglamento UE 2016/679.\\n","Place order":"Pedir","See all":"Ver todo","Shop this story":"Productos imperdibles","Recommended categories":"Categorías imperdibles","Related stories":"Historias relacionadas","I have coupon code":"Tengo un código de descuento","Submit":"Enviar","price high to low":"Precio: descendente","price low to high":"Precio: ascendente","sortByNameDesc":"por nombre Z-A","sortByNameAsc":"por nombre A-Z","recommended":"A no ser omitido","All orders":"Todos los pedidos","Address book":"Libreta de direcciones","Log out":"Cerrar sesión","Last order":"Último pedido","Personal info":"Información personal","My orders":"Mis pedidos","Account":"Cuenta","Orders":"Pedios","Order":"Pedido","Order number":"Pedido no","Ongoing":"En curso","Past orders":"Pedidos anteriores","Account password change description":"Haga clic en el botón de la derecha para cambiar la contraseña","Edit":"Modificar","Change":"Cambiar","Save":"Salvar","Old password":"Contraseña anterior","New password":"Nueva contraseña","Continue shopping":"Seguir comprando","bonus ePoints":"puntos Dajar ePrima","Use":"Usar","Sale":"Descuento","Your order":"Tu pedido","Search":"Buscar","See all suggestions ({{resultsLength}})":"Mostrar todos los resultados ({{resultsLength}})","Cancel":"Cancelar","Sort":"Ordenar","all filters":"todos los filtros","Clear":"Borrar","Filter":"Filtrar","select":"Seleccionar","selected":"seleccionado","Show result":"Mostrar los resultados","People also liked":"Ver también","Popular searches":"Búsquedas populares","Read more":"Leer más","capacity":"capacidad","diameter":"diámetro","material":"material","size":"medidas","length":"longitud","color":"color","depth":"profundidad","width":"ancho","height":"altura","shape":"forma","Search collections, products, etc...":"Buscar productos, colecciones, etc ...","Shop by Collection":"Colecciones destacadas","Shop by Type":"Categorías de productos","show all":"mostrar todo","show more":"mostrar más","show less":"mostrar menos","languages":"Idiomas","Please login, your session expired.":"Vuelve a iniciar sesión, tu sesión ha expirado.","pending":"recibido - pendiente","canceled":"cancelado","sending":"listo para enviar","processing":"en proceso","complete":"enviado","Delivered":"entregado","Tracking number":"Número de rastreo","ready":"listo","Track and trace":"Rastrear el envío","Copy":"Copiar","Out for delivery":"En ruta de entrega","Expect your package today":"En entrega hoy","Courier":"Mensajero","Change password":"Cambia la contraseña","Default seo description":"Bienvenido/a a DAJAR.es. Nuestra oferta incluye muebles, balancines y cojines de jardín. En nuestra tienda también encontrarás: vajilla, cubertería, vasos, ollas, sartenes y muchos otros utensilios y accesorios de cocina.","Default seo description - register":"Bienvenido/a a DAJAR.es. Nuestra oferta incluye muebles, balancines y cojines de jardín. En nuestra tienda también encontrarás: vajilla, cubertería, vasos, ollas, sartenes y muchos otros utensilios y accesorios de cocina.","Default seo title":"DAJAR.es - Vajillas, cocina y muebles de jardín","Default seo title - register":"DAJAR.es - Vajillas, cocina y muebles de jardín","search results":"Resultados de búsqueda para \\"{{phrase}}\\"","page":"Página","rachunku":"Productos de la categoría {{categoryName}} en la tienda DAJAR.es. ¡Buenas compras!","Accept terms":"He leído y acepto las","Terms":"Condiciones generales de venta","Shipment":"Entrega","Cookie notice":"Bienvenido/a en la tienda DAJAR.es.\\nUtilizamos cookies para analizar el tráfico en el sitio web DAJAR.es, personalizar el contenido del sitio, mostrar anuncios personalizados y aumentar la conveniencia de usar nuestra tienda. Al hacer clic en \\"\\"aceptar\\"\\", nos informas que aceptas la instalación de cookies en tu navegador y, en su caso, el tratamiento de los datos asociados para estos fines. Puedes administrar tu consentimiento y reti-rarlo en cualquier momento utilizando la configuración de tu navegador. Para obtener más informa-ción, consulta nuestra política de cookies.","Accept":"Acepto","Default billing":"Dirección de facturación predeterminada","Default billing address":"Dirección de facturación predeterminada","Default shipping":"Dirección de entrega predeterminada","Default shipping address":"Dirección de entrega predeterminada","Is default shipping address?":"¿Es esta la dirección de entrega predeterminada?","Is default billing address?":"¿Es esta la dirección de facturación predeterminada?","Add new address":"Añadir una nueva dirección","Not set":"Aún no predeterminado","Default billing and shipping":"Dirección de facturación y de entrega predeterminada","Product was added to cart":"El producto ha sido añadido al cesta","number of people":"número de personas","Wrong street format":"Ingrese el nombre de la calle y el número de la casa","New address":"Nueva dirección","Edit address":"Editar la dirección","Error":"Error","Something went wrong":"Algo salió mal","Fill in the delivery details":"Ingresa los datos de la entrega","We don\'t ship to this country, sorry":"Lo sentimos, pero no enviamos a este país.","This method is not available":"Este método no está disponible","Incorrect phone number":"Número de teléfono incorrecto","Incorrect VAT ID":"Número de IVA incorrecto","Shipping same as billing":"La dirección de entrega es la misma que la dirección de facturación.","As Company":"Hago el pedido como empresa","Name or Company":"Nombre de la empresa","Billing for":"Facturado a ","Choose pickup point":"","Deliver to company":"","Company address":"Dirección de la empresa","Search results | Dajar":"Resultados de la búsqueda | DAJAR.es","Address saved":"Dirección guardada","ePoints":"DAJAR ePrima","Available ePoints":"Puntos DAJAR ePrima disponibles","You can use these points with your next purchase":"Puedes utilizar los puntos DAJAR ePrima para tus próximas compras","Learn more":"Más información","ePoints earned":"Puntos DAJAR ePrima ganados","paid with ePoints":"Pagado con puntos DAJAR ePrima","Settlement of ePoints":"Saldo de puntos DAJAR ePrima","Added by administrator":"Agregado por el administrador","Purchase invoice":"Factura de compra","Purchase canceled":"Compra cancelada","Spent with order":"Gastado por el pedido","Spent with order canceled":"Gastado por el pedido cancelado","Order cancelation":"Cancelación del pedido","Max addresses reached":"Número máximo de direcciones registradas. La dirección no ha sido agregada.","Brexit":"","Pay less with ePoints":"Paga menos con los puntos DAJAR ePrima","Delete ePoints":"Eliminar los puntos DAJAR ePrima","ePoints (you have {{points}})":"ePrima (tienes {{puntos}})","price":"Precio","Active":"Activas","Accept all cookies":"Aceptar todas las cookies","Confirm my settings":"Aceptar las cookies elegidas","Manage cookie settings":"Dejame elegir ...","Third party cookies":"Lista de las cookies","Back to cookie list":"Lista de las cookies","Show cookie list":"Mostrar las cookies","Cookie name":"Nombre ","Duration":"Duración","Type":"Tipo","Required cookies description":"Cookies que necesitamos para el correcto funcionamiento de nuestra tienda DAJAR.es","Analytic cookies description":"Incluyen cookies que nos ayudan a analizar y controlar el tráfico en nuestro sitio web DAJAR.es. Nos brinda conocimientos adicionales para mejorar nuestro sitio web para ti.","Tracking cookies description":"Cookies que nos permiten personalizar y medir la efectividad de nuestra publicidad. Con su ayuda, te presentamos la información que es más relevante para ti.","Necessary cookies":"Cookies esenciales","Analytic cookies":"Cookies analíticas","Tracking cookies":"Cookies de seguimiento","Third party":"Tercero","day":"día","days":"días","years":"años","minute":"minuto","minutes":"minutos","month":"mes","months2":"meses","months":"meses","year":"año","session":"sesión","hour":"hora","Own":"Own","Too many points provided":"Demasiados puntos ingresados","Last name must be different then first name":"El apellido debe ser diferente al nombre","Additonal fee":"Cargos adicionales","price catalog high to low":"Precio de lista: descendente","price catalog low to high":"Precio de lista: ascendente","Additional information":"Información adicional","Length [cm]":"Longitud [cm]","Width [cm]":"Anchura [cm]","Shape":"Forma","Producer":"Fabricante","Height [cm]":"Altura [cm]","Depth [cm]":"Profundidad [cm]","Capacity [ml]":"Capacidad [ml]","Number of people":"Número de personas","Dajar collection":"Colección","Material":"Material","Application":"Utilización","Diameter [cm]":"Diámetro [cm]","Color list":"Color","Pattern list":"Patrón","Feature":"Función","Composition":"Composición","Max load":"Carga máxima [kg]","Capacity [l]":"Capacidad [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Peso [kg]","Help":"Ayuda","The product is no longer available":"El producto ya no está disponible","Remove it from the cart or reduce the quantity ":"Por favor, quítelo del cesta","The product will be available":"El producto estará disponible","product available in different variant":"producto disponible en una variante diferente","Possible service failure. Please wait a moment and try again":"Posible falla del servicio. Espere un momento y vuelva a intentarlo.","Page not found":"Página no encontrada.","Go to home page":"Ir a la pagina principal.","Check recently viewed":"Verifique lo visto recientemente.","Do not hesitate":"No se demore en realizar el pedido, añadir artículos a la cesta no supone su reserva.","Save new address":"Salvar","Other address":"Other address","Subscribe to the newsletter":"Suscríbete al boletín","And get even 20% off":"Disfruta de un 5% de descuento","Subscribe":"Suscríbete","Subscribe to our newsletter":"Suscríbase a nuestro boletín de noticias","And get even 10% off":"Disfruta de un 5% de descuento","Cart":"Cesta","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"No hay pedidos","Are you sure you want to remove this address?":"¿Seguro que quieres eliminar la dirección?","Password saved":"Contraseña guardada","Firstname and Lastname saved":"Nombre y apellido guardados","Address deleted":"Dirección eliminada","Yes":"Sí","No":"No","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Su pago está siendo procesado. Te enviaremos un email con el estado de tu pedido.","Thank you for your purchase":"Gracias por su orden!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Precio de referencia","Promo code was added to clipboard":"Se ha copiado el código promocional","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"El producto ha sido añadido a la lista de deseos","Removed from wishlist":"El producto ha sido eliminado de la lista de deseos","Product on wishlist":"El producto ya está en la lista de deseos","Wishlist inactive tooltip":"Inicie sesión para añadir el producto a la lista de deseos","Wishlist":"Lista de deseos","Add visible to cart":"Añadir los productos visibles al carrito","Wishlist products added to cart":"Los artículos de la lista de deseos disponibles se han añadido al carrito","No products in the wishlist":"No hay productos en la lista de deseos","Hit of the day":"Hit del día","Only {{qty}} left in stock":"Quedan {{qty}} piezas","Offer ends":"La oferta vence en:","hours hit":"h","minutes hit":"min","seconds hit":"s","sold out":"stock agotado","left hits":"quedan","sold hits":"vendidos","Offer start":"La nueva oferta comienza en","Available qty for person in hit {{qty}}":"Puedes comprar {{qty}} piezas/persona","Outlet":"Rebajas","Hit of the week":"Hit de la semana","Hit of the month":"Hit del mes","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"¡No te lo pierdas!","Check out this great deal":"¡Aprovecha la oportunidad!","A new unique offer every day":"Cada día un artículo diferente","Change parcel":"","card":"Pago con tarjeta","banktransfer":"Transferencia bancaria","cashondelivery":"-","dialcom_przelewy":"Transferencia rápida","bluepayment":"Transferencia rápida","blik":"Código Blik","googlepay":"GooglePay","applepay":"ApplePay","klarna":"Klarna","blik_info":"Ingresa el código BLIK desde tu aplicación bancaria.","applepay_info":"Haga clic para pagar el pedido.","googlepay_info":"Haga clic para pagar el pedido.","paypal_info":"PayPal seleccionado. Después de hacer clic en Pagar, serás redirigido a una página que te permitirá completar de forma segura los siguientes pasos.","bluepayment_info":"Autopay seleccionado. Después de hacer clic en Pagar, serás redirigido a una página que te permitirá completar de forma segura los siguientes pasos.","klarna_info":"Se ha elegido el pago con Klarna.<br />Al hacer clic, serás redirigido a una página que permite realizar los siguientes pasos de forma segura.","banktransfer_info":"Se ha seleccionado el pago mediante transferencia. Después de hacer clic en Pagar, recibirás un correo electrónico con los detalles de la cuenta para la transferencia.","cashondelivery_info":"-","The payment is REFUSED.":"El pago falló.","Payment refused. Choose payment method and retry":"Selecciona un método de pago y vuelve a intentarlo.","Finish payment":"Finaliza el pago.","klarna_paynow_button_label":"Paga ahora con Klarna","klarna_paylater_button_label":"Paga en 30 días con Klarna","klarna_account_button_label":"Paga a plazos con Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Su pago ha sido rechazado o hay un producto en su carrito que está agotado.","adyen_error_message":"Su pago ha sido rechazado.","Cannot set delivery method":"No se puede establecer el método de entrega","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Este producto puede usarse de forma segura y en la forma prevista por el fabricante únicamente de acuerdo con las instrucciones de uso y mantenimiento, recomendaciones, advertencias o información de seguridad que figuran en el producto o en su embalaje o que se proporcionan con el producto.","safety_title":""}');

/***/ }),

/***/ 8659:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Code de réduction","Delete coupon code":"Supprimer le code","AllProducts{{brandName}}":"Tous les produits {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Avec la participation de {{authorName}} de {{authorProfileNick}}","Shop items below":"Voir les produits ci-après","Curated by":"Avec la participation de","by":"par","from":"de","from range":"de","to range":"à","More":"Plus","more":"plus","starting at":"à partir de ","or":"ou","Login":"Connexion","My account":"Mon compte","Free delivery":"Livraison gratuite","to free standard shipping":"pour la livraison gratuite","Shipping":"Livraison","Shipping method":"Mode de livraison","Shipping address":"Adresse de livraison","Invoice data":"Données de facturation","Billing same as shipping":"Données de facturation identiques à celles de la livraison","Subtotal":"Sous-total du panier","Discounts":"Réductions","Tax":"T.V.A.","Tax and Shipping are estimated for ":"Les taxes et les frais d\'expédition sont estimés pour","Tax included":"Taxes incluses","Total":"Montant total","Go to checkout":"Aller à la caisse","Your cart":"Ton panier","Collections":"Collections","View details":"Voir les détails","Add to cart":"au panier","add to cart":"Ajouter au panier","More inspirations":"Plus d\'inspirations","Recently viewed":"Vu récemment","Register":"Enregistrement","Sign Up":"S\'enregistrer","Sign Off":"Se désinscrire","Log in":"Connexion","Log yourself":"Connectez-vous","of":"de","Technical data":"Données techniques","Product description":"Description du produit","Color":"Couleur","Size":"Taille","Story with":"Article avec la participation de","Inspirations":"Inspirations","Home":"Accueil","Arrivals by category":"Nouveautés par catégorie","Already have an account?":"Vous avez déjà un compte?","Rodo_agreement {{domain}}":"Je consens au traitement de mes données personnelles par DAJAR sp. z o.o. à des fins liés aux achats effectués sur la boutique en ligne {{domain}}. L\'administrateur des données personnelles fournies lors du passage des commandes est DAJAR sp. z o.o. dont le siège se trouve au 6 rue Połtawska, à Koszalin 75-072, en Pologne. \\nNous tenons à vous informer que chaque Client a le droit d\'accéder, de rectifier, de supprimer, de limiter le traitement, de s\'opposer au traitement de ses données personnelles et de transférer ses données. Veuillez adresser toute demande à ce sujet à l\'adresse e-mail suivante :dpo@dajar.pl. Nous vous informons également de la possibilité de déposer une plainte auprès de l\'organe de contrôle compétent en cas d\'utilisation non autorisée de vos données personnelles. Le présent consentement peut être retiré à tout moment sur la base de l\'article 23 point 1.1 de la loi du 29 août 1997 sur la protection des données personnelles et de l\'article 6 point 1a du règlement UE 2016/679.","Password":"Mot de passe","First Name":"Prénom","Last Name":"Nom","First, last name":"Prénom, nom","Street":"Rue","City":"Ville","Country":"Pays","Phone":"numéro de téléphone","Postal code":"Code postal","Company name":"Nom de société","Vat ID":"Numero de TVA","Company":"Société","Registration complete":"Votre compte a été créé et vous êtes connecté","Required field":"Champ obligatoire","Required option":"Option requise","Terms agreement":"Si vous souhaitez vous enregistrer, acceptez les conditions d\'utilisation du site Web","Invalid email":"Email invalide","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.fr","Forgot password?":"Mot de passe oublié?","Don\'t have an account?":"Vous n\'avez pas de compte?","All New in":"Toutes les Nouveautés dans","New arrivals":"Nouveautés","New arrival":"Nouveautés","Password match":"Le mot de passe doit être identique","No products in cart":"Pas de produits dans le panier","Thank you, your order has been placed!":"Vous venez de passer commande! Merci! ","Completed order info":"La commande est en cours de traitement, on vous informera de l\'envoi par e-mail.","Back to home page":"Retour à l\'accueil","come back to main categories":"Menu principal","Needs help?":"Besoin d\'aide?","Show cart summary":"Résumé du panier","Sign up for newsletter":"S\'inscrire à la newsletter","Subscribe to newsletter":"S\'inscrire","Sign off from newsletter":"Se désinscrire de la newsletter","Sign up for newsletter seo title":"Inscription à la newsletter","Sign up for newsletter seo description":"Inscrivez-vous à la newsletter pour être au courant de nos nouveautés et nos promotions.","Sign off for newsletter seo title":"Se désinscrire de la newsletter","Sign off for newsletter seo description":"Vous pouvez vous désinscrire de notre newsletter à tout moment","Sign up for newsletter success":"Vérifiez votre courrier électronique et confirmez l\'inscription. ","Unsubscribe success":"Desinscription de la newsletter réussie","Our bestsellers":"Nos meilleures ventes","Shop the deals":"Bonnes affaires","Popular categories":"Catégories populaires","Out of stock":"En rupture de stock","Last items in stock":"Derniers articles en stock","Also from this collection":"Autres produits de cette collection","Complete the look":"Complétez avec","Shop all{collectionName}}":"Afficher toute la collection {{collectionName}}","Catalog price":"Prix de liste","Quantity":"Quantité","Details":"Détails","Saved addresses":"Adresses enregistrées","Contact":"Contact","Continue to payment":"Passer au paiement","Go back to cart":"Revenir au panier","Go back to information":"Revenir aux informations","Create account":"Créer un compte","Payment method":"Mode de paiement","Payment":"Paiement","Waiting for payment":"En attente de paiement","Payment complete":"Paiement effectue","cash on delivery":"brak tej formy płatności na FR IT i ES","bank transfer":"virement bancaire","Newsletter description":"Soyez à jour. Recevez des informations sur les nouveaux produits et les promotions.","Reset password":"Réinitialiser le mot de passe","Reset password description":"Saisissez votre adresse e-mail pour recevoir des instructions sur la réinitialisation de votre mot de passe.","Reset":"Réinitialiser","Back to login":"Retour à la connexion","Newsletter agreement":"Je consens au traitement de mes données personnelles par DAJAR sp.z o.o. pour envoyer des informations commerciales de DAJAR sp.z o.o. à l\'adresse e-mail fournie. L\'administrateur des données personnelles fournies lors du passage des commandes est DAJAR sp.z o.o. dont le siège se trouve au 6 rue Połtawska, à Koszalin 75-072, en Pologne. Nous tenons à vous informer que chaque Client a le droit d\'accéder, de rectifier, de supprimer, de limiter le traitement, de s\'opposer au traitement de ses données personnelles et de transférer ses données. Veuillez adresser toute demande à ce sujet à l\'adresse e-mail suivante :dpo@dajar.pl. Nous vous informons également de la possibilité de déposer une plainte auprès de l\'organe de contrôle compétent en cas d\'utilisation non autorisée de vos données personnelles. Le présent consentement peut être retiré à tout moment sur la base de l\'article 23 point 1.1 de la loi du 29 août 1997 sur la protection des données personnelles et de l\'article 6 point 1a du règlement UE 2016/679.","Place order":"Commandes","See all":"Voir tout","Shop this story":"Produits à ne pas manquer","Recommended categories":"Catégories incontournables","Related stories":"Histoires liées","I have coupon code":"J\'ai un code promo","Submit":"Soumettre","price high to low":"Prix: descendant","price low to high":"Prix: ascendant","sortByNameDesc":"par nom Z-A","sortByNameAsc":"par nom A-Z","recommended":"À ne pas manquer","All orders":"Toutes les commandes","Address book":"Carnet d\'adresses","Log out":"Se déconnecter","Last order":"Dernière commande","Personal info":"Informations personnelles","My orders":"Mes commandes","Account":"Compte","Orders":"Commandes","Order":"Commande","Order number":"Commande no","Ongoing":"En cours","Past orders":"Commandes précédentes","Account password change description":"Cliquez sur le bouton à droite pour changer le mot de passe","Edit":"Éditer","Change":"Changer","Save":"Sauvegarder","Old password":"Ancien mot de passe","New password":"Nouveau mot de passe","Continue shopping":"Continuer ses achats","bonus ePoints":"points Dajar ePrime","Use":"Utiliser","Sale":"Réduction","Your order":"Votre commande","Search":"Rechercher","See all suggestions ({{resultsLength}})":"Afficher tous les résultats ({{resultsLength}})","Cancel":"Annuler","Sort":"Trier","all filters":"tous les filtres","Clear":"Effacer","Filter":"Filtrer","select":"Sélectionner","selected":"sélectionné","Show result":"Afficher les résultats","People also liked":"Voir aussi","Popular searches":"Recherches fréquentes","Read more":"Lire la suite","capacity":"capacité","diameter":"diamètre","material":"matériau","size":"taille","length":"longueur","color":"couleur","depth":"profondeur","width":"largeur","height":"hauteur","shape":"forme","Search collections, products, etc...":"Chercher des produits, collections, etc ...","Shop by Collection":"Collections en vedette","Shop by Type":"Catégories de produits","show all":"afficher tout ","show more":"afficher plus","show less":"afficher moins","languages":"Langues","Please login, your session expired.":"Reconnectez-vous, votre session a expiré.","pending":"reçue - en attente","canceled":"annulée","sending":"prête à envoyer","processing":"en cours de traitement","complete":"envoyée","Delivered":"livrée","Tracking number":"Numéro de suivi","ready":"prête","Track and trace":"Suivi de l\'envoi","Copy":"Copier","Out for delivery":"En cours de livraison","Expect your package today":"En livraison aujourd\'hui","Courier":"Transporteur","Change password":"Changer le mot de passe","Default seo description":"Bienvenue sur DAJAR.fr. Notre offre comprend des meubles, des balancelles et des coussins de jardin. Sur notre boutique vous trouverez également : vaisselle, couverts, verres, casseroles, poêles et tant d’autres ustensiles et accessoires de cuisine.","Default seo description - register":"Bienvenue sur DAJAR.fr. Notre offre comprend des meubles, des balancelles et des coussins de jardin. Sur notre boutique vous trouverez également : vaisselle, couverts, verres, casseroles, poêles et tant d’autres ustensiles et accessoires de cuisine.","Default seo title":"DAJAR.fr - Meubles de jardin, cuisine et arts de la table","Default seo title - register":"DAJAR.fr - Meubles de jardin, cuisine et arts de la table","search results":"Résultats de recherche pour \\"{{phrase}}\\"","page":"Page","rachunku":"Produits de la catégorie {{categoryName}} sur la boutique DAJAR.fr. Bons achats!","Accept terms":"J’ai lu et j’accepte les","Terms":"Conditions générales de vente","Shipment":"Livarison","Cookie notice":"Bienvenue sur la boutique DAJAR.fr.\\nNous utilisons des cookies pour analyser le trafic sur le site Web DAJAR.fr, personnaliser le contenu du site, afficher des publicités personnalisées et augmenter le confort d\'utilisation de notre bou-tique. En cliquant sur «accepter», vous nous informez que vous consentez à l’installation de cookies dans votre navigateur et, le cas échéant, au traitement des données associées à ces fins. Vous pou-vez gérer votre consentement et le retirer à tout moment à l’aide les paramètres de votre naviga-teur. Pour plus d\'informations, veuillez consulter notre politique en matière de cookies.","Accept":"J\'accepte","Default billing":"Adresse de facturation par défaut","Default billing address":"Adresse de facturation par défaut","Default shipping":"Adresse de livraison par défaut","Default shipping address":"Adresse de livraison par défaut","Is default shipping address?":"Est-ce l\'adresse de livraison par défaut?","Is default billing address?":"Est-ce l\'adresse de facuration par défaut?","Add new address":"Ajouter une nouvelle adresse","Not set":"Pas encore défini","Default billing and shipping":"Adresse de facturation et de livraison par défaut","Product was added to cart":"Le produit a été ajouté au panier","number of people":"nombre de personnes","Wrong street format":"Veuillez saisir le nom et le numéro de la rue ","New address":"Nouvelle adresse","Edit address":"Modifier l\'adresse","Error":"Erreur","Something went wrong":"Un problème est survenu","Fill in the delivery details":"Saisissez les données de livraison","We don\'t ship to this country, sorry":"Désolés mais nous ne livrons pas dans ce pays","This method is not available":"Cette méthode n\'est pas disponible","Incorrect phone number":"Numéro de téléphone incorrect","Incorrect VAT ID":"Numéro de TVA incorrect","Shipping same as billing":"L\'adresse de livraison est la même que l\'adresse de facturation","As Company":"Je commande en tant qu\'entreprise","Name or Company":"Nom de l\'entreprise","Billing for":"Facturé à","Choose pickup point":"","Deliver to company":"","Company address":"Adresse de la société","Search results | Dajar":"Résultats de la recherche | DAJAR.fr","Address saved":"Adresse enregistrée","ePoints":"DAJAR ePrime","Available ePoints":"Points DAJAR ePrime disponibles","You can use these points with your next purchase":"Vous pouvez utiliser les points DAJAR ePrime pour vos prochains achats","Learn more":"En savoir plus","ePoints earned":"Points DAJAR ePrime gagnés","paid with ePoints":"Payé avec des points DAJAR ePrime","Settlement of ePoints":"Bilan de points DAJAR ePrime","Added by administrator":"Ajouté par l\'administrateur","Purchase invoice":"Facture d\'achat","Purchase canceled":"Achat annulé","Spent with order":"Dépensé pour la commande","Spent with order canceled":"Dépensé pour la commande annulée","Order cancelation":"Annulation de la commande","Max addresses reached":"Nombre maximum d\'adresses enregistrées. L\'adresse n\'a pas été ajoutée.","Brexit":"","Pay less with ePoints":"Payez moins avec les points DAJAR ePrime","Delete ePoints":"Supprimer les points DAJAR ePrime","ePoints (you have {{points}})":"ePrime (vous avez {{points}})","price":"Prix","Active":"Actifs","Accept all cookies":"Accepter tous les cookies","Confirm my settings":"Accepter les cookies selectionnés","Manage cookie settings":"Laissez-moi choisir","Third party cookies":"Liste des cookies","Back to cookie list":"Liste des cookies","Show cookie list":"Afficher les cookies","Cookie name":"Nom","Duration":"Durée","Type":"Type","Required cookies description":"Les cookies dont nous avons besoin pour le bon fonctionnement de notre boutique DAJAR.fr. ","Analytic cookies description":"Ils incluent des cookies qui nous aident à monitorer et analyser le trafic sur notre site Web DAJAR.fr. Cela nous donne des connaissances supplémentaires pour améliorer notre site Web pour vous.","Tracking cookies description":"Cookies qui nous permettent de personnaliser et de mesurer l\'efficacité de notre publicité. Avec leur aide, nous vous présentons les informations les plus pertinentes pour vous.","Necessary cookies":"Cookies essentiels ","Analytic cookies":"Cookies d\'analyse de performances","Tracking cookies":"Cookies de suivi","Third party":"Tierce personne","day":"jour","days":"jours","years":"ans","minute":"minute","minutes":"minutes","month":"mois","months2":"mois","months":"mois","year":"an","session":"session","hour":"heure","Own":"Own","Too many points provided":"Trop de points saisis","Last name must be different then first name":"Le nom doit être différent du prénom","Additonal fee":"Frais supplémentaires","price catalog high to low":"Prix de liste: descendant","price catalog low to high":"Prix de liste: ascendant","Additional information":"Informations complémentaires","Length [cm]":"Longueur [cm]","Width [cm]":"Largeur [cm]","Shape":"Forme","Producer":"Fabricant","Height [cm]":"Hauteur [cm]","Depth [cm]":"Profondeur [cm]","Capacity [ml]":"Capacité [ml]","Number of people":"Nombre de personnes","Dajar collection":"Collection","Material":"Matière","Application":"Utiliser","Diameter [cm]":"Diamètre [cm]","Color list":"Coloris","Pattern list":"Motif","Feature":"Fonction","Composition":"Composition","Max load":"Charge maximale [kg]","Capacity [l]":"Capacité [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Poids [kg]","Help":"Aide","The product is no longer available":"Le produit n\'est plus disponible","Remove it from the cart or reduce the quantity ":"Veuillez le retirer du panier ","The product will be available":"Le produit sera disponible","product available in different variant":"produit disponible dans une variante différente","Possible service failure. Please wait a moment and try again":"Panne de service possible. Patientez un instant et réessayez.","Page not found":"Page non trouvée.","Go to home page":"Aller à la page d\'accueil.","Check recently viewed":"Voir récemment consulté.","Do not hesitate":"Ne tardez pas à passer commande, l\'ajout d\'articles au panier ne signifie pas leur réservation.","Save new address":"Sauvegarder","Other address":"Other address","Subscribe to the newsletter":"Inscription à la newsletter","And get even 20% off":"Profitez d\'une remise de 5%","Subscribe":"S\'inscrire","Subscribe to our newsletter":"Abonnez-vous à notre newsletter","And get even 10% off":"Profitez d\'une remise de 5%","Cart":"Panier","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"Pas de commandes","Are you sure you want to remove this address?":"Sûr de vouloir supprimer l’adresse?","Password saved":"Mot de passe sauvegardée","Firstname and Lastname saved":"Prénom et nom sauvegardés","Address deleted":"Adresse supprimée","Yes":"Oui","No":"Non","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Votre paiement est en cours de traitement. Nous vous enverrons un e-mail avec le statut de votre commande.","Thank you for your purchase":"Nous vous remercions de votre commande!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Prix de référence","Promo code was added to clipboard":"Le code promo a été copié","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Le produit a été ajouté à la liste de souhaits","Removed from wishlist":"Le produit a été supprimé de la liste de souhaits","Product on wishlist":"Le produit est déjà dans la liste de souhaits","Wishlist inactive tooltip":"Connectez-vous pour ajouter le produit à la liste de souhaits","Wishlist":"Liste de souhaits","Add visible to cart":"Ajouter des produits visibles au panier","Wishlist products added to cart":"Les articles disponibles de la liste de souhaits ont été ajoutés à votre panier","No products in the wishlist":"Il n\'y a aucun produit dans la liste de souhaits","Hit of the day":"Hit du jour","Only {{qty}} left in stock":"Il en reste {{qty}} pièces","Offer ends":"L’offre expire dans:","hours hit":"h.","minutes hit":"min","seconds hit":"s.","sold out":"stock épuisé","left hits":"il en reste","sold hits":"vendu(s)","Offer start":"La nouvelle offre commence dans","Available qty for person in hit {{qty}}":"On peut en acheter {{qty}} pièces/personne","Outlet":"Soldes","Hit of the week":"Hit de la semaine","Hit of the month":"Hit du mois","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Ne le ratez pas!","Check out this great deal":"Saisissez l\'opportunité!","A new unique offer every day":"Chaque jour un article différent","Change parcel":"","card":"Paiement par carte","banktransfer":"Virement bancaire","cashondelivery":"-","dialcom_przelewy":"Virement instantané","bluepayment":"Virement instantané","blik":"Code BLIK","googlepay":"GooglePay","applepay":"ApplePay","klarna":"Klarna","blik_info":"Saisissez le code BLIK de votre application bancaire","applepay_info":"Cliquez pour régler la commande","googlepay_info":"Cliquez pour régler la commande","paypal_info":"PayPal sélectionné. Après avoir cliqué sur Payer, vous serez redirigé vers une page vous permettant de réaliser les étapes suivantes en toute sécurité.","bluepayment_info":"Autopay sélectionné. Après avoir cliqué sur Payer, vous serez redirigé vers une page vous permettant de réaliser les étapes suivantes en toute sécurité.","klarna_info":"Paiement Klarna sélectionné.<br />Après un clic, vous serez redirigé vers une page permettant d\'effectuer les prochaines étapes en toute sécurité.","banktransfer_info":"Le paiement par virement a été sélectionné. Après avoir cliqué sur Payer, vous recevrez un e-mail avec les détails du compte pour le virement.","cashondelivery_info":"-","The payment is REFUSED.":"Le paiement a échoué.","Payment refused. Choose payment method and retry":"Sélectionnez un mode de paiement et réessayez.","Finish payment":"Finalisez le paiement.","klarna_paynow_button_label":"Payez maintenant avec Klarna","klarna_paylater_button_label":"Payez dans 30 jours avec Klarna","klarna_account_button_label":"Payez en plusieurs fois avec Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Votre paiement a été refusé ou vous avez un produit en rupture de stock dans votre panier.","adyen_error_message":"Votre paiement a été refusé.","Cannot set delivery method":"Impossible de définir le mode de livraison","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Ce produit ne peut être utilisé en toute sécurité et de la manière prévue par le fabricant que conformément aux instructions d\'utilisation et d\'entretien, aux recommandations, aux avertissements ou aux informations de sécurité figurant sur le produit ou sur son emballage ou fournies avec le produit.","safety_title":""}');

/***/ }),

/***/ 47289:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Discount code","Delete coupon code":"Delete coupon code","AllProducts{{brandName}}":"AllProducts{{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Curated by {{authorName}} from {{authorProfileNick}}","Shop items below":"Shop items below","Curated by":"Curated by","by":"by","from":"from","from range":"from range","to range":"to range","More":"More","more":"more","starting at":"starting at","or":"or","Login":"Login","My account":"My account","Free delivery":"Free delivery","to free standard shipping":"to free standard shipping","Shipping":"Shipping","Shipping method":"Shipping method","Shipping address":"Shipping address","Invoice data":"Invoice data","Billing same as shipping":"Billing same as shipping","Subtotal":"Subtotal","Discounts":"Discounts","Tax":"Tax","Tax and Shipping are estimated for ":"Tax and Shipping are estimated for ","Tax included":"Tax included","Total":"Total","Go to checkout":"Go to checkout","Your cart":"Your basket","Collections":"Collections","View details":"View details","Add to cart":"Add to basket","add to cart":"add to basket","More inspirations":"More inspirations","Recently viewed":"Recently viewed","Register":"Register","Sign Up":"Sign Up","Sign Off":"Sign Off","Log in":"Log in","Log yourself":"Log yourself","of":"of","Technical data":"Technical data","Product description":"Product description","Color":"Color","Size":"Size","Story with":"Story with","Inspirations":"Inspirations","Home":"Home","Arrivals by category":"Arrivals by category","Already have an account?":"Already have an account?","Rodo_agreement {{domain}}":"I hereby give consent for the processing of my personal data by DAJAR sp. z o.o. for the purpose of fulfilling purchases made on the online store {{domain}}. The administrator of the personal data provided during the order placement is DAJAR sp. z o.o. with registered office in 75-072 Koszalin, Połtawska 6. We inform you that every customer has the right to access, rectify, erase, restrict processing, object to the processing of their personal data, and data portability. Please direct your requests to the email address dpo@dajar.pl. We also inform you about the possibility of filing a complaint with the supervisory authority in case of unauthorized use of personal data. This consent can be withdrawn at any time based on Article 23 point 1 subpoint 1 of the Act of August 29, 1997 on the Protection of Personal Data, and Article 6 point 1a of the EU Regulation 2016/679.","Password":"Password","First Name":"First Name","Last Name":"Last Name","First, last name":"First, last name","Street":"Street","City":"City","Country":"Country","Phone":"Phone","Postal code":"Postal code","Company name":"Company name","Vat ID":"Vat ID","Company":"Company","Registration complete":"Registration complete","Required field":"Required field","Required option":"Required option","Terms agreement":"Terms agreement","Invalid email":"Invalid email","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.co.uk","Forgot password?":"Forgot password?","Don\'t have an account?":"Don\'t have an account?","All New in":"All New in","New arrivals":"New arrivals","New arrival":"New arrivals","Password match":"Password match","No products in cart":"No products in basket","Thank you, your order has been placed!":"Thank you, your order has been placed!","Completed order info":"Completed order info","Back to home page":"Back to home page","come back to main categories":"come back to main categories","Needs help?":"Needs help?","Show cart summary":"Show basket summary","Sign up for newsletter":"Sign up for newsletter","Subscribe to newsletter":"Subscribe to newsletter","Sign off from newsletter":"Sign off from newsletter","Sign up for newsletter seo title":"Sign up for newsletter seo title","Sign up for newsletter seo description":"Sign up for newsletter seo description","Sign off for newsletter seo title":"Sign off for newsletter seo title","Sign off for newsletter seo description":"Sign off for newsletter seo description","Sign up for newsletter success":"Check your email and confirm registration.","Unsubscribe success":"Unsubscribe success","Our bestsellers":"Our bestsellers","Shop the deals":"Shop the deals","Popular categories":"Popular categories","Out of stock":"Out of stock","Last items in stock":"Last items in stock","Also from this collection":"Also from this collection","Complete the look":"Complete with","Shop all{collectionName}}":"Shop all{collectionName}}","Catalog price":"Catalog price","Quantity":"Quantity","Details":"Details","Saved addresses":"Saved addresses","Contact":"Contact","Continue to payment":"Continue to payment","Go back to cart":"Go back to basket","Go back to information":"Go back to information","Create account":"Create account","Payment method":"Payment method","Payment":"Payment","Waiting for payment":"Waiting for payment","Payment complete":"Payment complete","cash on delivery":"cash on delivery","bank transfer":"bank transfer","Newsletter description":"Newsletter description","Reset password":"Reset password","Reset password description":"Reset password description","Reset":"Reset","Back to login":"Back to login","Newsletter agreement":"Newsletter agreement","Place order":"Place order","See all":"See all","Shop this story":"Shop this story","Recommended categories":"Recommended categories","Related stories":"Related stories","I have coupon code":"I have coupon code","Submit":"Submit","price high to low":"price high to low","price low to high":"price low to high","sortByNameDesc":"sortByNameDesc","sortByNameAsc":"sortByNameAsc","recommended":"recommended","All orders":"All orders","Address book":"Address book","Log out":"Log out","Last order":"Last order","Personal info":"Personal info","My orders":"My orders","Account":"Account","Orders":"Orders","Order":"Order","Order number":"Order number","Ongoing":"Ongoing","Past orders":"Past orders","Account password change description":"Account password change description","Edit":"Edit","Change":"Change","Save":"Save","Old password":"Old password","New password":"New password","Continue shopping":"Continue shopping","bonus ePoints":"DAJAR ePoints","Use":"Use","Sale":"Discount","Your order":"Your order","Search":"Search","See all suggestions ({{resultsLength}})":"See all suggestions ({{resultsLength}})","Cancel":"Cancel","Sort":"Sort","all filters":"all filters","Clear":"Clear","Filter":"Filter","select":"select","selected":"selected","Show result":"Show result","People also liked":"People also liked","Popular searches":"Popular searches","Read more":"Read more","capacity":"capacity","diameter":"diameter","material":"material","size":"size","length":"length","color":"color","depth":"depth","width":"width","height":"height","shape":"shape","Search collections, products, etc...":"Search collections, products, etc...","Shop by Collection":"Shop by Collection","Shop by Type":"Shop by Type","show all":"show all","show more":"show more","show less":"show less","languages":"languages","Please login, your session expired.":"Please login, your session expired.","pending":"pending","canceled":"canceled","sending":"sending","processing":"processing","complete":"complete","Delivered":"Delivered","Tracking number":"Tracking number","ready":"ready","Track and trace":"Track and trace","Copy":"Copy","Out for delivery":"Out for delivery","Expect your package today":"Expect your package today","Courier":"Courier","Change password":"Change password","Default seo description":"Welcome to DAJAR.co.uk. We offer garden furniture, cushions and swings. Our offer also includes tableware, cutlery, pots, pans, dinner sets and glasses.","Default seo description - register":"Welcome to DAJAR.co.uk. We offer garden furniture, cushions and swings. Our offer also includes tableware, cutlery, pots, pans, dinner sets and glasses.","Default seo title":"DAJAR.co.uk - garden furniture and tableware","Default seo title - register":"DAJAR.co.uk - garden furniture and tableware","search results":"Search results for \\"{{phrase}}\\"","page":"Page","rachunku":"Products in category {{categoryName}} in DAJAR.co.uk. Enjoy your shopping!","Accept terms":"I have read and accept the","Terms":"Terms agreement","Shipment":"Shipping","Cookie notice":"Welcome to our DAJAR.co.uk store.\\nWe use cookies to analyze traffic on the DAJAR.co.uk website, personalize the content on the website, display tailored ads and increase the comfort of using our website. By clicking \\"\\"accept\\"\\", you are informing us that you consent to our placing of cookies in your browser and, where applicable, to the processing of related data for these purposes. You can manage your consent and withdraw it at any time using the settings in your browser. For more information, please see our Cookie Policy.","Accept":"Accept","Default billing":"Default billing","Default billing address":"Default billing address","Default shipping":"Default shipping","Default shipping address":"Default shipping address","Is default shipping address?":"Is this the default shipping address?","Is default billing address?":"Is this the default billing address?","Add new address":"Add new address","Not set":"Not set","Default billing and shipping":"Default billing and shipping address","Product was added to cart":"Product was added to basket","number of people":"intended for this number of people","Wrong street format":"Please enter street name and house number (for no number, enter \\"0\\")","New address":"New address","Edit address":"Edit address","Error":"Error","Something went wrong":"Something went wrong.","Fill in the delivery details":"Fill in the delivery details","We don\'t ship to this country, sorry":"We don\'t ship to this country, sorry.","This method is not available":"This method is not available","Incorrect phone number":"Incorrect phone number","Incorrect VAT ID":"Incorrect VAT ID","Shipping same as billing":"The same delivery address as on the invoice","As Company":"Company","Name or Company":"Private person or Company","Billing for":"Billing for","Choose pickup point":"Choose pickup point","Deliver to company":"Deliver to company","Company address":"Company address","Search results | Dajar":"Search results | Dajar","Address saved":"Address saved","ePoints":"DAJAR ePoints","Available ePoints":"Available DAJAR ePoints","You can use these points with your next purchase":"You can use DAJAR ePoints with your next purchase","Learn more":"Learn more","ePoints earned":"DAJAR ePoints earned","paid with ePoints":"Paid with DAJAR ePoints","Settlement of ePoints":"Settlement of DAJAR ePoints","Added by administrator":"Added by administrator","Purchase invoice":"Purchase invoice","Purchase canceled":"Purchase canceled","Spent with order":"Spent with order","Spent with order canceled":"Spent with order canceled","Order cancelation":"Order cancelation","Max addresses reached":"Maximum number of saved addresses. The address has not been added","Brexit":"In preparation for Brexit, we will not be able to post orders to the UK during the period from 16.12.2020 until further notice. We are sorry for the inconvenience.","Pay less with ePoints":"Pay less with DAJAR ePoints","Delete ePoints":"Delete DAJAR ePoints","ePoints (you have {{points}})":"ePoints (you have {{points}})","price":"Price","Active":"Active","Accept all cookies":"Accept All","Confirm my settings":"Accept Selected","Manage cookie settings":"Let me choose…","Third party cookies":"List of cookies","Back to cookie list":"List of cookies","Show cookie list":"Show cookies","Cookie name":"Name","Duration":"Duration","Type":"Type","Required cookies description":"Cookies that we need for the proper operation of our DAJAR.co.uk store.","Analytic cookies description":"They include cookies that help us analyze and monitor traffic on our website DAJAR.co.uk. It gives us additional knowledge to improve our website for you. ","Tracking cookies description":" vă prezentăm informațiile care vă sunt cele mai relevante.","Necessary cookies":"Essential cookies","Analytic cookies":"Analytic cookies","Tracking cookies":"Tracking cookies","Third party":"Third party ","day":"day","days":"days","years":"years","minute":"minute","minutes":"minutes","month":"month","months2":"months","months":"months","year":"year","session":"session","hour":"hour","Own":"Own","Too many points provided":"Too many points provided","Last name must be different then first name":"Last name must be different then first name","Additonal fee":"Additonal fee","price catalog high to low":"Catalog price: high to low","price catalog low to high":"Catalog price: low to high","Additional information":"Additional information","Length [cm]":"Length [cm]","Width [cm]":"Width [cm]","Shape":"Shape","Producer":"Producer","Height [cm]":"Height [cm]","Depth [cm]":"Depth [cm]","Capacity [ml]":"Capacity [ml]","Number of people":"Number of person","Dajar collection":"Collection","Material":"Material","Application":"Usage","Diameter [cm]":"Diameter [cm]","Color list":"Color","Pattern list":"Pattern","Feature":"Function","Composition":"Composition","Max load":"Maximum load [kg]","Capacity [l]":"Capacity [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Weight [kg]","Help":"Help","The product is no longer available":"The product is no longer available","Remove it from the cart or reduce the quantity ":"Remove it from the basket or reduce the quantity ","The product will be available":"The product will be available","product available in different variant":"product available in different variant","Possible service failure. Please wait a moment and try again":"Possible service failure. Please wait a moment and try again","Page not found":"Page not found","Go to home page":"Go to home page","Check recently viewed":"Check recently viewed","Do not hesitate":"Do not hesitate with the purchase, adding items to the basket does not mean their reservation.","Save new address":"Save new address","Other address":"Other address","Subscribe to the newsletter":"Subscribe to the newsletter","And get even 20% off":"Get even 5% off","Subscribe":"Subscribe","Subscribe to our newsletter":"Subscribe to our newsletter","And get even 10% off":"Get even 5% off","Cart":"Basket","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"You don\'t have any orders","Are you sure you want to remove this address?":"Are you sure you want to cancel this address?","Password saved":"Password saved","Firstname and Lastname saved":"Firstname and Lastname saved","Address deleted":"Address deleted","Yes":"Yes","No":"No","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Your payment is being processed. We will send you an email about the status of your order.","Thank you for your purchase":"Thank you for your purchase!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"","Promo code was added to clipboard":"The discount code has been copied","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Product has been added to your wish list","Removed from wishlist":"Product has been removed from wish list","Product on wishlist":"Product is on your wish list","Wishlist inactive tooltip":"Log in to add the product to your wish list","Wishlist":"Wish List","Add visible to cart":"Add visible products to your basket","Wishlist products added to cart":"Available products from the wish list have been added to your basket","No products in the wishlist":"No products on wish list","Hit of the day":"Hit of the day","Only {{qty}} left in stock":"Remaining {{qty}} pieces","Offer ends":"Offer ends in:","hours hit":"hours","minutes hit":"minutes","seconds hit":"seconds","sold out":"sold out","left hits":"remaining","sold hits":"sold","Offer start":"New offer will start in","Available qty for person in hit {{qty}}":"You can buy max {{qty}} pieces per person","Outlet":"Sale","Hit of the week":"Hit of the week","Hit of the month":"Hit of the month","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"Back","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Special Offer!","Check out this great deal":"Check out this great deal","A new unique offer every day":"A new unique offer every day","Change parcel":"","card":"Card payment","banktransfer":"Traditional transfer","cashondelivery":"Cash","dialcom_przelewy":"Fast transfer","bluepayment":"Fast transfer","blik":"BLIK code","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"Enter the BLIK code from your bank\'s app","applepay_info":"Click to pay for the order","googlepay_info":"Click to pay for the order","paypal_info":"PayPal selected. After clicking Pay, you will be redirected to a page that allows you to securely complete the next steps.","bluepayment_info":"Autopay selected. After clicking Pay, you will be redirected to a page that allows you to securely complete the next steps.","klarna_info":"Klarna payment selected.<br />After clicking, you will be redirected to a page that allows for the secure completion of the next steps.","banktransfer_info":"Bank transfer payment selected. After clicking Pay, you will receive an email with the account details for the transfer.","cashondelivery_info":"Payment on delivery selected. You will pay for the order in cash to the courier upon delivery.","The payment is REFUSED.":"Payment failed.","Payment refused. Choose payment method and retry":"Select a payment method and try again","Finish payment":"Complete the payment","klarna_paynow_button_label":"Pay now with Klarna","klarna_paylater_button_label":"Pay in 30 days with Klarna","klarna_account_button_label":"Pay in instalments with Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Your payment was declined, or there is an item in your cart that is out of stock.","adyen_error_message":"Your payment has been refused.","Cannot set delivery method":"Delivery method cannot be set","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"This product can be used safely and as intended by the manufacturer only in accordance with the instructions for use and maintenance, recommendations, warnings, or safety information provided on the product, its packaging, or included with the product.","safety_title":""}');

/***/ }),

/***/ 80175:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Codice sconto","Delete coupon code":"Rimuovi il codice","AllProducts{{brandName}}":"Tutti i prodotti {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"A cura di {{authorName}} da {{authorProfileNick}}","Shop items below":"Vedi i prodotti qui sotto","Curated by":"A cura di ","by":"da","from":"da","from range":"da","to range":"a","More":"Di più ","more":"di più ","starting at":"a partire da","or":"o","Login":"Accesso","My account":"Il mio account","Free delivery":"Consegna gratuita","to free standard shipping":"per la consegna gratuita","Shipping":"Consegna","Shipping method":"Metodo di spedizione","Shipping address":"Indirizzo di spedizione","Invoice data":"Dati di fatturazione","Billing same as shipping":"Dati di fatturazione uguali a quelli della spedizione","Subtotal":"Totale parziale del carrello","Discounts":"Sconti","Tax":"I.V.A.","Tax and Shipping are estimated for ":"Le tasse e le spese di spedizione sono stimate per","Tax included":"Tasse incluse","Total":"Importo totale","Go to checkout":"Vai alla cassa","Your cart":"Il tuo carrello","Collections":"Collezioni","View details":"Visualizza dettagli","Add to cart":"al carrello","add to cart":"Aggiungi al carrello","More inspirations":"Più ispirazioni","Recently viewed":"Visualizzato recentemente","Register":"Registrazione","Sign Up":"Registrarsi","Sign Off":"Annullara l\'iscrizione","Log in":"Accesso","Log yourself":"Accedi","of":"di","Technical data":"Dati tecnici","Product description":"Descrizione del prodotto","Color":"Colore","Size":"Dimensioni","Story with":"Articolo a cura di","Inspirations":"Ispirazioni","Home":"Homepage","Arrivals by category":"Novità per categoria","Already have an account?":"Hai già un account?","Rodo_agreement {{domain}}":"Acconsento al trattamento dei miei dati personali da parte di DAJAR sp. z o.o. per scopi relativi agli acquisti effettuati sul negozio online {{domain}}. L\'amministratore dei dati personali forniti al momento dell\'ordine è DAJAR sp. z o.o. con sede legale in 6 Połtawska Street, Koszalin 75-072, Polonia.\\nDesideriamo informarti che ogni Cliente ha il diritto di accedere, rettificare, cancellare, limitare il trattamento, opporsi al trattamento dei propri dati personali e trasferire i propri dati. Si prega di indirizzare qualsiasi richiesta in merito al seguente indirizzo e-mail: dpo@dajar.pl. La informiamo inoltre della possibilità di proporre reclamo all\'Organismo di Vigilanza competente in caso di utilizzo non autorizzato dei suoi dati personali. Tale consenso può essere revocato in qualsiasi momento sulla base dell\'articolo 23 punto 1.1 della legge 29 agosto 1997 sulla protezione dei dati personali e dell\'articolo 6 punto 1a del Regolamento UE 2016/679.","Password":"Password","First Name":"Nome","Last Name":"Cognome","First, last name":"Nome, cognome","Street":"Via","City":"Città","Country":"Paese","Phone":"numero di telefono","Postal code":"CAP","Company name":"Nome della ditta","Vat ID":"Partita IVA","Company":"Ditta ","Registration complete":"Il tuo account è stato creato e sei loggato","Required field":"Campo obbligatorio","Required option":"Opzione richiesta","Terms agreement":"Se vuoi registrarti, accetti i termini di utilizzo del sito web","Invalid email":"E-mail non valido","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.it","Forgot password?":"Ha dimenticato la password?","Don\'t have an account?":"Non hai un account?","All New in":"Tutte le Novità in","New arrivals":"Novità","New arrival":"Novità","Password match":"La password deve essere la stessa","No products in cart":"Nessun prodotto nel carrello","Thank you, your order has been placed!":"Hai appena fatto l\'ordine! Grazie!","Completed order info":"L\'ordine è in elaborazione, ti informeremo della spedizione tramite e-mail.","Back to home page":"Torna alla homepage","come back to main categories":"Menu principale","Needs help?":"Hai bisogno di aiuto?","Show cart summary":"Riepilogo del carrello","Sign up for newsletter":"Iscriviti alla Newsletter","Subscribe to newsletter":"Iscriviti","Sign off from newsletter":"Annulla l\'iscrizione alla newsletter","Sign up for newsletter seo title":"Iscrizione alla Newsletter","Sign up for newsletter seo description":"Iscriviti alla newsletter per essere informato sulle nostre novità e promozioni.","Sign off for newsletter seo title":"Annulla l\'iscrizione alla newsletter","Sign off for newsletter seo description":"Puoi annullare l\'iscrizione alla nostra newsletter in qualsiasi momento","Sign up for newsletter success":"Controlla la tua email e conferma la registrazione. ","Unsubscribe success":"Annullamento dell\'iscrizione alla newsletter avvenuto con successo","Our bestsellers":"I nostri bestseller","Shop the deals":"Offerte speciali","Popular categories":"Categorie popolari","Out of stock":"Stock esaurito","Last items in stock":"Ultimi articoli in magazzino","Also from this collection":"Altri prodotti della collezione","Complete the look":"Completa con","Shop all{collectionName}}":"Visualizza l\'intera collezzione {{collectionName}}","Catalog price":"Prezzo di listino","Quantity":"Quantità","Details":"Dettagli","Saved addresses":"Indirizzi salvati","Contact":"Contatto","Continue to payment":"Procedere al pagamento","Go back to cart":"Torna al carrello","Go back to information":"Torna alle informazioni","Create account":"Creare un account","Payment method":"Metodo di pagamento","Payment":"Pagamento","Waiting for payment":"In attesa di pagamento","Payment complete":"Pagamento effettuato","cash on delivery":"","bank transfer":"bonifico bancario","Newsletter description":"Rimani aggiornato. Ricevi informazioni sui nuovi prodotti e sulle promozioni.","Reset password":"Reimpostare la password","Reset password description":"Inserisci il tuo indirizzo e-mail per ricevere istruzioni su come reimpostare la tua password.","Reset":"Reimpostare","Back to login":"Tornare al login","Newsletter agreement":"Acconsento al trattamento dei miei dati personali da parte di DAJAR sp. z o.o. per inviare informazioni commerciali da DAJAR sp. z o.o. all\'indirizzo e-mail fornito. L\'amministratore dei dati personali forniti al momento dell\'ordine è DAJAR sp. z o.o. con sede legale via Połtawska numero 6, a Koszalin 75-072, in Polonia. Desideriamo informarla che ogni Cliente ha il diritto di accedere, rettificare, cancellare, limitare il trattamento, opporsi al trattamento dei propri dati personali e trasferire i propri dati. Si prega di indirizzare qualsiasi richiesta in merito al seguente indirizzo e-mail: dpo@dajar.pl. La informiamo inoltre della possibilità di proporre reclamo all\'organismo di vigilanza competente in caso di utilizzo non autorizzato dei suoi dati personali. Tale consenso può essere revocato in qualsiasi momento sulla base dell\'articolo 23 punto 1.1 della legge 29 agosto 1997 sulla protezione dei dati personali e dell\'articolo 6 punto 1a del Regolamento UE 2016/679.","Place order":"Ordinare","See all":"Vedere tutto","Shop this story":"Prodotti da non perdere","Recommended categories":"Categorie da non perdere","Related stories":"Storie correlate","I have coupon code":"Ho un codice sconto","Submit":"Inviare","price high to low":"Prezzo: decrescente","price low to high":"Prezzo: crescente","sortByNameDesc":"per nome Z-A","sortByNameAsc":"per nome A-Z","recommended":"Dan non perdere","All orders":"Tutti gli ordini","Address book":"Rubrica","Log out":"Disconnettersi","Last order":"Ultimo ordine","Personal info":"Informazioni personali","My orders":"Miei ordini","Account":"Account","Orders":"Ordini","Order":"Ordine","Order number":"Ordine no","Ongoing":"In corso","Past orders":"Ordini precedenti","Account password change description":"Fare clic sul pulsante a destra per modificare la password","Edit":"Modificare","Change":"Cambiare","Save":"Salvare","Old password":"Vecchia password","New password":"Nuova password","Continue shopping":"Continuare lo shopping","bonus ePoints":"punti Dajar eBonus","Use":"Usare","Sale":"Sconto","Your order":"Il tuo ordine","Search":"Cercare","See all suggestions ({{resultsLength}})":"Mostrare tutti i risultati ({{resultsLength}})","Cancel":"Annullare","Sort":"Ordinare","all filters":"tutti i filtri","Clear":"Cancellare","Filter":"Filtrare","select":"Selezionare","selected":"selezionato","Show result":"Mostrar i risultati","People also liked":"Vedere pure","Popular searches":"Ricerche popolari","Read more":"Leggere di più","capacity":"capacità","diameter":"diametro","material":"materiale","size":"misure","length":"lunghezza","color":"colore","depth":"profondità","width":"larghezza","height":"altezza","shape":"forma","Search collections, products, etc...":"Cercare prodotti, collezioni, ecc ...","Shop by Collection":"Collezioni in vetrina","Shop by Type":"Categorie di prodotti","show all":"mostrare tutto","show more":"mostrare di più","show less":"mostrare di meno","languages":"Lingue","Please login, your session expired.":"Riconnettiti, la tua sessione è scaduta.","pending":"ricevuto - in attesa","canceled":"annullato","sending":"pronto per la spedizione","processing":"in lavorazione","complete":"inviato","Delivered":"consegnato","Tracking number":"Numero di tracciamento","ready":"pronto","Track and trace":"Rintracciare la spedizione","Copy":"Copiare","Out for delivery":"In consegna","Expect your package today":"In consegna oggi","Courier":"Corriere","Change password":"Cambia la password","Default seo description":"Benvenuto/a su DAJAR.it. La nostra offerta include mobili, dondoli e cuscini da giardino. Nel nostro negozio troverai anche: stoviglie, posate, bicchieri, pentole, padelle e tanti altri utensili e accessori da cucina.","Default seo description - register":"Benvenuto/a su DAJAR.it. La nostra offerta include mobili, dondoli e cuscini da giardino. Nel nostro negozio troverai anche: stoviglie, posate, bicchieri, pentole, padelle e tanti altri utensili e accessori da cucina.","Default seo title":"DAJAR.it - Mobili da giardino,  e stoviglie da tavola e cucina","Default seo title - register":"DAJAR.it - Mobili da giardino,  e stoviglie da tavola e cucina","search results":"Risultati ricerca per \\"{{phrase}}\\"","page":"Pagina","rachunku":"Prodotti della categoria {{categoryName}} nel negozio DAJAR.it. Buon shopping!","Accept terms":"Ho letto e accetto le ","Terms":"Condizioni generali di vendita","Shipment":"Consegna","Cookie notice":"Benvenuto/a nel negozio DAJAR.it. \\nUtilizziamo i cookie per analizzare il traffico sul sito Web DAJAR.it, personalizzare il contenuto del sito, visualizzare annunci pubblicitari personalizzati e aumentare la comodità di utilizzo del nostro negozio. Cliccando su \\"\\"accetto\\"\\", ci informi che acconsenti all\'installazione dei cookie nel tuo browser e, ove applicabile, al trattamento dei dati associati per tali finalità. Puoi gestire il tuo consenso e revocarlo in qualsiasi momento utilizzando le impostazioni del tuo browser. Per ulteriori informazioni, consultare la nostra cookie policy.","Accept":"Accetto","Default billing":"Indirizzo di fatturazione predefinito","Default billing address":"Indirizzo di fatturazione predefinito","Default shipping":"Indirizzo di consegna predefinito","Default shipping address":"Indirizzo di consegna predefinito","Is default shipping address?":"È questo l\'indirizzo di consegna predefinito?","Is default billing address?":"È questo l\'indirizzo di fatturazione predefinito?","Add new address":"Aggiungi un nuovo indirizzo","Not set":"Non ancora predefinito","Default billing and shipping":"Indirizzo di fatturazione e di consegna predefinito","Product was added to cart":"Il prodotto è stato aggiunto al carrello","number of people":"numero di persone","Wrong street format":"Inserisci il nome della via e il numero civico","New address":"Nuovo indirizzo","Edit address":"Modificare l\'indirizzo","Error":"Errore","Something went wrong":"Qualcosa è andato storto","Fill in the delivery details":"Compila i dati di consegna","We don\'t ship to this country, sorry":"Siamo spiacenti ma non effettuiamo spedizioni in questo paese","This method is not available":"Questo metodo non è disponibile","Incorrect phone number":"Numero di telefono errato","Incorrect VAT ID":"Numero di partita IVA errato","Shipping same as billing":"L\'indirizzo di consegna uguale all\'indirizzo di fatturazione","As Company":"Faccio l\'ordine come azienda","Name or Company":"Nome dell\'azienda","Billing for":"Fattura a","Choose pickup point":"","Deliver to company":"","Company address":"Indirizzo aziendale","Search results | Dajar":"Risultati della ricerca | DAJAR.it","Address saved":"Indirizzo salvato","ePoints":"DAJAR eBonus","Available ePoints":"Punti DAJAR eBonus disponibili","You can use these points with your next purchase":"Puoi utilizzare i punti DAJAR eBonus per i tuoi prossimi acquisti","Learn more":"Saperne di più","ePoints earned":"Punti DAJAR eBonus guadagnati","paid with ePoints":"pagato con punti DAJAR eBonus","Settlement of ePoints":"Saldo punti DAJAR eBonus","Added by administrator":"Aggiunto dall\'amministratore","Purchase invoice":"Fattura d\'acquisto","Purchase canceled":"Acquisto annullato","Spent with order":"Speso per l\'ordine","Spent with order canceled":"Speso per l\'ordine annullato","Order cancelation":"Annullamento dell\'ordine","Max addresses reached":"Numero massimo di indirizzi memorizzati. L\'indirizzo non è stato aggiunto.","Brexit":"","Pay less with ePoints":"Paghi meno con i punti DAJAR eBonus","Delete ePoints":"Rimuovere i punti DAJAR eBonus","ePoints (you have {{points}})":"eBonus (hai {{punti}})","price":"Prezzo","Active":"Attivi","Accept all cookies":"Accettare tutti i cookie","Confirm my settings":"Accettare i cookie selezionati","Manage cookie settings":"Fammi scegliere","Third party cookies":"Elenco dei cookie","Back to cookie list":"Elenco dei cookie","Show cookie list":"Mostrare i cookie","Cookie name":"Nome","Duration":"Durata","Type":"Tipo","Required cookies description":"Cookie di cui abbiamo bisogno per il corretto funzionamento del nostro negozio DAJAR.it. ","Analytic cookies description":"Includono cookie che ci aiutano a monitorare ed analizzare il traffico sul nostro sito web DAJAR.it. Ci fornisce ulteriori conoscenze per migliorare il nostro sito web per te.","Tracking cookies description":"Cookie che ci consentono di personalizzare e misurare l\'efficacia della nostra pubblicità. Con il loro aiuto, ti presentiamo le informazioni più rilevanti per te.","Necessary cookies":"Cookie essenziali ","Analytic cookies":"Cookie analitici ","Tracking cookies":"Cookie di tracciamento","Third party":"Terze parti","day":"giorno","days":"giorni","years":"anni","minute":"minuto","minutes":"minuti","month":"mese","months2":"mesi","months":"mesi","year":"anno","session":"sessione","hour":"ora","Own":"Own","Too many points provided":"Troppi punti inseriti","Last name must be different then first name":"Il cognome deve essere diverso dal nome","Additonal fee":"Costi aggiuntivi","price catalog high to low":"Prezzo di listino: decrescente","price catalog low to high":"Prezzo di listino: crescente","Additional information":"Informazioni aggiuntive","Length [cm]":"Lunghezza [cm]","Width [cm]":"Larghezza [cm]","Shape":"Forma","Producer":"Produttore","Height [cm]":"Altezza [cm]","Depth [cm]":"Profondità [cm]","Capacity [ml]":"Capacità [ml]","Number of people":"Numero di persone","Dajar collection":"Collezione","Material":"Materiale","Application":"Uso","Diameter [cm]":"Diametro [cm]","Color list":"Colore","Pattern list":"Disegno","Feature":"Funzione","Composition":"Composizione","Max load":"Carico massimo [kg]","Capacity [l]":"Capacità [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Peso [kg]","Help":"Aiuto","The product is no longer available":"Il prodotto non è più disponibile","Remove it from the cart or reduce the quantity ":"Rimuoverlo dal carrello","The product will be available":"Il prodotto sarà disponibile","product available in different variant":"prodotto disponibile in una diversa variante","Possible service failure. Please wait a moment and try again":"Possibile guasto del servizio. Aspetta un attimo e riprova.","Page not found":"Pagina non trovata.","Go to home page":"Vai alla home page.","Check recently viewed":"Controlla visto di recente.","Do not hesitate":"Non ritardare nell\'ordinare, l\'aggiunta di articoli al carrello non significa la loro prenotazione.","Save new address":"Salvare","Other address":"Other address","Subscribe to the newsletter":"Iscrizione alla Newsletter","And get even 20% off":"Goditi uno sconto del 5%","Subscribe":"Iscriviti","Subscribe to our newsletter":"Iscriviti alla nostra Newsletter","And get even 10% off":"Goditi uno sconto del 5%","Cart":"Carrello","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"Nessun ordine","Are you sure you want to remove this address?":"Sicuro di voler eliminare l\'indirizzo?","Password saved":"Password salvata","Firstname and Lastname saved":"Nome e cognome salvati","Address deleted":"Indirizzo rimosso","Yes":"Si","No":"No","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Il tuo pagamento è in fase di elaborazione. Ti invieremo un\'e-mail con lo stato del tuo ordine.","Thank you for your purchase":"Grazie per il vostro ordine!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Prezzo precedente","Promo code was added to clipboard":"Il codice promozionale è stato copiato","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Il prodotto è stato aggiunto alla lista dei desideri","Removed from wishlist":"Il prodotto è stato rimosso dalla lista dei desideri","Product on wishlist":"Il prodotto è già nella lista dei desideri","Wishlist inactive tooltip":"Accedi per aggiungere il prodotto alla lista dei desideri","Wishlist":"Lista dei desideri","Add visible to cart":"Aggiungi i prodotti visibili al carrello","Wishlist products added to cart":"Gli articoli della lista dei desideri disponibili sono stati aggiunti al carrello","No products in the wishlist":"Non ci sono prodotti nella lista dei desideri","Hit of the day":"Hit del giorno","Only {{qty}} left in stock":"Ce ne restano {{qty}} pezzi","Offer ends":"L’offerta scade tra:","hours hit":"h.","minutes hit":"minuti","seconds hit":"ss.","sold out":"stock esaurito","left hits":"ne sono rimasti","sold hits":"venduti","Offer start":"La nuova offerta inizia fra","Available qty for person in hit {{qty}}":"Puoi acquistare {{qty}} pezzi/persona","Outlet":"Saldi","Hit of the week":"Hit della settimana","Hit of the month":"Hit del mese","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Da non perdere!","Check out this great deal":"Cogli l’opportunità!","A new unique offer every day":"Ogni giorno un articolo diverso","Change parcel":"","card":"Pagamento con carta","banktransfer":"Bonifico bancario","cashondelivery":"-","dialcom_przelewy":"Bonifico istantaneo","bluepayment":"Bonifico istantaneo","blik":"Codice Blik","googlepay":"GooglePay","applepay":"ApplePay","klarna":"Klarna","blik_info":"Inserisci il codice BLIK dalla tua applicazione bancaria","applepay_info":"Fare clic per pagare l\'ordine","googlepay_info":"Fare clic per pagare l\'ordine","paypal_info":"PayPal selezionato. Dopo aver fatto clic su Paga, verrai reindirizzato a una pagina che ti consentirà di completare in sicurezza i passaggi successivi.","bluepayment_info":"Autopay selezionato. Dopo aver fatto clic su Paga, verrai reindirizzato a una pagina che ti consentirà di completare in sicurezza i passaggi successivi.","klarna_info":"Pagamento Klarna selezionato.<br />Dopo il clic, verrai reindirizzato a una pagina che consente di eseguire i passaggi successivi in sicurezza.","banktransfer_info":"È stato selezionato il pagamento tramite bonifico. Dopo aver cliccato su Paga, riceverai un\'e-mail con i dettagli del conto per il bonifico.","cashondelivery_info":"-","The payment is REFUSED.":"Pagamento fallito.","Payment refused. Choose payment method and retry":"Seleziona un metodo di pagamento e riprova.","Finish payment":"Finalizza il pagamento.","klarna_paynow_button_label":"Paga ora con Klarna","klarna_paylater_button_label":"Paga tra 30 giorni con Klarna","klarna_account_button_label":"Paga a rate con Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Il tuo pagamento è stato rifiutato oppure nel carrello è presente un prodotto esaurito.","adyen_error_message":"Il tuo pagamento è stato rifiutato.","Cannot set delivery method":"Impossibile impostare il metodo di consegna","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Questo prodotto può essere utilizzato in modo sicuro e nel modo previsto dal produttore solo in conformità con le istruzioni per l\'uso e la manutenzione, le raccomandazioni, le avvertenze o le informazioni di sicurezza riportate sul prodotto o sulla sua confezione o fornite con il prodotto.","safety_title":""}');

/***/ }),

/***/ 26618:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@deosite/translations","version":"0.0.0","description":"UI translations","private":true,"author":"Anna Roik","license":"ISC"}');

/***/ }),

/***/ 42537:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Kod rabatowy","Delete coupon code":"Usuń kod","AllProducts{{brandName}}":"Wszystkie produkty {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Ułożona przez {{authorName}} z {{authorProfileNick}}","Shop items below":"Zobacz produkty poniżej","Curated by":"Pod kuratelą","by":"od","from":"z","from range":"od","to range":"do","More":"Więcej","more":"więcej","starting at":"zaczynają się od","or":"lub","Login":"Zaloguj","My account":"Moje konto","Free delivery":"Darmowa dostawa","to free standard shipping":"do darmowej dostawy","Shipping":"Dostawa","Shipping method":"Sposób wysyłki","Shipping address":"Adres wysyłki","Invoice data":"Dane do faktury","Billing same as shipping":"Adres rozliczeniowy taki sam jak adres dostawy","Subtotal":"Wartość koszyka","Discounts":"Obniżki","Tax":"Podatek","Tax and Shipping are estimated for ":"Podatek i wysyłka są szacowane dla ","Tax included":"W tym podatek VAT","Total":"Łącznie","Go to checkout":"Przejdź do kasy","Your cart":"Twój koszyk","Collections":"Kolekcje","View details":"Pokaż szczegóły","Add to cart":"Do koszyka","add to cart":"Dodaj do koszyka","More inspirations":"Więcej inspiracji","Recently viewed":"Ostatnio przeglądane","Register":"Rejestracja","Sign Up":"Zarejestruj się","Sign Off":"Wypisz się","Log in":"Logowanie","Log yourself":"Zaloguj się","of":"z","Technical data":"Dane techniczne","Product description":"Opis produktu","Color":"Kolor","Size":"Rozmiar","Story with":"Artykuł z udziałem","Inspirations":"Inspiracje","Home":"Strona główna","Arrivals by category":"Nowości wg kategorii","Already have an account?":"Posiadasz już konto?","Rodo_agreement {{domain}}":"Wyrażam zgodę na przetwarzanie moich danych osobowych przez DAJAR sp. z o.o. do realizacji dokonywanych zakupów w sklepie internetowym {{domain}}. Administratorem danych osobowych przekazanych podczas składania zamówienia jest DAJAR sp. z o.o. z siedzibą w 75-072 Koszalin, ul. Połtawska 6. Informujemy iż każdemu naszemu Klientowi przysługuje prawo do dostępu, sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania swoich danych osobowych oraz przeniesienia danych. Zgłoszenia prosimy kierować na adres email dpo@dajar.pl. Informujemy również o możliwości wniesienia skargi do organu nadzorczego w przypadku nieuprawnionego wykorzystania danych osobowych. Powyższa zgoda może być cofnięta w dowolnym momencie na podstawie Art 23 punkt 1 podpunkt 1 Ustawy z dn.29.08.1997 O Ochronie Danych Osobowych, oraz Artykuł 6. punkt 1a rozporządzenia UE 2016/679.","Password":"Hasło","First Name":"Imię","Last Name":"Nazwisko","First, last name":"Imię i nazwisko","Street":"Ulica","City":"Miasto","Country":"Państwo","Phone":"Telefon","Postal code":"Kod pocztowy","Company name":"Nazwa firmy","Vat ID":"NIP","Company":"Klient firmowy","Registration complete":"Utworzono konto i zalogowano","Required field":"Pole wymagane","Required option":"Opcja musi być zaznaczona","Terms agreement":"Jeśli chcesz się zarejestrować musisz wyrazić zgodę na warunki korzystania z serwisu","Invalid email":"Nieprawidłowy email","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.pl","Forgot password?":"Zapomniałeś hasła?","Don\'t have an account?":"Nie masz konta?","All New in":"Wszystkie Nowości w","New arrivals":"Nowości","New arrival":"Nowość","Password match":"Hasło musi być takie samo","No products in cart":"Nie masz produktów w koszyku.","Thank you, your order has been placed!":"Dziękujemy, Twoje zamówienie zostało złożone!","Completed order info":"Zamówienie jest kompletowane, o wysyłce poinformujemy drogą mailową.","Back to home page":"Wróć do strony głównej","come back to main categories":"Menu główne","Needs help?":"Potrzebna pomoc?","Show cart summary":"Podsumowanie koszyka","Sign up for newsletter":"Zapisz się do naszego newslettera","Subscribe to newsletter":"Zapisz się","Sign off from newsletter":"Wypisz się z newslettera","Sign up for newsletter seo title":"Zapis do newslettera","Sign up for newsletter seo description":"Zapisz się do naszego newslettera. Informacje o nowych produktach i promocjach","Sign off for newsletter seo title":"Wypisz się z newslettera","Sign off for newsletter seo description":"Możesz wypisać się z naszego newslettera w dowolnym momencie","Sign up for newsletter success":"Sprawdź swoją skrzynkę mailową i potwierdź rejestrację.","Unsubscribe success":"Udanie wypisano z newslettera","Our bestsellers":"Popularne produkty","Shop the deals":"Okazje","Popular categories":"Popularne kategorie","Out of stock":"Brak w magazynie","Last items in stock":"Ostatnie sztuki w magazynie","Also from this collection":"Inne z tej kolekcji","Complete the look":"Uzupełnij o","Shop all{collectionName}}":"Zobacz całą kolekcję {{collectionName}}","Catalog price":"Cena katalogowa:","Quantity":"Ilość","Details":"Detale","Saved addresses":"Zachowane adresy","Contact":"Kontakt","Continue to payment":"Wybierz płatność","Go back to cart":"Powrót do koszyka","Go back to information":"Powrót do informacji","Create account":"Utwórz konto","Payment method":"Metoda płatności","Payment":"Płatność","Waiting for payment":"Oczekuje na płatność","Payment complete":"Płatność zakończona","cash on delivery":"Płatność przy odbiorze","bank transfer":"Przelew bankowy","Newsletter description":"Bądź na bieżąco. Otrzymuj informacje o nowościach i wyprzedażach.","Reset password":"Zresetuj hasło","Reset password description":"Podaj swój adres e-mail, aby otrzymać instrukcję jak zresetować hasło.","Reset":"Resetuj","Back to login":"Powrót do logowania","Newsletter agreement":"Wyrażam zgodę na przetwarzanie moich danych osobowych przez DAJAR sp. z o.o. do przesyłania na podany adres email informacji handlowych od DAJAR sp. z o.o. Administratorem danych osobowych przekazanych podczas składania zamówienia jest DAJAR sp. z o.o. z siedzibą w 75-072 Koszalin, ul. Połtawska 6. Informujemy iż każdemu naszemu Klientowi przysługuje prawo do dostępu, sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania swoich danych osobowych oraz przeniesienia danych. Zgłoszenia prosimy kierować na adres email dpo@dajar.pl. Informujemy również o możliwości wniesienia skargi do organu nadzorczego w przypadku nieuprawnionego wykorzystania danych osobowych. Powyższa zgoda może być cofnięta w dowolnym momencie na podstawie Art 23 punkt 1 podpunkt 1 Ustawy z dn.29.08.1997 O Ochronie Danych Osobowych, oraz Artykuł 6. punkt 1a rozporządzenia UE 2016/679.","Place order":"Zamawiam z obowiązkiem zapłaty","See all":"Wszystkie","Shop this story":"Polecane produkty","Recommended categories":"Polecane kategorie","Related stories":"Polecane historie","I have coupon code":"Mam kod rabatowy","Submit":"Wyślij","price high to low":"Cena: od najwyższej","price low to high":"Cena: od najniższej","sortByNameDesc":"Wg nazwy Z-A","sortByNameAsc":"Wg nazwy A-Z","recommended":"Polecane","All orders":"Wszystkie zamówienia","Address book":"Książka adresowa","Log out":"Wyloguj mnie","Last order":"Ostatnie zamówienie","Personal info":"Informacje o mnie","My orders":"Moje zamówienia","Account":"Konto","Orders":"Zamówienia","Order":"Zamówienie","Order number":"Zamówienie nr","Ongoing":"W toku","Past orders":"Poprzednie zamówienia","Account password change description":"Kliknij na przycisk po prawej, żeby zmienić hasło.","Edit":"Edytuj","Change":"Zmień","Save":"Zapisz","Old password":"Stare hasło","New password":"Nowe hasło","Continue shopping":"Kontynuuj zakupy","bonus ePoints":"punktów DAJAR ePremia","Use":"Użyj","Sale":"Rabat","Your order":"Twoje zamówienie","Search":"Wyszukaj","See all suggestions ({{resultsLength}})":"Pokaż wszystkie wyniki ({{resultsLength}})","Cancel":"Anuluj","Sort":"Sortuj","all filters":"wszystkie filtry","Clear":"Wyczyść","Filter":"Filtruj","select":"Wybierz","selected":"zaznaczone","Show result":"Pokaż wyniki","People also liked":"Zobacz również","Popular searches":"Popularne wyszukania","Read more":"Zobacz więcej","capacity":"pojemność","diameter":"średnica","material":"materiał","size":"rozmiar","length":"długość","color":"kolor","depth":"głębokość","width":"szerokość","height":"wysokość","shape":"kształt","Search collections, products, etc...":"Szukaj produktów, kolekcji, etc...","Shop by Collection":"Polecane Kolekcje","Shop by Type":"Kategorie produktów","show all":"pokaż wszystkie","show more":"pokaż więcej","show less":"pokaż mniej","languages":"Języki","Please login, your session expired.":"Zaloguj się ponownie, twoja sesja wygasła.","pending":"przyjęte do relaizacji","canceled":"Anulowane","sending":"Przygotowane do wysyłki","processing":"przetwarzane","complete":"Wysłane","Delivered":"Dostarczone","Tracking number":"Numer przesyłki","ready":"Gotowe","Track and trace":"Śledzenie przesyłki","Copy":"Kopiuj","Out for delivery":"W drodze do odbiorcy","Expect your package today":"Spodziewaj się dzisiaj swojej paczki","Courier":"Kurier","Change password":"Zmień hasło","Default seo description":"Witaj w DAJAR.pl. Oferujemy meble ogrodowe, poduszki i huśtawki. Nasz sklep to też zastawa stołowa, sztućce, garnki, patelnie, serwisy obiadowe i kieliszki.","Default seo description - register":"Załóż konto w DAJAR.pl i korzystaj! Zapewnij sobie dostęp do historii zamówień i specjalnych ofert dla zarejestrowanych użytkowników!","Default seo title":"Sklep DAJAR.pl - meble ogrodowe i zastawa stołowa","Default seo title - register":"Rejestracja – załóż konto | DAJAR.pl ","search results":"Wyniki wyszukiwania dla \\"{{phrase}}\\"","page":"Strona","rachunku":"Produkty w kategorii {{categoryName}} w sklepie DAJAR.pl. Zapraszamy do zakupów!","Accept terms":"Przeczytałem/am i akceptuję warunki","Terms":"Regulaminu","Shipment":"Wysyłka","Cookie notice":"Serdecznie witamy w naszym sklepie {{domain}}. \\nUżywamy ciasteczek (plików cookie) do analizowania ruchu na stronie {{domain}}, personalizowania treści na stronie, wyświetlania dostosowanych reklam i zwiększania komfortu korzystania z naszej witryny. Klikając „zaakceptuj\\", informujesz nas, że zgadzasz się na umieszczanie przez nas ciasteczek (plików cookie) w Twojej przeglądarce i, w stosownych przypadkach, przetwarzanie powiązanych danych w tych celach. Możesz zarządzać swoją zgodą i wycofywać ją w każdej chwili, za pomocą ustawień w Twojej przeglądarce. Aby uzyskać więcej informacji, przejdź do naszej <a href=\\"/info/cookies\\">Polityki plików cookie</a>.","Accept":"Akceptuję","Default billing":"Domyślny rozliczeniowy","Default billing address":"Domyślny adres rozliczeniowy","Default shipping":"Domyślny dostawy","Default shipping address":"Domyślny adres wysyłki","Is default shipping address?":"Domyślny adres do wysylki?","Is default billing address?":"Domyślny adres rozliczeniowy?","Add new address":"Dodaj nowy adres","Not set":"Nie dodany","Default billing and shipping":"Domyślny adres rozliczeniowy i wysyłki","Product was added to cart":"Produkt został dodany do koszyka","number of people":"ilość osób","Wrong street format":"Wymagana nazwa ulicy i numer domu","New address":"Nowy adres","Edit address":"Edytuj adres","Error":"Błąd","Something went wrong":"Coś poszło nie tak.","Fill in the delivery details":"Wypełnij dane do wysyłki.","We don\'t ship to this country, sorry":"Nie wysłamy do tego kraju, przepraszamy.","This method is not available":"Ta metoda jest niedostępna dla wybranych danych.","Incorrect phone number":"Nieprawidłowy numer telefonu","Incorrect VAT ID":"Nieprawidłowy numer NIP","Shipping same as billing":"Adres dostawy taki sam jak na fakturze","As Company":"Kupuję jako firma","Name or Company":"Nazwisko lub Nazwa firmy","Billing for":"Faktura dla","Choose pickup point":"Wybierz punkt odbioru","Deliver to company":"Dostawa do firmy","Company address":"Adres firmowy","Search results | Dajar":"Wyniki wyszukiwania | DAJAR.pl","Address saved":"Adres zapisany","ePoints":"DAJAR ePremia","Available ePoints":"Dostępne punkty DAJAR ePremia","You can use these points with your next purchase":"Możesz użyć punktów DAJAR ePremia przy kolejnych zakupach","Learn more":"Dowiedz się więcej","ePoints earned":"Uzyskano punkty DAJAR ePremia","paid with ePoints":"Zapłacono punktami DAJAR ePremia","Settlement of ePoints":"Rozliczenie punktów DAJAR ePremia","Added by administrator":"Dodane przez administratora","Purchase invoice":"Faktura zakupowa","Purchase canceled":"Zakup anulowany","Spent with order":"Wydano przy zamówieniu","Spent with order canceled":"Anulowano użycie przy zamówieniu","Order cancelation":"Rezygnacja z zamówienia","Max addresses reached":"Maksymalna ilość zapisanych adresów. Adres nie został dodany","Brexit":"","Pay less with ePoints":"Płać mniej z DAJAR ePremia","Delete ePoints":"Usuń punkty DAJAR ePremia","ePoints (you have {{points}})":"ePremia (posiadasz {{points}})","price":"Cena","Active":"Aktywne","Accept all cookies":"Zaakceptuj","Confirm my settings":"Zaakceptuj wybrane","Manage cookie settings":"Pozwól mi wybrać…","Third party cookies":"Lista ciasteczek (plików cookies)","Back to cookie list":"Lista ciasteczek (plików cookies)","Show cookie list":"Wyświetl pliki cookie","Cookie name":"Nazwa","Duration":"Czas trwania","Type":"Typ","Required cookies description":"Ciasteczka (pliki cookies), których potrzebujemy do prawidłowego działania naszego sklepu {{domain}}. ","Analytic cookies description":"Obejmują one ciasteczka (pliki cookies), które pomagają nam analizować i monitorować ruch na stronie naszego sklepu {{domain}}. Daje nam to dodatkową wiedzę do usprawniania naszego serwisu dla Ciebie.","Tracking cookies description":"Pliki cookie (pliki cookies), które pozwalają nam dostosowywać i mierzyć skuteczność naszych reklam. Z ich pomocą przedstawiamy Tobie informacje, które będą najbardziej dla Ciebie odpowiednie. ","Necessary cookies":"Niezbędne ciasteczka","Analytic cookies":"Analityczne ciasteczka","Tracking cookies":"Ciasteczka śledzące zachowania","Third party":"Strona trzecia","day":"dzień","days":"dni","years":"lata","minute":"minuta","minutes":"minuty","month":"miesiąc","months2":"miesięcy","months":"miesiące","year":"rok","session":"sesja","hour":"godzina","Own":"Własne","Too many points provided":"Wprowadzono za dużą ilość punktów","Last name must be different then first name":"Imię musi być inne niż nazwisko","Additonal fee":"Dodatkowa opłata +4 zł","price catalog high to low":"Cena katalogowa: od najwyższej","price catalog low to high":"Cena katalogowa: od najniższej","Additional information":"Dodatkowe informacje","Length [cm]":"Długość [cm]","Width [cm]":"Szerokość [cm]","Shape":"Kształt","Producer":"Marka","Height [cm]":"Wysokość [cm]","Depth [cm]":"Głębokość [cm]","Capacity [ml]":"Pojemność [ml]","Number of people":"Ilość osób","Dajar collection":"Kolekcja","Material":"Materiał","Application":"Zastosowanie","Diameter [cm]":"Średnica [cm]","Color list":"Kolor","Pattern list":"Wzór","Feature":"Funkcja","Composition":"Skład materiałowy","Max load":"Maksymalne obciążenie [kg]","Capacity [l]":"Pojemność [l]","Product usage":"Przeznaczenie","Brand":"Marka","Product styles":"Styl","Opportunity":"Okazja","Weight [kg]":"Waga [kg]","Help":"Pomoc","The product is no longer available":"Produkt nie jest już dostępny","Remove it from the cart or reduce the quantity ":"Proszę usuń go z koszyka lub zmniejsz jego ilość","The product will be available":"Produkt będzie dostępny","product available in different variant":"produkt dostępny w innym wariancie","Possible service failure. Please wait a moment and try again":"Możliwa awaria serwisu. Poczekaj chwilę i spróbuj ponownie","Page not found":"Nie znaleziono strony","Go to home page":"Przejdź do strony głównej","Check recently viewed":"Sprawdź ostatnio przeglądane","Do not hesitate":"Nie zwlekaj z zakupem, dodanie artykułów do koszyka nie oznacza ich rezerwacji.","Save new address":"Zapisz nowy adres","Other address":"Inny adres","Subscribe to the newsletter":"Zapisz się do newslettera","And get even 20% off":"Zyskaj nawet 5% zniżki","Subscribe":"ZAPISZ SIĘ","Subscribe to our newsletter":"Zapisz się na nasz newsletter","And get even 10% off":"Odbierz nawet 5% rabatu na zakupy o dowolnej wartości.","Cart":"Koszyk","Weber grills collections":"Kolekcje grilli Weber","Weber grills collections description":"Poznaj kultowe kolekcje naszych grilli","Recommended categories description - Weber":"Wysokiej jakości grille gazowe, węglowe, elektryczne i akcesoria do grillowania na każdą okazje","Kettler furniture collections":"Kolekcje mebli Kettler","Recommended categories description - Kettler":"Meble marki Kettler to synonim wygody, funkcjonalności i stylu.","Recommended categories - Kettler":"Poznaj nasze bestsellery","Search results | Kettler":"Wyniki wyszukiwania | Kettler","Search results | Weber":"Wyniki wyszukiwania | Kettler","Meta description ({{categoryName}}) - Kettler":"Kettler: ({{categoryName}})","Meta description ({{categoryName}}) - Weber":"Weber: ({{categoryName}})","Default seo title - Kettler":"Meble ogrodowe Kettler","Default seo title - Kettler - homepage":"Ekskluzywne meble ogrodowe | KettlerOutdoor.com","Default seo title - Weber":"Grille Weber","Default seo description - Kettler":"Komplety, meble modułowe, krzesła i stoły do ogrodu.","Default seo description - Kettler - homepage":"Komplety mebli ogrodowych, leżaki, krzesła i stoły do ogrodu najwyższej jakości o wyjątkowym designie. Z nami stworzysz swoje wymarzone miejsce wypoczynku!","Default seo description - Weber":"Gazowe, elektryczne, węglowe i akcesoria do grillowania.","Products in collection":"Produkty z kolekcji","Show other {{collectionName}} collections":"Inne z kolekcji {{collectionName}}","Price includes tax":"","You don\'t have any orders":"Brak zamówień","Are you sure you want to remove this address?":"Czy na pewno chcesz usunąć adres?","Password saved":"Zapisano hasło","Firstname and Lastname saved":"Zapisano imię i nazwisko","Address deleted":"Adres usunięty","Yes":"Tak","No":"Nie","available versions":"Dostępne warianty","Default seo title - Pro":"Designerskie naczynia, serwisy, sztućce","Default seo description - Pro":"Świeże trendy w designie naczyń i zastaw stołowych - talerze, sztućce i szkło topowych marek. Udekoruj dom i kuchnię nowymi kolekcjami od Dajar Professjonal.","Meta tags description alt - Pro":"Najlepsze marki do jadalni i kuchni. Kupuj w Dajar Professional.","Sale-Pro":"Wyprzedaż","Frequently asked questions":"Najczęściej zadawane pytania","Only {{amount}} to free shipping":"Jeszcze {{amount}} do darmowej wysyłki","Your cart is empty":"Twój koszyk jest pusty","start shopping":"zacznij zakupy","To checkout":"Do kasy","Your price (with tax)":"Twoja cena (z vat)","Availability":"Dostępność","product code":"KOD","Choose":"Wybierz","Filtering":"Filtrowanie","Previous":"poprzednia","Next":"następna","items (amount)":"przedmiotów","Other from category":"Inne z kategorii","less":"mniej","our categories":"nasze kategorie","See all - Pro":"zobacz wszystkie","Bestsellers - Pro":"Bestsellery","Free delivery PDP info {{freeDeliveryFrom}}":"Skorzystaj z Darmowej Dostawy przy zamówieniu już od {{freeDeliveryFrom}}","Your payment is being processed":"Twoja płatność jest przetwarzana. Wyślemy emaila o statusie zamówienia.","Thank you for your purchase":"Dziękujemy za Twoje zamówienie!","Collection page info":"Weber to wiodący producent wysokiej klasy grillów i akcesoriów ","Products":"Produkty","Suggestions":"Proponowane","We have sent an email to the given account with a link to change the password":"Na podane konto wysłaliśmy email z linkiem do zmiany hasła","Lowest price info":"Najniższa cena z ostatnich 30 dni sprzed promocji","Promo code was added to clipboard":"Kod promocyjny został skopiowany","Clear filters - Pro":"Wyczyść filtry","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"Wybierz paczkomat","Change locker":"Zmień paczkomat","with VAT":"z VAT","Unsubscribe info":"Możesz zrezygnować z subskrypcji w dowolnym momencie","Offer valid while stocks last":"Obowiązuje do wyczerpania zapasu","Product for free":"produkt gratis","Set as delivery parcel":"Ustaw jako punkt odbioru","Choose parcel pickup point":"Wybierz punkt odbioru","Get parcels addresses":"Pobierz adresy punktów odbioru","Enter address to get nearest parcels":"Wpisz adres aby pobrać najbliższe punkty odbioru","Incorrect postal code":"Nieprawidłowy kod pocztowy","Parcel not found":"Nie znaleziono punktu odbioru","Change form values":"Zmień dane w formularzu","Added to wishlist":"Produkt został dodany do listy życzeń","Removed from wishlist":"Produkt został usunięty z listy życzeń","Product on wishlist":"Produkt jest na liście życzeń","Wishlist inactive tooltip":"Zaloguj się aby dodać produkt do listy życzeń","Wishlist":"Lista życzeń","Add visible to cart":"Dodaj widoczne produkty do koszyka","Wishlist products added to cart":"Dostępne produkty z listy życzeń zostały dodane do koszyka","No products in the wishlist":"Brak produktów na liście życzeń","Hit of the day":"Hit dnia","Only {{qty}} left in stock":"Pozostało {{qty}} sztuk","Offer ends":"Oferta kończy się za:","hours hit":"godz.","minutes hit":"min.","seconds hit":"sek.","sold out":"wyprzedano","left hits":"pozostało","sold hits":"sprzedano","Offer start":"Nowa oferta rozpocznie się za","Available qty for person in hit {{qty}}":"Możesz kupić maks. {{qty}} szt. na osobę","Outlet":"Outlet","Hit of the week":"Hit tygodnia","Hit of the month":"Hit miesiąca","Choose DHL parcel":"Wybierz punkt odbioru","Choose Inpost pickup point":"Wybierz paczkomat","You may also like":"Zobacz również","see all":"Zobacz wszystkie","new account":"Nowe konto","menu":"menu","See all collections":"Zobacz wszystkie kolekcje","I am looking for a...":"Szukam...","New Collections":"Nowe kolekcje","Search results | Ambition":"Wyniki wyszukiwania | Ambition","Default seo title - Ambition":"Oficjalny Sklep AMBITION","Default seo description - Ambition":"Oryginalne produkty Ambition do kuchni i jadalni. Kupuj garnki, patelnie i zastawę stołową bezpośrednio u producenta.","Back":"Wstecz","Apply":"Zastosuj","Close":"Zamknij","Full of features":"Więcej z tej kolekcji","More from collection":"Nowe kolekcje","Copyrights - Ambition":"© 2025 Ambition.pl","Download Our App":"Pobierz Naszą Aplikację","Download Our App Description":"Opis aplikacji","Club benefits":"Poznajmy się. Oto kilka korzyści płynących z członkostwa w naszym Klubie Ambition. Zbieraj punkty i sprawdzaj najlepsze oferty i okazje dla Członków.","Earn Points":"Zdobądź punkty","Earn Points description":"1 PLN = 1 point, always, It os a easy way to buy cheaper next time.","Transfer Funds":"Przekaź fundusze","Transfer Funds description":"Zawsze najlepsze ceny dla członków Ambition Club.","First to Know":"Aktualne promocje","First to Know description":"Dzięki członkostwu w naszym biuletynie zawsze otrzymasz świeżą ofertę.","Rodo Club":"Rejestrując się, wyrażasz zgodę na nasze Warunki użytkowania, Politykę prywatności i Politykę plików cookie.","Special Offer!":"Okazja!","Check out this great deal":"sprawdź super ofertę","A new unique offer every day":"Codziennie nowa wyjątkowa oferta","Change parcel":"Zmień punkt odbioru","card":"Płatność kartą","banktransfer":"Przelew tradycyjny","cashondelivery":"Gotówka","dialcom_przelewy":"Szybki przelew","bluepayment":"Szybki przelew","blik":"Kod blik","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"Wprowadź kod BLIK z aplikacji swojego banku","applepay_info":"Kliknij aby opłacić zamówienie","googlepay_info":"Kliknij aby opłacić zamówienie","paypal_info":"Wybrano PayPal. Po kliknięciu Zapłać nastąpi przekierowanie do strony umożliwiającej bezpieczne wykonanie kolejnych kroków.","bluepayment_info":"Wybrano Autopay. Po kliknięciu Zapłać nastąpi przekierowanie do strony umożliwiającej bezpieczne wykonanie kolejnych kroków.","klarna_info":"Wybrano płatność Klarna.<br />Po kliknięciu Zapłać nastąpi przekierowanie do strony umożliwiającej bezpieczne wykonanie kolejnych kroków.","banktransfer_info":"Wybrano płatność przelewem. Po kliknięciu Zapłać otrzymasz wiadomość e-mail z danymi konta do przelewu.","cashondelivery_info":"Wybrano płatność przy odbiorze. Opłacisz zamówienie gotówką kurierowi podczas doręczenia przesyłki.","The payment is REFUSED.":"Płatność się nie powiodła.","Payment refused. Choose payment method and retry":"Wybierz metodę płatności i spróbuj ponownie","Finish payment":"Dokończ płatność","klarna_paynow_button_label":"Zapłać teraz z Klarna","klarna_paylater_button_label":"Zapłać za 30 dni z Klarna","klarna_account_button_label":"Zapłać na raty z Klarna","Settings":"Ustawienia","Download our app":"Pobierz naszą aplikację","Download our app description":"--Tu opis/reklama/slogan o aplikacji","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"Wyrażam zgodę na przetwarzanie moich danych osobowych przez DAJAR sp. z o.o. do realizacji dokonywanych zakupów w sklepie internetowym ambition.pl. Administratorem danych osobowych przekazanych podczas składania zamówienia jest DAJAR sp. z o.o. z siedzibą w 75-072 Koszalin, ul. Połtawska 6. Informujemy iż każdemu naszemu Klientowi przysługuje prawo do dostępu, sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania swoich danych osobowych oraz przeniesienia danych. Zgłoszenia prosimy kierować na adres email dpo@dajar.pl. Informujemy również o możliwości wniesienia skargi do organu nadzorczego w przypadku nieuprawnionego wykorzystania danych osobowych. Powyższa zgoda może być cofnięta w dowolnym momencie na podstawie Art 23 punkt 1 podpunkt 1 Ustawy z dn.29.08.1997 O Ochronie Danych Osobowych, oraz Artykuł 6. punkt 1a rozporządzenia UE 2016/679.","Log in or register":"Zaloguj się lub zapisz","Order List":"Lista zamówień","Your Last Order":"Ostatnie zamówienie","Expect your package in 1-2 working days":"Dostawa oczekiwana w przeciągu 1-2 dni","Tracking number copied":"Skopiowano numer przesyłki","Your Points":"Twoje punkty","See More":"Więcej","Hello {{name}}, nice to see You again !":"Cześć {{name}}, miło Cię znowu zobaczyć !","Date reach":"Wg. daty","Order status":"Wg. status","Your Special Membership Offer":"Twoja oferta członkowska","Become a Member":"Zostań członkiem klubu","App benefits":"Lorem ipsum dolor sit amet, consecteur adipiscing elit.","Dashboard":"Panel","More from this collection":"Więcej z tej kolekcji","adyen_error_message_amount_exceeded":"Twoja płatność została odrzucona lub w koszyku znajduje się produkt, który się wyprzedał.","adyen_error_message":"Twoja płatność została odrzucona.","Cannot set delivery method":"Nie można ustawić sposobu dostawy","Street and number":"Ulica i numer domu","mobile_10%_discount":"Rabat 10% na start","mobile_register_advert":"Zarejestruj konto klubowicza i ciesz się rabatem 10% na pierwsze zakupy.","mobile_make_order":"Zrealizuj zamówienie","mobile_set_discount":"Zastosuj zniżkę","mobile_add_coupon_code":"Dodaj kod rabatowy","mobile_add":"Dodaj","mobile_remove":"Usuń","mobile_user_login":"Logowanie użytkownika","mobile_no_products":"Brak produktów","mobile_confirm_password":"Potwierdź nowe hasło","mobile_must_contain_letter":"Musi zawierać przynajmniej jedną dużą literę","mobile_must_contain_special":"Przynajmniej jeden znak specjalny","mobile_must_contain_chars_amount":"8-20 znaków","mobile_must_contain_upper_letter":"Przynajmniej jedna cyfra i jedna mała litera","mobile_see_all":"Zobacz wszystkie z tej kategorii","mobile_got_account":"Posiadasz konto?","mobile_see_promotions":"Zobacz promocje","mobile_promotions_interested":"Być może zainteresują Cię nasze \\\\nnajnowsze promocje?","mobile_place_order":"Złóż zamówienie","mobile_profile_edition":"Edycja profilu","mobile_summary":"Podsumowanie","mobile_filter_sort":"Filtruj i sortuj","mobile_promotions":"Promocje","mobile_search_suggestion":"Sugestie dotyczące wyszukiwania","mobile_account_created":"Konto zostało utworzone. Sprawdź email","mobile_bestsellers":"Nasze bestsellery","mobile_filter_by":"Filtruj według","mobile_welcome_again":"Witamy ponownie!","mobile_login_to_continue":"Zaloguj się, aby kontynuować","mobile_sort_by":"Sortuj według","mobile_invoice_for_company":"Faktura dla firmy","mobile_edit_your_data":"Dokonaj edycji swoich danych","mobile_got_question":"W przypadku pytań zapoznaj się z naszym działem","mobile_customer_service":"Obsługi Klienta","mobile_send_to_same_address":"Wysyłka na ten sam adres","mobile_choose_shipping_method":"Wybierz sposób dostawy","mobile_your_email_address":"Twój adres email","mobile_order_data":"Dane zamówienia","mobile_register_and_use":"Zarejestruj konto i korzystaj","mobile_join_us":"Dołącz do nas!","mobile_register":"Załóż konto","mobile_change_data":"Zmiana Danych","mobile_epremia_discount":"-10%","mobile_epremia_points_info":"1 zł = 1 pkt","mobile_epremia_create_account":"Załóż konto Klubowicza","additional_promo_label":"Drugi -50%","Error with payment method":"Błąd z metodą płatności, proszę wybierz inną płatność","safety_description":"Ten produkt może być używany bezpiecznie i w sposób określony przez producenta wyłącznie w oparciu o instrukcje używania i konserwacji, zalecenia, ostrzeżenia lub informacje na temat bezpieczeństwa umieszczone na produkcie bądź jego opakowaniu lub dołączone do produktu.","safety_title":"Opis bezpieczeństwa"}');

/***/ }),

/***/ 9446:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Cod de reducere","Delete coupon code":"Șterge codul","AllProducts{{brandName}}":"Toate produsele {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Compusă de {{authorName}} de la {{authorProfileNick}}","Shop items below":"Vezi produsele de mai jos","Curated by":"Scris de","by":"de la","from":"din","from range":"de la","to range":"până la","More":"Mai mult","more":"mai mult","starting at":"încep de la","or":"sau","Login":"Autentificare","My account":"Contul meu","Free delivery":"Livrare gratuită","to free standard shipping":"pentru livrare gratuită","Shipping":"Livrare","Shipping method":"Metoda de livrare","Shipping address":"Adresa pentru livrare","Invoice data":"Date pentru factură","Billing same as shipping":"Adresa de facturare la fel ca adresa de livrare","Subtotal":"Valoarea coşului","Discounts":"Reduceri","Tax":"Taxa","Tax and Shipping are estimated for ":"Taxa și transportul sunt estimate pentru ","Tax included":"Inclusiv TVA","Total":"În total","Go to checkout":"Mergi la casă","Your cart":"Coşul tău","Collections":"Colecții","View details":"Afișează detaliile","Add to cart":"Spre coş","add to cart":"Adaugă în coş","More inspirations":"Mai multe inspirații","Recently viewed":"Vizualizate recent","Register":"Înregistrare","Sign Up":"Înregistraţi-vă","Sign Off":"Ieșire","Log in":"Autentificare","Log yourself":"Conectați-vă","of":"din","Technical data":"Date tehnice","Product description":"Descrierea produsului","Color":"Culoare","Size":"Dimensiuni","Story with":"Articol cu participarea","Inspirations":"Inspirații","Home":"Pagina principală","Arrivals by category":"Noutăți pe categorii","Already have an account?":"Aveți deja un cont?","Rodo_agreement {{domain}}":"Sunt de acord cu prelucrarea datelor mele cu caracter personal de către DAJAR sp. z o.o. în scopul efectuării de achiziții în magazinul online {{domain}}. Administratorul datelor cu caracter personal furnizate la efectuarea comenzii este DAJAR sp. z o.o. cu sediul în 75-072 Koszalin, ul. Połtawska 6. Vă informăm că fiecare dintre Clienții noștri are dreptul să acceseze, să rectifice, să șteargă, să limiteze prelucrarea, să se opună prelucrării datelor lor cu caracter personal și să transfere datele. Vă rugăm să trimiteți cererile dvs. la adresa de e-mail dpo@dajar.pl. Vă informăm, de asemenea, despre posibilitatea de a trimite o reclamație la organul de supraveghere în cazul utilizării neautorizate a datelor cu caracter personal. Consimțământul de mai sus poate fi retras în orice moment, în conformitate cu Articolul 23 punctul 1 subpunctul 1 al Legii din29 august 1997 privind Protecția Datelor cu Caracter Personal și Articolul 6 punctul 1a din Regulamentul UE 2016/679.","Password":"Parolă","First Name":"Prenume","Last Name":"Nume","First, last name":"Numele şi prenumele","Street":"Strada","City":"Orașul","Country":"Țara","Phone":"Telefon","Postal code":"Codul poștal","Company name":"Denumirea firmei","Vat ID":"Numărul TVA","Company":"Client firmă","Registration complete":"Contul a fost creat și autentificat","Required field":"Câmp obligatoriu","Required option":"Opțiunea trebuie bifată","Terms agreement":"Dacă doriți să vă înregistrați, trebuie să fiți de acord cu condițiile de utilizare ale serviciului web","Invalid email":"E-mail incorect","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.ro","Forgot password?":"Ați uitat parola?","Don\'t have an account?":"Nu aveţi cont?","All New in":"Toate Noutățile în","New arrivals":"Noutăţi","New arrival":"Noutate","Password match":"Parola trebuie să fie identică","No products in cart":"Nu aveți produse în coș.","Thank you, your order has been placed!":"Vă mulțumim, comanda dumneavoastră a fost plasată!","Completed order info":"Comanda este în curs de completare, vă vom informa despre expediere prin e-mail.","Back to home page":"Înapoi la pagina principală","come back to main categories":"Meniul principal","Needs help?":"Aveți nevoie de ajutor?","Show cart summary":"Sumarul coșului","Sign up for newsletter":"Abonați-vă la Newsletter","Subscribe to newsletter":"Abonați-vă","Sign off from newsletter":"Dezabonați-vă de la newsletter","Sign up for newsletter seo title":"Abonare la newsletter","Sign up for newsletter seo description":"Abonați-vă la newsletter-ul nostru. Informații despre produse și promoții noi","Sign off for newsletter seo title":"Dezabonați-vă de la newsletter","Sign off for newsletter seo description":"Vă puteți dezabona de la newsletter-ul nostru oricând","Sign up for newsletter success":"Verificați-vă e-mailul și confirmați înregistrarea.","Unsubscribe success":"Dezabonare reușită de la newsletter","Our bestsellers":"Produse populare","Shop the deals":"Ocazii","Popular categories":"Categorii populare","Out of stock":"Lipsă în stoc","Last items in stock":"Ultimele articole în stoc","Also from this collection":"Altele din această colecție","Complete the look":"Completează cu","Shop all{collectionName}}":"Vezi întreaga colecție {{collectionName}}","Catalog price":"Prețul din catalog:","Quantity":"Cantitate","Details":"Detalii","Saved addresses":"Adrese salvate","Contact":"Contact","Continue to payment":"Treceți la plată","Go back to cart":"Înapoi la coș","Go back to information":"Înapoi la informații","Create account":"Creează un cont","Payment method":"Metoda de plată","Payment":"Plată","Waiting for payment":"Se așteaptă plata","Payment complete":"Plata finalizată","cash on delivery":"Plata la livrare","bank transfer":"Transfer bancar","Newsletter description":"Rămâneți la curent. Primiți informații despre noutăți și oferte speciale.","Reset password":"Resetează parola","Reset password description":"Introduceți adresa de e-mail pentru a primi instrucțiuni despre cum să vă resetați parola.","Reset":"Resetează","Back to login":"Înapoi la autentificare","Newsletter agreement":"Sunt de acord cu prelucrarea datelor mele cu caracter personal de către DAJAR sp. z o.o. pentru a trimite informații comerciale de la DAJAR sp. z o.o. la adresa de e-mail furnizată. Administratorul datelor cu caracter personal furnizate la plasarea comenzii este DAJAR sp. z o.o. cu sediul la 75-072 Koszalin, ul. Połtawska 6. Vă informăm că fiecare dintre Clienții noștri are dreptul să acceseze, să rectifice, să șteargă, să limiteze prelucrarea, să se opună prelucrării datelor lor cu caracter personal și să transfere datele. Vă rugăm să trimiteți cererile dvs. la adresa de e-mail dpo@dajar.pl. Vă informăm, de asemenea, despre posibilitatea de a trimite o reclamație la organul de supraveghere în cazul utilizării neautorizate a datelor cu caracter personal. Consimțământul de mai sus poate fi retras în orice moment, în conformitate cu Articolul 23 punctul 1 subpunctul 1 al Legii din29 august 1997 privind Protecția Datelor cu Caracter Personal și Articolul 6 punctul 1a din Regulamentul UE 2016/679.","Place order":"Plasează comanda","See all":"Toate","Shop this story":"Produse recomandate","Recommended categories":"Categorii recomandate","Related stories":"Povești recomandate","I have coupon code":"Am un cod de reducere","Submit":"Trimite","price high to low":"Preț: de la cel mai mare","price low to high":"Preț: de la cel mai mic","sortByNameDesc":"Conform denumirii Z-A","sortByNameAsc":"Conform denumirii A-Z","recommended":"Recomandate","All orders":"Toate comenzile","Address book":"Agendă de contacte","Log out":"Deconectare","Last order":"Ultima comandă","Personal info":"Informații despre mine","My orders":"Comenzile mele","Account":"Cont","Orders":"Comenzi","Order":"Comandă","Order number":"Comanda nr.","Ongoing":"În desfășurare","Past orders":"Comenzile anterioare","Account password change description":"Faceți clic pe butonul din dreapta pentru a schimba parola.","Edit":"Editează","Change":"Modifică","Save":"Salvează","Old password":"Parola veche","New password":"Parola nouă","Continue shopping":"Continuă cumpărăturile","bonus ePoints":"puncte DAJAR ePremiu","Use":"Utilizează","Sale":"Reducere","Your order":"Comanda ta","Search":"Caută","See all suggestions ({{resultsLength}})":"Afișează toate rezultatele ({{resultsLength}})","Cancel":"Anulează","Sort":"Sortează","all filters":"toate filtrele","Clear":"Şterge","Filter":"Filtrează","select":"Selectează","selected":"marcate","Show result":"Afișează rezultatele","People also liked":"Vezi și","Popular searches":"Căutări populare","Read more":"Citește mai departe","capacity":"capacitate","diameter":"diametru","material":"material","size":"mărime","length":"lungime","color":"culoare","depth":"adâncime","width":"lăţime","height":"înălțime","shape":"formă","Search collections, products, etc...":"Caută produse, colecții etc...","Shop by Collection":"Colecții recomandate","Shop by Type":"Categorii de produse","show all":"afișează toate","show more":"afișează mai mult","show less":"afișează mai puțin","languages":"Limbi","Please login, your session expired.":"Autentificați-vă din nou, sesiunea dvs. a expirat.","pending":"acceptată pentru realizare","canceled":"Anulată","sending":"Pregătit pentru expediere","processing":"în prelucrare","complete":"Trimis","Delivered":"Livrat","Tracking number":"Numărul coletului","ready":"Gata","Track and trace":"Urmărirea coletului","Copy":"Copiază","Out for delivery":"În drum spre destinatar","Expect your package today":"Pachetul dvs. ar trebui să ajungă astăzi","Courier":"Curier","Change password":"Schimbă parola","Default seo description":"Mobilier de gradina si multe alte articole in magazinul online DAJAR.ro Casă & Grădină","Default seo description - register":"Mobilier de gradina si multe alte articole in magazinul online DAJAR.ro Casă & Grădină","Default seo title":"Magazinul DAJAR.ro - mobilier de grădină","Default seo title - register":"Magazinul DAJAR.ro - mobilier de grădină","search results":"Rezultatele căutării pentru \\"{{phrase}}\\"","page":"Pagina","rachunku":"Produse din categoria {{categoryName}} din magazinul DAJAR.ro. Vă invităm la cumpărături!","Accept terms":"Am citit / sunt și accept condițiile","Terms":"Condițiile generale de vânzare","Shipment":"Livrare","Cookie notice":"Bine ați venit la magazinul nostru DAJAR.ro.\\n\\nFolosim cookie-uri pentru a analiza traficul de pe site-ul DAJAR.ro, pentru a personaliza conținutul de pe site, pentru a afișa reclame personalizate și pentru a spori confortul utilizării site-ului nostru web. Dând clic pe „acceptați\\", ne informați că sunteți de acord cu plasarea cookie-urilor în browserul dvs. și, acolo unde este cazul, cu prelucrarea datelor conexe în aceste scopuri. Vă puteți gestiona consimțământul și îl puteți retrage oricând folosind setările din browserul dvs. Pentru mai multe informații, vă rugăm să consultați Politica noastră privind cookie-urile. ","Accept":"Accept","Default billing":"Adresa de facturare implicită","Default billing address":"Adresa de facturare implicită","Default shipping":"Adresa de livrare implicită","Default shipping address":"Adresa de livrare implicită","Is default shipping address?":"Adresa de livrare implicită?","Is default billing address?":"Adresa de facturare implicită?","Add new address":"Adăugați o nouă adresă","Not set":"Neadăugat","Default billing and shipping":"Adresa de facturare și livrare implicită","Product was added to cart":"Produsul a fost adăugat la coș","number of people":"Numărul persoanelor","Wrong street format":"Introduceți strada și numărul casei","New address":"Adresa nouă","Edit address":"Editați adresa","Error":"Eroare","Something went wrong":"Ceva nu a mers bine","Fill in the delivery details":"Completați datele pentru livrare","We don\'t ship to this country, sorry":"Nu trimitem în țara respectivă","This method is not available":"Aceasta metodă nu este disponibilă pentru datele alese","Incorrect phone number":"Numărul de telefon incorect","Incorrect VAT ID":"Numărul TVA incorect","Shipping same as billing":"Adresa livrării aceași ca cea de pe factură","As Company":"Cumpăr ca o firmă","Name or Company":"Numele cumpărătorului sau Denumirea firmei","Billing for":"Factura pentru","Choose pickup point":"","Deliver to company":"","Company address":"Adresa firmei","Search results | Dajar":"Rezultatele căutarii | DAJAR.ro","Address saved":"Adresa salvată","ePoints":"DAJAR ePremiu","Available ePoints":"Punctele disponibile DAJAR ePremiu","You can use these points with your next purchase":"Puteți să folosiți punctele DAJAR e Premiu la următoarele cumpărături","Learn more":"Află mai multe","ePoints earned":"Ați câștigat punctele DAJAR ePremiu","paid with ePoints":"S-a plătit cu punctele DAJAR ePremiu","Settlement of ePoints":"Decontarea punctelor DAJAR ePremiu","Added by administrator":"Adăugat de către administrator","Purchase invoice":"Factura de achiziție","Purchase canceled":"Achiziția anulată","Spent with order":"Cheltuit la comandă","Spent with order canceled":"Cheltuit la comandă anulat","Order cancelation":"Anularea comenzii","Max addresses reached":"Numărul maxim al adreselor salvate. Adresa n-a fost adăugată","Brexit":"","Pay less with ePoints":"Plătește mai putin cu DAJAR ePremiu","Delete ePoints":"Șterge punctele DAJAR ePremiu","ePoints (you have {{points}})":"ePremiu (aveți {{puncte}})","price":"Preț","Active":"Activ","Accept all cookies":"Acceptați toate","Confirm my settings":"Acceptați cele selectate","Manage cookie settings":"Lasă-mă să aleg…","Third party cookies":"Lista cookie-urilor","Back to cookie list":"Lista cookie-urilor","Show cookie list":"Afișați cookie-uri","Cookie name":"Denumire","Duration":"Durată","Type":"Tip","Required cookies description":"Cookie-uri de care avem nevoie pentru buna funcționare a magazinului nostru DAJAR.ro.","Analytic cookies description":"Acestea includ cookie-uri care ne ajută să analizăm și să monitorizăm traficul pe site-ul nostru DAJAR.ro. Ne oferă cunoștințe suplimentare pentru a ne îmbunătăți site-ul web.","Tracking cookies description":"Cookie-uri care ne permit să personalizăm și să măsurăm eficacitatea publicității noastre. Cu ajutorul lor","Necessary cookies":"Cookie-uri esențiale","Analytic cookies":"Cookie-uri analitice","Tracking cookies":"Urmărirea cookie-urilor","Third party":"Partea terță","day":"zi","days":"zile","years":"ani","minute":"minut","minutes":"minute","month":"lună","months2":"luni","months":"luni","year":"an","session":"sesiune","hour":"ora","Own":"Propriu","Too many points provided":"S-au introdus prea multe puncte","Last name must be different then first name":"Prenume trebuie să difere de nume","Additonal fee":"Cost suplimentar","price catalog high to low":"Prețul din catalog: descendent","price catalog low to high":"Prețul din catalog: ascendent","Additional information":"Informații suplimentare","Length [cm]":"Lungime","Width [cm]":"Lățime","Shape":"Formă","Producer":"Producător","Height [cm]":"înălțime","Depth [cm]":"Adâncime","Capacity [ml]":"Capacitate [ml]","Number of people":"număr de persoane","Dajar collection":"Colecția","Material":"Material","Application":"Utilizare","Diameter [cm]":"Diametru","Color list":"Culoare","Pattern list":"Model decor","Feature":"Funcție","Composition":"Compoziția țesăturii","Max load":"Sarcina maximă suportată [kg]","Capacity [l]":"Capacitate [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Greutate [kg]","Help":"Ajutor","The product is no longer available":"Produsul nu mai este disponibil","Remove it from the cart or reduce the quantity ":"Vă rugăm să-l ștergeți din coș sau să diminuați cantitatea","The product will be available":"Produsul va fi disponibil","product available in different variant":"product available in different variant","Possible service failure. Please wait a moment and try again":"Posibila avarie a portalului. Vă rugăm să așteptați și să incercați din nou","Page not found":"Pagina solicitată nu poate fi găsită","Go to home page":"Treceți pe pagina principală","Check recently viewed":"Verificați cele vizualizate recent","Do not hesitate":"Nu amânați cumpărăturile, adăugarea unor produse în coș nu înseamnă rezervarea acestora.","Save new address":"Salvează","Other address":"Other address","Subscribe to the newsletter":"Abonare la newsletter","And get even 20% off":"And get even 5% off","Subscribe":"Abonați-vă","Subscribe to our newsletter":"Înscrieți-vă la buletinul nostru informativ","And get even 10% off":"Obțineți chiar și 5% reducere","Cart":"Coş","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"Nu sunt comenzi","Are you sure you want to remove this address?":"Sigur dorești să ștergi adresa?","Password saved":"Parolă salvată","Firstname and Lastname saved":"Nume și prenume salvate","Address deleted":"Adresă eliminată","Yes":"Da","No":"Nu","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Din betalning behandlas. Vi skickar ett e-postmeddelande med status för din beställning.","Thank you for your purchase":"Vă mulțumim pentru comanda dumneavoastră!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Preț de referință","Promo code was added to clipboard":"Codul promoțional a fost copiat","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Produsul a fost adăugat în lista de dorințe","Removed from wishlist":"Produsul a fost eliminat din lista de dorințe","Product on wishlist":"Produsul este pe lista de dorințe","Wishlist inactive tooltip":"Conectează-te pentru a adăuga un produs la lista de dorințe","Wishlist":"Lista de dorințe","Add visible to cart":"Adaugă produsele vizibile în coș","Wishlist products added to cart":"Articolele disponibile din lista de dorințe au fost adăugate în coșul de cumpărături","No products in the wishlist":"Nu există produse în lista de dorințe","Hit of the day":"Hitul zilei","Only {{qty}} left in stock":"Rămân {{qty}} bucăți","Offer ends":"Oferta se încheie în:","hours hit":"ore","minutes hit":"minute","seconds hit":"secunde","sold out":"epuizat","left hits":"rămase","sold hits":"vândute","Offer start":"O nouă ofertă va începe în","Available qty for person in hit {{qty}}":"Puteți cumpăra maxim {{qty}} bucăți per persoană","Outlet":"Reduceri","Hit of the week":"Hitul săptămânii","Hit of the month":"Hitul lunii","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Ofertă specială!","Check out this great deal":"Verifică această ofertă grozavă","A new unique offer every day":"O nouă ofertă unică în fiecare zi","Change parcel":"","card":"Plată cu cardul","banktransfer":"Transfer bancar tradițional","cashondelivery":"Plată în numerar","dialcom_przelewy":"Transfer rapid","bluepayment":"Transfer rapid","blik":"Cod BLIK","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"Introduceți codul BLIK din aplicația băncii dvs.","applepay_info":"Faceți clic pentru a plăti comanda","googlepay_info":"Faceți clic pentru a plăti comanda","paypal_info":"Ați selectat PayPal. După clic pe Plătește","bluepayment_info":"Ați selectat Autopay. După clic pe Plătește","klarna_info":"A fost selectată plata cu Klarna.<br />După ce faceți clic, veți fi redirecționat către o pagină care permite efectuarea în siguranță a următorilor pași.","banktransfer_info":"Ați selectat plata prin transfer bancar. După clic pe Plătește","cashondelivery_info":"Ați selectat plata la livrare. Veți plăti comanda în numerar curierului la livrare.","The payment is REFUSED.":"Plata a eșuat.","Payment refused. Choose payment method and retry":"Selectați o metodă de plată și încercați din nou","Finish payment":"Finalizați plata","klarna_paynow_button_label":"Plătește acum cu Klarna","klarna_paylater_button_label":"Plătește în 30 de zile cu Klarna","klarna_account_button_label":"Plătește în rate cu Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Plata dumneavoastră a fost refuzată sau există un produs în coșul dumneavoastră care nu mai este în stoc.","adyen_error_message":"Plata dumneavoastră a fost respinsă.","Cannot set delivery method":"Nu se poate seta metoda de livrare","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Acest produs poate fi utilizat în siguranță și conform destinației producătorului numai în baza instrucțiunilor de utilizare și întreținere, recomandărilor, avertismentelor sau informațiilor privind siguranța furnizate pe produs, pe ambalajul acestuia sau incluse împreună cu produsul.","safety_title":""}');

/***/ }),

/***/ 61385:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Rabattkod","Delete coupon code":"Ta bort koden","AllProducts{{brandName}}":"Alla produkter {{brandName}}","Curated by {{authorName}} from {{authorProfileNick}}":"Skapad av {{authorName}} från {{authorProfileNick}}","Shop items below":"Kolla produkter nedan","Curated by":"Kuraterad av","by":"av","from":"av","from range":"av","to range":"till","More":"Mer","more":"mer","starting at":"börjar från","or":"eller","Login":"Logga in","My account":"Mitt konto","Free delivery":"Fri frakt","to free standard shipping":"till fri frakt","Shipping":"Frakt","Shipping method":"Leveranssätt","Shipping address":"Leveransadress","Invoice data":"Fakturauppgifter","Billing same as shipping":"Samma faktureringsadress som leveransadress","Subtotal":"Totalt","Discounts":"Rabatter","Tax":"Moms","Tax and Shipping are estimated for ":"Moms och frakt beräknas för","Tax included":"Skatt ingår","Total":"Totalt","Go to checkout":"Gå till kassan","Your cart":"Din varukorg","Collections":"Kollektioner","View details":"Visa detaljer","Add to cart":"Lägg till i varukorgen","add to cart":"lägg till i varukorgen","More inspirations":"Mer inspirationer","Recently viewed":"Nyss sedda","Register":"Registrering","Sign Up":"Bli Medlem","Sign Off":"Radera medlemskapet","Log in":"Logga in","Log yourself":"logga in","of":"av","Technical data":"Teknisk specifikation","Product description":"Produktbeskrivning","Color":"Färg","Size":"Storlek","Story with":"","Inspirations":"Inspirationer","Home":"Hem","Arrivals by category":"Nyheter per kategori","Already have an account?":"Har du redan ett konto?","Rodo_agreement {{domain}}":"Jag godkänner behandlingen av mina personuppgifter av DAJAR sp.z o.o. för att göra inköp i {{domain}} onlinebutik. Administratören av personuppgifter som tillhandahålls vid beställningen är DAJAR sp.z o.o. med huvudkontor i 75-072 Koszalin, ul. Połtawska 6. Observera att var och en av våra kunder har rätt att komma åt, korrigera, radera, begränsa behandlingen, göra invändningar mot behandlingen av sina personuppgifter och överföra data. Skicka dina ansökningar till e-postadressen dpo@dajar.pl. Vi informerar dig också om möjligheten att lämna in ett klagomål till tillsynsorganet vid obehörig användning av personuppgifter. Ovanstående samtycke kan återkallas när som helst på grundval av artikel 23 punkt 1 punkt 1 i lagen av den 29 augusti 1997 om skydd av personuppgifter och artikel 6 punkt 1a i EU-förordningen 2016/679.","Password":"Lösenord","First Name":"Förnamn","Last Name":"Efternamn","First, last name":"Förnamn och Efternamn","Street":"Gata","City":"Stad","Country":"Land","Phone":"Mobil","Postal code":"Postnummer","Company name":"Företagsnamn","Vat ID":"Momsregistreringsnummer","Company":"Företag","Registration complete":"Registreringen har slutförts","Required field":"Obligatoriskt fält","Required option":"Obligatoriskt alternativ","Terms agreement":"Om du vill registrera dig måste du acceptera användarvillkoren","Invalid email":"Ogiltig e-postadress","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.se","Forgot password?":"Har du glömt ditt lösenord?","Don\'t have an account?":"Har du inget konto?","All New in":"Alla nyheter i","New arrivals":"Nyheter","New arrival":"Nyheter","Password match":"Lösenordet måste vara detsamma","No products in cart":"Varukorgen är tom","Thank you, your order has been placed!":"Tack, din beställning har lagts!","Completed order info":"Beställningen är pågående vi kommer att informera dig om leveransdetaljerna via e-post.","Back to home page":"Gå tillbaka till hemsidan","come back to main categories":"Tillbaka till huvudkategorier","Needs help?":"Behöver du hjälp?","Show cart summary":"Sammanfattning","Sign up for newsletter":"Registrera dig för vårt nyhetsbrev","Subscribe to newsletter":"Registrera dig ","Sign off from newsletter":"Sluta prenumerera på vårt nyhetsbrev","Sign up for newsletter seo title":"Registrering för vårt nyhetsbrev","Sign up for newsletter seo description":"Registrera dig för vårt nyhetsbrev. Informationer om nya produkter och rea","Sign off for newsletter seo title":"Sluta prenumerera på vårt nyhetsbrev","Sign off for newsletter seo description":"Du kan sluta prenumerera på vårt nyhetsbrev när som helst","Sign up for newsletter success":"Kontrollera din e-post och bekräfta registreringen.","Unsubscribe success":"Du har avslutat prenumerationen på vårt nyhetsbrev","Our bestsellers":"Populära produkter","Shop the deals":"Erbjudanden","Popular categories":"Populära kategorier","Out of stock":"Slut i lager","Last items in stock":"Sista varan i lager","Also from this collection":"Andra produkter i kollektionen","Complete the look":"Komplettera med","Shop all{collectionName}}":"Kolla hela kollektionen {{collectionName}}","Catalog price":"Katalogpriset","Quantity":"Antal","Details":"Detaljer","Saved addresses":"Sparade adresser","Contact":"Kontakt","Continue to payment":"Gå till betalning","Go back to cart":"Gå tillbaka till varukorgen","Go back to information":"Gå tillbaka till informationen","Create account":"Skapa ett konto","Payment method":"Betalningssätt","Payment":"Betalning","Waiting for payment":"Inväntar betalning","Payment complete":"Betalningen har slutförts","cash on delivery":"postförskott","bank transfer":"Banköverföring","Newsletter description":"Håll dig uppdaterad. Få information om nya produkter och erbjudanden.","Reset password":"Återställ lösenordet","Reset password description":"Ange din e-postadress för att få instruktioner om hur du återställer ditt lösenord.","Reset":"Återställ","Back to login":"Gå tillbaka till inloggningssida","Newsletter agreement":"Jag godkänner behandlingen av mina personuppgifter av DAJAR sp.z o.o. för att göra inköp i DAJAR.pl onlinebutik. Administratören av personuppgifter som tillhandahålls vid beställningen är DAJAR sp.z o.o. med huvudkontor i 75-072 Koszalin, ul. Połtawska 6. Observera att var och en av våra kunder har rätt att komma åt, korrigera, radera, begränsa behandlingen, göra invändningar mot behandlingen av sina personuppgifter och överföra data. Skicka dina ansökningar till e-postadressen dpo@dajar.pl. Vi informerar dig också om möjligheten att lämna in ett klagomål till tillsynsorganet vid obehörig användning av personuppgifter. Ovanstående samtycke kan återkallas när som helst på grundval av artikel 23 punkt 1 punkt 1 i lagen av den 29 augusti 1997 om skydd av personuppgifter och artikel 6 punkt 1a i EU-förordningen 2016/679.","Place order":"Lägg en beställning","See all":"Alla","Shop this story":"Rekommenderade produkter","Recommended categories":"Rekommenderade kategorier","Related stories":"","I have coupon code":"Jag har en rabattkod","Submit":"Skicka","price high to low":"Pris: från det högsta","price low to high":"Pris: från det minsta","sortByNameDesc":"Efter namn Z-A","sortByNameAsc":"Efter namn A-Z","recommended":"Rekommenderade","All orders":"Alla beställningar","Address book":"Adressbok","Log out":"Logga ut","Last order":"Senaste beställning","Personal info":"Uppgifter om mig","My orders":"Mina beställningar","Account":"Konto","Orders":"Beställningar","Order":"Beställning","Order number":"Beställning nummer","Ongoing":"Pågående","Past orders":"Föregående beställning","Account password change description":"Klicka på knappen till höger för att ändra lösenordet.","Edit":"Redigera","Change":"Ändra","Save":"Spara","Old password":"Gammalt lösenord","New password":"Nytt lösenord","Continue shopping":"Fortsätt handla","bonus ePoints":"DAJAR-poänger","Use":"Använd","Sale":"Rabatt","Your order":"Din beställning","Search":"Sök","See all suggestions ({{resultsLength}})":"Visa alla resultat ({{resultsLength}})","Cancel":"Annullera","Sort":"Sortera","all filters":"alla filter","Clear":"Rensa","Filter":"Filtera","select":"Välj","selected":"markerade","Show result":"Visa resultat","People also liked":"Kolla också","Popular searches":"Populära sökningar","Read more":"Fortsätt läsa","capacity":"kapacitet","diameter":"diameter","material":"material","size":"storlek","length":"längd","color":"färg","depth":"djuphet","width":"bredd","height":"höjd","shape":"form","Search collections, products, etc...":"Sök efter produkter, kollektioner osv ...","Shop by Collection":"Rekommenderade Kollektioner","Shop by Type":"Produktkategori","show all":"visa alla ","show more":"visa mer","show less":"visa mindre","languages":"Språk","Please login, your session expired.":"Logga in igen din session har gått ut.","pending":"Pågående","canceled":"Annullerad","sending":"Redo att skickas","processing":"behandlas","complete":"Skickad","Delivered":"Levererad","Tracking number":"Spårningsnummret","ready":"Färdigt","Track and trace":"Spårning av försändelse","Copy":"Kopiera","Out for delivery":"Ut för leverans","Expect your package today":"Leveransen är planerad för idag","Courier":"Fraktbolag","Change password":"Ändra lösenordet","Default seo description":"Välkommen till DAJAR.se. Vi erbjuder trädgårdsmöbler, kuddar och hammockar. I vår butik ingår även porslin, bestick, kastruller, stekpannor, matserviser och glas.","Default seo description - register":"Välkommen till DAJAR.se. Vi erbjuder trädgårdsmöbler, kuddar och hammockar. I vår butik ingår även porslin, bestick, kastruller, stekpannor, matserviser och glas.","Default seo title":"DAJAR.se - trädgårdsmöbler och porslin","Default seo title - register":"DAJAR.se - trädgårdsmöbler och porslin","search results":"Sökresultat för \\"{{phrase}}\\"","page":"Sida","rachunku":"Produkter i kategori {{categoryName}} i DAJAR.se. Njut av din shopping!","Accept terms":"Jag har läst och accepterat","Terms":"villkoren","Shipment":"Leverans","Cookie notice":"Välkommen till vår DAJAR.se-butik.\\nVi använder cookies för att analysera trafik på DAJAR.se, anpassa innehållet på webbplatsen, visa skräddarsydda annonser och öka komforten med att använda vår webbplats. Genom att klicka på \\"\\"godkänn\\"\\" informerar du oss om att du samtycker till att vi placerar cookies i din webbläsare och i förekommande fall behandling av relaterad information för dessa ändamål. Du kan hantera ditt samtycke och dra tillbaka det när som helst med hjälp av inställningarna i din webbläsare. För mer information, se vår cookiepolicy. ","Accept":"Godkänn","Default billing":"Standard faktureringsadress","Default billing address":"Standard faktureringsadress","Default shipping":"Standard leveransadress","Default shipping address":"Standard leveransadress","Is default shipping address?":"Är detta standard leveransadressen?","Is default billing address?":"Är detta standard faktureringsadressen?","Add new address":"Lägg till en ny adress","Not set":"Inte tillagd","Default billing and shipping":"\\nStandard fakturerings- och leveransadress","Product was added to cart":"\\nProdukten har lagts till i kundvagnen","number of people":"avsedd för detta antal personer","Wrong street format":"Ange gatunamn och husnummer","New address":"Ny adress","Edit address":"Redigera adress","Error":"Fel","Something went wrong":"Något gick fel.","Fill in the delivery details":"Fyll i leveransinformation.","We don\'t ship to this country, sorry":"Vi beklagar men vi skickar inte till det här landet.","This method is not available":"Denna metod är inte tillgänglig.","Incorrect phone number":"Ogiltigt telefonnummer","Incorrect VAT ID":"Felaktigt momsregisteringsnummer","Shipping same as billing":"Samma leveransadress som på fakturan","As Company":"Företag","Name or Company":"Privat person eller företag","Billing for":"Faktura till","Choose pickup point":"","Deliver to company":"","Company address":"?","Search results | Dajar":"Sökresultat | DAJAR.se","Address saved":"Adressen har sparats","ePoints":"DAJAR - poänger","Available ePoints":"Tillgängliga DAJAR-poänger","You can use these points with your next purchase":"Du kan använda DAJAR-poänger vid nästa köp","Learn more":"Läs mer","ePoints earned":"Du har fått nya DAJAR - poänger","paid with ePoints":"Du har betalat med DAJAR-poänger","Settlement of ePoints":"Lösning av DAJAR-poänger","Added by administrator":"Tillagt av administratören","Purchase invoice":"Faktura","Purchase canceled":"Ordern har annullerats","Spent with order":"Använts vid order","Spent with order canceled":"Användning av DAJAR-poänger har annullerats","Order cancelation":"Annullering av order","Max addresses reached":"Maximalt antal lagrade adresser. Adressen har inte lagts till","Brexit":"","Pay less with ePoints":"Betala mindre med DAJAR-poänger","Delete ePoints":"Ta bort DAJAR-poänger","ePoints (you have {{points}})":"Poänger (du har {{poänger}})","price":"Pris","Active":"Aktiv","Accept all cookies":"Godkänn allt","Confirm my settings":"Godkänn markerade","Manage cookie settings":"Låt mig välja…","Third party cookies":"Lista över cookies","Back to cookie list":"Lista över cookies","Show cookie list":"Visa cookies","Cookie name":"Namn","Duration":"Varaktighet","Type":"Typ","Required cookies description":"Cookies som vi behöver för att vår DAJAR.se-butik ska fungera korrekt.","Analytic cookies description":"De inkluderar cookies som hjälper oss att analysera och övervaka trafik på vår webbplats DAJAR.se. Det ger oss ytterligare kunskap för att förbättra vår webbplats för dig. ","Tracking cookies description":"Cookies som gör att vi kan anpassa och mäta effektiviteten i vår reklam. Med deras hjälp presenterar vi dig den information som är mest relevant för dig.","Necessary cookies":"Viktiga cookies","Analytic cookies":"Analytiska cookies","Tracking cookies":"Spåra cookies","Third party":"Tredje part ","day":"dag","days":"dagar","years":"år","minute":"minut","minutes":"minuter","month":"månad","months2":"månader","months":"månader","year":"år","session":"session","hour":"timme","Own":"Own","Too many points provided":"För många poänger har angetts","Last name must be different then first name":"Förnamn kan inte vara samma som Efternamn","Additonal fee":"Extra avgift","price catalog high to low":"Katalogpriset: från det högsta","price catalog low to high":"Katalogpriset: från det minsta","Additional information":"Ytterligare information","Length [cm]":"Längd [cm]","Width [cm]":"Bredd [cm]","Shape":"Form","Producer":"Tillverkare","Height [cm]":"Höjd [cm]","Depth [cm]":"Djup [cm]","Capacity [ml]":"Rymd [ml]","Number of people":"Antal personer","Dajar collection":"Kollektion","Material":"Material","Application":"Lämplig för","Diameter [cm]":"Diameter [cm]","Color list":"Färg","Pattern list":"Mönster","Feature":"Egenskap","Composition":"Sammansättning","Max load":"Max belastning [kg]","Capacity [l]":"Rymd [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Vikt [kg]","Help":"Kundservice","The product is no longer available":"Produkten är inte längre tillgänglig","Remove it from the cart or reduce the quantity ":"Ta bort den från varukorgen eller minska mängden","The product will be available":"Produkten kommer snart att vara tillgänglig","product available in different variant":"produkt tillgänglig i annan variant","Possible service failure. Please wait a moment and try again":"Möjligt servicefel. Vänta ett tag och försök igen","Page not found":"Sidan hittas inte","Go to home page":"Gå till hemsidan","Check recently viewed":"Kontrollera nyligen visade sidor","Do not hesitate":"Tveka inte att köpa, att lägga varor i varukorgen betyder inte att de ska bokas","Save new address":"Spara","Other address":"Other address","Subscribe to the newsletter":"Registrering för vårt nyhetsbrev","And get even 20% off":"Få till och med 5% rabatt","Subscribe":"Prenumerera på","Subscribe to our newsletter":"Anmäl dig till vårt nyhetsbrev","And get even 10% off":"Få till och med 5% rabatt","Cart":"Varukorg","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"Du har inga beställningar","Are you sure you want to remove this address?":"Är du säker på att du vill ta bort adressen?","Password saved":"Lösenordet har sparats","Firstname and Lastname saved":"Namn och Efternamn har sparats","Address deleted":"Adressen har tagits bort","Yes":"Ja","No":"Nej","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Din betalning behandlas. Vi skickar ett e-postmeddelande med status för din beställning.","Thank you for your purchase":"Tack för din beställning!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Referenspriset","Promo code was added to clipboard":"Rabattkoden har kopieras","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Produkten har lagts till i din önskelista","Removed from wishlist":"Produkten har tagits bort från önskelistan","Product on wishlist":"Produkten finns på din önskelista","Wishlist inactive tooltip":"Logga in för att lägga till produkten i din önskelista","Wishlist":"Önskelista","Add visible to cart":"Lägg till synliga produkter i din korg","Wishlist products added to cart":"Tillgängliga produkter från önskelistan har lagts till i din korg","No products in the wishlist":"Inga produkter på önskelistan","Hit of the day":"Dagens hit","Only {{qty}} left in stock":"Återstår {{qty}} stycken","Offer ends":"Erbjudandet löper ut om:","hours hit":"timmar","minutes hit":"minuter","seconds hit":"sekunder","sold out":"slutsåld","left hits":"återstår","sold hits":"sålda","Offer start":"Nytt erbjudande börjar om","Available qty for person in hit {{qty}}":"Du kan köpa max {{qty}} stycken per person","Outlet":"Rea","Hit of the week":"Veckans hit","Hit of the month":"Månadens hit","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Specialerbjudande!","Check out this great deal":"Kolla in detta fantastiska erbjudande","A new unique offer every day":"Ett nytt unikt erbjudande varje dag","Change parcel":"","card":"Kortbetalning","banktransfer":"Traditionell överföring","cashondelivery":"Kontant","dialcom_przelewy":"Snabböverföring","bluepayment":"Snabböverföring","blik":"BLIK-kod","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"Ange BLIK-koden fran din banks app","applepay_info":"Klicka för att betala beställningen","googlepay_info":"Klicka för att betala beställningen","paypal_info":"PayPal valt. Efter att ha klickat pa Betala blir du omdirigerad till en sida där du säkert kan genomföra nästa steg.","bluepayment_info":"Autopay valt. Efter att ha klickat pa Betala blir du omdirigerad till en sida där du säkert kan genomföra nästa steg.","klarna_info":"Klarna-betalning vald.<br />Efter att ha klickat kommer du att omdirigeras till en sida som möjliggör säkert genomförande av nästa steg.","banktransfer_info":"Betalning via banköverföring vald. Efter att ha klickat pa Betala far du ett e-postmeddelande med kontouppgifter för överföringen.","cashondelivery_info":"Betalning vid leverans vald. Du betalar för beställningen kontant till kuriren vid leverans.","The payment is REFUSED.":"Betalningen misslyckades.","Payment refused. Choose payment method and retry":"Välj en betalningsmetod och försök igen","Finish payment":"Slutför betalningen","klarna_paynow_button_label":"Betala nu med Klarna","klarna_paylater_button_label":"Betala om 30 dagar med Klarna","klarna_account_button_label":"Betala på avbetalning med Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Din betalning har avslagits, eller så finns det en vara i din kundvagn som är slutsåld.","adyen_error_message":"Din betalning har avvisats.","Cannot set delivery method":"Leveransmetod kan inte ställas in","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Den här produkten kan användas säkert och enligt tillverkarens avsikt endast i enlighet med bruks- och underhållsanvisningar, rekommendationer, varningar eller säkerhetsinformation som finns på produkten, dess förpackning eller som medföljer produkten.","safety_title":""}');

/***/ }),

/***/ 48123:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Discount code":"Zľavový kód","Delete coupon code":"Vymazať kód","AllProducts{{brandName}}":"Všetky produkty {{brandname}}","Curated by {{authorName}} from {{authorProfileNick}}":"Vytvorená {{authorName}} od {{authorProfileNick}}","Shop items below":"Prezrite si produkty nižšie","Curated by":"Pod dohľadom","by":"od","from":"z","from range":"od","to range":"do","More":"Viac","more":"viac","starting at":"začíná od","or":"alebo","Login":"Prihlásenie","My account":"Môj účet","Free delivery":"Doprava zadarmo","to free standard shipping":"do dopravy zadarmo","Shipping":"Doprava","Shipping method":"Spôsob dopravy","Shipping address":"Doručovacia adresa","Invoice data":"Údaje pre faktúru","Billing same as shipping":"Fakturačná adresa je rovnaká ako doručovacia adresa","Subtotal":"Obsah košíka","Discounts":"Zľavy","Tax":"DPH","Tax and Shipping are estimated for ":"Daň a doprava sa odhadujú na","Tax included":"Vrátane DPH","Total":"Celkom","Go to checkout":"K pokladni","Your cart":"Váš košík","Collections":"Séria","View details":"Podrobnosti","Add to cart":"Do košíku","add to cart":"Pridaj do košíka","More inspirations":"Viac inšpirácií","Recently viewed":"Naposledy prezerané","Register":"Registrácia","Sign Up":"Zaregistrujte sa","Sign Off":"Odhlásiť","Log in":"Prihlásenie","Log yourself":"Prihláste sa","of":"z","Technical data":"Technické údaje","Product description":"Popis produktu","Color":"Farba","Size":"Rozmery","Story with":"Článok s účasťou","Inspirations":"Inšpirácie","Home":"Hlavná strana","Arrivals by category":"Novinky podľa kategórií","Already have an account?":"Máte už konto?","Rodo_agreement {{domain}}":"Súhlasím so spracovaním mojich osobných údajov spoločnosťou DAJAR sp.z o.o. za účelom nákupu v internetovom obchode {{domain}}. Správcom osobných údajov poskytnutých pri zadávaní objednávky je DAJAR sp.z o.o. hlavné sídlo: Polsko, 75-072 Koszalin, ul. Połtawska 6. Upozorňujeme, že každý z našich klientov má právo na prístup, opravu, odstránenie a obmedzení spracovania. Klient má právo namietať proti spracovaniu svojich osobných údajov a prenosu dát a to emailom na e-mailovú adresu dpo@dajar.pl. Tiež vás informujeme o možnosti podať sťažnosť dozornému orgánu v prípade neoprávneného použitia osobných údajov. Vyššie uvedený súhlas možno kedykoľvek odvolať na základe poľského zákonníka čl. 23 ods. 1 bode 1 zákona z 29. augusta 1997 o ochrane osobných údajov a čl. 6 ods. 1a nariadenia EÚ 2016/679. ","Password":"Heslo","First Name":"Meno","Last Name":"Priezvisko","First, last name":"Meno a prizvisko","Street":"Ulica+číslo popisné","City":"Mesto","Country":"Krajina","Phone":"Telefon","Postal code":"PSČ","Company name":"Názov firmy","Vat ID":"IČ DPH","Company":"Spoločnost","Registration complete":"Registrácia a prihlásenie dokončené","Required field":"Povinné pole","Required option":"Vybraná možnosť musí byť zaškrtnutá","Terms agreement":"Ak sa chcete zaregistrovať, musíte súhlasiť s podmienkami používania tejto webovej stránky","Invalid email":"Chybný email","© 2019 DAJAR All rights reserved.":"© 2022 DAJAR.sk","Forgot password?":"Zabudli ste heslo?","Don\'t have an account?":"Nemáte konto?","All New in":"Všetky novinky v","New arrivals":"Novinky ","New arrival":"Novinky ","Password match":"Heslo musí byť rovnaké","No products in cart":"V košíku nemáte žiadne produkty","Thank you, your order has been placed!":"Ďakujeme, Vaša objednávka je prijatá","Completed order info":"Objednávka je v realizácii, o odoslaní budete informovaní emailom.","Back to home page":"Návrat na hlavnú stranu","come back to main categories":"Hlavné menu","Needs help?":"Potrebujete pomoc?","Show cart summary":"Zhrnutie košíka","Sign up for newsletter":"Zapíšte sa k odberu Newsletter","Subscribe to newsletter":"Zapište sa","Sign off from newsletter":"Odhláste Newsletter","Sign up for newsletter seo title":"Zapiš do Newsletter","Sign up for newsletter seo description":"Prihláste sa k odberu nášho Newsletter. Informácie o nových produktoch a akciách","Sign off for newsletter seo title":"Odhláste Newsletter","Sign off for newsletter seo description":"Z odberu nášho Newsletter sa môžete kedykoľvek odhlásiť\\n","Sign up for newsletter success":"Skontrolujte svoj e-mail a potvrďte registráciu. ","Unsubscribe success":"Úspešné odhlásenie z odberu Newsletter","Our bestsellers":"Populárné produkty","Shop the deals":"Príležitosť","Popular categories":"Populárné kategorie","Out of stock":"Nie je na sklade","Last items in stock":"Posledné kusy skladom","Also from this collection":"Iné z tejto série","Complete the look":"Doplňte","Shop all{collectionName}}":"Pozrite sa na celú sériu {{collectionName}}","Catalog price":"Katalógová cena:","Quantity":"Množstvo","Details":"Detail","Saved addresses":"Uložené adresy","Contact":"Kontakt","Continue to payment":"Prejsť k platbe","Go back to cart":"Zpať do košíka","Go back to information":"Zpať k informáciam","Create account":"Vytvorit konto","Payment method":"Spôsob platby","Payment":"Platba","Waiting for payment":"Čakáme na platbu","Payment complete":"Platba dokončená","cash on delivery":"Dobierka-platba u kuriéra","bank transfer":"Bežný prevod","Newsletter description":"Buďte v obraze. Získajte informácie o nových produktoch a výpredajoch.","Reset password":"Obnoviť heslo","Reset password description":"Zadajte svoju e-mailovú adresu a dostanete pokyny, ako obnoviť heslo.","Reset":"Resetuj","Back to login":"Návrat na prihlásenie","Newsletter agreement":"Súhlasím so spracovaním mojich osobných údajov spoločnosťou DAJAR sp.z o.o. za účelom zasielania obchodných informácií od DAJAR sp.z o.o. na mnou uvedenú e-mailovú adresu. Správcom osobných údajov poskytnutých pri zadávaní objednávky je DAJAR sp.z o.o. hlavné sídlo: Polsko, 75-072 Koszalin, ul. Połtawska 6. Upozorňujeme, že každý z našich klientov má právo na prístup, opravu, odstránenie a obmedzení spracovania. Klient má právo namietať proti spracovaniu svojich osobných údajov a prenosu dát a to emailom na e-mailovú adresu dpo@dajar.pl. Tiež vás informujeme o možnosti podať sťažnosť dozornému orgánu v prípade neoprávneného použitia osobných údajov. Vyššie uvedený súhlas možno kedykoľvek odvolať na základe poľského zákonníka čl. 23 ods. 1 bode 1 zákona z 29. augusta 1997 o ochrane osobných údajov a čl. 6 ods. 1a nariadenia EÚ 2016/679. \\n","Place order":"Vytvoriť objednávku","See all":"Pozrite všetko","Shop this story":"Doporučené produkty","Recommended categories":"Doporučené kategórie","Related stories":"Súvisiace z histórie","I have coupon code":"Mám zľavový kód","Submit":"Odoslať","price high to low":"Cena: od najvyššej","price low to high":"Cena: od najnižšiej","sortByNameDesc":"Podľa názvu Z-A","sortByNameAsc":"Podľa názvu A-Z","recommended":"Odporúčame","All orders":"Všetky objednávky","Address book":"Zoznam adres","Log out":"Odhlásenie","Last order":"Posledné objednávky","Personal info":"Personálne informácie","My orders":"Moje objednávky","Account":"Konto","Orders":"Objednávky","Order":"Objednávka","Order number":"Objednávka číslo","Ongoing":"V priebehu","Past orders":"Predchádzajúce objednávky","Account password change description":"Pre zmenu hesla, kliknite na pravé tlačidlo","Edit":"Editovat","Change":"Zmeň","Save":"Uložiť","Old password":"Staré heslo","New password":"Nové heslo","Continue shopping":"Pokračovať v nákupe","bonus ePoints":"bodov Dajar ePremia","Use":"Použiť","Sale":"Zľava","Your order":"Vaša objednávka","Search":"Hľadaj","See all suggestions ({{resultsLength}})":"Zobraziť všetky výsledky ({{resultsLength}})","Cancel":"Zrušiť","Sort":"Filtruj","all filters":"Všetky filtry","Clear":"Vyčistiť","Filter":"Filtruj","select":"Vyber","selected":"Vybraté","Show result":"Ukázať výsledky","People also liked":"Pozrite sa tiež","Popular searches":"Populárne vyhľadávania","Read more":"Čítať ďalej","capacity":"Objem","diameter":"Priemer","material":"Materiál","size":"Rozmery","length":"Dľžka","color":"Farba","depth":"Hľbka","width":"Šírka","height":"Výška","shape":"Tvar","Search collections, products, etc...":"Hladaj produkty, série, atd...","Shop by Collection":"Odporúčané série","Shop by Type":"Kategórie produktov","show all":"Ukáž všetko","show more":"Ukáž viac","show less":"Ukáž menej","languages":"Jazyky","Please login, your session expired.":"Prihláste sa znova, vaša relácia vypršala.","pending":"Prijaté do realizácie","canceled":"Zrušené","sending":"Pripravené na odoslanie","processing":"vo zpracovaní","complete":"Odoslané","Delivered":"Doručené","Tracking number":"Číslo zásielky","ready":"Hotovo","Track and trace":"Sledovanie zásielky","Copy":"Kopíruj","Out for delivery":"Na ceste","Expect your package today":"Od dnešného dňa očakávajte svoju zásielku","Courier":"Kurýr","Change password":"Zmeniť heslo","Default seo description":"Vitajte v obchode DAJAR.sk. Ponúkame záhradný nábytok, vankúše a hojdačky. Náš obchod ponúka aj riad, príbory, hrnce, panvice, jedálenské súpravy a poháre.","Default seo description - register":"Vitajte v obchode DAJAR.sk. Ponúkame záhradný nábytok, vankúše a hojdačky. Náš obchod ponúka aj riad, príbory, hrnce, panvice, jedálenské súpravy a poháre.","Default seo title":"DAJAR.sk - záhradný nábytok a riad","Default seo title - register":"DAJAR.sk - záhradný nábytok a riad","search results":"Výsledky vyhľadávania pre \\"{{phrase}}\\"","page":"Stránke","rachunku":"Produkty v kategórii {{categoryName}} v obchode Dajar.sk Užite si nakupovanie!","Accept terms":"Prečítal/a som si a súhlasím s podmínkama","Terms":"Predaja","Shipment":"Dodanie","Cookie notice":"Vitajte v našom obchode DAJAR.sk.\\nCookies (súbory cookies) používame na analýzu prevádzky na webe DAJAR.sk, na personalizáciu obsahu na webe, zobrazovanie reklám na mieru a zvyšovanie komfortu používanie nášho webu. Kliknutím na \\"\\"Akceptuji\\"\\" nás informujete, že súhlasíte s našim ukladaním cookies (súborov cookies) do vášho prehliadača a prípadne sa spracovaním súvisiacich údajov pre tieto účely. Svoj súhlas môžete spravovať a kedykoľvek ho odvolať pomocou nastavenia vo vašom prehliadači. Ďalšie informácie nájdete v našich zásadách používania súborov cookies.","Accept":"Akceptujem","Default billing":"Prednastavená fakturácia","Default billing address":"Prednastavená fakturačná adresa","Default shipping":"Prednastavená doručenia","Default shipping address":"Prednastavená doručovacia adresa","Is default shipping address?":"Prednastavená doručovacia adresa?","Is default billing address?":"Prednastavená fakturačná adresa?","Add new address":"Pridajte novú adresu","Not set":"Nepridané","Default billing and shipping":"Prednastavená fakturačná a dodacia adresa","Product was added to cart":"Produkt bol pridaný do košíka","number of people":"počet osôb","Wrong street format":"Ulica a číslo domu sú povinné","New address":"Nová adresa","Edit address":"Upravte adresu","Error":"chyba","Something went wrong":"Niečo sa pokazilo.","Fill in the delivery details":"Vyplňte údaje o preprave.","We don\'t ship to this country, sorry":"Ospravedlňujeme sa, ale do tejto krajiny nezasielame","This method is not available":"Táto metóda nie je k dispozícii","Incorrect phone number":"Neplatné telefónne číslo","Incorrect VAT ID":"Nesprávne IČ DPH","Shipping same as billing":"Doručovacia adresa je rovnaká ako fakturačná","As Company":"Nakupujem na firmu","Name or Company":"Názov firmy","Billing for":"Faktura pre","Choose pickup point":"","Deliver to company":"","Company address":"Adresa spoločnosti","Search results | Dajar":"Výsledky hľadania | Dajar.sk","Address saved":"Uložená adresa","ePoints":"DAJAR ePremia","Available ePoints":"Dostupné body DAJAR ePremia","You can use these points with your next purchase":"Body DAJAR ePremia môžete použiť pri budúcich nákupoch","Learn more":"zistiť viac","ePoints earned":"Získané body DAJAR ePremia","paid with ePoints":"Zaplatené bodama DAJAR Premia","Settlement of ePoints":"Vyúčtovnání bodov DAJAR ePremia","Added by administrator":"Dodané administrátorom","Purchase invoice":"Doklad o kúpe","Purchase canceled":"Zrušený nákup","Spent with order":"Použité v objednávke","Spent with order canceled":"Zrušené použití v objednávke","Order cancelation":"Zrušenie objednávky","Max addresses reached":"Maximálny počet uložených adries. Adresa nebola pridaná","Brexit":"","Pay less with ePoints":"Plaťte menej s DAJAR ePremia","Delete ePoints":"Vymazať body DAJAR ePremia","ePoints (you have {{points}})":"ePremia (máte {{points}})","price":"Cena","Active":"Aktívne","Accept all cookies":"Akceptovať všetko","Confirm my settings":"Akceptovat vybrané","Manage cookie settings":"Chcem si vybrať ...","Third party cookies":"Zoznam cookies","Back to cookie list":"Zoznam cookies","Show cookie list":"Zobraziť súbory cookies","Cookie name":"Názov","Duration":"Doba trvania","Type":"Typ","Required cookies description":"Súbory cookie, ktoré potrebujeme pre riadnu prevádzku nášho obchodu DAJAR.sk.","Analytic cookies description":"Zahŕňajú cookies, ktoré nám pomáhajú analyzovať a sledovať prevádzku na našom webe DAJAR.sk. Poskytuje nám to ďalšie vedomosti pre vylepšenie našich webových stránok.","Tracking cookies description":"Cookies, ktoré nám umožňujú prispôsobiť a merať účinnosť našej reklamy. S ich pomocou vám poskytneme informácie, ktoré sú pre vás najdôležitejšie.","Necessary cookies":"Nevyhnutné cookies","Analytic cookies":"Analytické cookies","Tracking cookies":"Súbory cookies pre sledovanie správania","Third party":"Tretia strana ","day":"deň","days":"dni","years":"roky","minute":"minúta","minutes":"minúty","month":"mesiac","months2":"mesiacov","months":"mesiaca","year":"rok","session":"relácia","hour":"hodina ","Own":"Own","Too many points provided":"Zadané príliš veľa bodov ","Last name must be different then first name":"Meno musí byť inné sko prievzisko","Additonal fee":"Dodatočný poplatok +1,50 eur","price catalog high to low":"Katalógová cena: od najvyššej","price catalog low to high":"Katalógová cena: od najnižšiej","Additional information":"Dodatočné informácie","Length [cm]":"Dlžka [cm]","Width [cm]":"Šírka [cm]","Shape":"Tvar","Producer":"Výrobca","Height [cm]":"Výška [cm]","Depth [cm]":"Hĺbka [cm]","Capacity [ml]":"Objem [ml]","Number of people":"Počet osôb","Dajar collection":"Séria","Material":"Materiál","Application":"Použitie","Diameter [cm]":"Priemer [cm]","Color list":"Farba","Pattern list":"Vzor","Feature":"Funkcie","Composition":"Materiál","Max load":"Maximálne zaťaženie [kg]","Capacity [l]":"Objem [l]","Product usage":"","Brand":"","Product styles":"","Opportunity":"","Weight [kg]":"Váha [kg]","Help":"Pomoc","The product is no longer available":"Produkt už nie je dostupný ","Remove it from the cart or reduce the quantity ":"Prosíme odstráňte produkt z košíka ","The product will be available":"Produkt bude dostupný","product available in different variant":"produkt je dostupný aj v inej variante","Possible service failure. Please wait a moment and try again":"Možné zlyhanie služby. Chvíľu počkajte a skúste to znova","Page not found":"Stránka nenájdená","Go to home page":"Prejdite na hlavnú stránku","Check recently viewed":"Skontrolujte nedávno zobrazené","Do not hesitate":"S nákupom neváhajte, vloženie položiek do košíka neznamená ich rezerváciu ","Save new address":"Uložiť","Other address":"Other address","Subscribe to the newsletter":"Zapiš do Newsletter","And get even 20% off":"Získajte dokonca 5% zľavu","Subscribe":"ZAPIŠTE SA","Subscribe to our newsletter":"Prihláste sa na odber nášho newslettra ","And get even 10% off":"Získajte až 5% zľavu na nákupy akejkoľvek hodnoty.","Cart":"Košík","Weber grills collections":"","Weber grills collections description":"","Recommended categories description - Weber":"","Kettler furniture collections":"","Recommended categories description - Kettler":"","Recommended categories - Kettler":"","Search results | Kettler":"","Search results | Weber":"","Meta description ({{categoryName}}) - Kettler":"","Meta description ({{categoryName}}) - Weber":"","Default seo title - Kettler":"","Default seo title - Kettler - homepage":"","Default seo title - Weber":"","Default seo description - Kettler":"","Default seo description - Kettler - homepage":"","Default seo description - Weber":"","Products in collection":"","Show other {{collectionName}} collections":"","Price includes tax":"","You don\'t have any orders":"Žiadne objednávky","Are you sure you want to remove this address?":"Naozaj chcete odstrániť adresu?","Password saved":"Heslo uložené","Firstname and Lastname saved":"Uložené meno a priezvisko","Address deleted":"Adresa odstránená","Yes":"Áno","No":"Nie","available versions":"","Default seo title - Pro":"","Default seo description - Pro":"","Meta tags description alt - Pro":"","Sale-Pro":"","Frequently asked questions":"","Only {{amount}} to free shipping":"","Your cart is empty":"","start shopping":"","To checkout":"","Your price (with tax)":"","Availability":"","product code":"SKU","Choose":"","Filtering":"","Previous":"","Next":"","items (amount)":"","Other from category":"","less":"","our categories":"","See all - Pro":"","Bestsellers - Pro":"","Free delivery PDP info {{freeDeliveryFrom}}":"","Your payment is being processed":"Vaša platba sa spracováva. Pošleme Vám email so stavom Vašej objednávky.","Thank you for your purchase":"Ďakujeme za vašu objednávku!","Collection page info":"","Products":"","Suggestions":"","We have sent an email to the given account with a link to change the password":"","Lowest price info":"Najnižšia cena za posledných 30 dní","Promo code was added to clipboard":"Zľavový kód bol skopírovaný","Clear filters - Pro":"","Delivery time":"","Total with tax":"","Resign from newsletter":"","I agree to forward my email to the courier":"","Choose locker":"","Change locker":"","with VAT":"","Unsubscribe info":"","Offer valid while stocks last":"","Product for free":"","Set as delivery parcel":"","Choose parcel pickup point":"","Get parcels addresses":"","Enter address to get nearest parcels":"","Incorrect postal code":"","Parcel not found":"","Change form values":"","Added to wishlist":"Produkt bol pridaný do zoznamu obľúbených","Removed from wishlist":"Produkt bol odstránený zo zoznamu obľúbených","Product on wishlist":"Produkt je na zozname obľúbených","Wishlist inactive tooltip":"Prihláste sa a pridajte produkt do zoznamu obľúbených","Wishlist":"Zoznam obľúbených","Add visible to cart":"Pridajte dostupné produkty do košíka","Wishlist products added to cart":"Dostupné položky zoznamu obľúbených boli pridané do vášho košíka","No products in the wishlist":"V zozname obľúbených nie sú žiadne produkty","Hit of the day":"Hit dňa","Only {{qty}} left in stock":"Na sklade {{qty}} kusov","Offer ends":"Ponuka končí za:","hours hit":"hod.","minutes hit":"min.","seconds hit":"sek.","sold out":"vypredané","left hits":"zostatok","sold hits":"predané","Offer start":"Nová ponuka začína za","Available qty for person in hit {{qty}}":"Môžete kúpiť max. {{qty}} ks. na osobu","Outlet":"Výpredaj","Hit of the week":"Hit týždňa","Hit of the month":"Hit mesiaca","Choose DHL parcel":"","Choose Inpost pickup point":"","You may also like":"","see all":"","new account":"","menu":"","See all collections":"","I am looking for a...":"","New Collections":"","Search results | Ambition":"","Default seo title - Ambition":"","Default seo description - Ambition":"","Back":"","Apply":"","Close":"","Full of features":"","More from collection":"","Copyrights - Ambition":"","Download Our App":"","Download Our App Description":"","Club benefits":"","Earn Points":"","Earn Points description":"","Transfer Funds":"","Transfer Funds description":"","First to Know":"","First to Know description":"","Rodo Club":"","Special Offer!":"Príležitosť!","Check out this great deal":"Pozrite sa na túto skvelú ponuku","A new unique offer every day":"Každý deň nová jedinečná ponuk","Change parcel":"","card":"Platba platobnou kartou","banktransfer":"Bežný prevod","cashondelivery":"Dobierka","dialcom_przelewy":"Rýchly prevod","bluepayment":"Rýchly prevod","blik":"Blik platba","googlepay":"Google Pay","applepay":"Apple Pay","klarna":"Klarna","blik_info":"Zadajte kód BLIK z aplikácie vašej banky","applepay_info":"Kliknutím zaplatíte za objednávku","googlepay_info":"Kliknutím zaplatíte za objednávku","paypal_info":"Vybraný PayPal. Po kliknutí na Zaplatiť budete presmerovaní na stránku, ktorá vám umožní bezpečne dokončiť ďalšie kroky.","bluepayment_info":"Vybraná platba Autopay. Po kliknutí na Zaplatiť budete presmerovaní na stránku, ktorá vám umožní bezpečne dokončiť ďalšie kroky.","klarna_info":"Platba Klarna bola vybraná.<br />Po kliknutí budete presmerovaní na stránku, ktorá umožňuje bezpečné vykonanie ďalších krokov.","banktransfer_info":"Bola zvolená platba prevodom. Po kliknutí na Zaplatiť dostanete e-mail s bankovým spojením k úhrade.","cashondelivery_info":"Bola zvolená platba na dobierku. Objednávku zaplatíte kuriérovi pri doručení zásielky.","The payment is REFUSED.":"Platba zlyhala.","Payment refused. Choose payment method and retry":"Vyberte spôsob platby a skúste to znova","Finish payment":"Dokončite platbu","klarna_paynow_button_label":"Zaplať teraz s Klarna","klarna_paylater_button_label":"Zaplať za 30 dní s Klarna","klarna_account_button_label":"Zaplať na splátky s Klarna","Settings":"","Download our app":"","Download our app description":"","Transfer funds":"","Transfer funds description":"","First to know":"","First to know description":"","Rodo_agreement_secondary":"","Log in or register":"","Order List":"","Your Last Order":"","Expect your package in 1-2 working days":"","Tracking number copied":"","Your Points":"","See More":"","Hello {{name}}, nice to see You again !":"","Date reach":"","Order status":"","Your Special Membership Offer":"","Become a Member":"","App benefits":"","Dashboard":"","More from this collection":"","adyen_error_message_amount_exceeded":"Vaša platba bola zamietnutá alebo sa v košíku nachádza produkt, ktorý je vypredaný.","adyen_error_message":"Vaša platba bola zamietnutá.","Cannot set delivery method":"Nie je možné nastaviť spôsob doručenia","Street and number":"","mobile_10%_discount":"","mobile_register_advert":"","mobile_make_order":"","mobile_set_discount":"","mobile_add_coupon_code":"","mobile_add":"","mobile_remove":"","mobile_user_login":"","mobile_no_products":"","mobile_confirm_password":"","mobile_must_contain_letter":"","mobile_must_contain_special":"","mobile_must_contain_chars_amount":"","mobile_must_contain_upper_letter":"","mobile_see_all":"","mobile_got_account":"","mobile_see_promotions":"","mobile_promotions_interested":"","mobile_place_order":"","mobile_profile_edition":"","mobile_summary":"","mobile_filter_sort":"","mobile_promotions":"","mobile_search_suggestion":"","mobile_account_created":"","mobile_bestsellers":"","mobile_filter_by":"","mobile_welcome_again":"","mobile_login_to_continue":"","mobile_sort_by":"","mobile_invoice_for_company":"","mobile_edit_your_data":"","mobile_got_question":"","mobile_customer_service":"","mobile_send_to_same_address":"","mobile_choose_shipping_method":"","mobile_your_email_address":"","mobile_order_data":"","mobile_register_and_use":"","mobile_join_us":"","mobile_register":"","mobile_change_data":"","mobile_epremia_discount":"","mobile_epremia_points_info":"","mobile_epremia_create_account":"","additional_promo_label":"","Error with payment method":"","safety_description":"Tento výrobok je možné používať bezpečným spôsobom určeným výrobcom iba v súlade s návodom na obsluhu a údržbu, odporúčaniami, varovaniami alebo bezpečnostnými informáciami umiestnenými na výrobku alebo na jeho obale alebo na letáku dodávaného s výrobkom.","safety_title":""}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(26597), __webpack_exec__(79772), __webpack_exec__(84361); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);